var Gi = Object.defineProperty;
var qi = (Se, he, ke) => he in Se ? Gi(Se, he, { enumerable: !0, configurable: !0, writable: !0, value: ke }) : Se[he] = ke;
var Dt = (Se, he, ke) => (qi(Se, typeof he != "symbol" ? he + "" : he, ke), ke), Wn = (Se, he, ke) => {
  if (!he.has(Se))
    throw TypeError("Cannot " + ke);
};
var ge = (Se, he, ke) => (Wn(Se, he, "read from private field"), ke ? ke.call(Se) : he.get(Se)), Be = (Se, he, ke) => {
  if (he.has(Se))
    throw TypeError("Cannot add the same private member more than once");
  he instanceof WeakSet ? he.add(Se) : he.set(Se, ke);
}, rt = (Se, he, ke, ue) => (Wn(Se, he, "write to private field"), ue ? ue.call(Se, ke) : he.set(Se, ke), ke);
var kn = (Se, he, ke, ue) => ({
  set _(me) {
    rt(Se, he, me, ke);
  },
  get _() {
    return ge(Se, he, ue);
  }
}), ze = (Se, he, ke) => (Wn(Se, he, "access private method"), ke);
import * as React from "react";
import { p as propTypesExports, a as getAugmentedNamespace } from "./index-efd35e77.js";
import { B as Button$1 } from "./Button-4c83e316.js";
import { B as ButtonGroup } from "./ButtonGroup-a9850ef0.js";
import { T as Toolbar } from "./Toolbar-08559716.js";
import { T as ToolbarSpacer } from "./ToolbarSpacer-8b07ac30.js";
import { x as xa, g as gr } from "./index-a0534bb4.js";
import { U as Upload } from "./Upload-6f10e2c7.js";
import { y as ys } from "./index-b1011fa6.js";
import { S } from "./index-93802845.js";
import { _ as zoomOutIcon, $ as zoomInIcon, a0 as pointerIcon, a1 as handIcon, s as searchIcon, a2 as folderOpenIcon, a3 as downloadIcon, a4 as printIcon, a5 as convertLowercaseIcon, a6 as arrowUpIcon, a7 as arrowDownIcon, x as xIcon } from "./index.es-6889c727.js";
import { s as saveAs } from "./save-as-6eb63bad.js";
import { l as licensing, v as validatePackage$2 } from "./index-64063129.js";
import { v as validatePackage$1, p as packageMetadata$1, c as classNames$1 } from "./package-metadata-112a2384.js";
import { P as Pager } from "./Pager-c55e62fa.js";
import * as ReactDOM from "react-dom";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./keys-2b65407d.js";
import "./index-c07310bf.js";
import "./auto-scroll-b2de6e53.js";
import "./Label-079ad7bc.js";
import "./package-metadata-3dcf116a.js";
import "./FloatingLabel-922c628f.js";
import "./Popup-b6c9078b.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./ProgressBar-f33eeff2.js";
import "./Chip-cb37946d.js";
import "./TreeView-aa1ef3e3.js";
import "./Reveal-e2f427f6.js";
import "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "./ActionSheet-b5bf2237.js";
import "./Animation-154b683d.js";
import "./noop-d627517c.js";
import "./package-metadata-a152adb8.js";
var SEGMENT_COUNT = {
  pulsing: 2,
  "infinite-spinner": 3,
  "converging-spinner": 4
}, TYPE_CLASSES = {
  pulsing: "k-loader-pulsing-2",
  "infinite-spinner": "k-loader-spinner-3",
  "converging-spinner": "k-loader-spinner-4"
}, Loader = React.forwardRef(function(Se, he) {
  validatePackage$1(packageMetadata$1);
  var ke = Se.className, ue = Se.style, me = React.useRef(null), Me = React.useCallback(function() {
    me.current && me.current.focus();
  }, []);
  React.useImperativeHandle(he, function() {
    return {
      element: me.current,
      focus: Me
    };
  });
  var xe = React.useMemo(function() {
    return Se.size || defaultProps$1.size;
  }, [Se.size]), F = React.useMemo(function() {
    return Se.themeColor || defaultProps$1.themeColor;
  }, [Se.themeColor]), ae = React.useMemo(function() {
    return Se.type || defaultProps$1.type;
  }, [Se.type]), n = React.useMemo(function() {
    return classNames$1("k-loader", {
      "k-loader-sm": xe === "small",
      "k-loader-md": xe === "medium",
      "k-loader-lg": xe === "large",
      "k-loader-primary": F === "primary",
      "k-loader-secondary": F === "secondary",
      "k-loader-tertiary": F === "tertiary",
      "k-loader-info": F === "info",
      "k-loader-success": F === "success",
      "k-loader-warning": F === "warning",
      "k-loader-error": F === "error",
      "k-loader-dark": F === "dark",
      "k-loader-light": F === "light",
      "k-loader-inverse": F === "inverse"
    }, ke, TYPE_CLASSES[ae]);
  }, [
    xe,
    F,
    ke,
    ae
  ]), u = new Array(SEGMENT_COUNT[ae]);
  return u.fill(0, 0, SEGMENT_COUNT[ae]), React.createElement(
    "div",
    { className: n, style: ue },
    React.createElement("div", { className: "k-loader-canvas" }, u.map(function(q, e) {
      return React.createElement("span", { key: e, className: "k-loader-segment" });
    }))
  );
});
Loader.propTypes = {
  className: propTypesExports.string,
  style: propTypesExports.object,
  type: propTypesExports.oneOf([
    "pulsing",
    "infinite-spinner",
    "converging-spinner"
  ]),
  size: propTypesExports.oneOf(["small", "medium", "large"]),
  themeColor: propTypesExports.oneOf([
    "primary",
    "secondary",
    "tertiary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
    "inverse"
  ])
};
var defaultProps$1 = {
  size: "medium",
  themeColor: "primary",
  type: "pulsing"
};
Loader.defaultProps = defaultProps$1;
Loader.displayName = "KendoLoader";
var classNames = function() {
  for (var Se = [], he = 0; he < arguments.length; he++)
    Se[he] = arguments[he];
  var ke = {}, ue = function(Me) {
    return typeof Me == "object" ? Object.keys(Me).forEach(function(xe) {
      ke[xe] = Me[xe];
    }) : ke[Me] = !0;
  }, me = function(Me) {
    return Me.filter(function(xe) {
      return xe !== !0 && !!xe;
    }).map(function(xe) {
      return Array.isArray(xe) ? me(xe) : ue(xe);
    });
  };
  return me(Se), Object.keys(ke).map(function(Me) {
    return ke[Me] && Me || null;
  }).filter(function(Me) {
    return Me !== null;
  }).join(" ");
}, allowed = ["telerik.com", "progress.com", "stackblitz.io", "csb.app"];
function validatePackage(Se) {
  if (typeof licensing < "u")
    validatePackage$2(Se);
  else {
    var he = "License activation failed for ".concat(Se.name, `
`);
    he += `The @progress/kendo-licensing script is not loaded.
`, he += "See ".concat(Se.licensingDocsUrl, ` for more information.
`), console.warn(he);
  }
}
function shouldShowValidationUI(Se) {
  var he = allowed.some(function(ke) {
    var ue;
    return (ue = globalThis.document) === null || ue === void 0 ? void 0 : ue.location.hostname.endsWith(ke);
  });
  return !he && !(!(licensing === null || licensing === void 0) && validatePackage$2(Se));
}
var licenseKeyUrl = "https://www.telerik.com/kendo-react-ui/components/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-banner", didRender = !1, WatermarkOverlay = function() {
  var Se = React.useState(!0), he = Se[0], ke = Se[1], ue = React.useState(!1), me = ue[0], Me = ue[1];
  React.useEffect(function() {
    didRender || (Me(!0), didRender = !0);
  }, []);
  var xe = function() {
    ke(!1);
  }, F = React.createElement(React.Fragment, null, he && React.createElement(
    "div",
    { style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      position: "fixed",
      top: "16px",
      right: "16px",
      padding: "12px",
      borderRadius: "4px",
      boxShadow: "0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.03)",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      backgroundColor: "#FFC000",
      color: "#1E1E1E",
      zIndex: 999
    } },
    React.createElement(
      "span",
      { style: { display: "flex", alignSelf: "center", marginRight: "8px" } },
      React.createElement(
        "svg",
        { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1L0 15H16L8 1ZM7 6V11H9V6H7ZM7 14V12H9V14H7Z", fill: "#1E1E1E" })
      )
    ),
    React.createElement("span", null, "No valid license found for KendoReact. Learn how to activate your license."),
    React.createElement(
      "div",
      { style: { display: "flex", alignItems: "center", marginLeft: "24px" } },
      React.createElement(
        "a",
        { href: licenseKeyUrl, style: { marginRight: "8px", display: "flex" } },
        React.createElement(
          "button",
          { title: "Learn More", style: {
            display: "inline-flex",
            position: "relative",
            border: "none",
            borderRadius: "4px",
            padding: "5px",
            backgroundColor: "transparent",
            transition: "color 0.2s ease-in-out",
            outline: "none",
            cursor: "pointer"
          } },
          React.createElement(
            "svg",
            { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
            React.createElement("path", { d: "M15 8C15 11.8656 11.8656 15 8 15C4.13437 15 1 11.8656 1 8C1 4.13437 4.13437 1 8 1C11.8656 1 15 4.13437 15 8ZM14 8C14 4.6875 11.3125 2 8 2C4.6875 2 2 4.6875 2 8C2 11.3125 4.6875 14 8 14C11.3125 14 14 11.3125 14 8ZM11 6C11 7.4125 10.2687 8.05937 9.73125 8.53125C9.25937 8.94688 9 9.17813 9 10H7C7 8.275 7.84688 7.525 8.40938 7.03125C8.84062 6.65312 9 6.50938 9 6C9 5.45 8.55 5 8 5C7.45 5 7 5.45 7 6H5C5 4.34375 6.34375 3 8 3C9.65625 3 11 4.34375 11 6ZM9 13V11H7V13H9Z", fill: "#1E1E1E" })
          )
        )
      ),
      React.createElement(
        "button",
        { title: "Close", style: {
          display: "inline-flex",
          position: "relative",
          border: "none",
          borderRadius: "4px",
          padding: "5px",
          backgroundColor: "transparent",
          transition: "color 0.2s ease-in-out",
          outline: "none",
          cursor: "pointer"
        }, onClick: xe },
        React.createElement(
          "svg",
          { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none" },
          React.createElement("path", { d: "M13 4.41562L9.41563 8L13 11.5844L11.5844 13L8 9.41563L4.41562 13L3 11.5844L6.58437 8L3 4.41562L4.41562 3L8 6.58437L11.5844 3L13 4.41562Z", fill: "#1E1E1E" })
        )
      )
    )
  ));
  return React.createElement(
    React.Fragment,
    null,
    React.createElement("div", { style: {
      position: "absolute",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      opacity: 0.2,
      zIndex: 101,
      pointerEvents: "none",
      backgroundImage: "url('data:image/png;base64,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')"
    } }),
    me && ReactDOM.createPortal(F, document.body)
  );
}, pdf_worker = { exports: {} };
(function(Se, he) {
  (function(ue, me) {
    Se.exports = me();
  })(globalThis, () => (
    /******/
    (() => {
      var ke = [
        ,
        /* 1 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.WorkerTask = F.WorkerMessageHandler = void 0;
          var n = ae(2), u = ae(3), q = ae(4), e = ae(6), t = ae(72), B = ae(66), j = ae(103), M = ae(104), O = ae(105);
          class w {
            constructor(k) {
              this.name = k, this.terminated = !1, this._capability = new n.PromiseCapability();
            }
            get finished() {
              return this._capability.promise;
            }
            finish() {
              this._capability.resolve();
            }
            terminate() {
              this.terminated = !0;
            }
            ensureNotTerminated() {
              if (this.terminated)
                throw new Error("Worker task was terminated");
            }
          }
          F.WorkerTask = w;
          class C {
            static setup(k, s) {
              let l = !1;
              k.on("test", function(g) {
                l || (l = !0, k.send("test", g instanceof Uint8Array));
              }), k.on("configure", function(g) {
                (0, n.setVerbosityLevel)(g.verbosity);
              }), k.on("GetDocRequest", function(g) {
                return C.createDocumentHandler(g, s);
              });
            }
            static createDocumentHandler(k, s) {
              let l, g = !1, v = null;
              const r = /* @__PURE__ */ new Set(), x = (0, n.getVerbosityLevel)(), {
                docId: b,
                apiVersion: I
              } = k, h = "3.7.107";
              if (I !== h)
                throw new Error(`The API version "${I}" does not match the Worker version "${h}".`);
              const y = [];
              for (const m in [])
                y.push(m);
              if (y.length)
                throw new Error("The `Array.prototype` contains unexpected enumerable properties: " + y.join(", ") + "; thus breaking e.g. `for...in` iteration of `Array`s.");
              const P = b + "_worker";
              let c = new M.MessageHandler(P, b, s);
              function d() {
                if (g)
                  throw new Error("Worker was terminated");
              }
              function A(m) {
                r.add(m);
              }
              function N(m) {
                m.finish(), r.delete(m);
              }
              async function E(m) {
                await l.ensureDoc("checkHeader"), await l.ensureDoc("parseStartXRef"), await l.ensureDoc("parse", [m]), await l.ensureDoc("checkFirstPage", [m]), await l.ensureDoc("checkLastPage", [m]);
                const p = await l.ensureDoc("isPureXfa");
                if (p) {
                  const G = new w("loadXfaFonts");
                  A(G), await Promise.all([l.loadXfaFonts(c, G).catch((J) => {
                  }).then(() => N(G)), l.loadXfaImages()]);
                }
                const [T, L] = await Promise.all([l.ensureDoc("numPages"), l.ensureDoc("fingerprints")]), _ = p ? await l.ensureDoc("htmlForXfa") : null;
                return {
                  numPages: T,
                  fingerprints: L,
                  htmlForXfa: _
                };
              }
              function H({
                data: m,
                password: p,
                disableAutoFetch: T,
                rangeChunkSize: L,
                length: _,
                docBaseUrl: G,
                enableXfa: J,
                evaluatorOptions: K
              }) {
                const V = {
                  source: null,
                  disableAutoFetch: T,
                  docBaseUrl: G,
                  docId: b,
                  enableXfa: J,
                  evaluatorOptions: K,
                  handler: c,
                  length: _,
                  password: p,
                  rangeChunkSize: L
                }, U = new n.PromiseCapability();
                let Q;
                if (m) {
                  try {
                    V.source = m, Q = new e.LocalPdfManager(V), U.resolve(Q);
                  } catch (Y) {
                    U.reject(Y);
                  }
                  return U.promise;
                }
                let X, R = [];
                try {
                  X = new O.PDFWorkerStream(c);
                } catch (Y) {
                  return U.reject(Y), U.promise;
                }
                const f = X.getFullReader();
                f.headersReady.then(function() {
                  if (f.isRangeSupported) {
                    V.source = X, V.length = f.contentLength, V.disableAutoFetch || (V.disableAutoFetch = f.isStreamingSupported), Q = new e.NetworkPdfManager(V);
                    for (const Y of R)
                      Q.sendProgressiveData(Y);
                    R = [], U.resolve(Q), v = null;
                  }
                }).catch(function(Y) {
                  U.reject(Y), v = null;
                });
                let D = 0;
                const z = function() {
                  const Y = (0, u.arrayBuffersToBytes)(R);
                  _ && Y.length !== _ && (0, n.warn)("reported HTTP length is different from actual");
                  try {
                    V.source = Y, Q = new e.LocalPdfManager(V), U.resolve(Q);
                  } catch (W) {
                    U.reject(W);
                  }
                  R = [];
                };
                return new Promise(function(Y, W) {
                  const ie = function({
                    value: ne,
                    done: re
                  }) {
                    try {
                      if (d(), re) {
                        Q || z(), v = null;
                        return;
                      }
                      D += ne.byteLength, f.isStreamingSupported || c.send("DocProgress", {
                        loaded: D,
                        total: Math.max(D, f.contentLength || 0)
                      }), Q ? Q.sendProgressiveData(ne) : R.push(ne), f.read().then(ie, W);
                    } catch (ee) {
                      W(ee);
                    }
                  };
                  f.read().then(ie, W);
                }).catch(function(Y) {
                  U.reject(Y), v = null;
                }), v = function(Y) {
                  X.cancelAllRequests(Y);
                }, U.promise;
              }
              function $(m) {
                function p(_) {
                  d(), c.send("GetDoc", {
                    pdfInfo: _
                  });
                }
                function T(_) {
                  if (d(), _ instanceof n.PasswordException) {
                    const G = new w(`PasswordException: response ${_.code}`);
                    A(G), c.sendWithPromise("PasswordRequest", _).then(function({
                      password: J
                    }) {
                      N(G), l.updatePassword(J), L();
                    }).catch(function() {
                      N(G), c.send("DocException", _);
                    });
                  } else
                    _ instanceof n.InvalidPDFException || _ instanceof n.MissingPDFException || _ instanceof n.UnexpectedResponseException || _ instanceof n.UnknownErrorException ? c.send("DocException", _) : c.send("DocException", new n.UnknownErrorException(_.message, _.toString()));
                }
                function L() {
                  d(), E(!1).then(p, function(_) {
                    if (d(), !(_ instanceof u.XRefParseException)) {
                      T(_);
                      return;
                    }
                    l.requestLoadedStream().then(function() {
                      d(), E(!0).then(p, T);
                    });
                  });
                }
                d(), H(m).then(function(_) {
                  if (g)
                    throw _.terminate(new n.AbortException("Worker was terminated.")), new Error("Worker was terminated");
                  l = _, l.requestLoadedStream(!0).then((G) => {
                    c.send("DataLoaded", {
                      length: G.bytes.byteLength
                    });
                  });
                }).then(L, T);
              }
              return c.on("GetPage", function(m) {
                return l.getPage(m.pageIndex).then(function(p) {
                  return Promise.all([l.ensure(p, "rotate"), l.ensure(p, "ref"), l.ensure(p, "userUnit"), l.ensure(p, "view")]).then(function([T, L, _, G]) {
                    return {
                      rotate: T,
                      ref: L,
                      userUnit: _,
                      view: G
                    };
                  });
                });
              }), c.on("GetPageIndex", function(m) {
                const p = q.Ref.get(m.num, m.gen);
                return l.ensureCatalog("getPageIndex", [p]);
              }), c.on("GetDestinations", function(m) {
                return l.ensureCatalog("destinations");
              }), c.on("GetDestination", function(m) {
                return l.ensureCatalog("getDestination", [m.id]);
              }), c.on("GetPageLabels", function(m) {
                return l.ensureCatalog("pageLabels");
              }), c.on("GetPageLayout", function(m) {
                return l.ensureCatalog("pageLayout");
              }), c.on("GetPageMode", function(m) {
                return l.ensureCatalog("pageMode");
              }), c.on("GetViewerPreferences", function(m) {
                return l.ensureCatalog("viewerPreferences");
              }), c.on("GetOpenAction", function(m) {
                return l.ensureCatalog("openAction");
              }), c.on("GetAttachments", function(m) {
                return l.ensureCatalog("attachments");
              }), c.on("GetJavaScript", function(m) {
                return l.ensureCatalog("javaScript");
              }), c.on("GetDocJSActions", function(m) {
                return l.ensureCatalog("jsActions");
              }), c.on("GetPageJSActions", function({
                pageIndex: m
              }) {
                return l.getPage(m).then(function(p) {
                  return l.ensure(p, "jsActions");
                });
              }), c.on("GetOutline", function(m) {
                return l.ensureCatalog("documentOutline");
              }), c.on("GetOptionalContentConfig", function(m) {
                return l.ensureCatalog("optionalContentConfig");
              }), c.on("GetPermissions", function(m) {
                return l.ensureCatalog("permissions");
              }), c.on("GetMetadata", function(m) {
                return Promise.all([l.ensureDoc("documentInfo"), l.ensureCatalog("metadata")]);
              }), c.on("GetMarkInfo", function(m) {
                return l.ensureCatalog("markInfo");
              }), c.on("GetData", function(m) {
                return l.requestLoadedStream().then(function(p) {
                  return p.bytes;
                });
              }), c.on("GetAnnotations", function({
                pageIndex: m,
                intent: p
              }) {
                return l.getPage(m).then(function(T) {
                  const L = new w(`GetAnnotations: page ${m}`);
                  return A(L), T.getAnnotationsData(c, L, p).then((_) => (N(L), _), (_) => {
                    throw N(L), _;
                  });
                });
              }), c.on("GetFieldObjects", function(m) {
                return l.ensureDoc("fieldObjects");
              }), c.on("HasJSActions", function(m) {
                return l.ensureDoc("hasJSActions");
              }), c.on("GetCalculationOrderIds", function(m) {
                return l.ensureDoc("calculationOrderIds");
              }), c.on("SaveDocument", function({
                isPureXfa: m,
                numPages: p,
                annotationStorage: T,
                filename: L
              }) {
                const _ = [l.requestLoadedStream(), l.ensureCatalog("acroForm"), l.ensureCatalog("acroFormRef"), l.ensureDoc("xref"), l.ensureDoc("startXRef")], G = m ? null : (0, u.getNewAnnotationsMap)(T);
                if (G)
                  for (const [J, K] of G)
                    _.push(l.getPage(J).then((V) => {
                      const U = new w(`Save (editor): page ${J}`);
                      return V.saveNewAnnotations(c, U, K).finally(function() {
                        N(U);
                      });
                    }));
                if (m)
                  _.push(l.serializeXfaData(T));
                else
                  for (let J = 0; J < p; J++)
                    _.push(l.getPage(J).then(function(K) {
                      const V = new w(`Save: page ${J}`);
                      return K.save(c, V, T).finally(function() {
                        N(V);
                      });
                    }));
                return Promise.all(_).then(function([J, K, V, U, Q, ...X]) {
                  let R = [], f = null;
                  if (m) {
                    if (f = X[0], !f)
                      return J.bytes;
                  } else if (R = X.flat(2), R.length === 0)
                    return J.bytes;
                  const D = V && K instanceof q.Dict && R.some((ne) => ne.needAppearances), z = K instanceof q.Dict && K.get("XFA") || null;
                  let Y = null, W = !1;
                  if (Array.isArray(z)) {
                    for (let ne = 0, re = z.length; ne < re; ne += 2)
                      z[ne] === "datasets" && (Y = z[ne + 1], W = !0);
                    Y === null && (Y = U.getNewTemporaryRef());
                  } else
                    z && (0, n.warn)("Unsupported XFA type.");
                  let ie = /* @__PURE__ */ Object.create(null);
                  if (U.trailer) {
                    const ne = /* @__PURE__ */ Object.create(null), re = U.trailer.get("Info") || null;
                    re instanceof q.Dict && re.forEach((ee, te) => {
                      typeof te == "string" && (ne[ee] = (0, n.stringToPDFString)(te));
                    }), ie = {
                      rootRef: U.trailer.getRaw("Root") || null,
                      encryptRef: U.trailer.getRaw("Encrypt") || null,
                      newRef: U.getNewTemporaryRef(),
                      infoRef: U.trailer.getRaw("Info") || null,
                      info: ne,
                      fileIds: U.trailer.get("ID") || null,
                      startXRef: U.lastXRefStreamPos ?? Q,
                      filename: L
                    };
                  }
                  try {
                    return (0, B.incrementalUpdate)({
                      originalData: J.bytes,
                      xrefInfo: ie,
                      newRefs: R,
                      xref: U,
                      hasXfa: !!z,
                      xfaDatasetsRef: Y,
                      hasXfaDatasetsEntry: W,
                      needAppearances: D,
                      acroFormRef: V,
                      acroForm: K,
                      xfaData: f
                    });
                  } finally {
                    U.resetNewTemporaryRef();
                  }
                });
              }), c.on("GetOperatorList", function(m, p) {
                const T = m.pageIndex;
                l.getPage(T).then(function(L) {
                  const _ = new w(`GetOperatorList: page ${T}`);
                  A(_);
                  const G = x >= n.VerbosityLevel.INFOS ? Date.now() : 0;
                  L.getOperatorList({
                    handler: c,
                    sink: p,
                    task: _,
                    intent: m.intent,
                    cacheKey: m.cacheKey,
                    annotationStorage: m.annotationStorage
                  }).then(function(J) {
                    N(_), G && (0, n.info)(`page=${T + 1} - getOperatorList: time=${Date.now() - G}ms, len=${J.length}`), p.close();
                  }, function(J) {
                    N(_), !_.terminated && p.error(J);
                  });
                });
              }), c.on("GetTextContent", function(m, p) {
                const {
                  pageIndex: T,
                  includeMarkedContent: L,
                  disableNormalization: _
                } = m;
                l.getPage(T).then(function(G) {
                  const J = new w("GetTextContent: page " + T);
                  A(J);
                  const K = x >= n.VerbosityLevel.INFOS ? Date.now() : 0;
                  G.extractTextContent({
                    handler: c,
                    task: J,
                    sink: p,
                    includeMarkedContent: L,
                    disableNormalization: _
                  }).then(function() {
                    N(J), K && (0, n.info)(`page=${T + 1} - getTextContent: time=${Date.now() - K}ms`), p.close();
                  }, function(V) {
                    N(J), !J.terminated && p.error(V);
                  });
                });
              }), c.on("GetStructTree", function(m) {
                return l.getPage(m.pageIndex).then(function(p) {
                  return l.ensure(p, "getStructTree");
                });
              }), c.on("FontFallback", function(m) {
                return l.fontFallback(m.id, c);
              }), c.on("Cleanup", function(m) {
                return l.cleanup(!0);
              }), c.on("Terminate", function(m) {
                g = !0;
                const p = [];
                if (l) {
                  l.terminate(new n.AbortException("Worker was terminated."));
                  const T = l.cleanup();
                  p.push(T), l = null;
                } else
                  (0, t.clearGlobalCaches)();
                v && v(new n.AbortException("Worker was terminated."));
                for (const T of r)
                  p.push(T.finished), T.terminate();
                return Promise.all(p).then(function() {
                  c.destroy(), c = null;
                });
              }), c.on("Ready", function(m) {
                $(k), k = null;
              }), P;
            }
            static initializeFromPort(k) {
              const s = new M.MessageHandler("worker", "main", k);
              C.setup(s, k), s.send("ready", null);
            }
          }
          F.WorkerMessageHandler = C;
          function i(o) {
            return typeof o.postMessage == "function" && "onmessage" in o;
          }
          typeof window > "u" && !j.isNodeJS && typeof self < "u" && i(self) && C.initializeFromPort(self);
        },
        /* 2 */
        /***/
        (xe, F) => {
          var Re;
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.VerbosityLevel = F.Util = F.UnknownErrorException = F.UnexpectedResponseException = F.TextRenderingMode = F.RenderingIntentFlag = F.PromiseCapability = F.PermissionFlag = F.PasswordResponses = F.PasswordException = F.PageActionEventType = F.OPS = F.MissingPDFException = F.MAX_IMAGE_SIZE_TO_CACHE = F.LINE_FACTOR = F.LINE_DESCENT_FACTOR = F.InvalidPDFException = F.ImageKind = F.IDENTITY_MATRIX = F.FormatError = F.FeatureTest = F.FONT_IDENTITY_MATRIX = F.DocumentActionEventType = F.CMapCompressionType = F.BaseException = F.BASELINE_FACTOR = F.AnnotationType = F.AnnotationStateModelType = F.AnnotationReviewState = F.AnnotationReplyType = F.AnnotationMode = F.AnnotationMarkedState = F.AnnotationFlag = F.AnnotationFieldFlag = F.AnnotationEditorType = F.AnnotationEditorPrefix = F.AnnotationEditorParamsType = F.AnnotationBorderStyleType = F.AnnotationActionEventType = F.AbortException = void 0, F.assert = T, F.bytesToString = D, F.createValidAbsoluteUrl = _, F.getModificationDate = we, F.getVerbosityLevel = H, F.info = $, F.isArrayBuffer = Ie, F.isArrayEqual = Fe, F.normalizeUnicode = Pe, F.objectFromMap = ie, F.objectSize = W, F.setVerbosityLevel = E, F.shadow = G, F.string32 = Y, F.stringToBytes = z, F.stringToPDFString = ce, F.stringToUTF8String = le, F.unreachable = p, F.utf8StringToString = de, F.warn = m;
          const ae = [1, 0, 0, 1, 0, 0];
          F.IDENTITY_MATRIX = ae;
          const n = [1e-3, 0, 0, 1e-3, 0, 0];
          F.FONT_IDENTITY_MATRIX = n;
          const u = 1e7;
          F.MAX_IMAGE_SIZE_TO_CACHE = u;
          const q = 1.35;
          F.LINE_FACTOR = q;
          const e = 0.35;
          F.LINE_DESCENT_FACTOR = e;
          const t = e / q;
          F.BASELINE_FACTOR = t;
          const B = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            SAVE: 8,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          F.RenderingIntentFlag = B;
          const j = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          F.AnnotationMode = j;
          const M = "pdfjs_internal_editor_";
          F.AnnotationEditorPrefix = M;
          const O = {
            DISABLE: -1,
            NONE: 0,
            FREETEXT: 3,
            INK: 15
          };
          F.AnnotationEditorType = O;
          const w = {
            FREETEXT_SIZE: 1,
            FREETEXT_COLOR: 2,
            FREETEXT_OPACITY: 3,
            INK_COLOR: 11,
            INK_THICKNESS: 12,
            INK_OPACITY: 13
          };
          F.AnnotationEditorParamsType = w;
          const C = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          F.PermissionFlag = C;
          const i = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          F.TextRenderingMode = i;
          const o = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          F.ImageKind = o;
          const k = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          F.AnnotationType = k;
          const s = {
            MARKED: "Marked",
            REVIEW: "Review"
          };
          F.AnnotationStateModelType = s;
          const l = {
            MARKED: "Marked",
            UNMARKED: "Unmarked"
          };
          F.AnnotationMarkedState = l;
          const g = {
            ACCEPTED: "Accepted",
            REJECTED: "Rejected",
            CANCELLED: "Cancelled",
            COMPLETED: "Completed",
            NONE: "None"
          };
          F.AnnotationReviewState = g;
          const v = {
            GROUP: "Group",
            REPLY: "R"
          };
          F.AnnotationReplyType = v;
          const r = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          F.AnnotationFlag = r;
          const x = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          F.AnnotationFieldFlag = x;
          const b = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          F.AnnotationBorderStyleType = b;
          const I = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          F.AnnotationActionEventType = I;
          const h = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          F.DocumentActionEventType = h;
          const y = {
            O: "PageOpen",
            C: "PageClose"
          };
          F.PageActionEventType = y;
          const P = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          F.VerbosityLevel = P;
          const c = {
            NONE: 0,
            BINARY: 1
          };
          F.CMapCompressionType = c;
          const d = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          F.OPS = d;
          const A = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          F.PasswordResponses = A;
          let N = P.WARNINGS;
          function E(Ee) {
            Number.isInteger(Ee) && (N = Ee);
          }
          function H() {
            return N;
          }
          function $(Ee) {
            N >= P.INFOS && console.log(`Info: ${Ee}`);
          }
          function m(Ee) {
            N >= P.WARNINGS && console.log(`Warning: ${Ee}`);
          }
          function p(Ee) {
            throw new Error(Ee);
          }
          function T(Ee, ye) {
            Ee || p(ye);
          }
          function L(Ee) {
            switch (Ee == null ? void 0 : Ee.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function _(Ee, ye = null, Te = null) {
            if (!Ee)
              return null;
            try {
              if (Te && typeof Ee == "string") {
                if (Te.addDefaultProtocol && Ee.startsWith("www.")) {
                  const ve = Ee.match(/\./g);
                  (ve == null ? void 0 : ve.length) >= 2 && (Ee = `http://${Ee}`);
                }
                if (Te.tryConvertEncoding)
                  try {
                    Ee = le(Ee);
                  } catch {
                  }
              }
              const je = ye ? new URL(Ee, ye) : new URL(Ee);
              if (L(je))
                return je;
            } catch {
            }
            return null;
          }
          function G(Ee, ye, Te, je = !1) {
            return Object.defineProperty(Ee, ye, {
              value: Te,
              enumerable: !je,
              configurable: !0,
              writable: !1
            }), Te;
          }
          const J = function() {
            function ye(Te, je) {
              this.constructor === ye && p("Cannot initialize BaseException."), this.message = Te, this.name = je;
            }
            return ye.prototype = new Error(), ye.constructor = ye, ye;
          }();
          F.BaseException = J;
          class K extends J {
            constructor(ye, Te) {
              super(ye, "PasswordException"), this.code = Te;
            }
          }
          F.PasswordException = K;
          class V extends J {
            constructor(ye, Te) {
              super(ye, "UnknownErrorException"), this.details = Te;
            }
          }
          F.UnknownErrorException = V;
          class U extends J {
            constructor(ye) {
              super(ye, "InvalidPDFException");
            }
          }
          F.InvalidPDFException = U;
          class Q extends J {
            constructor(ye) {
              super(ye, "MissingPDFException");
            }
          }
          F.MissingPDFException = Q;
          class X extends J {
            constructor(ye, Te) {
              super(ye, "UnexpectedResponseException"), this.status = Te;
            }
          }
          F.UnexpectedResponseException = X;
          class R extends J {
            constructor(ye) {
              super(ye, "FormatError");
            }
          }
          F.FormatError = R;
          class f extends J {
            constructor(ye) {
              super(ye, "AbortException");
            }
          }
          F.AbortException = f;
          function D(Ee) {
            (typeof Ee != "object" || (Ee == null ? void 0 : Ee.length) === void 0) && p("Invalid argument for bytesToString");
            const ye = Ee.length, Te = 8192;
            if (ye < Te)
              return String.fromCharCode.apply(null, Ee);
            const je = [];
            for (let ve = 0; ve < ye; ve += Te) {
              const Ce = Math.min(ve + Te, ye), Ne = Ee.subarray(ve, Ce);
              je.push(String.fromCharCode.apply(null, Ne));
            }
            return je.join("");
          }
          function z(Ee) {
            typeof Ee != "string" && p("Invalid argument for stringToBytes");
            const ye = Ee.length, Te = new Uint8Array(ye);
            for (let je = 0; je < ye; ++je)
              Te[je] = Ee.charCodeAt(je) & 255;
            return Te;
          }
          function Y(Ee) {
            return String.fromCharCode(Ee >> 24 & 255, Ee >> 16 & 255, Ee >> 8 & 255, Ee & 255);
          }
          function W(Ee) {
            return Object.keys(Ee).length;
          }
          function ie(Ee) {
            const ye = /* @__PURE__ */ Object.create(null);
            for (const [Te, je] of Ee)
              ye[Te] = je;
            return ye;
          }
          function ne() {
            const Ee = new Uint8Array(4);
            return Ee[0] = 1, new Uint32Array(Ee.buffer, 0, 1)[0] === 1;
          }
          function re() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          class ee {
            static get isLittleEndian() {
              return G(this, "isLittleEndian", ne());
            }
            static get isEvalSupported() {
              return G(this, "isEvalSupported", re());
            }
            static get isOffscreenCanvasSupported() {
              return G(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
            }
            static get platform() {
              return typeof navigator > "u" ? G(this, "platform", {
                isWin: !1,
                isMac: !1
              }) : G(this, "platform", {
                isWin: navigator.platform.includes("Win"),
                isMac: navigator.platform.includes("Mac")
              });
            }
          }
          F.FeatureTest = ee;
          const te = [...Array(256).keys()].map((Ee) => Ee.toString(16).padStart(2, "0"));
          class oe {
            static makeHexColor(ye, Te, je) {
              return `#${te[ye]}${te[Te]}${te[je]}`;
            }
            static scaleMinMax(ye, Te) {
              let je;
              ye[0] ? (ye[0] < 0 && (je = Te[0], Te[0] = Te[1], Te[1] = je), Te[0] *= ye[0], Te[1] *= ye[0], ye[3] < 0 && (je = Te[2], Te[2] = Te[3], Te[3] = je), Te[2] *= ye[3], Te[3] *= ye[3]) : (je = Te[0], Te[0] = Te[2], Te[2] = je, je = Te[1], Te[1] = Te[3], Te[3] = je, ye[1] < 0 && (je = Te[2], Te[2] = Te[3], Te[3] = je), Te[2] *= ye[1], Te[3] *= ye[1], ye[2] < 0 && (je = Te[0], Te[0] = Te[1], Te[1] = je), Te[0] *= ye[2], Te[1] *= ye[2]), Te[0] += ye[4], Te[1] += ye[4], Te[2] += ye[5], Te[3] += ye[5];
            }
            static transform(ye, Te) {
              return [ye[0] * Te[0] + ye[2] * Te[1], ye[1] * Te[0] + ye[3] * Te[1], ye[0] * Te[2] + ye[2] * Te[3], ye[1] * Te[2] + ye[3] * Te[3], ye[0] * Te[4] + ye[2] * Te[5] + ye[4], ye[1] * Te[4] + ye[3] * Te[5] + ye[5]];
            }
            static applyTransform(ye, Te) {
              const je = ye[0] * Te[0] + ye[1] * Te[2] + Te[4], ve = ye[0] * Te[1] + ye[1] * Te[3] + Te[5];
              return [je, ve];
            }
            static applyInverseTransform(ye, Te) {
              const je = Te[0] * Te[3] - Te[1] * Te[2], ve = (ye[0] * Te[3] - ye[1] * Te[2] + Te[2] * Te[5] - Te[4] * Te[3]) / je, Ce = (-ye[0] * Te[1] + ye[1] * Te[0] + Te[4] * Te[1] - Te[5] * Te[0]) / je;
              return [ve, Ce];
            }
            static getAxialAlignedBoundingBox(ye, Te) {
              const je = oe.applyTransform(ye, Te), ve = oe.applyTransform(ye.slice(2, 4), Te), Ce = oe.applyTransform([ye[0], ye[3]], Te), Ne = oe.applyTransform([ye[2], ye[1]], Te);
              return [Math.min(je[0], ve[0], Ce[0], Ne[0]), Math.min(je[1], ve[1], Ce[1], Ne[1]), Math.max(je[0], ve[0], Ce[0], Ne[0]), Math.max(je[1], ve[1], Ce[1], Ne[1])];
            }
            static inverseTransform(ye) {
              const Te = ye[0] * ye[3] - ye[1] * ye[2];
              return [ye[3] / Te, -ye[1] / Te, -ye[2] / Te, ye[0] / Te, (ye[2] * ye[5] - ye[4] * ye[3]) / Te, (ye[4] * ye[1] - ye[5] * ye[0]) / Te];
            }
            static singularValueDecompose2dScale(ye) {
              const Te = [ye[0], ye[2], ye[1], ye[3]], je = ye[0] * Te[0] + ye[1] * Te[2], ve = ye[0] * Te[1] + ye[1] * Te[3], Ce = ye[2] * Te[0] + ye[3] * Te[2], Ne = ye[2] * Te[1] + ye[3] * Te[3], Ge = (je + Ne) / 2, Oe = Math.sqrt((je + Ne) ** 2 - 4 * (je * Ne - Ce * ve)) / 2, tt = Ge + Oe || 1, Ke = Ge - Oe || 1;
              return [Math.sqrt(tt), Math.sqrt(Ke)];
            }
            static normalizeRect(ye) {
              const Te = ye.slice(0);
              return ye[0] > ye[2] && (Te[0] = ye[2], Te[2] = ye[0]), ye[1] > ye[3] && (Te[1] = ye[3], Te[3] = ye[1]), Te;
            }
            static intersect(ye, Te) {
              const je = Math.max(Math.min(ye[0], ye[2]), Math.min(Te[0], Te[2])), ve = Math.min(Math.max(ye[0], ye[2]), Math.max(Te[0], Te[2]));
              if (je > ve)
                return null;
              const Ce = Math.max(Math.min(ye[1], ye[3]), Math.min(Te[1], Te[3])), Ne = Math.min(Math.max(ye[1], ye[3]), Math.max(Te[1], Te[3]));
              return Ce > Ne ? null : [je, Ce, ve, Ne];
            }
            static bezierBoundingBox(ye, Te, je, ve, Ce, Ne, Ge, Oe) {
              const tt = [], Ke = [[], []];
              let et, Xe, Qe, it, We, gt, mt, Ct;
              for (let ot = 0; ot < 2; ++ot) {
                if (ot === 0 ? (Xe = 6 * ye - 12 * je + 6 * Ce, et = -3 * ye + 9 * je - 9 * Ce + 3 * Ge, Qe = 3 * je - 3 * ye) : (Xe = 6 * Te - 12 * ve + 6 * Ne, et = -3 * Te + 9 * ve - 9 * Ne + 3 * Oe, Qe = 3 * ve - 3 * Te), Math.abs(et) < 1e-12) {
                  if (Math.abs(Xe) < 1e-12)
                    continue;
                  it = -Qe / Xe, 0 < it && it < 1 && tt.push(it);
                  continue;
                }
                mt = Xe * Xe - 4 * Qe * et, Ct = Math.sqrt(mt), !(mt < 0) && (We = (-Xe + Ct) / (2 * et), 0 < We && We < 1 && tt.push(We), gt = (-Xe - Ct) / (2 * et), 0 < gt && gt < 1 && tt.push(gt));
              }
              let Pt = tt.length, at;
              const dt = Pt;
              for (; Pt--; )
                it = tt[Pt], at = 1 - it, Ke[0][Pt] = at * at * at * ye + 3 * at * at * it * je + 3 * at * it * it * Ce + it * it * it * Ge, Ke[1][Pt] = at * at * at * Te + 3 * at * at * it * ve + 3 * at * it * it * Ne + it * it * it * Oe;
              return Ke[0][dt] = ye, Ke[1][dt] = Te, Ke[0][dt + 1] = Ge, Ke[1][dt + 1] = Oe, Ke[0].length = Ke[1].length = dt + 2, [Math.min(...Ke[0]), Math.min(...Ke[1]), Math.max(...Ke[0]), Math.max(...Ke[1])];
            }
          }
          F.Util = oe;
          const se = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function ce(Ee) {
            if (Ee[0] >= "ï") {
              let Te;
              if (Ee[0] === "þ" && Ee[1] === "ÿ" ? Te = "utf-16be" : Ee[0] === "ÿ" && Ee[1] === "þ" ? Te = "utf-16le" : Ee[0] === "ï" && Ee[1] === "»" && Ee[2] === "¿" && (Te = "utf-8"), Te)
                try {
                  const je = new TextDecoder(Te, {
                    fatal: !0
                  }), ve = z(Ee);
                  return je.decode(ve);
                } catch (je) {
                  m(`stringToPDFString: "${je}".`);
                }
            }
            const ye = [];
            for (let Te = 0, je = Ee.length; Te < je; Te++) {
              const ve = se[Ee.charCodeAt(Te)];
              ye.push(ve ? String.fromCharCode(ve) : Ee.charAt(Te));
            }
            return ye.join("");
          }
          function le(Ee) {
            return decodeURIComponent(escape(Ee));
          }
          function de(Ee) {
            return unescape(encodeURIComponent(Ee));
          }
          function Ie(Ee) {
            return typeof Ee == "object" && (Ee == null ? void 0 : Ee.byteLength) !== void 0;
          }
          function Fe(Ee, ye) {
            if (Ee.length !== ye.length)
              return !1;
            for (let Te = 0, je = Ee.length; Te < je; Te++)
              if (Ee[Te] !== ye[Te])
                return !1;
            return !0;
          }
          function we(Ee = /* @__PURE__ */ new Date()) {
            return [Ee.getUTCFullYear().toString(), (Ee.getUTCMonth() + 1).toString().padStart(2, "0"), Ee.getUTCDate().toString().padStart(2, "0"), Ee.getUTCHours().toString().padStart(2, "0"), Ee.getUTCMinutes().toString().padStart(2, "0"), Ee.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          class pe {
            constructor() {
              Be(this, Re, !1);
              this.promise = new Promise((ye, Te) => {
                this.resolve = (je) => {
                  rt(this, Re, !0), ye(je);
                }, this.reject = (je) => {
                  rt(this, Re, !0), Te(je);
                };
              });
            }
            get settled() {
              return ge(this, Re);
            }
          }
          Re = new WeakMap(), F.PromiseCapability = pe;
          let fe = null, Ae = null;
          function Pe(Ee) {
            return fe || (fe = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, Ae = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), Ee.replaceAll(fe, (ye, Te, je) => Te ? Te.normalize("NFKC") : Ae.get(je));
          }
        },
        /* 3 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XRefParseException = F.XRefEntryException = F.ParserEOFException = F.PDF_VERSION_REGEXP = F.MissingDataException = void 0, F.arrayBuffersToBytes = w, F.collectActions = h, F.encodeToXmlString = P, F.escapePDFName = x, F.escapeString = b, F.getInheritableProperty = C, F.getLookupTableFactory = t, F.getNewAnnotationsMap = E, F.getRotationMatrix = p, F.isAscii = H, F.isWhiteSpace = v, F.log2 = k, F.numberToString = N, F.parseXFAPath = r, F.readInt8 = s, F.readUint16 = l, F.readUint32 = g, F.recoverJsURL = A, F.stringToUTF16HexString = $, F.stringToUTF16String = m, F.toRomanNumerals = o, F.validateCSSFont = d, F.validateFontName = c;
          var n = ae(2), u = ae(4), q = ae(5);
          const e = /^[1-9]\.\d$/;
          F.PDF_VERSION_REGEXP = e;
          function t(T) {
            let L;
            return function() {
              return T && (L = /* @__PURE__ */ Object.create(null), T(L), T = null), L;
            };
          }
          class B extends n.BaseException {
            constructor(L, _) {
              super(`Missing data [${L}, ${_})`, "MissingDataException"), this.begin = L, this.end = _;
            }
          }
          F.MissingDataException = B;
          class j extends n.BaseException {
            constructor(L) {
              super(L, "ParserEOFException");
            }
          }
          F.ParserEOFException = j;
          class M extends n.BaseException {
            constructor(L) {
              super(L, "XRefEntryException");
            }
          }
          F.XRefEntryException = M;
          class O extends n.BaseException {
            constructor(L) {
              super(L, "XRefParseException");
            }
          }
          F.XRefParseException = O;
          function w(T) {
            const L = T.length;
            if (L === 0)
              return new Uint8Array(0);
            if (L === 1)
              return new Uint8Array(T[0]);
            let _ = 0;
            for (let K = 0; K < L; K++)
              _ += T[K].byteLength;
            const G = new Uint8Array(_);
            let J = 0;
            for (let K = 0; K < L; K++) {
              const V = new Uint8Array(T[K]);
              G.set(V, J), J += V.byteLength;
            }
            return G;
          }
          function C({
            dict: T,
            key: L,
            getArray: _ = !1,
            stopWhenFound: G = !0
          }) {
            let J;
            const K = new u.RefSet();
            for (; T instanceof u.Dict && !(T.objId && K.has(T.objId)); ) {
              T.objId && K.put(T.objId);
              const V = _ ? T.getArray(L) : T.get(L);
              if (V !== void 0) {
                if (G)
                  return V;
                (J || (J = [])).push(V);
              }
              T = T.get("Parent");
            }
            return J;
          }
          const i = ["", "C", "CC", "CCC", "CD", "D", "DC", "DCC", "DCCC", "CM", "", "X", "XX", "XXX", "XL", "L", "LX", "LXX", "LXXX", "XC", "", "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX"];
          function o(T, L = !1) {
            (0, n.assert)(Number.isInteger(T) && T > 0, "The number should be a positive integer.");
            const _ = [];
            let G;
            for (; T >= 1e3; )
              T -= 1e3, _.push("M");
            G = T / 100 | 0, T %= 100, _.push(i[G]), G = T / 10 | 0, T %= 10, _.push(i[10 + G]), _.push(i[20 + T]);
            const J = _.join("");
            return L ? J.toLowerCase() : J;
          }
          function k(T) {
            return T <= 0 ? 0 : Math.ceil(Math.log2(T));
          }
          function s(T, L) {
            return T[L] << 24 >> 24;
          }
          function l(T, L) {
            return T[L] << 8 | T[L + 1];
          }
          function g(T, L) {
            return (T[L] << 24 | T[L + 1] << 16 | T[L + 2] << 8 | T[L + 3]) >>> 0;
          }
          function v(T) {
            return T === 32 || T === 9 || T === 13 || T === 10;
          }
          function r(T) {
            const L = /(.+)\[(\d+)\]$/;
            return T.split(".").map((_) => {
              const G = _.match(L);
              return G ? {
                name: G[1],
                pos: parseInt(G[2], 10)
              } : {
                name: _,
                pos: 0
              };
            });
          }
          function x(T) {
            const L = [];
            let _ = 0;
            for (let G = 0, J = T.length; G < J; G++) {
              const K = T.charCodeAt(G);
              (K < 33 || K > 126 || K === 35 || K === 40 || K === 41 || K === 60 || K === 62 || K === 91 || K === 93 || K === 123 || K === 125 || K === 47 || K === 37) && (_ < G && L.push(T.substring(_, G)), L.push(`#${K.toString(16)}`), _ = G + 1);
            }
            return L.length === 0 ? T : (_ < T.length && L.push(T.substring(_, T.length)), L.join(""));
          }
          function b(T) {
            return T.replaceAll(/([()\\\n\r])/g, (L) => L === `
` ? "\\n" : L === "\r" ? "\\r" : `\\${L}`);
          }
          function I(T, L, _, G) {
            if (!T)
              return;
            let J = null;
            if (T instanceof u.Ref) {
              if (G.has(T))
                return;
              J = T, G.put(J), T = L.fetch(T);
            }
            if (Array.isArray(T))
              for (const K of T)
                I(K, L, _, G);
            else if (T instanceof u.Dict) {
              if ((0, u.isName)(T.get("S"), "JavaScript")) {
                const K = T.get("JS");
                let V;
                K instanceof q.BaseStream ? V = K.getString() : typeof K == "string" && (V = K), V && (V = (0, n.stringToPDFString)(V).replaceAll("\0", "")), V && _.push(V);
              }
              I(T.getRaw("Next"), L, _, G);
            }
            J && G.remove(J);
          }
          function h(T, L, _) {
            const G = /* @__PURE__ */ Object.create(null), J = C({
              dict: L,
              key: "AA",
              stopWhenFound: !1
            });
            if (J)
              for (let K = J.length - 1; K >= 0; K--) {
                const V = J[K];
                if (V instanceof u.Dict)
                  for (const U of V.getKeys()) {
                    const Q = _[U];
                    if (!Q)
                      continue;
                    const X = V.getRaw(U), R = new u.RefSet(), f = [];
                    I(X, T, f, R), f.length > 0 && (G[Q] = f);
                  }
              }
            if (L.has("A")) {
              const K = L.get("A"), V = new u.RefSet(), U = [];
              I(K, T, U, V), U.length > 0 && (G.Action = U);
            }
            return (0, n.objectSize)(G) > 0 ? G : null;
          }
          const y = {
            60: "&lt;",
            62: "&gt;",
            38: "&amp;",
            34: "&quot;",
            39: "&apos;"
          };
          function P(T) {
            const L = [];
            let _ = 0;
            for (let G = 0, J = T.length; G < J; G++) {
              const K = T.codePointAt(G);
              if (32 <= K && K <= 126) {
                const V = y[K];
                V && (_ < G && L.push(T.substring(_, G)), L.push(V), _ = G + 1);
              } else
                _ < G && L.push(T.substring(_, G)), L.push(`&#x${K.toString(16).toUpperCase()};`), K > 55295 && (K < 57344 || K > 65533) && G++, _ = G + 1;
            }
            return L.length === 0 ? T : (_ < T.length && L.push(T.substring(_, T.length)), L.join(""));
          }
          function c(T, L = !1) {
            const _ = /^("|').*("|')$/.exec(T);
            if (_ && _[1] === _[2]) {
              if (new RegExp(`[^\\\\]${_[1]}`).test(T.slice(1, -1)))
                return L && (0, n.warn)(`FontFamily contains unescaped ${_[1]}: ${T}.`), !1;
            } else
              for (const G of T.split(/[ \t]+/))
                if (/^(\d|(-(\d|-)))/.test(G) || !/^[\w-\\]+$/.test(G))
                  return L && (0, n.warn)(`FontFamily contains invalid <custom-ident>: ${T}.`), !1;
            return !0;
          }
          function d(T) {
            const L = "14", _ = "400", G = /* @__PURE__ */ new Set(["100", "200", "300", "400", "500", "600", "700", "800", "900", "1000", "normal", "bold", "bolder", "lighter"]), {
              fontFamily: J,
              fontWeight: K,
              italicAngle: V
            } = T;
            if (!c(J, !0))
              return !1;
            const U = K ? K.toString() : "";
            T.fontWeight = G.has(U) ? U : _;
            const Q = parseFloat(V);
            return T.italicAngle = isNaN(Q) || Q < -90 || Q > 90 ? L : V.toString(), !0;
          }
          function A(T) {
            const L = ["app.launchURL", "window.open", "xfa.host.gotoURL"], G = new RegExp("^\\s*(" + L.join("|").replaceAll(".", "\\.") + `)\\((?:'|")([^'"]*)(?:'|")(?:,\\s*(\\w+)\\)|\\))`, "i").exec(T);
            if (G != null && G[2]) {
              const J = G[2];
              let K = !1;
              return G[3] === "true" && G[1] === "app.launchURL" && (K = !0), {
                url: J,
                newWindow: K
              };
            }
            return null;
          }
          function N(T) {
            if (Number.isInteger(T))
              return T.toString();
            const L = Math.round(T * 100);
            return L % 100 === 0 ? (L / 100).toString() : L % 10 === 0 ? T.toFixed(1) : T.toFixed(2);
          }
          function E(T) {
            if (!T)
              return null;
            const L = /* @__PURE__ */ new Map();
            for (const [_, G] of T) {
              if (!_.startsWith(n.AnnotationEditorPrefix))
                continue;
              let J = L.get(G.pageIndex);
              J || (J = [], L.set(G.pageIndex, J)), J.push(G);
            }
            return L.size > 0 ? L : null;
          }
          function H(T) {
            return /^[\x00-\x7F]*$/.test(T);
          }
          function $(T) {
            const L = [];
            for (let _ = 0, G = T.length; _ < G; _++) {
              const J = T.charCodeAt(_);
              L.push((J >> 8 & 255).toString(16).padStart(2, "0"), (J & 255).toString(16).padStart(2, "0"));
            }
            return L.join("");
          }
          function m(T, L = !1) {
            const _ = [];
            L && _.push("þÿ");
            for (let G = 0, J = T.length; G < J; G++) {
              const K = T.charCodeAt(G);
              _.push(String.fromCharCode(K >> 8 & 255), String.fromCharCode(K & 255));
            }
            return _.join("");
          }
          function p(T, L, _) {
            switch (T) {
              case 90:
                return [0, 1, -1, 0, L, 0];
              case 180:
                return [-1, 0, 0, -1, L, _];
              case 270:
                return [0, -1, 1, 0, 0, _];
              default:
                throw new Error("Invalid rotation");
            }
          }
        },
        /* 4 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.RefSetCache = F.RefSet = F.Ref = F.Name = F.EOF = F.Dict = F.Cmd = F.CIRCULAR_REF = void 0, F.clearPrimitiveCaches = j, F.isCmd = l, F.isDict = g, F.isName = s, F.isRefsEqual = v;
          var n = ae(2);
          const u = Symbol("CIRCULAR_REF");
          F.CIRCULAR_REF = u;
          const q = Symbol("EOF");
          F.EOF = q;
          let e = /* @__PURE__ */ Object.create(null), t = /* @__PURE__ */ Object.create(null), B = /* @__PURE__ */ Object.create(null);
          function j() {
            e = /* @__PURE__ */ Object.create(null), t = /* @__PURE__ */ Object.create(null), B = /* @__PURE__ */ Object.create(null);
          }
          class M {
            constructor(x) {
              this.name = x;
            }
            static get(x) {
              return t[x] || (t[x] = new M(x));
            }
          }
          F.Name = M;
          class O {
            constructor(x) {
              this.cmd = x;
            }
            static get(x) {
              return e[x] || (e[x] = new O(x));
            }
          }
          F.Cmd = O;
          const w = function() {
            return w;
          };
          class C {
            constructor(x = null) {
              this._map = /* @__PURE__ */ Object.create(null), this.xref = x, this.objId = null, this.suppressEncryption = !1, this.__nonSerializable__ = w;
            }
            assignXref(x) {
              this.xref = x;
            }
            get size() {
              return Object.keys(this._map).length;
            }
            get(x, b, I) {
              let h = this._map[x];
              return h === void 0 && b !== void 0 && (h = this._map[b], h === void 0 && I !== void 0 && (h = this._map[I])), h instanceof i && this.xref ? this.xref.fetch(h, this.suppressEncryption) : h;
            }
            async getAsync(x, b, I) {
              let h = this._map[x];
              return h === void 0 && b !== void 0 && (h = this._map[b], h === void 0 && I !== void 0 && (h = this._map[I])), h instanceof i && this.xref ? this.xref.fetchAsync(h, this.suppressEncryption) : h;
            }
            getArray(x, b, I) {
              let h = this._map[x];
              if (h === void 0 && b !== void 0 && (h = this._map[b], h === void 0 && I !== void 0 && (h = this._map[I])), h instanceof i && this.xref && (h = this.xref.fetch(h, this.suppressEncryption)), Array.isArray(h)) {
                h = h.slice();
                for (let y = 0, P = h.length; y < P; y++)
                  h[y] instanceof i && this.xref && (h[y] = this.xref.fetch(h[y], this.suppressEncryption));
              }
              return h;
            }
            getRaw(x) {
              return this._map[x];
            }
            getKeys() {
              return Object.keys(this._map);
            }
            getRawValues() {
              return Object.values(this._map);
            }
            set(x, b) {
              this._map[x] = b;
            }
            has(x) {
              return this._map[x] !== void 0;
            }
            forEach(x) {
              for (const b in this._map)
                x(b, this.get(b));
            }
            static get empty() {
              const x = new C(null);
              return x.set = (b, I) => {
                (0, n.unreachable)("Should not call `set` on the empty dictionary.");
              }, (0, n.shadow)(this, "empty", x);
            }
            static merge({
              xref: x,
              dictArray: b,
              mergeSubDicts: I = !1
            }) {
              const h = new C(x), y = /* @__PURE__ */ new Map();
              for (const P of b)
                if (P instanceof C)
                  for (const [c, d] of Object.entries(P._map)) {
                    let A = y.get(c);
                    if (A === void 0)
                      A = [], y.set(c, A);
                    else if (!I || !(d instanceof C))
                      continue;
                    A.push(d);
                  }
              for (const [P, c] of y) {
                if (c.length === 1 || !(c[0] instanceof C)) {
                  h._map[P] = c[0];
                  continue;
                }
                const d = new C(x);
                for (const A of c)
                  for (const [N, E] of Object.entries(A._map))
                    d._map[N] === void 0 && (d._map[N] = E);
                d.size > 0 && (h._map[P] = d);
              }
              return y.clear(), h.size > 0 ? h : C.empty;
            }
          }
          F.Dict = C;
          class i {
            constructor(x, b) {
              this.num = x, this.gen = b;
            }
            toString() {
              return this.gen === 0 ? `${this.num}R` : `${this.num}R${this.gen}`;
            }
            static get(x, b) {
              const I = b === 0 ? `${x}R` : `${x}R${b}`;
              return B[I] || (B[I] = new i(x, b));
            }
          }
          F.Ref = i;
          class o {
            constructor(x = null) {
              this._set = new Set(x == null ? void 0 : x._set);
            }
            has(x) {
              return this._set.has(x.toString());
            }
            put(x) {
              this._set.add(x.toString());
            }
            remove(x) {
              this._set.delete(x.toString());
            }
            [Symbol.iterator]() {
              return this._set.values();
            }
            clear() {
              this._set.clear();
            }
          }
          F.RefSet = o;
          class k {
            constructor() {
              this._map = /* @__PURE__ */ new Map();
            }
            get size() {
              return this._map.size;
            }
            get(x) {
              return this._map.get(x.toString());
            }
            has(x) {
              return this._map.has(x.toString());
            }
            put(x, b) {
              this._map.set(x.toString(), b);
            }
            putAlias(x, b) {
              this._map.set(x.toString(), this.get(b));
            }
            [Symbol.iterator]() {
              return this._map.values();
            }
            clear() {
              this._map.clear();
            }
          }
          F.RefSetCache = k;
          function s(r, x) {
            return r instanceof M && (x === void 0 || r.name === x);
          }
          function l(r, x) {
            return r instanceof O && (x === void 0 || r.cmd === x);
          }
          function g(r, x) {
            return r instanceof C && (x === void 0 || s(r.get("Type"), x));
          }
          function v(r, x) {
            return r.num === x.num && r.gen === x.gen;
          }
        },
        /* 5 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.BaseStream = void 0;
          var n = ae(2);
          class u {
            constructor() {
              this.constructor === u && (0, n.unreachable)("Cannot initialize BaseStream.");
            }
            get length() {
              (0, n.unreachable)("Abstract getter `length` accessed");
            }
            get isEmpty() {
              (0, n.unreachable)("Abstract getter `isEmpty` accessed");
            }
            get isDataLoaded() {
              return (0, n.shadow)(this, "isDataLoaded", !0);
            }
            getByte() {
              (0, n.unreachable)("Abstract method `getByte` called");
            }
            getBytes(e) {
              (0, n.unreachable)("Abstract method `getBytes` called");
            }
            peekByte() {
              const e = this.getByte();
              return e !== -1 && this.pos--, e;
            }
            peekBytes(e) {
              const t = this.getBytes(e);
              return this.pos -= t.length, t;
            }
            getUint16() {
              const e = this.getByte(), t = this.getByte();
              return e === -1 || t === -1 ? -1 : (e << 8) + t;
            }
            getInt32() {
              const e = this.getByte(), t = this.getByte(), B = this.getByte(), j = this.getByte();
              return (e << 24) + (t << 16) + (B << 8) + j;
            }
            getByteRange(e, t) {
              (0, n.unreachable)("Abstract method `getByteRange` called");
            }
            getString(e) {
              return (0, n.bytesToString)(this.getBytes(e));
            }
            skip(e) {
              this.pos += e || 1;
            }
            reset() {
              (0, n.unreachable)("Abstract method `reset` called");
            }
            moveStart() {
              (0, n.unreachable)("Abstract method `moveStart` called");
            }
            makeSubStream(e, t, B = null) {
              (0, n.unreachable)("Abstract method `makeSubStream` called");
            }
            getBaseStreams() {
              return null;
            }
          }
          F.BaseStream = u;
        },
        /* 6 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.NetworkPdfManager = F.LocalPdfManager = void 0;
          var n = ae(2), u = ae(7), q = ae(3), e = ae(9), t = ae(8);
          function B(w) {
            if (w) {
              const C = (0, n.createValidAbsoluteUrl)(w);
              if (C)
                return C.href;
              (0, n.warn)(`Invalid absolute docBaseUrl: "${w}".`);
            }
            return null;
          }
          class j {
            constructor(C) {
              var i;
              this.constructor === j && (0, n.unreachable)("Cannot initialize BasePdfManager."), this._docBaseUrl = B(C.docBaseUrl), this._docId = C.docId, this._password = C.password, this.enableXfa = C.enableXfa, (i = C.evaluatorOptions).isOffscreenCanvasSupported && (i.isOffscreenCanvasSupported = n.FeatureTest.isOffscreenCanvasSupported), this.evaluatorOptions = C.evaluatorOptions;
            }
            get docId() {
              return this._docId;
            }
            get password() {
              return this._password;
            }
            get docBaseUrl() {
              const C = this.pdfDocument.catalog;
              return (0, n.shadow)(this, "docBaseUrl", C.baseUrl || this._docBaseUrl);
            }
            ensureDoc(C, i) {
              return this.ensure(this.pdfDocument, C, i);
            }
            ensureXRef(C, i) {
              return this.ensure(this.pdfDocument.xref, C, i);
            }
            ensureCatalog(C, i) {
              return this.ensure(this.pdfDocument.catalog, C, i);
            }
            getPage(C) {
              return this.pdfDocument.getPage(C);
            }
            fontFallback(C, i) {
              return this.pdfDocument.fontFallback(C, i);
            }
            loadXfaFonts(C, i) {
              return this.pdfDocument.loadXfaFonts(C, i);
            }
            loadXfaImages() {
              return this.pdfDocument.loadXfaImages();
            }
            serializeXfaData(C) {
              return this.pdfDocument.serializeXfaData(C);
            }
            cleanup(C = !1) {
              return this.pdfDocument.cleanup(C);
            }
            async ensure(C, i, o) {
              (0, n.unreachable)("Abstract method `ensure` called");
            }
            requestRange(C, i) {
              (0, n.unreachable)("Abstract method `requestRange` called");
            }
            requestLoadedStream(C = !1) {
              (0, n.unreachable)("Abstract method `requestLoadedStream` called");
            }
            sendProgressiveData(C) {
              (0, n.unreachable)("Abstract method `sendProgressiveData` called");
            }
            updatePassword(C) {
              this._password = C;
            }
            terminate(C) {
              (0, n.unreachable)("Abstract method `terminate` called");
            }
          }
          class M extends j {
            constructor(C) {
              super(C);
              const i = new t.Stream(C.source);
              this.pdfDocument = new e.PDFDocument(this, i), this._loadedStreamPromise = Promise.resolve(i);
            }
            async ensure(C, i, o) {
              const k = C[i];
              return typeof k == "function" ? k.apply(C, o) : k;
            }
            requestRange(C, i) {
              return Promise.resolve();
            }
            requestLoadedStream(C = !1) {
              return this._loadedStreamPromise;
            }
            terminate(C) {
            }
          }
          F.LocalPdfManager = M;
          class O extends j {
            constructor(C) {
              super(C), this.streamManager = new u.ChunkedStreamManager(C.source, {
                msgHandler: C.handler,
                length: C.length,
                disableAutoFetch: C.disableAutoFetch,
                rangeChunkSize: C.rangeChunkSize
              }), this.pdfDocument = new e.PDFDocument(this, this.streamManager.getStream());
            }
            async ensure(C, i, o) {
              try {
                const k = C[i];
                return typeof k == "function" ? k.apply(C, o) : k;
              } catch (k) {
                if (!(k instanceof q.MissingDataException))
                  throw k;
                return await this.requestRange(k.begin, k.end), this.ensure(C, i, o);
              }
            }
            requestRange(C, i) {
              return this.streamManager.requestRange(C, i);
            }
            requestLoadedStream(C = !1) {
              return this.streamManager.requestAllChunks(C);
            }
            sendProgressiveData(C) {
              this.streamManager.onReceiveData({
                chunk: C
              });
            }
            terminate(C) {
              this.streamManager.abort(C);
            }
          }
          F.NetworkPdfManager = O;
        },
        /* 7 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ChunkedStreamManager = F.ChunkedStream = void 0;
          var n = ae(3), u = ae(2), q = ae(8);
          class e extends q.Stream {
            constructor(j, M, O) {
              super(new Uint8Array(j), 0, j, null), this.chunkSize = M, this._loadedChunks = /* @__PURE__ */ new Set(), this.numChunks = Math.ceil(j / M), this.manager = O, this.progressiveDataLength = 0, this.lastSuccessfulEnsureByteChunk = -1;
            }
            getMissingChunks() {
              const j = [];
              for (let M = 0, O = this.numChunks; M < O; ++M)
                this._loadedChunks.has(M) || j.push(M);
              return j;
            }
            get numChunksLoaded() {
              return this._loadedChunks.size;
            }
            get isDataLoaded() {
              return this.numChunksLoaded === this.numChunks;
            }
            onReceiveData(j, M) {
              const O = this.chunkSize;
              if (j % O !== 0)
                throw new Error(`Bad begin offset: ${j}`);
              const w = j + M.byteLength;
              if (w % O !== 0 && w !== this.bytes.length)
                throw new Error(`Bad end offset: ${w}`);
              this.bytes.set(new Uint8Array(M), j);
              const C = Math.floor(j / O), i = Math.floor((w - 1) / O) + 1;
              for (let o = C; o < i; ++o)
                this._loadedChunks.add(o);
            }
            onReceiveProgressiveData(j) {
              let M = this.progressiveDataLength;
              const O = Math.floor(M / this.chunkSize);
              this.bytes.set(new Uint8Array(j), M), M += j.byteLength, this.progressiveDataLength = M;
              const w = M >= this.end ? this.numChunks : Math.floor(M / this.chunkSize);
              for (let C = O; C < w; ++C)
                this._loadedChunks.add(C);
            }
            ensureByte(j) {
              if (j < this.progressiveDataLength)
                return;
              const M = Math.floor(j / this.chunkSize);
              if (!(M > this.numChunks) && M !== this.lastSuccessfulEnsureByteChunk) {
                if (!this._loadedChunks.has(M))
                  throw new n.MissingDataException(j, j + 1);
                this.lastSuccessfulEnsureByteChunk = M;
              }
            }
            ensureRange(j, M) {
              if (j >= M || M <= this.progressiveDataLength)
                return;
              const O = Math.floor(j / this.chunkSize);
              if (O > this.numChunks)
                return;
              const w = Math.min(Math.floor((M - 1) / this.chunkSize) + 1, this.numChunks);
              for (let C = O; C < w; ++C)
                if (!this._loadedChunks.has(C))
                  throw new n.MissingDataException(j, M);
            }
            nextEmptyChunk(j) {
              const M = this.numChunks;
              for (let O = 0; O < M; ++O) {
                const w = (j + O) % M;
                if (!this._loadedChunks.has(w))
                  return w;
              }
              return null;
            }
            hasChunk(j) {
              return this._loadedChunks.has(j);
            }
            getByte() {
              const j = this.pos;
              return j >= this.end ? -1 : (j >= this.progressiveDataLength && this.ensureByte(j), this.bytes[this.pos++]);
            }
            getBytes(j) {
              const M = this.bytes, O = this.pos, w = this.end;
              if (!j)
                return w > this.progressiveDataLength && this.ensureRange(O, w), M.subarray(O, w);
              let C = O + j;
              return C > w && (C = w), C > this.progressiveDataLength && this.ensureRange(O, C), this.pos = C, M.subarray(O, C);
            }
            getByteRange(j, M) {
              return j < 0 && (j = 0), M > this.end && (M = this.end), M > this.progressiveDataLength && this.ensureRange(j, M), this.bytes.subarray(j, M);
            }
            makeSubStream(j, M, O = null) {
              M ? j + M > this.progressiveDataLength && this.ensureRange(j, j + M) : j >= this.progressiveDataLength && this.ensureByte(j);
              function w() {
              }
              w.prototype = Object.create(this), w.prototype.getMissingChunks = function() {
                const i = this.chunkSize, o = Math.floor(this.start / i), k = Math.floor((this.end - 1) / i) + 1, s = [];
                for (let l = o; l < k; ++l)
                  this._loadedChunks.has(l) || s.push(l);
                return s;
              }, Object.defineProperty(w.prototype, "isDataLoaded", {
                get() {
                  return this.numChunksLoaded === this.numChunks ? !0 : this.getMissingChunks().length === 0;
                },
                configurable: !0
              });
              const C = new w();
              return C.pos = C.start = j, C.end = j + M || this.end, C.dict = O, C;
            }
            getBaseStreams() {
              return [this];
            }
          }
          F.ChunkedStream = e;
          class t {
            constructor(j, M) {
              this.length = M.length, this.chunkSize = M.rangeChunkSize, this.stream = new e(this.length, this.chunkSize, this), this.pdfNetworkStream = j, this.disableAutoFetch = M.disableAutoFetch, this.msgHandler = M.msgHandler, this.currRequestId = 0, this._chunksNeededByRequest = /* @__PURE__ */ new Map(), this._requestsByChunk = /* @__PURE__ */ new Map(), this._promisesByRequest = /* @__PURE__ */ new Map(), this.progressiveDataLength = 0, this.aborted = !1, this._loadedStreamCapability = new u.PromiseCapability();
            }
            sendRequest(j, M) {
              const O = this.pdfNetworkStream.getRangeReader(j, M);
              O.isStreamingSupported || (O.onProgress = this.onProgress.bind(this));
              let w = [], C = 0;
              return new Promise((i, o) => {
                const k = ({
                  value: s,
                  done: l
                }) => {
                  try {
                    if (l) {
                      const g = (0, n.arrayBuffersToBytes)(w);
                      w = null, i(g);
                      return;
                    }
                    C += s.byteLength, O.isStreamingSupported && this.onProgress({
                      loaded: C
                    }), w.push(s), O.read().then(k, o);
                  } catch (g) {
                    o(g);
                  }
                };
                O.read().then(k, o);
              }).then((i) => {
                this.aborted || this.onReceiveData({
                  chunk: i,
                  begin: j
                });
              });
            }
            requestAllChunks(j = !1) {
              if (!j) {
                const M = this.stream.getMissingChunks();
                this._requestChunks(M);
              }
              return this._loadedStreamCapability.promise;
            }
            _requestChunks(j) {
              const M = this.currRequestId++, O = /* @__PURE__ */ new Set();
              this._chunksNeededByRequest.set(M, O);
              for (const i of j)
                this.stream.hasChunk(i) || O.add(i);
              if (O.size === 0)
                return Promise.resolve();
              const w = new u.PromiseCapability();
              this._promisesByRequest.set(M, w);
              const C = [];
              for (const i of O) {
                let o = this._requestsByChunk.get(i);
                o || (o = [], this._requestsByChunk.set(i, o), C.push(i)), o.push(M);
              }
              if (C.length > 0) {
                const i = this.groupChunks(C);
                for (const o of i) {
                  const k = o.beginChunk * this.chunkSize, s = Math.min(o.endChunk * this.chunkSize, this.length);
                  this.sendRequest(k, s).catch(w.reject);
                }
              }
              return w.promise.catch((i) => {
                if (!this.aborted)
                  throw i;
              });
            }
            getStream() {
              return this.stream;
            }
            requestRange(j, M) {
              M = Math.min(M, this.length);
              const O = this.getBeginChunk(j), w = this.getEndChunk(M), C = [];
              for (let i = O; i < w; ++i)
                C.push(i);
              return this._requestChunks(C);
            }
            requestRanges(j = []) {
              const M = [];
              for (const O of j) {
                const w = this.getBeginChunk(O.begin), C = this.getEndChunk(O.end);
                for (let i = w; i < C; ++i)
                  M.includes(i) || M.push(i);
              }
              return M.sort(function(O, w) {
                return O - w;
              }), this._requestChunks(M);
            }
            groupChunks(j) {
              const M = [];
              let O = -1, w = -1;
              for (let C = 0, i = j.length; C < i; ++C) {
                const o = j[C];
                O < 0 && (O = o), w >= 0 && w + 1 !== o && (M.push({
                  beginChunk: O,
                  endChunk: w + 1
                }), O = o), C + 1 === j.length && M.push({
                  beginChunk: O,
                  endChunk: o + 1
                }), w = o;
              }
              return M;
            }
            onProgress(j) {
              this.msgHandler.send("DocProgress", {
                loaded: this.stream.numChunksLoaded * this.chunkSize + j.loaded,
                total: this.length
              });
            }
            onReceiveData(j) {
              const M = j.chunk, O = j.begin === void 0, w = O ? this.progressiveDataLength : j.begin, C = w + M.byteLength, i = Math.floor(w / this.chunkSize), o = C < this.length ? Math.floor(C / this.chunkSize) : Math.ceil(C / this.chunkSize);
              O ? (this.stream.onReceiveProgressiveData(M), this.progressiveDataLength = C) : this.stream.onReceiveData(w, M), this.stream.isDataLoaded && this._loadedStreamCapability.resolve(this.stream);
              const k = [];
              for (let s = i; s < o; ++s) {
                const l = this._requestsByChunk.get(s);
                if (l) {
                  this._requestsByChunk.delete(s);
                  for (const g of l) {
                    const v = this._chunksNeededByRequest.get(g);
                    v.has(s) && v.delete(s), !(v.size > 0) && k.push(g);
                  }
                }
              }
              if (!this.disableAutoFetch && this._requestsByChunk.size === 0) {
                let s;
                if (this.stream.numChunksLoaded === 1) {
                  const l = this.stream.numChunks - 1;
                  this.stream.hasChunk(l) || (s = l);
                } else
                  s = this.stream.nextEmptyChunk(o);
                Number.isInteger(s) && this._requestChunks([s]);
              }
              for (const s of k) {
                const l = this._promisesByRequest.get(s);
                this._promisesByRequest.delete(s), l.resolve();
              }
              this.msgHandler.send("DocProgress", {
                loaded: this.stream.numChunksLoaded * this.chunkSize,
                total: this.length
              });
            }
            onError(j) {
              this._loadedStreamCapability.reject(j);
            }
            getBeginChunk(j) {
              return Math.floor(j / this.chunkSize);
            }
            getEndChunk(j) {
              return Math.floor((j - 1) / this.chunkSize) + 1;
            }
            abort(j) {
              this.aborted = !0, this.pdfNetworkStream && this.pdfNetworkStream.cancelAllRequests(j);
              for (const M of this._promisesByRequest.values())
                M.reject(j);
            }
          }
          F.ChunkedStreamManager = t;
        },
        /* 8 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.StringStream = F.Stream = F.NullStream = void 0;
          var n = ae(5), u = ae(2);
          class q extends n.BaseStream {
            constructor(j, M, O, w) {
              super(), this.bytes = j instanceof Uint8Array ? j : new Uint8Array(j), this.start = M || 0, this.pos = this.start, this.end = M + O || this.bytes.length, this.dict = w;
            }
            get length() {
              return this.end - this.start;
            }
            get isEmpty() {
              return this.length === 0;
            }
            getByte() {
              return this.pos >= this.end ? -1 : this.bytes[this.pos++];
            }
            getBytes(j) {
              const M = this.bytes, O = this.pos, w = this.end;
              if (!j)
                return M.subarray(O, w);
              let C = O + j;
              return C > w && (C = w), this.pos = C, M.subarray(O, C);
            }
            getByteRange(j, M) {
              return j < 0 && (j = 0), M > this.end && (M = this.end), this.bytes.subarray(j, M);
            }
            reset() {
              this.pos = this.start;
            }
            moveStart() {
              this.start = this.pos;
            }
            makeSubStream(j, M, O = null) {
              return new q(this.bytes.buffer, j, M, O);
            }
          }
          F.Stream = q;
          class e extends q {
            constructor(j) {
              super((0, u.stringToBytes)(j));
            }
          }
          F.StringStream = e;
          class t extends q {
            constructor() {
              super(new Uint8Array(0));
            }
          }
          F.NullStream = t;
        },
        /* 9 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Page = F.PDFDocument = void 0;
          var n = ae(10), u = ae(2), q = ae(3), e = ae(4), t = ae(51), B = ae(5), j = ae(68), M = ae(70), O = ae(72), w = ae(101), C = ae(16), i = ae(8), o = ae(76), k = ae(64), s = ae(13), l = ae(18), g = ae(75), v = ae(66), r = ae(77), x = ae(102);
          const b = 1, I = [0, 0, 612, 792];
          class h {
            constructor({
              pdfManager: $,
              xref: m,
              pageIndex: p,
              pageDict: T,
              ref: L,
              globalIdFactory: _,
              fontCache: G,
              builtInCMapCache: J,
              standardFontDataCache: K,
              globalImageCache: V,
              systemFontCache: U,
              nonBlendModesSet: Q,
              xfaFactory: X
            }) {
              this.pdfManager = $, this.pageIndex = p, this.pageDict = T, this.xref = m, this.ref = L, this.fontCache = G, this.builtInCMapCache = J, this.standardFontDataCache = K, this.globalImageCache = V, this.systemFontCache = U, this.nonBlendModesSet = Q, this.evaluatorOptions = $.evaluatorOptions, this.resourcesPromise = null, this.xfaFactory = X;
              const R = {
                obj: 0
              };
              this._localIdFactory = class extends _ {
                static createObjId() {
                  return `p${p}_${++R.obj}`;
                }
                static getPageObjId() {
                  return `p${L.toString()}`;
                }
              };
            }
            _getInheritableProperty($, m = !1) {
              const p = (0, q.getInheritableProperty)({
                dict: this.pageDict,
                key: $,
                getArray: m,
                stopWhenFound: !1
              });
              return Array.isArray(p) ? p.length === 1 || !(p[0] instanceof e.Dict) ? p[0] : e.Dict.merge({
                xref: this.xref,
                dictArray: p
              }) : p;
            }
            get content() {
              return this.pageDict.getArray("Contents");
            }
            get resources() {
              const $ = this._getInheritableProperty("Resources");
              return (0, u.shadow)(this, "resources", $ instanceof e.Dict ? $ : e.Dict.empty);
            }
            _getBoundingBox($) {
              if (this.xfaData)
                return this.xfaData.bbox;
              let m = this._getInheritableProperty($, !0);
              if (Array.isArray(m) && m.length === 4) {
                if (m = u.Util.normalizeRect(m), m[2] - m[0] > 0 && m[3] - m[1] > 0)
                  return m;
                (0, u.warn)(`Empty, or invalid, /${$} entry.`);
              }
              return null;
            }
            get mediaBox() {
              return (0, u.shadow)(this, "mediaBox", this._getBoundingBox("MediaBox") || I);
            }
            get cropBox() {
              return (0, u.shadow)(this, "cropBox", this._getBoundingBox("CropBox") || this.mediaBox);
            }
            get userUnit() {
              let $ = this.pageDict.get("UserUnit");
              return (typeof $ != "number" || $ <= 0) && ($ = b), (0, u.shadow)(this, "userUnit", $);
            }
            get view() {
              const {
                cropBox: $,
                mediaBox: m
              } = this;
              if ($ !== m && !(0, u.isArrayEqual)($, m)) {
                const p = u.Util.intersect($, m);
                if (p && p[2] - p[0] > 0 && p[3] - p[1] > 0)
                  return (0, u.shadow)(this, "view", p);
                (0, u.warn)("Empty /CropBox and /MediaBox intersection.");
              }
              return (0, u.shadow)(this, "view", m);
            }
            get rotate() {
              let $ = this._getInheritableProperty("Rotate") || 0;
              return $ % 90 !== 0 ? $ = 0 : $ >= 360 ? $ %= 360 : $ < 0 && ($ = ($ % 360 + 360) % 360), (0, u.shadow)(this, "rotate", $);
            }
            _onSubStreamError($, m) {
              if (this.evaluatorOptions.ignoreErrors) {
                (0, u.warn)(`getContentStream - ignoring sub-stream (${m}): "${$}".`);
                return;
              }
              throw $;
            }
            getContentStream() {
              return this.pdfManager.ensure(this, "content").then(($) => $ instanceof B.BaseStream ? $ : Array.isArray($) ? new l.StreamsSequenceStream($, this._onSubStreamError.bind(this)) : new i.NullStream());
            }
            get xfaData() {
              return (0, u.shadow)(this, "xfaData", this.xfaFactory ? {
                bbox: this.xfaFactory.getBoundingBox(this.pageIndex)
              } : null);
            }
            async saveNewAnnotations($, m, p) {
              if (this.xfaFactory)
                throw new Error("XFA: Cannot save new annotations.");
              const T = new s.PartialEvaluator({
                xref: this.xref,
                handler: $,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), L = this.pageDict, _ = this.annotations.slice(), G = await n.AnnotationFactory.saveNewAnnotations(T, m, p);
              for (const {
                ref: Q
              } of G.annotations)
                _.push(Q);
              const J = L.get("Annots");
              L.set("Annots", _);
              const K = [];
              let V = null;
              this.xref.encrypt && (V = this.xref.encrypt.createCipherTransform(this.ref.num, this.ref.gen)), await (0, v.writeObject)(this.ref, L, K, V), J && L.set("Annots", J);
              const U = G.dependencies;
              return U.push({
                ref: this.ref,
                data: K.join("")
              }, ...G.annotations), U;
            }
            save($, m, p) {
              const T = new s.PartialEvaluator({
                xref: this.xref,
                handler: $,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              });
              return this._parsedAnnotations.then(function(L) {
                const _ = [];
                for (const G of L)
                  G.mustBePrinted(p) && _.push(G.save(T, m, p).catch(function(J) {
                    return (0, u.warn)(`save - ignoring annotation data during "${m.name}" task: "${J}".`), null;
                  }));
                return Promise.all(_).then(function(G) {
                  return G.filter((J) => !!J);
                });
              });
            }
            loadResources($) {
              return this.resourcesPromise || (this.resourcesPromise = this.pdfManager.ensure(this, "resources")), this.resourcesPromise.then(() => new o.ObjectLoader(this.resources, $, this.xref).load());
            }
            getOperatorList({
              handler: $,
              sink: m,
              task: p,
              intent: T,
              cacheKey: L,
              annotationStorage: _ = null
            }) {
              const G = this.getContentStream(), J = this.loadResources(["ColorSpace", "ExtGState", "Font", "Pattern", "Properties", "Shading", "XObject"]), K = new s.PartialEvaluator({
                xref: this.xref,
                handler: $,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }), V = this.xfaFactory ? null : (0, q.getNewAnnotationsMap)(_);
              let U = Promise.resolve(null);
              if (V) {
                const R = V.get(this.pageIndex);
                R && (U = n.AnnotationFactory.printNewAnnotations(K, p, R));
              }
              const X = Promise.all([G, J]).then(([R]) => {
                const f = new k.OperatorList(T, m);
                return $.send("StartRenderPage", {
                  transparency: K.hasBlendModes(this.resources, this.nonBlendModesSet),
                  pageIndex: this.pageIndex,
                  cacheKey: L
                }), K.getOperatorList({
                  stream: R,
                  task: p,
                  resources: this.resources,
                  operatorList: f
                }).then(function() {
                  return f;
                });
              });
              return Promise.all([X, this._parsedAnnotations, U]).then(function([R, f, D]) {
                if (D && (f = f.concat(D)), f.length === 0 || T & u.RenderingIntentFlag.ANNOTATIONS_DISABLE)
                  return R.flush(!0), {
                    length: R.totalLength
                  };
                const z = !!(T & u.RenderingIntentFlag.ANNOTATIONS_FORMS), Y = !!(T & u.RenderingIntentFlag.ANY), W = !!(T & u.RenderingIntentFlag.DISPLAY), ie = !!(T & u.RenderingIntentFlag.PRINT), ne = [];
                for (const re of f)
                  (Y || W && re.mustBeViewed(_) || ie && re.mustBePrinted(_)) && ne.push(re.getOperatorList(K, p, T, z, _).catch(function(ee) {
                    return (0, u.warn)(`getOperatorList - ignoring annotation data during "${p.name}" task: "${ee}".`), {
                      opList: null,
                      separateForm: !1,
                      separateCanvas: !1
                    };
                  }));
                return Promise.all(ne).then(function(re) {
                  let ee = !1, te = !1;
                  for (const {
                    opList: oe,
                    separateForm: se,
                    separateCanvas: ce
                  } of re)
                    R.addOpList(oe), ee || (ee = se), te || (te = ce);
                  return R.flush(!0, {
                    form: ee,
                    canvas: te
                  }), {
                    length: R.totalLength
                  };
                });
              });
            }
            extractTextContent({
              handler: $,
              task: m,
              includeMarkedContent: p,
              disableNormalization: T,
              sink: L
            }) {
              const _ = this.getContentStream(), G = this.loadResources(["ExtGState", "Font", "Properties", "XObject"]);
              return Promise.all([_, G]).then(([K]) => new s.PartialEvaluator({
                xref: this.xref,
                handler: $,
                pageIndex: this.pageIndex,
                idFactory: this._localIdFactory,
                fontCache: this.fontCache,
                builtInCMapCache: this.builtInCMapCache,
                standardFontDataCache: this.standardFontDataCache,
                globalImageCache: this.globalImageCache,
                systemFontCache: this.systemFontCache,
                options: this.evaluatorOptions
              }).getTextContent({
                stream: K,
                task: m,
                resources: this.resources,
                includeMarkedContent: p,
                disableNormalization: T,
                sink: L,
                viewBox: this.view
              }));
            }
            async getStructTree() {
              const $ = await this.pdfManager.ensureCatalog("structTreeRoot");
              return $ ? (await this.pdfManager.ensure(this, "_parseStructTree", [$])).serializable : null;
            }
            _parseStructTree($) {
              const m = new g.StructTreePage($, this.pageDict);
              return m.parse(), m;
            }
            async getAnnotationsData($, m, p) {
              const T = await this._parsedAnnotations;
              if (T.length === 0)
                return [];
              const L = [], _ = [];
              let G;
              const J = !!(p & u.RenderingIntentFlag.ANY), K = !!(p & u.RenderingIntentFlag.DISPLAY), V = !!(p & u.RenderingIntentFlag.PRINT);
              for (const U of T) {
                const Q = J || K && U.viewable;
                (Q || V && U.printable) && L.push(U.data), U.hasTextContent && Q && (G || (G = new s.PartialEvaluator({
                  xref: this.xref,
                  handler: $,
                  pageIndex: this.pageIndex,
                  idFactory: this._localIdFactory,
                  fontCache: this.fontCache,
                  builtInCMapCache: this.builtInCMapCache,
                  standardFontDataCache: this.standardFontDataCache,
                  globalImageCache: this.globalImageCache,
                  systemFontCache: this.systemFontCache,
                  options: this.evaluatorOptions
                })), _.push(U.extractTextContent(G, m, [-1 / 0, -1 / 0, 1 / 0, 1 / 0]).catch(function(X) {
                  (0, u.warn)(`getAnnotationsData - ignoring textContent during "${m.name}" task: "${X}".`);
                })));
              }
              return await Promise.all(_), L;
            }
            get annotations() {
              const $ = this._getInheritableProperty("Annots");
              return (0, u.shadow)(this, "annotations", Array.isArray($) ? $ : []);
            }
            get _parsedAnnotations() {
              const $ = this.pdfManager.ensure(this, "annotations").then(() => {
                const m = [];
                for (const p of this.annotations)
                  m.push(n.AnnotationFactory.create(this.xref, p, this.pdfManager, this._localIdFactory, !1).catch(function(T) {
                    return (0, u.warn)(`_parsedAnnotations: "${T}".`), null;
                  }));
                return Promise.all(m).then(function(p) {
                  if (p.length === 0)
                    return p;
                  const T = [];
                  let L;
                  for (const _ of p)
                    if (_) {
                      if (_ instanceof n.PopupAnnotation) {
                        (L || (L = [])).push(_);
                        continue;
                      }
                      T.push(_);
                    }
                  return L && T.push(...L), T;
                });
              });
              return (0, u.shadow)(this, "_parsedAnnotations", $);
            }
            get jsActions() {
              const $ = (0, q.collectActions)(this.xref, this.pageDict, u.PageActionEventType);
              return (0, u.shadow)(this, "jsActions", $);
            }
          }
          F.Page = h;
          const y = new Uint8Array([37, 80, 68, 70, 45]), P = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), c = new Uint8Array([101, 110, 100, 111, 98, 106]), d = 1024, A = "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          function N(H, $, m = 1024, p = !1) {
            const T = $.length, L = H.peekBytes(m), _ = L.length - T;
            if (_ <= 0)
              return !1;
            if (p) {
              const G = T - 1;
              let J = L.length - 1;
              for (; J >= G; ) {
                let K = 0;
                for (; K < T && L[J - K] === $[G - K]; )
                  K++;
                if (K >= T)
                  return H.pos += J - G, !0;
                J--;
              }
            } else {
              let G = 0;
              for (; G <= _; ) {
                let J = 0;
                for (; J < T && L[G + J] === $[J]; )
                  J++;
                if (J >= T)
                  return H.pos += G, !0;
                G++;
              }
            }
            return !1;
          }
          class E {
            constructor($, m) {
              if (m.length <= 0)
                throw new u.InvalidPDFException("The PDF file is empty, i.e. its size is zero bytes.");
              this.pdfManager = $, this.stream = m, this.xref = new x.XRef(m, $), this._pagePromises = /* @__PURE__ */ new Map(), this._version = null;
              const p = {
                font: 0
              };
              this._globalIdFactory = class {
                static getDocId() {
                  return `g_${$.docId}`;
                }
                static createFontId() {
                  return `f${++p.font}`;
                }
                static createObjId() {
                  (0, u.unreachable)("Abstract method `createObjId` called.");
                }
                static getPageObjId() {
                  (0, u.unreachable)("Abstract method `getPageObjId` called.");
                }
              };
            }
            parse($) {
              this.xref.parse($), this.catalog = new M.Catalog(this.pdfManager, this.xref);
            }
            get linearization() {
              let $ = null;
              try {
                $ = C.Linearization.create(this.stream);
              } catch (m) {
                if (m instanceof q.MissingDataException)
                  throw m;
                (0, u.info)(m);
              }
              return (0, u.shadow)(this, "linearization", $);
            }
            get startXRef() {
              const $ = this.stream;
              let m = 0;
              if (this.linearization)
                $.reset(), N($, c) && (m = $.pos + 6 - $.start);
              else {
                const T = P.length;
                let L = !1, _ = $.end;
                for (; !L && _ > 0; )
                  _ -= 1024 - T, _ < 0 && (_ = 0), $.pos = _, L = N($, P, 1024, !0);
                if (L) {
                  $.skip(9);
                  let G;
                  do
                    G = $.getByte();
                  while ((0, q.isWhiteSpace)(G));
                  let J = "";
                  for (; G >= 32 && G <= 57; )
                    J += String.fromCharCode(G), G = $.getByte();
                  m = parseInt(J, 10), isNaN(m) && (m = 0);
                }
              }
              return (0, u.shadow)(this, "startXRef", m);
            }
            checkHeader() {
              const $ = this.stream;
              if ($.reset(), !N($, y))
                return;
              $.moveStart(), $.skip(y.length);
              let m = "", p;
              for (; (p = $.getByte()) > 32 && m.length < 7; )
                m += String.fromCharCode(p);
              q.PDF_VERSION_REGEXP.test(m) ? this._version = m : (0, u.warn)(`Invalid PDF header version: ${m}`);
            }
            parseStartXRef() {
              this.xref.setStartXRef(this.startXRef);
            }
            get numPages() {
              let $ = 0;
              return this.catalog.hasActualNumPages ? $ = this.catalog.numPages : this.xfaFactory ? $ = this.xfaFactory.getNumPages() : this.linearization ? $ = this.linearization.numPages : $ = this.catalog.numPages, (0, u.shadow)(this, "numPages", $);
            }
            _hasOnlyDocumentSignatures($, m = 0) {
              return Array.isArray($) ? $.every((T) => {
                if (T = this.xref.fetchIfRef(T), !(T instanceof e.Dict))
                  return !1;
                if (T.has("Kids"))
                  return ++m > 10 ? ((0, u.warn)("_hasOnlyDocumentSignatures: maximum recursion depth reached"), !1) : this._hasOnlyDocumentSignatures(T.get("Kids"), m);
                const L = (0, e.isName)(T.get("FT"), "Sig"), _ = T.get("Rect"), G = Array.isArray(_) && _.every((J) => J === 0);
                return L && G;
              }) : !1;
            }
            get _xfaStreams() {
              const $ = this.catalog.acroForm;
              if (!$)
                return null;
              const m = $.get("XFA"), p = {
                "xdp:xdp": "",
                template: "",
                datasets: "",
                config: "",
                connectionSet: "",
                localeSet: "",
                stylesheet: "",
                "/xdp:xdp": ""
              };
              if (m instanceof B.BaseStream && !m.isEmpty)
                return p["xdp:xdp"] = m, p;
              if (!Array.isArray(m) || m.length === 0)
                return null;
              for (let T = 0, L = m.length; T < L; T += 2) {
                let _;
                if (T === 0 ? _ = "xdp:xdp" : T === L - 2 ? _ = "/xdp:xdp" : _ = m[T], !p.hasOwnProperty(_))
                  continue;
                const G = this.xref.fetchIfRef(m[T + 1]);
                !(G instanceof B.BaseStream) || G.isEmpty || (p[_] = G);
              }
              return p;
            }
            get xfaDatasets() {
              const $ = this._xfaStreams;
              if (!$)
                return (0, u.shadow)(this, "xfaDatasets", null);
              for (const m of ["datasets", "xdp:xdp"]) {
                const p = $[m];
                if (p)
                  try {
                    const T = (0, u.stringToUTF8String)(p.getString()), L = {
                      [m]: T
                    };
                    return (0, u.shadow)(this, "xfaDatasets", new w.DatasetReader(L));
                  } catch {
                    (0, u.warn)("XFA - Invalid utf-8 string.");
                    break;
                  }
              }
              return (0, u.shadow)(this, "xfaDatasets", null);
            }
            get xfaData() {
              const $ = this._xfaStreams;
              if (!$)
                return null;
              const m = /* @__PURE__ */ Object.create(null);
              for (const [p, T] of Object.entries($))
                if (T)
                  try {
                    m[p] = (0, u.stringToUTF8String)(T.getString());
                  } catch {
                    return (0, u.warn)("XFA - Invalid utf-8 string."), null;
                  }
              return m;
            }
            get xfaFactory() {
              let $;
              return this.pdfManager.enableXfa && this.catalog.needsRendering && this.formInfo.hasXfa && !this.formInfo.hasAcroForm && ($ = this.xfaData), (0, u.shadow)(this, "xfaFactory", $ ? new r.XFAFactory($) : null);
            }
            get isPureXfa() {
              return this.xfaFactory ? this.xfaFactory.isValid() : !1;
            }
            get htmlForXfa() {
              return this.xfaFactory ? this.xfaFactory.getPages() : null;
            }
            async loadXfaImages() {
              const $ = await this.pdfManager.ensureCatalog("xfaImages");
              if (!$)
                return;
              const m = $.getKeys();
              await new o.ObjectLoader($, m, this.xref).load();
              const T = /* @__PURE__ */ new Map();
              for (const L of m) {
                const _ = $.get(L);
                _ instanceof B.BaseStream && T.set(L, _.getBytes());
              }
              this.xfaFactory.setImages(T);
            }
            async loadXfaFonts($, m) {
              const p = await this.pdfManager.ensureCatalog("acroForm");
              if (!p)
                return;
              const T = await p.getAsync("DR");
              if (!(T instanceof e.Dict))
                return;
              await new o.ObjectLoader(T, ["Font"], this.xref).load();
              const _ = T.get("Font");
              if (!(_ instanceof e.Dict))
                return;
              const G = Object.assign(/* @__PURE__ */ Object.create(null), this.pdfManager.evaluatorOptions);
              G.useSystemFonts = !1;
              const J = new s.PartialEvaluator({
                xref: this.xref,
                handler: $,
                pageIndex: -1,
                idFactory: this._globalIdFactory,
                fontCache: this.catalog.fontCache,
                builtInCMapCache: this.catalog.builtInCMapCache,
                standardFontDataCache: this.catalog.standardFontDataCache,
                options: G
              }), K = new k.OperatorList(), V = [], U = {
                get font() {
                  return V.at(-1);
                },
                set font(D) {
                  V.push(D);
                },
                clone() {
                  return this;
                }
              }, Q = /* @__PURE__ */ new Map();
              _.forEach((D, z) => {
                Q.set(D, z);
              });
              const X = [];
              for (const [D, z] of Q) {
                const Y = z.get("FontDescriptor");
                if (!(Y instanceof e.Dict))
                  continue;
                let W = Y.get("FontFamily");
                W = W.replaceAll(/[ ]+(\d)/g, "$1");
                const ie = Y.get("FontWeight"), ne = -Y.get("ItalicAngle"), re = {
                  fontFamily: W,
                  fontWeight: ie,
                  italicAngle: ne
                };
                (0, q.validateCSSFont)(re) && X.push(J.handleSetFont(T, [e.Name.get(D), 1], null, K, m, U, null, re).catch(function(ee) {
                  return (0, u.warn)(`loadXfaFonts: "${ee}".`), null;
                }));
              }
              await Promise.all(X);
              const R = this.xfaFactory.setFonts(V);
              if (!R)
                return;
              G.ignoreErrors = !0, X.length = 0, V.length = 0;
              const f = /* @__PURE__ */ new Set();
              for (const D of R)
                (0, t.getXfaFontName)(`${D}-Regular`) || f.add(D);
              f.size && R.push("PdfJS-Fallback");
              for (const D of R)
                if (!f.has(D))
                  for (const z of [{
                    name: "Regular",
                    fontWeight: 400,
                    italicAngle: 0
                  }, {
                    name: "Bold",
                    fontWeight: 700,
                    italicAngle: 0
                  }, {
                    name: "Italic",
                    fontWeight: 400,
                    italicAngle: 12
                  }, {
                    name: "BoldItalic",
                    fontWeight: 700,
                    italicAngle: 12
                  }]) {
                    const Y = `${D}-${z.name}`, W = (0, t.getXfaFontDict)(Y);
                    X.push(J.handleSetFont(T, [e.Name.get(Y), 1], null, K, m, U, W, {
                      fontFamily: D,
                      fontWeight: z.fontWeight,
                      italicAngle: z.italicAngle
                    }).catch(function(ie) {
                      return (0, u.warn)(`loadXfaFonts: "${ie}".`), null;
                    }));
                  }
              await Promise.all(X), this.xfaFactory.appendFonts(V, f);
            }
            async serializeXfaData($) {
              return this.xfaFactory ? this.xfaFactory.serializeData($) : null;
            }
            get version() {
              return this.catalog.version || this._version;
            }
            get formInfo() {
              const $ = {
                hasFields: !1,
                hasAcroForm: !1,
                hasXfa: !1,
                hasSignatures: !1
              }, m = this.catalog.acroForm;
              if (!m)
                return (0, u.shadow)(this, "formInfo", $);
              try {
                const p = m.get("Fields"), T = Array.isArray(p) && p.length > 0;
                $.hasFields = T;
                const L = m.get("XFA");
                $.hasXfa = Array.isArray(L) && L.length > 0 || L instanceof B.BaseStream && !L.isEmpty;
                const G = !!(m.get("SigFlags") & 1), J = G && this._hasOnlyDocumentSignatures(p);
                $.hasAcroForm = T && !J, $.hasSignatures = G;
              } catch (p) {
                if (p instanceof q.MissingDataException)
                  throw p;
                (0, u.warn)(`Cannot fetch form information: "${p}".`);
              }
              return (0, u.shadow)(this, "formInfo", $);
            }
            get documentInfo() {
              const $ = {
                PDFFormatVersion: this.version,
                Language: this.catalog.lang,
                EncryptFilterName: this.xref.encrypt ? this.xref.encrypt.filterName : null,
                IsLinearized: !!this.linearization,
                IsAcroFormPresent: this.formInfo.hasAcroForm,
                IsXFAPresent: this.formInfo.hasXfa,
                IsCollectionPresent: !!this.catalog.collection,
                IsSignaturesPresent: this.formInfo.hasSignatures
              };
              let m;
              try {
                m = this.xref.trailer.get("Info");
              } catch (p) {
                if (p instanceof q.MissingDataException)
                  throw p;
                (0, u.info)("The document information dictionary is invalid.");
              }
              if (!(m instanceof e.Dict))
                return (0, u.shadow)(this, "documentInfo", $);
              for (const p of m.getKeys()) {
                const T = m.get(p);
                switch (p) {
                  case "Title":
                  case "Author":
                  case "Subject":
                  case "Keywords":
                  case "Creator":
                  case "Producer":
                  case "CreationDate":
                  case "ModDate":
                    if (typeof T == "string") {
                      $[p] = (0, u.stringToPDFString)(T);
                      continue;
                    }
                    break;
                  case "Trapped":
                    if (T instanceof e.Name) {
                      $[p] = T;
                      continue;
                    }
                    break;
                  default:
                    let L;
                    switch (typeof T) {
                      case "string":
                        L = (0, u.stringToPDFString)(T);
                        break;
                      case "number":
                      case "boolean":
                        L = T;
                        break;
                      default:
                        T instanceof e.Name && (L = T);
                        break;
                    }
                    if (L === void 0) {
                      (0, u.warn)(`Bad value, for custom key "${p}", in Info: ${T}.`);
                      continue;
                    }
                    $.Custom || ($.Custom = /* @__PURE__ */ Object.create(null)), $.Custom[p] = L;
                    continue;
                }
                (0, u.warn)(`Bad value, for key "${p}", in Info: ${T}.`);
              }
              return (0, u.shadow)(this, "documentInfo", $);
            }
            get fingerprints() {
              function $(_) {
                return typeof _ == "string" && _.length > 0 && _ !== A;
              }
              function m(_) {
                const G = [];
                for (const J of _) {
                  const K = J.toString(16);
                  G.push(K.padStart(2, "0"));
                }
                return G.join("");
              }
              const p = this.xref.trailer.get("ID");
              let T, L;
              return Array.isArray(p) && $(p[0]) ? (T = (0, u.stringToBytes)(p[0]), p[1] !== p[0] && $(p[1]) && (L = (0, u.stringToBytes)(p[1]))) : T = (0, j.calculateMD5)(this.stream.getByteRange(0, d), 0, d), (0, u.shadow)(this, "fingerprints", [m(T), L ? m(L) : null]);
            }
            async _getLinearizationPage($) {
              const {
                catalog: m,
                linearization: p,
                xref: T
              } = this, L = e.Ref.get(p.objectNumberFirst, 0);
              try {
                const _ = await T.fetchAsync(L);
                if (_ instanceof e.Dict) {
                  let G = _.getRaw("Type");
                  if (G instanceof e.Ref && (G = await T.fetchAsync(G)), (0, e.isName)(G, "Page") || !_.has("Type") && !_.has("Kids"))
                    return m.pageKidsCountCache.has(L) || m.pageKidsCountCache.put(L, 1), m.pageIndexCache.has(L) || m.pageIndexCache.put(L, 0), [_, L];
                }
                throw new u.FormatError("The Linearization dictionary doesn't point to a valid Page dictionary.");
              } catch (_) {
                return (0, u.warn)(`_getLinearizationPage: "${_.message}".`), m.getPageDict($);
              }
            }
            getPage($) {
              const m = this._pagePromises.get($);
              if (m)
                return m;
              const {
                catalog: p,
                linearization: T,
                xfaFactory: L
              } = this;
              let _;
              return L ? _ = Promise.resolve([e.Dict.empty, null]) : (T == null ? void 0 : T.pageFirst) === $ ? _ = this._getLinearizationPage($) : _ = p.getPageDict($), _ = _.then(([G, J]) => new h({
                pdfManager: this.pdfManager,
                xref: this.xref,
                pageIndex: $,
                pageDict: G,
                ref: J,
                globalIdFactory: this._globalIdFactory,
                fontCache: p.fontCache,
                builtInCMapCache: p.builtInCMapCache,
                standardFontDataCache: p.standardFontDataCache,
                globalImageCache: p.globalImageCache,
                systemFontCache: p.systemFontCache,
                nonBlendModesSet: p.nonBlendModesSet,
                xfaFactory: L
              })), this._pagePromises.set($, _), _;
            }
            async checkFirstPage($ = !1) {
              if (!$)
                try {
                  await this.getPage(0);
                } catch (m) {
                  if (m instanceof q.XRefEntryException)
                    throw this._pagePromises.delete(0), await this.cleanup(), new q.XRefParseException();
                }
            }
            async checkLastPage($ = !1) {
              const {
                catalog: m,
                pdfManager: p
              } = this;
              m.setActualNumPages();
              let T;
              try {
                if (await Promise.all([p.ensureDoc("xfaFactory"), p.ensureDoc("linearization"), p.ensureCatalog("numPages")]), this.xfaFactory)
                  return;
                if (this.linearization ? T = this.linearization.numPages : T = m.numPages, Number.isInteger(T)) {
                  if (T <= 1)
                    return;
                } else
                  throw new u.FormatError("Page count is not an integer.");
                await this.getPage(T - 1);
              } catch (L) {
                if (this._pagePromises.delete(T - 1), await this.cleanup(), L instanceof q.XRefEntryException && !$)
                  throw new q.XRefParseException();
                (0, u.warn)(`checkLastPage - invalid /Pages tree /Count: ${T}.`);
                let _;
                try {
                  _ = await m.getAllPageDicts($);
                } catch (G) {
                  if (G instanceof q.XRefEntryException && !$)
                    throw new q.XRefParseException();
                  m.setActualNumPages(1);
                  return;
                }
                for (const [G, [J, K]] of _) {
                  let V;
                  J instanceof Error ? (V = Promise.reject(J), V.catch(() => {
                  })) : V = Promise.resolve(new h({
                    pdfManager: p,
                    xref: this.xref,
                    pageIndex: G,
                    pageDict: J,
                    ref: K,
                    globalIdFactory: this._globalIdFactory,
                    fontCache: m.fontCache,
                    builtInCMapCache: m.builtInCMapCache,
                    standardFontDataCache: m.standardFontDataCache,
                    globalImageCache: m.globalImageCache,
                    systemFontCache: m.systemFontCache,
                    nonBlendModesSet: m.nonBlendModesSet,
                    xfaFactory: null
                  })), this._pagePromises.set(G, V);
                }
                m.setActualNumPages(_.size);
              }
            }
            fontFallback($, m) {
              return this.catalog.fontFallback($, m);
            }
            async cleanup($ = !1) {
              return this.catalog ? this.catalog.cleanup($) : (0, O.clearGlobalCaches)();
            }
            _collectFieldObjects($, m, p) {
              const T = this.xref.fetchIfRef(m);
              if (T.has("T")) {
                const L = (0, u.stringToPDFString)(T.get("T"));
                $ === "" ? $ = L : $ = `${$}.${L}`;
              }
              if (p.has($) || p.set($, []), p.get($).push(n.AnnotationFactory.create(this.xref, m, this.pdfManager, this._localIdFactory, !0).then((L) => L == null ? void 0 : L.getFieldObject()).catch(function(L) {
                return (0, u.warn)(`_collectFieldObjects: "${L}".`), null;
              })), T.has("Kids")) {
                const L = T.get("Kids");
                for (const _ of L)
                  this._collectFieldObjects($, _, p);
              }
            }
            get fieldObjects() {
              if (!this.formInfo.hasFields)
                return (0, u.shadow)(this, "fieldObjects", Promise.resolve(null));
              const $ = /* @__PURE__ */ Object.create(null), m = /* @__PURE__ */ new Map();
              for (const T of this.catalog.acroForm.get("Fields"))
                this._collectFieldObjects("", T, m);
              const p = [];
              for (const [T, L] of m)
                p.push(Promise.all(L).then((_) => {
                  _ = _.filter((G) => !!G), _.length > 0 && ($[T] = _);
                }));
              return (0, u.shadow)(this, "fieldObjects", Promise.all(p).then(() => $));
            }
            get hasJSActions() {
              const $ = this.pdfManager.ensureDoc("_parseHasJSActions");
              return (0, u.shadow)(this, "hasJSActions", $);
            }
            async _parseHasJSActions() {
              const [$, m] = await Promise.all([this.pdfManager.ensureCatalog("jsActions"), this.pdfManager.ensureDoc("fieldObjects")]);
              return $ ? !0 : m ? Object.values(m).some((p) => p.some((T) => T.actions !== null)) : !1;
            }
            get calculationOrderIds() {
              const $ = this.catalog.acroForm;
              if (!($ != null && $.has("CO")))
                return (0, u.shadow)(this, "calculationOrderIds", null);
              const m = $.get("CO");
              if (!Array.isArray(m) || m.length === 0)
                return (0, u.shadow)(this, "calculationOrderIds", null);
              const p = [];
              for (const T of m)
                T instanceof e.Ref && p.push(T.toString());
              return p.length === 0 ? (0, u.shadow)(this, "calculationOrderIds", null) : (0, u.shadow)(this, "calculationOrderIds", p);
            }
          }
          F.PDFDocument = E;
        },
        /* 10 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PopupAnnotation = F.MarkupAnnotation = F.AnnotationFactory = F.AnnotationBorderStyle = F.Annotation = void 0, F.getQuadPoints = v;
          var n = ae(2), u = ae(3), q = ae(11), e = ae(4), t = ae(66), B = ae(5), j = ae(60), M = ae(70), O = ae(12), w = ae(73), C = ae(76), i = ae(64), o = ae(8), k = ae(77);
          class s {
            static create(f, D, z, Y, W) {
              return Promise.all([z.ensureCatalog("acroForm"), z.ensureCatalog("baseUrl"), z.ensureCatalog("attachments"), z.ensureDoc("xfaDatasets"), W ? this._getPageIndex(f, D, z) : -1]).then(([ie, ne, re, ee, te]) => z.ensure(this, "_create", [f, D, z, Y, ie, re, ee, W, te]));
            }
            static _create(f, D, z, Y, W, ie = null, ne, re, ee = -1) {
              const te = f.fetchIfRef(D);
              if (!(te instanceof e.Dict))
                return;
              const oe = D instanceof e.Ref ? D.toString() : `annot_${Y.createObjId()}`;
              let se = te.get("Subtype");
              se = se instanceof e.Name ? se.name : null;
              const ce = W instanceof e.Dict ? W : e.Dict.empty, le = {
                xref: f,
                ref: D,
                dict: te,
                subtype: se,
                id: oe,
                pdfManager: z,
                acroForm: ce,
                attachments: ie,
                xfaDatasets: ne,
                collectFields: re,
                needAppearances: !re && ce.get("NeedAppearances") === !0,
                pageIndex: ee,
                isOffscreenCanvasSupported: z.evaluatorOptions.isOffscreenCanvasSupported
              };
              switch (se) {
                case "Link":
                  return new N(le);
                case "Text":
                  return new A(le);
                case "Widget":
                  let de = (0, u.getInheritableProperty)({
                    dict: te,
                    key: "FT"
                  });
                  switch (de = de instanceof e.Name ? de.name : null, de) {
                    case "Tx":
                      return new y(le);
                    case "Btn":
                      return new P(le);
                    case "Ch":
                      return new c(le);
                    case "Sig":
                      return new d(le);
                  }
                  return (0, n.warn)(`Unimplemented widget field type "${de}", falling back to base field type.`), new h(le);
                case "Popup":
                  return new E(le);
                case "FreeText":
                  return new H(le);
                case "Line":
                  return new $(le);
                case "Square":
                  return new m(le);
                case "Circle":
                  return new p(le);
                case "PolyLine":
                  return new T(le);
                case "Polygon":
                  return new L(le);
                case "Caret":
                  return new _(le);
                case "Ink":
                  return new G(le);
                case "Highlight":
                  return new J(le);
                case "Underline":
                  return new K(le);
                case "Squiggly":
                  return new V(le);
                case "StrikeOut":
                  return new U(le);
                case "Stamp":
                  return new Q(le);
                case "FileAttachment":
                  return new X(le);
                default:
                  return re || (se ? (0, n.warn)(`Unimplemented annotation type "${se}", falling back to base annotation.`) : (0, n.warn)("Annotation is missing the required /Subtype.")), new x(le);
              }
            }
            static async _getPageIndex(f, D, z) {
              try {
                const Y = await f.fetchIfRefAsync(D);
                if (!(Y instanceof e.Dict))
                  return -1;
                const W = Y.getRaw("P");
                return W instanceof e.Ref ? await z.ensureCatalog("getPageIndex", [W]) : -1;
              } catch (Y) {
                return (0, n.warn)(`_getPageIndex: "${Y}".`), -1;
              }
            }
            static async saveNewAnnotations(f, D, z) {
              const Y = f.xref;
              let W;
              const ie = [], ne = [];
              for (const re of z)
                switch (re.annotationType) {
                  case n.AnnotationEditorType.FREETEXT:
                    if (!W) {
                      const ee = new e.Dict(Y);
                      ee.set("BaseFont", e.Name.get("Helvetica")), ee.set("Type", e.Name.get("Font")), ee.set("Subtype", e.Name.get("Type1")), ee.set("Encoding", e.Name.get("WinAnsiEncoding"));
                      const te = [];
                      W = Y.getNewTemporaryRef(), await (0, t.writeObject)(W, ee, te, null), ie.push({
                        ref: W,
                        data: te.join("")
                      });
                    }
                    ne.push(H.createNewAnnotation(Y, re, ie, {
                      evaluator: f,
                      task: D,
                      baseFontRef: W
                    }));
                    break;
                  case n.AnnotationEditorType.INK:
                    ne.push(G.createNewAnnotation(Y, re, ie));
                }
              return {
                annotations: await Promise.all(ne),
                dependencies: ie
              };
            }
            static async printNewAnnotations(f, D, z) {
              if (!z)
                return null;
              const Y = f.xref, {
                isOffscreenCanvasSupported: W
              } = f.options, ie = [];
              for (const ne of z)
                switch (ne.annotationType) {
                  case n.AnnotationEditorType.FREETEXT:
                    ie.push(H.createNewPrintAnnotation(Y, ne, {
                      evaluator: f,
                      task: D,
                      isOffscreenCanvasSupported: W
                    }));
                    break;
                  case n.AnnotationEditorType.INK:
                    ie.push(G.createNewPrintAnnotation(Y, ne, {
                      isOffscreenCanvasSupported: W
                    }));
                    break;
                }
              return Promise.all(ie);
            }
          }
          F.AnnotationFactory = s;
          function l(R, f = new Uint8ClampedArray(3)) {
            if (!Array.isArray(R))
              return f;
            const D = f || new Uint8ClampedArray(3);
            switch (R.length) {
              case 0:
                return null;
              case 1:
                return O.ColorSpace.singletons.gray.getRgbItem(R, 0, D, 0), D;
              case 3:
                return O.ColorSpace.singletons.rgb.getRgbItem(R, 0, D, 0), D;
              case 4:
                return O.ColorSpace.singletons.cmyk.getRgbItem(R, 0, D, 0), D;
              default:
                return f;
            }
          }
          function g(R) {
            return Array.from(R, (f) => f / 255);
          }
          function v(R, f) {
            const D = R.getArray("QuadPoints");
            if (!Array.isArray(D) || D.length === 0 || D.length % 8 > 0)
              return null;
            const z = [];
            for (let Y = 0, W = D.length / 8; Y < W; Y++) {
              let ie = 1 / 0, ne = -1 / 0, re = 1 / 0, ee = -1 / 0;
              for (let te = Y * 8, oe = Y * 8 + 8; te < oe; te += 2) {
                const se = D[te], ce = D[te + 1];
                ie = Math.min(se, ie), ne = Math.max(se, ne), re = Math.min(ce, re), ee = Math.max(ce, ee);
              }
              if (f !== null && (ie < f[0] || ne > f[2] || re < f[1] || ee > f[3]))
                return null;
              z.push([{
                x: ie,
                y: ee
              }, {
                x: ne,
                y: ee
              }, {
                x: ie,
                y: re
              }, {
                x: ne,
                y: re
              }]);
            }
            return z;
          }
          function r(R, f, D) {
            const [z, Y, W, ie] = n.Util.getAxialAlignedBoundingBox(f, D);
            if (z === W || Y === ie)
              return [1, 0, 0, 1, R[0], R[1]];
            const ne = (R[2] - R[0]) / (W - z), re = (R[3] - R[1]) / (ie - Y);
            return [ne, 0, 0, re, R[0] - z * ne, R[1] - Y * re];
          }
          class x {
            constructor(f) {
              const {
                dict: D,
                xref: z
              } = f;
              this.setTitle(D.get("T")), this.setContents(D.get("Contents")), this.setModificationDate(D.get("M")), this.setFlags(D.get("F")), this.setRectangle(D.getArray("Rect")), this.setColor(D.getArray("C")), this.setBorderStyle(D), this.setAppearance(D), this.setOptionalContent(D);
              const Y = D.get("MK");
              this.setBorderAndBackgroundColors(Y), this.setRotation(Y), this._streams = [], this.appearance && this._streams.push(this.appearance);
              const W = !!(this.flags & n.AnnotationFlag.LOCKED), ie = !!(this.flags & n.AnnotationFlag.LOCKEDCONTENTS);
              if (this.data = {
                annotationFlags: this.flags,
                borderStyle: this.borderStyle,
                color: this.color,
                backgroundColor: this.backgroundColor,
                borderColor: this.borderColor,
                rotation: this.rotation,
                contentsObj: this._contents,
                hasAppearance: !!this.appearance,
                id: f.id,
                modificationDate: this.modificationDate,
                rect: this.rectangle,
                subtype: f.subtype,
                hasOwnCanvas: !1,
                noRotate: !!(this.flags & n.AnnotationFlag.NOROTATE),
                noHTML: W && ie
              }, f.collectFields) {
                const ne = D.get("Kids");
                if (Array.isArray(ne)) {
                  const re = [];
                  for (const ee of ne)
                    ee instanceof e.Ref && re.push(ee.toString());
                  re.length !== 0 && (this.data.kidIds = re);
                }
                this.data.actions = (0, u.collectActions)(z, D, n.AnnotationActionEventType), this.data.fieldName = this._constructFieldName(D), this.data.pageIndex = f.pageIndex;
              }
              this._isOffscreenCanvasSupported = f.isOffscreenCanvasSupported, this._fallbackFontDict = null, this._needAppearances = !1;
            }
            _hasFlag(f, D) {
              return !!(f & D);
            }
            _isViewable(f) {
              return !this._hasFlag(f, n.AnnotationFlag.INVISIBLE) && !this._hasFlag(f, n.AnnotationFlag.NOVIEW);
            }
            _isPrintable(f) {
              return this._hasFlag(f, n.AnnotationFlag.PRINT) && !this._hasFlag(f, n.AnnotationFlag.INVISIBLE);
            }
            mustBeViewed(f) {
              var z;
              const D = (z = f == null ? void 0 : f.get(this.data.id)) == null ? void 0 : z.hidden;
              return D !== void 0 ? !D : this.viewable && !this._hasFlag(this.flags, n.AnnotationFlag.HIDDEN);
            }
            mustBePrinted(f) {
              var z;
              const D = (z = f == null ? void 0 : f.get(this.data.id)) == null ? void 0 : z.print;
              return D !== void 0 ? D : this.printable;
            }
            get viewable() {
              return this.data.quadPoints === null ? !1 : this.flags === 0 ? !0 : this._isViewable(this.flags);
            }
            get printable() {
              return this.data.quadPoints === null || this.flags === 0 ? !1 : this._isPrintable(this.flags);
            }
            _parseStringHelper(f) {
              const D = typeof f == "string" ? (0, n.stringToPDFString)(f) : "", z = D && (0, j.bidi)(D).dir === "rtl" ? "rtl" : "ltr";
              return {
                str: D,
                dir: z
              };
            }
            setDefaultAppearance(f) {
              const D = (0, u.getInheritableProperty)({
                dict: f.dict,
                key: "DA"
              }) || f.acroForm.get("DA");
              this._defaultAppearance = typeof D == "string" ? D : "", this.data.defaultAppearanceData = (0, q.parseDefaultAppearance)(this._defaultAppearance);
            }
            setTitle(f) {
              this._title = this._parseStringHelper(f);
            }
            setContents(f) {
              this._contents = this._parseStringHelper(f);
            }
            setModificationDate(f) {
              this.modificationDate = typeof f == "string" ? f : null;
            }
            setFlags(f) {
              this.flags = Number.isInteger(f) && f > 0 ? f : 0;
            }
            hasFlag(f) {
              return this._hasFlag(this.flags, f);
            }
            setRectangle(f) {
              Array.isArray(f) && f.length === 4 ? this.rectangle = n.Util.normalizeRect(f) : this.rectangle = [0, 0, 0, 0];
            }
            setColor(f) {
              this.color = l(f);
            }
            setLineEndings(f) {
              if (this.lineEndings = ["None", "None"], Array.isArray(f) && f.length === 2)
                for (let D = 0; D < 2; D++) {
                  const z = f[D];
                  if (z instanceof e.Name)
                    switch (z.name) {
                      case "None":
                        continue;
                      case "Square":
                      case "Circle":
                      case "Diamond":
                      case "OpenArrow":
                      case "ClosedArrow":
                      case "Butt":
                      case "ROpenArrow":
                      case "RClosedArrow":
                      case "Slash":
                        this.lineEndings[D] = z.name;
                        continue;
                    }
                  (0, n.warn)(`Ignoring invalid lineEnding: ${z}`);
                }
            }
            setRotation(f) {
              if (this.rotation = 0, f instanceof e.Dict) {
                let D = f.get("R") || 0;
                Number.isInteger(D) && D !== 0 && (D %= 360, D < 0 && (D += 360), D % 90 === 0 && (this.rotation = D));
              }
            }
            setBorderAndBackgroundColors(f) {
              f instanceof e.Dict ? (this.borderColor = l(f.getArray("BC"), null), this.backgroundColor = l(f.getArray("BG"), null)) : this.borderColor = this.backgroundColor = null;
            }
            setBorderStyle(f) {
              if (this.borderStyle = new b(), f instanceof e.Dict)
                if (f.has("BS")) {
                  const D = f.get("BS"), z = D.get("Type");
                  (!z || (0, e.isName)(z, "Border")) && (this.borderStyle.setWidth(D.get("W"), this.rectangle), this.borderStyle.setStyle(D.get("S")), this.borderStyle.setDashArray(D.getArray("D")));
                } else if (f.has("Border")) {
                  const D = f.getArray("Border");
                  Array.isArray(D) && D.length >= 3 && (this.borderStyle.setHorizontalCornerRadius(D[0]), this.borderStyle.setVerticalCornerRadius(D[1]), this.borderStyle.setWidth(D[2], this.rectangle), D.length === 4 && this.borderStyle.setDashArray(D[3], !0));
                } else
                  this.borderStyle.setWidth(0);
            }
            setAppearance(f) {
              this.appearance = null;
              const D = f.get("AP");
              if (!(D instanceof e.Dict))
                return;
              const z = D.get("N");
              if (z instanceof B.BaseStream) {
                this.appearance = z;
                return;
              }
              if (!(z instanceof e.Dict))
                return;
              const Y = f.get("AS");
              if (!(Y instanceof e.Name) || !z.has(Y.name))
                return;
              const W = z.get(Y.name);
              W instanceof B.BaseStream && (this.appearance = W);
            }
            setOptionalContent(f) {
              this.oc = null;
              const D = f.get("OC");
              D instanceof e.Name ? (0, n.warn)("setOptionalContent: Support for /Name-entry is not implemented.") : D instanceof e.Dict && (this.oc = D);
            }
            loadResources(f, D) {
              return D.dict.getAsync("Resources").then((z) => z ? new C.ObjectLoader(z, f, z.xref).load().then(function() {
                return z;
              }) : void 0);
            }
            async getOperatorList(f, D, z, Y, W) {
              const ie = this.data;
              let ne = this.appearance;
              const re = !!(this.data.hasOwnCanvas && z & n.RenderingIntentFlag.DISPLAY);
              if (!ne) {
                if (!re)
                  return {
                    opList: new i.OperatorList(),
                    separateForm: !1,
                    separateCanvas: !1
                  };
                ne = new o.StringStream(""), ne.dict = new e.Dict();
              }
              const ee = ne.dict, te = await this.loadResources(["ExtGState", "ColorSpace", "Pattern", "Shading", "XObject", "Font"], ne), oe = ee.getArray("BBox") || [0, 0, 1, 1], se = ee.getArray("Matrix") || [1, 0, 0, 1, 0, 0], ce = r(ie.rect, oe, se), le = new i.OperatorList();
              let de;
              return this.oc && (de = await f.parseMarkedContentProps(this.oc, null)), de !== void 0 && le.addOp(n.OPS.beginMarkedContentProps, ["OC", de]), le.addOp(n.OPS.beginAnnotation, [ie.id, ie.rect, ce, se, re]), await f.getOperatorList({
                stream: ne,
                task: D,
                resources: te,
                operatorList: le,
                fallbackFontDict: this._fallbackFontDict
              }), le.addOp(n.OPS.endAnnotation, []), de !== void 0 && le.addOp(n.OPS.endMarkedContent, []), this.reset(), {
                opList: le,
                separateForm: !1,
                separateCanvas: re
              };
            }
            async save(f, D, z) {
              return null;
            }
            get hasTextContent() {
              return !1;
            }
            async extractTextContent(f, D, z) {
              if (!this.appearance)
                return;
              const Y = await this.loadResources(["ExtGState", "Font", "Properties", "XObject"], this.appearance), W = [], ie = [], ne = {
                desiredSize: Math.Infinity,
                ready: !0,
                enqueue(re, ee) {
                  for (const te of re.items)
                    ie.push(te.str), te.hasEOL && (W.push(ie.join("")), ie.length = 0);
                }
              };
              await f.getTextContent({
                stream: this.appearance,
                task: D,
                resources: Y,
                includeMarkedContent: !0,
                sink: ne,
                viewBox: z
              }), this.reset(), ie.length && W.push(ie.join("")), W.length > 0 && (this.data.textContent = W);
            }
            getFieldObject() {
              return this.data.kidIds ? {
                id: this.data.id,
                actions: this.data.actions,
                name: this.data.fieldName,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                type: "",
                kidIds: this.data.kidIds,
                page: this.data.pageIndex,
                rotation: this.rotation
              } : null;
            }
            reset() {
              for (const f of this._streams)
                f.reset();
            }
            _constructFieldName(f) {
              if (!f.has("T") && !f.has("Parent"))
                return (0, n.warn)("Unknown field name, falling back to empty field name."), "";
              if (!f.has("Parent"))
                return (0, n.stringToPDFString)(f.get("T"));
              const D = [];
              f.has("T") && D.unshift((0, n.stringToPDFString)(f.get("T")));
              let z = f;
              const Y = new e.RefSet();
              for (f.objId && Y.put(f.objId); z.has("Parent") && (z = z.get("Parent"), !(!(z instanceof e.Dict) || z.objId && Y.has(z.objId))); )
                if (z.objId && Y.put(z.objId), z.has("T")) {
                  const W = (0, n.stringToPDFString)(z.get("T"));
                  W.startsWith("#") || D.unshift(W);
                }
              return D.join(".");
            }
          }
          F.Annotation = x;
          class b {
            constructor() {
              this.width = 1, this.style = n.AnnotationBorderStyleType.SOLID, this.dashArray = [3], this.horizontalCornerRadius = 0, this.verticalCornerRadius = 0;
            }
            setWidth(f, D = [0, 0, 0, 0]) {
              if (f instanceof e.Name) {
                this.width = 0;
                return;
              }
              if (typeof f == "number") {
                if (f > 0) {
                  const z = (D[2] - D[0]) / 2, Y = (D[3] - D[1]) / 2;
                  z > 0 && Y > 0 && (f > z || f > Y) && ((0, n.warn)(`AnnotationBorderStyle.setWidth - ignoring width: ${f}`), f = 1);
                }
                this.width = f;
              }
            }
            setStyle(f) {
              if (f instanceof e.Name)
                switch (f.name) {
                  case "S":
                    this.style = n.AnnotationBorderStyleType.SOLID;
                    break;
                  case "D":
                    this.style = n.AnnotationBorderStyleType.DASHED;
                    break;
                  case "B":
                    this.style = n.AnnotationBorderStyleType.BEVELED;
                    break;
                  case "I":
                    this.style = n.AnnotationBorderStyleType.INSET;
                    break;
                  case "U":
                    this.style = n.AnnotationBorderStyleType.UNDERLINE;
                    break;
                }
            }
            setDashArray(f, D = !1) {
              if (Array.isArray(f) && f.length > 0) {
                let z = !0, Y = !0;
                for (const W of f)
                  if (+W >= 0)
                    W > 0 && (Y = !1);
                  else {
                    z = !1;
                    break;
                  }
                z && !Y ? (this.dashArray = f, D && this.setStyle(e.Name.get("D"))) : this.width = 0;
              } else
                f && (this.width = 0);
            }
            setHorizontalCornerRadius(f) {
              Number.isInteger(f) && (this.horizontalCornerRadius = f);
            }
            setVerticalCornerRadius(f) {
              Number.isInteger(f) && (this.verticalCornerRadius = f);
            }
          }
          F.AnnotationBorderStyle = b;
          class I extends x {
            constructor(f) {
              super(f);
              const {
                dict: D
              } = f;
              if (D.has("IRT")) {
                const z = D.getRaw("IRT");
                this.data.inReplyTo = z instanceof e.Ref ? z.toString() : null;
                const Y = D.get("RT");
                this.data.replyType = Y instanceof e.Name ? Y.name : n.AnnotationReplyType.REPLY;
              }
              if (this.data.replyType === n.AnnotationReplyType.GROUP) {
                const z = D.get("IRT");
                this.setTitle(z.get("T")), this.data.titleObj = this._title, this.setContents(z.get("Contents")), this.data.contentsObj = this._contents, z.has("CreationDate") ? (this.setCreationDate(z.get("CreationDate")), this.data.creationDate = this.creationDate) : this.data.creationDate = null, z.has("M") ? (this.setModificationDate(z.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, this.data.hasPopup = z.has("Popup"), z.has("C") ? (this.setColor(z.getArray("C")), this.data.color = this.color) : this.data.color = null;
              } else
                this.data.titleObj = this._title, this.setCreationDate(D.get("CreationDate")), this.data.creationDate = this.creationDate, this.data.hasPopup = D.has("Popup"), D.has("C") || (this.data.color = null);
              D.has("RC") && (this.data.richText = k.XFAFactory.getRichTextAsHtml(D.get("RC")));
            }
            setCreationDate(f) {
              this.creationDate = typeof f == "string" ? f : null;
            }
            _setDefaultAppearance({
              xref: f,
              extra: D,
              strokeColor: z,
              fillColor: Y,
              blendMode: W,
              strokeAlpha: ie,
              fillAlpha: ne,
              pointsCallback: re
            }) {
              let ee = Number.MAX_VALUE, te = Number.MAX_VALUE, oe = Number.MIN_VALUE, se = Number.MIN_VALUE;
              const ce = ["q"];
              D && ce.push(D), z && ce.push(`${z[0]} ${z[1]} ${z[2]} RG`), Y && ce.push(`${Y[0]} ${Y[1]} ${Y[2]} rg`);
              let le = this.data.quadPoints;
              le || (le = [[{
                x: this.rectangle[0],
                y: this.rectangle[3]
              }, {
                x: this.rectangle[2],
                y: this.rectangle[3]
              }, {
                x: this.rectangle[0],
                y: this.rectangle[1]
              }, {
                x: this.rectangle[2],
                y: this.rectangle[1]
              }]]);
              for (const Re of le) {
                const [Ee, ye, Te, je] = re(ce, Re);
                ee = Math.min(ee, Ee), oe = Math.max(oe, ye), te = Math.min(te, Te), se = Math.max(se, je);
              }
              ce.push("Q");
              const de = new e.Dict(f), Ie = new e.Dict(f);
              Ie.set("Subtype", e.Name.get("Form"));
              const Fe = new o.StringStream(ce.join(" "));
              Fe.dict = Ie, de.set("Fm0", Fe);
              const we = new e.Dict(f);
              W && we.set("BM", e.Name.get(W)), typeof ie == "number" && we.set("CA", ie), typeof ne == "number" && we.set("ca", ne);
              const pe = new e.Dict(f);
              pe.set("GS0", we);
              const fe = new e.Dict(f);
              fe.set("ExtGState", pe), fe.set("XObject", de);
              const Ae = new e.Dict(f);
              Ae.set("Resources", fe);
              const Pe = this.data.rect = [ee, te, oe, se];
              Ae.set("BBox", Pe), this.appearance = new o.StringStream("/GS0 gs /Fm0 Do"), this.appearance.dict = Ae, this._streams.push(this.appearance, Fe);
            }
            static async createNewAnnotation(f, D, z, Y) {
              const W = f.getNewTemporaryRef(), ie = await this.createNewAppearanceStream(D, f, Y), ne = [];
              let re;
              if (ie) {
                const te = f.getNewTemporaryRef();
                re = this.createNewDict(D, f, {
                  apRef: te
                });
                const oe = f.encrypt ? f.encrypt.createCipherTransform(te.num, te.gen) : null;
                await (0, t.writeObject)(te, ie, ne, oe), z.push({
                  ref: te,
                  data: ne.join("")
                });
              } else
                re = this.createNewDict(D, f, {});
              ne.length = 0;
              const ee = f.encrypt ? f.encrypt.createCipherTransform(W.num, W.gen) : null;
              return await (0, t.writeObject)(W, re, ne, ee), {
                ref: W,
                data: ne.join("")
              };
            }
            static async createNewPrintAnnotation(f, D, z) {
              const Y = await this.createNewAppearanceStream(D, f, z), W = this.createNewDict(D, f, {
                ap: Y
              });
              return new this.prototype.constructor({
                dict: W,
                xref: f,
                isOffscreenCanvasSupported: z.isOffscreenCanvasSupported
              });
            }
          }
          F.MarkupAnnotation = I;
          class h extends x {
            constructor(f) {
              var oe;
              super(f);
              const {
                dict: D,
                xref: z
              } = f, Y = this.data;
              this.ref = f.ref, this._needAppearances = f.needAppearances, Y.annotationType = n.AnnotationType.WIDGET, Y.fieldName === void 0 && (Y.fieldName = this._constructFieldName(D)), Y.actions === void 0 && (Y.actions = (0, u.collectActions)(z, D, n.AnnotationActionEventType));
              let W = (0, u.getInheritableProperty)({
                dict: D,
                key: "V",
                getArray: !0
              });
              Y.fieldValue = this._decodeFormValue(W);
              const ie = (0, u.getInheritableProperty)({
                dict: D,
                key: "DV",
                getArray: !0
              });
              if (Y.defaultFieldValue = this._decodeFormValue(ie), W === void 0 && f.xfaDatasets) {
                const se = this._title.str;
                se && (this._hasValueFromXFA = !0, Y.fieldValue = W = f.xfaDatasets.getValue(se));
              }
              W === void 0 && Y.defaultFieldValue !== null && (Y.fieldValue = Y.defaultFieldValue), Y.alternativeText = (0, n.stringToPDFString)(D.get("TU") || ""), this.setDefaultAppearance(f), Y.hasAppearance || (Y.hasAppearance = this._needAppearances && Y.fieldValue !== void 0 && Y.fieldValue !== null);
              const ne = (0, u.getInheritableProperty)({
                dict: D,
                key: "FT"
              });
              Y.fieldType = ne instanceof e.Name ? ne.name : null;
              const re = (0, u.getInheritableProperty)({
                dict: D,
                key: "DR"
              }), ee = f.acroForm.get("DR"), te = (oe = this.appearance) == null ? void 0 : oe.dict.get("Resources");
              this._fieldResources = {
                localResources: re,
                acroFormResources: ee,
                appearanceResources: te,
                mergedResources: e.Dict.merge({
                  xref: z,
                  dictArray: [re, te, ee],
                  mergeSubDicts: !0
                })
              }, Y.fieldFlags = (0, u.getInheritableProperty)({
                dict: D,
                key: "Ff"
              }), (!Number.isInteger(Y.fieldFlags) || Y.fieldFlags < 0) && (Y.fieldFlags = 0), Y.readOnly = this.hasFieldFlag(n.AnnotationFieldFlag.READONLY), Y.required = this.hasFieldFlag(n.AnnotationFieldFlag.REQUIRED), Y.hidden = this._hasFlag(Y.annotationFlags, n.AnnotationFlag.HIDDEN);
            }
            _decodeFormValue(f) {
              return Array.isArray(f) ? f.filter((D) => typeof D == "string").map((D) => (0, n.stringToPDFString)(D)) : f instanceof e.Name ? (0, n.stringToPDFString)(f.name) : typeof f == "string" ? (0, n.stringToPDFString)(f) : null;
            }
            hasFieldFlag(f) {
              return !!(this.data.fieldFlags & f);
            }
            getRotationMatrix(f) {
              var W;
              let D = (W = f == null ? void 0 : f.get(this.data.id)) == null ? void 0 : W.rotation;
              if (D === void 0 && (D = this.rotation), D === 0)
                return n.IDENTITY_MATRIX;
              const z = this.data.rect[2] - this.data.rect[0], Y = this.data.rect[3] - this.data.rect[1];
              return (0, u.getRotationMatrix)(D, z, Y);
            }
            getBorderAndBackgroundAppearances(f) {
              var ne;
              let D = (ne = f == null ? void 0 : f.get(this.data.id)) == null ? void 0 : ne.rotation;
              if (D === void 0 && (D = this.rotation), !this.backgroundColor && !this.borderColor)
                return "";
              const z = this.data.rect[2] - this.data.rect[0], Y = this.data.rect[3] - this.data.rect[1], W = D === 0 || D === 180 ? `0 0 ${z} ${Y} re` : `0 0 ${Y} ${z} re`;
              let ie = "";
              if (this.backgroundColor && (ie = `${(0, q.getPdfColor)(this.backgroundColor, !0)} ${W} f `), this.borderColor) {
                const re = this.borderStyle.width || 1;
                ie += `${re} w ${(0, q.getPdfColor)(this.borderColor, !1)} ${W} S `;
              }
              return ie;
            }
            async getOperatorList(f, D, z, Y, W) {
              if (Y && !(this instanceof d) && !this.data.noHTML && !this.data.hasOwnCanvas)
                return {
                  opList: new i.OperatorList(),
                  separateForm: !0,
                  separateCanvas: !1
                };
              if (!this._hasText)
                return super.getOperatorList(f, D, z, Y, W);
              const ie = await this._getAppearance(f, D, z, W);
              if (this.appearance && ie === null)
                return super.getOperatorList(f, D, z, Y, W);
              const ne = new i.OperatorList();
              if (!this._defaultAppearance || ie === null)
                return {
                  opList: ne,
                  separateForm: !1,
                  separateCanvas: !1
                };
              const re = [1, 0, 0, 1, 0, 0], ee = [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]], te = r(this.data.rect, ee, re);
              let oe;
              this.oc && (oe = await f.parseMarkedContentProps(this.oc, null)), oe !== void 0 && ne.addOp(n.OPS.beginMarkedContentProps, ["OC", oe]), ne.addOp(n.OPS.beginAnnotation, [this.data.id, this.data.rect, te, this.getRotationMatrix(W), !1]);
              const se = new o.StringStream(ie);
              return await f.getOperatorList({
                stream: se,
                task: D,
                resources: this._fieldResources.mergedResources,
                operatorList: ne
              }), ne.addOp(n.OPS.endAnnotation, []), oe !== void 0 && ne.addOp(n.OPS.endMarkedContent, []), {
                opList: ne,
                separateForm: !1,
                separateCanvas: !1
              };
            }
            _getMKDict(f) {
              const D = new e.Dict(null);
              return f && D.set("R", f), this.borderColor && D.set("BC", g(this.borderColor)), this.backgroundColor && D.set("BG", g(this.backgroundColor)), D.size > 0 ? D : null;
            }
            amendSavedDict(f, D) {
            }
            async save(f, D, z) {
              const Y = z == null ? void 0 : z.get(this.data.id);
              let W = Y == null ? void 0 : Y.value, ie = Y == null ? void 0 : Y.rotation;
              if (W === this.data.fieldValue || W === void 0) {
                if (!this._hasValueFromXFA && ie === void 0)
                  return null;
                W || (W = this.data.fieldValue);
              }
              if (ie === void 0 && !this._hasValueFromXFA && Array.isArray(W) && Array.isArray(this.data.fieldValue) && W.length === this.data.fieldValue.length && W.every((pe, fe) => pe === this.data.fieldValue[fe]))
                return null;
              ie === void 0 && (ie = this.rotation);
              let ne = null;
              if (!this._needAppearances && (ne = await this._getAppearance(f, D, n.RenderingIntentFlag.SAVE, z), ne === null))
                return null;
              let re = !1;
              ne != null && ne.needAppearances && (re = !0, ne = null);
              const {
                xref: ee
              } = f, te = ee.fetchIfRef(this.ref);
              if (!(te instanceof e.Dict))
                return null;
              const oe = new e.Dict(ee);
              for (const pe of te.getKeys())
                pe !== "AP" && oe.set(pe, te.getRaw(pe));
              const se = {
                path: this.data.fieldName,
                value: W
              }, ce = (pe) => (0, u.isAscii)(pe) ? pe : (0, u.stringToUTF16String)(pe, !0);
              oe.set("V", Array.isArray(W) ? W.map(ce) : ce(W)), this.amendSavedDict(z, oe);
              const le = this._getMKDict(ie);
              le && oe.set("MK", le);
              const de = ee.encrypt, Ie = de ? de.createCipherTransform(this.ref.num, this.ref.gen) : null, Fe = [], we = [{
                ref: this.ref,
                data: "",
                xfa: se,
                needAppearances: re
              }];
              if (ne !== null) {
                const pe = ee.getNewTemporaryRef(), fe = new e.Dict(ee);
                oe.set("AP", fe), fe.set("N", pe);
                let Ae = null;
                de && (Ae = de.createCipherTransform(pe.num, pe.gen));
                const Pe = this._getSaveFieldResources(ee), Re = new o.StringStream(ne), Ee = Re.dict = new e.Dict(ee);
                Ee.set("Subtype", e.Name.get("Form")), Ee.set("Resources", Pe), Ee.set("BBox", [0, 0, this.data.rect[2] - this.data.rect[0], this.data.rect[3] - this.data.rect[1]]);
                const ye = this.getRotationMatrix(z);
                ye !== n.IDENTITY_MATRIX && Ee.set("Matrix", ye), await (0, t.writeObject)(pe, Re, Fe, Ae), we.push({
                  ref: pe,
                  data: Fe.join(""),
                  xfa: null,
                  needAppearances: !1
                }), Fe.length = 0;
              }
              return oe.set("M", `D:${(0, n.getModificationDate)()}`), await (0, t.writeObject)(this.ref, oe, Fe, Ie), we[0].data = Fe.join(""), we;
            }
            async _getAppearance(f, D, z, Y) {
              if (this.hasFieldFlag(n.AnnotationFieldFlag.PASSWORD))
                return null;
              const ie = Y == null ? void 0 : Y.get(this.data.id);
              let ne, re;
              if (ie && (ne = ie.formattedValue || ie.value, re = ie.rotation), re === void 0 && ne === void 0 && !this._needAppearances && (!this._hasValueFromXFA || this.appearance))
                return null;
              const ee = this.getBorderAndBackgroundAppearances(Y);
              if (ne === void 0 && (ne = this.data.fieldValue, !ne))
                return `/Tx BMC q ${ee}Q EMC`;
              if (Array.isArray(ne) && ne.length === 1 && (ne = ne[0]), (0, n.assert)(typeof ne == "string", "Expected `value` to be a string."), ne = ne.trim(), this.data.combo) {
                const ve = this.data.options.find(({
                  exportValue: Ce
                }) => ne === Ce);
                ne = (ve == null ? void 0 : ve.displayValue) || ne;
              }
              if (ne === "")
                return `/Tx BMC q ${ee}Q EMC`;
              re === void 0 && (re = this.rotation);
              let te = -1, oe;
              this.data.multiLine ? (oe = ne.split(/\r\n?|\n/).map((ve) => ve.normalize("NFC")), te = oe.length) : oe = [ne.replace(/\r\n?|\n/, "").normalize("NFC")];
              const se = 1, ce = 2;
              let le = this.data.rect[3] - this.data.rect[1], de = this.data.rect[2] - this.data.rect[0];
              (re === 90 || re === 270) && ([de, le] = [le, de]), this._defaultAppearance || (this.data.defaultAppearanceData = (0, q.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              let Ie = await h._getFontData(f, D, this.data.defaultAppearanceData, this._fieldResources.mergedResources), Fe, we, pe;
              const fe = [];
              let Ae = !1;
              for (const ve of oe) {
                const Ce = Ie.encodeString(ve);
                Ce.length > 1 && (Ae = !0), fe.push(Ce.join(""));
              }
              if (Ae && z & n.RenderingIntentFlag.SAVE)
                return {
                  needAppearances: !0
                };
              if (Ae && this._isOffscreenCanvasSupported) {
                const ve = this.data.comb ? "monospace" : "sans-serif", Ce = new q.FakeUnicodeFont(f.xref, ve), Ne = Ce.createFontResources(oe.join("")), Ge = Ne.getRaw("Font");
                if (this._fieldResources.mergedResources.has("Font")) {
                  const Ke = this._fieldResources.mergedResources.get("Font");
                  for (const et of Ge.getKeys())
                    Ke.set(et, Ge.getRaw(et));
                } else
                  this._fieldResources.mergedResources.set("Font", Ge);
                const Oe = Ce.fontName.name;
                Ie = await h._getFontData(f, D, {
                  fontName: Oe,
                  fontSize: 0
                }, Ne);
                for (let Ke = 0, et = fe.length; Ke < et; Ke++)
                  fe[Ke] = (0, u.stringToUTF16String)(oe[Ke]);
                const tt = Object.assign(/* @__PURE__ */ Object.create(null), this.data.defaultAppearanceData);
                this.data.defaultAppearanceData.fontSize = 0, this.data.defaultAppearanceData.fontName = Oe, [Fe, we, pe] = this._computeFontSize(le - 2 * se, de - 2 * ce, ne, Ie, te), this.data.defaultAppearanceData = tt;
              } else
                this._isOffscreenCanvasSupported || (0, n.warn)("_getAppearance: OffscreenCanvas is not supported, annotation may not render correctly."), [Fe, we, pe] = this._computeFontSize(le - 2 * se, de - 2 * ce, ne, Ie, te);
              let Pe = Ie.descent;
              isNaN(Pe) ? Pe = n.BASELINE_FACTOR * pe : Pe = Math.max(n.BASELINE_FACTOR * pe, Math.abs(Pe) * we);
              const Re = Math.min(Math.floor((le - we) / 2), se), Ee = this.data.textAlignment;
              if (this.data.multiLine)
                return this._getMultilineAppearance(Fe, fe, Ie, we, de, le, Ee, ce, Re, Pe, pe, Y);
              if (this.data.comb)
                return this._getCombAppearance(Fe, Ie, fe[0], we, de, le, ce, Re, Pe, pe, Y);
              const ye = Re + Pe;
              if (Ee === 0 || Ee > 2)
                return `/Tx BMC q ${ee}BT ` + Fe + ` 1 0 0 1 ${(0, u.numberToString)(ce)} ${(0, u.numberToString)(ye)} Tm (${(0, u.escapeString)(fe[0])}) Tj ET Q EMC`;
              const Te = {
                shift: 0
              }, je = this._renderText(fe[0], Ie, we, de, Ee, Te, ce, ye);
              return `/Tx BMC q ${ee}BT ` + Fe + ` 1 0 0 1 0 0 Tm ${je} ET Q EMC`;
            }
            static async _getFontData(f, D, z, Y) {
              const W = new i.OperatorList(), ie = {
                font: null,
                clone() {
                  return this;
                }
              }, {
                fontName: ne,
                fontSize: re
              } = z;
              return await f.handleSetFont(Y, [ne && e.Name.get(ne), re], null, W, D, ie, null), ie.font;
            }
            _getTextWidth(f, D) {
              return D.charsToGlyphs(f).reduce((z, Y) => z + Y.width, 0) / 1e3;
            }
            _computeFontSize(f, D, z, Y, W) {
              let {
                fontSize: ie
              } = this.data.defaultAppearanceData, ne = (ie || 12) * n.LINE_FACTOR, re = Math.round(f / ne);
              if (!ie) {
                const ee = (se) => Math.floor(se * 100) / 100;
                if (W === -1) {
                  const se = this._getTextWidth(z, Y);
                  ie = ee(Math.min(f / n.LINE_FACTOR, se > D ? D / se : 1 / 0)), re = 1;
                } else {
                  const se = z.split(/\r\n?|\n/), ce = [];
                  for (const de of se) {
                    const Ie = Y.encodeString(de).join(""), Fe = Y.charsToGlyphs(Ie), we = Y.getCharPositions(Ie);
                    ce.push({
                      line: Ie,
                      glyphs: Fe,
                      positions: we
                    });
                  }
                  const le = (de) => {
                    let Ie = 0;
                    for (const Fe of ce) {
                      const we = this._splitLine(null, Y, de, D, Fe);
                      if (Ie += we.length * de, Ie > f)
                        return !0;
                    }
                    return !1;
                  };
                  for (re = Math.max(re, W); ; ) {
                    if (ne = f / re, ie = ee(ne / n.LINE_FACTOR), le(ie)) {
                      re++;
                      continue;
                    }
                    break;
                  }
                }
                const {
                  fontName: te,
                  fontColor: oe
                } = this.data.defaultAppearanceData;
                this._defaultAppearance = (0, q.createDefaultAppearance)({
                  fontSize: ie,
                  fontName: te,
                  fontColor: oe
                });
              }
              return [this._defaultAppearance, ie, f / re];
            }
            _renderText(f, D, z, Y, W, ie, ne, re) {
              let ee;
              if (W === 1) {
                const oe = this._getTextWidth(f, D) * z;
                ee = (Y - oe) / 2;
              } else if (W === 2) {
                const oe = this._getTextWidth(f, D) * z;
                ee = Y - oe - ne;
              } else
                ee = ne;
              const te = (0, u.numberToString)(ee - ie.shift);
              return ie.shift = ee, re = (0, u.numberToString)(re), `${te} ${re} Td (${(0, u.escapeString)(f)}) Tj`;
            }
            _getSaveFieldResources(f) {
              var ie;
              const {
                localResources: D,
                appearanceResources: z,
                acroFormResources: Y
              } = this._fieldResources, W = (ie = this.data.defaultAppearanceData) == null ? void 0 : ie.fontName;
              if (!W)
                return D || e.Dict.empty;
              for (const ne of [D, z])
                if (ne instanceof e.Dict) {
                  const re = ne.get("Font");
                  if (re instanceof e.Dict && re.has(W))
                    return ne;
                }
              if (Y instanceof e.Dict) {
                const ne = Y.get("Font");
                if (ne instanceof e.Dict && ne.has(W)) {
                  const re = new e.Dict(f);
                  re.set(W, ne.getRaw(W));
                  const ee = new e.Dict(f);
                  return ee.set("Font", re), e.Dict.merge({
                    xref: f,
                    dictArray: [ee, D],
                    mergeSubDicts: !0
                  });
                }
              }
              return D || e.Dict.empty;
            }
            getFieldObject() {
              return null;
            }
          }
          class y extends h {
            constructor(f) {
              super(f), this.data.hasOwnCanvas = this.data.readOnly && !this.data.noHTML, this._hasText = !0;
              const D = f.dict;
              typeof this.data.fieldValue != "string" && (this.data.fieldValue = "");
              let z = (0, u.getInheritableProperty)({
                dict: D,
                key: "Q"
              });
              (!Number.isInteger(z) || z < 0 || z > 2) && (z = null), this.data.textAlignment = z;
              let Y = (0, u.getInheritableProperty)({
                dict: D,
                key: "MaxLen"
              });
              (!Number.isInteger(Y) || Y < 0) && (Y = 0), this.data.maxLen = Y, this.data.multiLine = this.hasFieldFlag(n.AnnotationFieldFlag.MULTILINE), this.data.comb = this.hasFieldFlag(n.AnnotationFieldFlag.COMB) && !this.hasFieldFlag(n.AnnotationFieldFlag.MULTILINE) && !this.hasFieldFlag(n.AnnotationFieldFlag.PASSWORD) && !this.hasFieldFlag(n.AnnotationFieldFlag.FILESELECT) && this.data.maxLen !== 0, this.data.doNotScroll = this.hasFieldFlag(n.AnnotationFieldFlag.DONOTSCROLL);
            }
            get hasTextContent() {
              return !!this.appearance;
            }
            _getCombAppearance(f, D, z, Y, W, ie, ne, re, ee, te, oe) {
              const se = W / this.data.maxLen, ce = this.getBorderAndBackgroundAppearances(oe), le = [], de = D.getCharPositions(z);
              for (const [Fe, we] of de)
                le.push(`(${(0, u.escapeString)(z.substring(Fe, we))}) Tj`);
              const Ie = le.join(` ${(0, u.numberToString)(se)} 0 Td `);
              return `/Tx BMC q ${ce}BT ` + f + ` 1 0 0 1 ${(0, u.numberToString)(ne)} ${(0, u.numberToString)(re + ee)} Tm ${Ie} ET Q EMC`;
            }
            _getMultilineAppearance(f, D, z, Y, W, ie, ne, re, ee, te, oe, se) {
              const ce = [], le = W - 2 * re, de = {
                shift: 0
              };
              for (let we = 0, pe = D.length; we < pe; we++) {
                const fe = D[we], Ae = this._splitLine(fe, z, Y, le);
                for (let Pe = 0, Re = Ae.length; Pe < Re; Pe++) {
                  const Ee = Ae[Pe], ye = we === 0 && Pe === 0 ? -ee - (oe - te) : -oe;
                  ce.push(this._renderText(Ee, z, Y, W, ne, de, re, ye));
                }
              }
              const Ie = this.getBorderAndBackgroundAppearances(se), Fe = ce.join(`
`);
              return `/Tx BMC q ${Ie}BT ` + f + ` 1 0 0 1 0 ${(0, u.numberToString)(ie)} Tm ${Fe} ET Q EMC`;
            }
            _splitLine(f, D, z, Y, W = {}) {
              f = W.line || f;
              const ie = W.glyphs || D.charsToGlyphs(f);
              if (ie.length <= 1)
                return [f];
              const ne = W.positions || D.getCharPositions(f), re = z / 1e3, ee = [];
              let te = -1, oe = -1, se = -1, ce = 0, le = 0;
              for (let de = 0, Ie = ie.length; de < Ie; de++) {
                const [Fe, we] = ne[de], pe = ie[de], fe = pe.width * re;
                pe.unicode === " " ? le + fe > Y ? (ee.push(f.substring(ce, Fe)), ce = Fe, le = fe, te = -1, se = -1) : (le += fe, te = Fe, oe = we, se = de) : le + fe > Y ? te !== -1 ? (ee.push(f.substring(ce, oe)), ce = oe, de = se + 1, te = -1, le = 0) : (ee.push(f.substring(ce, Fe)), ce = Fe, le = fe) : le += fe;
              }
              return ce < f.length && ee.push(f.substring(ce, f.length)), ee;
            }
            getFieldObject() {
              return {
                id: this.data.id,
                value: this.data.fieldValue,
                defaultValue: this.data.defaultFieldValue || "",
                multiline: this.data.multiLine,
                password: this.hasFieldFlag(n.AnnotationFieldFlag.PASSWORD),
                charLimit: this.data.maxLen,
                comb: this.data.comb,
                editable: !this.data.readOnly,
                hidden: this.data.hidden,
                name: this.data.fieldName,
                rect: this.data.rect,
                actions: this.data.actions,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: "text"
              };
            }
          }
          class P extends h {
            constructor(f) {
              super(f), this.checkedAppearance = null, this.uncheckedAppearance = null, this.data.checkBox = !this.hasFieldFlag(n.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(n.AnnotationFieldFlag.PUSHBUTTON), this.data.radioButton = this.hasFieldFlag(n.AnnotationFieldFlag.RADIO) && !this.hasFieldFlag(n.AnnotationFieldFlag.PUSHBUTTON), this.data.pushButton = this.hasFieldFlag(n.AnnotationFieldFlag.PUSHBUTTON), this.data.isTooltipOnly = !1, this.data.checkBox ? this._processCheckBox(f) : this.data.radioButton ? this._processRadioButton(f) : this.data.pushButton ? (this.data.hasOwnCanvas = !0, this._processPushButton(f)) : (0, n.warn)("Invalid field flags for button widget annotation");
            }
            async getOperatorList(f, D, z, Y, W) {
              if (this.data.pushButton)
                return super.getOperatorList(f, D, z, !1, W);
              let ie = null, ne = null;
              if (W) {
                const ee = W.get(this.data.id);
                ie = ee ? ee.value : null, ne = ee ? ee.rotation : null;
              }
              if (ie === null && this.appearance)
                return super.getOperatorList(f, D, z, Y, W);
              ie == null && (this.data.checkBox ? ie = this.data.fieldValue === this.data.exportValue : ie = this.data.fieldValue === this.data.buttonValue);
              const re = ie ? this.checkedAppearance : this.uncheckedAppearance;
              if (re) {
                const ee = this.appearance, te = re.dict.getArray("Matrix") || n.IDENTITY_MATRIX;
                ne && re.dict.set("Matrix", this.getRotationMatrix(W)), this.appearance = re;
                const oe = super.getOperatorList(f, D, z, Y, W);
                return this.appearance = ee, re.dict.set("Matrix", te), oe;
              }
              return {
                opList: new i.OperatorList(),
                separateForm: !1,
                separateCanvas: !1
              };
            }
            async save(f, D, z) {
              return this.data.checkBox ? this._saveCheckbox(f, D, z) : this.data.radioButton ? this._saveRadioButton(f, D, z) : null;
            }
            async _saveCheckbox(f, D, z) {
              if (!z)
                return null;
              const Y = z.get(this.data.id);
              let W = Y == null ? void 0 : Y.rotation, ie = Y == null ? void 0 : Y.value;
              if (W === void 0 && (ie === void 0 || this.data.fieldValue === this.data.exportValue === ie))
                return null;
              const ne = f.xref.fetchIfRef(this.ref);
              if (!(ne instanceof e.Dict))
                return null;
              W === void 0 && (W = this.rotation), ie === void 0 && (ie = this.data.fieldValue === this.data.exportValue);
              const re = {
                path: this.data.fieldName,
                value: ie ? this.data.exportValue : ""
              }, ee = e.Name.get(ie ? this.data.exportValue : "Off");
              ne.set("V", ee), ne.set("AS", ee), ne.set("M", `D:${(0, n.getModificationDate)()}`);
              const te = this._getMKDict(W);
              te && ne.set("MK", te);
              const oe = f.xref.encrypt;
              let se = null;
              oe && (se = oe.createCipherTransform(this.ref.num, this.ref.gen));
              const ce = [`${this.ref.num} ${this.ref.gen} obj
`];
              return await (0, t.writeDict)(ne, ce, se), ce.push(`
endobj
`), [{
                ref: this.ref,
                data: ce.join(""),
                xfa: re
              }];
            }
            async _saveRadioButton(f, D, z) {
              if (!z)
                return null;
              const Y = z.get(this.data.id);
              let W = Y == null ? void 0 : Y.rotation, ie = Y == null ? void 0 : Y.value;
              if (W === void 0 && (ie === void 0 || this.data.fieldValue === this.data.buttonValue === ie))
                return null;
              const ne = f.xref.fetchIfRef(this.ref);
              if (!(ne instanceof e.Dict))
                return null;
              ie === void 0 && (ie = this.data.fieldValue === this.data.buttonValue), W === void 0 && (W = this.rotation);
              const re = {
                path: this.data.fieldName,
                value: ie ? this.data.buttonValue : ""
              }, ee = e.Name.get(ie ? this.data.buttonValue : "Off");
              let te = null;
              const oe = f.xref.encrypt;
              if (ie)
                if (this.parent instanceof e.Ref) {
                  const Ie = f.xref.fetch(this.parent);
                  let Fe = null;
                  oe && (Fe = oe.createCipherTransform(this.parent.num, this.parent.gen)), Ie.set("V", ee), te = [`${this.parent.num} ${this.parent.gen} obj
`], await (0, t.writeDict)(Ie, te, Fe), te.push(`
endobj
`);
                } else
                  this.parent instanceof e.Dict && this.parent.set("V", ee);
              ne.set("AS", ee), ne.set("M", `D:${(0, n.getModificationDate)()}`);
              const se = this._getMKDict(W);
              se && ne.set("MK", se);
              let ce = null;
              oe && (ce = oe.createCipherTransform(this.ref.num, this.ref.gen));
              const le = [`${this.ref.num} ${this.ref.gen} obj
`];
              await (0, t.writeDict)(ne, le, ce), le.push(`
endobj
`);
              const de = [{
                ref: this.ref,
                data: le.join(""),
                xfa: re
              }];
              return te !== null && de.push({
                ref: this.parent,
                data: te.join(""),
                xfa: null
              }), de;
            }
            _getDefaultCheckedAppearance(f, D) {
              const z = this.data.rect[2] - this.data.rect[0], Y = this.data.rect[3] - this.data.rect[1], W = [0, 0, z, Y], ie = 0.8, ne = Math.min(z, Y) * ie;
              let re, ee;
              D === "check" ? (re = {
                width: 0.755 * ne,
                height: 0.705 * ne
              }, ee = "3") : D === "disc" ? (re = {
                width: 0.791 * ne,
                height: 0.705 * ne
              }, ee = "l") : (0, n.unreachable)(`_getDefaultCheckedAppearance - unsupported type: ${D}`);
              const te = (0, u.numberToString)((z - re.width) / 2), oe = (0, u.numberToString)((Y - re.height) / 2), se = `q BT /PdfJsZaDb ${ne} Tf 0 g ${te} ${oe} Td (${ee}) Tj ET Q`, ce = new e.Dict(f.xref);
              ce.set("FormType", 1), ce.set("Subtype", e.Name.get("Form")), ce.set("Type", e.Name.get("XObject")), ce.set("BBox", W), ce.set("Matrix", [1, 0, 0, 1, 0, 0]), ce.set("Length", se.length);
              const le = new e.Dict(f.xref), de = new e.Dict(f.xref);
              de.set("PdfJsZaDb", this.fallbackFontDict), le.set("Font", de), ce.set("Resources", le), this.checkedAppearance = new o.StringStream(se), this.checkedAppearance.dict = ce, this._streams.push(this.checkedAppearance);
            }
            _processCheckBox(f) {
              const D = f.dict.get("AP");
              if (!(D instanceof e.Dict))
                return;
              const z = D.get("N");
              if (!(z instanceof e.Dict))
                return;
              const Y = this._decodeFormValue(f.dict.get("AS"));
              typeof Y == "string" && (this.data.fieldValue = Y);
              const W = this.data.fieldValue !== null && this.data.fieldValue !== "Off" ? this.data.fieldValue : "Yes", ie = z.getKeys();
              if (ie.length === 0)
                ie.push("Off", W);
              else if (ie.length === 1)
                ie[0] === "Off" ? ie.push(W) : ie.unshift("Off");
              else if (ie.includes(W))
                ie.length = 0, ie.push("Off", W);
              else {
                const ee = ie.find((te) => te !== "Off");
                ie.length = 0, ie.push("Off", ee);
              }
              ie.includes(this.data.fieldValue) || (this.data.fieldValue = "Off"), this.data.exportValue = ie[1];
              const ne = z.get(this.data.exportValue);
              this.checkedAppearance = ne instanceof B.BaseStream ? ne : null;
              const re = z.get("Off");
              this.uncheckedAppearance = re instanceof B.BaseStream ? re : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(f, "check"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict;
            }
            _processRadioButton(f) {
              this.data.fieldValue = this.data.buttonValue = null;
              const D = f.dict.get("Parent");
              if (D instanceof e.Dict) {
                this.parent = f.dict.getRaw("Parent");
                const ne = D.get("V");
                ne instanceof e.Name && (this.data.fieldValue = this._decodeFormValue(ne));
              }
              const z = f.dict.get("AP");
              if (!(z instanceof e.Dict))
                return;
              const Y = z.get("N");
              if (!(Y instanceof e.Dict))
                return;
              for (const ne of Y.getKeys())
                if (ne !== "Off") {
                  this.data.buttonValue = this._decodeFormValue(ne);
                  break;
                }
              const W = Y.get(this.data.buttonValue);
              this.checkedAppearance = W instanceof B.BaseStream ? W : null;
              const ie = Y.get("Off");
              this.uncheckedAppearance = ie instanceof B.BaseStream ? ie : null, this.checkedAppearance ? this._streams.push(this.checkedAppearance) : this._getDefaultCheckedAppearance(f, "disc"), this.uncheckedAppearance && this._streams.push(this.uncheckedAppearance), this._fallbackFontDict = this.fallbackFontDict;
            }
            _processPushButton(f) {
              if (!f.dict.has("A") && !f.dict.has("AA") && !this.data.alternativeText) {
                (0, n.warn)("Push buttons without action dictionaries are not supported");
                return;
              }
              this.data.isTooltipOnly = !f.dict.has("A") && !f.dict.has("AA"), M.Catalog.parseDestDictionary({
                destDict: f.dict,
                resultObj: this.data,
                docBaseUrl: f.pdfManager.docBaseUrl,
                docAttachments: f.attachments
              });
            }
            getFieldObject() {
              let f = "button", D;
              return this.data.checkBox ? (f = "checkbox", D = this.data.exportValue) : this.data.radioButton && (f = "radiobutton", D = this.data.buttonValue), {
                id: this.data.id,
                value: this.data.fieldValue || "Off",
                defaultValue: this.data.defaultFieldValue,
                exportValues: D,
                editable: !this.data.readOnly,
                name: this.data.fieldName,
                rect: this.data.rect,
                hidden: this.data.hidden,
                actions: this.data.actions,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: f
              };
            }
            get fallbackFontDict() {
              const f = new e.Dict();
              return f.set("BaseFont", e.Name.get("ZapfDingbats")), f.set("Type", e.Name.get("FallbackType")), f.set("Subtype", e.Name.get("FallbackType")), f.set("Encoding", e.Name.get("ZapfDingbatsEncoding")), (0, n.shadow)(this, "fallbackFontDict", f);
            }
          }
          class c extends h {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              this.indices = D.getArray("I"), this.hasIndices = Array.isArray(this.indices) && this.indices.length > 0, this.data.options = [];
              const Y = (0, u.getInheritableProperty)({
                dict: D,
                key: "Opt"
              });
              if (Array.isArray(Y))
                for (let W = 0, ie = Y.length; W < ie; W++) {
                  const ne = z.fetchIfRef(Y[W]), re = Array.isArray(ne);
                  this.data.options[W] = {
                    exportValue: this._decodeFormValue(re ? z.fetchIfRef(ne[0]) : ne),
                    displayValue: this._decodeFormValue(re ? z.fetchIfRef(ne[1]) : ne)
                  };
                }
              if (!this.hasIndices)
                typeof this.data.fieldValue == "string" ? this.data.fieldValue = [this.data.fieldValue] : this.data.fieldValue || (this.data.fieldValue = []);
              else {
                this.data.fieldValue = [];
                const W = this.data.options.length;
                for (const ie of this.indices)
                  Number.isInteger(ie) && ie >= 0 && ie < W && this.data.fieldValue.push(this.data.options[ie].exportValue);
              }
              this.data.combo = this.hasFieldFlag(n.AnnotationFieldFlag.COMBO), this.data.multiSelect = this.hasFieldFlag(n.AnnotationFieldFlag.MULTISELECT), this._hasText = !0;
            }
            getFieldObject() {
              const f = this.data.combo ? "combobox" : "listbox", D = this.data.fieldValue.length > 0 ? this.data.fieldValue[0] : null;
              return {
                id: this.data.id,
                value: D,
                defaultValue: this.data.defaultFieldValue,
                editable: !this.data.readOnly,
                name: this.data.fieldName,
                rect: this.data.rect,
                numItems: this.data.fieldValue.length,
                multipleSelection: this.data.multiSelect,
                hidden: this.data.hidden,
                actions: this.data.actions,
                items: this.data.options,
                page: this.data.pageIndex,
                strokeColor: this.data.borderColor,
                fillColor: this.data.backgroundColor,
                rotation: this.rotation,
                type: f
              };
            }
            amendSavedDict(f, D) {
              var ie;
              if (!this.hasIndices)
                return;
              let z = (ie = f == null ? void 0 : f.get(this.data.id)) == null ? void 0 : ie.value;
              Array.isArray(z) || (z = [z]);
              const Y = [], {
                options: W
              } = this.data;
              for (let ne = 0, re = 0, ee = W.length; ne < ee; ne++)
                W[ne].exportValue === z[re] && (Y.push(ne), re += 1);
              D.set("I", Y);
            }
            async _getAppearance(f, D, z, Y) {
              if (this.data.combo)
                return super._getAppearance(f, D, z, Y);
              let W, ie;
              const ne = Y == null ? void 0 : Y.get(this.data.id);
              if (ne && (ie = ne.rotation, W = ne.value), ie === void 0 && W === void 0 && !this._needAppearances)
                return null;
              W === void 0 ? W = this.data.fieldValue : Array.isArray(W) || (W = [W]);
              const re = 1, ee = 2;
              let te = this.data.rect[3] - this.data.rect[1], oe = this.data.rect[2] - this.data.rect[0];
              (ie === 90 || ie === 270) && ([oe, te] = [te, oe]);
              const se = this.data.options.length, ce = [];
              for (let Ee = 0; Ee < se; Ee++) {
                const {
                  exportValue: ye
                } = this.data.options[Ee];
                W.includes(ye) && ce.push(Ee);
              }
              this._defaultAppearance || (this.data.defaultAppearanceData = (0, q.parseDefaultAppearance)(this._defaultAppearance = "/Helvetica 0 Tf 0 g"));
              const le = await h._getFontData(f, D, this.data.defaultAppearanceData, this._fieldResources.mergedResources);
              let de, {
                fontSize: Ie
              } = this.data.defaultAppearanceData;
              if (Ie)
                de = this._defaultAppearance;
              else {
                const Ee = (te - re) / se;
                let ye = -1, Te;
                for (const {
                  displayValue: je
                } of this.data.options) {
                  const ve = this._getTextWidth(je, le);
                  ve > ye && (ye = ve, Te = je);
                }
                [de, Ie] = this._computeFontSize(Ee, oe - 2 * ee, Te, le, -1);
              }
              const Fe = Ie * n.LINE_FACTOR, we = (Fe - Ie) / 2, pe = Math.floor(te / Fe);
              let fe;
              if (ce.length === 1) {
                const Ee = ce[0], ye = Ee % pe;
                fe = Ee - ye;
              } else
                fe = ce.length ? ce[0] : 0;
              const Ae = Math.min(fe + pe + 1, se), Pe = ["/Tx BMC q", `1 1 ${oe} ${te} re W n`];
              if (ce.length) {
                Pe.push("0.600006 0.756866 0.854904 rg");
                for (const Ee of ce)
                  fe <= Ee && Ee < Ae && Pe.push(`1 ${te - (Ee - fe + 1) * Fe} ${oe} ${Fe} re f`);
              }
              Pe.push("BT", de, `1 0 0 1 0 ${te} Tm`);
              const Re = {
                shift: 0
              };
              for (let Ee = fe; Ee < Ae; Ee++) {
                const {
                  displayValue: ye
                } = this.data.options[Ee], Te = Ee === fe ? we : 0;
                Pe.push(this._renderText(ye, le, Ie, oe, 0, Re, ee, -Fe + Te));
              }
              return Pe.push("ET Q EMC"), Pe.join(`
`);
            }
          }
          class d extends h {
            constructor(f) {
              super(f), this.data.fieldValue = null, this.data.hasOwnCanvas = this.data.noRotate;
            }
            getFieldObject() {
              return {
                id: this.data.id,
                value: null,
                page: this.data.pageIndex,
                type: "signature"
              };
            }
          }
          class A extends I {
            constructor(f) {
              super(f), this.data.noRotate = !0, this.data.hasOwnCanvas = this.data.noRotate;
              const {
                dict: z
              } = f;
              this.data.annotationType = n.AnnotationType.TEXT, this.data.hasAppearance ? this.data.name = "NoIcon" : (this.data.rect[1] = this.data.rect[3] - 22, this.data.rect[2] = this.data.rect[0] + 22, this.data.name = z.has("Name") ? z.get("Name").name : "Note"), z.has("State") ? (this.data.state = z.get("State") || null, this.data.stateModel = z.get("StateModel") || null) : (this.data.state = null, this.data.stateModel = null);
            }
          }
          class N extends x {
            constructor(f) {
              var z;
              super(f), this.data.annotationType = n.AnnotationType.LINK;
              const D = v(f.dict, this.rectangle);
              D && (this.data.quadPoints = D), (z = this.data).borderColor || (z.borderColor = this.data.color), M.Catalog.parseDestDictionary({
                destDict: f.dict,
                resultObj: this.data,
                docBaseUrl: f.pdfManager.docBaseUrl,
                docAttachments: f.attachments
              });
            }
          }
          class E extends x {
            constructor(f) {
              super(f);
              const {
                dict: D
              } = f;
              this.data.annotationType = n.AnnotationType.POPUP;
              let z = D.get("Parent");
              if (!z) {
                (0, n.warn)("Popup annotation has a missing or invalid parent annotation.");
                return;
              }
              const Y = z.get("Subtype");
              this.data.parentType = Y instanceof e.Name ? Y.name : null;
              const W = D.getRaw("Parent");
              this.data.parentId = W instanceof e.Ref ? W.toString() : null;
              const ie = z.getArray("Rect");
              Array.isArray(ie) && ie.length === 4 ? this.data.parentRect = n.Util.normalizeRect(ie) : this.data.parentRect = [0, 0, 0, 0];
              const ne = z.get("RT");
              if ((0, e.isName)(ne, n.AnnotationReplyType.GROUP) && (z = z.get("IRT")), z.has("M") ? (this.setModificationDate(z.get("M")), this.data.modificationDate = this.modificationDate) : this.data.modificationDate = null, z.has("C") ? (this.setColor(z.getArray("C")), this.data.color = this.color) : this.data.color = null, !this.viewable) {
                const re = z.get("F");
                this._isViewable(re) && this.setFlags(re);
              }
              this.setTitle(z.get("T")), this.data.titleObj = this._title, this.setContents(z.get("Contents")), this.data.contentsObj = this._contents, z.has("RC") && (this.data.richText = k.XFAFactory.getRichTextAsHtml(z.get("RC")));
            }
          }
          F.PopupAnnotation = E;
          class H extends I {
            constructor(f) {
              super(f), this.data.hasOwnCanvas = this.data.noRotate;
              const {
                xref: D
              } = f;
              if (this.data.annotationType = n.AnnotationType.FREETEXT, this.setDefaultAppearance(f), !this.appearance && this._isOffscreenCanvasSupported) {
                const z = f.dict.get("CA"), Y = new q.FakeUnicodeFont(D, "sans-serif"), W = this.data.defaultAppearanceData;
                this.appearance = Y.createAppearance(this._contents.str, this.rectangle, this.rotation, W.fontSize || 10, W.fontColor, z), this._streams.push(this.appearance, q.FakeUnicodeFont.toUnicodeStream);
              } else
                this._isOffscreenCanvasSupported || (0, n.warn)("FreeTextAnnotation: OffscreenCanvas is not supported, annotation may not render correctly.");
            }
            get hasTextContent() {
              return !!this.appearance;
            }
            static createNewDict(f, D, {
              apRef: z,
              ap: Y
            }) {
              const {
                color: W,
                fontSize: ie,
                rect: ne,
                rotation: re,
                user: ee,
                value: te
              } = f, oe = new e.Dict(D);
              oe.set("Type", e.Name.get("Annot")), oe.set("Subtype", e.Name.get("FreeText")), oe.set("CreationDate", `D:${(0, n.getModificationDate)()}`), oe.set("Rect", ne);
              const se = `/Helv ${ie} Tf ${(0, q.getPdfColor)(W, !0)}`;
              if (oe.set("DA", se), oe.set("Contents", (0, u.isAscii)(te) ? te : (0, u.stringToUTF16String)(te, !0)), oe.set("F", 4), oe.set("Border", [0, 0, 0]), oe.set("Rotate", re), ee && oe.set("T", (0, u.isAscii)(ee) ? ee : (0, u.stringToUTF16String)(ee, !0)), z || Y) {
                const ce = new e.Dict(D);
                oe.set("AP", ce), z ? ce.set("N", z) : ce.set("N", Y);
              }
              return oe;
            }
            static async createNewAppearanceStream(f, D, z) {
              const {
                baseFontRef: Y,
                evaluator: W,
                task: ie
              } = z, {
                color: ne,
                fontSize: re,
                rect: ee,
                rotation: te,
                value: oe
              } = f, se = new e.Dict(D), ce = new e.Dict(D);
              if (Y)
                ce.set("Helv", Y);
              else {
                const Qe = new e.Dict(D);
                Qe.set("BaseFont", e.Name.get("Helvetica")), Qe.set("Type", e.Name.get("Font")), Qe.set("Subtype", e.Name.get("Type1")), Qe.set("Encoding", e.Name.get("WinAnsiEncoding")), ce.set("Helv", Qe);
              }
              se.set("Font", ce);
              const le = await h._getFontData(W, ie, {
                fontName: "Helvetica",
                fontSize: re
              }, se), [de, Ie, Fe, we] = ee;
              let pe = Fe - de, fe = we - Ie;
              te % 180 !== 0 && ([pe, fe] = [fe, pe]);
              const Ae = oe.split(`
`), Pe = re / 1e3;
              let Re = -1 / 0;
              const Ee = [];
              for (let Qe of Ae) {
                const it = le.encodeString(Qe);
                if (it.length > 1)
                  return null;
                Qe = it.join(""), Ee.push(Qe);
                let We = 0;
                const gt = le.charsToGlyphs(Qe);
                for (const mt of gt)
                  We += mt.width * Pe;
                Re = Math.max(Re, We);
              }
              let ye = 1;
              Re > pe && (ye = pe / Re);
              let Te = 1;
              const je = n.LINE_FACTOR * re, ve = n.LINE_DESCENT_FACTOR * re, Ce = je * Ae.length;
              Ce > fe && (Te = fe / Ce);
              const Ne = Math.min(ye, Te), Ge = re * Ne, Oe = ["q", `0 0 ${(0, u.numberToString)(pe)} ${(0, u.numberToString)(fe)} re W n`, "BT", `1 0 0 1 0 ${(0, u.numberToString)(fe + ve)} Tm 0 Tc ${(0, q.getPdfColor)(ne, !0)}`, `/Helv ${(0, u.numberToString)(Ge)} Tf`], tt = (0, u.numberToString)(je);
              for (const Qe of Ee)
                Oe.push(`0 -${tt} Td (${(0, u.escapeString)(Qe)}) Tj`);
              Oe.push("ET", "Q");
              const Ke = Oe.join(`
`), et = new e.Dict(D);
              if (et.set("FormType", 1), et.set("Subtype", e.Name.get("Form")), et.set("Type", e.Name.get("XObject")), et.set("BBox", [0, 0, pe, fe]), et.set("Resources", se), te) {
                const Qe = (0, u.getRotationMatrix)(te, pe, fe);
                et.set("Matrix", Qe);
              }
              const Xe = new o.StringStream(Ke);
              return Xe.dict = et, Xe;
            }
          }
          class $ extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              this.data.annotationType = n.AnnotationType.LINE, this.data.hasOwnCanvas = this.data.noRotate;
              const Y = D.getArray("L");
              if (this.data.lineCoordinates = n.Util.normalizeRect(Y), this.setLineEndings(D.getArray("LE")), this.data.lineEndings = this.lineEndings, !this.appearance) {
                const W = this.color ? g(this.color) : [0, 0, 0], ie = D.get("CA"), ne = l(D.getArray("IC"), null), re = ne ? g(ne) : null, ee = re ? ie : null, te = this.borderStyle.width || 1, oe = 2 * te, se = [this.data.lineCoordinates[0] - oe, this.data.lineCoordinates[1] - oe, this.data.lineCoordinates[2] + oe, this.data.lineCoordinates[3] + oe];
                n.Util.intersect(this.rectangle, se) || (this.rectangle = se), this._setDefaultAppearance({
                  xref: z,
                  extra: `${te} w`,
                  strokeColor: W,
                  fillColor: re,
                  strokeAlpha: ie,
                  fillAlpha: ee,
                  pointsCallback: (ce, le) => (ce.push(`${Y[0]} ${Y[1]} m`, `${Y[2]} ${Y[3]} l`, "S"), [le[0].x - te, le[1].x + te, le[3].y - te, le[1].y + te])
                });
              }
            }
          }
          class m extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              if (this.data.annotationType = n.AnnotationType.SQUARE, this.data.hasOwnCanvas = this.data.noRotate, !this.appearance) {
                const Y = this.color ? g(this.color) : [0, 0, 0], W = D.get("CA"), ie = l(D.getArray("IC"), null), ne = ie ? g(ie) : null, re = ne ? W : null;
                if (this.borderStyle.width === 0 && !ne)
                  return;
                this._setDefaultAppearance({
                  xref: z,
                  extra: `${this.borderStyle.width} w`,
                  strokeColor: Y,
                  fillColor: ne,
                  strokeAlpha: W,
                  fillAlpha: re,
                  pointsCallback: (ee, te) => {
                    const oe = te[2].x + this.borderStyle.width / 2, se = te[2].y + this.borderStyle.width / 2, ce = te[3].x - te[2].x - this.borderStyle.width, le = te[1].y - te[3].y - this.borderStyle.width;
                    return ee.push(`${oe} ${se} ${ce} ${le} re`), ne ? ee.push("B") : ee.push("S"), [te[0].x, te[1].x, te[3].y, te[1].y];
                  }
                });
              }
            }
          }
          class p extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              if (this.data.annotationType = n.AnnotationType.CIRCLE, !this.appearance) {
                const Y = this.color ? g(this.color) : [0, 0, 0], W = D.get("CA"), ie = l(D.getArray("IC"), null), ne = ie ? g(ie) : null, re = ne ? W : null;
                if (this.borderStyle.width === 0 && !ne)
                  return;
                const ee = 4 / 3 * Math.tan(Math.PI / (2 * 4));
                this._setDefaultAppearance({
                  xref: z,
                  extra: `${this.borderStyle.width} w`,
                  strokeColor: Y,
                  fillColor: ne,
                  strokeAlpha: W,
                  fillAlpha: re,
                  pointsCallback: (te, oe) => {
                    const se = oe[0].x + this.borderStyle.width / 2, ce = oe[0].y - this.borderStyle.width / 2, le = oe[3].x - this.borderStyle.width / 2, de = oe[3].y + this.borderStyle.width / 2, Ie = se + (le - se) / 2, Fe = ce + (de - ce) / 2, we = (le - se) / 2 * ee, pe = (de - ce) / 2 * ee;
                    return te.push(`${Ie} ${de} m`, `${Ie + we} ${de} ${le} ${Fe + pe} ${le} ${Fe} c`, `${le} ${Fe - pe} ${Ie + we} ${ce} ${Ie} ${ce} c`, `${Ie - we} ${ce} ${se} ${Fe - pe} ${se} ${Fe} c`, `${se} ${Fe + pe} ${Ie - we} ${de} ${Ie} ${de} c`, "h"), ne ? te.push("B") : te.push("S"), [oe[0].x, oe[1].x, oe[3].y, oe[1].y];
                  }
                });
              }
            }
          }
          class T extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              this.data.annotationType = n.AnnotationType.POLYLINE, this.data.hasOwnCanvas = this.data.noRotate, this.data.vertices = [], this instanceof L || (this.setLineEndings(D.getArray("LE")), this.data.lineEndings = this.lineEndings);
              const Y = D.getArray("Vertices");
              if (Array.isArray(Y)) {
                for (let W = 0, ie = Y.length; W < ie; W += 2)
                  this.data.vertices.push({
                    x: Y[W],
                    y: Y[W + 1]
                  });
                if (!this.appearance) {
                  const W = this.color ? g(this.color) : [0, 0, 0], ie = D.get("CA"), ne = this.borderStyle.width || 1, re = 2 * ne, ee = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  for (const te of this.data.vertices)
                    ee[0] = Math.min(ee[0], te.x - re), ee[1] = Math.min(ee[1], te.y - re), ee[2] = Math.max(ee[2], te.x + re), ee[3] = Math.max(ee[3], te.y + re);
                  n.Util.intersect(this.rectangle, ee) || (this.rectangle = ee), this._setDefaultAppearance({
                    xref: z,
                    extra: `${ne} w`,
                    strokeColor: W,
                    strokeAlpha: ie,
                    pointsCallback: (te, oe) => {
                      const se = this.data.vertices;
                      for (let ce = 0, le = se.length; ce < le; ce++)
                        te.push(`${se[ce].x} ${se[ce].y} ${ce === 0 ? "m" : "l"}`);
                      return te.push("S"), [oe[0].x, oe[1].x, oe[3].y, oe[1].y];
                    }
                  });
                }
              }
            }
          }
          class L extends T {
            constructor(f) {
              super(f), this.data.annotationType = n.AnnotationType.POLYGON;
            }
          }
          class _ extends I {
            constructor(f) {
              super(f), this.data.annotationType = n.AnnotationType.CARET;
            }
          }
          class G extends I {
            constructor(f) {
              super(f), this.data.hasOwnCanvas = this.data.noRotate;
              const {
                dict: D,
                xref: z
              } = f;
              this.data.annotationType = n.AnnotationType.INK, this.data.inkLists = [];
              const Y = D.getArray("InkList");
              if (Array.isArray(Y)) {
                for (let W = 0, ie = Y.length; W < ie; ++W) {
                  this.data.inkLists.push([]);
                  for (let ne = 0, re = Y[W].length; ne < re; ne += 2)
                    this.data.inkLists[W].push({
                      x: z.fetchIfRef(Y[W][ne]),
                      y: z.fetchIfRef(Y[W][ne + 1])
                    });
                }
                if (!this.appearance) {
                  const W = this.color ? g(this.color) : [0, 0, 0], ie = D.get("CA"), ne = this.borderStyle.width || 1, re = 2 * ne, ee = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
                  for (const te of this.data.inkLists)
                    for (const oe of te)
                      ee[0] = Math.min(ee[0], oe.x - re), ee[1] = Math.min(ee[1], oe.y - re), ee[2] = Math.max(ee[2], oe.x + re), ee[3] = Math.max(ee[3], oe.y + re);
                  n.Util.intersect(this.rectangle, ee) || (this.rectangle = ee), this._setDefaultAppearance({
                    xref: z,
                    extra: `${ne} w`,
                    strokeColor: W,
                    strokeAlpha: ie,
                    pointsCallback: (te, oe) => {
                      for (const se of this.data.inkLists) {
                        for (let ce = 0, le = se.length; ce < le; ce++)
                          te.push(`${se[ce].x} ${se[ce].y} ${ce === 0 ? "m" : "l"}`);
                        te.push("S");
                      }
                      return [oe[0].x, oe[1].x, oe[3].y, oe[1].y];
                    }
                  });
                }
              }
            }
            static createNewDict(f, D, {
              apRef: z,
              ap: Y
            }) {
              const {
                paths: W,
                rect: ie,
                rotation: ne
              } = f, re = new e.Dict(D);
              re.set("Type", e.Name.get("Annot")), re.set("Subtype", e.Name.get("Ink")), re.set("CreationDate", `D:${(0, n.getModificationDate)()}`), re.set("Rect", ie), re.set("InkList", W.map((te) => te.points)), re.set("F", 4), re.set("Border", [0, 0, 0]), re.set("Rotate", ne);
              const ee = new e.Dict(D);
              return re.set("AP", ee), z ? ee.set("N", z) : ee.set("N", Y), re;
            }
            static async createNewAppearanceStream(f, D, z) {
              const {
                color: Y,
                rect: W,
                rotation: ie,
                paths: ne,
                thickness: re,
                opacity: ee
              } = f, [te, oe, se, ce] = W;
              let le = se - te, de = ce - oe;
              ie % 180 !== 0 && ([le, de] = [de, le]);
              const Ie = [`${re} w 1 J 1 j`, `${(0, q.getPdfColor)(Y, !1)}`];
              ee !== 1 && Ie.push("/R0 gs");
              const Fe = [];
              for (const {
                bezier: Ae
              } of ne) {
                Fe.length = 0, Fe.push(`${(0, u.numberToString)(Ae[0])} ${(0, u.numberToString)(Ae[1])} m`);
                for (let Pe = 2, Re = Ae.length; Pe < Re; Pe += 6) {
                  const Ee = Ae.slice(Pe, Pe + 6).map(u.numberToString).join(" ");
                  Fe.push(`${Ee} c`);
                }
                Fe.push("S"), Ie.push(Fe.join(`
`));
              }
              const we = Ie.join(`
`), pe = new e.Dict(D);
              if (pe.set("FormType", 1), pe.set("Subtype", e.Name.get("Form")), pe.set("Type", e.Name.get("XObject")), pe.set("BBox", [0, 0, le, de]), pe.set("Length", we.length), ie) {
                const Ae = (0, u.getRotationMatrix)(ie, le, de);
                pe.set("Matrix", Ae);
              }
              if (ee !== 1) {
                const Ae = new e.Dict(D), Pe = new e.Dict(D), Re = new e.Dict(D);
                Re.set("CA", ee), Re.set("Type", e.Name.get("ExtGState")), Pe.set("R0", Re), Ae.set("ExtGState", Pe), pe.set("Resources", Ae);
              }
              const fe = new o.StringStream(we);
              return fe.dict = pe, fe;
            }
          }
          class J extends I {
            constructor(f) {
              var W;
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              if (this.data.annotationType = n.AnnotationType.HIGHLIGHT, this.data.quadPoints = v(D, null)) {
                const ie = (W = this.appearance) == null ? void 0 : W.dict.get("Resources");
                if (!this.appearance || !(ie != null && ie.has("ExtGState"))) {
                  this.appearance && (0, n.warn)("HighlightAnnotation - ignoring built-in appearance stream.");
                  const ne = this.color ? g(this.color) : [1, 1, 0], re = D.get("CA");
                  this._setDefaultAppearance({
                    xref: z,
                    fillColor: ne,
                    blendMode: "Multiply",
                    fillAlpha: re,
                    pointsCallback: (ee, te) => (ee.push(`${te[0].x} ${te[0].y} m`, `${te[1].x} ${te[1].y} l`, `${te[3].x} ${te[3].y} l`, `${te[2].x} ${te[2].y} l`, "f"), [te[0].x, te[1].x, te[3].y, te[1].y])
                  });
                }
              } else
                this.data.hasPopup = !1;
            }
          }
          class K extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              if (this.data.annotationType = n.AnnotationType.UNDERLINE, this.data.quadPoints = v(D, null)) {
                if (!this.appearance) {
                  const W = this.color ? g(this.color) : [0, 0, 0], ie = D.get("CA");
                  this._setDefaultAppearance({
                    xref: z,
                    extra: "[] 0 d 0.571 w",
                    strokeColor: W,
                    strokeAlpha: ie,
                    pointsCallback: (ne, re) => (ne.push(`${re[2].x} ${re[2].y + 1.3} m`, `${re[3].x} ${re[3].y + 1.3} l`, "S"), [re[0].x, re[1].x, re[3].y, re[1].y])
                  });
                }
              } else
                this.data.hasPopup = !1;
            }
          }
          class V extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              if (this.data.annotationType = n.AnnotationType.SQUIGGLY, this.data.quadPoints = v(D, null)) {
                if (!this.appearance) {
                  const W = this.color ? g(this.color) : [0, 0, 0], ie = D.get("CA");
                  this._setDefaultAppearance({
                    xref: z,
                    extra: "[] 0 d 1 w",
                    strokeColor: W,
                    strokeAlpha: ie,
                    pointsCallback: (ne, re) => {
                      const ee = (re[0].y - re[2].y) / 6;
                      let te = ee, oe = re[2].x;
                      const se = re[2].y, ce = re[3].x;
                      ne.push(`${oe} ${se + te} m`);
                      do
                        oe += 2, te = te === 0 ? ee : 0, ne.push(`${oe} ${se + te} l`);
                      while (oe < ce);
                      return ne.push("S"), [re[2].x, ce, se - 2 * ee, se + 2 * ee];
                    }
                  });
                }
              } else
                this.data.hasPopup = !1;
            }
          }
          class U extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f;
              if (this.data.annotationType = n.AnnotationType.STRIKEOUT, this.data.quadPoints = v(D, null)) {
                if (!this.appearance) {
                  const W = this.color ? g(this.color) : [0, 0, 0], ie = D.get("CA");
                  this._setDefaultAppearance({
                    xref: z,
                    extra: "[] 0 d 1 w",
                    strokeColor: W,
                    strokeAlpha: ie,
                    pointsCallback: (ne, re) => (ne.push(`${(re[0].x + re[2].x) / 2} ${(re[0].y + re[2].y) / 2} m`, `${(re[1].x + re[3].x) / 2} ${(re[1].y + re[3].y) / 2} l`, "S"), [re[0].x, re[1].x, re[3].y, re[1].y])
                  });
                }
              } else
                this.data.hasPopup = !1;
            }
          }
          class Q extends I {
            constructor(f) {
              super(f), this.data.annotationType = n.AnnotationType.STAMP, this.data.hasOwnCanvas = this.data.noRotate;
            }
          }
          class X extends I {
            constructor(f) {
              super(f);
              const {
                dict: D,
                xref: z
              } = f, Y = new w.FileSpec(D.get("FS"), z);
              this.data.annotationType = n.AnnotationType.FILEATTACHMENT, this.data.hasOwnCanvas = this.data.noRotate, this.data.file = Y.serializable;
              const W = D.get("Name");
              this.data.name = W instanceof e.Name ? (0, n.stringToPDFString)(W.name) : "PushPin";
            }
          }
        },
        /* 11 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.FakeUnicodeFont = void 0, F.createDefaultAppearance = w, F.getPdfColor = O, F.parseDefaultAppearance = M;
          var n = ae(4), u = ae(3), q = ae(2), e = ae(12), t = ae(13), B = ae(8);
          class j extends t.EvaluatorPreprocessor {
            constructor(o) {
              super(new B.StringStream(o));
            }
            parse() {
              const o = {
                fn: 0,
                args: []
              }, k = {
                fontSize: 0,
                fontName: "",
                fontColor: new Uint8ClampedArray(3)
              };
              try {
                for (; o.args.length = 0, !!this.read(o); ) {
                  if (this.savedStatesDepth !== 0)
                    continue;
                  const {
                    fn: s,
                    args: l
                  } = o;
                  switch (s | 0) {
                    case q.OPS.setFont:
                      const [g, v] = l;
                      g instanceof n.Name && (k.fontName = g.name), typeof v == "number" && v > 0 && (k.fontSize = v);
                      break;
                    case q.OPS.setFillRGBColor:
                      e.ColorSpace.singletons.rgb.getRgbItem(l, 0, k.fontColor, 0);
                      break;
                    case q.OPS.setFillGray:
                      e.ColorSpace.singletons.gray.getRgbItem(l, 0, k.fontColor, 0);
                      break;
                    case q.OPS.setFillColorSpace:
                      e.ColorSpace.singletons.cmyk.getRgbItem(l, 0, k.fontColor, 0);
                      break;
                  }
                }
              } catch (s) {
                (0, q.warn)(`parseDefaultAppearance - ignoring errors: "${s}".`);
              }
              return k;
            }
          }
          function M(i) {
            return new j(i).parse();
          }
          function O(i, o) {
            if (i[0] === i[1] && i[1] === i[2]) {
              const k = i[0] / 255;
              return `${(0, u.numberToString)(k)} ${o ? "g" : "G"}`;
            }
            return Array.from(i, (k) => (0, u.numberToString)(k / 255)).join(" ") + ` ${o ? "rg" : "RG"}`;
          }
          function w({
            fontSize: i,
            fontName: o,
            fontColor: k
          }) {
            return `/${(0, u.escapePDFName)(o)} ${i} Tf ${O(k, !0)}`;
          }
          class C {
            constructor(o, k) {
              this.xref = o, this.widths = null, this.firstChar = 1 / 0, this.lastChar = -1 / 0, this.fontFamily = k;
              const s = new OffscreenCanvas(1, 1);
              this.ctxMeasure = s.getContext("2d"), C._fontNameId || (C._fontNameId = 1), this.fontName = n.Name.get(`InvalidPDFjsFont_${k}_${C._fontNameId++}`);
            }
            get toUnicodeRef() {
              if (!C._toUnicodeRef) {
                const o = `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo
<< /Registry (Adobe)
/Ordering (UCS) /Supplement 0 >> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000> <FFFF>
endcodespacerange
1 beginbfrange
<0000> <FFFF> <0000>
endbfrange
endcmap CMapName currentdict /CMap defineresource pop end end`, k = C.toUnicodeStream = new B.StringStream(o), s = new n.Dict(this.xref);
                k.dict = s, s.set("Length", o.length), C._toUnicodeRef = this.xref.getNewPersistentRef(k);
              }
              return C._toUnicodeRef;
            }
            get fontDescriptorRef() {
              if (!C._fontDescriptorRef) {
                const o = new n.Dict(this.xref);
                o.set("Type", n.Name.get("FontDescriptor")), o.set("FontName", this.fontName), o.set("FontFamily", "MyriadPro Regular"), o.set("FontBBox", [0, 0, 0, 0]), o.set("FontStretch", n.Name.get("Normal")), o.set("FontWeight", 400), o.set("ItalicAngle", 0), C._fontDescriptorRef = this.xref.getNewPersistentRef(o);
              }
              return C._fontDescriptorRef;
            }
            get descendantFontRef() {
              const o = new n.Dict(this.xref);
              o.set("BaseFont", this.fontName), o.set("Type", n.Name.get("Font")), o.set("Subtype", n.Name.get("CIDFontType0")), o.set("CIDToGIDMap", n.Name.get("Identity")), o.set("FirstChar", this.firstChar), o.set("LastChar", this.lastChar), o.set("FontDescriptor", this.fontDescriptorRef), o.set("DW", 1e3);
              const k = [], s = [...this.widths.entries()].sort();
              let l = null, g = null;
              for (const [r, x] of s) {
                if (!l) {
                  l = r, g = [x];
                  continue;
                }
                r === l + g.length ? g.push(x) : (k.push(l, g), l = r, g = [x]);
              }
              l && k.push(l, g), o.set("W", k);
              const v = new n.Dict(this.xref);
              return v.set("Ordering", "Identity"), v.set("Registry", "Adobe"), v.set("Supplement", 0), o.set("CIDSystemInfo", v), this.xref.getNewPersistentRef(o);
            }
            get baseFontRef() {
              const o = new n.Dict(this.xref);
              return o.set("BaseFont", this.fontName), o.set("Type", n.Name.get("Font")), o.set("Subtype", n.Name.get("Type0")), o.set("Encoding", n.Name.get("Identity-H")), o.set("DescendantFonts", [this.descendantFontRef]), o.set("ToUnicode", this.toUnicodeRef), this.xref.getNewPersistentRef(o);
            }
            get resources() {
              const o = new n.Dict(this.xref), k = new n.Dict(this.xref);
              return k.set(this.fontName.name, this.baseFontRef), o.set("Font", k), o;
            }
            _createContext() {
              return this.widths = /* @__PURE__ */ new Map(), this.ctxMeasure.font = `1000px ${this.fontFamily}`, this.ctxMeasure;
            }
            createFontResources(o) {
              const k = this._createContext();
              for (const s of o.split(/\r\n?|\n/))
                for (const l of s.split("")) {
                  const g = l.charCodeAt(0);
                  if (this.widths.has(g))
                    continue;
                  const v = k.measureText(l), r = Math.ceil(v.width);
                  this.widths.set(g, r), this.firstChar = Math.min(g, this.firstChar), this.lastChar = Math.max(g, this.lastChar);
                }
              return this.resources;
            }
            createAppearance(o, k, s, l, g, v) {
              const r = this._createContext(), x = [];
              let b = -1 / 0;
              for (const V of o.split(/\r\n?|\n/)) {
                x.push(V);
                const U = r.measureText(V).width;
                b = Math.max(b, U);
                for (const Q of V.split("")) {
                  const X = Q.charCodeAt(0);
                  let R = this.widths.get(X);
                  if (R === void 0) {
                    const f = r.measureText(Q);
                    R = Math.ceil(f.width), this.widths.set(X, R), this.firstChar = Math.min(X, this.firstChar), this.lastChar = Math.max(X, this.lastChar);
                  }
                }
              }
              b *= l / 1e3;
              const [I, h, y, P] = k;
              let c = y - I, d = P - h;
              s % 180 !== 0 && ([c, d] = [d, c]);
              let A = 1;
              b > c && (A = c / b);
              let N = 1;
              const E = q.LINE_FACTOR * l, H = q.LINE_DESCENT_FACTOR * l, $ = E * x.length;
              $ > d && (N = d / $);
              const m = Math.min(A, N), p = l * m, T = ["q", `0 0 ${(0, u.numberToString)(c)} ${(0, u.numberToString)(d)} re W n`, "BT", `1 0 0 1 0 ${(0, u.numberToString)(d + H)} Tm 0 Tc ${O(g, !0)}`, `/${this.fontName.name} ${(0, u.numberToString)(p)} Tf`], {
                resources: L
              } = this;
              if (v = typeof v == "number" && v >= 0 && v <= 1 ? v : 1, v !== 1) {
                T.push("/R0 gs");
                const V = new n.Dict(this.xref), U = new n.Dict(this.xref);
                U.set("ca", v), U.set("CA", v), U.set("Type", n.Name.get("ExtGState")), V.set("R0", U), L.set("ExtGState", V);
              }
              const _ = (0, u.numberToString)(E);
              for (const V of x)
                T.push(`0 -${_} Td <${(0, u.stringToUTF16HexString)(V)}> Tj`);
              T.push("ET", "Q");
              const G = T.join(`
`), J = new n.Dict(this.xref);
              if (J.set("Subtype", n.Name.get("Form")), J.set("Type", n.Name.get("XObject")), J.set("BBox", [0, 0, c, d]), J.set("Length", G.length), J.set("Resources", L), s) {
                const V = (0, u.getRotationMatrix)(s, c, d);
                J.set("Matrix", V);
              }
              const K = new B.StringStream(G);
              return K.dict = J, K;
            }
          }
          F.FakeUnicodeFont = C;
        },
        /* 12 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ColorSpace = void 0;
          var n = ae(2), u = ae(4), q = ae(5), e = ae(3);
          function t(l, g, v, r, x, b, I) {
            I = I !== 1 ? 0 : I;
            const y = v / x, P = r / b;
            let c = 0, d;
            const A = new Uint16Array(x), N = v * 3;
            for (let E = 0; E < x; E++)
              A[E] = Math.floor(E * y) * 3;
            for (let E = 0; E < b; E++) {
              const H = Math.floor(E * P) * N;
              for (let $ = 0; $ < x; $++)
                d = H + A[$], g[c++] = l[d++], g[c++] = l[d++], g[c++] = l[d++], c += I;
            }
          }
          class B {
            constructor(g, v) {
              this.constructor === B && (0, n.unreachable)("Cannot initialize ColorSpace."), this.name = g, this.numComps = v;
            }
            getRgb(g, v) {
              const r = new Uint8ClampedArray(3);
              return this.getRgbItem(g, v, r, 0), r;
            }
            getRgbItem(g, v, r, x) {
              (0, n.unreachable)("Should not call ColorSpace.getRgbItem");
            }
            getRgbBuffer(g, v, r, x, b, I, h) {
              (0, n.unreachable)("Should not call ColorSpace.getRgbBuffer");
            }
            getOutputLength(g, v) {
              (0, n.unreachable)("Should not call ColorSpace.getOutputLength");
            }
            isPassthrough(g) {
              return !1;
            }
            isDefaultDecode(g, v) {
              return B.isDefaultDecode(g, this.numComps);
            }
            fillRgb(g, v, r, x, b, I, h, y, P) {
              const c = v * r;
              let d = null;
              const A = 1 << h, N = r !== b || v !== x;
              if (this.isPassthrough(h))
                d = y;
              else if (this.numComps === 1 && c > A && this.name !== "DeviceGray" && this.name !== "DeviceRGB") {
                const E = h <= 8 ? new Uint8Array(A) : new Uint16Array(A);
                for (let $ = 0; $ < A; $++)
                  E[$] = $;
                const H = new Uint8ClampedArray(A * 3);
                if (this.getRgbBuffer(E, 0, A, H, 0, h, 0), N) {
                  d = new Uint8Array(c * 3);
                  let $ = 0;
                  for (let m = 0; m < c; ++m) {
                    const p = y[m] * 3;
                    d[$++] = H[p], d[$++] = H[p + 1], d[$++] = H[p + 2];
                  }
                } else {
                  let $ = 0;
                  for (let m = 0; m < c; ++m) {
                    const p = y[m] * 3;
                    g[$++] = H[p], g[$++] = H[p + 1], g[$++] = H[p + 2], $ += P;
                  }
                }
              } else
                N ? (d = new Uint8ClampedArray(c * 3), this.getRgbBuffer(y, 0, c, d, 0, h, 0)) : this.getRgbBuffer(y, 0, x * I, g, 0, h, P);
              if (d)
                if (N)
                  t(d, g, v, r, x, b, P);
                else {
                  let E = 0, H = 0;
                  for (let $ = 0, m = x * I; $ < m; $++)
                    g[E++] = d[H++], g[E++] = d[H++], g[E++] = d[H++], E += P;
                }
            }
            get usesZeroToOneRange() {
              return (0, n.shadow)(this, "usesZeroToOneRange", !0);
            }
            static _cache(g, v, r, x) {
              if (!r)
                throw new Error('ColorSpace._cache - expected "localColorSpaceCache" argument.');
              if (!x)
                throw new Error('ColorSpace._cache - expected "parsedColorSpace" argument.');
              let b, I;
              g instanceof u.Ref && (I = g, g = v.fetch(g)), g instanceof u.Name && (b = g.name), (b || I) && r.set(b, I, x);
            }
            static getCached(g, v, r) {
              if (!r)
                throw new Error('ColorSpace.getCached - expected "localColorSpaceCache" argument.');
              if (g instanceof u.Ref) {
                const x = r.getByRef(g);
                if (x)
                  return x;
                try {
                  g = v.fetch(g);
                } catch (b) {
                  if (b instanceof e.MissingDataException)
                    throw b;
                }
              }
              if (g instanceof u.Name) {
                const x = r.getByName(g.name);
                if (x)
                  return x;
              }
              return null;
            }
            static async parseAsync({
              cs: g,
              xref: v,
              resources: r = null,
              pdfFunctionFactory: x,
              localColorSpaceCache: b
            }) {
              const I = this._parse(g, v, r, x);
              return this._cache(g, v, b, I), I;
            }
            static parse({
              cs: g,
              xref: v,
              resources: r = null,
              pdfFunctionFactory: x,
              localColorSpaceCache: b
            }) {
              const I = this.getCached(g, v, b);
              if (I)
                return I;
              const h = this._parse(g, v, r, x);
              return this._cache(g, v, b, h), h;
            }
            static _parse(g, v, r = null, x) {
              if (g = v.fetchIfRef(g), g instanceof u.Name)
                switch (g.name) {
                  case "G":
                  case "DeviceGray":
                    return this.singletons.gray;
                  case "RGB":
                  case "DeviceRGB":
                    return this.singletons.rgb;
                  case "CMYK":
                  case "DeviceCMYK":
                    return this.singletons.cmyk;
                  case "Pattern":
                    return new M(null);
                  default:
                    if (r instanceof u.Dict) {
                      const b = r.get("ColorSpace");
                      if (b instanceof u.Dict) {
                        const I = b.get(g.name);
                        if (I) {
                          if (I instanceof u.Name)
                            return this._parse(I, v, r, x);
                          g = I;
                          break;
                        }
                      }
                    }
                    throw new n.FormatError(`Unrecognized ColorSpace: ${g.name}`);
                }
              if (Array.isArray(g)) {
                const b = v.fetchIfRef(g[0]).name;
                let I, h, y, P, c, d;
                switch (b) {
                  case "G":
                  case "DeviceGray":
                    return this.singletons.gray;
                  case "RGB":
                  case "DeviceRGB":
                    return this.singletons.rgb;
                  case "CMYK":
                  case "DeviceCMYK":
                    return this.singletons.cmyk;
                  case "CalGray":
                    return I = v.fetchIfRef(g[1]), P = I.getArray("WhitePoint"), c = I.getArray("BlackPoint"), d = I.get("Gamma"), new o(P, c, d);
                  case "CalRGB":
                    I = v.fetchIfRef(g[1]), P = I.getArray("WhitePoint"), c = I.getArray("BlackPoint"), d = I.getArray("Gamma");
                    const A = I.getArray("Matrix");
                    return new k(P, c, d, A);
                  case "ICCBased":
                    const E = v.fetchIfRef(g[1]).dict;
                    h = E.get("N");
                    const H = E.get("Alternate");
                    if (H) {
                      const _ = this._parse(H, v, r, x);
                      if (_.numComps === h)
                        return _;
                      (0, n.warn)("ICCBased color space: Ignoring incorrect /Alternate entry.");
                    }
                    if (h === 1)
                      return this.singletons.gray;
                    if (h === 3)
                      return this.singletons.rgb;
                    if (h === 4)
                      return this.singletons.cmyk;
                    break;
                  case "Pattern":
                    return y = g[1] || null, y && (y = this._parse(y, v, r, x)), new M(y);
                  case "I":
                  case "Indexed":
                    y = this._parse(g[1], v, r, x);
                    const $ = v.fetchIfRef(g[2]) + 1, m = v.fetchIfRef(g[3]);
                    return new O(y, $, m);
                  case "Separation":
                  case "DeviceN":
                    const p = v.fetchIfRef(g[1]);
                    h = Array.isArray(p) ? p.length : 1, y = this._parse(g[2], v, r, x);
                    const T = x.create(g[3]);
                    return new j(h, y, T);
                  case "Lab":
                    I = v.fetchIfRef(g[1]), P = I.getArray("WhitePoint"), c = I.getArray("BlackPoint");
                    const L = I.getArray("Range");
                    return new s(P, c, L);
                  default:
                    throw new n.FormatError(`Unimplemented ColorSpace object: ${b}`);
                }
              }
              throw new n.FormatError(`Unrecognized ColorSpace object: ${g}`);
            }
            static isDefaultDecode(g, v) {
              if (!Array.isArray(g))
                return !0;
              if (v * 2 !== g.length)
                return (0, n.warn)("The decode map is not the correct length"), !0;
              for (let r = 0, x = g.length; r < x; r += 2)
                if (g[r] !== 0 || g[r + 1] !== 1)
                  return !1;
              return !0;
            }
            static get singletons() {
              return (0, n.shadow)(this, "singletons", {
                get gray() {
                  return (0, n.shadow)(this, "gray", new w());
                },
                get rgb() {
                  return (0, n.shadow)(this, "rgb", new C());
                },
                get cmyk() {
                  return (0, n.shadow)(this, "cmyk", new i());
                }
              });
            }
          }
          F.ColorSpace = B;
          class j extends B {
            constructor(g, v, r) {
              super("Alternate", g), this.base = v, this.tintFn = r, this.tmpBuf = new Float32Array(v.numComps);
            }
            getRgbItem(g, v, r, x) {
              const b = this.tmpBuf;
              this.tintFn(g, v, b, 0), this.base.getRgbItem(b, 0, r, x);
            }
            getRgbBuffer(g, v, r, x, b, I, h) {
              const y = this.tintFn, P = this.base, c = 1 / ((1 << I) - 1), d = P.numComps, A = P.usesZeroToOneRange, N = (P.isPassthrough(8) || !A) && h === 0;
              let E = N ? b : 0;
              const H = N ? x : new Uint8ClampedArray(d * r), $ = this.numComps, m = new Float32Array($), p = new Float32Array(d);
              let T, L;
              for (T = 0; T < r; T++) {
                for (L = 0; L < $; L++)
                  m[L] = g[v++] * c;
                if (y(m, 0, p, 0), A)
                  for (L = 0; L < d; L++)
                    H[E++] = p[L] * 255;
                else
                  P.getRgbItem(p, 0, H, E), E += d;
              }
              N || P.getRgbBuffer(H, 0, r, x, b, 8, h);
            }
            getOutputLength(g, v) {
              return this.base.getOutputLength(g * this.base.numComps / this.numComps, v);
            }
          }
          class M extends B {
            constructor(g) {
              super("Pattern", null), this.base = g;
            }
            isDefaultDecode(g, v) {
              (0, n.unreachable)("Should not call PatternCS.isDefaultDecode");
            }
          }
          class O extends B {
            constructor(g, v, r) {
              super("Indexed", 1), this.base = g, this.highVal = v;
              const x = g.numComps * v;
              if (this.lookup = new Uint8Array(x), r instanceof q.BaseStream) {
                const b = r.getBytes(x);
                this.lookup.set(b);
              } else if (typeof r == "string")
                for (let b = 0; b < x; ++b)
                  this.lookup[b] = r.charCodeAt(b) & 255;
              else
                throw new n.FormatError(`IndexedCS - unrecognized lookup table: ${r}`);
            }
            getRgbItem(g, v, r, x) {
              const b = this.base.numComps, I = g[v] * b;
              this.base.getRgbBuffer(this.lookup, I, 1, r, x, 8, 0);
            }
            getRgbBuffer(g, v, r, x, b, I, h) {
              const y = this.base, P = y.numComps, c = y.getOutputLength(P, h), d = this.lookup;
              for (let A = 0; A < r; ++A) {
                const N = g[v++] * P;
                y.getRgbBuffer(d, N, 1, x, b, 8, h), b += c;
              }
            }
            getOutputLength(g, v) {
              return this.base.getOutputLength(g * this.base.numComps, v);
            }
            isDefaultDecode(g, v) {
              return Array.isArray(g) ? g.length !== 2 ? ((0, n.warn)("Decode map length is not correct"), !0) : !Number.isInteger(v) || v < 1 ? ((0, n.warn)("Bits per component is not correct"), !0) : g[0] === 0 && g[1] === (1 << v) - 1 : !0;
            }
          }
          class w extends B {
            constructor() {
              super("DeviceGray", 1);
            }
            getRgbItem(g, v, r, x) {
              const b = g[v] * 255;
              r[x] = r[x + 1] = r[x + 2] = b;
            }
            getRgbBuffer(g, v, r, x, b, I, h) {
              const y = 255 / ((1 << I) - 1);
              let P = v, c = b;
              for (let d = 0; d < r; ++d) {
                const A = y * g[P++];
                x[c++] = A, x[c++] = A, x[c++] = A, c += h;
              }
            }
            getOutputLength(g, v) {
              return g * (3 + v);
            }
          }
          class C extends B {
            constructor() {
              super("DeviceRGB", 3);
            }
            getRgbItem(g, v, r, x) {
              r[x] = g[v] * 255, r[x + 1] = g[v + 1] * 255, r[x + 2] = g[v + 2] * 255;
            }
            getRgbBuffer(g, v, r, x, b, I, h) {
              if (I === 8 && h === 0) {
                x.set(g.subarray(v, v + r * 3), b);
                return;
              }
              const y = 255 / ((1 << I) - 1);
              let P = v, c = b;
              for (let d = 0; d < r; ++d)
                x[c++] = y * g[P++], x[c++] = y * g[P++], x[c++] = y * g[P++], c += h;
            }
            getOutputLength(g, v) {
              return g * (3 + v) / 3 | 0;
            }
            isPassthrough(g) {
              return g === 8;
            }
          }
          const i = function() {
            function g(r, x, b, I, h) {
              const y = r[x] * b, P = r[x + 1] * b, c = r[x + 2] * b, d = r[x + 3] * b;
              I[h] = 255 + y * (-4.387332384609988 * y + 54.48615194189176 * P + 18.82290502165302 * c + 212.25662451639585 * d + -285.2331026137004) + P * (1.7149763477362134 * P - 5.6096736904047315 * c + -17.873870861415444 * d - 5.497006427196366) + c * (-2.5217340131683033 * c - 21.248923337353073 * d + 17.5119270841813) + d * (-21.86122147463605 * d - 189.48180835922747), I[h + 1] = 255 + y * (8.841041422036149 * y + 60.118027045597366 * P + 6.871425592049007 * c + 31.159100130055922 * d + -79.2970844816548) + P * (-15.310361306967817 * P + 17.575251261109482 * c + 131.35250912493976 * d - 190.9453302588951) + c * (4.444339102852739 * c + 9.8632861493405 * d - 24.86741582555878) + d * (-20.737325471181034 * d - 187.80453709719578), I[h + 2] = 255 + y * (0.8842522430003296 * y + 8.078677503112928 * P + 30.89978309703729 * c - 0.23883238689178934 * d + -14.183576799673286) + P * (10.49593273432072 * P + 63.02378494754052 * c + 50.606957656360734 * d - 112.23884253719248) + c * (0.03296041114873217 * c + 115.60384449646641 * d + -193.58209356861505) + d * (-22.33816807309886 * d - 180.12613974708367);
            }
            class v extends B {
              constructor() {
                super("DeviceCMYK", 4);
              }
              getRgbItem(x, b, I, h) {
                g(x, b, 1, I, h);
              }
              getRgbBuffer(x, b, I, h, y, P, c) {
                const d = 1 / ((1 << P) - 1);
                for (let A = 0; A < I; A++)
                  g(x, b, d, h, y), b += 4, y += 3 + c;
              }
              getOutputLength(x, b) {
                return x / 4 * (3 + b) | 0;
              }
            }
            return v;
          }(), o = function() {
            function g(r, x, b, I, h, y) {
              const c = (x[b] * y) ** r.G, d = r.YW * c, A = Math.max(295.8 * d ** 0.3333333333333333 - 40.8, 0);
              I[h] = A, I[h + 1] = A, I[h + 2] = A;
            }
            class v extends B {
              constructor(x, b, I) {
                if (super("CalGray", 1), !x)
                  throw new n.FormatError("WhitePoint missing - required for color space CalGray");
                if (b || (b = [0, 0, 0]), I || (I = 1), this.XW = x[0], this.YW = x[1], this.ZW = x[2], this.XB = b[0], this.YB = b[1], this.ZB = b[2], this.G = I, this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                  throw new n.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, n.info)(`Invalid BlackPoint for ${this.name}, falling back to default.`), this.XB = this.YB = this.ZB = 0), (this.XB !== 0 || this.YB !== 0 || this.ZB !== 0) && (0, n.warn)(`${this.name}, BlackPoint: XB: ${this.XB}, YB: ${this.YB}, ZB: ${this.ZB}, only default values are supported.`), this.G < 1 && ((0, n.info)(`Invalid Gamma: ${this.G} for ${this.name}, falling back to default.`), this.G = 1);
              }
              getRgbItem(x, b, I, h) {
                g(this, x, b, I, h, 1);
              }
              getRgbBuffer(x, b, I, h, y, P, c) {
                const d = 1 / ((1 << P) - 1);
                for (let A = 0; A < I; ++A)
                  g(this, x, b, h, y, d), b += 1, y += 3 + c;
              }
              getOutputLength(x, b) {
                return x * (3 + b);
              }
            }
            return v;
          }(), k = function() {
            const g = new Float32Array([0.8951, 0.2664, -0.1614, -0.7502, 1.7135, 0.0367, 0.0389, -0.0685, 1.0296]), v = new Float32Array([0.9869929, -0.1470543, 0.1599627, 0.4323053, 0.5183603, 0.0492912, -85287e-7, 0.0400428, 0.9684867]), r = new Float32Array([3.2404542, -1.5371385, -0.4985314, -0.969266, 1.8760108, 0.041556, 0.0556434, -0.2040259, 1.0572252]), x = new Float32Array([1, 1, 1]), b = new Float32Array(3), I = new Float32Array(3), h = new Float32Array(3), y = ((8 + 16) / 116) ** 3 / 8;
            function P(L, _, G) {
              G[0] = L[0] * _[0] + L[1] * _[1] + L[2] * _[2], G[1] = L[3] * _[0] + L[4] * _[1] + L[5] * _[2], G[2] = L[6] * _[0] + L[7] * _[1] + L[8] * _[2];
            }
            function c(L, _, G) {
              G[0] = _[0] * 1 / L[0], G[1] = _[1] * 1 / L[1], G[2] = _[2] * 1 / L[2];
            }
            function d(L, _, G) {
              G[0] = _[0] * 0.95047 / L[0], G[1] = _[1] * 1 / L[1], G[2] = _[2] * 1.08883 / L[2];
            }
            function A(L) {
              return L <= 31308e-7 ? N(0, 1, 12.92 * L) : L >= 0.99554525 ? 1 : N(0, 1, (1 + 0.055) * L ** (1 / 2.4) - 0.055);
            }
            function N(L, _, G) {
              return Math.max(L, Math.min(_, G));
            }
            function E(L) {
              return L < 0 ? -E(-L) : L > 8 ? ((L + 16) / 116) ** 3 : L * y;
            }
            function H(L, _, G) {
              if (L[0] === 0 && L[1] === 0 && L[2] === 0) {
                G[0] = _[0], G[1] = _[1], G[2] = _[2];
                return;
              }
              const J = E(0), K = J, V = E(L[0]), U = J, Q = E(L[1]), X = J, R = E(L[2]), f = (1 - K) / (1 - V), D = 1 - f, z = (1 - U) / (1 - Q), Y = 1 - z, W = (1 - X) / (1 - R), ie = 1 - W;
              G[0] = _[0] * f + D, G[1] = _[1] * z + Y, G[2] = _[2] * W + ie;
            }
            function $(L, _, G) {
              if (L[0] === 1 && L[2] === 1) {
                G[0] = _[0], G[1] = _[1], G[2] = _[2];
                return;
              }
              const J = G;
              P(g, _, J);
              const K = b;
              c(L, J, K), P(v, K, G);
            }
            function m(L, _, G) {
              const J = G;
              P(g, _, J);
              const K = b;
              d(L, J, K), P(v, K, G);
            }
            function p(L, _, G, J, K, V) {
              const U = N(0, 1, _[G] * V), Q = N(0, 1, _[G + 1] * V), X = N(0, 1, _[G + 2] * V), R = U === 1 ? 1 : U ** L.GR, f = Q === 1 ? 1 : Q ** L.GG, D = X === 1 ? 1 : X ** L.GB, z = L.MXA * R + L.MXB * f + L.MXC * D, Y = L.MYA * R + L.MYB * f + L.MYC * D, W = L.MZA * R + L.MZB * f + L.MZC * D, ie = I;
              ie[0] = z, ie[1] = Y, ie[2] = W;
              const ne = h;
              $(L.whitePoint, ie, ne);
              const re = I;
              H(L.blackPoint, ne, re);
              const ee = h;
              m(x, re, ee);
              const te = I;
              P(r, ee, te), J[K] = A(te[0]) * 255, J[K + 1] = A(te[1]) * 255, J[K + 2] = A(te[2]) * 255;
            }
            class T extends B {
              constructor(_, G, J, K) {
                if (super("CalRGB", 3), !_)
                  throw new n.FormatError("WhitePoint missing - required for color space CalRGB");
                G || (G = new Float32Array(3)), J || (J = new Float32Array([1, 1, 1])), K || (K = new Float32Array([1, 0, 0, 0, 1, 0, 0, 0, 1]));
                const V = _[0], U = _[1], Q = _[2];
                this.whitePoint = _;
                const X = G[0], R = G[1], f = G[2];
                if (this.blackPoint = G, this.GR = J[0], this.GG = J[1], this.GB = J[2], this.MXA = K[0], this.MYA = K[1], this.MZA = K[2], this.MXB = K[3], this.MYB = K[4], this.MZB = K[5], this.MXC = K[6], this.MYC = K[7], this.MZC = K[8], V < 0 || Q < 0 || U !== 1)
                  throw new n.FormatError(`Invalid WhitePoint components for ${this.name}, no fallback available`);
                (X < 0 || R < 0 || f < 0) && ((0, n.info)(`Invalid BlackPoint for ${this.name} [${X}, ${R}, ${f}], falling back to default.`), this.blackPoint = new Float32Array(3)), (this.GR < 0 || this.GG < 0 || this.GB < 0) && ((0, n.info)(`Invalid Gamma [${this.GR}, ${this.GG}, ${this.GB}] for ${this.name}, falling back to default.`), this.GR = this.GG = this.GB = 1);
              }
              getRgbItem(_, G, J, K) {
                p(this, _, G, J, K, 1);
              }
              getRgbBuffer(_, G, J, K, V, U, Q) {
                const X = 1 / ((1 << U) - 1);
                for (let R = 0; R < J; ++R)
                  p(this, _, G, K, V, X), G += 3, V += 3 + Q;
              }
              getOutputLength(_, G) {
                return _ * (3 + G) / 3 | 0;
              }
            }
            return T;
          }(), s = function() {
            function g(b) {
              let I;
              return b >= 6 / 29 ? I = b ** 3 : I = 108 / 841 * (b - 4 / 29), I;
            }
            function v(b, I, h, y) {
              return h + b * (y - h) / I;
            }
            function r(b, I, h, y, P, c) {
              let d = I[h], A = I[h + 1], N = I[h + 2];
              y !== !1 && (d = v(d, y, 0, 100), A = v(A, y, b.amin, b.amax), N = v(N, y, b.bmin, b.bmax)), A > b.amax ? A = b.amax : A < b.amin && (A = b.amin), N > b.bmax ? N = b.bmax : N < b.bmin && (N = b.bmin);
              const E = (d + 16) / 116, H = E + A / 500, $ = E - N / 200, m = b.XW * g(H), p = b.YW * g(E), T = b.ZW * g($);
              let L, _, G;
              b.ZW < 1 ? (L = m * 3.1339 + p * -1.617 + T * -0.4906, _ = m * -0.9785 + p * 1.916 + T * 0.0333, G = m * 0.072 + p * -0.229 + T * 1.4057) : (L = m * 3.2406 + p * -1.5372 + T * -0.4986, _ = m * -0.9689 + p * 1.8758 + T * 0.0415, G = m * 0.0557 + p * -0.204 + T * 1.057), P[c] = Math.sqrt(L) * 255, P[c + 1] = Math.sqrt(_) * 255, P[c + 2] = Math.sqrt(G) * 255;
            }
            class x extends B {
              constructor(I, h, y) {
                if (super("Lab", 3), !I)
                  throw new n.FormatError("WhitePoint missing - required for color space Lab");
                if (h || (h = [0, 0, 0]), y || (y = [-100, 100, -100, 100]), this.XW = I[0], this.YW = I[1], this.ZW = I[2], this.amin = y[0], this.amax = y[1], this.bmin = y[2], this.bmax = y[3], this.XB = h[0], this.YB = h[1], this.ZB = h[2], this.XW < 0 || this.ZW < 0 || this.YW !== 1)
                  throw new n.FormatError("Invalid WhitePoint components, no fallback available");
                (this.XB < 0 || this.YB < 0 || this.ZB < 0) && ((0, n.info)("Invalid BlackPoint, falling back to default"), this.XB = this.YB = this.ZB = 0), (this.amin > this.amax || this.bmin > this.bmax) && ((0, n.info)("Invalid Range, falling back to defaults"), this.amin = -100, this.amax = 100, this.bmin = -100, this.bmax = 100);
              }
              getRgbItem(I, h, y, P) {
                r(this, I, h, !1, y, P);
              }
              getRgbBuffer(I, h, y, P, c, d, A) {
                const N = (1 << d) - 1;
                for (let E = 0; E < y; E++)
                  r(this, I, h, N, P, c), h += 3, c += 3 + A;
              }
              getOutputLength(I, h) {
                return I * (3 + h) / 3 | 0;
              }
              isDefaultDecode(I, h) {
                return !0;
              }
              get usesZeroToOneRange() {
                return (0, n.shadow)(this, "usesZeroToOneRange", !1);
              }
            }
            return x;
          }();
        },
        /* 13 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PartialEvaluator = F.EvaluatorPreprocessor = void 0;
          var n = ae(2), u = ae(14), q = ae(4), e = ae(34), t = ae(37), B = ae(41), j = ae(50), M = ae(51), O = ae(42), w = ae(57), C = ae(16), i = ae(59), o = ae(8), k = ae(5), s = ae(60), l = ae(12), g = ae(18), v = ae(38), r = ae(61), x = ae(39), b = ae(3), I = ae(45), h = ae(40), y = ae(62), P = ae(63), c = ae(64), d = ae(65);
          const A = Object.freeze({
            maxImageSize: -1,
            disableFontFace: !1,
            ignoreErrors: !1,
            isEvalSupported: !0,
            isOffscreenCanvasSupported: !1,
            canvasMaxAreaInBytes: -1,
            fontExtraProperties: !1,
            useSystemFonts: !0,
            cMapUrl: null,
            standardFontDataUrl: null
          }), N = {
            TILING: 1,
            SHADING: 2
          }, E = 10, H = Promise.resolve();
          function $(Q, X = !1) {
            if (Array.isArray(Q)) {
              for (const R of Q) {
                const f = $(R, !0);
                if (f)
                  return f;
              }
              return (0, n.warn)(`Unsupported blend mode Array: ${Q}`), "source-over";
            }
            if (!(Q instanceof q.Name))
              return X ? null : "source-over";
            switch (Q.name) {
              case "Normal":
              case "Compatible":
                return "source-over";
              case "Multiply":
                return "multiply";
              case "Screen":
                return "screen";
              case "Overlay":
                return "overlay";
              case "Darken":
                return "darken";
              case "Lighten":
                return "lighten";
              case "ColorDodge":
                return "color-dodge";
              case "ColorBurn":
                return "color-burn";
              case "HardLight":
                return "hard-light";
              case "SoftLight":
                return "soft-light";
              case "Difference":
                return "difference";
              case "Exclusion":
                return "exclusion";
              case "Hue":
                return "hue";
              case "Saturation":
                return "saturation";
              case "Color":
                return "color";
              case "Luminosity":
                return "luminosity";
            }
            return X ? null : ((0, n.warn)(`Unsupported blend mode: ${Q.name}`), "source-over");
          }
          function m(Q) {
            var X;
            Q.fn === n.OPS.paintImageMaskXObject && ((X = Q.args[0]) == null ? void 0 : X.count) > 0 && Q.args[0].count++;
          }
          const V = class V {
            constructor() {
              this.reset();
            }
            check() {
              return ++this.checked < V.CHECK_TIME_EVERY ? !1 : (this.checked = 0, this.endTime <= Date.now());
            }
            reset() {
              this.endTime = Date.now() + V.TIME_SLOT_DURATION_MS, this.checked = 0;
            }
          };
          Dt(V, "TIME_SLOT_DURATION_MS", 20), Dt(V, "CHECK_TIME_EVERY", 100);
          let p = V;
          class T {
            constructor({
              xref: X,
              handler: R,
              pageIndex: f,
              idFactory: D,
              fontCache: z,
              builtInCMapCache: Y,
              standardFontDataCache: W,
              globalImageCache: ie,
              systemFontCache: ne,
              options: re = null
            }) {
              this.xref = X, this.handler = R, this.pageIndex = f, this.idFactory = D, this.fontCache = z, this.builtInCMapCache = Y, this.standardFontDataCache = W, this.globalImageCache = ie, this.systemFontCache = ne, this.options = re || A, this.parsingType3Font = !1, this._regionalImageCache = new i.RegionalImageCache(), this._fetchBuiltInCMapBound = this.fetchBuiltInCMap.bind(this), y.ImageResizer.setMaxArea(this.options.canvasMaxAreaInBytes);
            }
            get _pdfFunctionFactory() {
              const X = new w.PDFFunctionFactory({
                xref: this.xref,
                isEvalSupported: this.options.isEvalSupported
              });
              return (0, n.shadow)(this, "_pdfFunctionFactory", X);
            }
            clone(X = null) {
              const R = Object.create(this);
              return R.options = Object.assign(/* @__PURE__ */ Object.create(null), this.options, X), R;
            }
            hasBlendModes(X, R) {
              if (!(X instanceof q.Dict) || X.objId && R.has(X.objId))
                return !1;
              const f = new q.RefSet(R);
              X.objId && f.put(X.objId);
              const D = [X], z = this.xref;
              for (; D.length; ) {
                const Y = D.shift(), W = Y.get("ExtGState");
                if (W instanceof q.Dict)
                  for (let ne of W.getRawValues()) {
                    if (ne instanceof q.Ref) {
                      if (f.has(ne))
                        continue;
                      try {
                        ne = z.fetch(ne);
                      } catch (ee) {
                        f.put(ne), (0, n.info)(`hasBlendModes - ignoring ExtGState: "${ee}".`);
                        continue;
                      }
                    }
                    if (!(ne instanceof q.Dict))
                      continue;
                    ne.objId && f.put(ne.objId);
                    const re = ne.get("BM");
                    if (re instanceof q.Name) {
                      if (re.name !== "Normal")
                        return !0;
                      continue;
                    }
                    if (re !== void 0 && Array.isArray(re)) {
                      for (const ee of re)
                        if (ee instanceof q.Name && ee.name !== "Normal")
                          return !0;
                    }
                  }
                const ie = Y.get("XObject");
                if (ie instanceof q.Dict)
                  for (let ne of ie.getRawValues()) {
                    if (ne instanceof q.Ref) {
                      if (f.has(ne))
                        continue;
                      try {
                        ne = z.fetch(ne);
                      } catch (ee) {
                        f.put(ne), (0, n.info)(`hasBlendModes - ignoring XObject: "${ee}".`);
                        continue;
                      }
                    }
                    if (!(ne instanceof k.BaseStream))
                      continue;
                    ne.dict.objId && f.put(ne.dict.objId);
                    const re = ne.dict.get("Resources");
                    re instanceof q.Dict && (re.objId && f.has(re.objId) || (D.push(re), re.objId && f.put(re.objId)));
                  }
              }
              for (const Y of f)
                R.put(Y);
              return !1;
            }
            async fetchBuiltInCMap(X) {
              const R = this.builtInCMapCache.get(X);
              if (R)
                return R;
              let f;
              if (this.options.cMapUrl !== null) {
                const D = `${this.options.cMapUrl}${X}.bcmap`, z = await fetch(D);
                if (!z.ok)
                  throw new Error(`fetchBuiltInCMap: failed to fetch file "${D}" with "${z.statusText}".`);
                f = {
                  cMapData: new Uint8Array(await z.arrayBuffer()),
                  compressionType: n.CMapCompressionType.BINARY
                };
              } else
                f = await this.handler.sendWithPromise("FetchBuiltInCMap", {
                  name: X
                });
              return f.compressionType !== n.CMapCompressionType.NONE && this.builtInCMapCache.set(X, f), f;
            }
            async fetchStandardFontData(X) {
              const R = this.standardFontDataCache.get(X);
              if (R)
                return new o.Stream(R);
              if (this.options.useSystemFonts && X !== "Symbol" && X !== "ZapfDingbats")
                return null;
              const f = (0, B.getFontNameToFileMap)(), D = f[X];
              let z;
              if (this.options.standardFontDataUrl !== null) {
                const Y = `${this.options.standardFontDataUrl}${D}`, W = await fetch(Y);
                W.ok ? z = await W.arrayBuffer() : (0, n.warn)(`fetchStandardFontData: failed to fetch file "${Y}" with "${W.statusText}".`);
              } else
                try {
                  z = await this.handler.sendWithPromise("FetchStandardFontData", {
                    filename: D
                  });
                } catch (Y) {
                  (0, n.warn)(`fetchStandardFontData: failed to fetch file "${D}" with "${Y}".`);
                }
              return z ? (this.standardFontDataCache.set(X, z), new o.Stream(z)) : null;
            }
            async buildFormXObject(X, R, f, D, z, Y, W) {
              const ie = R.dict, ne = ie.getArray("Matrix");
              let re = ie.getArray("BBox");
              Array.isArray(re) && re.length === 4 ? re = n.Util.normalizeRect(re) : re = null;
              let ee, te;
              ie.has("OC") && (ee = await this.parseMarkedContentProps(ie.get("OC"), X)), ee !== void 0 && D.addOp(n.OPS.beginMarkedContentProps, ["OC", ee]);
              const oe = ie.get("Group");
              if (oe) {
                te = {
                  matrix: ne,
                  bbox: re,
                  smask: f,
                  isolated: !1,
                  knockout: !1
                };
                const ce = oe.get("S");
                let le = null;
                if ((0, q.isName)(ce, "Transparency") && (te.isolated = oe.get("I") || !1, te.knockout = oe.get("K") || !1, oe.has("CS"))) {
                  const de = oe.getRaw("CS"), Ie = l.ColorSpace.getCached(de, this.xref, W);
                  Ie ? le = Ie : le = await this.parseColorSpace({
                    cs: de,
                    resources: X,
                    localColorSpaceCache: W
                  });
                }
                f != null && f.backdrop && (le || (le = l.ColorSpace.singletons.rgb), f.backdrop = le.getRgb(f.backdrop, 0)), D.addOp(n.OPS.beginGroup, [te]);
              }
              const se = oe ? [ne, null] : [ne, re];
              return D.addOp(n.OPS.paintFormXObjectBegin, se), this.getOperatorList({
                stream: R,
                task: z,
                resources: ie.get("Resources") || X,
                operatorList: D,
                initialState: Y
              }).then(function() {
                D.addOp(n.OPS.paintFormXObjectEnd, []), oe && D.addOp(n.OPS.endGroup, [te]), ee !== void 0 && D.addOp(n.OPS.endMarkedContent, []);
              });
            }
            _sendImgData(X, R, f = !1) {
              const D = R ? [R.bitmap || R.data.buffer] : null;
              return this.parsingType3Font || f ? this.handler.send("commonobj", [X, "Image", R], D) : this.handler.send("obj", [X, this.pageIndex, "Image", R], D);
            }
            async buildPaintImageXObject({
              resources: X,
              image: R,
              isInline: f = !1,
              operatorList: D,
              cacheKey: z,
              localImageCache: Y,
              localColorSpaceCache: W
            }) {
              const ie = R.dict, ne = ie.objId, re = ie.get("W", "Width"), ee = ie.get("H", "Height");
              if (!(re && typeof re == "number") || !(ee && typeof ee == "number")) {
                (0, n.warn)("Image dimensions are missing, or not numbers.");
                return;
              }
              const te = this.options.maxImageSize;
              if (te !== -1 && re * ee > te) {
                const fe = "Image exceeded maximum allowed size and was removed.";
                if (this.options.ignoreErrors) {
                  (0, n.warn)(fe);
                  return;
                }
                throw new Error(fe);
              }
              let oe;
              ie.has("OC") && (oe = await this.parseMarkedContentProps(ie.get("OC"), X));
              const se = ie.get("IM", "ImageMask") || !1;
              let ce, le;
              if (se) {
                const fe = ie.get("I", "Interpolate"), Ae = re + 7 >> 3, Pe = R.getBytes(Ae * ee), Re = ie.getArray("D", "Decode");
                if (this.parsingType3Font) {
                  if (ce = d.PDFImage.createRawMask({
                    imgArray: Pe,
                    width: re,
                    height: ee,
                    imageIsFromDecodeStream: R instanceof g.DecodeStream,
                    inverseDecode: (Re == null ? void 0 : Re[0]) > 0,
                    interpolate: fe
                  }), ce.cached = !!z, le = [ce], D.addImageOps(n.OPS.paintImageMaskXObject, le, oe), z) {
                    const ye = {
                      fn: n.OPS.paintImageMaskXObject,
                      args: le,
                      optionalContent: oe
                    };
                    Y.set(z, ne, ye), ne && this._regionalImageCache.set(null, ne, ye);
                  }
                  return;
                }
                if (ce = await d.PDFImage.createMask({
                  imgArray: Pe,
                  width: re,
                  height: ee,
                  imageIsFromDecodeStream: R instanceof g.DecodeStream,
                  inverseDecode: (Re == null ? void 0 : Re[0]) > 0,
                  interpolate: fe,
                  isOffscreenCanvasSupported: this.options.isOffscreenCanvasSupported
                }), ce.isSingleOpaquePixel) {
                  if (D.addImageOps(n.OPS.paintSolidColorImageMask, [], oe), z) {
                    const ye = {
                      fn: n.OPS.paintSolidColorImageMask,
                      args: [],
                      optionalContent: oe
                    };
                    Y.set(z, ne, ye), ne && this._regionalImageCache.set(null, ne, ye);
                  }
                  return;
                }
                const Ee = `mask_${this.idFactory.createObjId()}`;
                if (D.addDependency(Ee), this._sendImgData(Ee, ce), le = [{
                  data: Ee,
                  width: ce.width,
                  height: ce.height,
                  interpolate: ce.interpolate,
                  count: 1
                }], D.addImageOps(n.OPS.paintImageMaskXObject, le, oe), z) {
                  const ye = {
                    fn: n.OPS.paintImageMaskXObject,
                    args: le,
                    optionalContent: oe
                  };
                  Y.set(z, ne, ye), ne && this._regionalImageCache.set(null, ne, ye);
                }
                return;
              }
              const de = ie.get("SM", "SMask") || !1, Ie = ie.get("Mask") || !1, Fe = 200;
              if (f && !de && !Ie && re + ee < Fe) {
                ce = await new d.PDFImage({
                  xref: this.xref,
                  res: X,
                  image: R,
                  isInline: f,
                  pdfFunctionFactory: this._pdfFunctionFactory,
                  localColorSpaceCache: W
                }).createImageData(!0, !1), D.isOffscreenCanvasSupported = this.options.isOffscreenCanvasSupported, D.addImageOps(n.OPS.paintInlineImageXObject, [ce], oe);
                return;
              }
              let we = `img_${this.idFactory.createObjId()}`, pe = !1;
              if (this.parsingType3Font ? we = `${this.idFactory.getDocId()}_type3_${we}` : ne && (pe = this.globalImageCache.shouldCache(ne, this.pageIndex), pe && (we = `${this.idFactory.getDocId()}_${we}`)), D.addDependency(we), le = [we, re, ee], d.PDFImage.buildImage({
                xref: this.xref,
                res: X,
                image: R,
                isInline: f,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: W
              }).then(async (fe) => {
                if (ce = await fe.createImageData(!1, this.options.isOffscreenCanvasSupported), z && ne && pe) {
                  let Ae = 0;
                  ce.bitmap ? Ae = ce.width * ce.height * 4 : Ae = ce.data.length, this.globalImageCache.addByteSize(ne, Ae);
                }
                return this._sendImgData(we, ce, pe);
              }).catch((fe) => ((0, n.warn)(`Unable to decode image "${we}": "${fe}".`), this._sendImgData(we, null, pe))), D.addImageOps(n.OPS.paintImageXObject, le, oe), z) {
                const fe = {
                  fn: n.OPS.paintImageXObject,
                  args: le,
                  optionalContent: oe
                };
                Y.set(z, ne, fe), ne && (this._regionalImageCache.set(null, ne, fe), pe && ((0, n.assert)(!f, "Cannot cache an inline image globally."), this.globalImageCache.setData(ne, {
                  objId: we,
                  fn: n.OPS.paintImageXObject,
                  args: le,
                  optionalContent: oe,
                  byteSize: 0
                })));
              }
            }
            handleSMask(X, R, f, D, z, Y) {
              const W = X.get("G"), ie = {
                subtype: X.get("S").name,
                backdrop: X.get("BC")
              }, ne = X.get("TR");
              if ((0, w.isPDFFunction)(ne)) {
                const re = this._pdfFunctionFactory.create(ne), ee = new Uint8Array(256), te = new Float32Array(1);
                for (let oe = 0; oe < 256; oe++)
                  te[0] = oe / 255, re(te, 0, te, 0), ee[oe] = te[0] * 255 | 0;
                ie.transferMap = ee;
              }
              return this.buildFormXObject(R, W, ie, f, D, z.state.clone(), Y);
            }
            handleTransferFunction(X) {
              let R;
              if (Array.isArray(X))
                R = X;
              else if ((0, w.isPDFFunction)(X))
                R = [X];
              else
                return null;
              const f = [];
              let D = 0, z = 0;
              for (const Y of R) {
                const W = this.xref.fetchIfRef(Y);
                if (D++, (0, q.isName)(W, "Identity")) {
                  f.push(null);
                  continue;
                } else if (!(0, w.isPDFFunction)(W))
                  return null;
                const ie = this._pdfFunctionFactory.create(W), ne = new Uint8Array(256), re = new Float32Array(1);
                for (let ee = 0; ee < 256; ee++)
                  re[0] = ee / 255, ie(re, 0, re, 0), ne[ee] = re[0] * 255 | 0;
                f.push(ne), z++;
              }
              return !(D === 1 || D === 4) || z === 0 ? null : f;
            }
            handleTilingType(X, R, f, D, z, Y, W, ie) {
              const ne = new c.OperatorList(), re = q.Dict.merge({
                xref: this.xref,
                dictArray: [z.get("Resources"), f]
              });
              return this.getOperatorList({
                stream: D,
                task: W,
                resources: re,
                operatorList: ne
              }).then(function() {
                const ee = ne.getIR(), te = (0, j.getTilingPatternIR)(ee, z, R);
                Y.addDependencies(ne.dependencies), Y.addOp(X, te), z.objId && ie.set(null, z.objId, {
                  operatorListIR: ee,
                  dict: z
                });
              }).catch((ee) => {
                if (!(ee instanceof n.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, n.warn)(`handleTilingType - ignoring pattern: "${ee}".`);
                    return;
                  }
                  throw ee;
                }
              });
            }
            handleSetFont(X, R, f, D, z, Y, W = null, ie = null) {
              const ne = (R == null ? void 0 : R[0]) instanceof q.Name ? R[0].name : null;
              return this.loadFont(ne, f, X, W, ie).then((re) => re.font.isType3Font ? re.loadType3Data(this, X, z).then(function() {
                return D.addDependencies(re.type3Dependencies), re;
              }).catch((ee) => new L({
                loadedName: "g_font_error",
                font: new e.ErrorFont(`Type3 font load error: ${ee}`),
                dict: re.font,
                evaluatorOptions: this.options
              })) : re).then((re) => (Y.font = re.font, re.send(this.handler), re.loadedName));
            }
            handleText(X, R) {
              const f = R.font, D = f.charsToGlyphs(X);
              return f.data && (R.textRenderingMode & n.TextRenderingMode.ADD_TO_PATH_FLAG || R.fillColorSpace.name === "Pattern" || f.disableFontFace || this.options.disableFontFace) && T.buildFontPaths(f, D, this.handler, this.options), D;
            }
            ensureStateFont(X) {
              if (X.font)
                return;
              const R = new n.FormatError("Missing setFont (Tf) operator before text rendering operator.");
              if (this.options.ignoreErrors) {
                (0, n.warn)(`ensureStateFont: "${R}".`);
                return;
              }
              throw R;
            }
            async setGState({
              resources: X,
              gState: R,
              operatorList: f,
              cacheKey: D,
              task: z,
              stateManager: Y,
              localGStateCache: W,
              localColorSpaceCache: ie
            }) {
              const ne = R.objId;
              let re = !0;
              const ee = [];
              let te = Promise.resolve();
              for (const oe of R.getKeys()) {
                const se = R.get(oe);
                switch (oe) {
                  case "Type":
                    break;
                  case "LW":
                  case "LC":
                  case "LJ":
                  case "ML":
                  case "D":
                  case "RI":
                  case "FL":
                  case "CA":
                  case "ca":
                    ee.push([oe, se]);
                    break;
                  case "Font":
                    re = !1, te = te.then(() => this.handleSetFont(X, null, se[0], f, z, Y.state).then(function(le) {
                      f.addDependency(le), ee.push([oe, [le, se[1]]]);
                    }));
                    break;
                  case "BM":
                    ee.push([oe, $(se)]);
                    break;
                  case "SMask":
                    if ((0, q.isName)(se, "None")) {
                      ee.push([oe, !1]);
                      break;
                    }
                    se instanceof q.Dict ? (re = !1, te = te.then(() => this.handleSMask(se, X, f, z, Y, ie)), ee.push([oe, !0])) : (0, n.warn)("Unsupported SMask type");
                    break;
                  case "TR":
                    const ce = this.handleTransferFunction(se);
                    ee.push([oe, ce]);
                    break;
                  case "OP":
                  case "op":
                  case "OPM":
                  case "BG":
                  case "BG2":
                  case "UCR":
                  case "UCR2":
                  case "TR2":
                  case "HT":
                  case "SM":
                  case "SA":
                  case "AIS":
                  case "TK":
                    (0, n.info)("graphic state operator " + oe);
                    break;
                  default:
                    (0, n.info)("Unknown graphic state operator " + oe);
                    break;
                }
              }
              return te.then(function() {
                ee.length > 0 && f.addOp(n.OPS.setGState, [ee]), re && W.set(D, ne, ee);
              });
            }
            loadFont(X, R, f, D = null, z = null) {
              const Y = async () => new L({
                loadedName: "g_font_error",
                font: new e.ErrorFont(`Font "${X}" is not available.`),
                dict: R,
                evaluatorOptions: this.options
              });
              let W;
              if (R)
                R instanceof q.Ref && (W = R);
              else {
                const se = f.get("Font");
                se && (W = se.getRaw(X));
              }
              if (W) {
                if (this.parsingType3Font && this.type3FontRefs.has(W))
                  return Y();
                if (this.fontCache.has(W))
                  return this.fontCache.get(W);
                R = this.xref.fetchIfRef(W);
              }
              if (!(R instanceof q.Dict)) {
                if (!this.options.ignoreErrors && !this.parsingType3Font)
                  return (0, n.warn)(`Font "${X}" is not available.`), Y();
                (0, n.warn)(`Font "${X}" is not available -- attempting to fallback to a default font.`), R = D || T.fallbackFontDict;
              }
              if (R.cacheKey && this.fontCache.has(R.cacheKey))
                return this.fontCache.get(R.cacheKey);
              const ie = new n.PromiseCapability();
              let ne;
              try {
                ne = this.preEvaluateFont(R), ne.cssFontInfo = z;
              } catch (se) {
                return (0, n.warn)(`loadFont - preEvaluateFont failed: "${se}".`), Y();
              }
              const {
                descriptor: re,
                hash: ee
              } = ne, te = W instanceof q.Ref;
              let oe;
              if (ee && re instanceof q.Dict) {
                const se = re.fontAliases || (re.fontAliases = /* @__PURE__ */ Object.create(null));
                if (se[ee]) {
                  const ce = se[ee].aliasRef;
                  if (te && ce && this.fontCache.has(ce))
                    return this.fontCache.putAlias(W, ce), this.fontCache.get(W);
                } else
                  se[ee] = {
                    fontID: this.idFactory.createFontId()
                  };
                te && (se[ee].aliasRef = W), oe = se[ee].fontID;
              } else
                oe = this.idFactory.createFontId();
              return (0, n.assert)(oe == null ? void 0 : oe.startsWith("f"), 'The "fontID" must be (correctly) defined.'), te ? this.fontCache.put(W, ie.promise) : (R.cacheKey = `cacheKey_${oe}`, this.fontCache.put(R.cacheKey, ie.promise)), R.loadedName = `${this.idFactory.getDocId()}_${oe}`, this.translateFont(ne).then((se) => {
                ie.resolve(new L({
                  loadedName: R.loadedName,
                  font: se,
                  dict: R,
                  evaluatorOptions: this.options
                }));
              }).catch((se) => {
                (0, n.warn)(`loadFont - translateFont failed: "${se}".`), ie.resolve(new L({
                  loadedName: R.loadedName,
                  font: new e.ErrorFont(se instanceof Error ? se.message : se),
                  dict: R,
                  evaluatorOptions: this.options
                }));
              }), ie.promise;
            }
            buildPath(X, R, f, D = !1) {
              const z = X.length - 1;
              if (f || (f = []), z < 0 || X.fnArray[z] !== n.OPS.constructPath) {
                D && ((0, n.warn)(`Encountered path operator "${R}" inside of a text object.`), X.addOp(n.OPS.save, null));
                let Y;
                switch (R) {
                  case n.OPS.rectangle:
                    const W = f[0] + f[2], ie = f[1] + f[3];
                    Y = [Math.min(f[0], W), Math.max(f[0], W), Math.min(f[1], ie), Math.max(f[1], ie)];
                    break;
                  case n.OPS.moveTo:
                  case n.OPS.lineTo:
                    Y = [f[0], f[0], f[1], f[1]];
                    break;
                  default:
                    Y = [1 / 0, -1 / 0, 1 / 0, -1 / 0];
                    break;
                }
                X.addOp(n.OPS.constructPath, [[R], f, Y]), D && X.addOp(n.OPS.restore, null);
              } else {
                const Y = X.argsArray[z];
                Y[0].push(R), Y[1].push(...f);
                const W = Y[2];
                switch (R) {
                  case n.OPS.rectangle:
                    const ie = f[0] + f[2], ne = f[1] + f[3];
                    W[0] = Math.min(W[0], f[0], ie), W[1] = Math.max(W[1], f[0], ie), W[2] = Math.min(W[2], f[1], ne), W[3] = Math.max(W[3], f[1], ne);
                    break;
                  case n.OPS.moveTo:
                  case n.OPS.lineTo:
                    W[0] = Math.min(W[0], f[0]), W[1] = Math.max(W[1], f[0]), W[2] = Math.min(W[2], f[1]), W[3] = Math.max(W[3], f[1]);
                    break;
                }
              }
            }
            parseColorSpace({
              cs: X,
              resources: R,
              localColorSpaceCache: f
            }) {
              return l.ColorSpace.parseAsync({
                cs: X,
                xref: this.xref,
                resources: R,
                pdfFunctionFactory: this._pdfFunctionFactory,
                localColorSpaceCache: f
              }).catch((D) => {
                if (D instanceof n.AbortException)
                  return null;
                if (this.options.ignoreErrors)
                  return (0, n.warn)(`parseColorSpace - ignoring ColorSpace: "${D}".`), null;
                throw D;
              });
            }
            parseShading({
              shading: X,
              resources: R,
              localColorSpaceCache: f,
              localShadingPatternCache: D
            }) {
              let z = D.get(X);
              if (!z) {
                var Y = j.Pattern.parseShading(X, this.xref, R, this._pdfFunctionFactory, f);
                const W = Y.getIR();
                z = `pattern_${this.idFactory.createObjId()}`, this.parsingType3Font && (z = `${this.idFactory.getDocId()}_type3_${z}`), D.set(X, z), this.parsingType3Font ? this.handler.send("commonobj", [z, "Pattern", W]) : this.handler.send("obj", [z, this.pageIndex, "Pattern", W]);
              }
              return z;
            }
            handleColorN(X, R, f, D, z, Y, W, ie, ne, re) {
              const ee = f.pop();
              if (ee instanceof q.Name) {
                const te = z.getRaw(ee.name), oe = te instanceof q.Ref && ne.getByRef(te);
                if (oe)
                  try {
                    const ce = D.base ? D.base.getRgb(f, 0) : null, le = (0, j.getTilingPatternIR)(oe.operatorListIR, oe.dict, ce);
                    X.addOp(R, le);
                    return;
                  } catch {
                  }
                const se = this.xref.fetchIfRef(te);
                if (se) {
                  const ce = se instanceof k.BaseStream ? se.dict : se, le = ce.get("PatternType");
                  if (le === N.TILING) {
                    const de = D.base ? D.base.getRgb(f, 0) : null;
                    return this.handleTilingType(R, de, Y, se, ce, X, W, ne);
                  } else if (le === N.SHADING) {
                    const de = ce.get("Shading"), Ie = ce.getArray("Matrix"), Fe = this.parseShading({
                      shading: de,
                      resources: Y,
                      localColorSpaceCache: ie,
                      localShadingPatternCache: re
                    });
                    X.addOp(R, ["Shading", Fe, Ie]);
                    return;
                  }
                  throw new n.FormatError(`Unknown PatternType: ${le}`);
                }
              }
              throw new n.FormatError(`Unknown PatternName: ${ee}`);
            }
            _parseVisibilityExpression(X, R, f) {
              if (++R > 10) {
                (0, n.warn)("Visibility expression is too deeply nested");
                return;
              }
              const z = X.length, Y = this.xref.fetchIfRef(X[0]);
              if (z < 2 || !(Y instanceof q.Name)) {
                (0, n.warn)("Invalid visibility expression");
                return;
              }
              switch (Y.name) {
                case "And":
                case "Or":
                case "Not":
                  f.push(Y.name);
                  break;
                default:
                  (0, n.warn)(`Invalid operator ${Y.name} in visibility expression`);
                  return;
              }
              for (let W = 1; W < z; W++) {
                const ie = X[W], ne = this.xref.fetchIfRef(ie);
                if (Array.isArray(ne)) {
                  const re = [];
                  f.push(re), this._parseVisibilityExpression(ne, R, re);
                } else
                  ie instanceof q.Ref && f.push(ie.toString());
              }
            }
            async parseMarkedContentProps(X, R) {
              let f;
              if (X instanceof q.Name)
                f = R.get("Properties").get(X.name);
              else if (X instanceof q.Dict)
                f = X;
              else
                throw new n.FormatError("Optional content properties malformed.");
              const D = f.get("Type").name;
              if (D === "OCG")
                return {
                  type: D,
                  id: f.objId
                };
              if (D === "OCMD") {
                const z = f.get("VE");
                if (Array.isArray(z)) {
                  const W = [];
                  if (this._parseVisibilityExpression(z, 0, W), W.length > 0)
                    return {
                      type: "OCMD",
                      expression: W
                    };
                }
                const Y = f.get("OCGs");
                if (Array.isArray(Y) || Y instanceof q.Dict) {
                  const W = [];
                  if (Array.isArray(Y))
                    for (const ie of Y)
                      W.push(ie.toString());
                  else
                    W.push(Y.objId);
                  return {
                    type: D,
                    ids: W,
                    policy: f.get("P") instanceof q.Name ? f.get("P").name : null,
                    expression: null
                  };
                } else if (Y instanceof q.Ref)
                  return {
                    type: D,
                    id: Y.toString()
                  };
              }
              return null;
            }
            getOperatorList({
              stream: X,
              task: R,
              resources: f,
              operatorList: D,
              initialState: z = null,
              fallbackFontDict: Y = null
            }) {
              if (f || (f = q.Dict.empty), z || (z = new J()), !D)
                throw new Error('getOperatorList: missing "operatorList" parameter');
              const W = this, ie = this.xref;
              let ne = !1;
              const re = new i.LocalImageCache(), ee = new i.LocalColorSpaceCache(), te = new i.LocalGStateCache(), oe = new i.LocalTilingPatternCache(), se = /* @__PURE__ */ new Map(), ce = f.get("XObject") || q.Dict.empty, le = f.get("Pattern") || q.Dict.empty, de = new _(z), Ie = new K(X, ie, de), Fe = new p();
              function we(pe) {
                for (let fe = 0, Ae = Ie.savedStatesDepth; fe < Ae; fe++)
                  D.addOp(n.OPS.restore, []);
              }
              return new Promise(function pe(fe, Ae) {
                const Pe = function(Xe) {
                  Promise.all([Xe, D.ready]).then(function() {
                    try {
                      pe(fe, Ae);
                    } catch (Qe) {
                      Ae(Qe);
                    }
                  }, Ae);
                };
                R.ensureNotTerminated(), Fe.reset();
                const Re = {};
                let Ee, ye, Te, je, ve, Ce;
                for (; !(Ee = Fe.check()) && (Re.args = null, !!Ie.read(Re)); ) {
                  let Xe = Re.args, Qe = Re.fn;
                  switch (Qe | 0) {
                    case n.OPS.paintXObject:
                      if (Ce = Xe[0] instanceof q.Name, ve = Xe[0].name, Ce) {
                        const We = re.getByName(ve);
                        if (We) {
                          D.addImageOps(We.fn, We.args, We.optionalContent), m(We), Xe = null;
                          continue;
                        }
                      }
                      Pe(new Promise(function(We, gt) {
                        if (!Ce)
                          throw new n.FormatError("XObject must be referred to by name.");
                        let mt = ce.getRaw(ve);
                        if (mt instanceof q.Ref) {
                          const Pt = re.getByRef(mt) || W._regionalImageCache.getByRef(mt);
                          if (Pt) {
                            D.addImageOps(Pt.fn, Pt.args, Pt.optionalContent), m(Pt), We();
                            return;
                          }
                          const at = W.globalImageCache.getData(mt, W.pageIndex);
                          if (at) {
                            D.addDependency(at.objId), D.addImageOps(at.fn, at.args, at.optionalContent), We();
                            return;
                          }
                          mt = ie.fetch(mt);
                        }
                        if (!(mt instanceof k.BaseStream))
                          throw new n.FormatError("XObject should be a stream");
                        const Ct = mt.dict.get("Subtype");
                        if (!(Ct instanceof q.Name))
                          throw new n.FormatError("XObject should have a Name subtype");
                        if (Ct.name === "Form") {
                          de.save(), W.buildFormXObject(f, mt, null, D, R, de.state.clone(), ee).then(function() {
                            de.restore(), We();
                          }, gt);
                          return;
                        } else if (Ct.name === "Image") {
                          W.buildPaintImageXObject({
                            resources: f,
                            image: mt,
                            operatorList: D,
                            cacheKey: ve,
                            localImageCache: re,
                            localColorSpaceCache: ee
                          }).then(We, gt);
                          return;
                        } else if (Ct.name === "PS")
                          (0, n.info)("Ignored XObject subtype PS");
                        else
                          throw new n.FormatError(`Unhandled XObject subtype ${Ct.name}`);
                        We();
                      }).catch(function(We) {
                        if (!(We instanceof n.AbortException)) {
                          if (W.options.ignoreErrors) {
                            (0, n.warn)(`getOperatorList - ignoring XObject: "${We}".`);
                            return;
                          }
                          throw We;
                        }
                      }));
                      return;
                    case n.OPS.setFont:
                      var Ne = Xe[1];
                      Pe(W.handleSetFont(f, Xe, null, D, R, de.state, Y).then(function(We) {
                        D.addDependency(We), D.addOp(n.OPS.setFont, [We, Ne]);
                      }));
                      return;
                    case n.OPS.beginText:
                      ne = !0;
                      break;
                    case n.OPS.endText:
                      ne = !1;
                      break;
                    case n.OPS.endInlineImage:
                      var Ge = Xe[0].cacheKey;
                      if (Ge) {
                        const We = re.getByName(Ge);
                        if (We) {
                          D.addImageOps(We.fn, We.args, We.optionalContent), m(We), Xe = null;
                          continue;
                        }
                      }
                      Pe(W.buildPaintImageXObject({
                        resources: f,
                        image: Xe[0],
                        isInline: !0,
                        operatorList: D,
                        cacheKey: Ge,
                        localImageCache: re,
                        localColorSpaceCache: ee
                      }));
                      return;
                    case n.OPS.showText:
                      if (!de.state.font) {
                        W.ensureStateFont(de.state);
                        continue;
                      }
                      Xe[0] = W.handleText(Xe[0], de.state);
                      break;
                    case n.OPS.showSpacedText:
                      if (!de.state.font) {
                        W.ensureStateFont(de.state);
                        continue;
                      }
                      var Oe = [], tt = de.state;
                      for (const We of Xe[0])
                        typeof We == "string" ? Oe.push(...W.handleText(We, tt)) : typeof We == "number" && Oe.push(We);
                      Xe[0] = Oe, Qe = n.OPS.showText;
                      break;
                    case n.OPS.nextLineShowText:
                      if (!de.state.font) {
                        W.ensureStateFont(de.state);
                        continue;
                      }
                      D.addOp(n.OPS.nextLine), Xe[0] = W.handleText(Xe[0], de.state), Qe = n.OPS.showText;
                      break;
                    case n.OPS.nextLineSetSpacingShowText:
                      if (!de.state.font) {
                        W.ensureStateFont(de.state);
                        continue;
                      }
                      D.addOp(n.OPS.nextLine), D.addOp(n.OPS.setWordSpacing, [Xe.shift()]), D.addOp(n.OPS.setCharSpacing, [Xe.shift()]), Xe[0] = W.handleText(Xe[0], de.state), Qe = n.OPS.showText;
                      break;
                    case n.OPS.setTextRenderingMode:
                      de.state.textRenderingMode = Xe[0];
                      break;
                    case n.OPS.setFillColorSpace: {
                      const We = l.ColorSpace.getCached(Xe[0], ie, ee);
                      if (We) {
                        de.state.fillColorSpace = We;
                        continue;
                      }
                      Pe(W.parseColorSpace({
                        cs: Xe[0],
                        resources: f,
                        localColorSpaceCache: ee
                      }).then(function(gt) {
                        gt && (de.state.fillColorSpace = gt);
                      }));
                      return;
                    }
                    case n.OPS.setStrokeColorSpace: {
                      const We = l.ColorSpace.getCached(Xe[0], ie, ee);
                      if (We) {
                        de.state.strokeColorSpace = We;
                        continue;
                      }
                      Pe(W.parseColorSpace({
                        cs: Xe[0],
                        resources: f,
                        localColorSpaceCache: ee
                      }).then(function(gt) {
                        gt && (de.state.strokeColorSpace = gt);
                      }));
                      return;
                    }
                    case n.OPS.setFillColor:
                      je = de.state.fillColorSpace, Xe = je.getRgb(Xe, 0), Qe = n.OPS.setFillRGBColor;
                      break;
                    case n.OPS.setStrokeColor:
                      je = de.state.strokeColorSpace, Xe = je.getRgb(Xe, 0), Qe = n.OPS.setStrokeRGBColor;
                      break;
                    case n.OPS.setFillGray:
                      de.state.fillColorSpace = l.ColorSpace.singletons.gray, Xe = l.ColorSpace.singletons.gray.getRgb(Xe, 0), Qe = n.OPS.setFillRGBColor;
                      break;
                    case n.OPS.setStrokeGray:
                      de.state.strokeColorSpace = l.ColorSpace.singletons.gray, Xe = l.ColorSpace.singletons.gray.getRgb(Xe, 0), Qe = n.OPS.setStrokeRGBColor;
                      break;
                    case n.OPS.setFillCMYKColor:
                      de.state.fillColorSpace = l.ColorSpace.singletons.cmyk, Xe = l.ColorSpace.singletons.cmyk.getRgb(Xe, 0), Qe = n.OPS.setFillRGBColor;
                      break;
                    case n.OPS.setStrokeCMYKColor:
                      de.state.strokeColorSpace = l.ColorSpace.singletons.cmyk, Xe = l.ColorSpace.singletons.cmyk.getRgb(Xe, 0), Qe = n.OPS.setStrokeRGBColor;
                      break;
                    case n.OPS.setFillRGBColor:
                      de.state.fillColorSpace = l.ColorSpace.singletons.rgb, Xe = l.ColorSpace.singletons.rgb.getRgb(Xe, 0);
                      break;
                    case n.OPS.setStrokeRGBColor:
                      de.state.strokeColorSpace = l.ColorSpace.singletons.rgb, Xe = l.ColorSpace.singletons.rgb.getRgb(Xe, 0);
                      break;
                    case n.OPS.setFillColorN:
                      if (je = de.state.fillColorSpace, je.name === "Pattern") {
                        Pe(W.handleColorN(D, n.OPS.setFillColorN, Xe, je, le, f, R, ee, oe, se));
                        return;
                      }
                      Xe = je.getRgb(Xe, 0), Qe = n.OPS.setFillRGBColor;
                      break;
                    case n.OPS.setStrokeColorN:
                      if (je = de.state.strokeColorSpace, je.name === "Pattern") {
                        Pe(W.handleColorN(D, n.OPS.setStrokeColorN, Xe, je, le, f, R, ee, oe, se));
                        return;
                      }
                      Xe = je.getRgb(Xe, 0), Qe = n.OPS.setStrokeRGBColor;
                      break;
                    case n.OPS.shadingFill:
                      var Ke = f.get("Shading");
                      if (!Ke)
                        throw new n.FormatError("No shading resource found");
                      var et = Ke.get(Xe[0].name);
                      if (!et)
                        throw new n.FormatError("No shading object found");
                      Xe = [W.parseShading({
                        shading: et,
                        resources: f,
                        localColorSpaceCache: ee,
                        localShadingPatternCache: se
                      })], Qe = n.OPS.shadingFill;
                      break;
                    case n.OPS.setGState:
                      if (Ce = Xe[0] instanceof q.Name, ve = Xe[0].name, Ce) {
                        const We = te.getByName(ve);
                        if (We) {
                          We.length > 0 && D.addOp(n.OPS.setGState, [We]), Xe = null;
                          continue;
                        }
                      }
                      Pe(new Promise(function(We, gt) {
                        if (!Ce)
                          throw new n.FormatError("GState must be referred to by name.");
                        const mt = f.get("ExtGState");
                        if (!(mt instanceof q.Dict))
                          throw new n.FormatError("ExtGState should be a dictionary.");
                        const Ct = mt.get(ve);
                        if (!(Ct instanceof q.Dict))
                          throw new n.FormatError("GState should be a dictionary.");
                        W.setGState({
                          resources: f,
                          gState: Ct,
                          operatorList: D,
                          cacheKey: ve,
                          task: R,
                          stateManager: de,
                          localGStateCache: te,
                          localColorSpaceCache: ee
                        }).then(We, gt);
                      }).catch(function(We) {
                        if (!(We instanceof n.AbortException)) {
                          if (W.options.ignoreErrors) {
                            (0, n.warn)(`getOperatorList - ignoring ExtGState: "${We}".`);
                            return;
                          }
                          throw We;
                        }
                      }));
                      return;
                    case n.OPS.moveTo:
                    case n.OPS.lineTo:
                    case n.OPS.curveTo:
                    case n.OPS.curveTo2:
                    case n.OPS.curveTo3:
                    case n.OPS.closePath:
                    case n.OPS.rectangle:
                      W.buildPath(D, Qe, Xe, ne);
                      continue;
                    case n.OPS.markPoint:
                    case n.OPS.markPointProps:
                    case n.OPS.beginCompat:
                    case n.OPS.endCompat:
                      continue;
                    case n.OPS.beginMarkedContentProps:
                      if (!(Xe[0] instanceof q.Name)) {
                        (0, n.warn)(`Expected name for beginMarkedContentProps arg0=${Xe[0]}`);
                        continue;
                      }
                      if (Xe[0].name === "OC") {
                        Pe(W.parseMarkedContentProps(Xe[1], f).then((We) => {
                          D.addOp(n.OPS.beginMarkedContentProps, ["OC", We]);
                        }).catch((We) => {
                          if (!(We instanceof n.AbortException)) {
                            if (W.options.ignoreErrors) {
                              (0, n.warn)(`getOperatorList - ignoring beginMarkedContentProps: "${We}".`);
                              return;
                            }
                            throw We;
                          }
                        }));
                        return;
                      }
                      Xe = [Xe[0].name, Xe[1] instanceof q.Dict ? Xe[1].get("MCID") : null];
                      break;
                    case n.OPS.beginMarkedContent:
                    case n.OPS.endMarkedContent:
                    default:
                      if (Xe !== null) {
                        for (ye = 0, Te = Xe.length; ye < Te && !(Xe[ye] instanceof q.Dict); ye++)
                          ;
                        if (ye < Te) {
                          (0, n.warn)("getOperatorList - ignoring operator: " + Qe);
                          continue;
                        }
                      }
                  }
                  D.addOp(Qe, Xe);
                }
                if (Ee) {
                  Pe(H);
                  return;
                }
                we(), fe();
              }).catch((pe) => {
                if (!(pe instanceof n.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, n.warn)(`getOperatorList - ignoring errors during "${R.name}" task: "${pe}".`), we();
                    return;
                  }
                  throw pe;
                }
              });
            }
            getTextContent({
              stream: X,
              task: R,
              resources: f,
              stateManager: D = null,
              includeMarkedContent: z = !1,
              sink: Y,
              seenStyles: W = /* @__PURE__ */ new Set(),
              viewBox: ie,
              markedContentData: ne = null,
              disableNormalization: re = !1
            }) {
              f || (f = q.Dict.empty), D || (D = new _(new G())), z && (ne || (ne = {
                level: 0
              }));
              const ee = {
                items: [],
                styles: /* @__PURE__ */ Object.create(null)
              }, te = {
                initialized: !1,
                str: [],
                totalWidth: 0,
                totalHeight: 0,
                width: 0,
                height: 0,
                vertical: !1,
                prevTransform: null,
                textAdvanceScale: 0,
                spaceInFlowMin: 0,
                spaceInFlowMax: 0,
                trackingSpaceMin: 1 / 0,
                negativeSpaceMax: -1 / 0,
                notASpace: -1 / 0,
                transform: null,
                fontName: null,
                hasEOL: !1
              }, oe = [" ", " "];
              let se = 0;
              function ce(at) {
                const dt = (se + 1) % 2, ot = oe[se] !== " " && oe[dt] === " ";
                return oe[se] = at, se = dt, ot;
              }
              function le() {
                return oe[se] !== " " && oe[(se + 1) % 2] === " ";
              }
              function de() {
                oe[0] = oe[1] = " ", se = 0;
              }
              const Ie = 0.102, Fe = 0.03, we = -0.2, pe = 0.102, fe = 0.6, Ae = 0.25, Pe = this, Re = this.xref, Ee = [];
              let ye = null;
              const Te = new i.LocalImageCache(), je = new i.LocalGStateCache(), ve = new K(X, Re, D);
              let Ce;
              function Ne({
                width: at = 0,
                height: dt = 0,
                transform: ot = te.prevTransform,
                fontName: Mt = te.fontName
              }) {
                ee.items.push({
                  str: " ",
                  dir: "ltr",
                  width: at,
                  height: dt,
                  transform: ot,
                  fontName: Mt,
                  hasEOL: !1
                });
              }
              function Ge() {
                const at = Ce.font, dt = [Ce.fontSize * Ce.textHScale, 0, 0, Ce.fontSize, 0, Ce.textRise];
                if (at.isType3Font && (Ce.fontSize <= 1 || at.isCharBBox) && !(0, n.isArrayEqual)(Ce.fontMatrix, n.FONT_IDENTITY_MATRIX)) {
                  const ot = at.bbox[3] - at.bbox[1];
                  ot > 0 && (dt[3] *= ot * Ce.fontMatrix[3]);
                }
                return n.Util.transform(Ce.ctm, n.Util.transform(Ce.textMatrix, dt));
              }
              function Oe() {
                if (te.initialized)
                  return te;
                const {
                  font: at,
                  loadedName: dt
                } = Ce;
                W.has(dt) || (W.add(dt), ee.styles[dt] = {
                  fontFamily: at.fallbackName,
                  ascent: at.ascent,
                  descent: at.descent,
                  vertical: at.vertical
                }), te.fontName = dt;
                const ot = te.transform = Ge();
                at.vertical ? (te.width = te.totalWidth = Math.hypot(ot[0], ot[1]), te.height = te.totalHeight = 0, te.vertical = !0) : (te.width = te.totalWidth = 0, te.height = te.totalHeight = Math.hypot(ot[2], ot[3]), te.vertical = !1);
                const Mt = Math.hypot(Ce.textLineMatrix[0], Ce.textLineMatrix[1]), Rt = Math.hypot(Ce.ctm[0], Ce.ctm[1]);
                te.textAdvanceScale = Rt * Mt;
                const {
                  fontSize: Et
                } = Ce;
                return te.trackingSpaceMin = Et * Ie, te.notASpace = Et * Fe, te.negativeSpaceMax = Et * we, te.spaceInFlowMin = Et * pe, te.spaceInFlowMax = Et * fe, te.hasEOL = !1, te.initialized = !0, te;
              }
              function tt() {
                if (!te.initialized)
                  return;
                const at = Math.hypot(Ce.textLineMatrix[0], Ce.textLineMatrix[1]), ot = Math.hypot(Ce.ctm[0], Ce.ctm[1]) * at;
                ot !== te.textAdvanceScale && (te.vertical ? (te.totalHeight += te.height * te.textAdvanceScale, te.height = 0) : (te.totalWidth += te.width * te.textAdvanceScale, te.width = 0), te.textAdvanceScale = ot);
              }
              function Ke(at) {
                let dt = at.str.join("");
                re || (dt = (0, n.normalizeUnicode)(dt));
                const ot = (0, s.bidi)(dt, -1, at.vertical);
                return {
                  str: ot.str,
                  dir: ot.dir,
                  width: Math.abs(at.totalWidth),
                  height: Math.abs(at.totalHeight),
                  transform: at.transform,
                  fontName: at.fontName,
                  hasEOL: at.hasEOL
                };
              }
              function et(at, dt) {
                return Pe.loadFont(at, dt, f).then(function(ot) {
                  return ot.font.isType3Font ? ot.loadType3Data(Pe, f, R).catch(function() {
                  }).then(function() {
                    return ot;
                  }) : ot;
                }).then(function(ot) {
                  Ce.loadedName = ot.loadedName, Ce.font = ot.font, Ce.fontMatrix = ot.font.fontMatrix || n.FONT_IDENTITY_MATRIX;
                });
              }
              function Xe(at, dt, ot) {
                const Mt = Math.hypot(ot[0], ot[1]);
                return [(ot[0] * at + ot[1] * dt) / Mt, (ot[2] * at + ot[3] * dt) / Mt];
              }
              function Qe(at) {
                var Je;
                const dt = Ge();
                let ot = dt[4], Mt = dt[5];
                if ((Je = Ce.font) != null && Je.vertical) {
                  if (ot < ie[0] || ot > ie[2] || Mt + at < ie[1] || Mt > ie[3])
                    return !1;
                } else if (ot + at < ie[0] || ot > ie[2] || Mt < ie[1] || Mt > ie[3])
                  return !1;
                if (!Ce.font || !te.prevTransform)
                  return !0;
                let Rt = te.prevTransform[4], Et = te.prevTransform[5];
                if (Rt === ot && Et === Mt)
                  return !0;
                let At = -1;
                switch (dt[0] && dt[1] === 0 && dt[2] === 0 ? At = dt[0] > 0 ? 0 : 180 : dt[1] && dt[0] === 0 && dt[3] === 0 && (At = dt[1] > 0 ? 90 : 270), At) {
                  case 0:
                    break;
                  case 90:
                    [ot, Mt] = [Mt, ot], [Rt, Et] = [Et, Rt];
                    break;
                  case 180:
                    [ot, Mt, Rt, Et] = [-ot, -Mt, -Rt, -Et];
                    break;
                  case 270:
                    [ot, Mt] = [-Mt, -ot], [Rt, Et] = [-Et, -Rt];
                    break;
                  default:
                    [ot, Mt] = Xe(ot, Mt, dt), [Rt, Et] = Xe(Rt, Et, te.prevTransform);
                }
                if (Ce.font.vertical) {
                  const Ve = (Et - Mt) / te.textAdvanceScale, st = ot - Rt, ft = Math.sign(te.height);
                  return Ve < ft * te.negativeSpaceMax ? Math.abs(st) > 0.5 * te.width ? (We(), !0) : (de(), mt(), !0) : Math.abs(st) > te.width ? (We(), !0) : (Ve <= ft * te.notASpace && de(), Ve <= ft * te.trackingSpaceMin ? le() ? (de(), mt(), Ne({
                    height: Math.abs(Ve)
                  })) : te.height += Ve : gt(Ve, te.prevTransform, ft) || (te.str.length === 0 ? (de(), Ne({
                    height: Math.abs(Ve)
                  })) : te.height += Ve), Math.abs(st) > te.width * Ae && mt(), !0);
                }
                const Nt = (ot - Rt) / te.textAdvanceScale, qe = Mt - Et, Ue = Math.sign(te.width);
                return Nt < Ue * te.negativeSpaceMax ? Math.abs(qe) > 0.5 * te.height ? (We(), !0) : (de(), mt(), !0) : Math.abs(qe) > te.height ? (We(), !0) : (Nt <= Ue * te.notASpace && de(), Nt <= Ue * te.trackingSpaceMin ? le() ? (de(), mt(), Ne({
                  width: Math.abs(Nt)
                })) : te.width += Nt : gt(Nt, te.prevTransform, Ue) || (te.str.length === 0 ? (de(), Ne({
                  width: Math.abs(Nt)
                })) : te.width += Nt), Math.abs(qe) > te.height * Ae && mt(), !0);
              }
              function it({
                chars: at,
                extraSpacing: dt
              }) {
                const ot = Ce.font;
                if (!at) {
                  const Et = Ce.charSpacing + dt;
                  Et && (ot.vertical ? Ce.translateTextMatrix(0, -Et) : Ce.translateTextMatrix(Et * Ce.textHScale, 0));
                  return;
                }
                const Mt = ot.charsToGlyphs(at), Rt = Ce.fontMatrix[0] * Ce.fontSize;
                for (let Et = 0, At = Mt.length; Et < At; Et++) {
                  const Nt = Mt[Et], {
                    category: qe
                  } = Nt;
                  if (qe.isInvisibleFormatMark)
                    continue;
                  let Ue = Ce.charSpacing + (Et + 1 === At ? dt : 0), Je = Nt.width;
                  ot.vertical && (Je = Nt.vmetric ? Nt.vmetric[0] : -Je);
                  let Ve = Je * Rt;
                  if (qe.isWhitespace) {
                    ot.vertical ? (Ue += -Ve + Ce.wordSpacing, Ce.translateTextMatrix(0, -Ue)) : (Ue += Ve + Ce.wordSpacing, Ce.translateTextMatrix(Ue * Ce.textHScale, 0)), ce(" ");
                    continue;
                  }
                  if (!qe.isZeroWidthDiacritic && !Qe(Ve)) {
                    ot.vertical ? Ce.translateTextMatrix(0, Ve) : Ce.translateTextMatrix(Ve * Ce.textHScale, 0);
                    continue;
                  }
                  const st = Oe();
                  qe.isZeroWidthDiacritic && (Ve = 0), ot.vertical ? (Ce.translateTextMatrix(0, Ve), Ve = Math.abs(Ve), st.height += Ve) : (Ve *= Ce.textHScale, Ce.translateTextMatrix(Ve, 0), st.width += Ve), Ve && (st.prevTransform = Ge());
                  const ft = Nt.unicode;
                  ce(ft) && st.str.push(" "), st.str.push(ft), Ue && (ot.vertical ? Ce.translateTextMatrix(0, -Ue) : Ce.translateTextMatrix(Ue * Ce.textHScale, 0));
                }
              }
              function We() {
                de(), te.initialized ? (te.hasEOL = !0, mt()) : ee.items.push({
                  str: "",
                  dir: "ltr",
                  width: 0,
                  height: 0,
                  transform: Ge(),
                  fontName: Ce.loadedName,
                  hasEOL: !0
                });
              }
              function gt(at, dt, ot) {
                if (ot * te.spaceInFlowMin <= at && at <= ot * te.spaceInFlowMax)
                  return te.initialized && (de(), te.str.push(" ")), !1;
                const Mt = te.fontName;
                let Rt = 0;
                return te.vertical && (Rt = at, at = 0), mt(), de(), Ne({
                  width: Math.abs(at),
                  height: Math.abs(Rt),
                  transform: dt || Ge(),
                  fontName: Mt
                }), !0;
              }
              function mt() {
                !te.initialized || !te.str || (te.vertical ? te.totalHeight += te.height * te.textAdvanceScale : te.totalWidth += te.width * te.textAdvanceScale, ee.items.push(Ke(te)), te.initialized = !1, te.str.length = 0);
              }
              function Ct(at = !1) {
                const dt = ee.items.length;
                dt !== 0 && (at && dt < E || (Y.enqueue(ee, dt), ee.items = [], ee.styles = /* @__PURE__ */ Object.create(null)));
              }
              const Pt = new p();
              return new Promise(function at(dt, ot) {
                const Mt = function(Ve) {
                  Ct(!0), Promise.all([Ve, Y.ready]).then(function() {
                    try {
                      at(dt, ot);
                    } catch (st) {
                      ot(st);
                    }
                  }, ot);
                };
                R.ensureNotTerminated(), Pt.reset();
                const Rt = {};
                let Et, At = [];
                for (; !(Et = Pt.check()) && (At.length = 0, Rt.args = At, !!ve.read(Rt)); ) {
                  const Ve = Ce;
                  Ce = D.state;
                  const st = Rt.fn;
                  switch (At = Rt.args, st | 0) {
                    case n.OPS.setFont:
                      var Nt = At[0].name, qe = At[1];
                      if (Ce.font && Nt === Ce.fontName && qe === Ce.fontSize)
                        break;
                      mt(), Ce.fontName = Nt, Ce.fontSize = qe, Mt(et(Nt, null));
                      return;
                    case n.OPS.setTextRise:
                      Ce.textRise = At[0];
                      break;
                    case n.OPS.setHScale:
                      Ce.textHScale = At[0] / 100;
                      break;
                    case n.OPS.setLeading:
                      Ce.leading = At[0];
                      break;
                    case n.OPS.moveText:
                      Ce.translateTextLineMatrix(At[0], At[1]), Ce.textMatrix = Ce.textLineMatrix.slice();
                      break;
                    case n.OPS.setLeadingMoveText:
                      Ce.leading = -At[1], Ce.translateTextLineMatrix(At[0], At[1]), Ce.textMatrix = Ce.textLineMatrix.slice();
                      break;
                    case n.OPS.nextLine:
                      Ce.carriageReturn();
                      break;
                    case n.OPS.setTextMatrix:
                      Ce.setTextMatrix(At[0], At[1], At[2], At[3], At[4], At[5]), Ce.setTextLineMatrix(At[0], At[1], At[2], At[3], At[4], At[5]), tt();
                      break;
                    case n.OPS.setCharSpacing:
                      Ce.charSpacing = At[0];
                      break;
                    case n.OPS.setWordSpacing:
                      Ce.wordSpacing = At[0];
                      break;
                    case n.OPS.beginText:
                      Ce.textMatrix = n.IDENTITY_MATRIX.slice(), Ce.textLineMatrix = n.IDENTITY_MATRIX.slice();
                      break;
                    case n.OPS.showSpacedText:
                      if (!D.state.font) {
                        Pe.ensureStateFont(D.state);
                        continue;
                      }
                      const ft = (Ce.font.vertical ? 1 : -1) * Ce.fontSize / 1e3, ct = At[0];
                      for (let be = 0, _e = ct.length; be < _e; be++) {
                        const $e = ct[be];
                        if (typeof $e == "string")
                          Ee.push($e);
                        else if (typeof $e == "number" && $e !== 0) {
                          const Ze = Ee.join("");
                          Ee.length = 0, it({
                            chars: Ze,
                            extraSpacing: $e * ft
                          });
                        }
                      }
                      if (Ee.length > 0) {
                        const be = Ee.join("");
                        Ee.length = 0, it({
                          chars: be,
                          extraSpacing: 0
                        });
                      }
                      break;
                    case n.OPS.showText:
                      if (!D.state.font) {
                        Pe.ensureStateFont(D.state);
                        continue;
                      }
                      it({
                        chars: At[0],
                        extraSpacing: 0
                      });
                      break;
                    case n.OPS.nextLineShowText:
                      if (!D.state.font) {
                        Pe.ensureStateFont(D.state);
                        continue;
                      }
                      Ce.carriageReturn(), it({
                        chars: At[0],
                        extraSpacing: 0
                      });
                      break;
                    case n.OPS.nextLineSetSpacingShowText:
                      if (!D.state.font) {
                        Pe.ensureStateFont(D.state);
                        continue;
                      }
                      Ce.wordSpacing = At[0], Ce.charSpacing = At[1], Ce.carriageReturn(), it({
                        chars: At[2],
                        extraSpacing: 0
                      });
                      break;
                    case n.OPS.paintXObject:
                      mt(), ye || (ye = f.get("XObject") || q.Dict.empty);
                      var Ue = At[0] instanceof q.Name, Je = At[0].name;
                      if (Ue && Te.getByName(Je))
                        break;
                      Mt(new Promise(function(be, _e) {
                        if (!Ue)
                          throw new n.FormatError("XObject must be referred to by name.");
                        let $e = ye.getRaw(Je);
                        if ($e instanceof q.Ref) {
                          if (Te.getByRef($e)) {
                            be();
                            return;
                          }
                          if (Pe.globalImageCache.getData($e, Pe.pageIndex)) {
                            be();
                            return;
                          }
                          $e = Re.fetch($e);
                        }
                        if (!($e instanceof k.BaseStream))
                          throw new n.FormatError("XObject should be a stream");
                        const Ze = $e.dict.get("Subtype");
                        if (!(Ze instanceof q.Name))
                          throw new n.FormatError("XObject should have a Name subtype");
                        if (Ze.name !== "Form") {
                          Te.set(Je, $e.dict.objId, !0), be();
                          return;
                        }
                        const nt = D.state.clone(), pt = new _(nt), yt = $e.dict.getArray("Matrix");
                        Array.isArray(yt) && yt.length === 6 && pt.transform(yt), Ct();
                        const lt = {
                          enqueueInvoked: !1,
                          enqueue(St, ht) {
                            this.enqueueInvoked = !0, Y.enqueue(St, ht);
                          },
                          get desiredSize() {
                            return Y.desiredSize;
                          },
                          get ready() {
                            return Y.ready;
                          }
                        };
                        Pe.getTextContent({
                          stream: $e,
                          task: R,
                          resources: $e.dict.get("Resources") || f,
                          stateManager: pt,
                          includeMarkedContent: z,
                          sink: lt,
                          seenStyles: W,
                          viewBox: ie,
                          markedContentData: ne,
                          disableNormalization: re
                        }).then(function() {
                          lt.enqueueInvoked || Te.set(Je, $e.dict.objId, !0), be();
                        }, _e);
                      }).catch(function(be) {
                        if (!(be instanceof n.AbortException)) {
                          if (Pe.options.ignoreErrors) {
                            (0, n.warn)(`getTextContent - ignoring XObject: "${be}".`);
                            return;
                          }
                          throw be;
                        }
                      }));
                      return;
                    case n.OPS.setGState:
                      if (Ue = At[0] instanceof q.Name, Je = At[0].name, Ue && je.getByName(Je))
                        break;
                      Mt(new Promise(function(be, _e) {
                        if (!Ue)
                          throw new n.FormatError("GState must be referred to by name.");
                        const $e = f.get("ExtGState");
                        if (!($e instanceof q.Dict))
                          throw new n.FormatError("ExtGState should be a dictionary.");
                        const Ze = $e.get(Je);
                        if (!(Ze instanceof q.Dict))
                          throw new n.FormatError("GState should be a dictionary.");
                        const nt = Ze.get("Font");
                        if (!nt) {
                          je.set(Je, Ze.objId, !0), be();
                          return;
                        }
                        mt(), Ce.fontName = null, Ce.fontSize = nt[1], et(null, nt[0]).then(be, _e);
                      }).catch(function(be) {
                        if (!(be instanceof n.AbortException)) {
                          if (Pe.options.ignoreErrors) {
                            (0, n.warn)(`getTextContent - ignoring ExtGState: "${be}".`);
                            return;
                          }
                          throw be;
                        }
                      }));
                      return;
                    case n.OPS.beginMarkedContent:
                      mt(), z && (ne.level++, ee.items.push({
                        type: "beginMarkedContent",
                        tag: At[0] instanceof q.Name ? At[0].name : null
                      }));
                      break;
                    case n.OPS.beginMarkedContentProps:
                      if (mt(), z) {
                        ne.level++;
                        let be = null;
                        At[1] instanceof q.Dict && (be = At[1].get("MCID")), ee.items.push({
                          type: "beginMarkedContentProps",
                          id: Number.isInteger(be) ? `${Pe.idFactory.getPageObjId()}_mc${be}` : null,
                          tag: At[0] instanceof q.Name ? At[0].name : null
                        });
                      }
                      break;
                    case n.OPS.endMarkedContent:
                      if (mt(), z) {
                        if (ne.level === 0)
                          break;
                        ne.level--, ee.items.push({
                          type: "endMarkedContent"
                        });
                      }
                      break;
                    case n.OPS.restore:
                      Ve && (Ve.font !== Ce.font || Ve.fontSize !== Ce.fontSize || Ve.fontName !== Ce.fontName) && mt();
                      break;
                  }
                  if (ee.items.length >= Y.desiredSize) {
                    Et = !0;
                    break;
                  }
                }
                if (Et) {
                  Mt(H);
                  return;
                }
                mt(), Ct(), dt();
              }).catch((at) => {
                if (!(at instanceof n.AbortException)) {
                  if (this.options.ignoreErrors) {
                    (0, n.warn)(`getTextContent - ignoring errors during "${R.name}" task: "${at}".`), mt(), Ct();
                    return;
                  }
                  throw at;
                }
              });
            }
            extractDataStructures(X, R, f) {
              const D = this.xref;
              let z;
              const Y = this.readToUnicode(f.toUnicode || X.get("ToUnicode") || R.get("ToUnicode"));
              if (f.composite) {
                const ee = X.get("CIDSystemInfo");
                ee instanceof q.Dict && (f.cidSystemInfo = {
                  registry: (0, n.stringToPDFString)(ee.get("Registry")),
                  ordering: (0, n.stringToPDFString)(ee.get("Ordering")),
                  supplement: ee.get("Supplement")
                });
                try {
                  const te = X.get("CIDToGIDMap");
                  te instanceof k.BaseStream && (z = te.getBytes());
                } catch (te) {
                  if (!this.options.ignoreErrors)
                    throw te;
                  (0, n.warn)(`extractDataStructures - ignoring CIDToGIDMap data: "${te}".`);
                }
              }
              const W = [];
              let ie = null, ne;
              if (X.has("Encoding")) {
                if (ne = X.get("Encoding"), ne instanceof q.Dict) {
                  if (ie = ne.get("BaseEncoding"), ie = ie instanceof q.Name ? ie.name : null, ne.has("Differences")) {
                    const ee = ne.get("Differences");
                    let te = 0;
                    for (const oe of ee) {
                      const se = D.fetchIfRef(oe);
                      if (typeof se == "number")
                        te = se;
                      else if (se instanceof q.Name)
                        W[te++] = se.name;
                      else
                        throw new n.FormatError(`Invalid entry in 'Differences' array: ${se}`);
                    }
                  }
                } else if (ne instanceof q.Name)
                  ie = ne.name;
                else {
                  const ee = "Encoding is not a Name nor a Dict";
                  if (!this.options.ignoreErrors)
                    throw new n.FormatError(ee);
                  (0, n.warn)(ee);
                }
                ie !== "MacRomanEncoding" && ie !== "MacExpertEncoding" && ie !== "WinAnsiEncoding" && (ie = null);
              }
              const re = !f.file || f.isInternalFont;
              if (ie && re && (0, B.getSymbolsFonts)()[f.name] && (ie = null), ie)
                f.defaultEncoding = (0, t.getEncoding)(ie);
              else {
                const ee = !!(f.flags & v.FontFlags.Symbolic), te = !!(f.flags & v.FontFlags.Nonsymbolic);
                ne = t.StandardEncoding, f.type === "TrueType" && !te && (ne = t.WinAnsiEncoding), ee && (ne = t.MacRomanEncoding, re && (/Symbol/i.test(f.name) ? ne = t.SymbolSetEncoding : /Dingbats/i.test(f.name) ? ne = t.ZapfDingbatsEncoding : /Wingdings/i.test(f.name) && (ne = t.WinAnsiEncoding))), f.defaultEncoding = ne;
              }
              return f.differences = W, f.baseEncodingName = ie, f.hasEncoding = !!ie || W.length > 0, f.dict = X, Y.then((ee) => (f.toUnicode = ee, this.buildToUnicode(f))).then((ee) => (f.toUnicode = ee, z && (f.cidToGidMap = this.readCidToGidMap(z, ee)), f));
            }
            _simpleFontToUnicode(X, R = !1) {
              (0, n.assert)(!X.composite, "Must be a simple font.");
              const f = [], D = X.defaultEncoding.slice(), z = X.baseEncodingName, Y = X.differences;
              for (const ie in Y) {
                const ne = Y[ie];
                ne !== ".notdef" && (D[ie] = ne);
              }
              const W = (0, x.getGlyphsUnicode)();
              for (const ie in D) {
                let ne = D[ie];
                if (ne === "")
                  continue;
                let re = W[ne];
                if (re !== void 0) {
                  f[ie] = String.fromCharCode(re);
                  continue;
                }
                let ee = 0;
                switch (ne[0]) {
                  case "G":
                    ne.length === 3 && (ee = parseInt(ne.substring(1), 16));
                    break;
                  case "g":
                    ne.length === 5 && (ee = parseInt(ne.substring(1), 16));
                    break;
                  case "C":
                  case "c":
                    if (ne.length >= 3 && ne.length <= 4) {
                      const te = ne.substring(1);
                      if (R) {
                        ee = parseInt(te, 16);
                        break;
                      }
                      if (ee = +te, Number.isNaN(ee) && Number.isInteger(parseInt(te, 16)))
                        return this._simpleFontToUnicode(X, !0);
                    }
                    break;
                  case "u":
                    re = (0, h.getUnicodeForGlyph)(ne, W), re !== -1 && (ee = re);
                    break;
                  default:
                    switch (ne) {
                      case "f_h":
                      case "f_t":
                      case "T_h":
                        f[ie] = ne.replaceAll("_", "");
                        continue;
                    }
                    break;
                }
                if (ee > 0 && ee <= 1114111 && Number.isInteger(ee)) {
                  if (z && ee === +ie) {
                    const te = (0, t.getEncoding)(z);
                    if (te && (ne = te[ie])) {
                      f[ie] = String.fromCharCode(W[ne]);
                      continue;
                    }
                  }
                  f[ie] = String.fromCodePoint(ee);
                }
              }
              return f;
            }
            async buildToUnicode(X) {
              var R;
              if (X.hasIncludedToUnicodeMap = ((R = X.toUnicode) == null ? void 0 : R.length) > 0, X.hasIncludedToUnicodeMap)
                return !X.composite && X.hasEncoding && (X.fallbackToUnicode = this._simpleFontToUnicode(X)), X.toUnicode;
              if (!X.composite)
                return new O.ToUnicodeMap(this._simpleFontToUnicode(X));
              if (X.composite && (X.cMap.builtInCMap && !(X.cMap instanceof u.IdentityCMap) || X.cidSystemInfo.registry === "Adobe" && (X.cidSystemInfo.ordering === "GB1" || X.cidSystemInfo.ordering === "CNS1" || X.cidSystemInfo.ordering === "Japan1" || X.cidSystemInfo.ordering === "Korea1"))) {
                const {
                  registry: f,
                  ordering: D
                } = X.cidSystemInfo, z = q.Name.get(`${f}-${D}-UCS2`), Y = await u.CMapFactory.create({
                  encoding: z,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                }), W = [], ie = [];
                return X.cMap.forEach(function(ne, re) {
                  if (re > 65535)
                    throw new n.FormatError("Max size of CID is 65,535");
                  const ee = Y.lookup(re);
                  if (ee) {
                    ie.length = 0;
                    for (let te = 0, oe = ee.length; te < oe; te += 2)
                      ie.push((ee.charCodeAt(te) << 8) + ee.charCodeAt(te + 1));
                    W[ne] = String.fromCharCode(...ie);
                  }
                }), new O.ToUnicodeMap(W);
              }
              return new O.IdentityToUnicodeMap(X.firstChar, X.lastChar);
            }
            readToUnicode(X) {
              return X ? X instanceof q.Name ? u.CMapFactory.create({
                encoding: X,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              }).then(function(R) {
                return R instanceof u.IdentityCMap ? new O.IdentityToUnicodeMap(0, 65535) : new O.ToUnicodeMap(R.getMap());
              }) : X instanceof k.BaseStream ? u.CMapFactory.create({
                encoding: X,
                fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                useCMap: null
              }).then(function(R) {
                if (R instanceof u.IdentityCMap)
                  return new O.IdentityToUnicodeMap(0, 65535);
                const f = new Array(R.length);
                return R.forEach(function(D, z) {
                  if (typeof z == "number") {
                    f[D] = String.fromCodePoint(z);
                    return;
                  }
                  const Y = [];
                  for (let W = 0; W < z.length; W += 2) {
                    const ie = z.charCodeAt(W) << 8 | z.charCodeAt(W + 1);
                    if ((ie & 63488) !== 55296) {
                      Y.push(ie);
                      continue;
                    }
                    W += 2;
                    const ne = z.charCodeAt(W) << 8 | z.charCodeAt(W + 1);
                    Y.push(((ie & 1023) << 10) + (ne & 1023) + 65536);
                  }
                  f[D] = String.fromCodePoint(...Y);
                }), new O.ToUnicodeMap(f);
              }, (R) => {
                if (R instanceof n.AbortException)
                  return null;
                if (this.options.ignoreErrors)
                  return (0, n.warn)(`readToUnicode - ignoring ToUnicode data: "${R}".`), null;
                throw R;
              }) : Promise.resolve(null) : Promise.resolve(null);
            }
            readCidToGidMap(X, R) {
              const f = [];
              for (let D = 0, z = X.length; D < z; D++) {
                const Y = X[D++] << 8 | X[D], W = D >> 1;
                Y === 0 && !R.has(W) || (f[W] = Y);
              }
              return f;
            }
            extractWidths(X, R, f) {
              const D = this.xref;
              let z = [], Y = 0;
              const W = [];
              let ie, ne, re, ee, te, oe, se, ce;
              if (f.composite) {
                if (Y = X.has("DW") ? X.get("DW") : 1e3, ce = X.get("W"), ce)
                  for (ne = 0, re = ce.length; ne < re; ne++)
                    if (oe = D.fetchIfRef(ce[ne++]), se = D.fetchIfRef(ce[ne]), Array.isArray(se))
                      for (ee = 0, te = se.length; ee < te; ee++)
                        z[oe++] = D.fetchIfRef(se[ee]);
                    else {
                      const Ie = D.fetchIfRef(ce[++ne]);
                      for (ee = oe; ee <= se; ee++)
                        z[ee] = Ie;
                    }
                if (f.vertical) {
                  let Ie = X.getArray("DW2") || [880, -1e3];
                  if (ie = [Ie[1], Y * 0.5, Ie[0]], Ie = X.get("W2"), Ie)
                    for (ne = 0, re = Ie.length; ne < re; ne++)
                      if (oe = D.fetchIfRef(Ie[ne++]), se = D.fetchIfRef(Ie[ne]), Array.isArray(se))
                        for (ee = 0, te = se.length; ee < te; ee++)
                          W[oe++] = [D.fetchIfRef(se[ee++]), D.fetchIfRef(se[ee++]), D.fetchIfRef(se[ee])];
                      else {
                        const Fe = [D.fetchIfRef(Ie[++ne]), D.fetchIfRef(Ie[++ne]), D.fetchIfRef(Ie[++ne])];
                        for (ee = oe; ee <= se; ee++)
                          W[ee] = Fe;
                      }
                }
              } else {
                const Ie = f.firstChar;
                if (ce = X.get("Widths"), ce) {
                  for (ee = Ie, ne = 0, re = ce.length; ne < re; ne++)
                    z[ee++] = D.fetchIfRef(ce[ne]);
                  Y = parseFloat(R.get("MissingWidth")) || 0;
                } else {
                  const Fe = X.get("BaseFont");
                  if (Fe instanceof q.Name) {
                    const we = this.getBaseFontMetrics(Fe.name);
                    z = this.buildCharCodeToWidth(we.widths, f), Y = we.defaultWidth;
                  }
                }
              }
              let le = !0, de = Y;
              for (const Ie in z) {
                const Fe = z[Ie];
                if (Fe) {
                  if (!de) {
                    de = Fe;
                    continue;
                  }
                  if (de !== Fe) {
                    le = !1;
                    break;
                  }
                }
              }
              le ? f.flags |= v.FontFlags.FixedPitch : f.flags &= ~v.FontFlags.FixedPitch, f.defaultWidth = Y, f.widths = z, f.defaultVMetrics = ie, f.vmetrics = W;
            }
            isSerifFont(X) {
              const R = X.split("-")[0];
              return R in (0, B.getSerifFonts)() || /serif/gi.test(R);
            }
            getBaseFontMetrics(X) {
              let R = 0, f = /* @__PURE__ */ Object.create(null), D = !1, Y = (0, B.getStdFontMap)()[X] || X;
              const W = (0, I.getMetrics)();
              Y in W || (this.isSerifFont(X) ? Y = "Times-Roman" : Y = "Helvetica");
              const ie = W[Y];
              return typeof ie == "number" ? (R = ie, D = !0) : f = ie(), {
                defaultWidth: R,
                monospace: D,
                widths: f
              };
            }
            buildCharCodeToWidth(X, R) {
              const f = /* @__PURE__ */ Object.create(null), D = R.differences, z = R.defaultEncoding;
              for (let Y = 0; Y < 256; Y++) {
                if (Y in D && X[D[Y]]) {
                  f[Y] = X[D[Y]];
                  continue;
                }
                if (Y in z && X[z[Y]]) {
                  f[Y] = X[z[Y]];
                  continue;
                }
              }
              return f;
            }
            preEvaluateFont(X) {
              const R = X;
              let f = X.get("Subtype");
              if (!(f instanceof q.Name))
                throw new n.FormatError("invalid font Subtype");
              let D = !1, z, Y;
              if (f.name === "Type0") {
                const re = X.get("DescendantFonts");
                if (!re)
                  throw new n.FormatError("Descendant fonts are not specified");
                if (X = Array.isArray(re) ? this.xref.fetchIfRef(re[0]) : re, !(X instanceof q.Dict))
                  throw new n.FormatError("Descendant font is not a dictionary.");
                if (f = X.get("Subtype"), !(f instanceof q.Name))
                  throw new n.FormatError("invalid font Subtype");
                D = !0;
              }
              const W = X.get("FirstChar") || 0, ie = X.get("LastChar") || (D ? 65535 : 255), ne = X.get("FontDescriptor");
              if (ne) {
                z = new P.MurmurHash3_64();
                const re = R.getRaw("Encoding");
                if (re instanceof q.Name)
                  z.update(re.name);
                else if (re instanceof q.Ref)
                  z.update(re.toString());
                else if (re instanceof q.Dict) {
                  for (const te of re.getRawValues())
                    if (te instanceof q.Name)
                      z.update(te.name);
                    else if (te instanceof q.Ref)
                      z.update(te.toString());
                    else if (Array.isArray(te)) {
                      const oe = te.length, se = new Array(oe);
                      for (let ce = 0; ce < oe; ce++) {
                        const le = te[ce];
                        le instanceof q.Name ? se[ce] = le.name : (typeof le == "number" || le instanceof q.Ref) && (se[ce] = le.toString());
                      }
                      z.update(se.join());
                    }
                }
                if (z.update(`${W}-${ie}`), Y = X.get("ToUnicode") || R.get("ToUnicode"), Y instanceof k.BaseStream) {
                  const te = Y.str || Y, oe = te.buffer ? new Uint8Array(te.buffer.buffer, 0, te.bufferLength) : new Uint8Array(te.bytes.buffer, te.start, te.end - te.start);
                  z.update(oe);
                } else
                  Y instanceof q.Name && z.update(Y.name);
                const ee = X.get("Widths") || R.get("Widths");
                if (Array.isArray(ee)) {
                  const te = [];
                  for (const oe of ee)
                    (typeof oe == "number" || oe instanceof q.Ref) && te.push(oe.toString());
                  z.update(te.join());
                }
                if (D) {
                  z.update("compositeFont");
                  const te = X.get("W") || R.get("W");
                  if (Array.isArray(te)) {
                    const se = [];
                    for (const ce of te)
                      if (typeof ce == "number" || ce instanceof q.Ref)
                        se.push(ce.toString());
                      else if (Array.isArray(ce)) {
                        const le = [];
                        for (const de of ce)
                          (typeof de == "number" || de instanceof q.Ref) && le.push(de.toString());
                        se.push(`[${le.join()}]`);
                      }
                    z.update(se.join());
                  }
                  const oe = X.getRaw("CIDToGIDMap") || R.getRaw("CIDToGIDMap");
                  oe instanceof q.Name ? z.update(oe.name) : oe instanceof q.Ref ? z.update(oe.toString()) : oe instanceof k.BaseStream && z.update(oe.peekBytes());
                }
              }
              return {
                descriptor: ne,
                dict: X,
                baseDict: R,
                composite: D,
                type: f.name,
                firstChar: W,
                lastChar: ie,
                toUnicode: Y,
                hash: z ? z.hexdigest() : ""
              };
            }
            async translateFont({
              descriptor: X,
              dict: R,
              baseDict: f,
              composite: D,
              type: z,
              firstChar: Y,
              lastChar: W,
              toUnicode: ie,
              cssFontInfo: ne
            }) {
              const re = z === "Type3";
              let ee;
              if (!X)
                if (re)
                  X = new q.Dict(null), X.set("FontName", q.Name.get(z)), X.set("FontBBox", R.getArray("FontBBox") || [0, 0, 0, 0]);
                else {
                  let fe = R.get("BaseFont");
                  if (!(fe instanceof q.Name))
                    throw new n.FormatError("Base font is not specified");
                  fe = fe.name.replaceAll(/[,_]/g, "-");
                  const Ae = this.getBaseFontMetrics(fe), Pe = fe.split("-")[0], Re = (this.isSerifFont(Pe) ? v.FontFlags.Serif : 0) | (Ae.monospace ? v.FontFlags.FixedPitch : 0) | ((0, B.getSymbolsFonts)()[Pe] ? v.FontFlags.Symbolic : v.FontFlags.Nonsymbolic);
                  ee = {
                    type: z,
                    name: fe,
                    loadedName: f.loadedName,
                    systemFontInfo: null,
                    widths: Ae.widths,
                    defaultWidth: Ae.defaultWidth,
                    isSimulatedFlags: !0,
                    flags: Re,
                    firstChar: Y,
                    lastChar: W,
                    toUnicode: ie,
                    xHeight: 0,
                    capHeight: 0,
                    italicAngle: 0,
                    isType3Font: re
                  };
                  const Ee = R.get("Widths"), ye = (0, B.getStandardFontName)(fe);
                  let Te = null;
                  return ye && (Te = await this.fetchStandardFontData(ye), ee.isInternalFont = !!Te), !ee.isInternalFont && this.options.useSystemFonts && (ee.systemFontInfo = (0, r.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, fe, ye)), this.extractDataStructures(R, R, ee).then((je) => {
                    if (Ee) {
                      const ve = [];
                      let Ce = Y;
                      for (const Ne of Ee)
                        ve[Ce++] = this.xref.fetchIfRef(Ne);
                      je.widths = ve;
                    } else
                      je.widths = this.buildCharCodeToWidth(Ae.widths, je);
                    return new e.Font(fe, Te, je);
                  });
                }
              let te = X.get("FontName"), oe = R.get("BaseFont");
              if (typeof te == "string" && (te = q.Name.get(te)), typeof oe == "string" && (oe = q.Name.get(oe)), !re) {
                const fe = te == null ? void 0 : te.name, Ae = oe == null ? void 0 : oe.name;
                fe !== Ae && ((0, n.info)(`The FontDescriptor's FontName is "${fe}" but should be the same as the Font's BaseFont "${Ae}".`), fe && (Ae != null && Ae.startsWith(fe)) && (te = oe));
              }
              if (te || (te = oe), !(te instanceof q.Name))
                throw new n.FormatError("invalid font name");
              let se, ce, le, de, Ie;
              try {
                se = X.get("FontFile", "FontFile2", "FontFile3");
              } catch (fe) {
                if (!this.options.ignoreErrors)
                  throw fe;
                (0, n.warn)(`translateFont - fetching "${te.name}" font file: "${fe}".`), se = new o.NullStream();
              }
              let Fe = !1, we = null, pe = null;
              if (se) {
                if (se.dict) {
                  const fe = se.dict.get("Subtype");
                  fe instanceof q.Name && (ce = fe.name), le = se.dict.get("Length1"), de = se.dict.get("Length2"), Ie = se.dict.get("Length3");
                }
              } else if (ne) {
                const fe = (0, M.getXfaFontName)(te.name);
                fe && (ne.fontFamily = `${ne.fontFamily}-PdfJS-XFA`, ne.metrics = fe.metrics || null, we = fe.factors || null, se = await this.fetchStandardFontData(fe.name), Fe = !!se, f = R = (0, M.getXfaFontDict)(te.name), D = !0);
              } else if (!re) {
                const fe = (0, B.getStandardFontName)(te.name);
                fe && (se = await this.fetchStandardFontData(fe), Fe = !!se), !Fe && this.options.useSystemFonts && (pe = (0, r.getFontSubstitution)(this.systemFontCache, this.idFactory, this.options.standardFontDataUrl, te.name, fe));
              }
              if (ee = {
                type: z,
                name: te.name,
                subtype: ce,
                file: se,
                length1: le,
                length2: de,
                length3: Ie,
                isInternalFont: Fe,
                loadedName: f.loadedName,
                composite: D,
                fixedPitch: !1,
                fontMatrix: R.getArray("FontMatrix") || n.FONT_IDENTITY_MATRIX,
                firstChar: Y,
                lastChar: W,
                toUnicode: ie,
                bbox: X.getArray("FontBBox") || R.getArray("FontBBox"),
                ascent: X.get("Ascent"),
                descent: X.get("Descent"),
                xHeight: X.get("XHeight") || 0,
                capHeight: X.get("CapHeight") || 0,
                flags: X.get("Flags"),
                italicAngle: X.get("ItalicAngle") || 0,
                isType3Font: re,
                cssFontInfo: ne,
                scaleFactors: we,
                systemFontInfo: pe
              }, D) {
                const fe = f.get("Encoding");
                fe instanceof q.Name && (ee.cidEncoding = fe.name);
                const Ae = await u.CMapFactory.create({
                  encoding: fe,
                  fetchBuiltInCMap: this._fetchBuiltInCMapBound,
                  useCMap: null
                });
                ee.cMap = Ae, ee.vertical = ee.cMap.vertical;
              }
              return this.extractDataStructures(R, f, ee).then((fe) => (this.extractWidths(R, X, fe), new e.Font(te.name, se, fe)));
            }
            static buildFontPaths(X, R, f, D) {
              function z(Y) {
                const W = `${X.loadedName}_path_${Y}`;
                try {
                  if (X.renderer.hasBuiltPath(Y))
                    return;
                  f.send("commonobj", [W, "FontPath", X.renderer.getPathJs(Y)]);
                } catch (ie) {
                  if (D.ignoreErrors) {
                    (0, n.warn)(`buildFontPaths - ignoring ${W} glyph: "${ie}".`);
                    return;
                  }
                  throw ie;
                }
              }
              for (const Y of R) {
                z(Y.fontChar);
                const W = Y.accent;
                W != null && W.fontChar && z(W.fontChar);
              }
            }
            static get fallbackFontDict() {
              const X = new q.Dict();
              return X.set("BaseFont", q.Name.get("Helvetica")), X.set("Type", q.Name.get("FallbackType")), X.set("Subtype", q.Name.get("FallbackType")), X.set("Encoding", q.Name.get("WinAnsiEncoding")), (0, n.shadow)(this, "fallbackFontDict", X);
            }
          }
          F.PartialEvaluator = T;
          class L {
            constructor({
              loadedName: X,
              font: R,
              dict: f,
              evaluatorOptions: D
            }) {
              this.loadedName = X, this.font = R, this.dict = f, this._evaluatorOptions = D || A, this.type3Loaded = null, this.type3Dependencies = R.isType3Font ? /* @__PURE__ */ new Set() : null, this.sent = !1;
            }
            send(X) {
              this.sent || (this.sent = !0, X.send("commonobj", [this.loadedName, "Font", this.font.exportData(this._evaluatorOptions.fontExtraProperties)]));
            }
            fallback(X) {
              this.font.data && (this.font.disableFontFace = !0, T.buildFontPaths(this.font, this.font.glyphCacheValues, X, this._evaluatorOptions));
            }
            loadType3Data(X, R, f) {
              if (this.type3Loaded)
                return this.type3Loaded;
              if (!this.font.isType3Font)
                throw new Error("Must be a Type3 font.");
              const D = X.clone({
                ignoreErrors: !1
              });
              D.parsingType3Font = !0;
              const z = new q.RefSet(X.type3FontRefs);
              this.dict.objId && !z.has(this.dict.objId) && z.put(this.dict.objId), D.type3FontRefs = z;
              const Y = this.font, W = this.type3Dependencies;
              let ie = Promise.resolve();
              const ne = this.dict.get("CharProcs"), re = this.dict.get("Resources") || R, ee = /* @__PURE__ */ Object.create(null), te = n.Util.normalizeRect(Y.bbox || [0, 0, 0, 0]), oe = te[2] - te[0], se = te[3] - te[1], ce = Math.hypot(oe, se);
              for (const le of ne.getKeys())
                ie = ie.then(() => {
                  const de = ne.get(le), Ie = new c.OperatorList();
                  return D.getOperatorList({
                    stream: de,
                    task: f,
                    resources: re,
                    operatorList: Ie
                  }).then(() => {
                    Ie.fnArray[0] === n.OPS.setCharWidthAndBounds && this._removeType3ColorOperators(Ie, ce), ee[le] = Ie.getIR();
                    for (const Fe of Ie.dependencies)
                      W.add(Fe);
                  }).catch(function(Fe) {
                    (0, n.warn)(`Type3 font resource "${le}" is not available.`);
                    const we = new c.OperatorList();
                    ee[le] = we.getIR();
                  });
                });
              return this.type3Loaded = ie.then(() => {
                Y.charProcOperatorList = ee, this._bbox && (Y.isCharBBox = !0, Y.bbox = this._bbox);
              }), this.type3Loaded;
            }
            _removeType3ColorOperators(X, R = NaN) {
              const f = n.Util.normalizeRect(X.argsArray[0].slice(2)), D = f[2] - f[0], z = f[3] - f[1], Y = Math.hypot(D, z);
              D === 0 || z === 0 ? (X.fnArray.splice(0, 1), X.argsArray.splice(0, 1)) : (R === 0 || Math.round(Y / R) >= 10) && (this._bbox || (this._bbox = [1 / 0, 1 / 0, -1 / 0, -1 / 0]), this._bbox[0] = Math.min(this._bbox[0], f[0]), this._bbox[1] = Math.min(this._bbox[1], f[1]), this._bbox[2] = Math.max(this._bbox[2], f[2]), this._bbox[3] = Math.max(this._bbox[3], f[3]));
              let W = 0, ie = X.length;
              for (; W < ie; ) {
                switch (X.fnArray[W]) {
                  case n.OPS.setCharWidthAndBounds:
                    break;
                  case n.OPS.setStrokeColorSpace:
                  case n.OPS.setFillColorSpace:
                  case n.OPS.setStrokeColor:
                  case n.OPS.setStrokeColorN:
                  case n.OPS.setFillColor:
                  case n.OPS.setFillColorN:
                  case n.OPS.setStrokeGray:
                  case n.OPS.setFillGray:
                  case n.OPS.setStrokeRGBColor:
                  case n.OPS.setFillRGBColor:
                  case n.OPS.setStrokeCMYKColor:
                  case n.OPS.setFillCMYKColor:
                  case n.OPS.shadingFill:
                  case n.OPS.setRenderingIntent:
                    X.fnArray.splice(W, 1), X.argsArray.splice(W, 1), ie--;
                    continue;
                  case n.OPS.setGState:
                    const [ne] = X.argsArray[W];
                    let re = 0, ee = ne.length;
                    for (; re < ee; ) {
                      const [te] = ne[re];
                      switch (te) {
                        case "TR":
                        case "TR2":
                        case "HT":
                        case "BG":
                        case "BG2":
                        case "UCR":
                        case "UCR2":
                          ne.splice(re, 1), ee--;
                          continue;
                      }
                      re++;
                    }
                    break;
                }
                W++;
              }
            }
          }
          class _ {
            constructor(X = new J()) {
              this.state = X, this.stateStack = [];
            }
            save() {
              const X = this.state;
              this.stateStack.push(this.state), this.state = X.clone();
            }
            restore() {
              const X = this.stateStack.pop();
              X && (this.state = X);
            }
            transform(X) {
              this.state.ctm = n.Util.transform(this.state.ctm, X);
            }
          }
          class G {
            constructor() {
              this.ctm = new Float32Array(n.IDENTITY_MATRIX), this.fontName = null, this.fontSize = 0, this.loadedName = null, this.font = null, this.fontMatrix = n.FONT_IDENTITY_MATRIX, this.textMatrix = n.IDENTITY_MATRIX.slice(), this.textLineMatrix = n.IDENTITY_MATRIX.slice(), this.charSpacing = 0, this.wordSpacing = 0, this.leading = 0, this.textHScale = 1, this.textRise = 0;
            }
            setTextMatrix(X, R, f, D, z, Y) {
              const W = this.textMatrix;
              W[0] = X, W[1] = R, W[2] = f, W[3] = D, W[4] = z, W[5] = Y;
            }
            setTextLineMatrix(X, R, f, D, z, Y) {
              const W = this.textLineMatrix;
              W[0] = X, W[1] = R, W[2] = f, W[3] = D, W[4] = z, W[5] = Y;
            }
            translateTextMatrix(X, R) {
              const f = this.textMatrix;
              f[4] = f[0] * X + f[2] * R + f[4], f[5] = f[1] * X + f[3] * R + f[5];
            }
            translateTextLineMatrix(X, R) {
              const f = this.textLineMatrix;
              f[4] = f[0] * X + f[2] * R + f[4], f[5] = f[1] * X + f[3] * R + f[5];
            }
            carriageReturn() {
              this.translateTextLineMatrix(0, -this.leading), this.textMatrix = this.textLineMatrix.slice();
            }
            clone() {
              const X = Object.create(this);
              return X.textMatrix = this.textMatrix.slice(), X.textLineMatrix = this.textLineMatrix.slice(), X.fontMatrix = this.fontMatrix.slice(), X;
            }
          }
          class J {
            constructor() {
              this.ctm = new Float32Array(n.IDENTITY_MATRIX), this.font = null, this.textRenderingMode = n.TextRenderingMode.FILL, this.fillColorSpace = l.ColorSpace.singletons.gray, this.strokeColorSpace = l.ColorSpace.singletons.gray;
            }
            clone() {
              return Object.create(this);
            }
          }
          const U = class U {
            static get opMap() {
              const X = (0, b.getLookupTableFactory)(function(R) {
                R.w = {
                  id: n.OPS.setLineWidth,
                  numArgs: 1,
                  variableArgs: !1
                }, R.J = {
                  id: n.OPS.setLineCap,
                  numArgs: 1,
                  variableArgs: !1
                }, R.j = {
                  id: n.OPS.setLineJoin,
                  numArgs: 1,
                  variableArgs: !1
                }, R.M = {
                  id: n.OPS.setMiterLimit,
                  numArgs: 1,
                  variableArgs: !1
                }, R.d = {
                  id: n.OPS.setDash,
                  numArgs: 2,
                  variableArgs: !1
                }, R.ri = {
                  id: n.OPS.setRenderingIntent,
                  numArgs: 1,
                  variableArgs: !1
                }, R.i = {
                  id: n.OPS.setFlatness,
                  numArgs: 1,
                  variableArgs: !1
                }, R.gs = {
                  id: n.OPS.setGState,
                  numArgs: 1,
                  variableArgs: !1
                }, R.q = {
                  id: n.OPS.save,
                  numArgs: 0,
                  variableArgs: !1
                }, R.Q = {
                  id: n.OPS.restore,
                  numArgs: 0,
                  variableArgs: !1
                }, R.cm = {
                  id: n.OPS.transform,
                  numArgs: 6,
                  variableArgs: !1
                }, R.m = {
                  id: n.OPS.moveTo,
                  numArgs: 2,
                  variableArgs: !1
                }, R.l = {
                  id: n.OPS.lineTo,
                  numArgs: 2,
                  variableArgs: !1
                }, R.c = {
                  id: n.OPS.curveTo,
                  numArgs: 6,
                  variableArgs: !1
                }, R.v = {
                  id: n.OPS.curveTo2,
                  numArgs: 4,
                  variableArgs: !1
                }, R.y = {
                  id: n.OPS.curveTo3,
                  numArgs: 4,
                  variableArgs: !1
                }, R.h = {
                  id: n.OPS.closePath,
                  numArgs: 0,
                  variableArgs: !1
                }, R.re = {
                  id: n.OPS.rectangle,
                  numArgs: 4,
                  variableArgs: !1
                }, R.S = {
                  id: n.OPS.stroke,
                  numArgs: 0,
                  variableArgs: !1
                }, R.s = {
                  id: n.OPS.closeStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, R.f = {
                  id: n.OPS.fill,
                  numArgs: 0,
                  variableArgs: !1
                }, R.F = {
                  id: n.OPS.fill,
                  numArgs: 0,
                  variableArgs: !1
                }, R["f*"] = {
                  id: n.OPS.eoFill,
                  numArgs: 0,
                  variableArgs: !1
                }, R.B = {
                  id: n.OPS.fillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, R["B*"] = {
                  id: n.OPS.eoFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, R.b = {
                  id: n.OPS.closeFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, R["b*"] = {
                  id: n.OPS.closeEOFillStroke,
                  numArgs: 0,
                  variableArgs: !1
                }, R.n = {
                  id: n.OPS.endPath,
                  numArgs: 0,
                  variableArgs: !1
                }, R.W = {
                  id: n.OPS.clip,
                  numArgs: 0,
                  variableArgs: !1
                }, R["W*"] = {
                  id: n.OPS.eoClip,
                  numArgs: 0,
                  variableArgs: !1
                }, R.BT = {
                  id: n.OPS.beginText,
                  numArgs: 0,
                  variableArgs: !1
                }, R.ET = {
                  id: n.OPS.endText,
                  numArgs: 0,
                  variableArgs: !1
                }, R.Tc = {
                  id: n.OPS.setCharSpacing,
                  numArgs: 1,
                  variableArgs: !1
                }, R.Tw = {
                  id: n.OPS.setWordSpacing,
                  numArgs: 1,
                  variableArgs: !1
                }, R.Tz = {
                  id: n.OPS.setHScale,
                  numArgs: 1,
                  variableArgs: !1
                }, R.TL = {
                  id: n.OPS.setLeading,
                  numArgs: 1,
                  variableArgs: !1
                }, R.Tf = {
                  id: n.OPS.setFont,
                  numArgs: 2,
                  variableArgs: !1
                }, R.Tr = {
                  id: n.OPS.setTextRenderingMode,
                  numArgs: 1,
                  variableArgs: !1
                }, R.Ts = {
                  id: n.OPS.setTextRise,
                  numArgs: 1,
                  variableArgs: !1
                }, R.Td = {
                  id: n.OPS.moveText,
                  numArgs: 2,
                  variableArgs: !1
                }, R.TD = {
                  id: n.OPS.setLeadingMoveText,
                  numArgs: 2,
                  variableArgs: !1
                }, R.Tm = {
                  id: n.OPS.setTextMatrix,
                  numArgs: 6,
                  variableArgs: !1
                }, R["T*"] = {
                  id: n.OPS.nextLine,
                  numArgs: 0,
                  variableArgs: !1
                }, R.Tj = {
                  id: n.OPS.showText,
                  numArgs: 1,
                  variableArgs: !1
                }, R.TJ = {
                  id: n.OPS.showSpacedText,
                  numArgs: 1,
                  variableArgs: !1
                }, R["'"] = {
                  id: n.OPS.nextLineShowText,
                  numArgs: 1,
                  variableArgs: !1
                }, R['"'] = {
                  id: n.OPS.nextLineSetSpacingShowText,
                  numArgs: 3,
                  variableArgs: !1
                }, R.d0 = {
                  id: n.OPS.setCharWidth,
                  numArgs: 2,
                  variableArgs: !1
                }, R.d1 = {
                  id: n.OPS.setCharWidthAndBounds,
                  numArgs: 6,
                  variableArgs: !1
                }, R.CS = {
                  id: n.OPS.setStrokeColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                }, R.cs = {
                  id: n.OPS.setFillColorSpace,
                  numArgs: 1,
                  variableArgs: !1
                }, R.SC = {
                  id: n.OPS.setStrokeColor,
                  numArgs: 4,
                  variableArgs: !0
                }, R.SCN = {
                  id: n.OPS.setStrokeColorN,
                  numArgs: 33,
                  variableArgs: !0
                }, R.sc = {
                  id: n.OPS.setFillColor,
                  numArgs: 4,
                  variableArgs: !0
                }, R.scn = {
                  id: n.OPS.setFillColorN,
                  numArgs: 33,
                  variableArgs: !0
                }, R.G = {
                  id: n.OPS.setStrokeGray,
                  numArgs: 1,
                  variableArgs: !1
                }, R.g = {
                  id: n.OPS.setFillGray,
                  numArgs: 1,
                  variableArgs: !1
                }, R.RG = {
                  id: n.OPS.setStrokeRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                }, R.rg = {
                  id: n.OPS.setFillRGBColor,
                  numArgs: 3,
                  variableArgs: !1
                }, R.K = {
                  id: n.OPS.setStrokeCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                }, R.k = {
                  id: n.OPS.setFillCMYKColor,
                  numArgs: 4,
                  variableArgs: !1
                }, R.sh = {
                  id: n.OPS.shadingFill,
                  numArgs: 1,
                  variableArgs: !1
                }, R.BI = {
                  id: n.OPS.beginInlineImage,
                  numArgs: 0,
                  variableArgs: !1
                }, R.ID = {
                  id: n.OPS.beginImageData,
                  numArgs: 0,
                  variableArgs: !1
                }, R.EI = {
                  id: n.OPS.endInlineImage,
                  numArgs: 1,
                  variableArgs: !1
                }, R.Do = {
                  id: n.OPS.paintXObject,
                  numArgs: 1,
                  variableArgs: !1
                }, R.MP = {
                  id: n.OPS.markPoint,
                  numArgs: 1,
                  variableArgs: !1
                }, R.DP = {
                  id: n.OPS.markPointProps,
                  numArgs: 2,
                  variableArgs: !1
                }, R.BMC = {
                  id: n.OPS.beginMarkedContent,
                  numArgs: 1,
                  variableArgs: !1
                }, R.BDC = {
                  id: n.OPS.beginMarkedContentProps,
                  numArgs: 2,
                  variableArgs: !1
                }, R.EMC = {
                  id: n.OPS.endMarkedContent,
                  numArgs: 0,
                  variableArgs: !1
                }, R.BX = {
                  id: n.OPS.beginCompat,
                  numArgs: 0,
                  variableArgs: !1
                }, R.EX = {
                  id: n.OPS.endCompat,
                  numArgs: 0,
                  variableArgs: !1
                }, R.BM = null, R.BD = null, R.true = null, R.fa = null, R.fal = null, R.fals = null, R.false = null, R.nu = null, R.nul = null, R.null = null;
              });
              return (0, n.shadow)(this, "opMap", X());
            }
            constructor(X, R, f = new _()) {
              this.parser = new C.Parser({
                lexer: new C.Lexer(X, U.opMap),
                xref: R
              }), this.stateManager = f, this.nonProcessedArgs = [], this._isPathOp = !1, this._numInvalidPathOPS = 0;
            }
            get savedStatesDepth() {
              return this.stateManager.stateStack.length;
            }
            read(X) {
              let R = X.args;
              for (; ; ) {
                const f = this.parser.getObj();
                if (f instanceof q.Cmd) {
                  const D = f.cmd, z = U.opMap[D];
                  if (!z) {
                    (0, n.warn)(`Unknown command "${D}".`);
                    continue;
                  }
                  const Y = z.id, W = z.numArgs;
                  let ie = R !== null ? R.length : 0;
                  if (this._isPathOp || (this._numInvalidPathOPS = 0), this._isPathOp = Y >= n.OPS.moveTo && Y <= n.OPS.endPath, z.variableArgs)
                    ie > W && (0, n.info)(`Command ${D}: expected [0, ${W}] args, but received ${ie} args.`);
                  else {
                    if (ie !== W) {
                      const ne = this.nonProcessedArgs;
                      for (; ie > W; )
                        ne.push(R.shift()), ie--;
                      for (; ie < W && ne.length !== 0; )
                        R === null && (R = []), R.unshift(ne.pop()), ie++;
                    }
                    if (ie < W) {
                      const ne = `command ${D}: expected ${W} args, but received ${ie} args.`;
                      if (this._isPathOp && ++this._numInvalidPathOPS > U.MAX_INVALID_PATH_OPS)
                        throw new n.FormatError(`Invalid ${ne}`);
                      (0, n.warn)(`Skipping ${ne}`), R !== null && (R.length = 0);
                      continue;
                    }
                  }
                  return this.preprocessCommand(Y, R), X.fn = Y, X.args = R, !0;
                }
                if (f === q.EOF)
                  return !1;
                if (f !== null && (R === null && (R = []), R.push(f), R.length > 33))
                  throw new n.FormatError("Too many arguments");
              }
            }
            preprocessCommand(X, R) {
              switch (X | 0) {
                case n.OPS.save:
                  this.stateManager.save();
                  break;
                case n.OPS.restore:
                  this.stateManager.restore();
                  break;
                case n.OPS.transform:
                  this.stateManager.transform(R);
                  break;
              }
            }
          };
          Dt(U, "MAX_INVALID_PATH_OPS", 10);
          let K = U;
          F.EvaluatorPreprocessor = K;
        },
        /* 14 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.IdentityCMap = F.CMapFactory = F.CMap = void 0;
          var n = ae(2), u = ae(4), q = ae(5), e = ae(15), t = ae(16), B = ae(3), j = ae(8);
          const M = ["Adobe-GB1-UCS2", "Adobe-CNS1-UCS2", "Adobe-Japan1-UCS2", "Adobe-Korea1-UCS2", "78-EUC-H", "78-EUC-V", "78-H", "78-RKSJ-H", "78-RKSJ-V", "78-V", "78ms-RKSJ-H", "78ms-RKSJ-V", "83pv-RKSJ-H", "90ms-RKSJ-H", "90ms-RKSJ-V", "90msp-RKSJ-H", "90msp-RKSJ-V", "90pv-RKSJ-H", "90pv-RKSJ-V", "Add-H", "Add-RKSJ-H", "Add-RKSJ-V", "Add-V", "Adobe-CNS1-0", "Adobe-CNS1-1", "Adobe-CNS1-2", "Adobe-CNS1-3", "Adobe-CNS1-4", "Adobe-CNS1-5", "Adobe-CNS1-6", "Adobe-GB1-0", "Adobe-GB1-1", "Adobe-GB1-2", "Adobe-GB1-3", "Adobe-GB1-4", "Adobe-GB1-5", "Adobe-Japan1-0", "Adobe-Japan1-1", "Adobe-Japan1-2", "Adobe-Japan1-3", "Adobe-Japan1-4", "Adobe-Japan1-5", "Adobe-Japan1-6", "Adobe-Korea1-0", "Adobe-Korea1-1", "Adobe-Korea1-2", "B5-H", "B5-V", "B5pc-H", "B5pc-V", "CNS-EUC-H", "CNS-EUC-V", "CNS1-H", "CNS1-V", "CNS2-H", "CNS2-V", "ETHK-B5-H", "ETHK-B5-V", "ETen-B5-H", "ETen-B5-V", "ETenms-B5-H", "ETenms-B5-V", "EUC-H", "EUC-V", "Ext-H", "Ext-RKSJ-H", "Ext-RKSJ-V", "Ext-V", "GB-EUC-H", "GB-EUC-V", "GB-H", "GB-V", "GBK-EUC-H", "GBK-EUC-V", "GBK2K-H", "GBK2K-V", "GBKp-EUC-H", "GBKp-EUC-V", "GBT-EUC-H", "GBT-EUC-V", "GBT-H", "GBT-V", "GBTpc-EUC-H", "GBTpc-EUC-V", "GBpc-EUC-H", "GBpc-EUC-V", "H", "HKdla-B5-H", "HKdla-B5-V", "HKdlb-B5-H", "HKdlb-B5-V", "HKgccs-B5-H", "HKgccs-B5-V", "HKm314-B5-H", "HKm314-B5-V", "HKm471-B5-H", "HKm471-B5-V", "HKscs-B5-H", "HKscs-B5-V", "Hankaku", "Hiragana", "KSC-EUC-H", "KSC-EUC-V", "KSC-H", "KSC-Johab-H", "KSC-Johab-V", "KSC-V", "KSCms-UHC-H", "KSCms-UHC-HW-H", "KSCms-UHC-HW-V", "KSCms-UHC-V", "KSCpc-EUC-H", "KSCpc-EUC-V", "Katakana", "NWP-H", "NWP-V", "RKSJ-H", "RKSJ-V", "Roman", "UniCNS-UCS2-H", "UniCNS-UCS2-V", "UniCNS-UTF16-H", "UniCNS-UTF16-V", "UniCNS-UTF32-H", "UniCNS-UTF32-V", "UniCNS-UTF8-H", "UniCNS-UTF8-V", "UniGB-UCS2-H", "UniGB-UCS2-V", "UniGB-UTF16-H", "UniGB-UTF16-V", "UniGB-UTF32-H", "UniGB-UTF32-V", "UniGB-UTF8-H", "UniGB-UTF8-V", "UniJIS-UCS2-H", "UniJIS-UCS2-HW-H", "UniJIS-UCS2-HW-V", "UniJIS-UCS2-V", "UniJIS-UTF16-H", "UniJIS-UTF16-V", "UniJIS-UTF32-H", "UniJIS-UTF32-V", "UniJIS-UTF8-H", "UniJIS-UTF8-V", "UniJIS2004-UTF16-H", "UniJIS2004-UTF16-V", "UniJIS2004-UTF32-H", "UniJIS2004-UTF32-V", "UniJIS2004-UTF8-H", "UniJIS2004-UTF8-V", "UniJISPro-UCS2-HW-V", "UniJISPro-UCS2-V", "UniJISPro-UTF8-V", "UniJISX0213-UTF32-H", "UniJISX0213-UTF32-V", "UniJISX02132004-UTF32-H", "UniJISX02132004-UTF32-V", "UniKS-UCS2-H", "UniKS-UCS2-V", "UniKS-UTF16-H", "UniKS-UTF16-V", "UniKS-UTF32-H", "UniKS-UTF32-V", "UniKS-UTF8-H", "UniKS-UTF8-V", "V", "WP-Symbol"], O = 2 ** 24 - 1;
          class w {
            constructor(d = !1) {
              this.codespaceRanges = [[], [], [], []], this.numCodespaceRanges = 0, this._map = [], this.name = "", this.vertical = !1, this.useCMap = null, this.builtInCMap = d;
            }
            addCodespaceRange(d, A, N) {
              this.codespaceRanges[d - 1].push(A, N), this.numCodespaceRanges++;
            }
            mapCidRange(d, A, N) {
              if (A - d > O)
                throw new Error("mapCidRange - ignoring data above MAX_MAP_RANGE.");
              for (; d <= A; )
                this._map[d++] = N++;
            }
            mapBfRange(d, A, N) {
              if (A - d > O)
                throw new Error("mapBfRange - ignoring data above MAX_MAP_RANGE.");
              const E = N.length - 1;
              for (; d <= A; ) {
                this._map[d++] = N;
                const H = N.charCodeAt(E) + 1;
                if (H > 255) {
                  N = N.substring(0, E - 1) + String.fromCharCode(N.charCodeAt(E - 1) + 1) + "\0";
                  continue;
                }
                N = N.substring(0, E) + String.fromCharCode(H);
              }
            }
            mapBfRangeToArray(d, A, N) {
              if (A - d > O)
                throw new Error("mapBfRangeToArray - ignoring data above MAX_MAP_RANGE.");
              const E = N.length;
              let H = 0;
              for (; d <= A && H < E; )
                this._map[d] = N[H++], ++d;
            }
            mapOne(d, A) {
              this._map[d] = A;
            }
            lookup(d) {
              return this._map[d];
            }
            contains(d) {
              return this._map[d] !== void 0;
            }
            forEach(d) {
              const A = this._map, N = A.length;
              if (N <= 65536)
                for (let E = 0; E < N; E++)
                  A[E] !== void 0 && d(E, A[E]);
              else
                for (const E in A)
                  d(E, A[E]);
            }
            charCodeOf(d) {
              const A = this._map;
              if (A.length <= 65536)
                return A.indexOf(d);
              for (const N in A)
                if (A[N] === d)
                  return N | 0;
              return -1;
            }
            getMap() {
              return this._map;
            }
            readCharCode(d, A, N) {
              let E = 0;
              const H = this.codespaceRanges;
              for (let $ = 0, m = H.length; $ < m; $++) {
                E = (E << 8 | d.charCodeAt(A + $)) >>> 0;
                const p = H[$];
                for (let T = 0, L = p.length; T < L; ) {
                  const _ = p[T++], G = p[T++];
                  if (E >= _ && E <= G) {
                    N.charcode = E, N.length = $ + 1;
                    return;
                  }
                }
              }
              N.charcode = 0, N.length = 1;
            }
            getCharCodeLength(d) {
              const A = this.codespaceRanges;
              for (let N = 0, E = A.length; N < E; N++) {
                const H = A[N];
                for (let $ = 0, m = H.length; $ < m; ) {
                  const p = H[$++], T = H[$++];
                  if (d >= p && d <= T)
                    return N + 1;
                }
              }
              return 1;
            }
            get length() {
              return this._map.length;
            }
            get isIdentityCMap() {
              if (!(this.name === "Identity-H" || this.name === "Identity-V") || this._map.length !== 65536)
                return !1;
              for (let d = 0; d < 65536; d++)
                if (this._map[d] !== d)
                  return !1;
              return !0;
            }
          }
          F.CMap = w;
          class C extends w {
            constructor(d, A) {
              super(), this.vertical = d, this.addCodespaceRange(A, 0, 65535);
            }
            mapCidRange(d, A, N) {
              (0, n.unreachable)("should not call mapCidRange");
            }
            mapBfRange(d, A, N) {
              (0, n.unreachable)("should not call mapBfRange");
            }
            mapBfRangeToArray(d, A, N) {
              (0, n.unreachable)("should not call mapBfRangeToArray");
            }
            mapOne(d, A) {
              (0, n.unreachable)("should not call mapCidOne");
            }
            lookup(d) {
              return Number.isInteger(d) && d <= 65535 ? d : void 0;
            }
            contains(d) {
              return Number.isInteger(d) && d <= 65535;
            }
            forEach(d) {
              for (let A = 0; A <= 65535; A++)
                d(A, A);
            }
            charCodeOf(d) {
              return Number.isInteger(d) && d <= 65535 ? d : -1;
            }
            getMap() {
              const d = new Array(65536);
              for (let A = 0; A <= 65535; A++)
                d[A] = A;
              return d;
            }
            get length() {
              return 65536;
            }
            get isIdentityCMap() {
              (0, n.unreachable)("should not access .isIdentityCMap");
            }
          }
          F.IdentityCMap = C;
          function i(c) {
            let d = 0;
            for (let A = 0; A < c.length; A++)
              d = d << 8 | c.charCodeAt(A);
            return d >>> 0;
          }
          function o(c) {
            if (typeof c != "string")
              throw new n.FormatError("Malformed CMap: expected string.");
          }
          function k(c) {
            if (!Number.isInteger(c))
              throw new n.FormatError("Malformed CMap: expected int.");
          }
          function s(c, d) {
            for (; ; ) {
              let A = d.getObj();
              if (A === u.EOF)
                break;
              if ((0, u.isCmd)(A, "endbfchar"))
                return;
              o(A);
              const N = i(A);
              A = d.getObj(), o(A);
              const E = A;
              c.mapOne(N, E);
            }
          }
          function l(c, d) {
            for (; ; ) {
              let A = d.getObj();
              if (A === u.EOF)
                break;
              if ((0, u.isCmd)(A, "endbfrange"))
                return;
              o(A);
              const N = i(A);
              A = d.getObj(), o(A);
              const E = i(A);
              if (A = d.getObj(), Number.isInteger(A) || typeof A == "string") {
                const H = Number.isInteger(A) ? String.fromCharCode(A) : A;
                c.mapBfRange(N, E, H);
              } else if ((0, u.isCmd)(A, "[")) {
                A = d.getObj();
                const H = [];
                for (; !(0, u.isCmd)(A, "]") && A !== u.EOF; )
                  H.push(A), A = d.getObj();
                c.mapBfRangeToArray(N, E, H);
              } else
                break;
            }
            throw new n.FormatError("Invalid bf range.");
          }
          function g(c, d) {
            for (; ; ) {
              let A = d.getObj();
              if (A === u.EOF)
                break;
              if ((0, u.isCmd)(A, "endcidchar"))
                return;
              o(A);
              const N = i(A);
              A = d.getObj(), k(A);
              const E = A;
              c.mapOne(N, E);
            }
          }
          function v(c, d) {
            for (; ; ) {
              let A = d.getObj();
              if (A === u.EOF)
                break;
              if ((0, u.isCmd)(A, "endcidrange"))
                return;
              o(A);
              const N = i(A);
              A = d.getObj(), o(A);
              const E = i(A);
              A = d.getObj(), k(A);
              const H = A;
              c.mapCidRange(N, E, H);
            }
          }
          function r(c, d) {
            for (; ; ) {
              let A = d.getObj();
              if (A === u.EOF)
                break;
              if ((0, u.isCmd)(A, "endcodespacerange"))
                return;
              if (typeof A != "string")
                break;
              const N = i(A);
              if (A = d.getObj(), typeof A != "string")
                break;
              const E = i(A);
              c.addCodespaceRange(A.length, N, E);
            }
            throw new n.FormatError("Invalid codespace range.");
          }
          function x(c, d) {
            const A = d.getObj();
            Number.isInteger(A) && (c.vertical = !!A);
          }
          function b(c, d) {
            const A = d.getObj();
            A instanceof u.Name && (c.name = A.name);
          }
          async function I(c, d, A, N) {
            let E, H;
            e:
              for (; ; )
                try {
                  const $ = d.getObj();
                  if ($ === u.EOF)
                    break;
                  if ($ instanceof u.Name)
                    $.name === "WMode" ? x(c, d) : $.name === "CMapName" && b(c, d), E = $;
                  else if ($ instanceof u.Cmd)
                    switch ($.cmd) {
                      case "endcmap":
                        break e;
                      case "usecmap":
                        E instanceof u.Name && (H = E.name);
                        break;
                      case "begincodespacerange":
                        r(c, d);
                        break;
                      case "beginbfchar":
                        s(c, d);
                        break;
                      case "begincidchar":
                        g(c, d);
                        break;
                      case "beginbfrange":
                        l(c, d);
                        break;
                      case "begincidrange":
                        v(c, d);
                        break;
                    }
                } catch ($) {
                  if ($ instanceof B.MissingDataException)
                    throw $;
                  (0, n.warn)("Invalid cMap data: " + $);
                  continue;
                }
            return !N && H && (N = H), N ? h(c, A, N) : c;
          }
          async function h(c, d, A) {
            if (c.useCMap = await y(A, d), c.numCodespaceRanges === 0) {
              const N = c.useCMap.codespaceRanges;
              for (let E = 0; E < N.length; E++)
                c.codespaceRanges[E] = N[E].slice();
              c.numCodespaceRanges = c.useCMap.numCodespaceRanges;
            }
            return c.useCMap.forEach(function(N, E) {
              c.contains(N) || c.mapOne(N, c.useCMap.lookup(N));
            }), c;
          }
          async function y(c, d) {
            if (c === "Identity-H")
              return new C(!1, 2);
            if (c === "Identity-V")
              return new C(!0, 2);
            if (!M.includes(c))
              throw new Error("Unknown CMap name: " + c);
            if (!d)
              throw new Error("Built-in CMap parameters are not provided.");
            const {
              cMapData: A,
              compressionType: N
            } = await d(c), E = new w(!0);
            if (N === n.CMapCompressionType.BINARY)
              return new e.BinaryCMapReader().process(A, E, (H) => h(E, d, H));
            if (N === n.CMapCompressionType.NONE) {
              const H = new t.Lexer(new j.Stream(A));
              return I(E, H, d, null);
            }
            throw new Error(`Invalid CMap "compressionType" value: ${N}`);
          }
          class P {
            static async create({
              encoding: d,
              fetchBuiltInCMap: A,
              useCMap: N
            }) {
              if (d instanceof u.Name)
                return y(d.name, A);
              if (d instanceof q.BaseStream) {
                const E = await I(new w(), new t.Lexer(d), A, N);
                return E.isIdentityCMap ? y(E.name, A) : E;
              }
              throw new Error("Encoding required.");
            }
          }
          F.CMapFactory = P;
        },
        /* 15 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.BinaryCMapReader = void 0;
          var n = ae(2);
          function u(w, C) {
            let i = 0;
            for (let o = 0; o <= C; o++)
              i = i << 8 | w[o];
            return i >>> 0;
          }
          function q(w, C) {
            return C === 1 ? String.fromCharCode(w[0], w[1]) : C === 3 ? String.fromCharCode(w[0], w[1], w[2], w[3]) : String.fromCharCode(...w.subarray(0, C + 1));
          }
          function e(w, C, i) {
            let o = 0;
            for (let k = i; k >= 0; k--)
              o += w[k] + C[k], w[k] = o & 255, o >>= 8;
          }
          function t(w, C) {
            let i = 1;
            for (let o = C; o >= 0 && i > 0; o--)
              i += w[o], w[o] = i & 255, i >>= 8;
          }
          const B = 16, j = 19;
          class M {
            constructor(C) {
              this.buffer = C, this.pos = 0, this.end = C.length, this.tmpBuf = new Uint8Array(j);
            }
            readByte() {
              return this.pos >= this.end ? -1 : this.buffer[this.pos++];
            }
            readNumber() {
              let C = 0, i;
              do {
                const o = this.readByte();
                if (o < 0)
                  throw new n.FormatError("unexpected EOF in bcmap");
                i = !(o & 128), C = C << 7 | o & 127;
              } while (!i);
              return C;
            }
            readSigned() {
              const C = this.readNumber();
              return C & 1 ? ~(C >>> 1) : C >>> 1;
            }
            readHex(C, i) {
              C.set(this.buffer.subarray(this.pos, this.pos + i + 1)), this.pos += i + 1;
            }
            readHexNumber(C, i) {
              let o;
              const k = this.tmpBuf;
              let s = 0;
              do {
                const r = this.readByte();
                if (r < 0)
                  throw new n.FormatError("unexpected EOF in bcmap");
                o = !(r & 128), k[s++] = r & 127;
              } while (!o);
              let l = i, g = 0, v = 0;
              for (; l >= 0; ) {
                for (; v < 8 && k.length > 0; )
                  g |= k[--s] << v, v += 7;
                C[l] = g & 255, l--, g >>= 8, v -= 8;
              }
            }
            readHexSigned(C, i) {
              this.readHexNumber(C, i);
              const o = C[i] & 1 ? 255 : 0;
              let k = 0;
              for (let s = 0; s <= i; s++)
                k = (k & 1) << 8 | C[s], C[s] = k >> 1 ^ o;
            }
            readString() {
              const C = this.readNumber(), i = new Array(C);
              for (let o = 0; o < C; o++)
                i[o] = this.readNumber();
              return String.fromCharCode(...i);
            }
          }
          class O {
            async process(C, i, o) {
              const k = new M(C), s = k.readByte();
              i.vertical = !!(s & 1);
              let l = null;
              const g = new Uint8Array(B), v = new Uint8Array(B), r = new Uint8Array(B), x = new Uint8Array(B), b = new Uint8Array(B);
              let I, h;
              for (; (h = k.readByte()) >= 0; ) {
                const y = h >> 5;
                if (y === 7) {
                  switch (h & 31) {
                    case 0:
                      k.readString();
                      break;
                    case 1:
                      l = k.readString();
                      break;
                  }
                  continue;
                }
                const P = !!(h & 16), c = h & 15;
                if (c + 1 > B)
                  throw new Error("BinaryCMapReader.process: Invalid dataSize.");
                const d = 1, A = k.readNumber();
                switch (y) {
                  case 0:
                    k.readHex(g, c), k.readHexNumber(v, c), e(v, g, c), i.addCodespaceRange(c + 1, u(g, c), u(v, c));
                    for (let N = 1; N < A; N++)
                      t(v, c), k.readHexNumber(g, c), e(g, v, c), k.readHexNumber(v, c), e(v, g, c), i.addCodespaceRange(c + 1, u(g, c), u(v, c));
                    break;
                  case 1:
                    k.readHex(g, c), k.readHexNumber(v, c), e(v, g, c), k.readNumber();
                    for (let N = 1; N < A; N++)
                      t(v, c), k.readHexNumber(g, c), e(g, v, c), k.readHexNumber(v, c), e(v, g, c), k.readNumber();
                    break;
                  case 2:
                    k.readHex(r, c), I = k.readNumber(), i.mapOne(u(r, c), I);
                    for (let N = 1; N < A; N++)
                      t(r, c), P || (k.readHexNumber(b, c), e(r, b, c)), I = k.readSigned() + (I + 1), i.mapOne(u(r, c), I);
                    break;
                  case 3:
                    k.readHex(g, c), k.readHexNumber(v, c), e(v, g, c), I = k.readNumber(), i.mapCidRange(u(g, c), u(v, c), I);
                    for (let N = 1; N < A; N++)
                      t(v, c), P ? g.set(v) : (k.readHexNumber(g, c), e(g, v, c)), k.readHexNumber(v, c), e(v, g, c), I = k.readNumber(), i.mapCidRange(u(g, c), u(v, c), I);
                    break;
                  case 4:
                    k.readHex(r, d), k.readHex(x, c), i.mapOne(u(r, d), q(x, c));
                    for (let N = 1; N < A; N++)
                      t(r, d), P || (k.readHexNumber(b, d), e(r, b, d)), t(x, c), k.readHexSigned(b, c), e(x, b, c), i.mapOne(u(r, d), q(x, c));
                    break;
                  case 5:
                    k.readHex(g, d), k.readHexNumber(v, d), e(v, g, d), k.readHex(x, c), i.mapBfRange(u(g, d), u(v, d), q(x, c));
                    for (let N = 1; N < A; N++)
                      t(v, d), P ? g.set(v) : (k.readHexNumber(g, d), e(g, v, d)), k.readHexNumber(v, d), e(v, g, d), k.readHex(x, c), i.mapBfRange(u(g, d), u(v, d), q(x, c));
                    break;
                  default:
                    throw new Error(`BinaryCMapReader.process - unknown type: ${y}`);
                }
              }
              return l ? o(l) : i;
            }
          }
          F.BinaryCMapReader = O;
        },
        /* 16 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Parser = F.Linearization = F.Lexer = void 0;
          var n = ae(2), u = ae(4), q = ae(3), e = ae(8), t = ae(17), B = ae(19), j = ae(20), M = ae(22), O = ae(23), w = ae(26), C = ae(29), i = ae(31), o = ae(32), k = ae(33);
          const s = 1e3;
          function l(I) {
            const h = [], y = I.length;
            let P = 0;
            for (; P < y - 1; )
              h.push(I[P++] << 8 | I[P++]);
            return P < y && h.push(I[P]), y + "_" + String.fromCharCode.apply(null, h);
          }
          class g {
            constructor({
              lexer: h,
              xref: y,
              allowStreams: P = !1,
              recoveryMode: c = !1
            }) {
              this.lexer = h, this.xref = y, this.allowStreams = P, this.recoveryMode = c, this.imageCache = /* @__PURE__ */ Object.create(null), this._imageId = 0, this.refill();
            }
            refill() {
              this.buf1 = this.lexer.getObj(), this.buf2 = this.lexer.getObj();
            }
            shift() {
              this.buf2 instanceof u.Cmd && this.buf2.cmd === "ID" ? (this.buf1 = this.buf2, this.buf2 = null) : (this.buf1 = this.buf2, this.buf2 = this.lexer.getObj());
            }
            tryShift() {
              try {
                return this.shift(), !0;
              } catch (h) {
                if (h instanceof q.MissingDataException)
                  throw h;
                return !1;
              }
            }
            getObj(h = null) {
              const y = this.buf1;
              if (this.shift(), y instanceof u.Cmd)
                switch (y.cmd) {
                  case "BI":
                    return this.makeInlineImage(h);
                  case "[":
                    const P = [];
                    for (; !(0, u.isCmd)(this.buf1, "]") && this.buf1 !== u.EOF; )
                      P.push(this.getObj(h));
                    if (this.buf1 === u.EOF) {
                      if (this.recoveryMode)
                        return P;
                      throw new q.ParserEOFException("End of file inside array.");
                    }
                    return this.shift(), P;
                  case "<<":
                    const c = new u.Dict(this.xref);
                    for (; !(0, u.isCmd)(this.buf1, ">>") && this.buf1 !== u.EOF; ) {
                      if (!(this.buf1 instanceof u.Name)) {
                        (0, n.info)("Malformed dictionary: key must be a name object"), this.shift();
                        continue;
                      }
                      const d = this.buf1.name;
                      if (this.shift(), this.buf1 === u.EOF)
                        break;
                      c.set(d, this.getObj(h));
                    }
                    if (this.buf1 === u.EOF) {
                      if (this.recoveryMode)
                        return c;
                      throw new q.ParserEOFException("End of file inside dictionary.");
                    }
                    return (0, u.isCmd)(this.buf2, "stream") ? this.allowStreams ? this.makeStream(c, h) : c : (this.shift(), c);
                  default:
                    return y;
                }
              if (Number.isInteger(y)) {
                if (Number.isInteger(this.buf1) && (0, u.isCmd)(this.buf2, "R")) {
                  const P = u.Ref.get(y, this.buf1);
                  return this.shift(), this.shift(), P;
                }
                return y;
              }
              return typeof y == "string" && h ? h.decryptString(y) : y;
            }
            findDefaultInlineStreamEnd(h) {
              const {
                knownCommands: E
              } = this.lexer, H = h.pos, $ = 15;
              let m = 0, p, T;
              for (; (p = h.getByte()) !== -1; )
                if (m === 0)
                  m = p === 69 ? 1 : 0;
                else if (m === 1)
                  m = p === 73 ? 2 : 0;
                else if (p === 32 || p === 10 || p === 13) {
                  T = h.pos;
                  const _ = h.peekBytes($), G = _.length;
                  if (G === 0)
                    break;
                  for (let V = 0; V < G; V++)
                    if (p = _[V], !(p === 0 && _[V + 1] !== 0) && p !== 10 && p !== 13 && (p < 32 || p > 127)) {
                      m = 0;
                      break;
                    }
                  if (m !== 2)
                    continue;
                  if (!E) {
                    (0, n.warn)("findDefaultInlineStreamEnd - `lexer.knownCommands` is undefined.");
                    continue;
                  }
                  const J = new x(new e.Stream(_.slice()), E);
                  J._hexStringWarn = () => {
                  };
                  let K = 0;
                  for (; ; ) {
                    const V = J.getObj();
                    if (V === u.EOF) {
                      m = 0;
                      break;
                    }
                    if (V instanceof u.Cmd) {
                      const U = E[V.cmd];
                      if (U) {
                        if (U.variableArgs ? K <= U.numArgs : K === U.numArgs)
                          break;
                      } else {
                        m = 0;
                        break;
                      }
                      K = 0;
                      continue;
                    }
                    K++;
                  }
                  if (m === 2)
                    break;
                } else
                  m = 0;
              p === -1 && ((0, n.warn)("findDefaultInlineStreamEnd: Reached the end of the stream without finding a valid EI marker"), T && ((0, n.warn)('... trying to recover by using the last "EI" occurrence.'), h.skip(-(h.pos - T))));
              let L = 4;
              return h.skip(-L), p = h.peekByte(), h.skip(L), (0, q.isWhiteSpace)(p) || L--, h.pos - L - H;
            }
            findDCTDecodeInlineStreamEnd(h) {
              const y = h.pos;
              let P = !1, c, d;
              for (; (c = h.getByte()) !== -1; )
                if (c === 255) {
                  switch (h.getByte()) {
                    case 0:
                      break;
                    case 255:
                      h.skip(-1);
                      break;
                    case 217:
                      P = !0;
                      break;
                    case 192:
                    case 193:
                    case 194:
                    case 195:
                    case 197:
                    case 198:
                    case 199:
                    case 201:
                    case 202:
                    case 203:
                    case 205:
                    case 206:
                    case 207:
                    case 196:
                    case 204:
                    case 218:
                    case 219:
                    case 220:
                    case 221:
                    case 222:
                    case 223:
                    case 224:
                    case 225:
                    case 226:
                    case 227:
                    case 228:
                    case 229:
                    case 230:
                    case 231:
                    case 232:
                    case 233:
                    case 234:
                    case 235:
                    case 236:
                    case 237:
                    case 238:
                    case 239:
                    case 254:
                      d = h.getUint16(), d > 2 ? h.skip(d - 2) : h.skip(-2);
                      break;
                  }
                  if (P)
                    break;
                }
              const A = h.pos - y;
              return c === -1 ? ((0, n.warn)("Inline DCTDecode image stream: EOI marker not found, searching for /EI/ instead."), h.skip(-A), this.findDefaultInlineStreamEnd(h)) : (this.inlineStreamSkipEI(h), A);
            }
            findASCII85DecodeInlineStreamEnd(h) {
              const c = h.pos;
              let d;
              for (; (d = h.getByte()) !== -1; )
                if (d === 126) {
                  const N = h.pos;
                  for (d = h.peekByte(); (0, q.isWhiteSpace)(d); )
                    h.skip(), d = h.peekByte();
                  if (d === 62) {
                    h.skip();
                    break;
                  }
                  if (h.pos > N) {
                    const E = h.peekBytes(2);
                    if (E[0] === 69 && E[1] === 73)
                      break;
                  }
                }
              const A = h.pos - c;
              return d === -1 ? ((0, n.warn)("Inline ASCII85Decode image stream: EOD marker not found, searching for /EI/ instead."), h.skip(-A), this.findDefaultInlineStreamEnd(h)) : (this.inlineStreamSkipEI(h), A);
            }
            findASCIIHexDecodeInlineStreamEnd(h) {
              const P = h.pos;
              let c;
              for (; (c = h.getByte()) !== -1 && c !== 62; )
                ;
              const d = h.pos - P;
              return c === -1 ? ((0, n.warn)("Inline ASCIIHexDecode image stream: EOD marker not found, searching for /EI/ instead."), h.skip(-d), this.findDefaultInlineStreamEnd(h)) : (this.inlineStreamSkipEI(h), d);
            }
            inlineStreamSkipEI(h) {
              let c = 0, d;
              for (; (d = h.getByte()) !== -1; )
                if (c === 0)
                  c = d === 69 ? 1 : 0;
                else if (c === 1)
                  c = d === 73 ? 2 : 0;
                else if (c === 2)
                  break;
            }
            makeInlineImage(h) {
              const y = this.lexer, P = y.stream, c = /* @__PURE__ */ Object.create(null);
              let d;
              for (; !(0, u.isCmd)(this.buf1, "ID") && this.buf1 !== u.EOF; ) {
                if (!(this.buf1 instanceof u.Name))
                  throw new n.FormatError("Dictionary key must be a name object");
                const T = this.buf1.name;
                if (this.shift(), this.buf1 === u.EOF)
                  break;
                c[T] = this.getObj(h);
              }
              y.beginInlineImagePos !== -1 && (d = P.pos - y.beginInlineImagePos);
              const A = this.xref.fetchIfRef(c.F || c.Filter);
              let N;
              if (A instanceof u.Name)
                N = A.name;
              else if (Array.isArray(A)) {
                const T = this.xref.fetchIfRef(A[0]);
                T instanceof u.Name && (N = T.name);
              }
              const E = P.pos;
              let H;
              switch (N) {
                case "DCT":
                case "DCTDecode":
                  H = this.findDCTDecodeInlineStreamEnd(P);
                  break;
                case "A85":
                case "ASCII85Decode":
                  H = this.findASCII85DecodeInlineStreamEnd(P);
                  break;
                case "AHx":
                case "ASCIIHexDecode":
                  H = this.findASCIIHexDecodeInlineStreamEnd(P);
                  break;
                default:
                  H = this.findDefaultInlineStreamEnd(P);
              }
              let $;
              if (H < s && d > 0) {
                const T = P.pos;
                P.pos = y.beginInlineImagePos, $ = l(P.getBytes(d + H)), P.pos = T;
                const L = this.imageCache[$];
                if (L !== void 0)
                  return this.buf2 = u.Cmd.get("EI"), this.shift(), L.reset(), L;
              }
              const m = new u.Dict(this.xref);
              for (const T in c)
                m.set(T, c[T]);
              let p = P.makeSubStream(E, H, m);
              return h && (p = h.createStream(p, H)), p = this.filter(p, m, H), p.dict = m, $ !== void 0 && (p.cacheKey = `inline_img_${++this._imageId}`, this.imageCache[$] = p), this.buf2 = u.Cmd.get("EI"), this.shift(), p;
            }
            _findStreamLength(h, y) {
              const {
                stream: P
              } = this.lexer;
              P.pos = h;
              const c = 2048, d = y.length;
              for (; P.pos < P.end; ) {
                const A = P.peekBytes(c), N = A.length - d;
                if (N <= 0)
                  break;
                let E = 0;
                for (; E < N; ) {
                  let H = 0;
                  for (; H < d && A[E + H] === y[H]; )
                    H++;
                  if (H >= d)
                    return P.pos += E, P.pos - h;
                  E++;
                }
                P.pos += N;
              }
              return -1;
            }
            makeStream(h, y) {
              const P = this.lexer;
              let c = P.stream;
              P.skipToNextLine();
              const d = c.pos - 1;
              let A = h.get("Length");
              if (Number.isInteger(A) || ((0, n.info)(`Bad length "${A && A.toString()}" in stream.`), A = 0), c.pos = d + A, P.nextChar(), this.tryShift() && (0, u.isCmd)(this.buf2, "endstream"))
                this.shift();
              else {
                const N = new Uint8Array([101, 110, 100, 115, 116, 114, 101, 97, 109]);
                let E = this._findStreamLength(d, N);
                if (E < 0) {
                  for (let $ = 1; $ <= 1; $++) {
                    const m = N.length - $, p = N.slice(0, m), T = this._findStreamLength(d, p);
                    if (T >= 0) {
                      const L = c.peekBytes(m + 1)[m];
                      if (!(0, q.isWhiteSpace)(L))
                        break;
                      (0, n.info)(`Found "${(0, n.bytesToString)(p)}" when searching for endstream command.`), E = T;
                      break;
                    }
                  }
                  if (E < 0)
                    throw new n.FormatError("Missing endstream command.");
                }
                A = E, P.nextChar(), this.shift(), this.shift();
              }
              return this.shift(), c = c.makeSubStream(d, A, h), y && (c = y.createStream(c, A)), c = this.filter(c, h, A), c.dict = h, c;
            }
            filter(h, y, P) {
              let c = y.get("F", "Filter"), d = y.get("DP", "DecodeParms");
              if (c instanceof u.Name)
                return Array.isArray(d) && (0, n.warn)("/DecodeParms should not be an Array, when /Filter is a Name."), this.makeFilter(h, c.name, P, d);
              let A = P;
              if (Array.isArray(c)) {
                const N = c, E = d;
                for (let H = 0, $ = N.length; H < $; ++H) {
                  if (c = this.xref.fetchIfRef(N[H]), !(c instanceof u.Name))
                    throw new n.FormatError(`Bad filter name "${c}"`);
                  d = null, Array.isArray(E) && H in E && (d = this.xref.fetchIfRef(E[H])), h = this.makeFilter(h, c.name, A, d), A = null;
                }
              }
              return h;
            }
            makeFilter(h, y, P, c) {
              if (P === 0)
                return (0, n.warn)(`Empty "${y}" stream.`), new e.NullStream();
              try {
                switch (y) {
                  case "Fl":
                  case "FlateDecode":
                    return c ? new o.PredictorStream(new M.FlateStream(h, P), P, c) : new M.FlateStream(h, P);
                  case "LZW":
                  case "LZWDecode":
                    let d = 1;
                    return c ? (c.has("EarlyChange") && (d = c.get("EarlyChange")), new o.PredictorStream(new i.LZWStream(h, P, d), P, c)) : new i.LZWStream(h, P, d);
                  case "DCT":
                  case "DCTDecode":
                    return new w.JpegStream(h, P, c);
                  case "JPX":
                  case "JPXDecode":
                    return new C.JpxStream(h, P, c);
                  case "A85":
                  case "ASCII85Decode":
                    return new t.Ascii85Stream(h, P);
                  case "AHx":
                  case "ASCIIHexDecode":
                    return new B.AsciiHexStream(h, P);
                  case "CCF":
                  case "CCITTFaxDecode":
                    return new j.CCITTFaxStream(h, P, c);
                  case "RL":
                  case "RunLengthDecode":
                    return new k.RunLengthStream(h, P);
                  case "JBIG2Decode":
                    return new O.Jbig2Stream(h, P, c);
                }
                return (0, n.warn)(`Filter "${y}" is not supported.`), h;
              } catch (d) {
                if (d instanceof q.MissingDataException)
                  throw d;
                return (0, n.warn)(`Invalid stream: "${d}"`), new e.NullStream();
              }
            }
          }
          F.Parser = g;
          const v = [1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 2, 0, 0, 2, 2, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
          function r(I) {
            return I >= 48 && I <= 57 ? I & 15 : I >= 65 && I <= 70 || I >= 97 && I <= 102 ? (I & 15) + 9 : -1;
          }
          class x {
            constructor(h, y = null) {
              this.stream = h, this.nextChar(), this.strBuf = [], this.knownCommands = y, this._hexStringNumWarn = 0, this.beginInlineImagePos = -1;
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            peekChar() {
              return this.stream.peekByte();
            }
            getNumber() {
              let h = this.currentChar, y = !1, P = 0, c = 0;
              if (h === 45 ? (c = -1, h = this.nextChar(), h === 45 && (h = this.nextChar())) : h === 43 && (c = 1, h = this.nextChar()), h === 10 || h === 13)
                do
                  h = this.nextChar();
                while (h === 10 || h === 13);
              if (h === 46 && (P = 10, h = this.nextChar()), h < 48 || h > 57) {
                const E = `Invalid number: ${String.fromCharCode(h)} (charCode ${h})`;
                if ((0, q.isWhiteSpace)(h) || h === -1)
                  return (0, n.info)(`Lexer.getNumber - "${E}".`), 0;
                throw new n.FormatError(E);
              }
              c || (c = 1);
              let d = h - 48, A = 0, N = 1;
              for (; (h = this.nextChar()) >= 0; )
                if (h >= 48 && h <= 57) {
                  const E = h - 48;
                  y ? A = A * 10 + E : (P !== 0 && (P *= 10), d = d * 10 + E);
                } else if (h === 46)
                  if (P === 0)
                    P = 1;
                  else
                    break;
                else if (h === 45)
                  (0, n.warn)("Badly formatted number: minus sign in the middle");
                else if (h === 69 || h === 101) {
                  if (h = this.peekChar(), h === 43 || h === 45)
                    N = h === 45 ? -1 : 1, this.nextChar();
                  else if (h < 48 || h > 57)
                    break;
                  y = !0;
                } else
                  break;
              return P !== 0 && (d /= P), y && (d *= 10 ** (N * A)), c * d;
            }
            getString() {
              let h = 1, y = !1;
              const P = this.strBuf;
              P.length = 0;
              let c = this.nextChar();
              for (; ; ) {
                let d = !1;
                switch (c | 0) {
                  case -1:
                    (0, n.warn)("Unterminated string"), y = !0;
                    break;
                  case 40:
                    ++h, P.push("(");
                    break;
                  case 41:
                    --h === 0 ? (this.nextChar(), y = !0) : P.push(")");
                    break;
                  case 92:
                    switch (c = this.nextChar(), c) {
                      case -1:
                        (0, n.warn)("Unterminated string"), y = !0;
                        break;
                      case 110:
                        P.push(`
`);
                        break;
                      case 114:
                        P.push("\r");
                        break;
                      case 116:
                        P.push("	");
                        break;
                      case 98:
                        P.push("\b");
                        break;
                      case 102:
                        P.push("\f");
                        break;
                      case 92:
                      case 40:
                      case 41:
                        P.push(String.fromCharCode(c));
                        break;
                      case 48:
                      case 49:
                      case 50:
                      case 51:
                      case 52:
                      case 53:
                      case 54:
                      case 55:
                        let A = c & 15;
                        c = this.nextChar(), d = !0, c >= 48 && c <= 55 && (A = (A << 3) + (c & 15), c = this.nextChar(), c >= 48 && c <= 55 && (d = !1, A = (A << 3) + (c & 15))), P.push(String.fromCharCode(A));
                        break;
                      case 13:
                        this.peekChar() === 10 && this.nextChar();
                        break;
                      case 10:
                        break;
                      default:
                        P.push(String.fromCharCode(c));
                        break;
                    }
                    break;
                  default:
                    P.push(String.fromCharCode(c));
                    break;
                }
                if (y)
                  break;
                d || (c = this.nextChar());
              }
              return P.join("");
            }
            getName() {
              let h, y;
              const P = this.strBuf;
              for (P.length = 0; (h = this.nextChar()) >= 0 && !v[h]; )
                if (h === 35) {
                  if (h = this.nextChar(), v[h]) {
                    (0, n.warn)("Lexer_getName: NUMBER SIGN (#) should be followed by a hexadecimal number."), P.push("#");
                    break;
                  }
                  const c = r(h);
                  if (c !== -1) {
                    y = h, h = this.nextChar();
                    const d = r(h);
                    if (d === -1) {
                      if ((0, n.warn)(`Lexer_getName: Illegal digit (${String.fromCharCode(h)}) in hexadecimal number.`), P.push("#", String.fromCharCode(y)), v[h])
                        break;
                      P.push(String.fromCharCode(h));
                      continue;
                    }
                    P.push(String.fromCharCode(c << 4 | d));
                  } else
                    P.push("#", String.fromCharCode(h));
                } else
                  P.push(String.fromCharCode(h));
              return P.length > 127 && (0, n.warn)(`Name token is longer than allowed by the spec: ${P.length}`), u.Name.get(P.join(""));
            }
            _hexStringWarn(h) {
              if (this._hexStringNumWarn++ === 5) {
                (0, n.warn)("getHexString - ignoring additional invalid characters.");
                return;
              }
              this._hexStringNumWarn > 5 || (0, n.warn)(`getHexString - ignoring invalid character: ${h}`);
            }
            getHexString() {
              const h = this.strBuf;
              h.length = 0;
              let y = this.currentChar, P = !0, c, d;
              for (this._hexStringNumWarn = 0; ; )
                if (y < 0) {
                  (0, n.warn)("Unterminated hex string");
                  break;
                } else if (y === 62) {
                  this.nextChar();
                  break;
                } else if (v[y] === 1) {
                  y = this.nextChar();
                  continue;
                } else {
                  if (P) {
                    if (c = r(y), c === -1) {
                      this._hexStringWarn(y), y = this.nextChar();
                      continue;
                    }
                  } else {
                    if (d = r(y), d === -1) {
                      this._hexStringWarn(y), y = this.nextChar();
                      continue;
                    }
                    h.push(String.fromCharCode(c << 4 | d));
                  }
                  P = !P, y = this.nextChar();
                }
              return h.join("");
            }
            getObj() {
              let h = !1, y = this.currentChar;
              for (; ; ) {
                if (y < 0)
                  return u.EOF;
                if (h)
                  (y === 10 || y === 13) && (h = !1);
                else if (y === 37)
                  h = !0;
                else if (v[y] !== 1)
                  break;
                y = this.nextChar();
              }
              switch (y | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return this.getNumber();
                case 40:
                  return this.getString();
                case 47:
                  return this.getName();
                case 91:
                  return this.nextChar(), u.Cmd.get("[");
                case 93:
                  return this.nextChar(), u.Cmd.get("]");
                case 60:
                  return y = this.nextChar(), y === 60 ? (this.nextChar(), u.Cmd.get("<<")) : this.getHexString();
                case 62:
                  return y = this.nextChar(), y === 62 ? (this.nextChar(), u.Cmd.get(">>")) : u.Cmd.get(">");
                case 123:
                  return this.nextChar(), u.Cmd.get("{");
                case 125:
                  return this.nextChar(), u.Cmd.get("}");
                case 41:
                  throw this.nextChar(), new n.FormatError(`Illegal character: ${y}`);
              }
              let P = String.fromCharCode(y);
              if (y < 32 || y > 127) {
                const A = this.peekChar();
                if (A >= 32 && A <= 127)
                  return this.nextChar(), u.Cmd.get(P);
              }
              const c = this.knownCommands;
              let d = (c == null ? void 0 : c[P]) !== void 0;
              for (; (y = this.nextChar()) >= 0 && !v[y]; ) {
                const A = P + String.fromCharCode(y);
                if (d && c[A] === void 0)
                  break;
                if (P.length === 128)
                  throw new n.FormatError(`Command token too long: ${P.length}`);
                P = A, d = (c == null ? void 0 : c[P]) !== void 0;
              }
              return P === "true" ? !0 : P === "false" ? !1 : P === "null" ? null : (P === "BI" && (this.beginInlineImagePos = this.stream.pos), u.Cmd.get(P));
            }
            skipToNextLine() {
              let h = this.currentChar;
              for (; h >= 0; ) {
                if (h === 13) {
                  h = this.nextChar(), h === 10 && this.nextChar();
                  break;
                } else if (h === 10) {
                  this.nextChar();
                  break;
                }
                h = this.nextChar();
              }
            }
          }
          F.Lexer = x;
          class b {
            static create(h) {
              function y(m, p, T = !1) {
                const L = m.get(p);
                if (Number.isInteger(L) && (T ? L >= 0 : L > 0))
                  return L;
                throw new Error(`The "${p}" parameter in the linearization dictionary is invalid.`);
              }
              function P(m) {
                const p = m.get("H");
                let T;
                if (Array.isArray(p) && ((T = p.length) === 2 || T === 4)) {
                  for (let L = 0; L < T; L++) {
                    const _ = p[L];
                    if (!(Number.isInteger(_) && _ > 0))
                      throw new Error(`Hint (${L}) in the linearization dictionary is invalid.`);
                  }
                  return p;
                }
                throw new Error("Hint array in the linearization dictionary is invalid.");
              }
              const c = new g({
                lexer: new x(h),
                xref: null
              }), d = c.getObj(), A = c.getObj(), N = c.getObj(), E = c.getObj();
              let H, $;
              if (Number.isInteger(d) && Number.isInteger(A) && (0, u.isCmd)(N, "obj") && E instanceof u.Dict && typeof (H = E.get("Linearized")) == "number" && H > 0) {
                if (($ = y(E, "L")) !== h.length)
                  throw new Error('The "L" parameter in the linearization dictionary does not equal the stream length.');
              } else
                return null;
              return {
                length: $,
                hints: P(E),
                objectNumberFirst: y(E, "O"),
                endFirst: y(E, "E"),
                numPages: y(E, "N"),
                mainXRefEntriesOffset: y(E, "T"),
                pageFirst: E.has("P") ? y(E, "P", !0) : 0
              };
            }
          }
          F.Linearization = b;
        },
        /* 17 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Ascii85Stream = void 0;
          var n = ae(18), u = ae(3);
          class q extends n.DecodeStream {
            constructor(t, B) {
              B && (B *= 0.8), super(B), this.str = t, this.dict = t.dict, this.input = new Uint8Array(5);
            }
            readBlock() {
              const M = this.str;
              let O = M.getByte();
              for (; (0, u.isWhiteSpace)(O); )
                O = M.getByte();
              if (O === -1 || O === 126) {
                this.eof = !0;
                return;
              }
              const w = this.bufferLength;
              let C, i;
              if (O === 122) {
                for (C = this.ensureBuffer(w + 4), i = 0; i < 4; ++i)
                  C[w + i] = 0;
                this.bufferLength += 4;
              } else {
                const o = this.input;
                for (o[0] = O, i = 1; i < 5; ++i) {
                  for (O = M.getByte(); (0, u.isWhiteSpace)(O); )
                    O = M.getByte();
                  if (o[i] = O, O === -1 || O === 126)
                    break;
                }
                if (C = this.ensureBuffer(w + i - 1), this.bufferLength += i - 1, i < 5) {
                  for (; i < 5; ++i)
                    o[i] = 117;
                  this.eof = !0;
                }
                let k = 0;
                for (i = 0; i < 5; ++i)
                  k = k * 85 + (o[i] - 33);
                for (i = 3; i >= 0; --i)
                  C[w + i] = k & 255, k >>= 8;
              }
            }
          }
          F.Ascii85Stream = q;
        },
        /* 18 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.StreamsSequenceStream = F.DecodeStream = void 0;
          var n = ae(5), u = ae(8);
          const q = new Uint8Array(0);
          class e extends n.BaseStream {
            constructor(j) {
              if (super(), this._rawMinBufferLength = j || 0, this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = q, this.minBufferLength = 512, j)
                for (; this.minBufferLength < j; )
                  this.minBufferLength *= 2;
            }
            get isEmpty() {
              for (; !this.eof && this.bufferLength === 0; )
                this.readBlock();
              return this.bufferLength === 0;
            }
            ensureBuffer(j) {
              const M = this.buffer;
              if (j <= M.byteLength)
                return M;
              let O = this.minBufferLength;
              for (; O < j; )
                O *= 2;
              const w = new Uint8Array(O);
              return w.set(M), this.buffer = w;
            }
            getByte() {
              const j = this.pos;
              for (; this.bufferLength <= j; ) {
                if (this.eof)
                  return -1;
                this.readBlock();
              }
              return this.buffer[this.pos++];
            }
            getBytes(j) {
              const M = this.pos;
              let O;
              if (j) {
                for (this.ensureBuffer(M + j), O = M + j; !this.eof && this.bufferLength < O; )
                  this.readBlock();
                const w = this.bufferLength;
                O > w && (O = w);
              } else {
                for (; !this.eof; )
                  this.readBlock();
                O = this.bufferLength;
              }
              return this.pos = O, this.buffer.subarray(M, O);
            }
            reset() {
              this.pos = 0;
            }
            makeSubStream(j, M, O = null) {
              if (M === void 0)
                for (; !this.eof; )
                  this.readBlock();
              else {
                const w = j + M;
                for (; this.bufferLength <= w && !this.eof; )
                  this.readBlock();
              }
              return new u.Stream(this.buffer, j, M, O);
            }
            getBaseStreams() {
              return this.str ? this.str.getBaseStreams() : null;
            }
          }
          F.DecodeStream = e;
          class t extends e {
            constructor(j, M = null) {
              let O = 0;
              for (const w of j)
                O += w instanceof e ? w._rawMinBufferLength : w.length;
              super(O), this.streams = j, this._onError = M;
            }
            readBlock() {
              var o;
              const j = this.streams;
              if (j.length === 0) {
                this.eof = !0;
                return;
              }
              const M = j.shift();
              let O;
              try {
                O = M.getBytes();
              } catch (k) {
                if (this._onError) {
                  this._onError(k, (o = M.dict) == null ? void 0 : o.objId);
                  return;
                }
                throw k;
              }
              const w = this.bufferLength, C = w + O.length;
              this.ensureBuffer(C).set(O, w), this.bufferLength = C;
            }
            getBaseStreams() {
              const j = [];
              for (const M of this.streams) {
                const O = M.getBaseStreams();
                O && j.push(...O);
              }
              return j.length > 0 ? j : null;
            }
          }
          F.StreamsSequenceStream = t;
        },
        /* 19 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.AsciiHexStream = void 0;
          var n = ae(18);
          class u extends n.DecodeStream {
            constructor(e, t) {
              t && (t *= 0.5), super(t), this.str = e, this.dict = e.dict, this.firstDigit = -1;
            }
            readBlock() {
              const t = this.str.getBytes(8e3);
              if (!t.length) {
                this.eof = !0;
                return;
              }
              const B = t.length + 1 >> 1, j = this.ensureBuffer(this.bufferLength + B);
              let M = this.bufferLength, O = this.firstDigit;
              for (const w of t) {
                let C;
                if (w >= 48 && w <= 57)
                  C = w & 15;
                else if (w >= 65 && w <= 70 || w >= 97 && w <= 102)
                  C = (w & 15) + 9;
                else if (w === 62) {
                  this.eof = !0;
                  break;
                } else
                  continue;
                O < 0 ? O = C : (j[M++] = O << 4 | C, O = -1);
              }
              O >= 0 && this.eof && (j[M++] = O << 4, O = -1), this.firstDigit = O, this.bufferLength = M;
            }
          }
          F.AsciiHexStream = u;
        },
        /* 20 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.CCITTFaxStream = void 0;
          var n = ae(21), u = ae(18), q = ae(4);
          class e extends u.DecodeStream {
            constructor(B, j, M) {
              super(j), this.str = B, this.dict = B.dict, M instanceof q.Dict || (M = q.Dict.empty);
              const O = {
                next() {
                  return B.getByte();
                }
              };
              this.ccittFaxDecoder = new n.CCITTFaxDecoder(O, {
                K: M.get("K"),
                EndOfLine: M.get("EndOfLine"),
                EncodedByteAlign: M.get("EncodedByteAlign"),
                Columns: M.get("Columns"),
                Rows: M.get("Rows"),
                EndOfBlock: M.get("EndOfBlock"),
                BlackIs1: M.get("BlackIs1")
              });
            }
            readBlock() {
              for (; !this.eof; ) {
                const B = this.ccittFaxDecoder.readNextChar();
                if (B === -1) {
                  this.eof = !0;
                  return;
                }
                this.ensureBuffer(this.bufferLength + 1), this.buffer[this.bufferLength++] = B;
              }
            }
          }
          F.CCITTFaxStream = e;
        },
        /* 21 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.CCITTFaxDecoder = void 0;
          var n = ae(2);
          const u = -2, q = -1, e = 0, t = 1, B = 2, j = 3, M = 4, O = 5, w = 6, C = 7, i = 8, o = [[-1, -1], [-1, -1], [7, i], [7, C], [6, w], [6, w], [6, O], [6, O], [4, e], [4, e], [4, e], [4, e], [4, e], [4, e], [4, e], [4, e], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, t], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, M], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [3, j], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B], [1, B]], k = [[-1, -1], [12, u], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [12, 1984], [12, 2048], [12, 2112], [12, 2176], [12, 2240], [12, 2304], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [12, 2368], [12, 2432], [12, 2496], [12, 2560]], s = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [8, 29], [8, 29], [8, 30], [8, 30], [8, 45], [8, 45], [8, 46], [8, 46], [7, 22], [7, 22], [7, 22], [7, 22], [7, 23], [7, 23], [7, 23], [7, 23], [8, 47], [8, 47], [8, 48], [8, 48], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [6, 13], [7, 20], [7, 20], [7, 20], [7, 20], [8, 33], [8, 33], [8, 34], [8, 34], [8, 35], [8, 35], [8, 36], [8, 36], [8, 37], [8, 37], [8, 38], [8, 38], [7, 19], [7, 19], [7, 19], [7, 19], [8, 31], [8, 31], [8, 32], [8, 32], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 1], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [6, 12], [8, 53], [8, 53], [8, 54], [8, 54], [7, 26], [7, 26], [7, 26], [7, 26], [8, 39], [8, 39], [8, 40], [8, 40], [8, 41], [8, 41], [8, 42], [8, 42], [8, 43], [8, 43], [8, 44], [8, 44], [7, 21], [7, 21], [7, 21], [7, 21], [7, 28], [7, 28], [7, 28], [7, 28], [8, 61], [8, 61], [8, 62], [8, 62], [8, 63], [8, 63], [8, 0], [8, 0], [8, 320], [8, 320], [8, 384], [8, 384], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 10], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [5, 11], [7, 27], [7, 27], [7, 27], [7, 27], [8, 59], [8, 59], [8, 60], [8, 60], [9, 1472], [9, 1536], [9, 1600], [9, 1728], [7, 18], [7, 18], [7, 18], [7, 18], [7, 24], [7, 24], [7, 24], [7, 24], [8, 49], [8, 49], [8, 50], [8, 50], [8, 51], [8, 51], [8, 52], [8, 52], [7, 25], [7, 25], [7, 25], [7, 25], [8, 55], [8, 55], [8, 56], [8, 56], [8, 57], [8, 57], [8, 58], [8, 58], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 192], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [6, 1664], [8, 448], [8, 448], [8, 512], [8, 512], [9, 704], [9, 768], [8, 640], [8, 640], [8, 576], [8, 576], [9, 832], [9, 896], [9, 960], [9, 1024], [9, 1088], [9, 1152], [9, 1216], [9, 1280], [9, 1344], [9, 1408], [7, 256], [7, 256], [7, 256], [7, 256], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 2], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [4, 3], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 128], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 8], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [5, 9], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 16], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [6, 17], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 4], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [4, 5], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 14], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [6, 15], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [5, 64], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 6], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7], [4, 7]], l = [[-1, -1], [-1, -1], [12, u], [12, u], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [-1, -1], [11, 1792], [11, 1792], [11, 1792], [11, 1792], [12, 1984], [12, 1984], [12, 2048], [12, 2048], [12, 2112], [12, 2112], [12, 2176], [12, 2176], [12, 2240], [12, 2240], [12, 2304], [12, 2304], [11, 1856], [11, 1856], [11, 1856], [11, 1856], [11, 1920], [11, 1920], [11, 1920], [11, 1920], [12, 2368], [12, 2368], [12, 2432], [12, 2432], [12, 2496], [12, 2496], [12, 2560], [12, 2560], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [10, 18], [12, 52], [12, 52], [13, 640], [13, 704], [13, 768], [13, 832], [12, 55], [12, 55], [12, 56], [12, 56], [13, 1280], [13, 1344], [13, 1408], [13, 1472], [12, 59], [12, 59], [12, 60], [12, 60], [13, 1536], [13, 1600], [11, 24], [11, 24], [11, 24], [11, 24], [11, 25], [11, 25], [11, 25], [11, 25], [13, 1664], [13, 1728], [12, 320], [12, 320], [12, 384], [12, 384], [12, 448], [12, 448], [13, 512], [13, 576], [12, 53], [12, 53], [12, 54], [12, 54], [13, 896], [13, 960], [13, 1024], [13, 1088], [13, 1152], [13, 1216], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64], [10, 64]], g = [[8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [8, 13], [11, 23], [11, 23], [12, 50], [12, 51], [12, 44], [12, 45], [12, 46], [12, 47], [12, 57], [12, 58], [12, 61], [12, 256], [10, 16], [10, 16], [10, 16], [10, 16], [10, 17], [10, 17], [10, 17], [10, 17], [12, 48], [12, 49], [12, 62], [12, 63], [12, 30], [12, 31], [12, 32], [12, 33], [12, 40], [12, 41], [11, 22], [11, 22], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [8, 14], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 10], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [7, 11], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [9, 15], [12, 128], [12, 192], [12, 26], [12, 27], [12, 28], [12, 29], [11, 19], [11, 19], [11, 20], [11, 20], [12, 34], [12, 35], [12, 36], [12, 37], [12, 38], [12, 39], [11, 21], [11, 21], [12, 42], [12, 43], [10, 0], [10, 0], [10, 0], [10, 0], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12], [7, 12]], v = [[-1, -1], [-1, -1], [-1, -1], [-1, -1], [6, 9], [6, 8], [5, 7], [5, 7], [4, 6], [4, 6], [4, 6], [4, 6], [4, 5], [4, 5], [4, 5], [4, 5], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 1], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [3, 4], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 3], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2], [2, 2]];
          class r {
            constructor(b, I = {}) {
              if (!b || typeof b.next != "function")
                throw new Error('CCITTFaxDecoder - invalid "source" parameter.');
              this.source = b, this.eof = !1, this.encoding = I.K || 0, this.eoline = I.EndOfLine || !1, this.byteAlign = I.EncodedByteAlign || !1, this.columns = I.Columns || 1728, this.rows = I.Rows || 0, this.eoblock = I.EndOfBlock ?? !0, this.black = I.BlackIs1 || !1, this.codingLine = new Uint32Array(this.columns + 1), this.refLine = new Uint32Array(this.columns + 2), this.codingLine[0] = this.columns, this.codingPos = 0, this.row = 0, this.nextLine2D = this.encoding < 0, this.inputBits = 0, this.inputBuf = 0, this.outputBits = 0, this.rowsDone = !1;
              let h;
              for (; (h = this._lookBits(12)) === 0; )
                this._eatBits(1);
              h === 1 && this._eatBits(12), this.encoding > 0 && (this.nextLine2D = !this._lookBits(1), this._eatBits(1));
            }
            readNextChar() {
              if (this.eof)
                return -1;
              const b = this.refLine, I = this.codingLine, h = this.columns;
              let y, P, c, d;
              if (this.outputBits === 0) {
                if (this.rowsDone && (this.eof = !0), this.eof)
                  return -1;
                this.err = !1;
                let N, E, H;
                if (this.nextLine2D) {
                  for (d = 0; I[d] < h; ++d)
                    b[d] = I[d];
                  for (b[d++] = h, b[d] = h, I[0] = 0, this.codingPos = 0, y = 0, P = 0; I[this.codingPos] < h; )
                    switch (N = this._getTwoDimCode(), N) {
                      case e:
                        this._addPixels(b[y + 1], P), b[y + 1] < h && (y += 2);
                        break;
                      case t:
                        if (N = E = 0, P) {
                          do
                            N += H = this._getBlackCode();
                          while (H >= 64);
                          do
                            E += H = this._getWhiteCode();
                          while (H >= 64);
                        } else {
                          do
                            N += H = this._getWhiteCode();
                          while (H >= 64);
                          do
                            E += H = this._getBlackCode();
                          while (H >= 64);
                        }
                        for (this._addPixels(I[this.codingPos] + N, P), I[this.codingPos] < h && this._addPixels(I[this.codingPos] + E, P ^ 1); b[y] <= I[this.codingPos] && b[y] < h; )
                          y += 2;
                        break;
                      case C:
                        if (this._addPixels(b[y] + 3, P), P ^= 1, I[this.codingPos] < h)
                          for (++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case O:
                        if (this._addPixels(b[y] + 2, P), P ^= 1, I[this.codingPos] < h)
                          for (++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case j:
                        if (this._addPixels(b[y] + 1, P), P ^= 1, I[this.codingPos] < h)
                          for (++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case B:
                        if (this._addPixels(b[y], P), P ^= 1, I[this.codingPos] < h)
                          for (++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case i:
                        if (this._addPixelsNeg(b[y] - 3, P), P ^= 1, I[this.codingPos] < h)
                          for (y > 0 ? --y : ++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case w:
                        if (this._addPixelsNeg(b[y] - 2, P), P ^= 1, I[this.codingPos] < h)
                          for (y > 0 ? --y : ++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case M:
                        if (this._addPixelsNeg(b[y] - 1, P), P ^= 1, I[this.codingPos] < h)
                          for (y > 0 ? --y : ++y; b[y] <= I[this.codingPos] && b[y] < h; )
                            y += 2;
                        break;
                      case q:
                        this._addPixels(h, 0), this.eof = !0;
                        break;
                      default:
                        (0, n.info)("bad 2d code"), this._addPixels(h, 0), this.err = !0;
                    }
                } else
                  for (I[0] = 0, this.codingPos = 0, P = 0; I[this.codingPos] < h; ) {
                    if (N = 0, P)
                      do
                        N += H = this._getBlackCode();
                      while (H >= 64);
                    else
                      do
                        N += H = this._getWhiteCode();
                      while (H >= 64);
                    this._addPixels(I[this.codingPos] + N, P), P ^= 1;
                  }
                let $ = !1;
                if (this.byteAlign && (this.inputBits &= -8), !this.eoblock && this.row === this.rows - 1)
                  this.rowsDone = !0;
                else {
                  if (N = this._lookBits(12), this.eoline)
                    for (; N !== q && N !== 1; )
                      this._eatBits(1), N = this._lookBits(12);
                  else
                    for (; N === 0; )
                      this._eatBits(1), N = this._lookBits(12);
                  N === 1 ? (this._eatBits(12), $ = !0) : N === q && (this.eof = !0);
                }
                if (!this.eof && this.encoding > 0 && !this.rowsDone && (this.nextLine2D = !this._lookBits(1), this._eatBits(1)), this.eoblock && $ && this.byteAlign) {
                  if (N = this._lookBits(12), N === 1) {
                    if (this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1)), this.encoding >= 0)
                      for (d = 0; d < 4; ++d)
                        N = this._lookBits(12), N !== 1 && (0, n.info)("bad rtc code: " + N), this._eatBits(12), this.encoding > 0 && (this._lookBits(1), this._eatBits(1));
                    this.eof = !0;
                  }
                } else if (this.err && this.eoline) {
                  for (; ; ) {
                    if (N = this._lookBits(13), N === q)
                      return this.eof = !0, -1;
                    if (N >> 1 === 1)
                      break;
                    this._eatBits(1);
                  }
                  this._eatBits(12), this.encoding > 0 && (this._eatBits(1), this.nextLine2D = !(N & 1));
                }
                I[0] > 0 ? this.outputBits = I[this.codingPos = 0] : this.outputBits = I[this.codingPos = 1], this.row++;
              }
              let A;
              if (this.outputBits >= 8)
                A = this.codingPos & 1 ? 0 : 255, this.outputBits -= 8, this.outputBits === 0 && I[this.codingPos] < h && (this.codingPos++, this.outputBits = I[this.codingPos] - I[this.codingPos - 1]);
              else {
                c = 8, A = 0;
                do {
                  if (typeof this.outputBits != "number")
                    throw new n.FormatError('Invalid /CCITTFaxDecode data, "outputBits" must be a number.');
                  this.outputBits > c ? (A <<= c, this.codingPos & 1 || (A |= 255 >> 8 - c), this.outputBits -= c, c = 0) : (A <<= this.outputBits, this.codingPos & 1 || (A |= 255 >> 8 - this.outputBits), c -= this.outputBits, this.outputBits = 0, I[this.codingPos] < h ? (this.codingPos++, this.outputBits = I[this.codingPos] - I[this.codingPos - 1]) : c > 0 && (A <<= c, c = 0));
                } while (c);
              }
              return this.black && (A ^= 255), A;
            }
            _addPixels(b, I) {
              const h = this.codingLine;
              let y = this.codingPos;
              b > h[y] && (b > this.columns && ((0, n.info)("row is wrong length"), this.err = !0, b = this.columns), y & 1 ^ I && ++y, h[y] = b), this.codingPos = y;
            }
            _addPixelsNeg(b, I) {
              const h = this.codingLine;
              let y = this.codingPos;
              if (b > h[y])
                b > this.columns && ((0, n.info)("row is wrong length"), this.err = !0, b = this.columns), y & 1 ^ I && ++y, h[y] = b;
              else if (b < h[y]) {
                for (b < 0 && ((0, n.info)("invalid code"), this.err = !0, b = 0); y > 0 && b < h[y - 1]; )
                  --y;
                h[y] = b;
              }
              this.codingPos = y;
            }
            _findTableCode(b, I, h, y) {
              const P = y || 0;
              for (let c = b; c <= I; ++c) {
                let d = this._lookBits(c);
                if (d === q)
                  return [!0, 1, !1];
                if (c < I && (d <<= I - c), !P || d >= P) {
                  const A = h[d - P];
                  if (A[0] === c)
                    return this._eatBits(c), [!0, A[1], !0];
                }
              }
              return [!1, 0, !1];
            }
            _getTwoDimCode() {
              let b = 0, I;
              if (this.eoblock) {
                if (b = this._lookBits(7), I = o[b], (I == null ? void 0 : I[0]) > 0)
                  return this._eatBits(I[0]), I[1];
              } else {
                const h = this._findTableCode(1, 7, o);
                if (h[0] && h[2])
                  return h[1];
              }
              return (0, n.info)("Bad two dim code"), q;
            }
            _getWhiteCode() {
              let b = 0, I;
              if (this.eoblock) {
                if (b = this._lookBits(12), b === q)
                  return 1;
                if (b >> 5 ? I = s[b >> 3] : I = k[b], I[0] > 0)
                  return this._eatBits(I[0]), I[1];
              } else {
                let h = this._findTableCode(1, 9, s);
                if (h[0] || (h = this._findTableCode(11, 12, k), h[0]))
                  return h[1];
              }
              return (0, n.info)("bad white code"), this._eatBits(1), 1;
            }
            _getBlackCode() {
              let b, I;
              if (this.eoblock) {
                if (b = this._lookBits(13), b === q)
                  return 1;
                if (b >> 7 ? !(b >> 9) && b >> 7 ? I = g[(b >> 1) - 64] : I = v[b >> 7] : I = l[b], I[0] > 0)
                  return this._eatBits(I[0]), I[1];
              } else {
                let h = this._findTableCode(2, 6, v);
                if (h[0] || (h = this._findTableCode(7, 12, g, 64), h[0]) || (h = this._findTableCode(10, 13, l), h[0]))
                  return h[1];
              }
              return (0, n.info)("bad black code"), this._eatBits(1), 1;
            }
            _lookBits(b) {
              let I;
              for (; this.inputBits < b; ) {
                if ((I = this.source.next()) === -1)
                  return this.inputBits === 0 ? q : this.inputBuf << b - this.inputBits & 65535 >> 16 - b;
                this.inputBuf = this.inputBuf << 8 | I, this.inputBits += 8;
              }
              return this.inputBuf >> this.inputBits - b & 65535 >> 16 - b;
            }
            _eatBits(b) {
              (this.inputBits -= b) < 0 && (this.inputBits = 0);
            }
          }
          F.CCITTFaxDecoder = r;
        },
        /* 22 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.FlateStream = void 0;
          var n = ae(18), u = ae(2);
          const q = new Int32Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]), e = new Int32Array([3, 4, 5, 6, 7, 8, 9, 10, 65547, 65549, 65551, 65553, 131091, 131095, 131099, 131103, 196643, 196651, 196659, 196667, 262211, 262227, 262243, 262259, 327811, 327843, 327875, 327907, 258, 258, 258]), t = new Int32Array([1, 2, 3, 4, 65541, 65543, 131081, 131085, 196625, 196633, 262177, 262193, 327745, 327777, 393345, 393409, 459009, 459137, 524801, 525057, 590849, 591361, 657409, 658433, 724993, 727041, 794625, 798721, 868353, 876545]), B = [new Int32Array([459008, 524368, 524304, 524568, 459024, 524400, 524336, 590016, 459016, 524384, 524320, 589984, 524288, 524416, 524352, 590048, 459012, 524376, 524312, 589968, 459028, 524408, 524344, 590032, 459020, 524392, 524328, 59e4, 524296, 524424, 524360, 590064, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590024, 459018, 524388, 524324, 589992, 524292, 524420, 524356, 590056, 459014, 524380, 524316, 589976, 459030, 524412, 524348, 590040, 459022, 524396, 524332, 590008, 524300, 524428, 524364, 590072, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590020, 459017, 524386, 524322, 589988, 524290, 524418, 524354, 590052, 459013, 524378, 524314, 589972, 459029, 524410, 524346, 590036, 459021, 524394, 524330, 590004, 524298, 524426, 524362, 590068, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590028, 459019, 524390, 524326, 589996, 524294, 524422, 524358, 590060, 459015, 524382, 524318, 589980, 459031, 524414, 524350, 590044, 459023, 524398, 524334, 590012, 524302, 524430, 524366, 590076, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590018, 459016, 524385, 524321, 589986, 524289, 524417, 524353, 590050, 459012, 524377, 524313, 589970, 459028, 524409, 524345, 590034, 459020, 524393, 524329, 590002, 524297, 524425, 524361, 590066, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590026, 459018, 524389, 524325, 589994, 524293, 524421, 524357, 590058, 459014, 524381, 524317, 589978, 459030, 524413, 524349, 590042, 459022, 524397, 524333, 590010, 524301, 524429, 524365, 590074, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590022, 459017, 524387, 524323, 589990, 524291, 524419, 524355, 590054, 459013, 524379, 524315, 589974, 459029, 524411, 524347, 590038, 459021, 524395, 524331, 590006, 524299, 524427, 524363, 590070, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590030, 459019, 524391, 524327, 589998, 524295, 524423, 524359, 590062, 459015, 524383, 524319, 589982, 459031, 524415, 524351, 590046, 459023, 524399, 524335, 590014, 524303, 524431, 524367, 590078, 459008, 524368, 524304, 524568, 459024, 524400, 524336, 590017, 459016, 524384, 524320, 589985, 524288, 524416, 524352, 590049, 459012, 524376, 524312, 589969, 459028, 524408, 524344, 590033, 459020, 524392, 524328, 590001, 524296, 524424, 524360, 590065, 459010, 524372, 524308, 524572, 459026, 524404, 524340, 590025, 459018, 524388, 524324, 589993, 524292, 524420, 524356, 590057, 459014, 524380, 524316, 589977, 459030, 524412, 524348, 590041, 459022, 524396, 524332, 590009, 524300, 524428, 524364, 590073, 459009, 524370, 524306, 524570, 459025, 524402, 524338, 590021, 459017, 524386, 524322, 589989, 524290, 524418, 524354, 590053, 459013, 524378, 524314, 589973, 459029, 524410, 524346, 590037, 459021, 524394, 524330, 590005, 524298, 524426, 524362, 590069, 459011, 524374, 524310, 524574, 459027, 524406, 524342, 590029, 459019, 524390, 524326, 589997, 524294, 524422, 524358, 590061, 459015, 524382, 524318, 589981, 459031, 524414, 524350, 590045, 459023, 524398, 524334, 590013, 524302, 524430, 524366, 590077, 459008, 524369, 524305, 524569, 459024, 524401, 524337, 590019, 459016, 524385, 524321, 589987, 524289, 524417, 524353, 590051, 459012, 524377, 524313, 589971, 459028, 524409, 524345, 590035, 459020, 524393, 524329, 590003, 524297, 524425, 524361, 590067, 459010, 524373, 524309, 524573, 459026, 524405, 524341, 590027, 459018, 524389, 524325, 589995, 524293, 524421, 524357, 590059, 459014, 524381, 524317, 589979, 459030, 524413, 524349, 590043, 459022, 524397, 524333, 590011, 524301, 524429, 524365, 590075, 459009, 524371, 524307, 524571, 459025, 524403, 524339, 590023, 459017, 524387, 524323, 589991, 524291, 524419, 524355, 590055, 459013, 524379, 524315, 589975, 459029, 524411, 524347, 590039, 459021, 524395, 524331, 590007, 524299, 524427, 524363, 590071, 459011, 524375, 524311, 524575, 459027, 524407, 524343, 590031, 459019, 524391, 524327, 589999, 524295, 524423, 524359, 590063, 459015, 524383, 524319, 589983, 459031, 524415, 524351, 590047, 459023, 524399, 524335, 590015, 524303, 524431, 524367, 590079]), 9], j = [new Int32Array([327680, 327696, 327688, 327704, 327684, 327700, 327692, 327708, 327682, 327698, 327690, 327706, 327686, 327702, 327694, 0, 327681, 327697, 327689, 327705, 327685, 327701, 327693, 327709, 327683, 327699, 327691, 327707, 327687, 327703, 327695, 0]), 5];
          class M extends n.DecodeStream {
            constructor(w, C) {
              super(C), this.str = w, this.dict = w.dict;
              const i = w.getByte(), o = w.getByte();
              if (i === -1 || o === -1)
                throw new u.FormatError(`Invalid header in flate stream: ${i}, ${o}`);
              if ((i & 15) !== 8)
                throw new u.FormatError(`Unknown compression method in flate stream: ${i}, ${o}`);
              if (((i << 8) + o) % 31 !== 0)
                throw new u.FormatError(`Bad FCHECK in flate stream: ${i}, ${o}`);
              if (o & 32)
                throw new u.FormatError(`FDICT bit set in flate stream: ${i}, ${o}`);
              this.codeSize = 0, this.codeBuf = 0;
            }
            getBits(w) {
              const C = this.str;
              let i = this.codeSize, o = this.codeBuf, k;
              for (; i < w; ) {
                if ((k = C.getByte()) === -1)
                  throw new u.FormatError("Bad encoding in flate stream");
                o |= k << i, i += 8;
              }
              return k = o & (1 << w) - 1, this.codeBuf = o >> w, this.codeSize = i -= w, k;
            }
            getCode(w) {
              const C = this.str, i = w[0], o = w[1];
              let k = this.codeSize, s = this.codeBuf, l;
              for (; k < o && (l = C.getByte()) !== -1; )
                s |= l << k, k += 8;
              const g = i[s & (1 << o) - 1], v = g >> 16, r = g & 65535;
              if (v < 1 || k < v)
                throw new u.FormatError("Bad encoding in flate stream");
              return this.codeBuf = s >> v, this.codeSize = k - v, r;
            }
            generateHuffmanTable(w) {
              const C = w.length;
              let i = 0, o;
              for (o = 0; o < C; ++o)
                w[o] > i && (i = w[o]);
              const k = 1 << i, s = new Int32Array(k);
              for (let l = 1, g = 0, v = 2; l <= i; ++l, g <<= 1, v <<= 1)
                for (let r = 0; r < C; ++r)
                  if (w[r] === l) {
                    let x = 0, b = g;
                    for (o = 0; o < l; ++o)
                      x = x << 1 | b & 1, b >>= 1;
                    for (o = x; o < k; o += v)
                      s[o] = l << 16 | r;
                    ++g;
                  }
              return [s, i];
            }
            readBlock() {
              let w, C;
              const i = this.str;
              let o = this.getBits(3);
              if (o & 1 && (this.eof = !0), o >>= 1, o === 0) {
                let v;
                if ((v = i.getByte()) === -1)
                  throw new u.FormatError("Bad block header in flate stream");
                let r = v;
                if ((v = i.getByte()) === -1)
                  throw new u.FormatError("Bad block header in flate stream");
                if (r |= v << 8, (v = i.getByte()) === -1)
                  throw new u.FormatError("Bad block header in flate stream");
                let x = v;
                if ((v = i.getByte()) === -1)
                  throw new u.FormatError("Bad block header in flate stream");
                if (x |= v << 8, x !== (~r & 65535) && (r !== 0 || x !== 0))
                  throw new u.FormatError("Bad uncompressed block length in flate stream");
                this.codeBuf = 0, this.codeSize = 0;
                const b = this.bufferLength, I = b + r;
                if (w = this.ensureBuffer(I), this.bufferLength = I, r === 0)
                  i.peekByte() === -1 && (this.eof = !0);
                else {
                  const h = i.getBytes(r);
                  w.set(h, b), h.length < r && (this.eof = !0);
                }
                return;
              }
              let k, s;
              if (o === 1)
                k = B, s = j;
              else if (o === 2) {
                const v = this.getBits(5) + 257, r = this.getBits(5) + 1, x = this.getBits(4) + 4, b = new Uint8Array(q.length);
                let I;
                for (I = 0; I < x; ++I)
                  b[q[I]] = this.getBits(3);
                const h = this.generateHuffmanTable(b);
                C = 0, I = 0;
                const y = v + r, P = new Uint8Array(y);
                let c, d, A;
                for (; I < y; ) {
                  const N = this.getCode(h);
                  if (N === 16)
                    c = 2, d = 3, A = C;
                  else if (N === 17)
                    c = 3, d = 3, A = C = 0;
                  else if (N === 18)
                    c = 7, d = 11, A = C = 0;
                  else {
                    P[I++] = C = N;
                    continue;
                  }
                  let E = this.getBits(c) + d;
                  for (; E-- > 0; )
                    P[I++] = A;
                }
                k = this.generateHuffmanTable(P.subarray(0, v)), s = this.generateHuffmanTable(P.subarray(v, y));
              } else
                throw new u.FormatError("Unknown block type in flate stream");
              w = this.buffer;
              let l = w ? w.length : 0, g = this.bufferLength;
              for (; ; ) {
                let v = this.getCode(k);
                if (v < 256) {
                  g + 1 >= l && (w = this.ensureBuffer(g + 1), l = w.length), w[g++] = v;
                  continue;
                }
                if (v === 256) {
                  this.bufferLength = g;
                  return;
                }
                v -= 257, v = e[v];
                let r = v >> 16;
                r > 0 && (r = this.getBits(r)), C = (v & 65535) + r, v = this.getCode(s), v = t[v], r = v >> 16, r > 0 && (r = this.getBits(r));
                const x = (v & 65535) + r;
                g + C >= l && (w = this.ensureBuffer(g + C), l = w.length);
                for (let b = 0; b < C; ++b, ++g)
                  w[g] = w[g - x];
              }
            }
          }
          F.FlateStream = M;
        },
        /* 23 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Jbig2Stream = void 0;
          var n = ae(5), u = ae(18), q = ae(4), e = ae(24), t = ae(2);
          class B extends u.DecodeStream {
            constructor(M, O, w) {
              super(O), this.stream = M, this.dict = M.dict, this.maybeLength = O, this.params = w;
            }
            get bytes() {
              return (0, t.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(M) {
            }
            readBlock() {
              if (this.eof)
                return;
              const M = new e.Jbig2Image(), O = [];
              if (this.params instanceof q.Dict) {
                const i = this.params.get("JBIG2Globals");
                if (i instanceof n.BaseStream) {
                  const o = i.getBytes();
                  O.push({
                    data: o,
                    start: 0,
                    end: o.length
                  });
                }
              }
              O.push({
                data: this.bytes,
                start: 0,
                end: this.bytes.length
              });
              const w = M.parseChunks(O), C = w.length;
              for (let i = 0; i < C; i++)
                w[i] ^= 255;
              this.buffer = w, this.bufferLength = C, this.eof = !0;
            }
          }
          F.Jbig2Stream = B;
        },
        /* 24 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Jbig2Image = void 0;
          var n = ae(2), u = ae(3), q = ae(25), e = ae(21);
          class t extends n.BaseException {
            constructor(f) {
              super(`JBIG2 error: ${f}`, "Jbig2Error");
            }
          }
          class B {
            getContexts(f) {
              return f in this ? this[f] : this[f] = new Int8Array(65536);
            }
          }
          class j {
            constructor(f, D, z) {
              this.data = f, this.start = D, this.end = z;
            }
            get decoder() {
              const f = new q.ArithmeticDecoder(this.data, this.start, this.end);
              return (0, n.shadow)(this, "decoder", f);
            }
            get contextCache() {
              const f = new B();
              return (0, n.shadow)(this, "contextCache", f);
            }
          }
          const M = 2 ** 31 - 1, O = -(2 ** 31);
          function w(R, f, D) {
            const z = R.getContexts(f);
            let Y = 1;
            function W(ee) {
              let te = 0;
              for (let oe = 0; oe < ee; oe++) {
                const se = D.readBit(z, Y);
                Y = Y < 256 ? Y << 1 | se : (Y << 1 | se) & 511 | 256, te = te << 1 | se;
              }
              return te >>> 0;
            }
            const ie = W(1), ne = W(1) ? W(1) ? W(1) ? W(1) ? W(1) ? W(32) + 4436 : W(12) + 340 : W(8) + 84 : W(6) + 20 : W(4) + 4 : W(2);
            let re;
            return ie === 0 ? re = ne : ne > 0 && (re = -ne), re >= O && re <= M ? re : null;
          }
          function C(R, f, D) {
            const z = R.getContexts("IAID");
            let Y = 1;
            for (let W = 0; W < D; W++) {
              const ie = f.readBit(z, Y);
              Y = Y << 1 | ie;
            }
            return D < 31 ? Y & (1 << D) - 1 : Y & 2147483647;
          }
          const i = ["SymbolDictionary", null, null, null, "IntermediateTextRegion", null, "ImmediateTextRegion", "ImmediateLosslessTextRegion", null, null, null, null, null, null, null, null, "PatternDictionary", null, null, null, "IntermediateHalftoneRegion", null, "ImmediateHalftoneRegion", "ImmediateLosslessHalftoneRegion", null, null, null, null, null, null, null, null, null, null, null, null, "IntermediateGenericRegion", null, "ImmediateGenericRegion", "ImmediateLosslessGenericRegion", "IntermediateGenericRefinementRegion", null, "ImmediateGenericRefinementRegion", "ImmediateLosslessGenericRefinementRegion", null, null, null, null, "PageInformation", "EndOfPage", "EndOfStripe", "EndOfFile", "Profiles", "Tables", null, null, null, null, null, null, null, null, "Extension"], o = [[{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: 2,
            y: -1
          }, {
            x: -4,
            y: 0
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: 2,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: 2,
            y: -1
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -1,
            y: -2
          }, {
            x: 0,
            y: -2
          }, {
            x: 1,
            y: -2
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }], [{
            x: -3,
            y: -1
          }, {
            x: -2,
            y: -1
          }, {
            x: -1,
            y: -1
          }, {
            x: 0,
            y: -1
          }, {
            x: 1,
            y: -1
          }, {
            x: -4,
            y: 0
          }, {
            x: -3,
            y: 0
          }, {
            x: -2,
            y: 0
          }, {
            x: -1,
            y: 0
          }]], k = [{
            coding: [{
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }],
            reference: [{
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }, {
              x: 0,
              y: 0
            }, {
              x: 1,
              y: 0
            }, {
              x: -1,
              y: 1
            }, {
              x: 0,
              y: 1
            }, {
              x: 1,
              y: 1
            }]
          }, {
            coding: [{
              x: -1,
              y: -1
            }, {
              x: 0,
              y: -1
            }, {
              x: 1,
              y: -1
            }, {
              x: -1,
              y: 0
            }],
            reference: [{
              x: 0,
              y: -1
            }, {
              x: -1,
              y: 0
            }, {
              x: 0,
              y: 0
            }, {
              x: 1,
              y: 0
            }, {
              x: 0,
              y: 1
            }, {
              x: 1,
              y: 1
            }]
          }], s = [39717, 1941, 229, 405], l = [32, 8];
          function g(R, f, D) {
            const z = D.decoder, Y = D.contextCache.getContexts("GB"), W = [];
            let ie, ne, re, ee, te, oe, se;
            const ce = 31735;
            for (ne = 0; ne < f; ne++)
              for (te = W[ne] = new Uint8Array(R), oe = ne < 1 ? te : W[ne - 1], se = ne < 2 ? te : W[ne - 2], ie = se[0] << 13 | se[1] << 12 | se[2] << 11 | oe[0] << 7 | oe[1] << 6 | oe[2] << 5 | oe[3] << 4, re = 0; re < R; re++)
                te[re] = ee = z.readBit(Y, ie), ie = (ie & ce) << 1 | (re + 3 < R ? se[re + 3] << 11 : 0) | (re + 4 < R ? oe[re + 4] << 4 : 0) | ee;
            return W;
          }
          function v(R, f, D, z, Y, W, ie, ne) {
            if (R) {
              const We = new G(ne.data, ne.start, ne.end);
              return Q(We, f, D, !1);
            }
            if (z === 0 && !W && !Y && ie.length === 4 && ie[0].x === 3 && ie[0].y === -1 && ie[1].x === -3 && ie[1].y === -1 && ie[2].x === 2 && ie[2].y === -2 && ie[3].x === -2 && ie[3].y === -2)
              return g(f, D, ne);
            const re = !!W, ee = o[z].concat(ie);
            ee.sort(function(We, gt) {
              return We.y - gt.y || We.x - gt.x;
            });
            const te = ee.length, oe = new Int8Array(te), se = new Int8Array(te), ce = [];
            let le = 0, de = 0, Ie = 0, Fe = 0, we, pe;
            for (pe = 0; pe < te; pe++)
              oe[pe] = ee[pe].x, se[pe] = ee[pe].y, de = Math.min(de, ee[pe].x), Ie = Math.max(Ie, ee[pe].x), Fe = Math.min(Fe, ee[pe].y), pe < te - 1 && ee[pe].y === ee[pe + 1].y && ee[pe].x === ee[pe + 1].x - 1 ? le |= 1 << te - 1 - pe : ce.push(pe);
            const fe = ce.length, Ae = new Int8Array(fe), Pe = new Int8Array(fe), Re = new Uint16Array(fe);
            for (we = 0; we < fe; we++)
              pe = ce[we], Ae[we] = ee[pe].x, Pe[we] = ee[pe].y, Re[we] = 1 << te - 1 - pe;
            const Ee = -de, ye = -Fe, Te = f - Ie, je = s[z];
            let ve = new Uint8Array(f);
            const Ce = [], Ne = ne.decoder, Ge = ne.contextCache.getContexts("GB");
            let Oe = 0, tt, Ke, et, Xe = 0, Qe, it;
            for (let We = 0; We < D; We++) {
              if (Y) {
                const gt = Ne.readBit(Ge, je);
                if (Oe ^= gt, Oe) {
                  Ce.push(ve);
                  continue;
                }
              }
              for (ve = new Uint8Array(ve), Ce.push(ve), tt = 0; tt < f; tt++) {
                if (re && W[We][tt]) {
                  ve[tt] = 0;
                  continue;
                }
                if (tt >= Ee && tt < Te && We >= ye)
                  for (Xe = Xe << 1 & le, pe = 0; pe < fe; pe++)
                    Ke = We + Pe[pe], et = tt + Ae[pe], Qe = Ce[Ke][et], Qe && (Qe = Re[pe], Xe |= Qe);
                else
                  for (Xe = 0, it = te - 1, pe = 0; pe < te; pe++, it--)
                    et = tt + oe[pe], et >= 0 && et < f && (Ke = We + se[pe], Ke >= 0 && (Qe = Ce[Ke][et], Qe && (Xe |= Qe << it)));
                const gt = Ne.readBit(Ge, Xe);
                ve[tt] = gt;
              }
            }
            return Ce;
          }
          function r(R, f, D, z, Y, W, ie, ne, re) {
            let ee = k[D].coding;
            D === 0 && (ee = ee.concat([ne[0]]));
            const te = ee.length, oe = new Int32Array(te), se = new Int32Array(te);
            let ce;
            for (ce = 0; ce < te; ce++)
              oe[ce] = ee[ce].x, se[ce] = ee[ce].y;
            let le = k[D].reference;
            D === 0 && (le = le.concat([ne[1]]));
            const de = le.length, Ie = new Int32Array(de), Fe = new Int32Array(de);
            for (ce = 0; ce < de; ce++)
              Ie[ce] = le[ce].x, Fe[ce] = le[ce].y;
            const we = z[0].length, pe = z.length, fe = l[D], Ae = [], Pe = re.decoder, Re = re.contextCache.getContexts("GR");
            let Ee = 0;
            for (let ye = 0; ye < f; ye++) {
              if (ie) {
                const je = Pe.readBit(Re, fe);
                if (Ee ^= je, Ee)
                  throw new t("prediction is not supported");
              }
              const Te = new Uint8Array(R);
              Ae.push(Te);
              for (let je = 0; je < R; je++) {
                let ve, Ce, Ne = 0;
                for (ce = 0; ce < te; ce++)
                  ve = ye + se[ce], Ce = je + oe[ce], ve < 0 || Ce < 0 || Ce >= R ? Ne <<= 1 : Ne = Ne << 1 | Ae[ve][Ce];
                for (ce = 0; ce < de; ce++)
                  ve = ye + Fe[ce] - W, Ce = je + Ie[ce] - Y, ve < 0 || ve >= pe || Ce < 0 || Ce >= we ? Ne <<= 1 : Ne = Ne << 1 | z[ve][Ce];
                const Ge = Pe.readBit(Re, Ne);
                Te[je] = Ge;
              }
            }
            return Ae;
          }
          function x(R, f, D, z, Y, W, ie, ne, re, ee, te, oe) {
            if (R && f)
              throw new t("symbol refinement with Huffman is not supported");
            const se = [];
            let ce = 0, le = (0, u.log2)(D.length + z);
            const de = te.decoder, Ie = te.contextCache;
            let Fe, we;
            for (R && (Fe = _(1), we = [], le = Math.max(le, 1)); se.length < z; ) {
              const ye = R ? W.tableDeltaHeight.decode(oe) : w(Ie, "IADH", de);
              ce += ye;
              let Te = 0, je = 0;
              const ve = R ? we.length : 0;
              for (; ; ) {
                const Ce = R ? W.tableDeltaWidth.decode(oe) : w(Ie, "IADW", de);
                if (Ce === null)
                  break;
                Te += Ce, je += Te;
                let Ne;
                if (f) {
                  const Ge = w(Ie, "IAAI", de);
                  if (Ge > 1)
                    Ne = b(R, f, Te, ce, 0, Ge, 1, D.concat(se), le, 0, 0, 1, 0, W, re, ee, te, 0, oe);
                  else {
                    const Oe = C(Ie, de, le), tt = w(Ie, "IARDX", de), Ke = w(Ie, "IARDY", de), et = Oe < D.length ? D[Oe] : se[Oe - D.length];
                    Ne = r(Te, ce, re, et, tt, Ke, !1, ee, te);
                  }
                  se.push(Ne);
                } else
                  R ? we.push(Te) : (Ne = v(!1, Te, ce, ie, !1, null, ne, te), se.push(Ne));
              }
              if (R && !f) {
                const Ce = W.tableBitmapSize.decode(oe);
                oe.byteAlign();
                let Ne;
                if (Ce === 0)
                  Ne = U(oe, je, ce);
                else {
                  const Oe = oe.end, tt = oe.position + Ce;
                  oe.end = tt, Ne = Q(oe, je, ce, !1), oe.end = Oe, oe.position = tt;
                }
                const Ge = we.length;
                if (ve === Ge - 1)
                  se.push(Ne);
                else {
                  let Oe, tt, Ke = 0, et, Xe, Qe;
                  for (Oe = ve; Oe < Ge; Oe++) {
                    for (Xe = we[Oe], et = Ke + Xe, Qe = [], tt = 0; tt < ce; tt++)
                      Qe.push(Ne[tt].subarray(Ke, et));
                    se.push(Qe), Ke = et;
                  }
                }
              }
            }
            const pe = [], fe = [];
            let Ae = !1, Pe, Re;
            const Ee = D.length + z;
            for (; fe.length < Ee; ) {
              let ye = R ? Fe.decode(oe) : w(Ie, "IAEX", de);
              for (; ye--; )
                fe.push(Ae);
              Ae = !Ae;
            }
            for (Pe = 0, Re = D.length; Pe < Re; Pe++)
              fe[Pe] && pe.push(D[Pe]);
            for (let ye = 0; ye < z; Pe++, ye++)
              fe[Pe] && pe.push(se[ye]);
            return pe;
          }
          function b(R, f, D, z, Y, W, ie, ne, re, ee, te, oe, se, ce, le, de, Ie, Fe, we) {
            if (R && f)
              throw new t("refinement with Huffman is not supported");
            const pe = [];
            let fe, Ae;
            for (fe = 0; fe < z; fe++) {
              if (Ae = new Uint8Array(D), Y)
                for (let Te = 0; Te < D; Te++)
                  Ae[Te] = Y;
              pe.push(Ae);
            }
            const Pe = Ie.decoder, Re = Ie.contextCache;
            let Ee = R ? -ce.tableDeltaT.decode(we) : -w(Re, "IADT", Pe), ye = 0;
            for (fe = 0; fe < W; ) {
              const Te = R ? ce.tableDeltaT.decode(we) : w(Re, "IADT", Pe);
              Ee += Te;
              const je = R ? ce.tableFirstS.decode(we) : w(Re, "IAFS", Pe);
              ye += je;
              let ve = ye;
              do {
                let Ce = 0;
                ie > 1 && (Ce = R ? we.readBits(Fe) : w(Re, "IAIT", Pe));
                const Ne = ie * Ee + Ce, Ge = R ? ce.symbolIDTable.decode(we) : C(Re, Pe, re), Oe = f && (R ? we.readBit() : w(Re, "IARI", Pe));
                let tt = ne[Ge], Ke = tt[0].length, et = tt.length;
                if (Oe) {
                  const Ct = w(Re, "IARDW", Pe), Pt = w(Re, "IARDH", Pe), at = w(Re, "IARDX", Pe), dt = w(Re, "IARDY", Pe);
                  Ke += Ct, et += Pt, tt = r(Ke, et, le, tt, (Ct >> 1) + at, (Pt >> 1) + dt, !1, de, Ie);
                }
                const Xe = Ne - (oe & 1 ? 0 : et - 1), Qe = ve - (oe & 2 ? Ke - 1 : 0);
                let it, We, gt;
                if (ee) {
                  for (it = 0; it < et; it++) {
                    if (Ae = pe[Qe + it], !Ae)
                      continue;
                    gt = tt[it];
                    const Ct = Math.min(D - Xe, Ke);
                    switch (se) {
                      case 0:
                        for (We = 0; We < Ct; We++)
                          Ae[Xe + We] |= gt[We];
                        break;
                      case 2:
                        for (We = 0; We < Ct; We++)
                          Ae[Xe + We] ^= gt[We];
                        break;
                      default:
                        throw new t(`operator ${se} is not supported`);
                    }
                  }
                  ve += et - 1;
                } else {
                  for (We = 0; We < et; We++)
                    if (Ae = pe[Xe + We], !!Ae)
                      switch (gt = tt[We], se) {
                        case 0:
                          for (it = 0; it < Ke; it++)
                            Ae[Qe + it] |= gt[it];
                          break;
                        case 2:
                          for (it = 0; it < Ke; it++)
                            Ae[Qe + it] ^= gt[it];
                          break;
                        default:
                          throw new t(`operator ${se} is not supported`);
                      }
                  ve += Ke - 1;
                }
                fe++;
                const mt = R ? ce.tableDeltaS.decode(we) : w(Re, "IADS", Pe);
                if (mt === null)
                  break;
                ve += mt + te;
              } while (!0);
            }
            return pe;
          }
          function I(R, f, D, z, Y, W) {
            const ie = [];
            R || (ie.push({
              x: -f,
              y: 0
            }), Y === 0 && ie.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            }));
            const ne = (z + 1) * f, re = v(R, ne, D, Y, !1, null, ie, W), ee = [];
            for (let te = 0; te <= z; te++) {
              const oe = [], se = f * te, ce = se + f;
              for (let le = 0; le < D; le++)
                oe.push(re[le].subarray(se, ce));
              ee.push(oe);
            }
            return ee;
          }
          function h(R, f, D, z, Y, W, ie, ne, re, ee, te, oe, se, ce, le) {
            if (ie)
              throw new t("skip is not supported");
            if (ne !== 0)
              throw new t(`operator "${ne}" is not supported in halftone region`);
            const Ie = [];
            let Fe, we, pe;
            for (Fe = 0; Fe < Y; Fe++) {
              if (pe = new Uint8Array(z), W)
                for (we = 0; we < z; we++)
                  pe[we] = W;
              Ie.push(pe);
            }
            const fe = f.length, Ae = f[0], Pe = Ae[0].length, Re = Ae.length, Ee = (0, u.log2)(fe), ye = [];
            R || (ye.push({
              x: D <= 1 ? 3 : 2,
              y: -1
            }), D === 0 && ye.push({
              x: -3,
              y: -1
            }, {
              x: 2,
              y: -2
            }, {
              x: -2,
              y: -2
            }));
            const Te = [];
            let je, ve;
            for (R && (je = new G(le.data, le.start, le.end)), Fe = Ee - 1; Fe >= 0; Fe--)
              R ? ve = Q(je, re, ee, !0) : ve = v(!1, re, ee, D, !1, null, ye, le), Te[Fe] = ve;
            let Ce, Ne, Ge, Oe, tt, Ke, et, Xe, Qe;
            for (Ce = 0; Ce < ee; Ce++)
              for (Ne = 0; Ne < re; Ne++) {
                for (Ge = 0, Oe = 0, we = Ee - 1; we >= 0; we--)
                  Ge ^= Te[we][Ce][Ne], Oe |= Ge << we;
                if (tt = f[Oe], Ke = te + Ce * ce + Ne * se >> 8, et = oe + Ce * se - Ne * ce >> 8, Ke >= 0 && Ke + Pe <= z && et >= 0 && et + Re <= Y)
                  for (Fe = 0; Fe < Re; Fe++)
                    for (Qe = Ie[et + Fe], Xe = tt[Fe], we = 0; we < Pe; we++)
                      Qe[Ke + we] |= Xe[we];
                else {
                  let it, We;
                  for (Fe = 0; Fe < Re; Fe++)
                    if (We = et + Fe, !(We < 0 || We >= Y))
                      for (Qe = Ie[We], Xe = tt[Fe], we = 0; we < Pe; we++)
                        it = Ke + we, it >= 0 && it < z && (Qe[it] |= Xe[we]);
                }
              }
            return Ie;
          }
          function y(R, f) {
            const D = {};
            D.number = (0, u.readUint32)(R, f);
            const z = R[f + 4], Y = z & 63;
            if (!i[Y])
              throw new t("invalid segment type: " + Y);
            D.type = Y, D.typeName = i[Y], D.deferredNonRetain = !!(z & 128);
            const W = !!(z & 64), ie = R[f + 5];
            let ne = ie >> 5 & 7;
            const re = [ie & 31];
            let ee = f + 6;
            if (ie === 7) {
              ne = (0, u.readUint32)(R, ee - 1) & 536870911, ee += 3;
              let le = ne + 7 >> 3;
              for (re[0] = R[ee++]; --le > 0; )
                re.push(R[ee++]);
            } else if (ie === 5 || ie === 6)
              throw new t("invalid referred-to flags");
            D.retainBits = re;
            let te = 4;
            D.number <= 256 ? te = 1 : D.number <= 65536 && (te = 2);
            const oe = [];
            let se, ce;
            for (se = 0; se < ne; se++) {
              let le;
              te === 1 ? le = R[ee] : te === 2 ? le = (0, u.readUint16)(R, ee) : le = (0, u.readUint32)(R, ee), oe.push(le), ee += te;
            }
            if (D.referredTo = oe, W ? (D.pageAssociation = (0, u.readUint32)(R, ee), ee += 4) : D.pageAssociation = R[ee++], D.length = (0, u.readUint32)(R, ee), ee += 4, D.length === 4294967295)
              if (Y === 38) {
                const le = c(R, ee), Ie = !!(R[ee + d] & 1), Fe = 6, we = new Uint8Array(Fe);
                for (Ie || (we[0] = 255, we[1] = 172), we[2] = le.height >>> 24 & 255, we[3] = le.height >> 16 & 255, we[4] = le.height >> 8 & 255, we[5] = le.height & 255, se = ee, ce = R.length; se < ce; se++) {
                  let pe = 0;
                  for (; pe < Fe && we[pe] === R[se + pe]; )
                    pe++;
                  if (pe === Fe) {
                    D.length = se + Fe;
                    break;
                  }
                }
                if (D.length === 4294967295)
                  throw new t("segment end was not found");
              } else
                throw new t("invalid unknown segment length");
            return D.headerEnd = ee, D;
          }
          function P(R, f, D, z) {
            const Y = [];
            let W = D;
            for (; W < z; ) {
              const ie = y(f, W);
              W = ie.headerEnd;
              const ne = {
                header: ie,
                data: f
              };
              if (R.randomAccess || (ne.start = W, W += ie.length, ne.end = W), Y.push(ne), ie.type === 51)
                break;
            }
            if (R.randomAccess)
              for (let ie = 0, ne = Y.length; ie < ne; ie++)
                Y[ie].start = W, W += Y[ie].header.length, Y[ie].end = W;
            return Y;
          }
          function c(R, f) {
            return {
              width: (0, u.readUint32)(R, f),
              height: (0, u.readUint32)(R, f + 4),
              x: (0, u.readUint32)(R, f + 8),
              y: (0, u.readUint32)(R, f + 12),
              combinationOperator: R[f + 16] & 7
            };
          }
          const d = 17;
          function A(R, f) {
            const D = R.header, z = R.data, Y = R.end;
            let W = R.start, ie, ne, re, ee;
            switch (D.type) {
              case 0:
                const oe = {}, se = (0, u.readUint16)(z, W);
                if (oe.huffman = !!(se & 1), oe.refinement = !!(se & 2), oe.huffmanDHSelector = se >> 2 & 3, oe.huffmanDWSelector = se >> 4 & 3, oe.bitmapSizeSelector = se >> 6 & 1, oe.aggregationInstancesSelector = se >> 7 & 1, oe.bitmapCodingContextUsed = !!(se & 256), oe.bitmapCodingContextRetained = !!(se & 512), oe.template = se >> 10 & 3, oe.refinementTemplate = se >> 12 & 1, W += 2, !oe.huffman) {
                  for (ee = oe.template === 0 ? 4 : 1, ne = [], re = 0; re < ee; re++)
                    ne.push({
                      x: (0, u.readInt8)(z, W),
                      y: (0, u.readInt8)(z, W + 1)
                    }), W += 2;
                  oe.at = ne;
                }
                if (oe.refinement && !oe.refinementTemplate) {
                  for (ne = [], re = 0; re < 2; re++)
                    ne.push({
                      x: (0, u.readInt8)(z, W),
                      y: (0, u.readInt8)(z, W + 1)
                    }), W += 2;
                  oe.refinementAt = ne;
                }
                oe.numberOfExportedSymbols = (0, u.readUint32)(z, W), W += 4, oe.numberOfNewSymbols = (0, u.readUint32)(z, W), W += 4, ie = [oe, D.number, D.referredTo, z, W, Y];
                break;
              case 6:
              case 7:
                const ce = {};
                ce.info = c(z, W), W += d;
                const le = (0, u.readUint16)(z, W);
                if (W += 2, ce.huffman = !!(le & 1), ce.refinement = !!(le & 2), ce.logStripSize = le >> 2 & 3, ce.stripSize = 1 << ce.logStripSize, ce.referenceCorner = le >> 4 & 3, ce.transposed = !!(le & 64), ce.combinationOperator = le >> 7 & 3, ce.defaultPixelValue = le >> 9 & 1, ce.dsOffset = le << 17 >> 27, ce.refinementTemplate = le >> 15 & 1, ce.huffman) {
                  const Re = (0, u.readUint16)(z, W);
                  W += 2, ce.huffmanFS = Re & 3, ce.huffmanDS = Re >> 2 & 3, ce.huffmanDT = Re >> 4 & 3, ce.huffmanRefinementDW = Re >> 6 & 3, ce.huffmanRefinementDH = Re >> 8 & 3, ce.huffmanRefinementDX = Re >> 10 & 3, ce.huffmanRefinementDY = Re >> 12 & 3, ce.huffmanRefinementSizeSelector = !!(Re & 16384);
                }
                if (ce.refinement && !ce.refinementTemplate) {
                  for (ne = [], re = 0; re < 2; re++)
                    ne.push({
                      x: (0, u.readInt8)(z, W),
                      y: (0, u.readInt8)(z, W + 1)
                    }), W += 2;
                  ce.refinementAt = ne;
                }
                ce.numberOfSymbolInstances = (0, u.readUint32)(z, W), W += 4, ie = [ce, D.referredTo, z, W, Y];
                break;
              case 16:
                const de = {}, Ie = z[W++];
                de.mmr = !!(Ie & 1), de.template = Ie >> 1 & 3, de.patternWidth = z[W++], de.patternHeight = z[W++], de.maxPatternIndex = (0, u.readUint32)(z, W), W += 4, ie = [de, D.number, z, W, Y];
                break;
              case 22:
              case 23:
                const Fe = {};
                Fe.info = c(z, W), W += d;
                const we = z[W++];
                Fe.mmr = !!(we & 1), Fe.template = we >> 1 & 3, Fe.enableSkip = !!(we & 8), Fe.combinationOperator = we >> 4 & 7, Fe.defaultPixelValue = we >> 7 & 1, Fe.gridWidth = (0, u.readUint32)(z, W), W += 4, Fe.gridHeight = (0, u.readUint32)(z, W), W += 4, Fe.gridOffsetX = (0, u.readUint32)(z, W) & 4294967295, W += 4, Fe.gridOffsetY = (0, u.readUint32)(z, W) & 4294967295, W += 4, Fe.gridVectorX = (0, u.readUint16)(z, W), W += 2, Fe.gridVectorY = (0, u.readUint16)(z, W), W += 2, ie = [Fe, D.referredTo, z, W, Y];
                break;
              case 38:
              case 39:
                const pe = {};
                pe.info = c(z, W), W += d;
                const fe = z[W++];
                if (pe.mmr = !!(fe & 1), pe.template = fe >> 1 & 3, pe.prediction = !!(fe & 8), !pe.mmr) {
                  for (ee = pe.template === 0 ? 4 : 1, ne = [], re = 0; re < ee; re++)
                    ne.push({
                      x: (0, u.readInt8)(z, W),
                      y: (0, u.readInt8)(z, W + 1)
                    }), W += 2;
                  pe.at = ne;
                }
                ie = [pe, z, W, Y];
                break;
              case 48:
                const Ae = {
                  width: (0, u.readUint32)(z, W),
                  height: (0, u.readUint32)(z, W + 4),
                  resolutionX: (0, u.readUint32)(z, W + 8),
                  resolutionY: (0, u.readUint32)(z, W + 12)
                };
                Ae.height === 4294967295 && delete Ae.height;
                const Pe = z[W + 16];
                (0, u.readUint16)(z, W + 17), Ae.lossless = !!(Pe & 1), Ae.refinement = !!(Pe & 2), Ae.defaultPixelValue = Pe >> 2 & 1, Ae.combinationOperator = Pe >> 3 & 3, Ae.requiresBuffer = !!(Pe & 32), Ae.combinationOperatorOverride = !!(Pe & 64), ie = [Ae];
                break;
              case 49:
                break;
              case 50:
                break;
              case 51:
                break;
              case 53:
                ie = [D.number, z, W, Y];
                break;
              case 62:
                break;
              default:
                throw new t(`segment type ${D.typeName}(${D.type}) is not implemented`);
            }
            const te = "on" + D.typeName;
            te in f && f[te].apply(f, ie);
          }
          function N(R, f) {
            for (let D = 0, z = R.length; D < z; D++)
              A(R[D], f);
          }
          function E(R) {
            const f = new H();
            for (let D = 0, z = R.length; D < z; D++) {
              const Y = R[D], W = P({}, Y.data, Y.start, Y.end);
              N(W, f);
            }
            return f.buffer;
          }
          class H {
            onPageInformation(f) {
              this.currentPageInfo = f;
              const D = f.width + 7 >> 3, z = new Uint8ClampedArray(D * f.height);
              f.defaultPixelValue && z.fill(255), this.buffer = z;
            }
            drawBitmap(f, D) {
              const z = this.currentPageInfo, Y = f.width, W = f.height, ie = z.width + 7 >> 3, ne = z.combinationOperatorOverride ? f.combinationOperator : z.combinationOperator, re = this.buffer, ee = 128 >> (f.x & 7);
              let te = f.y * ie + (f.x >> 3), oe, se, ce, le;
              switch (ne) {
                case 0:
                  for (oe = 0; oe < W; oe++) {
                    for (ce = ee, le = te, se = 0; se < Y; se++)
                      D[oe][se] && (re[le] |= ce), ce >>= 1, ce || (ce = 128, le++);
                    te += ie;
                  }
                  break;
                case 2:
                  for (oe = 0; oe < W; oe++) {
                    for (ce = ee, le = te, se = 0; se < Y; se++)
                      D[oe][se] && (re[le] ^= ce), ce >>= 1, ce || (ce = 128, le++);
                    te += ie;
                  }
                  break;
                default:
                  throw new t(`operator ${ne} is not supported`);
              }
            }
            onImmediateGenericRegion(f, D, z, Y) {
              const W = f.info, ie = new j(D, z, Y), ne = v(f.mmr, W.width, W.height, f.template, f.prediction, null, f.at, ie);
              this.drawBitmap(W, ne);
            }
            onImmediateLosslessGenericRegion() {
              this.onImmediateGenericRegion(...arguments);
            }
            onSymbolDictionary(f, D, z, Y, W, ie) {
              let ne, re;
              f.huffman && (ne = V(f, z, this.customTables), re = new G(Y, W, ie));
              let ee = this.symbols;
              ee || (this.symbols = ee = {});
              const te = [];
              for (const se of z) {
                const ce = ee[se];
                ce && te.push(...ce);
              }
              const oe = new j(Y, W, ie);
              ee[D] = x(f.huffman, f.refinement, te, f.numberOfNewSymbols, f.numberOfExportedSymbols, ne, f.template, f.at, f.refinementTemplate, f.refinementAt, oe, re);
            }
            onImmediateTextRegion(f, D, z, Y, W) {
              const ie = f.info;
              let ne, re;
              const ee = this.symbols, te = [];
              for (const le of D) {
                const de = ee[le];
                de && te.push(...de);
              }
              const oe = (0, u.log2)(te.length);
              f.huffman && (re = new G(z, Y, W), ne = K(f, D, this.customTables, te.length, re));
              const se = new j(z, Y, W), ce = b(f.huffman, f.refinement, ie.width, ie.height, f.defaultPixelValue, f.numberOfSymbolInstances, f.stripSize, te, oe, f.transposed, f.dsOffset, f.referenceCorner, f.combinationOperator, ne, f.refinementTemplate, f.refinementAt, se, f.logStripSize, re);
              this.drawBitmap(ie, ce);
            }
            onImmediateLosslessTextRegion() {
              this.onImmediateTextRegion(...arguments);
            }
            onPatternDictionary(f, D, z, Y, W) {
              let ie = this.patterns;
              ie || (this.patterns = ie = {});
              const ne = new j(z, Y, W);
              ie[D] = I(f.mmr, f.patternWidth, f.patternHeight, f.maxPatternIndex, f.template, ne);
            }
            onImmediateHalftoneRegion(f, D, z, Y, W) {
              const ie = this.patterns[D[0]], ne = f.info, re = new j(z, Y, W), ee = h(f.mmr, ie, f.template, ne.width, ne.height, f.defaultPixelValue, f.enableSkip, f.combinationOperator, f.gridWidth, f.gridHeight, f.gridOffsetX, f.gridOffsetY, f.gridVectorX, f.gridVectorY, re);
              this.drawBitmap(ne, ee);
            }
            onImmediateLosslessHalftoneRegion() {
              this.onImmediateHalftoneRegion(...arguments);
            }
            onTables(f, D, z, Y) {
              let W = this.customTables;
              W || (this.customTables = W = {}), W[f] = T(D, z, Y);
            }
          }
          class $ {
            constructor(f) {
              f.length === 2 ? (this.isOOB = !0, this.rangeLow = 0, this.prefixLength = f[0], this.rangeLength = 0, this.prefixCode = f[1], this.isLowerRange = !1) : (this.isOOB = !1, this.rangeLow = f[0], this.prefixLength = f[1], this.rangeLength = f[2], this.prefixCode = f[3], this.isLowerRange = f[4] === "lower");
            }
          }
          class m {
            constructor(f) {
              this.children = [], f ? (this.isLeaf = !0, this.rangeLength = f.rangeLength, this.rangeLow = f.rangeLow, this.isLowerRange = f.isLowerRange, this.isOOB = f.isOOB) : this.isLeaf = !1;
            }
            buildTree(f, D) {
              const z = f.prefixCode >> D & 1;
              if (D <= 0)
                this.children[z] = new m(f);
              else {
                let Y = this.children[z];
                Y || (this.children[z] = Y = new m(null)), Y.buildTree(f, D - 1);
              }
            }
            decodeNode(f) {
              if (this.isLeaf) {
                if (this.isOOB)
                  return null;
                const z = f.readBits(this.rangeLength);
                return this.rangeLow + (this.isLowerRange ? -z : z);
              }
              const D = this.children[f.readBit()];
              if (!D)
                throw new t("invalid Huffman data");
              return D.decodeNode(f);
            }
          }
          class p {
            constructor(f, D) {
              D || this.assignPrefixCodes(f), this.rootNode = new m(null);
              for (let z = 0, Y = f.length; z < Y; z++) {
                const W = f[z];
                W.prefixLength > 0 && this.rootNode.buildTree(W, W.prefixLength - 1);
              }
            }
            decode(f) {
              return this.rootNode.decodeNode(f);
            }
            assignPrefixCodes(f) {
              const D = f.length;
              let z = 0;
              for (let te = 0; te < D; te++)
                z = Math.max(z, f[te].prefixLength);
              const Y = new Uint32Array(z + 1);
              for (let te = 0; te < D; te++)
                Y[f[te].prefixLength]++;
              let W = 1, ie = 0, ne, re, ee;
              for (Y[0] = 0; W <= z; ) {
                for (ie = ie + Y[W - 1] << 1, ne = ie, re = 0; re < D; )
                  ee = f[re], ee.prefixLength === W && (ee.prefixCode = ne, ne++), re++;
                W++;
              }
            }
          }
          function T(R, f, D) {
            const z = R[f], Y = (0, u.readUint32)(R, f + 1) & 4294967295, W = (0, u.readUint32)(R, f + 5) & 4294967295, ie = new G(R, f + 9, D), ne = (z >> 1 & 7) + 1, re = (z >> 4 & 7) + 1, ee = [];
            let te, oe, se = Y;
            do
              te = ie.readBits(ne), oe = ie.readBits(re), ee.push(new $([se, te, oe, 0])), se += 1 << oe;
            while (se < W);
            return te = ie.readBits(ne), ee.push(new $([Y - 1, te, 32, 0, "lower"])), te = ie.readBits(ne), ee.push(new $([W, te, 32, 0])), z & 1 && (te = ie.readBits(ne), ee.push(new $([te, 0]))), new p(ee, !1);
          }
          const L = {};
          function _(R) {
            let f = L[R];
            if (f)
              return f;
            let D;
            switch (R) {
              case 1:
                D = [[0, 1, 4, 0], [16, 2, 8, 2], [272, 3, 16, 6], [65808, 3, 32, 7]];
                break;
              case 2:
                D = [[0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [75, 6, 32, 62], [6, 63]];
                break;
              case 3:
                D = [[-256, 8, 8, 254], [0, 1, 0, 0], [1, 2, 0, 2], [2, 3, 0, 6], [3, 4, 3, 14], [11, 5, 6, 30], [-257, 8, 32, 255, "lower"], [75, 7, 32, 126], [6, 62]];
                break;
              case 4:
                D = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [76, 5, 32, 31]];
                break;
              case 5:
                D = [[-255, 7, 8, 126], [1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 0, 6], [4, 4, 3, 14], [12, 5, 6, 30], [-256, 7, 32, 127, "lower"], [76, 6, 32, 62]];
                break;
              case 6:
                D = [[-2048, 5, 10, 28], [-1024, 4, 9, 8], [-512, 4, 8, 9], [-256, 4, 7, 10], [-128, 5, 6, 29], [-64, 5, 5, 30], [-32, 4, 5, 11], [0, 2, 7, 0], [128, 3, 7, 2], [256, 3, 8, 3], [512, 4, 9, 12], [1024, 4, 10, 13], [-2049, 6, 32, 62, "lower"], [2048, 6, 32, 63]];
                break;
              case 7:
                D = [[-1024, 4, 9, 8], [-512, 3, 8, 0], [-256, 4, 7, 9], [-128, 5, 6, 26], [-64, 5, 5, 27], [-32, 4, 5, 10], [0, 4, 5, 11], [32, 5, 5, 28], [64, 5, 6, 29], [128, 4, 7, 12], [256, 3, 8, 1], [512, 3, 9, 2], [1024, 3, 10, 3], [-1025, 5, 32, 30, "lower"], [2048, 5, 32, 31]];
                break;
              case 8:
                D = [[-15, 8, 3, 252], [-7, 9, 1, 508], [-5, 8, 1, 253], [-3, 9, 0, 509], [-2, 7, 0, 124], [-1, 4, 0, 10], [0, 2, 1, 0], [2, 5, 0, 26], [3, 6, 0, 58], [4, 3, 4, 4], [20, 6, 1, 59], [22, 4, 4, 11], [38, 4, 5, 12], [70, 5, 6, 27], [134, 5, 7, 28], [262, 6, 7, 60], [390, 7, 8, 125], [646, 6, 10, 61], [-16, 9, 32, 510, "lower"], [1670, 9, 32, 511], [2, 1]];
                break;
              case 9:
                D = [[-31, 8, 4, 252], [-15, 9, 2, 508], [-11, 8, 2, 253], [-7, 9, 1, 509], [-5, 7, 1, 124], [-3, 4, 1, 10], [-1, 3, 1, 2], [1, 3, 1, 3], [3, 5, 1, 26], [5, 6, 1, 58], [7, 3, 5, 4], [39, 6, 2, 59], [43, 4, 5, 11], [75, 4, 6, 12], [139, 5, 7, 27], [267, 5, 8, 28], [523, 6, 8, 60], [779, 7, 9, 125], [1291, 6, 11, 61], [-32, 9, 32, 510, "lower"], [3339, 9, 32, 511], [2, 0]];
                break;
              case 10:
                D = [[-21, 7, 4, 122], [-5, 8, 0, 252], [-4, 7, 0, 123], [-3, 5, 0, 24], [-2, 2, 2, 0], [2, 5, 0, 25], [3, 6, 0, 54], [4, 7, 0, 124], [5, 8, 0, 253], [6, 2, 6, 1], [70, 5, 5, 26], [102, 6, 5, 55], [134, 6, 6, 56], [198, 6, 7, 57], [326, 6, 8, 58], [582, 6, 9, 59], [1094, 6, 10, 60], [2118, 7, 11, 125], [-22, 8, 32, 254, "lower"], [4166, 8, 32, 255], [2, 2]];
                break;
              case 11:
                D = [[1, 1, 0, 0], [2, 2, 1, 2], [4, 4, 0, 12], [5, 4, 1, 13], [7, 5, 1, 28], [9, 5, 2, 29], [13, 6, 2, 60], [17, 7, 2, 122], [21, 7, 3, 123], [29, 7, 4, 124], [45, 7, 5, 125], [77, 7, 6, 126], [141, 7, 32, 127]];
                break;
              case 12:
                D = [[1, 1, 0, 0], [2, 2, 0, 2], [3, 3, 1, 6], [5, 5, 0, 28], [6, 5, 1, 29], [8, 6, 1, 60], [10, 7, 0, 122], [11, 7, 1, 123], [13, 7, 2, 124], [17, 7, 3, 125], [25, 7, 4, 126], [41, 8, 5, 254], [73, 8, 32, 255]];
                break;
              case 13:
                D = [[1, 1, 0, 0], [2, 3, 0, 4], [3, 4, 0, 12], [4, 5, 0, 28], [5, 4, 1, 13], [7, 3, 3, 5], [15, 6, 1, 58], [17, 6, 2, 59], [21, 6, 3, 60], [29, 6, 4, 61], [45, 6, 5, 62], [77, 7, 6, 126], [141, 7, 32, 127]];
                break;
              case 14:
                D = [[-2, 3, 0, 4], [-1, 3, 0, 5], [0, 1, 0, 0], [1, 3, 0, 6], [2, 3, 0, 7]];
                break;
              case 15:
                D = [[-24, 7, 4, 124], [-8, 6, 2, 60], [-4, 5, 1, 28], [-2, 4, 0, 12], [-1, 3, 0, 4], [0, 1, 0, 0], [1, 3, 0, 5], [2, 4, 0, 13], [3, 5, 1, 29], [5, 6, 2, 61], [9, 7, 4, 125], [-25, 7, 32, 126, "lower"], [25, 7, 32, 127]];
                break;
              default:
                throw new t(`standard table B.${R} does not exist`);
            }
            for (let z = 0, Y = D.length; z < Y; z++)
              D[z] = new $(D[z]);
            return f = new p(D, !0), L[R] = f, f;
          }
          class G {
            constructor(f, D, z) {
              this.data = f, this.start = D, this.end = z, this.position = D, this.shift = -1, this.currentByte = 0;
            }
            readBit() {
              if (this.shift < 0) {
                if (this.position >= this.end)
                  throw new t("end of data while reading bit");
                this.currentByte = this.data[this.position++], this.shift = 7;
              }
              const f = this.currentByte >> this.shift & 1;
              return this.shift--, f;
            }
            readBits(f) {
              let D = 0, z;
              for (z = f - 1; z >= 0; z--)
                D |= this.readBit() << z;
              return D;
            }
            byteAlign() {
              this.shift = -1;
            }
            next() {
              return this.position >= this.end ? -1 : this.data[this.position++];
            }
          }
          function J(R, f, D) {
            let z = 0;
            for (let Y = 0, W = f.length; Y < W; Y++) {
              const ie = D[f[Y]];
              if (ie) {
                if (R === z)
                  return ie;
                z++;
              }
            }
            throw new t("can't find custom Huffman table");
          }
          function K(R, f, D, z, Y) {
            const W = [];
            for (let se = 0; se <= 34; se++) {
              const ce = Y.readBits(4);
              W.push(new $([se, ce, 0, 0]));
            }
            const ie = new p(W, !1);
            W.length = 0;
            for (let se = 0; se < z; ) {
              const ce = ie.decode(Y);
              if (ce >= 32) {
                let le, de, Ie;
                switch (ce) {
                  case 32:
                    if (se === 0)
                      throw new t("no previous value in symbol ID table");
                    de = Y.readBits(2) + 3, le = W[se - 1].prefixLength;
                    break;
                  case 33:
                    de = Y.readBits(3) + 3, le = 0;
                    break;
                  case 34:
                    de = Y.readBits(7) + 11, le = 0;
                    break;
                  default:
                    throw new t("invalid code length in symbol ID table");
                }
                for (Ie = 0; Ie < de; Ie++)
                  W.push(new $([se, le, 0, 0])), se++;
              } else
                W.push(new $([se, ce, 0, 0])), se++;
            }
            Y.byteAlign();
            const ne = new p(W, !1);
            let re = 0, ee, te, oe;
            switch (R.huffmanFS) {
              case 0:
              case 1:
                ee = _(R.huffmanFS + 6);
                break;
              case 3:
                ee = J(re, f, D), re++;
                break;
              default:
                throw new t("invalid Huffman FS selector");
            }
            switch (R.huffmanDS) {
              case 0:
              case 1:
              case 2:
                te = _(R.huffmanDS + 8);
                break;
              case 3:
                te = J(re, f, D), re++;
                break;
              default:
                throw new t("invalid Huffman DS selector");
            }
            switch (R.huffmanDT) {
              case 0:
              case 1:
              case 2:
                oe = _(R.huffmanDT + 11);
                break;
              case 3:
                oe = J(re, f, D), re++;
                break;
              default:
                throw new t("invalid Huffman DT selector");
            }
            if (R.refinement)
              throw new t("refinement with Huffman is not supported");
            return {
              symbolIDTable: ne,
              tableFirstS: ee,
              tableDeltaS: te,
              tableDeltaT: oe
            };
          }
          function V(R, f, D) {
            let z = 0, Y, W;
            switch (R.huffmanDHSelector) {
              case 0:
              case 1:
                Y = _(R.huffmanDHSelector + 4);
                break;
              case 3:
                Y = J(z, f, D), z++;
                break;
              default:
                throw new t("invalid Huffman DH selector");
            }
            switch (R.huffmanDWSelector) {
              case 0:
              case 1:
                W = _(R.huffmanDWSelector + 2);
                break;
              case 3:
                W = J(z, f, D), z++;
                break;
              default:
                throw new t("invalid Huffman DW selector");
            }
            let ie, ne;
            return R.bitmapSizeSelector ? (ie = J(z, f, D), z++) : ie = _(1), R.aggregationInstancesSelector ? ne = J(z, f, D) : ne = _(1), {
              tableDeltaHeight: Y,
              tableDeltaWidth: W,
              tableBitmapSize: ie,
              tableAggregateInstances: ne
            };
          }
          function U(R, f, D) {
            const z = [];
            for (let Y = 0; Y < D; Y++) {
              const W = new Uint8Array(f);
              z.push(W);
              for (let ie = 0; ie < f; ie++)
                W[ie] = R.readBit();
              R.byteAlign();
            }
            return z;
          }
          function Q(R, f, D, z) {
            const Y = {
              K: -1,
              Columns: f,
              Rows: D,
              BlackIs1: !0,
              EndOfBlock: z
            }, W = new e.CCITTFaxDecoder(R, Y), ie = [];
            let ne, re = !1;
            for (let ee = 0; ee < D; ee++) {
              const te = new Uint8Array(f);
              ie.push(te);
              let oe = -1;
              for (let se = 0; se < f; se++)
                oe < 0 && (ne = W.readNextChar(), ne === -1 && (ne = 0, re = !0), oe = 7), te[se] = ne >> oe & 1, oe--;
            }
            if (z && !re)
              for (let te = 0; te < 5 && W.readNextChar() !== -1; te++)
                ;
            return ie;
          }
          class X {
            parseChunks(f) {
              return E(f);
            }
            parse(f) {
              throw new Error("Not implemented: Jbig2Image.parse");
            }
          }
          F.Jbig2Image = X;
        },
        /* 25 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ArithmeticDecoder = void 0;
          const ae = [{
            qe: 22017,
            nmps: 1,
            nlps: 1,
            switchFlag: 1
          }, {
            qe: 13313,
            nmps: 2,
            nlps: 6,
            switchFlag: 0
          }, {
            qe: 6145,
            nmps: 3,
            nlps: 9,
            switchFlag: 0
          }, {
            qe: 2753,
            nmps: 4,
            nlps: 12,
            switchFlag: 0
          }, {
            qe: 1313,
            nmps: 5,
            nlps: 29,
            switchFlag: 0
          }, {
            qe: 545,
            nmps: 38,
            nlps: 33,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 7,
            nlps: 6,
            switchFlag: 1
          }, {
            qe: 21505,
            nmps: 8,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 18433,
            nmps: 9,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 14337,
            nmps: 10,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 12289,
            nmps: 11,
            nlps: 17,
            switchFlag: 0
          }, {
            qe: 9217,
            nmps: 12,
            nlps: 18,
            switchFlag: 0
          }, {
            qe: 7169,
            nmps: 13,
            nlps: 20,
            switchFlag: 0
          }, {
            qe: 5633,
            nmps: 29,
            nlps: 21,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 15,
            nlps: 14,
            switchFlag: 1
          }, {
            qe: 21505,
            nmps: 16,
            nlps: 14,
            switchFlag: 0
          }, {
            qe: 20737,
            nmps: 17,
            nlps: 15,
            switchFlag: 0
          }, {
            qe: 18433,
            nmps: 18,
            nlps: 16,
            switchFlag: 0
          }, {
            qe: 14337,
            nmps: 19,
            nlps: 17,
            switchFlag: 0
          }, {
            qe: 13313,
            nmps: 20,
            nlps: 18,
            switchFlag: 0
          }, {
            qe: 12289,
            nmps: 21,
            nlps: 19,
            switchFlag: 0
          }, {
            qe: 10241,
            nmps: 22,
            nlps: 19,
            switchFlag: 0
          }, {
            qe: 9217,
            nmps: 23,
            nlps: 20,
            switchFlag: 0
          }, {
            qe: 8705,
            nmps: 24,
            nlps: 21,
            switchFlag: 0
          }, {
            qe: 7169,
            nmps: 25,
            nlps: 22,
            switchFlag: 0
          }, {
            qe: 6145,
            nmps: 26,
            nlps: 23,
            switchFlag: 0
          }, {
            qe: 5633,
            nmps: 27,
            nlps: 24,
            switchFlag: 0
          }, {
            qe: 5121,
            nmps: 28,
            nlps: 25,
            switchFlag: 0
          }, {
            qe: 4609,
            nmps: 29,
            nlps: 26,
            switchFlag: 0
          }, {
            qe: 4353,
            nmps: 30,
            nlps: 27,
            switchFlag: 0
          }, {
            qe: 2753,
            nmps: 31,
            nlps: 28,
            switchFlag: 0
          }, {
            qe: 2497,
            nmps: 32,
            nlps: 29,
            switchFlag: 0
          }, {
            qe: 2209,
            nmps: 33,
            nlps: 30,
            switchFlag: 0
          }, {
            qe: 1313,
            nmps: 34,
            nlps: 31,
            switchFlag: 0
          }, {
            qe: 1089,
            nmps: 35,
            nlps: 32,
            switchFlag: 0
          }, {
            qe: 673,
            nmps: 36,
            nlps: 33,
            switchFlag: 0
          }, {
            qe: 545,
            nmps: 37,
            nlps: 34,
            switchFlag: 0
          }, {
            qe: 321,
            nmps: 38,
            nlps: 35,
            switchFlag: 0
          }, {
            qe: 273,
            nmps: 39,
            nlps: 36,
            switchFlag: 0
          }, {
            qe: 133,
            nmps: 40,
            nlps: 37,
            switchFlag: 0
          }, {
            qe: 73,
            nmps: 41,
            nlps: 38,
            switchFlag: 0
          }, {
            qe: 37,
            nmps: 42,
            nlps: 39,
            switchFlag: 0
          }, {
            qe: 21,
            nmps: 43,
            nlps: 40,
            switchFlag: 0
          }, {
            qe: 9,
            nmps: 44,
            nlps: 41,
            switchFlag: 0
          }, {
            qe: 5,
            nmps: 45,
            nlps: 42,
            switchFlag: 0
          }, {
            qe: 1,
            nmps: 45,
            nlps: 43,
            switchFlag: 0
          }, {
            qe: 22017,
            nmps: 46,
            nlps: 46,
            switchFlag: 0
          }];
          class n {
            constructor(q, e, t) {
              this.data = q, this.bp = e, this.dataEnd = t, this.chigh = q[e], this.clow = 0, this.byteIn(), this.chigh = this.chigh << 7 & 65535 | this.clow >> 9 & 127, this.clow = this.clow << 7 & 65535, this.ct -= 7, this.a = 32768;
            }
            byteIn() {
              const q = this.data;
              let e = this.bp;
              q[e] === 255 ? q[e + 1] > 143 ? (this.clow += 65280, this.ct = 8) : (e++, this.clow += q[e] << 9, this.ct = 7, this.bp = e) : (e++, this.clow += e < this.dataEnd ? q[e] << 8 : 65280, this.ct = 8, this.bp = e), this.clow > 65535 && (this.chigh += this.clow >> 16, this.clow &= 65535);
            }
            readBit(q, e) {
              let t = q[e] >> 1, B = q[e] & 1;
              const j = ae[t], M = j.qe;
              let O, w = this.a - M;
              if (this.chigh < M)
                w < M ? (w = M, O = B, t = j.nmps) : (w = M, O = 1 ^ B, j.switchFlag === 1 && (B = O), t = j.nlps);
              else {
                if (this.chigh -= M, w & 32768)
                  return this.a = w, B;
                w < M ? (O = 1 ^ B, j.switchFlag === 1 && (B = O), t = j.nlps) : (O = B, t = j.nmps);
              }
              do
                this.ct === 0 && this.byteIn(), w <<= 1, this.chigh = this.chigh << 1 & 65535 | this.clow >> 15 & 1, this.clow = this.clow << 1 & 65535, this.ct--;
              while (!(w & 32768));
              return this.a = w, q[e] = t << 1 | B, O;
            }
          }
          F.ArithmeticDecoder = n;
        },
        /* 26 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.JpegStream = void 0;
          var n = ae(18), u = ae(4), q = ae(27), e = ae(2);
          class t extends n.DecodeStream {
            constructor(j, M, O) {
              let w;
              for (; (w = j.getByte()) !== -1; )
                if (w === 255) {
                  j.skip(-1);
                  break;
                }
              super(M), this.stream = j, this.dict = j.dict, this.maybeLength = M, this.params = O;
            }
            get bytes() {
              return (0, e.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(j) {
            }
            readBlock() {
              if (this.eof)
                return;
              const j = {
                decodeTransform: void 0,
                colorTransform: void 0
              }, M = this.dict.getArray("D", "Decode");
              if ((this.forceRGBA || this.forceRGB) && Array.isArray(M)) {
                const C = this.dict.get("BPC", "BitsPerComponent") || 8, i = M.length, o = new Int32Array(i);
                let k = !1;
                const s = (1 << C) - 1;
                for (let l = 0; l < i; l += 2)
                  o[l] = (M[l + 1] - M[l]) * 256 | 0, o[l + 1] = M[l] * s | 0, (o[l] !== 256 || o[l + 1] !== 0) && (k = !0);
                k && (j.decodeTransform = o);
              }
              if (this.params instanceof u.Dict) {
                const C = this.params.get("ColorTransform");
                Number.isInteger(C) && (j.colorTransform = C);
              }
              const O = new q.JpegImage(j);
              O.parse(this.bytes);
              const w = O.getData({
                width: this.drawWidth,
                height: this.drawHeight,
                forceRGBA: this.forceRGBA,
                forceRGB: this.forceRGB,
                isSourcePDF: !0
              });
              this.buffer = w, this.bufferLength = w.length, this.eof = !0;
            }
          }
          F.JpegStream = t;
        },
        /* 27 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.JpegImage = void 0;
          var n = ae(2), u = ae(28), q = ae(3);
          class e extends n.BaseException {
            constructor(y) {
              super(`JPEG error: ${y}`, "JpegError");
            }
          }
          class t extends n.BaseException {
            constructor(y, P) {
              super(y, "DNLMarkerError"), this.scanLines = P;
            }
          }
          class B extends n.BaseException {
            constructor(y) {
              super(y, "EOIMarkerError");
            }
          }
          const j = new Uint8Array([0, 1, 8, 16, 9, 2, 3, 10, 17, 24, 32, 25, 18, 11, 4, 5, 12, 19, 26, 33, 40, 48, 41, 34, 27, 20, 13, 6, 7, 14, 21, 28, 35, 42, 49, 56, 57, 50, 43, 36, 29, 22, 15, 23, 30, 37, 44, 51, 58, 59, 52, 45, 38, 31, 39, 46, 53, 60, 61, 54, 47, 55, 62, 63]), M = 4017, O = 799, w = 3406, C = 2276, i = 1567, o = 3784, k = 5793, s = 2896;
          function l(h, y) {
            let P = 0, c, d, A = 16;
            for (; A > 0 && !h[A - 1]; )
              A--;
            const N = [{
              children: [],
              index: 0
            }];
            let E = N[0], H;
            for (c = 0; c < A; c++) {
              for (d = 0; d < h[c]; d++) {
                for (E = N.pop(), E.children[E.index] = y[P]; E.index > 0; )
                  E = N.pop();
                for (E.index++, N.push(E); N.length <= c; )
                  N.push(H = {
                    children: [],
                    index: 0
                  }), E.children[E.index] = H.children, E = H;
                P++;
              }
              c + 1 < A && (N.push(H = {
                children: [],
                index: 0
              }), E.children[E.index] = H.children, E = H);
            }
            return N[0].children;
          }
          function g(h, y, P) {
            return 64 * ((h.blocksPerLine + 1) * y + P);
          }
          function v(h, y, P, c, d, A, N, E, H, $ = !1) {
            const m = P.mcusPerLine, p = P.progressive, T = y;
            let L = 0, _ = 0;
            function G() {
              if (_ > 0)
                return _--, L >> _ & 1;
              if (L = h[y++], L === 255) {
                const fe = h[y++];
                if (fe) {
                  if (fe === 220 && $) {
                    y += 2;
                    const Ae = (0, q.readUint16)(h, y);
                    if (y += 2, Ae > 0 && Ae !== P.scanLines)
                      throw new t("Found DNL marker (0xFFDC) while parsing scan data", Ae);
                  } else if (fe === 217) {
                    if ($) {
                      const Ae = W * (P.precision === 8 ? 8 : 0);
                      if (Ae > 0 && Math.round(P.scanLines / Ae) >= 5)
                        throw new t("Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter", Ae);
                    }
                    throw new B("Found EOI marker (0xFFD9) while parsing scan data");
                  }
                  throw new e(`unexpected marker ${(L << 8 | fe).toString(16)}`);
                }
              }
              return _ = 7, L >>> 7;
            }
            function J(fe) {
              let Ae = fe;
              for (; ; ) {
                switch (Ae = Ae[G()], typeof Ae) {
                  case "number":
                    return Ae;
                  case "object":
                    continue;
                }
                throw new e("invalid huffman sequence");
              }
            }
            function K(fe) {
              let Ae = 0;
              for (; fe > 0; )
                Ae = Ae << 1 | G(), fe--;
              return Ae;
            }
            function V(fe) {
              if (fe === 1)
                return G() === 1 ? 1 : -1;
              const Ae = K(fe);
              return Ae >= 1 << fe - 1 ? Ae : Ae + (-1 << fe) + 1;
            }
            function U(fe, Ae) {
              const Pe = J(fe.huffmanTableDC), Re = Pe === 0 ? 0 : V(Pe);
              fe.blockData[Ae] = fe.pred += Re;
              let Ee = 1;
              for (; Ee < 64; ) {
                const ye = J(fe.huffmanTableAC), Te = ye & 15, je = ye >> 4;
                if (Te === 0) {
                  if (je < 15)
                    break;
                  Ee += 16;
                  continue;
                }
                Ee += je;
                const ve = j[Ee];
                fe.blockData[Ae + ve] = V(Te), Ee++;
              }
            }
            function Q(fe, Ae) {
              const Pe = J(fe.huffmanTableDC), Re = Pe === 0 ? 0 : V(Pe) << H;
              fe.blockData[Ae] = fe.pred += Re;
            }
            function X(fe, Ae) {
              fe.blockData[Ae] |= G() << H;
            }
            let R = 0;
            function f(fe, Ae) {
              if (R > 0) {
                R--;
                return;
              }
              let Pe = A;
              const Re = N;
              for (; Pe <= Re; ) {
                const Ee = J(fe.huffmanTableAC), ye = Ee & 15, Te = Ee >> 4;
                if (ye === 0) {
                  if (Te < 15) {
                    R = K(Te) + (1 << Te) - 1;
                    break;
                  }
                  Pe += 16;
                  continue;
                }
                Pe += Te;
                const je = j[Pe];
                fe.blockData[Ae + je] = V(ye) * (1 << H), Pe++;
              }
            }
            let D = 0, z;
            function Y(fe, Ae) {
              let Pe = A;
              const Re = N;
              let Ee = 0, ye, Te;
              for (; Pe <= Re; ) {
                const je = Ae + j[Pe], ve = fe.blockData[je] < 0 ? -1 : 1;
                switch (D) {
                  case 0:
                    if (Te = J(fe.huffmanTableAC), ye = Te & 15, Ee = Te >> 4, ye === 0)
                      Ee < 15 ? (R = K(Ee) + (1 << Ee), D = 4) : (Ee = 16, D = 1);
                    else {
                      if (ye !== 1)
                        throw new e("invalid ACn encoding");
                      z = V(ye), D = Ee ? 2 : 3;
                    }
                    continue;
                  case 1:
                  case 2:
                    fe.blockData[je] ? fe.blockData[je] += ve * (G() << H) : (Ee--, Ee === 0 && (D = D === 2 ? 3 : 0));
                    break;
                  case 3:
                    fe.blockData[je] ? fe.blockData[je] += ve * (G() << H) : (fe.blockData[je] = z << H, D = 0);
                    break;
                  case 4:
                    fe.blockData[je] && (fe.blockData[je] += ve * (G() << H));
                    break;
                }
                Pe++;
              }
              D === 4 && (R--, R === 0 && (D = 0));
            }
            let W = 0;
            function ie(fe, Ae, Pe, Re, Ee) {
              const ye = Pe / m | 0, Te = Pe % m;
              W = ye * fe.v + Re;
              const je = Te * fe.h + Ee, ve = g(fe, W, je);
              Ae(fe, ve);
            }
            function ne(fe, Ae, Pe) {
              W = Pe / fe.blocksPerLine | 0;
              const Re = Pe % fe.blocksPerLine, Ee = g(fe, W, Re);
              Ae(fe, Ee);
            }
            const re = c.length;
            let ee, te, oe, se, ce, le;
            p ? A === 0 ? le = E === 0 ? Q : X : le = E === 0 ? f : Y : le = U;
            let de = 0, Ie, Fe;
            re === 1 ? Fe = c[0].blocksPerLine * c[0].blocksPerColumn : Fe = m * P.mcusPerColumn;
            let we, pe;
            for (; de <= Fe; ) {
              const fe = d ? Math.min(Fe - de, d) : Fe;
              if (fe > 0) {
                for (te = 0; te < re; te++)
                  c[te].pred = 0;
                if (R = 0, re === 1)
                  for (ee = c[0], ce = 0; ce < fe; ce++)
                    ne(ee, le, de), de++;
                else
                  for (ce = 0; ce < fe; ce++) {
                    for (te = 0; te < re; te++)
                      for (ee = c[te], we = ee.h, pe = ee.v, oe = 0; oe < pe; oe++)
                        for (se = 0; se < we; se++)
                          ie(ee, le, de, oe, se);
                    de++;
                  }
              }
              if (_ = 0, Ie = b(h, y), !Ie)
                break;
              if (Ie.invalid) {
                const Ae = fe > 0 ? "unexpected" : "excessive";
                (0, n.warn)(`decodeScan - ${Ae} MCU data, current marker is: ${Ie.invalid}`), y = Ie.offset;
              }
              if (Ie.marker >= 65488 && Ie.marker <= 65495)
                y += 2;
              else
                break;
            }
            return y - T;
          }
          function r(h, y, P) {
            const c = h.quantizationTable, d = h.blockData;
            let A, N, E, H, $, m, p, T, L, _, G, J, K, V, U, Q, X;
            if (!c)
              throw new e("missing required Quantization Table.");
            for (let R = 0; R < 64; R += 8) {
              if (L = d[y + R], _ = d[y + R + 1], G = d[y + R + 2], J = d[y + R + 3], K = d[y + R + 4], V = d[y + R + 5], U = d[y + R + 6], Q = d[y + R + 7], L *= c[R], !(_ | G | J | K | V | U | Q)) {
                X = k * L + 512 >> 10, P[R] = X, P[R + 1] = X, P[R + 2] = X, P[R + 3] = X, P[R + 4] = X, P[R + 5] = X, P[R + 6] = X, P[R + 7] = X;
                continue;
              }
              _ *= c[R + 1], G *= c[R + 2], J *= c[R + 3], K *= c[R + 4], V *= c[R + 5], U *= c[R + 6], Q *= c[R + 7], A = k * L + 128 >> 8, N = k * K + 128 >> 8, E = G, H = U, $ = s * (_ - Q) + 128 >> 8, T = s * (_ + Q) + 128 >> 8, m = J << 4, p = V << 4, A = A + N + 1 >> 1, N = A - N, X = E * o + H * i + 128 >> 8, E = E * i - H * o + 128 >> 8, H = X, $ = $ + p + 1 >> 1, p = $ - p, T = T + m + 1 >> 1, m = T - m, A = A + H + 1 >> 1, H = A - H, N = N + E + 1 >> 1, E = N - E, X = $ * C + T * w + 2048 >> 12, $ = $ * w - T * C + 2048 >> 12, T = X, X = m * O + p * M + 2048 >> 12, m = m * M - p * O + 2048 >> 12, p = X, P[R] = A + T, P[R + 7] = A - T, P[R + 1] = N + p, P[R + 6] = N - p, P[R + 2] = E + m, P[R + 5] = E - m, P[R + 3] = H + $, P[R + 4] = H - $;
            }
            for (let R = 0; R < 8; ++R) {
              if (L = P[R], _ = P[R + 8], G = P[R + 16], J = P[R + 24], K = P[R + 32], V = P[R + 40], U = P[R + 48], Q = P[R + 56], !(_ | G | J | K | V | U | Q)) {
                X = k * L + 8192 >> 14, X < -2040 ? X = 0 : X >= 2024 ? X = 255 : X = X + 2056 >> 4, d[y + R] = X, d[y + R + 8] = X, d[y + R + 16] = X, d[y + R + 24] = X, d[y + R + 32] = X, d[y + R + 40] = X, d[y + R + 48] = X, d[y + R + 56] = X;
                continue;
              }
              A = k * L + 2048 >> 12, N = k * K + 2048 >> 12, E = G, H = U, $ = s * (_ - Q) + 2048 >> 12, T = s * (_ + Q) + 2048 >> 12, m = J, p = V, A = (A + N + 1 >> 1) + 4112, N = A - N, X = E * o + H * i + 2048 >> 12, E = E * i - H * o + 2048 >> 12, H = X, $ = $ + p + 1 >> 1, p = $ - p, T = T + m + 1 >> 1, m = T - m, A = A + H + 1 >> 1, H = A - H, N = N + E + 1 >> 1, E = N - E, X = $ * C + T * w + 2048 >> 12, $ = $ * w - T * C + 2048 >> 12, T = X, X = m * O + p * M + 2048 >> 12, m = m * M - p * O + 2048 >> 12, p = X, L = A + T, Q = A - T, _ = N + p, U = N - p, G = E + m, V = E - m, J = H + $, K = H - $, L < 16 ? L = 0 : L >= 4080 ? L = 255 : L >>= 4, _ < 16 ? _ = 0 : _ >= 4080 ? _ = 255 : _ >>= 4, G < 16 ? G = 0 : G >= 4080 ? G = 255 : G >>= 4, J < 16 ? J = 0 : J >= 4080 ? J = 255 : J >>= 4, K < 16 ? K = 0 : K >= 4080 ? K = 255 : K >>= 4, V < 16 ? V = 0 : V >= 4080 ? V = 255 : V >>= 4, U < 16 ? U = 0 : U >= 4080 ? U = 255 : U >>= 4, Q < 16 ? Q = 0 : Q >= 4080 ? Q = 255 : Q >>= 4, d[y + R] = L, d[y + R + 8] = _, d[y + R + 16] = G, d[y + R + 24] = J, d[y + R + 32] = K, d[y + R + 40] = V, d[y + R + 48] = U, d[y + R + 56] = Q;
            }
          }
          function x(h, y) {
            const P = y.blocksPerLine, c = y.blocksPerColumn, d = new Int16Array(64);
            for (let A = 0; A < c; A++)
              for (let N = 0; N < P; N++) {
                const E = g(y, A, N);
                r(y, E, d);
              }
            return y.blockData;
          }
          function b(h, y, P = y) {
            const c = h.length - 1;
            let d = P < y ? P : y;
            if (y >= c)
              return null;
            const A = (0, q.readUint16)(h, y);
            if (A >= 65472 && A <= 65534)
              return {
                invalid: null,
                marker: A,
                offset: y
              };
            let N = (0, q.readUint16)(h, d);
            for (; !(N >= 65472 && N <= 65534); ) {
              if (++d >= c)
                return null;
              N = (0, q.readUint16)(h, d);
            }
            return {
              invalid: A.toString(16),
              marker: N,
              offset: d
            };
          }
          class I {
            constructor({
              decodeTransform: y = null,
              colorTransform: P = -1
            } = {}) {
              this._decodeTransform = y, this._colorTransform = P;
            }
            parse(y, {
              dnlScanLines: P = null
            } = {}) {
              function c() {
                const G = (0, q.readUint16)(y, A);
                A += 2;
                let J = A + G - 2;
                const K = b(y, J, A);
                K != null && K.invalid && ((0, n.warn)("readDataBlock - incorrect length, current marker is: " + K.invalid), J = K.offset);
                const V = y.subarray(A, J);
                return A += V.length, V;
              }
              function d(G) {
                const J = Math.ceil(G.samplesPerLine / 8 / G.maxH), K = Math.ceil(G.scanLines / 8 / G.maxV);
                for (const V of G.components) {
                  const U = Math.ceil(Math.ceil(G.samplesPerLine / 8) * V.h / G.maxH), Q = Math.ceil(Math.ceil(G.scanLines / 8) * V.v / G.maxV), X = J * V.h, f = 64 * (K * V.v) * (X + 1);
                  V.blockData = new Int16Array(f), V.blocksPerLine = U, V.blocksPerColumn = Q;
                }
                G.mcusPerLine = J, G.mcusPerColumn = K;
              }
              let A = 0, N = null, E = null, H, $, m = 0;
              const p = [], T = [], L = [];
              let _ = (0, q.readUint16)(y, A);
              if (A += 2, _ !== 65496)
                throw new e("SOI not found");
              _ = (0, q.readUint16)(y, A), A += 2;
              e:
                for (; _ !== 65497; ) {
                  let G, J, K;
                  switch (_) {
                    case 65504:
                    case 65505:
                    case 65506:
                    case 65507:
                    case 65508:
                    case 65509:
                    case 65510:
                    case 65511:
                    case 65512:
                    case 65513:
                    case 65514:
                    case 65515:
                    case 65516:
                    case 65517:
                    case 65518:
                    case 65519:
                    case 65534:
                      const V = c();
                      _ === 65504 && V[0] === 74 && V[1] === 70 && V[2] === 73 && V[3] === 70 && V[4] === 0 && (N = {
                        version: {
                          major: V[5],
                          minor: V[6]
                        },
                        densityUnits: V[7],
                        xDensity: V[8] << 8 | V[9],
                        yDensity: V[10] << 8 | V[11],
                        thumbWidth: V[12],
                        thumbHeight: V[13],
                        thumbData: V.subarray(14, 14 + 3 * V[12] * V[13])
                      }), _ === 65518 && V[0] === 65 && V[1] === 100 && V[2] === 111 && V[3] === 98 && V[4] === 101 && (E = {
                        version: V[5] << 8 | V[6],
                        flags0: V[7] << 8 | V[8],
                        flags1: V[9] << 8 | V[10],
                        transformCode: V[11]
                      });
                      break;
                    case 65499:
                      const U = (0, q.readUint16)(y, A);
                      A += 2;
                      const Q = U + A - 2;
                      let X;
                      for (; A < Q; ) {
                        const se = y[A++], ce = new Uint16Array(64);
                        if (se >> 4)
                          if (se >> 4 === 1)
                            for (J = 0; J < 64; J++)
                              X = j[J], ce[X] = (0, q.readUint16)(y, A), A += 2;
                          else
                            throw new e("DQT - invalid table spec");
                        else
                          for (J = 0; J < 64; J++)
                            X = j[J], ce[X] = y[A++];
                        p[se & 15] = ce;
                      }
                      break;
                    case 65472:
                    case 65473:
                    case 65474:
                      if (H)
                        throw new e("Only single frame JPEGs supported");
                      A += 2, H = {}, H.extended = _ === 65473, H.progressive = _ === 65474, H.precision = y[A++];
                      const R = (0, q.readUint16)(y, A);
                      A += 2, H.scanLines = P || R, H.samplesPerLine = (0, q.readUint16)(y, A), A += 2, H.components = [], H.componentIds = {};
                      const f = y[A++];
                      let D = 0, z = 0;
                      for (G = 0; G < f; G++) {
                        const se = y[A], ce = y[A + 1] >> 4, le = y[A + 1] & 15;
                        D < ce && (D = ce), z < le && (z = le);
                        const de = y[A + 2];
                        K = H.components.push({
                          h: ce,
                          v: le,
                          quantizationId: de,
                          quantizationTable: null
                        }), H.componentIds[se] = K - 1, A += 3;
                      }
                      H.maxH = D, H.maxV = z, d(H);
                      break;
                    case 65476:
                      const Y = (0, q.readUint16)(y, A);
                      for (A += 2, G = 2; G < Y; ) {
                        const se = y[A++], ce = new Uint8Array(16);
                        let le = 0;
                        for (J = 0; J < 16; J++, A++)
                          le += ce[J] = y[A];
                        const de = new Uint8Array(le);
                        for (J = 0; J < le; J++, A++)
                          de[J] = y[A];
                        G += 17 + le, (se >> 4 ? T : L)[se & 15] = l(ce, de);
                      }
                      break;
                    case 65501:
                      A += 2, $ = (0, q.readUint16)(y, A), A += 2;
                      break;
                    case 65498:
                      const W = ++m === 1 && !P;
                      A += 2;
                      const ie = y[A++], ne = [];
                      for (G = 0; G < ie; G++) {
                        const se = y[A++], ce = H.componentIds[se], le = H.components[ce];
                        le.index = se;
                        const de = y[A++];
                        le.huffmanTableDC = L[de >> 4], le.huffmanTableAC = T[de & 15], ne.push(le);
                      }
                      const re = y[A++], ee = y[A++], te = y[A++];
                      try {
                        const se = v(y, A, H, ne, $, re, ee, te >> 4, te & 15, W);
                        A += se;
                      } catch (se) {
                        if (se instanceof t)
                          return (0, n.warn)(`${se.message} -- attempting to re-parse the JPEG image.`), this.parse(y, {
                            dnlScanLines: se.scanLines
                          });
                        if (se instanceof B) {
                          (0, n.warn)(`${se.message} -- ignoring the rest of the image data.`);
                          break e;
                        }
                        throw se;
                      }
                      break;
                    case 65500:
                      A += 4;
                      break;
                    case 65535:
                      y[A] !== 255 && A--;
                      break;
                    default:
                      const oe = b(y, A - 2, A - 3);
                      if (oe != null && oe.invalid) {
                        (0, n.warn)("JpegImage.parse - unexpected data, current marker is: " + oe.invalid), A = oe.offset;
                        break;
                      }
                      if (!oe || A >= y.length - 1) {
                        (0, n.warn)("JpegImage.parse - reached the end of the image data without finding an EOI marker (0xFFD9).");
                        break e;
                      }
                      throw new e("JpegImage.parse - unknown marker: " + _.toString(16));
                  }
                  _ = (0, q.readUint16)(y, A), A += 2;
                }
              this.width = H.samplesPerLine, this.height = H.scanLines, this.jfif = N, this.adobe = E, this.components = [];
              for (const G of H.components) {
                const J = p[G.quantizationId];
                J && (G.quantizationTable = J), this.components.push({
                  index: G.index,
                  output: x(H, G),
                  scaleX: G.h / H.maxH,
                  scaleY: G.v / H.maxV,
                  blocksPerLine: G.blocksPerLine,
                  blocksPerColumn: G.blocksPerColumn
                });
              }
              this.numComponents = this.components.length;
            }
            _getLinearizedBlockData(y, P, c = !1) {
              const d = this.width / y, A = this.height / P;
              let N, E, H, $, m, p, T, L, _, G, J = 0, K;
              const V = this.components.length, U = y * P * V, Q = new Uint8ClampedArray(U), X = new Uint32Array(y), R = 4294967288;
              let f;
              for (T = 0; T < V; T++) {
                if (N = this.components[T], E = N.scaleX * d, H = N.scaleY * A, J = T, K = N.output, $ = N.blocksPerLine + 1 << 3, E !== f) {
                  for (m = 0; m < y; m++)
                    L = 0 | m * E, X[m] = (L & R) << 3 | L & 7;
                  f = E;
                }
                for (p = 0; p < P; p++)
                  for (L = 0 | p * H, G = $ * (L & R) | (L & 7) << 3, m = 0; m < y; m++)
                    Q[J] = K[G + X[m]], J += V;
              }
              let D = this._decodeTransform;
              if (!c && V === 4 && !D && (D = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), D)
                for (T = 0; T < U; )
                  for (L = 0, _ = 0; L < V; L++, T++, _ += 2)
                    Q[T] = (Q[T] * D[_] >> 8) + D[_ + 1];
              return Q;
            }
            get _isColorConversionNeeded() {
              return this.adobe ? !!this.adobe.transformCode : this.numComponents === 3 ? this._colorTransform === 0 ? !1 : !(this.components[0].index === 82 && this.components[1].index === 71 && this.components[2].index === 66) : this._colorTransform === 1;
            }
            _convertYccToRgb(y) {
              let P, c, d;
              for (let A = 0, N = y.length; A < N; A += 3)
                P = y[A], c = y[A + 1], d = y[A + 2], y[A] = P - 179.456 + 1.402 * d, y[A + 1] = P + 135.459 - 0.344 * c - 0.714 * d, y[A + 2] = P - 226.816 + 1.772 * c;
              return y;
            }
            _convertYccToRgba(y, P) {
              for (let c = 0, d = 0, A = y.length; c < A; c += 3, d += 4) {
                const N = y[c], E = y[c + 1], H = y[c + 2];
                P[d] = N - 179.456 + 1.402 * H, P[d + 1] = N + 135.459 - 0.344 * E - 0.714 * H, P[d + 2] = N - 226.816 + 1.772 * E, P[d + 3] = 255;
              }
              return P;
            }
            _convertYcckToRgb(y) {
              let P, c, d, A, N = 0;
              for (let E = 0, H = y.length; E < H; E += 4)
                P = y[E], c = y[E + 1], d = y[E + 2], A = y[E + 3], y[N++] = -122.67195406894 + c * (-660635669420364e-19 * c + 437130475926232e-18 * d - 54080610064599e-18 * P + 48449797120281e-17 * A - 0.154362151871126) + d * (-957964378445773e-18 * d + 817076911346625e-18 * P - 0.00477271405408747 * A + 1.53380253221734) + P * (961250184130688e-18 * P - 0.00266257332283933 * A + 0.48357088451265) + A * (-336197177618394e-18 * A + 0.484791561490776), y[N++] = 107.268039397724 + c * (219927104525741e-19 * c - 640992018297945e-18 * d + 659397001245577e-18 * P + 426105652938837e-18 * A - 0.176491792462875) + d * (-778269941513683e-18 * d + 0.00130872261408275 * P + 770482631801132e-18 * A - 0.151051492775562) + P * (0.00126935368114843 * P - 0.00265090189010898 * A + 0.25802910206845) + A * (-318913117588328e-18 * A - 0.213742400323665), y[N++] = -20.810012546947 + c * (-570115196973677e-18 * c - 263409051004589e-19 * d + 0.0020741088115012 * P - 0.00288260236853442 * A + 0.814272968359295) + d * (-153496057440975e-19 * d - 132689043961446e-18 * P + 560833691242812e-18 * A - 0.195152027534049) + P * (0.00174418132927582 * P - 0.00255243321439347 * A + 0.116935020465145) + A * (-343531996510555e-18 * A + 0.24165260232407);
              return y.subarray(0, N);
            }
            _convertYcckToRgba(y) {
              for (let P = 0, c = y.length; P < c; P += 4) {
                const d = y[P], A = y[P + 1], N = y[P + 2], E = y[P + 3];
                y[P] = -122.67195406894 + A * (-660635669420364e-19 * A + 437130475926232e-18 * N - 54080610064599e-18 * d + 48449797120281e-17 * E - 0.154362151871126) + N * (-957964378445773e-18 * N + 817076911346625e-18 * d - 0.00477271405408747 * E + 1.53380253221734) + d * (961250184130688e-18 * d - 0.00266257332283933 * E + 0.48357088451265) + E * (-336197177618394e-18 * E + 0.484791561490776), y[P + 1] = 107.268039397724 + A * (219927104525741e-19 * A - 640992018297945e-18 * N + 659397001245577e-18 * d + 426105652938837e-18 * E - 0.176491792462875) + N * (-778269941513683e-18 * N + 0.00130872261408275 * d + 770482631801132e-18 * E - 0.151051492775562) + d * (0.00126935368114843 * d - 0.00265090189010898 * E + 0.25802910206845) + E * (-318913117588328e-18 * E - 0.213742400323665), y[P + 2] = -20.810012546947 + A * (-570115196973677e-18 * A - 263409051004589e-19 * N + 0.0020741088115012 * d - 0.00288260236853442 * E + 0.814272968359295) + N * (-153496057440975e-19 * N - 132689043961446e-18 * d + 560833691242812e-18 * E - 0.195152027534049) + d * (0.00174418132927582 * d - 0.00255243321439347 * E + 0.116935020465145) + E * (-343531996510555e-18 * E + 0.24165260232407), y[P + 3] = 255;
              }
              return y;
            }
            _convertYcckToCmyk(y) {
              let P, c, d;
              for (let A = 0, N = y.length; A < N; A += 4)
                P = y[A], c = y[A + 1], d = y[A + 2], y[A] = 434.456 - P - 1.402 * d, y[A + 1] = 119.541 - P + 0.344 * c + 0.714 * d, y[A + 2] = 481.816 - P - 1.772 * c;
              return y;
            }
            _convertCmykToRgb(y) {
              let P, c, d, A, N = 0;
              for (let E = 0, H = y.length; E < H; E += 4)
                P = y[E], c = y[E + 1], d = y[E + 2], A = y[E + 3], y[N++] = 255 + P * (-6747147073602441e-20 * P + 8379262121013727e-19 * c + 2894718188643294e-19 * d + 0.003264231057537806 * A - 1.1185611867203937) + c * (26374107616089405e-21 * c - 8626949158638572e-20 * d - 2748769067499491e-19 * A - 0.02155688794978967) + d * (-3878099212869363e-20 * d - 3267808279485286e-19 * A + 0.0686742238595345) - A * (3361971776183937e-19 * A + 0.7430659151342254), y[N++] = 255 + P * (13596372813588848e-20 * P + 924537132573585e-18 * c + 10567359618683593e-20 * d + 4791864687436512e-19 * A - 0.3109689587515875) + c * (-23545346108370344e-20 * c + 2702845253534714e-19 * d + 0.0020200308977307156 * A - 0.7488052167015494) + d * (6834815998235662e-20 * d + 15168452363460973e-20 * A - 0.09751927774728933) - A * (3189131175883281e-19 * A + 0.7364883807733168), y[N++] = 255 + P * (13598650411385307e-21 * P + 12423956175490851e-20 * c + 4751985097583589e-19 * d - 36729317476630422e-22 * A - 0.05562186980264034) + c * (16141380598724676e-20 * c + 9692239130725186e-19 * d + 7782692450036253e-19 * A - 0.44015232367526463) + d * (5068882914068769e-22 * d + 0.0017778369011375071 * A - 0.7591454649749609) - A * (3435319965105553e-19 * A + 0.7063770186160144);
              return y.subarray(0, N);
            }
            _convertCmykToRgba(y) {
              for (let P = 0, c = y.length; P < c; P += 4) {
                const d = y[P], A = y[P + 1], N = y[P + 2], E = y[P + 3];
                y[P] = 255 + d * (-6747147073602441e-20 * d + 8379262121013727e-19 * A + 2894718188643294e-19 * N + 0.003264231057537806 * E - 1.1185611867203937) + A * (26374107616089405e-21 * A - 8626949158638572e-20 * N - 2748769067499491e-19 * E - 0.02155688794978967) + N * (-3878099212869363e-20 * N - 3267808279485286e-19 * E + 0.0686742238595345) - E * (3361971776183937e-19 * E + 0.7430659151342254), y[P + 1] = 255 + d * (13596372813588848e-20 * d + 924537132573585e-18 * A + 10567359618683593e-20 * N + 4791864687436512e-19 * E - 0.3109689587515875) + A * (-23545346108370344e-20 * A + 2702845253534714e-19 * N + 0.0020200308977307156 * E - 0.7488052167015494) + N * (6834815998235662e-20 * N + 15168452363460973e-20 * E - 0.09751927774728933) - E * (3189131175883281e-19 * E + 0.7364883807733168), y[P + 2] = 255 + d * (13598650411385307e-21 * d + 12423956175490851e-20 * A + 4751985097583589e-19 * N - 36729317476630422e-22 * E - 0.05562186980264034) + A * (16141380598724676e-20 * A + 9692239130725186e-19 * N + 7782692450036253e-19 * E - 0.44015232367526463) + N * (5068882914068769e-22 * N + 0.0017778369011375071 * E - 0.7591454649749609) - E * (3435319965105553e-19 * E + 0.7063770186160144), y[P + 3] = 255;
              }
              return y;
            }
            getData({
              width: y,
              height: P,
              forceRGBA: c = !1,
              forceRGB: d = !1,
              isSourcePDF: A = !1
            }) {
              if (this.numComponents > 4)
                throw new e("Unsupported color mode");
              const N = this._getLinearizedBlockData(y, P, A);
              if (this.numComponents === 1 && (c || d)) {
                const E = N.length * (c ? 4 : 3), H = new Uint8ClampedArray(E);
                let $ = 0;
                if (c)
                  (0, u.grayToRGBA)(N, new Uint32Array(H.buffer));
                else
                  for (const m of N)
                    H[$++] = m, H[$++] = m, H[$++] = m;
                return H;
              } else if (this.numComponents === 3 && this._isColorConversionNeeded) {
                if (c) {
                  const E = new Uint8ClampedArray(N.length / 3 * 4);
                  return this._convertYccToRgba(N, E);
                }
                return this._convertYccToRgb(N);
              } else if (this.numComponents === 4) {
                if (this._isColorConversionNeeded)
                  return c ? this._convertYcckToRgba(N) : d ? this._convertYcckToRgb(N) : this._convertYcckToCmyk(N);
                if (c)
                  return this._convertCmykToRgba(N);
                if (d)
                  return this._convertCmykToRgb(N);
              }
              return N;
            }
          }
          F.JpegImage = I;
        },
        /* 28 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.convertBlackAndWhiteToRGBA = q, F.convertToRGBA = u, F.grayToRGBA = t;
          var n = ae(2);
          function u(B) {
            switch (B.kind) {
              case n.ImageKind.GRAYSCALE_1BPP:
                return q(B);
              case n.ImageKind.RGB_24BPP:
                return e(B);
            }
            return null;
          }
          function q({
            src: B,
            srcPos: j = 0,
            dest: M,
            width: O,
            height: w,
            nonBlackColor: C = 4294967295,
            inverseDecode: i = !1
          }) {
            const o = n.FeatureTest.isLittleEndian ? 4278190080 : 255, [k, s] = i ? [C, o] : [o, C], l = O >> 3, g = O & 7, v = B.length;
            M = new Uint32Array(M.buffer);
            let r = 0;
            for (let x = 0; x < w; x++) {
              for (const I = j + l; j < I; j++) {
                const h = j < v ? B[j] : 255;
                M[r++] = h & 128 ? s : k, M[r++] = h & 64 ? s : k, M[r++] = h & 32 ? s : k, M[r++] = h & 16 ? s : k, M[r++] = h & 8 ? s : k, M[r++] = h & 4 ? s : k, M[r++] = h & 2 ? s : k, M[r++] = h & 1 ? s : k;
              }
              if (g === 0)
                continue;
              const b = j < v ? B[j++] : 255;
              for (let I = 0; I < g; I++)
                M[r++] = b & 1 << 7 - I ? s : k;
            }
            return {
              srcPos: j,
              destPos: r
            };
          }
          function e({
            src: B,
            srcPos: j = 0,
            dest: M,
            destPos: O = 0,
            width: w,
            height: C
          }) {
            let i = 0;
            const o = B.length >> 2, k = new Uint32Array(B.buffer, j, o);
            if (n.FeatureTest.isLittleEndian) {
              for (; i < o - 2; i += 3, O += 4) {
                const s = k[i], l = k[i + 1], g = k[i + 2];
                M[O] = s | 4278190080, M[O + 1] = s >>> 24 | l << 8 | 4278190080, M[O + 2] = l >>> 16 | g << 16 | 4278190080, M[O + 3] = g >>> 8 | 4278190080;
              }
              for (let s = i * 4, l = B.length; s < l; s += 3)
                M[O++] = B[s] | B[s + 1] << 8 | B[s + 2] << 16 | 4278190080;
            } else {
              for (; i < o - 2; i += 3, O += 4) {
                const s = k[i], l = k[i + 1], g = k[i + 2];
                M[O] = s | 255, M[O + 1] = s << 24 | l >>> 8 | 255, M[O + 2] = l << 16 | g >>> 16 | 255, M[O + 3] = g << 8 | 255;
              }
              for (let s = i * 4, l = B.length; s < l; s += 3)
                M[O++] = B[s] << 24 | B[s + 1] << 16 | B[s + 2] << 8 | 255;
            }
            return {
              srcPos: j,
              destPos: O
            };
          }
          function t(B, j) {
            if (n.FeatureTest.isLittleEndian)
              for (let M = 0, O = B.length; M < O; M++)
                j[M] = B[M] * 65793 | 4278190080;
            else
              for (let M = 0, O = B.length; M < O; M++)
                j[M] = B[M] * 16843008 | 255;
          }
        },
        /* 29 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.JpxStream = void 0;
          var n = ae(18), u = ae(30), q = ae(2);
          class e extends n.DecodeStream {
            constructor(B, j, M) {
              super(j), this.stream = B, this.dict = B.dict, this.maybeLength = j, this.params = M;
            }
            get bytes() {
              return (0, q.shadow)(this, "bytes", this.stream.getBytes(this.maybeLength));
            }
            ensureBuffer(B) {
            }
            readBlock() {
              if (this.eof)
                return;
              const B = new u.JpxImage();
              B.parse(this.bytes);
              const j = B.width, M = B.height, O = B.componentsCount, w = B.tiles.length;
              if (w === 1)
                this.buffer = B.tiles[0].items;
              else {
                const C = new Uint8ClampedArray(j * M * O);
                for (let i = 0; i < w; i++) {
                  const o = B.tiles[i], k = o.width, s = o.height, l = o.left, g = o.top, v = o.items;
                  let r = 0, x = (j * g + l) * O;
                  const b = j * O, I = k * O;
                  for (let h = 0; h < s; h++) {
                    const y = v.subarray(r, r + I);
                    C.set(y, x), r += I, x += b;
                  }
                }
                this.buffer = C;
              }
              this.bufferLength = this.buffer.length, this.eof = !0;
            }
          }
          F.JpxStream = e;
        },
        /* 30 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.JpxImage = void 0;
          var n = ae(2), u = ae(3), q = ae(25);
          class e extends n.BaseException {
            constructor(p) {
              super(`JPX error: ${p}`, "JpxError");
            }
          }
          const t = {
            LL: 0,
            LH: 1,
            HL: 1,
            HH: 2
          };
          class B {
            constructor() {
              this.failOnCorruptedImage = !1;
            }
            parse(p) {
              if ((0, u.readUint16)(p, 0) === 65359) {
                this.parseCodestream(p, 0, p.length);
                return;
              }
              const L = p.length;
              let _ = 0;
              for (; _ < L; ) {
                let G = 8, J = (0, u.readUint32)(p, _);
                const K = (0, u.readUint32)(p, _ + 4);
                if (_ += G, J === 1 && (J = (0, u.readUint32)(p, _) * 4294967296 + (0, u.readUint32)(p, _ + 4), _ += 8, G += 8), J === 0 && (J = L - _ + G), J < G)
                  throw new e("Invalid box field size");
                const V = J - G;
                let U = !0;
                switch (K) {
                  case 1785737832:
                    U = !1;
                    break;
                  case 1668246642:
                    const Q = p[_];
                    if (Q === 1) {
                      const R = (0, u.readUint32)(p, _ + 3);
                      switch (R) {
                        case 16:
                        case 17:
                        case 18:
                          break;
                        default:
                          (0, n.warn)("Unknown colorspace " + R);
                          break;
                      }
                    } else
                      Q === 2 && (0, n.info)("ICC profile not supported");
                    break;
                  case 1785737827:
                    this.parseCodestream(p, _, _ + V);
                    break;
                  case 1783636e3:
                    (0, u.readUint32)(p, _) !== 218793738 && (0, n.warn)("Invalid JP2 signature");
                    break;
                  case 1783634458:
                  case 1718909296:
                  case 1920099697:
                  case 1919251232:
                  case 1768449138:
                    break;
                  default:
                    const X = String.fromCharCode(K >> 24 & 255, K >> 16 & 255, K >> 8 & 255, K & 255);
                    (0, n.warn)(`Unsupported header type ${K} (${X}).`);
                    break;
                }
                U && (_ += V);
              }
            }
            parseImageProperties(p) {
              let T = p.getByte();
              for (; T >= 0; ) {
                const L = T;
                if (T = p.getByte(), (L << 8 | T) === 65361) {
                  p.skip(4);
                  const G = p.getInt32() >>> 0, J = p.getInt32() >>> 0, K = p.getInt32() >>> 0, V = p.getInt32() >>> 0;
                  p.skip(16);
                  const U = p.getUint16();
                  this.width = G - K, this.height = J - V, this.componentsCount = U, this.bitsPerComponent = 8;
                  return;
                }
              }
              throw new e("No size marker found in JPX stream");
            }
            parseCodestream(p, T, L) {
              const _ = {};
              let G = !1;
              try {
                let J = T;
                for (; J + 1 < L; ) {
                  const K = (0, u.readUint16)(p, J);
                  J += 2;
                  let V = 0, U, Q, X, R, f, D;
                  switch (K) {
                    case 65359:
                      _.mainHeader = !0;
                      break;
                    case 65497:
                      break;
                    case 65361:
                      V = (0, u.readUint16)(p, J);
                      const z = {};
                      z.Xsiz = (0, u.readUint32)(p, J + 4), z.Ysiz = (0, u.readUint32)(p, J + 8), z.XOsiz = (0, u.readUint32)(p, J + 12), z.YOsiz = (0, u.readUint32)(p, J + 16), z.XTsiz = (0, u.readUint32)(p, J + 20), z.YTsiz = (0, u.readUint32)(p, J + 24), z.XTOsiz = (0, u.readUint32)(p, J + 28), z.YTOsiz = (0, u.readUint32)(p, J + 32);
                      const Y = (0, u.readUint16)(p, J + 36);
                      z.Csiz = Y;
                      const W = [];
                      U = J + 38;
                      for (let ce = 0; ce < Y; ce++) {
                        const le = {
                          precision: (p[U] & 127) + 1,
                          isSigned: !!(p[U] & 128),
                          XRsiz: p[U + 1],
                          YRsiz: p[U + 2]
                        };
                        U += 3, j(le, z), W.push(le);
                      }
                      _.SIZ = z, _.components = W, M(_, W), _.QCC = [], _.COC = [];
                      break;
                    case 65372:
                      V = (0, u.readUint16)(p, J);
                      const ie = {};
                      switch (U = J + 2, Q = p[U++], Q & 31) {
                        case 0:
                          R = 8, f = !0;
                          break;
                        case 1:
                          R = 16, f = !1;
                          break;
                        case 2:
                          R = 16, f = !0;
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + Q);
                      }
                      for (ie.noQuantization = R === 8, ie.scalarExpounded = f, ie.guardBits = Q >> 5, X = []; U < V + J; ) {
                        const ce = {};
                        R === 8 ? (ce.epsilon = p[U++] >> 3, ce.mu = 0) : (ce.epsilon = p[U] >> 3, ce.mu = (p[U] & 7) << 8 | p[U + 1], U += 2), X.push(ce);
                      }
                      ie.SPqcds = X, _.mainHeader ? _.QCD = ie : (_.currentTile.QCD = ie, _.currentTile.QCC = []);
                      break;
                    case 65373:
                      V = (0, u.readUint16)(p, J);
                      const ne = {};
                      U = J + 2;
                      let re;
                      switch (_.SIZ.Csiz < 257 ? re = p[U++] : (re = (0, u.readUint16)(p, U), U += 2), Q = p[U++], Q & 31) {
                        case 0:
                          R = 8, f = !0;
                          break;
                        case 1:
                          R = 16, f = !1;
                          break;
                        case 2:
                          R = 16, f = !0;
                          break;
                        default:
                          throw new Error("Invalid SQcd value " + Q);
                      }
                      for (ne.noQuantization = R === 8, ne.scalarExpounded = f, ne.guardBits = Q >> 5, X = []; U < V + J; ) {
                        const ce = {};
                        R === 8 ? (ce.epsilon = p[U++] >> 3, ce.mu = 0) : (ce.epsilon = p[U] >> 3, ce.mu = (p[U] & 7) << 8 | p[U + 1], U += 2), X.push(ce);
                      }
                      ne.SPqcds = X, _.mainHeader ? _.QCC[re] = ne : _.currentTile.QCC[re] = ne;
                      break;
                    case 65362:
                      V = (0, u.readUint16)(p, J);
                      const ee = {};
                      U = J + 2;
                      const te = p[U++];
                      ee.entropyCoderWithCustomPrecincts = !!(te & 1), ee.sopMarkerUsed = !!(te & 2), ee.ephMarkerUsed = !!(te & 4), ee.progressionOrder = p[U++], ee.layersCount = (0, u.readUint16)(p, U), U += 2, ee.multipleComponentTransform = p[U++], ee.decompositionLevelsCount = p[U++], ee.xcb = (p[U++] & 15) + 2, ee.ycb = (p[U++] & 15) + 2;
                      const oe = p[U++];
                      if (ee.selectiveArithmeticCodingBypass = !!(oe & 1), ee.resetContextProbabilities = !!(oe & 2), ee.terminationOnEachCodingPass = !!(oe & 4), ee.verticallyStripe = !!(oe & 8), ee.predictableTermination = !!(oe & 16), ee.segmentationSymbolUsed = !!(oe & 32), ee.reversibleTransformation = p[U++], ee.entropyCoderWithCustomPrecincts) {
                        const ce = [];
                        for (; U < V + J; ) {
                          const le = p[U++];
                          ce.push({
                            PPx: le & 15,
                            PPy: le >> 4
                          });
                        }
                        ee.precinctsSizes = ce;
                      }
                      const se = [];
                      ee.selectiveArithmeticCodingBypass && se.push("selectiveArithmeticCodingBypass"), ee.terminationOnEachCodingPass && se.push("terminationOnEachCodingPass"), ee.verticallyStripe && se.push("verticallyStripe"), ee.predictableTermination && se.push("predictableTermination"), se.length > 0 && (G = !0, (0, n.warn)(`JPX: Unsupported COD options (${se.join(", ")}).`)), _.mainHeader ? _.COD = ee : (_.currentTile.COD = ee, _.currentTile.COC = []);
                      break;
                    case 65424:
                      V = (0, u.readUint16)(p, J), D = {}, D.index = (0, u.readUint16)(p, J + 2), D.length = (0, u.readUint32)(p, J + 4), D.dataEnd = D.length + J - 2, D.partIndex = p[J + 8], D.partsCount = p[J + 9], _.mainHeader = !1, D.partIndex === 0 && (D.COD = _.COD, D.COC = _.COC.slice(0), D.QCD = _.QCD, D.QCC = _.QCC.slice(0)), _.currentTile = D;
                      break;
                    case 65427:
                      D = _.currentTile, D.partIndex === 0 && (P(_, D.index), x(_)), V = D.dataEnd - J, b(_, p, J, V);
                      break;
                    case 65363:
                      (0, n.warn)("JPX: Codestream code 0xFF53 (COC) is not implemented.");
                    case 65365:
                    case 65367:
                    case 65368:
                    case 65380:
                      V = (0, u.readUint16)(p, J);
                      break;
                    default:
                      throw new Error("Unknown codestream code: " + K.toString(16));
                  }
                  J += V;
                }
              } catch (J) {
                if (G || this.failOnCorruptedImage)
                  throw new e(J.message);
                (0, n.warn)(`JPX: Trying to recover from: "${J.message}".`);
              }
              this.tiles = y(_), this.width = _.SIZ.Xsiz - _.SIZ.XOsiz, this.height = _.SIZ.Ysiz - _.SIZ.YOsiz, this.componentsCount = _.SIZ.Csiz;
            }
          }
          F.JpxImage = B;
          function j(m, p) {
            m.x0 = Math.ceil(p.XOsiz / m.XRsiz), m.x1 = Math.ceil(p.Xsiz / m.XRsiz), m.y0 = Math.ceil(p.YOsiz / m.YRsiz), m.y1 = Math.ceil(p.Ysiz / m.YRsiz), m.width = m.x1 - m.x0, m.height = m.y1 - m.y0;
          }
          function M(m, p) {
            const T = m.SIZ, L = [];
            let _;
            const G = Math.ceil((T.Xsiz - T.XTOsiz) / T.XTsiz), J = Math.ceil((T.Ysiz - T.YTOsiz) / T.YTsiz);
            for (let V = 0; V < J; V++)
              for (let U = 0; U < G; U++)
                _ = {}, _.tx0 = Math.max(T.XTOsiz + U * T.XTsiz, T.XOsiz), _.ty0 = Math.max(T.YTOsiz + V * T.YTsiz, T.YOsiz), _.tx1 = Math.min(T.XTOsiz + (U + 1) * T.XTsiz, T.Xsiz), _.ty1 = Math.min(T.YTOsiz + (V + 1) * T.YTsiz, T.Ysiz), _.width = _.tx1 - _.tx0, _.height = _.ty1 - _.ty0, _.components = [], L.push(_);
            m.tiles = L;
            const K = T.Csiz;
            for (let V = 0, U = K; V < U; V++) {
              const Q = p[V];
              for (let X = 0, R = L.length; X < R; X++) {
                const f = {};
                _ = L[X], f.tcx0 = Math.ceil(_.tx0 / Q.XRsiz), f.tcy0 = Math.ceil(_.ty0 / Q.YRsiz), f.tcx1 = Math.ceil(_.tx1 / Q.XRsiz), f.tcy1 = Math.ceil(_.ty1 / Q.YRsiz), f.width = f.tcx1 - f.tcx0, f.height = f.tcy1 - f.tcy0, _.components[V] = f;
              }
            }
          }
          function O(m, p, T) {
            const L = p.codingStyleParameters, _ = {};
            return L.entropyCoderWithCustomPrecincts ? (_.PPx = L.precinctsSizes[T].PPx, _.PPy = L.precinctsSizes[T].PPy) : (_.PPx = 15, _.PPy = 15), _.xcb_ = T > 0 ? Math.min(L.xcb, _.PPx - 1) : Math.min(L.xcb, _.PPx), _.ycb_ = T > 0 ? Math.min(L.ycb, _.PPy - 1) : Math.min(L.ycb, _.PPy), _;
          }
          function w(m, p, T) {
            const L = 1 << T.PPx, _ = 1 << T.PPy, G = p.resLevel === 0, J = 1 << T.PPx + (G ? 0 : -1), K = 1 << T.PPy + (G ? 0 : -1), V = p.trx1 > p.trx0 ? Math.ceil(p.trx1 / L) - Math.floor(p.trx0 / L) : 0, U = p.try1 > p.try0 ? Math.ceil(p.try1 / _) - Math.floor(p.try0 / _) : 0, Q = V * U;
            p.precinctParameters = {
              precinctWidth: L,
              precinctHeight: _,
              numprecinctswide: V,
              numprecinctshigh: U,
              numprecincts: Q,
              precinctWidthInSubband: J,
              precinctHeightInSubband: K
            };
          }
          function C(m, p, T) {
            const L = T.xcb_, _ = T.ycb_, G = 1 << L, J = 1 << _, K = p.tbx0 >> L, V = p.tby0 >> _, U = p.tbx1 + G - 1 >> L, Q = p.tby1 + J - 1 >> _, X = p.resolution.precinctParameters, R = [], f = [];
            let D, z, Y, W;
            for (z = V; z < Q; z++)
              for (D = K; D < U; D++) {
                Y = {
                  cbx: D,
                  cby: z,
                  tbx0: G * D,
                  tby0: J * z,
                  tbx1: G * (D + 1),
                  tby1: J * (z + 1)
                }, Y.tbx0_ = Math.max(p.tbx0, Y.tbx0), Y.tby0_ = Math.max(p.tby0, Y.tby0), Y.tbx1_ = Math.min(p.tbx1, Y.tbx1), Y.tby1_ = Math.min(p.tby1, Y.tby1);
                const ie = Math.floor((Y.tbx0_ - p.tbx0) / X.precinctWidthInSubband), ne = Math.floor((Y.tby0_ - p.tby0) / X.precinctHeightInSubband);
                if (W = ie + ne * X.numprecinctswide, Y.precinctNumber = W, Y.subbandType = p.type, Y.Lblock = 3, Y.tbx1_ <= Y.tbx0_ || Y.tby1_ <= Y.tby0_)
                  continue;
                R.push(Y);
                let re = f[W];
                re !== void 0 ? (D < re.cbxMin ? re.cbxMin = D : D > re.cbxMax && (re.cbxMax = D), z < re.cbyMin ? re.cbxMin = z : z > re.cbyMax && (re.cbyMax = z)) : f[W] = re = {
                  cbxMin: D,
                  cbyMin: z,
                  cbxMax: D,
                  cbyMax: z
                }, Y.precinct = re;
              }
            p.codeblockParameters = {
              codeblockWidth: L,
              codeblockHeight: _,
              numcodeblockwide: U - K + 1,
              numcodeblockhigh: Q - V + 1
            }, p.codeblocks = R, p.precincts = f;
          }
          function i(m, p, T) {
            const L = [], _ = m.subbands;
            for (let G = 0, J = _.length; G < J; G++) {
              const V = _[G].codeblocks;
              for (let U = 0, Q = V.length; U < Q; U++) {
                const X = V[U];
                X.precinctNumber === p && L.push(X);
              }
            }
            return {
              layerNumber: T,
              codeblocks: L
            };
          }
          function o(m) {
            const p = m.SIZ, T = m.currentTile.index, L = m.tiles[T], _ = L.codingStyleDefaultParameters.layersCount, G = p.Csiz;
            let J = 0;
            for (let X = 0; X < G; X++)
              J = Math.max(J, L.components[X].codingStyleParameters.decompositionLevelsCount);
            let K = 0, V = 0, U = 0, Q = 0;
            this.nextPacket = function() {
              for (; K < _; K++) {
                for (; V <= J; V++) {
                  for (; U < G; U++) {
                    const R = L.components[U];
                    if (V > R.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const f = R.resolutions[V], D = f.precinctParameters.numprecincts;
                    for (; Q < D; ) {
                      const z = i(f, Q, K);
                      return Q++, z;
                    }
                    Q = 0;
                  }
                  U = 0;
                }
                V = 0;
              }
              throw new e("Out of packets");
            };
          }
          function k(m) {
            const p = m.SIZ, T = m.currentTile.index, L = m.tiles[T], _ = L.codingStyleDefaultParameters.layersCount, G = p.Csiz;
            let J = 0;
            for (let X = 0; X < G; X++)
              J = Math.max(J, L.components[X].codingStyleParameters.decompositionLevelsCount);
            let K = 0, V = 0, U = 0, Q = 0;
            this.nextPacket = function() {
              for (; K <= J; K++) {
                for (; V < _; V++) {
                  for (; U < G; U++) {
                    const R = L.components[U];
                    if (K > R.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const f = R.resolutions[K], D = f.precinctParameters.numprecincts;
                    for (; Q < D; ) {
                      const z = i(f, Q, V);
                      return Q++, z;
                    }
                    Q = 0;
                  }
                  U = 0;
                }
                V = 0;
              }
              throw new e("Out of packets");
            };
          }
          function s(m) {
            const p = m.SIZ, T = m.currentTile.index, L = m.tiles[T], _ = L.codingStyleDefaultParameters.layersCount, G = p.Csiz;
            let J, K, V, U, Q = 0;
            for (V = 0; V < G; V++) {
              const R = L.components[V];
              Q = Math.max(Q, R.codingStyleParameters.decompositionLevelsCount);
            }
            const X = new Int32Array(Q + 1);
            for (K = 0; K <= Q; ++K) {
              let R = 0;
              for (V = 0; V < G; ++V) {
                const f = L.components[V].resolutions;
                K < f.length && (R = Math.max(R, f[K].precinctParameters.numprecincts));
              }
              X[K] = R;
            }
            J = 0, K = 0, V = 0, U = 0, this.nextPacket = function() {
              for (; K <= Q; K++) {
                for (; U < X[K]; U++) {
                  for (; V < G; V++) {
                    const f = L.components[V];
                    if (K > f.codingStyleParameters.decompositionLevelsCount)
                      continue;
                    const D = f.resolutions[K], z = D.precinctParameters.numprecincts;
                    if (!(U >= z)) {
                      for (; J < _; ) {
                        const Y = i(D, U, J);
                        return J++, Y;
                      }
                      J = 0;
                    }
                  }
                  V = 0;
                }
                U = 0;
              }
              throw new e("Out of packets");
            };
          }
          function l(m) {
            const p = m.SIZ, T = m.currentTile.index, L = m.tiles[T], _ = L.codingStyleDefaultParameters.layersCount, G = p.Csiz, J = r(L), K = J;
            let V = 0, U = 0, Q = 0, X = 0, R = 0;
            this.nextPacket = function() {
              for (; R < K.maxNumHigh; R++) {
                for (; X < K.maxNumWide; X++) {
                  for (; Q < G; Q++) {
                    const D = L.components[Q], z = D.codingStyleParameters.decompositionLevelsCount;
                    for (; U <= z; U++) {
                      const Y = D.resolutions[U], W = J.components[Q].resolutions[U], ie = v(X, R, W, K, Y);
                      if (ie !== null) {
                        for (; V < _; ) {
                          const ne = i(Y, ie, V);
                          return V++, ne;
                        }
                        V = 0;
                      }
                    }
                    U = 0;
                  }
                  Q = 0;
                }
                X = 0;
              }
              throw new e("Out of packets");
            };
          }
          function g(m) {
            const p = m.SIZ, T = m.currentTile.index, L = m.tiles[T], _ = L.codingStyleDefaultParameters.layersCount, G = p.Csiz, J = r(L);
            let K = 0, V = 0, U = 0, Q = 0, X = 0;
            this.nextPacket = function() {
              for (; U < G; ++U) {
                const f = L.components[U], D = J.components[U], z = f.codingStyleParameters.decompositionLevelsCount;
                for (; X < D.maxNumHigh; X++) {
                  for (; Q < D.maxNumWide; Q++) {
                    for (; V <= z; V++) {
                      const Y = f.resolutions[V], W = D.resolutions[V], ie = v(Q, X, W, D, Y);
                      if (ie !== null) {
                        for (; K < _; ) {
                          const ne = i(Y, ie, K);
                          return K++, ne;
                        }
                        K = 0;
                      }
                    }
                    V = 0;
                  }
                  Q = 0;
                }
                X = 0;
              }
              throw new e("Out of packets");
            };
          }
          function v(m, p, T, L, _) {
            const G = m * L.minWidth, J = p * L.minHeight;
            if (G % T.width !== 0 || J % T.height !== 0)
              return null;
            const K = J / T.width * _.precinctParameters.numprecinctswide;
            return G / T.height + K;
          }
          function r(m) {
            const p = m.components.length;
            let T = Number.MAX_VALUE, L = Number.MAX_VALUE, _ = 0, G = 0;
            const J = new Array(p);
            for (let K = 0; K < p; K++) {
              const V = m.components[K], U = V.codingStyleParameters.decompositionLevelsCount, Q = new Array(U + 1);
              let X = Number.MAX_VALUE, R = Number.MAX_VALUE, f = 0, D = 0, z = 1;
              for (let Y = U; Y >= 0; --Y) {
                const W = V.resolutions[Y], ie = z * W.precinctParameters.precinctWidth, ne = z * W.precinctParameters.precinctHeight;
                X = Math.min(X, ie), R = Math.min(R, ne), f = Math.max(f, W.precinctParameters.numprecinctswide), D = Math.max(D, W.precinctParameters.numprecinctshigh), Q[Y] = {
                  width: ie,
                  height: ne
                }, z <<= 1;
              }
              T = Math.min(T, X), L = Math.min(L, R), _ = Math.max(_, f), G = Math.max(G, D), J[K] = {
                resolutions: Q,
                minWidth: X,
                minHeight: R,
                maxNumWide: f,
                maxNumHigh: D
              };
            }
            return {
              components: J,
              minWidth: T,
              minHeight: L,
              maxNumWide: _,
              maxNumHigh: G
            };
          }
          function x(m) {
            const p = m.SIZ, T = m.currentTile.index, L = m.tiles[T], _ = p.Csiz;
            for (let J = 0; J < _; J++) {
              const K = L.components[J], V = K.codingStyleParameters.decompositionLevelsCount, U = [], Q = [];
              for (let X = 0; X <= V; X++) {
                const R = O(m, K, X), f = {}, D = 1 << V - X;
                f.trx0 = Math.ceil(K.tcx0 / D), f.try0 = Math.ceil(K.tcy0 / D), f.trx1 = Math.ceil(K.tcx1 / D), f.try1 = Math.ceil(K.tcy1 / D), f.resLevel = X, w(m, f, R), U.push(f);
                let z;
                if (X === 0)
                  z = {}, z.type = "LL", z.tbx0 = Math.ceil(K.tcx0 / D), z.tby0 = Math.ceil(K.tcy0 / D), z.tbx1 = Math.ceil(K.tcx1 / D), z.tby1 = Math.ceil(K.tcy1 / D), z.resolution = f, C(m, z, R), Q.push(z), f.subbands = [z];
                else {
                  const Y = 1 << V - X + 1, W = [];
                  z = {}, z.type = "HL", z.tbx0 = Math.ceil(K.tcx0 / Y - 0.5), z.tby0 = Math.ceil(K.tcy0 / Y), z.tbx1 = Math.ceil(K.tcx1 / Y - 0.5), z.tby1 = Math.ceil(K.tcy1 / Y), z.resolution = f, C(m, z, R), Q.push(z), W.push(z), z = {}, z.type = "LH", z.tbx0 = Math.ceil(K.tcx0 / Y), z.tby0 = Math.ceil(K.tcy0 / Y - 0.5), z.tbx1 = Math.ceil(K.tcx1 / Y), z.tby1 = Math.ceil(K.tcy1 / Y - 0.5), z.resolution = f, C(m, z, R), Q.push(z), W.push(z), z = {}, z.type = "HH", z.tbx0 = Math.ceil(K.tcx0 / Y - 0.5), z.tby0 = Math.ceil(K.tcy0 / Y - 0.5), z.tbx1 = Math.ceil(K.tcx1 / Y - 0.5), z.tby1 = Math.ceil(K.tcy1 / Y - 0.5), z.resolution = f, C(m, z, R), Q.push(z), W.push(z), f.subbands = W;
                }
              }
              K.resolutions = U, K.subbands = Q;
            }
            const G = L.codingStyleDefaultParameters.progressionOrder;
            switch (G) {
              case 0:
                L.packetsIterator = new o(m);
                break;
              case 1:
                L.packetsIterator = new k(m);
                break;
              case 2:
                L.packetsIterator = new s(m);
                break;
              case 3:
                L.packetsIterator = new l(m);
                break;
              case 4:
                L.packetsIterator = new g(m);
                break;
              default:
                throw new e(`Unsupported progression order ${G}`);
            }
          }
          function b(m, p, T, L) {
            let _ = 0, G, J = 0, K = !1;
            function V(ie) {
              for (; J < ie; ) {
                const ne = p[T + _];
                _++, K ? (G = G << 7 | ne, J += 7, K = !1) : (G = G << 8 | ne, J += 8), ne === 255 && (K = !0);
              }
              return J -= ie, G >>> J & (1 << ie) - 1;
            }
            function U(ie) {
              return p[T + _ - 1] === 255 && p[T + _] === ie ? (Q(1), !0) : p[T + _] === 255 && p[T + _ + 1] === ie ? (Q(2), !0) : !1;
            }
            function Q(ie) {
              _ += ie;
            }
            function X() {
              J = 0, K && (_++, K = !1);
            }
            function R() {
              if (V(1) === 0)
                return 1;
              if (V(1) === 0)
                return 2;
              let ie = V(2);
              return ie < 3 ? ie + 3 : (ie = V(5), ie < 31 ? ie + 6 : (ie = V(7), ie + 37));
            }
            const f = m.currentTile.index, D = m.tiles[f], z = m.COD.sopMarkerUsed, Y = m.COD.ephMarkerUsed, W = D.packetsIterator;
            for (; _ < L; ) {
              X(), z && U(145) && Q(4);
              const ie = W.nextPacket();
              if (!V(1))
                continue;
              const ne = ie.layerNumber, re = [];
              let ee;
              for (let te = 0, oe = ie.codeblocks.length; te < oe; te++) {
                ee = ie.codeblocks[te];
                let se = ee.precinct;
                const ce = ee.cbx - se.cbxMin, le = ee.cby - se.cbyMin;
                let de = !1, Ie = !1, Fe, we;
                if (ee.included !== void 0)
                  de = !!V(1);
                else {
                  se = ee.precinct;
                  let Re;
                  if (se.inclusionTree !== void 0)
                    Re = se.inclusionTree;
                  else {
                    const Ee = se.cbxMax - se.cbxMin + 1, ye = se.cbyMax - se.cbyMin + 1;
                    Re = new d(Ee, ye, ne), we = new c(Ee, ye), se.inclusionTree = Re, se.zeroBitPlanesTree = we;
                    for (let Te = 0; Te < ne; Te++)
                      if (V(1) !== 0)
                        throw new e("Invalid tag tree");
                  }
                  if (Re.reset(ce, le, ne))
                    for (; ; )
                      if (V(1)) {
                        if (Fe = !Re.nextLevel(), Fe) {
                          ee.included = !0, de = Ie = !0;
                          break;
                        }
                      } else {
                        Re.incrementValue(ne);
                        break;
                      }
                }
                if (!de)
                  continue;
                if (Ie) {
                  for (we = se.zeroBitPlanesTree, we.reset(ce, le); ; )
                    if (V(1)) {
                      if (Fe = !we.nextLevel(), Fe)
                        break;
                    } else
                      we.incrementValue();
                  ee.zeroBitPlanes = we.value;
                }
                const pe = R();
                for (; V(1); )
                  ee.Lblock++;
                const fe = (0, u.log2)(pe), Ae = (pe < 1 << fe ? fe - 1 : fe) + ee.Lblock, Pe = V(Ae);
                re.push({
                  codeblock: ee,
                  codingpasses: pe,
                  dataLength: Pe
                });
              }
              for (X(), Y && U(146); re.length > 0; ) {
                const te = re.shift();
                ee = te.codeblock, ee.data === void 0 && (ee.data = []), ee.data.push({
                  data: p,
                  start: T + _,
                  end: T + _ + te.dataLength,
                  codingpasses: te.codingpasses
                }), _ += te.dataLength;
              }
            }
            return _;
          }
          function I(m, p, T, L, _, G, J, K, V) {
            const U = L.tbx0, Q = L.tby0, X = L.tbx1 - L.tbx0, R = L.codeblocks, f = L.type.charAt(0) === "H" ? 1 : 0, D = L.type.charAt(1) === "H" ? p : 0;
            for (let z = 0, Y = R.length; z < Y; ++z) {
              const W = R[z], ie = W.tbx1_ - W.tbx0_, ne = W.tby1_ - W.tby0_;
              if (ie === 0 || ne === 0 || W.data === void 0)
                continue;
              const re = new A(ie, ne, W.subbandType, W.zeroBitPlanes, G);
              let ee = 2;
              const te = W.data;
              let oe = 0, se = 0, ce, le, de;
              for (ce = 0, le = te.length; ce < le; ce++)
                de = te[ce], oe += de.end - de.start, se += de.codingpasses;
              const Ie = new Uint8Array(oe);
              let Fe = 0;
              for (ce = 0, le = te.length; ce < le; ce++) {
                de = te[ce];
                const ve = de.data.subarray(de.start, de.end);
                Ie.set(ve, Fe), Fe += ve.length;
              }
              const we = new q.ArithmeticDecoder(Ie, 0, oe);
              for (re.setDecoder(we), ce = 0; ce < se; ce++) {
                switch (ee) {
                  case 0:
                    re.runSignificancePropagationPass();
                    break;
                  case 1:
                    re.runMagnitudeRefinementPass();
                    break;
                  case 2:
                    re.runCleanupPass(), K && re.checkSegmentationSymbol();
                    break;
                }
                V && re.reset(), ee = (ee + 1) % 3;
              }
              let pe = W.tbx0_ - U + (W.tby0_ - Q) * X;
              const fe = re.coefficentsSign, Ae = re.coefficentsMagnitude, Pe = re.bitsDecoded, Re = J ? 0 : 0.5;
              let Ee, ye, Te;
              Fe = 0;
              const je = L.type !== "LL";
              for (ce = 0; ce < ne; ce++) {
                const Ce = 2 * (pe / X | 0) * (p - X) + f + D;
                for (Ee = 0; Ee < ie; Ee++) {
                  if (ye = Ae[Fe], ye !== 0) {
                    ye = (ye + Re) * _, fe[Fe] !== 0 && (ye = -ye), Te = Pe[Fe];
                    const Ne = je ? Ce + (pe << 1) : pe;
                    J && Te >= G ? m[Ne] = ye : m[Ne] = ye * (1 << G - Te);
                  }
                  pe++, Fe++;
                }
                pe += X - ie;
              }
            }
          }
          function h(m, p, T) {
            const L = p.components[T], _ = L.codingStyleParameters, G = L.quantizationParameters, J = _.decompositionLevelsCount, K = G.SPqcds, V = G.scalarExpounded, U = G.guardBits, Q = _.segmentationSymbolUsed, X = _.resetContextProbabilities, R = m.components[T].precision, f = _.reversibleTransformation, D = f ? new H() : new E(), z = [];
            let Y = 0;
            for (let ie = 0; ie <= J; ie++) {
              const ne = L.resolutions[ie], re = ne.trx1 - ne.trx0, ee = ne.try1 - ne.try0, te = new Float32Array(re * ee);
              for (let oe = 0, se = ne.subbands.length; oe < se; oe++) {
                let ce, le;
                V ? (ce = K[Y].mu, le = K[Y].epsilon, Y++) : (ce = K[0].mu, le = K[0].epsilon + (ie > 0 ? 1 - ie : 0));
                const de = ne.subbands[oe], Ie = t[de.type], Fe = f ? 1 : 2 ** (R + Ie - le) * (1 + ce / 2048), we = U + le - 1;
                I(te, re, ee, de, Fe, we, f, Q, X);
              }
              z.push({
                width: re,
                height: ee,
                items: te
              });
            }
            const W = D.calculate(z, L.tcx0, L.tcy0);
            return {
              left: L.tcx0,
              top: L.tcy0,
              width: W.width,
              height: W.height,
              items: W.items
            };
          }
          function y(m) {
            const p = m.SIZ, T = m.components, L = p.Csiz, _ = [];
            for (let G = 0, J = m.tiles.length; G < J; G++) {
              const K = m.tiles[G], V = [];
              for (let re = 0; re < L; re++)
                V[re] = h(m, K, re);
              const U = V[0], Q = new Uint8ClampedArray(U.items.length * L), X = {
                left: U.left,
                top: U.top,
                width: U.width,
                height: U.height,
                items: Q
              };
              let R, f, D = 0, z, Y, W, ie, ne;
              if (K.codingStyleDefaultParameters.multipleComponentTransform) {
                const re = L === 4, ee = V[0].items, te = V[1].items, oe = V[2].items, se = re ? V[3].items : null;
                R = T[0].precision - 8, f = (128 << R) + 0.5;
                const ce = K.components[0], le = L - 3;
                if (Y = ee.length, ce.codingStyleParameters.reversibleTransformation)
                  for (z = 0; z < Y; z++, D += le) {
                    W = ee[z] + f, ie = te[z], ne = oe[z];
                    const de = W - (ne + ie >> 2);
                    Q[D++] = de + ne >> R, Q[D++] = de >> R, Q[D++] = de + ie >> R;
                  }
                else
                  for (z = 0; z < Y; z++, D += le)
                    W = ee[z] + f, ie = te[z], ne = oe[z], Q[D++] = W + 1.402 * ne >> R, Q[D++] = W - 0.34413 * ie - 0.71414 * ne >> R, Q[D++] = W + 1.772 * ie >> R;
                if (re)
                  for (z = 0, D = 3; z < Y; z++, D += 4)
                    Q[D] = se[z] + f >> R;
              } else
                for (let re = 0; re < L; re++) {
                  const ee = V[re].items;
                  for (R = T[re].precision - 8, f = (128 << R) + 0.5, D = re, z = 0, Y = ee.length; z < Y; z++)
                    Q[D] = ee[z] + f >> R, D += L;
                }
              _.push(X);
            }
            return _;
          }
          function P(m, p) {
            const L = m.SIZ.Csiz, _ = m.tiles[p];
            for (let G = 0; G < L; G++) {
              const J = _.components[G], K = m.currentTile.QCC[G] !== void 0 ? m.currentTile.QCC[G] : m.currentTile.QCD;
              J.quantizationParameters = K;
              const V = m.currentTile.COC[G] !== void 0 ? m.currentTile.COC[G] : m.currentTile.COD;
              J.codingStyleParameters = V;
            }
            _.codingStyleDefaultParameters = m.currentTile.COD;
          }
          class c {
            constructor(p, T) {
              const L = (0, u.log2)(Math.max(p, T)) + 1;
              this.levels = [];
              for (let _ = 0; _ < L; _++) {
                const G = {
                  width: p,
                  height: T,
                  items: []
                };
                this.levels.push(G), p = Math.ceil(p / 2), T = Math.ceil(T / 2);
              }
            }
            reset(p, T) {
              let L = 0, _ = 0, G;
              for (; L < this.levels.length; ) {
                G = this.levels[L];
                const J = p + T * G.width;
                if (G.items[J] !== void 0) {
                  _ = G.items[J];
                  break;
                }
                G.index = J, p >>= 1, T >>= 1, L++;
              }
              L--, G = this.levels[L], G.items[G.index] = _, this.currentLevel = L, delete this.value;
            }
            incrementValue() {
              const p = this.levels[this.currentLevel];
              p.items[p.index]++;
            }
            nextLevel() {
              let p = this.currentLevel, T = this.levels[p];
              const L = T.items[T.index];
              return p--, p < 0 ? (this.value = L, !1) : (this.currentLevel = p, T = this.levels[p], T.items[T.index] = L, !0);
            }
          }
          class d {
            constructor(p, T, L) {
              const _ = (0, u.log2)(Math.max(p, T)) + 1;
              this.levels = [];
              for (let G = 0; G < _; G++) {
                const J = new Uint8Array(p * T);
                for (let V = 0, U = J.length; V < U; V++)
                  J[V] = L;
                const K = {
                  width: p,
                  height: T,
                  items: J
                };
                this.levels.push(K), p = Math.ceil(p / 2), T = Math.ceil(T / 2);
              }
            }
            reset(p, T, L) {
              let _ = 0;
              for (; _ < this.levels.length; ) {
                const G = this.levels[_], J = p + T * G.width;
                G.index = J;
                const K = G.items[J];
                if (K === 255)
                  break;
                if (K > L)
                  return this.currentLevel = _, this.propagateValues(), !1;
                p >>= 1, T >>= 1, _++;
              }
              return this.currentLevel = _ - 1, !0;
            }
            incrementValue(p) {
              const T = this.levels[this.currentLevel];
              T.items[T.index] = p + 1, this.propagateValues();
            }
            propagateValues() {
              let p = this.currentLevel, T = this.levels[p];
              const L = T.items[T.index];
              for (; --p >= 0; )
                T = this.levels[p], T.items[T.index] = L;
            }
            nextLevel() {
              let p = this.currentLevel, T = this.levels[p];
              const L = T.items[T.index];
              return T.items[T.index] = 255, p--, p < 0 ? !1 : (this.currentLevel = p, T = this.levels[p], T.items[T.index] = L, !0);
            }
          }
          const $ = class $ {
            constructor(p, T, L, _, G) {
              this.width = p, this.height = T;
              let J;
              L === "HH" ? J = $.HHContextLabel : L === "HL" ? J = $.HLContextLabel : J = $.LLAndLHContextsLabel, this.contextLabelTable = J;
              const K = p * T;
              this.neighborsSignificance = new Uint8Array(K), this.coefficentsSign = new Uint8Array(K);
              let V;
              G > 14 ? V = new Uint32Array(K) : G > 6 ? V = new Uint16Array(K) : V = new Uint8Array(K), this.coefficentsMagnitude = V, this.processingFlags = new Uint8Array(K);
              const U = new Uint8Array(K);
              if (_ !== 0)
                for (let Q = 0; Q < K; Q++)
                  U[Q] = _;
              this.bitsDecoded = U, this.reset();
            }
            setDecoder(p) {
              this.decoder = p;
            }
            reset() {
              this.contexts = new Int8Array(19), this.contexts[0] = 8, this.contexts[$.UNIFORM_CONTEXT] = 92, this.contexts[$.RUNLENGTH_CONTEXT] = 6;
            }
            setNeighborsSignificance(p, T, L) {
              const _ = this.neighborsSignificance, G = this.width, J = this.height, K = T > 0, V = T + 1 < G;
              let U;
              p > 0 && (U = L - G, K && (_[U - 1] += 16), V && (_[U + 1] += 16), _[U] += 4), p + 1 < J && (U = L + G, K && (_[U - 1] += 16), V && (_[U + 1] += 16), _[U] += 4), K && (_[L - 1] += 1), V && (_[L + 1] += 1), _[L] |= 128;
            }
            runSignificancePropagationPass() {
              const p = this.decoder, T = this.width, L = this.height, _ = this.coefficentsMagnitude, G = this.coefficentsSign, J = this.neighborsSignificance, K = this.processingFlags, V = this.contexts, U = this.contextLabelTable, Q = this.bitsDecoded, X = -2, R = 1, f = 2;
              for (let D = 0; D < L; D += 4)
                for (let z = 0; z < T; z++) {
                  let Y = D * T + z;
                  for (let W = 0; W < 4; W++, Y += T) {
                    const ie = D + W;
                    if (ie >= L)
                      break;
                    if (K[Y] &= X, _[Y] || !J[Y])
                      continue;
                    const ne = U[J[Y]];
                    if (p.readBit(V, ne)) {
                      const ee = this.decodeSignBit(ie, z, Y);
                      G[Y] = ee, _[Y] = 1, this.setNeighborsSignificance(ie, z, Y), K[Y] |= f;
                    }
                    Q[Y]++, K[Y] |= R;
                  }
                }
            }
            decodeSignBit(p, T, L) {
              const _ = this.width, G = this.height, J = this.coefficentsMagnitude, K = this.coefficentsSign;
              let V, U, Q, X, R, f;
              X = T > 0 && J[L - 1] !== 0, T + 1 < _ && J[L + 1] !== 0 ? (Q = K[L + 1], X ? (U = K[L - 1], V = 1 - Q - U) : V = 1 - Q - Q) : X ? (U = K[L - 1], V = 1 - U - U) : V = 0;
              const D = 3 * V;
              return X = p > 0 && J[L - _] !== 0, p + 1 < G && J[L + _] !== 0 ? (Q = K[L + _], X ? (U = K[L - _], V = 1 - Q - U + D) : V = 1 - Q - Q + D) : X ? (U = K[L - _], V = 1 - U - U + D) : V = D, V >= 0 ? (R = 9 + V, f = this.decoder.readBit(this.contexts, R)) : (R = 9 - V, f = this.decoder.readBit(this.contexts, R) ^ 1), f;
            }
            runMagnitudeRefinementPass() {
              const p = this.decoder, T = this.width, L = this.height, _ = this.coefficentsMagnitude, G = this.neighborsSignificance, J = this.contexts, K = this.bitsDecoded, V = this.processingFlags, U = 1, Q = 2, X = T * L, R = T * 4;
              for (let f = 0, D; f < X; f = D) {
                D = Math.min(X, f + R);
                for (let z = 0; z < T; z++)
                  for (let Y = f + z; Y < D; Y += T) {
                    if (!_[Y] || V[Y] & U)
                      continue;
                    let W = 16;
                    V[Y] & Q && (V[Y] ^= Q, W = (G[Y] & 127) === 0 ? 15 : 14);
                    const ie = p.readBit(J, W);
                    _[Y] = _[Y] << 1 | ie, K[Y]++, V[Y] |= U;
                  }
              }
            }
            runCleanupPass() {
              const p = this.decoder, T = this.width, L = this.height, _ = this.neighborsSignificance, G = this.coefficentsMagnitude, J = this.coefficentsSign, K = this.contexts, V = this.contextLabelTable, U = this.bitsDecoded, Q = this.processingFlags, X = 1, R = 2, f = T, D = T * 2, z = T * 3;
              let Y;
              for (let W = 0; W < L; W = Y) {
                Y = Math.min(W + 4, L);
                const ie = W * T, ne = W + 3 < L;
                for (let re = 0; re < T; re++) {
                  const ee = ie + re, te = ne && Q[ee] === 0 && Q[ee + f] === 0 && Q[ee + D] === 0 && Q[ee + z] === 0 && _[ee] === 0 && _[ee + f] === 0 && _[ee + D] === 0 && _[ee + z] === 0;
                  let oe = 0, se = ee, ce = W, le;
                  if (te) {
                    if (!p.readBit(K, $.RUNLENGTH_CONTEXT)) {
                      U[ee]++, U[ee + f]++, U[ee + D]++, U[ee + z]++;
                      continue;
                    }
                    oe = p.readBit(K, $.UNIFORM_CONTEXT) << 1 | p.readBit(K, $.UNIFORM_CONTEXT), oe !== 0 && (ce = W + oe, se += oe * T), le = this.decodeSignBit(ce, re, se), J[se] = le, G[se] = 1, this.setNeighborsSignificance(ce, re, se), Q[se] |= R, se = ee;
                    for (let Ie = W; Ie <= ce; Ie++, se += T)
                      U[se]++;
                    oe++;
                  }
                  for (ce = W + oe; ce < Y; ce++, se += T) {
                    if (G[se] || Q[se] & X)
                      continue;
                    const de = V[_[se]];
                    p.readBit(K, de) === 1 && (le = this.decodeSignBit(ce, re, se), J[se] = le, G[se] = 1, this.setNeighborsSignificance(ce, re, se), Q[se] |= R), U[se]++;
                  }
                }
              }
            }
            checkSegmentationSymbol() {
              const p = this.decoder, T = this.contexts;
              if ((p.readBit(T, $.UNIFORM_CONTEXT) << 3 | p.readBit(T, $.UNIFORM_CONTEXT) << 2 | p.readBit(T, $.UNIFORM_CONTEXT) << 1 | p.readBit(T, $.UNIFORM_CONTEXT)) !== 10)
                throw new e("Invalid segmentation symbol");
            }
          };
          Dt($, "UNIFORM_CONTEXT", 17), Dt($, "RUNLENGTH_CONTEXT", 18), Dt($, "LLAndLHContextsLabel", new Uint8Array([0, 5, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 1, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8, 0, 0, 0, 0, 0, 2, 6, 8, 0, 3, 7, 8, 0, 4, 7, 8])), Dt($, "HLContextLabel", new Uint8Array([0, 3, 4, 0, 5, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 1, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8, 0, 0, 0, 0, 0, 2, 3, 4, 0, 6, 7, 7, 0, 8, 8, 8])), Dt($, "HHContextLabel", new Uint8Array([0, 1, 2, 0, 1, 2, 2, 0, 2, 2, 2, 0, 0, 0, 0, 0, 3, 4, 5, 0, 4, 5, 5, 0, 5, 5, 5, 0, 0, 0, 0, 0, 6, 7, 7, 0, 7, 7, 7, 0, 7, 7, 7, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8, 0, 0, 0, 0, 0, 8, 8, 8, 0, 8, 8, 8, 0, 8, 8, 8]));
          let A = $;
          class N {
            constructor() {
              this.constructor === N && (0, n.unreachable)("Cannot initialize Transform.");
            }
            calculate(p, T, L) {
              let _ = p[0];
              for (let G = 1, J = p.length; G < J; G++)
                _ = this.iterate(_, p[G], T, L);
              return _;
            }
            extend(p, T, L) {
              let _ = T - 1, G = T + 1, J = T + L - 2, K = T + L;
              p[_--] = p[G++], p[K++] = p[J--], p[_--] = p[G++], p[K++] = p[J--], p[_--] = p[G++], p[K++] = p[J--], p[_] = p[G], p[K] = p[J];
            }
            filter(p, T, L) {
              (0, n.unreachable)("Abstract method `filter` called");
            }
            iterate(p, T, L, _) {
              const G = p.width, J = p.height;
              let K = p.items;
              const V = T.width, U = T.height, Q = T.items;
              let X, R, f, D, z, Y;
              for (f = 0, X = 0; X < J; X++)
                for (D = X * 2 * V, R = 0; R < G; R++, f++, D += 2)
                  Q[D] = K[f];
              K = p.items = null;
              const W = 4, ie = new Float32Array(V + 2 * W);
              if (V === 1) {
                if (L & 1)
                  for (Y = 0, f = 0; Y < U; Y++, f += V)
                    Q[f] *= 0.5;
              } else
                for (Y = 0, f = 0; Y < U; Y++, f += V)
                  ie.set(Q.subarray(f, f + V), W), this.extend(ie, W, V), this.filter(ie, W, V), Q.set(ie.subarray(W, W + V), f);
              let ne = 16;
              const re = [];
              for (X = 0; X < ne; X++)
                re.push(new Float32Array(U + 2 * W));
              let ee, te = 0;
              if (p = W + U, U === 1) {
                if (_ & 1)
                  for (z = 0; z < V; z++)
                    Q[z] *= 0.5;
              } else
                for (z = 0; z < V; z++) {
                  if (te === 0) {
                    for (ne = Math.min(V - z, ne), f = z, D = W; D < p; f += V, D++)
                      for (ee = 0; ee < ne; ee++)
                        re[ee][D] = Q[f + ee];
                    te = ne;
                  }
                  te--;
                  const oe = re[te];
                  if (this.extend(oe, W, U), this.filter(oe, W, U), te === 0)
                    for (f = z - ne + 1, D = W; D < p; f += V, D++)
                      for (ee = 0; ee < ne; ee++)
                        Q[f + ee] = re[ee][D];
                }
              return {
                width: V,
                height: U,
                items: Q
              };
            }
          }
          class E extends N {
            filter(p, T, L) {
              const _ = L >> 1;
              T |= 0;
              let G, J, K, V;
              const U = -1.586134342059924, Q = -0.052980118572961, X = 0.882911075530934, R = 0.443506852043971, f = 1.230174104914001, D = 1 / f;
              for (G = T - 3, J = _ + 4; J--; G += 2)
                p[G] *= D;
              for (G = T - 2, K = R * p[G - 1], J = _ + 3; J-- && (V = R * p[G + 1], p[G] = f * p[G] - K - V, J--); G += 2)
                G += 2, K = R * p[G + 1], p[G] = f * p[G] - K - V;
              for (G = T - 1, K = X * p[G - 1], J = _ + 2; J-- && (V = X * p[G + 1], p[G] -= K + V, J--); G += 2)
                G += 2, K = X * p[G + 1], p[G] -= K + V;
              for (G = T, K = Q * p[G - 1], J = _ + 1; J-- && (V = Q * p[G + 1], p[G] -= K + V, J--); G += 2)
                G += 2, K = Q * p[G + 1], p[G] -= K + V;
              if (_ !== 0)
                for (G = T + 1, K = U * p[G - 1], J = _; J-- && (V = U * p[G + 1], p[G] -= K + V, J--); G += 2)
                  G += 2, K = U * p[G + 1], p[G] -= K + V;
            }
          }
          class H extends N {
            filter(p, T, L) {
              const _ = L >> 1;
              T |= 0;
              let G, J;
              for (G = T, J = _ + 1; J--; G += 2)
                p[G] -= p[G - 1] + p[G + 1] + 2 >> 2;
              for (G = T + 1, J = _; J--; G += 2)
                p[G] += p[G - 1] + p[G + 1] >> 1;
            }
          }
        },
        /* 31 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.LZWStream = void 0;
          var n = ae(18);
          class u extends n.DecodeStream {
            constructor(e, t, B) {
              super(t), this.str = e, this.dict = e.dict, this.cachedData = 0, this.bitsCached = 0;
              const j = 4096, M = {
                earlyChange: B,
                codeLength: 9,
                nextCode: 258,
                dictionaryValues: new Uint8Array(j),
                dictionaryLengths: new Uint16Array(j),
                dictionaryPrevCodes: new Uint16Array(j),
                currentSequence: new Uint8Array(j),
                currentSequenceLength: 0
              };
              for (let O = 0; O < 256; ++O)
                M.dictionaryValues[O] = O, M.dictionaryLengths[O] = 1;
              this.lzwState = M;
            }
            readBits(e) {
              let t = this.bitsCached, B = this.cachedData;
              for (; t < e; ) {
                const j = this.str.getByte();
                if (j === -1)
                  return this.eof = !0, null;
                B = B << 8 | j, t += 8;
              }
              return this.bitsCached = t -= e, this.cachedData = B, this.lastCode = null, B >>> t & (1 << e) - 1;
            }
            readBlock() {
              let B = 1024, j, M, O;
              const w = this.lzwState;
              if (!w)
                return;
              const C = w.earlyChange;
              let i = w.nextCode;
              const o = w.dictionaryValues, k = w.dictionaryLengths, s = w.dictionaryPrevCodes;
              let l = w.codeLength, g = w.prevCode;
              const v = w.currentSequence;
              let r = w.currentSequenceLength, x = 0, b = this.bufferLength, I = this.ensureBuffer(this.bufferLength + B);
              for (j = 0; j < 512; j++) {
                const h = this.readBits(l), y = r > 0;
                if (h < 256)
                  v[0] = h, r = 1;
                else if (h >= 258)
                  if (h < i)
                    for (r = k[h], M = r - 1, O = h; M >= 0; M--)
                      v[M] = o[O], O = s[O];
                  else
                    v[r++] = v[0];
                else if (h === 256) {
                  l = 9, i = 258, r = 0;
                  continue;
                } else {
                  this.eof = !0, delete this.lzwState;
                  break;
                }
                if (y && (s[i] = g, k[i] = k[g] + 1, o[i] = v[0], i++, l = i + C & i + C - 1 ? l : Math.min(Math.log(i + C) / 0.6931471805599453 + 1, 12) | 0), g = h, x += r, B < x) {
                  do
                    B += 512;
                  while (B < x);
                  I = this.ensureBuffer(this.bufferLength + B);
                }
                for (M = 0; M < r; M++)
                  I[b++] = v[M];
              }
              w.nextCode = i, w.codeLength = l, w.prevCode = g, w.currentSequenceLength = r, this.bufferLength = b;
            }
          }
          F.LZWStream = u;
        },
        /* 32 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PredictorStream = void 0;
          var n = ae(18), u = ae(4), q = ae(2);
          class e extends n.DecodeStream {
            constructor(B, j, M) {
              if (super(j), !(M instanceof u.Dict))
                return B;
              const O = this.predictor = M.get("Predictor") || 1;
              if (O <= 1)
                return B;
              if (O !== 2 && (O < 10 || O > 15))
                throw new q.FormatError(`Unsupported predictor: ${O}`);
              O === 2 ? this.readBlock = this.readBlockTiff : this.readBlock = this.readBlockPng, this.str = B, this.dict = B.dict;
              const w = this.colors = M.get("Colors") || 1, C = this.bits = M.get("BPC", "BitsPerComponent") || 8, i = this.columns = M.get("Columns") || 1;
              return this.pixBytes = w * C + 7 >> 3, this.rowBytes = i * w * C + 7 >> 3, this;
            }
            readBlockTiff() {
              const B = this.rowBytes, j = this.bufferLength, M = this.ensureBuffer(j + B), O = this.bits, w = this.colors, C = this.str.getBytes(B);
              if (this.eof = !C.length, this.eof)
                return;
              let i = 0, o = 0, k = 0, s = 0, l = j, g;
              if (O === 1 && w === 1)
                for (g = 0; g < B; ++g) {
                  let v = C[g] ^ i;
                  v ^= v >> 1, v ^= v >> 2, v ^= v >> 4, i = (v & 1) << 7, M[l++] = v;
                }
              else if (O === 8) {
                for (g = 0; g < w; ++g)
                  M[l++] = C[g];
                for (; g < B; ++g)
                  M[l] = M[l - w] + C[g], l++;
              } else if (O === 16) {
                const v = w * 2;
                for (g = 0; g < v; ++g)
                  M[l++] = C[g];
                for (; g < B; g += 2) {
                  const r = ((C[g] & 255) << 8) + (C[g + 1] & 255) + ((M[l - v] & 255) << 8) + (M[l - v + 1] & 255);
                  M[l++] = r >> 8 & 255, M[l++] = r & 255;
                }
              } else {
                const v = new Uint8Array(w + 1), r = (1 << O) - 1;
                let x = 0, b = j;
                const I = this.columns;
                for (g = 0; g < I; ++g)
                  for (let h = 0; h < w; ++h)
                    k < O && (i = i << 8 | C[x++] & 255, k += 8), v[h] = v[h] + (i >> k - O) & r, k -= O, o = o << O | v[h], s += O, s >= 8 && (M[b++] = o >> s - 8 & 255, s -= 8);
                s > 0 && (M[b++] = (o << 8 - s) + (i & (1 << 8 - s) - 1));
              }
              this.bufferLength += B;
            }
            readBlockPng() {
              const B = this.rowBytes, j = this.pixBytes, M = this.str.getByte(), O = this.str.getBytes(B);
              if (this.eof = !O.length, this.eof)
                return;
              const w = this.bufferLength, C = this.ensureBuffer(w + B);
              let i = C.subarray(w - B, w);
              i.length === 0 && (i = new Uint8Array(B));
              let o, k = w, s, l;
              switch (M) {
                case 0:
                  for (o = 0; o < B; ++o)
                    C[k++] = O[o];
                  break;
                case 1:
                  for (o = 0; o < j; ++o)
                    C[k++] = O[o];
                  for (; o < B; ++o)
                    C[k] = C[k - j] + O[o] & 255, k++;
                  break;
                case 2:
                  for (o = 0; o < B; ++o)
                    C[k++] = i[o] + O[o] & 255;
                  break;
                case 3:
                  for (o = 0; o < j; ++o)
                    C[k++] = (i[o] >> 1) + O[o];
                  for (; o < B; ++o)
                    C[k] = (i[o] + C[k - j] >> 1) + O[o] & 255, k++;
                  break;
                case 4:
                  for (o = 0; o < j; ++o)
                    s = i[o], l = O[o], C[k++] = s + l;
                  for (; o < B; ++o) {
                    s = i[o];
                    const g = i[o - j], v = C[k - j], r = v + s - g;
                    let x = r - v;
                    x < 0 && (x = -x);
                    let b = r - s;
                    b < 0 && (b = -b);
                    let I = r - g;
                    I < 0 && (I = -I), l = O[o], x <= b && x <= I ? C[k++] = v + l : b <= I ? C[k++] = s + l : C[k++] = g + l;
                  }
                  break;
                default:
                  throw new q.FormatError(`Unsupported predictor: ${M}`);
              }
              this.bufferLength += B;
            }
          }
          F.PredictorStream = e;
        },
        /* 33 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.RunLengthStream = void 0;
          var n = ae(18);
          class u extends n.DecodeStream {
            constructor(e, t) {
              super(t), this.str = e, this.dict = e.dict;
            }
            readBlock() {
              const e = this.str.getBytes(2);
              if (!e || e.length < 2 || e[0] === 128) {
                this.eof = !0;
                return;
              }
              let t, B = this.bufferLength, j = e[0];
              if (j < 128) {
                if (t = this.ensureBuffer(B + j + 1), t[B++] = e[1], j > 0) {
                  const M = this.str.getBytes(j);
                  t.set(M, B), B += j;
                }
              } else {
                j = 257 - j;
                const M = e[1];
                t = this.ensureBuffer(B + j + 1);
                for (let O = 0; O < j; O++)
                  t[B++] = M;
              }
              this.bufferLength = B;
            }
          }
          F.RunLengthStream = u;
        },
        /* 34 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Font = F.ErrorFont = void 0;
          var n = ae(2), u = ae(35), q = ae(38), e = ae(40), t = ae(39), B = ae(37), j = ae(41), M = ae(42), O = ae(43), w = ae(44), C = ae(45), i = ae(46), o = ae(14), k = ae(47), s = ae(3), l = ae(8), g = ae(48);
          const v = [[57344, 63743], [1048576, 1114109]], r = 1e3, x = ["ascent", "bbox", "black", "bold", "charProcOperatorList", "composite", "cssFontInfo", "data", "defaultVMetrics", "defaultWidth", "descent", "fallbackName", "fontMatrix", "isInvalidPDFjsFont", "isType3Font", "italic", "loadedName", "mimetype", "missingFile", "name", "remeasure", "subtype", "systemFontInfo", "type", "vertical"], b = ["cMap", "defaultEncoding", "differences", "isMonospace", "isSerifFont", "isSymbolicFont", "seacMap", "toFontChar", "toUnicode", "vmetrics", "widths"];
          function I(ee) {
            if (!ee.fontMatrix || ee.fontMatrix[0] === n.FONT_IDENTITY_MATRIX[0])
              return;
            const te = 1e-3 / ee.fontMatrix[0], oe = ee.widths;
            for (const se in oe)
              oe[se] *= te;
            ee.defaultWidth *= te;
          }
          function h(ee, te, oe) {
            if (ee.isInternalFont || ee.hasIncludedToUnicodeMap || ee.hasEncoding || ee.toUnicode instanceof M.IdentityToUnicodeMap || !te || oe.length === 0 || ee.defaultEncoding === B.WinAnsiEncoding)
              return;
            for (const de of oe)
              if (!U(de))
                return;
            const se = B.WinAnsiEncoding, ce = [], le = (0, t.getGlyphsUnicode)();
            for (const de in se) {
              const Ie = se[de];
              if (Ie === "")
                continue;
              const Fe = le[Ie];
              Fe !== void 0 && (ce[de] = String.fromCharCode(Fe));
            }
            ce.length > 0 && ee.toUnicode.amend(ce);
          }
          function y(ee, te) {
            if (ee.isInternalFont || ee.hasIncludedToUnicodeMap || te === ee.defaultEncoding || ee.toUnicode instanceof M.IdentityToUnicodeMap)
              return;
            const oe = [], se = (0, t.getGlyphsUnicode)();
            for (const ce in te) {
              if (ee.hasEncoding && (ee.baseEncodingName || ee.differences[ce] !== void 0))
                continue;
              const le = te[ce], de = (0, e.getUnicodeForGlyph)(le, se);
              de !== -1 && (oe[ce] = String.fromCharCode(de));
            }
            oe.length > 0 && ee.toUnicode.amend(oe);
          }
          function P(ee) {
            if (!ee.fallbackToUnicode || ee.toUnicode instanceof M.IdentityToUnicodeMap)
              return;
            const te = [];
            for (const oe in ee.fallbackToUnicode)
              ee.toUnicode.has(oe) || (te[oe] = ee.fallbackToUnicode[oe]);
            te.length > 0 && ee.toUnicode.amend(te);
          }
          class c {
            constructor(te, oe, se, ce, le, de, Ie, Fe, we) {
              this.originalCharCode = te, this.fontChar = oe, this.unicode = se, this.accent = ce, this.width = le, this.vmetric = de, this.operatorListId = Ie, this.isSpace = Fe, this.isInFont = we;
            }
            get category() {
              return (0, n.shadow)(this, "category", (0, e.getCharUnicodeCategory)(this.unicode), !0);
            }
          }
          function d(ee, te) {
            return (ee << 8) + te;
          }
          function A(ee, te, oe) {
            ee[te + 1] = oe, ee[te] = oe >>> 8;
          }
          function N(ee, te) {
            const oe = (ee << 8) + te;
            return oe & 32768 ? oe - 65536 : oe;
          }
          function E(ee, te, oe, se) {
            return (ee << 24) + (te << 16) + (oe << 8) + se;
          }
          function H(ee) {
            return String.fromCharCode(ee >> 8 & 255, ee & 255);
          }
          function $(ee) {
            return ee > 32767 ? ee = 32767 : ee < -32768 && (ee = -32768), String.fromCharCode(ee >> 8 & 255, ee & 255);
          }
          function m(ee) {
            const te = ee.peekBytes(4);
            return (0, s.readUint32)(te, 0) === 65536 || (0, n.bytesToString)(te) === "true";
          }
          function p(ee) {
            const te = ee.peekBytes(4);
            return (0, n.bytesToString)(te) === "ttcf";
          }
          function T(ee) {
            const te = ee.peekBytes(4);
            return (0, n.bytesToString)(te) === "OTTO";
          }
          function L(ee) {
            const te = ee.peekBytes(2);
            return te[0] === 37 && te[1] === 33 || te[0] === 128 && te[1] === 1;
          }
          function _(ee) {
            const te = ee.peekBytes(4);
            return te[0] >= 1 && te[3] >= 1 && te[3] <= 4;
          }
          function G(ee, {
            type: te,
            subtype: oe,
            composite: se
          }) {
            let ce, le;
            return m(ee) || p(ee) ? se ? ce = "CIDFontType2" : ce = "TrueType" : T(ee) ? se ? ce = "CIDFontType2" : ce = "OpenType" : L(ee) ? se ? ce = "CIDFontType0" : ce = te === "MMType1" ? "MMType1" : "Type1" : _(ee) ? se ? (ce = "CIDFontType0", le = "CIDFontType0C") : (ce = te === "MMType1" ? "MMType1" : "Type1", le = "Type1C") : ((0, n.warn)("getFontFileType: Unable to detect correct font file Type/Subtype."), ce = te, le = oe), [ce, le];
          }
          function J(ee, te) {
            for (const oe in te)
              ee[+oe] = te[oe];
          }
          function K(ee, te, oe) {
            const se = [];
            let ce;
            for (let le = 0, de = ee.length; le < de; le++)
              ce = (0, e.getUnicodeForGlyph)(ee[le], te), ce !== -1 && (se[le] = ce);
            for (const le in oe)
              ce = (0, e.getUnicodeForGlyph)(oe[le], te), ce !== -1 && (se[+le] = ce);
            return se;
          }
          function V(ee) {
            return ee.platform === 1 && ee.encoding === 0 && ee.language === 0;
          }
          function U(ee) {
            return ee.platform === 3 && ee.encoding === 1 && ee.language === 1033;
          }
          function Q(ee, te, oe = !1) {
            switch (te.length) {
              case 1:
                return te.charCodeAt(0);
              case 2:
                return te.charCodeAt(0) << 8 | te.charCodeAt(1);
            }
            const se = `Unsupported CID string (charCode ${ee}): "${te}".`;
            if (oe)
              throw new n.FormatError(se);
            return (0, n.warn)(se), te;
          }
          function X(ee, te, oe, se) {
            const ce = /* @__PURE__ */ Object.create(null), le = /* @__PURE__ */ new Map(), de = [], Ie = /* @__PURE__ */ new Set();
            let Fe = 0, pe = v[Fe][0], fe = v[Fe][1];
            const Ae = (Pe) => v[0][0] <= Pe && Pe <= v[0][1] || v[1][0] <= Pe && Pe <= v[1][1];
            for (let Pe in ee) {
              Pe |= 0;
              let Re = ee[Pe];
              if (!te(Re))
                continue;
              if (pe > fe) {
                if (Fe++, Fe >= v.length) {
                  (0, n.warn)("Ran out of space in font private use area.");
                  break;
                }
                pe = v[Fe][0], fe = v[Fe][1];
              }
              const Ee = pe++;
              Re === 0 && (Re = oe);
              let ye = se.get(Pe);
              typeof ye == "string" && (ye = ye.codePointAt(0)), ye && !Ae(ye) && !Ie.has(Re) && (le.set(ye, Re), Ie.add(Re)), ce[Ee] = Re, de[Pe] = Ee;
            }
            return {
              toFontChar: de,
              charCodeToGlyphId: ce,
              toUnicodeExtraMap: le,
              nextAvailableFontCharCode: pe
            };
          }
          function R(ee, te, oe) {
            const se = [];
            for (const de in ee)
              ee[de] >= oe || se.push({
                fontCharCode: de | 0,
                glyphId: ee[de]
              });
            if (te)
              for (const [de, Ie] of te)
                Ie >= oe || se.push({
                  fontCharCode: de,
                  glyphId: Ie
                });
            se.length === 0 && se.push({
              fontCharCode: 0,
              glyphId: 0
            }), se.sort(function(Ie, Fe) {
              return Ie.fontCharCode - Fe.fontCharCode;
            });
            const ce = [], le = se.length;
            for (let de = 0; de < le; ) {
              const Ie = se[de].fontCharCode, Fe = [se[de].glyphId];
              ++de;
              let we = Ie;
              for (; de < le && we + 1 === se[de].fontCharCode && (Fe.push(se[de].glyphId), ++we, ++de, we !== 65535); )
                ;
              ce.push([Ie, we, Fe]);
            }
            return ce;
          }
          function f(ee, te, oe) {
            const se = R(ee, te, oe), ce = se.at(-1)[1] > 65535 ? 2 : 1;
            let le = "\0\0" + H(ce) + "\0\0" + (0, n.string32)(4 + ce * 8), de, Ie, Fe, we;
            for (de = se.length - 1; de >= 0 && !(se[de][0] <= 65535); --de)
              ;
            const pe = de + 1;
            se[de][0] < 65535 && se[de][1] === 65535 && (se[de][1] = 65534);
            const fe = se[de][1] < 65535 ? 1 : 0, Ae = pe + fe, Pe = k.OpenTypeFileBuilder.getSearchParams(Ae, 2);
            let Re = "", Ee = "", ye = "", Te = "", je = "", ve = 0, Ce, Ne, Ge, Oe;
            for (de = 0, Ie = pe; de < Ie; de++) {
              Ce = se[de], Ne = Ce[0], Ge = Ce[1], Re += H(Ne), Ee += H(Ge), Oe = Ce[2];
              let Xe = !0;
              for (Fe = 1, we = Oe.length; Fe < we; ++Fe)
                if (Oe[Fe] !== Oe[Fe - 1] + 1) {
                  Xe = !1;
                  break;
                }
              if (Xe) {
                const Qe = Oe[0];
                ye += H(Qe - Ne & 65535), Te += H(0);
              } else {
                const Qe = (Ae - de) * 2 + ve * 2;
                for (ve += Ge - Ne + 1, ye += H(0), Te += H(Qe), Fe = 0, we = Oe.length; Fe < we; ++Fe)
                  je += H(Oe[Fe]);
              }
            }
            fe > 0 && (Ee += "ÿÿ", Re += "ÿÿ", ye += "\0", Te += "\0\0");
            const tt = "\0\0" + H(2 * Ae) + H(Pe.range) + H(Pe.entry) + H(Pe.rangeShift) + Ee + "\0\0" + Re + ye + Te + je;
            let Ke = "", et = "";
            if (ce > 1) {
              for (le += `\0\0
` + (0, n.string32)(4 + ce * 8 + 4 + tt.length), Ke = "", de = 0, Ie = se.length; de < Ie; de++) {
                Ce = se[de], Ne = Ce[0], Oe = Ce[2];
                let Xe = Oe[0];
                for (Fe = 1, we = Oe.length; Fe < we; ++Fe)
                  Oe[Fe] !== Oe[Fe - 1] + 1 && (Ge = Ce[0] + Fe - 1, Ke += (0, n.string32)(Ne) + (0, n.string32)(Ge) + (0, n.string32)(Xe), Ne = Ge + 1, Xe = Oe[Fe]);
                Ke += (0, n.string32)(Ne) + (0, n.string32)(Ce[1]) + (0, n.string32)(Xe);
              }
              et = "\0\f\0\0" + (0, n.string32)(Ke.length + 16) + "\0\0\0\0" + (0, n.string32)(Ke.length / 12);
            }
            return le + "\0" + H(tt.length + 4) + tt + et + Ke;
          }
          function D(ee, te) {
            te.pos = (te.start || 0) + ee.offset;
            const oe = te.getUint16();
            te.skip(60);
            const se = te.getUint16();
            if (oe < 4 && se & 768)
              return !1;
            const ce = te.getUint16(), le = te.getUint16();
            return ce > le || (te.skip(6), te.getUint16() === 0) ? !1 : (ee.data[8] = ee.data[9] = 0, !0);
          }
          function z(ee, te, oe) {
            oe || (oe = {
              unitsPerEm: 0,
              yMax: 0,
              yMin: 0,
              ascent: 0,
              descent: 0
            });
            let se = 0, ce = 0, le = 0, de = 0, Ie = null, Fe = 0, we = -1;
            if (te) {
              for (let Te in te)
                if (Te |= 0, (Ie > Te || !Ie) && (Ie = Te), Fe < Te && (Fe = Te), we = (0, e.getUnicodeRangeFor)(Te, we), we < 32)
                  se |= 1 << we;
                else if (we < 64)
                  ce |= 1 << we - 32;
                else if (we < 96)
                  le |= 1 << we - 64;
                else if (we < 123)
                  de |= 1 << we - 96;
                else
                  throw new n.FormatError("Unicode ranges Bits > 123 are reserved for internal usage");
              Fe > 65535 && (Fe = 65535);
            } else
              Ie = 0, Fe = 255;
            const pe = ee.bbox || [0, 0, 0, 0], fe = oe.unitsPerEm || 1 / (ee.fontMatrix || n.FONT_IDENTITY_MATRIX)[0], Ae = ee.ascentScaled ? 1 : fe / r, Pe = oe.ascent || Math.round(Ae * (ee.ascent || pe[3]));
            let Re = oe.descent || Math.round(Ae * (ee.descent || pe[1]));
            Re > 0 && ee.descent > 0 && pe[1] < 0 && (Re = -Re);
            const Ee = oe.yMax || Pe, ye = -oe.yMin || -Re;
            return "\0$ô\0\0\0»\0\0\0»\0\0ß\x001\0\0\0\0" + String.fromCharCode(ee.fixedPitch ? 9 : 0) + "\0\0\0\0\0\0" + (0, n.string32)(se) + (0, n.string32)(ce) + (0, n.string32)(le) + (0, n.string32)(de) + "*21*" + H(ee.italicAngle ? 1 : 0) + H(Ie || ee.firstChar) + H(Fe || ee.lastChar) + H(Pe) + H(Re) + "\0d" + H(Ee) + H(ye) + "\0\0\0\0\0\0\0\0" + H(ee.xHeight) + H(ee.capHeight) + H(0) + H(Ie || ee.firstChar) + "\0";
          }
          function Y(ee) {
            const te = Math.floor(ee.italicAngle * 65536);
            return "\0\0\0" + (0, n.string32)(te) + "\0\0\0\0" + (0, n.string32)(ee.fixedPitch ? 1 : 0) + "\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0";
          }
          function W(ee) {
            return ee.replaceAll(/[^\x21-\x7E]|[[\](){}<>/%]/g, "").slice(0, 63);
          }
          function ie(ee, te) {
            te || (te = [[], []]);
            const oe = [te[0][0] || "Original licence", te[0][1] || ee, te[0][2] || "Unknown", te[0][3] || "uniqueID", te[0][4] || ee, te[0][5] || "Version 0.11", te[0][6] || W(ee), te[0][7] || "Unknown", te[0][8] || "Unknown", te[0][9] || "Unknown"], se = [];
            let ce, le, de, Ie, Fe;
            for (ce = 0, le = oe.length; ce < le; ce++) {
              Fe = te[1][ce] || oe[ce];
              const ye = [];
              for (de = 0, Ie = Fe.length; de < Ie; de++)
                ye.push(H(Fe.charCodeAt(de)));
              se.push(ye.join(""));
            }
            const we = [oe, se], pe = ["\0", "\0"], fe = ["\0\0", "\0"], Ae = ["\0\0", "	"], Pe = oe.length * pe.length;
            let Re = "\0\0" + H(Pe) + H(Pe * 12 + 6), Ee = 0;
            for (ce = 0, le = pe.length; ce < le; ce++) {
              const ye = we[ce];
              for (de = 0, Ie = ye.length; de < Ie; de++) {
                Fe = ye[de];
                const Te = pe[ce] + fe[ce] + Ae[ce] + H(de) + H(Fe.length) + H(Ee);
                Re += Te, Ee += Fe.length;
              }
            }
            return Re += oe.join("") + se.join(""), Re;
          }
          class ne {
            constructor(te, oe, se) {
              var we;
              this.name = te, this.psName = null, this.mimetype = null, this.disableFontFace = !1, this.loadedName = se.loadedName, this.isType3Font = se.isType3Font, this.missingFile = !1, this.cssFontInfo = se.cssFontInfo, this._charsCache = /* @__PURE__ */ Object.create(null), this._glyphCache = /* @__PURE__ */ Object.create(null);
              let ce = !!(se.flags & q.FontFlags.Serif);
              if (!ce && !se.isSimulatedFlags) {
                const pe = te.replaceAll(/[,_]/g, "-").split("-")[0], fe = (0, j.getSerifFonts)();
                for (const Ae of pe.split("+"))
                  if (fe[Ae]) {
                    ce = !0;
                    break;
                  }
              }
              this.isSerifFont = ce, this.isSymbolicFont = !!(se.flags & q.FontFlags.Symbolic), this.isMonospace = !!(se.flags & q.FontFlags.FixedPitch);
              let {
                type: le,
                subtype: de
              } = se;
              this.type = le, this.subtype = de, this.systemFontInfo = se.systemFontInfo;
              const Ie = te.match(/^InvalidPDFjsFont_(.*)_\d+$/);
              if (this.isInvalidPDFjsFont = !!Ie, this.isInvalidPDFjsFont ? this.fallbackName = Ie[1] : this.isMonospace ? this.fallbackName = "monospace" : this.isSerifFont ? this.fallbackName = "serif" : this.fallbackName = "sans-serif", (we = this.systemFontInfo) != null && we.guessFallback && (this.systemFontInfo.guessFallback = !1, this.systemFontInfo.css += `,${this.fallbackName}`), this.differences = se.differences, this.widths = se.widths, this.defaultWidth = se.defaultWidth, this.composite = se.composite, this.cMap = se.cMap, this.capHeight = se.capHeight / r, this.ascent = se.ascent / r, this.descent = se.descent / r, this.lineHeight = this.ascent - this.descent, this.fontMatrix = se.fontMatrix, this.bbox = se.bbox, this.defaultEncoding = se.defaultEncoding, this.toUnicode = se.toUnicode, this.toFontChar = [], se.type === "Type3") {
                for (let pe = 0; pe < 256; pe++)
                  this.toFontChar[pe] = this.differences[pe] || se.defaultEncoding[pe];
                return;
              }
              if (this.cidEncoding = se.cidEncoding || "", this.vertical = !!se.vertical, this.vertical && (this.vmetrics = se.vmetrics, this.defaultVMetrics = se.defaultVMetrics), !oe || oe.isEmpty) {
                oe && (0, n.warn)('Font file is empty in "' + te + '" (' + this.loadedName + ")"), this.fallbackToSystemFont(se);
                return;
              }
              [le, de] = G(oe, se), (le !== this.type || de !== this.subtype) && (0, n.info)(`Inconsistent font file Type/SubType, expected: ${this.type}/${this.subtype} but found: ${le}/${de}.`);
              let Fe;
              try {
                switch (le) {
                  case "MMType1":
                    (0, n.info)("MMType1 font (" + te + "), falling back to Type1.");
                  case "Type1":
                  case "CIDFontType0":
                    this.mimetype = "font/opentype";
                    const pe = de === "Type1C" || de === "CIDFontType0C" ? new O.CFFFont(oe, se) : new g.Type1Font(te, oe, se);
                    I(se), Fe = this.convert(te, pe, se);
                    break;
                  case "OpenType":
                  case "TrueType":
                  case "CIDFontType2":
                    this.mimetype = "font/opentype", Fe = this.checkAndRepair(te, oe, se), this.isOpenType && (I(se), le = "OpenType");
                    break;
                  default:
                    throw new n.FormatError(`Font ${le} is not supported`);
                }
              } catch (pe) {
                (0, n.warn)(pe), this.fallbackToSystemFont(se);
                return;
              }
              P(se), this.data = Fe, this.type = le, this.subtype = de, this.fontMatrix = se.fontMatrix, this.widths = se.widths, this.defaultWidth = se.defaultWidth, this.toUnicode = se.toUnicode, this.seacMap = se.seacMap;
            }
            get renderer() {
              const te = w.FontRendererFactory.create(this, q.SEAC_ANALYSIS_ENABLED);
              return (0, n.shadow)(this, "renderer", te);
            }
            exportData(te = !1) {
              const oe = te ? [...x, ...b] : x, se = /* @__PURE__ */ Object.create(null);
              let ce, le;
              for (ce of oe)
                le = this[ce], le !== void 0 && (se[ce] = le);
              return se;
            }
            fallbackToSystemFont(te) {
              this.missingFile = !0;
              const {
                name: oe,
                type: se
              } = this;
              let ce = (0, q.normalizeFontName)(oe);
              const le = (0, j.getStdFontMap)(), de = (0, j.getNonStdFontMap)(), Ie = !!le[ce], Fe = !!(de[ce] && le[de[ce]]);
              ce = le[ce] || de[ce] || ce;
              const pe = (0, C.getFontBasicMetrics)()[ce];
              pe && (isNaN(this.ascent) && (this.ascent = pe.ascent / r), isNaN(this.descent) && (this.descent = pe.descent / r), isNaN(this.capHeight) && (this.capHeight = pe.capHeight / r)), this.bold = /bold/gi.test(ce), this.italic = /oblique|italic/gi.test(ce), this.black = /Black/g.test(oe);
              const fe = /Narrow/g.test(oe);
              if (this.remeasure = (!Ie || fe) && Object.keys(this.widths).length > 0, (Ie || Fe) && se === "CIDFontType2" && this.cidEncoding.startsWith("Identity-")) {
                const Ae = te.cidToGidMap, Pe = [];
                if (J(Pe, (0, j.getGlyphMapForStandardFonts)()), /Arial-?Black/i.test(oe) ? J(Pe, (0, j.getSupplementalGlyphMapForArialBlack)()) : /Calibri/i.test(oe) && J(Pe, (0, j.getSupplementalGlyphMapForCalibri)()), Ae) {
                  for (const Re in Pe) {
                    const Ee = Pe[Re];
                    Ae[Ee] !== void 0 && (Pe[+Re] = Ae[Ee]);
                  }
                  Ae.length !== this.toUnicode.length && te.hasIncludedToUnicodeMap && this.toUnicode instanceof M.IdentityToUnicodeMap && this.toUnicode.forEach(function(Re, Ee) {
                    const ye = Pe[Re];
                    Ae[ye] === void 0 && (Pe[+Re] = Ee);
                  });
                }
                this.toUnicode instanceof M.IdentityToUnicodeMap || this.toUnicode.forEach(function(Re, Ee) {
                  Pe[+Re] = Ee;
                }), this.toFontChar = Pe, this.toUnicode = new M.ToUnicodeMap(Pe);
              } else if (/Symbol/i.test(ce))
                this.toFontChar = K(B.SymbolSetEncoding, (0, t.getGlyphsUnicode)(), this.differences);
              else if (/Dingbats/i.test(ce))
                this.toFontChar = K(B.ZapfDingbatsEncoding, (0, t.getDingbatsGlyphsUnicode)(), this.differences);
              else if (Ie) {
                const Ae = K(this.defaultEncoding, (0, t.getGlyphsUnicode)(), this.differences);
                se === "CIDFontType2" && !this.cidEncoding.startsWith("Identity-") && !(this.toUnicode instanceof M.IdentityToUnicodeMap) && this.toUnicode.forEach(function(Pe, Re) {
                  Ae[+Pe] = Re;
                }), this.toFontChar = Ae;
              } else {
                const Ae = (0, t.getGlyphsUnicode)(), Pe = [];
                this.toUnicode.forEach((Re, Ee) => {
                  if (!this.composite) {
                    const ye = this.differences[Re] || this.defaultEncoding[Re], Te = (0, e.getUnicodeForGlyph)(ye, Ae);
                    Te !== -1 && (Ee = Te);
                  }
                  Pe[+Re] = Ee;
                }), this.composite && this.toUnicode instanceof M.IdentityToUnicodeMap && /Tahoma|Verdana/i.test(oe) && J(Pe, (0, j.getGlyphMapForStandardFonts)()), this.toFontChar = Pe;
              }
              P(te), this.loadedName = ce.split("-")[0];
            }
            checkAndRepair(te, oe, se) {
              var Et, At, Nt;
              const ce = ["OS/2", "cmap", "head", "hhea", "hmtx", "maxp", "name", "post", "loca", "glyf", "fpgm", "prep", "cvt ", "CFF "];
              function le(qe, Ue) {
                const Je = /* @__PURE__ */ Object.create(null);
                Je["OS/2"] = null, Je.cmap = null, Je.head = null, Je.hhea = null, Je.hmtx = null, Je.maxp = null, Je.name = null, Je.post = null;
                for (let Ve = 0; Ve < Ue; Ve++) {
                  const st = de(qe);
                  ce.includes(st.tag) && st.length !== 0 && (Je[st.tag] = st);
                }
                return Je;
              }
              function de(qe) {
                const Ue = qe.getString(4), Je = qe.getInt32() >>> 0, Ve = qe.getInt32() >>> 0, st = qe.getInt32() >>> 0, ft = qe.pos;
                qe.pos = qe.start || 0, qe.skip(Ve);
                const ct = qe.getBytes(st);
                return qe.pos = ft, Ue === "head" && (ct[8] = ct[9] = ct[10] = ct[11] = 0, ct[17] |= 32), {
                  tag: Ue,
                  checksum: Je,
                  length: st,
                  offset: Ve,
                  data: ct
                };
              }
              function Ie(qe) {
                return {
                  version: qe.getString(4),
                  numTables: qe.getUint16(),
                  searchRange: qe.getUint16(),
                  entrySelector: qe.getUint16(),
                  rangeShift: qe.getUint16()
                };
              }
              function Fe(qe) {
                const Ue = qe.getString(4);
                (0, n.assert)(Ue === "ttcf", "Must be a TrueType Collection font.");
                const Je = qe.getUint16(), Ve = qe.getUint16(), st = qe.getInt32() >>> 0, ft = [];
                for (let be = 0; be < st; be++)
                  ft.push(qe.getInt32() >>> 0);
                const ct = {
                  ttcTag: Ue,
                  majorVersion: Je,
                  minorVersion: Ve,
                  numFonts: st,
                  offsetTable: ft
                };
                switch (Je) {
                  case 1:
                    return ct;
                  case 2:
                    return ct.dsigTag = qe.getInt32() >>> 0, ct.dsigLength = qe.getInt32() >>> 0, ct.dsigOffset = qe.getInt32() >>> 0, ct;
                }
                throw new n.FormatError(`Invalid TrueType Collection majorVersion: ${Je}.`);
              }
              function we(qe, Ue) {
                var ct;
                const {
                  numFonts: Je,
                  offsetTable: Ve
                } = Fe(qe), st = Ue.split("+");
                let ft;
                for (let be = 0; be < Je; be++) {
                  qe.pos = (qe.start || 0) + Ve[be];
                  const _e = Ie(qe), $e = le(qe, _e.numTables);
                  if (!$e.name)
                    throw new n.FormatError('TrueType Collection font must contain a "name" table.');
                  const [Ze] = ye($e.name);
                  for (let nt = 0, pt = Ze.length; nt < pt; nt++)
                    for (let yt = 0, lt = Ze[nt].length; yt < lt; yt++) {
                      const St = (ct = Ze[nt][yt]) == null ? void 0 : ct.replaceAll(/\s/g, "");
                      if (St) {
                        if (St === Ue)
                          return {
                            header: _e,
                            tables: $e
                          };
                        if (!(st.length < 2))
                          for (const ht of st)
                            St === ht && (ft = {
                              name: ht,
                              header: _e,
                              tables: $e
                            });
                      }
                    }
                }
                if (ft)
                  return (0, n.warn)(`TrueType Collection does not contain "${Ue}" font, falling back to "${ft.name}" font instead.`), {
                    header: ft.header,
                    tables: ft.tables
                  };
                throw new n.FormatError(`TrueType Collection does not contain "${Ue}" font.`);
              }
              function pe(qe, Ue, Je, Ve) {
                if (!qe)
                  return (0, n.warn)("No cmap table available."), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                let st, ft = (Ue.start || 0) + qe.offset;
                Ue.pos = ft, Ue.skip(2);
                const ct = Ue.getUint16();
                let be, _e = !1;
                for (let lt = 0; lt < ct; lt++) {
                  const St = Ue.getUint16(), ht = Ue.getUint16(), Ft = Ue.getInt32() >>> 0;
                  let It = !1;
                  if (!((be == null ? void 0 : be.platformId) === St && (be == null ? void 0 : be.encodingId) === ht)) {
                    if (St === 0 && (ht === 0 || ht === 1 || ht === 3))
                      It = !0;
                    else if (St === 1 && ht === 0)
                      It = !0;
                    else if (St === 3 && ht === 1 && (Ve || !be))
                      It = !0, Je || (_e = !0);
                    else if (Je && St === 3 && ht === 0) {
                      It = !0;
                      let Gt = !0;
                      if (lt < ct - 1) {
                        const vt = Ue.peekBytes(2);
                        d(vt[0], vt[1]) < St && (Gt = !1);
                      }
                      Gt && (_e = !0);
                    }
                    if (It && (be = {
                      platformId: St,
                      encodingId: ht,
                      offset: Ft
                    }), _e)
                      break;
                  }
                }
                if (be && (Ue.pos = ft + be.offset), !be || Ue.peekByte() === -1)
                  return (0, n.warn)("Could not find a preferred cmap table."), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                const $e = Ue.getUint16();
                let Ze = !1;
                const nt = [];
                let pt, yt;
                if ($e === 0) {
                  for (Ue.skip(4), pt = 0; pt < 256; pt++) {
                    const lt = Ue.getByte();
                    lt && nt.push({
                      charCode: pt,
                      glyphId: lt
                    });
                  }
                  Ze = !0;
                } else if ($e === 2) {
                  Ue.skip(4);
                  const lt = [];
                  let St = 0;
                  for (let Ft = 0; Ft < 256; Ft++) {
                    const It = Ue.getUint16() >> 3;
                    lt.push(It), St = Math.max(It, St);
                  }
                  const ht = [];
                  for (let Ft = 0; Ft <= St; Ft++)
                    ht.push({
                      firstCode: Ue.getUint16(),
                      entryCount: Ue.getUint16(),
                      idDelta: N(Ue.getByte(), Ue.getByte()),
                      idRangePos: Ue.pos + Ue.getUint16()
                    });
                  for (let Ft = 0; Ft < 256; Ft++)
                    if (lt[Ft] === 0)
                      Ue.pos = ht[0].idRangePos + 2 * Ft, yt = Ue.getUint16(), nt.push({
                        charCode: Ft,
                        glyphId: yt
                      });
                    else {
                      const It = ht[lt[Ft]];
                      for (pt = 0; pt < It.entryCount; pt++) {
                        const Gt = (Ft << 8) + pt + It.firstCode;
                        Ue.pos = It.idRangePos + 2 * pt, yt = Ue.getUint16(), yt !== 0 && (yt = (yt + It.idDelta) % 65536), nt.push({
                          charCode: Gt,
                          glyphId: yt
                        });
                      }
                    }
                } else if ($e === 4) {
                  Ue.skip(4);
                  const lt = Ue.getUint16() >> 1;
                  Ue.skip(6);
                  const St = [];
                  let ht;
                  for (ht = 0; ht < lt; ht++)
                    St.push({
                      end: Ue.getUint16()
                    });
                  for (Ue.skip(2), ht = 0; ht < lt; ht++)
                    St[ht].start = Ue.getUint16();
                  for (ht = 0; ht < lt; ht++)
                    St[ht].delta = Ue.getUint16();
                  let Ft = 0, It;
                  for (ht = 0; ht < lt; ht++) {
                    st = St[ht];
                    const vt = Ue.getUint16();
                    if (!vt) {
                      st.offsetIndex = -1;
                      continue;
                    }
                    It = (vt >> 1) - (lt - ht), st.offsetIndex = It, Ft = Math.max(Ft, It + st.end - st.start + 1);
                  }
                  const Gt = [];
                  for (pt = 0; pt < Ft; pt++)
                    Gt.push(Ue.getUint16());
                  for (ht = 0; ht < lt; ht++) {
                    st = St[ht], ft = st.start;
                    const vt = st.end, kt = st.delta;
                    for (It = st.offsetIndex, pt = ft; pt <= vt; pt++)
                      pt !== 65535 && (yt = It < 0 ? pt : Gt[It + pt - ft], yt = yt + kt & 65535, nt.push({
                        charCode: pt,
                        glyphId: yt
                      }));
                  }
                } else if ($e === 6) {
                  Ue.skip(4);
                  const lt = Ue.getUint16(), St = Ue.getUint16();
                  for (pt = 0; pt < St; pt++) {
                    yt = Ue.getUint16();
                    const ht = lt + pt;
                    nt.push({
                      charCode: ht,
                      glyphId: yt
                    });
                  }
                } else if ($e === 12) {
                  Ue.skip(10);
                  const lt = Ue.getInt32() >>> 0;
                  for (pt = 0; pt < lt; pt++) {
                    const St = Ue.getInt32() >>> 0, ht = Ue.getInt32() >>> 0;
                    let Ft = Ue.getInt32() >>> 0;
                    for (let It = St; It <= ht; It++)
                      nt.push({
                        charCode: It,
                        glyphId: Ft++
                      });
                  }
                } else
                  return (0, n.warn)("cmap table has unsupported format: " + $e), {
                    platformId: -1,
                    encodingId: -1,
                    mappings: [],
                    hasShortCmap: !1
                  };
                nt.sort(function(lt, St) {
                  return lt.charCode - St.charCode;
                });
                for (let lt = 1; lt < nt.length; lt++)
                  nt[lt - 1].charCode === nt[lt].charCode && (nt.splice(lt, 1), lt--);
                return {
                  platformId: be.platformId,
                  encodingId: be.encodingId,
                  mappings: nt,
                  hasShortCmap: Ze
                };
              }
              function fe(qe, Ue, Je, Ve, st, ft) {
                if (!Ue) {
                  Je && (Je.data = null);
                  return;
                }
                qe.pos = (qe.start || 0) + Ue.offset, qe.pos += 4, qe.pos += 2, qe.pos += 2, qe.pos += 2, qe.pos += 2, qe.pos += 2, qe.pos += 2, qe.pos += 2, qe.pos += 2, qe.pos += 2;
                const ct = qe.getUint16();
                qe.pos += 8, qe.pos += 2;
                let be = qe.getUint16();
                ct !== 0 && (d(Ve.data[44], Ve.data[45]) & 2 || (Ue.data[22] = 0, Ue.data[23] = 0)), be > st && ((0, n.info)(`The numOfMetrics (${be}) should not be greater than the numGlyphs (${st}).`), be = st, Ue.data[34] = (be & 65280) >> 8, Ue.data[35] = be & 255);
                const $e = st - be - (Je.length - be * 4 >> 1);
                if ($e > 0) {
                  const Ze = new Uint8Array(Je.length + $e * 2);
                  Ze.set(Je.data), ft && (Ze[Je.length] = Je.data[2], Ze[Je.length + 1] = Je.data[3]), Je.data = Ze;
                }
              }
              function Ae(qe, Ue, Je, Ve, st, ft) {
                const ct = {
                  length: 0,
                  sizeOfInstructions: 0
                };
                if (Ue < 0 || Ue >= qe.length || Je > qe.length || Je - Ue <= 12)
                  return ct;
                const be = qe.subarray(Ue, Je), _e = N(be[2], be[3]), $e = N(be[4], be[5]), Ze = N(be[6], be[7]), nt = N(be[8], be[9]);
                _e > Ze && (A(be, 2, Ze), A(be, 6, _e)), $e > nt && (A(be, 4, nt), A(be, 8, $e));
                const pt = N(be[0], be[1]);
                if (pt < 0)
                  return pt < -1 || (Ve.set(be, st), ct.length = be.length), ct;
                let yt, lt = 10, St = 0;
                for (yt = 0; yt < pt; yt++)
                  St = (be[lt] << 8 | be[lt + 1]) + 1, lt += 2;
                const ht = lt, Ft = be[lt] << 8 | be[lt + 1];
                ct.sizeOfInstructions = Ft, lt += 2 + Ft;
                const It = lt;
                let Gt = 0;
                for (yt = 0; yt < St; yt++) {
                  const kt = be[lt++];
                  kt & 192 && (be[lt - 1] = kt & 63);
                  let Bt = 2;
                  kt & 2 ? Bt = 1 : kt & 16 && (Bt = 0);
                  let Ut = 2;
                  kt & 4 ? Ut = 1 : kt & 32 && (Ut = 0);
                  const Yt = Bt + Ut;
                  if (Gt += Yt, kt & 8) {
                    const rn = be[lt++];
                    rn === 0 && (be[lt - 1] ^= 8), yt += rn, Gt += rn * Yt;
                  }
                }
                if (Gt === 0)
                  return ct;
                let vt = lt + Gt;
                return vt > be.length ? ct : !ft && Ft > 0 ? (Ve.set(be.subarray(0, ht), st), Ve.set([0, 0], st + ht), Ve.set(be.subarray(It, vt), st + ht + 2), vt -= Ft, be.length - vt > 3 && (vt = vt + 3 & -4), ct.length = vt, ct) : be.length - vt > 3 ? (vt = vt + 3 & -4, Ve.set(be.subarray(0, vt), st), ct.length = vt, ct) : (Ve.set(be, st), ct.length = be.length, ct);
              }
              function Pe(qe, Ue, Je) {
                const Ve = qe.data, st = E(Ve[0], Ve[1], Ve[2], Ve[3]);
                st >> 16 !== 1 && ((0, n.info)("Attempting to fix invalid version in head table: " + st), Ve[0] = 0, Ve[1] = 1, Ve[2] = 0, Ve[3] = 0);
                const ft = d(Ve[50], Ve[51]);
                if (ft < 0 || ft > 1) {
                  (0, n.info)("Attempting to fix invalid indexToLocFormat in head table: " + ft);
                  const ct = Ue + 1;
                  if (Je === ct << 1)
                    Ve[50] = 0, Ve[51] = 0;
                  else if (Je === ct << 2)
                    Ve[50] = 0, Ve[51] = 1;
                  else
                    throw new n.FormatError("Could not fix indexToLocFormat: " + ft);
                }
              }
              function Re(qe, Ue, Je, Ve, st, ft, ct) {
                let be, _e, $e;
                Ve ? (be = 4, _e = function(Bt, Ut) {
                  return Bt[Ut] << 24 | Bt[Ut + 1] << 16 | Bt[Ut + 2] << 8 | Bt[Ut + 3];
                }, $e = function(Bt, Ut, Yt) {
                  Bt[Ut] = Yt >>> 24 & 255, Bt[Ut + 1] = Yt >> 16 & 255, Bt[Ut + 2] = Yt >> 8 & 255, Bt[Ut + 3] = Yt & 255;
                }) : (be = 2, _e = function(Bt, Ut) {
                  return Bt[Ut] << 9 | Bt[Ut + 1] << 1;
                }, $e = function(Bt, Ut, Yt) {
                  Bt[Ut] = Yt >> 9 & 255, Bt[Ut + 1] = Yt >> 1 & 255;
                });
                const Ze = ft ? Je + 1 : Je, nt = be * (1 + Ze), pt = new Uint8Array(nt);
                pt.set(qe.data.subarray(0, nt)), qe.data = pt;
                const yt = Ue.data, lt = yt.length, St = new Uint8Array(lt);
                let ht, Ft;
                const It = [];
                for (ht = 0, Ft = 0; ht < Je + 1; ht++, Ft += be) {
                  let kt = _e(pt, Ft);
                  kt > lt && (kt = lt), It.push({
                    index: ht,
                    offset: kt,
                    endOffset: 0
                  });
                }
                for (It.sort((kt, Bt) => kt.offset - Bt.offset), ht = 0; ht < Je; ht++)
                  It[ht].endOffset = It[ht + 1].offset;
                for (It.sort((kt, Bt) => kt.index - Bt.index), ht = 0; ht < Je; ht++) {
                  const {
                    offset: kt,
                    endOffset: Bt
                  } = It[ht];
                  if (kt !== 0 || Bt !== 0)
                    break;
                  const Ut = It[ht + 1].offset;
                  if (Ut !== 0) {
                    It[ht].endOffset = Ut;
                    break;
                  }
                }
                const Gt = /* @__PURE__ */ Object.create(null);
                let vt = 0;
                for ($e(pt, 0, vt), ht = 0, Ft = be; ht < Je; ht++, Ft += be) {
                  const kt = Ae(yt, It[ht].offset, It[ht].endOffset, St, vt, st), Bt = kt.length;
                  Bt === 0 && (Gt[ht] = !0), kt.sizeOfInstructions > ct && (ct = kt.sizeOfInstructions), vt += Bt, $e(pt, Ft, vt);
                }
                if (vt === 0) {
                  const kt = new Uint8Array([0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 49, 0]);
                  for (ht = 0, Ft = be; ht < Ze; ht++, Ft += be)
                    $e(pt, Ft, kt.length);
                  Ue.data = kt;
                } else if (ft) {
                  const kt = _e(pt, be);
                  St.length > kt + vt ? Ue.data = St.subarray(0, kt + vt) : (Ue.data = new Uint8Array(kt + vt), Ue.data.set(St.subarray(0, vt))), Ue.data.set(St.subarray(0, kt), vt), $e(qe.data, pt.length - be, vt + kt);
                } else
                  Ue.data = St.subarray(0, vt);
                return {
                  missingGlyphs: Gt,
                  maxSizeOfInstructions: ct
                };
              }
              function Ee(qe, Ue, Je) {
                const Ve = (oe.start || 0) + qe.offset;
                oe.pos = Ve;
                const st = qe.length, ft = Ve + st, ct = oe.getInt32();
                oe.skip(28);
                let be, _e = !0, $e;
                switch (ct) {
                  case 65536:
                    be = q.MacStandardGlyphOrdering;
                    break;
                  case 131072:
                    const Ze = oe.getUint16();
                    if (Ze !== Je) {
                      _e = !1;
                      break;
                    }
                    const nt = [];
                    for ($e = 0; $e < Ze; ++$e) {
                      const lt = oe.getUint16();
                      if (lt >= 32768) {
                        _e = !1;
                        break;
                      }
                      nt.push(lt);
                    }
                    if (!_e)
                      break;
                    const pt = [], yt = [];
                    for (; oe.pos < ft; ) {
                      const lt = oe.getByte();
                      for (yt.length = lt, $e = 0; $e < lt; ++$e)
                        yt[$e] = String.fromCharCode(oe.getByte());
                      pt.push(yt.join(""));
                    }
                    for (be = [], $e = 0; $e < Ze; ++$e) {
                      const lt = nt[$e];
                      if (lt < 258) {
                        be.push(q.MacStandardGlyphOrdering[lt]);
                        continue;
                      }
                      be.push(pt[lt - 258]);
                    }
                    break;
                  case 196608:
                    break;
                  default:
                    (0, n.warn)("Unknown/unsupported post table version " + ct), _e = !1, Ue.defaultEncoding && (be = Ue.defaultEncoding);
                    break;
                }
                return Ue.glyphNames = be, _e;
              }
              function ye(qe) {
                const Ue = (oe.start || 0) + qe.offset;
                oe.pos = Ue;
                const Je = [[], []], Ve = [], st = qe.length, ft = Ue + st;
                if (oe.getUint16() !== 0 || st < 6)
                  return [Je, Ve];
                const _e = oe.getUint16(), $e = oe.getUint16(), Ze = 12;
                let nt, pt;
                for (nt = 0; nt < _e && oe.pos + Ze <= ft; nt++) {
                  const yt = {
                    platform: oe.getUint16(),
                    encoding: oe.getUint16(),
                    language: oe.getUint16(),
                    name: oe.getUint16(),
                    length: oe.getUint16(),
                    offset: oe.getUint16()
                  };
                  (V(yt) || U(yt)) && Ve.push(yt);
                }
                for (nt = 0, pt = Ve.length; nt < pt; nt++) {
                  const yt = Ve[nt];
                  if (yt.length <= 0)
                    continue;
                  const lt = Ue + $e + yt.offset;
                  if (lt + yt.length > ft)
                    continue;
                  oe.pos = lt;
                  const St = yt.name;
                  if (yt.encoding) {
                    let ht = "";
                    for (let Ft = 0, It = yt.length; Ft < It; Ft += 2)
                      ht += String.fromCharCode(oe.getUint16());
                    Je[1][St] = ht;
                  } else
                    Je[0][St] = oe.getString(yt.length);
                }
                return [Je, Ve];
              }
              const Te = [0, 0, 0, 0, 0, 0, 0, 0, -2, -2, -2, -2, 0, 0, -2, -5, -1, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, -1, -1, 1, -1, -999, 0, 1, 0, -1, -2, 0, -1, -2, -1, -1, 0, -1, -1, 0, 0, -999, -999, -1, -1, -1, -1, -2, -999, -2, -2, -999, 0, -2, -2, 0, 0, -2, 0, -2, 0, 0, 0, -2, -1, -1, 1, 1, 0, 0, -1, -1, -1, -1, -1, -1, -1, 0, 0, -1, 0, -1, -1, 0, -999, -1, -1, -1, -1, -1, -1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -2, -999, -999, -999, -999, -999, -1, -1, -2, -2, 0, 0, 0, 0, -1, -1, -999, -2, -2, 0, 0, -1, -2, -2, 0, 0, 0, -1, -1, -1, -2];
              function je(qe, Ue) {
                let Je = qe.data, Ve = 0, st, ft, ct, be, _e, $e = 0, Ze = 0;
                const nt = [], pt = [], yt = [];
                let lt = Ue.tooComplexToFollowFunctions, St = !1, ht = 0, Ft = 0;
                for (let Gt = Je.length; Ve < Gt; ) {
                  const vt = Je[Ve++];
                  if (vt === 64)
                    if (ft = Je[Ve++], St || Ft)
                      Ve += ft;
                    else
                      for (st = 0; st < ft; st++)
                        nt.push(Je[Ve++]);
                  else if (vt === 65)
                    if (ft = Je[Ve++], St || Ft)
                      Ve += ft * 2;
                    else
                      for (st = 0; st < ft; st++)
                        ct = Je[Ve++], nt.push(ct << 8 | Je[Ve++]);
                  else if ((vt & 248) === 176)
                    if (ft = vt - 176 + 1, St || Ft)
                      Ve += ft;
                    else
                      for (st = 0; st < ft; st++)
                        nt.push(Je[Ve++]);
                  else if ((vt & 248) === 184)
                    if (ft = vt - 184 + 1, St || Ft)
                      Ve += ft * 2;
                    else
                      for (st = 0; st < ft; st++)
                        ct = Je[Ve++], nt.push(ct << 8 | Je[Ve++]);
                  else if (vt === 43 && !lt) {
                    if (!St && !Ft) {
                      if (be = nt.at(-1), isNaN(be))
                        (0, n.info)("TT: CALL empty stack (or invalid entry).");
                      else if (Ue.functionsUsed[be] = !0, be in Ue.functionsStackDeltas) {
                        const kt = nt.length + Ue.functionsStackDeltas[be];
                        if (kt < 0) {
                          (0, n.warn)("TT: CALL invalid functions stack delta."), Ue.hintsValid = !1;
                          return;
                        }
                        nt.length = kt;
                      } else if (be in Ue.functionsDefined && !yt.includes(be)) {
                        if (pt.push({
                          data: Je,
                          i: Ve,
                          stackTop: nt.length - 1
                        }), yt.push(be), _e = Ue.functionsDefined[be], !_e) {
                          (0, n.warn)("TT: CALL non-existent function"), Ue.hintsValid = !1;
                          return;
                        }
                        Je = _e.data, Ve = _e.i;
                      }
                    }
                  } else if (vt === 44 && !lt)
                    (St || Ft) && ((0, n.warn)("TT: nested FDEFs not allowed"), lt = !0), St = !0, Ze = Ve, be = nt.pop(), Ue.functionsDefined[be] = {
                      data: Je,
                      i: Ve
                    };
                  else if (vt === 45)
                    if (St)
                      St = !1, $e = Ve;
                    else {
                      if (_e = pt.pop(), !_e) {
                        (0, n.warn)("TT: ENDF bad stack"), Ue.hintsValid = !1;
                        return;
                      }
                      be = yt.pop(), Je = _e.data, Ve = _e.i, Ue.functionsStackDeltas[be] = nt.length - _e.stackTop;
                    }
                  else if (vt === 137)
                    (St || Ft) && ((0, n.warn)("TT: nested IDEFs not allowed"), lt = !0), St = !0, Ze = Ve;
                  else if (vt === 88)
                    ++ht;
                  else if (vt === 27)
                    Ft = ht;
                  else if (vt === 89)
                    Ft === ht && (Ft = 0), --ht;
                  else if (vt === 28 && !St && !Ft) {
                    const kt = nt.at(-1);
                    kt > 0 && (Ve += kt - 1);
                  }
                  if (!St && !Ft) {
                    let kt = 0;
                    for (vt <= 142 ? kt = Te[vt] : vt >= 192 && vt <= 223 ? kt = -1 : vt >= 224 && (kt = -2), vt >= 113 && vt <= 117 && (ft = nt.pop(), isNaN(ft) || (kt = -ft * 2)); kt < 0 && nt.length > 0; )
                      nt.pop(), kt++;
                    for (; kt > 0; )
                      nt.push(NaN), kt--;
                  }
                }
                Ue.tooComplexToFollowFunctions = lt;
                const It = [Je];
                Ve > Je.length && It.push(new Uint8Array(Ve - Je.length)), Ze > $e && ((0, n.warn)("TT: complementing a missing function tail"), It.push(new Uint8Array([34, 45]))), Ce(qe, It);
              }
              function ve(qe, Ue) {
                if (!qe.tooComplexToFollowFunctions) {
                  if (qe.functionsDefined.length > Ue) {
                    (0, n.warn)("TT: more functions defined than expected"), qe.hintsValid = !1;
                    return;
                  }
                  for (let Je = 0, Ve = qe.functionsUsed.length; Je < Ve; Je++) {
                    if (Je > Ue) {
                      (0, n.warn)("TT: invalid function id: " + Je), qe.hintsValid = !1;
                      return;
                    }
                    if (qe.functionsUsed[Je] && !qe.functionsDefined[Je]) {
                      (0, n.warn)("TT: undefined function: " + Je), qe.hintsValid = !1;
                      return;
                    }
                  }
                }
              }
              function Ce(qe, Ue) {
                if (Ue.length > 1) {
                  let Je = 0, Ve, st;
                  for (Ve = 0, st = Ue.length; Ve < st; Ve++)
                    Je += Ue[Ve].length;
                  Je = Je + 3 & -4;
                  const ft = new Uint8Array(Je);
                  let ct = 0;
                  for (Ve = 0, st = Ue.length; Ve < st; Ve++)
                    ft.set(Ue[Ve], ct), ct += Ue[Ve].length;
                  qe.data = ft, qe.length = Je;
                }
              }
              function Ne(qe, Ue, Je, Ve) {
                const st = {
                  functionsDefined: [],
                  functionsUsed: [],
                  functionsStackDeltas: [],
                  tooComplexToFollowFunctions: !1,
                  hintsValid: !0
                };
                if (qe && je(qe, st), Ue && je(Ue, st), qe && ve(st, Ve), Je && Je.length & 1) {
                  const ft = new Uint8Array(Je.length + 1);
                  ft.set(Je.data), Je.data = ft;
                }
                return st.hintsValid;
              }
              oe = new l.Stream(new Uint8Array(oe.getBytes()));
              let Ge, Oe;
              if (p(oe)) {
                const qe = we(oe, this.name);
                Ge = qe.header, Oe = qe.tables;
              } else
                Ge = Ie(oe), Oe = le(oe, Ge.numTables);
              let tt, Ke;
              const et = !Oe["CFF "];
              if (et) {
                if (!Oe.loca)
                  throw new n.FormatError('Required "loca" table is not found');
                Oe.glyf || ((0, n.warn)('Required "glyf" table is not found -- trying to recover.'), Oe.glyf = {
                  tag: "glyf",
                  data: new Uint8Array(0)
                }), this.isOpenType = !1;
              } else {
                const qe = se.composite && (((Et = se.cidToGidMap) == null ? void 0 : Et.length) > 0 || !(se.cMap instanceof o.IdentityCMap));
                if (Ge.version === "OTTO" && !qe || !Oe.head || !Oe.hhea || !Oe.maxp || !Oe.post)
                  return Ke = new l.Stream(Oe["CFF "].data), tt = new O.CFFFont(Ke, se), I(se), this.convert(te, tt, se);
                delete Oe.glyf, delete Oe.loca, delete Oe.fpgm, delete Oe.prep, delete Oe["cvt "], this.isOpenType = !0;
              }
              if (!Oe.maxp)
                throw new n.FormatError('Required "maxp" table is not found');
              oe.pos = (oe.start || 0) + Oe.maxp.offset;
              const Xe = oe.getInt32(), Qe = oe.getUint16();
              if (((At = se.scaleFactors) == null ? void 0 : At.length) === Qe && et) {
                const {
                  scaleFactors: qe
                } = se, Ue = d(Oe.head.data[50], Oe.head.data[51]), Je = new i.GlyfTable({
                  glyfTable: Oe.glyf.data,
                  isGlyphLocationsLong: Ue,
                  locaTable: Oe.loca.data,
                  numGlyphs: Qe
                });
                Je.scale(qe);
                const {
                  glyf: Ve,
                  loca: st,
                  isLocationLong: ft
                } = Je.write();
                Oe.glyf.data = Ve, Oe.loca.data = st, ft !== !!Ue && (Oe.head.data[50] = 0, Oe.head.data[51] = ft ? 1 : 0);
                const ct = Oe.hmtx.data;
                for (let be = 0; be < Qe; be++) {
                  const _e = 4 * be, $e = Math.round(qe[be] * d(ct[_e], ct[_e + 1]));
                  ct[_e] = $e >> 8 & 255, ct[_e + 1] = $e & 255;
                  const Ze = Math.round(qe[be] * N(ct[_e + 2], ct[_e + 3]));
                  A(ct, _e + 2, Ze);
                }
              }
              let it = Qe + 1, We = !0;
              it > 65535 && (We = !1, it = Qe, (0, n.warn)("Not enough space in glyfs to duplicate first glyph."));
              let gt = 0, mt = 0;
              Xe >= 65536 && Oe.maxp.length >= 22 && (oe.pos += 8, oe.getUint16() > 2 && (Oe.maxp.data[14] = 0, Oe.maxp.data[15] = 2), oe.pos += 4, gt = oe.getUint16(), oe.pos += 4, mt = oe.getUint16()), Oe.maxp.data[4] = it >> 8, Oe.maxp.data[5] = it & 255;
              const Ct = Ne(Oe.fpgm, Oe.prep, Oe["cvt "], gt);
              if (Ct || (delete Oe.fpgm, delete Oe.prep, delete Oe["cvt "]), fe(oe, Oe.hhea, Oe.hmtx, Oe.head, it, We), !Oe.head)
                throw new n.FormatError('Required "head" table is not found');
              Pe(Oe.head, Qe, et ? Oe.loca.length : 0);
              let Pt = /* @__PURE__ */ Object.create(null);
              if (et) {
                const qe = d(Oe.head.data[50], Oe.head.data[51]), Ue = Re(Oe.loca, Oe.glyf, Qe, qe, Ct, We, mt);
                Pt = Ue.missingGlyphs, Xe >= 65536 && Oe.maxp.length >= 22 && (Oe.maxp.data[26] = Ue.maxSizeOfInstructions >> 8, Oe.maxp.data[27] = Ue.maxSizeOfInstructions & 255);
              }
              if (!Oe.hhea)
                throw new n.FormatError('Required "hhea" table is not found');
              Oe.hhea.data[10] === 0 && Oe.hhea.data[11] === 0 && (Oe.hhea.data[10] = 255, Oe.hhea.data[11] = 255);
              const at = {
                unitsPerEm: d(Oe.head.data[18], Oe.head.data[19]),
                yMax: N(Oe.head.data[42], Oe.head.data[43]),
                yMin: N(Oe.head.data[38], Oe.head.data[39]),
                ascent: N(Oe.hhea.data[4], Oe.hhea.data[5]),
                descent: N(Oe.hhea.data[6], Oe.hhea.data[7]),
                lineGap: N(Oe.hhea.data[8], Oe.hhea.data[9])
              };
              this.ascent = at.ascent / at.unitsPerEm, this.descent = at.descent / at.unitsPerEm, this.lineGap = at.lineGap / at.unitsPerEm, (Nt = this.cssFontInfo) != null && Nt.lineHeight ? (this.lineHeight = this.cssFontInfo.metrics.lineHeight, this.lineGap = this.cssFontInfo.metrics.lineGap) : this.lineHeight = this.ascent - this.descent + this.lineGap, Oe.post && Ee(Oe.post, se, Qe), Oe.post = {
                tag: "post",
                data: Y(se)
              };
              const dt = [];
              function ot(qe) {
                return !Pt[qe];
              }
              if (se.composite) {
                const qe = se.cidToGidMap || [], Ue = qe.length === 0;
                se.cMap.forEach(function(Je, Ve) {
                  if (typeof Ve == "string" && (Ve = Q(Je, Ve, !0)), Ve > 65535)
                    throw new n.FormatError("Max size of CID is 65,535");
                  let st = -1;
                  Ue ? st = Ve : qe[Ve] !== void 0 && (st = qe[Ve]), st >= 0 && st < Qe && ot(st) && (dt[Je] = st);
                });
              } else {
                const qe = pe(Oe.cmap, oe, this.isSymbolicFont, se.hasEncoding), Ue = qe.platformId, Je = qe.encodingId, Ve = qe.mappings;
                let st = [], ft = !1;
                if (se.hasEncoding && (se.baseEncodingName === "MacRomanEncoding" || se.baseEncodingName === "WinAnsiEncoding") && (st = (0, B.getEncoding)(se.baseEncodingName)), se.hasEncoding && !this.isSymbolicFont && (Ue === 3 && Je === 1 || Ue === 1 && Je === 0)) {
                  const ct = (0, t.getGlyphsUnicode)();
                  for (let be = 0; be < 256; be++) {
                    let _e;
                    if (this.differences[be] !== void 0 ? _e = this.differences[be] : st.length && st[be] !== "" ? _e = st[be] : _e = B.StandardEncoding[be], !_e)
                      continue;
                    const $e = (0, q.recoverGlyphName)(_e, ct);
                    let Ze;
                    if (Ue === 3 && Je === 1 ? Ze = ct[$e] : Ue === 1 && Je === 0 && (Ze = B.MacRomanEncoding.indexOf($e)), Ze === void 0) {
                      if (!se.glyphNames && se.hasIncludedToUnicodeMap && !(this.toUnicode instanceof M.IdentityToUnicodeMap)) {
                        const nt = this.toUnicode.get(be);
                        nt && (Ze = nt.codePointAt(0));
                      }
                      if (Ze === void 0)
                        continue;
                    }
                    for (const nt of Ve)
                      if (nt.charCode === Ze) {
                        dt[be] = nt.glyphId;
                        break;
                      }
                  }
                } else if (Ue === 0) {
                  for (const ct of Ve)
                    dt[ct.charCode] = ct.glyphId;
                  ft = !0;
                } else
                  for (const ct of Ve) {
                    let be = ct.charCode;
                    Ue === 3 && be >= 61440 && be <= 61695 && (be &= 255), dt[be] = ct.glyphId;
                  }
                if (se.glyphNames && (st.length || this.differences.length))
                  for (let ct = 0; ct < 256; ++ct) {
                    if (!ft && dt[ct] !== void 0)
                      continue;
                    const be = this.differences[ct] || st[ct];
                    if (!be)
                      continue;
                    const _e = se.glyphNames.indexOf(be);
                    _e > 0 && ot(_e) && (dt[ct] = _e);
                  }
              }
              dt.length === 0 && (dt[0] = 0);
              let Mt = it - 1;
              if (We || (Mt = 0), !se.cssFontInfo) {
                const qe = X(dt, ot, Mt, this.toUnicode);
                this.toFontChar = qe.toFontChar, Oe.cmap = {
                  tag: "cmap",
                  data: f(qe.charCodeToGlyphId, qe.toUnicodeExtraMap, it)
                }, (!Oe["OS/2"] || !D(Oe["OS/2"], oe)) && (Oe["OS/2"] = {
                  tag: "OS/2",
                  data: z(se, qe.charCodeToGlyphId, at)
                });
              }
              if (!et)
                try {
                  Ke = new l.Stream(Oe["CFF "].data), tt = new u.CFFParser(Ke, se, q.SEAC_ANALYSIS_ENABLED).parse(), tt.duplicateFirstGlyph();
                  const Ue = new u.CFFCompiler(tt);
                  Oe["CFF "].data = Ue.compile();
                } catch {
                  (0, n.warn)("Failed to compile font " + se.loadedName);
                }
              if (!Oe.name)
                Oe.name = {
                  tag: "name",
                  data: ie(this.name)
                };
              else {
                const [qe, Ue] = ye(Oe.name);
                Oe.name.data = ie(te, qe), this.psName = qe[0][6] || null, se.composite || h(se, this.isSymbolicFont, Ue);
              }
              const Rt = new k.OpenTypeFileBuilder(Ge.version);
              for (const qe in Oe)
                Rt.addTable(qe, Oe[qe].data);
              return Rt.toArray();
            }
            convert(te, oe, se) {
              se.fixedPitch = !1, se.builtInEncoding && y(se, se.builtInEncoding);
              let ce = 1;
              oe instanceof O.CFFFont && (ce = oe.numGlyphs - 1);
              const le = oe.getGlyphMapping(se);
              let de = null, Ie = le, Fe = null;
              se.cssFontInfo || (de = X(le, oe.hasGlyphId.bind(oe), ce, this.toUnicode), this.toFontChar = de.toFontChar, Ie = de.charCodeToGlyphId, Fe = de.toUnicodeExtraMap);
              const we = oe.numGlyphs;
              function pe(Ee, ye) {
                let Te = null;
                for (const je in Ee)
                  ye === Ee[je] && (Te || (Te = [])).push(je | 0);
                return Te;
              }
              function fe(Ee, ye) {
                for (const Te in Ee)
                  if (ye === Ee[Te])
                    return Te | 0;
                return de.charCodeToGlyphId[de.nextAvailableFontCharCode] = ye, de.nextAvailableFontCharCode++;
              }
              const Ae = oe.seacs;
              if (de && q.SEAC_ANALYSIS_ENABLED && (Ae != null && Ae.length)) {
                const Ee = se.fontMatrix || n.FONT_IDENTITY_MATRIX, ye = oe.getCharset(), Te = /* @__PURE__ */ Object.create(null);
                for (let je in Ae) {
                  je |= 0;
                  const ve = Ae[je], Ce = B.StandardEncoding[ve[2]], Ne = B.StandardEncoding[ve[3]], Ge = ye.indexOf(Ce), Oe = ye.indexOf(Ne);
                  if (Ge < 0 || Oe < 0)
                    continue;
                  const tt = {
                    x: ve[0] * Ee[0] + ve[1] * Ee[2] + Ee[4],
                    y: ve[0] * Ee[1] + ve[1] * Ee[3] + Ee[5]
                  }, Ke = pe(le, je);
                  if (Ke)
                    for (const et of Ke) {
                      const Xe = de.charCodeToGlyphId, Qe = fe(Xe, Ge), it = fe(Xe, Oe);
                      Te[et] = {
                        baseFontCharCode: Qe,
                        accentFontCharCode: it,
                        accentOffset: tt
                      };
                    }
                }
                se.seacMap = Te;
              }
              const Pe = 1 / (se.fontMatrix || n.FONT_IDENTITY_MATRIX)[0], Re = new k.OpenTypeFileBuilder("OTTO");
              return Re.addTable("CFF ", oe.data), Re.addTable("OS/2", z(se, Ie)), Re.addTable("cmap", f(Ie, Fe, we)), Re.addTable("head", "\0\0\0\0\0\0\0\0\0\0_<õ\0\0" + $(Pe) + "\0\0\0\0\v~'\0\0\0\0\v~'\0\0" + $(se.descent) + "ÿ" + $(se.ascent) + H(se.italicAngle ? 2 : 0) + "\0\0\0\0\0\0\0"), Re.addTable("hhea", "\0\0\0" + $(se.ascent) + $(se.descent) + "\0\0ÿÿ\0\0\0\0\0\0" + $(se.capHeight) + $(Math.tan(se.italicAngle) * se.xHeight) + "\0\0\0\0\0\0\0\0\0\0\0\0" + H(we)), Re.addTable("hmtx", function() {
                const ye = oe.charstrings, Te = oe.cff ? oe.cff.widths : null;
                let je = "\0\0\0\0";
                for (let ve = 1, Ce = we; ve < Ce; ve++) {
                  let Ne = 0;
                  if (ye) {
                    const Ge = ye[ve - 1];
                    Ne = "width" in Ge ? Ge.width : 0;
                  } else
                    Te && (Ne = Math.ceil(Te[ve] || 0));
                  je += H(Ne) + H(0);
                }
                return je;
              }()), Re.addTable("maxp", "\0\0P\0" + H(we)), Re.addTable("name", ie(te)), Re.addTable("post", Y(se)), Re.toArray();
            }
            get spaceWidth() {
              const te = ["space", "minus", "one", "i", "I"];
              let oe;
              for (const se of te) {
                if (se in this.widths) {
                  oe = this.widths[se];
                  break;
                }
                const le = (0, t.getGlyphsUnicode)()[se];
                let de = 0;
                if (this.composite && this.cMap.contains(le) && (de = this.cMap.lookup(le), typeof de == "string" && (de = Q(le, de))), !de && this.toUnicode && (de = this.toUnicode.charCodeOf(le)), de <= 0 && (de = le), oe = this.widths[de], oe)
                  break;
              }
              return (0, n.shadow)(this, "spaceWidth", oe || this.defaultWidth);
            }
            _charToGlyph(te, oe = !1) {
              var Pe, Re, Ee;
              let se = this._glyphCache[te];
              if ((se == null ? void 0 : se.isSpace) === oe)
                return se;
              let ce, le, de, Ie = te;
              (Pe = this.cMap) != null && Pe.contains(te) && (Ie = this.cMap.lookup(te), typeof Ie == "string" && (Ie = Q(te, Ie))), le = this.widths[Ie], typeof le != "number" && (le = this.defaultWidth);
              const Fe = (Re = this.vmetrics) == null ? void 0 : Re[Ie];
              let we = this.toUnicode.get(te) || te;
              typeof we == "number" && (we = String.fromCharCode(we));
              let pe = this.toFontChar[te] !== void 0;
              if (ce = this.toFontChar[te] || te, this.missingFile) {
                const ye = this.differences[te] || this.defaultEncoding[te];
                (ye === ".notdef" || ye === "") && this.type === "Type1" && (ce = 32), ce = (0, e.mapSpecialUnicodeValues)(ce);
              }
              this.isType3Font && (de = ce);
              let fe = null;
              if ((Ee = this.seacMap) != null && Ee[te]) {
                pe = !0;
                const ye = this.seacMap[te];
                ce = ye.baseFontCharCode, fe = {
                  fontChar: String.fromCodePoint(ye.accentFontCharCode),
                  offset: ye.accentOffset
                };
              }
              let Ae = "";
              return typeof ce == "number" && (ce <= 1114111 ? Ae = String.fromCodePoint(ce) : (0, n.warn)(`charToGlyph - invalid fontCharCode: ${ce}`)), se = new c(te, Ae, we, fe, le, Fe, de, oe, pe), this._glyphCache[te] = se;
            }
            charsToGlyphs(te) {
              let oe = this._charsCache[te];
              if (oe)
                return oe;
              if (oe = [], this.cMap) {
                const se = /* @__PURE__ */ Object.create(null), ce = te.length;
                let le = 0;
                for (; le < ce; ) {
                  this.cMap.readCharCode(te, le, se);
                  const {
                    charcode: de,
                    length: Ie
                  } = se;
                  le += Ie;
                  const Fe = this._charToGlyph(de, Ie === 1 && te.charCodeAt(le - 1) === 32);
                  oe.push(Fe);
                }
              } else
                for (let se = 0, ce = te.length; se < ce; ++se) {
                  const le = te.charCodeAt(se), de = this._charToGlyph(le, le === 32);
                  oe.push(de);
                }
              return this._charsCache[te] = oe;
            }
            getCharPositions(te) {
              const oe = [];
              if (this.cMap) {
                const se = /* @__PURE__ */ Object.create(null);
                let ce = 0;
                for (; ce < te.length; ) {
                  this.cMap.readCharCode(te, ce, se);
                  const le = se.length;
                  oe.push([ce, ce + le]), ce += le;
                }
              } else
                for (let se = 0, ce = te.length; se < ce; ++se)
                  oe.push([se, se + 1]);
              return oe;
            }
            get glyphCacheValues() {
              return Object.values(this._glyphCache);
            }
            encodeString(te) {
              const oe = [], se = [], ce = () => oe.length % 2 === 1, le = this.toUnicode instanceof M.IdentityToUnicodeMap ? (de) => this.toUnicode.charCodeOf(de) : (de) => this.toUnicode.charCodeOf(String.fromCodePoint(de));
              for (let de = 0, Ie = te.length; de < Ie; de++) {
                const Fe = te.codePointAt(de);
                if (Fe > 55295 && (Fe < 57344 || Fe > 65533) && de++, this.toUnicode) {
                  const we = le(Fe);
                  if (we !== -1) {
                    ce() && (oe.push(se.join("")), se.length = 0);
                    const pe = this.cMap ? this.cMap.getCharCodeLength(we) : 1;
                    for (let fe = pe - 1; fe >= 0; fe--)
                      se.push(String.fromCharCode(we >> 8 * fe & 255));
                    continue;
                  }
                }
                ce() || (oe.push(se.join("")), se.length = 0), se.push(String.fromCodePoint(Fe));
              }
              return oe.push(se.join("")), oe;
            }
          }
          F.Font = ne;
          class re {
            constructor(te) {
              this.error = te, this.loadedName = "g_font_error", this.missingFile = !0;
            }
            charsToGlyphs() {
              return [];
            }
            encodeString(te) {
              return [te];
            }
            exportData(te = !1) {
              return {
                error: this.error
              };
            }
          }
          F.ErrorFont = re;
        },
        /* 35 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.CFFTopDict = F.CFFStrings = F.CFFStandardStrings = F.CFFPrivateDict = F.CFFParser = F.CFFIndex = F.CFFHeader = F.CFFFDSelect = F.CFFCompiler = F.CFFCharset = F.CFF = void 0;
          var n = ae(2), u = ae(36), q = ae(37);
          const e = 10, t = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall", "001.000", "001.001", "001.002", "001.003", "Black", "Bold", "Book", "Light", "Medium", "Regular", "Roman", "Semibold"];
          F.CFFStandardStrings = t;
          const B = 391, j = [null, {
            id: "hstem",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, null, {
            id: "vstem",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "vmoveto",
            min: 1,
            stackClearing: !0
          }, {
            id: "rlineto",
            min: 2,
            resetStack: !0
          }, {
            id: "hlineto",
            min: 1,
            resetStack: !0
          }, {
            id: "vlineto",
            min: 1,
            resetStack: !0
          }, {
            id: "rrcurveto",
            min: 6,
            resetStack: !0
          }, null, {
            id: "callsubr",
            min: 1,
            undefStack: !0
          }, {
            id: "return",
            min: 0,
            undefStack: !0
          }, null, null, {
            id: "endchar",
            min: 0,
            stackClearing: !0
          }, null, null, null, {
            id: "hstemhm",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "hintmask",
            min: 0,
            stackClearing: !0
          }, {
            id: "cntrmask",
            min: 0,
            stackClearing: !0
          }, {
            id: "rmoveto",
            min: 2,
            stackClearing: !0
          }, {
            id: "hmoveto",
            min: 1,
            stackClearing: !0
          }, {
            id: "vstemhm",
            min: 2,
            stackClearing: !0,
            stem: !0
          }, {
            id: "rcurveline",
            min: 8,
            resetStack: !0
          }, {
            id: "rlinecurve",
            min: 8,
            resetStack: !0
          }, {
            id: "vvcurveto",
            min: 4,
            resetStack: !0
          }, {
            id: "hhcurveto",
            min: 4,
            resetStack: !0
          }, null, {
            id: "callgsubr",
            min: 1,
            undefStack: !0
          }, {
            id: "vhcurveto",
            min: 4,
            resetStack: !0
          }, {
            id: "hvcurveto",
            min: 4,
            resetStack: !0
          }], M = [null, null, null, {
            id: "and",
            min: 2,
            stackDelta: -1
          }, {
            id: "or",
            min: 2,
            stackDelta: -1
          }, {
            id: "not",
            min: 1,
            stackDelta: 0
          }, null, null, null, {
            id: "abs",
            min: 1,
            stackDelta: 0
          }, {
            id: "add",
            min: 2,
            stackDelta: -1,
            stackFn(P, c) {
              P[c - 2] = P[c - 2] + P[c - 1];
            }
          }, {
            id: "sub",
            min: 2,
            stackDelta: -1,
            stackFn(P, c) {
              P[c - 2] = P[c - 2] - P[c - 1];
            }
          }, {
            id: "div",
            min: 2,
            stackDelta: -1,
            stackFn(P, c) {
              P[c - 2] = P[c - 2] / P[c - 1];
            }
          }, null, {
            id: "neg",
            min: 1,
            stackDelta: 0,
            stackFn(P, c) {
              P[c - 1] = -P[c - 1];
            }
          }, {
            id: "eq",
            min: 2,
            stackDelta: -1
          }, null, null, {
            id: "drop",
            min: 1,
            stackDelta: -1
          }, null, {
            id: "put",
            min: 2,
            stackDelta: -2
          }, {
            id: "get",
            min: 1,
            stackDelta: 0
          }, {
            id: "ifelse",
            min: 4,
            stackDelta: -3
          }, {
            id: "random",
            min: 0,
            stackDelta: 1
          }, {
            id: "mul",
            min: 2,
            stackDelta: -1,
            stackFn(P, c) {
              P[c - 2] = P[c - 2] * P[c - 1];
            }
          }, null, {
            id: "sqrt",
            min: 1,
            stackDelta: 0
          }, {
            id: "dup",
            min: 1,
            stackDelta: 1
          }, {
            id: "exch",
            min: 2,
            stackDelta: 0
          }, {
            id: "index",
            min: 2,
            stackDelta: 0
          }, {
            id: "roll",
            min: 3,
            stackDelta: -2
          }, null, null, null, {
            id: "hflex",
            min: 7,
            resetStack: !0
          }, {
            id: "flex",
            min: 13,
            resetStack: !0
          }, {
            id: "hflex1",
            min: 9,
            resetStack: !0
          }, {
            id: "flex1",
            min: 11,
            resetStack: !0
          }];
          class O {
            constructor(c, d, A) {
              this.bytes = c.getBytes(), this.properties = d, this.seacAnalysisEnabled = !!A;
            }
            parse() {
              const c = this.properties, d = new w();
              this.cff = d;
              const A = this.parseHeader(), N = this.parseIndex(A.endPos), E = this.parseIndex(N.endPos), H = this.parseIndex(E.endPos), $ = this.parseIndex(H.endPos), m = this.parseDict(E.obj.get(0)), p = this.createDict(l, m, d.strings);
              d.header = A.obj, d.names = this.parseNameIndex(N.obj), d.strings = this.parseStringIndex(H.obj), d.topDict = p, d.globalSubrIndex = $.obj, this.parsePrivateDict(d.topDict), d.isCIDFont = p.hasName("ROS");
              const T = p.getByName("CharStrings"), L = this.parseIndex(T).obj, _ = p.getByName("FontMatrix");
              _ && (c.fontMatrix = _);
              const G = p.getByName("FontBBox");
              G && (c.ascent = Math.max(G[3], G[1]), c.descent = Math.min(G[1], G[3]), c.ascentScaled = !0);
              let J, K;
              if (d.isCIDFont) {
                const U = this.parseIndex(p.getByName("FDArray")).obj;
                for (let Q = 0, X = U.count; Q < X; ++Q) {
                  const R = U.get(Q), f = this.createDict(l, this.parseDict(R), d.strings);
                  this.parsePrivateDict(f), d.fdArray.push(f);
                }
                K = null, J = this.parseCharsets(p.getByName("charset"), L.count, d.strings, !0), d.fdSelect = this.parseFDSelect(p.getByName("FDSelect"), L.count);
              } else
                J = this.parseCharsets(p.getByName("charset"), L.count, d.strings, !1), K = this.parseEncoding(p.getByName("Encoding"), c, d.strings, J.charset);
              d.charset = J, d.encoding = K;
              const V = this.parseCharStrings({
                charStrings: L,
                localSubrIndex: p.privateDict.subrsIndex,
                globalSubrIndex: $.obj,
                fdSelect: d.fdSelect,
                fdArray: d.fdArray,
                privateDict: p.privateDict
              });
              return d.charStrings = V.charStrings, d.seacs = V.seacs, d.widths = V.widths, d;
            }
            parseHeader() {
              let c = this.bytes;
              const d = c.length;
              let A = 0;
              for (; A < d && c[A] !== 1; )
                ++A;
              if (A >= d)
                throw new n.FormatError("Invalid CFF header");
              A !== 0 && ((0, n.info)("cff data is shifted"), c = c.subarray(A), this.bytes = c);
              const N = c[0], E = c[1], H = c[2], $ = c[3];
              return {
                obj: new C(N, E, H, $),
                endPos: H
              };
            }
            parseDict(c) {
              let d = 0;
              function A() {
                let m = c[d++];
                return m === 30 ? N() : m === 28 ? (m = c[d++], m = (m << 24 | c[d++] << 16) >> 16, m) : m === 29 ? (m = c[d++], m = m << 8 | c[d++], m = m << 8 | c[d++], m = m << 8 | c[d++], m) : m >= 32 && m <= 246 ? m - 139 : m >= 247 && m <= 250 ? (m - 247) * 256 + c[d++] + 108 : m >= 251 && m <= 254 ? -((m - 251) * 256) - c[d++] - 108 : ((0, n.warn)('CFFParser_parseDict: "' + m + '" is a reserved command.'), NaN);
              }
              function N() {
                let m = "";
                const T = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".", "E", "E-", null, "-"], L = c.length;
                for (; d < L; ) {
                  const _ = c[d++], G = _ >> 4, J = _ & 15;
                  if (G === 15 || (m += T[G], J === 15))
                    break;
                  m += T[J];
                }
                return parseFloat(m);
              }
              let E = [];
              const H = [];
              d = 0;
              const $ = c.length;
              for (; d < $; ) {
                let m = c[d];
                m <= 21 ? (m === 12 && (m = m << 8 | c[++d]), H.push([m, E]), E = [], ++d) : E.push(A());
              }
              return H;
            }
            parseIndex(c) {
              const d = new o(), A = this.bytes, N = A[c++] << 8 | A[c++], E = [];
              let H = c, $, m;
              if (N !== 0) {
                const p = A[c++], T = c + (N + 1) * p - 1;
                for ($ = 0, m = N + 1; $ < m; ++$) {
                  let L = 0;
                  for (let _ = 0; _ < p; ++_)
                    L <<= 8, L += A[c++];
                  E.push(T + L);
                }
                H = E[N];
              }
              for ($ = 0, m = E.length - 1; $ < m; ++$) {
                const p = E[$], T = E[$ + 1];
                d.add(A.subarray(p, T));
              }
              return {
                obj: d,
                endPos: H
              };
            }
            parseNameIndex(c) {
              const d = [];
              for (let A = 0, N = c.count; A < N; ++A) {
                const E = c.get(A);
                d.push((0, n.bytesToString)(E));
              }
              return d;
            }
            parseStringIndex(c) {
              const d = new i();
              for (let A = 0, N = c.count; A < N; ++A) {
                const E = c.get(A);
                d.add((0, n.bytesToString)(E));
              }
              return d;
            }
            createDict(c, d, A) {
              const N = new c(A);
              for (const [E, H] of d)
                N.setByKey(E, H);
              return N;
            }
            parseCharString(c, d, A, N) {
              if (!d || c.callDepth > e)
                return !1;
              let E = c.stackSize;
              const H = c.stack;
              let $ = d.length;
              for (let m = 0; m < $; ) {
                const p = d[m++];
                let T = null;
                if (p === 12) {
                  const L = d[m++];
                  L === 0 ? (d[m - 2] = 139, d[m - 1] = 22, E = 0) : T = M[L];
                } else if (p === 28)
                  H[E] = (d[m] << 24 | d[m + 1] << 16) >> 16, m += 2, E++;
                else if (p === 14) {
                  if (E >= 4 && (E -= 4, this.seacAnalysisEnabled))
                    return c.seac = H.slice(E, E + 4), !1;
                  T = j[p];
                } else if (p >= 32 && p <= 246)
                  H[E] = p - 139, E++;
                else if (p >= 247 && p <= 254)
                  H[E] = p < 251 ? (p - 247 << 8) + d[m] + 108 : -(p - 251 << 8) - d[m] - 108, m++, E++;
                else if (p === 255)
                  H[E] = (d[m] << 24 | d[m + 1] << 16 | d[m + 2] << 8 | d[m + 3]) / 65536, m += 4, E++;
                else if (p === 19 || p === 20) {
                  if (c.hints += E >> 1, c.hints === 0) {
                    d.copyWithin(m - 1, m, -1), m -= 1, $ -= 1;
                    continue;
                  }
                  m += c.hints + 7 >> 3, E %= 2, T = j[p];
                } else if (p === 10 || p === 29) {
                  let L;
                  if (p === 10 ? L = A : L = N, !L)
                    return T = j[p], (0, n.warn)("Missing subrsIndex for " + T.id), !1;
                  let _ = 32768;
                  L.count < 1240 ? _ = 107 : L.count < 33900 && (_ = 1131);
                  const G = H[--E] + _;
                  if (G < 0 || G >= L.count || isNaN(G))
                    return T = j[p], (0, n.warn)("Out of bounds subrIndex for " + T.id), !1;
                  if (c.stackSize = E, c.callDepth++, !this.parseCharString(c, L.get(G), A, N))
                    return !1;
                  c.callDepth--, E = c.stackSize;
                  continue;
                } else {
                  if (p === 11)
                    return c.stackSize = E, !0;
                  if (p === 0 && m === d.length)
                    d[m - 1] = 14, T = j[14];
                  else if (p === 9) {
                    d.copyWithin(m - 1, m, -1), m -= 1, $ -= 1;
                    continue;
                  } else
                    T = j[p];
                }
                if (T) {
                  if (T.stem && (c.hints += E >> 1, p === 3 || p === 23 ? c.hasVStems = !0 : c.hasVStems && (p === 1 || p === 18) && ((0, n.warn)("CFF stem hints are in wrong order"), d[m - 1] = p === 1 ? 3 : 23)), "min" in T && !c.undefStack && E < T.min)
                    return (0, n.warn)("Not enough parameters for " + T.id + "; actual: " + E + ", expected: " + T.min), E === 0 ? (d[m - 1] = 14, !0) : !1;
                  c.firstStackClearing && T.stackClearing && (c.firstStackClearing = !1, E -= T.min, E >= 2 && T.stem ? E %= 2 : E > 1 && (0, n.warn)("Found too many parameters for stack-clearing command"), E > 0 && (c.width = H[E - 1])), "stackDelta" in T ? ("stackFn" in T && T.stackFn(H, E), E += T.stackDelta) : T.stackClearing ? E = 0 : T.resetStack ? (E = 0, c.undefStack = !1) : T.undefStack && (E = 0, c.undefStack = !0, c.firstStackClearing = !1);
                }
              }
              return $ < d.length && d.fill(14, $), c.stackSize = E, !0;
            }
            parseCharStrings({
              charStrings: c,
              localSubrIndex: d,
              globalSubrIndex: A,
              fdSelect: N,
              fdArray: E,
              privateDict: H
            }) {
              const $ = [], m = [], p = c.count;
              for (let T = 0; T < p; T++) {
                const L = c.get(T), _ = {
                  callDepth: 0,
                  stackSize: 0,
                  stack: [],
                  undefStack: !0,
                  hints: 0,
                  firstStackClearing: !0,
                  seac: null,
                  width: null,
                  hasVStems: !1
                };
                let G = !0, J = null, K = H;
                if (N && E.length) {
                  const V = N.getFDIndex(T);
                  V === -1 && ((0, n.warn)("Glyph index is not in fd select."), G = !1), V >= E.length && ((0, n.warn)("Invalid fd index for glyph index."), G = !1), G && (K = E[V].privateDict, J = K.subrsIndex);
                } else
                  d && (J = d);
                if (G && (G = this.parseCharString(_, L, J, A)), _.width !== null) {
                  const V = K.getByName("nominalWidthX");
                  m[T] = V + _.width;
                } else {
                  const V = K.getByName("defaultWidthX");
                  m[T] = V;
                }
                _.seac !== null && ($[T] = _.seac), G || c.set(T, new Uint8Array([14]));
              }
              return {
                charStrings: c,
                seacs: $,
                widths: m
              };
            }
            emptyPrivateDictionary(c) {
              const d = this.createDict(v, [], c.strings);
              c.setByKey(18, [0, 0]), c.privateDict = d;
            }
            parsePrivateDict(c) {
              if (!c.hasName("Private")) {
                this.emptyPrivateDictionary(c);
                return;
              }
              const d = c.getByName("Private");
              if (!Array.isArray(d) || d.length !== 2) {
                c.removeByName("Private");
                return;
              }
              const A = d[0], N = d[1];
              if (A === 0 || N >= this.bytes.length) {
                this.emptyPrivateDictionary(c);
                return;
              }
              const E = N + A, H = this.bytes.subarray(N, E), $ = this.parseDict(H), m = this.createDict(v, $, c.strings);
              if (c.privateDict = m, m.getByName("ExpansionFactor") === 0 && m.setByName("ExpansionFactor", 0.06), !m.getByName("Subrs"))
                return;
              const p = m.getByName("Subrs"), T = N + p;
              if (p === 0 || T >= this.bytes.length) {
                this.emptyPrivateDictionary(c);
                return;
              }
              const L = this.parseIndex(T);
              m.subrsIndex = L.obj;
            }
            parseCharsets(c, d, A, N) {
              if (c === 0)
                return new x(!0, r.ISO_ADOBE, u.ISOAdobeCharset);
              if (c === 1)
                return new x(!0, r.EXPERT, u.ExpertCharset);
              if (c === 2)
                return new x(!0, r.EXPERT_SUBSET, u.ExpertSubsetCharset);
              const E = this.bytes, H = c, $ = E[c++], m = [N ? 0 : ".notdef"];
              let p, T, L;
              switch (d -= 1, $) {
                case 0:
                  for (L = 0; L < d; L++)
                    p = E[c++] << 8 | E[c++], m.push(N ? p : A.get(p));
                  break;
                case 1:
                  for (; m.length <= d; )
                    for (p = E[c++] << 8 | E[c++], T = E[c++], L = 0; L <= T; L++)
                      m.push(N ? p++ : A.get(p++));
                  break;
                case 2:
                  for (; m.length <= d; )
                    for (p = E[c++] << 8 | E[c++], T = E[c++] << 8 | E[c++], L = 0; L <= T; L++)
                      m.push(N ? p++ : A.get(p++));
                  break;
                default:
                  throw new n.FormatError("Unknown charset format");
              }
              const _ = c, G = E.subarray(H, _);
              return new x(!1, $, m, G);
            }
            parseEncoding(c, d, A, N) {
              const E = /* @__PURE__ */ Object.create(null), H = this.bytes;
              let $ = !1, m, p, T, L = null;
              function _() {
                const G = H[c++];
                for (p = 0; p < G; p++) {
                  const J = H[c++], K = (H[c++] << 8) + (H[c++] & 255);
                  E[J] = N.indexOf(A.get(K));
                }
              }
              if (c === 0 || c === 1) {
                $ = !0, m = c;
                const G = c ? q.ExpertEncoding : q.StandardEncoding;
                for (p = 0, T = N.length; p < T; p++) {
                  const J = G.indexOf(N[p]);
                  J !== -1 && (E[J] = p);
                }
              } else {
                const G = c;
                switch (m = H[c++], m & 127) {
                  case 0:
                    const K = H[c++];
                    for (p = 1; p <= K; p++)
                      E[H[c++]] = p;
                    break;
                  case 1:
                    const V = H[c++];
                    let U = 1;
                    for (p = 0; p < V; p++) {
                      const Q = H[c++], X = H[c++];
                      for (let R = Q; R <= Q + X; R++)
                        E[R] = U++;
                    }
                    break;
                  default:
                    throw new n.FormatError(`Unknown encoding format: ${m} in CFF`);
                }
                const J = c;
                m & 128 && (H[G] &= 127, _()), L = H.subarray(G, J);
              }
              return m &= 127, new b($, m, E, L);
            }
            parseFDSelect(c, d) {
              const A = this.bytes, N = A[c++], E = [];
              let H;
              switch (N) {
                case 0:
                  for (H = 0; H < d; ++H) {
                    const m = A[c++];
                    E.push(m);
                  }
                  break;
                case 3:
                  const $ = A[c++] << 8 | A[c++];
                  for (H = 0; H < $; ++H) {
                    let m = A[c++] << 8 | A[c++];
                    H === 0 && m !== 0 && ((0, n.warn)("parseFDSelect: The first range must have a first GID of 0 -- trying to recover."), m = 0);
                    const p = A[c++], T = A[c] << 8 | A[c + 1];
                    for (let L = m; L < T; ++L)
                      E.push(p);
                  }
                  c += 2;
                  break;
                default:
                  throw new n.FormatError(`parseFDSelect: Unknown format "${N}".`);
              }
              if (E.length !== d)
                throw new n.FormatError("parseFDSelect: Invalid font data.");
              return new I(N, E);
            }
          }
          F.CFFParser = O;
          class w {
            constructor() {
              this.header = null, this.names = [], this.topDict = null, this.strings = new i(), this.globalSubrIndex = null, this.encoding = null, this.charset = null, this.charStrings = null, this.fdArray = [], this.fdSelect = null, this.isCIDFont = !1;
            }
            duplicateFirstGlyph() {
              if (this.charStrings.count >= 65535) {
                (0, n.warn)("Not enough space in charstrings to duplicate first glyph.");
                return;
              }
              const c = this.charStrings.get(0);
              this.charStrings.add(c), this.isCIDFont && this.fdSelect.fdSelect.push(this.fdSelect.fdSelect[0]);
            }
            hasGlyphId(c) {
              return c < 0 || c >= this.charStrings.count ? !1 : this.charStrings.get(c).length > 0;
            }
          }
          F.CFF = w;
          class C {
            constructor(c, d, A, N) {
              this.major = c, this.minor = d, this.hdrSize = A, this.offSize = N;
            }
          }
          F.CFFHeader = C;
          class i {
            constructor() {
              this.strings = [];
            }
            get(c) {
              return c >= 0 && c <= B - 1 ? t[c] : c - B <= this.strings.length ? this.strings[c - B] : t[0];
            }
            getSID(c) {
              let d = t.indexOf(c);
              return d !== -1 ? d : (d = this.strings.indexOf(c), d !== -1 ? d + B : -1);
            }
            add(c) {
              this.strings.push(c);
            }
            get count() {
              return this.strings.length;
            }
          }
          F.CFFStrings = i;
          class o {
            constructor() {
              this.objects = [], this.length = 0;
            }
            add(c) {
              this.length += c.length, this.objects.push(c);
            }
            set(c, d) {
              this.length += d.length - this.objects[c].length, this.objects[c] = d;
            }
            get(c) {
              return this.objects[c];
            }
            get count() {
              return this.objects.length;
            }
          }
          F.CFFIndex = o;
          class k {
            constructor(c, d) {
              this.keyToNameMap = c.keyToNameMap, this.nameToKeyMap = c.nameToKeyMap, this.defaults = c.defaults, this.types = c.types, this.opcodes = c.opcodes, this.order = c.order, this.strings = d, this.values = /* @__PURE__ */ Object.create(null);
            }
            setByKey(c, d) {
              if (!(c in this.keyToNameMap))
                return !1;
              if (d.length === 0)
                return !0;
              for (const N of d)
                if (isNaN(N))
                  return (0, n.warn)(`Invalid CFFDict value: "${d}" for key "${c}".`), !0;
              const A = this.types[c];
              return (A === "num" || A === "sid" || A === "offset") && (d = d[0]), this.values[c] = d, !0;
            }
            setByName(c, d) {
              if (!(c in this.nameToKeyMap))
                throw new n.FormatError(`Invalid dictionary name "${c}"`);
              this.values[this.nameToKeyMap[c]] = d;
            }
            hasName(c) {
              return this.nameToKeyMap[c] in this.values;
            }
            getByName(c) {
              if (!(c in this.nameToKeyMap))
                throw new n.FormatError(`Invalid dictionary name ${c}"`);
              const d = this.nameToKeyMap[c];
              return d in this.values ? this.values[d] : this.defaults[d];
            }
            removeByName(c) {
              delete this.values[this.nameToKeyMap[c]];
            }
            static createTables(c) {
              const d = {
                keyToNameMap: {},
                nameToKeyMap: {},
                defaults: {},
                types: {},
                opcodes: {},
                order: []
              };
              for (const A of c) {
                const N = Array.isArray(A[0]) ? (A[0][0] << 8) + A[0][1] : A[0];
                d.keyToNameMap[N] = A[1], d.nameToKeyMap[A[1]] = N, d.types[N] = A[2], d.defaults[N] = A[3], d.opcodes[N] = Array.isArray(A[0]) ? A[0] : [A[0]], d.order.push(N);
              }
              return d;
            }
          }
          const s = [[[12, 30], "ROS", ["sid", "sid", "num"], null], [[12, 20], "SyntheticBase", "num", null], [0, "version", "sid", null], [1, "Notice", "sid", null], [[12, 0], "Copyright", "sid", null], [2, "FullName", "sid", null], [3, "FamilyName", "sid", null], [4, "Weight", "sid", null], [[12, 1], "isFixedPitch", "num", 0], [[12, 2], "ItalicAngle", "num", 0], [[12, 3], "UnderlinePosition", "num", -100], [[12, 4], "UnderlineThickness", "num", 50], [[12, 5], "PaintType", "num", 0], [[12, 6], "CharstringType", "num", 2], [[12, 7], "FontMatrix", ["num", "num", "num", "num", "num", "num"], [1e-3, 0, 0, 1e-3, 0, 0]], [13, "UniqueID", "num", null], [5, "FontBBox", ["num", "num", "num", "num"], [0, 0, 0, 0]], [[12, 8], "StrokeWidth", "num", 0], [14, "XUID", "array", null], [15, "charset", "offset", 0], [16, "Encoding", "offset", 0], [17, "CharStrings", "offset", 0], [18, "Private", ["offset", "offset"], null], [[12, 21], "PostScript", "sid", null], [[12, 22], "BaseFontName", "sid", null], [[12, 23], "BaseFontBlend", "delta", null], [[12, 31], "CIDFontVersion", "num", 0], [[12, 32], "CIDFontRevision", "num", 0], [[12, 33], "CIDFontType", "num", 0], [[12, 34], "CIDCount", "num", 8720], [[12, 35], "UIDBase", "num", null], [[12, 37], "FDSelect", "offset", null], [[12, 36], "FDArray", "offset", null], [[12, 38], "FontName", "sid", null]];
          class l extends k {
            static get tables() {
              return (0, n.shadow)(this, "tables", this.createTables(s));
            }
            constructor(c) {
              super(l.tables, c), this.privateDict = null;
            }
          }
          F.CFFTopDict = l;
          const g = [[6, "BlueValues", "delta", null], [7, "OtherBlues", "delta", null], [8, "FamilyBlues", "delta", null], [9, "FamilyOtherBlues", "delta", null], [[12, 9], "BlueScale", "num", 0.039625], [[12, 10], "BlueShift", "num", 7], [[12, 11], "BlueFuzz", "num", 1], [10, "StdHW", "num", null], [11, "StdVW", "num", null], [[12, 12], "StemSnapH", "delta", null], [[12, 13], "StemSnapV", "delta", null], [[12, 14], "ForceBold", "num", 0], [[12, 17], "LanguageGroup", "num", 0], [[12, 18], "ExpansionFactor", "num", 0.06], [[12, 19], "initialRandomSeed", "num", 0], [20, "defaultWidthX", "num", 0], [21, "nominalWidthX", "num", 0], [19, "Subrs", "offset", null]];
          class v extends k {
            static get tables() {
              return (0, n.shadow)(this, "tables", this.createTables(g));
            }
            constructor(c) {
              super(v.tables, c), this.subrsIndex = null;
            }
          }
          F.CFFPrivateDict = v;
          const r = {
            ISO_ADOBE: 0,
            EXPERT: 1,
            EXPERT_SUBSET: 2
          };
          class x {
            constructor(c, d, A, N) {
              this.predefined = c, this.format = d, this.charset = A, this.raw = N;
            }
          }
          F.CFFCharset = x;
          class b {
            constructor(c, d, A, N) {
              this.predefined = c, this.format = d, this.encoding = A, this.raw = N;
            }
          }
          class I {
            constructor(c, d) {
              this.format = c, this.fdSelect = d;
            }
            getFDIndex(c) {
              return c < 0 || c >= this.fdSelect.length ? -1 : this.fdSelect[c];
            }
          }
          F.CFFFDSelect = I;
          class h {
            constructor() {
              this.offsets = /* @__PURE__ */ Object.create(null);
            }
            isTracking(c) {
              return c in this.offsets;
            }
            track(c, d) {
              if (c in this.offsets)
                throw new n.FormatError(`Already tracking location of ${c}`);
              this.offsets[c] = d;
            }
            offset(c) {
              for (const d in this.offsets)
                this.offsets[d] += c;
            }
            setEntryLocation(c, d, A) {
              if (!(c in this.offsets))
                throw new n.FormatError(`Not tracking location of ${c}`);
              const N = A.data, E = this.offsets[c], H = 5;
              for (let $ = 0, m = d.length; $ < m; ++$) {
                const p = $ * H + E, T = p + 1, L = p + 2, _ = p + 3, G = p + 4;
                if (N[p] !== 29 || N[T] !== 0 || N[L] !== 0 || N[_] !== 0 || N[G] !== 0)
                  throw new n.FormatError("writing to an offset that is not empty");
                const J = d[$];
                N[p] = 29, N[T] = J >> 24 & 255, N[L] = J >> 16 & 255, N[_] = J >> 8 & 255, N[G] = J & 255;
              }
            }
          }
          class y {
            constructor(c) {
              this.cff = c;
            }
            compile() {
              const c = this.cff, d = {
                data: [],
                length: 0,
                add(_) {
                  _.length <= 65536 ? this.data.push(..._) : this.data = this.data.concat(_), this.length = this.data.length;
                }
              }, A = this.compileHeader(c.header);
              d.add(A);
              const N = this.compileNameIndex(c.names);
              if (d.add(N), c.isCIDFont && c.topDict.hasName("FontMatrix")) {
                const _ = c.topDict.getByName("FontMatrix");
                c.topDict.removeByName("FontMatrix");
                for (const G of c.fdArray) {
                  let J = _.slice(0);
                  G.hasName("FontMatrix") && (J = n.Util.transform(J, G.getByName("FontMatrix"))), G.setByName("FontMatrix", J);
                }
              }
              const E = c.topDict.getByName("XUID");
              (E == null ? void 0 : E.length) > 16 && c.topDict.removeByName("XUID"), c.topDict.setByName("charset", 0);
              let H = this.compileTopDicts([c.topDict], d.length, c.isCIDFont);
              d.add(H.output);
              const $ = H.trackers[0], m = this.compileStringIndex(c.strings.strings);
              d.add(m);
              const p = this.compileIndex(c.globalSubrIndex);
              if (d.add(p), c.encoding && c.topDict.hasName("Encoding"))
                if (c.encoding.predefined)
                  $.setEntryLocation("Encoding", [c.encoding.format], d);
                else {
                  const _ = this.compileEncoding(c.encoding);
                  $.setEntryLocation("Encoding", [d.length], d), d.add(_);
                }
              const T = this.compileCharset(c.charset, c.charStrings.count, c.strings, c.isCIDFont);
              $.setEntryLocation("charset", [d.length], d), d.add(T);
              const L = this.compileCharStrings(c.charStrings);
              if ($.setEntryLocation("CharStrings", [d.length], d), d.add(L), c.isCIDFont) {
                $.setEntryLocation("FDSelect", [d.length], d);
                const _ = this.compileFDSelect(c.fdSelect);
                d.add(_), H = this.compileTopDicts(c.fdArray, d.length, !0), $.setEntryLocation("FDArray", [d.length], d), d.add(H.output);
                const G = H.trackers;
                this.compilePrivateDicts(c.fdArray, G, d);
              }
              return this.compilePrivateDicts([c.topDict], [$], d), d.add([0]), d.data;
            }
            encodeNumber(c) {
              return Number.isInteger(c) ? this.encodeInteger(c) : this.encodeFloat(c);
            }
            static get EncodeFloatRegExp() {
              return (0, n.shadow)(this, "EncodeFloatRegExp", /\.(\d*?)(?:9{5,20}|0{5,20})\d{0,2}(?:e(.+)|$)/);
            }
            encodeFloat(c) {
              let d = c.toString();
              const A = y.EncodeFloatRegExp.exec(d);
              if (A) {
                const m = parseFloat("1e" + ((A[2] ? +A[2] : 0) + A[1].length));
                d = (Math.round(c * m) / m).toString();
              }
              let N = "", E, H;
              for (E = 0, H = d.length; E < H; ++E) {
                const m = d[E];
                m === "e" ? N += d[++E] === "-" ? "c" : "b" : m === "." ? N += "a" : m === "-" ? N += "e" : N += m;
              }
              N += N.length & 1 ? "f" : "ff";
              const $ = [30];
              for (E = 0, H = N.length; E < H; E += 2)
                $.push(parseInt(N.substring(E, E + 2), 16));
              return $;
            }
            encodeInteger(c) {
              let d;
              return c >= -107 && c <= 107 ? d = [c + 139] : c >= 108 && c <= 1131 ? (c -= 108, d = [(c >> 8) + 247, c & 255]) : c >= -1131 && c <= -108 ? (c = -c - 108, d = [(c >> 8) + 251, c & 255]) : c >= -32768 && c <= 32767 ? d = [28, c >> 8 & 255, c & 255] : d = [29, c >> 24 & 255, c >> 16 & 255, c >> 8 & 255, c & 255], d;
            }
            compileHeader(c) {
              return [c.major, c.minor, 4, c.offSize];
            }
            compileNameIndex(c) {
              const d = new o();
              for (const A of c) {
                const N = Math.min(A.length, 127);
                let E = new Array(N);
                for (let H = 0; H < N; H++) {
                  let $ = A[H];
                  ($ < "!" || $ > "~" || $ === "[" || $ === "]" || $ === "(" || $ === ")" || $ === "{" || $ === "}" || $ === "<" || $ === ">" || $ === "/" || $ === "%") && ($ = "_"), E[H] = $;
                }
                E = E.join(""), E === "" && (E = "Bad_Font_Name"), d.add((0, n.stringToBytes)(E));
              }
              return this.compileIndex(d);
            }
            compileTopDicts(c, d, A) {
              const N = [];
              let E = new o();
              for (const H of c) {
                A && (H.removeByName("CIDFontVersion"), H.removeByName("CIDFontRevision"), H.removeByName("CIDFontType"), H.removeByName("CIDCount"), H.removeByName("UIDBase"));
                const $ = new h(), m = this.compileDict(H, $);
                N.push($), E.add(m), $.offset(d);
              }
              return E = this.compileIndex(E, N), {
                trackers: N,
                output: E
              };
            }
            compilePrivateDicts(c, d, A) {
              for (let N = 0, E = c.length; N < E; ++N) {
                const H = c[N], $ = H.privateDict;
                if (!$ || !H.hasName("Private"))
                  throw new n.FormatError("There must be a private dictionary.");
                const m = new h(), p = this.compileDict($, m);
                let T = A.length;
                if (m.offset(T), p.length || (T = 0), d[N].setEntryLocation("Private", [p.length, T], A), A.add(p), $.subrsIndex && $.hasName("Subrs")) {
                  const L = this.compileIndex($.subrsIndex);
                  m.setEntryLocation("Subrs", [p.length], A), A.add(L);
                }
              }
            }
            compileDict(c, d) {
              const A = [];
              for (const N of c.order) {
                if (!(N in c.values))
                  continue;
                let E = c.values[N], H = c.types[N];
                if (Array.isArray(H) || (H = [H]), Array.isArray(E) || (E = [E]), E.length !== 0) {
                  for (let $ = 0, m = H.length; $ < m; ++$) {
                    const p = H[$], T = E[$];
                    switch (p) {
                      case "num":
                      case "sid":
                        A.push(...this.encodeNumber(T));
                        break;
                      case "offset":
                        const L = c.keyToNameMap[N];
                        d.isTracking(L) || d.track(L, A.length), A.push(29, 0, 0, 0, 0);
                        break;
                      case "array":
                      case "delta":
                        A.push(...this.encodeNumber(T));
                        for (let _ = 1, G = E.length; _ < G; ++_)
                          A.push(...this.encodeNumber(E[_]));
                        break;
                      default:
                        throw new n.FormatError(`Unknown data type of ${p}`);
                    }
                  }
                  A.push(...c.opcodes[N]);
                }
              }
              return A;
            }
            compileStringIndex(c) {
              const d = new o();
              for (const A of c)
                d.add((0, n.stringToBytes)(A));
              return this.compileIndex(d);
            }
            compileCharStrings(c) {
              const d = new o();
              for (let A = 0; A < c.count; A++) {
                const N = c.get(A);
                if (N.length === 0) {
                  d.add(new Uint8Array([139, 14]));
                  continue;
                }
                d.add(N);
              }
              return this.compileIndex(d);
            }
            compileCharset(c, d, A, N) {
              let E;
              const H = d - 1;
              if (N)
                E = new Uint8Array([2, 0, 0, H >> 8 & 255, H & 255]);
              else {
                const $ = 1 + H * 2;
                E = new Uint8Array($), E[0] = 0;
                let m = 0;
                const p = c.charset.length;
                let T = !1;
                for (let L = 1; L < E.length; L += 2) {
                  let _ = 0;
                  if (m < p) {
                    const G = c.charset[m++];
                    _ = A.getSID(G), _ === -1 && (_ = 0, T || (T = !0, (0, n.warn)(`Couldn't find ${G} in CFF strings`)));
                  }
                  E[L] = _ >> 8 & 255, E[L + 1] = _ & 255;
                }
              }
              return this.compileTypedArray(E);
            }
            compileEncoding(c) {
              return this.compileTypedArray(c.raw);
            }
            compileFDSelect(c) {
              const d = c.format;
              let A, N;
              switch (d) {
                case 0:
                  for (A = new Uint8Array(1 + c.fdSelect.length), A[0] = d, N = 0; N < c.fdSelect.length; N++)
                    A[N + 1] = c.fdSelect[N];
                  break;
                case 3:
                  const E = 0;
                  let H = c.fdSelect[0];
                  const $ = [d, 0, 0, E >> 8 & 255, E & 255, H];
                  for (N = 1; N < c.fdSelect.length; N++) {
                    const p = c.fdSelect[N];
                    p !== H && ($.push(N >> 8 & 255, N & 255, p), H = p);
                  }
                  const m = ($.length - 3) / 3;
                  $[1] = m >> 8 & 255, $[2] = m & 255, $.push(N >> 8 & 255, N & 255), A = new Uint8Array($);
                  break;
              }
              return this.compileTypedArray(A);
            }
            compileTypedArray(c) {
              return Array.from(c);
            }
            compileIndex(c, d = []) {
              const A = c.objects, N = A.length;
              if (N === 0)
                return [0, 0];
              const E = [N >> 8 & 255, N & 255];
              let H = 1, $;
              for ($ = 0; $ < N; ++$)
                H += A[$].length;
              let m;
              H < 256 ? m = 1 : H < 65536 ? m = 2 : H < 16777216 ? m = 3 : m = 4, E.push(m);
              let p = 1;
              for ($ = 0; $ < N + 1; $++)
                m === 1 ? E.push(p & 255) : m === 2 ? E.push(p >> 8 & 255, p & 255) : m === 3 ? E.push(p >> 16 & 255, p >> 8 & 255, p & 255) : E.push(p >>> 24 & 255, p >> 16 & 255, p >> 8 & 255, p & 255), A[$] && (p += A[$].length);
              for ($ = 0; $ < N; $++)
                d[$] && d[$].offset(E.length), E.push(...A[$]);
              return E;
            }
          }
          F.CFFCompiler = y;
        },
        /* 36 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ISOAdobeCharset = F.ExpertSubsetCharset = F.ExpertCharset = void 0;
          const ae = [".notdef", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "endash", "dagger", "daggerdbl", "periodcentered", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "questiondown", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "emdash", "AE", "ordfeminine", "Lslash", "Oslash", "OE", "ordmasculine", "ae", "dotlessi", "lslash", "oslash", "oe", "germandbls", "onesuperior", "logicalnot", "mu", "trademark", "Eth", "onehalf", "plusminus", "Thorn", "onequarter", "divide", "brokenbar", "degree", "thorn", "threequarters", "twosuperior", "registered", "minus", "eth", "multiply", "threesuperior", "copyright", "Aacute", "Acircumflex", "Adieresis", "Agrave", "Aring", "Atilde", "Ccedilla", "Eacute", "Ecircumflex", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Ntilde", "Oacute", "Ocircumflex", "Odieresis", "Ograve", "Otilde", "Scaron", "Uacute", "Ucircumflex", "Udieresis", "Ugrave", "Yacute", "Ydieresis", "Zcaron", "aacute", "acircumflex", "adieresis", "agrave", "aring", "atilde", "ccedilla", "eacute", "ecircumflex", "edieresis", "egrave", "iacute", "icircumflex", "idieresis", "igrave", "ntilde", "oacute", "ocircumflex", "odieresis", "ograve", "otilde", "scaron", "uacute", "ucircumflex", "udieresis", "ugrave", "yacute", "ydieresis", "zcaron"];
          F.ISOAdobeCharset = ae;
          const n = [".notdef", "space", "exclamsmall", "Hungarumlautsmall", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "exclamdownsmall", "centoldstyle", "Lslashsmall", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "Dotaccentsmall", "Macronsmall", "figuredash", "hypheninferior", "Ogoneksmall", "Ringsmall", "Cedillasmall", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
          F.ExpertCharset = n;
          const u = [".notdef", "space", "dollaroldstyle", "dollarsuperior", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "isuperior", "lsuperior", "msuperior", "nsuperior", "osuperior", "rsuperior", "ssuperior", "tsuperior", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "parenrightinferior", "hyphensuperior", "colonmonetary", "onefitted", "rupiah", "centoldstyle", "figuredash", "hypheninferior", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior"];
          F.ExpertSubsetCharset = u;
        },
        /* 37 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ZapfDingbatsEncoding = F.WinAnsiEncoding = F.SymbolSetEncoding = F.StandardEncoding = F.MacRomanEncoding = F.ExpertEncoding = void 0, F.getEncoding = j;
          const ae = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "commasuperior", "threequartersemdash", "periodsuperior", "questionsmall", "", "asuperior", "bsuperior", "centsuperior", "dsuperior", "esuperior", "", "", "", "isuperior", "", "", "lsuperior", "msuperior", "nsuperior", "osuperior", "", "", "rsuperior", "ssuperior", "tsuperior", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hyphensuperior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdownsmall", "centoldstyle", "Lslashsmall", "", "", "Scaronsmall", "Zcaronsmall", "Dieresissmall", "Brevesmall", "Caronsmall", "", "Dotaccentsmall", "", "", "Macronsmall", "", "", "figuredash", "hypheninferior", "", "", "Ogoneksmall", "Ringsmall", "Cedillasmall", "", "", "", "onequarter", "onehalf", "threequarters", "questiondownsmall", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "zerosuperior", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "eightsuperior", "ninesuperior", "zeroinferior", "oneinferior", "twoinferior", "threeinferior", "fourinferior", "fiveinferior", "sixinferior", "seveninferior", "eightinferior", "nineinferior", "centinferior", "dollarinferior", "periodinferior", "commainferior", "Agravesmall", "Aacutesmall", "Acircumflexsmall", "Atildesmall", "Adieresissmall", "Aringsmall", "AEsmall", "Ccedillasmall", "Egravesmall", "Eacutesmall", "Ecircumflexsmall", "Edieresissmall", "Igravesmall", "Iacutesmall", "Icircumflexsmall", "Idieresissmall", "Ethsmall", "Ntildesmall", "Ogravesmall", "Oacutesmall", "Ocircumflexsmall", "Otildesmall", "Odieresissmall", "OEsmall", "Oslashsmall", "Ugravesmall", "Uacutesmall", "Ucircumflexsmall", "Udieresissmall", "Yacutesmall", "Thornsmall", "Ydieresissmall"];
          F.ExpertEncoding = ae;
          const n = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclamsmall", "Hungarumlautsmall", "centoldstyle", "dollaroldstyle", "dollarsuperior", "ampersandsmall", "Acutesmall", "parenleftsuperior", "parenrightsuperior", "twodotenleader", "onedotenleader", "comma", "hyphen", "period", "fraction", "zerooldstyle", "oneoldstyle", "twooldstyle", "threeoldstyle", "fouroldstyle", "fiveoldstyle", "sixoldstyle", "sevenoldstyle", "eightoldstyle", "nineoldstyle", "colon", "semicolon", "", "threequartersemdash", "", "questionsmall", "", "", "", "", "Ethsmall", "", "", "onequarter", "onehalf", "threequarters", "oneeighth", "threeeighths", "fiveeighths", "seveneighths", "onethird", "twothirds", "", "", "", "", "", "", "ff", "fi", "fl", "ffi", "ffl", "parenleftinferior", "", "parenrightinferior", "Circumflexsmall", "hypheninferior", "Gravesmall", "Asmall", "Bsmall", "Csmall", "Dsmall", "Esmall", "Fsmall", "Gsmall", "Hsmall", "Ismall", "Jsmall", "Ksmall", "Lsmall", "Msmall", "Nsmall", "Osmall", "Psmall", "Qsmall", "Rsmall", "Ssmall", "Tsmall", "Usmall", "Vsmall", "Wsmall", "Xsmall", "Ysmall", "Zsmall", "colonmonetary", "onefitted", "rupiah", "Tildesmall", "", "", "asuperior", "centsuperior", "", "", "", "", "Aacutesmall", "Agravesmall", "Acircumflexsmall", "Adieresissmall", "Atildesmall", "Aringsmall", "Ccedillasmall", "Eacutesmall", "Egravesmall", "Ecircumflexsmall", "Edieresissmall", "Iacutesmall", "Igravesmall", "Icircumflexsmall", "Idieresissmall", "Ntildesmall", "Oacutesmall", "Ogravesmall", "Ocircumflexsmall", "Odieresissmall", "Otildesmall", "Uacutesmall", "Ugravesmall", "Ucircumflexsmall", "Udieresissmall", "", "eightsuperior", "fourinferior", "threeinferior", "sixinferior", "eightinferior", "seveninferior", "Scaronsmall", "", "centinferior", "twoinferior", "", "Dieresissmall", "", "Caronsmall", "osuperior", "fiveinferior", "", "commainferior", "periodinferior", "Yacutesmall", "", "dollarinferior", "", "", "Thornsmall", "", "nineinferior", "zeroinferior", "Zcaronsmall", "AEsmall", "Oslashsmall", "questiondownsmall", "oneinferior", "Lslashsmall", "", "", "", "", "", "", "Cedillasmall", "", "", "", "", "", "OEsmall", "figuredash", "hyphensuperior", "", "", "", "", "exclamdownsmall", "", "Ydieresissmall", "", "onesuperior", "twosuperior", "threesuperior", "foursuperior", "fivesuperior", "sixsuperior", "sevensuperior", "ninesuperior", "zerosuperior", "", "esuperior", "rsuperior", "tsuperior", "", "", "isuperior", "ssuperior", "dsuperior", "", "", "", "", "", "lsuperior", "Ogoneksmall", "Brevesmall", "Macronsmall", "bsuperior", "nsuperior", "msuperior", "commasuperior", "periodsuperior", "Dotaccentsmall", "Ringsmall", "", "", "", ""], u = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "space", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron"];
          F.MacRomanEncoding = u;
          const q = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quoteright", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "quoteleft", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "exclamdown", "cent", "sterling", "fraction", "yen", "florin", "section", "currency", "quotesingle", "quotedblleft", "guillemotleft", "guilsinglleft", "guilsinglright", "fi", "fl", "", "endash", "dagger", "daggerdbl", "periodcentered", "", "paragraph", "bullet", "quotesinglbase", "quotedblbase", "quotedblright", "guillemotright", "ellipsis", "perthousand", "", "questiondown", "", "grave", "acute", "circumflex", "tilde", "macron", "breve", "dotaccent", "dieresis", "", "ring", "cedilla", "", "hungarumlaut", "ogonek", "caron", "emdash", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "AE", "", "ordfeminine", "", "", "", "", "Lslash", "Oslash", "OE", "ordmasculine", "", "", "", "", "", "ae", "", "", "", "dotlessi", "", "", "lslash", "oslash", "oe", "germandbls", "", "", "", ""];
          F.StandardEncoding = q;
          const e = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "bullet", "Euro", "bullet", "quotesinglbase", "florin", "quotedblbase", "ellipsis", "dagger", "daggerdbl", "circumflex", "perthousand", "Scaron", "guilsinglleft", "OE", "bullet", "Zcaron", "bullet", "bullet", "quoteleft", "quoteright", "quotedblleft", "quotedblright", "bullet", "endash", "emdash", "tilde", "trademark", "scaron", "guilsinglright", "oe", "bullet", "zcaron", "Ydieresis", "space", "exclamdown", "cent", "sterling", "currency", "yen", "brokenbar", "section", "dieresis", "copyright", "ordfeminine", "guillemotleft", "logicalnot", "hyphen", "registered", "macron", "degree", "plusminus", "twosuperior", "threesuperior", "acute", "mu", "paragraph", "periodcentered", "cedilla", "onesuperior", "ordmasculine", "guillemotright", "onequarter", "onehalf", "threequarters", "questiondown", "Agrave", "Aacute", "Acircumflex", "Atilde", "Adieresis", "Aring", "AE", "Ccedilla", "Egrave", "Eacute", "Ecircumflex", "Edieresis", "Igrave", "Iacute", "Icircumflex", "Idieresis", "Eth", "Ntilde", "Ograve", "Oacute", "Ocircumflex", "Otilde", "Odieresis", "multiply", "Oslash", "Ugrave", "Uacute", "Ucircumflex", "Udieresis", "Yacute", "Thorn", "germandbls", "agrave", "aacute", "acircumflex", "atilde", "adieresis", "aring", "ae", "ccedilla", "egrave", "eacute", "ecircumflex", "edieresis", "igrave", "iacute", "icircumflex", "idieresis", "eth", "ntilde", "ograve", "oacute", "ocircumflex", "otilde", "odieresis", "divide", "oslash", "ugrave", "uacute", "ucircumflex", "udieresis", "yacute", "thorn", "ydieresis"];
          F.WinAnsiEncoding = e;
          const t = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "exclam", "universal", "numbersign", "existential", "percent", "ampersand", "suchthat", "parenleft", "parenright", "asteriskmath", "plus", "comma", "minus", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "congruent", "Alpha", "Beta", "Chi", "Delta", "Epsilon", "Phi", "Gamma", "Eta", "Iota", "theta1", "Kappa", "Lambda", "Mu", "Nu", "Omicron", "Pi", "Theta", "Rho", "Sigma", "Tau", "Upsilon", "sigma1", "Omega", "Xi", "Psi", "Zeta", "bracketleft", "therefore", "bracketright", "perpendicular", "underscore", "radicalex", "alpha", "beta", "chi", "delta", "epsilon", "phi", "gamma", "eta", "iota", "phi1", "kappa", "lambda", "mu", "nu", "omicron", "pi", "theta", "rho", "sigma", "tau", "upsilon", "omega1", "omega", "xi", "psi", "zeta", "braceleft", "bar", "braceright", "similar", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "Euro", "Upsilon1", "minute", "lessequal", "fraction", "infinity", "florin", "club", "diamond", "heart", "spade", "arrowboth", "arrowleft", "arrowup", "arrowright", "arrowdown", "degree", "plusminus", "second", "greaterequal", "multiply", "proportional", "partialdiff", "bullet", "divide", "notequal", "equivalence", "approxequal", "ellipsis", "arrowvertex", "arrowhorizex", "carriagereturn", "aleph", "Ifraktur", "Rfraktur", "weierstrass", "circlemultiply", "circleplus", "emptyset", "intersection", "union", "propersuperset", "reflexsuperset", "notsubset", "propersubset", "reflexsubset", "element", "notelement", "angle", "gradient", "registerserif", "copyrightserif", "trademarkserif", "product", "radical", "dotmath", "logicalnot", "logicaland", "logicalor", "arrowdblboth", "arrowdblleft", "arrowdblup", "arrowdblright", "arrowdbldown", "lozenge", "angleleft", "registersans", "copyrightsans", "trademarksans", "summation", "parenlefttp", "parenleftex", "parenleftbt", "bracketlefttp", "bracketleftex", "bracketleftbt", "bracelefttp", "braceleftmid", "braceleftbt", "braceex", "", "angleright", "integral", "integraltp", "integralex", "integralbt", "parenrighttp", "parenrightex", "parenrightbt", "bracketrighttp", "bracketrightex", "bracketrightbt", "bracerighttp", "bracerightmid", "bracerightbt", ""];
          F.SymbolSetEncoding = t;
          const B = ["", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "space", "a1", "a2", "a202", "a3", "a4", "a5", "a119", "a118", "a117", "a11", "a12", "a13", "a14", "a15", "a16", "a105", "a17", "a18", "a19", "a20", "a21", "a22", "a23", "a24", "a25", "a26", "a27", "a28", "a6", "a7", "a8", "a9", "a10", "a29", "a30", "a31", "a32", "a33", "a34", "a35", "a36", "a37", "a38", "a39", "a40", "a41", "a42", "a43", "a44", "a45", "a46", "a47", "a48", "a49", "a50", "a51", "a52", "a53", "a54", "a55", "a56", "a57", "a58", "a59", "a60", "a61", "a62", "a63", "a64", "a65", "a66", "a67", "a68", "a69", "a70", "a71", "a72", "a73", "a74", "a203", "a75", "a204", "a76", "a77", "a78", "a79", "a81", "a82", "a83", "a84", "a97", "a98", "a99", "a100", "", "a89", "a90", "a93", "a94", "a91", "a92", "a205", "a85", "a206", "a86", "a87", "a88", "a95", "a96", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "", "a101", "a102", "a103", "a104", "a106", "a107", "a108", "a112", "a111", "a110", "a109", "a120", "a121", "a122", "a123", "a124", "a125", "a126", "a127", "a128", "a129", "a130", "a131", "a132", "a133", "a134", "a135", "a136", "a137", "a138", "a139", "a140", "a141", "a142", "a143", "a144", "a145", "a146", "a147", "a148", "a149", "a150", "a151", "a152", "a153", "a154", "a155", "a156", "a157", "a158", "a159", "a160", "a161", "a163", "a164", "a196", "a165", "a192", "a166", "a167", "a168", "a169", "a170", "a171", "a172", "a173", "a162", "a174", "a175", "a176", "a177", "a178", "a179", "a193", "a180", "a199", "a181", "a200", "a182", "", "a201", "a183", "a184", "a197", "a185", "a194", "a198", "a186", "a195", "a187", "a188", "a189", "a190", "a191", ""];
          F.ZapfDingbatsEncoding = B;
          function j(M) {
            switch (M) {
              case "WinAnsiEncoding":
                return e;
              case "StandardEncoding":
                return q;
              case "MacRomanEncoding":
                return u;
              case "SymbolSetEncoding":
                return t;
              case "ZapfDingbatsEncoding":
                return B;
              case "ExpertEncoding":
                return ae;
              case "MacExpertEncoding":
                return n;
              default:
                return null;
            }
          }
        },
        /* 38 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.SEAC_ANALYSIS_ENABLED = F.MacStandardGlyphOrdering = F.FontFlags = void 0, F.normalizeFontName = w, F.recoverGlyphName = M, F.type1FontGlyphMapping = O;
          var n = ae(37), u = ae(39), q = ae(40), e = ae(2);
          const t = !0;
          F.SEAC_ANALYSIS_ENABLED = t;
          const B = {
            FixedPitch: 1,
            Serif: 2,
            Symbolic: 4,
            Script: 8,
            Nonsymbolic: 32,
            Italic: 64,
            AllCap: 65536,
            SmallCap: 131072,
            ForceBold: 262144
          };
          F.FontFlags = B;
          const j = [".notdef", ".null", "nonmarkingreturn", "space", "exclam", "quotedbl", "numbersign", "dollar", "percent", "ampersand", "quotesingle", "parenleft", "parenright", "asterisk", "plus", "comma", "hyphen", "period", "slash", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "colon", "semicolon", "less", "equal", "greater", "question", "at", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "bracketleft", "backslash", "bracketright", "asciicircum", "underscore", "grave", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "braceleft", "bar", "braceright", "asciitilde", "Adieresis", "Aring", "Ccedilla", "Eacute", "Ntilde", "Odieresis", "Udieresis", "aacute", "agrave", "acircumflex", "adieresis", "atilde", "aring", "ccedilla", "eacute", "egrave", "ecircumflex", "edieresis", "iacute", "igrave", "icircumflex", "idieresis", "ntilde", "oacute", "ograve", "ocircumflex", "odieresis", "otilde", "uacute", "ugrave", "ucircumflex", "udieresis", "dagger", "degree", "cent", "sterling", "section", "bullet", "paragraph", "germandbls", "registered", "copyright", "trademark", "acute", "dieresis", "notequal", "AE", "Oslash", "infinity", "plusminus", "lessequal", "greaterequal", "yen", "mu", "partialdiff", "summation", "product", "pi", "integral", "ordfeminine", "ordmasculine", "Omega", "ae", "oslash", "questiondown", "exclamdown", "logicalnot", "radical", "florin", "approxequal", "Delta", "guillemotleft", "guillemotright", "ellipsis", "nonbreakingspace", "Agrave", "Atilde", "Otilde", "OE", "oe", "endash", "emdash", "quotedblleft", "quotedblright", "quoteleft", "quoteright", "divide", "lozenge", "ydieresis", "Ydieresis", "fraction", "currency", "guilsinglleft", "guilsinglright", "fi", "fl", "daggerdbl", "periodcentered", "quotesinglbase", "quotedblbase", "perthousand", "Acircumflex", "Ecircumflex", "Aacute", "Edieresis", "Egrave", "Iacute", "Icircumflex", "Idieresis", "Igrave", "Oacute", "Ocircumflex", "apple", "Ograve", "Uacute", "Ucircumflex", "Ugrave", "dotlessi", "circumflex", "tilde", "macron", "breve", "dotaccent", "ring", "cedilla", "hungarumlaut", "ogonek", "caron", "Lslash", "lslash", "Scaron", "scaron", "Zcaron", "zcaron", "brokenbar", "Eth", "eth", "Yacute", "yacute", "Thorn", "thorn", "minus", "multiply", "onesuperior", "twosuperior", "threesuperior", "onehalf", "onequarter", "threequarters", "franc", "Gbreve", "gbreve", "Idotaccent", "Scedilla", "scedilla", "Cacute", "cacute", "Ccaron", "ccaron", "dcroat"];
          F.MacStandardGlyphOrdering = j;
          function M(C, i) {
            if (i[C] !== void 0)
              return C;
            const o = (0, q.getUnicodeForGlyph)(C, i);
            if (o !== -1) {
              for (const k in i)
                if (i[k] === o)
                  return k;
            }
            return (0, e.info)("Unable to recover a standard glyph name for: " + C), C;
          }
          function O(C, i, o) {
            const k = /* @__PURE__ */ Object.create(null);
            let s, l, g;
            const v = !!(C.flags & B.Symbolic);
            if (C.isInternalFont)
              for (g = i, l = 0; l < g.length; l++)
                s = o.indexOf(g[l]), s >= 0 ? k[l] = s : k[l] = 0;
            else if (C.baseEncodingName)
              for (g = (0, n.getEncoding)(C.baseEncodingName), l = 0; l < g.length; l++)
                s = o.indexOf(g[l]), s >= 0 ? k[l] = s : k[l] = 0;
            else if (v)
              for (l in i)
                k[l] = i[l];
            else
              for (g = n.StandardEncoding, l = 0; l < g.length; l++)
                s = o.indexOf(g[l]), s >= 0 ? k[l] = s : k[l] = 0;
            const r = C.differences;
            let x;
            if (r)
              for (l in r) {
                const b = r[l];
                if (s = o.indexOf(b), s === -1) {
                  x || (x = (0, u.getGlyphsUnicode)());
                  const I = M(b, x);
                  I !== b && (s = o.indexOf(I));
                }
                s >= 0 ? k[l] = s : k[l] = 0;
              }
            return k;
          }
          function w(C) {
            return C.replaceAll(/[,_]/g, "-").replaceAll(/\s/g, "");
          }
        },
        /* 39 */
        /***/
        (xe, F, ae) => {
          ae.r(F), ae.d(F, {
            /* harmony export */
            getDingbatsGlyphsUnicode: () => (
              /* binding */
              q
            ),
            /* harmony export */
            getGlyphsUnicode: () => (
              /* binding */
              u
            )
            /* harmony export */
          });
          var n = ae(3);
          const u = (0, n.getLookupTableFactory)(function(e) {
            e.A = 65, e.AE = 198, e.AEacute = 508, e.AEmacron = 482, e.AEsmall = 63462, e.Aacute = 193, e.Aacutesmall = 63457, e.Abreve = 258, e.Abreveacute = 7854, e.Abrevecyrillic = 1232, e.Abrevedotbelow = 7862, e.Abrevegrave = 7856, e.Abrevehookabove = 7858, e.Abrevetilde = 7860, e.Acaron = 461, e.Acircle = 9398, e.Acircumflex = 194, e.Acircumflexacute = 7844, e.Acircumflexdotbelow = 7852, e.Acircumflexgrave = 7846, e.Acircumflexhookabove = 7848, e.Acircumflexsmall = 63458, e.Acircumflextilde = 7850, e.Acute = 63177, e.Acutesmall = 63412, e.Acyrillic = 1040, e.Adblgrave = 512, e.Adieresis = 196, e.Adieresiscyrillic = 1234, e.Adieresismacron = 478, e.Adieresissmall = 63460, e.Adotbelow = 7840, e.Adotmacron = 480, e.Agrave = 192, e.Agravesmall = 63456, e.Ahookabove = 7842, e.Aiecyrillic = 1236, e.Ainvertedbreve = 514, e.Alpha = 913, e.Alphatonos = 902, e.Amacron = 256, e.Amonospace = 65313, e.Aogonek = 260, e.Aring = 197, e.Aringacute = 506, e.Aringbelow = 7680, e.Aringsmall = 63461, e.Asmall = 63329, e.Atilde = 195, e.Atildesmall = 63459, e.Aybarmenian = 1329, e.B = 66, e.Bcircle = 9399, e.Bdotaccent = 7682, e.Bdotbelow = 7684, e.Becyrillic = 1041, e.Benarmenian = 1330, e.Beta = 914, e.Bhook = 385, e.Blinebelow = 7686, e.Bmonospace = 65314, e.Brevesmall = 63220, e.Bsmall = 63330, e.Btopbar = 386, e.C = 67, e.Caarmenian = 1342, e.Cacute = 262, e.Caron = 63178, e.Caronsmall = 63221, e.Ccaron = 268, e.Ccedilla = 199, e.Ccedillaacute = 7688, e.Ccedillasmall = 63463, e.Ccircle = 9400, e.Ccircumflex = 264, e.Cdot = 266, e.Cdotaccent = 266, e.Cedillasmall = 63416, e.Chaarmenian = 1353, e.Cheabkhasiancyrillic = 1212, e.Checyrillic = 1063, e.Chedescenderabkhasiancyrillic = 1214, e.Chedescendercyrillic = 1206, e.Chedieresiscyrillic = 1268, e.Cheharmenian = 1347, e.Chekhakassiancyrillic = 1227, e.Cheverticalstrokecyrillic = 1208, e.Chi = 935, e.Chook = 391, e.Circumflexsmall = 63222, e.Cmonospace = 65315, e.Coarmenian = 1361, e.Csmall = 63331, e.D = 68, e.DZ = 497, e.DZcaron = 452, e.Daarmenian = 1332, e.Dafrican = 393, e.Dcaron = 270, e.Dcedilla = 7696, e.Dcircle = 9401, e.Dcircumflexbelow = 7698, e.Dcroat = 272, e.Ddotaccent = 7690, e.Ddotbelow = 7692, e.Decyrillic = 1044, e.Deicoptic = 1006, e.Delta = 8710, e.Deltagreek = 916, e.Dhook = 394, e.Dieresis = 63179, e.DieresisAcute = 63180, e.DieresisGrave = 63181, e.Dieresissmall = 63400, e.Digammagreek = 988, e.Djecyrillic = 1026, e.Dlinebelow = 7694, e.Dmonospace = 65316, e.Dotaccentsmall = 63223, e.Dslash = 272, e.Dsmall = 63332, e.Dtopbar = 395, e.Dz = 498, e.Dzcaron = 453, e.Dzeabkhasiancyrillic = 1248, e.Dzecyrillic = 1029, e.Dzhecyrillic = 1039, e.E = 69, e.Eacute = 201, e.Eacutesmall = 63465, e.Ebreve = 276, e.Ecaron = 282, e.Ecedillabreve = 7708, e.Echarmenian = 1333, e.Ecircle = 9402, e.Ecircumflex = 202, e.Ecircumflexacute = 7870, e.Ecircumflexbelow = 7704, e.Ecircumflexdotbelow = 7878, e.Ecircumflexgrave = 7872, e.Ecircumflexhookabove = 7874, e.Ecircumflexsmall = 63466, e.Ecircumflextilde = 7876, e.Ecyrillic = 1028, e.Edblgrave = 516, e.Edieresis = 203, e.Edieresissmall = 63467, e.Edot = 278, e.Edotaccent = 278, e.Edotbelow = 7864, e.Efcyrillic = 1060, e.Egrave = 200, e.Egravesmall = 63464, e.Eharmenian = 1335, e.Ehookabove = 7866, e.Eightroman = 8551, e.Einvertedbreve = 518, e.Eiotifiedcyrillic = 1124, e.Elcyrillic = 1051, e.Elevenroman = 8554, e.Emacron = 274, e.Emacronacute = 7702, e.Emacrongrave = 7700, e.Emcyrillic = 1052, e.Emonospace = 65317, e.Encyrillic = 1053, e.Endescendercyrillic = 1186, e.Eng = 330, e.Enghecyrillic = 1188, e.Enhookcyrillic = 1223, e.Eogonek = 280, e.Eopen = 400, e.Epsilon = 917, e.Epsilontonos = 904, e.Ercyrillic = 1056, e.Ereversed = 398, e.Ereversedcyrillic = 1069, e.Escyrillic = 1057, e.Esdescendercyrillic = 1194, e.Esh = 425, e.Esmall = 63333, e.Eta = 919, e.Etarmenian = 1336, e.Etatonos = 905, e.Eth = 208, e.Ethsmall = 63472, e.Etilde = 7868, e.Etildebelow = 7706, e.Euro = 8364, e.Ezh = 439, e.Ezhcaron = 494, e.Ezhreversed = 440, e.F = 70, e.Fcircle = 9403, e.Fdotaccent = 7710, e.Feharmenian = 1366, e.Feicoptic = 996, e.Fhook = 401, e.Fitacyrillic = 1138, e.Fiveroman = 8548, e.Fmonospace = 65318, e.Fourroman = 8547, e.Fsmall = 63334, e.G = 71, e.GBsquare = 13191, e.Gacute = 500, e.Gamma = 915, e.Gammaafrican = 404, e.Gangiacoptic = 1002, e.Gbreve = 286, e.Gcaron = 486, e.Gcedilla = 290, e.Gcircle = 9404, e.Gcircumflex = 284, e.Gcommaaccent = 290, e.Gdot = 288, e.Gdotaccent = 288, e.Gecyrillic = 1043, e.Ghadarmenian = 1346, e.Ghemiddlehookcyrillic = 1172, e.Ghestrokecyrillic = 1170, e.Gheupturncyrillic = 1168, e.Ghook = 403, e.Gimarmenian = 1331, e.Gjecyrillic = 1027, e.Gmacron = 7712, e.Gmonospace = 65319, e.Grave = 63182, e.Gravesmall = 63328, e.Gsmall = 63335, e.Gsmallhook = 667, e.Gstroke = 484, e.H = 72, e.H18533 = 9679, e.H18543 = 9642, e.H18551 = 9643, e.H22073 = 9633, e.HPsquare = 13259, e.Haabkhasiancyrillic = 1192, e.Hadescendercyrillic = 1202, e.Hardsigncyrillic = 1066, e.Hbar = 294, e.Hbrevebelow = 7722, e.Hcedilla = 7720, e.Hcircle = 9405, e.Hcircumflex = 292, e.Hdieresis = 7718, e.Hdotaccent = 7714, e.Hdotbelow = 7716, e.Hmonospace = 65320, e.Hoarmenian = 1344, e.Horicoptic = 1e3, e.Hsmall = 63336, e.Hungarumlaut = 63183, e.Hungarumlautsmall = 63224, e.Hzsquare = 13200, e.I = 73, e.IAcyrillic = 1071, e.IJ = 306, e.IUcyrillic = 1070, e.Iacute = 205, e.Iacutesmall = 63469, e.Ibreve = 300, e.Icaron = 463, e.Icircle = 9406, e.Icircumflex = 206, e.Icircumflexsmall = 63470, e.Icyrillic = 1030, e.Idblgrave = 520, e.Idieresis = 207, e.Idieresisacute = 7726, e.Idieresiscyrillic = 1252, e.Idieresissmall = 63471, e.Idot = 304, e.Idotaccent = 304, e.Idotbelow = 7882, e.Iebrevecyrillic = 1238, e.Iecyrillic = 1045, e.Ifraktur = 8465, e.Igrave = 204, e.Igravesmall = 63468, e.Ihookabove = 7880, e.Iicyrillic = 1048, e.Iinvertedbreve = 522, e.Iishortcyrillic = 1049, e.Imacron = 298, e.Imacroncyrillic = 1250, e.Imonospace = 65321, e.Iniarmenian = 1339, e.Iocyrillic = 1025, e.Iogonek = 302, e.Iota = 921, e.Iotaafrican = 406, e.Iotadieresis = 938, e.Iotatonos = 906, e.Ismall = 63337, e.Istroke = 407, e.Itilde = 296, e.Itildebelow = 7724, e.Izhitsacyrillic = 1140, e.Izhitsadblgravecyrillic = 1142, e.J = 74, e.Jaarmenian = 1345, e.Jcircle = 9407, e.Jcircumflex = 308, e.Jecyrillic = 1032, e.Jheharmenian = 1355, e.Jmonospace = 65322, e.Jsmall = 63338, e.K = 75, e.KBsquare = 13189, e.KKsquare = 13261, e.Kabashkircyrillic = 1184, e.Kacute = 7728, e.Kacyrillic = 1050, e.Kadescendercyrillic = 1178, e.Kahookcyrillic = 1219, e.Kappa = 922, e.Kastrokecyrillic = 1182, e.Kaverticalstrokecyrillic = 1180, e.Kcaron = 488, e.Kcedilla = 310, e.Kcircle = 9408, e.Kcommaaccent = 310, e.Kdotbelow = 7730, e.Keharmenian = 1364, e.Kenarmenian = 1343, e.Khacyrillic = 1061, e.Kheicoptic = 998, e.Khook = 408, e.Kjecyrillic = 1036, e.Klinebelow = 7732, e.Kmonospace = 65323, e.Koppacyrillic = 1152, e.Koppagreek = 990, e.Ksicyrillic = 1134, e.Ksmall = 63339, e.L = 76, e.LJ = 455, e.LL = 63167, e.Lacute = 313, e.Lambda = 923, e.Lcaron = 317, e.Lcedilla = 315, e.Lcircle = 9409, e.Lcircumflexbelow = 7740, e.Lcommaaccent = 315, e.Ldot = 319, e.Ldotaccent = 319, e.Ldotbelow = 7734, e.Ldotbelowmacron = 7736, e.Liwnarmenian = 1340, e.Lj = 456, e.Ljecyrillic = 1033, e.Llinebelow = 7738, e.Lmonospace = 65324, e.Lslash = 321, e.Lslashsmall = 63225, e.Lsmall = 63340, e.M = 77, e.MBsquare = 13190, e.Macron = 63184, e.Macronsmall = 63407, e.Macute = 7742, e.Mcircle = 9410, e.Mdotaccent = 7744, e.Mdotbelow = 7746, e.Menarmenian = 1348, e.Mmonospace = 65325, e.Msmall = 63341, e.Mturned = 412, e.Mu = 924, e.N = 78, e.NJ = 458, e.Nacute = 323, e.Ncaron = 327, e.Ncedilla = 325, e.Ncircle = 9411, e.Ncircumflexbelow = 7754, e.Ncommaaccent = 325, e.Ndotaccent = 7748, e.Ndotbelow = 7750, e.Nhookleft = 413, e.Nineroman = 8552, e.Nj = 459, e.Njecyrillic = 1034, e.Nlinebelow = 7752, e.Nmonospace = 65326, e.Nowarmenian = 1350, e.Nsmall = 63342, e.Ntilde = 209, e.Ntildesmall = 63473, e.Nu = 925, e.O = 79, e.OE = 338, e.OEsmall = 63226, e.Oacute = 211, e.Oacutesmall = 63475, e.Obarredcyrillic = 1256, e.Obarreddieresiscyrillic = 1258, e.Obreve = 334, e.Ocaron = 465, e.Ocenteredtilde = 415, e.Ocircle = 9412, e.Ocircumflex = 212, e.Ocircumflexacute = 7888, e.Ocircumflexdotbelow = 7896, e.Ocircumflexgrave = 7890, e.Ocircumflexhookabove = 7892, e.Ocircumflexsmall = 63476, e.Ocircumflextilde = 7894, e.Ocyrillic = 1054, e.Odblacute = 336, e.Odblgrave = 524, e.Odieresis = 214, e.Odieresiscyrillic = 1254, e.Odieresissmall = 63478, e.Odotbelow = 7884, e.Ogoneksmall = 63227, e.Ograve = 210, e.Ogravesmall = 63474, e.Oharmenian = 1365, e.Ohm = 8486, e.Ohookabove = 7886, e.Ohorn = 416, e.Ohornacute = 7898, e.Ohorndotbelow = 7906, e.Ohorngrave = 7900, e.Ohornhookabove = 7902, e.Ohorntilde = 7904, e.Ohungarumlaut = 336, e.Oi = 418, e.Oinvertedbreve = 526, e.Omacron = 332, e.Omacronacute = 7762, e.Omacrongrave = 7760, e.Omega = 8486, e.Omegacyrillic = 1120, e.Omegagreek = 937, e.Omegaroundcyrillic = 1146, e.Omegatitlocyrillic = 1148, e.Omegatonos = 911, e.Omicron = 927, e.Omicrontonos = 908, e.Omonospace = 65327, e.Oneroman = 8544, e.Oogonek = 490, e.Oogonekmacron = 492, e.Oopen = 390, e.Oslash = 216, e.Oslashacute = 510, e.Oslashsmall = 63480, e.Osmall = 63343, e.Ostrokeacute = 510, e.Otcyrillic = 1150, e.Otilde = 213, e.Otildeacute = 7756, e.Otildedieresis = 7758, e.Otildesmall = 63477, e.P = 80, e.Pacute = 7764, e.Pcircle = 9413, e.Pdotaccent = 7766, e.Pecyrillic = 1055, e.Peharmenian = 1354, e.Pemiddlehookcyrillic = 1190, e.Phi = 934, e.Phook = 420, e.Pi = 928, e.Piwrarmenian = 1363, e.Pmonospace = 65328, e.Psi = 936, e.Psicyrillic = 1136, e.Psmall = 63344, e.Q = 81, e.Qcircle = 9414, e.Qmonospace = 65329, e.Qsmall = 63345, e.R = 82, e.Raarmenian = 1356, e.Racute = 340, e.Rcaron = 344, e.Rcedilla = 342, e.Rcircle = 9415, e.Rcommaaccent = 342, e.Rdblgrave = 528, e.Rdotaccent = 7768, e.Rdotbelow = 7770, e.Rdotbelowmacron = 7772, e.Reharmenian = 1360, e.Rfraktur = 8476, e.Rho = 929, e.Ringsmall = 63228, e.Rinvertedbreve = 530, e.Rlinebelow = 7774, e.Rmonospace = 65330, e.Rsmall = 63346, e.Rsmallinverted = 641, e.Rsmallinvertedsuperior = 694, e.S = 83, e.SF010000 = 9484, e.SF020000 = 9492, e.SF030000 = 9488, e.SF040000 = 9496, e.SF050000 = 9532, e.SF060000 = 9516, e.SF070000 = 9524, e.SF080000 = 9500, e.SF090000 = 9508, e.SF100000 = 9472, e.SF110000 = 9474, e.SF190000 = 9569, e.SF200000 = 9570, e.SF210000 = 9558, e.SF220000 = 9557, e.SF230000 = 9571, e.SF240000 = 9553, e.SF250000 = 9559, e.SF260000 = 9565, e.SF270000 = 9564, e.SF280000 = 9563, e.SF360000 = 9566, e.SF370000 = 9567, e.SF380000 = 9562, e.SF390000 = 9556, e.SF400000 = 9577, e.SF410000 = 9574, e.SF420000 = 9568, e.SF430000 = 9552, e.SF440000 = 9580, e.SF450000 = 9575, e.SF460000 = 9576, e.SF470000 = 9572, e.SF480000 = 9573, e.SF490000 = 9561, e.SF500000 = 9560, e.SF510000 = 9554, e.SF520000 = 9555, e.SF530000 = 9579, e.SF540000 = 9578, e.Sacute = 346, e.Sacutedotaccent = 7780, e.Sampigreek = 992, e.Scaron = 352, e.Scarondotaccent = 7782, e.Scaronsmall = 63229, e.Scedilla = 350, e.Schwa = 399, e.Schwacyrillic = 1240, e.Schwadieresiscyrillic = 1242, e.Scircle = 9416, e.Scircumflex = 348, e.Scommaaccent = 536, e.Sdotaccent = 7776, e.Sdotbelow = 7778, e.Sdotbelowdotaccent = 7784, e.Seharmenian = 1357, e.Sevenroman = 8550, e.Shaarmenian = 1351, e.Shacyrillic = 1064, e.Shchacyrillic = 1065, e.Sheicoptic = 994, e.Shhacyrillic = 1210, e.Shimacoptic = 1004, e.Sigma = 931, e.Sixroman = 8549, e.Smonospace = 65331, e.Softsigncyrillic = 1068, e.Ssmall = 63347, e.Stigmagreek = 986, e.T = 84, e.Tau = 932, e.Tbar = 358, e.Tcaron = 356, e.Tcedilla = 354, e.Tcircle = 9417, e.Tcircumflexbelow = 7792, e.Tcommaaccent = 354, e.Tdotaccent = 7786, e.Tdotbelow = 7788, e.Tecyrillic = 1058, e.Tedescendercyrillic = 1196, e.Tenroman = 8553, e.Tetsecyrillic = 1204, e.Theta = 920, e.Thook = 428, e.Thorn = 222, e.Thornsmall = 63486, e.Threeroman = 8546, e.Tildesmall = 63230, e.Tiwnarmenian = 1359, e.Tlinebelow = 7790, e.Tmonospace = 65332, e.Toarmenian = 1337, e.Tonefive = 444, e.Tonesix = 388, e.Tonetwo = 423, e.Tretroflexhook = 430, e.Tsecyrillic = 1062, e.Tshecyrillic = 1035, e.Tsmall = 63348, e.Twelveroman = 8555, e.Tworoman = 8545, e.U = 85, e.Uacute = 218, e.Uacutesmall = 63482, e.Ubreve = 364, e.Ucaron = 467, e.Ucircle = 9418, e.Ucircumflex = 219, e.Ucircumflexbelow = 7798, e.Ucircumflexsmall = 63483, e.Ucyrillic = 1059, e.Udblacute = 368, e.Udblgrave = 532, e.Udieresis = 220, e.Udieresisacute = 471, e.Udieresisbelow = 7794, e.Udieresiscaron = 473, e.Udieresiscyrillic = 1264, e.Udieresisgrave = 475, e.Udieresismacron = 469, e.Udieresissmall = 63484, e.Udotbelow = 7908, e.Ugrave = 217, e.Ugravesmall = 63481, e.Uhookabove = 7910, e.Uhorn = 431, e.Uhornacute = 7912, e.Uhorndotbelow = 7920, e.Uhorngrave = 7914, e.Uhornhookabove = 7916, e.Uhorntilde = 7918, e.Uhungarumlaut = 368, e.Uhungarumlautcyrillic = 1266, e.Uinvertedbreve = 534, e.Ukcyrillic = 1144, e.Umacron = 362, e.Umacroncyrillic = 1262, e.Umacrondieresis = 7802, e.Umonospace = 65333, e.Uogonek = 370, e.Upsilon = 933, e.Upsilon1 = 978, e.Upsilonacutehooksymbolgreek = 979, e.Upsilonafrican = 433, e.Upsilondieresis = 939, e.Upsilondieresishooksymbolgreek = 980, e.Upsilonhooksymbol = 978, e.Upsilontonos = 910, e.Uring = 366, e.Ushortcyrillic = 1038, e.Usmall = 63349, e.Ustraightcyrillic = 1198, e.Ustraightstrokecyrillic = 1200, e.Utilde = 360, e.Utildeacute = 7800, e.Utildebelow = 7796, e.V = 86, e.Vcircle = 9419, e.Vdotbelow = 7806, e.Vecyrillic = 1042, e.Vewarmenian = 1358, e.Vhook = 434, e.Vmonospace = 65334, e.Voarmenian = 1352, e.Vsmall = 63350, e.Vtilde = 7804, e.W = 87, e.Wacute = 7810, e.Wcircle = 9420, e.Wcircumflex = 372, e.Wdieresis = 7812, e.Wdotaccent = 7814, e.Wdotbelow = 7816, e.Wgrave = 7808, e.Wmonospace = 65335, e.Wsmall = 63351, e.X = 88, e.Xcircle = 9421, e.Xdieresis = 7820, e.Xdotaccent = 7818, e.Xeharmenian = 1341, e.Xi = 926, e.Xmonospace = 65336, e.Xsmall = 63352, e.Y = 89, e.Yacute = 221, e.Yacutesmall = 63485, e.Yatcyrillic = 1122, e.Ycircle = 9422, e.Ycircumflex = 374, e.Ydieresis = 376, e.Ydieresissmall = 63487, e.Ydotaccent = 7822, e.Ydotbelow = 7924, e.Yericyrillic = 1067, e.Yerudieresiscyrillic = 1272, e.Ygrave = 7922, e.Yhook = 435, e.Yhookabove = 7926, e.Yiarmenian = 1349, e.Yicyrillic = 1031, e.Yiwnarmenian = 1362, e.Ymonospace = 65337, e.Ysmall = 63353, e.Ytilde = 7928, e.Yusbigcyrillic = 1130, e.Yusbigiotifiedcyrillic = 1132, e.Yuslittlecyrillic = 1126, e.Yuslittleiotifiedcyrillic = 1128, e.Z = 90, e.Zaarmenian = 1334, e.Zacute = 377, e.Zcaron = 381, e.Zcaronsmall = 63231, e.Zcircle = 9423, e.Zcircumflex = 7824, e.Zdot = 379, e.Zdotaccent = 379, e.Zdotbelow = 7826, e.Zecyrillic = 1047, e.Zedescendercyrillic = 1176, e.Zedieresiscyrillic = 1246, e.Zeta = 918, e.Zhearmenian = 1338, e.Zhebrevecyrillic = 1217, e.Zhecyrillic = 1046, e.Zhedescendercyrillic = 1174, e.Zhedieresiscyrillic = 1244, e.Zlinebelow = 7828, e.Zmonospace = 65338, e.Zsmall = 63354, e.Zstroke = 437, e.a = 97, e.aabengali = 2438, e.aacute = 225, e.aadeva = 2310, e.aagujarati = 2694, e.aagurmukhi = 2566, e.aamatragurmukhi = 2622, e.aarusquare = 13059, e.aavowelsignbengali = 2494, e.aavowelsigndeva = 2366, e.aavowelsigngujarati = 2750, e.abbreviationmarkarmenian = 1375, e.abbreviationsigndeva = 2416, e.abengali = 2437, e.abopomofo = 12570, e.abreve = 259, e.abreveacute = 7855, e.abrevecyrillic = 1233, e.abrevedotbelow = 7863, e.abrevegrave = 7857, e.abrevehookabove = 7859, e.abrevetilde = 7861, e.acaron = 462, e.acircle = 9424, e.acircumflex = 226, e.acircumflexacute = 7845, e.acircumflexdotbelow = 7853, e.acircumflexgrave = 7847, e.acircumflexhookabove = 7849, e.acircumflextilde = 7851, e.acute = 180, e.acutebelowcmb = 791, e.acutecmb = 769, e.acutecomb = 769, e.acutedeva = 2388, e.acutelowmod = 719, e.acutetonecmb = 833, e.acyrillic = 1072, e.adblgrave = 513, e.addakgurmukhi = 2673, e.adeva = 2309, e.adieresis = 228, e.adieresiscyrillic = 1235, e.adieresismacron = 479, e.adotbelow = 7841, e.adotmacron = 481, e.ae = 230, e.aeacute = 509, e.aekorean = 12624, e.aemacron = 483, e.afii00208 = 8213, e.afii08941 = 8356, e.afii10017 = 1040, e.afii10018 = 1041, e.afii10019 = 1042, e.afii10020 = 1043, e.afii10021 = 1044, e.afii10022 = 1045, e.afii10023 = 1025, e.afii10024 = 1046, e.afii10025 = 1047, e.afii10026 = 1048, e.afii10027 = 1049, e.afii10028 = 1050, e.afii10029 = 1051, e.afii10030 = 1052, e.afii10031 = 1053, e.afii10032 = 1054, e.afii10033 = 1055, e.afii10034 = 1056, e.afii10035 = 1057, e.afii10036 = 1058, e.afii10037 = 1059, e.afii10038 = 1060, e.afii10039 = 1061, e.afii10040 = 1062, e.afii10041 = 1063, e.afii10042 = 1064, e.afii10043 = 1065, e.afii10044 = 1066, e.afii10045 = 1067, e.afii10046 = 1068, e.afii10047 = 1069, e.afii10048 = 1070, e.afii10049 = 1071, e.afii10050 = 1168, e.afii10051 = 1026, e.afii10052 = 1027, e.afii10053 = 1028, e.afii10054 = 1029, e.afii10055 = 1030, e.afii10056 = 1031, e.afii10057 = 1032, e.afii10058 = 1033, e.afii10059 = 1034, e.afii10060 = 1035, e.afii10061 = 1036, e.afii10062 = 1038, e.afii10063 = 63172, e.afii10064 = 63173, e.afii10065 = 1072, e.afii10066 = 1073, e.afii10067 = 1074, e.afii10068 = 1075, e.afii10069 = 1076, e.afii10070 = 1077, e.afii10071 = 1105, e.afii10072 = 1078, e.afii10073 = 1079, e.afii10074 = 1080, e.afii10075 = 1081, e.afii10076 = 1082, e.afii10077 = 1083, e.afii10078 = 1084, e.afii10079 = 1085, e.afii10080 = 1086, e.afii10081 = 1087, e.afii10082 = 1088, e.afii10083 = 1089, e.afii10084 = 1090, e.afii10085 = 1091, e.afii10086 = 1092, e.afii10087 = 1093, e.afii10088 = 1094, e.afii10089 = 1095, e.afii10090 = 1096, e.afii10091 = 1097, e.afii10092 = 1098, e.afii10093 = 1099, e.afii10094 = 1100, e.afii10095 = 1101, e.afii10096 = 1102, e.afii10097 = 1103, e.afii10098 = 1169, e.afii10099 = 1106, e.afii10100 = 1107, e.afii10101 = 1108, e.afii10102 = 1109, e.afii10103 = 1110, e.afii10104 = 1111, e.afii10105 = 1112, e.afii10106 = 1113, e.afii10107 = 1114, e.afii10108 = 1115, e.afii10109 = 1116, e.afii10110 = 1118, e.afii10145 = 1039, e.afii10146 = 1122, e.afii10147 = 1138, e.afii10148 = 1140, e.afii10192 = 63174, e.afii10193 = 1119, e.afii10194 = 1123, e.afii10195 = 1139, e.afii10196 = 1141, e.afii10831 = 63175, e.afii10832 = 63176, e.afii10846 = 1241, e.afii299 = 8206, e.afii300 = 8207, e.afii301 = 8205, e.afii57381 = 1642, e.afii57388 = 1548, e.afii57392 = 1632, e.afii57393 = 1633, e.afii57394 = 1634, e.afii57395 = 1635, e.afii57396 = 1636, e.afii57397 = 1637, e.afii57398 = 1638, e.afii57399 = 1639, e.afii57400 = 1640, e.afii57401 = 1641, e.afii57403 = 1563, e.afii57407 = 1567, e.afii57409 = 1569, e.afii57410 = 1570, e.afii57411 = 1571, e.afii57412 = 1572, e.afii57413 = 1573, e.afii57414 = 1574, e.afii57415 = 1575, e.afii57416 = 1576, e.afii57417 = 1577, e.afii57418 = 1578, e.afii57419 = 1579, e.afii57420 = 1580, e.afii57421 = 1581, e.afii57422 = 1582, e.afii57423 = 1583, e.afii57424 = 1584, e.afii57425 = 1585, e.afii57426 = 1586, e.afii57427 = 1587, e.afii57428 = 1588, e.afii57429 = 1589, e.afii57430 = 1590, e.afii57431 = 1591, e.afii57432 = 1592, e.afii57433 = 1593, e.afii57434 = 1594, e.afii57440 = 1600, e.afii57441 = 1601, e.afii57442 = 1602, e.afii57443 = 1603, e.afii57444 = 1604, e.afii57445 = 1605, e.afii57446 = 1606, e.afii57448 = 1608, e.afii57449 = 1609, e.afii57450 = 1610, e.afii57451 = 1611, e.afii57452 = 1612, e.afii57453 = 1613, e.afii57454 = 1614, e.afii57455 = 1615, e.afii57456 = 1616, e.afii57457 = 1617, e.afii57458 = 1618, e.afii57470 = 1607, e.afii57505 = 1700, e.afii57506 = 1662, e.afii57507 = 1670, e.afii57508 = 1688, e.afii57509 = 1711, e.afii57511 = 1657, e.afii57512 = 1672, e.afii57513 = 1681, e.afii57514 = 1722, e.afii57519 = 1746, e.afii57534 = 1749, e.afii57636 = 8362, e.afii57645 = 1470, e.afii57658 = 1475, e.afii57664 = 1488, e.afii57665 = 1489, e.afii57666 = 1490, e.afii57667 = 1491, e.afii57668 = 1492, e.afii57669 = 1493, e.afii57670 = 1494, e.afii57671 = 1495, e.afii57672 = 1496, e.afii57673 = 1497, e.afii57674 = 1498, e.afii57675 = 1499, e.afii57676 = 1500, e.afii57677 = 1501, e.afii57678 = 1502, e.afii57679 = 1503, e.afii57680 = 1504, e.afii57681 = 1505, e.afii57682 = 1506, e.afii57683 = 1507, e.afii57684 = 1508, e.afii57685 = 1509, e.afii57686 = 1510, e.afii57687 = 1511, e.afii57688 = 1512, e.afii57689 = 1513, e.afii57690 = 1514, e.afii57694 = 64298, e.afii57695 = 64299, e.afii57700 = 64331, e.afii57705 = 64287, e.afii57716 = 1520, e.afii57717 = 1521, e.afii57718 = 1522, e.afii57723 = 64309, e.afii57793 = 1460, e.afii57794 = 1461, e.afii57795 = 1462, e.afii57796 = 1467, e.afii57797 = 1464, e.afii57798 = 1463, e.afii57799 = 1456, e.afii57800 = 1458, e.afii57801 = 1457, e.afii57802 = 1459, e.afii57803 = 1474, e.afii57804 = 1473, e.afii57806 = 1465, e.afii57807 = 1468, e.afii57839 = 1469, e.afii57841 = 1471, e.afii57842 = 1472, e.afii57929 = 700, e.afii61248 = 8453, e.afii61289 = 8467, e.afii61352 = 8470, e.afii61573 = 8236, e.afii61574 = 8237, e.afii61575 = 8238, e.afii61664 = 8204, e.afii63167 = 1645, e.afii64937 = 701, e.agrave = 224, e.agujarati = 2693, e.agurmukhi = 2565, e.ahiragana = 12354, e.ahookabove = 7843, e.aibengali = 2448, e.aibopomofo = 12574, e.aideva = 2320, e.aiecyrillic = 1237, e.aigujarati = 2704, e.aigurmukhi = 2576, e.aimatragurmukhi = 2632, e.ainarabic = 1593, e.ainfinalarabic = 65226, e.aininitialarabic = 65227, e.ainmedialarabic = 65228, e.ainvertedbreve = 515, e.aivowelsignbengali = 2504, e.aivowelsigndeva = 2376, e.aivowelsigngujarati = 2760, e.akatakana = 12450, e.akatakanahalfwidth = 65393, e.akorean = 12623, e.alef = 1488, e.alefarabic = 1575, e.alefdageshhebrew = 64304, e.aleffinalarabic = 65166, e.alefhamzaabovearabic = 1571, e.alefhamzaabovefinalarabic = 65156, e.alefhamzabelowarabic = 1573, e.alefhamzabelowfinalarabic = 65160, e.alefhebrew = 1488, e.aleflamedhebrew = 64335, e.alefmaddaabovearabic = 1570, e.alefmaddaabovefinalarabic = 65154, e.alefmaksuraarabic = 1609, e.alefmaksurafinalarabic = 65264, e.alefmaksurainitialarabic = 65267, e.alefmaksuramedialarabic = 65268, e.alefpatahhebrew = 64302, e.alefqamatshebrew = 64303, e.aleph = 8501, e.allequal = 8780, e.alpha = 945, e.alphatonos = 940, e.amacron = 257, e.amonospace = 65345, e.ampersand = 38, e.ampersandmonospace = 65286, e.ampersandsmall = 63270, e.amsquare = 13250, e.anbopomofo = 12578, e.angbopomofo = 12580, e.angbracketleft = 12296, e.angbracketright = 12297, e.angkhankhuthai = 3674, e.angle = 8736, e.anglebracketleft = 12296, e.anglebracketleftvertical = 65087, e.anglebracketright = 12297, e.anglebracketrightvertical = 65088, e.angleleft = 9001, e.angleright = 9002, e.angstrom = 8491, e.anoteleia = 903, e.anudattadeva = 2386, e.anusvarabengali = 2434, e.anusvaradeva = 2306, e.anusvaragujarati = 2690, e.aogonek = 261, e.apaatosquare = 13056, e.aparen = 9372, e.apostrophearmenian = 1370, e.apostrophemod = 700, e.apple = 63743, e.approaches = 8784, e.approxequal = 8776, e.approxequalorimage = 8786, e.approximatelyequal = 8773, e.araeaekorean = 12686, e.araeakorean = 12685, e.arc = 8978, e.arighthalfring = 7834, e.aring = 229, e.aringacute = 507, e.aringbelow = 7681, e.arrowboth = 8596, e.arrowdashdown = 8675, e.arrowdashleft = 8672, e.arrowdashright = 8674, e.arrowdashup = 8673, e.arrowdblboth = 8660, e.arrowdbldown = 8659, e.arrowdblleft = 8656, e.arrowdblright = 8658, e.arrowdblup = 8657, e.arrowdown = 8595, e.arrowdownleft = 8601, e.arrowdownright = 8600, e.arrowdownwhite = 8681, e.arrowheaddownmod = 709, e.arrowheadleftmod = 706, e.arrowheadrightmod = 707, e.arrowheadupmod = 708, e.arrowhorizex = 63719, e.arrowleft = 8592, e.arrowleftdbl = 8656, e.arrowleftdblstroke = 8653, e.arrowleftoverright = 8646, e.arrowleftwhite = 8678, e.arrowright = 8594, e.arrowrightdblstroke = 8655, e.arrowrightheavy = 10142, e.arrowrightoverleft = 8644, e.arrowrightwhite = 8680, e.arrowtableft = 8676, e.arrowtabright = 8677, e.arrowup = 8593, e.arrowupdn = 8597, e.arrowupdnbse = 8616, e.arrowupdownbase = 8616, e.arrowupleft = 8598, e.arrowupleftofdown = 8645, e.arrowupright = 8599, e.arrowupwhite = 8679, e.arrowvertex = 63718, e.asciicircum = 94, e.asciicircummonospace = 65342, e.asciitilde = 126, e.asciitildemonospace = 65374, e.ascript = 593, e.ascriptturned = 594, e.asmallhiragana = 12353, e.asmallkatakana = 12449, e.asmallkatakanahalfwidth = 65383, e.asterisk = 42, e.asteriskaltonearabic = 1645, e.asteriskarabic = 1645, e.asteriskmath = 8727, e.asteriskmonospace = 65290, e.asterisksmall = 65121, e.asterism = 8258, e.asuperior = 63209, e.asymptoticallyequal = 8771, e.at = 64, e.atilde = 227, e.atmonospace = 65312, e.atsmall = 65131, e.aturned = 592, e.aubengali = 2452, e.aubopomofo = 12576, e.audeva = 2324, e.augujarati = 2708, e.augurmukhi = 2580, e.aulengthmarkbengali = 2519, e.aumatragurmukhi = 2636, e.auvowelsignbengali = 2508, e.auvowelsigndeva = 2380, e.auvowelsigngujarati = 2764, e.avagrahadeva = 2365, e.aybarmenian = 1377, e.ayin = 1506, e.ayinaltonehebrew = 64288, e.ayinhebrew = 1506, e.b = 98, e.babengali = 2476, e.backslash = 92, e.backslashmonospace = 65340, e.badeva = 2348, e.bagujarati = 2732, e.bagurmukhi = 2604, e.bahiragana = 12400, e.bahtthai = 3647, e.bakatakana = 12496, e.bar = 124, e.barmonospace = 65372, e.bbopomofo = 12549, e.bcircle = 9425, e.bdotaccent = 7683, e.bdotbelow = 7685, e.beamedsixteenthnotes = 9836, e.because = 8757, e.becyrillic = 1073, e.beharabic = 1576, e.behfinalarabic = 65168, e.behinitialarabic = 65169, e.behiragana = 12409, e.behmedialarabic = 65170, e.behmeeminitialarabic = 64671, e.behmeemisolatedarabic = 64520, e.behnoonfinalarabic = 64621, e.bekatakana = 12505, e.benarmenian = 1378, e.bet = 1489, e.beta = 946, e.betasymbolgreek = 976, e.betdagesh = 64305, e.betdageshhebrew = 64305, e.bethebrew = 1489, e.betrafehebrew = 64332, e.bhabengali = 2477, e.bhadeva = 2349, e.bhagujarati = 2733, e.bhagurmukhi = 2605, e.bhook = 595, e.bihiragana = 12403, e.bikatakana = 12499, e.bilabialclick = 664, e.bindigurmukhi = 2562, e.birusquare = 13105, e.blackcircle = 9679, e.blackdiamond = 9670, e.blackdownpointingtriangle = 9660, e.blackleftpointingpointer = 9668, e.blackleftpointingtriangle = 9664, e.blacklenticularbracketleft = 12304, e.blacklenticularbracketleftvertical = 65083, e.blacklenticularbracketright = 12305, e.blacklenticularbracketrightvertical = 65084, e.blacklowerlefttriangle = 9699, e.blacklowerrighttriangle = 9698, e.blackrectangle = 9644, e.blackrightpointingpointer = 9658, e.blackrightpointingtriangle = 9654, e.blacksmallsquare = 9642, e.blacksmilingface = 9787, e.blacksquare = 9632, e.blackstar = 9733, e.blackupperlefttriangle = 9700, e.blackupperrighttriangle = 9701, e.blackuppointingsmalltriangle = 9652, e.blackuppointingtriangle = 9650, e.blank = 9251, e.blinebelow = 7687, e.block = 9608, e.bmonospace = 65346, e.bobaimaithai = 3610, e.bohiragana = 12412, e.bokatakana = 12508, e.bparen = 9373, e.bqsquare = 13251, e.braceex = 63732, e.braceleft = 123, e.braceleftbt = 63731, e.braceleftmid = 63730, e.braceleftmonospace = 65371, e.braceleftsmall = 65115, e.bracelefttp = 63729, e.braceleftvertical = 65079, e.braceright = 125, e.bracerightbt = 63742, e.bracerightmid = 63741, e.bracerightmonospace = 65373, e.bracerightsmall = 65116, e.bracerighttp = 63740, e.bracerightvertical = 65080, e.bracketleft = 91, e.bracketleftbt = 63728, e.bracketleftex = 63727, e.bracketleftmonospace = 65339, e.bracketlefttp = 63726, e.bracketright = 93, e.bracketrightbt = 63739, e.bracketrightex = 63738, e.bracketrightmonospace = 65341, e.bracketrighttp = 63737, e.breve = 728, e.brevebelowcmb = 814, e.brevecmb = 774, e.breveinvertedbelowcmb = 815, e.breveinvertedcmb = 785, e.breveinverteddoublecmb = 865, e.bridgebelowcmb = 810, e.bridgeinvertedbelowcmb = 826, e.brokenbar = 166, e.bstroke = 384, e.bsuperior = 63210, e.btopbar = 387, e.buhiragana = 12406, e.bukatakana = 12502, e.bullet = 8226, e.bulletinverse = 9688, e.bulletoperator = 8729, e.bullseye = 9678, e.c = 99, e.caarmenian = 1390, e.cabengali = 2458, e.cacute = 263, e.cadeva = 2330, e.cagujarati = 2714, e.cagurmukhi = 2586, e.calsquare = 13192, e.candrabindubengali = 2433, e.candrabinducmb = 784, e.candrabindudeva = 2305, e.candrabindugujarati = 2689, e.capslock = 8682, e.careof = 8453, e.caron = 711, e.caronbelowcmb = 812, e.caroncmb = 780, e.carriagereturn = 8629, e.cbopomofo = 12568, e.ccaron = 269, e.ccedilla = 231, e.ccedillaacute = 7689, e.ccircle = 9426, e.ccircumflex = 265, e.ccurl = 597, e.cdot = 267, e.cdotaccent = 267, e.cdsquare = 13253, e.cedilla = 184, e.cedillacmb = 807, e.cent = 162, e.centigrade = 8451, e.centinferior = 63199, e.centmonospace = 65504, e.centoldstyle = 63394, e.centsuperior = 63200, e.chaarmenian = 1401, e.chabengali = 2459, e.chadeva = 2331, e.chagujarati = 2715, e.chagurmukhi = 2587, e.chbopomofo = 12564, e.cheabkhasiancyrillic = 1213, e.checkmark = 10003, e.checyrillic = 1095, e.chedescenderabkhasiancyrillic = 1215, e.chedescendercyrillic = 1207, e.chedieresiscyrillic = 1269, e.cheharmenian = 1395, e.chekhakassiancyrillic = 1228, e.cheverticalstrokecyrillic = 1209, e.chi = 967, e.chieuchacirclekorean = 12919, e.chieuchaparenkorean = 12823, e.chieuchcirclekorean = 12905, e.chieuchkorean = 12618, e.chieuchparenkorean = 12809, e.chochangthai = 3594, e.chochanthai = 3592, e.chochingthai = 3593, e.chochoethai = 3596, e.chook = 392, e.cieucacirclekorean = 12918, e.cieucaparenkorean = 12822, e.cieuccirclekorean = 12904, e.cieuckorean = 12616, e.cieucparenkorean = 12808, e.cieucuparenkorean = 12828, e.circle = 9675, e.circlecopyrt = 169, e.circlemultiply = 8855, e.circleot = 8857, e.circleplus = 8853, e.circlepostalmark = 12342, e.circlewithlefthalfblack = 9680, e.circlewithrighthalfblack = 9681, e.circumflex = 710, e.circumflexbelowcmb = 813, e.circumflexcmb = 770, e.clear = 8999, e.clickalveolar = 450, e.clickdental = 448, e.clicklateral = 449, e.clickretroflex = 451, e.club = 9827, e.clubsuitblack = 9827, e.clubsuitwhite = 9831, e.cmcubedsquare = 13220, e.cmonospace = 65347, e.cmsquaredsquare = 13216, e.coarmenian = 1409, e.colon = 58, e.colonmonetary = 8353, e.colonmonospace = 65306, e.colonsign = 8353, e.colonsmall = 65109, e.colontriangularhalfmod = 721, e.colontriangularmod = 720, e.comma = 44, e.commaabovecmb = 787, e.commaaboverightcmb = 789, e.commaaccent = 63171, e.commaarabic = 1548, e.commaarmenian = 1373, e.commainferior = 63201, e.commamonospace = 65292, e.commareversedabovecmb = 788, e.commareversedmod = 701, e.commasmall = 65104, e.commasuperior = 63202, e.commaturnedabovecmb = 786, e.commaturnedmod = 699, e.compass = 9788, e.congruent = 8773, e.contourintegral = 8750, e.control = 8963, e.controlACK = 6, e.controlBEL = 7, e.controlBS = 8, e.controlCAN = 24, e.controlCR = 13, e.controlDC1 = 17, e.controlDC2 = 18, e.controlDC3 = 19, e.controlDC4 = 20, e.controlDEL = 127, e.controlDLE = 16, e.controlEM = 25, e.controlENQ = 5, e.controlEOT = 4, e.controlESC = 27, e.controlETB = 23, e.controlETX = 3, e.controlFF = 12, e.controlFS = 28, e.controlGS = 29, e.controlHT = 9, e.controlLF = 10, e.controlNAK = 21, e.controlNULL = 0, e.controlRS = 30, e.controlSI = 15, e.controlSO = 14, e.controlSOT = 2, e.controlSTX = 1, e.controlSUB = 26, e.controlSYN = 22, e.controlUS = 31, e.controlVT = 11, e.copyright = 169, e.copyrightsans = 63721, e.copyrightserif = 63193, e.cornerbracketleft = 12300, e.cornerbracketlefthalfwidth = 65378, e.cornerbracketleftvertical = 65089, e.cornerbracketright = 12301, e.cornerbracketrighthalfwidth = 65379, e.cornerbracketrightvertical = 65090, e.corporationsquare = 13183, e.cosquare = 13255, e.coverkgsquare = 13254, e.cparen = 9374, e.cruzeiro = 8354, e.cstretched = 663, e.curlyand = 8911, e.curlyor = 8910, e.currency = 164, e.cyrBreve = 63185, e.cyrFlex = 63186, e.cyrbreve = 63188, e.cyrflex = 63189, e.d = 100, e.daarmenian = 1380, e.dabengali = 2470, e.dadarabic = 1590, e.dadeva = 2342, e.dadfinalarabic = 65214, e.dadinitialarabic = 65215, e.dadmedialarabic = 65216, e.dagesh = 1468, e.dageshhebrew = 1468, e.dagger = 8224, e.daggerdbl = 8225, e.dagujarati = 2726, e.dagurmukhi = 2598, e.dahiragana = 12384, e.dakatakana = 12480, e.dalarabic = 1583, e.dalet = 1491, e.daletdagesh = 64307, e.daletdageshhebrew = 64307, e.dalethebrew = 1491, e.dalfinalarabic = 65194, e.dammaarabic = 1615, e.dammalowarabic = 1615, e.dammatanaltonearabic = 1612, e.dammatanarabic = 1612, e.danda = 2404, e.dargahebrew = 1447, e.dargalefthebrew = 1447, e.dasiapneumatacyrilliccmb = 1157, e.dblGrave = 63187, e.dblanglebracketleft = 12298, e.dblanglebracketleftvertical = 65085, e.dblanglebracketright = 12299, e.dblanglebracketrightvertical = 65086, e.dblarchinvertedbelowcmb = 811, e.dblarrowleft = 8660, e.dblarrowright = 8658, e.dbldanda = 2405, e.dblgrave = 63190, e.dblgravecmb = 783, e.dblintegral = 8748, e.dbllowline = 8215, e.dbllowlinecmb = 819, e.dbloverlinecmb = 831, e.dblprimemod = 698, e.dblverticalbar = 8214, e.dblverticallineabovecmb = 782, e.dbopomofo = 12553, e.dbsquare = 13256, e.dcaron = 271, e.dcedilla = 7697, e.dcircle = 9427, e.dcircumflexbelow = 7699, e.dcroat = 273, e.ddabengali = 2465, e.ddadeva = 2337, e.ddagujarati = 2721, e.ddagurmukhi = 2593, e.ddalarabic = 1672, e.ddalfinalarabic = 64393, e.dddhadeva = 2396, e.ddhabengali = 2466, e.ddhadeva = 2338, e.ddhagujarati = 2722, e.ddhagurmukhi = 2594, e.ddotaccent = 7691, e.ddotbelow = 7693, e.decimalseparatorarabic = 1643, e.decimalseparatorpersian = 1643, e.decyrillic = 1076, e.degree = 176, e.dehihebrew = 1453, e.dehiragana = 12391, e.deicoptic = 1007, e.dekatakana = 12487, e.deleteleft = 9003, e.deleteright = 8998, e.delta = 948, e.deltaturned = 397, e.denominatorminusonenumeratorbengali = 2552, e.dezh = 676, e.dhabengali = 2471, e.dhadeva = 2343, e.dhagujarati = 2727, e.dhagurmukhi = 2599, e.dhook = 599, e.dialytikatonos = 901, e.dialytikatonoscmb = 836, e.diamond = 9830, e.diamondsuitwhite = 9826, e.dieresis = 168, e.dieresisacute = 63191, e.dieresisbelowcmb = 804, e.dieresiscmb = 776, e.dieresisgrave = 63192, e.dieresistonos = 901, e.dihiragana = 12386, e.dikatakana = 12482, e.dittomark = 12291, e.divide = 247, e.divides = 8739, e.divisionslash = 8725, e.djecyrillic = 1106, e.dkshade = 9619, e.dlinebelow = 7695, e.dlsquare = 13207, e.dmacron = 273, e.dmonospace = 65348, e.dnblock = 9604, e.dochadathai = 3598, e.dodekthai = 3604, e.dohiragana = 12393, e.dokatakana = 12489, e.dollar = 36, e.dollarinferior = 63203, e.dollarmonospace = 65284, e.dollaroldstyle = 63268, e.dollarsmall = 65129, e.dollarsuperior = 63204, e.dong = 8363, e.dorusquare = 13094, e.dotaccent = 729, e.dotaccentcmb = 775, e.dotbelowcmb = 803, e.dotbelowcomb = 803, e.dotkatakana = 12539, e.dotlessi = 305, e.dotlessj = 63166, e.dotlessjstrokehook = 644, e.dotmath = 8901, e.dottedcircle = 9676, e.doubleyodpatah = 64287, e.doubleyodpatahhebrew = 64287, e.downtackbelowcmb = 798, e.downtackmod = 725, e.dparen = 9375, e.dsuperior = 63211, e.dtail = 598, e.dtopbar = 396, e.duhiragana = 12389, e.dukatakana = 12485, e.dz = 499, e.dzaltone = 675, e.dzcaron = 454, e.dzcurl = 677, e.dzeabkhasiancyrillic = 1249, e.dzecyrillic = 1109, e.dzhecyrillic = 1119, e.e = 101, e.eacute = 233, e.earth = 9793, e.ebengali = 2447, e.ebopomofo = 12572, e.ebreve = 277, e.ecandradeva = 2317, e.ecandragujarati = 2701, e.ecandravowelsigndeva = 2373, e.ecandravowelsigngujarati = 2757, e.ecaron = 283, e.ecedillabreve = 7709, e.echarmenian = 1381, e.echyiwnarmenian = 1415, e.ecircle = 9428, e.ecircumflex = 234, e.ecircumflexacute = 7871, e.ecircumflexbelow = 7705, e.ecircumflexdotbelow = 7879, e.ecircumflexgrave = 7873, e.ecircumflexhookabove = 7875, e.ecircumflextilde = 7877, e.ecyrillic = 1108, e.edblgrave = 517, e.edeva = 2319, e.edieresis = 235, e.edot = 279, e.edotaccent = 279, e.edotbelow = 7865, e.eegurmukhi = 2575, e.eematragurmukhi = 2631, e.efcyrillic = 1092, e.egrave = 232, e.egujarati = 2703, e.eharmenian = 1383, e.ehbopomofo = 12573, e.ehiragana = 12360, e.ehookabove = 7867, e.eibopomofo = 12575, e.eight = 56, e.eightarabic = 1640, e.eightbengali = 2542, e.eightcircle = 9319, e.eightcircleinversesansserif = 10129, e.eightdeva = 2414, e.eighteencircle = 9329, e.eighteenparen = 9349, e.eighteenperiod = 9369, e.eightgujarati = 2798, e.eightgurmukhi = 2670, e.eighthackarabic = 1640, e.eighthangzhou = 12328, e.eighthnotebeamed = 9835, e.eightideographicparen = 12839, e.eightinferior = 8328, e.eightmonospace = 65304, e.eightoldstyle = 63288, e.eightparen = 9339, e.eightperiod = 9359, e.eightpersian = 1784, e.eightroman = 8567, e.eightsuperior = 8312, e.eightthai = 3672, e.einvertedbreve = 519, e.eiotifiedcyrillic = 1125, e.ekatakana = 12456, e.ekatakanahalfwidth = 65396, e.ekonkargurmukhi = 2676, e.ekorean = 12628, e.elcyrillic = 1083, e.element = 8712, e.elevencircle = 9322, e.elevenparen = 9342, e.elevenperiod = 9362, e.elevenroman = 8570, e.ellipsis = 8230, e.ellipsisvertical = 8942, e.emacron = 275, e.emacronacute = 7703, e.emacrongrave = 7701, e.emcyrillic = 1084, e.emdash = 8212, e.emdashvertical = 65073, e.emonospace = 65349, e.emphasismarkarmenian = 1371, e.emptyset = 8709, e.enbopomofo = 12579, e.encyrillic = 1085, e.endash = 8211, e.endashvertical = 65074, e.endescendercyrillic = 1187, e.eng = 331, e.engbopomofo = 12581, e.enghecyrillic = 1189, e.enhookcyrillic = 1224, e.enspace = 8194, e.eogonek = 281, e.eokorean = 12627, e.eopen = 603, e.eopenclosed = 666, e.eopenreversed = 604, e.eopenreversedclosed = 606, e.eopenreversedhook = 605, e.eparen = 9376, e.epsilon = 949, e.epsilontonos = 941, e.equal = 61, e.equalmonospace = 65309, e.equalsmall = 65126, e.equalsuperior = 8316, e.equivalence = 8801, e.erbopomofo = 12582, e.ercyrillic = 1088, e.ereversed = 600, e.ereversedcyrillic = 1101, e.escyrillic = 1089, e.esdescendercyrillic = 1195, e.esh = 643, e.eshcurl = 646, e.eshortdeva = 2318, e.eshortvowelsigndeva = 2374, e.eshreversedloop = 426, e.eshsquatreversed = 645, e.esmallhiragana = 12359, e.esmallkatakana = 12455, e.esmallkatakanahalfwidth = 65386, e.estimated = 8494, e.esuperior = 63212, e.eta = 951, e.etarmenian = 1384, e.etatonos = 942, e.eth = 240, e.etilde = 7869, e.etildebelow = 7707, e.etnahtafoukhhebrew = 1425, e.etnahtafoukhlefthebrew = 1425, e.etnahtahebrew = 1425, e.etnahtalefthebrew = 1425, e.eturned = 477, e.eukorean = 12641, e.euro = 8364, e.evowelsignbengali = 2503, e.evowelsigndeva = 2375, e.evowelsigngujarati = 2759, e.exclam = 33, e.exclamarmenian = 1372, e.exclamdbl = 8252, e.exclamdown = 161, e.exclamdownsmall = 63393, e.exclammonospace = 65281, e.exclamsmall = 63265, e.existential = 8707, e.ezh = 658, e.ezhcaron = 495, e.ezhcurl = 659, e.ezhreversed = 441, e.ezhtail = 442, e.f = 102, e.fadeva = 2398, e.fagurmukhi = 2654, e.fahrenheit = 8457, e.fathaarabic = 1614, e.fathalowarabic = 1614, e.fathatanarabic = 1611, e.fbopomofo = 12552, e.fcircle = 9429, e.fdotaccent = 7711, e.feharabic = 1601, e.feharmenian = 1414, e.fehfinalarabic = 65234, e.fehinitialarabic = 65235, e.fehmedialarabic = 65236, e.feicoptic = 997, e.female = 9792, e.ff = 64256, e.f_f = 64256, e.ffi = 64259, e.f_f_i = 64259, e.ffl = 64260, e.f_f_l = 64260, e.fi = 64257, e.f_i = 64257, e.fifteencircle = 9326, e.fifteenparen = 9346, e.fifteenperiod = 9366, e.figuredash = 8210, e.filledbox = 9632, e.filledrect = 9644, e.finalkaf = 1498, e.finalkafdagesh = 64314, e.finalkafdageshhebrew = 64314, e.finalkafhebrew = 1498, e.finalmem = 1501, e.finalmemhebrew = 1501, e.finalnun = 1503, e.finalnunhebrew = 1503, e.finalpe = 1507, e.finalpehebrew = 1507, e.finaltsadi = 1509, e.finaltsadihebrew = 1509, e.firsttonechinese = 713, e.fisheye = 9673, e.fitacyrillic = 1139, e.five = 53, e.fivearabic = 1637, e.fivebengali = 2539, e.fivecircle = 9316, e.fivecircleinversesansserif = 10126, e.fivedeva = 2411, e.fiveeighths = 8541, e.fivegujarati = 2795, e.fivegurmukhi = 2667, e.fivehackarabic = 1637, e.fivehangzhou = 12325, e.fiveideographicparen = 12836, e.fiveinferior = 8325, e.fivemonospace = 65301, e.fiveoldstyle = 63285, e.fiveparen = 9336, e.fiveperiod = 9356, e.fivepersian = 1781, e.fiveroman = 8564, e.fivesuperior = 8309, e.fivethai = 3669, e.fl = 64258, e.f_l = 64258, e.florin = 402, e.fmonospace = 65350, e.fmsquare = 13209, e.fofanthai = 3615, e.fofathai = 3613, e.fongmanthai = 3663, e.forall = 8704, e.four = 52, e.fourarabic = 1636, e.fourbengali = 2538, e.fourcircle = 9315, e.fourcircleinversesansserif = 10125, e.fourdeva = 2410, e.fourgujarati = 2794, e.fourgurmukhi = 2666, e.fourhackarabic = 1636, e.fourhangzhou = 12324, e.fourideographicparen = 12835, e.fourinferior = 8324, e.fourmonospace = 65300, e.fournumeratorbengali = 2551, e.fouroldstyle = 63284, e.fourparen = 9335, e.fourperiod = 9355, e.fourpersian = 1780, e.fourroman = 8563, e.foursuperior = 8308, e.fourteencircle = 9325, e.fourteenparen = 9345, e.fourteenperiod = 9365, e.fourthai = 3668, e.fourthtonechinese = 715, e.fparen = 9377, e.fraction = 8260, e.franc = 8355, e.g = 103, e.gabengali = 2455, e.gacute = 501, e.gadeva = 2327, e.gafarabic = 1711, e.gaffinalarabic = 64403, e.gafinitialarabic = 64404, e.gafmedialarabic = 64405, e.gagujarati = 2711, e.gagurmukhi = 2583, e.gahiragana = 12364, e.gakatakana = 12460, e.gamma = 947, e.gammalatinsmall = 611, e.gammasuperior = 736, e.gangiacoptic = 1003, e.gbopomofo = 12557, e.gbreve = 287, e.gcaron = 487, e.gcedilla = 291, e.gcircle = 9430, e.gcircumflex = 285, e.gcommaaccent = 291, e.gdot = 289, e.gdotaccent = 289, e.gecyrillic = 1075, e.gehiragana = 12370, e.gekatakana = 12466, e.geometricallyequal = 8785, e.gereshaccenthebrew = 1436, e.gereshhebrew = 1523, e.gereshmuqdamhebrew = 1437, e.germandbls = 223, e.gershayimaccenthebrew = 1438, e.gershayimhebrew = 1524, e.getamark = 12307, e.ghabengali = 2456, e.ghadarmenian = 1394, e.ghadeva = 2328, e.ghagujarati = 2712, e.ghagurmukhi = 2584, e.ghainarabic = 1594, e.ghainfinalarabic = 65230, e.ghaininitialarabic = 65231, e.ghainmedialarabic = 65232, e.ghemiddlehookcyrillic = 1173, e.ghestrokecyrillic = 1171, e.gheupturncyrillic = 1169, e.ghhadeva = 2394, e.ghhagurmukhi = 2650, e.ghook = 608, e.ghzsquare = 13203, e.gihiragana = 12366, e.gikatakana = 12462, e.gimarmenian = 1379, e.gimel = 1490, e.gimeldagesh = 64306, e.gimeldageshhebrew = 64306, e.gimelhebrew = 1490, e.gjecyrillic = 1107, e.glottalinvertedstroke = 446, e.glottalstop = 660, e.glottalstopinverted = 662, e.glottalstopmod = 704, e.glottalstopreversed = 661, e.glottalstopreversedmod = 705, e.glottalstopreversedsuperior = 740, e.glottalstopstroke = 673, e.glottalstopstrokereversed = 674, e.gmacron = 7713, e.gmonospace = 65351, e.gohiragana = 12372, e.gokatakana = 12468, e.gparen = 9378, e.gpasquare = 13228, e.gradient = 8711, e.grave = 96, e.gravebelowcmb = 790, e.gravecmb = 768, e.gravecomb = 768, e.gravedeva = 2387, e.gravelowmod = 718, e.gravemonospace = 65344, e.gravetonecmb = 832, e.greater = 62, e.greaterequal = 8805, e.greaterequalorless = 8923, e.greatermonospace = 65310, e.greaterorequivalent = 8819, e.greaterorless = 8823, e.greateroverequal = 8807, e.greatersmall = 65125, e.gscript = 609, e.gstroke = 485, e.guhiragana = 12368, e.guillemotleft = 171, e.guillemotright = 187, e.guilsinglleft = 8249, e.guilsinglright = 8250, e.gukatakana = 12464, e.guramusquare = 13080, e.gysquare = 13257, e.h = 104, e.haabkhasiancyrillic = 1193, e.haaltonearabic = 1729, e.habengali = 2489, e.hadescendercyrillic = 1203, e.hadeva = 2361, e.hagujarati = 2745, e.hagurmukhi = 2617, e.haharabic = 1581, e.hahfinalarabic = 65186, e.hahinitialarabic = 65187, e.hahiragana = 12399, e.hahmedialarabic = 65188, e.haitusquare = 13098, e.hakatakana = 12495, e.hakatakanahalfwidth = 65418, e.halantgurmukhi = 2637, e.hamzaarabic = 1569, e.hamzalowarabic = 1569, e.hangulfiller = 12644, e.hardsigncyrillic = 1098, e.harpoonleftbarbup = 8636, e.harpoonrightbarbup = 8640, e.hasquare = 13258, e.hatafpatah = 1458, e.hatafpatah16 = 1458, e.hatafpatah23 = 1458, e.hatafpatah2f = 1458, e.hatafpatahhebrew = 1458, e.hatafpatahnarrowhebrew = 1458, e.hatafpatahquarterhebrew = 1458, e.hatafpatahwidehebrew = 1458, e.hatafqamats = 1459, e.hatafqamats1b = 1459, e.hatafqamats28 = 1459, e.hatafqamats34 = 1459, e.hatafqamatshebrew = 1459, e.hatafqamatsnarrowhebrew = 1459, e.hatafqamatsquarterhebrew = 1459, e.hatafqamatswidehebrew = 1459, e.hatafsegol = 1457, e.hatafsegol17 = 1457, e.hatafsegol24 = 1457, e.hatafsegol30 = 1457, e.hatafsegolhebrew = 1457, e.hatafsegolnarrowhebrew = 1457, e.hatafsegolquarterhebrew = 1457, e.hatafsegolwidehebrew = 1457, e.hbar = 295, e.hbopomofo = 12559, e.hbrevebelow = 7723, e.hcedilla = 7721, e.hcircle = 9431, e.hcircumflex = 293, e.hdieresis = 7719, e.hdotaccent = 7715, e.hdotbelow = 7717, e.he = 1492, e.heart = 9829, e.heartsuitblack = 9829, e.heartsuitwhite = 9825, e.hedagesh = 64308, e.hedageshhebrew = 64308, e.hehaltonearabic = 1729, e.heharabic = 1607, e.hehebrew = 1492, e.hehfinalaltonearabic = 64423, e.hehfinalalttwoarabic = 65258, e.hehfinalarabic = 65258, e.hehhamzaabovefinalarabic = 64421, e.hehhamzaaboveisolatedarabic = 64420, e.hehinitialaltonearabic = 64424, e.hehinitialarabic = 65259, e.hehiragana = 12408, e.hehmedialaltonearabic = 64425, e.hehmedialarabic = 65260, e.heiseierasquare = 13179, e.hekatakana = 12504, e.hekatakanahalfwidth = 65421, e.hekutaarusquare = 13110, e.henghook = 615, e.herutusquare = 13113, e.het = 1495, e.hethebrew = 1495, e.hhook = 614, e.hhooksuperior = 689, e.hieuhacirclekorean = 12923, e.hieuhaparenkorean = 12827, e.hieuhcirclekorean = 12909, e.hieuhkorean = 12622, e.hieuhparenkorean = 12813, e.hihiragana = 12402, e.hikatakana = 12498, e.hikatakanahalfwidth = 65419, e.hiriq = 1460, e.hiriq14 = 1460, e.hiriq21 = 1460, e.hiriq2d = 1460, e.hiriqhebrew = 1460, e.hiriqnarrowhebrew = 1460, e.hiriqquarterhebrew = 1460, e.hiriqwidehebrew = 1460, e.hlinebelow = 7830, e.hmonospace = 65352, e.hoarmenian = 1392, e.hohipthai = 3627, e.hohiragana = 12411, e.hokatakana = 12507, e.hokatakanahalfwidth = 65422, e.holam = 1465, e.holam19 = 1465, e.holam26 = 1465, e.holam32 = 1465, e.holamhebrew = 1465, e.holamnarrowhebrew = 1465, e.holamquarterhebrew = 1465, e.holamwidehebrew = 1465, e.honokhukthai = 3630, e.hookabovecomb = 777, e.hookcmb = 777, e.hookpalatalizedbelowcmb = 801, e.hookretroflexbelowcmb = 802, e.hoonsquare = 13122, e.horicoptic = 1001, e.horizontalbar = 8213, e.horncmb = 795, e.hotsprings = 9832, e.house = 8962, e.hparen = 9379, e.hsuperior = 688, e.hturned = 613, e.huhiragana = 12405, e.huiitosquare = 13107, e.hukatakana = 12501, e.hukatakanahalfwidth = 65420, e.hungarumlaut = 733, e.hungarumlautcmb = 779, e.hv = 405, e.hyphen = 45, e.hypheninferior = 63205, e.hyphenmonospace = 65293, e.hyphensmall = 65123, e.hyphensuperior = 63206, e.hyphentwo = 8208, e.i = 105, e.iacute = 237, e.iacyrillic = 1103, e.ibengali = 2439, e.ibopomofo = 12583, e.ibreve = 301, e.icaron = 464, e.icircle = 9432, e.icircumflex = 238, e.icyrillic = 1110, e.idblgrave = 521, e.ideographearthcircle = 12943, e.ideographfirecircle = 12939, e.ideographicallianceparen = 12863, e.ideographiccallparen = 12858, e.ideographiccentrecircle = 12965, e.ideographicclose = 12294, e.ideographiccomma = 12289, e.ideographiccommaleft = 65380, e.ideographiccongratulationparen = 12855, e.ideographiccorrectcircle = 12963, e.ideographicearthparen = 12847, e.ideographicenterpriseparen = 12861, e.ideographicexcellentcircle = 12957, e.ideographicfestivalparen = 12864, e.ideographicfinancialcircle = 12950, e.ideographicfinancialparen = 12854, e.ideographicfireparen = 12843, e.ideographichaveparen = 12850, e.ideographichighcircle = 12964, e.ideographiciterationmark = 12293, e.ideographiclaborcircle = 12952, e.ideographiclaborparen = 12856, e.ideographicleftcircle = 12967, e.ideographiclowcircle = 12966, e.ideographicmedicinecircle = 12969, e.ideographicmetalparen = 12846, e.ideographicmoonparen = 12842, e.ideographicnameparen = 12852, e.ideographicperiod = 12290, e.ideographicprintcircle = 12958, e.ideographicreachparen = 12867, e.ideographicrepresentparen = 12857, e.ideographicresourceparen = 12862, e.ideographicrightcircle = 12968, e.ideographicsecretcircle = 12953, e.ideographicselfparen = 12866, e.ideographicsocietyparen = 12851, e.ideographicspace = 12288, e.ideographicspecialparen = 12853, e.ideographicstockparen = 12849, e.ideographicstudyparen = 12859, e.ideographicsunparen = 12848, e.ideographicsuperviseparen = 12860, e.ideographicwaterparen = 12844, e.ideographicwoodparen = 12845, e.ideographiczero = 12295, e.ideographmetalcircle = 12942, e.ideographmooncircle = 12938, e.ideographnamecircle = 12948, e.ideographsuncircle = 12944, e.ideographwatercircle = 12940, e.ideographwoodcircle = 12941, e.ideva = 2311, e.idieresis = 239, e.idieresisacute = 7727, e.idieresiscyrillic = 1253, e.idotbelow = 7883, e.iebrevecyrillic = 1239, e.iecyrillic = 1077, e.ieungacirclekorean = 12917, e.ieungaparenkorean = 12821, e.ieungcirclekorean = 12903, e.ieungkorean = 12615, e.ieungparenkorean = 12807, e.igrave = 236, e.igujarati = 2695, e.igurmukhi = 2567, e.ihiragana = 12356, e.ihookabove = 7881, e.iibengali = 2440, e.iicyrillic = 1080, e.iideva = 2312, e.iigujarati = 2696, e.iigurmukhi = 2568, e.iimatragurmukhi = 2624, e.iinvertedbreve = 523, e.iishortcyrillic = 1081, e.iivowelsignbengali = 2496, e.iivowelsigndeva = 2368, e.iivowelsigngujarati = 2752, e.ij = 307, e.ikatakana = 12452, e.ikatakanahalfwidth = 65394, e.ikorean = 12643, e.ilde = 732, e.iluyhebrew = 1452, e.imacron = 299, e.imacroncyrillic = 1251, e.imageorapproximatelyequal = 8787, e.imatragurmukhi = 2623, e.imonospace = 65353, e.increment = 8710, e.infinity = 8734, e.iniarmenian = 1387, e.integral = 8747, e.integralbottom = 8993, e.integralbt = 8993, e.integralex = 63733, e.integraltop = 8992, e.integraltp = 8992, e.intersection = 8745, e.intisquare = 13061, e.invbullet = 9688, e.invcircle = 9689, e.invsmileface = 9787, e.iocyrillic = 1105, e.iogonek = 303, e.iota = 953, e.iotadieresis = 970, e.iotadieresistonos = 912, e.iotalatin = 617, e.iotatonos = 943, e.iparen = 9380, e.irigurmukhi = 2674, e.ismallhiragana = 12355, e.ismallkatakana = 12451, e.ismallkatakanahalfwidth = 65384, e.issharbengali = 2554, e.istroke = 616, e.isuperior = 63213, e.iterationhiragana = 12445, e.iterationkatakana = 12541, e.itilde = 297, e.itildebelow = 7725, e.iubopomofo = 12585, e.iucyrillic = 1102, e.ivowelsignbengali = 2495, e.ivowelsigndeva = 2367, e.ivowelsigngujarati = 2751, e.izhitsacyrillic = 1141, e.izhitsadblgravecyrillic = 1143, e.j = 106, e.jaarmenian = 1393, e.jabengali = 2460, e.jadeva = 2332, e.jagujarati = 2716, e.jagurmukhi = 2588, e.jbopomofo = 12560, e.jcaron = 496, e.jcircle = 9433, e.jcircumflex = 309, e.jcrossedtail = 669, e.jdotlessstroke = 607, e.jecyrillic = 1112, e.jeemarabic = 1580, e.jeemfinalarabic = 65182, e.jeeminitialarabic = 65183, e.jeemmedialarabic = 65184, e.jeharabic = 1688, e.jehfinalarabic = 64395, e.jhabengali = 2461, e.jhadeva = 2333, e.jhagujarati = 2717, e.jhagurmukhi = 2589, e.jheharmenian = 1403, e.jis = 12292, e.jmonospace = 65354, e.jparen = 9381, e.jsuperior = 690, e.k = 107, e.kabashkircyrillic = 1185, e.kabengali = 2453, e.kacute = 7729, e.kacyrillic = 1082, e.kadescendercyrillic = 1179, e.kadeva = 2325, e.kaf = 1499, e.kafarabic = 1603, e.kafdagesh = 64315, e.kafdageshhebrew = 64315, e.kaffinalarabic = 65242, e.kafhebrew = 1499, e.kafinitialarabic = 65243, e.kafmedialarabic = 65244, e.kafrafehebrew = 64333, e.kagujarati = 2709, e.kagurmukhi = 2581, e.kahiragana = 12363, e.kahookcyrillic = 1220, e.kakatakana = 12459, e.kakatakanahalfwidth = 65398, e.kappa = 954, e.kappasymbolgreek = 1008, e.kapyeounmieumkorean = 12657, e.kapyeounphieuphkorean = 12676, e.kapyeounpieupkorean = 12664, e.kapyeounssangpieupkorean = 12665, e.karoriisquare = 13069, e.kashidaautoarabic = 1600, e.kashidaautonosidebearingarabic = 1600, e.kasmallkatakana = 12533, e.kasquare = 13188, e.kasraarabic = 1616, e.kasratanarabic = 1613, e.kastrokecyrillic = 1183, e.katahiraprolongmarkhalfwidth = 65392, e.kaverticalstrokecyrillic = 1181, e.kbopomofo = 12558, e.kcalsquare = 13193, e.kcaron = 489, e.kcedilla = 311, e.kcircle = 9434, e.kcommaaccent = 311, e.kdotbelow = 7731, e.keharmenian = 1412, e.kehiragana = 12369, e.kekatakana = 12465, e.kekatakanahalfwidth = 65401, e.kenarmenian = 1391, e.kesmallkatakana = 12534, e.kgreenlandic = 312, e.khabengali = 2454, e.khacyrillic = 1093, e.khadeva = 2326, e.khagujarati = 2710, e.khagurmukhi = 2582, e.khaharabic = 1582, e.khahfinalarabic = 65190, e.khahinitialarabic = 65191, e.khahmedialarabic = 65192, e.kheicoptic = 999, e.khhadeva = 2393, e.khhagurmukhi = 2649, e.khieukhacirclekorean = 12920, e.khieukhaparenkorean = 12824, e.khieukhcirclekorean = 12906, e.khieukhkorean = 12619, e.khieukhparenkorean = 12810, e.khokhaithai = 3586, e.khokhonthai = 3589, e.khokhuatthai = 3587, e.khokhwaithai = 3588, e.khomutthai = 3675, e.khook = 409, e.khorakhangthai = 3590, e.khzsquare = 13201, e.kihiragana = 12365, e.kikatakana = 12461, e.kikatakanahalfwidth = 65399, e.kiroguramusquare = 13077, e.kiromeetorusquare = 13078, e.kirosquare = 13076, e.kiyeokacirclekorean = 12910, e.kiyeokaparenkorean = 12814, e.kiyeokcirclekorean = 12896, e.kiyeokkorean = 12593, e.kiyeokparenkorean = 12800, e.kiyeoksioskorean = 12595, e.kjecyrillic = 1116, e.klinebelow = 7733, e.klsquare = 13208, e.kmcubedsquare = 13222, e.kmonospace = 65355, e.kmsquaredsquare = 13218, e.kohiragana = 12371, e.kohmsquare = 13248, e.kokaithai = 3585, e.kokatakana = 12467, e.kokatakanahalfwidth = 65402, e.kooposquare = 13086, e.koppacyrillic = 1153, e.koreanstandardsymbol = 12927, e.koroniscmb = 835, e.kparen = 9382, e.kpasquare = 13226, e.ksicyrillic = 1135, e.ktsquare = 13263, e.kturned = 670, e.kuhiragana = 12367, e.kukatakana = 12463, e.kukatakanahalfwidth = 65400, e.kvsquare = 13240, e.kwsquare = 13246, e.l = 108, e.labengali = 2482, e.lacute = 314, e.ladeva = 2354, e.lagujarati = 2738, e.lagurmukhi = 2610, e.lakkhangyaothai = 3653, e.lamaleffinalarabic = 65276, e.lamalefhamzaabovefinalarabic = 65272, e.lamalefhamzaaboveisolatedarabic = 65271, e.lamalefhamzabelowfinalarabic = 65274, e.lamalefhamzabelowisolatedarabic = 65273, e.lamalefisolatedarabic = 65275, e.lamalefmaddaabovefinalarabic = 65270, e.lamalefmaddaaboveisolatedarabic = 65269, e.lamarabic = 1604, e.lambda = 955, e.lambdastroke = 411, e.lamed = 1500, e.lameddagesh = 64316, e.lameddageshhebrew = 64316, e.lamedhebrew = 1500, e.lamfinalarabic = 65246, e.lamhahinitialarabic = 64714, e.laminitialarabic = 65247, e.lamjeeminitialarabic = 64713, e.lamkhahinitialarabic = 64715, e.lamlamhehisolatedarabic = 65010, e.lammedialarabic = 65248, e.lammeemhahinitialarabic = 64904, e.lammeeminitialarabic = 64716, e.largecircle = 9711, e.lbar = 410, e.lbelt = 620, e.lbopomofo = 12556, e.lcaron = 318, e.lcedilla = 316, e.lcircle = 9435, e.lcircumflexbelow = 7741, e.lcommaaccent = 316, e.ldot = 320, e.ldotaccent = 320, e.ldotbelow = 7735, e.ldotbelowmacron = 7737, e.leftangleabovecmb = 794, e.lefttackbelowcmb = 792, e.less = 60, e.lessequal = 8804, e.lessequalorgreater = 8922, e.lessmonospace = 65308, e.lessorequivalent = 8818, e.lessorgreater = 8822, e.lessoverequal = 8806, e.lesssmall = 65124, e.lezh = 622, e.lfblock = 9612, e.lhookretroflex = 621, e.lira = 8356, e.liwnarmenian = 1388, e.lj = 457, e.ljecyrillic = 1113, e.ll = 63168, e.lladeva = 2355, e.llagujarati = 2739, e.llinebelow = 7739, e.llladeva = 2356, e.llvocalicbengali = 2529, e.llvocalicdeva = 2401, e.llvocalicvowelsignbengali = 2531, e.llvocalicvowelsigndeva = 2403, e.lmiddletilde = 619, e.lmonospace = 65356, e.lmsquare = 13264, e.lochulathai = 3628, e.logicaland = 8743, e.logicalnot = 172, e.logicalnotreversed = 8976, e.logicalor = 8744, e.lolingthai = 3621, e.longs = 383, e.lowlinecenterline = 65102, e.lowlinecmb = 818, e.lowlinedashed = 65101, e.lozenge = 9674, e.lparen = 9383, e.lslash = 322, e.lsquare = 8467, e.lsuperior = 63214, e.ltshade = 9617, e.luthai = 3622, e.lvocalicbengali = 2444, e.lvocalicdeva = 2316, e.lvocalicvowelsignbengali = 2530, e.lvocalicvowelsigndeva = 2402, e.lxsquare = 13267, e.m = 109, e.mabengali = 2478, e.macron = 175, e.macronbelowcmb = 817, e.macroncmb = 772, e.macronlowmod = 717, e.macronmonospace = 65507, e.macute = 7743, e.madeva = 2350, e.magujarati = 2734, e.magurmukhi = 2606, e.mahapakhhebrew = 1444, e.mahapakhlefthebrew = 1444, e.mahiragana = 12414, e.maichattawalowleftthai = 63637, e.maichattawalowrightthai = 63636, e.maichattawathai = 3659, e.maichattawaupperleftthai = 63635, e.maieklowleftthai = 63628, e.maieklowrightthai = 63627, e.maiekthai = 3656, e.maiekupperleftthai = 63626, e.maihanakatleftthai = 63620, e.maihanakatthai = 3633, e.maitaikhuleftthai = 63625, e.maitaikhuthai = 3655, e.maitholowleftthai = 63631, e.maitholowrightthai = 63630, e.maithothai = 3657, e.maithoupperleftthai = 63629, e.maitrilowleftthai = 63634, e.maitrilowrightthai = 63633, e.maitrithai = 3658, e.maitriupperleftthai = 63632, e.maiyamokthai = 3654, e.makatakana = 12510, e.makatakanahalfwidth = 65423, e.male = 9794, e.mansyonsquare = 13127, e.maqafhebrew = 1470, e.mars = 9794, e.masoracirclehebrew = 1455, e.masquare = 13187, e.mbopomofo = 12551, e.mbsquare = 13268, e.mcircle = 9436, e.mcubedsquare = 13221, e.mdotaccent = 7745, e.mdotbelow = 7747, e.meemarabic = 1605, e.meemfinalarabic = 65250, e.meeminitialarabic = 65251, e.meemmedialarabic = 65252, e.meemmeeminitialarabic = 64721, e.meemmeemisolatedarabic = 64584, e.meetorusquare = 13133, e.mehiragana = 12417, e.meizierasquare = 13182, e.mekatakana = 12513, e.mekatakanahalfwidth = 65426, e.mem = 1502, e.memdagesh = 64318, e.memdageshhebrew = 64318, e.memhebrew = 1502, e.menarmenian = 1396, e.merkhahebrew = 1445, e.merkhakefulahebrew = 1446, e.merkhakefulalefthebrew = 1446, e.merkhalefthebrew = 1445, e.mhook = 625, e.mhzsquare = 13202, e.middledotkatakanahalfwidth = 65381, e.middot = 183, e.mieumacirclekorean = 12914, e.mieumaparenkorean = 12818, e.mieumcirclekorean = 12900, e.mieumkorean = 12609, e.mieumpansioskorean = 12656, e.mieumparenkorean = 12804, e.mieumpieupkorean = 12654, e.mieumsioskorean = 12655, e.mihiragana = 12415, e.mikatakana = 12511, e.mikatakanahalfwidth = 65424, e.minus = 8722, e.minusbelowcmb = 800, e.minuscircle = 8854, e.minusmod = 727, e.minusplus = 8723, e.minute = 8242, e.miribaarusquare = 13130, e.mirisquare = 13129, e.mlonglegturned = 624, e.mlsquare = 13206, e.mmcubedsquare = 13219, e.mmonospace = 65357, e.mmsquaredsquare = 13215, e.mohiragana = 12418, e.mohmsquare = 13249, e.mokatakana = 12514, e.mokatakanahalfwidth = 65427, e.molsquare = 13270, e.momathai = 3617, e.moverssquare = 13223, e.moverssquaredsquare = 13224, e.mparen = 9384, e.mpasquare = 13227, e.mssquare = 13235, e.msuperior = 63215, e.mturned = 623, e.mu = 181, e.mu1 = 181, e.muasquare = 13186, e.muchgreater = 8811, e.muchless = 8810, e.mufsquare = 13196, e.mugreek = 956, e.mugsquare = 13197, e.muhiragana = 12416, e.mukatakana = 12512, e.mukatakanahalfwidth = 65425, e.mulsquare = 13205, e.multiply = 215, e.mumsquare = 13211, e.munahhebrew = 1443, e.munahlefthebrew = 1443, e.musicalnote = 9834, e.musicalnotedbl = 9835, e.musicflatsign = 9837, e.musicsharpsign = 9839, e.mussquare = 13234, e.muvsquare = 13238, e.muwsquare = 13244, e.mvmegasquare = 13241, e.mvsquare = 13239, e.mwmegasquare = 13247, e.mwsquare = 13245, e.n = 110, e.nabengali = 2472, e.nabla = 8711, e.nacute = 324, e.nadeva = 2344, e.nagujarati = 2728, e.nagurmukhi = 2600, e.nahiragana = 12394, e.nakatakana = 12490, e.nakatakanahalfwidth = 65413, e.napostrophe = 329, e.nasquare = 13185, e.nbopomofo = 12555, e.nbspace = 160, e.ncaron = 328, e.ncedilla = 326, e.ncircle = 9437, e.ncircumflexbelow = 7755, e.ncommaaccent = 326, e.ndotaccent = 7749, e.ndotbelow = 7751, e.nehiragana = 12397, e.nekatakana = 12493, e.nekatakanahalfwidth = 65416, e.newsheqelsign = 8362, e.nfsquare = 13195, e.ngabengali = 2457, e.ngadeva = 2329, e.ngagujarati = 2713, e.ngagurmukhi = 2585, e.ngonguthai = 3591, e.nhiragana = 12435, e.nhookleft = 626, e.nhookretroflex = 627, e.nieunacirclekorean = 12911, e.nieunaparenkorean = 12815, e.nieuncieuckorean = 12597, e.nieuncirclekorean = 12897, e.nieunhieuhkorean = 12598, e.nieunkorean = 12596, e.nieunpansioskorean = 12648, e.nieunparenkorean = 12801, e.nieunsioskorean = 12647, e.nieuntikeutkorean = 12646, e.nihiragana = 12395, e.nikatakana = 12491, e.nikatakanahalfwidth = 65414, e.nikhahitleftthai = 63641, e.nikhahitthai = 3661, e.nine = 57, e.ninearabic = 1641, e.ninebengali = 2543, e.ninecircle = 9320, e.ninecircleinversesansserif = 10130, e.ninedeva = 2415, e.ninegujarati = 2799, e.ninegurmukhi = 2671, e.ninehackarabic = 1641, e.ninehangzhou = 12329, e.nineideographicparen = 12840, e.nineinferior = 8329, e.ninemonospace = 65305, e.nineoldstyle = 63289, e.nineparen = 9340, e.nineperiod = 9360, e.ninepersian = 1785, e.nineroman = 8568, e.ninesuperior = 8313, e.nineteencircle = 9330, e.nineteenparen = 9350, e.nineteenperiod = 9370, e.ninethai = 3673, e.nj = 460, e.njecyrillic = 1114, e.nkatakana = 12531, e.nkatakanahalfwidth = 65437, e.nlegrightlong = 414, e.nlinebelow = 7753, e.nmonospace = 65358, e.nmsquare = 13210, e.nnabengali = 2467, e.nnadeva = 2339, e.nnagujarati = 2723, e.nnagurmukhi = 2595, e.nnnadeva = 2345, e.nohiragana = 12398, e.nokatakana = 12494, e.nokatakanahalfwidth = 65417, e.nonbreakingspace = 160, e.nonenthai = 3603, e.nonuthai = 3609, e.noonarabic = 1606, e.noonfinalarabic = 65254, e.noonghunnaarabic = 1722, e.noonghunnafinalarabic = 64415, e.nooninitialarabic = 65255, e.noonjeeminitialarabic = 64722, e.noonjeemisolatedarabic = 64587, e.noonmedialarabic = 65256, e.noonmeeminitialarabic = 64725, e.noonmeemisolatedarabic = 64590, e.noonnoonfinalarabic = 64653, e.notcontains = 8716, e.notelement = 8713, e.notelementof = 8713, e.notequal = 8800, e.notgreater = 8815, e.notgreaternorequal = 8817, e.notgreaternorless = 8825, e.notidentical = 8802, e.notless = 8814, e.notlessnorequal = 8816, e.notparallel = 8742, e.notprecedes = 8832, e.notsubset = 8836, e.notsucceeds = 8833, e.notsuperset = 8837, e.nowarmenian = 1398, e.nparen = 9385, e.nssquare = 13233, e.nsuperior = 8319, e.ntilde = 241, e.nu = 957, e.nuhiragana = 12396, e.nukatakana = 12492, e.nukatakanahalfwidth = 65415, e.nuktabengali = 2492, e.nuktadeva = 2364, e.nuktagujarati = 2748, e.nuktagurmukhi = 2620, e.numbersign = 35, e.numbersignmonospace = 65283, e.numbersignsmall = 65119, e.numeralsigngreek = 884, e.numeralsignlowergreek = 885, e.numero = 8470, e.nun = 1504, e.nundagesh = 64320, e.nundageshhebrew = 64320, e.nunhebrew = 1504, e.nvsquare = 13237, e.nwsquare = 13243, e.nyabengali = 2462, e.nyadeva = 2334, e.nyagujarati = 2718, e.nyagurmukhi = 2590, e.o = 111, e.oacute = 243, e.oangthai = 3629, e.obarred = 629, e.obarredcyrillic = 1257, e.obarreddieresiscyrillic = 1259, e.obengali = 2451, e.obopomofo = 12571, e.obreve = 335, e.ocandradeva = 2321, e.ocandragujarati = 2705, e.ocandravowelsigndeva = 2377, e.ocandravowelsigngujarati = 2761, e.ocaron = 466, e.ocircle = 9438, e.ocircumflex = 244, e.ocircumflexacute = 7889, e.ocircumflexdotbelow = 7897, e.ocircumflexgrave = 7891, e.ocircumflexhookabove = 7893, e.ocircumflextilde = 7895, e.ocyrillic = 1086, e.odblacute = 337, e.odblgrave = 525, e.odeva = 2323, e.odieresis = 246, e.odieresiscyrillic = 1255, e.odotbelow = 7885, e.oe = 339, e.oekorean = 12634, e.ogonek = 731, e.ogonekcmb = 808, e.ograve = 242, e.ogujarati = 2707, e.oharmenian = 1413, e.ohiragana = 12362, e.ohookabove = 7887, e.ohorn = 417, e.ohornacute = 7899, e.ohorndotbelow = 7907, e.ohorngrave = 7901, e.ohornhookabove = 7903, e.ohorntilde = 7905, e.ohungarumlaut = 337, e.oi = 419, e.oinvertedbreve = 527, e.okatakana = 12458, e.okatakanahalfwidth = 65397, e.okorean = 12631, e.olehebrew = 1451, e.omacron = 333, e.omacronacute = 7763, e.omacrongrave = 7761, e.omdeva = 2384, e.omega = 969, e.omega1 = 982, e.omegacyrillic = 1121, e.omegalatinclosed = 631, e.omegaroundcyrillic = 1147, e.omegatitlocyrillic = 1149, e.omegatonos = 974, e.omgujarati = 2768, e.omicron = 959, e.omicrontonos = 972, e.omonospace = 65359, e.one = 49, e.onearabic = 1633, e.onebengali = 2535, e.onecircle = 9312, e.onecircleinversesansserif = 10122, e.onedeva = 2407, e.onedotenleader = 8228, e.oneeighth = 8539, e.onefitted = 63196, e.onegujarati = 2791, e.onegurmukhi = 2663, e.onehackarabic = 1633, e.onehalf = 189, e.onehangzhou = 12321, e.oneideographicparen = 12832, e.oneinferior = 8321, e.onemonospace = 65297, e.onenumeratorbengali = 2548, e.oneoldstyle = 63281, e.oneparen = 9332, e.oneperiod = 9352, e.onepersian = 1777, e.onequarter = 188, e.oneroman = 8560, e.onesuperior = 185, e.onethai = 3665, e.onethird = 8531, e.oogonek = 491, e.oogonekmacron = 493, e.oogurmukhi = 2579, e.oomatragurmukhi = 2635, e.oopen = 596, e.oparen = 9386, e.openbullet = 9702, e.option = 8997, e.ordfeminine = 170, e.ordmasculine = 186, e.orthogonal = 8735, e.oshortdeva = 2322, e.oshortvowelsigndeva = 2378, e.oslash = 248, e.oslashacute = 511, e.osmallhiragana = 12361, e.osmallkatakana = 12457, e.osmallkatakanahalfwidth = 65387, e.ostrokeacute = 511, e.osuperior = 63216, e.otcyrillic = 1151, e.otilde = 245, e.otildeacute = 7757, e.otildedieresis = 7759, e.oubopomofo = 12577, e.overline = 8254, e.overlinecenterline = 65098, e.overlinecmb = 773, e.overlinedashed = 65097, e.overlinedblwavy = 65100, e.overlinewavy = 65099, e.overscore = 175, e.ovowelsignbengali = 2507, e.ovowelsigndeva = 2379, e.ovowelsigngujarati = 2763, e.p = 112, e.paampssquare = 13184, e.paasentosquare = 13099, e.pabengali = 2474, e.pacute = 7765, e.padeva = 2346, e.pagedown = 8671, e.pageup = 8670, e.pagujarati = 2730, e.pagurmukhi = 2602, e.pahiragana = 12401, e.paiyannoithai = 3631, e.pakatakana = 12497, e.palatalizationcyrilliccmb = 1156, e.palochkacyrillic = 1216, e.pansioskorean = 12671, e.paragraph = 182, e.parallel = 8741, e.parenleft = 40, e.parenleftaltonearabic = 64830, e.parenleftbt = 63725, e.parenleftex = 63724, e.parenleftinferior = 8333, e.parenleftmonospace = 65288, e.parenleftsmall = 65113, e.parenleftsuperior = 8317, e.parenlefttp = 63723, e.parenleftvertical = 65077, e.parenright = 41, e.parenrightaltonearabic = 64831, e.parenrightbt = 63736, e.parenrightex = 63735, e.parenrightinferior = 8334, e.parenrightmonospace = 65289, e.parenrightsmall = 65114, e.parenrightsuperior = 8318, e.parenrighttp = 63734, e.parenrightvertical = 65078, e.partialdiff = 8706, e.paseqhebrew = 1472, e.pashtahebrew = 1433, e.pasquare = 13225, e.patah = 1463, e.patah11 = 1463, e.patah1d = 1463, e.patah2a = 1463, e.patahhebrew = 1463, e.patahnarrowhebrew = 1463, e.patahquarterhebrew = 1463, e.patahwidehebrew = 1463, e.pazerhebrew = 1441, e.pbopomofo = 12550, e.pcircle = 9439, e.pdotaccent = 7767, e.pe = 1508, e.pecyrillic = 1087, e.pedagesh = 64324, e.pedageshhebrew = 64324, e.peezisquare = 13115, e.pefinaldageshhebrew = 64323, e.peharabic = 1662, e.peharmenian = 1402, e.pehebrew = 1508, e.pehfinalarabic = 64343, e.pehinitialarabic = 64344, e.pehiragana = 12410, e.pehmedialarabic = 64345, e.pekatakana = 12506, e.pemiddlehookcyrillic = 1191, e.perafehebrew = 64334, e.percent = 37, e.percentarabic = 1642, e.percentmonospace = 65285, e.percentsmall = 65130, e.period = 46, e.periodarmenian = 1417, e.periodcentered = 183, e.periodhalfwidth = 65377, e.periodinferior = 63207, e.periodmonospace = 65294, e.periodsmall = 65106, e.periodsuperior = 63208, e.perispomenigreekcmb = 834, e.perpendicular = 8869, e.perthousand = 8240, e.peseta = 8359, e.pfsquare = 13194, e.phabengali = 2475, e.phadeva = 2347, e.phagujarati = 2731, e.phagurmukhi = 2603, e.phi = 966, e.phi1 = 981, e.phieuphacirclekorean = 12922, e.phieuphaparenkorean = 12826, e.phieuphcirclekorean = 12908, e.phieuphkorean = 12621, e.phieuphparenkorean = 12812, e.philatin = 632, e.phinthuthai = 3642, e.phisymbolgreek = 981, e.phook = 421, e.phophanthai = 3614, e.phophungthai = 3612, e.phosamphaothai = 3616, e.pi = 960, e.pieupacirclekorean = 12915, e.pieupaparenkorean = 12819, e.pieupcieuckorean = 12662, e.pieupcirclekorean = 12901, e.pieupkiyeokkorean = 12658, e.pieupkorean = 12610, e.pieupparenkorean = 12805, e.pieupsioskiyeokkorean = 12660, e.pieupsioskorean = 12612, e.pieupsiostikeutkorean = 12661, e.pieupthieuthkorean = 12663, e.pieuptikeutkorean = 12659, e.pihiragana = 12404, e.pikatakana = 12500, e.pisymbolgreek = 982, e.piwrarmenian = 1411, e.plus = 43, e.plusbelowcmb = 799, e.pluscircle = 8853, e.plusminus = 177, e.plusmod = 726, e.plusmonospace = 65291, e.plussmall = 65122, e.plussuperior = 8314, e.pmonospace = 65360, e.pmsquare = 13272, e.pohiragana = 12413, e.pointingindexdownwhite = 9759, e.pointingindexleftwhite = 9756, e.pointingindexrightwhite = 9758, e.pointingindexupwhite = 9757, e.pokatakana = 12509, e.poplathai = 3611, e.postalmark = 12306, e.postalmarkface = 12320, e.pparen = 9387, e.precedes = 8826, e.prescription = 8478, e.primemod = 697, e.primereversed = 8245, e.product = 8719, e.projective = 8965, e.prolongedkana = 12540, e.propellor = 8984, e.propersubset = 8834, e.propersuperset = 8835, e.proportion = 8759, e.proportional = 8733, e.psi = 968, e.psicyrillic = 1137, e.psilipneumatacyrilliccmb = 1158, e.pssquare = 13232, e.puhiragana = 12407, e.pukatakana = 12503, e.pvsquare = 13236, e.pwsquare = 13242, e.q = 113, e.qadeva = 2392, e.qadmahebrew = 1448, e.qafarabic = 1602, e.qaffinalarabic = 65238, e.qafinitialarabic = 65239, e.qafmedialarabic = 65240, e.qamats = 1464, e.qamats10 = 1464, e.qamats1a = 1464, e.qamats1c = 1464, e.qamats27 = 1464, e.qamats29 = 1464, e.qamats33 = 1464, e.qamatsde = 1464, e.qamatshebrew = 1464, e.qamatsnarrowhebrew = 1464, e.qamatsqatanhebrew = 1464, e.qamatsqatannarrowhebrew = 1464, e.qamatsqatanquarterhebrew = 1464, e.qamatsqatanwidehebrew = 1464, e.qamatsquarterhebrew = 1464, e.qamatswidehebrew = 1464, e.qarneyparahebrew = 1439, e.qbopomofo = 12561, e.qcircle = 9440, e.qhook = 672, e.qmonospace = 65361, e.qof = 1511, e.qofdagesh = 64327, e.qofdageshhebrew = 64327, e.qofhebrew = 1511, e.qparen = 9388, e.quarternote = 9833, e.qubuts = 1467, e.qubuts18 = 1467, e.qubuts25 = 1467, e.qubuts31 = 1467, e.qubutshebrew = 1467, e.qubutsnarrowhebrew = 1467, e.qubutsquarterhebrew = 1467, e.qubutswidehebrew = 1467, e.question = 63, e.questionarabic = 1567, e.questionarmenian = 1374, e.questiondown = 191, e.questiondownsmall = 63423, e.questiongreek = 894, e.questionmonospace = 65311, e.questionsmall = 63295, e.quotedbl = 34, e.quotedblbase = 8222, e.quotedblleft = 8220, e.quotedblmonospace = 65282, e.quotedblprime = 12318, e.quotedblprimereversed = 12317, e.quotedblright = 8221, e.quoteleft = 8216, e.quoteleftreversed = 8219, e.quotereversed = 8219, e.quoteright = 8217, e.quoterightn = 329, e.quotesinglbase = 8218, e.quotesingle = 39, e.quotesinglemonospace = 65287, e.r = 114, e.raarmenian = 1404, e.rabengali = 2480, e.racute = 341, e.radeva = 2352, e.radical = 8730, e.radicalex = 63717, e.radoverssquare = 13230, e.radoverssquaredsquare = 13231, e.radsquare = 13229, e.rafe = 1471, e.rafehebrew = 1471, e.ragujarati = 2736, e.ragurmukhi = 2608, e.rahiragana = 12425, e.rakatakana = 12521, e.rakatakanahalfwidth = 65431, e.ralowerdiagonalbengali = 2545, e.ramiddlediagonalbengali = 2544, e.ramshorn = 612, e.ratio = 8758, e.rbopomofo = 12566, e.rcaron = 345, e.rcedilla = 343, e.rcircle = 9441, e.rcommaaccent = 343, e.rdblgrave = 529, e.rdotaccent = 7769, e.rdotbelow = 7771, e.rdotbelowmacron = 7773, e.referencemark = 8251, e.reflexsubset = 8838, e.reflexsuperset = 8839, e.registered = 174, e.registersans = 63720, e.registerserif = 63194, e.reharabic = 1585, e.reharmenian = 1408, e.rehfinalarabic = 65198, e.rehiragana = 12428, e.rekatakana = 12524, e.rekatakanahalfwidth = 65434, e.resh = 1512, e.reshdageshhebrew = 64328, e.reshhebrew = 1512, e.reversedtilde = 8765, e.reviahebrew = 1431, e.reviamugrashhebrew = 1431, e.revlogicalnot = 8976, e.rfishhook = 638, e.rfishhookreversed = 639, e.rhabengali = 2525, e.rhadeva = 2397, e.rho = 961, e.rhook = 637, e.rhookturned = 635, e.rhookturnedsuperior = 693, e.rhosymbolgreek = 1009, e.rhotichookmod = 734, e.rieulacirclekorean = 12913, e.rieulaparenkorean = 12817, e.rieulcirclekorean = 12899, e.rieulhieuhkorean = 12608, e.rieulkiyeokkorean = 12602, e.rieulkiyeoksioskorean = 12649, e.rieulkorean = 12601, e.rieulmieumkorean = 12603, e.rieulpansioskorean = 12652, e.rieulparenkorean = 12803, e.rieulphieuphkorean = 12607, e.rieulpieupkorean = 12604, e.rieulpieupsioskorean = 12651, e.rieulsioskorean = 12605, e.rieulthieuthkorean = 12606, e.rieultikeutkorean = 12650, e.rieulyeorinhieuhkorean = 12653, e.rightangle = 8735, e.righttackbelowcmb = 793, e.righttriangle = 8895, e.rihiragana = 12426, e.rikatakana = 12522, e.rikatakanahalfwidth = 65432, e.ring = 730, e.ringbelowcmb = 805, e.ringcmb = 778, e.ringhalfleft = 703, e.ringhalfleftarmenian = 1369, e.ringhalfleftbelowcmb = 796, e.ringhalfleftcentered = 723, e.ringhalfright = 702, e.ringhalfrightbelowcmb = 825, e.ringhalfrightcentered = 722, e.rinvertedbreve = 531, e.rittorusquare = 13137, e.rlinebelow = 7775, e.rlongleg = 636, e.rlonglegturned = 634, e.rmonospace = 65362, e.rohiragana = 12429, e.rokatakana = 12525, e.rokatakanahalfwidth = 65435, e.roruathai = 3619, e.rparen = 9389, e.rrabengali = 2524, e.rradeva = 2353, e.rragurmukhi = 2652, e.rreharabic = 1681, e.rrehfinalarabic = 64397, e.rrvocalicbengali = 2528, e.rrvocalicdeva = 2400, e.rrvocalicgujarati = 2784, e.rrvocalicvowelsignbengali = 2500, e.rrvocalicvowelsigndeva = 2372, e.rrvocalicvowelsigngujarati = 2756, e.rsuperior = 63217, e.rtblock = 9616, e.rturned = 633, e.rturnedsuperior = 692, e.ruhiragana = 12427, e.rukatakana = 12523, e.rukatakanahalfwidth = 65433, e.rupeemarkbengali = 2546, e.rupeesignbengali = 2547, e.rupiah = 63197, e.ruthai = 3620, e.rvocalicbengali = 2443, e.rvocalicdeva = 2315, e.rvocalicgujarati = 2699, e.rvocalicvowelsignbengali = 2499, e.rvocalicvowelsigndeva = 2371, e.rvocalicvowelsigngujarati = 2755, e.s = 115, e.sabengali = 2488, e.sacute = 347, e.sacutedotaccent = 7781, e.sadarabic = 1589, e.sadeva = 2360, e.sadfinalarabic = 65210, e.sadinitialarabic = 65211, e.sadmedialarabic = 65212, e.sagujarati = 2744, e.sagurmukhi = 2616, e.sahiragana = 12373, e.sakatakana = 12469, e.sakatakanahalfwidth = 65403, e.sallallahoualayhewasallamarabic = 65018, e.samekh = 1505, e.samekhdagesh = 64321, e.samekhdageshhebrew = 64321, e.samekhhebrew = 1505, e.saraaathai = 3634, e.saraaethai = 3649, e.saraaimaimalaithai = 3652, e.saraaimaimuanthai = 3651, e.saraamthai = 3635, e.saraathai = 3632, e.saraethai = 3648, e.saraiileftthai = 63622, e.saraiithai = 3637, e.saraileftthai = 63621, e.saraithai = 3636, e.saraothai = 3650, e.saraueeleftthai = 63624, e.saraueethai = 3639, e.saraueleftthai = 63623, e.sarauethai = 3638, e.sarauthai = 3640, e.sarauuthai = 3641, e.sbopomofo = 12569, e.scaron = 353, e.scarondotaccent = 7783, e.scedilla = 351, e.schwa = 601, e.schwacyrillic = 1241, e.schwadieresiscyrillic = 1243, e.schwahook = 602, e.scircle = 9442, e.scircumflex = 349, e.scommaaccent = 537, e.sdotaccent = 7777, e.sdotbelow = 7779, e.sdotbelowdotaccent = 7785, e.seagullbelowcmb = 828, e.second = 8243, e.secondtonechinese = 714, e.section = 167, e.seenarabic = 1587, e.seenfinalarabic = 65202, e.seeninitialarabic = 65203, e.seenmedialarabic = 65204, e.segol = 1462, e.segol13 = 1462, e.segol1f = 1462, e.segol2c = 1462, e.segolhebrew = 1462, e.segolnarrowhebrew = 1462, e.segolquarterhebrew = 1462, e.segoltahebrew = 1426, e.segolwidehebrew = 1462, e.seharmenian = 1405, e.sehiragana = 12379, e.sekatakana = 12475, e.sekatakanahalfwidth = 65406, e.semicolon = 59, e.semicolonarabic = 1563, e.semicolonmonospace = 65307, e.semicolonsmall = 65108, e.semivoicedmarkkana = 12444, e.semivoicedmarkkanahalfwidth = 65439, e.sentisquare = 13090, e.sentosquare = 13091, e.seven = 55, e.sevenarabic = 1639, e.sevenbengali = 2541, e.sevencircle = 9318, e.sevencircleinversesansserif = 10128, e.sevendeva = 2413, e.seveneighths = 8542, e.sevengujarati = 2797, e.sevengurmukhi = 2669, e.sevenhackarabic = 1639, e.sevenhangzhou = 12327, e.sevenideographicparen = 12838, e.seveninferior = 8327, e.sevenmonospace = 65303, e.sevenoldstyle = 63287, e.sevenparen = 9338, e.sevenperiod = 9358, e.sevenpersian = 1783, e.sevenroman = 8566, e.sevensuperior = 8311, e.seventeencircle = 9328, e.seventeenparen = 9348, e.seventeenperiod = 9368, e.seventhai = 3671, e.sfthyphen = 173, e.shaarmenian = 1399, e.shabengali = 2486, e.shacyrillic = 1096, e.shaddaarabic = 1617, e.shaddadammaarabic = 64609, e.shaddadammatanarabic = 64606, e.shaddafathaarabic = 64608, e.shaddakasraarabic = 64610, e.shaddakasratanarabic = 64607, e.shade = 9618, e.shadedark = 9619, e.shadelight = 9617, e.shademedium = 9618, e.shadeva = 2358, e.shagujarati = 2742, e.shagurmukhi = 2614, e.shalshelethebrew = 1427, e.shbopomofo = 12565, e.shchacyrillic = 1097, e.sheenarabic = 1588, e.sheenfinalarabic = 65206, e.sheeninitialarabic = 65207, e.sheenmedialarabic = 65208, e.sheicoptic = 995, e.sheqel = 8362, e.sheqelhebrew = 8362, e.sheva = 1456, e.sheva115 = 1456, e.sheva15 = 1456, e.sheva22 = 1456, e.sheva2e = 1456, e.shevahebrew = 1456, e.shevanarrowhebrew = 1456, e.shevaquarterhebrew = 1456, e.shevawidehebrew = 1456, e.shhacyrillic = 1211, e.shimacoptic = 1005, e.shin = 1513, e.shindagesh = 64329, e.shindageshhebrew = 64329, e.shindageshshindot = 64300, e.shindageshshindothebrew = 64300, e.shindageshsindot = 64301, e.shindageshsindothebrew = 64301, e.shindothebrew = 1473, e.shinhebrew = 1513, e.shinshindot = 64298, e.shinshindothebrew = 64298, e.shinsindot = 64299, e.shinsindothebrew = 64299, e.shook = 642, e.sigma = 963, e.sigma1 = 962, e.sigmafinal = 962, e.sigmalunatesymbolgreek = 1010, e.sihiragana = 12375, e.sikatakana = 12471, e.sikatakanahalfwidth = 65404, e.siluqhebrew = 1469, e.siluqlefthebrew = 1469, e.similar = 8764, e.sindothebrew = 1474, e.siosacirclekorean = 12916, e.siosaparenkorean = 12820, e.sioscieuckorean = 12670, e.sioscirclekorean = 12902, e.sioskiyeokkorean = 12666, e.sioskorean = 12613, e.siosnieunkorean = 12667, e.siosparenkorean = 12806, e.siospieupkorean = 12669, e.siostikeutkorean = 12668, e.six = 54, e.sixarabic = 1638, e.sixbengali = 2540, e.sixcircle = 9317, e.sixcircleinversesansserif = 10127, e.sixdeva = 2412, e.sixgujarati = 2796, e.sixgurmukhi = 2668, e.sixhackarabic = 1638, e.sixhangzhou = 12326, e.sixideographicparen = 12837, e.sixinferior = 8326, e.sixmonospace = 65302, e.sixoldstyle = 63286, e.sixparen = 9337, e.sixperiod = 9357, e.sixpersian = 1782, e.sixroman = 8565, e.sixsuperior = 8310, e.sixteencircle = 9327, e.sixteencurrencydenominatorbengali = 2553, e.sixteenparen = 9347, e.sixteenperiod = 9367, e.sixthai = 3670, e.slash = 47, e.slashmonospace = 65295, e.slong = 383, e.slongdotaccent = 7835, e.smileface = 9786, e.smonospace = 65363, e.sofpasuqhebrew = 1475, e.softhyphen = 173, e.softsigncyrillic = 1100, e.sohiragana = 12381, e.sokatakana = 12477, e.sokatakanahalfwidth = 65407, e.soliduslongoverlaycmb = 824, e.solidusshortoverlaycmb = 823, e.sorusithai = 3625, e.sosalathai = 3624, e.sosothai = 3595, e.sosuathai = 3626, e.space = 32, e.spacehackarabic = 32, e.spade = 9824, e.spadesuitblack = 9824, e.spadesuitwhite = 9828, e.sparen = 9390, e.squarebelowcmb = 827, e.squarecc = 13252, e.squarecm = 13213, e.squarediagonalcrosshatchfill = 9641, e.squarehorizontalfill = 9636, e.squarekg = 13199, e.squarekm = 13214, e.squarekmcapital = 13262, e.squareln = 13265, e.squarelog = 13266, e.squaremg = 13198, e.squaremil = 13269, e.squaremm = 13212, e.squaremsquared = 13217, e.squareorthogonalcrosshatchfill = 9638, e.squareupperlefttolowerrightfill = 9639, e.squareupperrighttolowerleftfill = 9640, e.squareverticalfill = 9637, e.squarewhitewithsmallblack = 9635, e.srsquare = 13275, e.ssabengali = 2487, e.ssadeva = 2359, e.ssagujarati = 2743, e.ssangcieuckorean = 12617, e.ssanghieuhkorean = 12677, e.ssangieungkorean = 12672, e.ssangkiyeokkorean = 12594, e.ssangnieunkorean = 12645, e.ssangpieupkorean = 12611, e.ssangsioskorean = 12614, e.ssangtikeutkorean = 12600, e.ssuperior = 63218, e.sterling = 163, e.sterlingmonospace = 65505, e.strokelongoverlaycmb = 822, e.strokeshortoverlaycmb = 821, e.subset = 8834, e.subsetnotequal = 8842, e.subsetorequal = 8838, e.succeeds = 8827, e.suchthat = 8715, e.suhiragana = 12377, e.sukatakana = 12473, e.sukatakanahalfwidth = 65405, e.sukunarabic = 1618, e.summation = 8721, e.sun = 9788, e.superset = 8835, e.supersetnotequal = 8843, e.supersetorequal = 8839, e.svsquare = 13276, e.syouwaerasquare = 13180, e.t = 116, e.tabengali = 2468, e.tackdown = 8868, e.tackleft = 8867, e.tadeva = 2340, e.tagujarati = 2724, e.tagurmukhi = 2596, e.taharabic = 1591, e.tahfinalarabic = 65218, e.tahinitialarabic = 65219, e.tahiragana = 12383, e.tahmedialarabic = 65220, e.taisyouerasquare = 13181, e.takatakana = 12479, e.takatakanahalfwidth = 65408, e.tatweelarabic = 1600, e.tau = 964, e.tav = 1514, e.tavdages = 64330, e.tavdagesh = 64330, e.tavdageshhebrew = 64330, e.tavhebrew = 1514, e.tbar = 359, e.tbopomofo = 12554, e.tcaron = 357, e.tccurl = 680, e.tcedilla = 355, e.tcheharabic = 1670, e.tchehfinalarabic = 64379, e.tchehinitialarabic = 64380, e.tchehmedialarabic = 64381, e.tcircle = 9443, e.tcircumflexbelow = 7793, e.tcommaaccent = 355, e.tdieresis = 7831, e.tdotaccent = 7787, e.tdotbelow = 7789, e.tecyrillic = 1090, e.tedescendercyrillic = 1197, e.teharabic = 1578, e.tehfinalarabic = 65174, e.tehhahinitialarabic = 64674, e.tehhahisolatedarabic = 64524, e.tehinitialarabic = 65175, e.tehiragana = 12390, e.tehjeeminitialarabic = 64673, e.tehjeemisolatedarabic = 64523, e.tehmarbutaarabic = 1577, e.tehmarbutafinalarabic = 65172, e.tehmedialarabic = 65176, e.tehmeeminitialarabic = 64676, e.tehmeemisolatedarabic = 64526, e.tehnoonfinalarabic = 64627, e.tekatakana = 12486, e.tekatakanahalfwidth = 65411, e.telephone = 8481, e.telephoneblack = 9742, e.telishagedolahebrew = 1440, e.telishaqetanahebrew = 1449, e.tencircle = 9321, e.tenideographicparen = 12841, e.tenparen = 9341, e.tenperiod = 9361, e.tenroman = 8569, e.tesh = 679, e.tet = 1496, e.tetdagesh = 64312, e.tetdageshhebrew = 64312, e.tethebrew = 1496, e.tetsecyrillic = 1205, e.tevirhebrew = 1435, e.tevirlefthebrew = 1435, e.thabengali = 2469, e.thadeva = 2341, e.thagujarati = 2725, e.thagurmukhi = 2597, e.thalarabic = 1584, e.thalfinalarabic = 65196, e.thanthakhatlowleftthai = 63640, e.thanthakhatlowrightthai = 63639, e.thanthakhatthai = 3660, e.thanthakhatupperleftthai = 63638, e.theharabic = 1579, e.thehfinalarabic = 65178, e.thehinitialarabic = 65179, e.thehmedialarabic = 65180, e.thereexists = 8707, e.therefore = 8756, e.theta = 952, e.theta1 = 977, e.thetasymbolgreek = 977, e.thieuthacirclekorean = 12921, e.thieuthaparenkorean = 12825, e.thieuthcirclekorean = 12907, e.thieuthkorean = 12620, e.thieuthparenkorean = 12811, e.thirteencircle = 9324, e.thirteenparen = 9344, e.thirteenperiod = 9364, e.thonangmonthothai = 3601, e.thook = 429, e.thophuthaothai = 3602, e.thorn = 254, e.thothahanthai = 3607, e.thothanthai = 3600, e.thothongthai = 3608, e.thothungthai = 3606, e.thousandcyrillic = 1154, e.thousandsseparatorarabic = 1644, e.thousandsseparatorpersian = 1644, e.three = 51, e.threearabic = 1635, e.threebengali = 2537, e.threecircle = 9314, e.threecircleinversesansserif = 10124, e.threedeva = 2409, e.threeeighths = 8540, e.threegujarati = 2793, e.threegurmukhi = 2665, e.threehackarabic = 1635, e.threehangzhou = 12323, e.threeideographicparen = 12834, e.threeinferior = 8323, e.threemonospace = 65299, e.threenumeratorbengali = 2550, e.threeoldstyle = 63283, e.threeparen = 9334, e.threeperiod = 9354, e.threepersian = 1779, e.threequarters = 190, e.threequartersemdash = 63198, e.threeroman = 8562, e.threesuperior = 179, e.threethai = 3667, e.thzsquare = 13204, e.tihiragana = 12385, e.tikatakana = 12481, e.tikatakanahalfwidth = 65409, e.tikeutacirclekorean = 12912, e.tikeutaparenkorean = 12816, e.tikeutcirclekorean = 12898, e.tikeutkorean = 12599, e.tikeutparenkorean = 12802, e.tilde = 732, e.tildebelowcmb = 816, e.tildecmb = 771, e.tildecomb = 771, e.tildedoublecmb = 864, e.tildeoperator = 8764, e.tildeoverlaycmb = 820, e.tildeverticalcmb = 830, e.timescircle = 8855, e.tipehahebrew = 1430, e.tipehalefthebrew = 1430, e.tippigurmukhi = 2672, e.titlocyrilliccmb = 1155, e.tiwnarmenian = 1407, e.tlinebelow = 7791, e.tmonospace = 65364, e.toarmenian = 1385, e.tohiragana = 12392, e.tokatakana = 12488, e.tokatakanahalfwidth = 65412, e.tonebarextrahighmod = 741, e.tonebarextralowmod = 745, e.tonebarhighmod = 742, e.tonebarlowmod = 744, e.tonebarmidmod = 743, e.tonefive = 445, e.tonesix = 389, e.tonetwo = 424, e.tonos = 900, e.tonsquare = 13095, e.topatakthai = 3599, e.tortoiseshellbracketleft = 12308, e.tortoiseshellbracketleftsmall = 65117, e.tortoiseshellbracketleftvertical = 65081, e.tortoiseshellbracketright = 12309, e.tortoiseshellbracketrightsmall = 65118, e.tortoiseshellbracketrightvertical = 65082, e.totaothai = 3605, e.tpalatalhook = 427, e.tparen = 9391, e.trademark = 8482, e.trademarksans = 63722, e.trademarkserif = 63195, e.tretroflexhook = 648, e.triagdn = 9660, e.triaglf = 9668, e.triagrt = 9658, e.triagup = 9650, e.ts = 678, e.tsadi = 1510, e.tsadidagesh = 64326, e.tsadidageshhebrew = 64326, e.tsadihebrew = 1510, e.tsecyrillic = 1094, e.tsere = 1461, e.tsere12 = 1461, e.tsere1e = 1461, e.tsere2b = 1461, e.tserehebrew = 1461, e.tserenarrowhebrew = 1461, e.tserequarterhebrew = 1461, e.tserewidehebrew = 1461, e.tshecyrillic = 1115, e.tsuperior = 63219, e.ttabengali = 2463, e.ttadeva = 2335, e.ttagujarati = 2719, e.ttagurmukhi = 2591, e.tteharabic = 1657, e.ttehfinalarabic = 64359, e.ttehinitialarabic = 64360, e.ttehmedialarabic = 64361, e.tthabengali = 2464, e.tthadeva = 2336, e.tthagujarati = 2720, e.tthagurmukhi = 2592, e.tturned = 647, e.tuhiragana = 12388, e.tukatakana = 12484, e.tukatakanahalfwidth = 65410, e.tusmallhiragana = 12387, e.tusmallkatakana = 12483, e.tusmallkatakanahalfwidth = 65391, e.twelvecircle = 9323, e.twelveparen = 9343, e.twelveperiod = 9363, e.twelveroman = 8571, e.twentycircle = 9331, e.twentyhangzhou = 21316, e.twentyparen = 9351, e.twentyperiod = 9371, e.two = 50, e.twoarabic = 1634, e.twobengali = 2536, e.twocircle = 9313, e.twocircleinversesansserif = 10123, e.twodeva = 2408, e.twodotenleader = 8229, e.twodotleader = 8229, e.twodotleadervertical = 65072, e.twogujarati = 2792, e.twogurmukhi = 2664, e.twohackarabic = 1634, e.twohangzhou = 12322, e.twoideographicparen = 12833, e.twoinferior = 8322, e.twomonospace = 65298, e.twonumeratorbengali = 2549, e.twooldstyle = 63282, e.twoparen = 9333, e.twoperiod = 9353, e.twopersian = 1778, e.tworoman = 8561, e.twostroke = 443, e.twosuperior = 178, e.twothai = 3666, e.twothirds = 8532, e.u = 117, e.uacute = 250, e.ubar = 649, e.ubengali = 2441, e.ubopomofo = 12584, e.ubreve = 365, e.ucaron = 468, e.ucircle = 9444, e.ucircumflex = 251, e.ucircumflexbelow = 7799, e.ucyrillic = 1091, e.udattadeva = 2385, e.udblacute = 369, e.udblgrave = 533, e.udeva = 2313, e.udieresis = 252, e.udieresisacute = 472, e.udieresisbelow = 7795, e.udieresiscaron = 474, e.udieresiscyrillic = 1265, e.udieresisgrave = 476, e.udieresismacron = 470, e.udotbelow = 7909, e.ugrave = 249, e.ugujarati = 2697, e.ugurmukhi = 2569, e.uhiragana = 12358, e.uhookabove = 7911, e.uhorn = 432, e.uhornacute = 7913, e.uhorndotbelow = 7921, e.uhorngrave = 7915, e.uhornhookabove = 7917, e.uhorntilde = 7919, e.uhungarumlaut = 369, e.uhungarumlautcyrillic = 1267, e.uinvertedbreve = 535, e.ukatakana = 12454, e.ukatakanahalfwidth = 65395, e.ukcyrillic = 1145, e.ukorean = 12636, e.umacron = 363, e.umacroncyrillic = 1263, e.umacrondieresis = 7803, e.umatragurmukhi = 2625, e.umonospace = 65365, e.underscore = 95, e.underscoredbl = 8215, e.underscoremonospace = 65343, e.underscorevertical = 65075, e.underscorewavy = 65103, e.union = 8746, e.universal = 8704, e.uogonek = 371, e.uparen = 9392, e.upblock = 9600, e.upperdothebrew = 1476, e.upsilon = 965, e.upsilondieresis = 971, e.upsilondieresistonos = 944, e.upsilonlatin = 650, e.upsilontonos = 973, e.uptackbelowcmb = 797, e.uptackmod = 724, e.uragurmukhi = 2675, e.uring = 367, e.ushortcyrillic = 1118, e.usmallhiragana = 12357, e.usmallkatakana = 12453, e.usmallkatakanahalfwidth = 65385, e.ustraightcyrillic = 1199, e.ustraightstrokecyrillic = 1201, e.utilde = 361, e.utildeacute = 7801, e.utildebelow = 7797, e.uubengali = 2442, e.uudeva = 2314, e.uugujarati = 2698, e.uugurmukhi = 2570, e.uumatragurmukhi = 2626, e.uuvowelsignbengali = 2498, e.uuvowelsigndeva = 2370, e.uuvowelsigngujarati = 2754, e.uvowelsignbengali = 2497, e.uvowelsigndeva = 2369, e.uvowelsigngujarati = 2753, e.v = 118, e.vadeva = 2357, e.vagujarati = 2741, e.vagurmukhi = 2613, e.vakatakana = 12535, e.vav = 1493, e.vavdagesh = 64309, e.vavdagesh65 = 64309, e.vavdageshhebrew = 64309, e.vavhebrew = 1493, e.vavholam = 64331, e.vavholamhebrew = 64331, e.vavvavhebrew = 1520, e.vavyodhebrew = 1521, e.vcircle = 9445, e.vdotbelow = 7807, e.vecyrillic = 1074, e.veharabic = 1700, e.vehfinalarabic = 64363, e.vehinitialarabic = 64364, e.vehmedialarabic = 64365, e.vekatakana = 12537, e.venus = 9792, e.verticalbar = 124, e.verticallineabovecmb = 781, e.verticallinebelowcmb = 809, e.verticallinelowmod = 716, e.verticallinemod = 712, e.vewarmenian = 1406, e.vhook = 651, e.vikatakana = 12536, e.viramabengali = 2509, e.viramadeva = 2381, e.viramagujarati = 2765, e.visargabengali = 2435, e.visargadeva = 2307, e.visargagujarati = 2691, e.vmonospace = 65366, e.voarmenian = 1400, e.voicediterationhiragana = 12446, e.voicediterationkatakana = 12542, e.voicedmarkkana = 12443, e.voicedmarkkanahalfwidth = 65438, e.vokatakana = 12538, e.vparen = 9393, e.vtilde = 7805, e.vturned = 652, e.vuhiragana = 12436, e.vukatakana = 12532, e.w = 119, e.wacute = 7811, e.waekorean = 12633, e.wahiragana = 12431, e.wakatakana = 12527, e.wakatakanahalfwidth = 65436, e.wakorean = 12632, e.wasmallhiragana = 12430, e.wasmallkatakana = 12526, e.wattosquare = 13143, e.wavedash = 12316, e.wavyunderscorevertical = 65076, e.wawarabic = 1608, e.wawfinalarabic = 65262, e.wawhamzaabovearabic = 1572, e.wawhamzaabovefinalarabic = 65158, e.wbsquare = 13277, e.wcircle = 9446, e.wcircumflex = 373, e.wdieresis = 7813, e.wdotaccent = 7815, e.wdotbelow = 7817, e.wehiragana = 12433, e.weierstrass = 8472, e.wekatakana = 12529, e.wekorean = 12638, e.weokorean = 12637, e.wgrave = 7809, e.whitebullet = 9702, e.whitecircle = 9675, e.whitecircleinverse = 9689, e.whitecornerbracketleft = 12302, e.whitecornerbracketleftvertical = 65091, e.whitecornerbracketright = 12303, e.whitecornerbracketrightvertical = 65092, e.whitediamond = 9671, e.whitediamondcontainingblacksmalldiamond = 9672, e.whitedownpointingsmalltriangle = 9663, e.whitedownpointingtriangle = 9661, e.whiteleftpointingsmalltriangle = 9667, e.whiteleftpointingtriangle = 9665, e.whitelenticularbracketleft = 12310, e.whitelenticularbracketright = 12311, e.whiterightpointingsmalltriangle = 9657, e.whiterightpointingtriangle = 9655, e.whitesmallsquare = 9643, e.whitesmilingface = 9786, e.whitesquare = 9633, e.whitestar = 9734, e.whitetelephone = 9743, e.whitetortoiseshellbracketleft = 12312, e.whitetortoiseshellbracketright = 12313, e.whiteuppointingsmalltriangle = 9653, e.whiteuppointingtriangle = 9651, e.wihiragana = 12432, e.wikatakana = 12528, e.wikorean = 12639, e.wmonospace = 65367, e.wohiragana = 12434, e.wokatakana = 12530, e.wokatakanahalfwidth = 65382, e.won = 8361, e.wonmonospace = 65510, e.wowaenthai = 3623, e.wparen = 9394, e.wring = 7832, e.wsuperior = 695, e.wturned = 653, e.wynn = 447, e.x = 120, e.xabovecmb = 829, e.xbopomofo = 12562, e.xcircle = 9447, e.xdieresis = 7821, e.xdotaccent = 7819, e.xeharmenian = 1389, e.xi = 958, e.xmonospace = 65368, e.xparen = 9395, e.xsuperior = 739, e.y = 121, e.yaadosquare = 13134, e.yabengali = 2479, e.yacute = 253, e.yadeva = 2351, e.yaekorean = 12626, e.yagujarati = 2735, e.yagurmukhi = 2607, e.yahiragana = 12420, e.yakatakana = 12516, e.yakatakanahalfwidth = 65428, e.yakorean = 12625, e.yamakkanthai = 3662, e.yasmallhiragana = 12419, e.yasmallkatakana = 12515, e.yasmallkatakanahalfwidth = 65388, e.yatcyrillic = 1123, e.ycircle = 9448, e.ycircumflex = 375, e.ydieresis = 255, e.ydotaccent = 7823, e.ydotbelow = 7925, e.yeharabic = 1610, e.yehbarreearabic = 1746, e.yehbarreefinalarabic = 64431, e.yehfinalarabic = 65266, e.yehhamzaabovearabic = 1574, e.yehhamzaabovefinalarabic = 65162, e.yehhamzaaboveinitialarabic = 65163, e.yehhamzaabovemedialarabic = 65164, e.yehinitialarabic = 65267, e.yehmedialarabic = 65268, e.yehmeeminitialarabic = 64733, e.yehmeemisolatedarabic = 64600, e.yehnoonfinalarabic = 64660, e.yehthreedotsbelowarabic = 1745, e.yekorean = 12630, e.yen = 165, e.yenmonospace = 65509, e.yeokorean = 12629, e.yeorinhieuhkorean = 12678, e.yerahbenyomohebrew = 1450, e.yerahbenyomolefthebrew = 1450, e.yericyrillic = 1099, e.yerudieresiscyrillic = 1273, e.yesieungkorean = 12673, e.yesieungpansioskorean = 12675, e.yesieungsioskorean = 12674, e.yetivhebrew = 1434, e.ygrave = 7923, e.yhook = 436, e.yhookabove = 7927, e.yiarmenian = 1397, e.yicyrillic = 1111, e.yikorean = 12642, e.yinyang = 9775, e.yiwnarmenian = 1410, e.ymonospace = 65369, e.yod = 1497, e.yoddagesh = 64313, e.yoddageshhebrew = 64313, e.yodhebrew = 1497, e.yodyodhebrew = 1522, e.yodyodpatahhebrew = 64287, e.yohiragana = 12424, e.yoikorean = 12681, e.yokatakana = 12520, e.yokatakanahalfwidth = 65430, e.yokorean = 12635, e.yosmallhiragana = 12423, e.yosmallkatakana = 12519, e.yosmallkatakanahalfwidth = 65390, e.yotgreek = 1011, e.yoyaekorean = 12680, e.yoyakorean = 12679, e.yoyakthai = 3618, e.yoyingthai = 3597, e.yparen = 9396, e.ypogegrammeni = 890, e.ypogegrammenigreekcmb = 837, e.yr = 422, e.yring = 7833, e.ysuperior = 696, e.ytilde = 7929, e.yturned = 654, e.yuhiragana = 12422, e.yuikorean = 12684, e.yukatakana = 12518, e.yukatakanahalfwidth = 65429, e.yukorean = 12640, e.yusbigcyrillic = 1131, e.yusbigiotifiedcyrillic = 1133, e.yuslittlecyrillic = 1127, e.yuslittleiotifiedcyrillic = 1129, e.yusmallhiragana = 12421, e.yusmallkatakana = 12517, e.yusmallkatakanahalfwidth = 65389, e.yuyekorean = 12683, e.yuyeokorean = 12682, e.yyabengali = 2527, e.yyadeva = 2399, e.z = 122, e.zaarmenian = 1382, e.zacute = 378, e.zadeva = 2395, e.zagurmukhi = 2651, e.zaharabic = 1592, e.zahfinalarabic = 65222, e.zahinitialarabic = 65223, e.zahiragana = 12374, e.zahmedialarabic = 65224, e.zainarabic = 1586, e.zainfinalarabic = 65200, e.zakatakana = 12470, e.zaqefgadolhebrew = 1429, e.zaqefqatanhebrew = 1428, e.zarqahebrew = 1432, e.zayin = 1494, e.zayindagesh = 64310, e.zayindageshhebrew = 64310, e.zayinhebrew = 1494, e.zbopomofo = 12567, e.zcaron = 382, e.zcircle = 9449, e.zcircumflex = 7825, e.zcurl = 657, e.zdot = 380, e.zdotaccent = 380, e.zdotbelow = 7827, e.zecyrillic = 1079, e.zedescendercyrillic = 1177, e.zedieresiscyrillic = 1247, e.zehiragana = 12380, e.zekatakana = 12476, e.zero = 48, e.zeroarabic = 1632, e.zerobengali = 2534, e.zerodeva = 2406, e.zerogujarati = 2790, e.zerogurmukhi = 2662, e.zerohackarabic = 1632, e.zeroinferior = 8320, e.zeromonospace = 65296, e.zerooldstyle = 63280, e.zeropersian = 1776, e.zerosuperior = 8304, e.zerothai = 3664, e.zerowidthjoiner = 65279, e.zerowidthnonjoiner = 8204, e.zerowidthspace = 8203, e.zeta = 950, e.zhbopomofo = 12563, e.zhearmenian = 1386, e.zhebrevecyrillic = 1218, e.zhecyrillic = 1078, e.zhedescendercyrillic = 1175, e.zhedieresiscyrillic = 1245, e.zihiragana = 12376, e.zikatakana = 12472, e.zinorhebrew = 1454, e.zlinebelow = 7829, e.zmonospace = 65370, e.zohiragana = 12382, e.zokatakana = 12478, e.zparen = 9397, e.zretroflexhook = 656, e.zstroke = 438, e.zuhiragana = 12378, e.zukatakana = 12474, e[".notdef"] = 0, e.angbracketleftbig = 9001, e.angbracketleftBig = 9001, e.angbracketleftbigg = 9001, e.angbracketleftBigg = 9001, e.angbracketrightBig = 9002, e.angbracketrightbig = 9002, e.angbracketrightBigg = 9002, e.angbracketrightbigg = 9002, e.arrowhookleft = 8618, e.arrowhookright = 8617, e.arrowlefttophalf = 8636, e.arrowleftbothalf = 8637, e.arrownortheast = 8599, e.arrownorthwest = 8598, e.arrowrighttophalf = 8640, e.arrowrightbothalf = 8641, e.arrowsoutheast = 8600, e.arrowsouthwest = 8601, e.backslashbig = 8726, e.backslashBig = 8726, e.backslashBigg = 8726, e.backslashbigg = 8726, e.bardbl = 8214, e.bracehtipdownleft = 65079, e.bracehtipdownright = 65079, e.bracehtipupleft = 65080, e.bracehtipupright = 65080, e.braceleftBig = 123, e.braceleftbig = 123, e.braceleftbigg = 123, e.braceleftBigg = 123, e.bracerightBig = 125, e.bracerightbig = 125, e.bracerightbigg = 125, e.bracerightBigg = 125, e.bracketleftbig = 91, e.bracketleftBig = 91, e.bracketleftbigg = 91, e.bracketleftBigg = 91, e.bracketrightBig = 93, e.bracketrightbig = 93, e.bracketrightbigg = 93, e.bracketrightBigg = 93, e.ceilingleftbig = 8968, e.ceilingleftBig = 8968, e.ceilingleftBigg = 8968, e.ceilingleftbigg = 8968, e.ceilingrightbig = 8969, e.ceilingrightBig = 8969, e.ceilingrightbigg = 8969, e.ceilingrightBigg = 8969, e.circledotdisplay = 8857, e.circledottext = 8857, e.circlemultiplydisplay = 8855, e.circlemultiplytext = 8855, e.circleplusdisplay = 8853, e.circleplustext = 8853, e.contintegraldisplay = 8750, e.contintegraltext = 8750, e.coproductdisplay = 8720, e.coproducttext = 8720, e.floorleftBig = 8970, e.floorleftbig = 8970, e.floorleftbigg = 8970, e.floorleftBigg = 8970, e.floorrightbig = 8971, e.floorrightBig = 8971, e.floorrightBigg = 8971, e.floorrightbigg = 8971, e.hatwide = 770, e.hatwider = 770, e.hatwidest = 770, e.intercal = 7488, e.integraldisplay = 8747, e.integraltext = 8747, e.intersectiondisplay = 8898, e.intersectiontext = 8898, e.logicalanddisplay = 8743, e.logicalandtext = 8743, e.logicalordisplay = 8744, e.logicalortext = 8744, e.parenleftBig = 40, e.parenleftbig = 40, e.parenleftBigg = 40, e.parenleftbigg = 40, e.parenrightBig = 41, e.parenrightbig = 41, e.parenrightBigg = 41, e.parenrightbigg = 41, e.prime = 8242, e.productdisplay = 8719, e.producttext = 8719, e.radicalbig = 8730, e.radicalBig = 8730, e.radicalBigg = 8730, e.radicalbigg = 8730, e.radicalbt = 8730, e.radicaltp = 8730, e.radicalvertex = 8730, e.slashbig = 47, e.slashBig = 47, e.slashBigg = 47, e.slashbigg = 47, e.summationdisplay = 8721, e.summationtext = 8721, e.tildewide = 732, e.tildewider = 732, e.tildewidest = 732, e.uniondisplay = 8899, e.unionmultidisplay = 8846, e.unionmultitext = 8846, e.unionsqdisplay = 8852, e.unionsqtext = 8852, e.uniontext = 8899, e.vextenddouble = 8741, e.vextendsingle = 8739;
          }), q = (0, n.getLookupTableFactory)(function(e) {
            e.space = 32, e.a1 = 9985, e.a2 = 9986, e.a202 = 9987, e.a3 = 9988, e.a4 = 9742, e.a5 = 9990, e.a119 = 9991, e.a118 = 9992, e.a117 = 9993, e.a11 = 9755, e.a12 = 9758, e.a13 = 9996, e.a14 = 9997, e.a15 = 9998, e.a16 = 9999, e.a105 = 1e4, e.a17 = 10001, e.a18 = 10002, e.a19 = 10003, e.a20 = 10004, e.a21 = 10005, e.a22 = 10006, e.a23 = 10007, e.a24 = 10008, e.a25 = 10009, e.a26 = 10010, e.a27 = 10011, e.a28 = 10012, e.a6 = 10013, e.a7 = 10014, e.a8 = 10015, e.a9 = 10016, e.a10 = 10017, e.a29 = 10018, e.a30 = 10019, e.a31 = 10020, e.a32 = 10021, e.a33 = 10022, e.a34 = 10023, e.a35 = 9733, e.a36 = 10025, e.a37 = 10026, e.a38 = 10027, e.a39 = 10028, e.a40 = 10029, e.a41 = 10030, e.a42 = 10031, e.a43 = 10032, e.a44 = 10033, e.a45 = 10034, e.a46 = 10035, e.a47 = 10036, e.a48 = 10037, e.a49 = 10038, e.a50 = 10039, e.a51 = 10040, e.a52 = 10041, e.a53 = 10042, e.a54 = 10043, e.a55 = 10044, e.a56 = 10045, e.a57 = 10046, e.a58 = 10047, e.a59 = 10048, e.a60 = 10049, e.a61 = 10050, e.a62 = 10051, e.a63 = 10052, e.a64 = 10053, e.a65 = 10054, e.a66 = 10055, e.a67 = 10056, e.a68 = 10057, e.a69 = 10058, e.a70 = 10059, e.a71 = 9679, e.a72 = 10061, e.a73 = 9632, e.a74 = 10063, e.a203 = 10064, e.a75 = 10065, e.a204 = 10066, e.a76 = 9650, e.a77 = 9660, e.a78 = 9670, e.a79 = 10070, e.a81 = 9687, e.a82 = 10072, e.a83 = 10073, e.a84 = 10074, e.a97 = 10075, e.a98 = 10076, e.a99 = 10077, e.a100 = 10078, e.a101 = 10081, e.a102 = 10082, e.a103 = 10083, e.a104 = 10084, e.a106 = 10085, e.a107 = 10086, e.a108 = 10087, e.a112 = 9827, e.a111 = 9830, e.a110 = 9829, e.a109 = 9824, e.a120 = 9312, e.a121 = 9313, e.a122 = 9314, e.a123 = 9315, e.a124 = 9316, e.a125 = 9317, e.a126 = 9318, e.a127 = 9319, e.a128 = 9320, e.a129 = 9321, e.a130 = 10102, e.a131 = 10103, e.a132 = 10104, e.a133 = 10105, e.a134 = 10106, e.a135 = 10107, e.a136 = 10108, e.a137 = 10109, e.a138 = 10110, e.a139 = 10111, e.a140 = 10112, e.a141 = 10113, e.a142 = 10114, e.a143 = 10115, e.a144 = 10116, e.a145 = 10117, e.a146 = 10118, e.a147 = 10119, e.a148 = 10120, e.a149 = 10121, e.a150 = 10122, e.a151 = 10123, e.a152 = 10124, e.a153 = 10125, e.a154 = 10126, e.a155 = 10127, e.a156 = 10128, e.a157 = 10129, e.a158 = 10130, e.a159 = 10131, e.a160 = 10132, e.a161 = 8594, e.a163 = 8596, e.a164 = 8597, e.a196 = 10136, e.a165 = 10137, e.a192 = 10138, e.a166 = 10139, e.a167 = 10140, e.a168 = 10141, e.a169 = 10142, e.a170 = 10143, e.a171 = 10144, e.a172 = 10145, e.a173 = 10146, e.a162 = 10147, e.a174 = 10148, e.a175 = 10149, e.a176 = 10150, e.a177 = 10151, e.a178 = 10152, e.a179 = 10153, e.a193 = 10154, e.a180 = 10155, e.a199 = 10156, e.a181 = 10157, e.a200 = 10158, e.a182 = 10159, e.a201 = 10161, e.a183 = 10162, e.a184 = 10163, e.a197 = 10164, e.a185 = 10165, e.a194 = 10166, e.a198 = 10167, e.a186 = 10168, e.a195 = 10169, e.a187 = 10170, e.a188 = 10171, e.a189 = 10172, e.a190 = 10173, e.a191 = 10174, e.a89 = 10088, e.a90 = 10089, e.a93 = 10090, e.a94 = 10091, e.a91 = 10092, e.a92 = 10093, e.a205 = 10094, e.a85 = 10095, e.a206 = 10096, e.a86 = 10097, e.a87 = 10098, e.a88 = 10099, e.a95 = 10100, e.a96 = 10101, e[".notdef"] = 0;
          });
        },
        /* 40 */
        /***/
        (xe, F, ae) => {
          ae.r(F), ae.d(F, {
            /* harmony export */
            clearUnicodeCaches: () => (
              /* binding */
              w
            ),
            /* harmony export */
            getCharUnicodeCategory: () => (
              /* binding */
              O
            ),
            /* harmony export */
            getUnicodeForGlyph: () => (
              /* binding */
              e
            ),
            /* harmony export */
            getUnicodeRangeFor: () => (
              /* binding */
              B
            ),
            /* harmony export */
            mapSpecialUnicodeValues: () => (
              /* binding */
              q
            )
            /* harmony export */
          });
          var n = ae(3);
          const u = (0, n.getLookupTableFactory)(function(C) {
            C[63721] = 169, C[63193] = 169, C[63720] = 174, C[63194] = 174, C[63722] = 8482, C[63195] = 8482, C[63729] = 9127, C[63730] = 9128, C[63731] = 9129, C[63740] = 9131, C[63741] = 9132, C[63742] = 9133, C[63726] = 9121, C[63727] = 9122, C[63728] = 9123, C[63737] = 9124, C[63738] = 9125, C[63739] = 9126, C[63723] = 9115, C[63724] = 9116, C[63725] = 9117, C[63734] = 9118, C[63735] = 9119, C[63736] = 9120;
          });
          function q(C) {
            return C >= 65520 && C <= 65535 ? 0 : C >= 62976 && C <= 63743 ? u()[C] || C : C === 173 ? 45 : C;
          }
          function e(C, i) {
            let o = i[C];
            if (o !== void 0)
              return o;
            if (!C)
              return -1;
            if (C[0] === "u") {
              const k = C.length;
              let s;
              if (k === 7 && C[1] === "n" && C[2] === "i")
                s = C.substring(3);
              else if (k >= 5 && k <= 7)
                s = C.substring(1);
              else
                return -1;
              if (s === s.toUpperCase() && (o = parseInt(s, 16), o >= 0))
                return o;
            }
            return -1;
          }
          const t = [
            [
              0,
              127
            ],
            [
              128,
              255
            ],
            [
              256,
              383
            ],
            [
              384,
              591
            ],
            [
              592,
              687,
              7424,
              7551,
              7552,
              7615
            ],
            [
              688,
              767,
              42752,
              42783
            ],
            [
              768,
              879,
              7616,
              7679
            ],
            [
              880,
              1023
            ],
            [
              11392,
              11519
            ],
            [
              1024,
              1279,
              1280,
              1327,
              11744,
              11775,
              42560,
              42655
            ],
            [
              1328,
              1423
            ],
            [
              1424,
              1535
            ],
            [
              42240,
              42559
            ],
            [
              1536,
              1791,
              1872,
              1919
            ],
            [
              1984,
              2047
            ],
            [
              2304,
              2431
            ],
            [
              2432,
              2559
            ],
            [
              2560,
              2687
            ],
            [
              2688,
              2815
            ],
            [
              2816,
              2943
            ],
            [
              2944,
              3071
            ],
            [
              3072,
              3199
            ],
            [
              3200,
              3327
            ],
            [
              3328,
              3455
            ],
            [
              3584,
              3711
            ],
            [
              3712,
              3839
            ],
            [
              4256,
              4351,
              11520,
              11567
            ],
            [
              6912,
              7039
            ],
            [
              4352,
              4607
            ],
            [
              7680,
              7935,
              11360,
              11391,
              42784,
              43007
            ],
            [
              7936,
              8191
            ],
            [
              8192,
              8303,
              11776,
              11903
            ],
            [
              8304,
              8351
            ],
            [
              8352,
              8399
            ],
            [
              8400,
              8447
            ],
            [
              8448,
              8527
            ],
            [
              8528,
              8591
            ],
            [
              8592,
              8703,
              10224,
              10239,
              10496,
              10623,
              11008,
              11263
            ],
            [
              8704,
              8959,
              10752,
              11007,
              10176,
              10223,
              10624,
              10751
            ],
            [
              8960,
              9215
            ],
            [
              9216,
              9279
            ],
            [
              9280,
              9311
            ],
            [
              9312,
              9471
            ],
            [
              9472,
              9599
            ],
            [
              9600,
              9631
            ],
            [
              9632,
              9727
            ],
            [
              9728,
              9983
            ],
            [
              9984,
              10175
            ],
            [
              12288,
              12351
            ],
            [
              12352,
              12447
            ],
            [
              12448,
              12543,
              12784,
              12799
            ],
            [
              12544,
              12591,
              12704,
              12735
            ],
            [
              12592,
              12687
            ],
            [
              43072,
              43135
            ],
            [
              12800,
              13055
            ],
            [
              13056,
              13311
            ],
            [
              44032,
              55215
            ],
            [
              55296,
              57343
            ],
            [
              67840,
              67871
            ],
            [
              19968,
              40959,
              11904,
              12031,
              12032,
              12255,
              12272,
              12287,
              13312,
              19903,
              131072,
              173791,
              12688,
              12703
            ],
            [
              57344,
              63743
            ],
            [
              12736,
              12783,
              63744,
              64255,
              194560,
              195103
            ],
            [
              64256,
              64335
            ],
            [
              64336,
              65023
            ],
            [
              65056,
              65071
            ],
            [
              65040,
              65055
            ],
            [
              65104,
              65135
            ],
            [
              65136,
              65279
            ],
            [
              65280,
              65519
            ],
            [
              65520,
              65535
            ],
            [
              3840,
              4095
            ],
            [
              1792,
              1871
            ],
            [
              1920,
              1983
            ],
            [
              3456,
              3583
            ],
            [
              4096,
              4255
            ],
            [
              4608,
              4991,
              4992,
              5023,
              11648,
              11743
            ],
            [
              5024,
              5119
            ],
            [
              5120,
              5759
            ],
            [
              5760,
              5791
            ],
            [
              5792,
              5887
            ],
            [
              6016,
              6143
            ],
            [
              6144,
              6319
            ],
            [
              10240,
              10495
            ],
            [
              40960,
              42127
            ],
            [
              5888,
              5919,
              5920,
              5951,
              5952,
              5983,
              5984,
              6015
            ],
            [
              66304,
              66351
            ],
            [
              66352,
              66383
            ],
            [
              66560,
              66639
            ],
            [
              118784,
              119039,
              119040,
              119295,
              119296,
              119375
            ],
            [
              119808,
              120831
            ],
            [
              1044480,
              1048573
            ],
            [
              65024,
              65039,
              917760,
              917999
            ],
            [
              917504,
              917631
            ],
            [
              6400,
              6479
            ],
            [
              6480,
              6527
            ],
            [
              6528,
              6623
            ],
            [
              6656,
              6687
            ],
            [
              11264,
              11359
            ],
            [
              11568,
              11647
            ],
            [
              19904,
              19967
            ],
            [
              43008,
              43055
            ],
            [
              65536,
              65663,
              65664,
              65791,
              65792,
              65855
            ],
            [
              65856,
              65935
            ],
            [
              66432,
              66463
            ],
            [
              66464,
              66527
            ],
            [
              66640,
              66687
            ],
            [
              66688,
              66735
            ],
            [
              67584,
              67647
            ],
            [
              68096,
              68191
            ],
            [
              119552,
              119647
            ],
            [
              73728,
              74751,
              74752,
              74879
            ],
            [
              119648,
              119679
            ],
            [
              7040,
              7103
            ],
            [
              7168,
              7247
            ],
            [
              7248,
              7295
            ],
            [
              43136,
              43231
            ],
            [
              43264,
              43311
            ],
            [
              43312,
              43359
            ],
            [
              43520,
              43615
            ],
            [
              65936,
              65999
            ],
            [
              66e3,
              66047
            ],
            [
              66208,
              66271,
              66176,
              66207,
              67872,
              67903
            ],
            [
              127024,
              127135,
              126976,
              127023
            ]
          ];
          function B(C, i = -1) {
            if (i !== -1) {
              const o = t[i];
              for (let k = 0, s = o.length; k < s; k += 2)
                if (C >= o[k] && C <= o[k + 1])
                  return i;
            }
            for (let o = 0, k = t.length; o < k; o++) {
              const s = t[o];
              for (let l = 0, g = s.length; l < g; l += 2)
                if (C >= s[l] && C <= s[l + 1])
                  return o;
            }
            return -1;
          }
          const j = new RegExp("^(\\s)|(\\p{Mn})|(\\p{Cf})$", "u"), M = /* @__PURE__ */ new Map();
          function O(C) {
            const i = M.get(C);
            if (i)
              return i;
            const o = C.match(j), k = {
              isWhitespace: !!(o != null && o[1]),
              isZeroWidthDiacritic: !!(o != null && o[2]),
              isInvisibleFormatMark: !!(o != null && o[3])
            };
            return M.set(C, k), k;
          }
          function w() {
            M.clear();
          }
        },
        /* 41 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.getSerifFonts = F.getNonStdFontMap = F.getGlyphMapForStandardFonts = F.getFontNameToFileMap = void 0, F.getStandardFontName = C, F.getSymbolsFonts = F.getSupplementalGlyphMapForCalibri = F.getSupplementalGlyphMapForArialBlack = F.getStdFontMap = void 0;
          var n = ae(3), u = ae(38);
          const q = (0, n.getLookupTableFactory)(function(i) {
            i["Times-Roman"] = "Times-Roman", i.Helvetica = "Helvetica", i.Courier = "Courier", i.Symbol = "Symbol", i["Times-Bold"] = "Times-Bold", i["Helvetica-Bold"] = "Helvetica-Bold", i["Courier-Bold"] = "Courier-Bold", i.ZapfDingbats = "ZapfDingbats", i["Times-Italic"] = "Times-Italic", i["Helvetica-Oblique"] = "Helvetica-Oblique", i["Courier-Oblique"] = "Courier-Oblique", i["Times-BoldItalic"] = "Times-BoldItalic", i["Helvetica-BoldOblique"] = "Helvetica-BoldOblique", i["Courier-BoldOblique"] = "Courier-BoldOblique", i.ArialNarrow = "Helvetica", i["ArialNarrow-Bold"] = "Helvetica-Bold", i["ArialNarrow-BoldItalic"] = "Helvetica-BoldOblique", i["ArialNarrow-Italic"] = "Helvetica-Oblique", i.ArialBlack = "Helvetica", i["ArialBlack-Bold"] = "Helvetica-Bold", i["ArialBlack-BoldItalic"] = "Helvetica-BoldOblique", i["ArialBlack-Italic"] = "Helvetica-Oblique", i["Arial-Black"] = "Helvetica", i["Arial-Black-Bold"] = "Helvetica-Bold", i["Arial-Black-BoldItalic"] = "Helvetica-BoldOblique", i["Arial-Black-Italic"] = "Helvetica-Oblique", i.Arial = "Helvetica", i["Arial-Bold"] = "Helvetica-Bold", i["Arial-BoldItalic"] = "Helvetica-BoldOblique", i["Arial-Italic"] = "Helvetica-Oblique", i.ArialMT = "Helvetica", i["Arial-BoldItalicMT"] = "Helvetica-BoldOblique", i["Arial-BoldMT"] = "Helvetica-Bold", i["Arial-ItalicMT"] = "Helvetica-Oblique", i["Arial-BoldItalicMT-BoldItalic"] = "Helvetica-BoldOblique", i["Arial-BoldMT-Bold"] = "Helvetica-Bold", i["Arial-ItalicMT-Italic"] = "Helvetica-Oblique", i.ArialUnicodeMS = "Helvetica", i["ArialUnicodeMS-Bold"] = "Helvetica-Bold", i["ArialUnicodeMS-BoldItalic"] = "Helvetica-BoldOblique", i["ArialUnicodeMS-Italic"] = "Helvetica-Oblique", i["Courier-BoldItalic"] = "Courier-BoldOblique", i["Courier-Italic"] = "Courier-Oblique", i.CourierNew = "Courier", i["CourierNew-Bold"] = "Courier-Bold", i["CourierNew-BoldItalic"] = "Courier-BoldOblique", i["CourierNew-Italic"] = "Courier-Oblique", i["CourierNewPS-BoldItalicMT"] = "Courier-BoldOblique", i["CourierNewPS-BoldMT"] = "Courier-Bold", i["CourierNewPS-ItalicMT"] = "Courier-Oblique", i.CourierNewPSMT = "Courier", i["Helvetica-BoldItalic"] = "Helvetica-BoldOblique", i["Helvetica-Italic"] = "Helvetica-Oblique", i["Symbol-Bold"] = "Symbol", i["Symbol-BoldItalic"] = "Symbol", i["Symbol-Italic"] = "Symbol", i.TimesNewRoman = "Times-Roman", i["TimesNewRoman-Bold"] = "Times-Bold", i["TimesNewRoman-BoldItalic"] = "Times-BoldItalic", i["TimesNewRoman-Italic"] = "Times-Italic", i.TimesNewRomanPS = "Times-Roman", i["TimesNewRomanPS-Bold"] = "Times-Bold", i["TimesNewRomanPS-BoldItalic"] = "Times-BoldItalic", i["TimesNewRomanPS-BoldItalicMT"] = "Times-BoldItalic", i["TimesNewRomanPS-BoldMT"] = "Times-Bold", i["TimesNewRomanPS-Italic"] = "Times-Italic", i["TimesNewRomanPS-ItalicMT"] = "Times-Italic", i.TimesNewRomanPSMT = "Times-Roman", i["TimesNewRomanPSMT-Bold"] = "Times-Bold", i["TimesNewRomanPSMT-BoldItalic"] = "Times-BoldItalic", i["TimesNewRomanPSMT-Italic"] = "Times-Italic";
          });
          F.getStdFontMap = q;
          const e = (0, n.getLookupTableFactory)(function(i) {
            i.Courier = "FoxitFixed.pfb", i["Courier-Bold"] = "FoxitFixedBold.pfb", i["Courier-BoldOblique"] = "FoxitFixedBoldItalic.pfb", i["Courier-Oblique"] = "FoxitFixedItalic.pfb", i.Helvetica = "LiberationSans-Regular.ttf", i["Helvetica-Bold"] = "LiberationSans-Bold.ttf", i["Helvetica-BoldOblique"] = "LiberationSans-BoldItalic.ttf", i["Helvetica-Oblique"] = "LiberationSans-Italic.ttf", i["Times-Roman"] = "FoxitSerif.pfb", i["Times-Bold"] = "FoxitSerifBold.pfb", i["Times-BoldItalic"] = "FoxitSerifBoldItalic.pfb", i["Times-Italic"] = "FoxitSerifItalic.pfb", i.Symbol = "FoxitSymbol.pfb", i.ZapfDingbats = "FoxitDingbats.pfb", i["LiberationSans-Regular"] = "LiberationSans-Regular.ttf", i["LiberationSans-Bold"] = "LiberationSans-Bold.ttf", i["LiberationSans-Italic"] = "LiberationSans-Italic.ttf", i["LiberationSans-BoldItalic"] = "LiberationSans-BoldItalic.ttf";
          });
          F.getFontNameToFileMap = e;
          const t = (0, n.getLookupTableFactory)(function(i) {
            i.Calibri = "Helvetica", i["Calibri-Bold"] = "Helvetica-Bold", i["Calibri-BoldItalic"] = "Helvetica-BoldOblique", i["Calibri-Italic"] = "Helvetica-Oblique", i.CenturyGothic = "Helvetica", i["CenturyGothic-Bold"] = "Helvetica-Bold", i["CenturyGothic-BoldItalic"] = "Helvetica-BoldOblique", i["CenturyGothic-Italic"] = "Helvetica-Oblique", i.ComicSansMS = "Comic Sans MS", i["ComicSansMS-Bold"] = "Comic Sans MS-Bold", i["ComicSansMS-BoldItalic"] = "Comic Sans MS-BoldItalic", i["ComicSansMS-Italic"] = "Comic Sans MS-Italic", i.Impact = "Helvetica", i["ItcSymbol-Bold"] = "Helvetica-Bold", i["ItcSymbol-BoldItalic"] = "Helvetica-BoldOblique", i["ItcSymbol-Book"] = "Helvetica", i["ItcSymbol-BookItalic"] = "Helvetica-Oblique", i["ItcSymbol-Medium"] = "Helvetica", i["ItcSymbol-MediumItalic"] = "Helvetica-Oblique", i.LucidaConsole = "Courier", i["LucidaConsole-Bold"] = "Courier-Bold", i["LucidaConsole-BoldItalic"] = "Courier-BoldOblique", i["LucidaConsole-Italic"] = "Courier-Oblique", i["LucidaSans-Demi"] = "Helvetica-Bold", i["MS-Gothic"] = "MS Gothic", i["MS-Gothic-Bold"] = "MS Gothic-Bold", i["MS-Gothic-BoldItalic"] = "MS Gothic-BoldItalic", i["MS-Gothic-Italic"] = "MS Gothic-Italic", i["MS-Mincho"] = "MS Mincho", i["MS-Mincho-Bold"] = "MS Mincho-Bold", i["MS-Mincho-BoldItalic"] = "MS Mincho-BoldItalic", i["MS-Mincho-Italic"] = "MS Mincho-Italic", i["MS-PGothic"] = "MS PGothic", i["MS-PGothic-Bold"] = "MS PGothic-Bold", i["MS-PGothic-BoldItalic"] = "MS PGothic-BoldItalic", i["MS-PGothic-Italic"] = "MS PGothic-Italic", i["MS-PMincho"] = "MS PMincho", i["MS-PMincho-Bold"] = "MS PMincho-Bold", i["MS-PMincho-BoldItalic"] = "MS PMincho-BoldItalic", i["MS-PMincho-Italic"] = "MS PMincho-Italic", i.NuptialScript = "Times-Italic", i.SegoeUISymbol = "Helvetica";
          });
          F.getNonStdFontMap = t;
          const B = (0, n.getLookupTableFactory)(function(i) {
            i["Adobe Jenson"] = !0, i["Adobe Text"] = !0, i.Albertus = !0, i.Aldus = !0, i.Alexandria = !0, i.Algerian = !0, i["American Typewriter"] = !0, i.Antiqua = !0, i.Apex = !0, i.Arno = !0, i.Aster = !0, i.Aurora = !0, i.Baskerville = !0, i.Bell = !0, i.Bembo = !0, i["Bembo Schoolbook"] = !0, i.Benguiat = !0, i["Berkeley Old Style"] = !0, i["Bernhard Modern"] = !0, i["Berthold City"] = !0, i.Bodoni = !0, i["Bauer Bodoni"] = !0, i["Book Antiqua"] = !0, i.Bookman = !0, i["Bordeaux Roman"] = !0, i["Californian FB"] = !0, i.Calisto = !0, i.Calvert = !0, i.Capitals = !0, i.Cambria = !0, i.Cartier = !0, i.Caslon = !0, i.Catull = !0, i.Centaur = !0, i["Century Old Style"] = !0, i["Century Schoolbook"] = !0, i.Chaparral = !0, i["Charis SIL"] = !0, i.Cheltenham = !0, i["Cholla Slab"] = !0, i.Clarendon = !0, i.Clearface = !0, i.Cochin = !0, i.Colonna = !0, i["Computer Modern"] = !0, i["Concrete Roman"] = !0, i.Constantia = !0, i["Cooper Black"] = !0, i.Corona = !0, i.Ecotype = !0, i.Egyptienne = !0, i.Elephant = !0, i.Excelsior = !0, i.Fairfield = !0, i["FF Scala"] = !0, i.Folkard = !0, i.Footlight = !0, i.FreeSerif = !0, i["Friz Quadrata"] = !0, i.Garamond = !0, i.Gentium = !0, i.Georgia = !0, i.Gloucester = !0, i["Goudy Old Style"] = !0, i["Goudy Schoolbook"] = !0, i["Goudy Pro Font"] = !0, i.Granjon = !0, i["Guardian Egyptian"] = !0, i.Heather = !0, i.Hercules = !0, i["High Tower Text"] = !0, i.Hiroshige = !0, i["Hoefler Text"] = !0, i["Humana Serif"] = !0, i.Imprint = !0, i["Ionic No. 5"] = !0, i.Janson = !0, i.Joanna = !0, i.Korinna = !0, i.Lexicon = !0, i.LiberationSerif = !0, i["Liberation Serif"] = !0, i["Linux Libertine"] = !0, i.Literaturnaya = !0, i.Lucida = !0, i["Lucida Bright"] = !0, i.Melior = !0, i.Memphis = !0, i.Miller = !0, i.Minion = !0, i.Modern = !0, i["Mona Lisa"] = !0, i["Mrs Eaves"] = !0, i["MS Serif"] = !0, i["Museo Slab"] = !0, i["New York"] = !0, i["Nimbus Roman"] = !0, i["NPS Rawlinson Roadway"] = !0, i.NuptialScript = !0, i.Palatino = !0, i.Perpetua = !0, i.Plantin = !0, i["Plantin Schoolbook"] = !0, i.Playbill = !0, i["Poor Richard"] = !0, i["Rawlinson Roadway"] = !0, i.Renault = !0, i.Requiem = !0, i.Rockwell = !0, i.Roman = !0, i["Rotis Serif"] = !0, i.Sabon = !0, i.Scala = !0, i.Seagull = !0, i.Sistina = !0, i.Souvenir = !0, i.STIX = !0, i["Stone Informal"] = !0, i["Stone Serif"] = !0, i.Sylfaen = !0, i.Times = !0, i.Trajan = !0, i.Trinité = !0, i["Trump Mediaeval"] = !0, i.Utopia = !0, i["Vale Type"] = !0, i["Bitstream Vera"] = !0, i["Vera Serif"] = !0, i.Versailles = !0, i.Wanted = !0, i.Weiss = !0, i["Wide Latin"] = !0, i.Windsor = !0, i.XITS = !0;
          });
          F.getSerifFonts = B;
          const j = (0, n.getLookupTableFactory)(function(i) {
            i.Dingbats = !0, i.Symbol = !0, i.ZapfDingbats = !0;
          });
          F.getSymbolsFonts = j;
          const M = (0, n.getLookupTableFactory)(function(i) {
            i[2] = 10, i[3] = 32, i[4] = 33, i[5] = 34, i[6] = 35, i[7] = 36, i[8] = 37, i[9] = 38, i[10] = 39, i[11] = 40, i[12] = 41, i[13] = 42, i[14] = 43, i[15] = 44, i[16] = 45, i[17] = 46, i[18] = 47, i[19] = 48, i[20] = 49, i[21] = 50, i[22] = 51, i[23] = 52, i[24] = 53, i[25] = 54, i[26] = 55, i[27] = 56, i[28] = 57, i[29] = 58, i[30] = 894, i[31] = 60, i[32] = 61, i[33] = 62, i[34] = 63, i[35] = 64, i[36] = 65, i[37] = 66, i[38] = 67, i[39] = 68, i[40] = 69, i[41] = 70, i[42] = 71, i[43] = 72, i[44] = 73, i[45] = 74, i[46] = 75, i[47] = 76, i[48] = 77, i[49] = 78, i[50] = 79, i[51] = 80, i[52] = 81, i[53] = 82, i[54] = 83, i[55] = 84, i[56] = 85, i[57] = 86, i[58] = 87, i[59] = 88, i[60] = 89, i[61] = 90, i[62] = 91, i[63] = 92, i[64] = 93, i[65] = 94, i[66] = 95, i[67] = 96, i[68] = 97, i[69] = 98, i[70] = 99, i[71] = 100, i[72] = 101, i[73] = 102, i[74] = 103, i[75] = 104, i[76] = 105, i[77] = 106, i[78] = 107, i[79] = 108, i[80] = 109, i[81] = 110, i[82] = 111, i[83] = 112, i[84] = 113, i[85] = 114, i[86] = 115, i[87] = 116, i[88] = 117, i[89] = 118, i[90] = 119, i[91] = 120, i[92] = 121, i[93] = 122, i[94] = 123, i[95] = 124, i[96] = 125, i[97] = 126, i[98] = 196, i[99] = 197, i[100] = 199, i[101] = 201, i[102] = 209, i[103] = 214, i[104] = 220, i[105] = 225, i[106] = 224, i[107] = 226, i[108] = 228, i[109] = 227, i[110] = 229, i[111] = 231, i[112] = 233, i[113] = 232, i[114] = 234, i[115] = 235, i[116] = 237, i[117] = 236, i[118] = 238, i[119] = 239, i[120] = 241, i[121] = 243, i[122] = 242, i[123] = 244, i[124] = 246, i[125] = 245, i[126] = 250, i[127] = 249, i[128] = 251, i[129] = 252, i[130] = 8224, i[131] = 176, i[132] = 162, i[133] = 163, i[134] = 167, i[135] = 8226, i[136] = 182, i[137] = 223, i[138] = 174, i[139] = 169, i[140] = 8482, i[141] = 180, i[142] = 168, i[143] = 8800, i[144] = 198, i[145] = 216, i[146] = 8734, i[147] = 177, i[148] = 8804, i[149] = 8805, i[150] = 165, i[151] = 181, i[152] = 8706, i[153] = 8721, i[154] = 8719, i[156] = 8747, i[157] = 170, i[158] = 186, i[159] = 8486, i[160] = 230, i[161] = 248, i[162] = 191, i[163] = 161, i[164] = 172, i[165] = 8730, i[166] = 402, i[167] = 8776, i[168] = 8710, i[169] = 171, i[170] = 187, i[171] = 8230, i[179] = 8220, i[180] = 8221, i[181] = 8216, i[182] = 8217, i[200] = 193, i[203] = 205, i[207] = 211, i[210] = 218, i[223] = 711, i[224] = 321, i[225] = 322, i[226] = 352, i[227] = 353, i[228] = 381, i[229] = 382, i[233] = 221, i[234] = 253, i[252] = 263, i[253] = 268, i[254] = 269, i[258] = 258, i[260] = 260, i[261] = 261, i[265] = 280, i[266] = 281, i[267] = 282, i[268] = 283, i[269] = 313, i[275] = 323, i[276] = 324, i[278] = 328, i[283] = 344, i[284] = 345, i[285] = 346, i[286] = 347, i[292] = 367, i[295] = 377, i[296] = 378, i[298] = 380, i[305] = 963, i[306] = 964, i[307] = 966, i[308] = 8215, i[309] = 8252, i[310] = 8319, i[311] = 8359, i[312] = 8592, i[313] = 8593, i[337] = 9552, i[493] = 1039, i[494] = 1040, i[672] = 1488, i[673] = 1489, i[674] = 1490, i[675] = 1491, i[676] = 1492, i[677] = 1493, i[678] = 1494, i[679] = 1495, i[680] = 1496, i[681] = 1497, i[682] = 1498, i[683] = 1499, i[684] = 1500, i[685] = 1501, i[686] = 1502, i[687] = 1503, i[688] = 1504, i[689] = 1505, i[690] = 1506, i[691] = 1507, i[692] = 1508, i[693] = 1509, i[694] = 1510, i[695] = 1511, i[696] = 1512, i[697] = 1513, i[698] = 1514, i[705] = 1524, i[706] = 8362, i[710] = 64288, i[711] = 64298, i[759] = 1617, i[761] = 1776, i[763] = 1778, i[775] = 1652, i[777] = 1764, i[778] = 1780, i[779] = 1781, i[780] = 1782, i[782] = 771, i[783] = 64726, i[786] = 8363, i[788] = 8532, i[790] = 768, i[791] = 769, i[792] = 768, i[795] = 803, i[797] = 64336, i[798] = 64337, i[799] = 64342, i[800] = 64343, i[801] = 64344, i[802] = 64345, i[803] = 64362, i[804] = 64363, i[805] = 64364, i[2424] = 7821, i[2425] = 7822, i[2426] = 7823, i[2427] = 7824, i[2428] = 7825, i[2429] = 7826, i[2430] = 7827, i[2433] = 7682, i[2678] = 8045, i[2679] = 8046, i[2830] = 1552, i[2838] = 686, i[2840] = 751, i[2842] = 753, i[2843] = 754, i[2844] = 755, i[2846] = 757, i[2856] = 767, i[2857] = 848, i[2858] = 849, i[2862] = 853, i[2863] = 854, i[2864] = 855, i[2865] = 861, i[2866] = 862, i[2906] = 7460, i[2908] = 7462, i[2909] = 7463, i[2910] = 7464, i[2912] = 7466, i[2913] = 7467, i[2914] = 7468, i[2916] = 7470, i[2917] = 7471, i[2918] = 7472, i[2920] = 7474, i[2921] = 7475, i[2922] = 7476, i[2924] = 7478, i[2925] = 7479, i[2926] = 7480, i[2928] = 7482, i[2929] = 7483, i[2930] = 7484, i[2932] = 7486, i[2933] = 7487, i[2934] = 7488, i[2936] = 7490, i[2937] = 7491, i[2938] = 7492, i[2940] = 7494, i[2941] = 7495, i[2942] = 7496, i[2944] = 7498, i[2946] = 7500, i[2948] = 7502, i[2950] = 7504, i[2951] = 7505, i[2952] = 7506, i[2954] = 7508, i[2955] = 7509, i[2956] = 7510, i[2958] = 7512, i[2959] = 7513, i[2960] = 7514, i[2962] = 7516, i[2963] = 7517, i[2964] = 7518, i[2966] = 7520, i[2967] = 7521, i[2968] = 7522, i[2970] = 7524, i[2971] = 7525, i[2972] = 7526, i[2974] = 7528, i[2975] = 7529, i[2976] = 7530, i[2978] = 1537, i[2979] = 1538, i[2980] = 1539, i[2982] = 1549, i[2983] = 1551, i[2984] = 1552, i[2986] = 1554, i[2987] = 1555, i[2988] = 1556, i[2990] = 1623, i[2991] = 1624, i[2995] = 1775, i[2999] = 1791, i[3002] = 64290, i[3003] = 64291, i[3004] = 64292, i[3006] = 64294, i[3007] = 64295, i[3008] = 64296, i[3011] = 1900, i[3014] = 8223, i[3015] = 8244, i[3017] = 7532, i[3018] = 7533, i[3019] = 7534, i[3075] = 7590, i[3076] = 7591, i[3079] = 7594, i[3080] = 7595, i[3083] = 7598, i[3084] = 7599, i[3087] = 7602, i[3088] = 7603, i[3091] = 7606, i[3092] = 7607, i[3095] = 7610, i[3096] = 7611, i[3099] = 7614, i[3100] = 7615, i[3103] = 7618, i[3104] = 7619, i[3107] = 8337, i[3108] = 8338, i[3116] = 1884, i[3119] = 1885, i[3120] = 1885, i[3123] = 1886, i[3124] = 1886, i[3127] = 1887, i[3128] = 1887, i[3131] = 1888, i[3132] = 1888, i[3135] = 1889, i[3136] = 1889, i[3139] = 1890, i[3140] = 1890, i[3143] = 1891, i[3144] = 1891, i[3147] = 1892, i[3148] = 1892, i[3153] = 580, i[3154] = 581, i[3157] = 584, i[3158] = 585, i[3161] = 588, i[3162] = 589, i[3165] = 891, i[3166] = 892, i[3169] = 1274, i[3170] = 1275, i[3173] = 1278, i[3174] = 1279, i[3181] = 7622, i[3182] = 7623, i[3282] = 11799, i[3316] = 578, i[3379] = 42785, i[3393] = 1159, i[3416] = 8377;
          });
          F.getGlyphMapForStandardFonts = M;
          const O = (0, n.getLookupTableFactory)(function(i) {
            i[227] = 322, i[264] = 261, i[291] = 346;
          });
          F.getSupplementalGlyphMapForArialBlack = O;
          const w = (0, n.getLookupTableFactory)(function(i) {
            i[1] = 32, i[4] = 65, i[5] = 192, i[6] = 193, i[9] = 196, i[17] = 66, i[18] = 67, i[21] = 268, i[24] = 68, i[28] = 69, i[29] = 200, i[30] = 201, i[32] = 282, i[38] = 70, i[39] = 71, i[44] = 72, i[47] = 73, i[48] = 204, i[49] = 205, i[58] = 74, i[60] = 75, i[62] = 76, i[68] = 77, i[69] = 78, i[75] = 79, i[76] = 210, i[80] = 214, i[87] = 80, i[89] = 81, i[90] = 82, i[92] = 344, i[94] = 83, i[97] = 352, i[100] = 84, i[104] = 85, i[109] = 220, i[115] = 86, i[116] = 87, i[121] = 88, i[122] = 89, i[124] = 221, i[127] = 90, i[129] = 381, i[258] = 97, i[259] = 224, i[260] = 225, i[263] = 228, i[268] = 261, i[271] = 98, i[272] = 99, i[273] = 263, i[275] = 269, i[282] = 100, i[286] = 101, i[287] = 232, i[288] = 233, i[290] = 283, i[295] = 281, i[296] = 102, i[336] = 103, i[346] = 104, i[349] = 105, i[350] = 236, i[351] = 237, i[361] = 106, i[364] = 107, i[367] = 108, i[371] = 322, i[373] = 109, i[374] = 110, i[381] = 111, i[382] = 242, i[383] = 243, i[386] = 246, i[393] = 112, i[395] = 113, i[396] = 114, i[398] = 345, i[400] = 115, i[401] = 347, i[403] = 353, i[410] = 116, i[437] = 117, i[442] = 252, i[448] = 118, i[449] = 119, i[454] = 120, i[455] = 121, i[457] = 253, i[460] = 122, i[462] = 382, i[463] = 380, i[853] = 44, i[855] = 58, i[856] = 46, i[876] = 47, i[878] = 45, i[882] = 45, i[894] = 40, i[895] = 41, i[896] = 91, i[897] = 93, i[923] = 64, i[1004] = 48, i[1005] = 49, i[1006] = 50, i[1007] = 51, i[1008] = 52, i[1009] = 53, i[1010] = 54, i[1011] = 55, i[1012] = 56, i[1013] = 57, i[1081] = 37, i[1085] = 43, i[1086] = 45;
          });
          F.getSupplementalGlyphMapForCalibri = w;
          function C(i) {
            const o = (0, u.normalizeFontName)(i);
            return q()[o];
          }
        },
        /* 42 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ToUnicodeMap = F.IdentityToUnicodeMap = void 0;
          var n = ae(2);
          class u {
            constructor(t = []) {
              this._map = t;
            }
            get length() {
              return this._map.length;
            }
            forEach(t) {
              for (const B in this._map)
                t(B, this._map[B].charCodeAt(0));
            }
            has(t) {
              return this._map[t] !== void 0;
            }
            get(t) {
              return this._map[t];
            }
            charCodeOf(t) {
              const B = this._map;
              if (B.length <= 65536)
                return B.indexOf(t);
              for (const j in B)
                if (B[j] === t)
                  return j | 0;
              return -1;
            }
            amend(t) {
              for (const B in t)
                this._map[B] = t[B];
            }
          }
          F.ToUnicodeMap = u;
          class q {
            constructor(t, B) {
              this.firstChar = t, this.lastChar = B;
            }
            get length() {
              return this.lastChar + 1 - this.firstChar;
            }
            forEach(t) {
              for (let B = this.firstChar, j = this.lastChar; B <= j; B++)
                t(B, B);
            }
            has(t) {
              return this.firstChar <= t && t <= this.lastChar;
            }
            get(t) {
              if (this.firstChar <= t && t <= this.lastChar)
                return String.fromCharCode(t);
            }
            charCodeOf(t) {
              return Number.isInteger(t) && t >= this.firstChar && t <= this.lastChar ? t : -1;
            }
            amend(t) {
              (0, n.unreachable)("Should not call amend()");
            }
          }
          F.IdentityToUnicodeMap = q;
        },
        /* 43 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.CFFFont = void 0;
          var n = ae(35), u = ae(38), q = ae(2);
          class e {
            constructor(B, j) {
              this.properties = j;
              const M = new n.CFFParser(B, j, u.SEAC_ANALYSIS_ENABLED);
              this.cff = M.parse(), this.cff.duplicateFirstGlyph();
              const O = new n.CFFCompiler(this.cff);
              this.seacs = this.cff.seacs;
              try {
                this.data = O.compile();
              } catch {
                (0, q.warn)("Failed to compile font " + j.loadedName), this.data = B;
              }
              this._createBuiltInEncoding();
            }
            get numGlyphs() {
              return this.cff.charStrings.count;
            }
            getCharset() {
              return this.cff.charset.charset;
            }
            getGlyphMapping() {
              const B = this.cff, j = this.properties, {
                cidToGidMap: M,
                cMap: O
              } = j, w = B.charset.charset;
              let C, i;
              if (j.composite) {
                let k;
                if ((M == null ? void 0 : M.length) > 0) {
                  k = /* @__PURE__ */ Object.create(null);
                  for (let l = 0, g = M.length; l < g; l++) {
                    const v = M[l];
                    v !== void 0 && (k[v] = l);
                  }
                }
                C = /* @__PURE__ */ Object.create(null);
                let s;
                if (B.isCIDFont)
                  for (i = 0; i < w.length; i++) {
                    const l = w[i];
                    s = O.charCodeOf(l), (k == null ? void 0 : k[s]) !== void 0 && (s = k[s]), C[s] = i;
                  }
                else
                  for (i = 0; i < B.charStrings.count; i++)
                    s = O.charCodeOf(i), C[s] = i;
                return C;
              }
              let o = B.encoding ? B.encoding.encoding : null;
              return j.isInternalFont && (o = j.defaultEncoding), C = (0, u.type1FontGlyphMapping)(j, o, w), C;
            }
            hasGlyphId(B) {
              return this.cff.hasGlyphId(B);
            }
            _createBuiltInEncoding() {
              const {
                charset: B,
                encoding: j
              } = this.cff;
              if (!B || !j)
                return;
              const M = B.charset, O = j.encoding, w = [];
              for (const C in O) {
                const i = O[C];
                if (i >= 0) {
                  const o = M[i];
                  o && (w[C] = o);
                }
              }
              w.length > 0 && (this.properties.builtInEncoding = w);
            }
          }
          F.CFFFont = e;
        },
        /* 44 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.FontRendererFactory = void 0;
          var n = ae(2), u = ae(35), q = ae(39), e = ae(37), t = ae(8);
          function B(h, y) {
            return (h[y] << 24 | h[y + 1] << 16 | h[y + 2] << 8 | h[y + 3]) >>> 0;
          }
          function j(h, y) {
            return h[y] << 8 | h[y + 1];
          }
          function M(h, y) {
            return (h[y] << 24 | h[y + 1] << 16) >> 16;
          }
          function O(h, y) {
            return h[y] << 24 >> 24;
          }
          function w(h, y) {
            return M(h, y) / 16384;
          }
          function C(h) {
            const y = h.length;
            let P = 32768;
            return y < 1240 ? P = 107 : y < 33900 && (P = 1131), P;
          }
          function i(h, y, P) {
            const c = j(h, y + 2) === 1 ? B(h, y + 8) : B(h, y + 16), d = j(h, y + c);
            let A, N, E;
            if (d === 4) {
              j(h, y + c + 2);
              const H = j(h, y + c + 6) >> 1;
              for (N = y + c + 14, A = [], E = 0; E < H; E++, N += 2)
                A[E] = {
                  end: j(h, N)
                };
              for (N += 2, E = 0; E < H; E++, N += 2)
                A[E].start = j(h, N);
              for (E = 0; E < H; E++, N += 2)
                A[E].idDelta = j(h, N);
              for (E = 0; E < H; E++, N += 2) {
                let $ = j(h, N);
                if ($ !== 0) {
                  A[E].ids = [];
                  for (let m = 0, p = A[E].end - A[E].start + 1; m < p; m++)
                    A[E].ids[m] = j(h, N + $), $ += 2;
                }
              }
              return A;
            } else if (d === 12) {
              const H = B(h, y + c + 12);
              for (N = y + c + 16, A = [], E = 0; E < H; E++)
                y = B(h, N), A.push({
                  start: y,
                  end: B(h, N + 4),
                  idDelta: B(h, N + 8) - y
                }), N += 12;
              return A;
            }
            throw new n.FormatError(`unsupported cmap: ${d}`);
          }
          function o(h, y, P, c) {
            var E, H, $;
            const d = {}, N = new u.CFFParser(new t.Stream(h, y, P - y), d, c).parse();
            return {
              glyphs: N.charStrings.objects,
              subrs: (H = (E = N.topDict.privateDict) == null ? void 0 : E.subrsIndex) == null ? void 0 : H.objects,
              gsubrs: ($ = N.globalSubrIndex) == null ? void 0 : $.objects,
              isCFFCIDFont: N.isCIDFont,
              fdSelect: N.fdSelect,
              fdArray: N.fdArray
            };
          }
          function k(h, y, P) {
            let c, d;
            P ? (c = 4, d = B) : (c = 2, d = (E, H) => 2 * j(E, H));
            const A = [];
            let N = d(y, 0);
            for (let E = c; E < y.length; E += c) {
              const H = d(y, E);
              A.push(h.subarray(N, H)), N = H;
            }
            return A;
          }
          function s(h, y) {
            const P = y.codePointAt(0);
            let c = 0, d = 0, A = h.length - 1;
            for (; d < A; ) {
              const N = d + A + 1 >> 1;
              P < h[N].start ? A = N - 1 : d = N;
            }
            return h[d].start <= P && P <= h[d].end && (c = h[d].idDelta + (h[d].ids ? h[d].ids[P - h[d].start] : P) & 65535), {
              charCode: P,
              glyphId: c
            };
          }
          function l(h, y, P) {
            function c(p, T) {
              y.push({
                cmd: "moveTo",
                args: [p, T]
              });
            }
            function d(p, T) {
              y.push({
                cmd: "lineTo",
                args: [p, T]
              });
            }
            function A(p, T, L, _) {
              y.push({
                cmd: "quadraticCurveTo",
                args: [p, T, L, _]
              });
            }
            let N = 0;
            const E = M(h, N);
            let H, $ = 0, m = 0;
            if (N += 10, E < 0)
              do {
                H = j(h, N);
                const p = j(h, N + 2);
                N += 4;
                let T, L;
                H & 1 ? (H & 2 ? (T = M(h, N), L = M(h, N + 2)) : (T = j(h, N), L = j(h, N + 2)), N += 4) : H & 2 ? (T = O(h, N++), L = O(h, N++)) : (T = h[N++], L = h[N++]), H & 2 ? ($ = T, m = L) : ($ = 0, m = 0);
                let _ = 1, G = 1, J = 0, K = 0;
                H & 8 ? (_ = G = w(h, N), N += 2) : H & 64 ? (_ = w(h, N), G = w(h, N + 2), N += 4) : H & 128 && (_ = w(h, N), J = w(h, N + 2), K = w(h, N + 4), G = w(h, N + 6), N += 8);
                const V = P.glyphs[p];
                V && (y.push({
                  cmd: "save"
                }, {
                  cmd: "transform",
                  args: [_, J, K, G, $, m]
                }), l(V, y, P), y.push({
                  cmd: "restore"
                }));
              } while (H & 32);
            else {
              const p = [];
              let T, L;
              for (T = 0; T < E; T++)
                p.push(j(h, N)), N += 2;
              const _ = j(h, N);
              N += 2 + _;
              const G = p.at(-1) + 1, J = [];
              for (; J.length < G; ) {
                H = h[N++];
                let V = 1;
                for (H & 8 && (V += h[N++]); V-- > 0; )
                  J.push({
                    flags: H
                  });
              }
              for (T = 0; T < G; T++) {
                switch (J[T].flags & 18) {
                  case 0:
                    $ += M(h, N), N += 2;
                    break;
                  case 2:
                    $ -= h[N++];
                    break;
                  case 18:
                    $ += h[N++];
                    break;
                }
                J[T].x = $;
              }
              for (T = 0; T < G; T++) {
                switch (J[T].flags & 36) {
                  case 0:
                    m += M(h, N), N += 2;
                    break;
                  case 4:
                    m -= h[N++];
                    break;
                  case 36:
                    m += h[N++];
                    break;
                }
                J[T].y = m;
              }
              let K = 0;
              for (N = 0; N < E; N++) {
                const V = p[N], U = J.slice(K, V + 1);
                if (U[0].flags & 1)
                  U.push(U[0]);
                else if (U.at(-1).flags & 1)
                  U.unshift(U.at(-1));
                else {
                  const Q = {
                    flags: 1,
                    x: (U[0].x + U.at(-1).x) / 2,
                    y: (U[0].y + U.at(-1).y) / 2
                  };
                  U.unshift(Q), U.push(Q);
                }
                for (c(U[0].x, U[0].y), T = 1, L = U.length; T < L; T++)
                  U[T].flags & 1 ? d(U[T].x, U[T].y) : U[T + 1].flags & 1 ? (A(U[T].x, U[T].y, U[T + 1].x, U[T + 1].y), T++) : A(U[T].x, U[T].y, (U[T].x + U[T + 1].x) / 2, (U[T].y + U[T + 1].y) / 2);
                K = V + 1;
              }
            }
          }
          function g(h, y, P, c) {
            function d(T, L) {
              y.push({
                cmd: "moveTo",
                args: [T, L]
              });
            }
            function A(T, L) {
              y.push({
                cmd: "lineTo",
                args: [T, L]
              });
            }
            function N(T, L, _, G, J, K) {
              y.push({
                cmd: "bezierCurveTo",
                args: [T, L, _, G, J, K]
              });
            }
            const E = [];
            let H = 0, $ = 0, m = 0;
            function p(T) {
              var _;
              let L = 0;
              for (; L < T.length; ) {
                let G = !1, J = T[L++], K, V, U, Q, X, R, f, D, z;
                switch (J) {
                  case 1:
                    m += E.length >> 1, G = !0;
                    break;
                  case 3:
                    m += E.length >> 1, G = !0;
                    break;
                  case 4:
                    $ += E.pop(), d(H, $), G = !0;
                    break;
                  case 5:
                    for (; E.length > 0; )
                      H += E.shift(), $ += E.shift(), A(H, $);
                    break;
                  case 6:
                    for (; E.length > 0 && (H += E.shift(), A(H, $), E.length !== 0); )
                      $ += E.shift(), A(H, $);
                    break;
                  case 7:
                    for (; E.length > 0 && ($ += E.shift(), A(H, $), E.length !== 0); )
                      H += E.shift(), A(H, $);
                    break;
                  case 8:
                    for (; E.length > 0; )
                      K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + E.shift(), N(K, U, V, Q, H, $);
                    break;
                  case 10:
                    if (D = E.pop(), z = null, P.isCFFCIDFont) {
                      const Y = P.fdSelect.getFDIndex(c);
                      if (Y >= 0 && Y < P.fdArray.length) {
                        const W = P.fdArray[Y];
                        let ie;
                        (_ = W.privateDict) != null && _.subrsIndex && (ie = W.privateDict.subrsIndex.objects), ie && (D += C(ie), z = ie[D]);
                      } else
                        (0, n.warn)("Invalid fd index for glyph index.");
                    } else
                      z = P.subrs[D + P.subrsBias];
                    z && p(z);
                    break;
                  case 11:
                    return;
                  case 12:
                    switch (J = T[L++], J) {
                      case 34:
                        K = H + E.shift(), V = K + E.shift(), X = $ + E.shift(), H = V + E.shift(), N(K, $, V, X, H, X), K = H + E.shift(), V = K + E.shift(), H = V + E.shift(), N(K, X, V, $, H, $);
                        break;
                      case 35:
                        K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + E.shift(), N(K, U, V, Q, H, $), K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + E.shift(), N(K, U, V, Q, H, $), E.pop();
                        break;
                      case 36:
                        K = H + E.shift(), X = $ + E.shift(), V = K + E.shift(), R = X + E.shift(), H = V + E.shift(), N(K, X, V, R, H, R), K = H + E.shift(), V = K + E.shift(), f = R + E.shift(), H = V + E.shift(), N(K, R, V, f, H, $);
                        break;
                      case 37:
                        const Y = H, W = $;
                        K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + E.shift(), N(K, U, V, Q, H, $), K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V, $ = Q, Math.abs(H - Y) > Math.abs($ - W) ? H += E.shift() : $ += E.shift(), N(K, U, V, Q, H, $);
                        break;
                      default:
                        throw new n.FormatError(`unknown operator: 12 ${J}`);
                    }
                    break;
                  case 14:
                    if (E.length >= 4) {
                      const Y = E.pop(), W = E.pop();
                      $ = E.pop(), H = E.pop(), y.push({
                        cmd: "save"
                      }, {
                        cmd: "translate",
                        args: [H, $]
                      });
                      let ie = s(P.cmap, String.fromCharCode(P.glyphNameMap[e.StandardEncoding[Y]]));
                      g(P.glyphs[ie.glyphId], y, P, ie.glyphId), y.push({
                        cmd: "restore"
                      }), ie = s(P.cmap, String.fromCharCode(P.glyphNameMap[e.StandardEncoding[W]])), g(P.glyphs[ie.glyphId], y, P, ie.glyphId);
                    }
                    return;
                  case 18:
                    m += E.length >> 1, G = !0;
                    break;
                  case 19:
                    m += E.length >> 1, L += m + 7 >> 3, G = !0;
                    break;
                  case 20:
                    m += E.length >> 1, L += m + 7 >> 3, G = !0;
                    break;
                  case 21:
                    $ += E.pop(), H += E.pop(), d(H, $), G = !0;
                    break;
                  case 22:
                    H += E.pop(), d(H, $), G = !0;
                    break;
                  case 23:
                    m += E.length >> 1, G = !0;
                    break;
                  case 24:
                    for (; E.length > 2; )
                      K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + E.shift(), N(K, U, V, Q, H, $);
                    H += E.shift(), $ += E.shift(), A(H, $);
                    break;
                  case 25:
                    for (; E.length > 6; )
                      H += E.shift(), $ += E.shift(), A(H, $);
                    K = H + E.shift(), U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + E.shift(), N(K, U, V, Q, H, $);
                    break;
                  case 26:
                    for (E.length % 2 && (H += E.shift()); E.length > 0; )
                      K = H, U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V, $ = Q + E.shift(), N(K, U, V, Q, H, $);
                    break;
                  case 27:
                    for (E.length % 2 && ($ += E.shift()); E.length > 0; )
                      K = H + E.shift(), U = $, V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q, N(K, U, V, Q, H, $);
                    break;
                  case 28:
                    E.push((T[L] << 24 | T[L + 1] << 16) >> 16), L += 2;
                    break;
                  case 29:
                    D = E.pop() + P.gsubrsBias, z = P.gsubrs[D], z && p(z);
                    break;
                  case 30:
                    for (; E.length > 0 && (K = H, U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + (E.length === 1 ? E.shift() : 0), N(K, U, V, Q, H, $), E.length !== 0); )
                      K = H + E.shift(), U = $, V = K + E.shift(), Q = U + E.shift(), $ = Q + E.shift(), H = V + (E.length === 1 ? E.shift() : 0), N(K, U, V, Q, H, $);
                    break;
                  case 31:
                    for (; E.length > 0 && (K = H + E.shift(), U = $, V = K + E.shift(), Q = U + E.shift(), $ = Q + E.shift(), H = V + (E.length === 1 ? E.shift() : 0), N(K, U, V, Q, H, $), E.length !== 0); )
                      K = H, U = $ + E.shift(), V = K + E.shift(), Q = U + E.shift(), H = V + E.shift(), $ = Q + (E.length === 1 ? E.shift() : 0), N(K, U, V, Q, H, $);
                    break;
                  default:
                    if (J < 32)
                      throw new n.FormatError(`unknown operator: ${J}`);
                    J < 247 ? E.push(J - 139) : J < 251 ? E.push((J - 247) * 256 + T[L++] + 108) : J < 255 ? E.push(-(J - 251) * 256 - T[L++] - 108) : (E.push((T[L] << 24 | T[L + 1] << 16 | T[L + 2] << 8 | T[L + 3]) / 65536), L += 4);
                    break;
                }
                G && (E.length = 0);
              }
            }
            p(h);
          }
          const v = [];
          class r {
            constructor(y) {
              this.constructor === r && (0, n.unreachable)("Cannot initialize CompiledFont."), this.fontMatrix = y, this.compiledGlyphs = /* @__PURE__ */ Object.create(null), this.compiledCharCodeToGlyphId = /* @__PURE__ */ Object.create(null);
            }
            getPathJs(y) {
              const {
                charCode: P,
                glyphId: c
              } = s(this.cmap, y);
              let d = this.compiledGlyphs[c];
              if (!d)
                try {
                  d = this.compileGlyph(this.glyphs[c], c), this.compiledGlyphs[c] = d;
                } catch (A) {
                  throw this.compiledGlyphs[c] = v, this.compiledCharCodeToGlyphId[P] === void 0 && (this.compiledCharCodeToGlyphId[P] = c), A;
                }
              return this.compiledCharCodeToGlyphId[P] === void 0 && (this.compiledCharCodeToGlyphId[P] = c), d;
            }
            compileGlyph(y, P) {
              if (!y || y.length === 0 || y[0] === 14)
                return v;
              let c = this.fontMatrix;
              if (this.isCFFCIDFont) {
                const A = this.fdSelect.getFDIndex(P);
                A >= 0 && A < this.fdArray.length ? c = this.fdArray[A].getByName("FontMatrix") || n.FONT_IDENTITY_MATRIX : (0, n.warn)("Invalid fd index for glyph index.");
              }
              const d = [{
                cmd: "save"
              }, {
                cmd: "transform",
                args: c.slice()
              }, {
                cmd: "scale",
                args: ["size", "-size"]
              }];
              return this.compileGlyphImpl(y, d, P), d.push({
                cmd: "restore"
              }), d;
            }
            compileGlyphImpl() {
              (0, n.unreachable)("Children classes should implement this.");
            }
            hasBuiltPath(y) {
              const {
                charCode: P,
                glyphId: c
              } = s(this.cmap, y);
              return this.compiledGlyphs[c] !== void 0 && this.compiledCharCodeToGlyphId[P] !== void 0;
            }
          }
          class x extends r {
            constructor(y, P, c) {
              super(c || [488e-6, 0, 0, 488e-6, 0, 0]), this.glyphs = y, this.cmap = P;
            }
            compileGlyphImpl(y, P) {
              l(y, P, this);
            }
          }
          class b extends r {
            constructor(y, P, c, d) {
              super(c || [1e-3, 0, 0, 1e-3, 0, 0]), this.glyphs = y.glyphs, this.gsubrs = y.gsubrs || [], this.subrs = y.subrs || [], this.cmap = P, this.glyphNameMap = d || (0, q.getGlyphsUnicode)(), this.gsubrsBias = C(this.gsubrs), this.subrsBias = C(this.subrs), this.isCFFCIDFont = y.isCFFCIDFont, this.fdSelect = y.fdSelect, this.fdArray = y.fdArray;
            }
            compileGlyphImpl(y, P, c) {
              g(y, P, this, c);
            }
          }
          class I {
            static create(y, P) {
              const c = new Uint8Array(y.data);
              let d, A, N, E, H, $;
              const m = j(c, 4);
              for (let p = 0, T = 12; p < m; p++, T += 16) {
                const L = (0, n.bytesToString)(c.subarray(T, T + 4)), _ = B(c, T + 8), G = B(c, T + 12);
                switch (L) {
                  case "cmap":
                    d = i(c, _);
                    break;
                  case "glyf":
                    A = c.subarray(_, _ + G);
                    break;
                  case "loca":
                    N = c.subarray(_, _ + G);
                    break;
                  case "head":
                    $ = j(c, _ + 18), H = j(c, _ + 50);
                    break;
                  case "CFF ":
                    E = o(c, _, _ + G, P);
                    break;
                }
              }
              if (A) {
                const p = $ ? [1 / $, 0, 0, 1 / $, 0, 0] : y.fontMatrix;
                return new x(k(A, N, H), d, p);
              }
              return new b(E, d, y.fontMatrix, y.glyphNameMap);
            }
          }
          F.FontRendererFactory = I;
        },
        /* 45 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.getMetrics = F.getFontBasicMetrics = void 0;
          var n = ae(3);
          const u = (0, n.getLookupTableFactory)(function(e) {
            e.Courier = 600, e["Courier-Bold"] = 600, e["Courier-BoldOblique"] = 600, e["Courier-Oblique"] = 600, e.Helvetica = (0, n.getLookupTableFactory)(function(t) {
              t.space = 278, t.exclam = 278, t.quotedbl = 355, t.numbersign = 556, t.dollar = 556, t.percent = 889, t.ampersand = 667, t.quoteright = 222, t.parenleft = 333, t.parenright = 333, t.asterisk = 389, t.plus = 584, t.comma = 278, t.hyphen = 333, t.period = 278, t.slash = 278, t.zero = 556, t.one = 556, t.two = 556, t.three = 556, t.four = 556, t.five = 556, t.six = 556, t.seven = 556, t.eight = 556, t.nine = 556, t.colon = 278, t.semicolon = 278, t.less = 584, t.equal = 584, t.greater = 584, t.question = 556, t.at = 1015, t.A = 667, t.B = 667, t.C = 722, t.D = 722, t.E = 667, t.F = 611, t.G = 778, t.H = 722, t.I = 278, t.J = 500, t.K = 667, t.L = 556, t.M = 833, t.N = 722, t.O = 778, t.P = 667, t.Q = 778, t.R = 722, t.S = 667, t.T = 611, t.U = 722, t.V = 667, t.W = 944, t.X = 667, t.Y = 667, t.Z = 611, t.bracketleft = 278, t.backslash = 278, t.bracketright = 278, t.asciicircum = 469, t.underscore = 556, t.quoteleft = 222, t.a = 556, t.b = 556, t.c = 500, t.d = 556, t.e = 556, t.f = 278, t.g = 556, t.h = 556, t.i = 222, t.j = 222, t.k = 500, t.l = 222, t.m = 833, t.n = 556, t.o = 556, t.p = 556, t.q = 556, t.r = 333, t.s = 500, t.t = 278, t.u = 556, t.v = 500, t.w = 722, t.x = 500, t.y = 500, t.z = 500, t.braceleft = 334, t.bar = 260, t.braceright = 334, t.asciitilde = 584, t.exclamdown = 333, t.cent = 556, t.sterling = 556, t.fraction = 167, t.yen = 556, t.florin = 556, t.section = 556, t.currency = 556, t.quotesingle = 191, t.quotedblleft = 333, t.guillemotleft = 556, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 500, t.fl = 500, t.endash = 556, t.dagger = 556, t.daggerdbl = 556, t.periodcentered = 278, t.paragraph = 537, t.bullet = 350, t.quotesinglbase = 222, t.quotedblbase = 333, t.quotedblright = 333, t.guillemotright = 556, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 611, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 1e3, t.ordfeminine = 370, t.Lslash = 556, t.Oslash = 778, t.OE = 1e3, t.ordmasculine = 365, t.ae = 889, t.dotlessi = 278, t.lslash = 222, t.oslash = 611, t.oe = 944, t.germandbls = 611, t.Idieresis = 278, t.eacute = 556, t.abreve = 556, t.uhungarumlaut = 556, t.ecaron = 556, t.Ydieresis = 667, t.divide = 584, t.Yacute = 667, t.Acircumflex = 667, t.aacute = 556, t.Ucircumflex = 722, t.yacute = 500, t.scommaaccent = 500, t.ecircumflex = 556, t.Uring = 722, t.Udieresis = 722, t.aogonek = 556, t.Uacute = 722, t.uogonek = 556, t.Edieresis = 667, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 737, t.Emacron = 667, t.ccaron = 500, t.aring = 556, t.Ncommaaccent = 722, t.lacute = 222, t.agrave = 556, t.Tcommaaccent = 611, t.Cacute = 722, t.atilde = 556, t.Edotaccent = 667, t.scaron = 500, t.scedilla = 500, t.iacute = 278, t.lozenge = 471, t.Rcaron = 722, t.Gcommaaccent = 778, t.ucircumflex = 556, t.acircumflex = 556, t.Amacron = 667, t.rcaron = 333, t.ccedilla = 500, t.Zdotaccent = 611, t.Thorn = 667, t.Omacron = 778, t.Racute = 722, t.Sacute = 667, t.dcaron = 643, t.Umacron = 722, t.uring = 556, t.threesuperior = 333, t.Ograve = 778, t.Agrave = 667, t.Abreve = 667, t.multiply = 584, t.uacute = 556, t.Tcaron = 611, t.partialdiff = 476, t.ydieresis = 500, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 667, t.adieresis = 556, t.edieresis = 556, t.cacute = 500, t.nacute = 556, t.umacron = 556, t.Ncaron = 722, t.Iacute = 278, t.plusminus = 584, t.brokenbar = 260, t.registered = 737, t.Gbreve = 778, t.Idotaccent = 278, t.summation = 600, t.Egrave = 667, t.racute = 333, t.omacron = 556, t.Zacute = 611, t.Zcaron = 611, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 722, t.lcommaaccent = 222, t.tcaron = 317, t.eogonek = 556, t.Uogonek = 722, t.Aacute = 667, t.Adieresis = 667, t.egrave = 556, t.zacute = 500, t.iogonek = 222, t.Oacute = 778, t.oacute = 556, t.amacron = 556, t.sacute = 500, t.idieresis = 278, t.Ocircumflex = 778, t.Ugrave = 722, t.Delta = 612, t.thorn = 556, t.twosuperior = 333, t.Odieresis = 778, t.mu = 556, t.igrave = 278, t.ohungarumlaut = 556, t.Eogonek = 667, t.dcroat = 556, t.threequarters = 834, t.Scedilla = 667, t.lcaron = 299, t.Kcommaaccent = 667, t.Lacute = 556, t.trademark = 1e3, t.edotaccent = 556, t.Igrave = 278, t.Imacron = 278, t.Lcaron = 556, t.onehalf = 834, t.lessequal = 549, t.ocircumflex = 556, t.ntilde = 556, t.Uhungarumlaut = 722, t.Eacute = 667, t.emacron = 556, t.gbreve = 556, t.onequarter = 834, t.Scaron = 667, t.Scommaaccent = 667, t.Ohungarumlaut = 778, t.degree = 400, t.ograve = 556, t.Ccaron = 722, t.ugrave = 556, t.radical = 453, t.Dcaron = 722, t.rcommaaccent = 333, t.Ntilde = 722, t.otilde = 556, t.Rcommaaccent = 722, t.Lcommaaccent = 556, t.Atilde = 667, t.Aogonek = 667, t.Aring = 667, t.Otilde = 778, t.zdotaccent = 500, t.Ecaron = 667, t.Iogonek = 278, t.kcommaaccent = 500, t.minus = 584, t.Icircumflex = 278, t.ncaron = 556, t.tcommaaccent = 278, t.logicalnot = 584, t.odieresis = 556, t.udieresis = 556, t.notequal = 549, t.gcommaaccent = 556, t.eth = 556, t.zcaron = 500, t.ncommaaccent = 556, t.onesuperior = 333, t.imacron = 278, t.Euro = 556;
            }), e["Helvetica-Bold"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 278, t.exclam = 333, t.quotedbl = 474, t.numbersign = 556, t.dollar = 556, t.percent = 889, t.ampersand = 722, t.quoteright = 278, t.parenleft = 333, t.parenright = 333, t.asterisk = 389, t.plus = 584, t.comma = 278, t.hyphen = 333, t.period = 278, t.slash = 278, t.zero = 556, t.one = 556, t.two = 556, t.three = 556, t.four = 556, t.five = 556, t.six = 556, t.seven = 556, t.eight = 556, t.nine = 556, t.colon = 333, t.semicolon = 333, t.less = 584, t.equal = 584, t.greater = 584, t.question = 611, t.at = 975, t.A = 722, t.B = 722, t.C = 722, t.D = 722, t.E = 667, t.F = 611, t.G = 778, t.H = 722, t.I = 278, t.J = 556, t.K = 722, t.L = 611, t.M = 833, t.N = 722, t.O = 778, t.P = 667, t.Q = 778, t.R = 722, t.S = 667, t.T = 611, t.U = 722, t.V = 667, t.W = 944, t.X = 667, t.Y = 667, t.Z = 611, t.bracketleft = 333, t.backslash = 278, t.bracketright = 333, t.asciicircum = 584, t.underscore = 556, t.quoteleft = 278, t.a = 556, t.b = 611, t.c = 556, t.d = 611, t.e = 556, t.f = 333, t.g = 611, t.h = 611, t.i = 278, t.j = 278, t.k = 556, t.l = 278, t.m = 889, t.n = 611, t.o = 611, t.p = 611, t.q = 611, t.r = 389, t.s = 556, t.t = 333, t.u = 611, t.v = 556, t.w = 778, t.x = 556, t.y = 556, t.z = 500, t.braceleft = 389, t.bar = 280, t.braceright = 389, t.asciitilde = 584, t.exclamdown = 333, t.cent = 556, t.sterling = 556, t.fraction = 167, t.yen = 556, t.florin = 556, t.section = 556, t.currency = 556, t.quotesingle = 238, t.quotedblleft = 500, t.guillemotleft = 556, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 611, t.fl = 611, t.endash = 556, t.dagger = 556, t.daggerdbl = 556, t.periodcentered = 278, t.paragraph = 556, t.bullet = 350, t.quotesinglbase = 278, t.quotedblbase = 500, t.quotedblright = 500, t.guillemotright = 556, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 611, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 1e3, t.ordfeminine = 370, t.Lslash = 611, t.Oslash = 778, t.OE = 1e3, t.ordmasculine = 365, t.ae = 889, t.dotlessi = 278, t.lslash = 278, t.oslash = 611, t.oe = 944, t.germandbls = 611, t.Idieresis = 278, t.eacute = 556, t.abreve = 556, t.uhungarumlaut = 611, t.ecaron = 556, t.Ydieresis = 667, t.divide = 584, t.Yacute = 667, t.Acircumflex = 722, t.aacute = 556, t.Ucircumflex = 722, t.yacute = 556, t.scommaaccent = 556, t.ecircumflex = 556, t.Uring = 722, t.Udieresis = 722, t.aogonek = 556, t.Uacute = 722, t.uogonek = 611, t.Edieresis = 667, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 737, t.Emacron = 667, t.ccaron = 556, t.aring = 556, t.Ncommaaccent = 722, t.lacute = 278, t.agrave = 556, t.Tcommaaccent = 611, t.Cacute = 722, t.atilde = 556, t.Edotaccent = 667, t.scaron = 556, t.scedilla = 556, t.iacute = 278, t.lozenge = 494, t.Rcaron = 722, t.Gcommaaccent = 778, t.ucircumflex = 611, t.acircumflex = 556, t.Amacron = 722, t.rcaron = 389, t.ccedilla = 556, t.Zdotaccent = 611, t.Thorn = 667, t.Omacron = 778, t.Racute = 722, t.Sacute = 667, t.dcaron = 743, t.Umacron = 722, t.uring = 611, t.threesuperior = 333, t.Ograve = 778, t.Agrave = 722, t.Abreve = 722, t.multiply = 584, t.uacute = 611, t.Tcaron = 611, t.partialdiff = 494, t.ydieresis = 556, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 667, t.adieresis = 556, t.edieresis = 556, t.cacute = 556, t.nacute = 611, t.umacron = 611, t.Ncaron = 722, t.Iacute = 278, t.plusminus = 584, t.brokenbar = 280, t.registered = 737, t.Gbreve = 778, t.Idotaccent = 278, t.summation = 600, t.Egrave = 667, t.racute = 389, t.omacron = 611, t.Zacute = 611, t.Zcaron = 611, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 722, t.lcommaaccent = 278, t.tcaron = 389, t.eogonek = 556, t.Uogonek = 722, t.Aacute = 722, t.Adieresis = 722, t.egrave = 556, t.zacute = 500, t.iogonek = 278, t.Oacute = 778, t.oacute = 611, t.amacron = 556, t.sacute = 556, t.idieresis = 278, t.Ocircumflex = 778, t.Ugrave = 722, t.Delta = 612, t.thorn = 611, t.twosuperior = 333, t.Odieresis = 778, t.mu = 611, t.igrave = 278, t.ohungarumlaut = 611, t.Eogonek = 667, t.dcroat = 611, t.threequarters = 834, t.Scedilla = 667, t.lcaron = 400, t.Kcommaaccent = 722, t.Lacute = 611, t.trademark = 1e3, t.edotaccent = 556, t.Igrave = 278, t.Imacron = 278, t.Lcaron = 611, t.onehalf = 834, t.lessequal = 549, t.ocircumflex = 611, t.ntilde = 611, t.Uhungarumlaut = 722, t.Eacute = 667, t.emacron = 556, t.gbreve = 611, t.onequarter = 834, t.Scaron = 667, t.Scommaaccent = 667, t.Ohungarumlaut = 778, t.degree = 400, t.ograve = 611, t.Ccaron = 722, t.ugrave = 611, t.radical = 549, t.Dcaron = 722, t.rcommaaccent = 389, t.Ntilde = 722, t.otilde = 611, t.Rcommaaccent = 722, t.Lcommaaccent = 611, t.Atilde = 722, t.Aogonek = 722, t.Aring = 722, t.Otilde = 778, t.zdotaccent = 500, t.Ecaron = 667, t.Iogonek = 278, t.kcommaaccent = 556, t.minus = 584, t.Icircumflex = 278, t.ncaron = 611, t.tcommaaccent = 333, t.logicalnot = 584, t.odieresis = 611, t.udieresis = 611, t.notequal = 549, t.gcommaaccent = 611, t.eth = 611, t.zcaron = 500, t.ncommaaccent = 611, t.onesuperior = 333, t.imacron = 278, t.Euro = 556;
            }), e["Helvetica-BoldOblique"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 278, t.exclam = 333, t.quotedbl = 474, t.numbersign = 556, t.dollar = 556, t.percent = 889, t.ampersand = 722, t.quoteright = 278, t.parenleft = 333, t.parenright = 333, t.asterisk = 389, t.plus = 584, t.comma = 278, t.hyphen = 333, t.period = 278, t.slash = 278, t.zero = 556, t.one = 556, t.two = 556, t.three = 556, t.four = 556, t.five = 556, t.six = 556, t.seven = 556, t.eight = 556, t.nine = 556, t.colon = 333, t.semicolon = 333, t.less = 584, t.equal = 584, t.greater = 584, t.question = 611, t.at = 975, t.A = 722, t.B = 722, t.C = 722, t.D = 722, t.E = 667, t.F = 611, t.G = 778, t.H = 722, t.I = 278, t.J = 556, t.K = 722, t.L = 611, t.M = 833, t.N = 722, t.O = 778, t.P = 667, t.Q = 778, t.R = 722, t.S = 667, t.T = 611, t.U = 722, t.V = 667, t.W = 944, t.X = 667, t.Y = 667, t.Z = 611, t.bracketleft = 333, t.backslash = 278, t.bracketright = 333, t.asciicircum = 584, t.underscore = 556, t.quoteleft = 278, t.a = 556, t.b = 611, t.c = 556, t.d = 611, t.e = 556, t.f = 333, t.g = 611, t.h = 611, t.i = 278, t.j = 278, t.k = 556, t.l = 278, t.m = 889, t.n = 611, t.o = 611, t.p = 611, t.q = 611, t.r = 389, t.s = 556, t.t = 333, t.u = 611, t.v = 556, t.w = 778, t.x = 556, t.y = 556, t.z = 500, t.braceleft = 389, t.bar = 280, t.braceright = 389, t.asciitilde = 584, t.exclamdown = 333, t.cent = 556, t.sterling = 556, t.fraction = 167, t.yen = 556, t.florin = 556, t.section = 556, t.currency = 556, t.quotesingle = 238, t.quotedblleft = 500, t.guillemotleft = 556, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 611, t.fl = 611, t.endash = 556, t.dagger = 556, t.daggerdbl = 556, t.periodcentered = 278, t.paragraph = 556, t.bullet = 350, t.quotesinglbase = 278, t.quotedblbase = 500, t.quotedblright = 500, t.guillemotright = 556, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 611, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 1e3, t.ordfeminine = 370, t.Lslash = 611, t.Oslash = 778, t.OE = 1e3, t.ordmasculine = 365, t.ae = 889, t.dotlessi = 278, t.lslash = 278, t.oslash = 611, t.oe = 944, t.germandbls = 611, t.Idieresis = 278, t.eacute = 556, t.abreve = 556, t.uhungarumlaut = 611, t.ecaron = 556, t.Ydieresis = 667, t.divide = 584, t.Yacute = 667, t.Acircumflex = 722, t.aacute = 556, t.Ucircumflex = 722, t.yacute = 556, t.scommaaccent = 556, t.ecircumflex = 556, t.Uring = 722, t.Udieresis = 722, t.aogonek = 556, t.Uacute = 722, t.uogonek = 611, t.Edieresis = 667, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 737, t.Emacron = 667, t.ccaron = 556, t.aring = 556, t.Ncommaaccent = 722, t.lacute = 278, t.agrave = 556, t.Tcommaaccent = 611, t.Cacute = 722, t.atilde = 556, t.Edotaccent = 667, t.scaron = 556, t.scedilla = 556, t.iacute = 278, t.lozenge = 494, t.Rcaron = 722, t.Gcommaaccent = 778, t.ucircumflex = 611, t.acircumflex = 556, t.Amacron = 722, t.rcaron = 389, t.ccedilla = 556, t.Zdotaccent = 611, t.Thorn = 667, t.Omacron = 778, t.Racute = 722, t.Sacute = 667, t.dcaron = 743, t.Umacron = 722, t.uring = 611, t.threesuperior = 333, t.Ograve = 778, t.Agrave = 722, t.Abreve = 722, t.multiply = 584, t.uacute = 611, t.Tcaron = 611, t.partialdiff = 494, t.ydieresis = 556, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 667, t.adieresis = 556, t.edieresis = 556, t.cacute = 556, t.nacute = 611, t.umacron = 611, t.Ncaron = 722, t.Iacute = 278, t.plusminus = 584, t.brokenbar = 280, t.registered = 737, t.Gbreve = 778, t.Idotaccent = 278, t.summation = 600, t.Egrave = 667, t.racute = 389, t.omacron = 611, t.Zacute = 611, t.Zcaron = 611, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 722, t.lcommaaccent = 278, t.tcaron = 389, t.eogonek = 556, t.Uogonek = 722, t.Aacute = 722, t.Adieresis = 722, t.egrave = 556, t.zacute = 500, t.iogonek = 278, t.Oacute = 778, t.oacute = 611, t.amacron = 556, t.sacute = 556, t.idieresis = 278, t.Ocircumflex = 778, t.Ugrave = 722, t.Delta = 612, t.thorn = 611, t.twosuperior = 333, t.Odieresis = 778, t.mu = 611, t.igrave = 278, t.ohungarumlaut = 611, t.Eogonek = 667, t.dcroat = 611, t.threequarters = 834, t.Scedilla = 667, t.lcaron = 400, t.Kcommaaccent = 722, t.Lacute = 611, t.trademark = 1e3, t.edotaccent = 556, t.Igrave = 278, t.Imacron = 278, t.Lcaron = 611, t.onehalf = 834, t.lessequal = 549, t.ocircumflex = 611, t.ntilde = 611, t.Uhungarumlaut = 722, t.Eacute = 667, t.emacron = 556, t.gbreve = 611, t.onequarter = 834, t.Scaron = 667, t.Scommaaccent = 667, t.Ohungarumlaut = 778, t.degree = 400, t.ograve = 611, t.Ccaron = 722, t.ugrave = 611, t.radical = 549, t.Dcaron = 722, t.rcommaaccent = 389, t.Ntilde = 722, t.otilde = 611, t.Rcommaaccent = 722, t.Lcommaaccent = 611, t.Atilde = 722, t.Aogonek = 722, t.Aring = 722, t.Otilde = 778, t.zdotaccent = 500, t.Ecaron = 667, t.Iogonek = 278, t.kcommaaccent = 556, t.minus = 584, t.Icircumflex = 278, t.ncaron = 611, t.tcommaaccent = 333, t.logicalnot = 584, t.odieresis = 611, t.udieresis = 611, t.notequal = 549, t.gcommaaccent = 611, t.eth = 611, t.zcaron = 500, t.ncommaaccent = 611, t.onesuperior = 333, t.imacron = 278, t.Euro = 556;
            }), e["Helvetica-Oblique"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 278, t.exclam = 278, t.quotedbl = 355, t.numbersign = 556, t.dollar = 556, t.percent = 889, t.ampersand = 667, t.quoteright = 222, t.parenleft = 333, t.parenright = 333, t.asterisk = 389, t.plus = 584, t.comma = 278, t.hyphen = 333, t.period = 278, t.slash = 278, t.zero = 556, t.one = 556, t.two = 556, t.three = 556, t.four = 556, t.five = 556, t.six = 556, t.seven = 556, t.eight = 556, t.nine = 556, t.colon = 278, t.semicolon = 278, t.less = 584, t.equal = 584, t.greater = 584, t.question = 556, t.at = 1015, t.A = 667, t.B = 667, t.C = 722, t.D = 722, t.E = 667, t.F = 611, t.G = 778, t.H = 722, t.I = 278, t.J = 500, t.K = 667, t.L = 556, t.M = 833, t.N = 722, t.O = 778, t.P = 667, t.Q = 778, t.R = 722, t.S = 667, t.T = 611, t.U = 722, t.V = 667, t.W = 944, t.X = 667, t.Y = 667, t.Z = 611, t.bracketleft = 278, t.backslash = 278, t.bracketright = 278, t.asciicircum = 469, t.underscore = 556, t.quoteleft = 222, t.a = 556, t.b = 556, t.c = 500, t.d = 556, t.e = 556, t.f = 278, t.g = 556, t.h = 556, t.i = 222, t.j = 222, t.k = 500, t.l = 222, t.m = 833, t.n = 556, t.o = 556, t.p = 556, t.q = 556, t.r = 333, t.s = 500, t.t = 278, t.u = 556, t.v = 500, t.w = 722, t.x = 500, t.y = 500, t.z = 500, t.braceleft = 334, t.bar = 260, t.braceright = 334, t.asciitilde = 584, t.exclamdown = 333, t.cent = 556, t.sterling = 556, t.fraction = 167, t.yen = 556, t.florin = 556, t.section = 556, t.currency = 556, t.quotesingle = 191, t.quotedblleft = 333, t.guillemotleft = 556, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 500, t.fl = 500, t.endash = 556, t.dagger = 556, t.daggerdbl = 556, t.periodcentered = 278, t.paragraph = 537, t.bullet = 350, t.quotesinglbase = 222, t.quotedblbase = 333, t.quotedblright = 333, t.guillemotright = 556, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 611, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 1e3, t.ordfeminine = 370, t.Lslash = 556, t.Oslash = 778, t.OE = 1e3, t.ordmasculine = 365, t.ae = 889, t.dotlessi = 278, t.lslash = 222, t.oslash = 611, t.oe = 944, t.germandbls = 611, t.Idieresis = 278, t.eacute = 556, t.abreve = 556, t.uhungarumlaut = 556, t.ecaron = 556, t.Ydieresis = 667, t.divide = 584, t.Yacute = 667, t.Acircumflex = 667, t.aacute = 556, t.Ucircumflex = 722, t.yacute = 500, t.scommaaccent = 500, t.ecircumflex = 556, t.Uring = 722, t.Udieresis = 722, t.aogonek = 556, t.Uacute = 722, t.uogonek = 556, t.Edieresis = 667, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 737, t.Emacron = 667, t.ccaron = 500, t.aring = 556, t.Ncommaaccent = 722, t.lacute = 222, t.agrave = 556, t.Tcommaaccent = 611, t.Cacute = 722, t.atilde = 556, t.Edotaccent = 667, t.scaron = 500, t.scedilla = 500, t.iacute = 278, t.lozenge = 471, t.Rcaron = 722, t.Gcommaaccent = 778, t.ucircumflex = 556, t.acircumflex = 556, t.Amacron = 667, t.rcaron = 333, t.ccedilla = 500, t.Zdotaccent = 611, t.Thorn = 667, t.Omacron = 778, t.Racute = 722, t.Sacute = 667, t.dcaron = 643, t.Umacron = 722, t.uring = 556, t.threesuperior = 333, t.Ograve = 778, t.Agrave = 667, t.Abreve = 667, t.multiply = 584, t.uacute = 556, t.Tcaron = 611, t.partialdiff = 476, t.ydieresis = 500, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 667, t.adieresis = 556, t.edieresis = 556, t.cacute = 500, t.nacute = 556, t.umacron = 556, t.Ncaron = 722, t.Iacute = 278, t.plusminus = 584, t.brokenbar = 260, t.registered = 737, t.Gbreve = 778, t.Idotaccent = 278, t.summation = 600, t.Egrave = 667, t.racute = 333, t.omacron = 556, t.Zacute = 611, t.Zcaron = 611, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 722, t.lcommaaccent = 222, t.tcaron = 317, t.eogonek = 556, t.Uogonek = 722, t.Aacute = 667, t.Adieresis = 667, t.egrave = 556, t.zacute = 500, t.iogonek = 222, t.Oacute = 778, t.oacute = 556, t.amacron = 556, t.sacute = 500, t.idieresis = 278, t.Ocircumflex = 778, t.Ugrave = 722, t.Delta = 612, t.thorn = 556, t.twosuperior = 333, t.Odieresis = 778, t.mu = 556, t.igrave = 278, t.ohungarumlaut = 556, t.Eogonek = 667, t.dcroat = 556, t.threequarters = 834, t.Scedilla = 667, t.lcaron = 299, t.Kcommaaccent = 667, t.Lacute = 556, t.trademark = 1e3, t.edotaccent = 556, t.Igrave = 278, t.Imacron = 278, t.Lcaron = 556, t.onehalf = 834, t.lessequal = 549, t.ocircumflex = 556, t.ntilde = 556, t.Uhungarumlaut = 722, t.Eacute = 667, t.emacron = 556, t.gbreve = 556, t.onequarter = 834, t.Scaron = 667, t.Scommaaccent = 667, t.Ohungarumlaut = 778, t.degree = 400, t.ograve = 556, t.Ccaron = 722, t.ugrave = 556, t.radical = 453, t.Dcaron = 722, t.rcommaaccent = 333, t.Ntilde = 722, t.otilde = 556, t.Rcommaaccent = 722, t.Lcommaaccent = 556, t.Atilde = 667, t.Aogonek = 667, t.Aring = 667, t.Otilde = 778, t.zdotaccent = 500, t.Ecaron = 667, t.Iogonek = 278, t.kcommaaccent = 500, t.minus = 584, t.Icircumflex = 278, t.ncaron = 556, t.tcommaaccent = 278, t.logicalnot = 584, t.odieresis = 556, t.udieresis = 556, t.notequal = 549, t.gcommaaccent = 556, t.eth = 556, t.zcaron = 500, t.ncommaaccent = 556, t.onesuperior = 333, t.imacron = 278, t.Euro = 556;
            }), e.Symbol = (0, n.getLookupTableFactory)(function(t) {
              t.space = 250, t.exclam = 333, t.universal = 713, t.numbersign = 500, t.existential = 549, t.percent = 833, t.ampersand = 778, t.suchthat = 439, t.parenleft = 333, t.parenright = 333, t.asteriskmath = 500, t.plus = 549, t.comma = 250, t.minus = 549, t.period = 250, t.slash = 278, t.zero = 500, t.one = 500, t.two = 500, t.three = 500, t.four = 500, t.five = 500, t.six = 500, t.seven = 500, t.eight = 500, t.nine = 500, t.colon = 278, t.semicolon = 278, t.less = 549, t.equal = 549, t.greater = 549, t.question = 444, t.congruent = 549, t.Alpha = 722, t.Beta = 667, t.Chi = 722, t.Delta = 612, t.Epsilon = 611, t.Phi = 763, t.Gamma = 603, t.Eta = 722, t.Iota = 333, t.theta1 = 631, t.Kappa = 722, t.Lambda = 686, t.Mu = 889, t.Nu = 722, t.Omicron = 722, t.Pi = 768, t.Theta = 741, t.Rho = 556, t.Sigma = 592, t.Tau = 611, t.Upsilon = 690, t.sigma1 = 439, t.Omega = 768, t.Xi = 645, t.Psi = 795, t.Zeta = 611, t.bracketleft = 333, t.therefore = 863, t.bracketright = 333, t.perpendicular = 658, t.underscore = 500, t.radicalex = 500, t.alpha = 631, t.beta = 549, t.chi = 549, t.delta = 494, t.epsilon = 439, t.phi = 521, t.gamma = 411, t.eta = 603, t.iota = 329, t.phi1 = 603, t.kappa = 549, t.lambda = 549, t.mu = 576, t.nu = 521, t.omicron = 549, t.pi = 549, t.theta = 521, t.rho = 549, t.sigma = 603, t.tau = 439, t.upsilon = 576, t.omega1 = 713, t.omega = 686, t.xi = 493, t.psi = 686, t.zeta = 494, t.braceleft = 480, t.bar = 200, t.braceright = 480, t.similar = 549, t.Euro = 750, t.Upsilon1 = 620, t.minute = 247, t.lessequal = 549, t.fraction = 167, t.infinity = 713, t.florin = 500, t.club = 753, t.diamond = 753, t.heart = 753, t.spade = 753, t.arrowboth = 1042, t.arrowleft = 987, t.arrowup = 603, t.arrowright = 987, t.arrowdown = 603, t.degree = 400, t.plusminus = 549, t.second = 411, t.greaterequal = 549, t.multiply = 549, t.proportional = 713, t.partialdiff = 494, t.bullet = 460, t.divide = 549, t.notequal = 549, t.equivalence = 549, t.approxequal = 549, t.ellipsis = 1e3, t.arrowvertex = 603, t.arrowhorizex = 1e3, t.carriagereturn = 658, t.aleph = 823, t.Ifraktur = 686, t.Rfraktur = 795, t.weierstrass = 987, t.circlemultiply = 768, t.circleplus = 768, t.emptyset = 823, t.intersection = 768, t.union = 768, t.propersuperset = 713, t.reflexsuperset = 713, t.notsubset = 713, t.propersubset = 713, t.reflexsubset = 713, t.element = 713, t.notelement = 713, t.angle = 768, t.gradient = 713, t.registerserif = 790, t.copyrightserif = 790, t.trademarkserif = 890, t.product = 823, t.radical = 549, t.dotmath = 250, t.logicalnot = 713, t.logicaland = 603, t.logicalor = 603, t.arrowdblboth = 1042, t.arrowdblleft = 987, t.arrowdblup = 603, t.arrowdblright = 987, t.arrowdbldown = 603, t.lozenge = 494, t.angleleft = 329, t.registersans = 790, t.copyrightsans = 790, t.trademarksans = 786, t.summation = 713, t.parenlefttp = 384, t.parenleftex = 384, t.parenleftbt = 384, t.bracketlefttp = 384, t.bracketleftex = 384, t.bracketleftbt = 384, t.bracelefttp = 494, t.braceleftmid = 494, t.braceleftbt = 494, t.braceex = 494, t.angleright = 329, t.integral = 274, t.integraltp = 686, t.integralex = 686, t.integralbt = 686, t.parenrighttp = 384, t.parenrightex = 384, t.parenrightbt = 384, t.bracketrighttp = 384, t.bracketrightex = 384, t.bracketrightbt = 384, t.bracerighttp = 494, t.bracerightmid = 494, t.bracerightbt = 494, t.apple = 790;
            }), e["Times-Roman"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 250, t.exclam = 333, t.quotedbl = 408, t.numbersign = 500, t.dollar = 500, t.percent = 833, t.ampersand = 778, t.quoteright = 333, t.parenleft = 333, t.parenright = 333, t.asterisk = 500, t.plus = 564, t.comma = 250, t.hyphen = 333, t.period = 250, t.slash = 278, t.zero = 500, t.one = 500, t.two = 500, t.three = 500, t.four = 500, t.five = 500, t.six = 500, t.seven = 500, t.eight = 500, t.nine = 500, t.colon = 278, t.semicolon = 278, t.less = 564, t.equal = 564, t.greater = 564, t.question = 444, t.at = 921, t.A = 722, t.B = 667, t.C = 667, t.D = 722, t.E = 611, t.F = 556, t.G = 722, t.H = 722, t.I = 333, t.J = 389, t.K = 722, t.L = 611, t.M = 889, t.N = 722, t.O = 722, t.P = 556, t.Q = 722, t.R = 667, t.S = 556, t.T = 611, t.U = 722, t.V = 722, t.W = 944, t.X = 722, t.Y = 722, t.Z = 611, t.bracketleft = 333, t.backslash = 278, t.bracketright = 333, t.asciicircum = 469, t.underscore = 500, t.quoteleft = 333, t.a = 444, t.b = 500, t.c = 444, t.d = 500, t.e = 444, t.f = 333, t.g = 500, t.h = 500, t.i = 278, t.j = 278, t.k = 500, t.l = 278, t.m = 778, t.n = 500, t.o = 500, t.p = 500, t.q = 500, t.r = 333, t.s = 389, t.t = 278, t.u = 500, t.v = 500, t.w = 722, t.x = 500, t.y = 500, t.z = 444, t.braceleft = 480, t.bar = 200, t.braceright = 480, t.asciitilde = 541, t.exclamdown = 333, t.cent = 500, t.sterling = 500, t.fraction = 167, t.yen = 500, t.florin = 500, t.section = 500, t.currency = 500, t.quotesingle = 180, t.quotedblleft = 444, t.guillemotleft = 500, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 556, t.fl = 556, t.endash = 500, t.dagger = 500, t.daggerdbl = 500, t.periodcentered = 250, t.paragraph = 453, t.bullet = 350, t.quotesinglbase = 333, t.quotedblbase = 444, t.quotedblright = 444, t.guillemotright = 500, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 444, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 889, t.ordfeminine = 276, t.Lslash = 611, t.Oslash = 722, t.OE = 889, t.ordmasculine = 310, t.ae = 667, t.dotlessi = 278, t.lslash = 278, t.oslash = 500, t.oe = 722, t.germandbls = 500, t.Idieresis = 333, t.eacute = 444, t.abreve = 444, t.uhungarumlaut = 500, t.ecaron = 444, t.Ydieresis = 722, t.divide = 564, t.Yacute = 722, t.Acircumflex = 722, t.aacute = 444, t.Ucircumflex = 722, t.yacute = 500, t.scommaaccent = 389, t.ecircumflex = 444, t.Uring = 722, t.Udieresis = 722, t.aogonek = 444, t.Uacute = 722, t.uogonek = 500, t.Edieresis = 611, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 760, t.Emacron = 611, t.ccaron = 444, t.aring = 444, t.Ncommaaccent = 722, t.lacute = 278, t.agrave = 444, t.Tcommaaccent = 611, t.Cacute = 667, t.atilde = 444, t.Edotaccent = 611, t.scaron = 389, t.scedilla = 389, t.iacute = 278, t.lozenge = 471, t.Rcaron = 667, t.Gcommaaccent = 722, t.ucircumflex = 500, t.acircumflex = 444, t.Amacron = 722, t.rcaron = 333, t.ccedilla = 444, t.Zdotaccent = 611, t.Thorn = 556, t.Omacron = 722, t.Racute = 667, t.Sacute = 556, t.dcaron = 588, t.Umacron = 722, t.uring = 500, t.threesuperior = 300, t.Ograve = 722, t.Agrave = 722, t.Abreve = 722, t.multiply = 564, t.uacute = 500, t.Tcaron = 611, t.partialdiff = 476, t.ydieresis = 500, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 611, t.adieresis = 444, t.edieresis = 444, t.cacute = 444, t.nacute = 500, t.umacron = 500, t.Ncaron = 722, t.Iacute = 333, t.plusminus = 564, t.brokenbar = 200, t.registered = 760, t.Gbreve = 722, t.Idotaccent = 333, t.summation = 600, t.Egrave = 611, t.racute = 333, t.omacron = 500, t.Zacute = 611, t.Zcaron = 611, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 667, t.lcommaaccent = 278, t.tcaron = 326, t.eogonek = 444, t.Uogonek = 722, t.Aacute = 722, t.Adieresis = 722, t.egrave = 444, t.zacute = 444, t.iogonek = 278, t.Oacute = 722, t.oacute = 500, t.amacron = 444, t.sacute = 389, t.idieresis = 278, t.Ocircumflex = 722, t.Ugrave = 722, t.Delta = 612, t.thorn = 500, t.twosuperior = 300, t.Odieresis = 722, t.mu = 500, t.igrave = 278, t.ohungarumlaut = 500, t.Eogonek = 611, t.dcroat = 500, t.threequarters = 750, t.Scedilla = 556, t.lcaron = 344, t.Kcommaaccent = 722, t.Lacute = 611, t.trademark = 980, t.edotaccent = 444, t.Igrave = 333, t.Imacron = 333, t.Lcaron = 611, t.onehalf = 750, t.lessequal = 549, t.ocircumflex = 500, t.ntilde = 500, t.Uhungarumlaut = 722, t.Eacute = 611, t.emacron = 444, t.gbreve = 500, t.onequarter = 750, t.Scaron = 556, t.Scommaaccent = 556, t.Ohungarumlaut = 722, t.degree = 400, t.ograve = 500, t.Ccaron = 667, t.ugrave = 500, t.radical = 453, t.Dcaron = 722, t.rcommaaccent = 333, t.Ntilde = 722, t.otilde = 500, t.Rcommaaccent = 667, t.Lcommaaccent = 611, t.Atilde = 722, t.Aogonek = 722, t.Aring = 722, t.Otilde = 722, t.zdotaccent = 444, t.Ecaron = 611, t.Iogonek = 333, t.kcommaaccent = 500, t.minus = 564, t.Icircumflex = 333, t.ncaron = 500, t.tcommaaccent = 278, t.logicalnot = 564, t.odieresis = 500, t.udieresis = 500, t.notequal = 549, t.gcommaaccent = 500, t.eth = 500, t.zcaron = 444, t.ncommaaccent = 500, t.onesuperior = 300, t.imacron = 278, t.Euro = 500;
            }), e["Times-Bold"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 250, t.exclam = 333, t.quotedbl = 555, t.numbersign = 500, t.dollar = 500, t.percent = 1e3, t.ampersand = 833, t.quoteright = 333, t.parenleft = 333, t.parenright = 333, t.asterisk = 500, t.plus = 570, t.comma = 250, t.hyphen = 333, t.period = 250, t.slash = 278, t.zero = 500, t.one = 500, t.two = 500, t.three = 500, t.four = 500, t.five = 500, t.six = 500, t.seven = 500, t.eight = 500, t.nine = 500, t.colon = 333, t.semicolon = 333, t.less = 570, t.equal = 570, t.greater = 570, t.question = 500, t.at = 930, t.A = 722, t.B = 667, t.C = 722, t.D = 722, t.E = 667, t.F = 611, t.G = 778, t.H = 778, t.I = 389, t.J = 500, t.K = 778, t.L = 667, t.M = 944, t.N = 722, t.O = 778, t.P = 611, t.Q = 778, t.R = 722, t.S = 556, t.T = 667, t.U = 722, t.V = 722, t.W = 1e3, t.X = 722, t.Y = 722, t.Z = 667, t.bracketleft = 333, t.backslash = 278, t.bracketright = 333, t.asciicircum = 581, t.underscore = 500, t.quoteleft = 333, t.a = 500, t.b = 556, t.c = 444, t.d = 556, t.e = 444, t.f = 333, t.g = 500, t.h = 556, t.i = 278, t.j = 333, t.k = 556, t.l = 278, t.m = 833, t.n = 556, t.o = 500, t.p = 556, t.q = 556, t.r = 444, t.s = 389, t.t = 333, t.u = 556, t.v = 500, t.w = 722, t.x = 500, t.y = 500, t.z = 444, t.braceleft = 394, t.bar = 220, t.braceright = 394, t.asciitilde = 520, t.exclamdown = 333, t.cent = 500, t.sterling = 500, t.fraction = 167, t.yen = 500, t.florin = 500, t.section = 500, t.currency = 500, t.quotesingle = 278, t.quotedblleft = 500, t.guillemotleft = 500, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 556, t.fl = 556, t.endash = 500, t.dagger = 500, t.daggerdbl = 500, t.periodcentered = 250, t.paragraph = 540, t.bullet = 350, t.quotesinglbase = 333, t.quotedblbase = 500, t.quotedblright = 500, t.guillemotright = 500, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 500, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 1e3, t.ordfeminine = 300, t.Lslash = 667, t.Oslash = 778, t.OE = 1e3, t.ordmasculine = 330, t.ae = 722, t.dotlessi = 278, t.lslash = 278, t.oslash = 500, t.oe = 722, t.germandbls = 556, t.Idieresis = 389, t.eacute = 444, t.abreve = 500, t.uhungarumlaut = 556, t.ecaron = 444, t.Ydieresis = 722, t.divide = 570, t.Yacute = 722, t.Acircumflex = 722, t.aacute = 500, t.Ucircumflex = 722, t.yacute = 500, t.scommaaccent = 389, t.ecircumflex = 444, t.Uring = 722, t.Udieresis = 722, t.aogonek = 500, t.Uacute = 722, t.uogonek = 556, t.Edieresis = 667, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 747, t.Emacron = 667, t.ccaron = 444, t.aring = 500, t.Ncommaaccent = 722, t.lacute = 278, t.agrave = 500, t.Tcommaaccent = 667, t.Cacute = 722, t.atilde = 500, t.Edotaccent = 667, t.scaron = 389, t.scedilla = 389, t.iacute = 278, t.lozenge = 494, t.Rcaron = 722, t.Gcommaaccent = 778, t.ucircumflex = 556, t.acircumflex = 500, t.Amacron = 722, t.rcaron = 444, t.ccedilla = 444, t.Zdotaccent = 667, t.Thorn = 611, t.Omacron = 778, t.Racute = 722, t.Sacute = 556, t.dcaron = 672, t.Umacron = 722, t.uring = 556, t.threesuperior = 300, t.Ograve = 778, t.Agrave = 722, t.Abreve = 722, t.multiply = 570, t.uacute = 556, t.Tcaron = 667, t.partialdiff = 494, t.ydieresis = 500, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 667, t.adieresis = 500, t.edieresis = 444, t.cacute = 444, t.nacute = 556, t.umacron = 556, t.Ncaron = 722, t.Iacute = 389, t.plusminus = 570, t.brokenbar = 220, t.registered = 747, t.Gbreve = 778, t.Idotaccent = 389, t.summation = 600, t.Egrave = 667, t.racute = 444, t.omacron = 500, t.Zacute = 667, t.Zcaron = 667, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 722, t.lcommaaccent = 278, t.tcaron = 416, t.eogonek = 444, t.Uogonek = 722, t.Aacute = 722, t.Adieresis = 722, t.egrave = 444, t.zacute = 444, t.iogonek = 278, t.Oacute = 778, t.oacute = 500, t.amacron = 500, t.sacute = 389, t.idieresis = 278, t.Ocircumflex = 778, t.Ugrave = 722, t.Delta = 612, t.thorn = 556, t.twosuperior = 300, t.Odieresis = 778, t.mu = 556, t.igrave = 278, t.ohungarumlaut = 500, t.Eogonek = 667, t.dcroat = 556, t.threequarters = 750, t.Scedilla = 556, t.lcaron = 394, t.Kcommaaccent = 778, t.Lacute = 667, t.trademark = 1e3, t.edotaccent = 444, t.Igrave = 389, t.Imacron = 389, t.Lcaron = 667, t.onehalf = 750, t.lessequal = 549, t.ocircumflex = 500, t.ntilde = 556, t.Uhungarumlaut = 722, t.Eacute = 667, t.emacron = 444, t.gbreve = 500, t.onequarter = 750, t.Scaron = 556, t.Scommaaccent = 556, t.Ohungarumlaut = 778, t.degree = 400, t.ograve = 500, t.Ccaron = 722, t.ugrave = 556, t.radical = 549, t.Dcaron = 722, t.rcommaaccent = 444, t.Ntilde = 722, t.otilde = 500, t.Rcommaaccent = 722, t.Lcommaaccent = 667, t.Atilde = 722, t.Aogonek = 722, t.Aring = 722, t.Otilde = 778, t.zdotaccent = 444, t.Ecaron = 667, t.Iogonek = 389, t.kcommaaccent = 556, t.minus = 570, t.Icircumflex = 389, t.ncaron = 556, t.tcommaaccent = 333, t.logicalnot = 570, t.odieresis = 500, t.udieresis = 556, t.notequal = 549, t.gcommaaccent = 500, t.eth = 500, t.zcaron = 444, t.ncommaaccent = 556, t.onesuperior = 300, t.imacron = 278, t.Euro = 500;
            }), e["Times-BoldItalic"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 250, t.exclam = 389, t.quotedbl = 555, t.numbersign = 500, t.dollar = 500, t.percent = 833, t.ampersand = 778, t.quoteright = 333, t.parenleft = 333, t.parenright = 333, t.asterisk = 500, t.plus = 570, t.comma = 250, t.hyphen = 333, t.period = 250, t.slash = 278, t.zero = 500, t.one = 500, t.two = 500, t.three = 500, t.four = 500, t.five = 500, t.six = 500, t.seven = 500, t.eight = 500, t.nine = 500, t.colon = 333, t.semicolon = 333, t.less = 570, t.equal = 570, t.greater = 570, t.question = 500, t.at = 832, t.A = 667, t.B = 667, t.C = 667, t.D = 722, t.E = 667, t.F = 667, t.G = 722, t.H = 778, t.I = 389, t.J = 500, t.K = 667, t.L = 611, t.M = 889, t.N = 722, t.O = 722, t.P = 611, t.Q = 722, t.R = 667, t.S = 556, t.T = 611, t.U = 722, t.V = 667, t.W = 889, t.X = 667, t.Y = 611, t.Z = 611, t.bracketleft = 333, t.backslash = 278, t.bracketright = 333, t.asciicircum = 570, t.underscore = 500, t.quoteleft = 333, t.a = 500, t.b = 500, t.c = 444, t.d = 500, t.e = 444, t.f = 333, t.g = 500, t.h = 556, t.i = 278, t.j = 278, t.k = 500, t.l = 278, t.m = 778, t.n = 556, t.o = 500, t.p = 500, t.q = 500, t.r = 389, t.s = 389, t.t = 278, t.u = 556, t.v = 444, t.w = 667, t.x = 500, t.y = 444, t.z = 389, t.braceleft = 348, t.bar = 220, t.braceright = 348, t.asciitilde = 570, t.exclamdown = 389, t.cent = 500, t.sterling = 500, t.fraction = 167, t.yen = 500, t.florin = 500, t.section = 500, t.currency = 500, t.quotesingle = 278, t.quotedblleft = 500, t.guillemotleft = 500, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 556, t.fl = 556, t.endash = 500, t.dagger = 500, t.daggerdbl = 500, t.periodcentered = 250, t.paragraph = 500, t.bullet = 350, t.quotesinglbase = 333, t.quotedblbase = 500, t.quotedblright = 500, t.guillemotright = 500, t.ellipsis = 1e3, t.perthousand = 1e3, t.questiondown = 500, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 1e3, t.AE = 944, t.ordfeminine = 266, t.Lslash = 611, t.Oslash = 722, t.OE = 944, t.ordmasculine = 300, t.ae = 722, t.dotlessi = 278, t.lslash = 278, t.oslash = 500, t.oe = 722, t.germandbls = 500, t.Idieresis = 389, t.eacute = 444, t.abreve = 500, t.uhungarumlaut = 556, t.ecaron = 444, t.Ydieresis = 611, t.divide = 570, t.Yacute = 611, t.Acircumflex = 667, t.aacute = 500, t.Ucircumflex = 722, t.yacute = 444, t.scommaaccent = 389, t.ecircumflex = 444, t.Uring = 722, t.Udieresis = 722, t.aogonek = 500, t.Uacute = 722, t.uogonek = 556, t.Edieresis = 667, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 747, t.Emacron = 667, t.ccaron = 444, t.aring = 500, t.Ncommaaccent = 722, t.lacute = 278, t.agrave = 500, t.Tcommaaccent = 611, t.Cacute = 667, t.atilde = 500, t.Edotaccent = 667, t.scaron = 389, t.scedilla = 389, t.iacute = 278, t.lozenge = 494, t.Rcaron = 667, t.Gcommaaccent = 722, t.ucircumflex = 556, t.acircumflex = 500, t.Amacron = 667, t.rcaron = 389, t.ccedilla = 444, t.Zdotaccent = 611, t.Thorn = 611, t.Omacron = 722, t.Racute = 667, t.Sacute = 556, t.dcaron = 608, t.Umacron = 722, t.uring = 556, t.threesuperior = 300, t.Ograve = 722, t.Agrave = 667, t.Abreve = 667, t.multiply = 570, t.uacute = 556, t.Tcaron = 611, t.partialdiff = 494, t.ydieresis = 444, t.Nacute = 722, t.icircumflex = 278, t.Ecircumflex = 667, t.adieresis = 500, t.edieresis = 444, t.cacute = 444, t.nacute = 556, t.umacron = 556, t.Ncaron = 722, t.Iacute = 389, t.plusminus = 570, t.brokenbar = 220, t.registered = 747, t.Gbreve = 722, t.Idotaccent = 389, t.summation = 600, t.Egrave = 667, t.racute = 389, t.omacron = 500, t.Zacute = 611, t.Zcaron = 611, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 667, t.lcommaaccent = 278, t.tcaron = 366, t.eogonek = 444, t.Uogonek = 722, t.Aacute = 667, t.Adieresis = 667, t.egrave = 444, t.zacute = 389, t.iogonek = 278, t.Oacute = 722, t.oacute = 500, t.amacron = 500, t.sacute = 389, t.idieresis = 278, t.Ocircumflex = 722, t.Ugrave = 722, t.Delta = 612, t.thorn = 500, t.twosuperior = 300, t.Odieresis = 722, t.mu = 576, t.igrave = 278, t.ohungarumlaut = 500, t.Eogonek = 667, t.dcroat = 500, t.threequarters = 750, t.Scedilla = 556, t.lcaron = 382, t.Kcommaaccent = 667, t.Lacute = 611, t.trademark = 1e3, t.edotaccent = 444, t.Igrave = 389, t.Imacron = 389, t.Lcaron = 611, t.onehalf = 750, t.lessequal = 549, t.ocircumflex = 500, t.ntilde = 556, t.Uhungarumlaut = 722, t.Eacute = 667, t.emacron = 444, t.gbreve = 500, t.onequarter = 750, t.Scaron = 556, t.Scommaaccent = 556, t.Ohungarumlaut = 722, t.degree = 400, t.ograve = 500, t.Ccaron = 667, t.ugrave = 556, t.radical = 549, t.Dcaron = 722, t.rcommaaccent = 389, t.Ntilde = 722, t.otilde = 500, t.Rcommaaccent = 667, t.Lcommaaccent = 611, t.Atilde = 667, t.Aogonek = 667, t.Aring = 667, t.Otilde = 722, t.zdotaccent = 389, t.Ecaron = 667, t.Iogonek = 389, t.kcommaaccent = 500, t.minus = 606, t.Icircumflex = 389, t.ncaron = 556, t.tcommaaccent = 278, t.logicalnot = 606, t.odieresis = 500, t.udieresis = 556, t.notequal = 549, t.gcommaaccent = 500, t.eth = 500, t.zcaron = 389, t.ncommaaccent = 556, t.onesuperior = 300, t.imacron = 278, t.Euro = 500;
            }), e["Times-Italic"] = (0, n.getLookupTableFactory)(function(t) {
              t.space = 250, t.exclam = 333, t.quotedbl = 420, t.numbersign = 500, t.dollar = 500, t.percent = 833, t.ampersand = 778, t.quoteright = 333, t.parenleft = 333, t.parenright = 333, t.asterisk = 500, t.plus = 675, t.comma = 250, t.hyphen = 333, t.period = 250, t.slash = 278, t.zero = 500, t.one = 500, t.two = 500, t.three = 500, t.four = 500, t.five = 500, t.six = 500, t.seven = 500, t.eight = 500, t.nine = 500, t.colon = 333, t.semicolon = 333, t.less = 675, t.equal = 675, t.greater = 675, t.question = 500, t.at = 920, t.A = 611, t.B = 611, t.C = 667, t.D = 722, t.E = 611, t.F = 611, t.G = 722, t.H = 722, t.I = 333, t.J = 444, t.K = 667, t.L = 556, t.M = 833, t.N = 667, t.O = 722, t.P = 611, t.Q = 722, t.R = 611, t.S = 500, t.T = 556, t.U = 722, t.V = 611, t.W = 833, t.X = 611, t.Y = 556, t.Z = 556, t.bracketleft = 389, t.backslash = 278, t.bracketright = 389, t.asciicircum = 422, t.underscore = 500, t.quoteleft = 333, t.a = 500, t.b = 500, t.c = 444, t.d = 500, t.e = 444, t.f = 278, t.g = 500, t.h = 500, t.i = 278, t.j = 278, t.k = 444, t.l = 278, t.m = 722, t.n = 500, t.o = 500, t.p = 500, t.q = 500, t.r = 389, t.s = 389, t.t = 278, t.u = 500, t.v = 444, t.w = 667, t.x = 444, t.y = 444, t.z = 389, t.braceleft = 400, t.bar = 275, t.braceright = 400, t.asciitilde = 541, t.exclamdown = 389, t.cent = 500, t.sterling = 500, t.fraction = 167, t.yen = 500, t.florin = 500, t.section = 500, t.currency = 500, t.quotesingle = 214, t.quotedblleft = 556, t.guillemotleft = 500, t.guilsinglleft = 333, t.guilsinglright = 333, t.fi = 500, t.fl = 500, t.endash = 500, t.dagger = 500, t.daggerdbl = 500, t.periodcentered = 250, t.paragraph = 523, t.bullet = 350, t.quotesinglbase = 333, t.quotedblbase = 556, t.quotedblright = 556, t.guillemotright = 500, t.ellipsis = 889, t.perthousand = 1e3, t.questiondown = 500, t.grave = 333, t.acute = 333, t.circumflex = 333, t.tilde = 333, t.macron = 333, t.breve = 333, t.dotaccent = 333, t.dieresis = 333, t.ring = 333, t.cedilla = 333, t.hungarumlaut = 333, t.ogonek = 333, t.caron = 333, t.emdash = 889, t.AE = 889, t.ordfeminine = 276, t.Lslash = 556, t.Oslash = 722, t.OE = 944, t.ordmasculine = 310, t.ae = 667, t.dotlessi = 278, t.lslash = 278, t.oslash = 500, t.oe = 667, t.germandbls = 500, t.Idieresis = 333, t.eacute = 444, t.abreve = 500, t.uhungarumlaut = 500, t.ecaron = 444, t.Ydieresis = 556, t.divide = 675, t.Yacute = 556, t.Acircumflex = 611, t.aacute = 500, t.Ucircumflex = 722, t.yacute = 444, t.scommaaccent = 389, t.ecircumflex = 444, t.Uring = 722, t.Udieresis = 722, t.aogonek = 500, t.Uacute = 722, t.uogonek = 500, t.Edieresis = 611, t.Dcroat = 722, t.commaaccent = 250, t.copyright = 760, t.Emacron = 611, t.ccaron = 444, t.aring = 500, t.Ncommaaccent = 667, t.lacute = 278, t.agrave = 500, t.Tcommaaccent = 556, t.Cacute = 667, t.atilde = 500, t.Edotaccent = 611, t.scaron = 389, t.scedilla = 389, t.iacute = 278, t.lozenge = 471, t.Rcaron = 611, t.Gcommaaccent = 722, t.ucircumflex = 500, t.acircumflex = 500, t.Amacron = 611, t.rcaron = 389, t.ccedilla = 444, t.Zdotaccent = 556, t.Thorn = 611, t.Omacron = 722, t.Racute = 611, t.Sacute = 500, t.dcaron = 544, t.Umacron = 722, t.uring = 500, t.threesuperior = 300, t.Ograve = 722, t.Agrave = 611, t.Abreve = 611, t.multiply = 675, t.uacute = 500, t.Tcaron = 556, t.partialdiff = 476, t.ydieresis = 444, t.Nacute = 667, t.icircumflex = 278, t.Ecircumflex = 611, t.adieresis = 500, t.edieresis = 444, t.cacute = 444, t.nacute = 500, t.umacron = 500, t.Ncaron = 667, t.Iacute = 333, t.plusminus = 675, t.brokenbar = 275, t.registered = 760, t.Gbreve = 722, t.Idotaccent = 333, t.summation = 600, t.Egrave = 611, t.racute = 389, t.omacron = 500, t.Zacute = 556, t.Zcaron = 556, t.greaterequal = 549, t.Eth = 722, t.Ccedilla = 667, t.lcommaaccent = 278, t.tcaron = 300, t.eogonek = 444, t.Uogonek = 722, t.Aacute = 611, t.Adieresis = 611, t.egrave = 444, t.zacute = 389, t.iogonek = 278, t.Oacute = 722, t.oacute = 500, t.amacron = 500, t.sacute = 389, t.idieresis = 278, t.Ocircumflex = 722, t.Ugrave = 722, t.Delta = 612, t.thorn = 500, t.twosuperior = 300, t.Odieresis = 722, t.mu = 500, t.igrave = 278, t.ohungarumlaut = 500, t.Eogonek = 611, t.dcroat = 500, t.threequarters = 750, t.Scedilla = 500, t.lcaron = 300, t.Kcommaaccent = 667, t.Lacute = 556, t.trademark = 980, t.edotaccent = 444, t.Igrave = 333, t.Imacron = 333, t.Lcaron = 611, t.onehalf = 750, t.lessequal = 549, t.ocircumflex = 500, t.ntilde = 500, t.Uhungarumlaut = 722, t.Eacute = 611, t.emacron = 444, t.gbreve = 500, t.onequarter = 750, t.Scaron = 500, t.Scommaaccent = 500, t.Ohungarumlaut = 722, t.degree = 400, t.ograve = 500, t.Ccaron = 667, t.ugrave = 500, t.radical = 453, t.Dcaron = 722, t.rcommaaccent = 389, t.Ntilde = 667, t.otilde = 500, t.Rcommaaccent = 611, t.Lcommaaccent = 556, t.Atilde = 611, t.Aogonek = 611, t.Aring = 611, t.Otilde = 722, t.zdotaccent = 389, t.Ecaron = 611, t.Iogonek = 333, t.kcommaaccent = 444, t.minus = 675, t.Icircumflex = 333, t.ncaron = 500, t.tcommaaccent = 278, t.logicalnot = 675, t.odieresis = 500, t.udieresis = 500, t.notequal = 549, t.gcommaaccent = 500, t.eth = 500, t.zcaron = 389, t.ncommaaccent = 500, t.onesuperior = 300, t.imacron = 278, t.Euro = 500;
            }), e.ZapfDingbats = (0, n.getLookupTableFactory)(function(t) {
              t.space = 278, t.a1 = 974, t.a2 = 961, t.a202 = 974, t.a3 = 980, t.a4 = 719, t.a5 = 789, t.a119 = 790, t.a118 = 791, t.a117 = 690, t.a11 = 960, t.a12 = 939, t.a13 = 549, t.a14 = 855, t.a15 = 911, t.a16 = 933, t.a105 = 911, t.a17 = 945, t.a18 = 974, t.a19 = 755, t.a20 = 846, t.a21 = 762, t.a22 = 761, t.a23 = 571, t.a24 = 677, t.a25 = 763, t.a26 = 760, t.a27 = 759, t.a28 = 754, t.a6 = 494, t.a7 = 552, t.a8 = 537, t.a9 = 577, t.a10 = 692, t.a29 = 786, t.a30 = 788, t.a31 = 788, t.a32 = 790, t.a33 = 793, t.a34 = 794, t.a35 = 816, t.a36 = 823, t.a37 = 789, t.a38 = 841, t.a39 = 823, t.a40 = 833, t.a41 = 816, t.a42 = 831, t.a43 = 923, t.a44 = 744, t.a45 = 723, t.a46 = 749, t.a47 = 790, t.a48 = 792, t.a49 = 695, t.a50 = 776, t.a51 = 768, t.a52 = 792, t.a53 = 759, t.a54 = 707, t.a55 = 708, t.a56 = 682, t.a57 = 701, t.a58 = 826, t.a59 = 815, t.a60 = 789, t.a61 = 789, t.a62 = 707, t.a63 = 687, t.a64 = 696, t.a65 = 689, t.a66 = 786, t.a67 = 787, t.a68 = 713, t.a69 = 791, t.a70 = 785, t.a71 = 791, t.a72 = 873, t.a73 = 761, t.a74 = 762, t.a203 = 762, t.a75 = 759, t.a204 = 759, t.a76 = 892, t.a77 = 892, t.a78 = 788, t.a79 = 784, t.a81 = 438, t.a82 = 138, t.a83 = 277, t.a84 = 415, t.a97 = 392, t.a98 = 392, t.a99 = 668, t.a100 = 668, t.a89 = 390, t.a90 = 390, t.a93 = 317, t.a94 = 317, t.a91 = 276, t.a92 = 276, t.a205 = 509, t.a85 = 509, t.a206 = 410, t.a86 = 410, t.a87 = 234, t.a88 = 234, t.a95 = 334, t.a96 = 334, t.a101 = 732, t.a102 = 544, t.a103 = 544, t.a104 = 910, t.a106 = 667, t.a107 = 760, t.a108 = 760, t.a112 = 776, t.a111 = 595, t.a110 = 694, t.a109 = 626, t.a120 = 788, t.a121 = 788, t.a122 = 788, t.a123 = 788, t.a124 = 788, t.a125 = 788, t.a126 = 788, t.a127 = 788, t.a128 = 788, t.a129 = 788, t.a130 = 788, t.a131 = 788, t.a132 = 788, t.a133 = 788, t.a134 = 788, t.a135 = 788, t.a136 = 788, t.a137 = 788, t.a138 = 788, t.a139 = 788, t.a140 = 788, t.a141 = 788, t.a142 = 788, t.a143 = 788, t.a144 = 788, t.a145 = 788, t.a146 = 788, t.a147 = 788, t.a148 = 788, t.a149 = 788, t.a150 = 788, t.a151 = 788, t.a152 = 788, t.a153 = 788, t.a154 = 788, t.a155 = 788, t.a156 = 788, t.a157 = 788, t.a158 = 788, t.a159 = 788, t.a160 = 894, t.a161 = 838, t.a163 = 1016, t.a164 = 458, t.a196 = 748, t.a165 = 924, t.a192 = 748, t.a166 = 918, t.a167 = 927, t.a168 = 928, t.a169 = 928, t.a170 = 834, t.a171 = 873, t.a172 = 828, t.a173 = 924, t.a162 = 924, t.a174 = 917, t.a175 = 930, t.a176 = 931, t.a177 = 463, t.a178 = 883, t.a179 = 836, t.a193 = 836, t.a180 = 867, t.a199 = 867, t.a181 = 696, t.a200 = 696, t.a182 = 874, t.a201 = 874, t.a183 = 760, t.a184 = 946, t.a197 = 771, t.a185 = 865, t.a194 = 771, t.a198 = 888, t.a186 = 967, t.a195 = 888, t.a187 = 831, t.a188 = 873, t.a189 = 927, t.a190 = 970, t.a191 = 918;
            });
          });
          F.getMetrics = u;
          const q = (0, n.getLookupTableFactory)(function(e) {
            e.Courier = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: -426
            }, e["Courier-Bold"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 439
            }, e["Courier-Oblique"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 426
            }, e["Courier-BoldOblique"] = {
              ascent: 629,
              descent: -157,
              capHeight: 562,
              xHeight: 426
            }, e.Helvetica = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 523
            }, e["Helvetica-Bold"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 532
            }, e["Helvetica-Oblique"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 523
            }, e["Helvetica-BoldOblique"] = {
              ascent: 718,
              descent: -207,
              capHeight: 718,
              xHeight: 532
            }, e["Times-Roman"] = {
              ascent: 683,
              descent: -217,
              capHeight: 662,
              xHeight: 450
            }, e["Times-Bold"] = {
              ascent: 683,
              descent: -217,
              capHeight: 676,
              xHeight: 461
            }, e["Times-Italic"] = {
              ascent: 683,
              descent: -217,
              capHeight: 653,
              xHeight: 441
            }, e["Times-BoldItalic"] = {
              ascent: 683,
              descent: -217,
              capHeight: 669,
              xHeight: 462
            }, e.Symbol = {
              ascent: Math.NaN,
              descent: Math.NaN,
              capHeight: Math.NaN,
              xHeight: Math.NaN
            }, e.ZapfDingbats = {
              ascent: Math.NaN,
              descent: Math.NaN,
              capHeight: Math.NaN,
              xHeight: Math.NaN
            };
          });
          F.getFontBasicMetrics = q;
        },
        /* 46 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.GlyfTable = void 0;
          const ae = 1, n = 2, u = 4, q = 8, e = 16, t = 32, B = 64, j = 1, M = 2, O = 8, w = 32, C = 64, i = 128, o = 256;
          class k {
            constructor({
              glyfTable: b,
              isGlyphLocationsLong: I,
              locaTable: h,
              numGlyphs: y
            }) {
              this.glyphs = [];
              const P = new DataView(h.buffer, h.byteOffset, h.byteLength), c = new DataView(b.buffer, b.byteOffset, b.byteLength), d = I ? 4 : 2;
              let A = I ? P.getUint32(0) : 2 * P.getUint16(0), N = 0;
              for (let E = 0; E < y; E++) {
                N += d;
                const H = I ? P.getUint32(N) : 2 * P.getUint16(N);
                if (H === A) {
                  this.glyphs.push(new s({}));
                  continue;
                }
                const $ = s.parse(A, c);
                this.glyphs.push($), A = H;
              }
            }
            getSize() {
              return this.glyphs.reduce((b, I) => {
                const h = I.getSize();
                return b + (h + 3 & -4);
              }, 0);
            }
            write() {
              const b = this.getSize(), I = new DataView(new ArrayBuffer(b)), h = b > 131070, y = h ? 4 : 2, P = new DataView(new ArrayBuffer((this.glyphs.length + 1) * y));
              h ? P.setUint32(0, 0) : P.setUint16(0, 0);
              let c = 0, d = 0;
              for (const A of this.glyphs)
                c += A.write(c, I), c = c + 3 & -4, d += y, h ? P.setUint32(d, c) : P.setUint16(d, c >> 1);
              return {
                isLocationLong: h,
                loca: new Uint8Array(P.buffer),
                glyf: new Uint8Array(I.buffer)
              };
            }
            scale(b) {
              for (let I = 0, h = this.glyphs.length; I < h; I++)
                this.glyphs[I].scale(b[I]);
            }
          }
          F.GlyfTable = k;
          class s {
            constructor({
              header: b = null,
              simple: I = null,
              composites: h = null
            }) {
              this.header = b, this.simple = I, this.composites = h;
            }
            static parse(b, I) {
              const [h, y] = l.parse(b, I);
              if (b += h, y.numberOfContours < 0) {
                const c = [];
                for (; ; ) {
                  const [d, A] = r.parse(b, I);
                  if (b += d, c.push(A), !(A.flags & w))
                    break;
                }
                return new s({
                  header: y,
                  composites: c
                });
              }
              const P = v.parse(b, I, y.numberOfContours);
              return new s({
                header: y,
                simple: P
              });
            }
            getSize() {
              if (!this.header)
                return 0;
              const b = this.simple ? this.simple.getSize() : this.composites.reduce((I, h) => I + h.getSize(), 0);
              return this.header.getSize() + b;
            }
            write(b, I) {
              if (!this.header)
                return 0;
              const h = b;
              if (b += this.header.write(b, I), this.simple)
                b += this.simple.write(b, I);
              else
                for (const y of this.composites)
                  b += y.write(b, I);
              return b - h;
            }
            scale(b) {
              if (!this.header)
                return;
              const I = (this.header.xMin + this.header.xMax) / 2;
              if (this.header.scale(I, b), this.simple)
                this.simple.scale(I, b);
              else
                for (const h of this.composites)
                  h.scale(I, b);
            }
          }
          class l {
            constructor({
              numberOfContours: b,
              xMin: I,
              yMin: h,
              xMax: y,
              yMax: P
            }) {
              this.numberOfContours = b, this.xMin = I, this.yMin = h, this.xMax = y, this.yMax = P;
            }
            static parse(b, I) {
              return [10, new l({
                numberOfContours: I.getInt16(b),
                xMin: I.getInt16(b + 2),
                yMin: I.getInt16(b + 4),
                xMax: I.getInt16(b + 6),
                yMax: I.getInt16(b + 8)
              })];
            }
            getSize() {
              return 10;
            }
            write(b, I) {
              return I.setInt16(b, this.numberOfContours), I.setInt16(b + 2, this.xMin), I.setInt16(b + 4, this.yMin), I.setInt16(b + 6, this.xMax), I.setInt16(b + 8, this.yMax), 10;
            }
            scale(b, I) {
              this.xMin = Math.round(b + (this.xMin - b) * I), this.xMax = Math.round(b + (this.xMax - b) * I);
            }
          }
          class g {
            constructor({
              flags: b,
              xCoordinates: I,
              yCoordinates: h
            }) {
              this.xCoordinates = I, this.yCoordinates = h, this.flags = b;
            }
          }
          class v {
            constructor({
              contours: b,
              instructions: I
            }) {
              this.contours = b, this.instructions = I;
            }
            static parse(b, I, h) {
              const y = [];
              for (let L = 0; L < h; L++) {
                const _ = I.getUint16(b);
                b += 2, y.push(_);
              }
              const P = y[h - 1] + 1, c = I.getUint16(b);
              b += 2;
              const d = new Uint8Array(I).slice(b, b + c);
              b += c;
              const A = [];
              for (let L = 0; L < P; b++, L++) {
                let _ = I.getUint8(b);
                if (A.push(_), _ & q) {
                  const G = I.getUint8(++b);
                  _ ^= q;
                  for (let J = 0; J < G; J++)
                    A.push(_);
                  L += G;
                }
              }
              const N = [];
              let E = [], H = [], $ = [];
              const m = [];
              let p = 0, T = 0;
              for (let L = 0; L < P; L++) {
                const _ = A[L];
                if (_ & n) {
                  const G = I.getUint8(b++);
                  T += _ & e ? G : -G, E.push(T);
                } else
                  _ & e || (T += I.getInt16(b), b += 2), E.push(T);
                y[p] === L && (p++, N.push(E), E = []);
              }
              T = 0, p = 0;
              for (let L = 0; L < P; L++) {
                const _ = A[L];
                if (_ & u) {
                  const G = I.getUint8(b++);
                  T += _ & t ? G : -G, H.push(T);
                } else
                  _ & t || (T += I.getInt16(b), b += 2), H.push(T);
                $.push(_ & ae | _ & B), y[p] === L && (E = N[p], p++, m.push(new g({
                  flags: $,
                  xCoordinates: E,
                  yCoordinates: H
                })), H = [], $ = []);
              }
              return new v({
                contours: m,
                instructions: d
              });
            }
            getSize() {
              let b = this.contours.length * 2 + 2 + this.instructions.length, I = 0, h = 0;
              for (const y of this.contours) {
                b += y.flags.length;
                for (let P = 0, c = y.xCoordinates.length; P < c; P++) {
                  const d = y.xCoordinates[P], A = y.yCoordinates[P];
                  let N = Math.abs(d - I);
                  N > 255 ? b += 2 : N > 0 && (b += 1), I = d, N = Math.abs(A - h), N > 255 ? b += 2 : N > 0 && (b += 1), h = A;
                }
              }
              return b;
            }
            write(b, I) {
              const h = b, y = [], P = [], c = [];
              let d = 0, A = 0;
              for (const N of this.contours) {
                for (let E = 0, H = N.xCoordinates.length; E < H; E++) {
                  let $ = N.flags[E];
                  const m = N.xCoordinates[E];
                  let p = m - d;
                  if (p === 0)
                    $ |= e, y.push(0);
                  else {
                    const L = Math.abs(p);
                    L <= 255 ? ($ |= p >= 0 ? n | e : n, y.push(L)) : y.push(p);
                  }
                  d = m;
                  const T = N.yCoordinates[E];
                  if (p = T - A, p === 0)
                    $ |= t, P.push(0);
                  else {
                    const L = Math.abs(p);
                    L <= 255 ? ($ |= p >= 0 ? u | t : u, P.push(L)) : P.push(p);
                  }
                  A = T, c.push($);
                }
                I.setUint16(b, y.length - 1), b += 2;
              }
              I.setUint16(b, this.instructions.length), b += 2, this.instructions.length && (new Uint8Array(I.buffer, 0, I.buffer.byteLength).set(this.instructions, b), b += this.instructions.length);
              for (const N of c)
                I.setUint8(b++, N);
              for (let N = 0, E = y.length; N < E; N++) {
                const H = y[N], $ = c[N];
                $ & n ? I.setUint8(b++, H) : $ & e || (I.setInt16(b, H), b += 2);
              }
              for (let N = 0, E = P.length; N < E; N++) {
                const H = P[N], $ = c[N];
                $ & u ? I.setUint8(b++, H) : $ & t || (I.setInt16(b, H), b += 2);
              }
              return b - h;
            }
            scale(b, I) {
              for (const h of this.contours)
                if (h.xCoordinates.length !== 0)
                  for (let y = 0, P = h.xCoordinates.length; y < P; y++)
                    h.xCoordinates[y] = Math.round(b + (h.xCoordinates[y] - b) * I);
            }
          }
          class r {
            constructor({
              flags: b,
              glyphIndex: I,
              argument1: h,
              argument2: y,
              transf: P,
              instructions: c
            }) {
              this.flags = b, this.glyphIndex = I, this.argument1 = h, this.argument2 = y, this.transf = P, this.instructions = c;
            }
            static parse(b, I) {
              const h = b, y = [];
              let P = I.getUint16(b);
              const c = I.getUint16(b + 2);
              b += 4;
              let d, A;
              P & j ? (P & M ? (d = I.getInt16(b), A = I.getInt16(b + 2)) : (d = I.getUint16(b), A = I.getUint16(b + 2)), b += 4, P ^= j) : (P & M ? (d = I.getInt8(b), A = I.getInt8(b + 1)) : (d = I.getUint8(b), A = I.getUint8(b + 1)), b += 2), P & O ? (y.push(I.getUint16(b)), b += 2) : P & C ? (y.push(I.getUint16(b), I.getUint16(b + 2)), b += 4) : P & i && (y.push(I.getUint16(b), I.getUint16(b + 2), I.getUint16(b + 4), I.getUint16(b + 6)), b += 8);
              let N = null;
              if (P & o) {
                const E = I.getUint16(b);
                b += 2, N = new Uint8Array(I).slice(b, b + E), b += E;
              }
              return [b - h, new r({
                flags: P,
                glyphIndex: c,
                argument1: d,
                argument2: A,
                transf: y,
                instructions: N
              })];
            }
            getSize() {
              let b = 4 + this.transf.length * 2;
              return this.flags & o && (b += 2 + this.instructions.length), b += 2, this.flags & 2 ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (b += 2) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (b += 2), b;
            }
            write(b, I) {
              const h = b;
              return this.flags & M ? this.argument1 >= -128 && this.argument1 <= 127 && this.argument2 >= -128 && this.argument2 <= 127 || (this.flags |= j) : this.argument1 >= 0 && this.argument1 <= 255 && this.argument2 >= 0 && this.argument2 <= 255 || (this.flags |= j), I.setUint16(b, this.flags), I.setUint16(b + 2, this.glyphIndex), b += 4, this.flags & j ? (this.flags & M ? (I.setInt16(b, this.argument1), I.setInt16(b + 2, this.argument2)) : (I.setUint16(b, this.argument1), I.setUint16(b + 2, this.argument2)), b += 4) : (I.setUint8(b, this.argument1), I.setUint8(b + 1, this.argument2), b += 2), this.flags & o && (I.setUint16(b, this.instructions.length), b += 2, this.instructions.length && (new Uint8Array(I.buffer, 0, I.buffer.byteLength).set(this.instructions, b), b += this.instructions.length)), b - h;
            }
            scale(b, I) {
            }
          }
        },
        /* 47 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.OpenTypeFileBuilder = void 0;
          var n = ae(3), u = ae(2);
          function q(O, w, C) {
            O[w] = C >> 8 & 255, O[w + 1] = C & 255;
          }
          function e(O, w, C) {
            O[w] = C >> 24 & 255, O[w + 1] = C >> 16 & 255, O[w + 2] = C >> 8 & 255, O[w + 3] = C & 255;
          }
          function t(O, w, C) {
            if (C instanceof Uint8Array)
              O.set(C, w);
            else if (typeof C == "string")
              for (let i = 0, o = C.length; i < o; i++)
                O[w++] = C.charCodeAt(i) & 255;
            else
              for (const i of C)
                O[w++] = i & 255;
          }
          const B = 12, j = 16;
          class M {
            constructor(w) {
              this.sfnt = w, this.tables = /* @__PURE__ */ Object.create(null);
            }
            static getSearchParams(w, C) {
              let i = 1, o = 0;
              for (; (i ^ w) > i; )
                i <<= 1, o++;
              const k = i * C;
              return {
                range: k,
                entry: o,
                rangeShift: C * w - k
              };
            }
            toArray() {
              let w = this.sfnt;
              const C = this.tables, i = Object.keys(C);
              i.sort();
              const o = i.length;
              let k, s, l, g, v, r = B + o * j;
              const x = [r];
              for (k = 0; k < o; k++) {
                g = C[i[k]];
                const h = (g.length + 3 & -4) >>> 0;
                r += h, x.push(r);
              }
              const b = new Uint8Array(r);
              for (k = 0; k < o; k++)
                g = C[i[k]], t(b, x[k], g);
              w === "true" && (w = (0, u.string32)(65536)), b[0] = w.charCodeAt(0) & 255, b[1] = w.charCodeAt(1) & 255, b[2] = w.charCodeAt(2) & 255, b[3] = w.charCodeAt(3) & 255, q(b, 4, o);
              const I = M.getSearchParams(o, 16);
              for (q(b, 6, I.range), q(b, 8, I.entry), q(b, 10, I.rangeShift), r = B, k = 0; k < o; k++) {
                v = i[k], b[r] = v.charCodeAt(0) & 255, b[r + 1] = v.charCodeAt(1) & 255, b[r + 2] = v.charCodeAt(2) & 255, b[r + 3] = v.charCodeAt(3) & 255;
                let h = 0;
                for (s = x[k], l = x[k + 1]; s < l; s += 4) {
                  const y = (0, n.readUint32)(b, s);
                  h = h + y >>> 0;
                }
                e(b, r + 4, h), e(b, r + 8, x[k]), e(b, r + 12, C[v].length), r += j;
              }
              return b;
            }
            addTable(w, C) {
              if (w in this.tables)
                throw new Error("Table " + w + " already exists");
              this.tables[w] = C;
            }
          }
          F.OpenTypeFileBuilder = M;
        },
        /* 48 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Type1Font = void 0;
          var n = ae(35), u = ae(2), q = ae(38), e = ae(3), t = ae(8), B = ae(49);
          function j(C, i, o) {
            const k = C.length, s = i.length, l = k - s;
            let g = o, v = !1;
            for (; g < l; ) {
              let r = 0;
              for (; r < s && C[g + r] === i[r]; )
                r++;
              if (r >= s) {
                for (g += r; g < k && (0, e.isWhiteSpace)(C[g]); )
                  g++;
                v = !0;
                break;
              }
              g++;
            }
            return {
              found: v,
              length: g
            };
          }
          function M(C, i) {
            const o = [101, 101, 120, 101, 99], k = C.pos;
            let s, l, g;
            try {
              s = C.getBytes(i), l = s.length;
            } catch {
            }
            if (l === i && (g = j(s, o, i - 2 * o.length), g.found && g.length === i))
              return {
                stream: new t.Stream(s),
                length: i
              };
            (0, u.warn)('Invalid "Length1" property in Type1 font -- trying to recover.'), C.pos = k;
            const v = 2048;
            let r;
            for (; ; ) {
              const x = C.peekBytes(v);
              if (g = j(x, o, 0), g.length === 0)
                break;
              if (C.pos += g.length, g.found) {
                r = C.pos - k;
                break;
              }
            }
            return C.pos = k, r ? {
              stream: new t.Stream(C.getBytes(r)),
              length: r
            } : ((0, u.warn)('Unable to recover "Length1" property in Type1 font -- using as is.'), {
              stream: new t.Stream(C.getBytes(i)),
              length: i
            });
          }
          function O(C, i) {
            const o = C.getBytes();
            if (o.length === 0)
              throw new u.FormatError("getEexecBlock - no font program found.");
            return {
              stream: new t.Stream(o),
              length: o.length
            };
          }
          class w {
            constructor(i, o, k) {
              let l = k.length1;
              k.length2;
              let g = o.peekBytes(6);
              const v = g[0] === 128 && g[1] === 1;
              v && (o.skip(6), l = g[5] << 24 | g[4] << 16 | g[3] << 8 | g[2]);
              const r = M(o, l);
              new B.Type1Parser(r.stream, !1, q.SEAC_ANALYSIS_ENABLED).extractFontHeader(k), v && (g = o.getBytes(6), g[5] << 24 | g[4] << 16 | g[3] << 8 | g[2]);
              const b = O(o), h = new B.Type1Parser(b.stream, !0, q.SEAC_ANALYSIS_ENABLED).extractFontProgram(k);
              for (const d in h.properties)
                k[d] = h.properties[d];
              const y = h.charstrings, P = this.getType2Charstrings(y), c = this.getType2Subrs(h.subrs);
              this.charstrings = y, this.data = this.wrap(i, P, this.charstrings, c, k), this.seacs = this.getSeacs(h.charstrings);
            }
            get numGlyphs() {
              return this.charstrings.length + 1;
            }
            getCharset() {
              const i = [".notdef"];
              for (const {
                glyphName: o
              } of this.charstrings)
                i.push(o);
              return i;
            }
            getGlyphMapping(i) {
              const o = this.charstrings;
              if (i.composite) {
                const v = /* @__PURE__ */ Object.create(null);
                for (let r = 0, x = o.length; r < x; r++) {
                  const b = i.cMap.charCodeOf(r);
                  v[b] = r + 1;
                }
                return v;
              }
              const k = [".notdef"];
              let s, l;
              for (l = 0; l < o.length; l++)
                k.push(o[l].glyphName);
              const g = i.builtInEncoding;
              if (g) {
                s = /* @__PURE__ */ Object.create(null);
                for (const v in g)
                  l = k.indexOf(g[v]), l >= 0 && (s[v] = l);
              }
              return (0, q.type1FontGlyphMapping)(i, s, k);
            }
            hasGlyphId(i) {
              return i < 0 || i >= this.numGlyphs ? !1 : i === 0 ? !0 : this.charstrings[i - 1].charstring.length > 0;
            }
            getSeacs(i) {
              const o = [];
              for (let k = 0, s = i.length; k < s; k++) {
                const l = i[k];
                l.seac && (o[k + 1] = l.seac);
              }
              return o;
            }
            getType2Charstrings(i) {
              const o = [];
              for (const k of i)
                o.push(k.charstring);
              return o;
            }
            getType2Subrs(i) {
              let o = 0;
              const k = i.length;
              k < 1133 ? o = 107 : k < 33769 ? o = 1131 : o = 32768;
              const s = [];
              let l;
              for (l = 0; l < o; l++)
                s.push([11]);
              for (l = 0; l < k; l++)
                s.push(i[l]);
              return s;
            }
            wrap(i, o, k, s, l) {
              const g = new n.CFF();
              g.header = new n.CFFHeader(1, 0, 4, 4), g.names = [i];
              const v = new n.CFFTopDict();
              v.setByName("version", 391), v.setByName("Notice", 392), v.setByName("FullName", 393), v.setByName("FamilyName", 394), v.setByName("Weight", 395), v.setByName("Encoding", null), v.setByName("FontMatrix", l.fontMatrix), v.setByName("FontBBox", l.bbox), v.setByName("charset", null), v.setByName("CharStrings", null), v.setByName("Private", null), g.topDict = v;
              const r = new n.CFFStrings();
              r.add("Version 0.11"), r.add("See original notice"), r.add(i), r.add(i), r.add("Medium"), g.strings = r, g.globalSubrIndex = new n.CFFIndex();
              const x = o.length, b = [".notdef"];
              let I, h;
              for (I = 0; I < x; I++) {
                const N = k[I].glyphName;
                n.CFFStandardStrings.indexOf(N) === -1 && r.add(N), b.push(N);
              }
              g.charset = new n.CFFCharset(!1, 0, b);
              const y = new n.CFFIndex();
              for (y.add([139, 14]), I = 0; I < x; I++)
                y.add(o[I]);
              g.charStrings = y;
              const P = new n.CFFPrivateDict();
              P.setByName("Subrs", null);
              const c = ["BlueValues", "OtherBlues", "FamilyBlues", "FamilyOtherBlues", "StemSnapH", "StemSnapV", "BlueShift", "BlueFuzz", "BlueScale", "LanguageGroup", "ExpansionFactor", "ForceBold", "StdHW", "StdVW"];
              for (I = 0, h = c.length; I < h; I++) {
                const N = c[I];
                if (!(N in l.privateData))
                  continue;
                const E = l.privateData[N];
                if (Array.isArray(E))
                  for (let H = E.length - 1; H > 0; H--)
                    E[H] -= E[H - 1];
                P.setByName(N, E);
              }
              g.topDict.privateDict = P;
              const d = new n.CFFIndex();
              for (I = 0, h = s.length; I < h; I++)
                d.add(s[I]);
              return P.subrsIndex = d, new n.CFFCompiler(g).compile();
            }
          }
          F.Type1Font = w;
        },
        /* 49 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Type1Parser = void 0;
          var n = ae(37), u = ae(3), q = ae(8), e = ae(2);
          const t = !1, B = {
            hstem: [1],
            vstem: [3],
            vmoveto: [4],
            rlineto: [5],
            hlineto: [6],
            vlineto: [7],
            rrcurveto: [8],
            callsubr: [10],
            flex: [12, 35],
            drop: [12, 18],
            endchar: [14],
            rmoveto: [21],
            hmoveto: [22],
            vhcurveto: [30],
            hvcurveto: [31]
          };
          class j {
            constructor() {
              this.width = 0, this.lsb = 0, this.flexing = !1, this.output = [], this.stack = [];
            }
            convert(l, g, v) {
              const r = l.length;
              let x = !1, b, I, h;
              for (let y = 0; y < r; y++) {
                let P = l[y];
                if (P < 32) {
                  switch (P === 12 && (P = (P << 8) + l[++y]), P) {
                    case 1: {
                      this.stack = [];
                      break;
                    }
                    case 3: {
                      this.stack = [];
                      break;
                    }
                    case 4:
                      if (this.flexing) {
                        if (this.stack.length < 1) {
                          x = !0;
                          break;
                        }
                        const E = this.stack.pop();
                        this.stack.push(0, E);
                        break;
                      }
                      x = this.executeCommand(1, B.vmoveto);
                      break;
                    case 5:
                      x = this.executeCommand(2, B.rlineto);
                      break;
                    case 6:
                      x = this.executeCommand(1, B.hlineto);
                      break;
                    case 7:
                      x = this.executeCommand(1, B.vlineto);
                      break;
                    case 8:
                      x = this.executeCommand(6, B.rrcurveto);
                      break;
                    case 9:
                      this.stack = [];
                      break;
                    case 10:
                      if (this.stack.length < 1) {
                        x = !0;
                        break;
                      }
                      if (h = this.stack.pop(), !g[h]) {
                        x = !0;
                        break;
                      }
                      x = this.convert(g[h], g, v);
                      break;
                    case 11:
                      return x;
                    case 13:
                      if (this.stack.length < 2) {
                        x = !0;
                        break;
                      }
                      b = this.stack.pop(), I = this.stack.pop(), this.lsb = I, this.width = b, this.stack.push(b, I), x = this.executeCommand(2, B.hmoveto);
                      break;
                    case 14:
                      this.output.push(B.endchar[0]);
                      break;
                    case 21:
                      if (this.flexing)
                        break;
                      x = this.executeCommand(2, B.rmoveto);
                      break;
                    case 22:
                      if (this.flexing) {
                        this.stack.push(0);
                        break;
                      }
                      x = this.executeCommand(1, B.hmoveto);
                      break;
                    case 30:
                      x = this.executeCommand(4, B.vhcurveto);
                      break;
                    case 31:
                      x = this.executeCommand(4, B.hvcurveto);
                      break;
                    case 3072:
                      this.stack = [];
                      break;
                    case 3073: {
                      this.stack = [];
                      break;
                    }
                    case 3074: {
                      this.stack = [];
                      break;
                    }
                    case 3078:
                      if (v) {
                        const E = this.stack.at(-5);
                        this.seac = this.stack.splice(-4, 4), this.seac[0] += this.lsb - E, x = this.executeCommand(0, B.endchar);
                      } else
                        x = this.executeCommand(4, B.endchar);
                      break;
                    case 3079:
                      if (this.stack.length < 4) {
                        x = !0;
                        break;
                      }
                      this.stack.pop(), b = this.stack.pop();
                      const c = this.stack.pop();
                      I = this.stack.pop(), this.lsb = I, this.width = b, this.stack.push(b, I, c), x = this.executeCommand(3, B.rmoveto);
                      break;
                    case 3084:
                      if (this.stack.length < 2) {
                        x = !0;
                        break;
                      }
                      const d = this.stack.pop(), A = this.stack.pop();
                      this.stack.push(A / d);
                      break;
                    case 3088:
                      if (this.stack.length < 2) {
                        x = !0;
                        break;
                      }
                      h = this.stack.pop();
                      const N = this.stack.pop();
                      if (h === 0 && N === 3) {
                        const E = this.stack.splice(-17, 17);
                        this.stack.push(E[2] + E[0], E[3] + E[1], E[4], E[5], E[6], E[7], E[8], E[9], E[10], E[11], E[12], E[13], E[14]), x = this.executeCommand(13, B.flex, !0), this.flexing = !1, this.stack.push(E[15], E[16]);
                      } else
                        h === 1 && N === 0 && (this.flexing = !0);
                      break;
                    case 3089:
                      break;
                    case 3105:
                      this.stack = [];
                      break;
                    default:
                      (0, e.warn)('Unknown type 1 charstring command of "' + P + '"');
                      break;
                  }
                  if (x)
                    break;
                  continue;
                } else
                  P <= 246 ? P -= 139 : P <= 250 ? P = (P - 247) * 256 + l[++y] + 108 : P <= 254 ? P = -((P - 251) * 256) - l[++y] - 108 : P = (l[++y] & 255) << 24 | (l[++y] & 255) << 16 | (l[++y] & 255) << 8 | (l[++y] & 255) << 0;
                this.stack.push(P);
              }
              return x;
            }
            executeCommand(l, g, v) {
              const r = this.stack.length;
              if (l > r)
                return !0;
              const x = r - l;
              for (let b = x; b < r; b++) {
                let I = this.stack[b];
                Number.isInteger(I) ? this.output.push(28, I >> 8 & 255, I & 255) : (I = 65536 * I | 0, this.output.push(255, I >> 24 & 255, I >> 16 & 255, I >> 8 & 255, I & 255));
              }
              return this.output.push(...g), v ? this.stack.splice(x, l) : this.stack.length = 0, !1;
            }
          }
          const M = 55665, O = 4330;
          function w(s) {
            return s >= 48 && s <= 57 || s >= 65 && s <= 70 || s >= 97 && s <= 102;
          }
          function C(s, l, g) {
            if (g >= s.length)
              return new Uint8Array(0);
            const v = 52845, r = 22719;
            let x = l | 0, b, I;
            for (b = 0; b < g; b++)
              x = (s[b] + x) * v + r & 65535;
            const h = s.length - g, y = new Uint8Array(h);
            for (b = g, I = 0; I < h; b++, I++) {
              const P = s[b];
              y[I] = P ^ x >> 8, x = (P + x) * v + r & 65535;
            }
            return y;
          }
          function i(s, l, g) {
            let x = l | 0;
            const b = s.length, I = b >>> 1, h = new Uint8Array(I);
            let y, P;
            for (y = 0, P = 0; y < b; y++) {
              const c = s[y];
              if (!w(c))
                continue;
              y++;
              let d;
              for (; y < b && !w(d = s[y]); )
                y++;
              if (y < b) {
                const A = parseInt(String.fromCharCode(c, d), 16);
                h[P++] = A ^ x >> 8, x = (A + x) * 52845 + 22719 & 65535;
              }
            }
            return h.slice(g, P);
          }
          function o(s) {
            return s === 47 || s === 91 || s === 93 || s === 123 || s === 125 || s === 40 || s === 41;
          }
          class k {
            constructor(l, g, v) {
              if (g) {
                const r = l.getBytes(), x = !((w(r[0]) || (0, u.isWhiteSpace)(r[0])) && w(r[1]) && w(r[2]) && w(r[3]) && w(r[4]) && w(r[5]) && w(r[6]) && w(r[7]));
                l = new q.Stream(x ? C(r, M, 4) : i(r, M, 4));
              }
              this.seacAnalysisEnabled = !!v, this.stream = l, this.nextChar();
            }
            readNumberArray() {
              this.getToken();
              const l = [];
              for (; ; ) {
                const g = this.getToken();
                if (g === null || g === "]" || g === "}")
                  break;
                l.push(parseFloat(g || 0));
              }
              return l;
            }
            readNumber() {
              const l = this.getToken();
              return parseFloat(l || 0);
            }
            readInt() {
              const l = this.getToken();
              return parseInt(l || 0, 10) | 0;
            }
            readBoolean() {
              return this.getToken() === "true" ? 1 : 0;
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            prevChar() {
              return this.stream.skip(-2), this.currentChar = this.stream.getByte();
            }
            getToken() {
              let l = !1, g = this.currentChar;
              for (; ; ) {
                if (g === -1)
                  return null;
                if (l)
                  (g === 10 || g === 13) && (l = !1);
                else if (g === 37)
                  l = !0;
                else if (!(0, u.isWhiteSpace)(g))
                  break;
                g = this.nextChar();
              }
              if (o(g))
                return this.nextChar(), String.fromCharCode(g);
              let v = "";
              do
                v += String.fromCharCode(g), g = this.nextChar();
              while (g >= 0 && !(0, u.isWhiteSpace)(g) && !o(g));
              return v;
            }
            readCharStrings(l, g) {
              return g === -1 ? l : C(l, O, g);
            }
            extractFontProgram(l) {
              const g = this.stream, v = [], r = [], x = /* @__PURE__ */ Object.create(null);
              x.lenIV = 4;
              const b = {
                subrs: [],
                charstrings: [],
                properties: {
                  privateData: x
                }
              };
              let I, h, y, P;
              for (; (I = this.getToken()) !== null; )
                if (I === "/")
                  switch (I = this.getToken(), I) {
                    case "CharStrings":
                      for (this.getToken(), this.getToken(), this.getToken(), this.getToken(); I = this.getToken(), !(I === null || I === "end"); ) {
                        if (I !== "/")
                          continue;
                        const d = this.getToken();
                        h = this.readInt(), this.getToken(), y = h > 0 ? g.getBytes(h) : new Uint8Array(0), P = b.properties.privateData.lenIV;
                        const A = this.readCharStrings(y, P);
                        this.nextChar(), I = this.getToken(), I === "noaccess" ? this.getToken() : I === "/" && this.prevChar(), r.push({
                          glyph: d,
                          encoded: A
                        });
                      }
                      break;
                    case "Subrs":
                      for (this.readInt(), this.getToken(); this.getToken() === "dup"; ) {
                        const d = this.readInt();
                        h = this.readInt(), this.getToken(), y = h > 0 ? g.getBytes(h) : new Uint8Array(0), P = b.properties.privateData.lenIV;
                        const A = this.readCharStrings(y, P);
                        this.nextChar(), I = this.getToken(), I === "noaccess" && this.getToken(), v[d] = A;
                      }
                      break;
                    case "BlueValues":
                    case "OtherBlues":
                    case "FamilyBlues":
                    case "FamilyOtherBlues":
                      const c = this.readNumberArray();
                      c.length > 0 && c.length % 2 === 0 && t && (b.properties.privateData[I] = c);
                      break;
                    case "StemSnapH":
                    case "StemSnapV":
                      b.properties.privateData[I] = this.readNumberArray();
                      break;
                    case "StdHW":
                    case "StdVW":
                      b.properties.privateData[I] = this.readNumberArray()[0];
                      break;
                    case "BlueShift":
                    case "lenIV":
                    case "BlueFuzz":
                    case "BlueScale":
                    case "LanguageGroup":
                      b.properties.privateData[I] = this.readNumber();
                      break;
                    case "ExpansionFactor":
                      b.properties.privateData[I] = this.readNumber() || 0.06;
                      break;
                    case "ForceBold":
                      b.properties.privateData[I] = this.readBoolean();
                      break;
                  }
              for (const {
                encoded: c,
                glyph: d
              } of r) {
                const A = new j(), N = A.convert(c, v, this.seacAnalysisEnabled);
                let E = A.output;
                N && (E = [14]);
                const H = {
                  glyphName: d,
                  charstring: E,
                  width: A.width,
                  lsb: A.lsb,
                  seac: A.seac
                };
                if (d === ".notdef" ? b.charstrings.unshift(H) : b.charstrings.push(H), l.builtInEncoding) {
                  const $ = l.builtInEncoding.indexOf(d);
                  $ > -1 && l.widths[$] === void 0 && $ >= l.firstChar && $ <= l.lastChar && (l.widths[$] = A.width);
                }
              }
              return b;
            }
            extractFontHeader(l) {
              let g;
              for (; (g = this.getToken()) !== null; )
                if (g === "/")
                  switch (g = this.getToken(), g) {
                    case "FontMatrix":
                      const v = this.readNumberArray();
                      l.fontMatrix = v;
                      break;
                    case "Encoding":
                      const r = this.getToken();
                      let x;
                      if (!/^\d+$/.test(r))
                        x = (0, n.getEncoding)(r);
                      else {
                        x = [];
                        const I = parseInt(r, 10) | 0;
                        this.getToken();
                        for (let h = 0; h < I; h++) {
                          for (g = this.getToken(); g !== "dup" && g !== "def"; )
                            if (g = this.getToken(), g === null)
                              return;
                          if (g === "def")
                            break;
                          const y = this.readInt();
                          this.getToken();
                          const P = this.getToken();
                          x[y] = P, this.getToken();
                        }
                      }
                      l.builtInEncoding = x;
                      break;
                    case "FontBBox":
                      const b = this.readNumberArray();
                      l.ascent = Math.max(b[3], b[1]), l.descent = Math.min(b[1], b[3]), l.ascentScaled = !0;
                      break;
                  }
            }
          }
          F.Type1Parser = k;
        },
        /* 50 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Pattern = void 0, F.getTilingPatternIR = o;
          var n = ae(2), u = ae(5), q = ae(12), e = ae(3);
          const t = {
            FUNCTION_BASED: 1,
            AXIAL: 2,
            RADIAL: 3,
            FREE_FORM_MESH: 4,
            LATTICE_FORM_MESH: 5,
            COONS_PATCH_MESH: 6,
            TENSOR_PATCH_MESH: 7
          };
          class B {
            constructor() {
              (0, n.unreachable)("Cannot initialize Pattern.");
            }
            static parseShading(g, v, r, x, b) {
              const I = g instanceof u.BaseStream ? g.dict : g, h = I.get("ShadingType");
              try {
                switch (h) {
                  case t.AXIAL:
                  case t.RADIAL:
                    return new M(I, v, r, x, b);
                  case t.FREE_FORM_MESH:
                  case t.LATTICE_FORM_MESH:
                  case t.COONS_PATCH_MESH:
                  case t.TENSOR_PATCH_MESH:
                    return new C(g, v, r, x, b);
                  default:
                    throw new n.FormatError("Unsupported ShadingType: " + h);
                }
              } catch (y) {
                if (y instanceof e.MissingDataException)
                  throw y;
                return (0, n.warn)(y), new i();
              }
            }
          }
          F.Pattern = B;
          const k = class k {
            constructor() {
              this.constructor === k && (0, n.unreachable)("Cannot initialize BaseShading.");
            }
            getIR() {
              (0, n.unreachable)("Abstract method `getIR` called.");
            }
          };
          Dt(k, "SMALL_NUMBER", 1e-6);
          let j = k;
          class M extends j {
            constructor(g, v, r, x, b) {
              super(), this.coordsArr = g.getArray("Coords"), this.shadingType = g.get("ShadingType");
              const I = q.ColorSpace.parse({
                cs: g.getRaw("CS") || g.getRaw("ColorSpace"),
                xref: v,
                resources: r,
                pdfFunctionFactory: x,
                localColorSpaceCache: b
              }), h = g.getArray("BBox");
              Array.isArray(h) && h.length === 4 ? this.bbox = n.Util.normalizeRect(h) : this.bbox = null;
              let y = 0, P = 1;
              if (g.has("Domain")) {
                const Y = g.getArray("Domain");
                y = Y[0], P = Y[1];
              }
              let c = !1, d = !1;
              if (g.has("Extend")) {
                const Y = g.getArray("Extend");
                c = Y[0], d = Y[1];
              }
              if (this.shadingType === t.RADIAL && (!c || !d)) {
                const [Y, W, ie, ne, re, ee] = this.coordsArr, te = Math.hypot(Y - ne, W - re);
                ie <= ee + te && ee <= ie + te && (0, n.warn)("Unsupported radial gradient.");
              }
              this.extendStart = c, this.extendEnd = d;
              const A = g.getRaw("Function"), N = x.createFromArray(A), E = 840, H = (P - y) / E, $ = this.colorStops = [];
              if (y >= P || H <= 0) {
                (0, n.info)("Bad shading domain.");
                return;
              }
              const m = new Float32Array(I.numComps), p = new Float32Array(1);
              let T, L = 0;
              p[0] = y, N(p, 0, m, 0);
              let _ = I.getRgb(m, 0);
              const G = n.Util.makeHexColor(_[0], _[1], _[2]);
              $.push([0, G]);
              let J = 1;
              p[0] = y + H, N(p, 0, m, 0);
              let K = I.getRgb(m, 0), V = K[0] - _[0] + 1, U = K[1] - _[1] + 1, Q = K[2] - _[2] + 1, X = K[0] - _[0] - 1, R = K[1] - _[1] - 1, f = K[2] - _[2] - 1;
              for (let Y = 2; Y < E; Y++) {
                p[0] = y + Y * H, N(p, 0, m, 0), T = I.getRgb(m, 0);
                const W = Y - L;
                if (V = Math.min(V, (T[0] - _[0] + 1) / W), U = Math.min(U, (T[1] - _[1] + 1) / W), Q = Math.min(Q, (T[2] - _[2] + 1) / W), X = Math.max(X, (T[0] - _[0] - 1) / W), R = Math.max(R, (T[1] - _[1] - 1) / W), f = Math.max(f, (T[2] - _[2] - 1) / W), !(X <= V && R <= U && f <= Q)) {
                  const ne = n.Util.makeHexColor(K[0], K[1], K[2]);
                  $.push([J / E, ne]), V = T[0] - K[0] + 1, U = T[1] - K[1] + 1, Q = T[2] - K[2] + 1, X = T[0] - K[0] - 1, R = T[1] - K[1] - 1, f = T[2] - K[2] - 1, L = J, _ = K;
                }
                J = Y, K = T;
              }
              const D = n.Util.makeHexColor(K[0], K[1], K[2]);
              $.push([1, D]);
              let z = "transparent";
              g.has("Background") && (T = I.getRgb(g.get("Background"), 0), z = n.Util.makeHexColor(T[0], T[1], T[2])), c || ($.unshift([0, z]), $[1][0] += j.SMALL_NUMBER), d || ($.at(-1)[0] -= j.SMALL_NUMBER, $.push([1, z])), this.colorStops = $;
            }
            getIR() {
              const g = this.coordsArr, v = this.shadingType;
              let r, x, b, I, h;
              return v === t.AXIAL ? (x = [g[0], g[1]], b = [g[2], g[3]], I = null, h = null, r = "axial") : v === t.RADIAL ? (x = [g[0], g[1]], b = [g[3], g[4]], I = g[2], h = g[5], r = "radial") : (0, n.unreachable)(`getPattern type unknown: ${v}`), ["RadialAxial", r, this.bbox, this.colorStops, x, b, I, h];
            }
          }
          class O {
            constructor(g, v) {
              this.stream = g, this.context = v, this.buffer = 0, this.bufferLength = 0;
              const r = v.numComps;
              this.tmpCompsBuf = new Float32Array(r);
              const x = v.colorSpace.numComps;
              this.tmpCsCompsBuf = v.colorFn ? new Float32Array(x) : this.tmpCompsBuf;
            }
            get hasData() {
              if (this.stream.end)
                return this.stream.pos < this.stream.end;
              if (this.bufferLength > 0)
                return !0;
              const g = this.stream.getByte();
              return g < 0 ? !1 : (this.buffer = g, this.bufferLength = 8, !0);
            }
            readBits(g) {
              let v = this.buffer, r = this.bufferLength;
              if (g === 32) {
                if (r === 0)
                  return (this.stream.getByte() << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte()) >>> 0;
                v = v << 24 | this.stream.getByte() << 16 | this.stream.getByte() << 8 | this.stream.getByte();
                const x = this.stream.getByte();
                return this.buffer = x & (1 << r) - 1, (v << 8 - r | (x & 255) >> r) >>> 0;
              }
              if (g === 8 && r === 0)
                return this.stream.getByte();
              for (; r < g; )
                v = v << 8 | this.stream.getByte(), r += 8;
              return r -= g, this.bufferLength = r, this.buffer = v & (1 << r) - 1, v >> r;
            }
            align() {
              this.buffer = 0, this.bufferLength = 0;
            }
            readFlag() {
              return this.readBits(this.context.bitsPerFlag);
            }
            readCoordinate() {
              const g = this.context.bitsPerCoordinate, v = this.readBits(g), r = this.readBits(g), x = this.context.decode, b = g < 32 ? 1 / ((1 << g) - 1) : 23283064365386963e-26;
              return [v * b * (x[1] - x[0]) + x[0], r * b * (x[3] - x[2]) + x[2]];
            }
            readComponents() {
              const g = this.context.numComps, v = this.context.bitsPerComponent, r = v < 32 ? 1 / ((1 << v) - 1) : 23283064365386963e-26, x = this.context.decode, b = this.tmpCompsBuf;
              for (let h = 0, y = 4; h < g; h++, y += 2) {
                const P = this.readBits(v);
                b[h] = P * r * (x[y + 1] - x[y]) + x[y];
              }
              const I = this.tmpCsCompsBuf;
              return this.context.colorFn && this.context.colorFn(b, 0, I, 0), this.context.colorSpace.getRgb(I, 0);
            }
          }
          const w = function() {
            function g(r) {
              const x = [];
              for (let b = 0; b <= r; b++) {
                const I = b / r, h = 1 - I;
                x.push(new Float32Array([h * h * h, 3 * I * h * h, 3 * I * I * h, I * I * I]));
              }
              return x;
            }
            const v = /* @__PURE__ */ Object.create(null);
            return function(r) {
              return v[r] || (v[r] = g(r));
            };
          }(), s = class s extends j {
            constructor(g, v, r, x, b) {
              if (super(), !(g instanceof u.BaseStream))
                throw new n.FormatError("Mesh data is not a stream");
              const I = g.dict;
              this.shadingType = I.get("ShadingType");
              const h = I.getArray("BBox");
              Array.isArray(h) && h.length === 4 ? this.bbox = n.Util.normalizeRect(h) : this.bbox = null;
              const y = q.ColorSpace.parse({
                cs: I.getRaw("CS") || I.getRaw("ColorSpace"),
                xref: v,
                resources: r,
                pdfFunctionFactory: x,
                localColorSpaceCache: b
              });
              this.background = I.has("Background") ? y.getRgb(I.get("Background"), 0) : null;
              const P = I.getRaw("Function"), c = P ? x.createFromArray(P) : null;
              this.coords = [], this.colors = [], this.figures = [];
              const d = {
                bitsPerCoordinate: I.get("BitsPerCoordinate"),
                bitsPerComponent: I.get("BitsPerComponent"),
                bitsPerFlag: I.get("BitsPerFlag"),
                decode: I.getArray("Decode"),
                colorFn: c,
                colorSpace: y,
                numComps: c ? 1 : y.numComps
              }, A = new O(g, d);
              let N = !1;
              switch (this.shadingType) {
                case t.FREE_FORM_MESH:
                  this._decodeType4Shading(A);
                  break;
                case t.LATTICE_FORM_MESH:
                  const E = I.get("VerticesPerRow") | 0;
                  if (E < 2)
                    throw new n.FormatError("Invalid VerticesPerRow");
                  this._decodeType5Shading(A, E);
                  break;
                case t.COONS_PATCH_MESH:
                  this._decodeType6Shading(A), N = !0;
                  break;
                case t.TENSOR_PATCH_MESH:
                  this._decodeType7Shading(A), N = !0;
                  break;
                default:
                  (0, n.unreachable)("Unsupported mesh type.");
                  break;
              }
              if (N) {
                this._updateBounds();
                for (let E = 0, H = this.figures.length; E < H; E++)
                  this._buildFigureFromPatch(E);
              }
              this._updateBounds(), this._packData();
            }
            _decodeType4Shading(g) {
              const v = this.coords, r = this.colors, x = [];
              let b = 0;
              for (; g.hasData; ) {
                const I = g.readFlag(), h = g.readCoordinate(), y = g.readComponents();
                if (b === 0) {
                  if (!(0 <= I && I <= 2))
                    throw new n.FormatError("Unknown type4 flag");
                  switch (I) {
                    case 0:
                      b = 3;
                      break;
                    case 1:
                      x.push(x.at(-2), x.at(-1)), b = 1;
                      break;
                    case 2:
                      x.push(x.at(-3), x.at(-1)), b = 1;
                      break;
                  }
                }
                x.push(v.length), v.push(h), r.push(y), b--, g.align();
              }
              this.figures.push({
                type: "triangles",
                coords: new Int32Array(x),
                colors: new Int32Array(x)
              });
            }
            _decodeType5Shading(g, v) {
              const r = this.coords, x = this.colors, b = [];
              for (; g.hasData; ) {
                const I = g.readCoordinate(), h = g.readComponents();
                b.push(r.length), r.push(I), x.push(h);
              }
              this.figures.push({
                type: "lattice",
                coords: new Int32Array(b),
                colors: new Int32Array(b),
                verticesPerRow: v
              });
            }
            _decodeType6Shading(g) {
              const v = this.coords, r = this.colors, x = new Int32Array(16), b = new Int32Array(4);
              for (; g.hasData; ) {
                const I = g.readFlag();
                if (!(0 <= I && I <= 3))
                  throw new n.FormatError("Unknown type6 flag");
                const h = v.length;
                for (let N = 0, E = I !== 0 ? 8 : 12; N < E; N++)
                  v.push(g.readCoordinate());
                const y = r.length;
                for (let N = 0, E = I !== 0 ? 2 : 4; N < E; N++)
                  r.push(g.readComponents());
                let P, c, d, A;
                switch (I) {
                  case 0:
                    x[12] = h + 3, x[13] = h + 4, x[14] = h + 5, x[15] = h + 6, x[8] = h + 2, x[11] = h + 7, x[4] = h + 1, x[7] = h + 8, x[0] = h, x[1] = h + 11, x[2] = h + 10, x[3] = h + 9, b[2] = y + 1, b[3] = y + 2, b[0] = y, b[1] = y + 3;
                    break;
                  case 1:
                    P = x[12], c = x[13], d = x[14], A = x[15], x[12] = A, x[13] = h + 0, x[14] = h + 1, x[15] = h + 2, x[8] = d, x[11] = h + 3, x[4] = c, x[7] = h + 4, x[0] = P, x[1] = h + 7, x[2] = h + 6, x[3] = h + 5, P = b[2], c = b[3], b[2] = c, b[3] = y, b[0] = P, b[1] = y + 1;
                    break;
                  case 2:
                    P = x[15], c = x[11], x[12] = x[3], x[13] = h + 0, x[14] = h + 1, x[15] = h + 2, x[8] = x[7], x[11] = h + 3, x[4] = c, x[7] = h + 4, x[0] = P, x[1] = h + 7, x[2] = h + 6, x[3] = h + 5, P = b[3], b[2] = b[1], b[3] = y, b[0] = P, b[1] = y + 1;
                    break;
                  case 3:
                    x[12] = x[0], x[13] = h + 0, x[14] = h + 1, x[15] = h + 2, x[8] = x[1], x[11] = h + 3, x[4] = x[2], x[7] = h + 4, x[0] = x[3], x[1] = h + 7, x[2] = h + 6, x[3] = h + 5, b[2] = b[0], b[3] = y, b[0] = b[1], b[1] = y + 1;
                    break;
                }
                x[5] = v.length, v.push([(-4 * v[x[0]][0] - v[x[15]][0] + 6 * (v[x[4]][0] + v[x[1]][0]) - 2 * (v[x[12]][0] + v[x[3]][0]) + 3 * (v[x[13]][0] + v[x[7]][0])) / 9, (-4 * v[x[0]][1] - v[x[15]][1] + 6 * (v[x[4]][1] + v[x[1]][1]) - 2 * (v[x[12]][1] + v[x[3]][1]) + 3 * (v[x[13]][1] + v[x[7]][1])) / 9]), x[6] = v.length, v.push([(-4 * v[x[3]][0] - v[x[12]][0] + 6 * (v[x[2]][0] + v[x[7]][0]) - 2 * (v[x[0]][0] + v[x[15]][0]) + 3 * (v[x[4]][0] + v[x[14]][0])) / 9, (-4 * v[x[3]][1] - v[x[12]][1] + 6 * (v[x[2]][1] + v[x[7]][1]) - 2 * (v[x[0]][1] + v[x[15]][1]) + 3 * (v[x[4]][1] + v[x[14]][1])) / 9]), x[9] = v.length, v.push([(-4 * v[x[12]][0] - v[x[3]][0] + 6 * (v[x[8]][0] + v[x[13]][0]) - 2 * (v[x[0]][0] + v[x[15]][0]) + 3 * (v[x[11]][0] + v[x[1]][0])) / 9, (-4 * v[x[12]][1] - v[x[3]][1] + 6 * (v[x[8]][1] + v[x[13]][1]) - 2 * (v[x[0]][1] + v[x[15]][1]) + 3 * (v[x[11]][1] + v[x[1]][1])) / 9]), x[10] = v.length, v.push([(-4 * v[x[15]][0] - v[x[0]][0] + 6 * (v[x[11]][0] + v[x[14]][0]) - 2 * (v[x[12]][0] + v[x[3]][0]) + 3 * (v[x[2]][0] + v[x[8]][0])) / 9, (-4 * v[x[15]][1] - v[x[0]][1] + 6 * (v[x[11]][1] + v[x[14]][1]) - 2 * (v[x[12]][1] + v[x[3]][1]) + 3 * (v[x[2]][1] + v[x[8]][1])) / 9]), this.figures.push({
                  type: "patch",
                  coords: new Int32Array(x),
                  colors: new Int32Array(b)
                });
              }
            }
            _decodeType7Shading(g) {
              const v = this.coords, r = this.colors, x = new Int32Array(16), b = new Int32Array(4);
              for (; g.hasData; ) {
                const I = g.readFlag();
                if (!(0 <= I && I <= 3))
                  throw new n.FormatError("Unknown type7 flag");
                const h = v.length;
                for (let N = 0, E = I !== 0 ? 12 : 16; N < E; N++)
                  v.push(g.readCoordinate());
                const y = r.length;
                for (let N = 0, E = I !== 0 ? 2 : 4; N < E; N++)
                  r.push(g.readComponents());
                let P, c, d, A;
                switch (I) {
                  case 0:
                    x[12] = h + 3, x[13] = h + 4, x[14] = h + 5, x[15] = h + 6, x[8] = h + 2, x[9] = h + 13, x[10] = h + 14, x[11] = h + 7, x[4] = h + 1, x[5] = h + 12, x[6] = h + 15, x[7] = h + 8, x[0] = h, x[1] = h + 11, x[2] = h + 10, x[3] = h + 9, b[2] = y + 1, b[3] = y + 2, b[0] = y, b[1] = y + 3;
                    break;
                  case 1:
                    P = x[12], c = x[13], d = x[14], A = x[15], x[12] = A, x[13] = h + 0, x[14] = h + 1, x[15] = h + 2, x[8] = d, x[9] = h + 9, x[10] = h + 10, x[11] = h + 3, x[4] = c, x[5] = h + 8, x[6] = h + 11, x[7] = h + 4, x[0] = P, x[1] = h + 7, x[2] = h + 6, x[3] = h + 5, P = b[2], c = b[3], b[2] = c, b[3] = y, b[0] = P, b[1] = y + 1;
                    break;
                  case 2:
                    P = x[15], c = x[11], x[12] = x[3], x[13] = h + 0, x[14] = h + 1, x[15] = h + 2, x[8] = x[7], x[9] = h + 9, x[10] = h + 10, x[11] = h + 3, x[4] = c, x[5] = h + 8, x[6] = h + 11, x[7] = h + 4, x[0] = P, x[1] = h + 7, x[2] = h + 6, x[3] = h + 5, P = b[3], b[2] = b[1], b[3] = y, b[0] = P, b[1] = y + 1;
                    break;
                  case 3:
                    x[12] = x[0], x[13] = h + 0, x[14] = h + 1, x[15] = h + 2, x[8] = x[1], x[9] = h + 9, x[10] = h + 10, x[11] = h + 3, x[4] = x[2], x[5] = h + 8, x[6] = h + 11, x[7] = h + 4, x[0] = x[3], x[1] = h + 7, x[2] = h + 6, x[3] = h + 5, b[2] = b[0], b[3] = y, b[0] = b[1], b[1] = y + 1;
                    break;
                }
                this.figures.push({
                  type: "patch",
                  coords: new Int32Array(x),
                  colors: new Int32Array(b)
                });
              }
            }
            _buildFigureFromPatch(g) {
              const v = this.figures[g];
              (0, n.assert)(v.type === "patch", "Unexpected patch mesh figure");
              const r = this.coords, x = this.colors, b = v.coords, I = v.colors, h = Math.min(r[b[0]][0], r[b[3]][0], r[b[12]][0], r[b[15]][0]), y = Math.min(r[b[0]][1], r[b[3]][1], r[b[12]][1], r[b[15]][1]), P = Math.max(r[b[0]][0], r[b[3]][0], r[b[12]][0], r[b[15]][0]), c = Math.max(r[b[0]][1], r[b[3]][1], r[b[12]][1], r[b[15]][1]);
              let d = Math.ceil((P - h) * s.TRIANGLE_DENSITY / (this.bounds[2] - this.bounds[0]));
              d = Math.max(s.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(s.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, d));
              let A = Math.ceil((c - y) * s.TRIANGLE_DENSITY / (this.bounds[3] - this.bounds[1]));
              A = Math.max(s.MIN_SPLIT_PATCH_CHUNKS_AMOUNT, Math.min(s.MAX_SPLIT_PATCH_CHUNKS_AMOUNT, A));
              const N = d + 1, E = new Int32Array((A + 1) * N), H = new Int32Array((A + 1) * N);
              let $ = 0;
              const m = new Uint8Array(3), p = new Uint8Array(3), T = x[I[0]], L = x[I[1]], _ = x[I[2]], G = x[I[3]], J = w(A), K = w(d);
              for (let V = 0; V <= A; V++) {
                m[0] = (T[0] * (A - V) + _[0] * V) / A | 0, m[1] = (T[1] * (A - V) + _[1] * V) / A | 0, m[2] = (T[2] * (A - V) + _[2] * V) / A | 0, p[0] = (L[0] * (A - V) + G[0] * V) / A | 0, p[1] = (L[1] * (A - V) + G[1] * V) / A | 0, p[2] = (L[2] * (A - V) + G[2] * V) / A | 0;
                for (let U = 0; U <= d; U++, $++) {
                  if ((V === 0 || V === A) && (U === 0 || U === d))
                    continue;
                  let Q = 0, X = 0, R = 0;
                  for (let D = 0; D <= 3; D++)
                    for (let z = 0; z <= 3; z++, R++) {
                      const Y = J[V][D] * K[U][z];
                      Q += r[b[R]][0] * Y, X += r[b[R]][1] * Y;
                    }
                  E[$] = r.length, r.push([Q, X]), H[$] = x.length;
                  const f = new Uint8Array(3);
                  f[0] = (m[0] * (d - U) + p[0] * U) / d | 0, f[1] = (m[1] * (d - U) + p[1] * U) / d | 0, f[2] = (m[2] * (d - U) + p[2] * U) / d | 0, x.push(f);
                }
              }
              E[0] = b[0], H[0] = I[0], E[d] = b[3], H[d] = I[1], E[N * A] = b[12], H[N * A] = I[2], E[N * A + d] = b[15], H[N * A + d] = I[3], this.figures[g] = {
                type: "lattice",
                coords: E,
                colors: H,
                verticesPerRow: N
              };
            }
            _updateBounds() {
              let g = this.coords[0][0], v = this.coords[0][1], r = g, x = v;
              for (let b = 1, I = this.coords.length; b < I; b++) {
                const h = this.coords[b][0], y = this.coords[b][1];
                g = g > h ? h : g, v = v > y ? y : v, r = r < h ? h : r, x = x < y ? y : x;
              }
              this.bounds = [g, v, r, x];
            }
            _packData() {
              let g, v, r, x;
              const b = this.coords, I = new Float32Array(b.length * 2);
              for (g = 0, r = 0, v = b.length; g < v; g++) {
                const c = b[g];
                I[r++] = c[0], I[r++] = c[1];
              }
              this.coords = I;
              const h = this.colors, y = new Uint8Array(h.length * 3);
              for (g = 0, r = 0, v = h.length; g < v; g++) {
                const c = h[g];
                y[r++] = c[0], y[r++] = c[1], y[r++] = c[2];
              }
              this.colors = y;
              const P = this.figures;
              for (g = 0, v = P.length; g < v; g++) {
                const c = P[g], d = c.coords, A = c.colors;
                for (r = 0, x = d.length; r < x; r++)
                  d[r] *= 2, A[r] *= 3;
              }
            }
            getIR() {
              return ["Mesh", this.shadingType, this.coords, this.colors, this.figures, this.bounds, this.bbox, this.background];
            }
          };
          Dt(s, "MIN_SPLIT_PATCH_CHUNKS_AMOUNT", 3), Dt(s, "MAX_SPLIT_PATCH_CHUNKS_AMOUNT", 20), Dt(s, "TRIANGLE_DENSITY", 20);
          let C = s;
          class i extends j {
            getIR() {
              return ["Dummy"];
            }
          }
          function o(l, g, v) {
            const r = g.getArray("Matrix"), x = n.Util.normalizeRect(g.getArray("BBox")), b = g.get("XStep"), I = g.get("YStep"), h = g.get("PaintType"), y = g.get("TilingType");
            if (x[2] - x[0] === 0 || x[3] - x[1] === 0)
              throw new n.FormatError(`Invalid getTilingPatternIR /BBox array: [${x}].`);
            return ["TilingPattern", v, l, r, x, b, I, h, y];
          }
        },
        /* 51 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.getXfaFontDict = i, F.getXfaFontName = w;
          var n = ae(52), u = ae(4), q = ae(53), e = ae(54), t = ae(55), B = ae(56), j = ae(3), M = ae(38);
          const O = (0, j.getLookupTableFactory)(function(o) {
            o["MyriadPro-Regular"] = o["PdfJS-Fallback-Regular"] = {
              name: "LiberationSans-Regular",
              factors: t.MyriadProRegularFactors,
              baseWidths: e.LiberationSansRegularWidths,
              baseMapping: e.LiberationSansRegularMapping,
              metrics: t.MyriadProRegularMetrics
            }, o["MyriadPro-Bold"] = o["PdfJS-Fallback-Bold"] = {
              name: "LiberationSans-Bold",
              factors: t.MyriadProBoldFactors,
              baseWidths: e.LiberationSansBoldWidths,
              baseMapping: e.LiberationSansBoldMapping,
              metrics: t.MyriadProBoldMetrics
            }, o["MyriadPro-It"] = o["MyriadPro-Italic"] = o["PdfJS-Fallback-Italic"] = {
              name: "LiberationSans-Italic",
              factors: t.MyriadProItalicFactors,
              baseWidths: e.LiberationSansItalicWidths,
              baseMapping: e.LiberationSansItalicMapping,
              metrics: t.MyriadProItalicMetrics
            }, o["MyriadPro-BoldIt"] = o["MyriadPro-BoldItalic"] = o["PdfJS-Fallback-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: t.MyriadProBoldItalicFactors,
              baseWidths: e.LiberationSansBoldItalicWidths,
              baseMapping: e.LiberationSansBoldItalicMapping,
              metrics: t.MyriadProBoldItalicMetrics
            }, o.ArialMT = o.Arial = o["Arial-Regular"] = {
              name: "LiberationSans-Regular",
              baseWidths: e.LiberationSansRegularWidths,
              baseMapping: e.LiberationSansRegularMapping
            }, o["Arial-BoldMT"] = o["Arial-Bold"] = {
              name: "LiberationSans-Bold",
              baseWidths: e.LiberationSansBoldWidths,
              baseMapping: e.LiberationSansBoldMapping
            }, o["Arial-ItalicMT"] = o["Arial-Italic"] = {
              name: "LiberationSans-Italic",
              baseWidths: e.LiberationSansItalicWidths,
              baseMapping: e.LiberationSansItalicMapping
            }, o["Arial-BoldItalicMT"] = o["Arial-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              baseWidths: e.LiberationSansBoldItalicWidths,
              baseMapping: e.LiberationSansBoldItalicMapping
            }, o["Calibri-Regular"] = {
              name: "LiberationSans-Regular",
              factors: n.CalibriRegularFactors,
              baseWidths: e.LiberationSansRegularWidths,
              baseMapping: e.LiberationSansRegularMapping,
              metrics: n.CalibriRegularMetrics
            }, o["Calibri-Bold"] = {
              name: "LiberationSans-Bold",
              factors: n.CalibriBoldFactors,
              baseWidths: e.LiberationSansBoldWidths,
              baseMapping: e.LiberationSansBoldMapping,
              metrics: n.CalibriBoldMetrics
            }, o["Calibri-Italic"] = {
              name: "LiberationSans-Italic",
              factors: n.CalibriItalicFactors,
              baseWidths: e.LiberationSansItalicWidths,
              baseMapping: e.LiberationSansItalicMapping,
              metrics: n.CalibriItalicMetrics
            }, o["Calibri-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: n.CalibriBoldItalicFactors,
              baseWidths: e.LiberationSansBoldItalicWidths,
              baseMapping: e.LiberationSansBoldItalicMapping,
              metrics: n.CalibriBoldItalicMetrics
            }, o["Segoeui-Regular"] = {
              name: "LiberationSans-Regular",
              factors: B.SegoeuiRegularFactors,
              baseWidths: e.LiberationSansRegularWidths,
              baseMapping: e.LiberationSansRegularMapping,
              metrics: B.SegoeuiRegularMetrics
            }, o["Segoeui-Bold"] = {
              name: "LiberationSans-Bold",
              factors: B.SegoeuiBoldFactors,
              baseWidths: e.LiberationSansBoldWidths,
              baseMapping: e.LiberationSansBoldMapping,
              metrics: B.SegoeuiBoldMetrics
            }, o["Segoeui-Italic"] = {
              name: "LiberationSans-Italic",
              factors: B.SegoeuiItalicFactors,
              baseWidths: e.LiberationSansItalicWidths,
              baseMapping: e.LiberationSansItalicMapping,
              metrics: B.SegoeuiItalicMetrics
            }, o["Segoeui-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: B.SegoeuiBoldItalicFactors,
              baseWidths: e.LiberationSansBoldItalicWidths,
              baseMapping: e.LiberationSansBoldItalicMapping,
              metrics: B.SegoeuiBoldItalicMetrics
            }, o["Helvetica-Regular"] = o.Helvetica = {
              name: "LiberationSans-Regular",
              factors: q.HelveticaRegularFactors,
              baseWidths: e.LiberationSansRegularWidths,
              baseMapping: e.LiberationSansRegularMapping,
              metrics: q.HelveticaRegularMetrics
            }, o["Helvetica-Bold"] = {
              name: "LiberationSans-Bold",
              factors: q.HelveticaBoldFactors,
              baseWidths: e.LiberationSansBoldWidths,
              baseMapping: e.LiberationSansBoldMapping,
              metrics: q.HelveticaBoldMetrics
            }, o["Helvetica-Italic"] = {
              name: "LiberationSans-Italic",
              factors: q.HelveticaItalicFactors,
              baseWidths: e.LiberationSansItalicWidths,
              baseMapping: e.LiberationSansItalicMapping,
              metrics: q.HelveticaItalicMetrics
            }, o["Helvetica-BoldItalic"] = {
              name: "LiberationSans-BoldItalic",
              factors: q.HelveticaBoldItalicFactors,
              baseWidths: e.LiberationSansBoldItalicWidths,
              baseMapping: e.LiberationSansBoldItalicMapping,
              metrics: q.HelveticaBoldItalicMetrics
            };
          });
          function w(o) {
            const k = (0, M.normalizeFontName)(o);
            return O()[k];
          }
          function C(o) {
            const k = w(o);
            if (!k)
              return null;
            const {
              baseWidths: s,
              baseMapping: l,
              factors: g
            } = k;
            let v;
            g ? v = s.map((I, h) => I * g[h]) : v = s;
            let r = -2, x;
            const b = [];
            for (const [I, h] of l.map((y, P) => [y, P]).sort(([y], [P]) => y - P))
              I !== -1 && (I === r + 1 ? (x.push(v[h]), r += 1) : (r = I, x = [v[h]], b.push(I, x)));
            return b;
          }
          function i(o) {
            const k = C(o), s = new u.Dict(null);
            s.set("BaseFont", u.Name.get(o)), s.set("Type", u.Name.get("Font")), s.set("Subtype", u.Name.get("CIDFontType2")), s.set("Encoding", u.Name.get("Identity-H")), s.set("CIDToGIDMap", u.Name.get("Identity")), s.set("W", k), s.set("FirstChar", k[0]), s.set("LastChar", k.at(-2) + k.at(-1).length - 1);
            const l = new u.Dict(null);
            s.set("FontDescriptor", l);
            const g = new u.Dict(null);
            return g.set("Ordering", "Identity"), g.set("Registry", "Adobe"), g.set("Supplement", 0), s.set("CIDSystemInfo", g), s;
          }
        },
        /* 52 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.CalibriRegularMetrics = F.CalibriRegularFactors = F.CalibriItalicMetrics = F.CalibriItalicFactors = F.CalibriBoldMetrics = F.CalibriBoldItalicMetrics = F.CalibriBoldItalicFactors = F.CalibriBoldFactors = void 0;
          const ae = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.54657, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.73293, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.9121, 0.86943, 0.79795, 0.88198, 0.77958, 0.70864, 0.81055, 0.90399, 0.88653, 0.96017, 0.82577, 0.77892, 0.78257, 0.97507, 1.54657, 0.97507, 0.85284, 0.89552, 0.90176, 0.88762, 0.8785, 0.75241, 0.8785, 0.90518, 0.95015, 0.77618, 0.8785, 0.88401, 0.91916, 0.86304, 0.88401, 0.91488, 0.8785, 0.8801, 0.8785, 0.8785, 0.91343, 0.7173, 1.04106, 0.8785, 0.85075, 0.95794, 0.82616, 0.85162, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.12401, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.73293, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.9121, 0.86943, 0.86943, 0.86943, 0.86943, 0.86943, 0.85284, 0.87508, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.88762, 0.8715, 0.75241, 0.90518, 0.90518, 0.90518, 0.90518, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.8785, 0.8801, 0.8801, 0.8801, 0.8801, 0.8801, 0.90747, 0.89049, 0.8785, 0.8785, 0.8785, 0.8785, 0.85162, 0.8785, 0.85162, 0.83908, 0.88762, 0.83908, 0.88762, 0.83908, 0.88762, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.73293, 0.75241, 0.87289, 0.83016, 0.88506, 0.93125, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.73133, 0.90518, 0.81921, 0.77618, 0.81921, 0.77618, 0.81921, 0.77618, 1, 1, 0.87356, 0.8785, 0.91075, 0.89608, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76229, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.79468, 0.91926, 0.88175, 0.70823, 0.94903, 0.9121, 0.8785, 1, 1, 0.9121, 0.8785, 0.87802, 0.88656, 0.8785, 0.86943, 0.8801, 0.86943, 0.8801, 0.86943, 0.8801, 0.87402, 0.89291, 0.77958, 0.91343, 1, 1, 0.77958, 0.91343, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 0.70864, 0.7173, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.90399, 0.8785, 0.96017, 0.95794, 0.77892, 0.85162, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.88762, 0.77539, 0.8715, 0.87508, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70674, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.06303, 0.83908, 0.80352, 0.57184, 0.6965, 0.56289, 0.82001, 0.56029, 0.81235, 1.02988, 0.83908, 0.7762, 0.68156, 0.80367, 0.73133, 0.78257, 0.87356, 0.86943, 0.95958, 0.75727, 0.89019, 1.04924, 0.9121, 0.7648, 0.86943, 0.87356, 0.79795, 0.78275, 0.81055, 0.77892, 0.9762, 0.82577, 0.99819, 0.84896, 0.95958, 0.77892, 0.96108, 1.01407, 0.89049, 1.02988, 0.94211, 0.96108, 0.8936, 0.84021, 0.87842, 0.96399, 0.79109, 0.89049, 1.00813, 1.02988, 0.86077, 0.87445, 0.92099, 0.84723, 0.86513, 0.8801, 0.75638, 0.85714, 0.78216, 0.79586, 0.87965, 0.94211, 0.97747, 0.78287, 0.97926, 0.84971, 1.02988, 0.94211, 0.8801, 0.94211, 0.84971, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90264, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90518, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90548, 1, 1, 1, 1, 1, 1, 0.96017, 0.95794, 0.96017, 0.95794, 0.96017, 0.95794, 0.77892, 0.85162, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.92794, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71143, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.93835, 0.83406, 0.91133, 0.84107, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90527, 1.81055, 0.90527, 1.81055, 1.31006, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.CalibriBoldFactors = ae;
          const n = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          F.CalibriBoldMetrics = n;
          const u = [1.3877, 1, 1, 1, 0.97801, 0.92482, 0.89552, 0.91133, 0.81988, 0.97566, 0.98152, 0.93548, 0.93548, 1.2798, 0.85284, 0.92794, 1, 0.96134, 1.56239, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.82845, 0.82845, 0.85284, 0.85284, 0.85284, 0.75859, 0.92138, 0.83908, 0.7762, 0.71805, 0.87289, 0.73133, 0.7514, 0.81921, 0.87356, 0.95958, 0.59526, 0.75727, 0.69225, 1.04924, 0.90872, 0.85938, 0.79795, 0.87068, 0.77958, 0.69766, 0.81055, 0.90399, 0.88653, 0.96068, 0.82577, 0.77892, 0.78257, 0.97507, 1.529, 0.97507, 0.85284, 0.89552, 0.90176, 0.94908, 0.86411, 0.74012, 0.86411, 0.88323, 0.95015, 0.86411, 0.86331, 0.88401, 0.91916, 0.86304, 0.88401, 0.9039, 0.86331, 0.86331, 0.86411, 0.86411, 0.90464, 0.70852, 1.04106, 0.86331, 0.84372, 0.95794, 0.82616, 0.84548, 0.79492, 0.88331, 1.69808, 0.88331, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.7801, 0.89552, 1.24487, 1.13254, 1.19129, 0.96839, 0.85284, 0.68787, 0.70645, 0.85592, 0.90747, 1.01466, 1.0088, 0.90323, 1, 1.07463, 1, 0.91056, 0.75806, 1.19118, 0.96839, 0.78864, 0.82845, 0.84133, 0.75859, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.83908, 0.77539, 0.71805, 0.73133, 0.73133, 0.73133, 0.73133, 0.95958, 0.95958, 0.95958, 0.95958, 0.88506, 0.90872, 0.85938, 0.85938, 0.85938, 0.85938, 0.85938, 0.85284, 0.87068, 0.90399, 0.90399, 0.90399, 0.90399, 0.77892, 0.79795, 0.90807, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.94908, 0.85887, 0.74012, 0.88323, 0.88323, 0.88323, 0.88323, 0.88401, 0.88401, 0.88401, 0.88401, 0.8785, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.86331, 0.90747, 0.89049, 0.86331, 0.86331, 0.86331, 0.86331, 0.84548, 0.86411, 0.84548, 0.83908, 0.94908, 0.83908, 0.94908, 0.83908, 0.94908, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.71805, 0.74012, 0.87289, 0.79538, 0.88506, 0.92726, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.73133, 0.88323, 0.81921, 0.86411, 0.81921, 0.86411, 0.81921, 0.86411, 1, 1, 0.87356, 0.86331, 0.91075, 0.8777, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.95958, 0.88401, 0.76467, 0.90167, 0.59526, 0.91916, 1, 1, 0.86304, 0.69225, 0.88401, 1, 1, 0.70424, 0.77312, 0.91926, 0.88175, 0.70823, 0.94903, 0.90872, 0.86331, 1, 1, 0.90872, 0.86331, 0.86906, 0.88116, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.85938, 0.86331, 0.87402, 0.86549, 0.77958, 0.90464, 1, 1, 0.77958, 0.90464, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 0.69766, 0.70852, 1, 1, 0.81055, 0.75841, 0.81055, 1.06452, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.90399, 0.86331, 0.96068, 0.95794, 0.77892, 0.84548, 0.77892, 0.78257, 0.79492, 0.78257, 0.79492, 0.78257, 0.79492, 0.9297, 0.56892, 0.83908, 0.94908, 0.77539, 0.85887, 0.87068, 0.89049, 1, 1, 0.81055, 1.04106, 1.20528, 1.20528, 1, 1.15543, 0.70088, 0.98387, 0.94721, 1.33431, 1.45894, 0.95161, 1.48387, 0.83908, 0.80352, 0.57118, 0.6965, 0.56347, 0.79179, 0.55853, 0.80346, 1.02988, 0.83908, 0.7762, 0.67174, 0.86036, 0.73133, 0.78257, 0.87356, 0.86441, 0.95958, 0.75727, 0.89019, 1.04924, 0.90872, 0.74889, 0.85938, 0.87891, 0.79795, 0.7957, 0.81055, 0.77892, 0.97447, 0.82577, 0.97466, 0.87179, 0.95958, 0.77892, 0.94252, 0.95612, 0.8753, 1.02988, 0.92733, 0.94252, 0.87411, 0.84021, 0.8728, 0.95612, 0.74081, 0.8753, 1.02189, 1.02988, 0.84814, 0.87445, 0.91822, 0.84723, 0.85668, 0.86331, 0.81344, 0.87581, 0.76422, 0.82046, 0.96057, 0.92733, 0.99375, 0.78022, 0.95452, 0.86015, 1.02988, 0.92733, 0.86331, 0.92733, 0.86015, 0.73133, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90631, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88323, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85174, 1, 1, 1, 1, 1, 1, 0.96068, 0.95794, 0.96068, 0.95794, 0.96068, 0.95794, 0.77892, 0.84548, 1, 1, 0.89552, 0.90527, 1, 0.90363, 0.92794, 0.92794, 0.92794, 0.89807, 0.87012, 0.87012, 0.87012, 0.89552, 0.89552, 1.42259, 0.71094, 1.06152, 1, 1, 1.03372, 1.03372, 0.97171, 1.4956, 2.2807, 0.92972, 0.83406, 0.91133, 0.83326, 0.91133, 1, 1, 1, 0.72021, 1, 1.23108, 0.83489, 0.88525, 0.88525, 0.81499, 0.90616, 1.81055, 0.90527, 1.81055, 1.3107, 1.53711, 0.94434, 1.08696, 1, 0.95018, 0.77192, 0.85284, 0.90747, 1.17534, 0.69825, 0.9716, 1.37077, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.08004, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90727, 0.90727, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.CalibriBoldItalicFactors = u;
          const q = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          F.CalibriBoldItalicMetrics = q;
          const e = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39543, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.72346, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89249, 0.84118, 0.77452, 0.85374, 0.75186, 0.67789, 0.79776, 0.88844, 0.85066, 0.94309, 0.77818, 0.7306, 0.76659, 1.10369, 1.38313, 1.10369, 1.06139, 0.89552, 0.8739, 0.9245, 0.9245, 0.83203, 0.9245, 0.85865, 1.09842, 0.9245, 0.9245, 1.03297, 1.07692, 0.90918, 1.03297, 0.94959, 0.9245, 0.92274, 0.9245, 0.9245, 1.02933, 0.77832, 1.20562, 0.9245, 0.8916, 0.98986, 0.86621, 0.89453, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.16359, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.72346, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89249, 0.84118, 0.84118, 0.84118, 0.84118, 0.84118, 0.85284, 0.84557, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.9245, 0.84843, 0.83203, 0.85865, 0.85865, 0.85865, 0.85865, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.9245, 0.92274, 0.92274, 0.92274, 0.92274, 0.92274, 0.90747, 0.86651, 0.9245, 0.9245, 0.9245, 0.9245, 0.89453, 0.9245, 0.89453, 0.8675, 0.9245, 0.8675, 0.9245, 0.8675, 0.9245, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.72346, 0.83203, 0.85193, 0.8875, 0.86477, 0.99034, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.73206, 0.85865, 0.81105, 0.9245, 0.81105, 0.9245, 0.81105, 0.9245, 1, 1, 0.86275, 0.9245, 0.90872, 0.93591, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77896, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.9375, 0.98156, 0.93407, 0.77261, 1.11429, 0.89249, 0.9245, 1, 1, 0.89249, 0.9245, 0.92534, 0.86698, 0.9245, 0.84118, 0.92274, 0.84118, 0.92274, 0.84118, 0.92274, 0.8667, 0.86291, 0.75186, 1.02933, 1, 1, 0.75186, 1.02933, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 0.67789, 0.77832, 1, 1, 0.79776, 0.97655, 0.79776, 1.23023, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.88844, 0.9245, 0.94309, 0.98986, 0.7306, 0.89453, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.9245, 0.76318, 0.84843, 0.84557, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67009, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.8675, 0.90861, 0.6192, 0.7363, 0.64824, 0.82411, 0.56321, 0.85696, 1.23516, 0.8675, 0.81552, 0.7286, 0.84134, 0.73206, 0.76659, 0.86275, 0.84369, 0.90685, 0.77892, 0.85871, 1.02638, 0.89249, 0.75828, 0.84118, 0.85984, 0.77452, 0.76466, 0.79776, 0.7306, 0.90782, 0.77818, 0.903, 0.87291, 0.90685, 0.7306, 0.99058, 1.03667, 0.94635, 1.23516, 0.9849, 0.99058, 0.92393, 0.8916, 0.942, 1.03667, 0.75026, 0.94635, 1.0297, 1.23516, 0.90918, 0.94048, 0.98217, 0.89746, 0.84153, 0.92274, 0.82507, 0.88832, 0.84438, 0.88178, 1.03525, 0.9849, 1.00225, 0.78086, 0.97248, 0.89404, 1.23516, 0.9849, 0.92274, 0.9849, 0.89404, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89693, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.85865, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.90933, 1, 1, 1, 1, 1, 1, 0.94309, 0.98986, 0.94309, 0.98986, 0.94309, 0.98986, 0.7306, 0.89453, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.68994, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.97858, 0.82616, 0.91133, 0.83437, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90572, 1.81055, 0.90749, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85284, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.CalibriItalicFactors = e;
          const t = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          F.CalibriItalicMetrics = t;
          const B = [1.3877, 1, 1, 1, 1.17223, 1.1293, 0.89552, 0.91133, 0.80395, 1.02269, 1.15601, 0.91056, 0.91056, 1.2798, 0.85284, 0.89807, 1, 0.90861, 1.39016, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.91133, 0.96309, 0.96309, 0.85284, 0.85284, 0.85284, 0.83319, 0.88071, 0.8675, 0.81552, 0.73834, 0.85193, 0.73206, 0.7522, 0.81105, 0.86275, 0.90685, 0.6377, 0.77892, 0.75593, 1.02638, 0.89385, 0.85122, 0.77452, 0.86503, 0.75186, 0.68887, 0.79776, 0.88844, 0.85066, 0.94258, 0.77818, 0.7306, 0.76659, 1.10369, 1.39016, 1.10369, 1.06139, 0.89552, 0.8739, 0.86128, 0.94469, 0.8457, 0.94469, 0.89464, 1.09842, 0.84636, 0.94469, 1.03297, 1.07692, 0.90918, 1.03297, 0.95897, 0.94469, 0.9482, 0.94469, 0.94469, 1.04692, 0.78223, 1.20562, 0.94469, 0.90332, 0.98986, 0.86621, 0.90527, 0.79004, 0.94152, 1.77256, 0.94152, 0.85284, 0.97801, 0.89552, 0.91133, 0.89552, 0.91133, 1.91729, 0.89552, 1.17889, 1.13254, 1.08707, 0.92098, 0.85284, 0.68787, 0.71353, 0.84737, 0.90747, 1.0088, 1.0044, 0.87683, 1, 1.09091, 1, 0.92229, 0.739, 1.15642, 0.92098, 0.76288, 0.80504, 0.80972, 0.75859, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.8675, 0.76318, 0.73834, 0.73206, 0.73206, 0.73206, 0.73206, 0.90685, 0.90685, 0.90685, 0.90685, 0.86477, 0.89385, 0.85122, 0.85122, 0.85122, 0.85122, 0.85122, 0.85284, 0.85311, 0.88844, 0.88844, 0.88844, 0.88844, 0.7306, 0.77452, 0.86331, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.86128, 0.8693, 0.8457, 0.89464, 0.89464, 0.89464, 0.89464, 0.82601, 0.82601, 0.82601, 0.82601, 0.94469, 0.94469, 0.9482, 0.9482, 0.9482, 0.9482, 0.9482, 0.90747, 0.86651, 0.94469, 0.94469, 0.94469, 0.94469, 0.90527, 0.94469, 0.90527, 0.8675, 0.86128, 0.8675, 0.86128, 0.8675, 0.86128, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.73834, 0.8457, 0.85193, 0.92454, 0.86477, 0.9921, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.73206, 0.89464, 0.81105, 0.84636, 0.81105, 0.84636, 0.81105, 0.84636, 1, 1, 0.86275, 0.94469, 0.90872, 0.95786, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 0.82601, 0.90685, 1.03297, 0.90685, 0.82601, 0.77741, 1.05611, 0.6377, 1.07692, 1, 1, 0.90918, 0.75593, 1.03297, 1, 1, 0.76032, 0.90452, 0.98156, 1.11842, 0.77261, 1.11429, 0.89385, 0.94469, 1, 1, 0.89385, 0.94469, 0.95877, 0.86901, 0.94469, 0.85122, 0.9482, 0.85122, 0.9482, 0.85122, 0.9482, 0.8667, 0.90016, 0.75186, 1.04692, 1, 1, 0.75186, 1.04692, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 0.68887, 0.78223, 1, 1, 0.79776, 0.92188, 0.79776, 1.23023, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.88844, 0.94469, 0.94258, 0.98986, 0.7306, 0.90527, 0.7306, 0.76659, 0.79004, 0.76659, 0.79004, 0.76659, 0.79004, 1.09231, 0.54873, 0.8675, 0.86128, 0.76318, 0.8693, 0.85311, 0.86651, 1, 1, 0.79776, 1.20562, 1.18622, 1.18622, 1, 1.1437, 0.67742, 0.96334, 0.93695, 1.35191, 1.40909, 0.95161, 1.48387, 0.86686, 0.90861, 0.62267, 0.74359, 0.65649, 0.85498, 0.56963, 0.88254, 1.23516, 0.8675, 0.81552, 0.75443, 0.84503, 0.73206, 0.76659, 0.86275, 0.85122, 0.90685, 0.77892, 0.85746, 1.02638, 0.89385, 0.75657, 0.85122, 0.86275, 0.77452, 0.74171, 0.79776, 0.7306, 0.95165, 0.77818, 0.89772, 0.88831, 0.90685, 0.7306, 0.98142, 1.02191, 0.96576, 1.23516, 0.99018, 0.98142, 0.9236, 0.89258, 0.94035, 1.02191, 0.78848, 0.96576, 0.9561, 1.23516, 0.90918, 0.92578, 0.95424, 0.89746, 0.83969, 0.9482, 0.80113, 0.89442, 0.85208, 0.86155, 0.98022, 0.99018, 1.00452, 0.81209, 0.99247, 0.89181, 1.23516, 0.99018, 0.9482, 0.99018, 0.89181, 0.73206, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.88844, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89464, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96766, 1, 1, 1, 1, 1, 1, 0.94258, 0.98986, 0.94258, 0.98986, 0.94258, 0.98986, 0.7306, 0.90527, 1, 1, 0.89552, 0.90527, 1, 0.90186, 1.12308, 1.12308, 1.12308, 1.12308, 1.2566, 1.2566, 1.2566, 0.89552, 0.89552, 1.42259, 0.69043, 1.03809, 1, 1, 1.0176, 1.0176, 1.11523, 1.4956, 2.01462, 0.99331, 0.82616, 0.91133, 0.84286, 0.91133, 1, 1, 1, 0.70508, 1, 1.23108, 0.79801, 0.84426, 0.84426, 0.774, 0.90527, 1.81055, 0.90527, 1.81055, 1.28809, 1.55469, 0.94434, 1.07806, 1, 0.97094, 0.7589, 0.85284, 0.90747, 1.19658, 0.69825, 0.97622, 1.33512, 0.90747, 0.90747, 0.85356, 0.90747, 0.90747, 1.44947, 0.85284, 0.8941, 0.8941, 0.70572, 0.8, 0.70572, 0.70572, 0.70572, 0.70572, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.99862, 0.99862, 1, 1, 1, 1, 1, 1.0336, 0.91027, 1, 1, 1, 0.99862, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05859, 1.05859, 1, 1, 1, 1.07185, 0.99413, 0.96334, 1.08065, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.CalibriRegularFactors = B;
          const j = {
            lineHeight: 1.2207,
            lineGap: 0.2207
          };
          F.CalibriRegularMetrics = j;
        },
        /* 53 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.HelveticaRegularMetrics = F.HelveticaRegularFactors = F.HelveticaItalicMetrics = F.HelveticaItalicFactors = F.HelveticaBoldMetrics = F.HelveticaBoldItalicMetrics = F.HelveticaBoldItalicFactors = F.HelveticaBoldFactors = void 0;
          const ae = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.03374, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.00042, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.03828, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00034, 0.99977, 1, 0.99997, 1.00026, 1.00078, 1.00036, 0.99973, 1.00013, 1.0006, 0.99977, 0.99977, 0.99988, 0.85148, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 1.00069, 1.00022, 0.99977, 1.00001, 0.99984, 1.00026, 1.00001, 1.00024, 1.00001, 0.9999, 1, 1.0006, 1.00001, 1.00041, 0.99962, 1.00026, 1.0006, 0.99995, 1.00041, 0.99942, 0.99973, 0.99927, 1.00082, 0.99902, 1.00026, 1.00087, 1.0006, 1.00069, 0.99973, 0.99867, 0.99973, 0.9993, 1.00026, 1.00049, 1.00056, 1, 0.99988, 0.99935, 0.99995, 0.99954, 1.00055, 0.99945, 1.00032, 1.0006, 0.99995, 1.00026, 0.99995, 1.00032, 1.00001, 1.00008, 0.99971, 1.00019, 0.9994, 1.00001, 1.0006, 1.00044, 0.99973, 1.00023, 1.00047, 1, 0.99942, 0.99561, 0.99989, 1.00035, 0.99977, 1.00035, 0.99977, 1.00019, 0.99944, 1.00001, 1.00021, 0.99926, 1.00035, 1.00035, 0.99942, 1.00048, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.99989, 1.00057, 1.00001, 0.99936, 1.00052, 1.00012, 0.99996, 1.00043, 1, 1.00035, 0.9994, 0.99976, 1.00035, 0.99973, 1.00052, 1.00041, 1.00119, 1.00037, 0.99973, 1.00002, 0.99986, 1.00041, 1.00041, 0.99902, 0.9996, 1.00034, 0.99999, 1.00026, 0.99999, 1.00026, 0.99973, 1.00052, 0.99973, 1, 0.99973, 1.00041, 1.00075, 0.9994, 1.0003, 0.99999, 1, 1.00041, 0.99955, 1, 0.99915, 0.99973, 0.99973, 1.00026, 1.00119, 0.99955, 0.99973, 1.0006, 0.99911, 1.0006, 1.00026, 0.99972, 1.00026, 0.99902, 1.00041, 0.99973, 0.99999, 1, 1, 1.00038, 1.0005, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 1.00047, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.HelveticaBoldFactors = ae;
          const n = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          F.HelveticaBoldMetrics = n;
          const u = [0.76116, 1, 1, 1.0006, 0.99998, 0.99974, 0.99973, 0.99973, 0.99982, 0.99977, 1.00087, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.00003, 1.00003, 1.00003, 1.00026, 0.9999, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 0.99973, 0.99977, 1.00026, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 0.99998, 1.0006, 0.99998, 1.00003, 0.99973, 0.99998, 0.99973, 1.00026, 0.99973, 1.00026, 0.99973, 0.99998, 1.00026, 1.00026, 1.0006, 1.0006, 0.99973, 1.0006, 0.99982, 1.00026, 1.00026, 1.00026, 1.00026, 0.99959, 0.99973, 0.99998, 1.00026, 0.99973, 1.00022, 0.99973, 0.99973, 1, 0.99959, 1.00077, 0.99959, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.00077, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.99973, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 0.99977, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 1.06409, 1.00026, 1.00026, 1.00026, 1.00026, 1.00026, 0.99973, 1.00026, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 1.0044, 0.99977, 1.00026, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99971, 0.99973, 0.99973, 1.0006, 0.99977, 0.99973, 0.99973, 1.00026, 1.0006, 1.00026, 1.0006, 1.00026, 1.01011, 1.00026, 0.99999, 1.00026, 1.0006, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.9993, 0.9998, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1.00022, 1.00026, 1, 1.00016, 0.99977, 0.99959, 0.99977, 0.99959, 0.99977, 0.99959, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00026, 0.99998, 1.00026, 0.8121, 1.00026, 0.99998, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 0.99977, 1.00026, 1.00016, 1.00022, 1.00001, 0.99973, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 1.0006, 0.99973, 0.99977, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 0.99973, 1.00026, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99977, 1, 1, 1.00026, 0.99969, 0.99972, 0.99981, 0.9998, 1.0006, 0.99977, 0.99977, 1.00022, 0.91155, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 0.99977, 1.00001, 0.99999, 0.99977, 0.99966, 1.00022, 1.00032, 1.00001, 0.99944, 1.00026, 1.00001, 0.99968, 1.00001, 1.00047, 1, 1.0006, 1.00001, 0.99981, 1.00101, 1.00026, 1.0006, 0.99948, 0.99981, 1.00064, 0.99973, 0.99942, 1.00101, 1.00061, 1.00026, 1.00069, 1.0006, 1.00014, 0.99973, 1.01322, 0.99973, 1.00065, 1.00026, 1.00012, 0.99923, 1, 1.00064, 1.00076, 0.99948, 1.00055, 1.00063, 1.00007, 0.99943, 1.0006, 0.99948, 1.00026, 0.99948, 0.99943, 1.00001, 1.00001, 1.00029, 1.00038, 1.00035, 1.00001, 1.0006, 1.0006, 0.99973, 0.99978, 1.00001, 1.00057, 0.99989, 0.99967, 0.99964, 0.99967, 0.99977, 0.99999, 0.99977, 1.00038, 0.99977, 1.00001, 0.99973, 1.00066, 0.99967, 0.99967, 1.00041, 0.99998, 0.99999, 0.99977, 1.00022, 0.99967, 1.00001, 0.99977, 1.00026, 0.99964, 1.00031, 1.00001, 0.99999, 0.99999, 1, 1.00023, 1, 1, 0.99999, 1.00035, 1.00001, 0.99999, 0.99973, 0.99977, 0.99999, 1.00058, 0.99973, 0.99973, 0.99955, 0.9995, 1.00026, 1.00026, 1.00032, 0.99989, 1.00034, 0.99999, 1.00026, 1.00026, 1.00026, 0.99973, 0.45998, 0.99973, 1.00026, 0.99973, 1.00001, 0.99999, 0.99982, 0.99994, 0.99996, 1, 1.00042, 1.00044, 1.00029, 1.00023, 0.99973, 0.99973, 1.00026, 0.99949, 1.00002, 0.99973, 1.0006, 1.0006, 1.0006, 0.99975, 1.00026, 1.00026, 1.00032, 0.98685, 0.99973, 1.00026, 1, 1, 0.99966, 1.00044, 1.00016, 1.00022, 1.00016, 1.00022, 1.00016, 1.00022, 1.00001, 0.99973, 1, 1, 0.99973, 1, 1, 0.99955, 1.0006, 1.0006, 1.0006, 1.0006, 1, 1, 1, 0.99973, 0.99973, 0.99972, 1, 1, 1.00106, 0.99999, 0.99998, 0.99998, 0.99999, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1, 0.99973, 0.99971, 0.99978, 1, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00098, 1, 1, 1, 1.00049, 1, 1, 0.99972, 1, 1.20985, 1.39713, 1.00003, 1.00031, 1.00015, 1, 0.99561, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.99972, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.HelveticaBoldItalicFactors = u;
          const q = {
            lineHeight: 1.35,
            lineGap: 0.2
          };
          F.HelveticaBoldItalicMetrics = q;
          const e = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.0288, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 0.99946, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.06311, 0.99973, 1.00024, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00041, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.89547, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 1.00001, 1, 1.00054, 0.99977, 1.00084, 1.00007, 0.99973, 1.00013, 0.99924, 1.00001, 1.00001, 0.99945, 0.91221, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00001, 0.99999, 0.99977, 0.99933, 1.00022, 1.00054, 1.00001, 1.00065, 1.00026, 1.00001, 1.0001, 1.00001, 1.00052, 1, 1.0006, 1.00001, 0.99945, 0.99897, 0.99968, 0.99924, 1.00036, 0.99945, 0.99949, 1, 1.0006, 0.99897, 0.99918, 0.99968, 0.99911, 0.99924, 1, 0.99962, 1.01487, 1, 1.0005, 0.99973, 1.00012, 1.00043, 1, 0.99995, 0.99994, 1.00036, 0.99947, 1.00019, 1.00063, 1.00025, 0.99924, 1.00036, 0.99973, 1.00036, 1.00025, 1.00001, 1.00001, 1.00027, 1.0001, 1.00068, 1.00001, 1.0006, 1.0006, 1, 1.00008, 0.99957, 0.99972, 0.9994, 0.99954, 0.99975, 1.00051, 1.00001, 1.00019, 1.00001, 1.0001, 0.99986, 1.00001, 1.00001, 1.00038, 0.99954, 0.99954, 0.9994, 1.00066, 0.99999, 0.99977, 1.00022, 1.00054, 1.00001, 0.99977, 1.00026, 0.99975, 1.0001, 1.00001, 0.99993, 0.9995, 0.99955, 1.00016, 0.99978, 0.99974, 1.00019, 1.00022, 0.99955, 1.00053, 0.99973, 1.00089, 1.00005, 0.99967, 1.00048, 0.99973, 1.00002, 1.00034, 0.99973, 0.99973, 0.99964, 1.00006, 1.00066, 0.99947, 0.99973, 0.98894, 0.99973, 1, 0.44898, 1, 0.99946, 1, 1.00039, 1.00082, 0.99991, 0.99991, 0.99985, 1.00022, 1.00023, 1.00061, 1.00006, 0.99966, 0.99973, 0.99973, 0.99973, 1.00019, 1.0008, 1, 0.99924, 0.99924, 0.99924, 0.99983, 1.00044, 0.99973, 0.99964, 0.98332, 1, 0.99973, 1, 1, 0.99962, 0.99895, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 1.00423, 0.99925, 0.99999, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1.00049, 1, 1.00245, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 1.00003, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 0.99998, 0.99998, 0.99998, 0.99998, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.HelveticaItalicFactors = e;
          const t = {
            lineHeight: 1.35,
            lineGap: 0.2
          };
          F.HelveticaItalicMetrics = t;
          const B = [0.76116, 1, 1, 1.0006, 1.0006, 1.00006, 0.99973, 0.99973, 0.99982, 1.00001, 1.00043, 0.99998, 0.99998, 0.99959, 1.00003, 1.0006, 0.99998, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1, 1.00003, 1.00003, 1.00003, 0.99973, 0.99987, 1.00001, 1.00001, 0.99977, 0.99977, 1.00001, 1.00026, 1.00022, 0.99977, 1.0006, 1, 1.00001, 0.99973, 0.99999, 0.99977, 1.00022, 1.00001, 1.00022, 0.99977, 1.00001, 1.00026, 0.99977, 1.00001, 1.00016, 1.00001, 1.00001, 1.00026, 1.0006, 1.0006, 1.0006, 0.99949, 0.99973, 0.99998, 0.99973, 0.99973, 1, 0.99973, 0.99973, 1.0006, 0.99973, 0.99973, 0.99924, 0.99924, 1, 0.99924, 0.99999, 0.99973, 0.99973, 0.99973, 0.99973, 0.99998, 1, 1.0006, 0.99973, 1, 0.99977, 1, 1, 1, 1.00005, 1.0009, 1.00005, 1.00003, 0.99998, 0.99973, 0.99973, 0.99973, 0.99973, 1.0009, 0.99973, 0.99998, 1.00025, 0.99968, 0.99973, 1.00003, 1.00025, 0.60299, 1.00024, 1.06409, 1, 1, 0.99998, 1, 0.9998, 1.0006, 0.99998, 1, 0.99936, 0.99973, 1.00002, 1.00002, 1.00002, 1.00026, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1.00001, 1, 0.99977, 1.00001, 1.00001, 1.00001, 1.00001, 1.0006, 1.0006, 1.0006, 1.0006, 0.99977, 0.99977, 1.00022, 1.00022, 1.00022, 1.00022, 1.00022, 1.00003, 1.00022, 0.99977, 0.99977, 0.99977, 0.99977, 1.00001, 1.00001, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99982, 1, 0.99973, 0.99973, 0.99973, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 0.99973, 1.06409, 1.00026, 0.99973, 0.99973, 0.99973, 0.99973, 1, 0.99973, 1, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1, 0.99977, 1.04596, 0.99977, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00001, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 1.0006, 0.99924, 1.0006, 1.0006, 1.00019, 1.00034, 1, 0.99924, 1.00001, 1, 1, 0.99973, 0.99924, 0.99973, 0.99924, 0.99973, 1.02572, 0.99973, 1.00005, 0.99973, 0.99924, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99999, 0.9998, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1.00022, 0.99973, 1, 1.00016, 0.99977, 0.99998, 0.99977, 0.99998, 0.99977, 0.99998, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00001, 1, 1.00026, 1.0006, 1.00026, 0.84533, 1.00026, 1.0006, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 0.99977, 0.99973, 1.00016, 0.99977, 1.00001, 1, 1.00001, 1.00026, 1, 1.00026, 1, 1.00026, 1, 0.99924, 0.99973, 1.00001, 0.99973, 1, 0.99982, 1.00022, 1.00026, 1.00001, 1, 1.00026, 1.0006, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99998, 0.99928, 1, 0.99977, 1.00013, 1.00055, 0.99947, 0.99945, 0.99941, 0.99924, 1.00001, 1.00001, 1.0004, 0.91621, 1.00001, 1.00026, 0.99977, 1.00022, 1.0006, 1.00001, 1.00005, 0.99999, 0.99977, 1.00015, 1.00022, 0.99977, 1.00001, 0.99973, 1.00026, 1.00001, 1.00019, 1.00001, 0.99946, 1, 1.0006, 1.00001, 0.99978, 1.00045, 0.99973, 0.99924, 1.00023, 0.99978, 0.99966, 1, 1.00065, 1.00045, 1.00019, 0.99973, 0.99973, 0.99924, 1, 1, 0.96499, 1, 1.00055, 0.99973, 1.00008, 1.00027, 1, 0.9997, 0.99995, 1.00023, 0.99933, 1.00019, 1.00015, 1.00031, 0.99924, 1.00023, 0.99973, 1.00023, 1.00031, 1.00001, 0.99928, 1.00029, 1.00092, 1.00035, 1.00001, 1.0006, 1.0006, 1, 0.99988, 0.99975, 1, 1.00082, 0.99561, 0.9996, 1.00035, 1.00001, 0.99962, 1.00001, 1.00092, 0.99964, 1.00001, 0.99963, 0.99999, 1.00035, 1.00035, 1.00082, 0.99962, 0.99999, 0.99977, 1.00022, 1.00035, 1.00001, 0.99977, 1.00026, 0.9996, 0.99967, 1.00001, 1.00034, 1.00074, 1.00054, 1.00053, 1.00063, 0.99971, 0.99962, 1.00035, 0.99975, 0.99977, 0.99973, 1.00043, 0.99953, 1.0007, 0.99915, 0.99973, 1.00008, 0.99892, 1.00073, 1.00073, 1.00114, 0.99915, 1.00073, 0.99955, 0.99973, 1.00092, 0.99973, 1, 0.99998, 1, 1.0003, 1, 1.00043, 1.00001, 0.99969, 1.0003, 1, 1.00035, 1.00001, 0.9995, 1, 1.00092, 0.99973, 0.99973, 0.99973, 1.0007, 0.9995, 1, 0.99924, 1.0006, 0.99924, 0.99972, 1.00062, 0.99973, 1.00114, 1.00073, 1, 0.99955, 1, 1, 1.00047, 0.99968, 1.00016, 0.99977, 1.00016, 0.99977, 1.00016, 0.99977, 1.00001, 1, 1, 1, 0.99973, 1, 1, 0.99955, 0.99924, 0.99924, 0.99924, 0.99924, 0.99998, 0.99998, 0.99998, 0.99973, 0.99973, 0.99972, 1, 1, 1.00267, 0.99999, 0.99998, 0.99998, 1, 0.99998, 1.66475, 1, 0.99973, 0.99973, 1.00023, 0.99973, 0.99971, 0.99925, 1.00023, 1, 0.99991, 0.99984, 1.00002, 1.00002, 1.00002, 1.00002, 1, 1, 1, 1, 1, 1, 1, 0.96329, 1, 1.20985, 1.39713, 1.00003, 0.8254, 1.00015, 1, 1.00035, 1.00027, 1.00031, 1.00031, 0.99915, 1.00031, 1.00031, 0.99999, 1.00003, 0.99999, 0.99999, 1.41144, 1.6, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.41144, 1.40579, 1.40579, 1.36625, 0.99999, 1, 0.99861, 0.99861, 1, 1.00026, 1.00026, 1.00026, 1.00026, 0.95317, 0.99999, 0.99999, 0.99999, 0.99999, 1.40483, 1, 0.99977, 1.00054, 1, 1, 0.99953, 0.99962, 1.00042, 0.9995, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.HelveticaRegularFactors = B;
          const j = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          F.HelveticaRegularMetrics = j;
        },
        /* 54 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.LiberationSansRegularWidths = F.LiberationSansRegularMapping = F.LiberationSansItalicWidths = F.LiberationSansItalicMapping = F.LiberationSansBoldWidths = F.LiberationSansBoldMapping = F.LiberationSansBoldItalicWidths = F.LiberationSansBoldItalicMapping = void 0;
          const ae = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 719, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 785, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 385, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 465, 722, 333, 853, 906, 474, 825, 927, 838, 278, 722, 722, 601, 719, 667, 611, 722, 778, 278, 722, 667, 833, 722, 644, 778, 722, 667, 600, 611, 667, 821, 667, 809, 802, 278, 667, 615, 451, 611, 278, 582, 615, 610, 556, 606, 475, 460, 611, 541, 278, 558, 556, 612, 556, 445, 611, 766, 619, 520, 684, 446, 582, 715, 576, 753, 845, 278, 582, 611, 582, 845, 667, 669, 885, 567, 711, 667, 278, 276, 556, 1094, 1062, 875, 610, 722, 622, 719, 722, 719, 722, 567, 712, 667, 904, 626, 719, 719, 610, 702, 833, 722, 778, 719, 667, 722, 611, 622, 854, 667, 730, 703, 1005, 1019, 870, 979, 719, 711, 1031, 719, 556, 618, 615, 417, 635, 556, 709, 497, 615, 615, 500, 635, 740, 604, 611, 604, 611, 556, 490, 556, 875, 556, 615, 581, 833, 844, 729, 854, 615, 552, 854, 583, 556, 556, 611, 417, 552, 556, 278, 281, 278, 969, 906, 611, 500, 615, 556, 604, 778, 611, 487, 447, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1094, 556, 885, 489, 1115, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
          F.LiberationSansBoldWidths = ae;
          const n = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          F.LiberationSansBoldMapping = n;
          const u = [365, 0, 333, 278, 333, 474, 556, 556, 889, 722, 238, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 333, 333, 584, 584, 584, 611, 975, 722, 722, 722, 722, 667, 611, 778, 722, 278, 556, 722, 611, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 333, 278, 333, 584, 556, 333, 556, 611, 556, 611, 556, 333, 611, 611, 278, 278, 556, 278, 889, 611, 611, 611, 611, 389, 556, 333, 611, 556, 778, 556, 556, 500, 389, 280, 389, 584, 333, 556, 556, 556, 556, 280, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 556, 278, 333, 333, 365, 556, 834, 834, 834, 611, 722, 722, 722, 722, 722, 722, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 556, 556, 556, 556, 556, 278, 278, 278, 278, 611, 611, 611, 611, 611, 611, 611, 549, 611, 611, 611, 611, 611, 556, 611, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 740, 722, 611, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 611, 778, 611, 778, 611, 778, 611, 722, 611, 722, 611, 278, 278, 278, 278, 278, 278, 278, 278, 278, 278, 782, 556, 556, 278, 722, 556, 556, 611, 278, 611, 278, 611, 396, 611, 479, 611, 278, 722, 611, 722, 611, 722, 611, 708, 723, 611, 778, 611, 778, 611, 778, 611, 1e3, 944, 722, 389, 722, 389, 722, 389, 667, 556, 667, 556, 667, 556, 667, 556, 611, 333, 611, 479, 611, 333, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 722, 611, 944, 778, 667, 556, 667, 611, 500, 611, 500, 611, 500, 278, 556, 722, 556, 1e3, 889, 778, 611, 667, 556, 611, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 722, 333, 854, 906, 473, 844, 930, 847, 278, 722, 722, 610, 671, 667, 611, 722, 778, 278, 722, 667, 833, 722, 657, 778, 718, 667, 590, 611, 667, 822, 667, 829, 781, 278, 667, 620, 479, 611, 278, 591, 620, 621, 556, 610, 479, 492, 611, 558, 278, 566, 556, 603, 556, 450, 611, 712, 605, 532, 664, 409, 591, 704, 578, 773, 834, 278, 591, 611, 591, 834, 667, 667, 886, 614, 719, 667, 278, 278, 556, 1094, 1042, 854, 622, 719, 677, 719, 722, 708, 722, 614, 722, 667, 927, 643, 719, 719, 615, 687, 833, 722, 778, 719, 667, 722, 611, 677, 781, 667, 729, 708, 979, 989, 854, 1e3, 708, 719, 1042, 729, 556, 619, 604, 534, 618, 556, 736, 510, 611, 611, 507, 622, 740, 604, 611, 611, 611, 556, 889, 556, 885, 556, 646, 583, 889, 935, 707, 854, 594, 552, 865, 589, 556, 556, 611, 469, 563, 556, 278, 278, 278, 969, 906, 611, 507, 619, 556, 611, 778, 611, 575, 467, 944, 778, 944, 778, 944, 778, 667, 556, 333, 333, 556, 1e3, 1e3, 552, 278, 278, 278, 278, 500, 500, 500, 556, 556, 350, 1e3, 1e3, 240, 479, 333, 333, 604, 333, 167, 396, 556, 556, 1104, 556, 885, 516, 1146, 1e3, 768, 600, 834, 834, 834, 834, 999, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 722, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 611, 611, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 333, 333, 333, 333, 333, 333, 333, 333];
          F.LiberationSansBoldItalicWidths = u;
          const q = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          F.LiberationSansBoldItalicMapping = q;
          const e = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 625, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 733, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 281, 556, 400, 556, 222, 722, 556, 722, 556, 722, 556, 615, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 354, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 789, 846, 389, 794, 865, 775, 222, 667, 667, 570, 671, 667, 611, 722, 778, 278, 667, 667, 833, 722, 648, 778, 725, 667, 600, 611, 667, 837, 667, 831, 761, 278, 667, 570, 439, 555, 222, 550, 570, 571, 500, 556, 439, 463, 555, 542, 222, 500, 492, 548, 500, 447, 556, 670, 573, 486, 603, 374, 550, 652, 546, 728, 779, 222, 550, 556, 550, 779, 667, 667, 843, 544, 708, 667, 278, 278, 500, 1066, 982, 844, 589, 715, 639, 724, 667, 651, 667, 544, 704, 667, 917, 614, 715, 715, 589, 686, 833, 722, 778, 725, 667, 722, 611, 639, 795, 667, 727, 673, 920, 923, 805, 886, 651, 694, 1022, 682, 556, 562, 522, 493, 553, 556, 688, 465, 556, 556, 472, 564, 686, 550, 556, 556, 556, 500, 833, 500, 835, 500, 572, 518, 830, 851, 621, 736, 526, 492, 752, 534, 556, 556, 556, 378, 496, 500, 222, 222, 222, 910, 828, 556, 472, 565, 500, 556, 778, 556, 492, 339, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1083, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 998, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 584, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
          F.LiberationSansItalicWidths = e;
          const t = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          F.LiberationSansItalicMapping = t;
          const B = [365, 0, 333, 278, 278, 355, 556, 556, 889, 667, 191, 333, 333, 389, 584, 278, 333, 278, 278, 556, 556, 556, 556, 556, 556, 556, 556, 556, 556, 278, 278, 584, 584, 584, 556, 1015, 667, 667, 722, 722, 667, 611, 778, 722, 278, 500, 667, 556, 833, 722, 778, 667, 778, 722, 667, 611, 722, 667, 944, 667, 667, 611, 278, 278, 278, 469, 556, 333, 556, 556, 500, 556, 556, 278, 556, 556, 222, 222, 500, 222, 833, 556, 556, 556, 556, 333, 500, 278, 556, 500, 722, 500, 500, 500, 334, 260, 334, 584, 333, 556, 556, 556, 556, 260, 556, 333, 737, 370, 556, 584, 737, 552, 400, 549, 333, 333, 333, 576, 537, 278, 333, 333, 365, 556, 834, 834, 834, 611, 667, 667, 667, 667, 667, 667, 1e3, 722, 667, 667, 667, 667, 278, 278, 278, 278, 722, 722, 778, 778, 778, 778, 778, 584, 778, 722, 722, 722, 722, 667, 667, 611, 556, 556, 556, 556, 556, 556, 889, 500, 556, 556, 556, 556, 278, 278, 278, 278, 556, 556, 556, 556, 556, 556, 556, 549, 611, 556, 556, 556, 556, 500, 556, 500, 667, 556, 667, 556, 667, 556, 722, 500, 722, 500, 722, 500, 722, 500, 722, 615, 722, 556, 667, 556, 667, 556, 667, 556, 667, 556, 667, 556, 778, 556, 778, 556, 778, 556, 778, 556, 722, 556, 722, 556, 278, 278, 278, 278, 278, 278, 278, 222, 278, 278, 735, 444, 500, 222, 667, 500, 500, 556, 222, 556, 222, 556, 292, 556, 334, 556, 222, 722, 556, 722, 556, 722, 556, 604, 723, 556, 778, 556, 778, 556, 778, 556, 1e3, 944, 722, 333, 722, 333, 722, 333, 667, 500, 667, 500, 667, 500, 667, 500, 611, 278, 611, 375, 611, 278, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 722, 556, 944, 722, 667, 500, 667, 611, 500, 611, 500, 611, 500, 222, 556, 667, 556, 1e3, 889, 778, 611, 667, 500, 611, 278, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 333, 667, 278, 784, 838, 384, 774, 855, 752, 222, 667, 667, 551, 668, 667, 611, 722, 778, 278, 667, 668, 833, 722, 650, 778, 722, 667, 618, 611, 667, 798, 667, 835, 748, 278, 667, 578, 446, 556, 222, 547, 578, 575, 500, 557, 446, 441, 556, 556, 222, 500, 500, 576, 500, 448, 556, 690, 569, 482, 617, 395, 547, 648, 525, 713, 781, 222, 547, 556, 547, 781, 667, 667, 865, 542, 719, 667, 278, 278, 500, 1057, 1010, 854, 583, 722, 635, 719, 667, 656, 667, 542, 677, 667, 923, 604, 719, 719, 583, 656, 833, 722, 778, 719, 667, 722, 611, 635, 760, 667, 740, 667, 917, 938, 792, 885, 656, 719, 1010, 722, 556, 573, 531, 365, 583, 556, 669, 458, 559, 559, 438, 583, 688, 552, 556, 542, 556, 500, 458, 500, 823, 500, 573, 521, 802, 823, 625, 719, 521, 510, 750, 542, 556, 556, 556, 365, 510, 500, 222, 278, 222, 906, 812, 556, 438, 559, 500, 552, 778, 556, 489, 411, 944, 722, 944, 722, 944, 722, 667, 500, 333, 333, 556, 1e3, 1e3, 552, 222, 222, 222, 222, 333, 333, 333, 556, 556, 350, 1e3, 1e3, 188, 354, 333, 333, 500, 333, 167, 365, 556, 556, 1094, 556, 885, 323, 1073, 1e3, 768, 600, 834, 834, 834, 834, 1e3, 500, 1e3, 500, 1e3, 500, 500, 494, 612, 823, 713, 584, 549, 713, 979, 719, 274, 549, 549, 583, 549, 549, 604, 584, 604, 604, 708, 625, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 708, 729, 604, 604, 354, 354, 1e3, 990, 990, 990, 990, 494, 604, 604, 604, 604, 354, 1021, 1052, 917, 750, 750, 531, 656, 594, 510, 500, 750, 750, 500, 500, 333, 333, 333, 333, 333, 333, 333, 333, 222, 222, 294, 294, 324, 324, 316, 328, 398, 285];
          F.LiberationSansRegularWidths = B;
          const j = [-1, -1, -1, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 402, 506, 507, 508, 509, 510, 511, 536, 537, 538, 539, 710, 711, 713, 728, 729, 730, 731, 732, 733, 900, 901, 902, 903, 904, 905, 906, 908, 910, 911, 912, 913, 914, 915, 916, 917, 918, 919, 920, 921, 922, 923, 924, 925, 926, 927, 928, 929, 931, 932, 933, 934, 935, 936, 937, 938, 939, 940, 941, 942, 943, 944, 945, 946, 947, 948, 949, 950, 951, 952, 953, 954, 955, 956, 957, 958, 959, 960, 961, 962, 963, 964, 965, 966, 967, 968, 969, 970, 971, 972, 973, 974, 1024, 1025, 1026, 1027, 1028, 1029, 1030, 1031, 1032, 1033, 1034, 1035, 1036, 1037, 1038, 1039, 1040, 1041, 1042, 1043, 1044, 1045, 1046, 1047, 1048, 1049, 1050, 1051, 1052, 1053, 1054, 1055, 1056, 1057, 1058, 1059, 1060, 1061, 1062, 1063, 1064, 1065, 1066, 1067, 1068, 1069, 1070, 1071, 1072, 1073, 1074, 1075, 1076, 1077, 1078, 1079, 1080, 1081, 1082, 1083, 1084, 1085, 1086, 1087, 1088, 1089, 1090, 1091, 1092, 1093, 1094, 1095, 1096, 1097, 1098, 1099, 1100, 1101, 1102, 1103, 1104, 1105, 1106, 1107, 1108, 1109, 1110, 1111, 1112, 1113, 1114, 1115, 1116, 1117, 1118, 1119, 1138, 1139, 1168, 1169, 7808, 7809, 7810, 7811, 7812, 7813, 7922, 7923, 8208, 8209, 8211, 8212, 8213, 8215, 8216, 8217, 8218, 8219, 8220, 8221, 8222, 8224, 8225, 8226, 8230, 8240, 8242, 8243, 8249, 8250, 8252, 8254, 8260, 8319, 8355, 8356, 8359, 8364, 8453, 8467, 8470, 8482, 8486, 8494, 8539, 8540, 8541, 8542, 8592, 8593, 8594, 8595, 8596, 8597, 8616, 8706, 8710, 8719, 8721, 8722, 8730, 8734, 8735, 8745, 8747, 8776, 8800, 8801, 8804, 8805, 8962, 8976, 8992, 8993, 9472, 9474, 9484, 9488, 9492, 9496, 9500, 9508, 9516, 9524, 9532, 9552, 9553, 9554, 9555, 9556, 9557, 9558, 9559, 9560, 9561, 9562, 9563, 9564, 9565, 9566, 9567, 9568, 9569, 9570, 9571, 9572, 9573, 9574, 9575, 9576, 9577, 9578, 9579, 9580, 9600, 9604, 9608, 9612, 9616, 9617, 9618, 9619, 9632, 9633, 9642, 9643, 9644, 9650, 9658, 9660, 9668, 9674, 9675, 9679, 9688, 9689, 9702, 9786, 9787, 9788, 9792, 9794, 9824, 9827, 9829, 9830, 9834, 9835, 9836, 61441, 61442, 61445, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1, -1];
          F.LiberationSansRegularMapping = j;
        },
        /* 55 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.MyriadProRegularMetrics = F.MyriadProRegularFactors = F.MyriadProItalicMetrics = F.MyriadProItalicFactors = F.MyriadProBoldMetrics = F.MyriadProBoldItalicMetrics = F.MyriadProBoldItalicFactors = F.MyriadProBoldFactors = void 0;
          const ae = [1.36898, 1, 1, 0.72706, 0.80479, 0.83734, 0.98894, 0.99793, 0.9897, 0.93884, 0.86209, 0.94292, 0.94292, 1.16661, 1.02058, 0.93582, 0.96694, 0.93582, 1.19137, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.99793, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.72851, 0.78966, 0.90838, 0.83637, 0.82391, 0.96376, 0.80061, 0.86275, 0.8768, 0.95407, 1.0258, 0.73901, 0.85022, 0.83655, 1.0156, 0.95546, 0.92179, 0.87107, 0.92179, 0.82114, 0.8096, 0.89713, 0.94438, 0.95353, 0.94083, 0.91905, 0.90406, 0.9446, 0.94292, 1.18777, 0.94292, 1.02058, 0.89903, 0.90088, 0.94938, 0.97898, 0.81093, 0.97571, 0.94938, 1.024, 0.9577, 0.95933, 0.98621, 1.0474, 0.97455, 0.98981, 0.9672, 0.95933, 0.9446, 0.97898, 0.97407, 0.97646, 0.78036, 1.10208, 0.95442, 0.95298, 0.97579, 0.9332, 0.94039, 0.938, 0.80687, 1.01149, 0.80687, 1.02058, 0.80479, 0.99793, 0.99793, 0.99793, 0.99793, 1.01149, 1.00872, 0.90088, 0.91882, 1.0213, 0.8361, 1.02058, 0.62295, 0.54324, 0.89022, 1.08595, 1, 1, 0.90088, 1, 0.97455, 0.93582, 0.90088, 1, 1.05686, 0.8361, 0.99642, 0.99642, 0.99642, 0.72851, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.90838, 0.868, 0.82391, 0.80061, 0.80061, 0.80061, 0.80061, 1.0258, 1.0258, 1.0258, 1.0258, 0.97484, 0.95546, 0.92179, 0.92179, 0.92179, 0.92179, 0.92179, 1.02058, 0.92179, 0.94438, 0.94438, 0.94438, 0.94438, 0.90406, 0.86958, 0.98225, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.94938, 0.9031, 0.81093, 0.94938, 0.94938, 0.94938, 0.94938, 0.98621, 0.98621, 0.98621, 0.98621, 0.93969, 0.95933, 0.9446, 0.9446, 0.9446, 0.9446, 0.9446, 1.08595, 0.9446, 0.95442, 0.95442, 0.95442, 0.95442, 0.94039, 0.97898, 0.94039, 0.90838, 0.94938, 0.90838, 0.94938, 0.90838, 0.94938, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.82391, 0.81093, 0.96376, 0.84313, 0.97484, 0.97571, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.80061, 0.94938, 0.8768, 0.9577, 0.8768, 0.9577, 0.8768, 0.9577, 1, 1, 0.95407, 0.95933, 0.97069, 0.95933, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 1.0258, 0.98621, 0.887, 1.01591, 0.73901, 1.0474, 1, 1, 0.97455, 0.83655, 0.98981, 1, 1, 0.83655, 0.73977, 0.83655, 0.73903, 0.84638, 1.033, 0.95546, 0.95933, 1, 1, 0.95546, 0.95933, 0.8271, 0.95417, 0.95933, 0.92179, 0.9446, 0.92179, 0.9446, 0.92179, 0.9446, 0.936, 0.91964, 0.82114, 0.97646, 1, 1, 0.82114, 0.97646, 0.8096, 0.78036, 0.8096, 0.78036, 1, 1, 0.8096, 0.78036, 1, 1, 0.89713, 0.77452, 0.89713, 1.10208, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94438, 0.95442, 0.94083, 0.97579, 0.90406, 0.94039, 0.90406, 0.9446, 0.938, 0.9446, 0.938, 0.9446, 0.938, 1, 0.99793, 0.90838, 0.94938, 0.868, 0.9031, 0.92179, 0.9446, 1, 1, 0.89713, 1.10208, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90989, 0.9358, 0.91945, 0.83181, 0.75261, 0.87992, 0.82976, 0.96034, 0.83689, 0.97268, 1.0078, 0.90838, 0.83637, 0.8019, 0.90157, 0.80061, 0.9446, 0.95407, 0.92436, 1.0258, 0.85022, 0.97153, 1.0156, 0.95546, 0.89192, 0.92179, 0.92361, 0.87107, 0.96318, 0.89713, 0.93704, 0.95638, 0.91905, 0.91709, 0.92796, 1.0258, 0.93704, 0.94836, 1.0373, 0.95933, 1.0078, 0.95871, 0.94836, 0.96174, 0.92601, 0.9498, 0.98607, 0.95776, 0.95933, 1.05453, 1.0078, 0.98275, 0.9314, 0.95617, 0.91701, 1.05993, 0.9446, 0.78367, 0.9553, 1, 0.86832, 1.0128, 0.95871, 0.99394, 0.87548, 0.96361, 0.86774, 1.0078, 0.95871, 0.9446, 0.95871, 0.86774, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.94083, 0.97579, 0.94083, 0.97579, 0.94083, 0.97579, 0.90406, 0.94039, 0.96694, 1, 0.89903, 1, 1, 1, 0.93582, 0.93582, 0.93582, 1, 0.908, 0.908, 0.918, 0.94219, 0.94219, 0.96544, 1, 1.285, 1, 1, 0.81079, 0.81079, 1, 1, 0.74854, 1, 1, 1, 1, 0.99793, 1, 1, 1, 0.65, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.17173, 1, 0.80535, 0.76169, 1.02058, 1.0732, 1.05486, 1, 1, 1.30692, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.16161, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.MyriadProBoldFactors = ae;
          const n = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          F.MyriadProBoldMetrics = n;
          const u = [1.36898, 1, 1, 0.66227, 0.80779, 0.81625, 0.97276, 0.97276, 0.97733, 0.92222, 0.83266, 0.94292, 0.94292, 1.16148, 1.02058, 0.93582, 0.96694, 0.93582, 1.17337, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.97276, 0.78076, 0.78076, 1.02058, 1.02058, 1.02058, 0.71541, 0.76813, 0.85576, 0.80591, 0.80729, 0.94299, 0.77512, 0.83655, 0.86523, 0.92222, 0.98621, 0.71743, 0.81698, 0.79726, 0.98558, 0.92222, 0.90637, 0.83809, 0.90637, 0.80729, 0.76463, 0.86275, 0.90699, 0.91605, 0.9154, 0.85308, 0.85458, 0.90531, 0.94292, 1.21296, 0.94292, 1.02058, 0.89903, 1.18616, 0.99613, 0.91677, 0.78216, 0.91677, 0.90083, 0.98796, 0.9135, 0.92168, 0.95381, 0.98981, 0.95298, 0.95381, 0.93459, 0.92168, 0.91513, 0.92004, 0.91677, 0.95077, 0.748, 1.04502, 0.91677, 0.92061, 0.94236, 0.89544, 0.89364, 0.9, 0.80687, 0.8578, 0.80687, 1.02058, 0.80779, 0.97276, 0.97276, 0.97276, 0.97276, 0.8578, 0.99973, 1.18616, 0.91339, 1.08074, 0.82891, 1.02058, 0.55509, 0.71526, 0.89022, 1.08595, 1, 1, 1.18616, 1, 0.96736, 0.93582, 1.18616, 1, 1.04864, 0.82711, 0.99043, 0.99043, 0.99043, 0.71541, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.85576, 0.845, 0.80729, 0.77512, 0.77512, 0.77512, 0.77512, 0.98621, 0.98621, 0.98621, 0.98621, 0.95961, 0.92222, 0.90637, 0.90637, 0.90637, 0.90637, 0.90637, 1.02058, 0.90251, 0.90699, 0.90699, 0.90699, 0.90699, 0.85458, 0.83659, 0.94951, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.99613, 0.85811, 0.78216, 0.90083, 0.90083, 0.90083, 0.90083, 0.95381, 0.95381, 0.95381, 0.95381, 0.9135, 0.92168, 0.91513, 0.91513, 0.91513, 0.91513, 0.91513, 1.08595, 0.91677, 0.91677, 0.91677, 0.91677, 0.91677, 0.89364, 0.92332, 0.89364, 0.85576, 0.99613, 0.85576, 0.99613, 0.85576, 0.99613, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.80729, 0.78216, 0.94299, 0.76783, 0.95961, 0.91677, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.77512, 0.90083, 0.86523, 0.9135, 0.86523, 0.9135, 0.86523, 0.9135, 1, 1, 0.92222, 0.92168, 0.92222, 0.92168, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.98621, 0.95381, 0.86036, 0.97096, 0.71743, 0.98981, 1, 1, 0.95298, 0.79726, 0.95381, 1, 1, 0.79726, 0.6894, 0.79726, 0.74321, 0.81691, 1.0006, 0.92222, 0.92168, 1, 1, 0.92222, 0.92168, 0.79464, 0.92098, 0.92168, 0.90637, 0.91513, 0.90637, 0.91513, 0.90637, 0.91513, 0.909, 0.87514, 0.80729, 0.95077, 1, 1, 0.80729, 0.95077, 0.76463, 0.748, 0.76463, 0.748, 1, 1, 0.76463, 0.748, 1, 1, 0.86275, 0.72651, 0.86275, 1.04502, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.90699, 0.91677, 0.9154, 0.94236, 0.85458, 0.89364, 0.85458, 0.90531, 0.9, 0.90531, 0.9, 0.90531, 0.9, 1, 0.97276, 0.85576, 0.99613, 0.845, 0.85811, 0.90251, 0.91677, 1, 1, 0.86275, 1.04502, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.18616, 1.00899, 1.30628, 0.85576, 0.80178, 0.66862, 0.7927, 0.69323, 0.88127, 0.72459, 0.89711, 0.95381, 0.85576, 0.80591, 0.7805, 0.94729, 0.77512, 0.90531, 0.92222, 0.90637, 0.98621, 0.81698, 0.92655, 0.98558, 0.92222, 0.85359, 0.90637, 0.90976, 0.83809, 0.94523, 0.86275, 0.83509, 0.93157, 0.85308, 0.83392, 0.92346, 0.98621, 0.83509, 0.92886, 0.91324, 0.92168, 0.95381, 0.90646, 0.92886, 0.90557, 0.86847, 0.90276, 0.91324, 0.86842, 0.92168, 0.99531, 0.95381, 0.9224, 0.85408, 0.92699, 0.86847, 1.0051, 0.91513, 0.80487, 0.93481, 1, 0.88159, 1.05214, 0.90646, 0.97355, 0.81539, 0.89398, 0.85923, 0.95381, 0.90646, 0.91513, 0.90646, 0.85923, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9154, 0.94236, 0.9154, 0.94236, 0.9154, 0.94236, 0.85458, 0.89364, 0.96694, 1, 0.89903, 1, 1, 1, 0.91782, 0.91782, 0.91782, 1, 0.896, 0.896, 0.896, 0.9332, 0.9332, 0.95973, 1, 1.26, 1, 1, 0.80479, 0.80178, 1, 1, 0.85633, 1, 1, 1, 1, 0.97276, 1, 1, 1, 0.698, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.14542, 1, 0.79199, 0.78694, 1.02058, 1.03493, 1.05486, 1, 1, 1.23026, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.20006, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.MyriadProBoldItalicFactors = u;
          const q = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          F.MyriadProBoldItalicMetrics = q;
          const e = [1.36898, 1, 1, 0.65507, 0.84943, 0.85639, 0.88465, 0.88465, 0.86936, 0.88307, 0.86948, 0.85283, 0.85283, 1.06383, 1.02058, 0.75945, 0.9219, 0.75945, 1.17337, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.88465, 0.75945, 0.75945, 1.02058, 1.02058, 1.02058, 0.69046, 0.70926, 0.85158, 0.77812, 0.76852, 0.89591, 0.70466, 0.76125, 0.80094, 0.86822, 0.83864, 0.728, 0.77212, 0.79475, 0.93637, 0.87514, 0.8588, 0.76013, 0.8588, 0.72421, 0.69866, 0.77598, 0.85991, 0.80811, 0.87832, 0.78112, 0.77512, 0.8562, 1.0222, 1.18417, 1.0222, 1.27014, 0.89903, 1.15012, 0.93859, 0.94399, 0.846, 0.94399, 0.81453, 1.0186, 0.94219, 0.96017, 1.03075, 1.02175, 0.912, 1.03075, 0.96998, 0.96017, 0.93859, 0.94399, 0.94399, 0.95493, 0.746, 1.12658, 0.94578, 0.91, 0.979, 0.882, 0.882, 0.83, 0.85034, 0.83537, 0.85034, 1.02058, 0.70869, 0.88465, 0.88465, 0.88465, 0.88465, 0.83537, 0.90083, 1.15012, 0.9161, 0.94565, 0.73541, 1.02058, 0.53609, 0.69353, 0.79519, 1.08595, 1, 1, 1.15012, 1, 0.91974, 0.75945, 1.15012, 1, 0.9446, 0.73361, 0.9005, 0.9005, 0.9005, 0.62864, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.85158, 0.773, 0.76852, 0.70466, 0.70466, 0.70466, 0.70466, 0.83864, 0.83864, 0.83864, 0.83864, 0.90561, 0.87514, 0.8588, 0.8588, 0.8588, 0.8588, 0.8588, 1.02058, 0.85751, 0.85991, 0.85991, 0.85991, 0.85991, 0.77512, 0.76013, 0.88075, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 0.8075, 0.846, 0.81453, 0.81453, 0.81453, 0.81453, 0.82424, 0.82424, 0.82424, 0.82424, 0.9278, 0.96017, 0.93859, 0.93859, 0.93859, 0.93859, 0.93859, 1.08595, 0.8562, 0.94578, 0.94578, 0.94578, 0.94578, 0.882, 0.94578, 0.882, 0.85158, 0.93859, 0.85158, 0.93859, 0.85158, 0.93859, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.76852, 0.846, 0.89591, 0.8544, 0.90561, 0.94399, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.70466, 0.81453, 0.80094, 0.94219, 0.80094, 0.94219, 0.80094, 0.94219, 1, 1, 0.86822, 0.96017, 0.86822, 0.96017, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 0.82424, 0.83864, 1.03075, 0.83864, 0.82424, 0.81402, 1.02738, 0.728, 1.02175, 1, 1, 0.912, 0.79475, 1.03075, 1, 1, 0.79475, 0.83911, 0.79475, 0.66266, 0.80553, 1.06676, 0.87514, 0.96017, 1, 1, 0.87514, 0.96017, 0.86865, 0.87396, 0.96017, 0.8588, 0.93859, 0.8588, 0.93859, 0.8588, 0.93859, 0.867, 0.84759, 0.72421, 0.95493, 1, 1, 0.72421, 0.95493, 0.69866, 0.746, 0.69866, 0.746, 1, 1, 0.69866, 0.746, 1, 1, 0.77598, 0.88417, 0.77598, 1.12658, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.85991, 0.94578, 0.87832, 0.979, 0.77512, 0.882, 0.77512, 0.8562, 0.83, 0.8562, 0.83, 0.8562, 0.83, 1, 0.88465, 0.85158, 0.93859, 0.773, 0.8075, 0.85751, 0.8562, 1, 1, 0.77598, 1.12658, 1.15012, 1.15012, 1.15012, 1.15012, 1.15012, 1.15313, 1.15012, 1.15012, 1.15012, 1.08106, 1.03901, 0.85158, 0.77025, 0.62264, 0.7646, 0.65351, 0.86026, 0.69461, 0.89947, 1.03075, 0.85158, 0.77812, 0.76449, 0.88836, 0.70466, 0.8562, 0.86822, 0.8588, 0.83864, 0.77212, 0.85308, 0.93637, 0.87514, 0.82352, 0.8588, 0.85701, 0.76013, 0.89058, 0.77598, 0.8156, 0.82565, 0.78112, 0.77899, 0.89386, 0.83864, 0.8156, 0.9486, 0.92388, 0.96186, 1.03075, 0.91123, 0.9486, 0.93298, 0.878, 0.93942, 0.92388, 0.84596, 0.96186, 0.95119, 1.03075, 0.922, 0.88787, 0.95829, 0.88, 0.93559, 0.93859, 0.78815, 0.93758, 1, 0.89217, 1.03737, 0.91123, 0.93969, 0.77487, 0.85769, 0.86799, 1.03075, 0.91123, 0.93859, 0.91123, 0.86799, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87832, 0.979, 0.87832, 0.979, 0.87832, 0.979, 0.77512, 0.882, 0.9219, 1, 0.89903, 1, 1, 1, 0.87321, 0.87321, 0.87321, 1, 1.027, 1.027, 1.027, 0.86847, 0.86847, 0.79121, 1, 1.124, 1, 1, 0.73572, 0.73572, 1, 1, 0.85034, 1, 1, 1, 1, 0.88465, 1, 1, 1, 0.669, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04828, 1, 0.74948, 0.75187, 1.02058, 0.98391, 1.02119, 1, 1, 1.06233, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05233, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.MyriadProItalicFactors = e;
          const t = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          F.MyriadProItalicMetrics = t;
          const B = [1.36898, 1, 1, 0.76305, 0.82784, 0.94935, 0.89364, 0.92241, 0.89073, 0.90706, 0.98472, 0.85283, 0.85283, 1.0664, 1.02058, 0.74505, 0.9219, 0.74505, 1.23456, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.92241, 0.74505, 0.74505, 1.02058, 1.02058, 1.02058, 0.73002, 0.72601, 0.91755, 0.8126, 0.80314, 0.92222, 0.73764, 0.79726, 0.83051, 0.90284, 0.86023, 0.74, 0.8126, 0.84869, 0.96518, 0.91115, 0.8858, 0.79761, 0.8858, 0.74498, 0.73914, 0.81363, 0.89591, 0.83659, 0.89633, 0.85608, 0.8111, 0.90531, 1.0222, 1.22736, 1.0222, 1.27014, 0.89903, 0.90088, 0.86667, 1.0231, 0.896, 1.01411, 0.90083, 1.05099, 1.00512, 0.99793, 1.05326, 1.09377, 0.938, 1.06226, 1.00119, 0.99793, 0.98714, 1.0231, 1.01231, 0.98196, 0.792, 1.19137, 0.99074, 0.962, 1.01915, 0.926, 0.942, 0.856, 0.85034, 0.92006, 0.85034, 1.02058, 0.69067, 0.92241, 0.92241, 0.92241, 0.92241, 0.92006, 0.9332, 0.90088, 0.91882, 0.93484, 0.75339, 1.02058, 0.56866, 0.54324, 0.79519, 1.08595, 1, 1, 0.90088, 1, 0.95325, 0.74505, 0.90088, 1, 0.97198, 0.75339, 0.91009, 0.91009, 0.91009, 0.66466, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.91755, 0.788, 0.80314, 0.73764, 0.73764, 0.73764, 0.73764, 0.86023, 0.86023, 0.86023, 0.86023, 0.92915, 0.91115, 0.8858, 0.8858, 0.8858, 0.8858, 0.8858, 1.02058, 0.8858, 0.89591, 0.89591, 0.89591, 0.89591, 0.8111, 0.79611, 0.89713, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86667, 0.86936, 0.896, 0.90083, 0.90083, 0.90083, 0.90083, 0.84224, 0.84224, 0.84224, 0.84224, 0.97276, 0.99793, 0.98714, 0.98714, 0.98714, 0.98714, 0.98714, 1.08595, 0.89876, 0.99074, 0.99074, 0.99074, 0.99074, 0.942, 1.0231, 0.942, 0.91755, 0.86667, 0.91755, 0.86667, 0.91755, 0.86667, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.80314, 0.896, 0.92222, 0.93372, 0.92915, 1.01411, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.73764, 0.90083, 0.83051, 1.00512, 0.83051, 1.00512, 0.83051, 1.00512, 1, 1, 0.90284, 0.99793, 0.90976, 0.99793, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 0.84224, 0.86023, 1.05326, 0.86023, 0.84224, 0.82873, 1.07469, 0.74, 1.09377, 1, 1, 0.938, 0.84869, 1.06226, 1, 1, 0.84869, 0.83704, 0.84869, 0.81441, 0.85588, 1.08927, 0.91115, 0.99793, 1, 1, 0.91115, 0.99793, 0.91887, 0.90991, 0.99793, 0.8858, 0.98714, 0.8858, 0.98714, 0.8858, 0.98714, 0.894, 0.91434, 0.74498, 0.98196, 1, 1, 0.74498, 0.98196, 0.73914, 0.792, 0.73914, 0.792, 1, 1, 0.73914, 0.792, 1, 1, 0.81363, 0.904, 0.81363, 1.19137, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89591, 0.99074, 0.89633, 1.01915, 0.8111, 0.942, 0.8111, 0.90531, 0.856, 0.90531, 0.856, 0.90531, 0.856, 1, 0.92241, 0.91755, 0.86667, 0.788, 0.86936, 0.8858, 0.89876, 1, 1, 0.81363, 1.19137, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90088, 0.90388, 1.03901, 0.92138, 0.78105, 0.7154, 0.86169, 0.80513, 0.94007, 0.82528, 0.98612, 1.06226, 0.91755, 0.8126, 0.81884, 0.92819, 0.73764, 0.90531, 0.90284, 0.8858, 0.86023, 0.8126, 0.91172, 0.96518, 0.91115, 0.83089, 0.8858, 0.87791, 0.79761, 0.89297, 0.81363, 0.88157, 0.89992, 0.85608, 0.81992, 0.94307, 0.86023, 0.88157, 0.95308, 0.98699, 0.99793, 1.06226, 0.95817, 0.95308, 0.97358, 0.928, 0.98088, 0.98699, 0.92761, 0.99793, 0.96017, 1.06226, 0.986, 0.944, 0.95978, 0.938, 0.96705, 0.98714, 0.80442, 0.98972, 1, 0.89762, 1.04552, 0.95817, 0.99007, 0.87064, 0.91879, 0.88888, 1.06226, 0.95817, 0.98714, 0.95817, 0.88888, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.89633, 1.01915, 0.89633, 1.01915, 0.89633, 1.01915, 0.8111, 0.942, 0.9219, 1, 0.89903, 1, 1, 1, 0.93173, 0.93173, 0.93173, 1, 1.06304, 1.06304, 1.06904, 0.89903, 0.89903, 0.80549, 1, 1.156, 1, 1, 0.76575, 0.76575, 1, 1, 0.72458, 1, 1, 1, 1, 0.92241, 1, 1, 1, 0.619, 1, 1.36145, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.07257, 1, 0.74705, 0.71119, 1.02058, 1.024, 1.02119, 1, 1, 1.1536, 1.08595, 1.08595, 1, 1.08595, 1.08595, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.05638, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.MyriadProRegularFactors = B;
          const j = {
            lineHeight: 1.2,
            lineGap: 0.2
          };
          F.MyriadProRegularMetrics = j;
        },
        /* 56 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.SegoeuiRegularMetrics = F.SegoeuiRegularFactors = F.SegoeuiItalicMetrics = F.SegoeuiItalicFactors = F.SegoeuiBoldMetrics = F.SegoeuiBoldItalicMetrics = F.SegoeuiBoldItalicFactors = F.SegoeuiBoldFactors = void 0;
          const ae = [1.76738, 1, 1, 0.99297, 0.9824, 1.04016, 1.06497, 1.03424, 0.97529, 1.17647, 1.23203, 1.1085, 1.1085, 1.16939, 1.2107, 0.9754, 1.21408, 0.9754, 1.59578, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 1.03424, 0.81378, 0.81378, 1.2107, 1.2107, 1.2107, 0.71703, 0.97847, 0.97363, 0.88776, 0.8641, 1.02096, 0.79795, 0.85132, 0.914, 1.06085, 1.1406, 0.8007, 0.89858, 0.83693, 1.14889, 1.09398, 0.97489, 0.92094, 0.97489, 0.90399, 0.84041, 0.95923, 1.00135, 1, 1.06467, 0.98243, 0.90996, 0.99361, 1.1085, 1.56942, 1.1085, 1.2107, 0.74627, 0.94282, 0.96752, 1.01519, 0.86304, 1.01359, 0.97278, 1.15103, 1.01359, 0.98561, 1.02285, 1.02285, 1.00527, 1.02285, 1.0302, 0.99041, 1.0008, 1.01519, 1.01359, 1.02258, 0.79104, 1.16862, 0.99041, 0.97454, 1.02511, 0.99298, 0.96752, 0.95801, 0.94856, 1.16579, 0.94856, 1.2107, 0.9824, 1.03424, 1.03424, 1, 1.03424, 1.16579, 0.8727, 1.3871, 1.18622, 1.10818, 1.04478, 1.2107, 1.18622, 0.75155, 0.94994, 1.28826, 1.21408, 1.21408, 0.91056, 1, 0.91572, 0.9754, 0.64663, 1.18328, 1.24866, 1.04478, 1.14169, 1.15749, 1.17389, 0.71703, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.93506, 0.8641, 0.79795, 0.79795, 0.79795, 0.79795, 1.1406, 1.1406, 1.1406, 1.1406, 1.02096, 1.09398, 0.97426, 0.97426, 0.97426, 0.97426, 0.97426, 1.2107, 0.97489, 1.00135, 1.00135, 1.00135, 1.00135, 0.90996, 0.92094, 1.02798, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.96752, 0.93136, 0.86304, 0.97278, 0.97278, 0.97278, 0.97278, 1.02285, 1.02285, 1.02285, 1.02285, 0.97122, 0.99041, 1, 1, 1, 1, 1, 1.28826, 1.0008, 0.99041, 0.99041, 0.99041, 0.99041, 0.96752, 1.01519, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.97363, 0.96752, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 0.8641, 0.86304, 1.02096, 1.03057, 1.02096, 1.03517, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.79795, 0.97278, 0.914, 1.01359, 0.914, 1.01359, 0.914, 1.01359, 1, 1, 1.06085, 0.98561, 1.06085, 1.00879, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 1.1406, 1.02285, 0.97138, 1.08692, 0.8007, 1.02285, 1, 1, 1.00527, 0.83693, 1.02285, 1, 1, 0.83693, 0.9455, 0.83693, 0.90418, 0.83693, 1.13005, 1.09398, 0.99041, 1, 1, 1.09398, 0.99041, 0.96692, 1.09251, 0.99041, 0.97489, 1.0008, 0.97489, 1.0008, 0.97489, 1.0008, 0.93994, 0.97931, 0.90399, 1.02258, 1, 1, 0.90399, 1.02258, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 0.84041, 0.79104, 1, 1, 0.95923, 1.07034, 0.95923, 1.16862, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.00135, 0.99041, 1.06467, 1.02511, 0.90996, 0.96752, 0.90996, 0.99361, 0.95801, 0.99361, 0.95801, 0.99361, 0.95801, 1.07733, 1.03424, 0.97363, 0.96752, 0.93506, 0.93136, 0.97489, 1.0008, 1, 1, 0.95923, 1.16862, 1.15103, 1.15103, 1.01173, 1.03959, 0.75953, 0.81378, 0.79912, 1.15103, 1.21994, 0.95161, 0.87815, 1.01149, 0.81525, 0.7676, 0.98167, 1.01134, 1.02546, 0.84097, 1.03089, 1.18102, 0.97363, 0.88776, 0.85134, 0.97826, 0.79795, 0.99361, 1.06085, 0.97489, 1.1406, 0.89858, 1.0388, 1.14889, 1.09398, 0.86039, 0.97489, 1.0595, 0.92094, 0.94793, 0.95923, 0.90996, 0.99346, 0.98243, 1.02112, 0.95493, 1.1406, 0.90996, 1.03574, 1.02597, 1.0008, 1.18102, 1.06628, 1.03574, 1.0192, 1.01932, 1.00886, 0.97531, 1.0106, 1.0008, 1.13189, 1.18102, 1.02277, 0.98683, 1.0016, 0.99561, 1.07237, 1.0008, 0.90434, 0.99921, 0.93803, 0.8965, 1.23085, 1.06628, 1.04983, 0.96268, 1.0499, 0.98439, 1.18102, 1.06628, 1.0008, 1.06628, 0.98439, 0.79795, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09466, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.97278, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.02065, 1, 1, 1, 1, 1, 1, 1.06467, 1.02511, 1.06467, 1.02511, 1.06467, 1.02511, 0.90996, 0.96752, 1, 1.21408, 0.89903, 1, 1, 0.75155, 1.04394, 1.04394, 1.04394, 1.04394, 0.98633, 0.98633, 0.98633, 0.73047, 0.73047, 1.20642, 0.91211, 1.25635, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.12454, 0.93503, 1.03424, 1.19687, 1.03424, 1, 1, 1, 0.771, 1, 1, 1.15749, 1.15749, 1.15749, 1.10948, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.16897, 1, 0.96085, 0.90137, 1.2107, 1.18416, 1.13973, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21172, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18874, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.09193, 1.09193, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.SegoeuiBoldFactors = ae;
          const n = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          F.SegoeuiBoldMetrics = n;
          const u = [1.76738, 1, 1, 0.98946, 1.03959, 1.04016, 1.02809, 1.036, 0.97639, 1.10953, 1.23203, 1.11144, 1.11144, 1.16939, 1.21237, 0.9754, 1.21261, 0.9754, 1.59754, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 1.036, 0.81378, 0.81378, 1.21237, 1.21237, 1.21237, 0.73541, 0.97847, 0.97363, 0.89723, 0.87897, 1.0426, 0.79429, 0.85292, 0.91149, 1.05815, 1.1406, 0.79631, 0.90128, 0.83853, 1.04396, 1.10615, 0.97552, 0.94436, 0.97552, 0.88641, 0.80527, 0.96083, 1.00135, 1, 1.06777, 0.9817, 0.91142, 0.99361, 1.11144, 1.57293, 1.11144, 1.21237, 0.74627, 1.31818, 1.06585, 0.97042, 0.83055, 0.97042, 0.93503, 1.1261, 0.97042, 0.97922, 1.14236, 0.94552, 1.01054, 1.14236, 1.02471, 0.97922, 0.94165, 0.97042, 0.97042, 1.0276, 0.78929, 1.1261, 0.97922, 0.95874, 1.02197, 0.98507, 0.96752, 0.97168, 0.95107, 1.16579, 0.95107, 1.21237, 1.03959, 1.036, 1.036, 1, 1.036, 1.16579, 0.87357, 1.31818, 1.18754, 1.26781, 1.05356, 1.21237, 1.18622, 0.79487, 0.94994, 1.29004, 1.24047, 1.24047, 1.31818, 1, 0.91484, 0.9754, 1.31818, 1.1349, 1.24866, 1.05356, 1.13934, 1.15574, 1.17389, 0.73541, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.97363, 0.94385, 0.87897, 0.79429, 0.79429, 0.79429, 0.79429, 1.1406, 1.1406, 1.1406, 1.1406, 1.0426, 1.10615, 0.97552, 0.97552, 0.97552, 0.97552, 0.97552, 1.21237, 0.97552, 1.00135, 1.00135, 1.00135, 1.00135, 0.91142, 0.94436, 0.98721, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 1.06585, 0.96705, 0.83055, 0.93503, 0.93503, 0.93503, 0.93503, 1.14236, 1.14236, 1.14236, 1.14236, 0.93125, 0.97922, 0.94165, 0.94165, 0.94165, 0.94165, 0.94165, 1.29004, 0.94165, 0.97922, 0.97922, 0.97922, 0.97922, 0.96752, 0.97042, 0.96752, 0.97363, 1.06585, 0.97363, 1.06585, 0.97363, 1.06585, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 0.87897, 0.83055, 1.0426, 1.0033, 1.0426, 0.97042, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.79429, 0.93503, 0.91149, 0.97042, 0.91149, 0.97042, 0.91149, 0.97042, 1, 1, 1.05815, 0.97922, 1.05815, 0.97922, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 1.1406, 1.14236, 0.97441, 1.04302, 0.79631, 1.01582, 1, 1, 1.01054, 0.83853, 1.14236, 1, 1, 0.83853, 1.09125, 0.83853, 0.90418, 0.83853, 1.19508, 1.10615, 0.97922, 1, 1, 1.10615, 0.97922, 1.01034, 1.10466, 0.97922, 0.97552, 0.94165, 0.97552, 0.94165, 0.97552, 0.94165, 0.91602, 0.91981, 0.88641, 1.0276, 1, 1, 0.88641, 1.0276, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 0.80527, 0.78929, 1, 1, 0.96083, 1.05403, 0.95923, 1.16862, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.00135, 0.97922, 1.06777, 1.02197, 0.91142, 0.96752, 0.91142, 0.99361, 0.97168, 0.99361, 0.97168, 0.99361, 0.97168, 1.23199, 1.036, 0.97363, 1.06585, 0.94385, 0.96705, 0.97552, 0.94165, 1, 1, 0.96083, 1.1261, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 1.31818, 0.95161, 1.27126, 1.00811, 0.83284, 0.77702, 0.99137, 0.95253, 1.0347, 0.86142, 1.07205, 1.14236, 0.97363, 0.89723, 0.86869, 1.09818, 0.79429, 0.99361, 1.05815, 0.97552, 1.1406, 0.90128, 1.06662, 1.04396, 1.10615, 0.84918, 0.97552, 1.04694, 0.94436, 0.98015, 0.96083, 0.91142, 1.00356, 0.9817, 1.01945, 0.98999, 1.1406, 0.91142, 1.04961, 0.9898, 1.00639, 1.14236, 1.07514, 1.04961, 0.99607, 1.02897, 1.008, 0.9898, 0.95134, 1.00639, 1.11121, 1.14236, 1.00518, 0.97981, 1.02186, 1, 1.08578, 0.94165, 0.99314, 0.98387, 0.93028, 0.93377, 1.35125, 1.07514, 1.10687, 0.93491, 1.04232, 1.00351, 1.14236, 1.07514, 0.94165, 1.07514, 1.00351, 0.79429, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.09097, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.93503, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.96609, 1, 1, 1, 1, 1, 1, 1.06777, 1.02197, 1.06777, 1.02197, 1.06777, 1.02197, 0.91142, 0.96752, 1, 1.21261, 0.89903, 1, 1, 0.75155, 1.04745, 1.04745, 1.04745, 1.04394, 0.98633, 0.98633, 0.98633, 0.72959, 0.72959, 1.20502, 0.91406, 1.26514, 1.222, 1.02956, 1.03372, 1.03372, 0.96039, 1.24633, 1, 1.09125, 0.93327, 1.03336, 1.16541, 1.036, 1, 1, 1, 0.771, 1, 1, 1.15574, 1.15574, 1.15574, 1.15574, 0.86364, 0.94434, 0.86279, 0.94434, 0.86224, 1, 1, 1.16798, 1, 0.96085, 0.90068, 1.21237, 1.18416, 1.13904, 0.69825, 0.9716, 2.10339, 1.29004, 1.29004, 1.21339, 1.29004, 1.29004, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18775, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.13269, 1.13269, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.SegoeuiBoldItalicFactors = u;
          const q = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          F.SegoeuiBoldItalicMetrics = q;
          const e = [1.76738, 1, 1, 0.98946, 1.14763, 1.05365, 1.06234, 0.96927, 0.92586, 1.15373, 1.18414, 0.91349, 0.91349, 1.07403, 1.17308, 0.78383, 1.20088, 0.78383, 1.42531, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78383, 0.78383, 1.17308, 1.17308, 1.17308, 0.77349, 0.94565, 0.94729, 0.85944, 0.88506, 0.9858, 0.74817, 0.80016, 0.88449, 0.98039, 0.95782, 0.69238, 0.89898, 0.83231, 0.98183, 1.03989, 0.96924, 0.86237, 0.96924, 0.80595, 0.74524, 0.86091, 0.95402, 0.94143, 0.98448, 0.8858, 0.83089, 0.93285, 1.0949, 1.39016, 1.0949, 1.45994, 0.74627, 1.04839, 0.97454, 0.97454, 0.87207, 0.97454, 0.87533, 1.06151, 0.97454, 1.00176, 1.16484, 1.08132, 0.98047, 1.16484, 1.02989, 1.01054, 0.96225, 0.97454, 0.97454, 1.06598, 0.79004, 1.16344, 1.00351, 0.94629, 0.9973, 0.91016, 0.96777, 0.9043, 0.91082, 0.92481, 0.91082, 1.17308, 0.95748, 0.96927, 0.96927, 1, 0.96927, 0.92481, 0.80597, 1.04839, 1.23393, 1.1781, 0.9245, 1.17308, 1.20808, 0.63218, 0.94261, 1.24822, 1.09971, 1.09971, 1.04839, 1, 0.85273, 0.78032, 1.04839, 1.09971, 1.22326, 0.9245, 1.09836, 1.13525, 1.15222, 0.70424, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.94729, 0.85498, 0.88506, 0.74817, 0.74817, 0.74817, 0.74817, 0.95782, 0.95782, 0.95782, 0.95782, 0.9858, 1.03989, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.17308, 0.96924, 0.95402, 0.95402, 0.95402, 0.95402, 0.83089, 0.86237, 0.88409, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.97454, 0.92916, 0.87207, 0.87533, 0.87533, 0.87533, 0.87533, 0.93146, 0.93146, 0.93146, 0.93146, 0.93854, 1.01054, 0.96225, 0.96225, 0.96225, 0.96225, 0.96225, 1.24822, 0.8761, 1.00351, 1.00351, 1.00351, 1.00351, 0.96777, 0.97454, 0.96777, 0.94729, 0.97454, 0.94729, 0.97454, 0.94729, 0.97454, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.88506, 0.87207, 0.9858, 0.95391, 0.9858, 0.97454, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.74817, 0.87533, 0.88449, 0.97454, 0.88449, 0.97454, 0.88449, 0.97454, 1, 1, 0.98039, 1.00176, 0.98039, 1.00176, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 0.93146, 0.95782, 1.16484, 0.95782, 0.93146, 0.84421, 1.12761, 0.69238, 1.08132, 1, 1, 0.98047, 0.83231, 1.16484, 1, 1, 0.84723, 1.04861, 0.84723, 0.78755, 0.83231, 1.23736, 1.03989, 1.01054, 1, 1, 1.03989, 1.01054, 0.9857, 1.03849, 1.01054, 0.96924, 0.96225, 0.96924, 0.96225, 0.96924, 0.96225, 0.92383, 0.90171, 0.80595, 1.06598, 1, 1, 0.80595, 1.06598, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 0.74524, 0.79004, 1, 1, 0.86091, 1.02759, 0.85771, 1.16344, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.95402, 1.00351, 0.98448, 0.9973, 0.83089, 0.96777, 0.83089, 0.93285, 0.9043, 0.93285, 0.9043, 0.93285, 0.9043, 1.31868, 0.96927, 0.94729, 0.97454, 0.85498, 0.92916, 0.96924, 0.8761, 1, 1, 0.86091, 1.16344, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 1.04839, 0.81965, 0.81965, 0.94729, 0.78032, 0.71022, 0.90883, 0.84171, 0.99877, 0.77596, 1.05734, 1.2, 0.94729, 0.85944, 0.82791, 0.9607, 0.74817, 0.93285, 0.98039, 0.96924, 0.95782, 0.89898, 0.98316, 0.98183, 1.03989, 0.78614, 0.96924, 0.97642, 0.86237, 0.86075, 0.86091, 0.83089, 0.90082, 0.8858, 0.97296, 1.01284, 0.95782, 0.83089, 1.0976, 1.04, 1.03342, 1.2, 1.0675, 1.0976, 0.98205, 1.03809, 1.05097, 1.04, 0.95364, 1.03342, 1.05401, 1.2, 1.02148, 1.0119, 1.04724, 1.0127, 1.02732, 0.96225, 0.8965, 0.97783, 0.93574, 0.94818, 1.30679, 1.0675, 1.11826, 0.99821, 1.0557, 1.0326, 1.2, 1.0675, 0.96225, 1.0675, 1.0326, 0.74817, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03754, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.87533, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.98705, 1, 1, 1, 1, 1, 1, 0.98448, 0.9973, 0.98448, 0.9973, 0.98448, 0.9973, 0.83089, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 0.94945, 0.94945, 0.94945, 0.94945, 1.12317, 1.12317, 1.12317, 0.67603, 0.67603, 1.15621, 0.73584, 1.21191, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87709, 0.96927, 1.01473, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.09836, 1.09836, 1.09836, 1.01522, 0.86321, 0.94434, 0.8649, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86438, 1.17308, 1.18416, 1.14589, 0.69825, 0.97622, 1.96791, 1.24822, 1.24822, 1.17308, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.17984, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10742, 1.10742, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.SegoeuiItalicFactors = e;
          const t = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          F.SegoeuiItalicMetrics = t;
          const B = [1.76738, 1, 1, 0.98594, 1.02285, 1.10454, 1.06234, 0.96927, 0.92037, 1.19985, 1.2046, 0.90616, 0.90616, 1.07152, 1.1714, 0.78032, 1.20088, 0.78032, 1.40246, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.96927, 0.78032, 0.78032, 1.1714, 1.1714, 1.1714, 0.80597, 0.94084, 0.96706, 0.85944, 0.85734, 0.97093, 0.75842, 0.79936, 0.88198, 0.9831, 0.95782, 0.71387, 0.86969, 0.84636, 1.07796, 1.03584, 0.96924, 0.83968, 0.96924, 0.82826, 0.79649, 0.85771, 0.95132, 0.93119, 0.98965, 0.88433, 0.8287, 0.93365, 1.08612, 1.3638, 1.08612, 1.45786, 0.74627, 0.80499, 0.91484, 1.05707, 0.92383, 1.05882, 0.9403, 1.12654, 1.05882, 1.01756, 1.09011, 1.09011, 0.99414, 1.09011, 1.034, 1.01756, 1.05356, 1.05707, 1.05882, 1.04399, 0.84863, 1.21968, 1.01756, 0.95801, 1.00068, 0.91797, 0.96777, 0.9043, 0.90351, 0.92105, 0.90351, 1.1714, 0.85337, 0.96927, 0.96927, 0.99912, 0.96927, 0.92105, 0.80597, 1.2434, 1.20808, 1.05937, 0.90957, 1.1714, 1.20808, 0.75155, 0.94261, 1.24644, 1.09971, 1.09971, 0.84751, 1, 0.85273, 0.78032, 0.61584, 1.05425, 1.17914, 0.90957, 1.08665, 1.11593, 1.14169, 0.73381, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.96706, 0.86035, 0.85734, 0.75842, 0.75842, 0.75842, 0.75842, 0.95782, 0.95782, 0.95782, 0.95782, 0.97093, 1.03584, 0.96924, 0.96924, 0.96924, 0.96924, 0.96924, 1.1714, 0.96924, 0.95132, 0.95132, 0.95132, 0.95132, 0.8287, 0.83968, 0.89049, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.91484, 0.93575, 0.92383, 0.9403, 0.9403, 0.9403, 0.9403, 0.8717, 0.8717, 0.8717, 0.8717, 1.00527, 1.01756, 1.05356, 1.05356, 1.05356, 1.05356, 1.05356, 1.24644, 0.95923, 1.01756, 1.01756, 1.01756, 1.01756, 0.96777, 1.05707, 0.96777, 0.96706, 0.91484, 0.96706, 0.91484, 0.96706, 0.91484, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.85734, 0.92383, 0.97093, 1.0969, 0.97093, 1.05882, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.75842, 0.9403, 0.88198, 1.05882, 0.88198, 1.05882, 0.88198, 1.05882, 1, 1, 0.9831, 1.01756, 0.9831, 1.01756, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 0.8717, 0.95782, 1.09011, 0.95782, 0.8717, 0.84784, 1.11551, 0.71387, 1.09011, 1, 1, 0.99414, 0.84636, 1.09011, 1, 1, 0.84636, 1.0536, 0.84636, 0.94298, 0.84636, 1.23297, 1.03584, 1.01756, 1, 1, 1.03584, 1.01756, 1.00323, 1.03444, 1.01756, 0.96924, 1.05356, 0.96924, 1.05356, 0.96924, 1.05356, 0.93066, 0.98293, 0.82826, 1.04399, 1, 1, 0.82826, 1.04399, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 0.79649, 0.84863, 1, 1, 0.85771, 1.17318, 0.85771, 1.21968, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.95132, 1.01756, 0.98965, 1.00068, 0.8287, 0.96777, 0.8287, 0.93365, 0.9043, 0.93365, 0.9043, 0.93365, 0.9043, 1.08571, 0.96927, 0.96706, 0.91484, 0.86035, 0.93575, 0.96924, 0.95923, 1, 1, 0.85771, 1.21968, 1.11437, 1.11437, 0.93109, 0.91202, 0.60411, 0.84164, 0.55572, 1.01173, 0.97361, 0.81818, 0.81818, 0.96635, 0.78032, 0.72727, 0.92366, 0.98601, 1.03405, 0.77968, 1.09799, 1.2, 0.96706, 0.85944, 0.85638, 0.96491, 0.75842, 0.93365, 0.9831, 0.96924, 0.95782, 0.86969, 0.94152, 1.07796, 1.03584, 0.78437, 0.96924, 0.98715, 0.83968, 0.83491, 0.85771, 0.8287, 0.94492, 0.88433, 0.9287, 1.0098, 0.95782, 0.8287, 1.0625, 0.98248, 1.03424, 1.2, 1.01071, 1.0625, 0.95246, 1.03809, 1.04912, 0.98248, 1.00221, 1.03424, 1.05443, 1.2, 1.04785, 0.99609, 1.00169, 1.05176, 0.99346, 1.05356, 0.9087, 1.03004, 0.95542, 0.93117, 1.23362, 1.01071, 1.07831, 1.02512, 1.05205, 1.03502, 1.2, 1.01071, 1.05356, 1.01071, 1.03502, 0.75842, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.03719, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0.9403, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.04021, 1, 1, 1, 1, 1, 1, 0.98965, 1.00068, 0.98965, 1.00068, 0.98965, 1.00068, 0.8287, 0.96777, 1, 1.20088, 0.89903, 1, 1, 0.75155, 1.03077, 1.03077, 1.03077, 1.03077, 1.13196, 1.13196, 1.13196, 0.67428, 0.67428, 1.16039, 0.73291, 1.20996, 1.22135, 1.06483, 0.94868, 0.94868, 0.95996, 1.24633, 1, 1.07497, 0.87796, 0.96927, 1.01518, 0.96927, 1, 1, 1, 0.77295, 1, 1, 1.10539, 1.10539, 1.11358, 1.06967, 0.86279, 0.94434, 0.86279, 0.94434, 0.86182, 1, 1, 1.083, 1, 0.91578, 0.86507, 1.1714, 1.18416, 1.14589, 0.69825, 0.97622, 1.9697, 1.24822, 1.24822, 1.17238, 1.24822, 1.24822, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1.42603, 1, 0.99862, 0.99862, 1, 0.87025, 0.87025, 0.87025, 0.87025, 1.18083, 1.42603, 1, 1.42603, 1.42603, 0.99862, 1, 1, 1, 1, 1, 1.2886, 1.04315, 1.15296, 1.34163, 1, 1, 1, 1.10938, 1.10938, 1, 1, 1, 1.05425, 1.09971, 1.09971, 1.09971, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
          F.SegoeuiRegularFactors = B;
          const j = {
            lineHeight: 1.33008,
            lineGap: 0
          };
          F.SegoeuiRegularMetrics = j;
        },
        /* 57 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PostScriptEvaluator = F.PostScriptCompiler = F.PDFFunctionFactory = void 0, F.isPDFFunction = O;
          var n = ae(4), u = ae(2), q = ae(58), e = ae(5), t = ae(59);
          class B {
            constructor({
              xref: d,
              isEvalSupported: A = !0
            }) {
              this.xref = d, this.isEvalSupported = A !== !1;
            }
            create(d) {
              const A = this.getCached(d);
              if (A)
                return A;
              const N = M.parse({
                xref: this.xref,
                isEvalSupported: this.isEvalSupported,
                fn: d instanceof n.Ref ? this.xref.fetch(d) : d
              });
              return this._cache(d, N), N;
            }
            createFromArray(d) {
              const A = this.getCached(d);
              if (A)
                return A;
              const N = M.parseArray({
                xref: this.xref,
                isEvalSupported: this.isEvalSupported,
                fnObj: d instanceof n.Ref ? this.xref.fetch(d) : d
              });
              return this._cache(d, N), N;
            }
            getCached(d) {
              var N;
              let A;
              if (d instanceof n.Ref ? A = d : d instanceof n.Dict ? A = d.objId : d instanceof e.BaseStream && (A = (N = d.dict) == null ? void 0 : N.objId), A) {
                const E = this._localFunctionCache.getByRef(A);
                if (E)
                  return E;
              }
              return null;
            }
            _cache(d, A) {
              var E;
              if (!A)
                throw new Error('PDFFunctionFactory._cache - expected "parsedFunction" argument.');
              let N;
              d instanceof n.Ref ? N = d : d instanceof n.Dict ? N = d.objId : d instanceof e.BaseStream && (N = (E = d.dict) == null ? void 0 : E.objId), N && this._localFunctionCache.set(null, N, A);
            }
            get _localFunctionCache() {
              return (0, u.shadow)(this, "_localFunctionCache", new t.LocalFunctionCache());
            }
          }
          F.PDFFunctionFactory = B;
          function j(c) {
            if (!Array.isArray(c))
              return null;
            const d = c.length;
            for (let A = 0; A < d; A++)
              if (typeof c[A] != "number") {
                const N = new Array(d);
                for (let E = 0; E < d; E++)
                  N[E] = +c[E];
                return N;
              }
            return c;
          }
          class M {
            static getSampleArray(d, A, N, E) {
              let H, $, m = 1;
              for (H = 0, $ = d.length; H < $; H++)
                m *= d[H];
              m *= A;
              const p = new Array(m);
              let T = 0, L = 0;
              const _ = 1 / (2 ** N - 1), G = E.getBytes((m * N + 7) / 8);
              let J = 0;
              for (H = 0; H < m; H++) {
                for (; T < N; )
                  L <<= 8, L |= G[J++], T += 8;
                T -= N, p[H] = (L >> T) * _, L &= (1 << T) - 1;
              }
              return p;
            }
            static parse({
              xref: d,
              isEvalSupported: A,
              fn: N
            }) {
              const E = N.dict || N;
              switch (E.get("FunctionType")) {
                case 0:
                  return this.constructSampled({
                    xref: d,
                    isEvalSupported: A,
                    fn: N,
                    dict: E
                  });
                case 1:
                  break;
                case 2:
                  return this.constructInterpolated({
                    xref: d,
                    isEvalSupported: A,
                    dict: E
                  });
                case 3:
                  return this.constructStiched({
                    xref: d,
                    isEvalSupported: A,
                    dict: E
                  });
                case 4:
                  return this.constructPostScript({
                    xref: d,
                    isEvalSupported: A,
                    fn: N,
                    dict: E
                  });
              }
              throw new u.FormatError("Unknown type of function");
            }
            static parseArray({
              xref: d,
              isEvalSupported: A,
              fnObj: N
            }) {
              if (!Array.isArray(N))
                return this.parse({
                  xref: d,
                  isEvalSupported: A,
                  fn: N
                });
              const E = [];
              for (const H of N)
                E.push(this.parse({
                  xref: d,
                  isEvalSupported: A,
                  fn: d.fetchIfRef(H)
                }));
              return function(H, $, m, p) {
                for (let T = 0, L = E.length; T < L; T++)
                  E[T](H, $, m, p + T);
              };
            }
            static constructSampled({
              xref: d,
              isEvalSupported: A,
              fn: N,
              dict: E
            }) {
              function H(Q) {
                const X = Q.length, R = [];
                let f = 0;
                for (let D = 0; D < X; D += 2)
                  R[f++] = [Q[D], Q[D + 1]];
                return R;
              }
              function $(Q, X, R, f, D) {
                return f + (Q - X) * ((D - f) / (R - X));
              }
              let m = j(E.getArray("Domain")), p = j(E.getArray("Range"));
              if (!m || !p)
                throw new u.FormatError("No domain or range");
              const T = m.length / 2, L = p.length / 2;
              m = H(m), p = H(p);
              const _ = j(E.getArray("Size")), G = E.get("BitsPerSample"), J = E.get("Order") || 1;
              J !== 1 && (0, u.info)("No support for cubic spline interpolation: " + J);
              let K = j(E.getArray("Encode"));
              if (K)
                K = H(K);
              else {
                K = [];
                for (let Q = 0; Q < T; ++Q)
                  K.push([0, _[Q] - 1]);
              }
              let V = j(E.getArray("Decode"));
              V ? V = H(V) : V = p;
              const U = this.getSampleArray(_, L, G, N);
              return function(X, R, f, D) {
                const z = 1 << T, Y = new Float64Array(z), W = new Uint32Array(z);
                let ie, ne;
                for (ne = 0; ne < z; ne++)
                  Y[ne] = 1;
                let re = L, ee = 1;
                for (ie = 0; ie < T; ++ie) {
                  const te = m[ie][0], oe = m[ie][1], se = Math.min(Math.max(X[R + ie], te), oe);
                  let ce = $(se, te, oe, K[ie][0], K[ie][1]);
                  const le = _[ie];
                  ce = Math.min(Math.max(ce, 0), le - 1);
                  const de = ce < le - 1 ? Math.floor(ce) : ce - 1, Ie = de + 1 - ce, Fe = ce - de, we = de * re, pe = we + re;
                  for (ne = 0; ne < z; ne++)
                    ne & ee ? (Y[ne] *= Fe, W[ne] += pe) : (Y[ne] *= Ie, W[ne] += we);
                  re *= le, ee <<= 1;
                }
                for (ne = 0; ne < L; ++ne) {
                  let te = 0;
                  for (ie = 0; ie < z; ie++)
                    te += U[W[ie] + ne] * Y[ie];
                  te = $(te, 0, 1, V[ne][0], V[ne][1]), f[D + ne] = Math.min(Math.max(te, p[ne][0]), p[ne][1]);
                }
              };
            }
            static constructInterpolated({
              xref: d,
              isEvalSupported: A,
              dict: N
            }) {
              const E = j(N.getArray("C0")) || [0], H = j(N.getArray("C1")) || [1], $ = N.get("N"), m = [];
              for (let T = 0, L = E.length; T < L; ++T)
                m.push(H[T] - E[T]);
              const p = m.length;
              return function(L, _, G, J) {
                const K = $ === 1 ? L[_] : L[_] ** $;
                for (let V = 0; V < p; ++V)
                  G[J + V] = E[V] + K * m[V];
              };
            }
            static constructStiched({
              xref: d,
              isEvalSupported: A,
              dict: N
            }) {
              const E = j(N.getArray("Domain"));
              if (!E)
                throw new u.FormatError("No domain");
              if (E.length / 2 !== 1)
                throw new u.FormatError("Bad domain for stiched function");
              const $ = [];
              for (const L of N.get("Functions"))
                $.push(this.parse({
                  xref: d,
                  isEvalSupported: A,
                  fn: d.fetchIfRef(L)
                }));
              const m = j(N.getArray("Bounds")), p = j(N.getArray("Encode")), T = new Float32Array(1);
              return function(_, G, J, K) {
                const U = function(W, ie, ne) {
                  return W > ne ? W = ne : W < ie && (W = ie), W;
                }(_[G], E[0], E[1]), Q = m.length;
                let X;
                for (X = 0; X < Q && !(U < m[X]); ++X)
                  ;
                let R = E[0];
                X > 0 && (R = m[X - 1]);
                let f = E[1];
                X < m.length && (f = m[X]);
                const D = p[2 * X], z = p[2 * X + 1];
                T[0] = R === f ? D : D + (U - R) * (z - D) / (f - R), $[X](T, 0, J, K);
              };
            }
            static constructPostScript({
              xref: d,
              isEvalSupported: A,
              fn: N,
              dict: E
            }) {
              const H = j(E.getArray("Domain")), $ = j(E.getArray("Range"));
              if (!H)
                throw new u.FormatError("No domain.");
              if (!$)
                throw new u.FormatError("No range.");
              const m = new q.PostScriptLexer(N), T = new q.PostScriptParser(m).parse();
              if (A && u.FeatureTest.isEvalSupported) {
                const Q = new y().compile(T, H, $);
                if (Q)
                  return new Function("src", "srcOffset", "dest", "destOffset", Q);
              }
              (0, u.info)("Unable to compile PS function");
              const L = $.length >> 1, _ = H.length >> 1, G = new C(T), J = /* @__PURE__ */ Object.create(null);
              let V = 2048 * 4;
              const U = new Float32Array(_);
              return function(X, R, f, D) {
                let z, Y, W = "";
                const ie = U;
                for (z = 0; z < _; z++)
                  Y = X[R + z], ie[z] = Y, W += Y + "_";
                const ne = J[W];
                if (ne !== void 0) {
                  f.set(ne, D);
                  return;
                }
                const re = new Float32Array(L), ee = G.execute(ie), te = ee.length - L;
                for (z = 0; z < L; z++) {
                  Y = ee[te + z];
                  let oe = $[z * 2];
                  Y < oe ? Y = oe : (oe = $[z * 2 + 1], Y > oe && (Y = oe)), re[z] = Y;
                }
                V > 0 && (V--, J[W] = re), f.set(re, D);
              };
            }
          }
          function O(c) {
            let d;
            if (c instanceof n.Dict)
              d = c;
            else if (c instanceof e.BaseStream)
              d = c.dict;
            else
              return !1;
            return d.has("FunctionType");
          }
          const P = class P {
            constructor(d) {
              this.stack = d ? Array.from(d) : [];
            }
            push(d) {
              if (this.stack.length >= P.MAX_STACK_SIZE)
                throw new Error("PostScript function stack overflow.");
              this.stack.push(d);
            }
            pop() {
              if (this.stack.length <= 0)
                throw new Error("PostScript function stack underflow.");
              return this.stack.pop();
            }
            copy(d) {
              if (this.stack.length + d >= P.MAX_STACK_SIZE)
                throw new Error("PostScript function stack overflow.");
              const A = this.stack;
              for (let N = A.length - d, E = d - 1; E >= 0; E--, N++)
                A.push(A[N]);
            }
            index(d) {
              this.push(this.stack[this.stack.length - d - 1]);
            }
            roll(d, A) {
              const N = this.stack, E = N.length - d, H = N.length - 1, $ = E + (A - Math.floor(A / d) * d);
              for (let m = E, p = H; m < p; m++, p--) {
                const T = N[m];
                N[m] = N[p], N[p] = T;
              }
              for (let m = E, p = $ - 1; m < p; m++, p--) {
                const T = N[m];
                N[m] = N[p], N[p] = T;
              }
              for (let m = $, p = H; m < p; m++, p--) {
                const T = N[m];
                N[m] = N[p], N[p] = T;
              }
            }
          };
          Dt(P, "MAX_STACK_SIZE", 100);
          let w = P;
          class C {
            constructor(d) {
              this.operators = d;
            }
            execute(d) {
              const A = new w(d);
              let N = 0;
              const E = this.operators, H = E.length;
              let $, m, p;
              for (; N < H; ) {
                if ($ = E[N++], typeof $ == "number") {
                  A.push($);
                  continue;
                }
                switch ($) {
                  case "jz":
                    p = A.pop(), m = A.pop(), m || (N = p);
                    break;
                  case "j":
                    m = A.pop(), N = m;
                    break;
                  case "abs":
                    m = A.pop(), A.push(Math.abs(m));
                    break;
                  case "add":
                    p = A.pop(), m = A.pop(), A.push(m + p);
                    break;
                  case "and":
                    p = A.pop(), m = A.pop(), typeof m == "boolean" && typeof p == "boolean" ? A.push(m && p) : A.push(m & p);
                    break;
                  case "atan":
                    p = A.pop(), m = A.pop(), m = Math.atan2(m, p) / Math.PI * 180, m < 0 && (m += 360), A.push(m);
                    break;
                  case "bitshift":
                    p = A.pop(), m = A.pop(), m > 0 ? A.push(m << p) : A.push(m >> p);
                    break;
                  case "ceiling":
                    m = A.pop(), A.push(Math.ceil(m));
                    break;
                  case "copy":
                    m = A.pop(), A.copy(m);
                    break;
                  case "cos":
                    m = A.pop(), A.push(Math.cos(m % 360 / 180 * Math.PI));
                    break;
                  case "cvi":
                    m = A.pop() | 0, A.push(m);
                    break;
                  case "cvr":
                    break;
                  case "div":
                    p = A.pop(), m = A.pop(), A.push(m / p);
                    break;
                  case "dup":
                    A.copy(1);
                    break;
                  case "eq":
                    p = A.pop(), m = A.pop(), A.push(m === p);
                    break;
                  case "exch":
                    A.roll(2, 1);
                    break;
                  case "exp":
                    p = A.pop(), m = A.pop(), A.push(m ** p);
                    break;
                  case "false":
                    A.push(!1);
                    break;
                  case "floor":
                    m = A.pop(), A.push(Math.floor(m));
                    break;
                  case "ge":
                    p = A.pop(), m = A.pop(), A.push(m >= p);
                    break;
                  case "gt":
                    p = A.pop(), m = A.pop(), A.push(m > p);
                    break;
                  case "idiv":
                    p = A.pop(), m = A.pop(), A.push(m / p | 0);
                    break;
                  case "index":
                    m = A.pop(), A.index(m);
                    break;
                  case "le":
                    p = A.pop(), m = A.pop(), A.push(m <= p);
                    break;
                  case "ln":
                    m = A.pop(), A.push(Math.log(m));
                    break;
                  case "log":
                    m = A.pop(), A.push(Math.log(m) / Math.LN10);
                    break;
                  case "lt":
                    p = A.pop(), m = A.pop(), A.push(m < p);
                    break;
                  case "mod":
                    p = A.pop(), m = A.pop(), A.push(m % p);
                    break;
                  case "mul":
                    p = A.pop(), m = A.pop(), A.push(m * p);
                    break;
                  case "ne":
                    p = A.pop(), m = A.pop(), A.push(m !== p);
                    break;
                  case "neg":
                    m = A.pop(), A.push(-m);
                    break;
                  case "not":
                    m = A.pop(), typeof m == "boolean" ? A.push(!m) : A.push(~m);
                    break;
                  case "or":
                    p = A.pop(), m = A.pop(), typeof m == "boolean" && typeof p == "boolean" ? A.push(m || p) : A.push(m | p);
                    break;
                  case "pop":
                    A.pop();
                    break;
                  case "roll":
                    p = A.pop(), m = A.pop(), A.roll(m, p);
                    break;
                  case "round":
                    m = A.pop(), A.push(Math.round(m));
                    break;
                  case "sin":
                    m = A.pop(), A.push(Math.sin(m % 360 / 180 * Math.PI));
                    break;
                  case "sqrt":
                    m = A.pop(), A.push(Math.sqrt(m));
                    break;
                  case "sub":
                    p = A.pop(), m = A.pop(), A.push(m - p);
                    break;
                  case "true":
                    A.push(!0);
                    break;
                  case "truncate":
                    m = A.pop(), m = m < 0 ? Math.ceil(m) : Math.floor(m), A.push(m);
                    break;
                  case "xor":
                    p = A.pop(), m = A.pop(), typeof m == "boolean" && typeof p == "boolean" ? A.push(m !== p) : A.push(m ^ p);
                    break;
                  default:
                    throw new u.FormatError(`Unknown operator ${$}`);
                }
              }
              return A.stack;
            }
          }
          F.PostScriptEvaluator = C;
          class i {
            constructor(d) {
              this.type = d;
            }
            visit(d) {
              (0, u.unreachable)("abstract method");
            }
          }
          class o extends i {
            constructor(d, A, N) {
              super("args"), this.index = d, this.min = A, this.max = N;
            }
            visit(d) {
              d.visitArgument(this);
            }
          }
          class k extends i {
            constructor(d) {
              super("literal"), this.number = d, this.min = d, this.max = d;
            }
            visit(d) {
              d.visitLiteral(this);
            }
          }
          class s extends i {
            constructor(d, A, N, E, H) {
              super("binary"), this.op = d, this.arg1 = A, this.arg2 = N, this.min = E, this.max = H;
            }
            visit(d) {
              d.visitBinaryOperation(this);
            }
          }
          class l extends i {
            constructor(d, A) {
              super("max"), this.arg = d, this.min = d.min, this.max = A;
            }
            visit(d) {
              d.visitMin(this);
            }
          }
          class g extends i {
            constructor(d, A, N) {
              super("var"), this.index = d, this.min = A, this.max = N;
            }
            visit(d) {
              d.visitVariable(this);
            }
          }
          class v extends i {
            constructor(d, A) {
              super("definition"), this.variable = d, this.arg = A;
            }
            visit(d) {
              d.visitVariableDefinition(this);
            }
          }
          class r {
            constructor() {
              this.parts = [];
            }
            visitArgument(d) {
              this.parts.push("Math.max(", d.min, ", Math.min(", d.max, ", src[srcOffset + ", d.index, "]))");
            }
            visitVariable(d) {
              this.parts.push("v", d.index);
            }
            visitLiteral(d) {
              this.parts.push(d.number);
            }
            visitBinaryOperation(d) {
              this.parts.push("("), d.arg1.visit(this), this.parts.push(" ", d.op, " "), d.arg2.visit(this), this.parts.push(")");
            }
            visitVariableDefinition(d) {
              this.parts.push("var "), d.variable.visit(this), this.parts.push(" = "), d.arg.visit(this), this.parts.push(";");
            }
            visitMin(d) {
              this.parts.push("Math.min("), d.arg.visit(this), this.parts.push(", ", d.max, ")");
            }
            toString() {
              return this.parts.join("");
            }
          }
          function x(c, d) {
            return d.type === "literal" && d.number === 0 ? c : c.type === "literal" && c.number === 0 ? d : d.type === "literal" && c.type === "literal" ? new k(c.number + d.number) : new s("+", c, d, c.min + d.min, c.max + d.max);
          }
          function b(c, d) {
            if (d.type === "literal") {
              if (d.number === 0)
                return new k(0);
              if (d.number === 1)
                return c;
              if (c.type === "literal")
                return new k(c.number * d.number);
            }
            if (c.type === "literal") {
              if (c.number === 0)
                return new k(0);
              if (c.number === 1)
                return d;
            }
            const A = Math.min(c.min * d.min, c.min * d.max, c.max * d.min, c.max * d.max), N = Math.max(c.min * d.min, c.min * d.max, c.max * d.min, c.max * d.max);
            return new s("*", c, d, A, N);
          }
          function I(c, d) {
            if (d.type === "literal") {
              if (d.number === 0)
                return c;
              if (c.type === "literal")
                return new k(c.number - d.number);
            }
            return d.type === "binary" && d.op === "-" && c.type === "literal" && c.number === 1 && d.arg1.type === "literal" && d.arg1.number === 1 ? d.arg2 : new s("-", c, d, c.min - d.max, c.max - d.min);
          }
          function h(c, d) {
            return c.min >= d ? new k(d) : c.max <= d ? c : new l(c, d);
          }
          class y {
            compile(d, A, N) {
              const E = [], H = [], $ = A.length >> 1, m = N.length >> 1;
              let p = 0, T, L, _, G, J, K, V, U;
              for (let X = 0; X < $; X++)
                E.push(new o(X, A[X * 2], A[X * 2 + 1]));
              for (let X = 0, R = d.length; X < R; X++) {
                if (U = d[X], typeof U == "number") {
                  E.push(new k(U));
                  continue;
                }
                switch (U) {
                  case "add":
                    if (E.length < 2)
                      return null;
                    G = E.pop(), _ = E.pop(), E.push(x(_, G));
                    break;
                  case "cvr":
                    if (E.length < 1)
                      return null;
                    break;
                  case "mul":
                    if (E.length < 2)
                      return null;
                    G = E.pop(), _ = E.pop(), E.push(b(_, G));
                    break;
                  case "sub":
                    if (E.length < 2)
                      return null;
                    G = E.pop(), _ = E.pop(), E.push(I(_, G));
                    break;
                  case "exch":
                    if (E.length < 2)
                      return null;
                    J = E.pop(), K = E.pop(), E.push(J, K);
                    break;
                  case "pop":
                    if (E.length < 1)
                      return null;
                    E.pop();
                    break;
                  case "index":
                    if (E.length < 1 || (_ = E.pop(), _.type !== "literal") || (T = _.number, T < 0 || !Number.isInteger(T) || E.length < T))
                      return null;
                    if (J = E[E.length - T - 1], J.type === "literal" || J.type === "var") {
                      E.push(J);
                      break;
                    }
                    V = new g(p++, J.min, J.max), E[E.length - T - 1] = V, E.push(V), H.push(new v(V, J));
                    break;
                  case "dup":
                    if (E.length < 1)
                      return null;
                    if (typeof d[X + 1] == "number" && d[X + 2] === "gt" && d[X + 3] === X + 7 && d[X + 4] === "jz" && d[X + 5] === "pop" && d[X + 6] === d[X + 1]) {
                      _ = E.pop(), E.push(h(_, d[X + 1])), X += 6;
                      break;
                    }
                    if (J = E.at(-1), J.type === "literal" || J.type === "var") {
                      E.push(J);
                      break;
                    }
                    V = new g(p++, J.min, J.max), E[E.length - 1] = V, E.push(V), H.push(new v(V, J));
                    break;
                  case "roll":
                    if (E.length < 2 || (G = E.pop(), _ = E.pop(), G.type !== "literal" || _.type !== "literal") || (L = G.number, T = _.number, T <= 0 || !Number.isInteger(T) || !Number.isInteger(L) || E.length < T))
                      return null;
                    if (L = (L % T + T) % T, L === 0)
                      break;
                    E.push(...E.splice(E.length - T, T - L));
                    break;
                  default:
                    return null;
                }
              }
              if (E.length !== m)
                return null;
              const Q = [];
              for (const X of H) {
                const R = new r();
                X.visit(R), Q.push(R.toString());
              }
              for (let X = 0, R = E.length; X < R; X++) {
                const f = E[X], D = new r();
                f.visit(D);
                const z = N[X * 2], Y = N[X * 2 + 1], W = [D.toString()];
                z > f.min && (W.unshift("Math.max(", z, ", "), W.push(")")), Y < f.max && (W.unshift("Math.min(", Y, ", "), W.push(")")), W.unshift("dest[destOffset + ", X, "] = "), W.push(";"), Q.push(W.join(""));
              }
              return Q.join(`
`);
            }
          }
          F.PostScriptCompiler = y;
        },
        /* 58 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PostScriptParser = F.PostScriptLexer = void 0;
          var n = ae(2), u = ae(4), q = ae(3);
          class e {
            constructor(O) {
              this.lexer = O, this.operators = [], this.token = null, this.prev = null;
            }
            nextToken() {
              this.prev = this.token, this.token = this.lexer.getToken();
            }
            accept(O) {
              return this.token.type === O ? (this.nextToken(), !0) : !1;
            }
            expect(O) {
              if (this.accept(O))
                return !0;
              throw new n.FormatError(`Unexpected symbol: found ${this.token.type} expected ${O}.`);
            }
            parse() {
              return this.nextToken(), this.expect(t.LBRACE), this.parseBlock(), this.expect(t.RBRACE), this.operators;
            }
            parseBlock() {
              for (; ; )
                if (this.accept(t.NUMBER))
                  this.operators.push(this.prev.value);
                else if (this.accept(t.OPERATOR))
                  this.operators.push(this.prev.value);
                else if (this.accept(t.LBRACE))
                  this.parseCondition();
                else
                  return;
            }
            parseCondition() {
              const O = this.operators.length;
              if (this.operators.push(null, null), this.parseBlock(), this.expect(t.RBRACE), this.accept(t.IF))
                this.operators[O] = this.operators.length, this.operators[O + 1] = "jz";
              else if (this.accept(t.LBRACE)) {
                const w = this.operators.length;
                this.operators.push(null, null);
                const C = this.operators.length;
                this.parseBlock(), this.expect(t.RBRACE), this.expect(t.IFELSE), this.operators[w] = this.operators.length, this.operators[w + 1] = "j", this.operators[O] = C, this.operators[O + 1] = "jz";
              } else
                throw new n.FormatError("PS Function: error parsing conditional.");
            }
          }
          F.PostScriptParser = e;
          const t = {
            LBRACE: 0,
            RBRACE: 1,
            NUMBER: 2,
            OPERATOR: 3,
            IF: 4,
            IFELSE: 5
          };
          class B {
            static get opCache() {
              return (0, n.shadow)(this, "opCache", /* @__PURE__ */ Object.create(null));
            }
            constructor(O, w) {
              this.type = O, this.value = w;
            }
            static getOperator(O) {
              var w;
              return (w = B.opCache)[O] || (w[O] = new B(t.OPERATOR, O));
            }
            static get LBRACE() {
              return (0, n.shadow)(this, "LBRACE", new B(t.LBRACE, "{"));
            }
            static get RBRACE() {
              return (0, n.shadow)(this, "RBRACE", new B(t.RBRACE, "}"));
            }
            static get IF() {
              return (0, n.shadow)(this, "IF", new B(t.IF, "IF"));
            }
            static get IFELSE() {
              return (0, n.shadow)(this, "IFELSE", new B(t.IFELSE, "IFELSE"));
            }
          }
          class j {
            constructor(O) {
              this.stream = O, this.nextChar(), this.strBuf = [];
            }
            nextChar() {
              return this.currentChar = this.stream.getByte();
            }
            getToken() {
              let O = !1, w = this.currentChar;
              for (; ; ) {
                if (w < 0)
                  return u.EOF;
                if (O)
                  (w === 10 || w === 13) && (O = !1);
                else if (w === 37)
                  O = !0;
                else if (!(0, q.isWhiteSpace)(w))
                  break;
                w = this.nextChar();
              }
              switch (w | 0) {
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 43:
                case 45:
                case 46:
                  return new B(t.NUMBER, this.getNumber());
                case 123:
                  return this.nextChar(), B.LBRACE;
                case 125:
                  return this.nextChar(), B.RBRACE;
              }
              const C = this.strBuf;
              for (C.length = 0, C[0] = String.fromCharCode(w); (w = this.nextChar()) >= 0 && (w >= 65 && w <= 90 || w >= 97 && w <= 122); )
                C.push(String.fromCharCode(w));
              const i = C.join("");
              switch (i.toLowerCase()) {
                case "if":
                  return B.IF;
                case "ifelse":
                  return B.IFELSE;
                default:
                  return B.getOperator(i);
              }
            }
            getNumber() {
              let O = this.currentChar;
              const w = this.strBuf;
              for (w.length = 0, w[0] = String.fromCharCode(O); (O = this.nextChar()) >= 0 && (O >= 48 && O <= 57 || O === 45 || O === 46); )
                w.push(String.fromCharCode(O));
              const C = parseFloat(w.join(""));
              if (isNaN(C))
                throw new n.FormatError(`Invalid floating point number: ${C}`);
              return C;
            }
          }
          F.PostScriptLexer = j;
        },
        /* 59 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.RegionalImageCache = F.LocalTilingPatternCache = F.LocalImageCache = F.LocalGStateCache = F.LocalFunctionCache = F.LocalColorSpaceCache = F.GlobalImageCache = void 0;
          var n = ae(2), u = ae(4);
          class q {
            constructor(o) {
              this.constructor === q && (0, n.unreachable)("Cannot initialize BaseLocalCache."), this._onlyRefs = (o == null ? void 0 : o.onlyRefs) === !0, this._onlyRefs || (this._nameRefMap = /* @__PURE__ */ new Map(), this._imageMap = /* @__PURE__ */ new Map()), this._imageCache = new u.RefSetCache();
            }
            getByName(o) {
              this._onlyRefs && (0, n.unreachable)("Should not call `getByName` method.");
              const k = this._nameRefMap.get(o);
              return k ? this.getByRef(k) : this._imageMap.get(o) || null;
            }
            getByRef(o) {
              return this._imageCache.get(o) || null;
            }
            set(o, k, s) {
              (0, n.unreachable)("Abstract method `set` called.");
            }
          }
          class e extends q {
            set(o, k = null, s) {
              if (typeof o != "string")
                throw new Error('LocalImageCache.set - expected "name" argument.');
              if (k) {
                if (this._imageCache.has(k))
                  return;
                this._nameRefMap.set(o, k), this._imageCache.put(k, s);
                return;
              }
              this._imageMap.has(o) || this._imageMap.set(o, s);
            }
          }
          F.LocalImageCache = e;
          class t extends q {
            set(o = null, k = null, s) {
              if (typeof o != "string" && !k)
                throw new Error('LocalColorSpaceCache.set - expected "name" and/or "ref" argument.');
              if (k) {
                if (this._imageCache.has(k))
                  return;
                o !== null && this._nameRefMap.set(o, k), this._imageCache.put(k, s);
                return;
              }
              this._imageMap.has(o) || this._imageMap.set(o, s);
            }
          }
          F.LocalColorSpaceCache = t;
          class B extends q {
            constructor(o) {
              super({
                onlyRefs: !0
              });
            }
            set(o = null, k, s) {
              if (!k)
                throw new Error('LocalFunctionCache.set - expected "ref" argument.');
              this._imageCache.has(k) || this._imageCache.put(k, s);
            }
          }
          F.LocalFunctionCache = B;
          class j extends q {
            set(o, k = null, s) {
              if (typeof o != "string")
                throw new Error('LocalGStateCache.set - expected "name" argument.');
              if (k) {
                if (this._imageCache.has(k))
                  return;
                this._nameRefMap.set(o, k), this._imageCache.put(k, s);
                return;
              }
              this._imageMap.has(o) || this._imageMap.set(o, s);
            }
          }
          F.LocalGStateCache = j;
          class M extends q {
            constructor(o) {
              super({
                onlyRefs: !0
              });
            }
            set(o = null, k, s) {
              if (!k)
                throw new Error('LocalTilingPatternCache.set - expected "ref" argument.');
              this._imageCache.has(k) || this._imageCache.put(k, s);
            }
          }
          F.LocalTilingPatternCache = M;
          class O extends q {
            constructor(o) {
              super({
                onlyRefs: !0
              });
            }
            set(o = null, k, s) {
              if (!k)
                throw new Error('RegionalImageCache.set - expected "ref" argument.');
              this._imageCache.has(k) || this._imageCache.put(k, s);
            }
          }
          F.RegionalImageCache = O;
          const C = class C {
            constructor() {
              this._refCache = new u.RefSetCache(), this._imageCache = new u.RefSetCache();
            }
            get _byteSize() {
              let o = 0;
              for (const k of this._imageCache)
                o += k.byteSize;
              return o;
            }
            get _cacheLimitReached() {
              return !(this._imageCache.size < C.MIN_IMAGES_TO_CACHE || this._byteSize < C.MAX_BYTE_SIZE);
            }
            shouldCache(o, k) {
              let s = this._refCache.get(o);
              return s || (s = /* @__PURE__ */ new Set(), this._refCache.put(o, s)), s.add(k), !(s.size < C.NUM_PAGES_THRESHOLD || !this._imageCache.has(o) && this._cacheLimitReached);
            }
            addByteSize(o, k) {
              const s = this._imageCache.get(o);
              s && (s.byteSize || (s.byteSize = k));
            }
            getData(o, k) {
              const s = this._refCache.get(o);
              if (!s || s.size < C.NUM_PAGES_THRESHOLD)
                return null;
              const l = this._imageCache.get(o);
              return l ? (s.add(k), l) : null;
            }
            setData(o, k) {
              if (!this._refCache.has(o))
                throw new Error('GlobalImageCache.setData - expected "shouldCache" to have been called.');
              if (!this._imageCache.has(o)) {
                if (this._cacheLimitReached) {
                  (0, n.warn)("GlobalImageCache.setData - cache limit reached.");
                  return;
                }
                this._imageCache.put(o, k);
              }
            }
            clear(o = !1) {
              o || this._refCache.clear(), this._imageCache.clear();
            }
          };
          Dt(C, "NUM_PAGES_THRESHOLD", 2), Dt(C, "MIN_IMAGES_TO_CACHE", 10), Dt(C, "MAX_BYTE_SIZE", 5 * n.MAX_IMAGE_SIZE_TO_CACHE);
          let w = C;
          F.GlobalImageCache = w;
        },
        /* 60 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.bidi = i;
          var n = ae(2);
          const u = ["BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "S", "B", "S", "WS", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "B", "B", "B", "S", "WS", "ON", "ON", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "ON", "ES", "CS", "ES", "CS", "CS", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "CS", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "ON", "ON", "ON", "BN", "BN", "BN", "BN", "BN", "BN", "B", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "BN", "CS", "ON", "ET", "ET", "ET", "ET", "ON", "ON", "ON", "ON", "L", "ON", "ON", "BN", "ON", "ON", "ET", "ET", "EN", "EN", "ON", "L", "ON", "ON", "ON", "EN", "L", "ON", "ON", "ON", "ON", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "L", "ON", "L", "L", "L", "L", "L", "L", "L", "L"], q = ["AN", "AN", "AN", "AN", "AN", "AN", "ON", "ON", "AL", "ET", "ET", "AL", "CS", "AL", "ON", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "AN", "ET", "AN", "AN", "AL", "AL", "AL", "NSM", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "AL", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AN", "ON", "NSM", "NSM", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "NSM", "NSM", "ON", "NSM", "NSM", "NSM", "NSM", "AL", "AL", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "EN", "AL", "AL", "AL", "AL", "AL", "AL"];
          function e(o) {
            return (o & 1) !== 0;
          }
          function t(o) {
            return (o & 1) === 0;
          }
          function B(o, k, s) {
            let l, g;
            for (l = k, g = o.length; l < g; ++l)
              if (o[l] !== s)
                return l;
            return l;
          }
          function j(o, k, s, l) {
            for (let g = k; g < s; ++g)
              o[g] = l;
          }
          function M(o, k, s) {
            for (let l = k, g = s - 1; l < g; ++l, --g) {
              const v = o[l];
              o[l] = o[g], o[g] = v;
            }
          }
          function O(o, k, s = !1) {
            let l = "ltr";
            return s ? l = "ttb" : k || (l = "rtl"), {
              str: o,
              dir: l
            };
          }
          const w = [], C = [];
          function i(o, k = -1, s = !1) {
            let l = !0;
            const g = o.length;
            if (g === 0 || s)
              return O(o, l, s);
            w.length = g, C.length = g;
            let v = 0, r, x;
            for (r = 0; r < g; ++r) {
              w[r] = o.charAt(r);
              const E = o.charCodeAt(r);
              let H = "L";
              E <= 255 ? H = u[E] : 1424 <= E && E <= 1524 ? H = "R" : 1536 <= E && E <= 1791 ? (H = q[E & 255], H || (0, n.warn)("Bidi: invalid Unicode character " + E.toString(16))) : (1792 <= E && E <= 2220 || 64336 <= E && E <= 65023 || 65136 <= E && E <= 65279) && (H = "AL"), (H === "R" || H === "AL" || H === "AN") && v++, C[r] = H;
            }
            if (v === 0)
              return l = !0, O(o, l);
            k === -1 && (v / g < 0.3 && g > 4 ? (l = !0, k = 0) : (l = !1, k = 1));
            const b = [];
            for (r = 0; r < g; ++r)
              b[r] = k;
            const I = e(k) ? "R" : "L", h = I, y = h;
            let P = h;
            for (r = 0; r < g; ++r)
              C[r] === "NSM" ? C[r] = P : P = C[r];
            P = h;
            let c;
            for (r = 0; r < g; ++r)
              c = C[r], c === "EN" ? C[r] = P === "AL" ? "AN" : "EN" : (c === "R" || c === "L" || c === "AL") && (P = c);
            for (r = 0; r < g; ++r)
              c = C[r], c === "AL" && (C[r] = "R");
            for (r = 1; r < g - 1; ++r)
              C[r] === "ES" && C[r - 1] === "EN" && C[r + 1] === "EN" && (C[r] = "EN"), C[r] === "CS" && (C[r - 1] === "EN" || C[r - 1] === "AN") && C[r + 1] === C[r - 1] && (C[r] = C[r - 1]);
            for (r = 0; r < g; ++r)
              if (C[r] === "EN") {
                for (let E = r - 1; E >= 0 && C[E] === "ET"; --E)
                  C[E] = "EN";
                for (let E = r + 1; E < g && C[E] === "ET"; ++E)
                  C[E] = "EN";
              }
            for (r = 0; r < g; ++r)
              c = C[r], (c === "WS" || c === "ES" || c === "ET" || c === "CS") && (C[r] = "ON");
            for (P = h, r = 0; r < g; ++r)
              c = C[r], c === "EN" ? C[r] = P === "L" ? "L" : "EN" : (c === "R" || c === "L") && (P = c);
            for (r = 0; r < g; ++r)
              if (C[r] === "ON") {
                const E = B(C, r + 1, "ON");
                let H = h;
                r > 0 && (H = C[r - 1]);
                let $ = y;
                E + 1 < g && ($ = C[E + 1]), H !== "L" && (H = "R"), $ !== "L" && ($ = "R"), H === $ && j(C, r, E, H), r = E - 1;
              }
            for (r = 0; r < g; ++r)
              C[r] === "ON" && (C[r] = I);
            for (r = 0; r < g; ++r)
              c = C[r], t(b[r]) ? c === "R" ? b[r] += 1 : (c === "AN" || c === "EN") && (b[r] += 2) : (c === "L" || c === "AN" || c === "EN") && (b[r] += 1);
            let d = -1, A = 99, N;
            for (r = 0, x = b.length; r < x; ++r)
              N = b[r], d < N && (d = N), A > N && e(N) && (A = N);
            for (N = d; N >= A; --N) {
              let E = -1;
              for (r = 0, x = b.length; r < x; ++r)
                b[r] < N ? E >= 0 && (M(w, E, r), E = -1) : E < 0 && (E = r);
              E >= 0 && M(w, E, b.length);
            }
            for (r = 0, x = w.length; r < x; ++r) {
              const E = w[r];
              (E === "<" || E === ">") && (w[r] = "");
            }
            return O(w.join(""), l);
          }
        },
        /* 61 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.getFontSubstitution = C;
          var n = ae(38), u = ae(3);
          const q = {
            style: "normal",
            weight: "normal"
          }, e = {
            style: "normal",
            weight: "bold"
          }, t = {
            style: "italic",
            weight: "normal"
          }, B = {
            style: "italic",
            weight: "bold"
          }, j = /* @__PURE__ */ new Map([["Times-Roman", {
            local: ["Times New Roman", "Times-Roman", "Times", "Liberation Serif", "Nimbus Roman", "Nimbus Roman L", "Tinos", "Thorndale", "TeX Gyre Termes", "FreeSerif", "DejaVu Serif", "Bitstream Vera Serif", "Ubuntu"],
            style: q,
            ultimate: "serif"
          }], ["Times-Bold", {
            alias: "Times-Roman",
            style: e,
            ultimate: "serif"
          }], ["Times-Italic", {
            alias: "Times-Roman",
            style: t,
            ultimate: "serif"
          }], ["Times-BoldItalic", {
            alias: "Times-Roman",
            style: B,
            ultimate: "serif"
          }], ["Helvetica", {
            local: ["Helvetica", "Helvetica Neue", "Arial", "Arial Nova", "Liberation Sans", "Arimo", "Nimbus Sans", "Nimbus Sans L", "A030", "TeX Gyre Heros", "FreeSans", "DejaVu Sans", "Albany", "Bitstream Vera Sans", "Arial Unicode MS", "Microsoft Sans Serif", "Apple Symbols", "Cantarell"],
            path: "LiberationSans-Regular.ttf",
            style: q,
            ultimate: "sans-serif"
          }], ["Helvetica-Bold", {
            alias: "Helvetica",
            path: "LiberationSans-Bold.ttf",
            style: e,
            ultimate: "sans-serif"
          }], ["Helvetica-Oblique", {
            alias: "Helvetica",
            path: "LiberationSans-Italic.ttf",
            style: t,
            ultimate: "sans-serif"
          }], ["Helvetica-BoldOblique", {
            alias: "Helvetica",
            path: "LiberationSans-BoldItalic.ttf",
            style: B,
            ultimate: "sans-serif"
          }], ["Courier", {
            local: ["Courier", "Courier New", "Liberation Mono", "Nimbus Mono", "Nimbus Mono L", "Cousine", "Cumberland", "TeX Gyre Cursor", "FreeMono"],
            style: q,
            ultimate: "monospace"
          }], ["Courier-Bold", {
            alias: "Courier",
            style: e,
            ultimate: "monospace"
          }], ["Courier-Oblique", {
            alias: "Courier",
            style: t,
            ultimate: "monospace"
          }], ["Courier-BoldOblique", {
            alias: "Courier",
            style: B,
            ultimate: "monospace"
          }], ["ArialBlack", {
            local: ["Arial Black"],
            style: {
              style: "normal",
              weight: "900"
            },
            fallback: "Helvetica-Bold"
          }], ["ArialBlack-Bold", {
            alias: "ArialBlack"
          }], ["ArialBlack-Italic", {
            alias: "ArialBlack",
            style: {
              style: "italic",
              weight: "900"
            },
            fallback: "Helvetica-BoldOblique"
          }], ["ArialBlack-BoldItalic", {
            alias: "ArialBlack-Italic"
          }], ["ArialNarrow", {
            local: ["Arial Narrow", "Liberation Sans Narrow", "Helvetica Condensed", "Nimbus Sans Narrow", "TeX Gyre Heros Cn"],
            style: q,
            fallback: "Helvetica"
          }], ["ArialNarrow-Bold", {
            alias: "ArialNarrow",
            style: e,
            fallback: "Helvetica-Bold"
          }], ["ArialNarrow-Italic", {
            alias: "ArialNarrow",
            style: t,
            fallback: "Helvetica-Oblique"
          }], ["ArialNarrow-BoldItalic", {
            alias: "ArialNarrow",
            style: B,
            fallback: "Helvetica-BoldOblique"
          }], ["Calibri", {
            local: ["Calibri", "Carlito"],
            style: q,
            fallback: "Helvetica"
          }], ["Calibri-Bold", {
            alias: "Calibri",
            style: e,
            fallback: "Helvetica-Bold"
          }], ["Calibri-Italic", {
            alias: "Calibri",
            style: t,
            fallback: "Helvetica-Oblique"
          }], ["Calibri-BoldItalic", {
            alias: "Calibri",
            style: B,
            fallback: "Helvetica-BoldOblique"
          }], ["Wingdings", {
            local: ["Wingdings", "URW Dingbats"],
            style: q
          }], ["Wingdings-Regular", {
            alias: "Wingdings"
          }], ["Wingdings-Bold", {
            alias: "Wingdings"
          }]]), M = /* @__PURE__ */ new Map([["Arial-Black", "ArialBlack"]]);
          function O(i) {
            switch (i) {
              case e:
                return "Bold";
              case t:
                return "Italic";
              case B:
                return "Bold Italic";
              default:
                if ((i == null ? void 0 : i.weight) === "bold")
                  return "Bold";
                if ((i == null ? void 0 : i.style) === "italic")
                  return "Italic";
            }
            return "";
          }
          function w({
            alias: i,
            local: o,
            path: k,
            fallback: s,
            style: l,
            ultimate: g
          }, v, r, x = !0, b = !0, I = "") {
            const h = {
              style: null,
              ultimate: null
            };
            if (o) {
              const y = I ? ` ${I}` : "";
              for (const P of o)
                v.push(`local(${P}${y})`);
            }
            if (i) {
              const y = j.get(i), P = I || O(l);
              Object.assign(h, w(y, v, r, x && !s, b && !k, P));
            }
            if (l && (h.style = l), g && (h.ultimate = g), x && s) {
              const y = j.get(s), {
                ultimate: P
              } = w(y, v, r, x, b && !k, I);
              h.ultimate || (h.ultimate = P);
            }
            return b && k && r && v.push(`url(${r}${k})`), h;
          }
          function C(i, o, k, s, l) {
            s = (0, n.normalizeFontName)(s);
            const g = s;
            let v = i.get(g);
            if (v)
              return v;
            let r = j.get(s);
            if (!r) {
              for (const [d, A] of M)
                if (s.startsWith(d)) {
                  s = `${A}${s.substring(d.length)}`, r = j.get(s);
                  break;
                }
            }
            let x = !1;
            r || (r = j.get(l), x = !0);
            const b = `${o.getDocId()}_s${o.createFontId()}`;
            if (!r) {
              if (!(0, u.validateFontName)(s))
                return i.set(g, null), null;
              const d = /bold/gi.test(s), A = /oblique|italic/gi.test(s), N = d && A && B || d && e || A && t || q;
              return v = {
                css: b,
                guessFallback: !0,
                loadedName: b,
                baseFontName: s,
                src: `local(${s})`,
                style: N
              }, i.set(g, v), v;
            }
            const I = [];
            x && (0, u.validateFontName)(s) && I.push(`local(${s})`);
            const {
              style: h,
              ultimate: y
            } = w(r, I, k), P = y === null, c = P ? "" : `,${y}`;
            return v = {
              css: `${b}${c}`,
              guessFallback: P,
              loadedName: b,
              baseFontName: s,
              src: I.join(","),
              style: h
            }, i.set(g, v), v;
          }
        },
        /* 62 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ImageResizer = void 0;
          var n = ae(2);
          const u = 2048, q = 65537, e = 128;
          class t {
            constructor(j, M) {
              this._imgData = j, this._isMask = M;
            }
            static needsToBeResized(j, M) {
              if (j <= this._goodSquareLength && M <= this._goodSquareLength)
                return !1;
              const {
                MAX_DIM: O
              } = this;
              if (j > O || M > O)
                return !0;
              const w = j * M;
              if (this._hasMaxArea)
                return w > this.MAX_AREA;
              if (w < this._goodSquareLength ** 2)
                return !1;
              if (this._areGoodDims(j, M))
                return this._goodSquareLength = Math.max(this._goodSquareLength, Math.floor(Math.sqrt(j * M))), !1;
              this._goodSquareLength = this._guessMax(this._goodSquareLength, O, e, 0);
              const C = this.MAX_AREA = this._goodSquareLength ** 2;
              return w > C;
            }
            static get MAX_DIM() {
              return (0, n.shadow)(this, "MAX_DIM", this._guessMax(u, q, 0, 1));
            }
            static get MAX_AREA() {
              return this._hasMaxArea = !0, (0, n.shadow)(this, "MAX_AREA", this._guessMax(t._goodSquareLength, this.MAX_DIM, e, 0) ** 2);
            }
            static set MAX_AREA(j) {
              j >= 0 && (this._hasMaxArea = !0, (0, n.shadow)(this, "MAX_AREA", j));
            }
            static setMaxArea(j) {
              this._hasMaxArea || (this.MAX_AREA = j >> 2);
            }
            static _areGoodDims(j, M) {
              try {
                const O = new OffscreenCanvas(j, M), w = O.getContext("2d");
                w.fillRect(0, 0, 1, 1);
                const C = w.getImageData(0, 0, 1, 1).data[3];
                return O.width = O.height = 1, C !== 0;
              } catch {
                return !1;
              }
            }
            static _guessMax(j, M, O, w) {
              for (; j + O + 1 < M; ) {
                const C = Math.floor((j + M) / 2), i = w || C;
                this._areGoodDims(C, i) ? j = C : M = C;
              }
              return j;
            }
            static async createImage(j, M = !1) {
              return new t(j, M)._createImage();
            }
            async _createImage() {
              const j = this._encodeBMP(), M = new Blob([j.buffer], {
                type: "image/bmp"
              }), O = createImageBitmap(M), {
                MAX_AREA: w,
                MAX_DIM: C
              } = t, {
                _imgData: i
              } = this, {
                width: o,
                height: k
              } = i, s = Math.max(o / C, k / C, Math.sqrt(o * k / w)), l = Math.max(s, 2), g = Math.round(10 * (s + 1.25)) / 10 / l, v = Math.floor(Math.log2(g)), r = new Array(v + 2).fill(2);
              r[0] = l, r.splice(-1, 1, g / (1 << v));
              let x = o, b = k, I = await O;
              for (const h of r) {
                const y = x, P = b;
                x = Math.floor(x / h) - 1, b = Math.floor(b / h) - 1;
                const c = new OffscreenCanvas(x, b);
                c.getContext("2d").drawImage(I, 0, 0, y, P, 0, 0, x, b), I = c.transferToImageBitmap();
              }
              return i.data = null, i.bitmap = I, i.width = x, i.height = b, i;
            }
            _encodeBMP() {
              const {
                width: j,
                height: M,
                kind: O
              } = this._imgData;
              let w = this._imgData.data, C, i = new Uint8Array(0), o = i, k = 0;
              switch (O) {
                case n.ImageKind.GRAYSCALE_1BPP: {
                  C = 1, i = new Uint8Array(this._isMask ? [255, 255, 255, 255, 0, 0, 0, 0] : [0, 0, 0, 0, 255, 255, 255, 255]);
                  const b = j + 7 >> 3, I = b + 3 & -4;
                  if (b !== I) {
                    const h = new Uint8Array(I * M);
                    let y = 0;
                    for (let P = 0, c = M * b; P < c; P += b, y += I)
                      h.set(w.subarray(P, P + b), y);
                    w = h;
                  }
                  break;
                }
                case n.ImageKind.RGB_24BPP: {
                  if (C = 24, j & 3) {
                    const b = 3 * j, I = b + 3 & -4, h = I - b, y = new Uint8Array(I * M);
                    let P = 0;
                    for (let c = 0, d = M * b; c < d; c += b) {
                      const A = w.subarray(c, c + b);
                      for (let N = 0; N < b; N += 3)
                        y[P++] = A[N + 2], y[P++] = A[N + 1], y[P++] = A[N];
                      P += h;
                    }
                    w = y;
                  } else
                    for (let b = 0, I = w.length; b < I; b += 3) {
                      const h = w[b];
                      w[b] = w[b + 2], w[b + 2] = h;
                    }
                  break;
                }
                case n.ImageKind.RGBA_32BPP:
                  C = 32, k = 3, o = new Uint8Array(68);
                  const x = new DataView(o.buffer);
                  n.FeatureTest.isLittleEndian ? (x.setUint32(0, 255, !0), x.setUint32(4, 65280, !0), x.setUint32(8, 16711680, !0), x.setUint32(12, 4278190080, !0)) : (x.setUint32(0, 4278190080, !0), x.setUint32(4, 16711680, !0), x.setUint32(8, 65280, !0), x.setUint32(12, 255, !0));
                  break;
                default:
                  throw new Error("invalid format");
              }
              let s = 0;
              const l = 40 + o.length, g = 14 + l + i.length + w.length, v = new Uint8Array(g), r = new DataView(v.buffer);
              return r.setUint16(s, 19778, !0), s += 2, r.setUint32(s, g, !0), s += 4, r.setUint32(s, 0, !0), s += 4, r.setUint32(s, 14 + l + i.length, !0), s += 4, r.setUint32(s, l, !0), s += 4, r.setInt32(s, j, !0), s += 4, r.setInt32(s, -M, !0), s += 4, r.setUint16(s, 1, !0), s += 2, r.setUint16(s, C, !0), s += 2, r.setUint32(s, k, !0), s += 4, r.setUint32(s, 0, !0), s += 4, r.setInt32(s, 0, !0), s += 4, r.setInt32(s, 0, !0), s += 4, r.setUint32(s, i.length / 4, !0), s += 4, r.setUint32(s, 0, !0), s += 4, v.set(o, s), s += o.length, v.set(i, s), s += i.length, v.set(w, s), v;
            }
          }
          F.ImageResizer = t, t._goodSquareLength = u;
        },
        /* 63 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.MurmurHash3_64 = void 0;
          var n = ae(2);
          const u = 3285377520, q = 4294901760, e = 65535;
          class t {
            constructor(j) {
              this.h1 = j ? j & 4294967295 : u, this.h2 = j ? j & 4294967295 : u;
            }
            update(j) {
              let M, O;
              if (typeof j == "string") {
                M = new Uint8Array(j.length * 2), O = 0;
                for (let b = 0, I = j.length; b < I; b++) {
                  const h = j.charCodeAt(b);
                  h <= 255 ? M[O++] = h : (M[O++] = h >>> 8, M[O++] = h & 255);
                }
              } else if ((0, n.isArrayBuffer)(j))
                M = j.slice(), O = M.byteLength;
              else
                throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
              const w = O >> 2, C = O - w * 4, i = new Uint32Array(M.buffer, 0, w);
              let o = 0, k = 0, s = this.h1, l = this.h2;
              const g = 3432918353, v = 461845907, r = g & e, x = v & e;
              for (let b = 0; b < w; b++)
                b & 1 ? (o = i[b], o = o * g & q | o * r & e, o = o << 15 | o >>> 17, o = o * v & q | o * x & e, s ^= o, s = s << 13 | s >>> 19, s = s * 5 + 3864292196) : (k = i[b], k = k * g & q | k * r & e, k = k << 15 | k >>> 17, k = k * v & q | k * x & e, l ^= k, l = l << 13 | l >>> 19, l = l * 5 + 3864292196);
              switch (o = 0, C) {
                case 3:
                  o ^= M[w * 4 + 2] << 16;
                case 2:
                  o ^= M[w * 4 + 1] << 8;
                case 1:
                  o ^= M[w * 4], o = o * g & q | o * r & e, o = o << 15 | o >>> 17, o = o * v & q | o * x & e, w & 1 ? s ^= o : l ^= o;
              }
              this.h1 = s, this.h2 = l;
            }
            hexdigest() {
              let j = this.h1, M = this.h2;
              return j ^= M >>> 1, j = j * 3981806797 & q | j * 36045 & e, M = M * 4283543511 & q | ((M << 16 | j >>> 16) * 2950163797 & q) >>> 16, j ^= M >>> 1, j = j * 444984403 & q | j * 60499 & e, M = M * 3301882366 & q | ((M << 16 | j >>> 16) * 3120437893 & q) >>> 16, j ^= M >>> 1, (j >>> 0).toString(16).padStart(8, "0") + (M >>> 0).toString(16).padStart(8, "0");
            }
          }
          F.MurmurHash3_64 = t;
        },
        /* 64 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.OperatorList = void 0;
          var n = ae(2);
          function u(M, O, w, C, i) {
            let o = M;
            for (let k = 0, s = O.length - 1; k < s; k++) {
              const l = O[k];
              o = o[l] || (o[l] = []);
            }
            o[O.at(-1)] = {
              checkFn: w,
              iterateFn: C,
              processFn: i
            };
          }
          const q = [];
          u(q, [n.OPS.save, n.OPS.transform, n.OPS.paintInlineImageXObject, n.OPS.restore], null, function(O, w) {
            const C = O.fnArray, i = O.iCurr - 3, o = (w - i) % 4;
            switch (o) {
              case 0:
                return C[w] === n.OPS.save;
              case 1:
                return C[w] === n.OPS.transform;
              case 2:
                return C[w] === n.OPS.paintInlineImageXObject;
              case 3:
                return C[w] === n.OPS.restore;
            }
            throw new Error(`iterateInlineImageGroup - invalid pos: ${o}`);
          }, function(O, w) {
            const s = O.fnArray, l = O.argsArray, g = O.iCurr, v = g - 3, r = g - 2, x = g - 1, b = Math.min(Math.floor((w - v) / 4), 200);
            if (b < 10)
              return w - (w - v) % 4;
            let I = 0;
            const h = [];
            let y = 0, P = 1, c = 1;
            for (let $ = 0; $ < b; $++) {
              const m = l[r + ($ << 2)], p = l[x + ($ << 2)][0];
              P + p.width > 1e3 && (I = Math.max(I, P), c += y + 2, P = 0, y = 0), h.push({
                transform: m,
                x: P,
                y: c,
                w: p.width,
                h: p.height
              }), P += p.width + 2, y = Math.max(y, p.height);
            }
            const d = Math.max(I, P) + 1, A = c + y + 1, N = new Uint8Array(d * A * 4), E = d << 2;
            for (let $ = 0; $ < b; $++) {
              const m = l[x + ($ << 2)][0].data, p = h[$].w << 2;
              let T = 0, L = h[$].x + h[$].y * d << 2;
              N.set(m.subarray(0, p), L - E);
              for (let _ = 0, G = h[$].h; _ < G; _++)
                N.set(m.subarray(T, T + p), L), T += p, L += E;
              for (N.set(m.subarray(T - p, T), L); L >= 0; )
                m[L - 4] = m[L], m[L - 3] = m[L + 1], m[L - 2] = m[L + 2], m[L - 1] = m[L + 3], m[L + p] = m[L + p - 4], m[L + p + 1] = m[L + p - 3], m[L + p + 2] = m[L + p - 2], m[L + p + 3] = m[L + p - 1], L -= E;
            }
            const H = {
              width: d,
              height: A
            };
            if (O.isOffscreenCanvasSupported) {
              const $ = new OffscreenCanvas(d, A);
              $.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(N.buffer), d, A), 0, 0), H.bitmap = $.transferToImageBitmap(), H.data = null;
            } else
              H.kind = n.ImageKind.RGBA_32BPP, H.data = N;
            return s.splice(v, b * 4, n.OPS.paintInlineImageXObjectGroup), l.splice(v, b * 4, [H, h]), v + 1;
          }), u(q, [n.OPS.save, n.OPS.transform, n.OPS.paintImageMaskXObject, n.OPS.restore], null, function(O, w) {
            const C = O.fnArray, i = O.iCurr - 3, o = (w - i) % 4;
            switch (o) {
              case 0:
                return C[w] === n.OPS.save;
              case 1:
                return C[w] === n.OPS.transform;
              case 2:
                return C[w] === n.OPS.paintImageMaskXObject;
              case 3:
                return C[w] === n.OPS.restore;
            }
            throw new Error(`iterateImageMaskGroup - invalid pos: ${o}`);
          }, function(O, w) {
            const k = O.fnArray, s = O.argsArray, l = O.iCurr, g = l - 3, v = l - 2, r = l - 1;
            let x = Math.floor((w - g) / 4);
            if (x < 10)
              return w - (w - g) % 4;
            let b = !1, I, h;
            const y = s[r][0], P = s[v][0], c = s[v][1], d = s[v][2], A = s[v][3];
            if (c === d) {
              b = !0, I = v + 4;
              let N = r + 4;
              for (let E = 1; E < x; E++, I += 4, N += 4)
                if (h = s[I], s[N][0] !== y || h[0] !== P || h[1] !== c || h[2] !== d || h[3] !== A) {
                  E < 10 ? b = !1 : x = E;
                  break;
                }
            }
            if (b) {
              x = Math.min(x, 1e3);
              const N = new Float32Array(x * 2);
              I = v;
              for (let E = 0; E < x; E++, I += 4)
                h = s[I], N[E << 1] = h[4], N[(E << 1) + 1] = h[5];
              k.splice(g, x * 4, n.OPS.paintImageMaskXObjectRepeat), s.splice(g, x * 4, [y, P, c, d, A, N]);
            } else {
              x = Math.min(x, 100);
              const N = [];
              for (let E = 0; E < x; E++) {
                h = s[v + (E << 2)];
                const H = s[r + (E << 2)][0];
                N.push({
                  data: H.data,
                  width: H.width,
                  height: H.height,
                  interpolate: H.interpolate,
                  count: H.count,
                  transform: h
                });
              }
              k.splice(g, x * 4, n.OPS.paintImageMaskXObjectGroup), s.splice(g, x * 4, [N]);
            }
            return g + 1;
          }), u(q, [n.OPS.save, n.OPS.transform, n.OPS.paintImageXObject, n.OPS.restore], function(M) {
            const O = M.argsArray, w = M.iCurr - 2;
            return O[w][1] === 0 && O[w][2] === 0;
          }, function(O, w) {
            const C = O.fnArray, i = O.argsArray, o = O.iCurr - 3, k = (w - o) % 4;
            switch (k) {
              case 0:
                return C[w] === n.OPS.save;
              case 1:
                if (C[w] !== n.OPS.transform)
                  return !1;
                const s = O.iCurr - 2, l = i[s][0], g = i[s][3];
                return !(i[w][0] !== l || i[w][1] !== 0 || i[w][2] !== 0 || i[w][3] !== g);
              case 2:
                if (C[w] !== n.OPS.paintImageXObject)
                  return !1;
                const v = O.iCurr - 1, r = i[v][0];
                return i[w][0] === r;
              case 3:
                return C[w] === n.OPS.restore;
            }
            throw new Error(`iterateImageGroup - invalid pos: ${k}`);
          }, function(M, O) {
            const i = M.fnArray, o = M.argsArray, k = M.iCurr, s = k - 3, l = k - 2, g = k - 1, v = o[g][0], r = o[l][0], x = o[l][3], b = Math.min(Math.floor((O - s) / 4), 1e3);
            if (b < 3)
              return O - (O - s) % 4;
            const I = new Float32Array(b * 2);
            let h = l;
            for (let P = 0; P < b; P++, h += 4) {
              const c = o[h];
              I[P << 1] = c[4], I[(P << 1) + 1] = c[5];
            }
            const y = [v, r, x, I];
            return i.splice(s, b * 4, n.OPS.paintImageXObjectRepeat), o.splice(s, b * 4, y), s + 1;
          }), u(q, [n.OPS.beginText, n.OPS.setFont, n.OPS.setTextMatrix, n.OPS.showText, n.OPS.endText], null, function(O, w) {
            const C = O.fnArray, i = O.argsArray, o = O.iCurr - 4, k = (w - o) % 5;
            switch (k) {
              case 0:
                return C[w] === n.OPS.beginText;
              case 1:
                return C[w] === n.OPS.setFont;
              case 2:
                return C[w] === n.OPS.setTextMatrix;
              case 3:
                if (C[w] !== n.OPS.showText)
                  return !1;
                const s = O.iCurr - 3, l = i[s][0], g = i[s][1];
                return !(i[w][0] !== l || i[w][1] !== g);
              case 4:
                return C[w] === n.OPS.endText;
            }
            throw new Error(`iterateShowTextGroup - invalid pos: ${k}`);
          }, function(M, O) {
            const i = M.fnArray, o = M.argsArray, k = M.iCurr, s = k - 4, l = k - 3, g = k - 2, v = k - 1, r = k, x = o[l][0], b = o[l][1];
            let I = Math.min(Math.floor((O - s) / 5), 1e3);
            if (I < 3)
              return O - (O - s) % 5;
            let h = s;
            s >= 4 && i[s - 4] === i[l] && i[s - 3] === i[g] && i[s - 2] === i[v] && i[s - 1] === i[r] && o[s - 4][0] === x && o[s - 4][1] === b && (I++, h -= 5);
            let y = h + 4;
            for (let P = 1; P < I; P++)
              i.splice(y, 3), o.splice(y, 3), y += 2;
            return y + 1;
          });
          class e {
            constructor(O) {
              this.queue = O;
            }
            _optimize() {
            }
            push(O, w) {
              this.queue.fnArray.push(O), this.queue.argsArray.push(w), this._optimize();
            }
            flush() {
            }
            reset() {
            }
          }
          class t extends e {
            constructor(O) {
              super(O), this.state = null, this.context = {
                iCurr: 0,
                fnArray: O.fnArray,
                argsArray: O.argsArray,
                isOffscreenCanvasSupported: !1
              }, this.match = null, this.lastProcessed = 0;
            }
            set isOffscreenCanvasSupported(O) {
              this.context.isOffscreenCanvasSupported = O;
            }
            _optimize() {
              const O = this.queue.fnArray;
              let w = this.lastProcessed, C = O.length, i = this.state, o = this.match;
              if (!i && !o && w + 1 === C && !q[O[w]]) {
                this.lastProcessed = C;
                return;
              }
              const k = this.context;
              for (; w < C; ) {
                if (o) {
                  if ((0, o.iterateFn)(k, w)) {
                    w++;
                    continue;
                  }
                  if (w = (0, o.processFn)(k, w + 1), C = O.length, o = null, i = null, w >= C)
                    break;
                }
                if (i = (i || q)[O[w]], !i || Array.isArray(i)) {
                  w++;
                  continue;
                }
                if (k.iCurr = w, w++, i.checkFn && !(0, i.checkFn)(k)) {
                  i = null;
                  continue;
                }
                o = i, i = null;
              }
              this.state = i, this.match = o, this.lastProcessed = w;
            }
            flush() {
              for (; this.match; ) {
                const O = this.queue.fnArray.length;
                this.lastProcessed = (0, this.match.processFn)(this.context, O), this.match = null, this.state = null, this._optimize();
              }
            }
            reset() {
              this.state = null, this.match = null, this.lastProcessed = 0;
            }
          }
          const j = class j {
            constructor(O = 0, w) {
              this._streamSink = w, this.fnArray = [], this.argsArray = [], w && !(O & n.RenderingIntentFlag.OPLIST) ? this.optimizer = new t(this) : this.optimizer = new e(this), this.dependencies = /* @__PURE__ */ new Set(), this._totalLength = 0, this.weight = 0, this._resolved = w ? null : Promise.resolve();
            }
            set isOffscreenCanvasSupported(O) {
              this.optimizer.isOffscreenCanvasSupported = O;
            }
            get length() {
              return this.argsArray.length;
            }
            get ready() {
              return this._resolved || this._streamSink.ready;
            }
            get totalLength() {
              return this._totalLength + this.length;
            }
            addOp(O, w) {
              this.optimizer.push(O, w), this.weight++, this._streamSink && (this.weight >= j.CHUNK_SIZE ? this.flush() : this.weight >= j.CHUNK_SIZE_ABOUT && (O === n.OPS.restore || O === n.OPS.endText) && this.flush());
            }
            addImageOps(O, w, C) {
              C !== void 0 && this.addOp(n.OPS.beginMarkedContentProps, ["OC", C]), this.addOp(O, w), C !== void 0 && this.addOp(n.OPS.endMarkedContent, []);
            }
            addDependency(O) {
              this.dependencies.has(O) || (this.dependencies.add(O), this.addOp(n.OPS.dependency, [O]));
            }
            addDependencies(O) {
              for (const w of O)
                this.addDependency(w);
            }
            addOpList(O) {
              if (!(O instanceof j)) {
                (0, n.warn)('addOpList - ignoring invalid "opList" parameter.');
                return;
              }
              for (const w of O.dependencies)
                this.dependencies.add(w);
              for (let w = 0, C = O.length; w < C; w++)
                this.addOp(O.fnArray[w], O.argsArray[w]);
            }
            getIR() {
              return {
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                length: this.length
              };
            }
            get _transfers() {
              var o;
              const O = [], {
                fnArray: w,
                argsArray: C,
                length: i
              } = this;
              for (let k = 0; k < i; k++)
                switch (w[k]) {
                  case n.OPS.paintInlineImageXObject:
                  case n.OPS.paintInlineImageXObjectGroup:
                  case n.OPS.paintImageMaskXObject:
                    const s = C[k][0];
                    !s.cached && ((o = s.data) == null ? void 0 : o.buffer) instanceof ArrayBuffer && O.push(s.data.buffer);
                    break;
                }
              return O;
            }
            flush(O = !1, w = null) {
              this.optimizer.flush();
              const C = this.length;
              this._totalLength += C, this._streamSink.enqueue({
                fnArray: this.fnArray,
                argsArray: this.argsArray,
                lastChunk: O,
                separateAnnots: w,
                length: C
              }, 1, this._transfers), this.dependencies.clear(), this.fnArray.length = 0, this.argsArray.length = 0, this.weight = 0, this.optimizer.reset();
            }
          };
          Dt(j, "CHUNK_SIZE", 1e3), Dt(j, "CHUNK_SIZE_ABOUT", j.CHUNK_SIZE - 5);
          let B = j;
          F.OperatorList = B;
        },
        /* 65 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PDFImage = void 0;
          var n = ae(2), u = ae(28), q = ae(5), e = ae(12), t = ae(18), B = ae(62), j = ae(26), M = ae(30), O = ae(4);
          function w(o, k, s, l) {
            return o = k + o * s, o < 0 ? o = 0 : o > l && (o = l), o;
          }
          function C(o, k, s, l, g, v) {
            const r = g * v;
            let x;
            k <= 8 ? x = new Uint8Array(r) : k <= 16 ? x = new Uint16Array(r) : x = new Uint32Array(r);
            const b = s / g, I = l / v;
            let h, y, P, c = 0, d;
            const A = new Uint16Array(g), N = s;
            for (h = 0; h < g; h++)
              A[h] = Math.floor(h * b);
            for (h = 0; h < v; h++)
              for (P = Math.floor(h * I) * N, y = 0; y < g; y++)
                d = P + A[y], x[c++] = o[d];
            return x;
          }
          class i {
            constructor({
              xref: k,
              res: s,
              image: l,
              isInline: g = !1,
              smask: v = null,
              mask: r = null,
              isMask: x = !1,
              pdfFunctionFactory: b,
              localColorSpaceCache: I
            }) {
              var N;
              this.image = l;
              const h = l.dict, y = h.get("F", "Filter");
              let P;
              if (y instanceof O.Name)
                P = y.name;
              else if (Array.isArray(y)) {
                const E = k.fetchIfRef(y[0]);
                E instanceof O.Name && (P = E.name);
              }
              switch (P) {
                case "JPXDecode":
                  const E = new M.JpxImage();
                  E.parseImageProperties(l.stream), l.stream.reset(), l.width = E.width, l.height = E.height, l.bitsPerComponent = E.bitsPerComponent, l.numComps = E.componentsCount;
                  break;
                case "JBIG2Decode":
                  l.bitsPerComponent = 1, l.numComps = 1;
                  break;
              }
              let c = h.get("W", "Width"), d = h.get("H", "Height");
              if (Number.isInteger(l.width) && l.width > 0 && Number.isInteger(l.height) && l.height > 0 && (l.width !== c || l.height !== d) && ((0, n.warn)("PDFImage - using the Width/Height of the image data, rather than the image dictionary."), c = l.width, d = l.height), c < 1 || d < 1)
                throw new n.FormatError(`Invalid image width: ${c} or height: ${d}`);
              this.width = c, this.height = d, this.interpolate = h.get("I", "Interpolate"), this.imageMask = h.get("IM", "ImageMask") || !1, this.matte = h.get("Matte") || !1;
              let A = l.bitsPerComponent;
              if (!A && (A = h.get("BPC", "BitsPerComponent"), !A))
                if (this.imageMask)
                  A = 1;
                else
                  throw new n.FormatError(`Bits per component missing in image: ${this.imageMask}`);
              if (this.bpc = A, !this.imageMask) {
                let E = h.getRaw("CS") || h.getRaw("ColorSpace");
                if (!E)
                  switch ((0, n.info)("JPX images (which do not require color spaces)"), l.numComps) {
                    case 1:
                      E = O.Name.get("DeviceGray");
                      break;
                    case 3:
                      E = O.Name.get("DeviceRGB");
                      break;
                    case 4:
                      E = O.Name.get("DeviceCMYK");
                      break;
                    default:
                      throw new Error(`JPX images with ${l.numComps} color components not supported.`);
                  }
                this.colorSpace = e.ColorSpace.parse({
                  cs: E,
                  xref: k,
                  resources: g ? s : null,
                  pdfFunctionFactory: b,
                  localColorSpaceCache: I
                }), this.numComps = this.colorSpace.numComps;
              }
              if (this.decode = h.getArray("D", "Decode"), this.needsDecode = !1, this.decode && (this.colorSpace && !this.colorSpace.isDefaultDecode(this.decode, A) || x && !e.ColorSpace.isDefaultDecode(this.decode, 1))) {
                this.needsDecode = !0;
                const E = (1 << A) - 1;
                this.decodeCoefficients = [], this.decodeAddends = [];
                const H = ((N = this.colorSpace) == null ? void 0 : N.name) === "Indexed";
                for (let $ = 0, m = 0; $ < this.decode.length; $ += 2, ++m) {
                  const p = this.decode[$], T = this.decode[$ + 1];
                  this.decodeCoefficients[m] = H ? (T - p) / E : T - p, this.decodeAddends[m] = H ? p : E * p;
                }
              }
              v ? this.smask = new i({
                xref: k,
                res: s,
                image: v,
                isInline: g,
                pdfFunctionFactory: b,
                localColorSpaceCache: I
              }) : r && (r instanceof q.BaseStream ? r.dict.get("IM", "ImageMask") ? this.mask = new i({
                xref: k,
                res: s,
                image: r,
                isInline: g,
                isMask: !0,
                pdfFunctionFactory: b,
                localColorSpaceCache: I
              }) : (0, n.warn)("Ignoring /Mask in image without /ImageMask.") : this.mask = r);
            }
            static async buildImage({
              xref: k,
              res: s,
              image: l,
              isInline: g = !1,
              pdfFunctionFactory: v,
              localColorSpaceCache: r
            }) {
              const x = l;
              let b = null, I = null;
              const h = l.dict.get("SMask"), y = l.dict.get("Mask");
              return h ? h instanceof q.BaseStream ? b = h : (0, n.warn)("Unsupported /SMask format.") : y && (y instanceof q.BaseStream || Array.isArray(y) ? I = y : (0, n.warn)("Unsupported /Mask format.")), new i({
                xref: k,
                res: s,
                image: x,
                isInline: g,
                smask: b,
                mask: I,
                pdfFunctionFactory: v,
                localColorSpaceCache: r
              });
            }
            static createRawMask({
              imgArray: k,
              width: s,
              height: l,
              imageIsFromDecodeStream: g,
              inverseDecode: v,
              interpolate: r
            }) {
              const x = (s + 7 >> 3) * l, b = k.byteLength, I = x === b;
              let h, y;
              if (g && (!v || I) ? h = k : v ? (h = new Uint8Array(x), h.set(k), h.fill(255, b)) : h = new Uint8Array(k), v)
                for (y = 0; y < b; y++)
                  h[y] ^= 255;
              return {
                data: h,
                width: s,
                height: l,
                interpolate: r
              };
            }
            static async createMask({
              imgArray: k,
              width: s,
              height: l,
              imageIsFromDecodeStream: g,
              inverseDecode: v,
              interpolate: r,
              isOffscreenCanvasSupported: x = !1
            }) {
              const b = s === 1 && l === 1 && v === (k.length === 0 || !!(k[0] & 128));
              if (b)
                return {
                  isSingleOpaquePixel: b
                };
              if (x) {
                if (B.ImageResizer.needsToBeResized(s, l)) {
                  const c = new Uint8ClampedArray(s * l * 4);
                  return (0, u.convertBlackAndWhiteToRGBA)({
                    src: k,
                    dest: c,
                    width: s,
                    height: l,
                    nonBlackColor: 0,
                    inverseDecode: v
                  }), B.ImageResizer.createImage({
                    kind: n.ImageKind.RGBA_32BPP,
                    data: c,
                    width: s,
                    height: l,
                    interpolate: r
                  });
                }
                const I = new OffscreenCanvas(s, l), h = I.getContext("2d"), y = h.createImageData(s, l);
                (0, u.convertBlackAndWhiteToRGBA)({
                  src: k,
                  dest: y.data,
                  width: s,
                  height: l,
                  nonBlackColor: 0,
                  inverseDecode: v
                }), h.putImageData(y, 0, 0);
                const P = I.transferToImageBitmap();
                return {
                  data: null,
                  width: s,
                  height: l,
                  interpolate: r,
                  bitmap: P
                };
              }
              return this.createRawMask({
                imgArray: k,
                width: s,
                height: l,
                inverseDecode: v,
                imageIsFromDecodeStream: g,
                interpolate: r
              });
            }
            get drawWidth() {
              var k, s;
              return Math.max(this.width, ((k = this.smask) == null ? void 0 : k.width) || 0, ((s = this.mask) == null ? void 0 : s.width) || 0);
            }
            get drawHeight() {
              var k, s;
              return Math.max(this.height, ((k = this.smask) == null ? void 0 : k.height) || 0, ((s = this.mask) == null ? void 0 : s.height) || 0);
            }
            decodeBuffer(k) {
              const s = this.bpc, l = this.numComps, g = this.decodeAddends, v = this.decodeCoefficients, r = (1 << s) - 1;
              let x, b;
              if (s === 1) {
                for (x = 0, b = k.length; x < b; x++)
                  k[x] = +!k[x];
                return;
              }
              let I = 0;
              for (x = 0, b = this.width * this.height; x < b; x++)
                for (let h = 0; h < l; h++)
                  k[I] = w(k[I], g[h], v[h], r), I++;
            }
            getComponents(k) {
              const s = this.bpc;
              if (s === 8)
                return k;
              const l = this.width, g = this.height, v = this.numComps, r = l * g * v;
              let x = 0, b;
              s <= 8 ? b = new Uint8Array(r) : s <= 16 ? b = new Uint16Array(r) : b = new Uint32Array(r);
              const I = l * v, h = (1 << s) - 1;
              let y = 0, P, c;
              if (s === 1) {
                let d, A, N;
                for (let E = 0; E < g; E++) {
                  for (A = y + (I & -8), N = y + I; y < A; )
                    c = k[x++], b[y] = c >> 7 & 1, b[y + 1] = c >> 6 & 1, b[y + 2] = c >> 5 & 1, b[y + 3] = c >> 4 & 1, b[y + 4] = c >> 3 & 1, b[y + 5] = c >> 2 & 1, b[y + 6] = c >> 1 & 1, b[y + 7] = c & 1, y += 8;
                  if (y < N)
                    for (c = k[x++], d = 128; y < N; )
                      b[y++] = +!!(c & d), d >>= 1;
                }
              } else {
                let d = 0;
                for (c = 0, y = 0, P = r; y < P; ++y) {
                  for (y % I === 0 && (c = 0, d = 0); d < s; )
                    c = c << 8 | k[x++], d += 8;
                  const A = d - s;
                  let N = c >> A;
                  N < 0 ? N = 0 : N > h && (N = h), b[y] = N, c &= (1 << A) - 1, d = A;
                }
              }
              return b;
            }
            fillOpacity(k, s, l, g, v) {
              const r = this.smask, x = this.mask;
              let b, I, h, y, P, c;
              if (r)
                I = r.width, h = r.height, b = new Uint8ClampedArray(I * h), r.fillGrayBuffer(b), (I !== s || h !== l) && (b = C(b, r.bpc, I, h, s, l));
              else if (x)
                if (x instanceof i) {
                  for (I = x.width, h = x.height, b = new Uint8ClampedArray(I * h), x.numComps = 1, x.fillGrayBuffer(b), y = 0, P = I * h; y < P; ++y)
                    b[y] = 255 - b[y];
                  (I !== s || h !== l) && (b = C(b, x.bpc, I, h, s, l));
                } else if (Array.isArray(x)) {
                  b = new Uint8ClampedArray(s * l);
                  const d = this.numComps;
                  for (y = 0, P = s * l; y < P; ++y) {
                    let A = 0;
                    const N = y * d;
                    for (c = 0; c < d; ++c) {
                      const E = v[N + c], H = c * 2;
                      if (E < x[H] || E > x[H + 1]) {
                        A = 255;
                        break;
                      }
                    }
                    b[y] = A;
                  }
                } else
                  throw new n.FormatError("Unknown mask format.");
              if (b)
                for (y = 0, c = 3, P = s * g; y < P; ++y, c += 4)
                  k[c] = b[y];
              else
                for (y = 0, c = 3, P = s * g; y < P; ++y, c += 4)
                  k[c] = 255;
            }
            undoPreblend(k, s, l) {
              var h;
              const g = (h = this.smask) == null ? void 0 : h.matte;
              if (!g)
                return;
              const v = this.colorSpace.getRgb(g, 0), r = v[0], x = v[1], b = v[2], I = s * l * 4;
              for (let y = 0; y < I; y += 4) {
                const P = k[y + 3];
                if (P === 0) {
                  k[y] = 255, k[y + 1] = 255, k[y + 2] = 255;
                  continue;
                }
                const c = 255 / P;
                k[y] = (k[y] - r) * c + r, k[y + 1] = (k[y + 1] - x) * c + x, k[y + 2] = (k[y + 2] - b) * c + b;
              }
            }
            async createImageData(k = !1, s = !1) {
              const l = this.drawWidth, g = this.drawHeight, v = {
                width: l,
                height: g,
                interpolate: this.interpolate,
                kind: 0,
                data: null
              }, r = this.numComps, x = this.width, b = this.height, I = this.bpc, h = x * r * I + 7 >> 3, y = s && B.ImageResizer.needsToBeResized(l, g);
              if (!k) {
                let p;
                if (this.colorSpace.name === "DeviceGray" && I === 1 ? p = n.ImageKind.GRAYSCALE_1BPP : this.colorSpace.name === "DeviceRGB" && I === 8 && !this.needsDecode && (p = n.ImageKind.RGB_24BPP), p && !this.smask && !this.mask && l === x && g === b) {
                  const T = this.getImageBytes(b * h, {});
                  if (s)
                    return y ? B.ImageResizer.createImage({
                      data: T,
                      kind: p,
                      width: l,
                      height: g,
                      interpolate: this.interpolate
                    }, this.needsDecode) : this.createBitmap(p, x, b, T);
                  if (v.kind = p, v.data = T, this.needsDecode) {
                    (0, n.assert)(p === n.ImageKind.GRAYSCALE_1BPP, "PDFImage.createImageData: The image must be grayscale.");
                    const L = v.data;
                    for (let _ = 0, G = L.length; _ < G; _++)
                      L[_] ^= 255;
                  }
                  return v;
                }
                if (this.image instanceof j.JpegStream && !this.smask && !this.mask && !this.needsDecode) {
                  let T = b * h;
                  if (s && !y) {
                    let L = !1;
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        T *= 4, L = !0;
                        break;
                      case "DeviceRGB":
                        T = T / 3 * 4, L = !0;
                        break;
                      case "DeviceCMYK":
                        L = !0;
                        break;
                    }
                    if (L) {
                      const _ = this.getImageBytes(T, {
                        drawWidth: l,
                        drawHeight: g,
                        forceRGBA: !0
                      });
                      return this.createBitmap(n.ImageKind.RGBA_32BPP, l, g, _);
                    }
                  } else
                    switch (this.colorSpace.name) {
                      case "DeviceGray":
                        T *= 3;
                      case "DeviceRGB":
                      case "DeviceCMYK":
                        return v.kind = n.ImageKind.RGB_24BPP, v.data = this.getImageBytes(T, {
                          drawWidth: l,
                          drawHeight: g,
                          forceRGB: !0
                        }), y ? B.ImageResizer.createImage(v) : v;
                    }
                }
              }
              const P = this.getImageBytes(b * h, {
                internal: !0
              }), c = 0 | P.length / h * g / b, d = this.getComponents(P);
              let A, N, E, H, $, m;
              if (s && !y && (E = new OffscreenCanvas(l, g), H = E.getContext("2d"), $ = H.createImageData(l, g), m = $.data), v.kind = n.ImageKind.RGBA_32BPP, !k && !this.smask && !this.mask ? (!s || y ? (v.kind = n.ImageKind.RGB_24BPP, m = new Uint8ClampedArray(l * g * 3), A = 0) : (new Uint32Array(m.buffer).fill(n.FeatureTest.isLittleEndian ? 4278190080 : 255), A = 1), N = !1) : ((!s || y) && (m = new Uint8ClampedArray(l * g * 4)), A = 1, N = !0, this.fillOpacity(m, l, g, c, d)), this.needsDecode && this.decodeBuffer(d), this.colorSpace.fillRgb(m, x, b, l, g, c, I, d, A), N && this.undoPreblend(m, l, c), s && !y) {
                H.putImageData($, 0, 0);
                const p = E.transferToImageBitmap();
                return {
                  data: null,
                  width: l,
                  height: g,
                  bitmap: p,
                  interpolate: this.interpolate
                };
              }
              return v.data = m, y ? B.ImageResizer.createImage(v) : v;
            }
            fillGrayBuffer(k) {
              const s = this.numComps;
              if (s !== 1)
                throw new n.FormatError(`Reading gray scale from a color image: ${s}`);
              const l = this.width, g = this.height, v = this.bpc, r = l * s * v + 7 >> 3, x = this.getImageBytes(g * r, {
                internal: !0
              }), b = this.getComponents(x);
              let I, h;
              if (v === 1) {
                if (h = l * g, this.needsDecode)
                  for (I = 0; I < h; ++I)
                    k[I] = b[I] - 1 & 255;
                else
                  for (I = 0; I < h; ++I)
                    k[I] = -b[I] & 255;
                return;
              }
              this.needsDecode && this.decodeBuffer(b), h = l * g;
              const y = 255 / ((1 << v) - 1);
              for (I = 0; I < h; ++I)
                k[I] = y * b[I];
            }
            createBitmap(k, s, l, g) {
              const v = new OffscreenCanvas(s, l), r = v.getContext("2d");
              let x;
              k === n.ImageKind.RGBA_32BPP ? x = new ImageData(g, s, l) : (x = r.createImageData(s, l), (0, u.convertToRGBA)({
                kind: k,
                src: g,
                dest: new Uint32Array(x.data.buffer),
                width: s,
                height: l,
                inverseDecode: this.needsDecode
              })), r.putImageData(x, 0, 0);
              const b = v.transferToImageBitmap();
              return {
                data: null,
                width: s,
                height: l,
                bitmap: b,
                interpolate: this.interpolate
              };
            }
            getImageBytes(k, {
              drawWidth: s,
              drawHeight: l,
              forceRGBA: g = !1,
              forceRGB: v = !1,
              internal: r = !1
            }) {
              this.image.reset(), this.image.drawWidth = s || this.width, this.image.drawHeight = l || this.height, this.image.forceRGBA = !!g, this.image.forceRGB = !!v;
              const x = this.image.getBytes(k);
              return r || this.image instanceof t.DecodeStream ? x : ((0, n.assert)(x instanceof Uint8Array, 'PDFImage.getImageBytes: Unsupported "imageBytes" type.'), new Uint8Array(x));
            }
          }
          F.PDFImage = i;
        },
        /* 66 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.incrementalUpdate = v, F.writeDict = M, F.writeObject = j;
          var n = ae(2), u = ae(4), q = ae(3), e = ae(67), t = ae(5), B = ae(68);
          async function j(r, x, b, I) {
            b.push(`${r.num} ${r.gen} obj
`), x instanceof u.Dict ? await M(x, b, I) : x instanceof t.BaseStream && await O(x, b, I), b.push(`
endobj
`);
          }
          async function M(r, x, b) {
            x.push("<<");
            for (const I of r.getKeys())
              x.push(` /${(0, q.escapePDFName)(I)} `), await C(r.getRaw(I), x, b);
            x.push(">>");
          }
          async function O(r, x, b) {
            let I = r.getString();
            if (b !== null && (I = b.encryptString(I)), typeof CompressionStream > "u") {
              r.dict.set("Length", I.length), await M(r.dict, x, b), x.push(` stream
`, I, `
endstream`);
              return;
            }
            const h = await r.dict.getAsync("Filter"), y = u.Name.get("FlateDecode"), P = 256;
            if (I.length >= P || Array.isArray(h) && h.includes(y) || h instanceof u.Name && h.name === y.name)
              try {
                const c = (0, n.stringToBytes)(I), d = new CompressionStream("deflate"), A = d.writable.getWriter();
                A.write(c), A.close();
                const N = await new Response(d.readable).arrayBuffer();
                I = (0, n.bytesToString)(new Uint8Array(N)), Array.isArray(h) ? h.includes(y) || h.push(y) : h ? (!(h instanceof u.Name) || h.name !== y.name) && r.dict.set("Filter", [h, y]) : r.dict.set("Filter", y);
              } catch (c) {
                (0, n.info)(`writeStream - cannot compress data: "${c}".`);
              }
            r.dict.set("Length", I.length), await M(r.dict, x, b), x.push(` stream
`, I, `
endstream`);
          }
          async function w(r, x, b) {
            x.push("[");
            let I = !0;
            for (const h of r)
              I ? I = !1 : x.push(" "), await C(h, x, b);
            x.push("]");
          }
          async function C(r, x, b) {
            r instanceof u.Name ? x.push(`/${(0, q.escapePDFName)(r.name)}`) : r instanceof u.Ref ? x.push(`${r.num} ${r.gen} R`) : Array.isArray(r) ? await w(r, x, b) : typeof r == "string" ? (b !== null && (r = b.encryptString(r)), x.push(`(${(0, q.escapeString)(r)})`)) : typeof r == "number" ? x.push((0, q.numberToString)(r)) : typeof r == "boolean" ? x.push(r.toString()) : r instanceof u.Dict ? await M(r, x, b) : r instanceof t.BaseStream ? await O(r, x, b) : r === null ? x.push("null") : (0, n.warn)(`Unhandled value in writer: ${typeof r}, please file a bug.`);
          }
          function i(r, x, b, I) {
            for (let h = x + b - 1; h > b - 1; h--)
              I[h] = r & 255, r >>= 8;
            return b + x;
          }
          function o(r, x, b) {
            for (let I = 0, h = r.length; I < h; I++)
              b[x + I] = r.charCodeAt(I) & 255;
          }
          function k(r, x) {
            const b = Math.floor(Date.now() / 1e3), I = x.filename || "", h = [b.toString(), I, r.toString()];
            let y = h.reduce((d, A) => d + A.length, 0);
            for (const d of Object.values(x.info))
              h.push(d), y += d.length;
            const P = new Uint8Array(y);
            let c = 0;
            for (const d of h)
              o(d, c, P), c += d.length;
            return (0, n.bytesToString)((0, B.calculateMD5)(P));
          }
          function s(r, x) {
            const b = new e.SimpleXMLParser({
              hasAttributes: !0
            }).parseFromString(r);
            for (const {
              xfa: h
            } of x) {
              if (!h)
                continue;
              const {
                path: y,
                value: P
              } = h;
              if (!y)
                continue;
              const c = (0, q.parseXFAPath)(y);
              let d = b.documentElement.searchNode(c, 0);
              !d && c.length > 1 && (d = b.documentElement.searchNode([c.at(-1)], 0)), d ? Array.isArray(P) ? d.childNodes = P.map((A) => new e.SimpleDOMNode("value", A)) : d.childNodes = [new e.SimpleDOMNode("#text", P)] : (0, n.warn)(`Node not found for path: ${y}`);
            }
            const I = [];
            return b.documentElement.dump(I), I.join("");
          }
          async function l({
            xref: r,
            acroForm: x,
            acroFormRef: b,
            hasXfa: I,
            hasXfaDatasetsEntry: h,
            xfaDatasetsRef: y,
            needAppearances: P,
            newRefs: c
          }) {
            if (I && !h && !y && (0, n.warn)("XFA - Cannot save it"), !P && (!I || !y))
              return;
            const d = new u.Dict(r);
            for (const H of x.getKeys())
              d.set(H, x.getRaw(H));
            if (I && !h) {
              const H = x.get("XFA").slice();
              H.splice(2, 0, "datasets"), H.splice(3, 0, y), d.set("XFA", H);
            }
            P && d.set("NeedAppearances", !0);
            const A = r.encrypt;
            let N = null;
            A && (N = A.createCipherTransform(b.num, b.gen));
            const E = [];
            await j(b, d, E, N), c.push({
              ref: b,
              data: E.join("")
            });
          }
          function g({
            xfaData: r,
            xfaDatasetsRef: x,
            newRefs: b,
            xref: I
          }) {
            if (r === null) {
              const P = I.fetchIfRef(x);
              r = s(P.getString(), b);
            }
            const h = I.encrypt;
            h && (r = h.createCipherTransform(x.num, x.gen).encryptString(r));
            const y = `${x.num} ${x.gen} obj
<< /Type /EmbeddedFile /Length ${r.length}>>
stream
` + r + `
endstream
endobj
`;
            b.push({
              ref: x,
              data: y
            });
          }
          async function v({
            originalData: r,
            xrefInfo: x,
            newRefs: b,
            xref: I = null,
            hasXfa: h = !1,
            xfaDatasetsRef: y = null,
            hasXfaDatasetsEntry: P = !1,
            needAppearances: c,
            acroFormRef: d = null,
            acroForm: A = null,
            xfaData: N = null
          }) {
            await l({
              xref: I,
              acroForm: A,
              acroFormRef: d,
              hasXfa: h,
              hasXfaDatasetsEntry: P,
              xfaDatasetsRef: y,
              needAppearances: c,
              newRefs: b
            }), h && g({
              xfaData: N,
              xfaDatasetsRef: y,
              newRefs: b,
              xref: I
            });
            const E = new u.Dict(null), H = x.newRef;
            let $, m;
            const p = r.at(-1);
            p === 10 || p === 13 ? ($ = [], m = r.length) : ($ = [`
`], m = r.length + 1), E.set("Size", H.num + 1), E.set("Prev", x.startXRef), E.set("Type", u.Name.get("XRef")), x.rootRef !== null && E.set("Root", x.rootRef), x.infoRef !== null && E.set("Info", x.infoRef), x.encryptRef !== null && E.set("Encrypt", x.encryptRef), b.push({
              ref: H,
              data: ""
            }), b = b.sort((f, D) => f.ref.num - D.ref.num);
            const T = [[0, 1, 65535]], L = [0, 1];
            let _ = 0;
            for (const {
              ref: f,
              data: D
            } of b)
              _ = Math.max(_, m), T.push([1, m, Math.min(f.gen, 65535)]), m += D.length, L.push(f.num, 1), $.push(D);
            if (E.set("Index", L), Array.isArray(x.fileIds) && x.fileIds.length > 0) {
              const f = k(m, x);
              E.set("ID", [x.fileIds[0], f]);
            }
            const J = [1, Math.ceil(Math.log2(_) / 8), 2], V = (J[0] + J[1] + J[2]) * T.length;
            E.set("W", J), E.set("Length", V), $.push(`${H.num} ${H.gen} obj
`), await M(E, $, null), $.push(` stream
`);
            const U = $.reduce((f, D) => f + D.length, 0), Q = `
endstream
endobj
startxref
${m}
%%EOF
`, X = new Uint8Array(r.length + U + V + Q.length);
            X.set(r);
            let R = r.length;
            for (const f of $)
              o(f, R, X), R += f.length;
            for (const [f, D, z] of T)
              R = i(f, J[0], R, X), R = i(D, J[1], R, X), R = i(z, J[2], R, X);
            return o(Q, R, X), X;
          }
        },
        /* 67 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XMLParserErrorCode = F.XMLParserBase = F.SimpleXMLParser = F.SimpleDOMNode = void 0;
          var n = ae(3);
          const u = {
            NoError: 0,
            EndOfDocument: -1,
            UnterminatedCdat: -2,
            UnterminatedXmlDeclaration: -3,
            UnterminatedDoctypeDeclaration: -4,
            UnterminatedComment: -5,
            MalformedElement: -6,
            OutOfMemory: -7,
            UnterminatedAttributeValue: -8,
            UnterminatedElement: -9,
            ElementNeverBegun: -10
          };
          F.XMLParserErrorCode = u;
          function q(M, O) {
            const w = M[O];
            return w === " " || w === `
` || w === "\r" || w === "	";
          }
          function e(M) {
            for (let O = 0, w = M.length; O < w; O++)
              if (!q(M, O))
                return !1;
            return !0;
          }
          class t {
            _resolveEntities(O) {
              return O.replaceAll(/&([^;]+);/g, (w, C) => {
                if (C.substring(0, 2) === "#x")
                  return String.fromCodePoint(parseInt(C.substring(2), 16));
                if (C.substring(0, 1) === "#")
                  return String.fromCodePoint(parseInt(C.substring(1), 10));
                switch (C) {
                  case "lt":
                    return "<";
                  case "gt":
                    return ">";
                  case "amp":
                    return "&";
                  case "quot":
                    return '"';
                  case "apos":
                    return "'";
                }
                return this.onResolveEntity(C);
              });
            }
            _parseContent(O, w) {
              const C = [];
              let i = w;
              function o() {
                for (; i < O.length && q(O, i); )
                  ++i;
              }
              for (; i < O.length && !q(O, i) && O[i] !== ">" && O[i] !== "/"; )
                ++i;
              const k = O.substring(w, i);
              for (o(); i < O.length && O[i] !== ">" && O[i] !== "/" && O[i] !== "?"; ) {
                o();
                let s = "", l = "";
                for (; i < O.length && !q(O, i) && O[i] !== "="; )
                  s += O[i], ++i;
                if (o(), O[i] !== "=")
                  return null;
                ++i, o();
                const g = O[i];
                if (g !== '"' && g !== "'")
                  return null;
                const v = O.indexOf(g, ++i);
                if (v < 0)
                  return null;
                l = O.substring(i, v), C.push({
                  name: s,
                  value: this._resolveEntities(l)
                }), i = v + 1, o();
              }
              return {
                name: k,
                attributes: C,
                parsed: i - w
              };
            }
            _parseProcessingInstruction(O, w) {
              let C = w;
              function i() {
                for (; C < O.length && q(O, C); )
                  ++C;
              }
              for (; C < O.length && !q(O, C) && O[C] !== ">" && O[C] !== "?" && O[C] !== "/"; )
                ++C;
              const o = O.substring(w, C);
              i();
              const k = C;
              for (; C < O.length && (O[C] !== "?" || O[C + 1] !== ">"); )
                ++C;
              const s = O.substring(k, C);
              return {
                name: o,
                value: s,
                parsed: C - w
              };
            }
            parseXml(O) {
              let w = 0;
              for (; w < O.length; ) {
                const C = O[w];
                let i = w;
                if (C === "<") {
                  ++i;
                  const o = O[i];
                  let k;
                  switch (o) {
                    case "/":
                      if (++i, k = O.indexOf(">", i), k < 0) {
                        this.onError(u.UnterminatedElement);
                        return;
                      }
                      this.onEndElement(O.substring(i, k)), i = k + 1;
                      break;
                    case "?":
                      ++i;
                      const s = this._parseProcessingInstruction(O, i);
                      if (O.substring(i + s.parsed, i + s.parsed + 2) !== "?>") {
                        this.onError(u.UnterminatedXmlDeclaration);
                        return;
                      }
                      this.onPi(s.name, s.value), i += s.parsed + 2;
                      break;
                    case "!":
                      if (O.substring(i + 1, i + 3) === "--") {
                        if (k = O.indexOf("-->", i + 3), k < 0) {
                          this.onError(u.UnterminatedComment);
                          return;
                        }
                        this.onComment(O.substring(i + 3, k)), i = k + 3;
                      } else if (O.substring(i + 1, i + 8) === "[CDATA[") {
                        if (k = O.indexOf("]]>", i + 8), k < 0) {
                          this.onError(u.UnterminatedCdat);
                          return;
                        }
                        this.onCdata(O.substring(i + 8, k)), i = k + 3;
                      } else if (O.substring(i + 1, i + 8) === "DOCTYPE") {
                        const v = O.indexOf("[", i + 8);
                        let r = !1;
                        if (k = O.indexOf(">", i + 8), k < 0) {
                          this.onError(u.UnterminatedDoctypeDeclaration);
                          return;
                        }
                        if (v > 0 && k > v) {
                          if (k = O.indexOf("]>", i + 8), k < 0) {
                            this.onError(u.UnterminatedDoctypeDeclaration);
                            return;
                          }
                          r = !0;
                        }
                        const x = O.substring(i + 8, k + (r ? 1 : 0));
                        this.onDoctype(x), i = k + (r ? 2 : 1);
                      } else {
                        this.onError(u.MalformedElement);
                        return;
                      }
                      break;
                    default:
                      const l = this._parseContent(O, i);
                      if (l === null) {
                        this.onError(u.MalformedElement);
                        return;
                      }
                      let g = !1;
                      if (O.substring(i + l.parsed, i + l.parsed + 2) === "/>")
                        g = !0;
                      else if (O.substring(i + l.parsed, i + l.parsed + 1) !== ">") {
                        this.onError(u.UnterminatedElement);
                        return;
                      }
                      this.onBeginElement(l.name, l.attributes, g), i += l.parsed + (g ? 2 : 1);
                      break;
                  }
                } else {
                  for (; i < O.length && O[i] !== "<"; )
                    i++;
                  const o = O.substring(w, i);
                  this.onText(this._resolveEntities(o));
                }
                w = i;
              }
            }
            onResolveEntity(O) {
              return `&${O};`;
            }
            onPi(O, w) {
            }
            onComment(O) {
            }
            onCdata(O) {
            }
            onDoctype(O) {
            }
            onText(O) {
            }
            onBeginElement(O, w, C) {
            }
            onEndElement(O) {
            }
            onError(O) {
            }
          }
          F.XMLParserBase = t;
          class B {
            constructor(O, w) {
              this.nodeName = O, this.nodeValue = w, Object.defineProperty(this, "parentNode", {
                value: null,
                writable: !0
              });
            }
            get firstChild() {
              var O;
              return (O = this.childNodes) == null ? void 0 : O[0];
            }
            get nextSibling() {
              const O = this.parentNode.childNodes;
              if (!O)
                return;
              const w = O.indexOf(this);
              if (w !== -1)
                return O[w + 1];
            }
            get textContent() {
              return this.childNodes ? this.childNodes.map(function(O) {
                return O.textContent;
              }).join("") : this.nodeValue || "";
            }
            get children() {
              return this.childNodes || [];
            }
            hasChildNodes() {
              var O;
              return ((O = this.childNodes) == null ? void 0 : O.length) > 0;
            }
            searchNode(O, w) {
              var k;
              if (w >= O.length)
                return this;
              const C = O[w], i = [];
              let o = this;
              for (; ; ) {
                if (C.name === o.nodeName)
                  if (C.pos === 0) {
                    const s = o.searchNode(O, w + 1);
                    if (s !== null)
                      return s;
                  } else {
                    if (i.length === 0)
                      return null;
                    {
                      const [s] = i.pop();
                      let l = 0;
                      for (const g of s.childNodes)
                        if (C.name === g.nodeName) {
                          if (l === C.pos)
                            return g.searchNode(O, w + 1);
                          l++;
                        }
                      return o.searchNode(O, w + 1);
                    }
                  }
                if (((k = o.childNodes) == null ? void 0 : k.length) > 0)
                  i.push([o, 0]), o = o.childNodes[0];
                else {
                  if (i.length === 0)
                    return null;
                  for (; i.length !== 0; ) {
                    const [s, l] = i.pop(), g = l + 1;
                    if (g < s.childNodes.length) {
                      i.push([s, g]), o = s.childNodes[g];
                      break;
                    }
                  }
                  if (i.length === 0)
                    return null;
                }
              }
            }
            dump(O) {
              if (this.nodeName === "#text") {
                O.push((0, n.encodeToXmlString)(this.nodeValue));
                return;
              }
              if (O.push(`<${this.nodeName}`), this.attributes)
                for (const w of this.attributes)
                  O.push(` ${w.name}="${(0, n.encodeToXmlString)(w.value)}"`);
              if (this.hasChildNodes()) {
                O.push(">");
                for (const w of this.childNodes)
                  w.dump(O);
                O.push(`</${this.nodeName}>`);
              } else
                this.nodeValue ? O.push(`>${(0, n.encodeToXmlString)(this.nodeValue)}</${this.nodeName}>`) : O.push("/>");
            }
          }
          F.SimpleDOMNode = B;
          class j extends t {
            constructor({
              hasAttributes: O = !1,
              lowerCaseName: w = !1
            }) {
              super(), this._currentFragment = null, this._stack = null, this._errorCode = u.NoError, this._hasAttributes = O, this._lowerCaseName = w;
            }
            parseFromString(O) {
              if (this._currentFragment = [], this._stack = [], this._errorCode = u.NoError, this.parseXml(O), this._errorCode !== u.NoError)
                return;
              const [w] = this._currentFragment;
              if (w)
                return {
                  documentElement: w
                };
            }
            onText(O) {
              if (e(O))
                return;
              const w = new B("#text", O);
              this._currentFragment.push(w);
            }
            onCdata(O) {
              const w = new B("#text", O);
              this._currentFragment.push(w);
            }
            onBeginElement(O, w, C) {
              this._lowerCaseName && (O = O.toLowerCase());
              const i = new B(O);
              i.childNodes = [], this._hasAttributes && (i.attributes = w), this._currentFragment.push(i), !C && (this._stack.push(this._currentFragment), this._currentFragment = i.childNodes);
            }
            onEndElement(O) {
              this._currentFragment = this._stack.pop() || [];
              const w = this._currentFragment.at(-1);
              if (!w)
                return null;
              for (const C of w.childNodes)
                C.parentNode = w;
              return w;
            }
            onError(O) {
              this._errorCode = O;
            }
          }
          F.SimpleXMLParser = j;
        },
        /* 68 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.calculateSHA256 = F.calculateMD5 = F.PDF20 = F.PDF17 = F.CipherTransformFactory = F.ARCFourCipher = F.AES256Cipher = F.AES128Cipher = void 0, F.calculateSHA384 = O, F.calculateSHA512 = void 0;
          var n = ae(2), u = ae(4), q = ae(69);
          class e {
            constructor(r) {
              this.a = 0, this.b = 0;
              const x = new Uint8Array(256), b = r.length;
              for (let I = 0; I < 256; ++I)
                x[I] = I;
              for (let I = 0, h = 0; I < 256; ++I) {
                const y = x[I];
                h = h + y + r[I % b] & 255, x[I] = x[h], x[h] = y;
              }
              this.s = x;
            }
            encryptBlock(r) {
              let x = this.a, b = this.b;
              const I = this.s, h = r.length, y = new Uint8Array(h);
              for (let P = 0; P < h; ++P) {
                x = x + 1 & 255;
                const c = I[x];
                b = b + c & 255;
                const d = I[b];
                I[x] = d, I[b] = c, y[P] = r[P] ^ I[c + d & 255];
              }
              return this.a = x, this.b = b, y;
            }
            decryptBlock(r) {
              return this.encryptBlock(r);
            }
            encrypt(r) {
              return this.encryptBlock(r);
            }
          }
          F.ARCFourCipher = e;
          const t = function() {
            const r = new Uint8Array([7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 7, 12, 17, 22, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 5, 9, 14, 20, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 4, 11, 16, 23, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21, 6, 10, 15, 21]), x = new Int32Array([-680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551]);
            function b(I, h, y) {
              let P = 1732584193, c = -271733879, d = -1732584194, A = 271733878;
              const N = y + 72 & -64, E = new Uint8Array(N);
              let H, $;
              for (H = 0; H < y; ++H)
                E[H] = I[h++];
              E[H++] = 128;
              const m = N - 8;
              for (; H < m; )
                E[H++] = 0;
              E[H++] = y << 3 & 255, E[H++] = y >> 5 & 255, E[H++] = y >> 13 & 255, E[H++] = y >> 21 & 255, E[H++] = y >>> 29 & 255, E[H++] = 0, E[H++] = 0, E[H++] = 0;
              const p = new Int32Array(16);
              for (H = 0; H < N; ) {
                for ($ = 0; $ < 16; ++$, H += 4)
                  p[$] = E[H] | E[H + 1] << 8 | E[H + 2] << 16 | E[H + 3] << 24;
                let T = P, L = c, _ = d, G = A, J, K;
                for ($ = 0; $ < 64; ++$) {
                  $ < 16 ? (J = L & _ | ~L & G, K = $) : $ < 32 ? (J = G & L | ~G & _, K = 5 * $ + 1 & 15) : $ < 48 ? (J = L ^ _ ^ G, K = 3 * $ + 5 & 15) : (J = _ ^ (L | ~G), K = 7 * $ & 15);
                  const V = G, U = T + J + x[$] + p[K] | 0, Q = r[$];
                  G = _, _ = L, L = L + (U << Q | U >>> 32 - Q) | 0, T = V;
                }
                P = P + T | 0, c = c + L | 0, d = d + _ | 0, A = A + G | 0;
              }
              return new Uint8Array([P & 255, P >> 8 & 255, P >> 16 & 255, P >>> 24 & 255, c & 255, c >> 8 & 255, c >> 16 & 255, c >>> 24 & 255, d & 255, d >> 8 & 255, d >> 16 & 255, d >>> 24 & 255, A & 255, A >> 8 & 255, A >> 16 & 255, A >>> 24 & 255]);
            }
            return b;
          }();
          F.calculateMD5 = t;
          class B {
            constructor(r, x) {
              this.high = r | 0, this.low = x | 0;
            }
            and(r) {
              this.high &= r.high, this.low &= r.low;
            }
            xor(r) {
              this.high ^= r.high, this.low ^= r.low;
            }
            or(r) {
              this.high |= r.high, this.low |= r.low;
            }
            shiftRight(r) {
              r >= 32 ? (this.low = this.high >>> r - 32 | 0, this.high = 0) : (this.low = this.low >>> r | this.high << 32 - r, this.high = this.high >>> r | 0);
            }
            shiftLeft(r) {
              r >= 32 ? (this.high = this.low << r - 32, this.low = 0) : (this.high = this.high << r | this.low >>> 32 - r, this.low <<= r);
            }
            rotateRight(r) {
              let x, b;
              r & 32 ? (b = this.low, x = this.high) : (x = this.low, b = this.high), r &= 31, this.low = x >>> r | b << 32 - r, this.high = b >>> r | x << 32 - r;
            }
            not() {
              this.high = ~this.high, this.low = ~this.low;
            }
            add(r) {
              const x = (this.low >>> 0) + (r.low >>> 0);
              let b = (this.high >>> 0) + (r.high >>> 0);
              x > 4294967295 && (b += 1), this.low = x | 0, this.high = b | 0;
            }
            copyTo(r, x) {
              r[x] = this.high >>> 24 & 255, r[x + 1] = this.high >> 16 & 255, r[x + 2] = this.high >> 8 & 255, r[x + 3] = this.high & 255, r[x + 4] = this.low >>> 24 & 255, r[x + 5] = this.low >> 16 & 255, r[x + 6] = this.low >> 8 & 255, r[x + 7] = this.low & 255;
            }
            assign(r) {
              this.high = r.high, this.low = r.low;
            }
          }
          const j = function() {
            function r(A, N) {
              return A >>> N | A << 32 - N;
            }
            function x(A, N, E) {
              return A & N ^ ~A & E;
            }
            function b(A, N, E) {
              return A & N ^ A & E ^ N & E;
            }
            function I(A) {
              return r(A, 2) ^ r(A, 13) ^ r(A, 22);
            }
            function h(A) {
              return r(A, 6) ^ r(A, 11) ^ r(A, 25);
            }
            function y(A) {
              return r(A, 7) ^ r(A, 18) ^ A >>> 3;
            }
            function P(A) {
              return r(A, 17) ^ r(A, 19) ^ A >>> 10;
            }
            const c = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298];
            function d(A, N, E) {
              let H = 1779033703, $ = 3144134277, m = 1013904242, p = 2773480762, T = 1359893119, L = 2600822924, _ = 528734635, G = 1541459225;
              const J = Math.ceil((E + 9) / 64) * 64, K = new Uint8Array(J);
              let V, U;
              for (V = 0; V < E; ++V)
                K[V] = A[N++];
              K[V++] = 128;
              const Q = J - 8;
              for (; V < Q; )
                K[V++] = 0;
              K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = E >>> 29 & 255, K[V++] = E >> 21 & 255, K[V++] = E >> 13 & 255, K[V++] = E >> 5 & 255, K[V++] = E << 3 & 255;
              const X = new Uint32Array(64);
              for (V = 0; V < J; ) {
                for (U = 0; U < 16; ++U)
                  X[U] = K[V] << 24 | K[V + 1] << 16 | K[V + 2] << 8 | K[V + 3], V += 4;
                for (U = 16; U < 64; ++U)
                  X[U] = P(X[U - 2]) + X[U - 7] + y(X[U - 15]) + X[U - 16] | 0;
                let R = H, f = $, D = m, z = p, Y = T, W = L, ie = _, ne = G, re, ee;
                for (U = 0; U < 64; ++U)
                  re = ne + h(Y) + x(Y, W, ie) + c[U] + X[U], ee = I(R) + b(R, f, D), ne = ie, ie = W, W = Y, Y = z + re | 0, z = D, D = f, f = R, R = re + ee | 0;
                H = H + R | 0, $ = $ + f | 0, m = m + D | 0, p = p + z | 0, T = T + Y | 0, L = L + W | 0, _ = _ + ie | 0, G = G + ne | 0;
              }
              return new Uint8Array([H >> 24 & 255, H >> 16 & 255, H >> 8 & 255, H & 255, $ >> 24 & 255, $ >> 16 & 255, $ >> 8 & 255, $ & 255, m >> 24 & 255, m >> 16 & 255, m >> 8 & 255, m & 255, p >> 24 & 255, p >> 16 & 255, p >> 8 & 255, p & 255, T >> 24 & 255, T >> 16 & 255, T >> 8 & 255, T & 255, L >> 24 & 255, L >> 16 & 255, L >> 8 & 255, L & 255, _ >> 24 & 255, _ >> 16 & 255, _ >> 8 & 255, _ & 255, G >> 24 & 255, G >> 16 & 255, G >> 8 & 255, G & 255]);
            }
            return d;
          }();
          F.calculateSHA256 = j;
          const M = function() {
            function r(d, A, N, E, H) {
              d.assign(A), d.and(N), H.assign(A), H.not(), H.and(E), d.xor(H);
            }
            function x(d, A, N, E, H) {
              d.assign(A), d.and(N), H.assign(A), H.and(E), d.xor(H), H.assign(N), H.and(E), d.xor(H);
            }
            function b(d, A, N) {
              d.assign(A), d.rotateRight(28), N.assign(A), N.rotateRight(34), d.xor(N), N.assign(A), N.rotateRight(39), d.xor(N);
            }
            function I(d, A, N) {
              d.assign(A), d.rotateRight(14), N.assign(A), N.rotateRight(18), d.xor(N), N.assign(A), N.rotateRight(41), d.xor(N);
            }
            function h(d, A, N) {
              d.assign(A), d.rotateRight(1), N.assign(A), N.rotateRight(8), d.xor(N), N.assign(A), N.shiftRight(7), d.xor(N);
            }
            function y(d, A, N) {
              d.assign(A), d.rotateRight(19), N.assign(A), N.rotateRight(61), d.xor(N), N.assign(A), N.shiftRight(6), d.xor(N);
            }
            const P = [new B(1116352408, 3609767458), new B(1899447441, 602891725), new B(3049323471, 3964484399), new B(3921009573, 2173295548), new B(961987163, 4081628472), new B(1508970993, 3053834265), new B(2453635748, 2937671579), new B(2870763221, 3664609560), new B(3624381080, 2734883394), new B(310598401, 1164996542), new B(607225278, 1323610764), new B(1426881987, 3590304994), new B(1925078388, 4068182383), new B(2162078206, 991336113), new B(2614888103, 633803317), new B(3248222580, 3479774868), new B(3835390401, 2666613458), new B(4022224774, 944711139), new B(264347078, 2341262773), new B(604807628, 2007800933), new B(770255983, 1495990901), new B(1249150122, 1856431235), new B(1555081692, 3175218132), new B(1996064986, 2198950837), new B(2554220882, 3999719339), new B(2821834349, 766784016), new B(2952996808, 2566594879), new B(3210313671, 3203337956), new B(3336571891, 1034457026), new B(3584528711, 2466948901), new B(113926993, 3758326383), new B(338241895, 168717936), new B(666307205, 1188179964), new B(773529912, 1546045734), new B(1294757372, 1522805485), new B(1396182291, 2643833823), new B(1695183700, 2343527390), new B(1986661051, 1014477480), new B(2177026350, 1206759142), new B(2456956037, 344077627), new B(2730485921, 1290863460), new B(2820302411, 3158454273), new B(3259730800, 3505952657), new B(3345764771, 106217008), new B(3516065817, 3606008344), new B(3600352804, 1432725776), new B(4094571909, 1467031594), new B(275423344, 851169720), new B(430227734, 3100823752), new B(506948616, 1363258195), new B(659060556, 3750685593), new B(883997877, 3785050280), new B(958139571, 3318307427), new B(1322822218, 3812723403), new B(1537002063, 2003034995), new B(1747873779, 3602036899), new B(1955562222, 1575990012), new B(2024104815, 1125592928), new B(2227730452, 2716904306), new B(2361852424, 442776044), new B(2428436474, 593698344), new B(2756734187, 3733110249), new B(3204031479, 2999351573), new B(3329325298, 3815920427), new B(3391569614, 3928383900), new B(3515267271, 566280711), new B(3940187606, 3454069534), new B(4118630271, 4000239992), new B(116418474, 1914138554), new B(174292421, 2731055270), new B(289380356, 3203993006), new B(460393269, 320620315), new B(685471733, 587496836), new B(852142971, 1086792851), new B(1017036298, 365543100), new B(1126000580, 2618297676), new B(1288033470, 3409855158), new B(1501505948, 4234509866), new B(1607167915, 987167468), new B(1816402316, 1246189591)];
            function c(d, A, N, E = !1) {
              let H, $, m, p, T, L, _, G;
              E ? (H = new B(3418070365, 3238371032), $ = new B(1654270250, 914150663), m = new B(2438529370, 812702999), p = new B(355462360, 4144912697), T = new B(1731405415, 4290775857), L = new B(2394180231, 1750603025), _ = new B(3675008525, 1694076839), G = new B(1203062813, 3204075428)) : (H = new B(1779033703, 4089235720), $ = new B(3144134277, 2227873595), m = new B(1013904242, 4271175723), p = new B(2773480762, 1595750129), T = new B(1359893119, 2917565137), L = new B(2600822924, 725511199), _ = new B(528734635, 4215389547), G = new B(1541459225, 327033209));
              const J = Math.ceil((N + 17) / 128) * 128, K = new Uint8Array(J);
              let V, U;
              for (V = 0; V < N; ++V)
                K[V] = d[A++];
              K[V++] = 128;
              const Q = J - 16;
              for (; V < Q; )
                K[V++] = 0;
              K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = 0, K[V++] = N >>> 29 & 255, K[V++] = N >> 21 & 255, K[V++] = N >> 13 & 255, K[V++] = N >> 5 & 255, K[V++] = N << 3 & 255;
              const X = new Array(80);
              for (V = 0; V < 80; V++)
                X[V] = new B(0, 0);
              let R = new B(0, 0), f = new B(0, 0), D = new B(0, 0), z = new B(0, 0), Y = new B(0, 0), W = new B(0, 0), ie = new B(0, 0), ne = new B(0, 0);
              const re = new B(0, 0), ee = new B(0, 0), te = new B(0, 0), oe = new B(0, 0);
              let se;
              for (V = 0; V < J; ) {
                for (U = 0; U < 16; ++U)
                  X[U].high = K[V] << 24 | K[V + 1] << 16 | K[V + 2] << 8 | K[V + 3], X[U].low = K[V + 4] << 24 | K[V + 5] << 16 | K[V + 6] << 8 | K[V + 7], V += 8;
                for (U = 16; U < 80; ++U)
                  se = X[U], y(se, X[U - 2], oe), se.add(X[U - 7]), h(te, X[U - 15], oe), se.add(te), se.add(X[U - 16]);
                for (R.assign(H), f.assign($), D.assign(m), z.assign(p), Y.assign(T), W.assign(L), ie.assign(_), ne.assign(G), U = 0; U < 80; ++U)
                  re.assign(ne), I(te, Y, oe), re.add(te), r(te, Y, W, ie, oe), re.add(te), re.add(P[U]), re.add(X[U]), b(ee, R, oe), x(te, R, f, D, oe), ee.add(te), se = ne, ne = ie, ie = W, W = Y, z.add(re), Y = z, z = D, D = f, f = R, se.assign(re), se.add(ee), R = se;
                H.add(R), $.add(f), m.add(D), p.add(z), T.add(Y), L.add(W), _.add(ie), G.add(ne);
              }
              let ce;
              return E ? (ce = new Uint8Array(48), H.copyTo(ce, 0), $.copyTo(ce, 8), m.copyTo(ce, 16), p.copyTo(ce, 24), T.copyTo(ce, 32), L.copyTo(ce, 40)) : (ce = new Uint8Array(64), H.copyTo(ce, 0), $.copyTo(ce, 8), m.copyTo(ce, 16), p.copyTo(ce, 24), T.copyTo(ce, 32), L.copyTo(ce, 40), _.copyTo(ce, 48), G.copyTo(ce, 56)), ce;
            }
            return c;
          }();
          F.calculateSHA512 = M;
          function O(v, r, x) {
            return M(v, r, x, !0);
          }
          class w {
            decryptBlock(r) {
              return r;
            }
            encrypt(r) {
              return r;
            }
          }
          class C {
            constructor() {
              this.constructor === C && (0, n.unreachable)("Cannot initialize AESBaseCipher."), this._s = new Uint8Array([99, 124, 119, 123, 242, 107, 111, 197, 48, 1, 103, 43, 254, 215, 171, 118, 202, 130, 201, 125, 250, 89, 71, 240, 173, 212, 162, 175, 156, 164, 114, 192, 183, 253, 147, 38, 54, 63, 247, 204, 52, 165, 229, 241, 113, 216, 49, 21, 4, 199, 35, 195, 24, 150, 5, 154, 7, 18, 128, 226, 235, 39, 178, 117, 9, 131, 44, 26, 27, 110, 90, 160, 82, 59, 214, 179, 41, 227, 47, 132, 83, 209, 0, 237, 32, 252, 177, 91, 106, 203, 190, 57, 74, 76, 88, 207, 208, 239, 170, 251, 67, 77, 51, 133, 69, 249, 2, 127, 80, 60, 159, 168, 81, 163, 64, 143, 146, 157, 56, 245, 188, 182, 218, 33, 16, 255, 243, 210, 205, 12, 19, 236, 95, 151, 68, 23, 196, 167, 126, 61, 100, 93, 25, 115, 96, 129, 79, 220, 34, 42, 144, 136, 70, 238, 184, 20, 222, 94, 11, 219, 224, 50, 58, 10, 73, 6, 36, 92, 194, 211, 172, 98, 145, 149, 228, 121, 231, 200, 55, 109, 141, 213, 78, 169, 108, 86, 244, 234, 101, 122, 174, 8, 186, 120, 37, 46, 28, 166, 180, 198, 232, 221, 116, 31, 75, 189, 139, 138, 112, 62, 181, 102, 72, 3, 246, 14, 97, 53, 87, 185, 134, 193, 29, 158, 225, 248, 152, 17, 105, 217, 142, 148, 155, 30, 135, 233, 206, 85, 40, 223, 140, 161, 137, 13, 191, 230, 66, 104, 65, 153, 45, 15, 176, 84, 187, 22]), this._inv_s = new Uint8Array([82, 9, 106, 213, 48, 54, 165, 56, 191, 64, 163, 158, 129, 243, 215, 251, 124, 227, 57, 130, 155, 47, 255, 135, 52, 142, 67, 68, 196, 222, 233, 203, 84, 123, 148, 50, 166, 194, 35, 61, 238, 76, 149, 11, 66, 250, 195, 78, 8, 46, 161, 102, 40, 217, 36, 178, 118, 91, 162, 73, 109, 139, 209, 37, 114, 248, 246, 100, 134, 104, 152, 22, 212, 164, 92, 204, 93, 101, 182, 146, 108, 112, 72, 80, 253, 237, 185, 218, 94, 21, 70, 87, 167, 141, 157, 132, 144, 216, 171, 0, 140, 188, 211, 10, 247, 228, 88, 5, 184, 179, 69, 6, 208, 44, 30, 143, 202, 63, 15, 2, 193, 175, 189, 3, 1, 19, 138, 107, 58, 145, 17, 65, 79, 103, 220, 234, 151, 242, 207, 206, 240, 180, 230, 115, 150, 172, 116, 34, 231, 173, 53, 133, 226, 249, 55, 232, 28, 117, 223, 110, 71, 241, 26, 113, 29, 41, 197, 137, 111, 183, 98, 14, 170, 24, 190, 27, 252, 86, 62, 75, 198, 210, 121, 32, 154, 219, 192, 254, 120, 205, 90, 244, 31, 221, 168, 51, 136, 7, 199, 49, 177, 18, 16, 89, 39, 128, 236, 95, 96, 81, 127, 169, 25, 181, 74, 13, 45, 229, 122, 159, 147, 201, 156, 239, 160, 224, 59, 77, 174, 42, 245, 176, 200, 235, 187, 60, 131, 83, 153, 97, 23, 43, 4, 126, 186, 119, 214, 38, 225, 105, 20, 99, 85, 33, 12, 125]), this._mix = new Uint32Array([0, 235474187, 470948374, 303765277, 941896748, 908933415, 607530554, 708780849, 1883793496, 2118214995, 1817866830, 1649639237, 1215061108, 1181045119, 1417561698, 1517767529, 3767586992, 4003061179, 4236429990, 4069246893, 3635733660, 3602770327, 3299278474, 3400528769, 2430122216, 2664543715, 2362090238, 2193862645, 2835123396, 2801107407, 3035535058, 3135740889, 3678124923, 3576870512, 3341394285, 3374361702, 3810496343, 3977675356, 4279080257, 4043610186, 2876494627, 2776292904, 3076639029, 3110650942, 2472011535, 2640243204, 2403728665, 2169303058, 1001089995, 899835584, 666464733, 699432150, 59727847, 226906860, 530400753, 294930682, 1273168787, 1172967064, 1475418501, 1509430414, 1942435775, 2110667444, 1876241833, 1641816226, 2910219766, 2743034109, 2976151520, 3211623147, 2505202138, 2606453969, 2302690252, 2269728455, 3711829422, 3543599269, 3240894392, 3475313331, 3843699074, 3943906441, 4178062228, 4144047775, 1306967366, 1139781709, 1374988112, 1610459739, 1975683434, 2076935265, 1775276924, 1742315127, 1034867998, 866637845, 566021896, 800440835, 92987698, 193195065, 429456164, 395441711, 1984812685, 2017778566, 1784663195, 1683407248, 1315562145, 1080094634, 1383856311, 1551037884, 101039829, 135050206, 437757123, 337553864, 1042385657, 807962610, 573804783, 742039012, 2531067453, 2564033334, 2328828971, 2227573024, 2935566865, 2700099354, 3001755655, 3168937228, 3868552805, 3902563182, 4203181171, 4102977912, 3736164937, 3501741890, 3265478751, 3433712980, 1106041591, 1340463100, 1576976609, 1408749034, 2043211483, 2009195472, 1708848333, 1809054150, 832877231, 1068351396, 766945465, 599762354, 159417987, 126454664, 361929877, 463180190, 2709260871, 2943682380, 3178106961, 3009879386, 2572697195, 2538681184, 2236228733, 2336434550, 3509871135, 3745345300, 3441850377, 3274667266, 3910161971, 3877198648, 4110568485, 4211818798, 2597806476, 2497604743, 2261089178, 2295101073, 2733856160, 2902087851, 3202437046, 2968011453, 3936291284, 3835036895, 4136440770, 4169408201, 3535486456, 3702665459, 3467192302, 3231722213, 2051518780, 1951317047, 1716890410, 1750902305, 1113818384, 1282050075, 1584504582, 1350078989, 168810852, 67556463, 371049330, 404016761, 841739592, 1008918595, 775550814, 540080725, 3969562369, 3801332234, 4035489047, 4269907996, 3569255213, 3669462566, 3366754619, 3332740144, 2631065433, 2463879762, 2160117071, 2395588676, 2767645557, 2868897406, 3102011747, 3069049960, 202008497, 33778362, 270040487, 504459436, 875451293, 975658646, 675039627, 641025152, 2084704233, 1917518562, 1615861247, 1851332852, 1147550661, 1248802510, 1484005843, 1451044056, 933301370, 967311729, 733156972, 632953703, 260388950, 25965917, 328671808, 496906059, 1206477858, 1239443753, 1543208500, 1441952575, 2144161806, 1908694277, 1675577880, 1842759443, 3610369226, 3644379585, 3408119516, 3307916247, 4011190502, 3776767469, 4077384432, 4245618683, 2809771154, 2842737049, 3144396420, 3043140495, 2673705150, 2438237621, 2203032232, 2370213795]), this._mixCol = new Uint8Array(256);
              for (let r = 0; r < 256; r++)
                r < 128 ? this._mixCol[r] = r << 1 : this._mixCol[r] = r << 1 ^ 27;
              this.buffer = new Uint8Array(16), this.bufferPosition = 0;
            }
            _expandKey(r) {
              (0, n.unreachable)("Cannot call `_expandKey` on the base class");
            }
            _decrypt(r, x) {
              let b, I, h;
              const y = new Uint8Array(16);
              y.set(r);
              for (let P = 0, c = this._keySize; P < 16; ++P, ++c)
                y[P] ^= x[c];
              for (let P = this._cyclesOfRepetition - 1; P >= 1; --P) {
                b = y[13], y[13] = y[9], y[9] = y[5], y[5] = y[1], y[1] = b, b = y[14], I = y[10], y[14] = y[6], y[10] = y[2], y[6] = b, y[2] = I, b = y[15], I = y[11], h = y[7], y[15] = y[3], y[11] = b, y[7] = I, y[3] = h;
                for (let c = 0; c < 16; ++c)
                  y[c] = this._inv_s[y[c]];
                for (let c = 0, d = P * 16; c < 16; ++c, ++d)
                  y[c] ^= x[d];
                for (let c = 0; c < 16; c += 4) {
                  const d = this._mix[y[c]], A = this._mix[y[c + 1]], N = this._mix[y[c + 2]], E = this._mix[y[c + 3]];
                  b = d ^ A >>> 8 ^ A << 24 ^ N >>> 16 ^ N << 16 ^ E >>> 24 ^ E << 8, y[c] = b >>> 24 & 255, y[c + 1] = b >> 16 & 255, y[c + 2] = b >> 8 & 255, y[c + 3] = b & 255;
                }
              }
              b = y[13], y[13] = y[9], y[9] = y[5], y[5] = y[1], y[1] = b, b = y[14], I = y[10], y[14] = y[6], y[10] = y[2], y[6] = b, y[2] = I, b = y[15], I = y[11], h = y[7], y[15] = y[3], y[11] = b, y[7] = I, y[3] = h;
              for (let P = 0; P < 16; ++P)
                y[P] = this._inv_s[y[P]], y[P] ^= x[P];
              return y;
            }
            _encrypt(r, x) {
              const b = this._s;
              let I, h, y;
              const P = new Uint8Array(16);
              P.set(r);
              for (let c = 0; c < 16; ++c)
                P[c] ^= x[c];
              for (let c = 1; c < this._cyclesOfRepetition; c++) {
                for (let d = 0; d < 16; ++d)
                  P[d] = b[P[d]];
                y = P[1], P[1] = P[5], P[5] = P[9], P[9] = P[13], P[13] = y, y = P[2], h = P[6], P[2] = P[10], P[6] = P[14], P[10] = y, P[14] = h, y = P[3], h = P[7], I = P[11], P[3] = P[15], P[7] = y, P[11] = h, P[15] = I;
                for (let d = 0; d < 16; d += 4) {
                  const A = P[d + 0], N = P[d + 1], E = P[d + 2], H = P[d + 3];
                  I = A ^ N ^ E ^ H, P[d + 0] ^= I ^ this._mixCol[A ^ N], P[d + 1] ^= I ^ this._mixCol[N ^ E], P[d + 2] ^= I ^ this._mixCol[E ^ H], P[d + 3] ^= I ^ this._mixCol[H ^ A];
                }
                for (let d = 0, A = c * 16; d < 16; ++d, ++A)
                  P[d] ^= x[A];
              }
              for (let c = 0; c < 16; ++c)
                P[c] = b[P[c]];
              y = P[1], P[1] = P[5], P[5] = P[9], P[9] = P[13], P[13] = y, y = P[2], h = P[6], P[2] = P[10], P[6] = P[14], P[10] = y, P[14] = h, y = P[3], h = P[7], I = P[11], P[3] = P[15], P[7] = y, P[11] = h, P[15] = I;
              for (let c = 0, d = this._keySize; c < 16; ++c, ++d)
                P[c] ^= x[d];
              return P;
            }
            _decryptBlock2(r, x) {
              const b = r.length;
              let I = this.buffer, h = this.bufferPosition;
              const y = [];
              let P = this.iv;
              for (let A = 0; A < b; ++A) {
                if (I[h] = r[A], ++h, h < 16)
                  continue;
                const N = this._decrypt(I, this._key);
                for (let E = 0; E < 16; ++E)
                  N[E] ^= P[E];
                P = I, y.push(N), I = new Uint8Array(16), h = 0;
              }
              if (this.buffer = I, this.bufferLength = h, this.iv = P, y.length === 0)
                return new Uint8Array(0);
              let c = 16 * y.length;
              if (x) {
                const A = y.at(-1);
                let N = A[15];
                if (N <= 16) {
                  for (let E = 15, H = 16 - N; E >= H; --E)
                    if (A[E] !== N) {
                      N = 0;
                      break;
                    }
                  c -= N, y[y.length - 1] = A.subarray(0, 16 - N);
                }
              }
              const d = new Uint8Array(c);
              for (let A = 0, N = 0, E = y.length; A < E; ++A, N += 16)
                d.set(y[A], N);
              return d;
            }
            decryptBlock(r, x, b = null) {
              const I = r.length, h = this.buffer;
              let y = this.bufferPosition;
              if (b)
                this.iv = b;
              else {
                for (let P = 0; y < 16 && P < I; ++P, ++y)
                  h[y] = r[P];
                if (y < 16)
                  return this.bufferLength = y, new Uint8Array(0);
                this.iv = h, r = r.subarray(16);
              }
              return this.buffer = new Uint8Array(16), this.bufferLength = 0, this.decryptBlock = this._decryptBlock2, this.decryptBlock(r, x);
            }
            encrypt(r, x) {
              const b = r.length;
              let I = this.buffer, h = this.bufferPosition;
              const y = [];
              x || (x = new Uint8Array(16));
              for (let d = 0; d < b; ++d) {
                if (I[h] = r[d], ++h, h < 16)
                  continue;
                for (let N = 0; N < 16; ++N)
                  I[N] ^= x[N];
                const A = this._encrypt(I, this._key);
                x = A, y.push(A), I = new Uint8Array(16), h = 0;
              }
              if (this.buffer = I, this.bufferLength = h, this.iv = x, y.length === 0)
                return new Uint8Array(0);
              const P = 16 * y.length, c = new Uint8Array(P);
              for (let d = 0, A = 0, N = y.length; d < N; ++d, A += 16)
                c.set(y[d], A);
              return c;
            }
          }
          class i extends C {
            constructor(r) {
              super(), this._cyclesOfRepetition = 10, this._keySize = 160, this._rcon = new Uint8Array([141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54, 108, 216, 171, 77, 154, 47, 94, 188, 99, 198, 151, 53, 106, 212, 179, 125, 250, 239, 197, 145, 57, 114, 228, 211, 189, 97, 194, 159, 37, 74, 148, 51, 102, 204, 131, 29, 58, 116, 232, 203, 141]), this._key = this._expandKey(r);
            }
            _expandKey(r) {
              const b = this._s, I = this._rcon, h = new Uint8Array(176);
              h.set(r);
              for (let y = 16, P = 1; y < 176; ++P) {
                let c = h[y - 3], d = h[y - 2], A = h[y - 1], N = h[y - 4];
                c = b[c], d = b[d], A = b[A], N = b[N], c ^= I[P];
                for (let E = 0; E < 4; ++E)
                  h[y] = c ^= h[y - 16], y++, h[y] = d ^= h[y - 16], y++, h[y] = A ^= h[y - 16], y++, h[y] = N ^= h[y - 16], y++;
              }
              return h;
            }
          }
          F.AES128Cipher = i;
          class o extends C {
            constructor(r) {
              super(), this._cyclesOfRepetition = 14, this._keySize = 224, this._key = this._expandKey(r);
            }
            _expandKey(r) {
              const b = this._s, I = new Uint8Array(240);
              I.set(r);
              let h = 1, y, P, c, d;
              for (let A = 32, N = 1; A < 240; ++N) {
                A % 32 === 16 ? (y = b[y], P = b[P], c = b[c], d = b[d]) : A % 32 === 0 && (y = I[A - 3], P = I[A - 2], c = I[A - 1], d = I[A - 4], y = b[y], P = b[P], c = b[c], d = b[d], y ^= h, (h <<= 1) >= 256 && (h = (h ^ 27) & 255));
                for (let E = 0; E < 4; ++E)
                  I[A] = y ^= I[A - 32], A++, I[A] = P ^= I[A - 32], A++, I[A] = c ^= I[A - 32], A++, I[A] = d ^= I[A - 32], A++;
              }
              return I;
            }
          }
          F.AES256Cipher = o;
          class k {
            checkOwnerPassword(r, x, b, I) {
              const h = new Uint8Array(r.length + 56);
              h.set(r, 0), h.set(x, r.length), h.set(b, r.length + x.length);
              const y = j(h, 0, h.length);
              return (0, n.isArrayEqual)(y, I);
            }
            checkUserPassword(r, x, b) {
              const I = new Uint8Array(r.length + 8);
              I.set(r, 0), I.set(x, r.length);
              const h = j(I, 0, I.length);
              return (0, n.isArrayEqual)(h, b);
            }
            getOwnerKey(r, x, b, I) {
              const h = new Uint8Array(r.length + 56);
              h.set(r, 0), h.set(x, r.length), h.set(b, r.length + x.length);
              const y = j(h, 0, h.length);
              return new o(y).decryptBlock(I, !1, new Uint8Array(16));
            }
            getUserKey(r, x, b) {
              const I = new Uint8Array(r.length + 8);
              I.set(r, 0), I.set(x, r.length);
              const h = j(I, 0, I.length);
              return new o(h).decryptBlock(b, !1, new Uint8Array(16));
            }
          }
          F.PDF17 = k;
          class s {
            _hash(r, x, b) {
              let I = j(x, 0, x.length).subarray(0, 32), h = [0], y = 0;
              for (; y < 64 || h.at(-1) > y - 32; ) {
                const P = r.length + I.length + b.length, c = new Uint8Array(P);
                let d = 0;
                c.set(r, d), d += r.length, c.set(I, d), d += I.length, c.set(b, d);
                const A = new Uint8Array(P * 64);
                for (let H = 0, $ = 0; H < 64; H++, $ += P)
                  A.set(c, $);
                h = new i(I.subarray(0, 16)).encrypt(A, I.subarray(16, 32));
                const E = h.slice(0, 16).reduce((H, $) => H + $, 0) % 3;
                E === 0 ? I = j(h, 0, h.length) : E === 1 ? I = O(h, 0, h.length) : E === 2 && (I = M(h, 0, h.length)), y++;
              }
              return I.subarray(0, 32);
            }
            checkOwnerPassword(r, x, b, I) {
              const h = new Uint8Array(r.length + 56);
              h.set(r, 0), h.set(x, r.length), h.set(b, r.length + x.length);
              const y = this._hash(r, h, b);
              return (0, n.isArrayEqual)(y, I);
            }
            checkUserPassword(r, x, b) {
              const I = new Uint8Array(r.length + 8);
              I.set(r, 0), I.set(x, r.length);
              const h = this._hash(r, I, []);
              return (0, n.isArrayEqual)(h, b);
            }
            getOwnerKey(r, x, b, I) {
              const h = new Uint8Array(r.length + 56);
              h.set(r, 0), h.set(x, r.length), h.set(b, r.length + x.length);
              const y = this._hash(r, h, b);
              return new o(y).decryptBlock(I, !1, new Uint8Array(16));
            }
            getUserKey(r, x, b) {
              const I = new Uint8Array(r.length + 8);
              I.set(r, 0), I.set(x, r.length);
              const h = this._hash(r, I, []);
              return new o(h).decryptBlock(b, !1, new Uint8Array(16));
            }
          }
          F.PDF20 = s;
          class l {
            constructor(r, x) {
              this.StringCipherConstructor = r, this.StreamCipherConstructor = x;
            }
            createStream(r, x) {
              const b = new this.StreamCipherConstructor();
              return new q.DecryptStream(r, x, function(h, y) {
                return b.decryptBlock(h, y);
              });
            }
            decryptString(r) {
              const x = new this.StringCipherConstructor();
              let b = (0, n.stringToBytes)(r);
              return b = x.decryptBlock(b, !0), (0, n.bytesToString)(b);
            }
            encryptString(r) {
              const x = new this.StringCipherConstructor();
              if (x instanceof C) {
                const h = 16 - r.length % 16;
                r += String.fromCharCode(h).repeat(h);
                const y = new Uint8Array(16);
                if (typeof crypto < "u")
                  crypto.getRandomValues(y);
                else
                  for (let d = 0; d < 16; d++)
                    y[d] = Math.floor(256 * Math.random());
                let P = (0, n.stringToBytes)(r);
                P = x.encrypt(P, y);
                const c = new Uint8Array(16 + P.length);
                return c.set(y), c.set(P, 16), (0, n.bytesToString)(c);
              }
              let b = (0, n.stringToBytes)(r);
              return b = x.encrypt(b), (0, n.bytesToString)(b);
            }
          }
          const g = function() {
            const r = new Uint8Array([40, 191, 78, 94, 78, 117, 138, 65, 100, 0, 78, 86, 255, 250, 1, 8, 46, 46, 0, 182, 208, 104, 62, 128, 47, 12, 169, 254, 100, 83, 105, 122]);
            function x(d, A, N, E, H, $, m, p, T, L, _, G) {
              if (A) {
                const K = Math.min(127, A.length);
                A = A.subarray(0, K);
              } else
                A = [];
              let J;
              return d === 6 ? J = new s() : J = new k(), J.checkUserPassword(A, p, m) ? J.getUserKey(A, T, _) : A.length && J.checkOwnerPassword(A, E, $, N) ? J.getOwnerKey(A, H, $, L) : null;
            }
            function b(d, A, N, E, H, $, m, p) {
              const T = 40 + N.length + d.length, L = new Uint8Array(T);
              let _ = 0, G, J;
              if (A)
                for (J = Math.min(32, A.length); _ < J; ++_)
                  L[_] = A[_];
              for (G = 0; _ < 32; )
                L[_++] = r[G++];
              for (G = 0, J = N.length; G < J; ++G)
                L[_++] = N[G];
              for (L[_++] = H & 255, L[_++] = H >> 8 & 255, L[_++] = H >> 16 & 255, L[_++] = H >>> 24 & 255, G = 0, J = d.length; G < J; ++G)
                L[_++] = d[G];
              $ >= 4 && !p && (L[_++] = 255, L[_++] = 255, L[_++] = 255, L[_++] = 255);
              let K = t(L, 0, _);
              const V = m >> 3;
              if ($ >= 3)
                for (G = 0; G < 50; ++G)
                  K = t(K, 0, V);
              const U = K.subarray(0, V);
              let Q, X;
              if ($ >= 3) {
                for (_ = 0; _ < 32; ++_)
                  L[_] = r[_];
                for (G = 0, J = d.length; G < J; ++G)
                  L[_++] = d[G];
                Q = new e(U), X = Q.encryptBlock(t(L, 0, _)), J = U.length;
                const R = new Uint8Array(J);
                for (G = 1; G <= 19; ++G) {
                  for (let f = 0; f < J; ++f)
                    R[f] = U[f] ^ G;
                  Q = new e(R), X = Q.encryptBlock(X);
                }
                for (G = 0, J = X.length; G < J; ++G)
                  if (E[G] !== X[G])
                    return null;
              } else
                for (Q = new e(U), X = Q.encryptBlock(r), G = 0, J = X.length; G < J; ++G)
                  if (E[G] !== X[G])
                    return null;
              return U;
            }
            function I(d, A, N, E) {
              const H = new Uint8Array(32);
              let $ = 0;
              const m = Math.min(32, d.length);
              for (; $ < m; ++$)
                H[$] = d[$];
              let p = 0;
              for (; $ < 32; )
                H[$++] = r[p++];
              let T = t(H, 0, $);
              const L = E >> 3;
              if (N >= 3)
                for (p = 0; p < 50; ++p)
                  T = t(T, 0, T.length);
              let _, G;
              if (N >= 3) {
                G = A;
                const J = new Uint8Array(L);
                for (p = 19; p >= 0; p--) {
                  for (let K = 0; K < L; ++K)
                    J[K] = T[K] ^ p;
                  _ = new e(J), G = _.encryptBlock(G);
                }
              } else
                _ = new e(T.subarray(0, L)), G = _.encryptBlock(A);
              return G;
            }
            const h = u.Name.get("Identity");
            function y(d, A, N, E = !1) {
              const H = new Uint8Array(N.length + 9), $ = N.length;
              let m;
              for (m = 0; m < $; ++m)
                H[m] = N[m];
              return H[m++] = d & 255, H[m++] = d >> 8 & 255, H[m++] = d >> 16 & 255, H[m++] = A & 255, H[m++] = A >> 8 & 255, E && (H[m++] = 115, H[m++] = 65, H[m++] = 108, H[m++] = 84), t(H, 0, m).subarray(0, Math.min(N.length + 5, 16));
            }
            function P(d, A, N, E, H) {
              if (!(A instanceof u.Name))
                throw new n.FormatError("Invalid crypt filter name.");
              const $ = d.get(A.name);
              let m;
              if ($ != null && (m = $.get("CFM")), !m || m.name === "None")
                return function() {
                  return new w();
                };
              if (m.name === "V2")
                return function() {
                  return new e(y(N, E, H, !1));
                };
              if (m.name === "AESV2")
                return function() {
                  return new i(y(N, E, H, !0));
                };
              if (m.name === "AESV3")
                return function() {
                  return new o(H);
                };
              throw new n.FormatError("Unknown crypto method");
            }
            class c {
              constructor(A, N, E) {
                const H = A.get("Filter");
                if (!(0, u.isName)(H, "Standard"))
                  throw new n.FormatError("unknown encryption method");
                this.filterName = H.name, this.dict = A;
                const $ = A.get("V");
                if (!Number.isInteger($) || $ !== 1 && $ !== 2 && $ !== 4 && $ !== 5)
                  throw new n.FormatError("unsupported encryption algorithm");
                this.algorithm = $;
                let m = A.get("Length");
                if (!m)
                  if ($ <= 3)
                    m = 40;
                  else {
                    const X = A.get("CF"), R = A.get("StmF");
                    if (X instanceof u.Dict && R instanceof u.Name) {
                      X.suppressEncryption = !0;
                      const f = X.get(R.name);
                      m = (f == null ? void 0 : f.get("Length")) || 128, m < 40 && (m <<= 3);
                    }
                  }
                if (!Number.isInteger(m) || m < 40 || m % 8 !== 0)
                  throw new n.FormatError("invalid key length");
                const p = (0, n.stringToBytes)(A.get("O")), T = (0, n.stringToBytes)(A.get("U")), L = p.subarray(0, 32), _ = T.subarray(0, 32), G = A.get("P"), J = A.get("R"), K = ($ === 4 || $ === 5) && A.get("EncryptMetadata") !== !1;
                this.encryptMetadata = K;
                const V = (0, n.stringToBytes)(N);
                let U;
                if (E) {
                  if (J === 6)
                    try {
                      E = (0, n.utf8StringToString)(E);
                    } catch {
                      (0, n.warn)("CipherTransformFactory: Unable to convert UTF8 encoded password.");
                    }
                  U = (0, n.stringToBytes)(E);
                }
                let Q;
                if ($ !== 5)
                  Q = b(V, U, L, _, G, J, m, K);
                else {
                  const X = p.subarray(32, 40), R = p.subarray(40, 48), f = T.subarray(0, 48), D = T.subarray(32, 40), z = T.subarray(40, 48), Y = (0, n.stringToBytes)(A.get("OE")), W = (0, n.stringToBytes)(A.get("UE"));
                  (0, n.stringToBytes)(A.get("Perms")), Q = x(J, U, L, X, R, f, _, D, z, Y, W);
                }
                if (!Q && !E)
                  throw new n.PasswordException("No password given", n.PasswordResponses.NEED_PASSWORD);
                if (!Q && E) {
                  const X = I(U, L, J, m);
                  Q = b(V, X, L, _, G, J, m, K);
                }
                if (!Q)
                  throw new n.PasswordException("Incorrect Password", n.PasswordResponses.INCORRECT_PASSWORD);
                if (this.encryptionKey = Q, $ >= 4) {
                  const X = A.get("CF");
                  X instanceof u.Dict && (X.suppressEncryption = !0), this.cf = X, this.stmf = A.get("StmF") || h, this.strf = A.get("StrF") || h, this.eff = A.get("EFF") || this.stmf;
                }
              }
              createCipherTransform(A, N) {
                if (this.algorithm === 4 || this.algorithm === 5)
                  return new l(P(this.cf, this.strf, A, N, this.encryptionKey), P(this.cf, this.stmf, A, N, this.encryptionKey));
                const E = y(A, N, this.encryptionKey, !1), H = function() {
                  return new e(E);
                };
                return new l(H, H);
              }
            }
            return c;
          }();
          F.CipherTransformFactory = g;
        },
        /* 69 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.DecryptStream = void 0;
          var n = ae(18);
          const u = 512;
          class q extends n.DecodeStream {
            constructor(t, B, j) {
              super(B), this.str = t, this.dict = t.dict, this.decrypt = j, this.nextChunk = null, this.initialized = !1;
            }
            readBlock() {
              var C;
              let t;
              if (this.initialized ? t = this.nextChunk : (t = this.str.getBytes(u), this.initialized = !0), !t || t.length === 0) {
                this.eof = !0;
                return;
              }
              this.nextChunk = this.str.getBytes(u);
              const B = ((C = this.nextChunk) == null ? void 0 : C.length) > 0, j = this.decrypt;
              t = j(t, !B);
              const M = this.bufferLength, O = M + t.length;
              this.ensureBuffer(O).set(t, M), this.bufferLength = O;
            }
          }
          F.DecryptStream = q;
        },
        /* 70 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Catalog = void 0;
          var n = ae(3), u = ae(2), q = ae(4), e = ae(71), t = ae(5), B = ae(72), j = ae(12), M = ae(73), O = ae(59), w = ae(74), C = ae(75);
          function i(k) {
            return k instanceof q.Dict && (k = k.get("D")), Array.isArray(k) ? k : null;
          }
          class o {
            constructor(s, l) {
              if (this.pdfManager = s, this.xref = l, this._catDict = l.getCatalogObj(), !(this._catDict instanceof q.Dict))
                throw new u.FormatError("Catalog object is not a dictionary.");
              this.toplevelPagesDict, this._actualNumPages = null, this.fontCache = new q.RefSetCache(), this.builtInCMapCache = /* @__PURE__ */ new Map(), this.standardFontDataCache = /* @__PURE__ */ new Map(), this.globalImageCache = new O.GlobalImageCache(), this.pageKidsCountCache = new q.RefSetCache(), this.pageIndexCache = new q.RefSetCache(), this.nonBlendModesSet = new q.RefSet(), this.systemFontCache = /* @__PURE__ */ new Map();
            }
            get version() {
              const s = this._catDict.get("Version");
              if (s instanceof q.Name) {
                if (n.PDF_VERSION_REGEXP.test(s.name))
                  return (0, u.shadow)(this, "version", s.name);
                (0, u.warn)(`Invalid PDF catalog version: ${s.name}`);
              }
              return (0, u.shadow)(this, "version", null);
            }
            get lang() {
              const s = this._catDict.get("Lang");
              return (0, u.shadow)(this, "lang", typeof s == "string" ? (0, u.stringToPDFString)(s) : null);
            }
            get needsRendering() {
              const s = this._catDict.get("NeedsRendering");
              return (0, u.shadow)(this, "needsRendering", typeof s == "boolean" ? s : !1);
            }
            get collection() {
              let s = null;
              try {
                const l = this._catDict.get("Collection");
                l instanceof q.Dict && l.size > 0 && (s = l);
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.info)("Cannot fetch Collection entry; assuming no collection is present.");
              }
              return (0, u.shadow)(this, "collection", s);
            }
            get acroForm() {
              let s = null;
              try {
                const l = this._catDict.get("AcroForm");
                l instanceof q.Dict && l.size > 0 && (s = l);
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.info)("Cannot fetch AcroForm entry; assuming no forms are present.");
              }
              return (0, u.shadow)(this, "acroForm", s);
            }
            get acroFormRef() {
              const s = this._catDict.getRaw("AcroForm");
              return (0, u.shadow)(this, "acroFormRef", s instanceof q.Ref ? s : null);
            }
            get metadata() {
              var g;
              const s = this._catDict.getRaw("Metadata");
              if (!(s instanceof q.Ref))
                return (0, u.shadow)(this, "metadata", null);
              let l = null;
              try {
                const v = this.xref.fetch(s, !((g = this.xref.encrypt) != null && g.encryptMetadata));
                if (v instanceof t.BaseStream && v.dict instanceof q.Dict) {
                  const r = v.dict.get("Type"), x = v.dict.get("Subtype");
                  if ((0, q.isName)(r, "Metadata") && (0, q.isName)(x, "XML")) {
                    const b = (0, u.stringToUTF8String)(v.getString());
                    b && (l = new w.MetadataParser(b).serializable);
                  }
                }
              } catch (v) {
                if (v instanceof n.MissingDataException)
                  throw v;
                (0, u.info)(`Skipping invalid Metadata: "${v}".`);
              }
              return (0, u.shadow)(this, "metadata", l);
            }
            get markInfo() {
              let s = null;
              try {
                s = this._readMarkInfo();
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.warn)("Unable to read mark info.");
              }
              return (0, u.shadow)(this, "markInfo", s);
            }
            _readMarkInfo() {
              const s = this._catDict.get("MarkInfo");
              if (!(s instanceof q.Dict))
                return null;
              const l = {
                Marked: !1,
                UserProperties: !1,
                Suspects: !1
              };
              for (const g in l) {
                const v = s.get(g);
                typeof v == "boolean" && (l[g] = v);
              }
              return l;
            }
            get structTreeRoot() {
              let s = null;
              try {
                s = this._readStructTreeRoot();
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.warn)("Unable read to structTreeRoot info.");
              }
              return (0, u.shadow)(this, "structTreeRoot", s);
            }
            _readStructTreeRoot() {
              const s = this._catDict.get("StructTreeRoot");
              if (!(s instanceof q.Dict))
                return null;
              const l = new C.StructTreeRoot(s);
              return l.init(), l;
            }
            get toplevelPagesDict() {
              const s = this._catDict.get("Pages");
              if (!(s instanceof q.Dict))
                throw new u.FormatError("Invalid top-level pages dictionary.");
              return (0, u.shadow)(this, "toplevelPagesDict", s);
            }
            get documentOutline() {
              let s = null;
              try {
                s = this._readDocumentOutline();
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.warn)("Unable to read document outline.");
              }
              return (0, u.shadow)(this, "documentOutline", s);
            }
            _readDocumentOutline() {
              let s = this._catDict.get("Outlines");
              if (!(s instanceof q.Dict) || (s = s.getRaw("First"), !(s instanceof q.Ref)))
                return null;
              const l = {
                items: []
              }, g = [{
                obj: s,
                parent: l
              }], v = new q.RefSet();
              v.put(s);
              const r = this.xref, x = new Uint8ClampedArray(3);
              for (; g.length > 0; ) {
                const b = g.shift(), I = r.fetchIfRef(b.obj);
                if (I === null)
                  continue;
                if (!I.has("Title"))
                  throw new u.FormatError("Invalid outline item encountered.");
                const h = {
                  url: null,
                  dest: null,
                  action: null
                };
                o.parseDestDictionary({
                  destDict: I,
                  resultObj: h,
                  docBaseUrl: this.pdfManager.docBaseUrl,
                  docAttachments: this.attachments
                });
                const y = I.get("Title"), P = I.get("F") || 0, c = I.getArray("C"), d = I.get("Count");
                let A = x;
                Array.isArray(c) && c.length === 3 && (c[0] !== 0 || c[1] !== 0 || c[2] !== 0) && (A = j.ColorSpace.singletons.rgb.getRgb(c, 0));
                const N = {
                  action: h.action,
                  attachment: h.attachment,
                  dest: h.dest,
                  url: h.url,
                  unsafeUrl: h.unsafeUrl,
                  newWindow: h.newWindow,
                  setOCGState: h.setOCGState,
                  title: (0, u.stringToPDFString)(y),
                  color: A,
                  count: Number.isInteger(d) ? d : void 0,
                  bold: !!(P & 2),
                  italic: !!(P & 1),
                  items: []
                };
                b.parent.items.push(N), s = I.getRaw("First"), s instanceof q.Ref && !v.has(s) && (g.push({
                  obj: s,
                  parent: N
                }), v.put(s)), s = I.getRaw("Next"), s instanceof q.Ref && !v.has(s) && (g.push({
                  obj: s,
                  parent: b.parent
                }), v.put(s));
              }
              return l.items.length > 0 ? l.items : null;
            }
            get permissions() {
              let s = null;
              try {
                s = this._readPermissions();
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.warn)("Unable to read permissions.");
              }
              return (0, u.shadow)(this, "permissions", s);
            }
            _readPermissions() {
              const s = this.xref.trailer.get("Encrypt");
              if (!(s instanceof q.Dict))
                return null;
              let l = s.get("P");
              if (typeof l != "number")
                return null;
              l += 4294967296;
              const g = [];
              for (const v in u.PermissionFlag) {
                const r = u.PermissionFlag[v];
                l & r && g.push(r);
              }
              return g;
            }
            get optionalContentConfig() {
              let s = null;
              try {
                const l = this._catDict.get("OCProperties");
                if (!l)
                  return (0, u.shadow)(this, "optionalContentConfig", null);
                const g = l.get("D");
                if (!g)
                  return (0, u.shadow)(this, "optionalContentConfig", null);
                const v = l.get("OCGs");
                if (!Array.isArray(v))
                  return (0, u.shadow)(this, "optionalContentConfig", null);
                const r = [], x = [];
                for (const b of v) {
                  if (!(b instanceof q.Ref))
                    continue;
                  x.push(b);
                  const I = this.xref.fetchIfRef(b);
                  r.push({
                    id: b.toString(),
                    name: typeof I.get("Name") == "string" ? (0, u.stringToPDFString)(I.get("Name")) : null,
                    intent: typeof I.get("Intent") == "string" ? (0, u.stringToPDFString)(I.get("Intent")) : null
                  });
                }
                s = this._readOptionalContentConfig(g, x), s.groups = r;
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.warn)(`Unable to read optional content config: ${l}`);
              }
              return (0, u.shadow)(this, "optionalContentConfig", s);
            }
            _readOptionalContentConfig(s, l) {
              function g(h) {
                const y = [];
                if (Array.isArray(h))
                  for (const P of h)
                    P instanceof q.Ref && l.includes(P) && y.push(P.toString());
                return y;
              }
              function v(h, y = 0) {
                if (!Array.isArray(h))
                  return null;
                const P = [];
                for (const d of h) {
                  if (d instanceof q.Ref && l.includes(d)) {
                    b.put(d), P.push(d.toString());
                    continue;
                  }
                  const A = r(d, y);
                  A && P.push(A);
                }
                if (y > 0)
                  return P;
                const c = [];
                for (const d of l)
                  b.has(d) || c.push(d.toString());
                return c.length && P.push({
                  name: null,
                  order: c
                }), P;
              }
              function r(h, y) {
                if (++y > I)
                  return (0, u.warn)("parseNestedOrder - reached MAX_NESTED_LEVELS."), null;
                const P = x.fetchIfRef(h);
                if (!Array.isArray(P))
                  return null;
                const c = x.fetchIfRef(P[0]);
                if (typeof c != "string")
                  return null;
                const d = v(P.slice(1), y);
                return !d || !d.length ? null : {
                  name: (0, u.stringToPDFString)(c),
                  order: d
                };
              }
              const x = this.xref, b = new q.RefSet(), I = 10;
              return {
                name: typeof s.get("Name") == "string" ? (0, u.stringToPDFString)(s.get("Name")) : null,
                creator: typeof s.get("Creator") == "string" ? (0, u.stringToPDFString)(s.get("Creator")) : null,
                baseState: s.get("BaseState") instanceof q.Name ? s.get("BaseState").name : null,
                on: g(s.get("ON")),
                off: g(s.get("OFF")),
                order: v(s.get("Order")),
                groups: null
              };
            }
            setActualNumPages(s = null) {
              this._actualNumPages = s;
            }
            get hasActualNumPages() {
              return this._actualNumPages !== null;
            }
            get _pagesCount() {
              const s = this.toplevelPagesDict.get("Count");
              if (!Number.isInteger(s))
                throw new u.FormatError("Page count in top-level pages dictionary is not an integer.");
              return (0, u.shadow)(this, "_pagesCount", s);
            }
            get numPages() {
              return this.hasActualNumPages ? this._actualNumPages : this._pagesCount;
            }
            get destinations() {
              const s = this._readDests(), l = /* @__PURE__ */ Object.create(null);
              if (s instanceof e.NameTree)
                for (const [g, v] of s.getAll()) {
                  const r = i(v);
                  r && (l[(0, u.stringToPDFString)(g)] = r);
                }
              else
                s instanceof q.Dict && s.forEach(function(g, v) {
                  const r = i(v);
                  r && (l[g] = r);
                });
              return (0, u.shadow)(this, "destinations", l);
            }
            getDestination(s) {
              const l = this._readDests();
              if (l instanceof e.NameTree) {
                const g = i(l.get(s));
                if (g)
                  return g;
                const v = this.destinations[s];
                if (v)
                  return (0, u.warn)(`Found "${s}" at an incorrect position in the NameTree.`), v;
              } else if (l instanceof q.Dict) {
                const g = i(l.get(s));
                if (g)
                  return g;
              }
              return null;
            }
            _readDests() {
              const s = this._catDict.get("Names");
              if (s != null && s.has("Dests"))
                return new e.NameTree(s.getRaw("Dests"), this.xref);
              if (this._catDict.has("Dests"))
                return this._catDict.get("Dests");
            }
            get pageLabels() {
              let s = null;
              try {
                s = this._readPageLabels();
              } catch (l) {
                if (l instanceof n.MissingDataException)
                  throw l;
                (0, u.warn)("Unable to read page labels.");
              }
              return (0, u.shadow)(this, "pageLabels", s);
            }
            _readPageLabels() {
              const s = this._catDict.getRaw("PageLabels");
              if (!s)
                return null;
              const l = new Array(this.numPages);
              let g = null, v = "";
              const x = new e.NumberTree(s, this.xref).getAll();
              let b = "", I = 1;
              for (let h = 0, y = this.numPages; h < y; h++) {
                const P = x.get(h);
                if (P !== void 0) {
                  if (!(P instanceof q.Dict))
                    throw new u.FormatError("PageLabel is not a dictionary.");
                  if (P.has("Type") && !(0, q.isName)(P.get("Type"), "PageLabel"))
                    throw new u.FormatError("Invalid type in PageLabel dictionary.");
                  if (P.has("S")) {
                    const c = P.get("S");
                    if (!(c instanceof q.Name))
                      throw new u.FormatError("Invalid style in PageLabel dictionary.");
                    g = c.name;
                  } else
                    g = null;
                  if (P.has("P")) {
                    const c = P.get("P");
                    if (typeof c != "string")
                      throw new u.FormatError("Invalid prefix in PageLabel dictionary.");
                    v = (0, u.stringToPDFString)(c);
                  } else
                    v = "";
                  if (P.has("St")) {
                    const c = P.get("St");
                    if (!(Number.isInteger(c) && c >= 1))
                      throw new u.FormatError("Invalid start in PageLabel dictionary.");
                    I = c;
                  } else
                    I = 1;
                }
                switch (g) {
                  case "D":
                    b = I;
                    break;
                  case "R":
                  case "r":
                    b = (0, n.toRomanNumerals)(I, g === "r");
                    break;
                  case "A":
                  case "a":
                    const c = 26, N = g === "a" ? 97 : 65, E = I - 1;
                    b = String.fromCharCode(N + E % c).repeat(Math.floor(E / c) + 1);
                    break;
                  default:
                    if (g)
                      throw new u.FormatError(`Invalid style "${g}" in PageLabel dictionary.`);
                    b = "";
                }
                l[h] = v + b, I++;
              }
              return l;
            }
            get pageLayout() {
              const s = this._catDict.get("PageLayout");
              let l = "";
              if (s instanceof q.Name)
                switch (s.name) {
                  case "SinglePage":
                  case "OneColumn":
                  case "TwoColumnLeft":
                  case "TwoColumnRight":
                  case "TwoPageLeft":
                  case "TwoPageRight":
                    l = s.name;
                }
              return (0, u.shadow)(this, "pageLayout", l);
            }
            get pageMode() {
              const s = this._catDict.get("PageMode");
              let l = "UseNone";
              if (s instanceof q.Name)
                switch (s.name) {
                  case "UseNone":
                  case "UseOutlines":
                  case "UseThumbs":
                  case "FullScreen":
                  case "UseOC":
                  case "UseAttachments":
                    l = s.name;
                }
              return (0, u.shadow)(this, "pageMode", l);
            }
            get viewerPreferences() {
              const s = this._catDict.get("ViewerPreferences");
              if (!(s instanceof q.Dict))
                return (0, u.shadow)(this, "viewerPreferences", null);
              let l = null;
              for (const g of s.getKeys()) {
                const v = s.get(g);
                let r;
                switch (g) {
                  case "HideToolbar":
                  case "HideMenubar":
                  case "HideWindowUI":
                  case "FitWindow":
                  case "CenterWindow":
                  case "DisplayDocTitle":
                  case "PickTrayByPDFSize":
                    typeof v == "boolean" && (r = v);
                    break;
                  case "NonFullScreenPageMode":
                    if (v instanceof q.Name)
                      switch (v.name) {
                        case "UseNone":
                        case "UseOutlines":
                        case "UseThumbs":
                        case "UseOC":
                          r = v.name;
                          break;
                        default:
                          r = "UseNone";
                      }
                    break;
                  case "Direction":
                    if (v instanceof q.Name)
                      switch (v.name) {
                        case "L2R":
                        case "R2L":
                          r = v.name;
                          break;
                        default:
                          r = "L2R";
                      }
                    break;
                  case "ViewArea":
                  case "ViewClip":
                  case "PrintArea":
                  case "PrintClip":
                    if (v instanceof q.Name)
                      switch (v.name) {
                        case "MediaBox":
                        case "CropBox":
                        case "BleedBox":
                        case "TrimBox":
                        case "ArtBox":
                          r = v.name;
                          break;
                        default:
                          r = "CropBox";
                      }
                    break;
                  case "PrintScaling":
                    if (v instanceof q.Name)
                      switch (v.name) {
                        case "None":
                        case "AppDefault":
                          r = v.name;
                          break;
                        default:
                          r = "AppDefault";
                      }
                    break;
                  case "Duplex":
                    if (v instanceof q.Name)
                      switch (v.name) {
                        case "Simplex":
                        case "DuplexFlipShortEdge":
                        case "DuplexFlipLongEdge":
                          r = v.name;
                          break;
                        default:
                          r = "None";
                      }
                    break;
                  case "PrintPageRange":
                    Array.isArray(v) && v.length % 2 === 0 && v.every((b, I, h) => Number.isInteger(b) && b > 0 && (I === 0 || b >= h[I - 1]) && b <= this.numPages) && (r = v);
                    break;
                  case "NumCopies":
                    Number.isInteger(v) && v > 0 && (r = v);
                    break;
                  default:
                    (0, u.warn)(`Ignoring non-standard key in ViewerPreferences: ${g}.`);
                    continue;
                }
                if (r === void 0) {
                  (0, u.warn)(`Bad value, for key "${g}", in ViewerPreferences: ${v}.`);
                  continue;
                }
                l || (l = /* @__PURE__ */ Object.create(null)), l[g] = r;
              }
              return (0, u.shadow)(this, "viewerPreferences", l);
            }
            get openAction() {
              const s = this._catDict.get("OpenAction"), l = /* @__PURE__ */ Object.create(null);
              if (s instanceof q.Dict) {
                const g = new q.Dict(this.xref);
                g.set("A", s);
                const v = {
                  url: null,
                  dest: null,
                  action: null
                };
                o.parseDestDictionary({
                  destDict: g,
                  resultObj: v
                }), Array.isArray(v.dest) ? l.dest = v.dest : v.action && (l.action = v.action);
              } else
                Array.isArray(s) && (l.dest = s);
              return (0, u.shadow)(this, "openAction", (0, u.objectSize)(l) > 0 ? l : null);
            }
            get attachments() {
              const s = this._catDict.get("Names");
              let l = null;
              if (s instanceof q.Dict && s.has("EmbeddedFiles")) {
                const g = new e.NameTree(s.getRaw("EmbeddedFiles"), this.xref);
                for (const [v, r] of g.getAll()) {
                  const x = new M.FileSpec(r, this.xref);
                  l || (l = /* @__PURE__ */ Object.create(null)), l[(0, u.stringToPDFString)(v)] = x.serializable;
                }
              }
              return (0, u.shadow)(this, "attachments", l);
            }
            get xfaImages() {
              const s = this._catDict.get("Names");
              let l = null;
              if (s instanceof q.Dict && s.has("XFAImages")) {
                const g = new e.NameTree(s.getRaw("XFAImages"), this.xref);
                for (const [v, r] of g.getAll())
                  l || (l = new q.Dict(this.xref)), l.set((0, u.stringToPDFString)(v), r);
              }
              return (0, u.shadow)(this, "xfaImages", l);
            }
            _collectJavaScript() {
              const s = this._catDict.get("Names");
              let l = null;
              function g(r, x) {
                if (!(x instanceof q.Dict) || !(0, q.isName)(x.get("S"), "JavaScript"))
                  return;
                let b = x.get("JS");
                if (b instanceof t.BaseStream)
                  b = b.getString();
                else if (typeof b != "string")
                  return;
                b = (0, u.stringToPDFString)(b).replaceAll("\0", ""), (l || (l = /* @__PURE__ */ new Map())).set(r, b);
              }
              if (s instanceof q.Dict && s.has("JavaScript")) {
                const r = new e.NameTree(s.getRaw("JavaScript"), this.xref);
                for (const [x, b] of r.getAll())
                  g((0, u.stringToPDFString)(x), b);
              }
              const v = this._catDict.get("OpenAction");
              return v && g("OpenAction", v), l;
            }
            get javaScript() {
              const s = this._collectJavaScript();
              return (0, u.shadow)(this, "javaScript", s ? [...s.values()] : null);
            }
            get jsActions() {
              const s = this._collectJavaScript();
              let l = (0, n.collectActions)(this.xref, this._catDict, u.DocumentActionEventType);
              if (s) {
                l || (l = /* @__PURE__ */ Object.create(null));
                for (const [g, v] of s)
                  g in l ? l[g].push(v) : l[g] = [v];
              }
              return (0, u.shadow)(this, "jsActions", l);
            }
            async fontFallback(s, l) {
              const g = await Promise.all(this.fontCache);
              for (const v of g)
                if (v.loadedName === s) {
                  v.fallback(l);
                  return;
                }
            }
            async cleanup(s = !1) {
              (0, B.clearGlobalCaches)(), this.globalImageCache.clear(s), this.pageKidsCountCache.clear(), this.pageIndexCache.clear(), this.nonBlendModesSet.clear();
              const l = await Promise.all(this.fontCache);
              for (const {
                dict: g
              } of l)
                delete g.cacheKey;
              this.fontCache.clear(), this.builtInCMapCache.clear(), this.standardFontDataCache.clear(), this.systemFontCache.clear();
            }
            async getPageDict(s) {
              const l = [this.toplevelPagesDict], g = new q.RefSet(), v = this._catDict.getRaw("Pages");
              v instanceof q.Ref && g.put(v);
              const r = this.xref, x = this.pageKidsCountCache, b = this.pageIndexCache;
              let I = 0;
              for (; l.length; ) {
                const h = l.pop();
                if (h instanceof q.Ref) {
                  const d = x.get(h);
                  if (d >= 0 && I + d <= s) {
                    I += d;
                    continue;
                  }
                  if (g.has(h))
                    throw new u.FormatError("Pages tree contains circular reference.");
                  g.put(h);
                  const A = await r.fetchAsync(h);
                  if (A instanceof q.Dict) {
                    let N = A.getRaw("Type");
                    if (N instanceof q.Ref && (N = await r.fetchAsync(N)), (0, q.isName)(N, "Page") || !A.has("Kids")) {
                      if (x.has(h) || x.put(h, 1), b.has(h) || b.put(h, I), I === s)
                        return [A, h];
                      I++;
                      continue;
                    }
                  }
                  l.push(A);
                  continue;
                }
                if (!(h instanceof q.Dict))
                  throw new u.FormatError("Page dictionary kid reference points to wrong type of object.");
                const {
                  objId: y
                } = h;
                let P = h.getRaw("Count");
                if (P instanceof q.Ref && (P = await r.fetchAsync(P)), Number.isInteger(P) && P >= 0 && (y && !x.has(y) && x.put(y, P), I + P <= s)) {
                  I += P;
                  continue;
                }
                let c = h.getRaw("Kids");
                if (c instanceof q.Ref && (c = await r.fetchAsync(c)), !Array.isArray(c)) {
                  let d = h.getRaw("Type");
                  if (d instanceof q.Ref && (d = await r.fetchAsync(d)), (0, q.isName)(d, "Page") || !h.has("Kids")) {
                    if (I === s)
                      return [h, null];
                    I++;
                    continue;
                  }
                  throw new u.FormatError("Page dictionary kids object is not an array.");
                }
                for (let d = c.length - 1; d >= 0; d--)
                  l.push(c[d]);
              }
              throw new Error(`Page index ${s} not found.`);
            }
            async getAllPageDicts(s = !1) {
              const {
                ignoreErrors: l
              } = this.pdfManager.evaluatorOptions, g = [{
                currentNode: this.toplevelPagesDict,
                posInKids: 0
              }], v = new q.RefSet(), r = this._catDict.getRaw("Pages");
              r instanceof q.Ref && v.put(r);
              const x = /* @__PURE__ */ new Map(), b = this.xref, I = this.pageIndexCache;
              let h = 0;
              function y(c, d) {
                d && !I.has(d) && I.put(d, h), x.set(h++, [c, d]);
              }
              function P(c) {
                if (c instanceof n.XRefEntryException && !s)
                  throw c;
                s && l && h === 0 && ((0, u.warn)(`getAllPageDicts - Skipping invalid first page: "${c}".`), c = q.Dict.empty), x.set(h++, [c, null]);
              }
              for (; g.length > 0; ) {
                const c = g.at(-1), {
                  currentNode: d,
                  posInKids: A
                } = c;
                let N = d.getRaw("Kids");
                if (N instanceof q.Ref)
                  try {
                    N = await b.fetchAsync(N);
                  } catch (m) {
                    P(m);
                    break;
                  }
                if (!Array.isArray(N)) {
                  P(new u.FormatError("Page dictionary kids object is not an array."));
                  break;
                }
                if (A >= N.length) {
                  g.pop();
                  continue;
                }
                const E = N[A];
                let H;
                if (E instanceof q.Ref) {
                  if (v.has(E)) {
                    P(new u.FormatError("Pages tree contains circular reference."));
                    break;
                  }
                  v.put(E);
                  try {
                    H = await b.fetchAsync(E);
                  } catch (m) {
                    P(m);
                    break;
                  }
                } else
                  H = E;
                if (!(H instanceof q.Dict)) {
                  P(new u.FormatError("Page dictionary kid reference points to wrong type of object."));
                  break;
                }
                let $ = H.getRaw("Type");
                if ($ instanceof q.Ref)
                  try {
                    $ = await b.fetchAsync($);
                  } catch (m) {
                    P(m);
                    break;
                  }
                (0, q.isName)($, "Page") || !H.has("Kids") ? y(H, E instanceof q.Ref ? E : null) : g.push({
                  currentNode: H,
                  posInKids: 0
                }), c.posInKids++;
              }
              return x;
            }
            getPageIndex(s) {
              const l = this.pageIndexCache.get(s);
              if (l !== void 0)
                return Promise.resolve(l);
              const g = this.xref;
              function v(b) {
                let I = 0, h;
                return g.fetchAsync(b).then(function(y) {
                  if ((0, q.isRefsEqual)(b, s) && !(0, q.isDict)(y, "Page") && !(y instanceof q.Dict && !y.has("Type") && y.has("Contents")))
                    throw new u.FormatError("The reference does not point to a /Page dictionary.");
                  if (!y)
                    return null;
                  if (!(y instanceof q.Dict))
                    throw new u.FormatError("Node must be a dictionary.");
                  return h = y.getRaw("Parent"), y.getAsync("Parent");
                }).then(function(y) {
                  if (!y)
                    return null;
                  if (!(y instanceof q.Dict))
                    throw new u.FormatError("Parent must be a dictionary.");
                  return y.getAsync("Kids");
                }).then(function(y) {
                  if (!y)
                    return null;
                  const P = [];
                  let c = !1;
                  for (const d of y) {
                    if (!(d instanceof q.Ref))
                      throw new u.FormatError("Kid must be a reference.");
                    if ((0, q.isRefsEqual)(d, b)) {
                      c = !0;
                      break;
                    }
                    P.push(g.fetchAsync(d).then(function(A) {
                      if (!(A instanceof q.Dict))
                        throw new u.FormatError("Kid node must be a dictionary.");
                      A.has("Count") ? I += A.get("Count") : I++;
                    }));
                  }
                  if (!c)
                    throw new u.FormatError("Kid reference not found in parent's kids.");
                  return Promise.all(P).then(function() {
                    return [I, h];
                  });
                });
              }
              let r = 0;
              const x = (b) => v(b).then((I) => {
                if (!I)
                  return this.pageIndexCache.put(s, r), r;
                const [h, y] = I;
                return r += h, x(y);
              });
              return x(s);
            }
            get baseUrl() {
              const s = this._catDict.get("URI");
              if (s instanceof q.Dict) {
                const l = s.get("Base");
                if (typeof l == "string") {
                  const g = (0, u.createValidAbsoluteUrl)(l, null, {
                    tryConvertEncoding: !0
                  });
                  if (g)
                    return (0, u.shadow)(this, "baseUrl", g.href);
                }
              }
              return (0, u.shadow)(this, "baseUrl", null);
            }
            static parseDestDictionary(s) {
              const l = s.destDict;
              if (!(l instanceof q.Dict)) {
                (0, u.warn)("parseDestDictionary: `destDict` must be a dictionary.");
                return;
              }
              const g = s.resultObj;
              if (typeof g != "object") {
                (0, u.warn)("parseDestDictionary: `resultObj` must be an object.");
                return;
              }
              const v = s.docBaseUrl || null, r = s.docAttachments || null;
              let x = l.get("A"), b, I;
              if (x instanceof q.Dict || (l.has("Dest") ? x = l.get("Dest") : (x = l.get("AA"), x instanceof q.Dict && (x.has("D") ? x = x.get("D") : x.has("U") && (x = x.get("U"))))), x instanceof q.Dict) {
                const h = x.get("S");
                if (!(h instanceof q.Name)) {
                  (0, u.warn)("parseDestDictionary: Invalid type in Action dictionary.");
                  return;
                }
                const y = h.name;
                switch (y) {
                  case "ResetForm":
                    const P = x.get("Flags"), c = ((typeof P == "number" ? P : 0) & 1) === 0, d = [], A = [];
                    for (const V of x.get("Fields") || [])
                      V instanceof q.Ref ? A.push(V.toString()) : typeof V == "string" && d.push((0, u.stringToPDFString)(V));
                    g.resetForm = {
                      fields: d,
                      refs: A,
                      include: c
                    };
                    break;
                  case "URI":
                    b = x.get("URI"), b instanceof q.Name && (b = "/" + b.name);
                    break;
                  case "GoTo":
                    I = x.get("D");
                    break;
                  case "Launch":
                  case "GoToR":
                    const N = x.get("F");
                    N instanceof q.Dict ? b = N.get("F") || null : typeof N == "string" && (b = N);
                    let E = x.get("D");
                    if (E && (E instanceof q.Name && (E = E.name), typeof b == "string")) {
                      const V = b.split("#")[0];
                      typeof E == "string" ? b = V + "#" + E : Array.isArray(E) && (b = V + "#" + JSON.stringify(E));
                    }
                    const H = x.get("NewWindow");
                    typeof H == "boolean" && (g.newWindow = H);
                    break;
                  case "GoToE":
                    const $ = x.get("T");
                    let m;
                    if (r && $ instanceof q.Dict) {
                      const V = $.get("R"), U = $.get("N");
                      (0, q.isName)(V, "C") && typeof U == "string" && (m = r[(0, u.stringToPDFString)(U)]);
                    }
                    m ? g.attachment = m : (0, u.warn)('parseDestDictionary - unimplemented "GoToE" action.');
                    break;
                  case "Named":
                    const p = x.get("N");
                    p instanceof q.Name && (g.action = p.name);
                    break;
                  case "SetOCGState":
                    const T = x.get("State"), L = x.get("PreserveRB");
                    if (!Array.isArray(T) || T.length === 0)
                      break;
                    const _ = [];
                    for (const V of T)
                      if (V instanceof q.Name)
                        switch (V.name) {
                          case "ON":
                          case "OFF":
                          case "Toggle":
                            _.push(V.name);
                            break;
                        }
                      else
                        V instanceof q.Ref && _.push(V.toString());
                    if (_.length !== T.length)
                      break;
                    g.setOCGState = {
                      state: _,
                      preserveRB: typeof L == "boolean" ? L : !0
                    };
                    break;
                  case "JavaScript":
                    const G = x.get("JS");
                    let J;
                    G instanceof t.BaseStream ? J = G.getString() : typeof G == "string" && (J = G);
                    const K = J && (0, n.recoverJsURL)((0, u.stringToPDFString)(J));
                    if (K) {
                      b = K.url, g.newWindow = K.newWindow;
                      break;
                    }
                  default:
                    if (y === "JavaScript" || y === "SubmitForm")
                      break;
                    (0, u.warn)(`parseDestDictionary - unsupported action: "${y}".`);
                    break;
                }
              } else
                l.has("Dest") && (I = l.get("Dest"));
              if (typeof b == "string") {
                const h = (0, u.createValidAbsoluteUrl)(b, v, {
                  addDefaultProtocol: !0,
                  tryConvertEncoding: !0
                });
                h && (g.url = h.href), g.unsafeUrl = b;
              }
              I && (I instanceof q.Name && (I = I.name), typeof I == "string" ? g.dest = (0, u.stringToPDFString)(I) : Array.isArray(I) && (g.dest = I));
            }
          }
          F.Catalog = o;
        },
        /* 71 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.NumberTree = F.NameTree = void 0;
          var n = ae(4), u = ae(2);
          class q {
            constructor(j, M, O) {
              this.constructor === q && (0, u.unreachable)("Cannot initialize NameOrNumberTree."), this.root = j, this.xref = M, this._type = O;
            }
            getAll() {
              const j = /* @__PURE__ */ new Map();
              if (!this.root)
                return j;
              const M = this.xref, O = new n.RefSet();
              O.put(this.root);
              const w = [this.root];
              for (; w.length > 0; ) {
                const C = M.fetchIfRef(w.shift());
                if (!(C instanceof n.Dict))
                  continue;
                if (C.has("Kids")) {
                  const o = C.get("Kids");
                  if (!Array.isArray(o))
                    continue;
                  for (const k of o) {
                    if (O.has(k))
                      throw new u.FormatError(`Duplicate entry in "${this._type}" tree.`);
                    w.push(k), O.put(k);
                  }
                  continue;
                }
                const i = C.get(this._type);
                if (Array.isArray(i))
                  for (let o = 0, k = i.length; o < k; o += 2)
                    j.set(M.fetchIfRef(i[o]), M.fetchIfRef(i[o + 1]));
              }
              return j;
            }
            get(j) {
              if (!this.root)
                return null;
              const M = this.xref;
              let O = M.fetchIfRef(this.root), w = 0;
              const C = 10;
              for (; O.has("Kids"); ) {
                if (++w > C)
                  return (0, u.warn)(`Search depth limit reached for "${this._type}" tree.`), null;
                const o = O.get("Kids");
                if (!Array.isArray(o))
                  return null;
                let k = 0, s = o.length - 1;
                for (; k <= s; ) {
                  const l = k + s >> 1, g = M.fetchIfRef(o[l]), v = g.get("Limits");
                  if (j < M.fetchIfRef(v[0]))
                    s = l - 1;
                  else if (j > M.fetchIfRef(v[1]))
                    k = l + 1;
                  else {
                    O = g;
                    break;
                  }
                }
                if (k > s)
                  return null;
              }
              const i = O.get(this._type);
              if (Array.isArray(i)) {
                let o = 0, k = i.length - 2;
                for (; o <= k; ) {
                  const s = o + k >> 1, l = s + (s & 1), g = M.fetchIfRef(i[l]);
                  if (j < g)
                    k = l - 2;
                  else if (j > g)
                    o = l + 2;
                  else
                    return M.fetchIfRef(i[l + 1]);
                }
              }
              return null;
            }
          }
          class e extends q {
            constructor(j, M) {
              super(j, M, "Names");
            }
          }
          F.NameTree = e;
          class t extends q {
            constructor(j, M) {
              super(j, M, "Nums");
            }
          }
          F.NumberTree = t;
        },
        /* 72 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.clearGlobalCaches = q;
          var n = ae(4), u = ae(40);
          function q() {
            (0, n.clearPrimitiveCaches)(), (0, u.clearUnicodeCaches)();
          }
        },
        /* 73 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.FileSpec = void 0;
          var n = ae(2), u = ae(5), q = ae(4);
          function e(B) {
            return B.has("UF") ? B.get("UF") : B.has("F") ? B.get("F") : B.has("Unix") ? B.get("Unix") : B.has("Mac") ? B.get("Mac") : B.has("DOS") ? B.get("DOS") : null;
          }
          class t {
            constructor(j, M) {
              j instanceof q.Dict && (this.xref = M, this.root = j, j.has("FS") && (this.fs = j.get("FS")), this.description = j.has("Desc") ? (0, n.stringToPDFString)(j.get("Desc")) : "", j.has("RF") && (0, n.warn)("Related file specifications are not supported"), this.contentAvailable = !0, j.has("EF") || (this.contentAvailable = !1, (0, n.warn)("Non-embedded file specifications are not supported")));
            }
            get filename() {
              if (!this._filename && this.root) {
                const j = e(this.root) || "unnamed";
                this._filename = (0, n.stringToPDFString)(j).replaceAll("\\\\", "\\").replaceAll("\\/", "/").replaceAll("\\", "/");
              }
              return this._filename;
            }
            get content() {
              if (!this.contentAvailable)
                return null;
              !this.contentRef && this.root && (this.contentRef = e(this.root.get("EF")));
              let j = null;
              if (this.contentRef) {
                const M = this.xref.fetchIfRef(this.contentRef);
                M instanceof u.BaseStream ? j = M.getBytes() : (0, n.warn)("Embedded file specification points to non-existing/invalid content");
              } else
                (0, n.warn)("Embedded file specification does not have a content");
              return j;
            }
            get serializable() {
              return {
                filename: this.filename,
                content: this.content
              };
            }
          }
          F.FileSpec = t;
        },
        /* 74 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.MetadataParser = void 0;
          var n = ae(67);
          class u {
            constructor(e) {
              e = this._repair(e);
              const B = new n.SimpleXMLParser({
                lowerCaseName: !0
              }).parseFromString(e);
              this._metadataMap = /* @__PURE__ */ new Map(), this._data = e, B && this._parse(B);
            }
            _repair(e) {
              return e.replace(/^[^<]+/, "").replaceAll(/>\\376\\377([^<]+)/g, function(t, B) {
                const j = B.replaceAll(/\\([0-3])([0-7])([0-7])/g, function(O, w, C, i) {
                  return String.fromCharCode(w * 64 + C * 8 + i * 1);
                }).replaceAll(/&(amp|apos|gt|lt|quot);/g, function(O, w) {
                  switch (w) {
                    case "amp":
                      return "&";
                    case "apos":
                      return "'";
                    case "gt":
                      return ">";
                    case "lt":
                      return "<";
                    case "quot":
                      return '"';
                  }
                  throw new Error(`_repair: ${w} isn't defined.`);
                }), M = [">"];
                for (let O = 0, w = j.length; O < w; O += 2) {
                  const C = j.charCodeAt(O) * 256 + j.charCodeAt(O + 1);
                  C >= 32 && C < 127 && C !== 60 && C !== 62 && C !== 38 ? M.push(String.fromCharCode(C)) : M.push("&#x" + (65536 + C).toString(16).substring(1) + ";");
                }
                return M.join("");
              });
            }
            _getSequence(e) {
              const t = e.nodeName;
              return t !== "rdf:bag" && t !== "rdf:seq" && t !== "rdf:alt" ? null : e.childNodes.filter((B) => B.nodeName === "rdf:li");
            }
            _parseArray(e) {
              if (!e.hasChildNodes())
                return;
              const [t] = e.childNodes, B = this._getSequence(t) || [];
              this._metadataMap.set(e.nodeName, B.map((j) => j.textContent.trim()));
            }
            _parse(e) {
              let t = e.documentElement;
              if (t.nodeName !== "rdf:rdf")
                for (t = t.firstChild; t && t.nodeName !== "rdf:rdf"; )
                  t = t.nextSibling;
              if (!(!t || t.nodeName !== "rdf:rdf" || !t.hasChildNodes())) {
                for (const B of t.childNodes)
                  if (B.nodeName === "rdf:description")
                    for (const j of B.childNodes) {
                      const M = j.nodeName;
                      switch (M) {
                        case "#text":
                          continue;
                        case "dc:creator":
                        case "dc:subject":
                          this._parseArray(j);
                          continue;
                      }
                      this._metadataMap.set(M, j.textContent.trim());
                    }
              }
            }
            get serializable() {
              return {
                parsedData: this._metadataMap,
                rawData: this._data
              };
            }
          }
          F.MetadataParser = u;
        },
        /* 75 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.StructTreeRoot = F.StructTreePage = void 0;
          var n = ae(4), u = ae(2), q = ae(71);
          const e = 40, t = {
            PAGE_CONTENT: "PAGE_CONTENT",
            STREAM_CONTENT: "STREAM_CONTENT",
            OBJECT: "OBJECT",
            ELEMENT: "ELEMENT"
          };
          class B {
            constructor(C) {
              this.dict = C, this.roleMap = /* @__PURE__ */ new Map();
            }
            init() {
              this.readRoleMap();
            }
            readRoleMap() {
              const C = this.dict.get("RoleMap");
              C instanceof n.Dict && C.forEach((i, o) => {
                o instanceof n.Name && this.roleMap.set(i, o.name);
              });
            }
          }
          F.StructTreeRoot = B;
          class j {
            constructor(C, i) {
              this.tree = C, this.dict = i, this.kids = [], this.parseKids();
            }
            get role() {
              const C = this.dict.get("S"), i = C instanceof n.Name ? C.name : "", {
                root: o
              } = this.tree;
              return o.roleMap.has(i) ? o.roleMap.get(i) : i;
            }
            parseKids() {
              let C = null;
              const i = this.dict.getRaw("Pg");
              i instanceof n.Ref && (C = i.toString());
              const o = this.dict.get("K");
              if (Array.isArray(o))
                for (const k of o) {
                  const s = this.parseKid(C, k);
                  s && this.kids.push(s);
                }
              else {
                const k = this.parseKid(C, o);
                k && this.kids.push(k);
              }
            }
            parseKid(C, i) {
              if (Number.isInteger(i))
                return this.tree.pageDict.objId !== C ? null : new M({
                  type: t.PAGE_CONTENT,
                  mcid: i,
                  pageObjId: C
                });
              let o = null;
              if (i instanceof n.Ref ? o = this.dict.xref.fetch(i) : i instanceof n.Dict && (o = i), !o)
                return null;
              const k = o.getRaw("Pg");
              k instanceof n.Ref && (C = k.toString());
              const s = o.get("Type") instanceof n.Name ? o.get("Type").name : null;
              return s === "MCR" ? this.tree.pageDict.objId !== C ? null : new M({
                type: t.STREAM_CONTENT,
                refObjId: o.getRaw("Stm") instanceof n.Ref ? o.getRaw("Stm").toString() : null,
                pageObjId: C,
                mcid: o.get("MCID")
              }) : s === "OBJR" ? this.tree.pageDict.objId !== C ? null : new M({
                type: t.OBJECT,
                refObjId: o.getRaw("Obj") instanceof n.Ref ? o.getRaw("Obj").toString() : null,
                pageObjId: C
              }) : new M({
                type: t.ELEMENT,
                dict: o
              });
            }
          }
          class M {
            constructor({
              type: C,
              dict: i = null,
              mcid: o = null,
              pageObjId: k = null,
              refObjId: s = null
            }) {
              this.type = C, this.dict = i, this.mcid = o, this.pageObjId = k, this.refObjId = s, this.parentNode = null;
            }
          }
          class O {
            constructor(C, i) {
              this.root = C, this.rootDict = C ? C.dict : null, this.pageDict = i, this.nodes = [];
            }
            parse() {
              if (!this.root || !this.rootDict)
                return;
              const C = this.rootDict.get("ParentTree");
              if (!C)
                return;
              const i = this.pageDict.get("StructParents");
              if (!Number.isInteger(i))
                return;
              const k = new q.NumberTree(C, this.rootDict.xref).get(i);
              if (!Array.isArray(k))
                return;
              const s = /* @__PURE__ */ new Map();
              for (const l of k)
                l instanceof n.Ref && this.addNode(this.rootDict.xref.fetch(l), s);
            }
            addNode(C, i, o = 0) {
              if (o > e)
                return (0, u.warn)("StructTree MAX_DEPTH reached."), null;
              if (i.has(C))
                return i.get(C);
              const k = new j(this, C);
              i.set(C, k);
              const s = C.get("P");
              if (!s || (0, n.isName)(s.get("Type"), "StructTreeRoot"))
                return this.addTopLevelNode(C, k) || i.delete(C), k;
              const l = this.addNode(s, i, o + 1);
              if (!l)
                return k;
              let g = !1;
              for (const v of l.kids)
                v.type === t.ELEMENT && v.dict === C && (v.parentNode = k, g = !0);
              return g || i.delete(C), k;
            }
            addTopLevelNode(C, i) {
              const o = this.rootDict.get("K");
              if (!o)
                return !1;
              if (o instanceof n.Dict)
                return o.objId !== C.objId ? !1 : (this.nodes[0] = i, !0);
              if (!Array.isArray(o))
                return !0;
              let k = !1;
              for (let s = 0; s < o.length; s++) {
                const l = o[s];
                (l == null ? void 0 : l.toString()) === C.objId && (this.nodes[s] = i, k = !0);
              }
              return k;
            }
            get serializable() {
              function C(o, k, s = 0) {
                if (s > e) {
                  (0, u.warn)("StructTree too deep to be fully serialized.");
                  return;
                }
                const l = /* @__PURE__ */ Object.create(null);
                l.role = o.role, l.children = [], k.children.push(l);
                const g = o.dict.get("Alt");
                typeof g == "string" && (l.alt = (0, u.stringToPDFString)(g));
                const v = o.dict.get("Lang");
                typeof v == "string" && (l.lang = (0, u.stringToPDFString)(v));
                for (const r of o.kids) {
                  const x = r.type === t.ELEMENT ? r.parentNode : null;
                  if (x) {
                    C(x, l, s + 1);
                    continue;
                  } else
                    r.type === t.PAGE_CONTENT || r.type === t.STREAM_CONTENT ? l.children.push({
                      type: "content",
                      id: `p${r.pageObjId}_mc${r.mcid}`
                    }) : r.type === t.OBJECT && l.children.push({
                      type: "object",
                      id: r.refObjId
                    });
                }
              }
              const i = /* @__PURE__ */ Object.create(null);
              i.children = [], i.role = "Root";
              for (const o of this.nodes)
                o && C(o, i);
              return i;
            }
          }
          F.StructTreePage = O;
        },
        /* 76 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ObjectLoader = void 0;
          var n = ae(4), u = ae(5), q = ae(3), e = ae(2);
          function t(M) {
            return M instanceof n.Ref || M instanceof n.Dict || M instanceof u.BaseStream || Array.isArray(M);
          }
          function B(M, O) {
            if (M instanceof n.Dict)
              M = M.getRawValues();
            else if (M instanceof u.BaseStream)
              M = M.dict.getRawValues();
            else if (!Array.isArray(M))
              return;
            for (const w of M)
              t(w) && O.push(w);
          }
          class j {
            constructor(O, w, C) {
              this.dict = O, this.keys = w, this.xref = C, this.refSet = null;
            }
            async load() {
              if (this.xref.stream.isDataLoaded)
                return;
              const {
                keys: O,
                dict: w
              } = this;
              this.refSet = new n.RefSet();
              const C = [];
              for (const i of O) {
                const o = w.getRaw(i);
                o !== void 0 && C.push(o);
              }
              return this._walk(C);
            }
            async _walk(O) {
              const w = [], C = [];
              for (; O.length; ) {
                let i = O.pop();
                if (i instanceof n.Ref) {
                  if (this.refSet.has(i))
                    continue;
                  try {
                    this.refSet.put(i), i = this.xref.fetch(i);
                  } catch (o) {
                    if (!(o instanceof q.MissingDataException)) {
                      (0, e.warn)(`ObjectLoader._walk - requesting all data: "${o}".`), this.refSet = null;
                      const {
                        manager: k
                      } = this.xref.stream;
                      return k.requestAllChunks();
                    }
                    w.push(i), C.push({
                      begin: o.begin,
                      end: o.end
                    });
                  }
                }
                if (i instanceof u.BaseStream) {
                  const o = i.getBaseStreams();
                  if (o) {
                    let k = !1;
                    for (const s of o)
                      s.isDataLoaded || (k = !0, C.push({
                        begin: s.start,
                        end: s.end
                      }));
                    k && w.push(i);
                  }
                }
                B(i, O);
              }
              if (C.length) {
                await this.xref.stream.manager.requestRanges(C);
                for (const i of w)
                  i instanceof n.Ref && this.refSet.remove(i);
                return this._walk(w);
              }
              this.refSet = null;
            }
          }
          F.ObjectLoader = j;
        },
        /* 77 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XFAFactory = void 0;
          var n = ae(78), u = ae(82), q = ae(88), e = ae(86), t = ae(79), B = ae(2), j = ae(89), M = ae(99);
          class O {
            constructor(C) {
              try {
                this.root = new j.XFAParser().parse(O._createDocument(C));
                const i = new u.Binder(this.root);
                this.form = i.bind(), this.dataHandler = new q.DataHandler(this.root, i.getData()), this.form[n.$globalData].template = this.form;
              } catch (i) {
                (0, B.warn)(`XFA - an error occurred during parsing and binding: ${i}`);
              }
            }
            isValid() {
              return this.root && this.form;
            }
            _createPagesHelper() {
              const C = this.form[n.$toPages]();
              return new Promise((i, o) => {
                const k = () => {
                  try {
                    const s = C.next();
                    s.done ? i(s.value) : setTimeout(k, 0);
                  } catch (s) {
                    o(s);
                  }
                };
                setTimeout(k, 0);
              });
            }
            async _createPages() {
              try {
                this.pages = await this._createPagesHelper(), this.dims = this.pages.children.map((C) => {
                  const {
                    width: i,
                    height: o
                  } = C.attributes.style;
                  return [0, 0, parseInt(i), parseInt(o)];
                });
              } catch (C) {
                (0, B.warn)(`XFA - an error occurred during layout: ${C}`);
              }
            }
            getBoundingBox(C) {
              return this.dims[C];
            }
            async getNumPages() {
              return this.pages || await this._createPages(), this.dims.length;
            }
            setImages(C) {
              this.form[n.$globalData].images = C;
            }
            setFonts(C) {
              this.form[n.$globalData].fontFinder = new e.FontFinder(C);
              const i = [];
              for (let o of this.form[n.$globalData].usedTypefaces)
                o = (0, t.stripQuotes)(o), this.form[n.$globalData].fontFinder.find(o) || i.push(o);
              return i.length > 0 ? i : null;
            }
            appendFonts(C, i) {
              this.form[n.$globalData].fontFinder.add(C, i);
            }
            async getPages() {
              this.pages || await this._createPages();
              const C = this.pages;
              return this.pages = null, C;
            }
            serializeData(C) {
              return this.dataHandler.serialize(C);
            }
            static _createDocument(C) {
              return C["/xdp:xdp"] ? Object.values(C).join("") : C["xdp:xdp"];
            }
            static getRichTextAsHtml(C) {
              if (!C || typeof C != "string")
                return null;
              try {
                let i = new j.XFAParser(M.XhtmlNamespace, !0).parse(C);
                if (!["body", "xhtml"].includes(i[n.$nodeName])) {
                  const l = M.XhtmlNamespace.body({});
                  l[n.$appendChild](i), i = l;
                }
                const o = i[n.$toHTML]();
                if (!o.success)
                  return null;
                const {
                  html: k
                } = o, {
                  attributes: s
                } = k;
                return s && (s.class && (s.class = s.class.filter((l) => !l.startsWith("xfa"))), s.dir = "auto"), {
                  html: k,
                  str: i[n.$text]()
                };
              } catch (i) {
                (0, B.warn)(`XFA - an error occurred during parsing of rich text: ${i}`);
              }
              return null;
            }
          }
          F.XFAFactory = O;
        },
        /* 78 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XmlObject = F.XFAObjectArray = F.XFAObject = F.XFAAttribute = F.StringObject = F.OptionObject = F.Option10 = F.Option01 = F.IntegerObject = F.ContentObject = F.$uid = F.$toStyle = F.$toString = F.$toPages = F.$toHTML = F.$text = F.$tabIndex = F.$setValue = F.$setSetAttributes = F.$setId = F.$searchNode = F.$root = F.$resolvePrototypes = F.$removeChild = F.$pushPara = F.$pushGlyphs = F.$popPara = F.$onText = F.$onChildCheck = F.$onChild = F.$nsAttributes = F.$nodeName = F.$namespaceId = F.$isUsable = F.$isTransparent = F.$isThereMoreWidth = F.$isSplittable = F.$isNsAgnostic = F.$isDescendent = F.$isDataValue = F.$isCDATAXml = F.$isBindable = F.$insertAt = F.$indexOf = F.$ids = F.$hasSettableValue = F.$globalData = F.$getTemplateRoot = F.$getSubformParent = F.$getRealChildrenByNameIt = F.$getParent = F.$getNextPage = F.$getExtra = F.$getDataValue = F.$getContainedChildren = F.$getChildrenByNameIt = F.$getChildrenByName = F.$getChildrenByClass = F.$getChildren = F.$getAvailableSpace = F.$getAttributes = F.$getAttributeIt = F.$flushHTML = F.$finalize = F.$extra = F.$dump = F.$data = F.$content = F.$consumed = F.$clone = F.$cleanup = F.$cleanPage = F.$clean = F.$childrenToHTML = F.$appendChild = F.$addHTML = F.$acceptWhitespace = void 0;
          var n = ae(79), u = ae(2), q = ae(3), e = ae(80), t = ae(81);
          const B = Symbol();
          F.$acceptWhitespace = B;
          const j = Symbol();
          F.$addHTML = j;
          const M = Symbol();
          F.$appendChild = M;
          const O = Symbol();
          F.$childrenToHTML = O;
          const w = Symbol();
          F.$clean = w;
          const C = Symbol();
          F.$cleanPage = C;
          const i = Symbol();
          F.$cleanup = i;
          const o = Symbol();
          F.$clone = o;
          const k = Symbol();
          F.$consumed = k;
          const s = Symbol("content");
          F.$content = s;
          const l = Symbol("data");
          F.$data = l;
          const g = Symbol();
          F.$dump = g;
          const v = Symbol("extra");
          F.$extra = v;
          const r = Symbol();
          F.$finalize = r;
          const x = Symbol();
          F.$flushHTML = x;
          const b = Symbol();
          F.$getAttributeIt = b;
          const I = Symbol();
          F.$getAttributes = I;
          const h = Symbol();
          F.$getAvailableSpace = h;
          const y = Symbol();
          F.$getChildrenByClass = y;
          const P = Symbol();
          F.$getChildrenByName = P;
          const c = Symbol();
          F.$getChildrenByNameIt = c;
          const d = Symbol();
          F.$getDataValue = d;
          const A = Symbol();
          F.$getExtra = A;
          const N = Symbol();
          F.$getRealChildrenByNameIt = N;
          const E = Symbol();
          F.$getChildren = E;
          const H = Symbol();
          F.$getContainedChildren = H;
          const $ = Symbol();
          F.$getNextPage = $;
          const m = Symbol();
          F.$getSubformParent = m;
          const p = Symbol();
          F.$getParent = p;
          const T = Symbol();
          F.$getTemplateRoot = T;
          const L = Symbol();
          F.$globalData = L;
          const _ = Symbol();
          F.$hasSettableValue = _;
          const G = Symbol();
          F.$ids = G;
          const J = Symbol();
          F.$indexOf = J;
          const K = Symbol();
          F.$insertAt = K;
          const V = Symbol();
          F.$isCDATAXml = V;
          const U = Symbol();
          F.$isBindable = U;
          const Q = Symbol();
          F.$isDataValue = Q;
          const X = Symbol();
          F.$isDescendent = X;
          const R = Symbol();
          F.$isNsAgnostic = R;
          const f = Symbol();
          F.$isSplittable = f;
          const D = Symbol();
          F.$isThereMoreWidth = D;
          const z = Symbol();
          F.$isTransparent = z;
          const Y = Symbol();
          F.$isUsable = Y;
          const W = Symbol(), ie = Symbol("namespaceId");
          F.$namespaceId = ie;
          const ne = Symbol("nodeName");
          F.$nodeName = ne;
          const re = Symbol();
          F.$nsAttributes = re;
          const ee = Symbol();
          F.$onChild = ee;
          const te = Symbol();
          F.$onChildCheck = te;
          const oe = Symbol();
          F.$onText = oe;
          const se = Symbol();
          F.$pushGlyphs = se;
          const ce = Symbol();
          F.$popPara = ce;
          const le = Symbol();
          F.$pushPara = le;
          const de = Symbol();
          F.$removeChild = de;
          const Ie = Symbol("root");
          F.$root = Ie;
          const Fe = Symbol();
          F.$resolvePrototypes = Fe;
          const we = Symbol();
          F.$searchNode = we;
          const pe = Symbol();
          F.$setId = pe;
          const fe = Symbol();
          F.$setSetAttributes = fe;
          const Ae = Symbol();
          F.$setValue = Ae;
          const Pe = Symbol();
          F.$tabIndex = Pe;
          const Re = Symbol();
          F.$text = Re;
          const Ee = Symbol();
          F.$toPages = Ee;
          const ye = Symbol();
          F.$toHTML = ye;
          const Te = Symbol();
          F.$toString = Te;
          const je = Symbol();
          F.$toStyle = je;
          const ve = Symbol("uid");
          F.$uid = ve;
          const Ce = Symbol(), Ne = Symbol(), Ge = Symbol(), Oe = Symbol("_children"), tt = Symbol(), Ke = Symbol(), et = Symbol(), Xe = Symbol(), Qe = Symbol(), it = Symbol(), We = Symbol(), gt = Symbol(), mt = Symbol(), Ct = Symbol("parent"), Pt = Symbol(), at = Symbol(), dt = Symbol();
          let ot = 0;
          const Mt = e.NamespaceIds.datasets.id;
          class Rt {
            constructor(be, _e, $e = !1) {
              this[ie] = be, this[ne] = _e, this[We] = $e, this[Ct] = null, this[Oe] = [], this[ve] = `${_e}${ot++}`, this[L] = null;
            }
            [ee](be) {
              if (!this[We] || !this[te](be))
                return !1;
              const _e = be[ne], $e = this[_e];
              if ($e instanceof Et) {
                if ($e.push(be))
                  return this[M](be), !0;
              } else
                return $e !== null && this[de]($e), this[_e] = be, this[M](be), !0;
              let Ze = "";
              return this.id ? Ze = ` (id: ${this.id})` : this.name && (Ze = ` (name: ${this.name} ${this.h.value})`), (0, u.warn)(`XFA - node "${this[ne]}"${Ze} has already enough "${_e}"!`), !1;
            }
            [te](be) {
              return this.hasOwnProperty(be[ne]) && be[ie] === this[ie];
            }
            [R]() {
              return !1;
            }
            [B]() {
              return !1;
            }
            [V]() {
              return !1;
            }
            [U]() {
              return !1;
            }
            [ce]() {
              this.para && this[T]()[v].paraStack.pop();
            }
            [le]() {
              this[T]()[v].paraStack.push(this.para);
            }
            [pe](be) {
              this.id && this[ie] === e.NamespaceIds.template.id && be.set(this.id, this);
            }
            [T]() {
              return this[L].template;
            }
            [f]() {
              return !1;
            }
            [D]() {
              return !1;
            }
            [M](be) {
              be[Ct] = this, this[Oe].push(be), !be[L] && this[L] && (be[L] = this[L]);
            }
            [de](be) {
              const _e = this[Oe].indexOf(be);
              this[Oe].splice(_e, 1);
            }
            [_]() {
              return this.hasOwnProperty("value");
            }
            [Ae](be) {
            }
            [oe](be) {
            }
            [r]() {
            }
            [w](be) {
              delete this[We], this[i] && (be.clean(this[i]), delete this[i]);
            }
            [J](be) {
              return this[Oe].indexOf(be);
            }
            [K](be, _e) {
              _e[Ct] = this, this[Oe].splice(be, 0, _e), !_e[L] && this[L] && (_e[L] = this[L]);
            }
            [z]() {
              return !this.name;
            }
            [W]() {
              return "";
            }
            [Re]() {
              return this[Oe].length === 0 ? this[s] : this[Oe].map((be) => be[Re]()).join("");
            }
            get [Ge]() {
              const be = Object.getPrototypeOf(this);
              if (!be._attributes) {
                const _e = be._attributes = /* @__PURE__ */ new Set();
                for (const $e of Object.getOwnPropertyNames(this)) {
                  if (this[$e] === null || this[$e] instanceof Rt || this[$e] instanceof Et)
                    break;
                  _e.add($e);
                }
              }
              return (0, u.shadow)(this, Ge, be._attributes);
            }
            [X](be) {
              let _e = this;
              for (; _e; ) {
                if (_e === be)
                  return !0;
                _e = _e[p]();
              }
              return !1;
            }
            [p]() {
              return this[Ct];
            }
            [m]() {
              return this[p]();
            }
            [E](be = null) {
              return be ? this[be] : this[Oe];
            }
            [g]() {
              const be = /* @__PURE__ */ Object.create(null);
              this[s] && (be.$content = this[s]);
              for (const _e of Object.getOwnPropertyNames(this)) {
                const $e = this[_e];
                $e !== null && ($e instanceof Rt ? be[_e] = $e[g]() : $e instanceof Et ? $e.isEmpty() || (be[_e] = $e.dump()) : be[_e] = $e);
              }
              return be;
            }
            [je]() {
              return null;
            }
            [ye]() {
              return n.HTMLResult.EMPTY;
            }
            *[H]() {
              for (const be of this[E]())
                yield be;
            }
            *[Xe](be, _e) {
              for (const $e of this[H]())
                if (!be || _e === be.has($e[ne])) {
                  const Ze = this[h](), nt = $e[ye](Ze);
                  nt.success || (this[v].failingNode = $e), yield nt;
                }
            }
            [x]() {
              return null;
            }
            [j](be, _e) {
              this[v].children.push(be);
            }
            [h]() {
            }
            [O]({
              filter: be = null,
              include: _e = !0
            }) {
              if (!this[v].generator)
                this[v].generator = this[Xe](be, _e);
              else {
                const $e = this[h](), Ze = this[v].failingNode[ye]($e);
                if (!Ze.success)
                  return Ze;
                Ze.html && this[j](Ze.html, Ze.bbox), delete this[v].failingNode;
              }
              for (; ; ) {
                const $e = this[v].generator.next();
                if ($e.done)
                  break;
                const Ze = $e.value;
                if (!Ze.success)
                  return Ze;
                Ze.html && this[j](Ze.html, Ze.bbox);
              }
              return this[v].generator = null, n.HTMLResult.EMPTY;
            }
            [fe](be) {
              this[at] = new Set(Object.keys(be));
            }
            [it](be) {
              const _e = this[Ge], $e = this[at];
              return [...be].filter((Ze) => _e.has(Ze) && !$e.has(Ze));
            }
            [Fe](be, _e = /* @__PURE__ */ new Set()) {
              for (const $e of this[Oe])
                $e[Pt](be, _e);
            }
            [Pt](be, _e) {
              const $e = this[Qe](be, _e);
              $e ? this[Ce]($e, be, _e) : this[Fe](be, _e);
            }
            [Qe](be, _e) {
              const {
                use: $e,
                usehref: Ze
              } = this;
              if (!$e && !Ze)
                return null;
              let nt = null, pt = null, yt = null, lt = $e;
              if (Ze ? (lt = Ze, Ze.startsWith("#som(") && Ze.endsWith(")") ? pt = Ze.slice(5, -1) : Ze.startsWith(".#som(") && Ze.endsWith(")") ? pt = Ze.slice(6, -1) : Ze.startsWith("#") ? yt = Ze.slice(1) : Ze.startsWith(".#") && (yt = Ze.slice(2))) : $e.startsWith("#") ? yt = $e.slice(1) : pt = $e, this.use = this.usehref = "", yt ? nt = be.get(yt) : (nt = (0, t.searchNode)(be.get(Ie), this, pt, !0, !1), nt && (nt = nt[0])), !nt)
                return (0, u.warn)(`XFA - Invalid prototype reference: ${lt}.`), null;
              if (nt[ne] !== this[ne])
                return (0, u.warn)(`XFA - Incompatible prototype: ${nt[ne]} !== ${this[ne]}.`), null;
              if (_e.has(nt))
                return (0, u.warn)("XFA - Cycle detected in prototypes use."), null;
              _e.add(nt);
              const St = nt[Qe](be, _e);
              return St && nt[Ce](St, be, _e), nt[Fe](be, _e), _e.delete(nt), nt;
            }
            [Ce](be, _e, $e) {
              if ($e.has(be)) {
                (0, u.warn)("XFA - Cycle detected in prototypes use.");
                return;
              }
              !this[s] && be[s] && (this[s] = be[s]), new Set($e).add(be);
              for (const nt of this[it](be[at]))
                this[nt] = be[nt], this[at] && this[at].add(nt);
              for (const nt of Object.getOwnPropertyNames(this)) {
                if (this[Ge].has(nt))
                  continue;
                const pt = this[nt], yt = be[nt];
                if (pt instanceof Et) {
                  for (const lt of pt[Oe])
                    lt[Pt](_e, $e);
                  for (let lt = pt[Oe].length, St = yt[Oe].length; lt < St; lt++) {
                    const ht = be[Oe][lt][o]();
                    if (pt.push(ht))
                      ht[Ct] = this, this[Oe].push(ht), ht[Pt](_e, $e);
                    else
                      break;
                  }
                  continue;
                }
                if (pt !== null) {
                  pt[Fe](_e, $e), yt && pt[Ce](yt, _e, $e);
                  continue;
                }
                if (yt !== null) {
                  const lt = yt[o]();
                  lt[Ct] = this, this[nt] = lt, this[Oe].push(lt), lt[Pt](_e, $e);
                }
              }
            }
            static [tt](be) {
              return Array.isArray(be) ? be.map((_e) => Rt[tt](_e)) : typeof be == "object" && be !== null ? Object.assign({}, be) : be;
            }
            [o]() {
              const be = Object.create(Object.getPrototypeOf(this));
              for (const _e of Object.getOwnPropertySymbols(this))
                try {
                  be[_e] = this[_e];
                } catch {
                  (0, u.shadow)(be, _e, this[_e]);
                }
              be[ve] = `${be[ne]}${ot++}`, be[Oe] = [];
              for (const _e of Object.getOwnPropertyNames(this)) {
                if (this[Ge].has(_e)) {
                  be[_e] = Rt[tt](this[_e]);
                  continue;
                }
                const $e = this[_e];
                $e instanceof Et ? be[_e] = new Et($e[gt]) : be[_e] = null;
              }
              for (const _e of this[Oe]) {
                const $e = _e[ne], Ze = _e[o]();
                be[Oe].push(Ze), Ze[Ct] = be, be[$e] === null ? be[$e] = Ze : be[$e][Oe].push(Ze);
              }
              return be;
            }
            [E](be = null) {
              return be ? this[Oe].filter((_e) => _e[ne] === be) : this[Oe];
            }
            [y](be) {
              return this[be];
            }
            [P](be, _e, $e = !0) {
              return Array.from(this[c](be, _e, $e));
            }
            *[c](be, _e, $e = !0) {
              if (be === "parent") {
                yield this[Ct];
                return;
              }
              for (const Ze of this[Oe])
                Ze[ne] === be && (yield Ze), Ze.name === be && (yield Ze), (_e || Ze[z]()) && (yield* Ze[c](be, _e, !1));
              $e && this[Ge].has(be) && (yield new At(this, be, this[be]));
            }
          }
          F.XFAObject = Rt;
          class Et {
            constructor(be = 1 / 0) {
              this[gt] = be, this[Oe] = [];
            }
            push(be) {
              return this[Oe].length <= this[gt] ? (this[Oe].push(be), !0) : ((0, u.warn)(`XFA - node "${be[ne]}" accepts no more than ${this[gt]} children`), !1);
            }
            isEmpty() {
              return this[Oe].length === 0;
            }
            dump() {
              return this[Oe].length === 1 ? this[Oe][0][g]() : this[Oe].map((be) => be[g]());
            }
            [o]() {
              const be = new Et(this[gt]);
              return be[Oe] = this[Oe].map((_e) => _e[o]()), be;
            }
            get children() {
              return this[Oe];
            }
            clear() {
              this[Oe].length = 0;
            }
          }
          F.XFAObjectArray = Et;
          class At {
            constructor(be, _e, $e) {
              this[Ct] = be, this[ne] = _e, this[s] = $e, this[k] = !1, this[ve] = `attribute${ot++}`;
            }
            [p]() {
              return this[Ct];
            }
            [Q]() {
              return !0;
            }
            [d]() {
              return this[s].trim();
            }
            [Ae](be) {
              be = be.value || "", this[s] = be.toString();
            }
            [Re]() {
              return this[s];
            }
            [X](be) {
              return this[Ct] === be || this[Ct][X](be);
            }
          }
          F.XFAAttribute = At;
          class Nt extends Rt {
            constructor(be, _e, $e = {}) {
              if (super(be, _e), this[s] = "", this[Ke] = null, _e !== "#text") {
                const Ze = /* @__PURE__ */ new Map();
                this[Ne] = Ze;
                for (const [nt, pt] of Object.entries($e))
                  Ze.set(nt, new At(this, nt, pt));
                if ($e.hasOwnProperty(re)) {
                  const nt = $e[re].xfa.dataNode;
                  nt !== void 0 && (nt === "dataGroup" ? this[Ke] = !1 : nt === "dataValue" && (this[Ke] = !0));
                }
              }
              this[k] = !1;
            }
            [Te](be) {
              const _e = this[ne];
              if (_e === "#text") {
                be.push((0, q.encodeToXmlString)(this[s]));
                return;
              }
              const $e = (0, u.utf8StringToString)(_e), Ze = this[ie] === Mt ? "xfa:" : "";
              be.push(`<${Ze}${$e}`);
              for (const [nt, pt] of this[Ne].entries()) {
                const yt = (0, u.utf8StringToString)(nt);
                be.push(` ${yt}="${(0, q.encodeToXmlString)(pt[s])}"`);
              }
              if (this[Ke] !== null && (this[Ke] ? be.push(' xfa:dataNode="dataValue"') : be.push(' xfa:dataNode="dataGroup"')), !this[s] && this[Oe].length === 0) {
                be.push("/>");
                return;
              }
              if (be.push(">"), this[s])
                typeof this[s] == "string" ? be.push((0, q.encodeToXmlString)(this[s])) : this[s][Te](be);
              else
                for (const nt of this[Oe])
                  nt[Te](be);
              be.push(`</${Ze}${$e}>`);
            }
            [ee](be) {
              if (this[s]) {
                const _e = new Nt(this[ie], "#text");
                this[M](_e), _e[s] = this[s], this[s] = "";
              }
              return this[M](be), !0;
            }
            [oe](be) {
              this[s] += be;
            }
            [r]() {
              if (this[s] && this[Oe].length > 0) {
                const be = new Nt(this[ie], "#text");
                this[M](be), be[s] = this[s], delete this[s];
              }
            }
            [ye]() {
              return this[ne] === "#text" ? n.HTMLResult.success({
                name: "#text",
                value: this[s]
              }) : n.HTMLResult.EMPTY;
            }
            [E](be = null) {
              return be ? this[Oe].filter((_e) => _e[ne] === be) : this[Oe];
            }
            [I]() {
              return this[Ne];
            }
            [y](be) {
              const _e = this[Ne].get(be);
              return _e !== void 0 ? _e : this[E](be);
            }
            *[c](be, _e) {
              const $e = this[Ne].get(be);
              $e && (yield $e);
              for (const Ze of this[Oe])
                Ze[ne] === be && (yield Ze), _e && (yield* Ze[c](be, _e));
            }
            *[b](be, _e) {
              const $e = this[Ne].get(be);
              $e && (!_e || !$e[k]) && (yield $e);
              for (const Ze of this[Oe])
                yield* Ze[b](be, _e);
            }
            *[N](be, _e, $e) {
              for (const Ze of this[Oe])
                Ze[ne] === be && (!$e || !Ze[k]) && (yield Ze), _e && (yield* Ze[N](be, _e, $e));
            }
            [Q]() {
              return this[Ke] === null ? this[Oe].length === 0 || this[Oe][0][ie] === e.NamespaceIds.xhtml.id : this[Ke];
            }
            [d]() {
              return this[Ke] === null ? this[Oe].length === 0 ? this[s].trim() : this[Oe][0][ie] === e.NamespaceIds.xhtml.id ? this[Oe][0][Re]().trim() : null : this[s].trim();
            }
            [Ae](be) {
              be = be.value || "", this[s] = be.toString();
            }
            [g](be = !1) {
              const _e = /* @__PURE__ */ Object.create(null);
              be && (_e.$ns = this[ie]), this[s] && (_e.$content = this[s]), _e.$name = this[ne], _e.children = [];
              for (const $e of this[Oe])
                _e.children.push($e[g](be));
              _e.attributes = /* @__PURE__ */ Object.create(null);
              for (const [$e, Ze] of this[Ne])
                _e.attributes[$e] = Ze[s];
              return _e;
            }
          }
          F.XmlObject = Nt;
          class qe extends Rt {
            constructor(be, _e) {
              super(be, _e), this[s] = "";
            }
            [oe](be) {
              this[s] += be;
            }
            [r]() {
            }
          }
          F.ContentObject = qe;
          class Ue extends qe {
            constructor(be, _e, $e) {
              super(be, _e), this[mt] = $e;
            }
            [r]() {
              this[s] = (0, n.getKeyword)({
                data: this[s],
                defaultValue: this[mt][0],
                validate: (be) => this[mt].includes(be)
              });
            }
            [w](be) {
              super[w](be), delete this[mt];
            }
          }
          F.OptionObject = Ue;
          class Je extends qe {
            [r]() {
              this[s] = this[s].trim();
            }
          }
          F.StringObject = Je;
          class Ve extends qe {
            constructor(be, _e, $e, Ze) {
              super(be, _e), this[et] = $e, this[dt] = Ze;
            }
            [r]() {
              this[s] = (0, n.getInteger)({
                data: this[s],
                defaultValue: this[et],
                validate: this[dt]
              });
            }
            [w](be) {
              super[w](be), delete this[et], delete this[dt];
            }
          }
          F.IntegerObject = Ve;
          class st extends Ve {
            constructor(be, _e) {
              super(be, _e, 0, ($e) => $e === 1);
            }
          }
          F.Option01 = st;
          class ft extends Ve {
            constructor(be, _e) {
              super(be, _e, 1, ($e) => $e === 0);
            }
          }
          F.Option10 = ft;
        },
        /* 79 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.HTMLResult = void 0, F.getBBox = o, F.getColor = i, F.getFloat = B, F.getInteger = t, F.getKeyword = j, F.getMeasurement = O, F.getRatio = w, F.getRelevant = C, F.getStringOption = M, F.stripQuotes = e;
          var n = ae(2);
          const u = {
            pt: (s) => s,
            cm: (s) => s / 2.54 * 72,
            mm: (s) => s / (10 * 2.54) * 72,
            in: (s) => s * 72,
            px: (s) => s
          }, q = /([+-]?\d+\.?\d*)(.*)/;
          function e(s) {
            return s.startsWith("'") || s.startsWith('"') ? s.slice(1, -1) : s;
          }
          function t({
            data: s,
            defaultValue: l,
            validate: g
          }) {
            if (!s)
              return l;
            s = s.trim();
            const v = parseInt(s, 10);
            return !isNaN(v) && g(v) ? v : l;
          }
          function B({
            data: s,
            defaultValue: l,
            validate: g
          }) {
            if (!s)
              return l;
            s = s.trim();
            const v = parseFloat(s);
            return !isNaN(v) && g(v) ? v : l;
          }
          function j({
            data: s,
            defaultValue: l,
            validate: g
          }) {
            return s ? (s = s.trim(), g(s) ? s : l) : l;
          }
          function M(s, l) {
            return j({
              data: s,
              defaultValue: l[0],
              validate: (g) => l.includes(g)
            });
          }
          function O(s, l = "0") {
            if (l || (l = "0"), !s)
              return O(l);
            const g = s.trim().match(q);
            if (!g)
              return O(l);
            const [, v, r] = g, x = parseFloat(v);
            if (isNaN(x))
              return O(l);
            if (x === 0)
              return 0;
            const b = u[r];
            return b ? b(x) : x;
          }
          function w(s) {
            if (!s)
              return {
                num: 1,
                den: 1
              };
            const l = s.trim().split(/\s*:\s*/).map((r) => parseFloat(r)).filter((r) => !isNaN(r));
            if (l.length === 1 && l.push(1), l.length === 0)
              return {
                num: 1,
                den: 1
              };
            const [g, v] = l;
            return {
              num: g,
              den: v
            };
          }
          function C(s) {
            return s ? s.trim().split(/\s+/).map((l) => ({
              excluded: l[0] === "-",
              viewname: l.substring(1)
            })) : [];
          }
          function i(s, l = [0, 0, 0]) {
            let [g, v, r] = l;
            if (!s)
              return {
                r: g,
                g: v,
                b: r
              };
            const x = s.trim().split(/\s*,\s*/).map((b) => Math.min(Math.max(0, parseInt(b.trim(), 10)), 255)).map((b) => isNaN(b) ? 0 : b);
            return x.length < 3 ? {
              r: g,
              g: v,
              b: r
            } : ([g, v, r] = x, {
              r: g,
              g: v,
              b: r
            });
          }
          function o(s) {
            if (!s)
              return {
                x: -1,
                y: -1,
                width: -1,
                height: -1
              };
            const g = s.trim().split(/\s*,\s*/).map((I) => O(I, "-1"));
            if (g.length < 4 || g[2] < 0 || g[3] < 0)
              return {
                x: -1,
                y: -1,
                width: -1,
                height: -1
              };
            const [v, r, x, b] = g;
            return {
              x: v,
              y: r,
              width: x,
              height: b
            };
          }
          class k {
            static get FAILURE() {
              return (0, n.shadow)(this, "FAILURE", new k(!1, null, null, null));
            }
            static get EMPTY() {
              return (0, n.shadow)(this, "EMPTY", new k(!0, null, null, null));
            }
            constructor(l, g, v, r) {
              this.success = l, this.html = g, this.bbox = v, this.breakNode = r;
            }
            isBreak() {
              return !!this.breakNode;
            }
            static breakNode(l) {
              return new k(!1, null, null, l);
            }
            static success(l, g = null) {
              return new k(!0, l, g, null);
            }
          }
          F.HTMLResult = k;
        },
        /* 80 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.NamespaceIds = F.$buildXFAObject = void 0;
          const ae = Symbol();
          F.$buildXFAObject = ae;
          const n = {
            config: {
              id: 0,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xci/")
            },
            connectionSet: {
              id: 1,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xfa-connection-set/")
            },
            datasets: {
              id: 2,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xfa-data/")
            },
            form: {
              id: 3,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xfa-form/")
            },
            localeSet: {
              id: 4,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xfa-locale-set/")
            },
            pdf: {
              id: 5,
              check: (u) => u === "http://ns.adobe.com/xdp/pdf/"
            },
            signature: {
              id: 6,
              check: (u) => u === "http://www.w3.org/2000/09/xmldsig#"
            },
            sourceSet: {
              id: 7,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xfa-source-set/")
            },
            stylesheet: {
              id: 8,
              check: (u) => u === "http://www.w3.org/1999/XSL/Transform"
            },
            template: {
              id: 9,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xfa-template/")
            },
            xdc: {
              id: 10,
              check: (u) => u.startsWith("http://www.xfa.org/schema/xdc/")
            },
            xdp: {
              id: 11,
              check: (u) => u === "http://ns.adobe.com/xdp/"
            },
            xfdf: {
              id: 12,
              check: (u) => u === "http://ns.adobe.com/xfdf/"
            },
            xhtml: {
              id: 13,
              check: (u) => u === "http://www.w3.org/1999/xhtml"
            },
            xmpmeta: {
              id: 14,
              check: (u) => u === "http://ns.adobe.com/xmpmeta/"
            }
          };
          F.NamespaceIds = n;
        },
        /* 81 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.createDataNode = k, F.searchNode = i;
          var n = ae(78), u = ae(80), q = ae(2);
          const e = /^[^.[]+/, t = /^[^\]]+/, B = {
            dot: 0,
            dotDot: 1,
            dotHash: 2,
            dotBracket: 3,
            dotParen: 4
          }, j = /* @__PURE__ */ new Map([["$data", (s, l) => s.datasets ? s.datasets.data : s], ["$record", (s, l) => (s.datasets ? s.datasets.data : s)[n.$getChildren]()[0]], ["$template", (s, l) => s.template], ["$connectionSet", (s, l) => s.connectionSet], ["$form", (s, l) => s.form], ["$layout", (s, l) => s.layout], ["$host", (s, l) => s.host], ["$dataWindow", (s, l) => s.dataWindow], ["$event", (s, l) => s.event], ["!", (s, l) => s.datasets], ["$xfa", (s, l) => s], ["xfa", (s, l) => s], ["$", (s, l) => l]]), M = /* @__PURE__ */ new WeakMap(), O = u.NamespaceIds.datasets.id;
          function w(s) {
            return s = s.trim(), s === "*" ? 1 / 0 : parseInt(s, 10) || 0;
          }
          function C(s, l, g = !0) {
            let v = s.match(e);
            if (!v)
              return null;
            let [r] = v;
            const x = [{
              name: r,
              cacheName: "." + r,
              index: 0,
              js: null,
              formCalc: null,
              operator: B.dot
            }];
            let b = r.length;
            for (; b < s.length; ) {
              const I = b;
              if (s.charAt(b++) === "[") {
                if (v = s.slice(b).match(t), !v)
                  return (0, q.warn)("XFA - Invalid index in SOM expression"), null;
                x.at(-1).index = w(v[0]), b += v[0].length + 1;
                continue;
              }
              let y;
              switch (s.charAt(b)) {
                case ".":
                  if (!l)
                    return null;
                  b++, y = B.dotDot;
                  break;
                case "#":
                  b++, y = B.dotHash;
                  break;
                case "[":
                  if (g)
                    return (0, q.warn)("XFA - SOM expression contains a FormCalc subexpression which is not supported for now."), null;
                  y = B.dotBracket;
                  break;
                case "(":
                  if (g)
                    return (0, q.warn)("XFA - SOM expression contains a JavaScript subexpression which is not supported for now."), null;
                  y = B.dotParen;
                  break;
                default:
                  y = B.dot;
                  break;
              }
              if (v = s.slice(b).match(e), !v)
                break;
              [r] = v, b += r.length, x.push({
                name: r,
                cacheName: s.slice(I, b),
                operator: y,
                index: 0,
                js: null,
                formCalc: null
              });
            }
            return x;
          }
          function i(s, l, g, v = !0, r = !0) {
            const x = C(g, v);
            if (!x)
              return null;
            const b = j.get(x[0].name);
            let I = 0, h;
            b ? (h = !0, s = [b(s, l)], I = 1) : (h = l === null, s = [l || s]);
            for (let y = x.length; I < y; I++) {
              const {
                name: P,
                cacheName: c,
                operator: d,
                index: A
              } = x[I], N = [];
              for (const E of s) {
                if (!(E instanceof n.XFAObject))
                  continue;
                let H, $;
                if (r && ($ = M.get(E), $ || ($ = /* @__PURE__ */ new Map(), M.set(E, $)), H = $.get(c)), !H) {
                  switch (d) {
                    case B.dot:
                      H = E[n.$getChildrenByName](P, !1);
                      break;
                    case B.dotDot:
                      H = E[n.$getChildrenByName](P, !0);
                      break;
                    case B.dotHash:
                      H = E[n.$getChildrenByClass](P), H instanceof n.XFAObjectArray ? H = H.children : H = [H];
                      break;
                  }
                  r && $.set(c, H);
                }
                H.length > 0 && N.push(H);
              }
              if (N.length === 0 && !h && I === 0) {
                if (l = l[n.$getParent](), !l)
                  return null;
                I = -1, s = [l];
                continue;
              }
              isFinite(A) ? s = N.filter((E) => A < E.length).map((E) => E[A]) : s = N.flat();
            }
            return s.length === 0 ? null : s;
          }
          function o(s, l) {
            let g = null;
            for (const {
              name: v,
              index: r
            } of l) {
              for (let x = 0, b = isFinite(r) ? r : 0; x <= b; x++) {
                const I = s[n.$namespaceId] === O ? -1 : s[n.$namespaceId];
                g = new n.XmlObject(I, v), s[n.$appendChild](g);
              }
              s = g;
            }
            return g;
          }
          function k(s, l, g) {
            const v = C(g);
            if (!v || v.some((b) => b.operator === B.dotDot))
              return null;
            const r = j.get(v[0].name);
            let x = 0;
            r ? (s = r(s, l), x = 1) : s = l || s;
            for (let b = v.length; x < b; x++) {
              const {
                name: I,
                operator: h,
                index: y
              } = v[x];
              if (!isFinite(y))
                return v[x].index = 0, o(s, v.slice(x));
              let P;
              switch (h) {
                case B.dot:
                  P = s[n.$getChildrenByName](I, !1);
                  break;
                case B.dotDot:
                  P = s[n.$getChildrenByName](I, !0);
                  break;
                case B.dotHash:
                  P = s[n.$getChildrenByClass](I), P instanceof n.XFAObjectArray ? P = P.children : P = [P];
                  break;
              }
              if (P.length === 0)
                return o(s, v.slice(x));
              if (y < P.length) {
                const c = P[y];
                if (!(c instanceof n.XFAObject))
                  return (0, q.warn)("XFA - Cannot create a node."), null;
                s = c;
              } else
                return v[x].index = y - P.length, o(s, v.slice(x));
            }
            return null;
          }
        },
        /* 82 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Binder = void 0;
          var n = ae(78), u = ae(83), q = ae(81), e = ae(80), t = ae(2);
          const B = e.NamespaceIds.datasets.id;
          function j(O) {
            const w = new u.Text({});
            return w[n.$content] = O, w;
          }
          class M {
            constructor(w) {
              var C;
              this.root = w, this.datasets = w.datasets, (C = w.datasets) != null && C.data ? this.data = w.datasets.data : this.data = new n.XmlObject(e.NamespaceIds.datasets.id, "data"), this.emptyMerge = this.data[n.$getChildren]().length === 0, this.root.form = this.form = w.template[n.$clone]();
            }
            _isConsumeData() {
              return !this.emptyMerge && this._mergeMode;
            }
            _isMatchTemplate() {
              return !this._isConsumeData();
            }
            bind() {
              return this._bindElement(this.form, this.data), this.form;
            }
            getData() {
              return this.data;
            }
            _bindValue(w, C, i) {
              var o, k;
              if (w[n.$data] = C, w[n.$hasSettableValue]())
                if (C[n.$isDataValue]()) {
                  const s = C[n.$getDataValue]();
                  w[n.$setValue](j(s));
                } else if (w instanceof u.Field && ((k = (o = w.ui) == null ? void 0 : o.choiceList) == null ? void 0 : k.open) === "multiSelect") {
                  const s = C[n.$getChildren]().map((l) => l[n.$content].trim()).join(`
`);
                  w[n.$setValue](j(s));
                } else
                  this._isConsumeData() && (0, t.warn)("XFA - Nodes haven't the same type.");
              else
                !C[n.$isDataValue]() || this._isMatchTemplate() ? this._bindElement(w, C) : (0, t.warn)("XFA - Nodes haven't the same type.");
            }
            _findDataByNameToConsume(w, C, i, o) {
              if (!w)
                return null;
              let k, s;
              for (let l = 0; l < 3; l++) {
                for (k = i[n.$getRealChildrenByNameIt](w, !1, !0); s = k.next().value, !!s; )
                  if (C === s[n.$isDataValue]())
                    return s;
                if (i[n.$namespaceId] === e.NamespaceIds.datasets.id && i[n.$nodeName] === "data")
                  break;
                i = i[n.$getParent]();
              }
              return o ? (k = this.data[n.$getRealChildrenByNameIt](w, !0, !1), s = k.next().value, s || (k = this.data[n.$getAttributeIt](w, !0), s = k.next().value, s != null && s[n.$isDataValue]()) ? s : null) : null;
            }
            _setProperties(w, C) {
              if (w.hasOwnProperty("setProperty"))
                for (const {
                  ref: i,
                  target: o,
                  connection: k
                } of w.setProperty.children) {
                  if (k || !i)
                    continue;
                  const s = (0, q.searchNode)(this.root, C, i, !1, !1);
                  if (!s) {
                    (0, t.warn)(`XFA - Invalid reference: ${i}.`);
                    continue;
                  }
                  const [l] = s;
                  if (!l[n.$isDescendent](this.data)) {
                    (0, t.warn)("XFA - Invalid node: must be a data node.");
                    continue;
                  }
                  const g = (0, q.searchNode)(this.root, w, o, !1, !1);
                  if (!g) {
                    (0, t.warn)(`XFA - Invalid target: ${o}.`);
                    continue;
                  }
                  const [v] = g;
                  if (!v[n.$isDescendent](w)) {
                    (0, t.warn)("XFA - Invalid target: must be a property or subproperty.");
                    continue;
                  }
                  const r = v[n.$getParent]();
                  if (v instanceof u.SetProperty || r instanceof u.SetProperty) {
                    (0, t.warn)("XFA - Invalid target: cannot be a setProperty or one of its properties.");
                    continue;
                  }
                  if (v instanceof u.BindItems || r instanceof u.BindItems) {
                    (0, t.warn)("XFA - Invalid target: cannot be a bindItems or one of its properties.");
                    continue;
                  }
                  const x = l[n.$text](), b = v[n.$nodeName];
                  if (v instanceof n.XFAAttribute) {
                    const I = /* @__PURE__ */ Object.create(null);
                    I[b] = x;
                    const h = Reflect.construct(Object.getPrototypeOf(r).constructor, [I]);
                    r[b] = h[b];
                    continue;
                  }
                  if (!v.hasOwnProperty(n.$content)) {
                    (0, t.warn)("XFA - Invalid node to use in setProperty");
                    continue;
                  }
                  v[n.$data] = l, v[n.$content] = x, v[n.$finalize]();
                }
            }
            _bindItems(w, C) {
              if (!w.hasOwnProperty("items") || !w.hasOwnProperty("bindItems") || w.bindItems.isEmpty())
                return;
              for (const k of w.items.children)
                w[n.$removeChild](k);
              w.items.clear();
              const i = new u.Items({}), o = new u.Items({});
              w[n.$appendChild](i), w.items.push(i), w[n.$appendChild](o), w.items.push(o);
              for (const {
                ref: k,
                labelRef: s,
                valueRef: l,
                connection: g
              } of w.bindItems.children) {
                if (g || !k)
                  continue;
                const v = (0, q.searchNode)(this.root, C, k, !1, !1);
                if (!v) {
                  (0, t.warn)(`XFA - Invalid reference: ${k}.`);
                  continue;
                }
                for (const r of v) {
                  if (!r[n.$isDescendent](this.datasets)) {
                    (0, t.warn)(`XFA - Invalid ref (${k}): must be a datasets child.`);
                    continue;
                  }
                  const x = (0, q.searchNode)(this.root, r, s, !0, !1);
                  if (!x) {
                    (0, t.warn)(`XFA - Invalid label: ${s}.`);
                    continue;
                  }
                  const [b] = x;
                  if (!b[n.$isDescendent](this.datasets)) {
                    (0, t.warn)("XFA - Invalid label: must be a datasets child.");
                    continue;
                  }
                  const I = (0, q.searchNode)(this.root, r, l, !0, !1);
                  if (!I) {
                    (0, t.warn)(`XFA - Invalid value: ${l}.`);
                    continue;
                  }
                  const [h] = I;
                  if (!h[n.$isDescendent](this.datasets)) {
                    (0, t.warn)("XFA - Invalid value: must be a datasets child.");
                    continue;
                  }
                  const y = j(b[n.$text]()), P = j(h[n.$text]());
                  i[n.$appendChild](y), i.text.push(y), o[n.$appendChild](P), o.text.push(P);
                }
              }
            }
            _bindOccurrences(w, C, i) {
              let o;
              if (C.length > 1 && (o = w[n.$clone](), o[n.$removeChild](o.occur), o.occur = null), this._bindValue(w, C[0], i), this._setProperties(w, C[0]), this._bindItems(w, C[0]), C.length === 1)
                return;
              const k = w[n.$getParent](), s = w[n.$nodeName], l = k[n.$indexOf](w);
              for (let g = 1, v = C.length; g < v; g++) {
                const r = C[g], x = o[n.$clone]();
                k[s].push(x), k[n.$insertAt](l + g, x), this._bindValue(x, r, i), this._setProperties(x, r), this._bindItems(x, r);
              }
            }
            _createOccurrences(w) {
              if (!this.emptyMerge)
                return;
              const {
                occur: C
              } = w;
              if (!C || C.initial <= 1)
                return;
              const i = w[n.$getParent](), o = w[n.$nodeName];
              if (!(i[o] instanceof n.XFAObjectArray))
                return;
              let k;
              w.name ? k = i[o].children.filter((g) => g.name === w.name).length : k = i[o].children.length;
              const s = i[n.$indexOf](w) + 1, l = C.initial - k;
              if (l) {
                const g = w[n.$clone]();
                g[n.$removeChild](g.occur), g.occur = null, i[o].push(g), i[n.$insertAt](s, g);
                for (let v = 1; v < l; v++) {
                  const r = g[n.$clone]();
                  i[o].push(r), i[n.$insertAt](s + v, r);
                }
              }
            }
            _getOccurInfo(w) {
              const {
                name: C,
                occur: i
              } = w;
              if (!i || !C)
                return [1, 1];
              const o = i.max === -1 ? 1 / 0 : i.max;
              return [i.min, o];
            }
            _setAndBind(w, C) {
              this._setProperties(w, C), this._bindItems(w, C), this._bindElement(w, C);
            }
            _bindElement(w, C) {
              const i = [];
              this._createOccurrences(w);
              for (const o of w[n.$getChildren]()) {
                if (o[n.$data])
                  continue;
                if (this._mergeMode === void 0 && o[n.$nodeName] === "subform") {
                  this._mergeMode = o.mergeMode === "consumeData";
                  const x = C[n.$getChildren]();
                  if (x.length > 0)
                    this._bindOccurrences(o, [x[0]], null);
                  else if (this.emptyMerge) {
                    const b = C[n.$namespaceId] === B ? -1 : C[n.$namespaceId], I = o[n.$data] = new n.XmlObject(b, o.name || "root");
                    C[n.$appendChild](I), this._bindElement(o, I);
                  }
                  continue;
                }
                if (!o[n.$isBindable]())
                  continue;
                let k = !1, s = null, l = null, g = null;
                if (o.bind) {
                  switch (o.bind.match) {
                    case "none":
                      this._setAndBind(o, C);
                      continue;
                    case "global":
                      k = !0;
                      break;
                    case "dataRef":
                      if (!o.bind.ref) {
                        (0, t.warn)(`XFA - ref is empty in node ${o[n.$nodeName]}.`), this._setAndBind(o, C);
                        continue;
                      }
                      l = o.bind.ref;
                      break;
                  }
                  o.bind.picture && (s = o.bind.picture[n.$content]);
                }
                const [v, r] = this._getOccurInfo(o);
                if (l)
                  if (g = (0, q.searchNode)(this.root, C, l, !0, !1), g === null) {
                    if (g = (0, q.createDataNode)(this.data, C, l), !g)
                      continue;
                    this._isConsumeData() && (g[n.$consumed] = !0), this._setAndBind(o, g);
                    continue;
                  } else
                    this._isConsumeData() && (g = g.filter((x) => !x[n.$consumed])), g.length > r ? g = g.slice(0, r) : g.length === 0 && (g = null), g && this._isConsumeData() && g.forEach((x) => {
                      x[n.$consumed] = !0;
                    });
                else {
                  if (!o.name) {
                    this._setAndBind(o, C);
                    continue;
                  }
                  if (this._isConsumeData()) {
                    const x = [];
                    for (; x.length < r; ) {
                      const b = this._findDataByNameToConsume(o.name, o[n.$hasSettableValue](), C, k);
                      if (!b)
                        break;
                      b[n.$consumed] = !0, x.push(b);
                    }
                    g = x.length > 0 ? x : null;
                  } else {
                    if (g = C[n.$getRealChildrenByNameIt](o.name, !1, this.emptyMerge).next().value, !g) {
                      if (v === 0) {
                        i.push(o);
                        continue;
                      }
                      const x = C[n.$namespaceId] === B ? -1 : C[n.$namespaceId];
                      g = o[n.$data] = new n.XmlObject(x, o.name), this.emptyMerge && (g[n.$consumed] = !0), C[n.$appendChild](g), this._setAndBind(o, g);
                      continue;
                    }
                    this.emptyMerge && (g[n.$consumed] = !0), g = [g];
                  }
                }
                g ? this._bindOccurrences(o, g, s) : v > 0 ? this._setAndBind(o, C) : i.push(o);
              }
              i.forEach((o) => o[n.$getParent]()[n.$removeChild](o));
            }
          }
          F.Binder = M;
        },
        /* 83 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Value = F.Text = F.TemplateNamespace = F.Template = F.SetProperty = F.Items = F.Field = F.BindItems = void 0;
          var n = ae(78), u = ae(80), q = ae(84), e = ae(85), t = ae(79), B = ae(2), j = ae(86), M = ae(3), O = ae(81);
          const w = u.NamespaceIds.template.id, C = "http://www.w3.org/2000/svg", i = 2, o = 3, k = 5e3, s = /^H(\d+)$/, l = /* @__PURE__ */ new Set(["image/gif", "image/jpeg", "image/jpg", "image/pjpeg", "image/png", "image/apng", "image/x-png", "image/bmp", "image/x-ms-bmp", "image/tiff", "image/tif", "application/octet-stream"]), g = [[[66, 77], "image/bmp"], [[255, 216, 255], "image/jpeg"], [[73, 73, 42, 0], "image/tiff"], [[77, 77, 0, 42], "image/tiff"], [[71, 73, 70, 56, 57, 97], "image/gif"], [[137, 80, 78, 71, 13, 10, 26, 10], "image/png"]];
          function v(Le) {
            if (!Le || !Le.border)
              return {
                w: 0,
                h: 0
              };
            const a = Le.border[n.$getExtra]();
            return a ? {
              w: a.widths[0] + a.widths[2] + a.insets[0] + a.insets[2],
              h: a.widths[1] + a.widths[3] + a.insets[1] + a.insets[3]
            } : {
              w: 0,
              h: 0
            };
          }
          function r(Le) {
            return Le.margin && (Le.margin.topInset || Le.margin.rightInset || Le.margin.bottomInset || Le.margin.leftInset);
          }
          function x(Le, a) {
            if (!Le.value) {
              const Z = new cn({});
              Le[n.$appendChild](Z), Le.value = Z;
            }
            Le.value[n.$setValue](a);
          }
          function* b(Le) {
            for (const a of Le[n.$getChildren]()) {
              if (a instanceof pn) {
                yield* a[n.$getContainedChildren]();
                continue;
              }
              yield a;
            }
          }
          function I(Le) {
            var a;
            return ((a = Le.validate) == null ? void 0 : a.nullTest) === "error";
          }
          function h(Le) {
            for (; Le; ) {
              if (!Le.traversal) {
                Le[n.$tabIndex] = Le[n.$getParent]()[n.$tabIndex];
                return;
              }
              if (Le[n.$tabIndex])
                return;
              let a = null;
              for (const He of Le.traversal[n.$getChildren]())
                if (He.operation === "next") {
                  a = He;
                  break;
                }
              if (!a || !a.ref) {
                Le[n.$tabIndex] = Le[n.$getParent]()[n.$tabIndex];
                return;
              }
              const Z = Le[n.$getTemplateRoot]();
              Le[n.$tabIndex] = ++Z[n.$tabIndex];
              const De = Z[n.$searchNode](a.ref, Le);
              if (!De)
                return;
              Le = De[0];
            }
          }
          function y(Le, a) {
            var De;
            const Z = Le.assist;
            if (Z) {
              const He = Z[n.$toHTML]();
              He && (a.title = He);
              const ut = Z.role.match(s);
              if (ut) {
                const xt = "heading", bt = ut[1];
                a.role = xt, a["aria-level"] = bt;
              }
            }
            if (Le.layout === "table")
              a.role = "table";
            else if (Le.layout === "row")
              a.role = "row";
            else {
              const He = Le[n.$getParent]();
              He.layout === "row" && (((De = He.assist) == null ? void 0 : De.role) === "TH" ? a.role = "columnheader" : a.role = "cell");
            }
          }
          function P(Le) {
            if (!Le.assist)
              return null;
            const a = Le.assist;
            return a.speak && a.speak[n.$content] !== "" ? a.speak[n.$content] : a.toolTip ? a.toolTip[n.$content] : null;
          }
          function c(Le) {
            return t.HTMLResult.success({
              name: "div",
              attributes: {
                class: ["xfaRich"],
                style: /* @__PURE__ */ Object.create(null)
              },
              children: [{
                name: "span",
                attributes: {
                  style: /* @__PURE__ */ Object.create(null)
                },
                value: Le
              }]
            });
          }
          function d(Le) {
            const a = Le[n.$getTemplateRoot]();
            a[n.$extra].firstUnsplittable === null && (a[n.$extra].firstUnsplittable = Le, a[n.$extra].noLayoutFailure = !0);
          }
          function A(Le) {
            const a = Le[n.$getTemplateRoot]();
            a[n.$extra].firstUnsplittable === Le && (a[n.$extra].noLayoutFailure = !1);
          }
          function N(Le) {
            if (Le[n.$extra] || (Le[n.$extra] = /* @__PURE__ */ Object.create(null), Le.targetType === "auto"))
              return !1;
            const a = Le[n.$getTemplateRoot]();
            let Z = null;
            if (Le.target) {
              if (Z = a[n.$searchNode](Le.target, Le[n.$getParent]()), !Z)
                return !1;
              Z = Z[0];
            }
            const {
              currentPageArea: De,
              currentContentArea: He
            } = a[n.$extra];
            if (Le.targetType === "pageArea")
              return Z instanceof Ze || (Z = null), Le.startNew ? (Le[n.$extra].target = Z || De, !0) : Z && Z !== De ? (Le[n.$extra].target = Z, !0) : !1;
            Z instanceof ee || (Z = null);
            const Ye = Z && Z[n.$getParent]();
            let ut, xt = Ye;
            if (Le.startNew)
              if (Z) {
                const bt = Ye.contentArea.children, Tt = bt.indexOf(He), _t = bt.indexOf(Z);
                Tt !== -1 && Tt < _t && (xt = null), ut = _t - 1;
              } else
                ut = De.contentArea.children.indexOf(He);
            else if (Z && Z !== He)
              ut = Ye.contentArea.children.indexOf(Z) - 1, xt = Ye === De ? null : Ye;
            else
              return !1;
            return Le[n.$extra].target = xt, Le[n.$extra].index = ut, !0;
          }
          function E(Le, a, Z) {
            const De = Le[n.$getTemplateRoot](), He = De[n.$extra].noLayoutFailure, Ye = a[n.$getSubformParent];
            a[n.$getSubformParent] = () => Le, De[n.$extra].noLayoutFailure = !0;
            const ut = a[n.$toHTML](Z);
            Le[n.$addHTML](ut.html, ut.bbox), De[n.$extra].noLayoutFailure = He, a[n.$getSubformParent] = Ye;
          }
          class H extends n.StringObject {
            constructor(a) {
              super(w, "appearanceFilter"), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class $ extends n.XFAObject {
            constructor(a) {
              super(w, "arc", !0), this.circular = (0, t.getInteger)({
                data: a.circular,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.hand = (0, t.getStringOption)(a.hand, ["even", "left", "right"]), this.id = a.id || "", this.startAngle = (0, t.getFloat)({
                data: a.startAngle,
                defaultValue: 0,
                validate: (Z) => !0
              }), this.sweepAngle = (0, t.getFloat)({
                data: a.sweepAngle,
                defaultValue: 360,
                validate: (Z) => !0
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.edge = null, this.fill = null;
            }
            [n.$toHTML]() {
              var bt;
              const a = this.edge || new fe({}), Z = a[n.$toStyle](), De = /* @__PURE__ */ Object.create(null);
              ((bt = this.fill) == null ? void 0 : bt.presence) === "visible" ? Object.assign(De, this.fill[n.$toStyle]()) : De.fill = "transparent", De.strokeWidth = (0, e.measureToString)(a.presence === "visible" ? a.thickness : 0), De.stroke = Z.color;
              let He;
              const Ye = {
                xmlns: C,
                style: {
                  width: "100%",
                  height: "100%",
                  overflow: "visible"
                }
              };
              if (this.sweepAngle === 360)
                He = {
                  name: "ellipse",
                  attributes: {
                    xmlns: C,
                    cx: "50%",
                    cy: "50%",
                    rx: "50%",
                    ry: "50%",
                    style: De
                  }
                };
              else {
                const Tt = this.startAngle * Math.PI / 180, _t = this.sweepAngle * Math.PI / 180, $t = this.sweepAngle > 180 ? 1 : 0, [jt, Ht, zt, Ot] = [50 * (1 + Math.cos(Tt)), 50 * (1 - Math.sin(Tt)), 50 * (1 + Math.cos(Tt + _t)), 50 * (1 - Math.sin(Tt + _t))];
                He = {
                  name: "path",
                  attributes: {
                    xmlns: C,
                    d: `M ${jt} ${Ht} A 50 50 0 ${$t} 0 ${zt} ${Ot}`,
                    vectorEffect: "non-scaling-stroke",
                    style: De
                  }
                }, Object.assign(Ye, {
                  viewBox: "0 0 100 100",
                  preserveAspectRatio: "none"
                });
              }
              const ut = {
                name: "svg",
                children: [He],
                attributes: Ye
              }, xt = this[n.$getParent]()[n.$getParent]();
              return r(xt) ? t.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [ut]
              }) : (ut.attributes.style.position = "absolute", t.HTMLResult.success(ut));
            }
          }
          class m extends n.XFAObject {
            constructor(a) {
              super(w, "area", !0), this.colSpan = (0, t.getInteger)({
                data: a.colSpan,
                defaultValue: 1,
                validate: (Z) => Z >= 1 || Z === -1
              }), this.id = a.id || "", this.name = a.name || "", this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.x = (0, t.getMeasurement)(a.x, "0pt"), this.y = (0, t.getMeasurement)(a.y, "0pt"), this.desc = null, this.extras = null, this.area = new n.XFAObjectArray(), this.draw = new n.XFAObjectArray(), this.exObject = new n.XFAObjectArray(), this.exclGroup = new n.XFAObjectArray(), this.field = new n.XFAObjectArray(), this.subform = new n.XFAObjectArray(), this.subformSet = new n.XFAObjectArray();
            }
            *[n.$getContainedChildren]() {
              yield* b(this);
            }
            [n.$isTransparent]() {
              return !0;
            }
            [n.$isBindable]() {
              return !0;
            }
            [n.$addHTML](a, Z) {
              const [De, He, Ye, ut] = Z;
              this[n.$extra].width = Math.max(this[n.$extra].width, De + Ye), this[n.$extra].height = Math.max(this[n.$extra].height, He + ut), this[n.$extra].children.push(a);
            }
            [n.$getAvailableSpace]() {
              return this[n.$extra].availableSpace;
            }
            [n.$toHTML](a) {
              const Z = (0, e.toStyle)(this, "position"), De = {
                style: Z,
                id: this[n.$uid],
                class: ["xfaArea"]
              };
              (0, e.isPrintOnly)(this) && De.class.push("xfaPrintOnly"), this.name && (De.xfaName = this.name);
              const He = [];
              this[n.$extra] = {
                children: He,
                width: 0,
                height: 0,
                availableSpace: a
              };
              const Ye = this[n.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["area", "draw", "field", "exclGroup", "subform", "subformSet"]),
                include: !0
              });
              if (!Ye.success)
                return Ye.isBreak() ? Ye : (delete this[n.$extra], t.HTMLResult.FAILURE);
              Z.width = (0, e.measureToString)(this[n.$extra].width), Z.height = (0, e.measureToString)(this[n.$extra].height);
              const ut = {
                name: "div",
                attributes: De,
                children: He
              }, xt = [this.x, this.y, this[n.$extra].width, this[n.$extra].height];
              return delete this[n.$extra], t.HTMLResult.success(ut, xt);
            }
          }
          class p extends n.XFAObject {
            constructor(a) {
              super(w, "assist", !0), this.id = a.id || "", this.role = a.role || "", this.use = a.use || "", this.usehref = a.usehref || "", this.speak = null, this.toolTip = null;
            }
            [n.$toHTML]() {
              var a;
              return ((a = this.toolTip) == null ? void 0 : a[n.$content]) || null;
            }
          }
          class T extends n.XFAObject {
            constructor(a) {
              super(w, "barcode", !0), this.charEncoding = (0, t.getKeyword)({
                data: a.charEncoding ? a.charEncoding.toLowerCase() : "",
                defaultValue: "",
                validate: (Z) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(Z) || Z.match(/iso-8859-\d{2}/)
              }), this.checksum = (0, t.getStringOption)(a.checksum, ["none", "1mod10", "1mod10_1mod11", "2mod10", "auto"]), this.dataColumnCount = (0, t.getInteger)({
                data: a.dataColumnCount,
                defaultValue: -1,
                validate: (Z) => Z >= 0
              }), this.dataLength = (0, t.getInteger)({
                data: a.dataLength,
                defaultValue: -1,
                validate: (Z) => Z >= 0
              }), this.dataPrep = (0, t.getStringOption)(a.dataPrep, ["none", "flateCompress"]), this.dataRowCount = (0, t.getInteger)({
                data: a.dataRowCount,
                defaultValue: -1,
                validate: (Z) => Z >= 0
              }), this.endChar = a.endChar || "", this.errorCorrectionLevel = (0, t.getInteger)({
                data: a.errorCorrectionLevel,
                defaultValue: -1,
                validate: (Z) => Z >= 0 && Z <= 8
              }), this.id = a.id || "", this.moduleHeight = (0, t.getMeasurement)(a.moduleHeight, "5mm"), this.moduleWidth = (0, t.getMeasurement)(a.moduleWidth, "0.25mm"), this.printCheckDigit = (0, t.getInteger)({
                data: a.printCheckDigit,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.rowColumnRatio = (0, t.getRatio)(a.rowColumnRatio), this.startChar = a.startChar || "", this.textLocation = (0, t.getStringOption)(a.textLocation, ["below", "above", "aboveEmbedded", "belowEmbedded", "none"]), this.truncate = (0, t.getInteger)({
                data: a.truncate,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.type = (0, t.getStringOption)(a.type ? a.type.toLowerCase() : "", ["aztec", "codabar", "code2of5industrial", "code2of5interleaved", "code2of5matrix", "code2of5standard", "code3of9", "code3of9extended", "code11", "code49", "code93", "code128", "code128a", "code128b", "code128c", "code128sscc", "datamatrix", "ean8", "ean8add2", "ean8add5", "ean13", "ean13add2", "ean13add5", "ean13pwcd", "fim", "logmars", "maxicode", "msi", "pdf417", "pdf417macro", "plessey", "postauscust2", "postauscust3", "postausreplypaid", "postausstandard", "postukrm4scc", "postusdpbc", "postusimb", "postusstandard", "postus5zip", "qrcode", "rfid", "rss14", "rss14expanded", "rss14limited", "rss14stacked", "rss14stackedomni", "rss14truncated", "telepen", "ucc128", "ucc128random", "ucc128sscc", "upca", "upcaadd2", "upcaadd5", "upcapwcd", "upce", "upceadd2", "upceadd5", "upcean2", "upcean5", "upsmaxicode"]), this.upsMode = (0, t.getStringOption)(a.upsMode, ["usCarrier", "internationalCarrier", "secureSymbol", "standardSymbol"]), this.use = a.use || "", this.usehref = a.usehref || "", this.wideNarrowRatio = (0, t.getRatio)(a.wideNarrowRatio), this.encrypt = null, this.extras = null;
            }
          }
          class L extends n.XFAObject {
            constructor(a) {
              super(w, "bind", !0), this.match = (0, t.getStringOption)(a.match, ["once", "dataRef", "global", "none"]), this.ref = a.ref || "", this.picture = null;
            }
          }
          class _ extends n.XFAObject {
            constructor(a) {
              super(w, "bindItems"), this.connection = a.connection || "", this.labelRef = a.labelRef || "", this.ref = a.ref || "", this.valueRef = a.valueRef || "";
            }
          }
          F.BindItems = _;
          class G extends n.XFAObject {
            constructor(a) {
              super(w, "bookend"), this.id = a.id || "", this.leader = a.leader || "", this.trailer = a.trailer || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class J extends n.Option01 {
            constructor(a) {
              super(w, "boolean"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$toHTML](a) {
              return c(this[n.$content] === 1 ? "1" : "0");
            }
          }
          class K extends n.XFAObject {
            constructor(a) {
              super(w, "border", !0), this.break = (0, t.getStringOption)(a.break, ["close", "open"]), this.hand = (0, t.getStringOption)(a.hand, ["even", "left", "right"]), this.id = a.id || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.corner = new n.XFAObjectArray(4), this.edge = new n.XFAObjectArray(4), this.extras = null, this.fill = null, this.margin = null;
            }
            [n.$getExtra]() {
              if (!this[n.$extra]) {
                const a = this.edge.children.slice();
                if (a.length < 4) {
                  const He = a.at(-1) || new fe({});
                  for (let Ye = a.length; Ye < 4; Ye++)
                    a.push(He);
                }
                const Z = a.map((He) => He.thickness), De = [0, 0, 0, 0];
                this.margin && (De[0] = this.margin.topInset, De[1] = this.margin.rightInset, De[2] = this.margin.bottomInset, De[3] = this.margin.leftInset), this[n.$extra] = {
                  widths: Z,
                  insets: De,
                  edges: a
                };
              }
              return this[n.$extra];
            }
            [n.$toStyle]() {
              var He;
              const {
                edges: a
              } = this[n.$getExtra](), Z = a.map((Ye) => {
                const ut = Ye[n.$toStyle]();
                return ut.color || (ut.color = "#000000"), ut;
              }), De = /* @__PURE__ */ Object.create(null);
              if (this.margin && Object.assign(De, this.margin[n.$toStyle]()), ((He = this.fill) == null ? void 0 : He.presence) === "visible" && Object.assign(De, this.fill[n.$toStyle]()), this.corner.children.some((Ye) => Ye.radius !== 0)) {
                const Ye = this.corner.children.map((ut) => ut[n.$toStyle]());
                if (Ye.length === 2 || Ye.length === 3) {
                  const ut = Ye.at(-1);
                  for (let xt = Ye.length; xt < 4; xt++)
                    Ye.push(ut);
                }
                De.borderRadius = Ye.map((ut) => ut.radius).join(" ");
              }
              switch (this.presence) {
                case "invisible":
                case "hidden":
                  De.borderStyle = "";
                  break;
                case "inactive":
                  De.borderStyle = "none";
                  break;
                default:
                  De.borderStyle = Z.map((Ye) => Ye.style).join(" ");
                  break;
              }
              return De.borderWidth = Z.map((Ye) => Ye.width).join(" "), De.borderColor = Z.map((Ye) => Ye.color).join(" "), De;
            }
          }
          class V extends n.XFAObject {
            constructor(a) {
              super(w, "break", !0), this.after = (0, t.getStringOption)(a.after, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.afterTarget = a.afterTarget || "", this.before = (0, t.getStringOption)(a.before, ["auto", "contentArea", "pageArea", "pageEven", "pageOdd"]), this.beforeTarget = a.beforeTarget || "", this.bookendLeader = a.bookendLeader || "", this.bookendTrailer = a.bookendTrailer || "", this.id = a.id || "", this.overflowLeader = a.overflowLeader || "", this.overflowTarget = a.overflowTarget || "", this.overflowTrailer = a.overflowTrailer || "", this.startNew = (0, t.getInteger)({
                data: a.startNew,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
          }
          class U extends n.XFAObject {
            constructor(a) {
              super(w, "breakAfter", !0), this.id = a.id || "", this.leader = a.leader || "", this.startNew = (0, t.getInteger)({
                data: a.startNew,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.target = a.target || "", this.targetType = (0, t.getStringOption)(a.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = a.trailer || "", this.use = a.use || "", this.usehref = a.usehref || "", this.script = null;
            }
          }
          class Q extends n.XFAObject {
            constructor(a) {
              super(w, "breakBefore", !0), this.id = a.id || "", this.leader = a.leader || "", this.startNew = (0, t.getInteger)({
                data: a.startNew,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.target = a.target || "", this.targetType = (0, t.getStringOption)(a.targetType, ["auto", "contentArea", "pageArea"]), this.trailer = a.trailer || "", this.use = a.use || "", this.usehref = a.usehref || "", this.script = null;
            }
            [n.$toHTML](a) {
              return this[n.$extra] = {}, t.HTMLResult.FAILURE;
            }
          }
          class X extends n.XFAObject {
            constructor(a) {
              super(w, "button", !0), this.highlight = (0, t.getStringOption)(a.highlight, ["inverted", "none", "outline", "push"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
            [n.$toHTML](a) {
              const De = this[n.$getParent]()[n.$getParent](), He = {
                name: "button",
                attributes: {
                  id: this[n.$uid],
                  class: ["xfaButton"],
                  style: {}
                },
                children: []
              };
              for (const Ye of De.event.children) {
                if (Ye.activity !== "click" || !Ye.script)
                  continue;
                const ut = (0, M.recoverJsURL)(Ye.script[n.$content]);
                if (!ut)
                  continue;
                const xt = (0, e.fixURL)(ut.url);
                xt && He.children.push({
                  name: "a",
                  attributes: {
                    id: "link" + this[n.$uid],
                    href: xt,
                    newWindow: ut.newWindow,
                    class: ["xfaLink"],
                    style: {}
                  },
                  children: []
                });
              }
              return t.HTMLResult.success(He);
            }
          }
          class R extends n.XFAObject {
            constructor(a) {
              super(w, "calculate", !0), this.id = a.id || "", this.override = (0, t.getStringOption)(a.override, ["disabled", "error", "ignore", "warning"]), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.message = null, this.script = null;
            }
          }
          class f extends n.XFAObject {
            constructor(a) {
              super(w, "caption", !0), this.id = a.id || "", this.placement = (0, t.getStringOption)(a.placement, ["left", "bottom", "inline", "right", "top"]), this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.reserve = Math.ceil((0, t.getMeasurement)(a.reserve)), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.font = null, this.margin = null, this.para = null, this.value = null;
            }
            [n.$setValue](a) {
              x(this, a);
            }
            [n.$getExtra](a) {
              if (!this[n.$extra]) {
                let {
                  width: Z,
                  height: De
                } = a;
                switch (this.placement) {
                  case "left":
                  case "right":
                  case "inline":
                    Z = this.reserve <= 0 ? Z : this.reserve;
                    break;
                  case "top":
                  case "bottom":
                    De = this.reserve <= 0 ? De : this.reserve;
                    break;
                }
                this[n.$extra] = (0, e.layoutNode)(this, {
                  width: Z,
                  height: De
                });
              }
              return this[n.$extra];
            }
            [n.$toHTML](a) {
              if (!this.value)
                return t.HTMLResult.EMPTY;
              this[n.$pushPara]();
              const Z = this.value[n.$toHTML](a).html;
              if (!Z)
                return this[n.$popPara](), t.HTMLResult.EMPTY;
              const De = this.reserve;
              if (this.reserve <= 0) {
                const {
                  w: ut,
                  h: xt
                } = this[n.$getExtra](a);
                switch (this.placement) {
                  case "left":
                  case "right":
                  case "inline":
                    this.reserve = ut;
                    break;
                  case "top":
                  case "bottom":
                    this.reserve = xt;
                    break;
                }
              }
              const He = [];
              typeof Z == "string" ? He.push({
                name: "#text",
                value: Z
              }) : He.push(Z);
              const Ye = (0, e.toStyle)(this, "font", "margin", "visibility");
              switch (this.placement) {
                case "left":
                case "right":
                  this.reserve > 0 && (Ye.width = (0, e.measureToString)(this.reserve));
                  break;
                case "top":
                case "bottom":
                  this.reserve > 0 && (Ye.height = (0, e.measureToString)(this.reserve));
                  break;
              }
              return (0, e.setPara)(this, null, Z), this[n.$popPara](), this.reserve = De, t.HTMLResult.success({
                name: "div",
                attributes: {
                  style: Ye,
                  class: ["xfaCaption"]
                },
                children: He
              });
            }
          }
          class D extends n.StringObject {
            constructor(a) {
              super(w, "certificate"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class z extends n.XFAObject {
            constructor(a) {
              super(w, "certificates", !0), this.credentialServerPolicy = (0, t.getStringOption)(a.credentialServerPolicy, ["optional", "required"]), this.id = a.id || "", this.url = a.url || "", this.urlPolicy = a.urlPolicy || "", this.use = a.use || "", this.usehref = a.usehref || "", this.encryption = null, this.issuers = null, this.keyUsage = null, this.oids = null, this.signing = null, this.subjectDNs = null;
            }
          }
          class Y extends n.XFAObject {
            constructor(a) {
              super(w, "checkButton", !0), this.id = a.id || "", this.mark = (0, t.getStringOption)(a.mark, ["default", "check", "circle", "cross", "diamond", "square", "star"]), this.shape = (0, t.getStringOption)(a.shape, ["square", "round"]), this.size = (0, t.getMeasurement)(a.size, "10pt"), this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [n.$toHTML](a) {
              var qt, Xt, Kt;
              const Z = (0, e.toStyle)("margin"), De = (0, e.measureToString)(this.size);
              Z.width = Z.height = De;
              let He, Ye, ut;
              const xt = this[n.$getParent]()[n.$getParent](), bt = xt.items.children.length && xt.items.children[0][n.$toHTML]().html || [], Tt = {
                on: (bt[0] !== void 0 ? bt[0] : "on").toString(),
                off: (bt[1] !== void 0 ? bt[1] : "off").toString()
              }, $t = (((qt = xt.value) == null ? void 0 : qt[n.$text]()) || "off") === Tt.on || void 0, jt = xt[n.$getSubformParent](), Ht = xt[n.$uid];
              let zt;
              jt instanceof Ge ? (ut = jt[n.$uid], He = "radio", Ye = "xfaRadio", zt = ((Xt = jt[n.$data]) == null ? void 0 : Xt[n.$uid]) || jt[n.$uid]) : (He = "checkbox", Ye = "xfaCheckbox", zt = ((Kt = xt[n.$data]) == null ? void 0 : Kt[n.$uid]) || xt[n.$uid]);
              const Ot = {
                name: "input",
                attributes: {
                  class: [Ye],
                  style: Z,
                  fieldId: Ht,
                  dataId: zt,
                  type: He,
                  checked: $t,
                  xfaOn: Tt.on,
                  xfaOff: Tt.off,
                  "aria-label": P(xt),
                  "aria-required": !1
                }
              };
              return ut && (Ot.attributes.name = ut), I(xt) && (Ot.attributes["aria-required"] = !0, Ot.attributes.required = !0), t.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [Ot]
              });
            }
          }
          class W extends n.XFAObject {
            constructor(a) {
              super(w, "choiceList", !0), this.commitOn = (0, t.getStringOption)(a.commitOn, ["select", "exit"]), this.id = a.id || "", this.open = (0, t.getStringOption)(a.open, ["userControl", "always", "multiSelect", "onEntry"]), this.textEntry = (0, t.getInteger)({
                data: a.textEntry,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [n.$toHTML](a) {
              var Tt, _t, $t;
              const Z = (0, e.toStyle)(this, "border", "margin"), He = this[n.$getParent]()[n.$getParent](), ut = {
                fontSize: `calc(${((Tt = He.font) == null ? void 0 : Tt.size) || 10}px * var(--scale-factor))`
              }, xt = [];
              if (He.items.children.length > 0) {
                const jt = He.items;
                let Ht = 0, zt = 0;
                jt.children.length === 2 && (Ht = jt.children[0].save, zt = 1 - Ht);
                const Ot = jt.children[Ht][n.$toHTML]().html, qt = jt.children[zt][n.$toHTML]().html;
                let Xt = !1;
                const Kt = ((_t = He.value) == null ? void 0 : _t[n.$text]()) || "";
                for (let Wt = 0, Lt = Ot.length; Wt < Lt; Wt++) {
                  const wt = {
                    name: "option",
                    attributes: {
                      value: qt[Wt] || Ot[Wt],
                      style: ut
                    },
                    value: Ot[Wt]
                  };
                  qt[Wt] === Kt && (wt.attributes.selected = Xt = !0), xt.push(wt);
                }
                Xt || xt.splice(0, 0, {
                  name: "option",
                  attributes: {
                    hidden: !0,
                    selected: !0
                  },
                  value: " "
                });
              }
              const bt = {
                class: ["xfaSelect"],
                fieldId: He[n.$uid],
                dataId: (($t = He[n.$data]) == null ? void 0 : $t[n.$uid]) || He[n.$uid],
                style: Z,
                "aria-label": P(He),
                "aria-required": !1
              };
              return I(He) && (bt["aria-required"] = !0, bt.required = !0), this.open === "multiSelect" && (bt.multiple = !0), t.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [{
                  name: "select",
                  children: xt,
                  attributes: bt
                }]
              });
            }
          }
          class ie extends n.XFAObject {
            constructor(a) {
              super(w, "color", !0), this.cSpace = (0, t.getStringOption)(a.cSpace, ["SRGB"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.value = a.value ? (0, t.getColor)(a.value) : "", this.extras = null;
            }
            [n.$hasSettableValue]() {
              return !1;
            }
            [n.$toStyle]() {
              return this.value ? B.Util.makeHexColor(this.value.r, this.value.g, this.value.b) : null;
            }
          }
          class ne extends n.XFAObject {
            constructor(a) {
              super(w, "comb"), this.id = a.id || "", this.numberOfCells = (0, t.getInteger)({
                data: a.numberOfCells,
                defaultValue: 0,
                validate: (Z) => Z >= 0
              }), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class re extends n.XFAObject {
            constructor(a) {
              super(w, "connect", !0), this.connection = a.connection || "", this.id = a.id || "", this.ref = a.ref || "", this.usage = (0, t.getStringOption)(a.usage, ["exportAndImport", "exportOnly", "importOnly"]), this.use = a.use || "", this.usehref = a.usehref || "", this.picture = null;
            }
          }
          class ee extends n.XFAObject {
            constructor(a) {
              super(w, "contentArea", !0), this.h = (0, t.getMeasurement)(a.h), this.id = a.id || "", this.name = a.name || "", this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.w = (0, t.getMeasurement)(a.w), this.x = (0, t.getMeasurement)(a.x, "0pt"), this.y = (0, t.getMeasurement)(a.y, "0pt"), this.desc = null, this.extras = null;
            }
            [n.$toHTML](a) {
              const Z = (0, e.measureToString)(this.x), De = (0, e.measureToString)(this.y), He = {
                left: Z,
                top: De,
                width: (0, e.measureToString)(this.w),
                height: (0, e.measureToString)(this.h)
              }, Ye = ["xfaContentarea"];
              return (0, e.isPrintOnly)(this) && Ye.push("xfaPrintOnly"), t.HTMLResult.success({
                name: "div",
                children: [],
                attributes: {
                  style: He,
                  class: Ye,
                  id: this[n.$uid]
                }
              });
            }
          }
          class te extends n.XFAObject {
            constructor(a) {
              super(w, "corner", !0), this.id = a.id || "", this.inverted = (0, t.getInteger)({
                data: a.inverted,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.join = (0, t.getStringOption)(a.join, ["square", "round"]), this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.radius = (0, t.getMeasurement)(a.radius), this.stroke = (0, t.getStringOption)(a.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, t.getMeasurement)(a.thickness, "0.5pt"), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null;
            }
            [n.$toStyle]() {
              const a = (0, e.toStyle)(this, "visibility");
              return a.radius = (0, e.measureToString)(this.join === "square" ? 0 : this.radius), a;
            }
          }
          class oe extends n.ContentObject {
            constructor(a) {
              super(w, "date"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              const a = this[n.$content].trim();
              this[n.$content] = a ? new Date(a) : null;
            }
            [n.$toHTML](a) {
              return c(this[n.$content] ? this[n.$content].toString() : "");
            }
          }
          class se extends n.ContentObject {
            constructor(a) {
              super(w, "dateTime"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              const a = this[n.$content].trim();
              this[n.$content] = a ? new Date(a) : null;
            }
            [n.$toHTML](a) {
              return c(this[n.$content] ? this[n.$content].toString() : "");
            }
          }
          class ce extends n.XFAObject {
            constructor(a) {
              super(w, "dateTimeEdit", !0), this.hScrollPolicy = (0, t.getStringOption)(a.hScrollPolicy, ["auto", "off", "on"]), this.id = a.id || "", this.picker = (0, t.getStringOption)(a.picker, ["host", "none"]), this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [n.$toHTML](a) {
              var Ye;
              const Z = (0, e.toStyle)(this, "border", "font", "margin"), De = this[n.$getParent]()[n.$getParent](), He = {
                name: "input",
                attributes: {
                  type: "text",
                  fieldId: De[n.$uid],
                  dataId: ((Ye = De[n.$data]) == null ? void 0 : Ye[n.$uid]) || De[n.$uid],
                  class: ["xfaTextfield"],
                  style: Z,
                  "aria-label": P(De),
                  "aria-required": !1
                }
              };
              return I(De) && (He.attributes["aria-required"] = !0, He.attributes.required = !0), t.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [He]
              });
            }
          }
          class le extends n.ContentObject {
            constructor(a) {
              super(w, "decimal"), this.fracDigits = (0, t.getInteger)({
                data: a.fracDigits,
                defaultValue: 2,
                validate: (Z) => !0
              }), this.id = a.id || "", this.leadDigits = (0, t.getInteger)({
                data: a.leadDigits,
                defaultValue: -1,
                validate: (Z) => !0
              }), this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              const a = parseFloat(this[n.$content].trim());
              this[n.$content] = isNaN(a) ? null : a;
            }
            [n.$toHTML](a) {
              return c(this[n.$content] !== null ? this[n.$content].toString() : "");
            }
          }
          class de extends n.XFAObject {
            constructor(a) {
              super(w, "defaultUi", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
          }
          class Ie extends n.XFAObject {
            constructor(a) {
              super(w, "desc", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.boolean = new n.XFAObjectArray(), this.date = new n.XFAObjectArray(), this.dateTime = new n.XFAObjectArray(), this.decimal = new n.XFAObjectArray(), this.exData = new n.XFAObjectArray(), this.float = new n.XFAObjectArray(), this.image = new n.XFAObjectArray(), this.integer = new n.XFAObjectArray(), this.text = new n.XFAObjectArray(), this.time = new n.XFAObjectArray();
            }
          }
          class Fe extends n.OptionObject {
            constructor(a) {
              super(w, "digestMethod", ["", "SHA1", "SHA256", "SHA512", "RIPEMD160"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class we extends n.XFAObject {
            constructor(a) {
              super(w, "digestMethods", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.digestMethod = new n.XFAObjectArray();
            }
          }
          class pe extends n.XFAObject {
            constructor(a) {
              super(w, "draw", !0), this.anchorType = (0, t.getStringOption)(a.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, t.getInteger)({
                data: a.colSpan,
                defaultValue: 1,
                validate: (Z) => Z >= 1 || Z === -1
              }), this.h = a.h ? (0, t.getMeasurement)(a.h) : "", this.hAlign = (0, t.getStringOption)(a.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = a.id || "", this.locale = a.locale || "", this.maxH = (0, t.getMeasurement)(a.maxH, "0pt"), this.maxW = (0, t.getMeasurement)(a.maxW, "0pt"), this.minH = (0, t.getMeasurement)(a.minH, "0pt"), this.minW = (0, t.getMeasurement)(a.minW, "0pt"), this.name = a.name || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, t.getRelevant)(a.relevant), this.rotate = (0, t.getInteger)({
                data: a.rotate,
                defaultValue: 0,
                validate: (Z) => Z % 90 === 0
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.w = a.w ? (0, t.getMeasurement)(a.w) : "", this.x = (0, t.getMeasurement)(a.x, "0pt"), this.y = (0, t.getMeasurement)(a.y, "0pt"), this.assist = null, this.border = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.value = null, this.setProperty = new n.XFAObjectArray();
            }
            [n.$setValue](a) {
              x(this, a);
            }
            [n.$toHTML](a) {
              if (h(this), this.presence === "hidden" || this.presence === "inactive")
                return t.HTMLResult.EMPTY;
              (0, e.fixDimensions)(this), this[n.$pushPara]();
              const Z = this.w, De = this.h, {
                w: He,
                h: Ye,
                isBroken: ut
              } = (0, e.layoutNode)(this, a);
              if (He && this.w === "") {
                if (ut && this[n.$getSubformParent]()[n.$isThereMoreWidth]())
                  return this[n.$popPara](), t.HTMLResult.FAILURE;
                this.w = He;
              }
              if (Ye && this.h === "" && (this.h = Ye), d(this), !(0, q.checkDimensions)(this, a))
                return this.w = Z, this.h = De, this[n.$popPara](), t.HTMLResult.FAILURE;
              A(this);
              const xt = (0, e.toStyle)(this, "font", "hAlign", "dimensions", "position", "presence", "rotate", "anchorType", "border", "margin");
              (0, e.setMinMaxDimensions)(this, xt), xt.margin && (xt.padding = xt.margin, delete xt.margin);
              const bt = ["xfaDraw"];
              this.font && bt.push("xfaFont"), (0, e.isPrintOnly)(this) && bt.push("xfaPrintOnly");
              const Tt = {
                style: xt,
                id: this[n.$uid],
                class: bt
              };
              this.name && (Tt.xfaName = this.name);
              const _t = {
                name: "div",
                attributes: Tt,
                children: []
              };
              y(this, Tt);
              const $t = (0, e.computeBbox)(this, _t, a), jt = this.value ? this.value[n.$toHTML](a).html : null;
              return jt === null ? (this.w = Z, this.h = De, this[n.$popPara](), t.HTMLResult.success((0, e.createWrapper)(this, _t), $t)) : (_t.children.push(jt), (0, e.setPara)(this, xt, jt), this.w = Z, this.h = De, this[n.$popPara](), t.HTMLResult.success((0, e.createWrapper)(this, _t), $t));
            }
          }
          class fe extends n.XFAObject {
            constructor(a) {
              super(w, "edge", !0), this.cap = (0, t.getStringOption)(a.cap, ["square", "butt", "round"]), this.id = a.id || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.stroke = (0, t.getStringOption)(a.stroke, ["solid", "dashDot", "dashDotDot", "dashed", "dotted", "embossed", "etched", "lowered", "raised"]), this.thickness = (0, t.getMeasurement)(a.thickness, "0.5pt"), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null;
            }
            [n.$toStyle]() {
              const a = (0, e.toStyle)(this, "visibility");
              if (Object.assign(a, {
                linecap: this.cap,
                width: (0, e.measureToString)(this.thickness),
                color: this.color ? this.color[n.$toStyle]() : "#000000",
                style: ""
              }), this.presence !== "visible")
                a.style = "none";
              else
                switch (this.stroke) {
                  case "solid":
                    a.style = "solid";
                    break;
                  case "dashDot":
                    a.style = "dashed";
                    break;
                  case "dashDotDot":
                    a.style = "dashed";
                    break;
                  case "dashed":
                    a.style = "dashed";
                    break;
                  case "dotted":
                    a.style = "dotted";
                    break;
                  case "embossed":
                    a.style = "ridge";
                    break;
                  case "etched":
                    a.style = "groove";
                    break;
                  case "lowered":
                    a.style = "inset";
                    break;
                  case "raised":
                    a.style = "outset";
                    break;
                }
              return a;
            }
          }
          class Ae extends n.OptionObject {
            constructor(a) {
              super(w, "encoding", ["adbe.x509.rsa_sha1", "adbe.pkcs7.detached", "adbe.pkcs7.sha1"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Pe extends n.XFAObject {
            constructor(a) {
              super(w, "encodings", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.encoding = new n.XFAObjectArray();
            }
          }
          class Re extends n.XFAObject {
            constructor(a) {
              super(w, "encrypt", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.certificate = null;
            }
          }
          class Ee extends n.XFAObject {
            constructor(a) {
              super(w, "encryptData", !0), this.id = a.id || "", this.operation = (0, t.getStringOption)(a.operation, ["encrypt", "decrypt"]), this.target = a.target || "", this.use = a.use || "", this.usehref = a.usehref || "", this.filter = null, this.manifest = null;
            }
          }
          class ye extends n.XFAObject {
            constructor(a) {
              super(w, "encryption", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.certificate = new n.XFAObjectArray();
            }
          }
          class Te extends n.OptionObject {
            constructor(a) {
              super(w, "encryptionMethod", ["", "AES256-CBC", "TRIPLEDES-CBC", "AES128-CBC", "AES192-CBC"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class je extends n.XFAObject {
            constructor(a) {
              super(w, "encryptionMethods", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.encryptionMethod = new n.XFAObjectArray();
            }
          }
          class ve extends n.XFAObject {
            constructor(a) {
              super(w, "event", !0), this.activity = (0, t.getStringOption)(a.activity, ["click", "change", "docClose", "docReady", "enter", "exit", "full", "indexChange", "initialize", "mouseDown", "mouseEnter", "mouseExit", "mouseUp", "postExecute", "postOpen", "postPrint", "postSave", "postSign", "postSubmit", "preExecute", "preOpen", "prePrint", "preSave", "preSign", "preSubmit", "ready", "validationState"]), this.id = a.id || "", this.listen = (0, t.getStringOption)(a.listen, ["refOnly", "refAndDescendents"]), this.name = a.name || "", this.ref = a.ref || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.encryptData = null, this.execute = null, this.script = null, this.signData = null, this.submit = null;
            }
          }
          class Ce extends n.ContentObject {
            constructor(a) {
              super(w, "exData"), this.contentType = a.contentType || "", this.href = a.href || "", this.id = a.id || "", this.maxLength = (0, t.getInteger)({
                data: a.maxLength,
                defaultValue: -1,
                validate: (Z) => Z >= -1
              }), this.name = a.name || "", this.rid = a.rid || "", this.transferEncoding = (0, t.getStringOption)(a.transferEncoding, ["none", "base64", "package"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$isCDATAXml]() {
              return this.contentType === "text/html";
            }
            [n.$onChild](a) {
              return this.contentType === "text/html" && a[n.$namespaceId] === u.NamespaceIds.xhtml.id ? (this[n.$content] = a, !0) : this.contentType === "text/xml" ? (this[n.$content] = a, !0) : !1;
            }
            [n.$toHTML](a) {
              return this.contentType !== "text/html" || !this[n.$content] ? t.HTMLResult.EMPTY : this[n.$content][n.$toHTML](a);
            }
          }
          class Ne extends n.XFAObject {
            constructor(a) {
              super(w, "exObject", !0), this.archive = a.archive || "", this.classId = a.classId || "", this.codeBase = a.codeBase || "", this.codeType = a.codeType || "", this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.boolean = new n.XFAObjectArray(), this.date = new n.XFAObjectArray(), this.dateTime = new n.XFAObjectArray(), this.decimal = new n.XFAObjectArray(), this.exData = new n.XFAObjectArray(), this.exObject = new n.XFAObjectArray(), this.float = new n.XFAObjectArray(), this.image = new n.XFAObjectArray(), this.integer = new n.XFAObjectArray(), this.text = new n.XFAObjectArray(), this.time = new n.XFAObjectArray();
            }
          }
          class Ge extends n.XFAObject {
            constructor(a) {
              super(w, "exclGroup", !0), this.access = (0, t.getStringOption)(a.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = a.accessKey || "", this.anchorType = (0, t.getStringOption)(a.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, t.getInteger)({
                data: a.colSpan,
                defaultValue: 1,
                validate: (Z) => Z >= 1 || Z === -1
              }), this.h = a.h ? (0, t.getMeasurement)(a.h) : "", this.hAlign = (0, t.getStringOption)(a.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = a.id || "", this.layout = (0, t.getStringOption)(a.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.maxH = (0, t.getMeasurement)(a.maxH, "0pt"), this.maxW = (0, t.getMeasurement)(a.maxW, "0pt"), this.minH = (0, t.getMeasurement)(a.minH, "0pt"), this.minW = (0, t.getMeasurement)(a.minW, "0pt"), this.name = a.name || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.w = a.w ? (0, t.getMeasurement)(a.w) : "", this.x = (0, t.getMeasurement)(a.x, "0pt"), this.y = (0, t.getMeasurement)(a.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.margin = null, this.para = null, this.traversal = null, this.validate = null, this.connect = new n.XFAObjectArray(), this.event = new n.XFAObjectArray(), this.field = new n.XFAObjectArray(), this.setProperty = new n.XFAObjectArray();
            }
            [n.$isBindable]() {
              return !0;
            }
            [n.$hasSettableValue]() {
              return !0;
            }
            [n.$setValue](a) {
              for (const Z of this.field.children) {
                if (!Z.value) {
                  const De = new cn({});
                  Z[n.$appendChild](De), Z.value = De;
                }
                Z.value[n.$setValue](a);
              }
            }
            [n.$isThereMoreWidth]() {
              return this.layout.endsWith("-tb") && this[n.$extra].attempt === 0 && this[n.$extra].numberInLine > 0 || this[n.$getParent]()[n.$isThereMoreWidth]();
            }
            [n.$isSplittable]() {
              var Z;
              const a = this[n.$getSubformParent]();
              return a[n.$isSplittable]() ? this[n.$extra]._isSplittable !== void 0 ? this[n.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[n.$extra]._isSplittable = !1, !1) : (Z = a.layout) != null && Z.endsWith("-tb") && a[n.$extra].numberInLine !== 0 ? !1 : (this[n.$extra]._isSplittable = !0, !0) : !1;
            }
            [n.$flushHTML]() {
              return (0, q.flushHTML)(this);
            }
            [n.$addHTML](a, Z) {
              (0, q.addHTML)(this, a, Z);
            }
            [n.$getAvailableSpace]() {
              return (0, q.getAvailableSpace)(this);
            }
            [n.$toHTML](a) {
              if (h(this), this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                return t.HTMLResult.EMPTY;
              (0, e.fixDimensions)(this);
              const Z = [], De = {
                id: this[n.$uid],
                class: []
              };
              (0, e.setAccess)(this, De.class), this[n.$extra] || (this[n.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[n.$extra], {
                children: Z,
                attributes: De,
                attempt: 0,
                line: null,
                numberInLine: 0,
                availableSpace: {
                  width: Math.min(this.w || 1 / 0, a.width),
                  height: Math.min(this.h || 1 / 0, a.height)
                },
                width: 0,
                height: 0,
                prevHeight: 0,
                currentWidth: 0
              });
              const He = this[n.$isSplittable]();
              if (He || d(this), !(0, q.checkDimensions)(this, a))
                return t.HTMLResult.FAILURE;
              const Ye = /* @__PURE__ */ new Set(["field"]);
              if (this.layout.includes("row")) {
                const Xt = this[n.$getSubformParent]().columnWidths;
                Array.isArray(Xt) && Xt.length > 0 && (this[n.$extra].columnWidths = Xt, this[n.$extra].currentColumn = 0);
              }
              const ut = (0, e.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), xt = ["xfaExclgroup"], bt = (0, e.layoutClass)(this);
              bt && xt.push(bt), (0, e.isPrintOnly)(this) && xt.push("xfaPrintOnly"), De.style = ut, De.class = xt, this.name && (De.xfaName = this.name), this[n.$pushPara]();
              const Tt = this.layout === "lr-tb" || this.layout === "rl-tb", _t = Tt ? i : 1;
              for (; this[n.$extra].attempt < _t; this[n.$extra].attempt++) {
                Tt && this[n.$extra].attempt === i - 1 && (this[n.$extra].numberInLine = 0);
                const Xt = this[n.$childrenToHTML]({
                  filter: Ye,
                  include: !0
                });
                if (Xt.success)
                  break;
                if (Xt.isBreak())
                  return this[n.$popPara](), Xt;
                if (Tt && this[n.$extra].attempt === 0 && this[n.$extra].numberInLine === 0 && !this[n.$getTemplateRoot]()[n.$extra].noLayoutFailure) {
                  this[n.$extra].attempt = _t;
                  break;
                }
              }
              if (this[n.$popPara](), He || A(this), this[n.$extra].attempt === _t)
                return He || delete this[n.$extra], t.HTMLResult.FAILURE;
              let $t = 0, jt = 0;
              this.margin && ($t = this.margin.leftInset + this.margin.rightInset, jt = this.margin.topInset + this.margin.bottomInset);
              const Ht = Math.max(this[n.$extra].width + $t, this.w || 0), zt = Math.max(this[n.$extra].height + jt, this.h || 0), Ot = [this.x, this.y, Ht, zt];
              this.w === "" && (ut.width = (0, e.measureToString)(Ht)), this.h === "" && (ut.height = (0, e.measureToString)(zt));
              const qt = {
                name: "div",
                attributes: De,
                children: Z
              };
              return y(this, De), delete this[n.$extra], t.HTMLResult.success((0, e.createWrapper)(this, qt), Ot);
            }
          }
          class Oe extends n.XFAObject {
            constructor(a) {
              super(w, "execute"), this.connection = a.connection || "", this.executeType = (0, t.getStringOption)(a.executeType, ["import", "remerge"]), this.id = a.id || "", this.runAt = (0, t.getStringOption)(a.runAt, ["client", "both", "server"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class tt extends n.XFAObject {
            constructor(a) {
              super(w, "extras", !0), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "", this.boolean = new n.XFAObjectArray(), this.date = new n.XFAObjectArray(), this.dateTime = new n.XFAObjectArray(), this.decimal = new n.XFAObjectArray(), this.exData = new n.XFAObjectArray(), this.extras = new n.XFAObjectArray(), this.float = new n.XFAObjectArray(), this.image = new n.XFAObjectArray(), this.integer = new n.XFAObjectArray(), this.text = new n.XFAObjectArray(), this.time = new n.XFAObjectArray();
            }
          }
          class Ke extends n.XFAObject {
            constructor(a) {
              super(w, "field", !0), this.access = (0, t.getStringOption)(a.access, ["open", "nonInteractive", "protected", "readOnly"]), this.accessKey = a.accessKey || "", this.anchorType = (0, t.getStringOption)(a.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, t.getInteger)({
                data: a.colSpan,
                defaultValue: 1,
                validate: (Z) => Z >= 1 || Z === -1
              }), this.h = a.h ? (0, t.getMeasurement)(a.h) : "", this.hAlign = (0, t.getStringOption)(a.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = a.id || "", this.locale = a.locale || "", this.maxH = (0, t.getMeasurement)(a.maxH, "0pt"), this.maxW = (0, t.getMeasurement)(a.maxW, "0pt"), this.minH = (0, t.getMeasurement)(a.minH, "0pt"), this.minW = (0, t.getMeasurement)(a.minW, "0pt"), this.name = a.name || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, t.getRelevant)(a.relevant), this.rotate = (0, t.getInteger)({
                data: a.rotate,
                defaultValue: 0,
                validate: (Z) => Z % 90 === 0
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.w = a.w ? (0, t.getMeasurement)(a.w) : "", this.x = (0, t.getMeasurement)(a.x, "0pt"), this.y = (0, t.getMeasurement)(a.y, "0pt"), this.assist = null, this.bind = null, this.border = null, this.calculate = null, this.caption = null, this.desc = null, this.extras = null, this.font = null, this.format = null, this.items = new n.XFAObjectArray(2), this.keep = null, this.margin = null, this.para = null, this.traversal = null, this.ui = null, this.validate = null, this.value = null, this.bindItems = new n.XFAObjectArray(), this.connect = new n.XFAObjectArray(), this.event = new n.XFAObjectArray(), this.setProperty = new n.XFAObjectArray();
            }
            [n.$isBindable]() {
              return !0;
            }
            [n.$setValue](a) {
              x(this, a);
            }
            [n.$toHTML](a) {
              var Xt, Kt, Wt;
              if (h(this), !this.ui) {
                this.ui = new xn({}), this.ui[n.$globalData] = this[n.$globalData], this[n.$appendChild](this.ui);
                let Lt;
                switch (this.items.children.length) {
                  case 0:
                    Lt = new vn({}), this.ui.textEdit = Lt;
                    break;
                  case 1:
                    Lt = new Y({}), this.ui.checkButton = Lt;
                    break;
                  case 2:
                    Lt = new W({}), this.ui.choiceList = Lt;
                    break;
                }
                this.ui[n.$appendChild](Lt);
              }
              if (!this.ui || this.presence === "hidden" || this.presence === "inactive" || this.h === 0 || this.w === 0)
                return t.HTMLResult.EMPTY;
              this.caption && delete this.caption[n.$extra], this[n.$pushPara]();
              const Z = this.caption ? this.caption[n.$toHTML](a).html : null, De = this.w, He = this.h;
              let Ye = 0, ut = 0;
              this.margin && (Ye = this.margin.leftInset + this.margin.rightInset, ut = this.margin.topInset + this.margin.bottomInset);
              let xt = null;
              if (this.w === "" || this.h === "") {
                let Lt = null, wt = null, Qt = 0, Jt = 0;
                if (this.ui.checkButton)
                  Qt = Jt = this.ui.checkButton.size;
                else {
                  const {
                    w: an,
                    h: en
                  } = (0, e.layoutNode)(this, a);
                  an !== null ? (Qt = an, Jt = en) : Jt = (0, j.getMetrics)(this.font, !0).lineNoGap;
                }
                if (xt = v(this.ui[n.$getExtra]()), Qt += xt.w, Jt += xt.h, this.caption) {
                  const {
                    w: an,
                    h: en,
                    isBroken: Vt
                  } = this.caption[n.$getExtra](a);
                  if (Vt && this[n.$getSubformParent]()[n.$isThereMoreWidth]())
                    return this[n.$popPara](), t.HTMLResult.FAILURE;
                  switch (Lt = an, wt = en, this.caption.placement) {
                    case "left":
                    case "right":
                    case "inline":
                      Lt += Qt;
                      break;
                    case "top":
                    case "bottom":
                      wt += Jt;
                      break;
                  }
                } else
                  Lt = Qt, wt = Jt;
                Lt && this.w === "" && (Lt += Ye, this.w = Math.min(this.maxW <= 0 ? 1 / 0 : this.maxW, this.minW + 1 < Lt ? Lt : this.minW)), wt && this.h === "" && (wt += ut, this.h = Math.min(this.maxH <= 0 ? 1 / 0 : this.maxH, this.minH + 1 < wt ? wt : this.minH));
              }
              if (this[n.$popPara](), (0, e.fixDimensions)(this), d(this), !(0, q.checkDimensions)(this, a))
                return this.w = De, this.h = He, this[n.$popPara](), t.HTMLResult.FAILURE;
              A(this);
              const bt = (0, e.toStyle)(this, "font", "dimensions", "position", "rotate", "anchorType", "presence", "margin", "hAlign");
              (0, e.setMinMaxDimensions)(this, bt);
              const Tt = ["xfaField"];
              this.font && Tt.push("xfaFont"), (0, e.isPrintOnly)(this) && Tt.push("xfaPrintOnly");
              const _t = {
                style: bt,
                id: this[n.$uid],
                class: Tt
              };
              bt.margin && (bt.padding = bt.margin, delete bt.margin), (0, e.setAccess)(this, Tt), this.name && (_t.xfaName = this.name);
              const $t = [], jt = {
                name: "div",
                attributes: _t,
                children: $t
              };
              y(this, _t);
              const Ht = this.border ? this.border[n.$toStyle]() : null, zt = (0, e.computeBbox)(this, jt, a), Ot = this.ui[n.$toHTML]().html;
              if (!Ot)
                return Object.assign(bt, Ht), t.HTMLResult.success((0, e.createWrapper)(this, jt), zt);
              this[n.$tabIndex] && ((Xt = Ot.children) != null && Xt[0] ? Ot.children[0].attributes.tabindex = this[n.$tabIndex] : Ot.attributes.tabindex = this[n.$tabIndex]), Ot.attributes.style || (Ot.attributes.style = /* @__PURE__ */ Object.create(null));
              let qt = null;
              if (this.ui.button ? (Ot.children.length === 1 && ([qt] = Ot.children.splice(0, 1)), Object.assign(Ot.attributes.style, Ht)) : Object.assign(bt, Ht), $t.push(Ot), this.value) {
                if (this.ui.imageEdit)
                  Ot.children.push(this.value[n.$toHTML]().html);
                else if (!this.ui.button) {
                  let Lt = "";
                  if (this.value.exData)
                    Lt = this.value.exData[n.$text]();
                  else if (this.value.text)
                    Lt = this.value.text[n.$getExtra]();
                  else {
                    const wt = this.value[n.$toHTML]().html;
                    wt !== null && (Lt = wt.children[0].value);
                  }
                  this.ui.textEdit && ((Kt = this.value.text) != null && Kt.maxChars) && (Ot.children[0].attributes.maxLength = this.value.text.maxChars), Lt && (this.ui.numericEdit && (Lt = parseFloat(Lt), Lt = isNaN(Lt) ? "" : Lt.toString()), Ot.children[0].name === "textarea" ? Ot.children[0].attributes.textContent = Lt : Ot.children[0].attributes.value = Lt);
                }
              }
              if (!this.ui.imageEdit && ((Wt = Ot.children) != null && Wt[0]) && this.h) {
                xt = xt || v(this.ui[n.$getExtra]());
                let Lt = 0;
                if (this.caption && ["top", "bottom"].includes(this.caption.placement)) {
                  Lt = this.caption.reserve, Lt <= 0 && (Lt = this.caption[n.$getExtra](a).h);
                  const wt = this.h - Lt - ut - xt.h;
                  Ot.children[0].attributes.style.height = (0, e.measureToString)(wt);
                } else
                  Ot.children[0].attributes.style.height = "100%";
              }
              if (qt && Ot.children.push(qt), !Z)
                return Ot.attributes.class && Ot.attributes.class.push("xfaLeft"), this.w = De, this.h = He, t.HTMLResult.success((0, e.createWrapper)(this, jt), zt);
              if (this.ui.button)
                return bt.padding && delete bt.padding, Z.name === "div" && (Z.name = "span"), Ot.children.push(Z), t.HTMLResult.success(jt, zt);
              switch (this.ui.checkButton && (Z.attributes.class[0] = "xfaCaptionForCheckButton"), Ot.attributes.class || (Ot.attributes.class = []), Ot.children.splice(0, 0, Z), this.caption.placement) {
                case "left":
                  Ot.attributes.class.push("xfaLeft");
                  break;
                case "right":
                  Ot.attributes.class.push("xfaRight");
                  break;
                case "top":
                  Ot.attributes.class.push("xfaTop");
                  break;
                case "bottom":
                  Ot.attributes.class.push("xfaBottom");
                  break;
                case "inline":
                  Ot.attributes.class.push("xfaLeft");
                  break;
              }
              return this.w = De, this.h = He, t.HTMLResult.success((0, e.createWrapper)(this, jt), zt);
            }
          }
          F.Field = Ke;
          class et extends n.XFAObject {
            constructor(a) {
              super(w, "fill", !0), this.id = a.id || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null, this.linear = null, this.pattern = null, this.radial = null, this.solid = null, this.stipple = null;
            }
            [n.$toStyle]() {
              var xt;
              const a = this[n.$getParent](), De = a[n.$getParent]()[n.$getParent](), He = /* @__PURE__ */ Object.create(null);
              let Ye = "color", ut = Ye;
              a instanceof K && (Ye = "background-color", ut = "background", De instanceof xn && (He.backgroundColor = "white")), (a instanceof vt || a instanceof $) && (Ye = ut = "fill", He.fill = "white");
              for (const bt of Object.getOwnPropertyNames(this)) {
                if (bt === "extras" || bt === "color")
                  continue;
                const Tt = this[bt];
                if (!(Tt instanceof n.XFAObject))
                  continue;
                const _t = Tt[n.$toStyle](this.color);
                return _t && (He[_t.startsWith("#") ? Ye : ut] = _t), He;
              }
              if ((xt = this.color) != null && xt.value) {
                const bt = this.color[n.$toStyle]();
                He[bt.startsWith("#") ? Ye : ut] = bt;
              }
              return He;
            }
          }
          class Xe extends n.XFAObject {
            constructor(a) {
              super(w, "filter", !0), this.addRevocationInfo = (0, t.getStringOption)(a.addRevocationInfo, ["", "required", "optional", "none"]), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "", this.version = (0, t.getInteger)({
                data: this.version,
                defaultValue: 5,
                validate: (Z) => Z >= 1 && Z <= 5
              }), this.appearanceFilter = null, this.certificates = null, this.digestMethods = null, this.encodings = null, this.encryptionMethods = null, this.handler = null, this.lockDocument = null, this.mdp = null, this.reasons = null, this.timeStamp = null;
            }
          }
          class Qe extends n.ContentObject {
            constructor(a) {
              super(w, "float"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              const a = parseFloat(this[n.$content].trim());
              this[n.$content] = isNaN(a) ? null : a;
            }
            [n.$toHTML](a) {
              return c(this[n.$content] !== null ? this[n.$content].toString() : "");
            }
          }
          class it extends n.XFAObject {
            constructor(a) {
              super(w, "font", !0), this.baselineShift = (0, t.getMeasurement)(a.baselineShift), this.fontHorizontalScale = (0, t.getFloat)({
                data: a.fontHorizontalScale,
                defaultValue: 100,
                validate: (Z) => Z >= 0
              }), this.fontVerticalScale = (0, t.getFloat)({
                data: a.fontVerticalScale,
                defaultValue: 100,
                validate: (Z) => Z >= 0
              }), this.id = a.id || "", this.kerningMode = (0, t.getStringOption)(a.kerningMode, ["none", "pair"]), this.letterSpacing = (0, t.getMeasurement)(a.letterSpacing, "0"), this.lineThrough = (0, t.getInteger)({
                data: a.lineThrough,
                defaultValue: 0,
                validate: (Z) => Z === 1 || Z === 2
              }), this.lineThroughPeriod = (0, t.getStringOption)(a.lineThroughPeriod, ["all", "word"]), this.overline = (0, t.getInteger)({
                data: a.overline,
                defaultValue: 0,
                validate: (Z) => Z === 1 || Z === 2
              }), this.overlinePeriod = (0, t.getStringOption)(a.overlinePeriod, ["all", "word"]), this.posture = (0, t.getStringOption)(a.posture, ["normal", "italic"]), this.size = (0, t.getMeasurement)(a.size, "10pt"), this.typeface = a.typeface || "Courier", this.underline = (0, t.getInteger)({
                data: a.underline,
                defaultValue: 0,
                validate: (Z) => Z === 1 || Z === 2
              }), this.underlinePeriod = (0, t.getStringOption)(a.underlinePeriod, ["all", "word"]), this.use = a.use || "", this.usehref = a.usehref || "", this.weight = (0, t.getStringOption)(a.weight, ["normal", "bold"]), this.extras = null, this.fill = null;
            }
            [n.$clean](a) {
              super[n.$clean](a), this[n.$globalData].usedTypefaces.add(this.typeface);
            }
            [n.$toStyle]() {
              const a = (0, e.toStyle)(this, "fill"), Z = a.color;
              return Z && (Z === "#000000" ? delete a.color : Z.startsWith("#") || (a.background = Z, a.backgroundClip = "text", a.color = "transparent")), this.baselineShift && (a.verticalAlign = (0, e.measureToString)(this.baselineShift)), a.fontKerning = this.kerningMode === "none" ? "none" : "normal", a.letterSpacing = (0, e.measureToString)(this.letterSpacing), this.lineThrough !== 0 && (a.textDecoration = "line-through", this.lineThrough === 2 && (a.textDecorationStyle = "double")), this.overline !== 0 && (a.textDecoration = "overline", this.overline === 2 && (a.textDecorationStyle = "double")), a.fontStyle = this.posture, a.fontSize = (0, e.measureToString)(0.99 * this.size), (0, e.setFontFamily)(this, this, this[n.$globalData].fontFinder, a), this.underline !== 0 && (a.textDecoration = "underline", this.underline === 2 && (a.textDecorationStyle = "double")), a.fontWeight = this.weight, a;
            }
          }
          class We extends n.XFAObject {
            constructor(a) {
              super(w, "format", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.picture = null;
            }
          }
          class gt extends n.StringObject {
            constructor(a) {
              super(w, "handler"), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class mt extends n.XFAObject {
            constructor(a) {
              super(w, "hyphenation"), this.excludeAllCaps = (0, t.getInteger)({
                data: a.excludeAllCaps,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.excludeInitialCap = (0, t.getInteger)({
                data: a.excludeInitialCap,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.hyphenate = (0, t.getInteger)({
                data: a.hyphenate,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.id = a.id || "", this.pushCharacterCount = (0, t.getInteger)({
                data: a.pushCharacterCount,
                defaultValue: 3,
                validate: (Z) => Z >= 0
              }), this.remainCharacterCount = (0, t.getInteger)({
                data: a.remainCharacterCount,
                defaultValue: 3,
                validate: (Z) => Z >= 0
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.wordCharacterCount = (0, t.getInteger)({
                data: a.wordCharacterCount,
                defaultValue: 7,
                validate: (Z) => Z >= 0
              });
            }
          }
          class Ct extends n.StringObject {
            constructor(a) {
              super(w, "image"), this.aspect = (0, t.getStringOption)(a.aspect, ["fit", "actual", "height", "none", "width"]), this.contentType = a.contentType || "", this.href = a.href || "", this.id = a.id || "", this.name = a.name || "", this.transferEncoding = (0, t.getStringOption)(a.transferEncoding, ["base64", "none", "package"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$toHTML]() {
              if (this.contentType && !l.has(this.contentType.toLowerCase()))
                return t.HTMLResult.EMPTY;
              let a = this[n.$globalData].images && this[n.$globalData].images.get(this.href);
              if (!a && (this.href || !this[n.$content]) || (!a && this.transferEncoding === "base64" && (a = (0, B.stringToBytes)(atob(this[n.$content]))), !a))
                return t.HTMLResult.EMPTY;
              if (!this.contentType) {
                for (const [Ye, ut] of g)
                  if (a.length > Ye.length && Ye.every((xt, bt) => xt === a[bt])) {
                    this.contentType = ut;
                    break;
                  }
                if (!this.contentType)
                  return t.HTMLResult.EMPTY;
              }
              const Z = new Blob([a], {
                type: this.contentType
              });
              let De;
              switch (this.aspect) {
                case "fit":
                case "actual":
                  break;
                case "height":
                  De = {
                    height: "100%",
                    objectFit: "fill"
                  };
                  break;
                case "none":
                  De = {
                    width: "100%",
                    height: "100%",
                    objectFit: "fill"
                  };
                  break;
                case "width":
                  De = {
                    width: "100%",
                    objectFit: "fill"
                  };
                  break;
              }
              const He = this[n.$getParent]();
              return t.HTMLResult.success({
                name: "img",
                attributes: {
                  class: ["xfaImage"],
                  style: De,
                  src: URL.createObjectURL(Z),
                  alt: He ? P(He[n.$getParent]()) : null
                }
              });
            }
          }
          class Pt extends n.XFAObject {
            constructor(a) {
              super(w, "imageEdit", !0), this.data = (0, t.getStringOption)(a.data, ["link", "embed"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
            [n.$toHTML](a) {
              return this.data === "embed" ? t.HTMLResult.success({
                name: "div",
                children: [],
                attributes: {}
              }) : t.HTMLResult.EMPTY;
            }
          }
          class at extends n.ContentObject {
            constructor(a) {
              super(w, "integer"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              const a = parseInt(this[n.$content].trim(), 10);
              this[n.$content] = isNaN(a) ? null : a;
            }
            [n.$toHTML](a) {
              return c(this[n.$content] !== null ? this[n.$content].toString() : "");
            }
          }
          class dt extends n.XFAObject {
            constructor(a) {
              super(w, "issuers", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.certificate = new n.XFAObjectArray();
            }
          }
          class ot extends n.XFAObject {
            constructor(a) {
              super(w, "items", !0), this.id = a.id || "", this.name = a.name || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.ref = a.ref || "", this.save = (0, t.getInteger)({
                data: a.save,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.boolean = new n.XFAObjectArray(), this.date = new n.XFAObjectArray(), this.dateTime = new n.XFAObjectArray(), this.decimal = new n.XFAObjectArray(), this.exData = new n.XFAObjectArray(), this.float = new n.XFAObjectArray(), this.image = new n.XFAObjectArray(), this.integer = new n.XFAObjectArray(), this.text = new n.XFAObjectArray(), this.time = new n.XFAObjectArray();
            }
            [n.$toHTML]() {
              const a = [];
              for (const Z of this[n.$getChildren]())
                a.push(Z[n.$text]());
              return t.HTMLResult.success(a);
            }
          }
          F.Items = ot;
          class Mt extends n.XFAObject {
            constructor(a) {
              super(w, "keep", !0), this.id = a.id || "";
              const Z = ["none", "contentArea", "pageArea"];
              this.intact = (0, t.getStringOption)(a.intact, Z), this.next = (0, t.getStringOption)(a.next, Z), this.previous = (0, t.getStringOption)(a.previous, Z), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
          }
          class Rt extends n.XFAObject {
            constructor(a) {
              super(w, "keyUsage");
              const Z = ["", "yes", "no"];
              this.crlSign = (0, t.getStringOption)(a.crlSign, Z), this.dataEncipherment = (0, t.getStringOption)(a.dataEncipherment, Z), this.decipherOnly = (0, t.getStringOption)(a.decipherOnly, Z), this.digitalSignature = (0, t.getStringOption)(a.digitalSignature, Z), this.encipherOnly = (0, t.getStringOption)(a.encipherOnly, Z), this.id = a.id || "", this.keyAgreement = (0, t.getStringOption)(a.keyAgreement, Z), this.keyCertSign = (0, t.getStringOption)(a.keyCertSign, Z), this.keyEncipherment = (0, t.getStringOption)(a.keyEncipherment, Z), this.nonRepudiation = (0, t.getStringOption)(a.nonRepudiation, Z), this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Et extends n.XFAObject {
            constructor(a) {
              super(w, "line", !0), this.hand = (0, t.getStringOption)(a.hand, ["even", "left", "right"]), this.id = a.id || "", this.slope = (0, t.getStringOption)(a.slope, ["\\", "/"]), this.use = a.use || "", this.usehref = a.usehref || "", this.edge = null;
            }
            [n.$toHTML]() {
              const a = this[n.$getParent]()[n.$getParent](), Z = this.edge || new fe({}), De = Z[n.$toStyle](), He = /* @__PURE__ */ Object.create(null), Ye = Z.presence === "visible" ? Z.thickness : 0;
              He.strokeWidth = (0, e.measureToString)(Ye), He.stroke = De.color;
              let ut, xt, bt, Tt, _t = "100%", $t = "100%";
              a.w <= Ye ? ([ut, xt, bt, Tt] = ["50%", 0, "50%", "100%"], _t = He.strokeWidth) : a.h <= Ye ? ([ut, xt, bt, Tt] = [0, "50%", "100%", "50%"], $t = He.strokeWidth) : this.slope === "\\" ? [ut, xt, bt, Tt] = [0, 0, "100%", "100%"] : [ut, xt, bt, Tt] = [0, "100%", "100%", 0];
              const Ht = {
                name: "svg",
                children: [{
                  name: "line",
                  attributes: {
                    xmlns: C,
                    x1: ut,
                    y1: xt,
                    x2: bt,
                    y2: Tt,
                    style: He
                  }
                }],
                attributes: {
                  xmlns: C,
                  width: _t,
                  height: $t,
                  style: {
                    overflow: "visible"
                  }
                }
              };
              return r(a) ? t.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [Ht]
              }) : (Ht.attributes.style.position = "absolute", t.HTMLResult.success(Ht));
            }
          }
          class At extends n.XFAObject {
            constructor(a) {
              super(w, "linear", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["toRight", "toBottom", "toLeft", "toTop"]), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null;
            }
            [n.$toStyle](a) {
              a = a ? a[n.$toStyle]() : "#FFFFFF";
              const Z = this.type.replace(/([RBLT])/, " $1").toLowerCase(), De = this.color ? this.color[n.$toStyle]() : "#000000";
              return `linear-gradient(${Z}, ${a}, ${De})`;
            }
          }
          class Nt extends n.ContentObject {
            constructor(a) {
              super(w, "lockDocument"), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              this[n.$content] = (0, t.getStringOption)(this[n.$content], ["auto", "0", "1"]);
            }
          }
          class qe extends n.XFAObject {
            constructor(a) {
              super(w, "manifest", !0), this.action = (0, t.getStringOption)(a.action, ["include", "all", "exclude"]), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.ref = new n.XFAObjectArray();
            }
          }
          class Ue extends n.XFAObject {
            constructor(a) {
              super(w, "margin", !0), this.bottomInset = (0, t.getMeasurement)(a.bottomInset, "0"), this.id = a.id || "", this.leftInset = (0, t.getMeasurement)(a.leftInset, "0"), this.rightInset = (0, t.getMeasurement)(a.rightInset, "0"), this.topInset = (0, t.getMeasurement)(a.topInset, "0"), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
            [n.$toStyle]() {
              return {
                margin: (0, e.measureToString)(this.topInset) + " " + (0, e.measureToString)(this.rightInset) + " " + (0, e.measureToString)(this.bottomInset) + " " + (0, e.measureToString)(this.leftInset)
              };
            }
          }
          class Je extends n.XFAObject {
            constructor(a) {
              super(w, "mdp"), this.id = a.id || "", this.permissions = (0, t.getInteger)({
                data: a.permissions,
                defaultValue: 2,
                validate: (Z) => Z === 1 || Z === 3
              }), this.signatureType = (0, t.getStringOption)(a.signatureType, ["filler", "author"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Ve extends n.XFAObject {
            constructor(a) {
              super(w, "medium"), this.id = a.id || "", this.imagingBBox = (0, t.getBBox)(a.imagingBBox), this.long = (0, t.getMeasurement)(a.long), this.orientation = (0, t.getStringOption)(a.orientation, ["portrait", "landscape"]), this.short = (0, t.getMeasurement)(a.short), this.stock = a.stock || "", this.trayIn = (0, t.getStringOption)(a.trayIn, ["auto", "delegate", "pageFront"]), this.trayOut = (0, t.getStringOption)(a.trayOut, ["auto", "delegate"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class st extends n.XFAObject {
            constructor(a) {
              super(w, "message", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.text = new n.XFAObjectArray();
            }
          }
          class ft extends n.XFAObject {
            constructor(a) {
              super(w, "numericEdit", !0), this.hScrollPolicy = (0, t.getStringOption)(a.hScrollPolicy, ["auto", "off", "on"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [n.$toHTML](a) {
              var Ye;
              const Z = (0, e.toStyle)(this, "border", "font", "margin"), De = this[n.$getParent]()[n.$getParent](), He = {
                name: "input",
                attributes: {
                  type: "text",
                  fieldId: De[n.$uid],
                  dataId: ((Ye = De[n.$data]) == null ? void 0 : Ye[n.$uid]) || De[n.$uid],
                  class: ["xfaTextfield"],
                  style: Z,
                  "aria-label": P(De),
                  "aria-required": !1
                }
              };
              return I(De) && (He.attributes["aria-required"] = !0, He.attributes.required = !0), t.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [He]
              });
            }
          }
          class ct extends n.XFAObject {
            constructor(a) {
              super(w, "occur", !0), this.id = a.id || "", this.initial = a.initial !== "" ? (0, t.getInteger)({
                data: a.initial,
                defaultValue: "",
                validate: (Z) => !0
              }) : "", this.max = a.max !== "" ? (0, t.getInteger)({
                data: a.max,
                defaultValue: 1,
                validate: (Z) => !0
              }) : "", this.min = a.min !== "" ? (0, t.getInteger)({
                data: a.min,
                defaultValue: 1,
                validate: (Z) => !0
              }) : "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
            [n.$clean]() {
              const a = this[n.$getParent](), Z = this.min;
              this.min === "" && (this.min = a instanceof Ze || a instanceof nt ? 0 : 1), this.max === "" && (Z === "" ? this.max = a instanceof Ze || a instanceof nt ? -1 : 1 : this.max = this.min), this.max !== -1 && this.max < this.min && (this.max = this.min), this.initial === "" && (this.initial = a instanceof mn ? 1 : this.min);
            }
          }
          class be extends n.StringObject {
            constructor(a) {
              super(w, "oid"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class _e extends n.XFAObject {
            constructor(a) {
              super(w, "oids", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.oid = new n.XFAObjectArray();
            }
          }
          class $e extends n.XFAObject {
            constructor(a) {
              super(w, "overflow"), this.id = a.id || "", this.leader = a.leader || "", this.target = a.target || "", this.trailer = a.trailer || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$getExtra]() {
              if (!this[n.$extra]) {
                const a = this[n.$getParent](), Z = this[n.$getTemplateRoot](), De = Z[n.$searchNode](this.target, a), He = Z[n.$searchNode](this.leader, a), Ye = Z[n.$searchNode](this.trailer, a);
                this[n.$extra] = {
                  target: (De == null ? void 0 : De[0]) || null,
                  leader: (He == null ? void 0 : He[0]) || null,
                  trailer: (Ye == null ? void 0 : Ye[0]) || null,
                  addLeader: !1,
                  addTrailer: !1
                };
              }
              return this[n.$extra];
            }
          }
          class Ze extends n.XFAObject {
            constructor(a) {
              super(w, "pageArea", !0), this.blankOrNotBlank = (0, t.getStringOption)(a.blankOrNotBlank, ["any", "blank", "notBlank"]), this.id = a.id || "", this.initialNumber = (0, t.getInteger)({
                data: a.initialNumber,
                defaultValue: 1,
                validate: (Z) => !0
              }), this.name = a.name || "", this.numbered = (0, t.getInteger)({
                data: a.numbered,
                defaultValue: 1,
                validate: (Z) => !0
              }), this.oddOrEven = (0, t.getStringOption)(a.oddOrEven, ["any", "even", "odd"]), this.pagePosition = (0, t.getStringOption)(a.pagePosition, ["any", "first", "last", "only", "rest"]), this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.desc = null, this.extras = null, this.medium = null, this.occur = null, this.area = new n.XFAObjectArray(), this.contentArea = new n.XFAObjectArray(), this.draw = new n.XFAObjectArray(), this.exclGroup = new n.XFAObjectArray(), this.field = new n.XFAObjectArray(), this.subform = new n.XFAObjectArray();
            }
            [n.$isUsable]() {
              return this[n.$extra] ? !this.occur || this.occur.max === -1 || this[n.$extra].numberOfUse < this.occur.max : (this[n.$extra] = {
                numberOfUse: 0
              }, !0);
            }
            [n.$cleanPage]() {
              delete this[n.$extra];
            }
            [n.$getNextPage]() {
              this[n.$extra] || (this[n.$extra] = {
                numberOfUse: 0
              });
              const a = this[n.$getParent]();
              return a.relation === "orderedOccurrence" && this[n.$isUsable]() ? (this[n.$extra].numberOfUse += 1, this) : a[n.$getNextPage]();
            }
            [n.$getAvailableSpace]() {
              return this[n.$extra].space || {
                width: 0,
                height: 0
              };
            }
            [n.$toHTML]() {
              this[n.$extra] || (this[n.$extra] = {
                numberOfUse: 1
              });
              const a = [];
              this[n.$extra].children = a;
              const Z = /* @__PURE__ */ Object.create(null);
              if (this.medium && this.medium.short && this.medium.long) {
                if (Z.width = (0, e.measureToString)(this.medium.short), Z.height = (0, e.measureToString)(this.medium.long), this[n.$extra].space = {
                  width: this.medium.short,
                  height: this.medium.long
                }, this.medium.orientation === "landscape") {
                  const De = Z.width;
                  Z.width = Z.height, Z.height = De, this[n.$extra].space = {
                    width: this.medium.long,
                    height: this.medium.short
                  };
                }
              } else
                (0, B.warn)("XFA - No medium specified in pageArea: please file a bug.");
              return this[n.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["area", "draw", "field", "subform"]),
                include: !0
              }), this[n.$childrenToHTML]({
                filter: /* @__PURE__ */ new Set(["contentArea"]),
                include: !0
              }), t.HTMLResult.success({
                name: "div",
                children: a,
                attributes: {
                  class: ["xfaPage"],
                  id: this[n.$uid],
                  style: Z,
                  xfaName: this.name
                }
              });
            }
          }
          class nt extends n.XFAObject {
            constructor(a) {
              super(w, "pageSet", !0), this.duplexImposition = (0, t.getStringOption)(a.duplexImposition, ["longEdge", "shortEdge"]), this.id = a.id || "", this.name = a.name || "", this.relation = (0, t.getStringOption)(a.relation, ["orderedOccurrence", "duplexPaginated", "simplexPaginated"]), this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.occur = null, this.pageArea = new n.XFAObjectArray(), this.pageSet = new n.XFAObjectArray();
            }
            [n.$cleanPage]() {
              for (const a of this.pageArea.children)
                a[n.$cleanPage]();
              for (const a of this.pageSet.children)
                a[n.$cleanPage]();
            }
            [n.$isUsable]() {
              return !this.occur || this.occur.max === -1 || this[n.$extra].numberOfUse < this.occur.max;
            }
            [n.$getNextPage]() {
              if (this[n.$extra] || (this[n.$extra] = {
                numberOfUse: 1,
                pageIndex: -1,
                pageSetIndex: -1
              }), this.relation === "orderedOccurrence") {
                if (this[n.$extra].pageIndex + 1 < this.pageArea.children.length)
                  return this[n.$extra].pageIndex += 1, this.pageArea.children[this[n.$extra].pageIndex][n.$getNextPage]();
                if (this[n.$extra].pageSetIndex + 1 < this.pageSet.children.length)
                  return this[n.$extra].pageSetIndex += 1, this.pageSet.children[this[n.$extra].pageSetIndex][n.$getNextPage]();
                if (this[n.$isUsable]())
                  return this[n.$extra].numberOfUse += 1, this[n.$extra].pageIndex = -1, this[n.$extra].pageSetIndex = -1, this[n.$getNextPage]();
                const Ye = this[n.$getParent]();
                return Ye instanceof nt ? Ye[n.$getNextPage]() : (this[n.$cleanPage](), this[n.$getNextPage]());
              }
              const a = this[n.$getTemplateRoot]()[n.$extra].pageNumber, Z = a % 2 === 0 ? "even" : "odd", De = a === 0 ? "first" : "rest";
              let He = this.pageArea.children.find((Ye) => Ye.oddOrEven === Z && Ye.pagePosition === De);
              return He || (He = this.pageArea.children.find((Ye) => Ye.oddOrEven === "any" && Ye.pagePosition === De), He) || (He = this.pageArea.children.find((Ye) => Ye.oddOrEven === "any" && Ye.pagePosition === "any"), He) ? He : this.pageArea.children[0];
            }
          }
          class pt extends n.XFAObject {
            constructor(a) {
              super(w, "para", !0), this.hAlign = (0, t.getStringOption)(a.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = a.id || "", this.lineHeight = a.lineHeight ? (0, t.getMeasurement)(a.lineHeight, "0pt") : "", this.marginLeft = a.marginLeft ? (0, t.getMeasurement)(a.marginLeft, "0pt") : "", this.marginRight = a.marginRight ? (0, t.getMeasurement)(a.marginRight, "0pt") : "", this.orphans = (0, t.getInteger)({
                data: a.orphans,
                defaultValue: 0,
                validate: (Z) => Z >= 0
              }), this.preserve = a.preserve || "", this.radixOffset = a.radixOffset ? (0, t.getMeasurement)(a.radixOffset, "0pt") : "", this.spaceAbove = a.spaceAbove ? (0, t.getMeasurement)(a.spaceAbove, "0pt") : "", this.spaceBelow = a.spaceBelow ? (0, t.getMeasurement)(a.spaceBelow, "0pt") : "", this.tabDefault = a.tabDefault ? (0, t.getMeasurement)(this.tabDefault) : "", this.tabStops = (a.tabStops || "").trim().split(/\s+/).map((Z, De) => De % 2 === 1 ? (0, t.getMeasurement)(Z) : Z), this.textIndent = a.textIndent ? (0, t.getMeasurement)(a.textIndent, "0pt") : "", this.use = a.use || "", this.usehref = a.usehref || "", this.vAlign = (0, t.getStringOption)(a.vAlign, ["top", "bottom", "middle"]), this.widows = (0, t.getInteger)({
                data: a.widows,
                defaultValue: 0,
                validate: (Z) => Z >= 0
              }), this.hyphenation = null;
            }
            [n.$toStyle]() {
              const a = (0, e.toStyle)(this, "hAlign");
              return this.marginLeft !== "" && (a.paddingLeft = (0, e.measureToString)(this.marginLeft)), this.marginRight !== "" && (a.paddingight = (0, e.measureToString)(this.marginRight)), this.spaceAbove !== "" && (a.paddingTop = (0, e.measureToString)(this.spaceAbove)), this.spaceBelow !== "" && (a.paddingBottom = (0, e.measureToString)(this.spaceBelow)), this.textIndent !== "" && (a.textIndent = (0, e.measureToString)(this.textIndent), (0, e.fixTextIndent)(a)), this.lineHeight > 0 && (a.lineHeight = (0, e.measureToString)(this.lineHeight)), this.tabDefault !== "" && (a.tabSize = (0, e.measureToString)(this.tabDefault)), this.tabStops.length > 0, this.hyphenatation && Object.assign(a, this.hyphenatation[n.$toStyle]()), a;
            }
          }
          class yt extends n.XFAObject {
            constructor(a) {
              super(w, "passwordEdit", !0), this.hScrollPolicy = (0, t.getStringOption)(a.hScrollPolicy, ["auto", "off", "on"]), this.id = a.id || "", this.passwordChar = a.passwordChar || "*", this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.extras = null, this.margin = null;
            }
          }
          class lt extends n.XFAObject {
            constructor(a) {
              super(w, "pattern", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["crossHatch", "crossDiagonal", "diagonalLeft", "diagonalRight", "horizontal", "vertical"]), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null;
            }
            [n.$toStyle](a) {
              a = a ? a[n.$toStyle]() : "#FFFFFF";
              const Z = this.color ? this.color[n.$toStyle]() : "#000000", De = 5, He = "repeating-linear-gradient", Ye = `${a},${a} ${De}px,${Z} ${De}px,${Z} ${2 * De}px`;
              switch (this.type) {
                case "crossHatch":
                  return `${He}(to top,${Ye}) ${He}(to right,${Ye})`;
                case "crossDiagonal":
                  return `${He}(45deg,${Ye}) ${He}(-45deg,${Ye})`;
                case "diagonalLeft":
                  return `${He}(45deg,${Ye})`;
                case "diagonalRight":
                  return `${He}(-45deg,${Ye})`;
                case "horizontal":
                  return `${He}(to top,${Ye})`;
                case "vertical":
                  return `${He}(to right,${Ye})`;
              }
              return "";
            }
          }
          class St extends n.StringObject {
            constructor(a) {
              super(w, "picture"), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class ht extends n.XFAObject {
            constructor(a) {
              super(w, "proto", !0), this.appearanceFilter = new n.XFAObjectArray(), this.arc = new n.XFAObjectArray(), this.area = new n.XFAObjectArray(), this.assist = new n.XFAObjectArray(), this.barcode = new n.XFAObjectArray(), this.bindItems = new n.XFAObjectArray(), this.bookend = new n.XFAObjectArray(), this.boolean = new n.XFAObjectArray(), this.border = new n.XFAObjectArray(), this.break = new n.XFAObjectArray(), this.breakAfter = new n.XFAObjectArray(), this.breakBefore = new n.XFAObjectArray(), this.button = new n.XFAObjectArray(), this.calculate = new n.XFAObjectArray(), this.caption = new n.XFAObjectArray(), this.certificate = new n.XFAObjectArray(), this.certificates = new n.XFAObjectArray(), this.checkButton = new n.XFAObjectArray(), this.choiceList = new n.XFAObjectArray(), this.color = new n.XFAObjectArray(), this.comb = new n.XFAObjectArray(), this.connect = new n.XFAObjectArray(), this.contentArea = new n.XFAObjectArray(), this.corner = new n.XFAObjectArray(), this.date = new n.XFAObjectArray(), this.dateTime = new n.XFAObjectArray(), this.dateTimeEdit = new n.XFAObjectArray(), this.decimal = new n.XFAObjectArray(), this.defaultUi = new n.XFAObjectArray(), this.desc = new n.XFAObjectArray(), this.digestMethod = new n.XFAObjectArray(), this.digestMethods = new n.XFAObjectArray(), this.draw = new n.XFAObjectArray(), this.edge = new n.XFAObjectArray(), this.encoding = new n.XFAObjectArray(), this.encodings = new n.XFAObjectArray(), this.encrypt = new n.XFAObjectArray(), this.encryptData = new n.XFAObjectArray(), this.encryption = new n.XFAObjectArray(), this.encryptionMethod = new n.XFAObjectArray(), this.encryptionMethods = new n.XFAObjectArray(), this.event = new n.XFAObjectArray(), this.exData = new n.XFAObjectArray(), this.exObject = new n.XFAObjectArray(), this.exclGroup = new n.XFAObjectArray(), this.execute = new n.XFAObjectArray(), this.extras = new n.XFAObjectArray(), this.field = new n.XFAObjectArray(), this.fill = new n.XFAObjectArray(), this.filter = new n.XFAObjectArray(), this.float = new n.XFAObjectArray(), this.font = new n.XFAObjectArray(), this.format = new n.XFAObjectArray(), this.handler = new n.XFAObjectArray(), this.hyphenation = new n.XFAObjectArray(), this.image = new n.XFAObjectArray(), this.imageEdit = new n.XFAObjectArray(), this.integer = new n.XFAObjectArray(), this.issuers = new n.XFAObjectArray(), this.items = new n.XFAObjectArray(), this.keep = new n.XFAObjectArray(), this.keyUsage = new n.XFAObjectArray(), this.line = new n.XFAObjectArray(), this.linear = new n.XFAObjectArray(), this.lockDocument = new n.XFAObjectArray(), this.manifest = new n.XFAObjectArray(), this.margin = new n.XFAObjectArray(), this.mdp = new n.XFAObjectArray(), this.medium = new n.XFAObjectArray(), this.message = new n.XFAObjectArray(), this.numericEdit = new n.XFAObjectArray(), this.occur = new n.XFAObjectArray(), this.oid = new n.XFAObjectArray(), this.oids = new n.XFAObjectArray(), this.overflow = new n.XFAObjectArray(), this.pageArea = new n.XFAObjectArray(), this.pageSet = new n.XFAObjectArray(), this.para = new n.XFAObjectArray(), this.passwordEdit = new n.XFAObjectArray(), this.pattern = new n.XFAObjectArray(), this.picture = new n.XFAObjectArray(), this.radial = new n.XFAObjectArray(), this.reason = new n.XFAObjectArray(), this.reasons = new n.XFAObjectArray(), this.rectangle = new n.XFAObjectArray(), this.ref = new n.XFAObjectArray(), this.script = new n.XFAObjectArray(), this.setProperty = new n.XFAObjectArray(), this.signData = new n.XFAObjectArray(), this.signature = new n.XFAObjectArray(), this.signing = new n.XFAObjectArray(), this.solid = new n.XFAObjectArray(), this.speak = new n.XFAObjectArray(), this.stipple = new n.XFAObjectArray(), this.subform = new n.XFAObjectArray(), this.subformSet = new n.XFAObjectArray(), this.subjectDN = new n.XFAObjectArray(), this.subjectDNs = new n.XFAObjectArray(), this.submit = new n.XFAObjectArray(), this.text = new n.XFAObjectArray(), this.textEdit = new n.XFAObjectArray(), this.time = new n.XFAObjectArray(), this.timeStamp = new n.XFAObjectArray(), this.toolTip = new n.XFAObjectArray(), this.traversal = new n.XFAObjectArray(), this.traverse = new n.XFAObjectArray(), this.ui = new n.XFAObjectArray(), this.validate = new n.XFAObjectArray(), this.value = new n.XFAObjectArray(), this.variables = new n.XFAObjectArray();
            }
          }
          class Ft extends n.XFAObject {
            constructor(a) {
              super(w, "radial", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["toEdge", "toCenter"]), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null;
            }
            [n.$toStyle](a) {
              a = a ? a[n.$toStyle]() : "#FFFFFF";
              const Z = this.color ? this.color[n.$toStyle]() : "#000000";
              return `radial-gradient(circle at center, ${this.type === "toEdge" ? `${a},${Z}` : `${Z},${a}`})`;
            }
          }
          class It extends n.StringObject {
            constructor(a) {
              super(w, "reason"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Gt extends n.XFAObject {
            constructor(a) {
              super(w, "reasons", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.reason = new n.XFAObjectArray();
            }
          }
          class vt extends n.XFAObject {
            constructor(a) {
              super(w, "rectangle", !0), this.hand = (0, t.getStringOption)(a.hand, ["even", "left", "right"]), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.corner = new n.XFAObjectArray(4), this.edge = new n.XFAObjectArray(4), this.fill = null;
            }
            [n.$toHTML]() {
              var Tt;
              const a = this.edge.children.length ? this.edge.children[0] : new fe({}), Z = a[n.$toStyle](), De = /* @__PURE__ */ Object.create(null);
              ((Tt = this.fill) == null ? void 0 : Tt.presence) === "visible" ? Object.assign(De, this.fill[n.$toStyle]()) : De.fill = "transparent", De.strokeWidth = (0, e.measureToString)(a.presence === "visible" ? a.thickness : 0), De.stroke = Z.color;
              const Ye = (this.corner.children.length ? this.corner.children[0] : new te({}))[n.$toStyle](), xt = {
                name: "svg",
                children: [{
                  name: "rect",
                  attributes: {
                    xmlns: C,
                    width: "100%",
                    height: "100%",
                    x: 0,
                    y: 0,
                    rx: Ye.radius,
                    ry: Ye.radius,
                    style: De
                  }
                }],
                attributes: {
                  xmlns: C,
                  style: {
                    overflow: "visible"
                  },
                  width: "100%",
                  height: "100%"
                }
              }, bt = this[n.$getParent]()[n.$getParent]();
              return r(bt) ? t.HTMLResult.success({
                name: "div",
                attributes: {
                  style: {
                    display: "inline",
                    width: "100%",
                    height: "100%"
                  }
                },
                children: [xt]
              }) : (xt.attributes.style.position = "absolute", t.HTMLResult.success(xt));
            }
          }
          class kt extends n.StringObject {
            constructor(a) {
              super(w, "ref"), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Bt extends n.StringObject {
            constructor(a) {
              super(w, "script"), this.binding = a.binding || "", this.contentType = a.contentType || "", this.id = a.id || "", this.name = a.name || "", this.runAt = (0, t.getStringOption)(a.runAt, ["client", "both", "server"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Ut extends n.XFAObject {
            constructor(a) {
              super(w, "setProperty"), this.connection = a.connection || "", this.ref = a.ref || "", this.target = a.target || "";
            }
          }
          F.SetProperty = Ut;
          class Yt extends n.XFAObject {
            constructor(a) {
              super(w, "signData", !0), this.id = a.id || "", this.operation = (0, t.getStringOption)(a.operation, ["sign", "clear", "verify"]), this.ref = a.ref || "", this.target = a.target || "", this.use = a.use || "", this.usehref = a.usehref || "", this.filter = null, this.manifest = null;
            }
          }
          class rn extends n.XFAObject {
            constructor(a) {
              super(w, "signature", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["PDF1.3", "PDF1.6"]), this.use = a.use || "", this.usehref = a.usehref || "", this.border = null, this.extras = null, this.filter = null, this.manifest = null, this.margin = null;
            }
          }
          class Rn extends n.XFAObject {
            constructor(a) {
              super(w, "signing", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.certificate = new n.XFAObjectArray();
            }
          }
          class Dn extends n.XFAObject {
            constructor(a) {
              super(w, "solid", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null;
            }
            [n.$toStyle](a) {
              return a ? a[n.$toStyle]() : "#FFFFFF";
            }
          }
          class _n extends n.StringObject {
            constructor(a) {
              super(w, "speak"), this.disable = (0, t.getInteger)({
                data: a.disable,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.id = a.id || "", this.priority = (0, t.getStringOption)(a.priority, ["custom", "caption", "name", "toolTip"]), this.rid = a.rid || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Ln extends n.XFAObject {
            constructor(a) {
              super(w, "stipple", !0), this.id = a.id || "", this.rate = (0, t.getInteger)({
                data: a.rate,
                defaultValue: 50,
                validate: (Z) => Z >= 0 && Z <= 100
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.color = null, this.extras = null;
            }
            [n.$toStyle](a) {
              const Z = this.rate / 100;
              return B.Util.makeHexColor(Math.round(a.value.r * (1 - Z) + this.value.r * Z), Math.round(a.value.g * (1 - Z) + this.value.g * Z), Math.round(a.value.b * (1 - Z) + this.value.b * Z));
            }
          }
          class An extends n.XFAObject {
            constructor(a) {
              super(w, "subform", !0), this.access = (0, t.getStringOption)(a.access, ["open", "nonInteractive", "protected", "readOnly"]), this.allowMacro = (0, t.getInteger)({
                data: a.allowMacro,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.anchorType = (0, t.getStringOption)(a.anchorType, ["topLeft", "bottomCenter", "bottomLeft", "bottomRight", "middleCenter", "middleLeft", "middleRight", "topCenter", "topRight"]), this.colSpan = (0, t.getInteger)({
                data: a.colSpan,
                defaultValue: 1,
                validate: (Z) => Z >= 1 || Z === -1
              }), this.columnWidths = (a.columnWidths || "").trim().split(/\s+/).map((Z) => Z === "-1" ? -1 : (0, t.getMeasurement)(Z)), this.h = a.h ? (0, t.getMeasurement)(a.h) : "", this.hAlign = (0, t.getStringOption)(a.hAlign, ["left", "center", "justify", "justifyAll", "radix", "right"]), this.id = a.id || "", this.layout = (0, t.getStringOption)(a.layout, ["position", "lr-tb", "rl-row", "rl-tb", "row", "table", "tb"]), this.locale = a.locale || "", this.maxH = (0, t.getMeasurement)(a.maxH, "0pt"), this.maxW = (0, t.getMeasurement)(a.maxW, "0pt"), this.mergeMode = (0, t.getStringOption)(a.mergeMode, ["consumeData", "matchTemplate"]), this.minH = (0, t.getMeasurement)(a.minH, "0pt"), this.minW = (0, t.getMeasurement)(a.minW, "0pt"), this.name = a.name || "", this.presence = (0, t.getStringOption)(a.presence, ["visible", "hidden", "inactive", "invisible"]), this.relevant = (0, t.getRelevant)(a.relevant), this.restoreState = (0, t.getStringOption)(a.restoreState, ["manual", "auto"]), this.scope = (0, t.getStringOption)(a.scope, ["name", "none"]), this.use = a.use || "", this.usehref = a.usehref || "", this.w = a.w ? (0, t.getMeasurement)(a.w) : "", this.x = (0, t.getMeasurement)(a.x, "0pt"), this.y = (0, t.getMeasurement)(a.y, "0pt"), this.assist = null, this.bind = null, this.bookend = null, this.border = null, this.break = null, this.calculate = null, this.desc = null, this.extras = null, this.keep = null, this.margin = null, this.occur = null, this.overflow = null, this.pageSet = null, this.para = null, this.traversal = null, this.validate = null, this.variables = null, this.area = new n.XFAObjectArray(), this.breakAfter = new n.XFAObjectArray(), this.breakBefore = new n.XFAObjectArray(), this.connect = new n.XFAObjectArray(), this.draw = new n.XFAObjectArray(), this.event = new n.XFAObjectArray(), this.exObject = new n.XFAObjectArray(), this.exclGroup = new n.XFAObjectArray(), this.field = new n.XFAObjectArray(), this.proto = new n.XFAObjectArray(), this.setProperty = new n.XFAObjectArray(), this.subform = new n.XFAObjectArray(), this.subformSet = new n.XFAObjectArray();
            }
            [n.$getSubformParent]() {
              const a = this[n.$getParent]();
              return a instanceof pn ? a[n.$getSubformParent]() : a;
            }
            [n.$isBindable]() {
              return !0;
            }
            [n.$isThereMoreWidth]() {
              return this.layout.endsWith("-tb") && this[n.$extra].attempt === 0 && this[n.$extra].numberInLine > 0 || this[n.$getParent]()[n.$isThereMoreWidth]();
            }
            *[n.$getContainedChildren]() {
              yield* b(this);
            }
            [n.$flushHTML]() {
              return (0, q.flushHTML)(this);
            }
            [n.$addHTML](a, Z) {
              (0, q.addHTML)(this, a, Z);
            }
            [n.$getAvailableSpace]() {
              return (0, q.getAvailableSpace)(this);
            }
            [n.$isSplittable]() {
              var Z;
              const a = this[n.$getSubformParent]();
              return a[n.$isSplittable]() ? this[n.$extra]._isSplittable !== void 0 ? this[n.$extra]._isSplittable : this.layout === "position" || this.layout.includes("row") ? (this[n.$extra]._isSplittable = !1, !1) : this.keep && this.keep.intact !== "none" ? (this[n.$extra]._isSplittable = !1, !1) : (Z = a.layout) != null && Z.endsWith("-tb") && a[n.$extra].numberInLine !== 0 ? !1 : (this[n.$extra]._isSplittable = !0, !0) : !1;
            }
            [n.$toHTML](a) {
              var Lt;
              if (h(this), this.break) {
                if (this.break.after !== "auto" || this.break.afterTarget !== "") {
                  const wt = new U({
                    targetType: this.break.after,
                    target: this.break.afterTarget,
                    startNew: this.break.startNew.toString()
                  });
                  wt[n.$globalData] = this[n.$globalData], this[n.$appendChild](wt), this.breakAfter.push(wt);
                }
                if (this.break.before !== "auto" || this.break.beforeTarget !== "") {
                  const wt = new Q({
                    targetType: this.break.before,
                    target: this.break.beforeTarget,
                    startNew: this.break.startNew.toString()
                  });
                  wt[n.$globalData] = this[n.$globalData], this[n.$appendChild](wt), this.breakBefore.push(wt);
                }
                if (this.break.overflowTarget !== "") {
                  const wt = new $e({
                    target: this.break.overflowTarget,
                    leader: this.break.overflowLeader,
                    trailer: this.break.overflowTrailer
                  });
                  wt[n.$globalData] = this[n.$globalData], this[n.$appendChild](wt), this.overflow.push(wt);
                }
                this[n.$removeChild](this.break), this.break = null;
              }
              if (this.presence === "hidden" || this.presence === "inactive")
                return t.HTMLResult.EMPTY;
              if ((this.breakBefore.children.length > 1 || this.breakAfter.children.length > 1) && (0, B.warn)("XFA - Several breakBefore or breakAfter in subforms: please file a bug."), this.breakBefore.children.length >= 1) {
                const wt = this.breakBefore.children[0];
                if (N(wt))
                  return t.HTMLResult.breakNode(wt);
              }
              if ((Lt = this[n.$extra]) != null && Lt.afterBreakAfter)
                return t.HTMLResult.EMPTY;
              (0, e.fixDimensions)(this);
              const Z = [], De = {
                id: this[n.$uid],
                class: []
              };
              (0, e.setAccess)(this, De.class), this[n.$extra] || (this[n.$extra] = /* @__PURE__ */ Object.create(null)), Object.assign(this[n.$extra], {
                children: Z,
                line: null,
                attributes: De,
                attempt: 0,
                numberInLine: 0,
                availableSpace: {
                  width: Math.min(this.w || 1 / 0, a.width),
                  height: Math.min(this.h || 1 / 0, a.height)
                },
                width: 0,
                height: 0,
                prevHeight: 0,
                currentWidth: 0
              });
              const He = this[n.$getTemplateRoot](), Ye = He[n.$extra].noLayoutFailure, ut = this[n.$isSplittable]();
              if (ut || d(this), !(0, q.checkDimensions)(this, a))
                return t.HTMLResult.FAILURE;
              const xt = /* @__PURE__ */ new Set(["area", "draw", "exclGroup", "field", "subform", "subformSet"]);
              if (this.layout.includes("row")) {
                const wt = this[n.$getSubformParent]().columnWidths;
                Array.isArray(wt) && wt.length > 0 && (this[n.$extra].columnWidths = wt, this[n.$extra].currentColumn = 0);
              }
              const bt = (0, e.toStyle)(this, "anchorType", "dimensions", "position", "presence", "border", "margin", "hAlign"), Tt = ["xfaSubform"], _t = (0, e.layoutClass)(this);
              if (_t && Tt.push(_t), De.style = bt, De.class = Tt, this.name && (De.xfaName = this.name), this.overflow) {
                const wt = this.overflow[n.$getExtra]();
                wt.addLeader && (wt.addLeader = !1, E(this, wt.leader, a));
              }
              this[n.$pushPara]();
              const $t = this.layout === "lr-tb" || this.layout === "rl-tb", jt = $t ? i : 1;
              for (; this[n.$extra].attempt < jt; this[n.$extra].attempt++) {
                $t && this[n.$extra].attempt === i - 1 && (this[n.$extra].numberInLine = 0);
                const wt = this[n.$childrenToHTML]({
                  filter: xt,
                  include: !0
                });
                if (wt.success)
                  break;
                if (wt.isBreak())
                  return this[n.$popPara](), wt;
                if ($t && this[n.$extra].attempt === 0 && this[n.$extra].numberInLine === 0 && !He[n.$extra].noLayoutFailure) {
                  this[n.$extra].attempt = jt;
                  break;
                }
              }
              if (this[n.$popPara](), ut || A(this), He[n.$extra].noLayoutFailure = Ye, this[n.$extra].attempt === jt)
                return this.overflow && (this[n.$getTemplateRoot]()[n.$extra].overflowNode = this.overflow), ut || delete this[n.$extra], t.HTMLResult.FAILURE;
              if (this.overflow) {
                const wt = this.overflow[n.$getExtra]();
                wt.addTrailer && (wt.addTrailer = !1, E(this, wt.trailer, a));
              }
              let Ht = 0, zt = 0;
              this.margin && (Ht = this.margin.leftInset + this.margin.rightInset, zt = this.margin.topInset + this.margin.bottomInset);
              const Ot = Math.max(this[n.$extra].width + Ht, this.w || 0), qt = Math.max(this[n.$extra].height + zt, this.h || 0), Xt = [this.x, this.y, Ot, qt];
              if (this.w === "" && (bt.width = (0, e.measureToString)(Ot)), this.h === "" && (bt.height = (0, e.measureToString)(qt)), (bt.width === "0px" || bt.height === "0px") && Z.length === 0)
                return t.HTMLResult.EMPTY;
              const Kt = {
                name: "div",
                attributes: De,
                children: Z
              };
              y(this, De);
              const Wt = t.HTMLResult.success((0, e.createWrapper)(this, Kt), Xt);
              if (this.breakAfter.children.length >= 1) {
                const wt = this.breakAfter.children[0];
                if (N(wt))
                  return this[n.$extra].afterBreakAfter = Wt, t.HTMLResult.breakNode(wt);
              }
              return delete this[n.$extra], Wt;
            }
          }
          class pn extends n.XFAObject {
            constructor(a) {
              super(w, "subformSet", !0), this.id = a.id || "", this.name = a.name || "", this.relation = (0, t.getStringOption)(a.relation, ["ordered", "choice", "unordered"]), this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.bookend = null, this.break = null, this.desc = null, this.extras = null, this.occur = null, this.overflow = null, this.breakAfter = new n.XFAObjectArray(), this.breakBefore = new n.XFAObjectArray(), this.subform = new n.XFAObjectArray(), this.subformSet = new n.XFAObjectArray();
            }
            *[n.$getContainedChildren]() {
              yield* b(this);
            }
            [n.$getSubformParent]() {
              let a = this[n.$getParent]();
              for (; !(a instanceof An); )
                a = a[n.$getParent]();
              return a;
            }
            [n.$isBindable]() {
              return !0;
            }
          }
          class Nn extends n.ContentObject {
            constructor(a) {
              super(w, "subjectDN"), this.delimiter = a.delimiter || ",", this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              this[n.$content] = new Map(this[n.$content].split(this.delimiter).map((a) => (a = a.split("=", 2), a[0] = a[0].trim(), a)));
            }
          }
          class Bn extends n.XFAObject {
            constructor(a) {
              super(w, "subjectDNs", !0), this.id = a.id || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "", this.subjectDN = new n.XFAObjectArray();
            }
          }
          class jn extends n.XFAObject {
            constructor(a) {
              super(w, "submit", !0), this.embedPDF = (0, t.getInteger)({
                data: a.embedPDF,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.format = (0, t.getStringOption)(a.format, ["xdp", "formdata", "pdf", "urlencoded", "xfd", "xml"]), this.id = a.id || "", this.target = a.target || "", this.textEncoding = (0, t.getKeyword)({
                data: a.textEncoding ? a.textEncoding.toLowerCase() : "",
                defaultValue: "",
                validate: (Z) => ["utf-8", "big-five", "fontspecific", "gbk", "gb-18030", "gb-2312", "ksc-5601", "none", "shift-jis", "ucs-2", "utf-16"].includes(Z) || Z.match(/iso-8859-\d{2}/)
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.xdpContent = a.xdpContent || "", this.encrypt = null, this.encryptData = new n.XFAObjectArray(), this.signData = new n.XFAObjectArray();
            }
          }
          class mn extends n.XFAObject {
            constructor(a) {
              super(w, "template", !0), this.baseProfile = (0, t.getStringOption)(a.baseProfile, ["full", "interactiveForms"]), this.extras = null, this.subform = new n.XFAObjectArray();
            }
            [n.$finalize]() {
              this.subform.children.length === 0 && (0, B.warn)("XFA - No subforms in template node."), this.subform.children.length >= 2 && (0, B.warn)("XFA - Several subforms in template node: please file a bug."), this[n.$tabIndex] = k;
            }
            [n.$isSplittable]() {
              return !0;
            }
            [n.$searchNode](a, Z) {
              return a.startsWith("#") ? [this[n.$ids].get(a.slice(1))] : (0, O.searchNode)(this, Z, a, !0, !0);
            }
            *[n.$toPages]() {
              var zt, Ot, qt;
              if (!this.subform.children.length)
                return t.HTMLResult.success({
                  name: "div",
                  children: []
                });
              this[n.$extra] = {
                overflowNode: null,
                firstUnsplittable: null,
                currentContentArea: null,
                currentPageArea: null,
                noLayoutFailure: !1,
                pageNumber: 1,
                pagePosition: "first",
                oddOrEven: "odd",
                blankOrNotBlank: "nonBlank",
                paraStack: []
              };
              const a = this.subform.children[0];
              a.pageSet[n.$cleanPage]();
              const Z = a.pageSet.pageArea.children, De = {
                name: "div",
                children: []
              };
              let He = null, Ye = null, ut = null;
              if (a.breakBefore.children.length >= 1 ? (Ye = a.breakBefore.children[0], ut = Ye.target) : a.subform.children.length >= 1 && a.subform.children[0].breakBefore.children.length >= 1 ? (Ye = a.subform.children[0].breakBefore.children[0], ut = Ye.target) : (zt = a.break) != null && zt.beforeTarget ? (Ye = a.break, ut = Ye.beforeTarget) : a.subform.children.length >= 1 && ((Ot = a.subform.children[0].break) != null && Ot.beforeTarget) && (Ye = a.subform.children[0].break, ut = Ye.beforeTarget), Ye) {
                const Xt = this[n.$searchNode](ut, Ye[n.$getParent]());
                Xt instanceof Ze && (He = Xt, Ye[n.$extra] = {});
              }
              He || (He = Z[0]), He[n.$extra] = {
                numberOfUse: 1
              };
              const xt = He[n.$getParent]();
              xt[n.$extra] = {
                numberOfUse: 1,
                pageIndex: xt.pageArea.children.indexOf(He),
                pageSetIndex: 0
              };
              let bt, Tt = null, _t = null, $t = !0, jt = 0, Ht = 0;
              for (; ; ) {
                if ($t)
                  jt = 0;
                else if (De.children.pop(), ++jt === o)
                  return (0, B.warn)("XFA - Something goes wrong: please file a bug."), De;
                bt = null, this[n.$extra].currentPageArea = He;
                const Xt = He[n.$toHTML]().html;
                De.children.push(Xt), Tt && (this[n.$extra].noLayoutFailure = !0, Xt.children.push(Tt[n.$toHTML](He[n.$extra].space).html), Tt = null), _t && (this[n.$extra].noLayoutFailure = !0, Xt.children.push(_t[n.$toHTML](He[n.$extra].space).html), _t = null);
                const Kt = He.contentArea.children, Wt = Xt.children.filter((wt) => wt.attributes.class.includes("xfaContentarea"));
                $t = !1, this[n.$extra].firstUnsplittable = null, this[n.$extra].noLayoutFailure = !1;
                const Lt = (wt) => {
                  var Jt;
                  const Qt = a[n.$flushHTML]();
                  Qt && ($t || ($t = ((Jt = Qt.children) == null ? void 0 : Jt.length) > 0), Wt[wt].children.push(Qt));
                };
                for (let wt = Ht, Qt = Kt.length; wt < Qt; wt++) {
                  const Jt = this[n.$extra].currentContentArea = Kt[wt], an = {
                    width: Jt.w,
                    height: Jt.h
                  };
                  Ht = 0, Tt && (Wt[wt].children.push(Tt[n.$toHTML](an).html), Tt = null), _t && (Wt[wt].children.push(_t[n.$toHTML](an).html), _t = null);
                  const en = a[n.$toHTML](an);
                  if (en.success)
                    return en.html ? ($t || ($t = ((qt = en.html.children) == null ? void 0 : qt.length) > 0), Wt[wt].children.push(en.html)) : !$t && De.children.length > 1 && De.children.pop(), De;
                  if (en.isBreak()) {
                    const Vt = en.breakNode;
                    if (Lt(wt), Vt.targetType === "auto")
                      continue;
                    Vt.leader && (Tt = this[n.$searchNode](Vt.leader, Vt[n.$getParent]()), Tt = Tt ? Tt[0] : null), Vt.trailer && (_t = this[n.$searchNode](Vt.trailer, Vt[n.$getParent]()), _t = _t ? _t[0] : null), Vt.targetType === "pageArea" ? (bt = Vt[n.$extra].target, wt = 1 / 0) : Vt[n.$extra].target ? (bt = Vt[n.$extra].target, Ht = Vt[n.$extra].index + 1, wt = 1 / 0) : wt = Vt[n.$extra].index;
                    continue;
                  }
                  if (this[n.$extra].overflowNode) {
                    const Vt = this[n.$extra].overflowNode;
                    this[n.$extra].overflowNode = null;
                    const bn = Vt[n.$getExtra](), hn = bn.target;
                    bn.addLeader = bn.leader !== null, bn.addTrailer = bn.trailer !== null, Lt(wt);
                    const zi = wt;
                    if (wt = 1 / 0, hn instanceof Ze)
                      bt = hn;
                    else if (hn instanceof ee) {
                      const Cn = Kt.indexOf(hn);
                      Cn !== -1 ? Cn > zi ? wt = Cn - 1 : Ht = Cn : (bt = hn[n.$getParent](), Ht = bt.contentArea.children.indexOf(hn));
                    }
                    continue;
                  }
                  Lt(wt);
                }
                this[n.$extra].pageNumber += 1, bt && (bt[n.$isUsable]() ? bt[n.$extra].numberOfUse += 1 : bt = null), He = bt || He[n.$getNextPage](), yield null;
              }
            }
          }
          F.Template = mn;
          class Sn extends n.ContentObject {
            constructor(a) {
              super(w, "text"), this.id = a.id || "", this.maxChars = (0, t.getInteger)({
                data: a.maxChars,
                defaultValue: 0,
                validate: (Z) => Z >= 0
              }), this.name = a.name || "", this.rid = a.rid || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$acceptWhitespace]() {
              return !0;
            }
            [n.$onChild](a) {
              return a[n.$namespaceId] === u.NamespaceIds.xhtml.id ? (this[n.$content] = a, !0) : ((0, B.warn)(`XFA - Invalid content in Text: ${a[n.$nodeName]}.`), !1);
            }
            [n.$onText](a) {
              this[n.$content] instanceof n.XFAObject || super[n.$onText](a);
            }
            [n.$finalize]() {
              typeof this[n.$content] == "string" && (this[n.$content] = this[n.$content].replaceAll(`\r
`, `
`));
            }
            [n.$getExtra]() {
              return typeof this[n.$content] == "string" ? this[n.$content].split(/[\u2029\u2028\n]/).reduce((a, Z) => (Z && a.push(Z), a), []).join(`
`) : this[n.$content][n.$text]();
            }
            [n.$toHTML](a) {
              if (typeof this[n.$content] == "string") {
                const Z = c(this[n.$content]).html;
                return this[n.$content].includes("\u2029") ? (Z.name = "div", Z.children = [], this[n.$content].split("\u2029").map((De) => De.split(/[\u2028\n]/).reduce((He, Ye) => (He.push({
                  name: "span",
                  value: Ye
                }, {
                  name: "br"
                }), He), [])).forEach((De) => {
                  Z.children.push({
                    name: "p",
                    children: De
                  });
                })) : /[\u2028\n]/.test(this[n.$content]) && (Z.name = "div", Z.children = [], this[n.$content].split(/[\u2028\n]/).forEach((De) => {
                  Z.children.push({
                    name: "span",
                    value: De
                  }, {
                    name: "br"
                  });
                })), t.HTMLResult.success(Z);
              }
              return this[n.$content][n.$toHTML](a);
            }
          }
          F.Text = Sn;
          class vn extends n.XFAObject {
            constructor(a) {
              super(w, "textEdit", !0), this.allowRichText = (0, t.getInteger)({
                data: a.allowRichText,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.hScrollPolicy = (0, t.getStringOption)(a.hScrollPolicy, ["auto", "off", "on"]), this.id = a.id || "", this.multiLine = (0, t.getInteger)({
                data: a.multiLine,
                defaultValue: "",
                validate: (Z) => Z === 0 || Z === 1
              }), this.use = a.use || "", this.usehref = a.usehref || "", this.vScrollPolicy = (0, t.getStringOption)(a.vScrollPolicy, ["auto", "off", "on"]), this.border = null, this.comb = null, this.extras = null, this.margin = null;
            }
            [n.$toHTML](a) {
              var Ye, ut;
              const Z = (0, e.toStyle)(this, "border", "font", "margin");
              let De;
              const He = this[n.$getParent]()[n.$getParent]();
              return this.multiLine === "" && (this.multiLine = He instanceof pe ? 1 : 0), this.multiLine === 1 ? De = {
                name: "textarea",
                attributes: {
                  dataId: ((Ye = He[n.$data]) == null ? void 0 : Ye[n.$uid]) || He[n.$uid],
                  fieldId: He[n.$uid],
                  class: ["xfaTextfield"],
                  style: Z,
                  "aria-label": P(He),
                  "aria-required": !1
                }
              } : De = {
                name: "input",
                attributes: {
                  type: "text",
                  dataId: ((ut = He[n.$data]) == null ? void 0 : ut[n.$uid]) || He[n.$uid],
                  fieldId: He[n.$uid],
                  class: ["xfaTextfield"],
                  style: Z,
                  "aria-label": P(He),
                  "aria-required": !1
                }
              }, I(He) && (De.attributes["aria-required"] = !0, De.attributes.required = !0), t.HTMLResult.success({
                name: "label",
                attributes: {
                  class: ["xfaLabel"]
                },
                children: [De]
              });
            }
          }
          class $n extends n.StringObject {
            constructor(a) {
              super(w, "time"), this.id = a.id || "", this.name = a.name || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
            [n.$finalize]() {
              const a = this[n.$content].trim();
              this[n.$content] = a ? new Date(a) : null;
            }
            [n.$toHTML](a) {
              return c(this[n.$content] ? this[n.$content].toString() : "");
            }
          }
          class Un extends n.XFAObject {
            constructor(a) {
              super(w, "timeStamp"), this.id = a.id || "", this.server = a.server || "", this.type = (0, t.getStringOption)(a.type, ["optional", "required"]), this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Hn extends n.StringObject {
            constructor(a) {
              super(w, "toolTip"), this.id = a.id || "", this.rid = a.rid || "", this.use = a.use || "", this.usehref = a.usehref || "";
            }
          }
          class Xn extends n.XFAObject {
            constructor(a) {
              super(w, "traversal", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.traverse = new n.XFAObjectArray();
            }
          }
          class zn extends n.XFAObject {
            constructor(a) {
              super(w, "traverse", !0), this.id = a.id || "", this.operation = (0, t.getStringOption)(a.operation, ["next", "back", "down", "first", "left", "right", "up"]), this.ref = a.ref || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.script = null;
            }
            get name() {
              return this.operation;
            }
            [n.$isTransparent]() {
              return !1;
            }
          }
          class xn extends n.XFAObject {
            constructor(a) {
              super(w, "ui", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.picture = null, this.barcode = null, this.button = null, this.checkButton = null, this.choiceList = null, this.dateTimeEdit = null, this.defaultUi = null, this.imageEdit = null, this.numericEdit = null, this.passwordEdit = null, this.signature = null, this.textEdit = null;
            }
            [n.$getExtra]() {
              if (this[n.$extra] === void 0) {
                for (const a of Object.getOwnPropertyNames(this)) {
                  if (a === "extras" || a === "picture")
                    continue;
                  const Z = this[a];
                  if (Z instanceof n.XFAObject)
                    return this[n.$extra] = Z, Z;
                }
                this[n.$extra] = null;
              }
              return this[n.$extra];
            }
            [n.$toHTML](a) {
              const Z = this[n.$getExtra]();
              return Z ? Z[n.$toHTML](a) : t.HTMLResult.EMPTY;
            }
          }
          class Gn extends n.XFAObject {
            constructor(a) {
              super(w, "validate", !0), this.formatTest = (0, t.getStringOption)(a.formatTest, ["warning", "disabled", "error"]), this.id = a.id || "", this.nullTest = (0, t.getStringOption)(a.nullTest, ["disabled", "error", "warning"]), this.scriptTest = (0, t.getStringOption)(a.scriptTest, ["error", "disabled", "warning"]), this.use = a.use || "", this.usehref = a.usehref || "", this.extras = null, this.message = null, this.picture = null, this.script = null;
            }
          }
          class cn extends n.XFAObject {
            constructor(a) {
              super(w, "value", !0), this.id = a.id || "", this.override = (0, t.getInteger)({
                data: a.override,
                defaultValue: 0,
                validate: (Z) => Z === 1
              }), this.relevant = (0, t.getRelevant)(a.relevant), this.use = a.use || "", this.usehref = a.usehref || "", this.arc = null, this.boolean = null, this.date = null, this.dateTime = null, this.decimal = null, this.exData = null, this.float = null, this.image = null, this.integer = null, this.line = null, this.rectangle = null, this.text = null, this.time = null;
            }
            [n.$setValue](a) {
              var He;
              const Z = this[n.$getParent]();
              if (Z instanceof Ke && (He = Z.ui) != null && He.imageEdit) {
                this.image || (this.image = new Ct({}), this[n.$appendChild](this.image)), this.image[n.$content] = a[n.$content];
                return;
              }
              const De = a[n.$nodeName];
              if (this[De] !== null) {
                this[De][n.$content] = a[n.$content];
                return;
              }
              for (const Ye of Object.getOwnPropertyNames(this)) {
                const ut = this[Ye];
                ut instanceof n.XFAObject && (this[Ye] = null, this[n.$removeChild](ut));
              }
              this[a[n.$nodeName]] = a, this[n.$appendChild](a);
            }
            [n.$text]() {
              if (this.exData)
                return typeof this.exData[n.$content] == "string" ? this.exData[n.$content].trim() : this.exData[n.$content][n.$text]().trim();
              for (const a of Object.getOwnPropertyNames(this)) {
                if (a === "image")
                  continue;
                const Z = this[a];
                if (Z instanceof n.XFAObject)
                  return (Z[n.$content] || "").toString().trim();
              }
              return null;
            }
            [n.$toHTML](a) {
              for (const Z of Object.getOwnPropertyNames(this)) {
                const De = this[Z];
                if (De instanceof n.XFAObject)
                  return De[n.$toHTML](a);
              }
              return t.HTMLResult.EMPTY;
            }
          }
          F.Value = cn;
          class qn extends n.XFAObject {
            constructor(a) {
              super(w, "variables", !0), this.id = a.id || "", this.use = a.use || "", this.usehref = a.usehref || "", this.boolean = new n.XFAObjectArray(), this.date = new n.XFAObjectArray(), this.dateTime = new n.XFAObjectArray(), this.decimal = new n.XFAObjectArray(), this.exData = new n.XFAObjectArray(), this.float = new n.XFAObjectArray(), this.image = new n.XFAObjectArray(), this.integer = new n.XFAObjectArray(), this.manifest = new n.XFAObjectArray(), this.script = new n.XFAObjectArray(), this.text = new n.XFAObjectArray(), this.time = new n.XFAObjectArray();
            }
            [n.$isTransparent]() {
              return !0;
            }
          }
          class ln {
            static [u.$buildXFAObject](a, Z) {
              if (ln.hasOwnProperty(a)) {
                const De = ln[a](Z);
                return De[n.$setSetAttributes](Z), De;
              }
            }
            static appearanceFilter(a) {
              return new H(a);
            }
            static arc(a) {
              return new $(a);
            }
            static area(a) {
              return new m(a);
            }
            static assist(a) {
              return new p(a);
            }
            static barcode(a) {
              return new T(a);
            }
            static bind(a) {
              return new L(a);
            }
            static bindItems(a) {
              return new _(a);
            }
            static bookend(a) {
              return new G(a);
            }
            static boolean(a) {
              return new J(a);
            }
            static border(a) {
              return new K(a);
            }
            static break(a) {
              return new V(a);
            }
            static breakAfter(a) {
              return new U(a);
            }
            static breakBefore(a) {
              return new Q(a);
            }
            static button(a) {
              return new X(a);
            }
            static calculate(a) {
              return new R(a);
            }
            static caption(a) {
              return new f(a);
            }
            static certificate(a) {
              return new D(a);
            }
            static certificates(a) {
              return new z(a);
            }
            static checkButton(a) {
              return new Y(a);
            }
            static choiceList(a) {
              return new W(a);
            }
            static color(a) {
              return new ie(a);
            }
            static comb(a) {
              return new ne(a);
            }
            static connect(a) {
              return new re(a);
            }
            static contentArea(a) {
              return new ee(a);
            }
            static corner(a) {
              return new te(a);
            }
            static date(a) {
              return new oe(a);
            }
            static dateTime(a) {
              return new se(a);
            }
            static dateTimeEdit(a) {
              return new ce(a);
            }
            static decimal(a) {
              return new le(a);
            }
            static defaultUi(a) {
              return new de(a);
            }
            static desc(a) {
              return new Ie(a);
            }
            static digestMethod(a) {
              return new Fe(a);
            }
            static digestMethods(a) {
              return new we(a);
            }
            static draw(a) {
              return new pe(a);
            }
            static edge(a) {
              return new fe(a);
            }
            static encoding(a) {
              return new Ae(a);
            }
            static encodings(a) {
              return new Pe(a);
            }
            static encrypt(a) {
              return new Re(a);
            }
            static encryptData(a) {
              return new Ee(a);
            }
            static encryption(a) {
              return new ye(a);
            }
            static encryptionMethod(a) {
              return new Te(a);
            }
            static encryptionMethods(a) {
              return new je(a);
            }
            static event(a) {
              return new ve(a);
            }
            static exData(a) {
              return new Ce(a);
            }
            static exObject(a) {
              return new Ne(a);
            }
            static exclGroup(a) {
              return new Ge(a);
            }
            static execute(a) {
              return new Oe(a);
            }
            static extras(a) {
              return new tt(a);
            }
            static field(a) {
              return new Ke(a);
            }
            static fill(a) {
              return new et(a);
            }
            static filter(a) {
              return new Xe(a);
            }
            static float(a) {
              return new Qe(a);
            }
            static font(a) {
              return new it(a);
            }
            static format(a) {
              return new We(a);
            }
            static handler(a) {
              return new gt(a);
            }
            static hyphenation(a) {
              return new mt(a);
            }
            static image(a) {
              return new Ct(a);
            }
            static imageEdit(a) {
              return new Pt(a);
            }
            static integer(a) {
              return new at(a);
            }
            static issuers(a) {
              return new dt(a);
            }
            static items(a) {
              return new ot(a);
            }
            static keep(a) {
              return new Mt(a);
            }
            static keyUsage(a) {
              return new Rt(a);
            }
            static line(a) {
              return new Et(a);
            }
            static linear(a) {
              return new At(a);
            }
            static lockDocument(a) {
              return new Nt(a);
            }
            static manifest(a) {
              return new qe(a);
            }
            static margin(a) {
              return new Ue(a);
            }
            static mdp(a) {
              return new Je(a);
            }
            static medium(a) {
              return new Ve(a);
            }
            static message(a) {
              return new st(a);
            }
            static numericEdit(a) {
              return new ft(a);
            }
            static occur(a) {
              return new ct(a);
            }
            static oid(a) {
              return new be(a);
            }
            static oids(a) {
              return new _e(a);
            }
            static overflow(a) {
              return new $e(a);
            }
            static pageArea(a) {
              return new Ze(a);
            }
            static pageSet(a) {
              return new nt(a);
            }
            static para(a) {
              return new pt(a);
            }
            static passwordEdit(a) {
              return new yt(a);
            }
            static pattern(a) {
              return new lt(a);
            }
            static picture(a) {
              return new St(a);
            }
            static proto(a) {
              return new ht(a);
            }
            static radial(a) {
              return new Ft(a);
            }
            static reason(a) {
              return new It(a);
            }
            static reasons(a) {
              return new Gt(a);
            }
            static rectangle(a) {
              return new vt(a);
            }
            static ref(a) {
              return new kt(a);
            }
            static script(a) {
              return new Bt(a);
            }
            static setProperty(a) {
              return new Ut(a);
            }
            static signData(a) {
              return new Yt(a);
            }
            static signature(a) {
              return new rn(a);
            }
            static signing(a) {
              return new Rn(a);
            }
            static solid(a) {
              return new Dn(a);
            }
            static speak(a) {
              return new _n(a);
            }
            static stipple(a) {
              return new Ln(a);
            }
            static subform(a) {
              return new An(a);
            }
            static subformSet(a) {
              return new pn(a);
            }
            static subjectDN(a) {
              return new Nn(a);
            }
            static subjectDNs(a) {
              return new Bn(a);
            }
            static submit(a) {
              return new jn(a);
            }
            static template(a) {
              return new mn(a);
            }
            static text(a) {
              return new Sn(a);
            }
            static textEdit(a) {
              return new vn(a);
            }
            static time(a) {
              return new $n(a);
            }
            static timeStamp(a) {
              return new Un(a);
            }
            static toolTip(a) {
              return new Hn(a);
            }
            static traversal(a) {
              return new Xn(a);
            }
            static traverse(a) {
              return new zn(a);
            }
            static ui(a) {
              return new xn(a);
            }
            static validate(a) {
              return new Gn(a);
            }
            static value(a) {
              return new cn(a);
            }
            static variables(a) {
              return new qn(a);
            }
          }
          F.TemplateNamespace = ln;
        },
        /* 84 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.addHTML = t, F.checkDimensions = M, F.flushHTML = e, F.getAvailableSpace = B;
          var n = ae(78), u = ae(85);
          function q(O, w) {
            return {
              name: "div",
              attributes: {
                class: [O.layout === "lr-tb" ? "xfaLr" : "xfaRl"]
              },
              children: w
            };
          }
          function e(O) {
            if (!O[n.$extra])
              return null;
            const C = {
              name: "div",
              attributes: O[n.$extra].attributes,
              children: O[n.$extra].children
            };
            if (O[n.$extra].failingNode) {
              const i = O[n.$extra].failingNode[n.$flushHTML]();
              i && (O.layout.endsWith("-tb") ? C.children.push(q(O, [i])) : C.children.push(i));
            }
            return C.children.length === 0 ? null : C;
          }
          function t(O, w, C) {
            const i = O[n.$extra], o = i.availableSpace, [k, s, l, g] = C;
            switch (O.layout) {
              case "position": {
                i.width = Math.max(i.width, k + l), i.height = Math.max(i.height, s + g), i.children.push(w);
                break;
              }
              case "lr-tb":
              case "rl-tb":
                (!i.line || i.attempt === 1) && (i.line = q(O, []), i.children.push(i.line), i.numberInLine = 0), i.numberInLine += 1, i.line.children.push(w), i.attempt === 0 ? (i.currentWidth += l, i.height = Math.max(i.height, i.prevHeight + g)) : (i.currentWidth = l, i.prevHeight = i.height, i.height += g, i.attempt = 0), i.width = Math.max(i.width, i.currentWidth);
                break;
              case "rl-row":
              case "row": {
                i.children.push(w), i.width += l, i.height = Math.max(i.height, g);
                const v = (0, u.measureToString)(i.height);
                for (const r of i.children)
                  r.attributes.style.height = v;
                break;
              }
              case "table": {
                i.width = Math.min(o.width, Math.max(i.width, l)), i.height += g, i.children.push(w);
                break;
              }
              case "tb": {
                i.width = Math.min(o.width, Math.max(i.width, l)), i.height += g, i.children.push(w);
                break;
              }
            }
          }
          function B(O) {
            const w = O[n.$extra].availableSpace, C = O.margin ? O.margin.topInset + O.margin.bottomInset : 0, i = O.margin ? O.margin.leftInset + O.margin.rightInset : 0;
            switch (O.layout) {
              case "lr-tb":
              case "rl-tb":
                return O[n.$extra].attempt === 0 ? {
                  width: w.width - i - O[n.$extra].currentWidth,
                  height: w.height - C - O[n.$extra].prevHeight
                } : {
                  width: w.width - i,
                  height: w.height - C - O[n.$extra].height
                };
              case "rl-row":
              case "row":
                return {
                  width: O[n.$extra].columnWidths.slice(O[n.$extra].currentColumn).reduce((k, s) => k + s),
                  height: w.height - i
                };
              case "table":
              case "tb":
                return {
                  width: w.width - i,
                  height: w.height - C - O[n.$extra].height
                };
              case "position":
              default:
                return w;
            }
          }
          function j(O) {
            let w = O.w === "" ? NaN : O.w, C = O.h === "" ? NaN : O.h, [i, o] = [0, 0];
            switch (O.anchorType || "") {
              case "bottomCenter":
                [i, o] = [w / 2, C];
                break;
              case "bottomLeft":
                [i, o] = [0, C];
                break;
              case "bottomRight":
                [i, o] = [w, C];
                break;
              case "middleCenter":
                [i, o] = [w / 2, C / 2];
                break;
              case "middleLeft":
                [i, o] = [0, C / 2];
                break;
              case "middleRight":
                [i, o] = [w, C / 2];
                break;
              case "topCenter":
                [i, o] = [w / 2, 0];
                break;
              case "topRight":
                [i, o] = [w, 0];
                break;
            }
            let k, s;
            switch (O.rotate || 0) {
              case 0:
                [k, s] = [-i, -o];
                break;
              case 90:
                [k, s] = [-o, i], [w, C] = [C, -w];
                break;
              case 180:
                [k, s] = [i, o], [w, C] = [-w, -C];
                break;
              case 270:
                [k, s] = [o, -i], [w, C] = [-C, w];
                break;
            }
            return [O.x + k + Math.min(0, w), O.y + s + Math.min(0, C), Math.abs(w), Math.abs(C)];
          }
          function M(O, w) {
            var g;
            if (O[n.$getTemplateRoot]()[n.$extra].firstUnsplittable === null || O.w === 0 || O.h === 0)
              return !0;
            const C = 2, i = O[n.$getSubformParent](), o = ((g = i[n.$extra]) == null ? void 0 : g.attempt) || 0, [, k, s, l] = j(O);
            switch (i.layout) {
              case "lr-tb":
              case "rl-tb":
                return o === 0 ? O[n.$getTemplateRoot]()[n.$extra].noLayoutFailure ? O.w !== "" ? Math.round(s - w.width) <= C : w.width > C : O.h !== "" && Math.round(l - w.height) > C ? !1 : O.w !== "" ? Math.round(s - w.width) <= C ? !0 : i[n.$extra].numberInLine === 0 ? w.height > C : !1 : w.width > C : O[n.$getTemplateRoot]()[n.$extra].noLayoutFailure ? !0 : O.h !== "" && Math.round(l - w.height) > C ? !1 : O.w === "" || Math.round(s - w.width) <= C ? w.height > C : i[n.$isThereMoreWidth]() ? !1 : w.height > C;
              case "table":
              case "tb":
                return O[n.$getTemplateRoot]()[n.$extra].noLayoutFailure ? !0 : O.h !== "" && !O[n.$isSplittable]() ? Math.round(l - w.height) <= C : O.w === "" || Math.round(s - w.width) <= C ? w.height > C : i[n.$isThereMoreWidth]() ? !1 : w.height > C;
              case "position":
                if (O[n.$getTemplateRoot]()[n.$extra].noLayoutFailure || O.h === "" || Math.round(l + k - w.height) <= C)
                  return !0;
                const v = O[n.$getTemplateRoot]()[n.$extra].currentContentArea;
                return l + k > v.h;
              case "rl-row":
              case "row":
                return O[n.$getTemplateRoot]()[n.$extra].noLayoutFailure ? !0 : O.h !== "" ? Math.round(l - w.height) <= C : !0;
              default:
                return !0;
            }
          }
        },
        /* 85 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.computeBbox = C, F.createWrapper = s, F.fixDimensions = i, F.fixTextIndent = l, F.fixURL = I, F.isPrintOnly = v, F.layoutClass = o, F.layoutNode = w, F.measureToString = B, F.setAccess = g, F.setFontFamily = b, F.setMinMaxDimensions = M, F.setPara = x, F.toStyle = k;
          var n = ae(78), u = ae(2), q = ae(79), e = ae(86), t = ae(87);
          function B(h) {
            return typeof h == "string" ? "0px" : Number.isInteger(h) ? `${h}px` : `${h.toFixed(2)}px`;
          }
          const j = {
            anchorType(h, y) {
              const P = h[n.$getSubformParent]();
              if (!(!P || P.layout && P.layout !== "position"))
                switch ("transform" in y || (y.transform = ""), h.anchorType) {
                  case "bottomCenter":
                    y.transform += "translate(-50%, -100%)";
                    break;
                  case "bottomLeft":
                    y.transform += "translate(0,-100%)";
                    break;
                  case "bottomRight":
                    y.transform += "translate(-100%,-100%)";
                    break;
                  case "middleCenter":
                    y.transform += "translate(-50%,-50%)";
                    break;
                  case "middleLeft":
                    y.transform += "translate(0,-50%)";
                    break;
                  case "middleRight":
                    y.transform += "translate(-100%,-50%)";
                    break;
                  case "topCenter":
                    y.transform += "translate(-50%,0)";
                    break;
                  case "topRight":
                    y.transform += "translate(-100%,0)";
                    break;
                }
            },
            dimensions(h, y) {
              var A;
              const P = h[n.$getSubformParent]();
              let c = h.w;
              const d = h.h;
              if ((A = P.layout) != null && A.includes("row")) {
                const N = P[n.$extra], E = h.colSpan;
                let H;
                E === -1 ? (H = N.columnWidths.slice(N.currentColumn).reduce(($, m) => $ + m, 0), N.currentColumn = 0) : (H = N.columnWidths.slice(N.currentColumn, N.currentColumn + E).reduce(($, m) => $ + m, 0), N.currentColumn = (N.currentColumn + h.colSpan) % N.columnWidths.length), isNaN(H) || (c = h.w = H);
              }
              c !== "" ? y.width = B(c) : y.width = "auto", d !== "" ? y.height = B(d) : y.height = "auto";
            },
            position(h, y) {
              const P = h[n.$getSubformParent]();
              P != null && P.layout && P.layout !== "position" || (y.position = "absolute", y.left = B(h.x), y.top = B(h.y));
            },
            rotate(h, y) {
              h.rotate && ("transform" in y || (y.transform = ""), y.transform += `rotate(-${h.rotate}deg)`, y.transformOrigin = "top left");
            },
            presence(h, y) {
              switch (h.presence) {
                case "invisible":
                  y.visibility = "hidden";
                  break;
                case "hidden":
                case "inactive":
                  y.display = "none";
                  break;
              }
            },
            hAlign(h, y) {
              if (h[n.$nodeName] === "para")
                switch (h.hAlign) {
                  case "justifyAll":
                    y.textAlign = "justify-all";
                    break;
                  case "radix":
                    y.textAlign = "left";
                    break;
                  default:
                    y.textAlign = h.hAlign;
                }
              else
                switch (h.hAlign) {
                  case "left":
                    y.alignSelf = "start";
                    break;
                  case "center":
                    y.alignSelf = "center";
                    break;
                  case "right":
                    y.alignSelf = "end";
                    break;
                }
            },
            margin(h, y) {
              h.margin && (y.margin = h.margin[n.$toStyle]().margin);
            }
          };
          function M(h, y) {
            h[n.$getSubformParent]().layout === "position" && (h.minW > 0 && (y.minWidth = B(h.minW)), h.maxW > 0 && (y.maxWidth = B(h.maxW)), h.minH > 0 && (y.minHeight = B(h.minH)), h.maxH > 0 && (y.maxHeight = B(h.maxH)));
          }
          function O(h, y, P, c, d, A) {
            const N = new t.TextMeasure(y, P, c, d);
            return typeof h == "string" ? N.addString(h) : h[n.$pushGlyphs](N), N.compute(A);
          }
          function w(h, y) {
            let P = null, c = null, d = !1;
            if ((!h.w || !h.h) && h.value) {
              let A = 0, N = 0;
              h.margin && (A = h.margin.leftInset + h.margin.rightInset, N = h.margin.topInset + h.margin.bottomInset);
              let E = null, H = null;
              h.para && (H = /* @__PURE__ */ Object.create(null), E = h.para.lineHeight === "" ? null : h.para.lineHeight, H.top = h.para.spaceAbove === "" ? 0 : h.para.spaceAbove, H.bottom = h.para.spaceBelow === "" ? 0 : h.para.spaceBelow, H.left = h.para.marginLeft === "" ? 0 : h.para.marginLeft, H.right = h.para.marginRight === "" ? 0 : h.para.marginRight);
              let $ = h.font;
              if (!$) {
                const T = h[n.$getTemplateRoot]();
                let L = h[n.$getParent]();
                for (; L && L !== T; ) {
                  if (L.font) {
                    $ = L.font;
                    break;
                  }
                  L = L[n.$getParent]();
                }
              }
              const m = (h.w || y.width) - A, p = h[n.$globalData].fontFinder;
              if (h.value.exData && h.value.exData[n.$content] && h.value.exData.contentType === "text/html") {
                const T = O(h.value.exData[n.$content], $, H, E, p, m);
                c = T.width, P = T.height, d = T.isBroken;
              } else {
                const T = h.value[n.$text]();
                if (T) {
                  const L = O(T, $, H, E, p, m);
                  c = L.width, P = L.height, d = L.isBroken;
                }
              }
              c !== null && !h.w && (c += A), P !== null && !h.h && (P += N);
            }
            return {
              w: c,
              h: P,
              isBroken: d
            };
          }
          function C(h, y, P) {
            let c;
            if (h.w !== "" && h.h !== "")
              c = [h.x, h.y, h.w, h.h];
            else {
              if (!P)
                return null;
              let d = h.w;
              if (d === "") {
                if (h.maxW === 0) {
                  const N = h[n.$getSubformParent]();
                  N.layout === "position" && N.w !== "" ? d = 0 : d = h.minW;
                } else
                  d = Math.min(h.maxW, P.width);
                y.attributes.style.width = B(d);
              }
              let A = h.h;
              if (A === "") {
                if (h.maxH === 0) {
                  const N = h[n.$getSubformParent]();
                  N.layout === "position" && N.h !== "" ? A = 0 : A = h.minH;
                } else
                  A = Math.min(h.maxH, P.height);
                y.attributes.style.height = B(A);
              }
              c = [h.x, h.y, d, A];
            }
            return c;
          }
          function i(h) {
            var P;
            const y = h[n.$getSubformParent]();
            if ((P = y.layout) != null && P.includes("row")) {
              const c = y[n.$extra], d = h.colSpan;
              let A;
              d === -1 ? A = c.columnWidths.slice(c.currentColumn).reduce((N, E) => N + E, 0) : A = c.columnWidths.slice(c.currentColumn, c.currentColumn + d).reduce((N, E) => N + E, 0), isNaN(A) || (h.w = A);
            }
            y.layout && y.layout !== "position" && (h.x = h.y = 0), h.layout === "table" && h.w === "" && Array.isArray(h.columnWidths) && (h.w = h.columnWidths.reduce((c, d) => c + d, 0));
          }
          function o(h) {
            switch (h.layout) {
              case "position":
                return "xfaPosition";
              case "lr-tb":
                return "xfaLrTb";
              case "rl-row":
                return "xfaRlRow";
              case "rl-tb":
                return "xfaRlTb";
              case "row":
                return "xfaRow";
              case "table":
                return "xfaTable";
              case "tb":
                return "xfaTb";
              default:
                return "xfaPosition";
            }
          }
          function k(h, ...y) {
            const P = /* @__PURE__ */ Object.create(null);
            for (const c of y) {
              const d = h[c];
              if (d !== null) {
                if (j.hasOwnProperty(c)) {
                  j[c](h, P);
                  continue;
                }
                if (d instanceof n.XFAObject) {
                  const A = d[n.$toStyle]();
                  A ? Object.assign(P, A) : (0, u.warn)(`(DEBUG) - XFA - style for ${c} not implemented yet`);
                }
              }
            }
            return P;
          }
          function s(h, y) {
            const {
              attributes: P
            } = y, {
              style: c
            } = P, d = {
              name: "div",
              attributes: {
                class: ["xfaWrapper"],
                style: /* @__PURE__ */ Object.create(null)
              },
              children: []
            };
            if (P.class.push("xfaWrapped"), h.border) {
              const {
                widths: A,
                insets: N
              } = h.border[n.$extra];
              let E, H, $ = N[0], m = N[3];
              const p = N[0] + N[2], T = N[1] + N[3];
              switch (h.border.hand) {
                case "even":
                  $ -= A[0] / 2, m -= A[3] / 2, E = `calc(100% + ${(A[1] + A[3]) / 2 - T}px)`, H = `calc(100% + ${(A[0] + A[2]) / 2 - p}px)`;
                  break;
                case "left":
                  $ -= A[0], m -= A[3], E = `calc(100% + ${A[1] + A[3] - T}px)`, H = `calc(100% + ${A[0] + A[2] - p}px)`;
                  break;
                case "right":
                  E = T ? `calc(100% - ${T}px)` : "100%", H = p ? `calc(100% - ${p}px)` : "100%";
                  break;
              }
              const L = ["xfaBorder"];
              v(h.border) && L.push("xfaPrintOnly");
              const _ = {
                name: "div",
                attributes: {
                  class: L,
                  style: {
                    top: `${$}px`,
                    left: `${m}px`,
                    width: E,
                    height: H
                  }
                },
                children: []
              };
              for (const G of ["border", "borderWidth", "borderColor", "borderRadius", "borderStyle"])
                c[G] !== void 0 && (_.attributes.style[G] = c[G], delete c[G]);
              d.children.push(_, y);
            } else
              d.children.push(y);
            for (const A of ["background", "backgroundClip", "top", "left", "width", "height", "minWidth", "minHeight", "maxWidth", "maxHeight", "transform", "transformOrigin", "visibility"])
              c[A] !== void 0 && (d.attributes.style[A] = c[A], delete c[A]);
            return c.position === "absolute" ? d.attributes.style.position = "absolute" : d.attributes.style.position = "relative", delete c.position, c.alignSelf && (d.attributes.style.alignSelf = c.alignSelf, delete c.alignSelf), d;
          }
          function l(h) {
            const y = (0, q.getMeasurement)(h.textIndent, "0px");
            if (y >= 0)
              return;
            const c = "padding" + ((h.textAlign === "right" ? "right" : "left") === "left" ? "Left" : "Right"), d = (0, q.getMeasurement)(h[c], "0px");
            h[c] = `${d - y}px`;
          }
          function g(h, y) {
            switch (h.access) {
              case "nonInteractive":
                y.push("xfaNonInteractive");
                break;
              case "readOnly":
                y.push("xfaReadOnly");
                break;
              case "protected":
                y.push("xfaDisabled");
                break;
            }
          }
          function v(h) {
            return h.relevant.length > 0 && !h.relevant[0].excluded && h.relevant[0].viewname === "print";
          }
          function r(h) {
            const y = h[n.$getTemplateRoot]()[n.$extra].paraStack;
            return y.length ? y.at(-1) : null;
          }
          function x(h, y, P) {
            var c;
            if ((c = P.attributes.class) != null && c.includes("xfaRich")) {
              y && (h.h === "" && (y.height = "auto"), h.w === "" && (y.width = "auto"));
              const d = r(h);
              if (d) {
                const A = P.attributes.style;
                switch (A.display = "flex", A.flexDirection = "column", d.vAlign) {
                  case "top":
                    A.justifyContent = "start";
                    break;
                  case "bottom":
                    A.justifyContent = "end";
                    break;
                  case "middle":
                    A.justifyContent = "center";
                    break;
                }
                const N = d[n.$toStyle]();
                for (const [E, H] of Object.entries(N))
                  E in A || (A[E] = H);
              }
            }
          }
          function b(h, y, P, c) {
            if (!P) {
              delete c.fontFamily;
              return;
            }
            const d = (0, q.stripQuotes)(h.typeface);
            c.fontFamily = `"${d}"`;
            const A = P.find(d);
            if (A) {
              const {
                fontFamily: N
              } = A.regular.cssFontInfo;
              N !== d && (c.fontFamily = `"${N}"`);
              const E = r(y);
              if (E && E.lineHeight !== "" || c.lineHeight)
                return;
              const H = (0, e.selectFont)(h, A);
              H && (c.lineHeight = Math.max(1.2, H.lineHeight));
            }
          }
          function I(h) {
            const y = (0, u.createValidAbsoluteUrl)(h, null, {
              addDefaultProtocol: !0,
              tryConvertEncoding: !0
            });
            return y ? y.href : null;
          }
        },
        /* 86 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.FontFinder = void 0, F.getMetrics = B, F.selectFont = t;
          var n = ae(78), u = ae(79), q = ae(2);
          class e {
            constructor(M) {
              this.fonts = /* @__PURE__ */ new Map(), this.cache = /* @__PURE__ */ new Map(), this.warned = /* @__PURE__ */ new Set(), this.defaultFont = null, this.add(M);
            }
            add(M, O = null) {
              for (const C of M)
                this.addPdfFont(C);
              for (const C of this.fonts.values())
                C.regular || (C.regular = C.italic || C.bold || C.bolditalic);
              if (!O || O.size === 0)
                return;
              const w = this.fonts.get("PdfJS-Fallback-PdfJS-XFA");
              for (const C of O)
                this.fonts.set(C, w);
            }
            addPdfFont(M) {
              var k, s, l;
              const O = M.cssFontInfo, w = O.fontFamily;
              let C = this.fonts.get(w);
              C || (C = /* @__PURE__ */ Object.create(null), this.fonts.set(w, C), this.defaultFont || (this.defaultFont = C));
              let i = "";
              const o = parseFloat(O.fontWeight);
              parseFloat(O.italicAngle) !== 0 ? i = o >= 700 ? "bolditalic" : "italic" : o >= 700 && (i = "bold"), i || ((M.name.includes("Bold") || (k = M.psName) != null && k.includes("Bold")) && (i = "bold"), (M.name.includes("Italic") || M.name.endsWith("It") || (s = M.psName) != null && s.includes("Italic") || (l = M.psName) != null && l.endsWith("It")) && (i += "italic")), i || (i = "regular"), C[i] = M;
            }
            getDefault() {
              return this.defaultFont;
            }
            find(M, O = !0) {
              var k, s;
              let w = this.fonts.get(M) || this.cache.get(M);
              if (w)
                return w;
              const C = /,|-|_| |bolditalic|bold|italic|regular|it/gi;
              let i = M.replaceAll(C, "");
              if (w = this.fonts.get(i), w)
                return this.cache.set(M, w), w;
              i = i.toLowerCase();
              const o = [];
              for (const [l, g] of this.fonts.entries())
                l.replaceAll(C, "").toLowerCase().startsWith(i) && o.push(g);
              if (o.length === 0)
                for (const [, l] of this.fonts.entries())
                  (k = l.regular.name) != null && k.replaceAll(C, "").toLowerCase().startsWith(i) && o.push(l);
              if (o.length === 0) {
                i = i.replaceAll(/psmt|mt/gi, "");
                for (const [l, g] of this.fonts.entries())
                  l.replaceAll(C, "").toLowerCase().startsWith(i) && o.push(g);
              }
              if (o.length === 0)
                for (const l of this.fonts.values())
                  (s = l.regular.name) != null && s.replaceAll(C, "").toLowerCase().startsWith(i) && o.push(l);
              return o.length >= 1 ? (o.length !== 1 && O && (0, q.warn)(`XFA - Too many choices to guess the correct font: ${M}`), this.cache.set(M, o[0]), o[0]) : (O && !this.warned.has(M) && (this.warned.add(M), (0, q.warn)(`XFA - Cannot find the font: ${M}`)), null);
            }
          }
          F.FontFinder = e;
          function t(j, M) {
            return j.posture === "italic" ? j.weight === "bold" ? M.bolditalic : M.italic : j.weight === "bold" ? M.bold : M.regular;
          }
          function B(j, M = !1) {
            let O = null;
            if (j) {
              const o = (0, u.stripQuotes)(j.typeface), k = j[n.$globalData].fontFinder.find(o);
              O = t(j, k);
            }
            if (!O)
              return {
                lineHeight: 12,
                lineGap: 2,
                lineNoGap: 10
              };
            const w = j.size || 10, C = O.lineHeight ? Math.max(M ? 0 : 1.2, O.lineHeight) : 1.2, i = O.lineGap === void 0 ? 0.2 : O.lineGap;
            return {
              lineHeight: C * w,
              lineGap: i * w,
              lineNoGap: Math.max(1, C - i) * w
            };
          }
        },
        /* 87 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.TextMeasure = void 0;
          var n = ae(86);
          const u = 1.02;
          class q {
            constructor(j, M, O, w) {
              if (this.lineHeight = O, this.paraMargin = M || {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
              }, !j) {
                [this.pdfFont, this.xfaFont] = this.defaultFont(w);
                return;
              }
              this.xfaFont = {
                typeface: j.typeface,
                posture: j.posture,
                weight: j.weight,
                size: j.size,
                letterSpacing: j.letterSpacing
              };
              const C = w.find(j.typeface);
              if (!C) {
                [this.pdfFont, this.xfaFont] = this.defaultFont(w);
                return;
              }
              this.pdfFont = (0, n.selectFont)(j, C), this.pdfFont || ([this.pdfFont, this.xfaFont] = this.defaultFont(w));
            }
            defaultFont(j) {
              const M = j.find("Helvetica", !1) || j.find("Myriad Pro", !1) || j.find("Arial", !1) || j.getDefault();
              if (M != null && M.regular) {
                const w = M.regular, i = {
                  typeface: w.cssFontInfo.fontFamily,
                  posture: "normal",
                  weight: "normal",
                  size: 10,
                  letterSpacing: 0
                };
                return [w, i];
              }
              return [null, {
                typeface: "Courier",
                posture: "normal",
                weight: "normal",
                size: 10,
                letterSpacing: 0
              }];
            }
          }
          class e {
            constructor(j, M, O, w) {
              this.fontFinder = w, this.stack = [new q(j, M, O, w)];
            }
            pushData(j, M, O) {
              const w = this.stack.at(-1);
              for (const i of ["typeface", "posture", "weight", "size", "letterSpacing"])
                j[i] || (j[i] = w.xfaFont[i]);
              for (const i of ["top", "bottom", "left", "right"])
                isNaN(M[i]) && (M[i] = w.paraMargin[i]);
              const C = new q(j, M, O || w.lineHeight, this.fontFinder);
              C.pdfFont || (C.pdfFont = w.pdfFont), this.stack.push(C);
            }
            popFont() {
              this.stack.pop();
            }
            topFont() {
              return this.stack.at(-1);
            }
          }
          class t {
            constructor(j, M, O, w) {
              this.glyphs = [], this.fontSelector = new e(j, M, O, w), this.extraHeight = 0;
            }
            pushData(j, M, O) {
              this.fontSelector.pushData(j, M, O);
            }
            popFont(j) {
              return this.fontSelector.popFont();
            }
            addPara() {
              const j = this.fontSelector.topFont();
              this.extraHeight += j.paraMargin.top + j.paraMargin.bottom;
            }
            addString(j) {
              if (!j)
                return;
              const M = this.fontSelector.topFont(), O = M.xfaFont.size;
              if (M.pdfFont) {
                const w = M.xfaFont.letterSpacing, C = M.pdfFont, i = C.lineHeight || 1.2, o = M.lineHeight || Math.max(1.2, i) * O, k = C.lineGap === void 0 ? 0.2 : C.lineGap, s = i - k, l = Math.max(1, s) * O, g = O / 1e3, v = C.defaultWidth || C.charsToGlyphs(" ")[0].width;
                for (const r of j.split(/[\u2029\n]/)) {
                  const x = C.encodeString(r).join(""), b = C.charsToGlyphs(x);
                  for (const I of b) {
                    const h = I.width || v;
                    this.glyphs.push([h * g + w, o, l, I.unicode, !1]);
                  }
                  this.glyphs.push([0, 0, 0, `
`, !0]);
                }
                this.glyphs.pop();
                return;
              }
              for (const w of j.split(/[\u2029\n]/)) {
                for (const C of w.split(""))
                  this.glyphs.push([O, 1.2 * O, O, C, !1]);
                this.glyphs.push([0, 0, 0, `
`, !0]);
              }
              this.glyphs.pop();
            }
            compute(j) {
              let M = -1, O = 0, w = 0, C = 0, i = 0, o = 0, k = !1, s = !0;
              for (let l = 0, g = this.glyphs.length; l < g; l++) {
                const [v, r, x, b, I] = this.glyphs[l], h = b === " ", y = s ? x : r;
                if (I) {
                  w = Math.max(w, i), i = 0, C += o, o = y, M = -1, O = 0, s = !1;
                  continue;
                }
                if (h) {
                  i + v > j ? (w = Math.max(w, i), i = 0, C += o, o = y, M = -1, O = 0, k = !0, s = !1) : (o = Math.max(y, o), O = i, i += v, M = l);
                  continue;
                }
                if (i + v > j) {
                  C += o, o = y, M !== -1 ? (l = M, w = Math.max(w, O), i = 0, M = -1, O = 0) : (w = Math.max(w, i), i = v), k = !0, s = !1;
                  continue;
                }
                i += v, o = Math.max(y, o);
              }
              return w = Math.max(w, i), C += o + this.extraHeight, {
                width: u * w,
                height: C,
                isBroken: k
              };
            }
          }
          F.TextMeasure = t;
        },
        /* 88 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.DataHandler = void 0;
          var n = ae(78);
          class u {
            constructor(e, t) {
              this.data = t, this.dataset = e.datasets || null;
            }
            serialize(e) {
              const t = [[-1, this.data[n.$getChildren]()]];
              for (; t.length > 0; ) {
                const j = t.at(-1), [M, O] = j;
                if (M + 1 === O.length) {
                  t.pop();
                  continue;
                }
                const w = O[++j[0]], C = e.get(w[n.$uid]);
                if (C)
                  w[n.$setValue](C);
                else {
                  const o = w[n.$getAttributes]();
                  for (const k of o.values()) {
                    const s = e.get(k[n.$uid]);
                    if (s) {
                      k[n.$setValue](s);
                      break;
                    }
                  }
                }
                const i = w[n.$getChildren]();
                i.length > 0 && t.push([-1, i]);
              }
              const B = ['<xfa:datasets xmlns:xfa="http://www.xfa.org/schema/xfa-data/1.0/">'];
              if (this.dataset)
                for (const j of this.dataset[n.$getChildren]())
                  j[n.$nodeName] !== "data" && j[n.$toString](B);
              return this.data[n.$toString](B), B.push("</xfa:datasets>"), B.join("");
            }
          }
          F.DataHandler = u;
        },
        /* 89 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XFAParser = void 0;
          var n = ae(78), u = ae(67), q = ae(90), e = ae(2);
          class t extends u.XMLParserBase {
            constructor(j = null, M = !1) {
              super(), this._builder = new q.Builder(j), this._stack = [], this._globalData = {
                usedTypefaces: /* @__PURE__ */ new Set()
              }, this._ids = /* @__PURE__ */ new Map(), this._current = this._builder.buildRoot(this._ids), this._errorCode = u.XMLParserErrorCode.NoError, this._whiteRegex = /^\s+$/, this._nbsps = /\xa0+/g, this._richText = M;
            }
            parse(j) {
              if (this.parseXml(j), this._errorCode === u.XMLParserErrorCode.NoError)
                return this._current[n.$finalize](), this._current.element;
            }
            onText(j) {
              if (j = j.replace(this._nbsps, (M) => M.slice(1) + " "), this._richText || this._current[n.$acceptWhitespace]()) {
                this._current[n.$onText](j, this._richText);
                return;
              }
              this._whiteRegex.test(j) || this._current[n.$onText](j.trim());
            }
            onCdata(j) {
              this._current[n.$onText](j);
            }
            _mkAttributes(j, M) {
              let O = null, w = null;
              const C = /* @__PURE__ */ Object.create({});
              for (const {
                name: i,
                value: o
              } of j)
                if (i === "xmlns")
                  O ? (0, e.warn)(`XFA - multiple namespace definition in <${M}>`) : O = o;
                else if (i.startsWith("xmlns:")) {
                  const k = i.substring(6);
                  w || (w = []), w.push({
                    prefix: k,
                    value: o
                  });
                } else {
                  const k = i.indexOf(":");
                  if (k === -1)
                    C[i] = o;
                  else {
                    let s = C[n.$nsAttributes];
                    s || (s = C[n.$nsAttributes] = /* @__PURE__ */ Object.create(null));
                    const [l, g] = [i.slice(0, k), i.slice(k + 1)], v = s[l] || (s[l] = /* @__PURE__ */ Object.create(null));
                    v[g] = o;
                  }
                }
              return [O, w, C];
            }
            _getNameAndPrefix(j, M) {
              const O = j.indexOf(":");
              return O === -1 ? [j, null] : [j.substring(O + 1), M ? "" : j.substring(0, O)];
            }
            onBeginElement(j, M, O) {
              const [w, C, i] = this._mkAttributes(M, j), [o, k] = this._getNameAndPrefix(j, this._builder.isNsAgnostic()), s = this._builder.build({
                nsPrefix: k,
                name: o,
                attributes: i,
                namespace: w,
                prefixes: C
              });
              if (s[n.$globalData] = this._globalData, O) {
                s[n.$finalize](), this._current[n.$onChild](s) && s[n.$setId](this._ids), s[n.$clean](this._builder);
                return;
              }
              this._stack.push(this._current), this._current = s;
            }
            onEndElement(j) {
              const M = this._current;
              if (M[n.$isCDATAXml]() && typeof M[n.$content] == "string") {
                const O = new t();
                O._globalData = this._globalData;
                const w = O.parse(M[n.$content]);
                M[n.$content] = null, M[n.$onChild](w);
              }
              M[n.$finalize](), this._current = this._stack.pop(), this._current[n.$onChild](M) && M[n.$setId](this._ids), M[n.$clean](this._builder);
            }
            onError(j) {
              this._errorCode = j;
            }
          }
          F.XFAParser = t;
        },
        /* 90 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.Builder = void 0;
          var n = ae(80), u = ae(78), q = ae(91), e = ae(83), t = ae(100), B = ae(2);
          class j extends u.XFAObject {
            constructor(C) {
              super(-1, "root", /* @__PURE__ */ Object.create(null)), this.element = null, this[u.$ids] = C;
            }
            [u.$onChild](C) {
              return this.element = C, !0;
            }
            [u.$finalize]() {
              super[u.$finalize](), this.element.template instanceof e.Template && (this[u.$ids].set(u.$root, this.element), this.element.template[u.$resolvePrototypes](this[u.$ids]), this.element.template[u.$ids] = this[u.$ids]);
            }
          }
          class M extends u.XFAObject {
            constructor() {
              super(-1, "", /* @__PURE__ */ Object.create(null));
            }
            [u.$onChild](C) {
              return !1;
            }
          }
          class O {
            constructor(C = null) {
              this._namespaceStack = [], this._nsAgnosticLevel = 0, this._namespacePrefixes = /* @__PURE__ */ new Map(), this._namespaces = /* @__PURE__ */ new Map(), this._nextNsId = Math.max(...Object.values(n.NamespaceIds).map(({
                id: i
              }) => i)), this._currentNamespace = C || new t.UnknownNamespace(++this._nextNsId);
            }
            buildRoot(C) {
              return new j(C);
            }
            build({
              nsPrefix: C,
              name: i,
              attributes: o,
              namespace: k,
              prefixes: s
            }) {
              const l = k !== null;
              if (l && (this._namespaceStack.push(this._currentNamespace), this._currentNamespace = this._searchNamespace(k)), s && this._addNamespacePrefix(s), o.hasOwnProperty(u.$nsAttributes)) {
                const r = q.NamespaceSetUp.datasets, x = o[u.$nsAttributes];
                let b = null;
                for (const [I, h] of Object.entries(x))
                  if (this._getNamespaceToUse(I) === r) {
                    b = {
                      xfa: h
                    };
                    break;
                  }
                b ? o[u.$nsAttributes] = b : delete o[u.$nsAttributes];
              }
              const g = this._getNamespaceToUse(C), v = (g == null ? void 0 : g[n.$buildXFAObject](i, o)) || new M();
              return v[u.$isNsAgnostic]() && this._nsAgnosticLevel++, (l || s || v[u.$isNsAgnostic]()) && (v[u.$cleanup] = {
                hasNamespace: l,
                prefixes: s,
                nsAgnostic: v[u.$isNsAgnostic]()
              }), v;
            }
            isNsAgnostic() {
              return this._nsAgnosticLevel > 0;
            }
            _searchNamespace(C) {
              let i = this._namespaces.get(C);
              if (i)
                return i;
              for (const [o, {
                check: k
              }] of Object.entries(n.NamespaceIds))
                if (k(C)) {
                  if (i = q.NamespaceSetUp[o], i)
                    return this._namespaces.set(C, i), i;
                  break;
                }
              return i = new t.UnknownNamespace(++this._nextNsId), this._namespaces.set(C, i), i;
            }
            _addNamespacePrefix(C) {
              for (const {
                prefix: i,
                value: o
              } of C) {
                const k = this._searchNamespace(o);
                let s = this._namespacePrefixes.get(i);
                s || (s = [], this._namespacePrefixes.set(i, s)), s.push(k);
              }
            }
            _getNamespaceToUse(C) {
              if (!C)
                return this._currentNamespace;
              const i = this._namespacePrefixes.get(C);
              return (i == null ? void 0 : i.length) > 0 ? i.at(-1) : ((0, B.warn)(`Unknown namespace prefix: ${C}.`), null);
            }
            clean(C) {
              const {
                hasNamespace: i,
                prefixes: o,
                nsAgnostic: k
              } = C;
              i && (this._currentNamespace = this._namespaceStack.pop()), o && o.forEach(({
                prefix: s
              }) => {
                this._namespacePrefixes.get(s).pop();
              }), k && this._nsAgnosticLevel--;
            }
          }
          F.Builder = O;
        },
        /* 91 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.NamespaceSetUp = void 0;
          var n = ae(92), u = ae(93), q = ae(94), e = ae(95), t = ae(96), B = ae(97), j = ae(83), M = ae(98), O = ae(99);
          const w = {
            config: n.ConfigNamespace,
            connection: u.ConnectionSetNamespace,
            datasets: q.DatasetsNamespace,
            localeSet: e.LocaleSetNamespace,
            signature: t.SignatureNamespace,
            stylesheet: B.StylesheetNamespace,
            template: j.TemplateNamespace,
            xdp: M.XdpNamespace,
            xhtml: O.XhtmlNamespace
          };
          F.NamespaceSetUp = w;
        },
        /* 92 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ConfigNamespace = void 0;
          var n = ae(80), u = ae(78), q = ae(79), e = ae(2);
          const t = n.NamespaceIds.config.id;
          class B extends u.XFAObject {
            constructor(Z) {
              super(t, "acrobat", !0), this.acrobat7 = null, this.autoSave = null, this.common = null, this.validate = null, this.validateApprovalSignatures = null, this.submitUrl = new u.XFAObjectArray();
            }
          }
          class j extends u.XFAObject {
            constructor(Z) {
              super(t, "acrobat7", !0), this.dynamicRender = null;
            }
          }
          class M extends u.OptionObject {
            constructor(Z) {
              super(t, "ADBE_JSConsole", ["delegate", "Enable", "Disable"]);
            }
          }
          class O extends u.OptionObject {
            constructor(Z) {
              super(t, "ADBE_JSDebugger", ["delegate", "Enable", "Disable"]);
            }
          }
          class w extends u.Option01 {
            constructor(Z) {
              super(t, "addSilentPrint");
            }
          }
          class C extends u.Option01 {
            constructor(Z) {
              super(t, "addViewerPreferences");
            }
          }
          class i extends u.Option10 {
            constructor(Z) {
              super(t, "adjustData");
            }
          }
          class o extends u.IntegerObject {
            constructor(Z) {
              super(t, "adobeExtensionLevel", 0, (De) => De >= 1 && De <= 8);
            }
          }
          class k extends u.XFAObject {
            constructor(Z) {
              super(t, "agent", !0), this.name = Z.name ? Z.name.trim() : "", this.common = new u.XFAObjectArray();
            }
          }
          class s extends u.ContentObject {
            constructor(Z) {
              super(t, "alwaysEmbed");
            }
          }
          class l extends u.StringObject {
            constructor(Z) {
              super(t, "amd");
            }
          }
          class g extends u.XFAObject {
            constructor(Z) {
              super(t, "area"), this.level = (0, q.getInteger)({
                data: Z.level,
                defaultValue: 0,
                validate: (De) => De >= 1 && De <= 3
              }), this.name = (0, q.getStringOption)(Z.name, ["", "barcode", "coreinit", "deviceDriver", "font", "general", "layout", "merge", "script", "signature", "sourceSet", "templateCache"]);
            }
          }
          class v extends u.OptionObject {
            constructor(Z) {
              super(t, "attributes", ["preserve", "delegate", "ignore"]);
            }
          }
          class r extends u.OptionObject {
            constructor(Z) {
              super(t, "autoSave", ["disabled", "enabled"]);
            }
          }
          class x extends u.StringObject {
            constructor(Z) {
              super(t, "base");
            }
          }
          class b extends u.XFAObject {
            constructor(Z) {
              super(t, "batchOutput"), this.format = (0, q.getStringOption)(Z.format, ["none", "concat", "zip", "zipCompress"]);
            }
          }
          class I extends u.ContentObject {
            constructor(Z) {
              super(t, "behaviorOverride");
            }
            [u.$finalize]() {
              this[u.$content] = new Map(this[u.$content].trim().split(/\s+/).filter((Z) => Z.includes(":")).map((Z) => Z.split(":", 2)));
            }
          }
          class h extends u.XFAObject {
            constructor(Z) {
              super(t, "cache", !0), this.templateCache = null;
            }
          }
          class y extends u.Option01 {
            constructor(Z) {
              super(t, "change");
            }
          }
          class P extends u.XFAObject {
            constructor(Z) {
              super(t, "common", !0), this.data = null, this.locale = null, this.localeSet = null, this.messaging = null, this.suppressBanner = null, this.template = null, this.validationMessaging = null, this.versionControl = null, this.log = new u.XFAObjectArray();
            }
          }
          class c extends u.XFAObject {
            constructor(Z) {
              super(t, "compress"), this.scope = (0, q.getStringOption)(Z.scope, ["imageOnly", "document"]);
            }
          }
          class d extends u.Option01 {
            constructor(Z) {
              super(t, "compressLogicalStructure");
            }
          }
          class A extends u.Option10 {
            constructor(Z) {
              super(t, "compressObjectStream");
            }
          }
          class N extends u.XFAObject {
            constructor(Z) {
              super(t, "compression", !0), this.compressLogicalStructure = null, this.compressObjectStream = null, this.level = null, this.type = null;
            }
          }
          class E extends u.XFAObject {
            constructor(Z) {
              super(t, "config", !0), this.acrobat = null, this.present = null, this.trace = null, this.agent = new u.XFAObjectArray();
            }
          }
          class H extends u.OptionObject {
            constructor(Z) {
              super(t, "conformance", ["A", "B"]);
            }
          }
          class $ extends u.Option01 {
            constructor(Z) {
              super(t, "contentCopy");
            }
          }
          class m extends u.IntegerObject {
            constructor(Z) {
              super(t, "copies", 1, (De) => De >= 1);
            }
          }
          class p extends u.StringObject {
            constructor(Z) {
              super(t, "creator");
            }
          }
          class T extends u.IntegerObject {
            constructor(Z) {
              super(t, "currentPage", 0, (De) => De >= 0);
            }
          }
          class L extends u.XFAObject {
            constructor(Z) {
              super(t, "data", !0), this.adjustData = null, this.attributes = null, this.incrementalLoad = null, this.outputXSL = null, this.range = null, this.record = null, this.startNode = null, this.uri = null, this.window = null, this.xsl = null, this.excludeNS = new u.XFAObjectArray(), this.transform = new u.XFAObjectArray();
            }
          }
          class _ extends u.XFAObject {
            constructor(Z) {
              super(t, "debug", !0), this.uri = null;
            }
          }
          class G extends u.ContentObject {
            constructor(Z) {
              super(t, "defaultTypeface"), this.writingScript = (0, q.getStringOption)(Z.writingScript, ["*", "Arabic", "Cyrillic", "EastEuropeanRoman", "Greek", "Hebrew", "Japanese", "Korean", "Roman", "SimplifiedChinese", "Thai", "TraditionalChinese", "Vietnamese"]);
            }
          }
          class J extends u.OptionObject {
            constructor(Z) {
              super(t, "destination", ["pdf", "pcl", "ps", "webClient", "zpl"]);
            }
          }
          class K extends u.Option01 {
            constructor(Z) {
              super(t, "documentAssembly");
            }
          }
          class V extends u.XFAObject {
            constructor(Z) {
              super(t, "driver", !0), this.name = Z.name ? Z.name.trim() : "", this.fontInfo = null, this.xdc = null;
            }
          }
          class U extends u.OptionObject {
            constructor(Z) {
              super(t, "duplexOption", ["simplex", "duplexFlipLongEdge", "duplexFlipShortEdge"]);
            }
          }
          class Q extends u.OptionObject {
            constructor(Z) {
              super(t, "dynamicRender", ["forbidden", "required"]);
            }
          }
          class X extends u.Option01 {
            constructor(Z) {
              super(t, "embed");
            }
          }
          class R extends u.Option01 {
            constructor(Z) {
              super(t, "encrypt");
            }
          }
          class f extends u.XFAObject {
            constructor(Z) {
              super(t, "encryption", !0), this.encrypt = null, this.encryptionLevel = null, this.permissions = null;
            }
          }
          class D extends u.OptionObject {
            constructor(Z) {
              super(t, "encryptionLevel", ["40bit", "128bit"]);
            }
          }
          class z extends u.StringObject {
            constructor(Z) {
              super(t, "enforce");
            }
          }
          class Y extends u.XFAObject {
            constructor(Z) {
              super(t, "equate"), this.force = (0, q.getInteger)({
                data: Z.force,
                defaultValue: 1,
                validate: (De) => De === 0
              }), this.from = Z.from || "", this.to = Z.to || "";
            }
          }
          class W extends u.XFAObject {
            constructor(Z) {
              super(t, "equateRange"), this.from = Z.from || "", this.to = Z.to || "", this._unicodeRange = Z.unicodeRange || "";
            }
            get unicodeRange() {
              const Z = [], De = /U\+([0-9a-fA-F]+)/, He = this._unicodeRange;
              for (let Ye of He.split(",").map((ut) => ut.trim()).filter((ut) => !!ut))
                Ye = Ye.split("-", 2).map((ut) => {
                  const xt = ut.match(De);
                  return xt ? parseInt(xt[1], 16) : 0;
                }), Ye.length === 1 && Ye.push(Ye[0]), Z.push(Ye);
              return (0, e.shadow)(this, "unicodeRange", Z);
            }
          }
          class ie extends u.ContentObject {
            constructor(Z) {
              super(t, "exclude");
            }
            [u.$finalize]() {
              this[u.$content] = this[u.$content].trim().split(/\s+/).filter((Z) => Z && ["calculate", "close", "enter", "exit", "initialize", "ready", "validate"].includes(Z));
            }
          }
          class ne extends u.StringObject {
            constructor(Z) {
              super(t, "excludeNS");
            }
          }
          class re extends u.OptionObject {
            constructor(Z) {
              super(t, "flipLabel", ["usePrinterSetting", "on", "off"]);
            }
          }
          class ee extends u.XFAObject {
            constructor(Z) {
              super(t, "fontInfo", !0), this.embed = null, this.map = null, this.subsetBelow = null, this.alwaysEmbed = new u.XFAObjectArray(), this.defaultTypeface = new u.XFAObjectArray(), this.neverEmbed = new u.XFAObjectArray();
            }
          }
          class te extends u.Option01 {
            constructor(Z) {
              super(t, "formFieldFilling");
            }
          }
          class oe extends u.StringObject {
            constructor(Z) {
              super(t, "groupParent");
            }
          }
          class se extends u.OptionObject {
            constructor(Z) {
              super(t, "ifEmpty", ["dataValue", "dataGroup", "ignore", "remove"]);
            }
          }
          class ce extends u.StringObject {
            constructor(Z) {
              super(t, "includeXDPContent");
            }
          }
          class le extends u.OptionObject {
            constructor(Z) {
              super(t, "incrementalLoad", ["none", "forwardOnly"]);
            }
          }
          class de extends u.Option01 {
            constructor(Z) {
              super(t, "incrementalMerge");
            }
          }
          class Ie extends u.Option01 {
            constructor(Z) {
              super(t, "interactive");
            }
          }
          class Fe extends u.OptionObject {
            constructor(Z) {
              super(t, "jog", ["usePrinterSetting", "none", "pageSet"]);
            }
          }
          class we extends u.XFAObject {
            constructor(Z) {
              super(t, "labelPrinter", !0), this.name = (0, q.getStringOption)(Z.name, ["zpl", "dpl", "ipl", "tcpl"]), this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
            }
          }
          class pe extends u.OptionObject {
            constructor(Z) {
              super(t, "layout", ["paginate", "panel"]);
            }
          }
          class fe extends u.IntegerObject {
            constructor(Z) {
              super(t, "level", 0, (De) => De > 0);
            }
          }
          class Ae extends u.Option01 {
            constructor(Z) {
              super(t, "linearized");
            }
          }
          class Pe extends u.StringObject {
            constructor(Z) {
              super(t, "locale");
            }
          }
          class Re extends u.StringObject {
            constructor(Z) {
              super(t, "localeSet");
            }
          }
          class Ee extends u.XFAObject {
            constructor(Z) {
              super(t, "log", !0), this.mode = null, this.threshold = null, this.to = null, this.uri = null;
            }
          }
          class ye extends u.XFAObject {
            constructor(Z) {
              super(t, "map", !0), this.equate = new u.XFAObjectArray(), this.equateRange = new u.XFAObjectArray();
            }
          }
          class Te extends u.XFAObject {
            constructor(Z) {
              super(t, "mediumInfo", !0), this.map = null;
            }
          }
          class je extends u.XFAObject {
            constructor(Z) {
              super(t, "message", !0), this.msgId = null, this.severity = null;
            }
          }
          class ve extends u.XFAObject {
            constructor(Z) {
              super(t, "messaging", !0), this.message = new u.XFAObjectArray();
            }
          }
          class Ce extends u.OptionObject {
            constructor(Z) {
              super(t, "mode", ["append", "overwrite"]);
            }
          }
          class Ne extends u.Option01 {
            constructor(Z) {
              super(t, "modifyAnnots");
            }
          }
          class Ge extends u.IntegerObject {
            constructor(Z) {
              super(t, "msgId", 1, (De) => De >= 1);
            }
          }
          class Oe extends u.StringObject {
            constructor(Z) {
              super(t, "nameAttr");
            }
          }
          class tt extends u.ContentObject {
            constructor(Z) {
              super(t, "neverEmbed");
            }
          }
          class Ke extends u.IntegerObject {
            constructor(Z) {
              super(t, "numberOfCopies", null, (De) => De >= 2 && De <= 5);
            }
          }
          class et extends u.XFAObject {
            constructor(Z) {
              super(t, "openAction", !0), this.destination = null;
            }
          }
          class Xe extends u.XFAObject {
            constructor(Z) {
              super(t, "output", !0), this.to = null, this.type = null, this.uri = null;
            }
          }
          class Qe extends u.StringObject {
            constructor(Z) {
              super(t, "outputBin");
            }
          }
          class it extends u.XFAObject {
            constructor(Z) {
              super(t, "outputXSL", !0), this.uri = null;
            }
          }
          class We extends u.OptionObject {
            constructor(Z) {
              super(t, "overprint", ["none", "both", "draw", "field"]);
            }
          }
          class gt extends u.StringObject {
            constructor(Z) {
              super(t, "packets");
            }
            [u.$finalize]() {
              this[u.$content] !== "*" && (this[u.$content] = this[u.$content].trim().split(/\s+/).filter((Z) => ["config", "datasets", "template", "xfdf", "xslt"].includes(Z)));
            }
          }
          class mt extends u.XFAObject {
            constructor(Z) {
              super(t, "pageOffset"), this.x = (0, q.getInteger)({
                data: Z.x,
                defaultValue: "useXDCSetting",
                validate: (De) => !0
              }), this.y = (0, q.getInteger)({
                data: Z.y,
                defaultValue: "useXDCSetting",
                validate: (De) => !0
              });
            }
          }
          class Ct extends u.StringObject {
            constructor(Z) {
              super(t, "pageRange");
            }
            [u.$finalize]() {
              const Z = this[u.$content].trim().split(/\s+/).map((He) => parseInt(He, 10)), De = [];
              for (let He = 0, Ye = Z.length; He < Ye; He += 2)
                De.push(Z.slice(He, He + 2));
              this[u.$content] = De;
            }
          }
          class Pt extends u.OptionObject {
            constructor(Z) {
              super(t, "pagination", ["simplex", "duplexShortEdge", "duplexLongEdge"]);
            }
          }
          class at extends u.OptionObject {
            constructor(Z) {
              super(t, "paginationOverride", ["none", "forceDuplex", "forceDuplexLongEdge", "forceDuplexShortEdge", "forceSimplex"]);
            }
          }
          class dt extends u.IntegerObject {
            constructor(Z) {
              super(t, "part", 1, (De) => !1);
            }
          }
          class ot extends u.XFAObject {
            constructor(Z) {
              super(t, "pcl", !0), this.name = Z.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.pageOffset = null, this.staple = null, this.xdc = null;
            }
          }
          class Mt extends u.XFAObject {
            constructor(Z) {
              super(t, "pdf", !0), this.name = Z.name || "", this.adobeExtensionLevel = null, this.batchOutput = null, this.compression = null, this.creator = null, this.encryption = null, this.fontInfo = null, this.interactive = null, this.linearized = null, this.openAction = null, this.pdfa = null, this.producer = null, this.renderPolicy = null, this.scriptModel = null, this.silentPrint = null, this.submitFormat = null, this.tagged = null, this.version = null, this.viewerPreferences = null, this.xdc = null;
            }
          }
          class Rt extends u.XFAObject {
            constructor(Z) {
              super(t, "pdfa", !0), this.amd = null, this.conformance = null, this.includeXDPContent = null, this.part = null;
            }
          }
          class Et extends u.XFAObject {
            constructor(Z) {
              super(t, "permissions", !0), this.accessibleContent = null, this.change = null, this.contentCopy = null, this.documentAssembly = null, this.formFieldFilling = null, this.modifyAnnots = null, this.plaintextMetadata = null, this.print = null, this.printHighQuality = null;
            }
          }
          class At extends u.Option01 {
            constructor(Z) {
              super(t, "pickTrayByPDFSize");
            }
          }
          class Nt extends u.StringObject {
            constructor(Z) {
              super(t, "picture");
            }
          }
          class qe extends u.Option01 {
            constructor(Z) {
              super(t, "plaintextMetadata");
            }
          }
          class Ue extends u.OptionObject {
            constructor(Z) {
              super(t, "presence", ["preserve", "dissolve", "dissolveStructure", "ignore", "remove"]);
            }
          }
          class Je extends u.XFAObject {
            constructor(Z) {
              super(t, "present", !0), this.behaviorOverride = null, this.cache = null, this.common = null, this.copies = null, this.destination = null, this.incrementalMerge = null, this.layout = null, this.output = null, this.overprint = null, this.pagination = null, this.paginationOverride = null, this.script = null, this.validate = null, this.xdp = null, this.driver = new u.XFAObjectArray(), this.labelPrinter = new u.XFAObjectArray(), this.pcl = new u.XFAObjectArray(), this.pdf = new u.XFAObjectArray(), this.ps = new u.XFAObjectArray(), this.submitUrl = new u.XFAObjectArray(), this.webClient = new u.XFAObjectArray(), this.zpl = new u.XFAObjectArray();
            }
          }
          class Ve extends u.Option01 {
            constructor(Z) {
              super(t, "print");
            }
          }
          class st extends u.Option01 {
            constructor(Z) {
              super(t, "printHighQuality");
            }
          }
          class ft extends u.OptionObject {
            constructor(Z) {
              super(t, "printScaling", ["appdefault", "noScaling"]);
            }
          }
          class ct extends u.StringObject {
            constructor(Z) {
              super(t, "printerName");
            }
          }
          class be extends u.StringObject {
            constructor(Z) {
              super(t, "producer");
            }
          }
          class _e extends u.XFAObject {
            constructor(Z) {
              super(t, "ps", !0), this.name = Z.name || "", this.batchOutput = null, this.fontInfo = null, this.jog = null, this.mediumInfo = null, this.outputBin = null, this.staple = null, this.xdc = null;
            }
          }
          class $e extends u.ContentObject {
            constructor(Z) {
              super(t, "range");
            }
            [u.$finalize]() {
              this[u.$content] = this[u.$content].trim().split(/\s*,\s*/, 2).map((Z) => Z.split("-").map((De) => parseInt(De.trim(), 10))).filter((Z) => Z.every((De) => !isNaN(De))).map((Z) => (Z.length === 1 && Z.push(Z[0]), Z));
            }
          }
          class Ze extends u.ContentObject {
            constructor(Z) {
              super(t, "record");
            }
            [u.$finalize]() {
              this[u.$content] = this[u.$content].trim();
              const Z = parseInt(this[u.$content], 10);
              !isNaN(Z) && Z >= 0 && (this[u.$content] = Z);
            }
          }
          class nt extends u.ContentObject {
            constructor(Z) {
              super(t, "relevant");
            }
            [u.$finalize]() {
              this[u.$content] = this[u.$content].trim().split(/\s+/);
            }
          }
          class pt extends u.ContentObject {
            constructor(Z) {
              super(t, "rename");
            }
            [u.$finalize]() {
              this[u.$content] = this[u.$content].trim(), (this[u.$content].toLowerCase().startsWith("xml") || new RegExp("[\\p{L}_][\\p{L}\\d._\\p{M}-]*", "u").test(this[u.$content])) && (0, e.warn)("XFA - Rename: invalid XFA name");
            }
          }
          class yt extends u.OptionObject {
            constructor(Z) {
              super(t, "renderPolicy", ["server", "client"]);
            }
          }
          class lt extends u.OptionObject {
            constructor(Z) {
              super(t, "runScripts", ["both", "client", "none", "server"]);
            }
          }
          class St extends u.XFAObject {
            constructor(Z) {
              super(t, "script", !0), this.currentPage = null, this.exclude = null, this.runScripts = null;
            }
          }
          class ht extends u.OptionObject {
            constructor(Z) {
              super(t, "scriptModel", ["XFA", "none"]);
            }
          }
          class Ft extends u.OptionObject {
            constructor(Z) {
              super(t, "severity", ["ignore", "error", "information", "trace", "warning"]);
            }
          }
          class It extends u.XFAObject {
            constructor(Z) {
              super(t, "silentPrint", !0), this.addSilentPrint = null, this.printerName = null;
            }
          }
          class Gt extends u.XFAObject {
            constructor(Z) {
              super(t, "staple"), this.mode = (0, q.getStringOption)(Z.mode, ["usePrinterSetting", "on", "off"]);
            }
          }
          class vt extends u.StringObject {
            constructor(Z) {
              super(t, "startNode");
            }
          }
          class kt extends u.IntegerObject {
            constructor(Z) {
              super(t, "startPage", 0, (De) => !0);
            }
          }
          class Bt extends u.OptionObject {
            constructor(Z) {
              super(t, "submitFormat", ["html", "delegate", "fdf", "xml", "pdf"]);
            }
          }
          class Ut extends u.StringObject {
            constructor(Z) {
              super(t, "submitUrl");
            }
          }
          class Yt extends u.IntegerObject {
            constructor(Z) {
              super(t, "subsetBelow", 100, (De) => De >= 0 && De <= 100);
            }
          }
          class rn extends u.Option01 {
            constructor(Z) {
              super(t, "suppressBanner");
            }
          }
          class Rn extends u.Option01 {
            constructor(Z) {
              super(t, "tagged");
            }
          }
          class Dn extends u.XFAObject {
            constructor(Z) {
              super(t, "template", !0), this.base = null, this.relevant = null, this.startPage = null, this.uri = null, this.xsl = null;
            }
          }
          class _n extends u.OptionObject {
            constructor(Z) {
              super(t, "threshold", ["trace", "error", "information", "warning"]);
            }
          }
          class Ln extends u.OptionObject {
            constructor(Z) {
              super(t, "to", ["null", "memory", "stderr", "stdout", "system", "uri"]);
            }
          }
          class An extends u.XFAObject {
            constructor(Z) {
              super(t, "templateCache"), this.maxEntries = (0, q.getInteger)({
                data: Z.maxEntries,
                defaultValue: 5,
                validate: (De) => De >= 0
              });
            }
          }
          class pn extends u.XFAObject {
            constructor(Z) {
              super(t, "trace", !0), this.area = new u.XFAObjectArray();
            }
          }
          class Nn extends u.XFAObject {
            constructor(Z) {
              super(t, "transform", !0), this.groupParent = null, this.ifEmpty = null, this.nameAttr = null, this.picture = null, this.presence = null, this.rename = null, this.whitespace = null;
            }
          }
          class Bn extends u.OptionObject {
            constructor(Z) {
              super(t, "type", ["none", "ascii85", "asciiHex", "ccittfax", "flate", "lzw", "runLength", "native", "xdp", "mergedXDP"]);
            }
          }
          class jn extends u.StringObject {
            constructor(Z) {
              super(t, "uri");
            }
          }
          class mn extends u.OptionObject {
            constructor(Z) {
              super(t, "validate", ["preSubmit", "prePrint", "preExecute", "preSave"]);
            }
          }
          class Sn extends u.ContentObject {
            constructor(Z) {
              super(t, "validateApprovalSignatures");
            }
            [u.$finalize]() {
              this[u.$content] = this[u.$content].trim().split(/\s+/).filter((Z) => ["docReady", "postSign"].includes(Z));
            }
          }
          class vn extends u.OptionObject {
            constructor(Z) {
              super(t, "validationMessaging", ["allMessagesIndividually", "allMessagesTogether", "firstMessageOnly", "noMessages"]);
            }
          }
          class $n extends u.OptionObject {
            constructor(Z) {
              super(t, "version", ["1.7", "1.6", "1.5", "1.4", "1.3", "1.2"]);
            }
          }
          class Un extends u.XFAObject {
            constructor(Z) {
              super(t, "VersionControl"), this.outputBelow = (0, q.getStringOption)(Z.outputBelow, ["warn", "error", "update"]), this.sourceAbove = (0, q.getStringOption)(Z.sourceAbove, ["warn", "error"]), this.sourceBelow = (0, q.getStringOption)(Z.sourceBelow, ["update", "maintain"]);
            }
          }
          class Hn extends u.XFAObject {
            constructor(Z) {
              super(t, "viewerPreferences", !0), this.ADBE_JSConsole = null, this.ADBE_JSDebugger = null, this.addViewerPreferences = null, this.duplexOption = null, this.enforce = null, this.numberOfCopies = null, this.pageRange = null, this.pickTrayByPDFSize = null, this.printScaling = null;
            }
          }
          class Xn extends u.XFAObject {
            constructor(Z) {
              super(t, "webClient", !0), this.name = Z.name ? Z.name.trim() : "", this.fontInfo = null, this.xdc = null;
            }
          }
          class zn extends u.OptionObject {
            constructor(Z) {
              super(t, "whitespace", ["preserve", "ltrim", "normalize", "rtrim", "trim"]);
            }
          }
          class xn extends u.ContentObject {
            constructor(Z) {
              super(t, "window");
            }
            [u.$finalize]() {
              const Z = this[u.$content].trim().split(/\s*,\s*/, 2).map((De) => parseInt(De, 10));
              if (Z.some((De) => isNaN(De))) {
                this[u.$content] = [0, 0];
                return;
              }
              Z.length === 1 && Z.push(Z[0]), this[u.$content] = Z;
            }
          }
          class Gn extends u.XFAObject {
            constructor(Z) {
              super(t, "xdc", !0), this.uri = new u.XFAObjectArray(), this.xsl = new u.XFAObjectArray();
            }
          }
          class cn extends u.XFAObject {
            constructor(Z) {
              super(t, "xdp", !0), this.packets = null;
            }
          }
          class qn extends u.XFAObject {
            constructor(Z) {
              super(t, "xsl", !0), this.debug = null, this.uri = null;
            }
          }
          class ln extends u.XFAObject {
            constructor(Z) {
              super(t, "zpl", !0), this.name = Z.name ? Z.name.trim() : "", this.batchOutput = null, this.flipLabel = null, this.fontInfo = null, this.xdc = null;
            }
          }
          class Le {
            static [n.$buildXFAObject](Z, De) {
              if (Le.hasOwnProperty(Z))
                return Le[Z](De);
            }
            static acrobat(Z) {
              return new B(Z);
            }
            static acrobat7(Z) {
              return new j(Z);
            }
            static ADBE_JSConsole(Z) {
              return new M(Z);
            }
            static ADBE_JSDebugger(Z) {
              return new O(Z);
            }
            static addSilentPrint(Z) {
              return new w(Z);
            }
            static addViewerPreferences(Z) {
              return new C(Z);
            }
            static adjustData(Z) {
              return new i(Z);
            }
            static adobeExtensionLevel(Z) {
              return new o(Z);
            }
            static agent(Z) {
              return new k(Z);
            }
            static alwaysEmbed(Z) {
              return new s(Z);
            }
            static amd(Z) {
              return new l(Z);
            }
            static area(Z) {
              return new g(Z);
            }
            static attributes(Z) {
              return new v(Z);
            }
            static autoSave(Z) {
              return new r(Z);
            }
            static base(Z) {
              return new x(Z);
            }
            static batchOutput(Z) {
              return new b(Z);
            }
            static behaviorOverride(Z) {
              return new I(Z);
            }
            static cache(Z) {
              return new h(Z);
            }
            static change(Z) {
              return new y(Z);
            }
            static common(Z) {
              return new P(Z);
            }
            static compress(Z) {
              return new c(Z);
            }
            static compressLogicalStructure(Z) {
              return new d(Z);
            }
            static compressObjectStream(Z) {
              return new A(Z);
            }
            static compression(Z) {
              return new N(Z);
            }
            static config(Z) {
              return new E(Z);
            }
            static conformance(Z) {
              return new H(Z);
            }
            static contentCopy(Z) {
              return new $(Z);
            }
            static copies(Z) {
              return new m(Z);
            }
            static creator(Z) {
              return new p(Z);
            }
            static currentPage(Z) {
              return new T(Z);
            }
            static data(Z) {
              return new L(Z);
            }
            static debug(Z) {
              return new _(Z);
            }
            static defaultTypeface(Z) {
              return new G(Z);
            }
            static destination(Z) {
              return new J(Z);
            }
            static documentAssembly(Z) {
              return new K(Z);
            }
            static driver(Z) {
              return new V(Z);
            }
            static duplexOption(Z) {
              return new U(Z);
            }
            static dynamicRender(Z) {
              return new Q(Z);
            }
            static embed(Z) {
              return new X(Z);
            }
            static encrypt(Z) {
              return new R(Z);
            }
            static encryption(Z) {
              return new f(Z);
            }
            static encryptionLevel(Z) {
              return new D(Z);
            }
            static enforce(Z) {
              return new z(Z);
            }
            static equate(Z) {
              return new Y(Z);
            }
            static equateRange(Z) {
              return new W(Z);
            }
            static exclude(Z) {
              return new ie(Z);
            }
            static excludeNS(Z) {
              return new ne(Z);
            }
            static flipLabel(Z) {
              return new re(Z);
            }
            static fontInfo(Z) {
              return new ee(Z);
            }
            static formFieldFilling(Z) {
              return new te(Z);
            }
            static groupParent(Z) {
              return new oe(Z);
            }
            static ifEmpty(Z) {
              return new se(Z);
            }
            static includeXDPContent(Z) {
              return new ce(Z);
            }
            static incrementalLoad(Z) {
              return new le(Z);
            }
            static incrementalMerge(Z) {
              return new de(Z);
            }
            static interactive(Z) {
              return new Ie(Z);
            }
            static jog(Z) {
              return new Fe(Z);
            }
            static labelPrinter(Z) {
              return new we(Z);
            }
            static layout(Z) {
              return new pe(Z);
            }
            static level(Z) {
              return new fe(Z);
            }
            static linearized(Z) {
              return new Ae(Z);
            }
            static locale(Z) {
              return new Pe(Z);
            }
            static localeSet(Z) {
              return new Re(Z);
            }
            static log(Z) {
              return new Ee(Z);
            }
            static map(Z) {
              return new ye(Z);
            }
            static mediumInfo(Z) {
              return new Te(Z);
            }
            static message(Z) {
              return new je(Z);
            }
            static messaging(Z) {
              return new ve(Z);
            }
            static mode(Z) {
              return new Ce(Z);
            }
            static modifyAnnots(Z) {
              return new Ne(Z);
            }
            static msgId(Z) {
              return new Ge(Z);
            }
            static nameAttr(Z) {
              return new Oe(Z);
            }
            static neverEmbed(Z) {
              return new tt(Z);
            }
            static numberOfCopies(Z) {
              return new Ke(Z);
            }
            static openAction(Z) {
              return new et(Z);
            }
            static output(Z) {
              return new Xe(Z);
            }
            static outputBin(Z) {
              return new Qe(Z);
            }
            static outputXSL(Z) {
              return new it(Z);
            }
            static overprint(Z) {
              return new We(Z);
            }
            static packets(Z) {
              return new gt(Z);
            }
            static pageOffset(Z) {
              return new mt(Z);
            }
            static pageRange(Z) {
              return new Ct(Z);
            }
            static pagination(Z) {
              return new Pt(Z);
            }
            static paginationOverride(Z) {
              return new at(Z);
            }
            static part(Z) {
              return new dt(Z);
            }
            static pcl(Z) {
              return new ot(Z);
            }
            static pdf(Z) {
              return new Mt(Z);
            }
            static pdfa(Z) {
              return new Rt(Z);
            }
            static permissions(Z) {
              return new Et(Z);
            }
            static pickTrayByPDFSize(Z) {
              return new At(Z);
            }
            static picture(Z) {
              return new Nt(Z);
            }
            static plaintextMetadata(Z) {
              return new qe(Z);
            }
            static presence(Z) {
              return new Ue(Z);
            }
            static present(Z) {
              return new Je(Z);
            }
            static print(Z) {
              return new Ve(Z);
            }
            static printHighQuality(Z) {
              return new st(Z);
            }
            static printScaling(Z) {
              return new ft(Z);
            }
            static printerName(Z) {
              return new ct(Z);
            }
            static producer(Z) {
              return new be(Z);
            }
            static ps(Z) {
              return new _e(Z);
            }
            static range(Z) {
              return new $e(Z);
            }
            static record(Z) {
              return new Ze(Z);
            }
            static relevant(Z) {
              return new nt(Z);
            }
            static rename(Z) {
              return new pt(Z);
            }
            static renderPolicy(Z) {
              return new yt(Z);
            }
            static runScripts(Z) {
              return new lt(Z);
            }
            static script(Z) {
              return new St(Z);
            }
            static scriptModel(Z) {
              return new ht(Z);
            }
            static severity(Z) {
              return new Ft(Z);
            }
            static silentPrint(Z) {
              return new It(Z);
            }
            static staple(Z) {
              return new Gt(Z);
            }
            static startNode(Z) {
              return new vt(Z);
            }
            static startPage(Z) {
              return new kt(Z);
            }
            static submitFormat(Z) {
              return new Bt(Z);
            }
            static submitUrl(Z) {
              return new Ut(Z);
            }
            static subsetBelow(Z) {
              return new Yt(Z);
            }
            static suppressBanner(Z) {
              return new rn(Z);
            }
            static tagged(Z) {
              return new Rn(Z);
            }
            static template(Z) {
              return new Dn(Z);
            }
            static templateCache(Z) {
              return new An(Z);
            }
            static threshold(Z) {
              return new _n(Z);
            }
            static to(Z) {
              return new Ln(Z);
            }
            static trace(Z) {
              return new pn(Z);
            }
            static transform(Z) {
              return new Nn(Z);
            }
            static type(Z) {
              return new Bn(Z);
            }
            static uri(Z) {
              return new jn(Z);
            }
            static validate(Z) {
              return new mn(Z);
            }
            static validateApprovalSignatures(Z) {
              return new Sn(Z);
            }
            static validationMessaging(Z) {
              return new vn(Z);
            }
            static version(Z) {
              return new $n(Z);
            }
            static versionControl(Z) {
              return new Un(Z);
            }
            static viewerPreferences(Z) {
              return new Hn(Z);
            }
            static webClient(Z) {
              return new Xn(Z);
            }
            static whitespace(Z) {
              return new zn(Z);
            }
            static window(Z) {
              return new xn(Z);
            }
            static xdc(Z) {
              return new Gn(Z);
            }
            static xdp(Z) {
              return new cn(Z);
            }
            static xsl(Z) {
              return new qn(Z);
            }
            static zpl(Z) {
              return new ln(Z);
            }
          }
          F.ConfigNamespace = Le;
        },
        /* 93 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.ConnectionSetNamespace = void 0;
          var n = ae(80), u = ae(78);
          const q = n.NamespaceIds.connectionSet.id;
          class e extends u.XFAObject {
            constructor(v) {
              super(q, "connectionSet", !0), this.wsdlConnection = new u.XFAObjectArray(), this.xmlConnection = new u.XFAObjectArray(), this.xsdConnection = new u.XFAObjectArray();
            }
          }
          class t extends u.XFAObject {
            constructor(v) {
              super(q, "effectiveInputPolicy"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class B extends u.XFAObject {
            constructor(v) {
              super(q, "effectiveOutputPolicy"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class j extends u.StringObject {
            constructor(v) {
              super(q, "operation"), this.id = v.id || "", this.input = v.input || "", this.name = v.name || "", this.output = v.output || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class M extends u.StringObject {
            constructor(v) {
              super(q, "rootElement"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class O extends u.StringObject {
            constructor(v) {
              super(q, "soapAction"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class w extends u.StringObject {
            constructor(v) {
              super(q, "soapAddress"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class C extends u.StringObject {
            constructor(v) {
              super(q, "uri"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class i extends u.StringObject {
            constructor(v) {
              super(q, "wsdlAddress"), this.id = v.id || "", this.name = v.name || "", this.use = v.use || "", this.usehref = v.usehref || "";
            }
          }
          class o extends u.XFAObject {
            constructor(v) {
              super(q, "wsdlConnection", !0), this.dataDescription = v.dataDescription || "", this.name = v.name || "", this.effectiveInputPolicy = null, this.effectiveOutputPolicy = null, this.operation = null, this.soapAction = null, this.soapAddress = null, this.wsdlAddress = null;
            }
          }
          class k extends u.XFAObject {
            constructor(v) {
              super(q, "xmlConnection", !0), this.dataDescription = v.dataDescription || "", this.name = v.name || "", this.uri = null;
            }
          }
          class s extends u.XFAObject {
            constructor(v) {
              super(q, "xsdConnection", !0), this.dataDescription = v.dataDescription || "", this.name = v.name || "", this.rootElement = null, this.uri = null;
            }
          }
          class l {
            static [n.$buildXFAObject](v, r) {
              if (l.hasOwnProperty(v))
                return l[v](r);
            }
            static connectionSet(v) {
              return new e(v);
            }
            static effectiveInputPolicy(v) {
              return new t(v);
            }
            static effectiveOutputPolicy(v) {
              return new B(v);
            }
            static operation(v) {
              return new j(v);
            }
            static rootElement(v) {
              return new M(v);
            }
            static soapAction(v) {
              return new O(v);
            }
            static soapAddress(v) {
              return new w(v);
            }
            static uri(v) {
              return new C(v);
            }
            static wsdlAddress(v) {
              return new i(v);
            }
            static wsdlConnection(v) {
              return new o(v);
            }
            static xmlConnection(v) {
              return new k(v);
            }
            static xsdConnection(v) {
              return new s(v);
            }
          }
          F.ConnectionSetNamespace = l;
        },
        /* 94 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.DatasetsNamespace = void 0;
          var n = ae(78), u = ae(80);
          const q = u.NamespaceIds.datasets.id;
          class e extends n.XmlObject {
            constructor(M) {
              super(q, "data", M);
            }
            [n.$isNsAgnostic]() {
              return !0;
            }
          }
          class t extends n.XFAObject {
            constructor(M) {
              super(q, "datasets", !0), this.data = null, this.Signature = null;
            }
            [n.$onChild](M) {
              const O = M[n.$nodeName];
              (O === "data" && M[n.$namespaceId] === q || O === "Signature" && M[n.$namespaceId] === u.NamespaceIds.signature.id) && (this[O] = M), this[n.$appendChild](M);
            }
          }
          class B {
            static [u.$buildXFAObject](M, O) {
              if (B.hasOwnProperty(M))
                return B[M](O);
            }
            static datasets(M) {
              return new t(M);
            }
            static data(M) {
              return new e(M);
            }
          }
          F.DatasetsNamespace = B;
        },
        /* 95 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.LocaleSetNamespace = void 0;
          var n = ae(80), u = ae(78), q = ae(79);
          const e = n.NamespaceIds.localeSet.id;
          class t extends u.XFAObject {
            constructor(H) {
              super(e, "calendarSymbols", !0), this.name = "gregorian", this.dayNames = new u.XFAObjectArray(2), this.eraNames = null, this.meridiemNames = null, this.monthNames = new u.XFAObjectArray(2);
            }
          }
          class B extends u.StringObject {
            constructor(H) {
              super(e, "currencySymbol"), this.name = (0, q.getStringOption)(H.name, ["symbol", "isoname", "decimal"]);
            }
          }
          class j extends u.XFAObject {
            constructor(H) {
              super(e, "currencySymbols", !0), this.currencySymbol = new u.XFAObjectArray(3);
            }
          }
          class M extends u.StringObject {
            constructor(H) {
              super(e, "datePattern"), this.name = (0, q.getStringOption)(H.name, ["full", "long", "med", "short"]);
            }
          }
          class O extends u.XFAObject {
            constructor(H) {
              super(e, "datePatterns", !0), this.datePattern = new u.XFAObjectArray(4);
            }
          }
          class w extends u.ContentObject {
            constructor(H) {
              super(e, "dateTimeSymbols");
            }
          }
          class C extends u.StringObject {
            constructor(H) {
              super(e, "day");
            }
          }
          class i extends u.XFAObject {
            constructor(H) {
              super(e, "dayNames", !0), this.abbr = (0, q.getInteger)({
                data: H.abbr,
                defaultValue: 0,
                validate: ($) => $ === 1
              }), this.day = new u.XFAObjectArray(7);
            }
          }
          class o extends u.StringObject {
            constructor(H) {
              super(e, "era");
            }
          }
          class k extends u.XFAObject {
            constructor(H) {
              super(e, "eraNames", !0), this.era = new u.XFAObjectArray(2);
            }
          }
          class s extends u.XFAObject {
            constructor(H) {
              super(e, "locale", !0), this.desc = H.desc || "", this.name = "isoname", this.calendarSymbols = null, this.currencySymbols = null, this.datePatterns = null, this.dateTimeSymbols = null, this.numberPatterns = null, this.numberSymbols = null, this.timePatterns = null, this.typeFaces = null;
            }
          }
          class l extends u.XFAObject {
            constructor(H) {
              super(e, "localeSet", !0), this.locale = new u.XFAObjectArray();
            }
          }
          class g extends u.StringObject {
            constructor(H) {
              super(e, "meridiem");
            }
          }
          class v extends u.XFAObject {
            constructor(H) {
              super(e, "meridiemNames", !0), this.meridiem = new u.XFAObjectArray(2);
            }
          }
          class r extends u.StringObject {
            constructor(H) {
              super(e, "month");
            }
          }
          class x extends u.XFAObject {
            constructor(H) {
              super(e, "monthNames", !0), this.abbr = (0, q.getInteger)({
                data: H.abbr,
                defaultValue: 0,
                validate: ($) => $ === 1
              }), this.month = new u.XFAObjectArray(12);
            }
          }
          class b extends u.StringObject {
            constructor(H) {
              super(e, "numberPattern"), this.name = (0, q.getStringOption)(H.name, ["full", "long", "med", "short"]);
            }
          }
          class I extends u.XFAObject {
            constructor(H) {
              super(e, "numberPatterns", !0), this.numberPattern = new u.XFAObjectArray(4);
            }
          }
          class h extends u.StringObject {
            constructor(H) {
              super(e, "numberSymbol"), this.name = (0, q.getStringOption)(H.name, ["decimal", "grouping", "percent", "minus", "zero"]);
            }
          }
          class y extends u.XFAObject {
            constructor(H) {
              super(e, "numberSymbols", !0), this.numberSymbol = new u.XFAObjectArray(5);
            }
          }
          class P extends u.StringObject {
            constructor(H) {
              super(e, "timePattern"), this.name = (0, q.getStringOption)(H.name, ["full", "long", "med", "short"]);
            }
          }
          class c extends u.XFAObject {
            constructor(H) {
              super(e, "timePatterns", !0), this.timePattern = new u.XFAObjectArray(4);
            }
          }
          class d extends u.XFAObject {
            constructor(H) {
              super(e, "typeFace", !0), this.name = H.name | "";
            }
          }
          class A extends u.XFAObject {
            constructor(H) {
              super(e, "typeFaces", !0), this.typeFace = new u.XFAObjectArray();
            }
          }
          class N {
            static [n.$buildXFAObject](H, $) {
              if (N.hasOwnProperty(H))
                return N[H]($);
            }
            static calendarSymbols(H) {
              return new t(H);
            }
            static currencySymbol(H) {
              return new B(H);
            }
            static currencySymbols(H) {
              return new j(H);
            }
            static datePattern(H) {
              return new M(H);
            }
            static datePatterns(H) {
              return new O(H);
            }
            static dateTimeSymbols(H) {
              return new w(H);
            }
            static day(H) {
              return new C(H);
            }
            static dayNames(H) {
              return new i(H);
            }
            static era(H) {
              return new o(H);
            }
            static eraNames(H) {
              return new k(H);
            }
            static locale(H) {
              return new s(H);
            }
            static localeSet(H) {
              return new l(H);
            }
            static meridiem(H) {
              return new g(H);
            }
            static meridiemNames(H) {
              return new v(H);
            }
            static month(H) {
              return new r(H);
            }
            static monthNames(H) {
              return new x(H);
            }
            static numberPattern(H) {
              return new b(H);
            }
            static numberPatterns(H) {
              return new I(H);
            }
            static numberSymbol(H) {
              return new h(H);
            }
            static numberSymbols(H) {
              return new y(H);
            }
            static timePattern(H) {
              return new P(H);
            }
            static timePatterns(H) {
              return new c(H);
            }
            static typeFace(H) {
              return new d(H);
            }
            static typeFaces(H) {
              return new A(H);
            }
          }
          F.LocaleSetNamespace = N;
        },
        /* 96 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.SignatureNamespace = void 0;
          var n = ae(80), u = ae(78);
          const q = n.NamespaceIds.signature.id;
          class e extends u.XFAObject {
            constructor(j) {
              super(q, "signature", !0);
            }
          }
          class t {
            static [n.$buildXFAObject](j, M) {
              if (t.hasOwnProperty(j))
                return t[j](M);
            }
            static signature(j) {
              return new e(j);
            }
          }
          F.SignatureNamespace = t;
        },
        /* 97 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.StylesheetNamespace = void 0;
          var n = ae(80), u = ae(78);
          const q = n.NamespaceIds.stylesheet.id;
          class e extends u.XFAObject {
            constructor(j) {
              super(q, "stylesheet", !0);
            }
          }
          class t {
            static [n.$buildXFAObject](j, M) {
              if (t.hasOwnProperty(j))
                return t[j](M);
            }
            static stylesheet(j) {
              return new e(j);
            }
          }
          F.StylesheetNamespace = t;
        },
        /* 98 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XdpNamespace = void 0;
          var n = ae(80), u = ae(78);
          const q = n.NamespaceIds.xdp.id;
          class e extends u.XFAObject {
            constructor(j) {
              super(q, "xdp", !0), this.uuid = j.uuid || "", this.timeStamp = j.timeStamp || "", this.config = null, this.connectionSet = null, this.datasets = null, this.localeSet = null, this.stylesheet = new u.XFAObjectArray(), this.template = null;
            }
            [u.$onChildCheck](j) {
              const M = n.NamespaceIds[j[u.$nodeName]];
              return M && j[u.$namespaceId] === M.id;
            }
          }
          class t {
            static [n.$buildXFAObject](j, M) {
              if (t.hasOwnProperty(j))
                return t[j](M);
            }
            static xdp(j) {
              return new e(j);
            }
          }
          F.XdpNamespace = t;
        },
        /* 99 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XhtmlNamespace = void 0;
          var n = ae(78), u = ae(80), q = ae(85), e = ae(79);
          const t = u.NamespaceIds.xhtml.id, B = Symbol(), j = /* @__PURE__ */ new Set(["color", "font", "font-family", "font-size", "font-stretch", "font-style", "font-weight", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "letter-spacing", "line-height", "orphans", "page-break-after", "page-break-before", "page-break-inside", "tab-interval", "tab-stop", "text-align", "text-decoration", "text-indent", "vertical-align", "widows", "kerning-mode", "xfa-font-horizontal-scale", "xfa-font-vertical-scale", "xfa-spacerun", "xfa-tab-stops"]), M = /* @__PURE__ */ new Map([["page-break-after", "breakAfter"], ["page-break-before", "breakBefore"], ["page-break-inside", "breakInside"], ["kerning-mode", (E) => E === "none" ? "none" : "normal"], ["xfa-font-horizontal-scale", (E) => `scaleX(${Math.max(0, Math.min(parseInt(E) / 100)).toFixed(2)})`], ["xfa-font-vertical-scale", (E) => `scaleY(${Math.max(0, Math.min(parseInt(E) / 100)).toFixed(2)})`], ["xfa-spacerun", ""], ["xfa-tab-stops", ""], ["font-size", (E, H) => (E = H.fontSize = (0, e.getMeasurement)(E), (0, q.measureToString)(0.99 * E))], ["letter-spacing", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["line-height", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["margin", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["margin-bottom", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["margin-left", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["margin-right", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["margin-top", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["text-indent", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))], ["font-family", (E) => E], ["vertical-align", (E) => (0, q.measureToString)((0, e.getMeasurement)(E))]]), O = /\s+/g, w = /[\r\n]+/g, C = /\r\n?/g;
          function i(E, H, $) {
            const m = /* @__PURE__ */ Object.create(null);
            if (!E)
              return m;
            const p = /* @__PURE__ */ Object.create(null);
            for (const [T, L] of E.split(";").map((_) => _.split(":", 2))) {
              const _ = M.get(T);
              if (_ === "")
                continue;
              let G = L;
              _ && (typeof _ == "string" ? G = _ : G = _(L, p)), T.endsWith("scale") ? m.transform ? m.transform = `${m[T]} ${G}` : m.transform = G : m[T.replaceAll(/-([a-zA-Z])/g, (J, K) => K.toUpperCase())] = G;
            }
            if (m.fontFamily && (0, q.setFontFamily)({
              typeface: m.fontFamily,
              weight: m.fontWeight || "normal",
              posture: m.fontStyle || "normal",
              size: p.fontSize || 0
            }, H, H[n.$globalData].fontFinder, m), $ && m.verticalAlign && m.verticalAlign !== "0px" && m.fontSize) {
              const _ = (0, e.getMeasurement)(m.fontSize);
              m.fontSize = (0, q.measureToString)(_ * 0.583), m.verticalAlign = (0, q.measureToString)(Math.sign((0, e.getMeasurement)(m.verticalAlign)) * _ * 0.333);
            }
            return $ && m.fontSize && (m.fontSize = `calc(${m.fontSize} * var(--scale-factor))`), (0, q.fixTextIndent)(m), m;
          }
          function o(E) {
            return E.style ? E.style.trim().split(/\s*;\s*/).filter((H) => !!H).map((H) => H.split(/\s*:\s*/, 2)).filter(([H, $]) => (H === "font-family" && E[n.$globalData].usedTypefaces.add($), j.has(H))).map((H) => H.join(":")).join(";") : "";
          }
          const k = /* @__PURE__ */ new Set(["body", "html"]);
          class s extends n.XmlObject {
            constructor(H, $) {
              super(t, $), this[B] = !1, this.style = H.style || "";
            }
            [n.$clean](H) {
              super[n.$clean](H), this.style = o(this);
            }
            [n.$acceptWhitespace]() {
              return !k.has(this[n.$nodeName]);
            }
            [n.$onText](H, $ = !1) {
              $ ? this[B] = !0 : (H = H.replaceAll(w, ""), this.style.includes("xfa-spacerun:yes") || (H = H.replaceAll(O, " "))), H && (this[n.$content] += H);
            }
            [n.$pushGlyphs](H, $ = !0) {
              const m = /* @__PURE__ */ Object.create(null), p = {
                top: NaN,
                bottom: NaN,
                left: NaN,
                right: NaN
              };
              let T = null;
              for (const [L, _] of this.style.split(";").map((G) => G.split(":", 2)))
                switch (L) {
                  case "font-family":
                    m.typeface = (0, e.stripQuotes)(_);
                    break;
                  case "font-size":
                    m.size = (0, e.getMeasurement)(_);
                    break;
                  case "font-weight":
                    m.weight = _;
                    break;
                  case "font-style":
                    m.posture = _;
                    break;
                  case "letter-spacing":
                    m.letterSpacing = (0, e.getMeasurement)(_);
                    break;
                  case "margin":
                    const G = _.split(/ \t/).map((J) => (0, e.getMeasurement)(J));
                    switch (G.length) {
                      case 1:
                        p.top = p.bottom = p.left = p.right = G[0];
                        break;
                      case 2:
                        p.top = p.bottom = G[0], p.left = p.right = G[1];
                        break;
                      case 3:
                        p.top = G[0], p.bottom = G[2], p.left = p.right = G[1];
                        break;
                      case 4:
                        p.top = G[0], p.left = G[1], p.bottom = G[2], p.right = G[3];
                        break;
                    }
                    break;
                  case "margin-top":
                    p.top = (0, e.getMeasurement)(_);
                    break;
                  case "margin-bottom":
                    p.bottom = (0, e.getMeasurement)(_);
                    break;
                  case "margin-left":
                    p.left = (0, e.getMeasurement)(_);
                    break;
                  case "margin-right":
                    p.right = (0, e.getMeasurement)(_);
                    break;
                  case "line-height":
                    T = (0, e.getMeasurement)(_);
                    break;
                }
              if (H.pushData(m, p, T), this[n.$content])
                H.addString(this[n.$content]);
              else
                for (const L of this[n.$getChildren]()) {
                  if (L[n.$nodeName] === "#text") {
                    H.addString(L[n.$content]);
                    continue;
                  }
                  L[n.$pushGlyphs](H);
                }
              $ && H.popFont();
            }
            [n.$toHTML](H) {
              const $ = [];
              if (this[n.$extra] = {
                children: $
              }, this[n.$childrenToHTML]({}), $.length === 0 && !this[n.$content])
                return e.HTMLResult.EMPTY;
              let m;
              return this[B] ? m = this[n.$content] ? this[n.$content].replaceAll(C, `
`) : void 0 : m = this[n.$content] || void 0, e.HTMLResult.success({
                name: this[n.$nodeName],
                attributes: {
                  href: this.href,
                  style: i(this.style, this, this[B])
                },
                children: $,
                value: m
              });
            }
          }
          class l extends s {
            constructor(H) {
              super(H, "a"), this.href = (0, q.fixURL)(H.href) || "";
            }
          }
          class g extends s {
            constructor(H) {
              super(H, "b");
            }
            [n.$pushGlyphs](H) {
              H.pushFont({
                weight: "bold"
              }), super[n.$pushGlyphs](H), H.popFont();
            }
          }
          class v extends s {
            constructor(H) {
              super(H, "body");
            }
            [n.$toHTML](H) {
              const $ = super[n.$toHTML](H), {
                html: m
              } = $;
              return m ? (m.name = "div", m.attributes.class = ["xfaRich"], $) : e.HTMLResult.EMPTY;
            }
          }
          class r extends s {
            constructor(H) {
              super(H, "br");
            }
            [n.$text]() {
              return `
`;
            }
            [n.$pushGlyphs](H) {
              H.addString(`
`);
            }
            [n.$toHTML](H) {
              return e.HTMLResult.success({
                name: "br"
              });
            }
          }
          class x extends s {
            constructor(H) {
              super(H, "html");
            }
            [n.$toHTML](H) {
              var m;
              const $ = [];
              if (this[n.$extra] = {
                children: $
              }, this[n.$childrenToHTML]({}), $.length === 0)
                return e.HTMLResult.success({
                  name: "div",
                  attributes: {
                    class: ["xfaRich"],
                    style: {}
                  },
                  value: this[n.$content] || ""
                });
              if ($.length === 1) {
                const p = $[0];
                if ((m = p.attributes) != null && m.class.includes("xfaRich"))
                  return e.HTMLResult.success(p);
              }
              return e.HTMLResult.success({
                name: "div",
                attributes: {
                  class: ["xfaRich"],
                  style: {}
                },
                children: $
              });
            }
          }
          class b extends s {
            constructor(H) {
              super(H, "i");
            }
            [n.$pushGlyphs](H) {
              H.pushFont({
                posture: "italic"
              }), super[n.$pushGlyphs](H), H.popFont();
            }
          }
          class I extends s {
            constructor(H) {
              super(H, "li");
            }
          }
          class h extends s {
            constructor(H) {
              super(H, "ol");
            }
          }
          class y extends s {
            constructor(H) {
              super(H, "p");
            }
            [n.$pushGlyphs](H) {
              super[n.$pushGlyphs](H, !1), H.addString(`
`), H.addPara(), H.popFont();
            }
            [n.$text]() {
              return this[n.$getParent]()[n.$getChildren]().at(-1) === this ? super[n.$text]() : super[n.$text]() + `
`;
            }
          }
          class P extends s {
            constructor(H) {
              super(H, "span");
            }
          }
          class c extends s {
            constructor(H) {
              super(H, "sub");
            }
          }
          class d extends s {
            constructor(H) {
              super(H, "sup");
            }
          }
          class A extends s {
            constructor(H) {
              super(H, "ul");
            }
          }
          class N {
            static [u.$buildXFAObject](H, $) {
              if (N.hasOwnProperty(H))
                return N[H]($);
            }
            static a(H) {
              return new l(H);
            }
            static b(H) {
              return new g(H);
            }
            static body(H) {
              return new v(H);
            }
            static br(H) {
              return new r(H);
            }
            static html(H) {
              return new x(H);
            }
            static i(H) {
              return new b(H);
            }
            static li(H) {
              return new I(H);
            }
            static ol(H) {
              return new h(H);
            }
            static p(H) {
              return new y(H);
            }
            static span(H) {
              return new P(H);
            }
            static sub(H) {
              return new c(H);
            }
            static sup(H) {
              return new d(H);
            }
            static ul(H) {
              return new A(H);
            }
          }
          F.XhtmlNamespace = N;
        },
        /* 100 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.UnknownNamespace = void 0;
          var n = ae(80), u = ae(78);
          class q {
            constructor(t) {
              this.namespaceId = t;
            }
            [n.$buildXFAObject](t, B) {
              return new u.XmlObject(this.namespaceId, t, B);
            }
          }
          F.UnknownNamespace = q;
        },
        /* 101 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.DatasetReader = void 0;
          var n = ae(2), u = ae(3), q = ae(67);
          function e(j) {
            try {
              return (0, n.stringToUTF8String)(j);
            } catch (M) {
              return (0, n.warn)(`UTF-8 decoding failed: "${M}".`), j;
            }
          }
          class t extends q.SimpleXMLParser {
            constructor(M) {
              super(M), this.node = null;
            }
            onEndElement(M) {
              const O = super.onEndElement(M);
              if (O && M === "xfa:datasets")
                throw this.node = O, new Error("Aborting DatasetXMLParser.");
            }
          }
          class B {
            constructor(M) {
              if (M.datasets)
                this.node = new q.SimpleXMLParser({
                  hasAttributes: !0
                }).parseFromString(M.datasets).documentElement;
              else {
                const O = new t({
                  hasAttributes: !0
                });
                try {
                  O.parseFromString(M["xdp:xdp"]);
                } catch {
                }
                this.node = O.node;
              }
            }
            getValue(M) {
              if (!this.node || !M)
                return "";
              const O = this.node.searchNode((0, u.parseXFAPath)(M), 0);
              if (!O)
                return "";
              const w = O.firstChild;
              return (w == null ? void 0 : w.nodeName) === "value" ? O.children.map((C) => e(C.textContent)) : e(O.textContent);
            }
          }
          F.DatasetReader = B;
        },
        /* 102 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.XRef = void 0;
          var n = ae(2), u = ae(4), q = ae(16), e = ae(3), t = ae(5), B = ae(68);
          class j {
            constructor(O, w) {
              this.stream = O, this.pdfManager = w, this.entries = [], this._xrefStms = /* @__PURE__ */ new Set(), this._cacheMap = /* @__PURE__ */ new Map(), this._pendingRefs = new u.RefSet(), this._newPersistentRefNum = null, this._newTemporaryRefNum = null;
            }
            getNewPersistentRef(O) {
              this._newPersistentRefNum === null && (this._newPersistentRefNum = this.entries.length || 1);
              const w = this._newPersistentRefNum++;
              return this._cacheMap.set(w, O), u.Ref.get(w, 0);
            }
            getNewTemporaryRef() {
              return this._newTemporaryRefNum === null && (this._newTemporaryRefNum = this.entries.length || 1), u.Ref.get(this._newTemporaryRefNum++, 0);
            }
            resetNewTemporaryRef() {
              this._newTemporaryRefNum = null;
            }
            setStartXRef(O) {
              this.startXRefQueue = [O];
            }
            parse(O = !1) {
              let w;
              O ? ((0, n.warn)("Indexing all PDF objects"), w = this.indexObjects()) : w = this.readXRef(), w.assignXref(this), this.trailer = w;
              let C;
              try {
                C = w.get("Encrypt");
              } catch (o) {
                if (o instanceof e.MissingDataException)
                  throw o;
                (0, n.warn)(`XRef.parse - Invalid "Encrypt" reference: "${o}".`);
              }
              if (C instanceof u.Dict) {
                const o = w.get("ID"), k = o != null && o.length ? o[0] : "";
                C.suppressEncryption = !0, this.encrypt = new B.CipherTransformFactory(C, k, this.pdfManager.password);
              }
              let i;
              try {
                i = w.get("Root");
              } catch (o) {
                if (o instanceof e.MissingDataException)
                  throw o;
                (0, n.warn)(`XRef.parse - Invalid "Root" reference: "${o}".`);
              }
              if (i instanceof u.Dict)
                try {
                  if (i.get("Pages") instanceof u.Dict) {
                    this.root = i;
                    return;
                  }
                } catch (o) {
                  if (o instanceof e.MissingDataException)
                    throw o;
                  (0, n.warn)(`XRef.parse - Invalid "Pages" reference: "${o}".`);
                }
              throw O ? new n.InvalidPDFException("Invalid Root reference.") : new e.XRefParseException();
            }
            processXRefTable(O) {
              "tableState" in this || (this.tableState = {
                entryNum: 0,
                streamPos: O.lexer.stream.pos,
                parserBuf1: O.buf1,
                parserBuf2: O.buf2
              });
              const w = this.readXRefTable(O);
              if (!(0, u.isCmd)(w, "trailer"))
                throw new n.FormatError("Invalid XRef table: could not find trailer dictionary");
              let C = O.getObj();
              if (!(C instanceof u.Dict) && C.dict && (C = C.dict), !(C instanceof u.Dict))
                throw new n.FormatError("Invalid XRef table: could not parse trailer dictionary");
              return delete this.tableState, C;
            }
            readXRefTable(O) {
              const w = O.lexer.stream, C = this.tableState;
              w.pos = C.streamPos, O.buf1 = C.parserBuf1, O.buf2 = C.parserBuf2;
              let i;
              for (; ; ) {
                if (!("firstEntryNum" in C) || !("entryCount" in C)) {
                  if ((0, u.isCmd)(i = O.getObj(), "trailer"))
                    break;
                  C.firstEntryNum = i, C.entryCount = O.getObj();
                }
                let o = C.firstEntryNum;
                const k = C.entryCount;
                if (!Number.isInteger(o) || !Number.isInteger(k))
                  throw new n.FormatError("Invalid XRef table: wrong types in subsection header");
                for (let s = C.entryNum; s < k; s++) {
                  C.streamPos = w.pos, C.entryNum = s, C.parserBuf1 = O.buf1, C.parserBuf2 = O.buf2;
                  const l = {};
                  l.offset = O.getObj(), l.gen = O.getObj();
                  const g = O.getObj();
                  if (g instanceof u.Cmd)
                    switch (g.cmd) {
                      case "f":
                        l.free = !0;
                        break;
                      case "n":
                        l.uncompressed = !0;
                        break;
                    }
                  if (!Number.isInteger(l.offset) || !Number.isInteger(l.gen) || !(l.free || l.uncompressed))
                    throw new n.FormatError(`Invalid entry in XRef subsection: ${o}, ${k}`);
                  s === 0 && l.free && o === 1 && (o = 0), this.entries[s + o] || (this.entries[s + o] = l);
                }
                C.entryNum = 0, C.streamPos = w.pos, C.parserBuf1 = O.buf1, C.parserBuf2 = O.buf2, delete C.firstEntryNum, delete C.entryCount;
              }
              if (this.entries[0] && !this.entries[0].free)
                throw new n.FormatError("Invalid XRef table: unexpected first object");
              return i;
            }
            processXRefStream(O) {
              if (!("streamState" in this)) {
                const w = O.dict, C = w.get("W");
                let i = w.get("Index");
                i || (i = [0, w.get("Size")]), this.streamState = {
                  entryRanges: i,
                  byteWidths: C,
                  entryNum: 0,
                  streamPos: O.pos
                };
              }
              return this.readXRefStream(O), delete this.streamState, O.dict;
            }
            readXRefStream(O) {
              const w = this.streamState;
              O.pos = w.streamPos;
              const [C, i, o] = w.byteWidths, k = w.entryRanges;
              for (; k.length > 0; ) {
                const [s, l] = k;
                if (!Number.isInteger(s) || !Number.isInteger(l))
                  throw new n.FormatError(`Invalid XRef range fields: ${s}, ${l}`);
                if (!Number.isInteger(C) || !Number.isInteger(i) || !Number.isInteger(o))
                  throw new n.FormatError(`Invalid XRef entry fields length: ${s}, ${l}`);
                for (let g = w.entryNum; g < l; ++g) {
                  w.entryNum = g, w.streamPos = O.pos;
                  let v = 0, r = 0, x = 0;
                  for (let I = 0; I < C; ++I) {
                    const h = O.getByte();
                    if (h === -1)
                      throw new n.FormatError("Invalid XRef byteWidths 'type'.");
                    v = v << 8 | h;
                  }
                  C === 0 && (v = 1);
                  for (let I = 0; I < i; ++I) {
                    const h = O.getByte();
                    if (h === -1)
                      throw new n.FormatError("Invalid XRef byteWidths 'offset'.");
                    r = r << 8 | h;
                  }
                  for (let I = 0; I < o; ++I) {
                    const h = O.getByte();
                    if (h === -1)
                      throw new n.FormatError("Invalid XRef byteWidths 'generation'.");
                    x = x << 8 | h;
                  }
                  const b = {};
                  switch (b.offset = r, b.gen = x, v) {
                    case 0:
                      b.free = !0;
                      break;
                    case 1:
                      b.uncompressed = !0;
                      break;
                    case 2:
                      break;
                    default:
                      throw new n.FormatError(`Invalid XRef entry type: ${v}`);
                  }
                  this.entries[s + g] || (this.entries[s + g] = b);
                }
                w.entryNum = 0, w.streamPos = O.pos, k.splice(0, 2);
              }
            }
            indexObjects() {
              function s(p, T) {
                let L = "", _ = p[T];
                for (; _ !== 10 && _ !== 13 && _ !== 60 && !(++T >= p.length); )
                  L += String.fromCharCode(_), _ = p[T];
                return L;
              }
              function l(p, T, L) {
                const _ = L.length, G = p.length;
                let J = 0;
                for (; T < G; ) {
                  let K = 0;
                  for (; K < _ && p[T + K] === L[K]; )
                    ++K;
                  if (K >= _)
                    break;
                  T++, J++;
                }
                return J;
              }
              const g = /\b(endobj|\d+\s+\d+\s+obj|xref|trailer)\b/g, v = /\b(startxref|\d+\s+\d+\s+obj)\b/g, r = /^(\d+)\s+(\d+)\s+obj\b/, x = new Uint8Array([116, 114, 97, 105, 108, 101, 114]), b = new Uint8Array([115, 116, 97, 114, 116, 120, 114, 101, 102]), I = new Uint8Array([47, 88, 82, 101, 102]);
              this.entries.length = 0, this._cacheMap.clear();
              const h = this.stream;
              h.pos = 0;
              const y = h.getBytes(), P = (0, n.bytesToString)(y), c = y.length;
              let d = h.start;
              const A = [], N = [];
              for (; d < c; ) {
                let p = y[d];
                if (p === 9 || p === 10 || p === 13 || p === 32) {
                  ++d;
                  continue;
                }
                if (p === 37) {
                  do {
                    if (++d, d >= c)
                      break;
                    p = y[d];
                  } while (p !== 10 && p !== 13);
                  continue;
                }
                const T = s(y, d);
                let L;
                if (T.startsWith("xref") && (T.length === 4 || /\s/.test(T[4])))
                  d += l(y, d, x), A.push(d), d += l(y, d, b);
                else if (L = r.exec(T)) {
                  const _ = L[1] | 0, G = L[2] | 0, J = d + T.length;
                  let K, V = !1;
                  if (!this.entries[_])
                    V = !0;
                  else if (this.entries[_].gen === G)
                    try {
                      new q.Parser({
                        lexer: new q.Lexer(h.makeSubStream(J))
                      }).getObj(), V = !0;
                    } catch (R) {
                      R instanceof e.ParserEOFException ? (0, n.warn)(`indexObjects -- checking object (${T}): "${R}".`) : V = !0;
                    }
                  V && (this.entries[_] = {
                    offset: d - h.start,
                    gen: G,
                    uncompressed: !0
                  }), g.lastIndex = J;
                  const U = g.exec(P);
                  U ? (K = g.lastIndex + 1 - d, U[1] !== "endobj" && ((0, n.warn)(`indexObjects: Found "${U[1]}" inside of another "obj", caused by missing "endobj" -- trying to recover.`), K -= U[1].length + 1)) : K = c - d;
                  const Q = y.subarray(d, d + K), X = l(Q, 0, I);
                  X < K && Q[X + 5] < 64 && (N.push(d - h.start), this._xrefStms.add(d - h.start)), d += K;
                } else if (T.startsWith("trailer") && (T.length === 7 || /\s/.test(T[7]))) {
                  A.push(d);
                  const _ = d + T.length;
                  let G;
                  v.lastIndex = _;
                  const J = v.exec(P);
                  J ? (G = v.lastIndex + 1 - d, J[1] !== "startxref" && ((0, n.warn)(`indexObjects: Found "${J[1]}" after "trailer", caused by missing "startxref" -- trying to recover.`), G -= J[1].length + 1)) : G = c - d, d += G;
                } else
                  d += T.length + 1;
              }
              for (const p of N)
                this.startXRefQueue.push(p), this.readXRef(!0);
              const E = [];
              let H = !1;
              for (const p of A) {
                h.pos = p;
                const T = new q.Parser({
                  lexer: new q.Lexer(h),
                  xref: this,
                  allowStreams: !0,
                  recoveryMode: !0
                }), L = T.getObj();
                if (!(0, u.isCmd)(L, "trailer"))
                  continue;
                const _ = T.getObj();
                _ instanceof u.Dict && (E.push(_), _.has("Encrypt") && (H = !0));
              }
              let $, m;
              for (const p of [...E, "genFallback", ...E]) {
                if (p === "genFallback") {
                  if (!m)
                    break;
                  this._generationFallback = !0;
                  continue;
                }
                let T = !1;
                try {
                  const L = p.get("Root");
                  if (!(L instanceof u.Dict))
                    continue;
                  const _ = L.get("Pages");
                  if (!(_ instanceof u.Dict))
                    continue;
                  const G = _.get("Count");
                  Number.isInteger(G) && (T = !0);
                } catch (L) {
                  m = L;
                  continue;
                }
                if (T && (!H || p.has("Encrypt")) && p.has("ID"))
                  return p;
                $ = p;
              }
              if ($)
                return $;
              if (this.topDict)
                return this.topDict;
              throw new n.InvalidPDFException("Invalid PDF structure.");
            }
            readXRef(O = !1) {
              const w = this.stream, C = /* @__PURE__ */ new Set();
              for (; this.startXRefQueue.length; ) {
                try {
                  const i = this.startXRefQueue[0];
                  if (C.has(i)) {
                    (0, n.warn)("readXRef - skipping XRef table since it was already parsed."), this.startXRefQueue.shift();
                    continue;
                  }
                  C.add(i), w.pos = i + w.start;
                  const o = new q.Parser({
                    lexer: new q.Lexer(w),
                    xref: this,
                    allowStreams: !0
                  });
                  let k = o.getObj(), s;
                  if ((0, u.isCmd)(k, "xref"))
                    s = this.processXRefTable(o), this.topDict || (this.topDict = s), k = s.get("XRefStm"), Number.isInteger(k) && !this._xrefStms.has(k) && (this._xrefStms.add(k), this.startXRefQueue.push(k));
                  else if (Number.isInteger(k)) {
                    if (!Number.isInteger(o.getObj()) || !(0, u.isCmd)(o.getObj(), "obj") || !((k = o.getObj()) instanceof t.BaseStream))
                      throw new n.FormatError("Invalid XRef stream");
                    if (s = this.processXRefStream(k), this.topDict || (this.topDict = s), !s)
                      throw new n.FormatError("Failed to read XRef stream");
                  } else
                    throw new n.FormatError("Invalid XRef stream header");
                  k = s.get("Prev"), Number.isInteger(k) ? this.startXRefQueue.push(k) : k instanceof u.Ref && this.startXRefQueue.push(k.num);
                } catch (i) {
                  if (i instanceof e.MissingDataException)
                    throw i;
                  (0, n.info)("(while reading XRef): " + i);
                }
                this.startXRefQueue.shift();
              }
              if (this.topDict)
                return this.topDict;
              if (!O)
                throw new e.XRefParseException();
            }
            get lastXRefStreamPos() {
              return this._xrefStms.size > 0 ? Math.max(...this._xrefStms) : null;
            }
            getEntry(O) {
              const w = this.entries[O];
              return w && !w.free && w.offset ? w : null;
            }
            fetchIfRef(O, w = !1) {
              return O instanceof u.Ref ? this.fetch(O, w) : O;
            }
            fetch(O, w = !1) {
              if (!(O instanceof u.Ref))
                throw new Error("ref object is not a reference");
              const C = O.num, i = this._cacheMap.get(C);
              if (i !== void 0)
                return i instanceof u.Dict && !i.objId && (i.objId = O.toString()), i;
              let o = this.getEntry(C);
              if (o === null)
                return this._cacheMap.set(C, o), o;
              if (this._pendingRefs.has(O))
                return this._pendingRefs.remove(O), (0, n.warn)(`Ignoring circular reference: ${O}.`), u.CIRCULAR_REF;
              this._pendingRefs.put(O);
              try {
                o.uncompressed ? o = this.fetchUncompressed(O, o, w) : o = this.fetchCompressed(O, o, w), this._pendingRefs.remove(O);
              } catch (k) {
                throw this._pendingRefs.remove(O), k;
              }
              return o instanceof u.Dict ? o.objId = O.toString() : o instanceof t.BaseStream && (o.dict.objId = O.toString()), o;
            }
            fetchUncompressed(O, w, C = !1) {
              const i = O.gen;
              let o = O.num;
              if (w.gen !== i) {
                const r = `Inconsistent generation in XRef: ${O}`;
                if (this._generationFallback && w.gen < i)
                  return (0, n.warn)(r), this.fetchUncompressed(u.Ref.get(o, w.gen), w, C);
                throw new e.XRefEntryException(r);
              }
              const k = this.stream.makeSubStream(w.offset + this.stream.start), s = new q.Parser({
                lexer: new q.Lexer(k),
                xref: this,
                allowStreams: !0
              }), l = s.getObj(), g = s.getObj(), v = s.getObj();
              if (l !== o || g !== i || !(v instanceof u.Cmd))
                throw new e.XRefEntryException(`Bad (uncompressed) XRef entry: ${O}`);
              if (v.cmd !== "obj") {
                if (v.cmd.startsWith("obj") && (o = parseInt(v.cmd.substring(3), 10), !Number.isNaN(o)))
                  return o;
                throw new e.XRefEntryException(`Bad (uncompressed) XRef entry: ${O}`);
              }
              return this.encrypt && !C ? w = s.getObj(this.encrypt.createCipherTransform(o, i)) : w = s.getObj(), w instanceof t.BaseStream || this._cacheMap.set(o, w), w;
            }
            fetchCompressed(O, w, C = !1) {
              const i = w.offset, o = this.fetch(u.Ref.get(i, 0));
              if (!(o instanceof t.BaseStream))
                throw new n.FormatError("bad ObjStm stream");
              const k = o.dict.get("First"), s = o.dict.get("N");
              if (!Number.isInteger(k) || !Number.isInteger(s))
                throw new n.FormatError("invalid first and n parameters for ObjStm stream");
              let l = new q.Parser({
                lexer: new q.Lexer(o),
                xref: this,
                allowStreams: !0
              });
              const g = new Array(s), v = new Array(s);
              for (let b = 0; b < s; ++b) {
                const I = l.getObj();
                if (!Number.isInteger(I))
                  throw new n.FormatError(`invalid object number in the ObjStm stream: ${I}`);
                const h = l.getObj();
                if (!Number.isInteger(h))
                  throw new n.FormatError(`invalid object offset in the ObjStm stream: ${h}`);
                g[b] = I, v[b] = h;
              }
              const r = (o.start || 0) + k, x = new Array(s);
              for (let b = 0; b < s; ++b) {
                const I = b < s - 1 ? v[b + 1] - v[b] : void 0;
                if (I < 0)
                  throw new n.FormatError("Invalid offset in the ObjStm stream.");
                l = new q.Parser({
                  lexer: new q.Lexer(o.makeSubStream(r + v[b], I, o.dict)),
                  xref: this,
                  allowStreams: !0
                });
                const h = l.getObj();
                if (x[b] = h, h instanceof t.BaseStream)
                  continue;
                const y = g[b], P = this.entries[y];
                P && P.offset === i && P.gen === b && this._cacheMap.set(y, h);
              }
              if (w = x[w.gen], w === void 0)
                throw new e.XRefEntryException(`Bad (compressed) XRef entry: ${O}`);
              return w;
            }
            async fetchIfRefAsync(O, w) {
              return O instanceof u.Ref ? this.fetchAsync(O, w) : O;
            }
            async fetchAsync(O, w) {
              try {
                return this.fetch(O, w);
              } catch (C) {
                if (!(C instanceof e.MissingDataException))
                  throw C;
                return await this.pdfManager.requestRange(C.begin, C.end), this.fetchAsync(O, w);
              }
            }
            getCatalogObj() {
              return this.root;
            }
          }
          F.XRef = j;
        },
        /* 103 */
        /***/
        (xe, F) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.isNodeJS = void 0;
          const ae = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          F.isNodeJS = ae;
        },
        /* 104 */
        /***/
        (xe, F, ae) => {
          var B, gi, M, pi, w, Fn;
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.MessageHandler = void 0;
          var n = ae(2);
          const u = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, q = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function e(i) {
            switch (i instanceof Error || typeof i == "object" && i !== null || (0, n.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), i.name) {
              case "AbortException":
                return new n.AbortException(i.message);
              case "MissingPDFException":
                return new n.MissingPDFException(i.message);
              case "PasswordException":
                return new n.PasswordException(i.message, i.code);
              case "UnexpectedResponseException":
                return new n.UnexpectedResponseException(i.message, i.status);
              case "UnknownErrorException":
                return new n.UnknownErrorException(i.message, i.details);
              default:
                return new n.UnknownErrorException(i.message, i.toString());
            }
          }
          class t {
            constructor(o, k, s) {
              Be(this, B);
              Be(this, M);
              Be(this, w);
              this.sourceName = o, this.targetName = k, this.comObj = s, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (l) => {
                const g = l.data;
                if (g.targetName !== this.sourceName)
                  return;
                if (g.stream) {
                  ze(this, M, pi).call(this, g);
                  return;
                }
                if (g.callback) {
                  const r = g.callbackId, x = this.callbackCapabilities[r];
                  if (!x)
                    throw new Error(`Cannot resolve callback ${r}`);
                  if (delete this.callbackCapabilities[r], g.callback === u.DATA)
                    x.resolve(g.data);
                  else if (g.callback === u.ERROR)
                    x.reject(e(g.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const v = this.actionHandler[g.action];
                if (!v)
                  throw new Error(`Unknown action from worker: ${g.action}`);
                if (g.callbackId) {
                  const r = this.sourceName, x = g.sourceName;
                  new Promise(function(b) {
                    b(v(g.data));
                  }).then(function(b) {
                    s.postMessage({
                      sourceName: r,
                      targetName: x,
                      callback: u.DATA,
                      callbackId: g.callbackId,
                      data: b
                    });
                  }, function(b) {
                    s.postMessage({
                      sourceName: r,
                      targetName: x,
                      callback: u.ERROR,
                      callbackId: g.callbackId,
                      reason: e(b)
                    });
                  });
                  return;
                }
                if (g.streamId) {
                  ze(this, B, gi).call(this, g);
                  return;
                }
                v(g.data);
              }, s.addEventListener("message", this._onComObjOnMessage);
            }
            on(o, k) {
              const s = this.actionHandler;
              if (s[o])
                throw new Error(`There is already an actionName called "${o}"`);
              s[o] = k;
            }
            send(o, k, s) {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: o,
                data: k
              }, s);
            }
            sendWithPromise(o, k, s) {
              const l = this.callbackId++, g = new n.PromiseCapability();
              this.callbackCapabilities[l] = g;
              try {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: o,
                  callbackId: l,
                  data: k
                }, s);
              } catch (v) {
                g.reject(v);
              }
              return g.promise;
            }
            sendWithStream(o, k, s, l) {
              const g = this.streamId++, v = this.sourceName, r = this.targetName, x = this.comObj;
              return new ReadableStream({
                start: (b) => {
                  const I = new n.PromiseCapability();
                  return this.streamControllers[g] = {
                    controller: b,
                    startCall: I,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, x.postMessage({
                    sourceName: v,
                    targetName: r,
                    action: o,
                    streamId: g,
                    data: k,
                    desiredSize: b.desiredSize
                  }, l), I.promise;
                },
                pull: (b) => {
                  const I = new n.PromiseCapability();
                  return this.streamControllers[g].pullCall = I, x.postMessage({
                    sourceName: v,
                    targetName: r,
                    stream: q.PULL,
                    streamId: g,
                    desiredSize: b.desiredSize
                  }), I.promise;
                },
                cancel: (b) => {
                  (0, n.assert)(b instanceof Error, "cancel must have a valid reason");
                  const I = new n.PromiseCapability();
                  return this.streamControllers[g].cancelCall = I, this.streamControllers[g].isClosed = !0, x.postMessage({
                    sourceName: v,
                    targetName: r,
                    stream: q.CANCEL,
                    streamId: g,
                    reason: e(b)
                  }), I.promise;
                }
              }, s);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          B = new WeakSet(), gi = function(o) {
            const k = o.streamId, s = this.sourceName, l = o.sourceName, g = this.comObj, v = this, r = this.actionHandler[o.action], x = {
              enqueue(b, I = 1, h) {
                if (this.isCancelled)
                  return;
                const y = this.desiredSize;
                this.desiredSize -= I, y > 0 && this.desiredSize <= 0 && (this.sinkCapability = new n.PromiseCapability(), this.ready = this.sinkCapability.promise), g.postMessage({
                  sourceName: s,
                  targetName: l,
                  stream: q.ENQUEUE,
                  streamId: k,
                  chunk: b
                }, h);
              },
              close() {
                this.isCancelled || (this.isCancelled = !0, g.postMessage({
                  sourceName: s,
                  targetName: l,
                  stream: q.CLOSE,
                  streamId: k
                }), delete v.streamSinks[k]);
              },
              error(b) {
                (0, n.assert)(b instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, g.postMessage({
                  sourceName: s,
                  targetName: l,
                  stream: q.ERROR,
                  streamId: k,
                  reason: e(b)
                }));
              },
              sinkCapability: new n.PromiseCapability(),
              onPull: null,
              onCancel: null,
              isCancelled: !1,
              desiredSize: o.desiredSize,
              ready: null
            };
            x.sinkCapability.resolve(), x.ready = x.sinkCapability.promise, this.streamSinks[k] = x, new Promise(function(b) {
              b(r(o.data, x));
            }).then(function() {
              g.postMessage({
                sourceName: s,
                targetName: l,
                stream: q.START_COMPLETE,
                streamId: k,
                success: !0
              });
            }, function(b) {
              g.postMessage({
                sourceName: s,
                targetName: l,
                stream: q.START_COMPLETE,
                streamId: k,
                reason: e(b)
              });
            });
          }, M = new WeakSet(), pi = function(o) {
            const k = o.streamId, s = this.sourceName, l = o.sourceName, g = this.comObj, v = this.streamControllers[k], r = this.streamSinks[k];
            switch (o.stream) {
              case q.START_COMPLETE:
                o.success ? v.startCall.resolve() : v.startCall.reject(e(o.reason));
                break;
              case q.PULL_COMPLETE:
                o.success ? v.pullCall.resolve() : v.pullCall.reject(e(o.reason));
                break;
              case q.PULL:
                if (!r) {
                  g.postMessage({
                    sourceName: s,
                    targetName: l,
                    stream: q.PULL_COMPLETE,
                    streamId: k,
                    success: !0
                  });
                  break;
                }
                r.desiredSize <= 0 && o.desiredSize > 0 && r.sinkCapability.resolve(), r.desiredSize = o.desiredSize, new Promise(function(x) {
                  var b;
                  x((b = r.onPull) == null ? void 0 : b.call(r));
                }).then(function() {
                  g.postMessage({
                    sourceName: s,
                    targetName: l,
                    stream: q.PULL_COMPLETE,
                    streamId: k,
                    success: !0
                  });
                }, function(x) {
                  g.postMessage({
                    sourceName: s,
                    targetName: l,
                    stream: q.PULL_COMPLETE,
                    streamId: k,
                    reason: e(x)
                  });
                });
                break;
              case q.ENQUEUE:
                if ((0, n.assert)(v, "enqueue should have stream controller"), v.isClosed)
                  break;
                v.controller.enqueue(o.chunk);
                break;
              case q.CLOSE:
                if ((0, n.assert)(v, "close should have stream controller"), v.isClosed)
                  break;
                v.isClosed = !0, v.controller.close(), ze(this, w, Fn).call(this, v, k);
                break;
              case q.ERROR:
                (0, n.assert)(v, "error should have stream controller"), v.controller.error(e(o.reason)), ze(this, w, Fn).call(this, v, k);
                break;
              case q.CANCEL_COMPLETE:
                o.success ? v.cancelCall.resolve() : v.cancelCall.reject(e(o.reason)), ze(this, w, Fn).call(this, v, k);
                break;
              case q.CANCEL:
                if (!r)
                  break;
                new Promise(function(x) {
                  var b;
                  x((b = r.onCancel) == null ? void 0 : b.call(r, e(o.reason)));
                }).then(function() {
                  g.postMessage({
                    sourceName: s,
                    targetName: l,
                    stream: q.CANCEL_COMPLETE,
                    streamId: k,
                    success: !0
                  });
                }, function(x) {
                  g.postMessage({
                    sourceName: s,
                    targetName: l,
                    stream: q.CANCEL_COMPLETE,
                    streamId: k,
                    reason: e(x)
                  });
                }), r.sinkCapability.reject(e(o.reason)), r.isCancelled = !0, delete this.streamSinks[k];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }, w = new WeakSet(), Fn = async function(o, k) {
            var s, l, g;
            await Promise.allSettled([(s = o.startCall) == null ? void 0 : s.promise, (l = o.pullCall) == null ? void 0 : l.promise, (g = o.cancelCall) == null ? void 0 : g.promise]), delete this.streamControllers[k];
          }, F.MessageHandler = t;
        },
        /* 105 */
        /***/
        (xe, F, ae) => {
          Object.defineProperty(F, "__esModule", {
            value: !0
          }), F.PDFWorkerStream = void 0;
          var n = ae(2);
          class u {
            constructor(B) {
              this._msgHandler = B, this._contentLength = null, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            getFullReader() {
              return (0, n.assert)(!this._fullRequestReader, "PDFWorkerStream.getFullReader can only be called once."), this._fullRequestReader = new q(this._msgHandler), this._fullRequestReader;
            }
            getRangeReader(B, j) {
              const M = new e(B, j, this._msgHandler);
              return this._rangeRequestReaders.push(M), M;
            }
            cancelAllRequests(B) {
              this._fullRequestReader && this._fullRequestReader.cancel(B);
              for (const j of this._rangeRequestReaders.slice(0))
                j.cancel(B);
            }
          }
          F.PDFWorkerStream = u;
          class q {
            constructor(B) {
              this._msgHandler = B, this.onProgress = null, this._contentLength = null, this._isRangeSupported = !1, this._isStreamingSupported = !1;
              const j = this._msgHandler.sendWithStream("GetReader");
              this._reader = j.getReader(), this._headersReady = this._msgHandler.sendWithPromise("ReaderHeadersReady").then((M) => {
                this._isStreamingSupported = M.isStreamingSupported, this._isRangeSupported = M.isRangeSupported, this._contentLength = M.contentLength;
              });
            }
            get headersReady() {
              return this._headersReady;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            async read() {
              const {
                value: B,
                done: j
              } = await this._reader.read();
              return j ? {
                value: void 0,
                done: !0
              } : {
                value: B.buffer,
                done: !1
              };
            }
            cancel(B) {
              this._reader.cancel(B);
            }
          }
          class e {
            constructor(B, j, M) {
              this._msgHandler = M, this.onProgress = null;
              const O = this._msgHandler.sendWithStream("GetRangeReader", {
                begin: B,
                end: j
              });
              this._reader = O.getReader();
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              const {
                value: B,
                done: j
              } = await this._reader.read();
              return j ? {
                value: void 0,
                done: !0
              } : {
                value: B.buffer,
                done: !1
              };
            }
            cancel(B) {
              this._reader.cancel(B);
            }
          }
        }
        /******/
      ], ue = {};
      function me(xe) {
        var F = ue[xe];
        if (F !== void 0)
          return F.exports;
        var ae = ue[xe] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return ke[xe](ae, ae.exports, me), ae.exports;
      }
      me.d = (xe, F) => {
        for (var ae in F)
          me.o(F, ae) && !me.o(xe, ae) && Object.defineProperty(xe, ae, { enumerable: !0, get: F[ae] });
      }, me.o = (xe, F) => Object.prototype.hasOwnProperty.call(xe, F), me.r = (xe) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(xe, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(xe, "__esModule", { value: !0 });
      };
      var Me = {};
      return (() => {
        var xe = Me;
        Object.defineProperty(xe, "__esModule", {
          value: !0
        }), Object.defineProperty(xe, "WorkerMessageHandler", {
          enumerable: !0,
          get: function() {
            return F.WorkerMessageHandler;
          }
        });
        var F = me(1);
      })(), Me;
    })()
  ));
})(pdf_worker);
var pdf_workerExports = pdf_worker.exports;
(typeof window < "u" ? window : {}).pdfjsWorker = pdf_workerExports;
const packageMetadata = {
  name: "@progress/kendo-react-pdf-viewer",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1695803154,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui/my-license/?utm_medium=product&utm_source=kendoreact&utm_campaign=kendo-ui-react-purchase-license-keys-warning"
};
var proxy = function(Se, he) {
  return function(ke) {
    return he(Se(ke));
  };
}, bind = function(Se, he, ke) {
  return Se.addEventListener && Se.addEventListener(he, ke);
}, unbind = function(Se, he, ke) {
  return Se && Se.removeEventListener && Se.removeEventListener(he, ke);
}, noop = function() {
}, preventDefault$1 = function(Se) {
  return Se.preventDefault();
}, touchRegExp = /touch/, IGNORE_MOUSE_TIMEOUT = 2e3;
function normalizeEvent(Se) {
  return Se.type.match(touchRegExp) ? {
    pageX: Se.changedTouches[0].pageX,
    pageY: Se.changedTouches[0].pageY,
    clientX: Se.changedTouches[0].clientX,
    clientY: Se.changedTouches[0].clientY,
    type: Se.type,
    originalEvent: Se,
    isTouch: !0
  } : {
    pageX: Se.pageX,
    pageY: Se.pageY,
    clientX: Se.clientX,
    clientY: Se.clientY,
    offsetX: Se.offsetX,
    offsetY: Se.offsetY,
    type: Se.type,
    ctrlKey: Se.ctrlKey,
    shiftKey: Se.shiftKey,
    altKey: Se.altKey,
    originalEvent: Se
  };
}
var Draggable = function(he) {
  var ke = this, ue = he.press;
  ue === void 0 && (ue = noop);
  var me = he.drag;
  me === void 0 && (me = noop);
  var Me = he.release;
  Me === void 0 && (Me = noop);
  var xe = he.mouseOnly;
  xe === void 0 && (xe = !1), this._pressHandler = proxy(normalizeEvent, ue), this._dragHandler = proxy(normalizeEvent, me), this._releaseHandler = proxy(normalizeEvent, Me), this._ignoreMouse = !1, this._mouseOnly = xe, this._touchstart = function(F) {
    F.touches.length === 1 && ke._pressHandler(F);
  }, this._touchmove = function(F) {
    F.touches.length === 1 && ke._dragHandler(F);
  }, this._touchend = function(F) {
    F.touches.length === 0 && F.changedTouches.length === 1 && (ke._releaseHandler(F), ke._ignoreMouse = !0, setTimeout(ke._restoreMouse, IGNORE_MOUSE_TIMEOUT));
  }, this._restoreMouse = function() {
    ke._ignoreMouse = !1;
  }, this._mousedown = function(F) {
    var ae = F.which;
    ae && ae > 1 || ke._ignoreMouse || (bind(ke.document, "mousemove", ke._mousemove), bind(ke.document, "mouseup", ke._mouseup), ke._pressHandler(F));
  }, this._mousemove = function(F) {
    ke._dragHandler(F);
  }, this._mouseup = function(F) {
    unbind(ke.document, "mousemove", ke._mousemove), unbind(ke.document, "mouseup", ke._mouseup), ke._releaseHandler(F);
  }, this._pointerdown = function(F) {
    F.isPrimary && F.button === 0 && (bind(ke.document, "pointermove", ke._pointermove), bind(ke.document, "pointerup", ke._pointerup), bind(ke.document, "pointercancel", ke._pointerup), bind(ke.document, "contextmenu", preventDefault$1), ke._pressHandler(F));
  }, this._pointermove = function(F) {
    F.isPrimary && ke._dragHandler(F);
  }, this._pointerup = function(F) {
    F.isPrimary && (unbind(ke.document, "pointermove", ke._pointermove), unbind(ke.document, "pointerup", ke._pointerup), unbind(ke.document, "pointercancel", ke._pointerup), unbind(ke.document, "contextmenu", preventDefault$1), ke._releaseHandler(F));
  };
}, prototypeAccessors = { document: { configurable: !0 } };
Draggable.supportPointerEvent = function() {
  return typeof window < "u" && window.PointerEvent;
};
prototypeAccessors.document.get = function() {
  return this._element ? this._element.ownerDocument : document;
};
Draggable.prototype.bindTo = function(he) {
  he !== this._element && (this._element && this._unbindFromCurrent(), this._element = he, this._bindToCurrent());
};
Draggable.prototype._bindToCurrent = function() {
  var he = this._element;
  if (this._usePointers()) {
    bind(he, "pointerdown", this._pointerdown);
    return;
  }
  bind(he, "mousedown", this._mousedown), this._mouseOnly || (bind(he, "touchstart", this._touchstart), bind(he, "touchmove", this._touchmove), bind(he, "touchend", this._touchend));
};
Draggable.prototype._unbindFromCurrent = function() {
  var he = this._element;
  if (this._usePointers()) {
    unbind(he, "pointerdown", this._pointerdown), unbind(this.document, "pointermove", this._pointermove), unbind(this.document, "pointerup", this._pointerup), unbind(this.document, "contextmenu", preventDefault$1), unbind(this.document, "pointercancel", this._pointerup);
    return;
  }
  unbind(he, "mousedown", this._mousedown), this._mouseOnly || (unbind(he, "touchstart", this._touchstart), unbind(he, "touchmove", this._touchmove), unbind(he, "touchend", this._touchend));
};
Draggable.prototype._usePointers = function() {
  return !this._mouseOnly && Draggable.supportPointerEvent();
};
Draggable.prototype.update = function(he) {
  var ke = he.press;
  ke === void 0 && (ke = noop);
  var ue = he.drag;
  ue === void 0 && (ue = noop);
  var me = he.release;
  me === void 0 && (me = noop);
  var Me = he.mouseOnly;
  Me === void 0 && (Me = !1), this._pressHandler = proxy(normalizeEvent, ke), this._dragHandler = proxy(normalizeEvent, ue), this._releaseHandler = proxy(normalizeEvent, me), this._mouseOnly = Me;
};
Draggable.prototype.destroy = function() {
  this._unbindFromCurrent(), this._element = null;
};
Object.defineProperties(Draggable.prototype, prototypeAccessors);
Draggable.default = Draggable;
const throttle = function(Se, he, ke = {}) {
  let ue, me, Me, xe, F = 0;
  const ae = function() {
    F = ke.leading === !1 ? 0 : (/* @__PURE__ */ new Date()).getTime(), ue = void 0, xe = Se.apply(me, Me), ue || (me = Me = null);
  };
  return function() {
    const u = (/* @__PURE__ */ new Date()).getTime();
    !F && ke.leading === !1 && (F = u);
    const q = he - (u - F);
    return me = void 0, Me = arguments, q <= 0 || q > he ? (ue && (clearTimeout(ue), ue = void 0), F = u, xe = Se.apply(me, Me), ue || (me = Me = null)) : !ue && ke.trailing !== !1 && (ue = window.setTimeout(ae, q)), xe;
  };
}, preventDefault = (Se) => {
  Se.preventDefault && Se.preventDefault(), Se.originalEvent && Se.originalEvent.preventDefault();
}, matchesElementSelector = (Se, he) => !Se || !he ? !1 : Se.closest(he), FRAMES_PER_SECOND = 1e3 / 60, SCROLL = "scroll";
class Scroller {
  constructor(he, ke) {
    this.options = {
      events: {
        [SCROLL]: () => {
        }
      },
      filter: "",
      // throttle the scroll events to get a more similar experience
      // to the scrolling behavior in Adobe Acrobat Reader
      // as well as allow a way to improve the scrolling performance for large files
      panScrollThrottleDelay: FRAMES_PER_SECOND,
      // the drag directions are actually reversed, e.g.
      // dragging to the right actually moves the document to the left
      scrollDirectionModifier: -1,
      scrollThrottleDelay: FRAMES_PER_SECOND
    }, this.onElementScroll = () => {
      const ue = this.element;
      this.state.trackNextElementScroll ? this.scrollTo(ue.scrollLeft, ue.scrollTop) : this.state.trackNextElementScroll = !0;
    }, this.onDragStart = (ue) => {
      if (this.state.dragStarted = !1, !this.shouldTrackPanEvents())
        return;
      const me = ue.target || (ue.originalEvent || {}).target;
      this.options.filter && !matchesElementSelector(me, this.options.filter) || (preventDefault(ue), this.setState({
        dragStarted: !0,
        location: {
          pageX: ue.pageX,
          pageY: ue.pageY
        },
        locationDelta: {
          x: 0,
          y: 0
        }
      }));
    }, this.onDrag = (ue) => {
      if (!this.shouldTrackPanEvents() || !this.state.dragStarted)
        return;
      this.calculateEventLocationDelta(ue), this.setState({
        location: {
          pageX: ue.pageX,
          pageY: ue.pageY
        }
      });
      const me = this.options.scrollDirectionModifier, Me = this.element.scrollLeft + me * this.state.locationDelta.x, xe = this.element.scrollTop + me * this.state.locationDelta.y;
      this.scrollTo(Me, xe);
    }, this.onDragEnd = () => {
      this.shouldTrackPanEvents();
    }, this.element = he, this.options = Object.assign({}, this.options, ke), this.resetState(), this.bindEvents();
  }
  destroy() {
    this.unbindEvents();
  }
  initDraggable() {
    this.destroyDraggable(), this.options.panScrollThrottleDelay > 0 ? this.throttledOnDrag = throttle(this.onDrag, this.options.panScrollThrottleDelay) : this.throttledOnDrag = this.onDrag, this.draggable = new Draggable({
      mouseOnly: !1,
      press: this.onDragStart,
      drag: this.throttledOnDrag,
      release: this.onDragEnd
    }), this.draggable.bindTo(this.element);
  }
  destroyDraggable() {
    this.draggable && this.draggable.destroy && (this.draggable.destroy(), this.throttledOnDrag && this.throttledOnDrag.cancel && (this.throttledOnDrag.cancel(), this.throttledOnDrag = null));
  }
  bindEvents() {
    this.bindDraggableEvents(), this.bindElementScroll();
  }
  bindDraggableEvents() {
    this.initDraggable();
  }
  bindElementScroll() {
    this.options.scrollThrottleDelay > 0 ? this.throttledOnElementScroll = throttle(this.onElementScroll, this.options.scrollThrottleDelay) : this.throttledOnElementScroll = this.onElementScroll, this.element.addEventListener(SCROLL, this.throttledOnElementScroll);
  }
  unbindEvents() {
    this.unbindElementScroll(), this.unbindDraggableEvents();
  }
  unbindDraggableEvents() {
    this.destroyDraggable();
  }
  unbindElementScroll() {
    this.throttledOnElementScroll && this.throttledOnElementScroll.cancel && (this.throttledOnElementScroll.cancel(), this.throttledOnElementScroll = null), this.element.removeEventListener(SCROLL, this.throttledOnElementScroll);
  }
  setState(he) {
    this.state = Object.assign({}, this.state || {}, he);
  }
  resetState() {
    this.setState({
      trackPanEvents: !1,
      trackNextElementScroll: !1,
      location: { pageX: 0, pageY: 0 },
      locationDelta: { x: 0, y: 0 }
    });
  }
  enablePanEventsTracking() {
    this.state.trackPanEvents = !0, this.bindDraggableEvents();
  }
  disablePanEventsTracking() {
    this.unbindDraggableEvents(), this.state.trackPanEvents = !1;
  }
  shouldTrackPanEvents() {
    return this.state.trackPanEvents;
  }
  calculateEventLocationDelta(he) {
    this.state.locationDelta = {
      x: he.pageX - this.state.location.pageX,
      y: he.pageY - this.state.location.pageY
    };
  }
  scrollTo(he, ke, ue = { trackScrollEvent: !0 }) {
    ue.trackScrollEvent || (this.state.trackNextElementScroll = !1), this.element.scrollLeft = he, this.element.scrollTop = ke;
  }
}
const unwrapElement = (Se) => {
  const he = Se.parentElement;
  !Se || !he || he.replaceWith(...Array.from(he.childNodes));
}, unwrapElements = (Se) => {
  if (!(!Se || !Se.length || Se.length <= 0))
    for (let he = 0; he < Se.length; he++)
      unwrapElement(Se[he]);
}, wrapElement = (Se, he) => {
  Se.parentNode && (Se.parentNode.insertBefore(he, Se), he.appendChild(Se));
}, wrapInnerElement = (Se, he) => {
  if (!(!Se || !Se.parentNode || !he))
    for (Se.appendChild(he); Se.firstChild && Se.firstChild !== he; )
      he.appendChild(Se.firstChild);
}, addClass = (Se, he) => {
  he.classList.add(Se);
}, removeClass = (Se, he) => {
  he.classList.remove(Se);
}, toClassSelector = (Se) => `.${Se}`, CHAR_INDEX_DATA_ATTR = "data-char-index", MATCH_INDEX_DATA_ATTR = "data-match-index";
class SearchService {
  constructor(he) {
    this.options = {
      highlightClass: "k-search-highlight",
      highlightMarkClass: "k-search-highlight-mark",
      charClass: "k-text-char",
      textContainers: []
    }, this.extendOptions(he), this.resetState();
  }
  destroy() {
    this.clearSearch();
  }
  extendOptions(he) {
    this.options = Object.assign({}, this.options, he);
  }
  setState(he) {
    this.state = Object.assign({}, this.state || {}, he);
  }
  resetState() {
    this.setState({
      text: "",
      textNodes: [],
      charIndex: 0,
      activeMatchIndex: 0,
      matches: []
    });
  }
  search({ text: he, matchCase: ke }) {
    let ue = new RegExp(he, ke ? "g" : "ig"), me;
    if (this.shouldTransformText() && this.transformTextForSearch(), this.state.matches = [], this.state.activeMatchIndex = 0, this.removeIndicators(), he === "")
      return [];
    for (me = ue.exec(this.state.text); me; )
      this.state.matches.push({
        startOffset: me.index,
        endOffset: me.index + me[0].length
      }), me = ue.exec(this.state.text);
    return this.highlightAllMatches(), this.addActiveMatchMark(), this.state.matches;
  }
  clearSearch() {
    this.removeIndicators(), this.restoreOriginalText();
  }
  restoreOriginalText() {
    this.forEachTextContainer((he) => {
      Array.from(he.querySelectorAll("span:not(." + this.options.charClass + ")")).forEach((ue) => {
        ue.innerHTML = ue.textContent;
      });
    });
  }
  shouldTransformText() {
    return !this.state.text;
  }
  transformTextForSearch() {
    this.state.textNodes = [], this.state.charIndex = 0, this.state.text = "", this.forEachTextContainer((he) => {
      this.extractTextNodes(he);
    }), this.transformTextNodesForSearch(this.state.textNodes);
  }
  extractTextNodes(he) {
    if (he.nodeType === Node.TEXT_NODE)
      this.state.textNodes.push(he);
    else
      for (let ke = 0; ke < he.childNodes.length; ke++)
        this.extractTextNodes(he.childNodes[ke]);
  }
  transformTextNodesForSearch(he) {
    for (let ke = 0; ke < he.length; ke++)
      this.transformTextNodeForSearch(he[ke]);
  }
  transformTextNodeForSearch(he) {
    const ke = he.textContent;
    if (ke.length <= 0)
      return;
    this.state.text = this.state.text + ke;
    const ue = document.createElement("span");
    wrapElement(he, ue);
    const me = this.splitTextByChars(ke);
    ue.innerHTML = me, unwrapElement(ue.childNodes[0]);
  }
  splitTextByChars(he) {
    let ke = "";
    for (let ue = 0; ue < he.length; ue++)
      ke += `<span class='${this.options.charClass}' ${CHAR_INDEX_DATA_ATTR}=${this.state.charIndex}>${he[ue]}</span>`, this.state.charIndex++;
    return ke;
  }
  forEachTextContainer(he) {
    for (let ke = 0; ke < this.options.textContainers.length; ke++) {
      const ue = this.options.textContainers[ke];
      he(ue, ke);
    }
  }
  highlightAllMatches() {
    this.state.matches.forEach((he, ke) => {
      this.addMatchHighlight(he.startOffset, he.endOffset, ke);
    });
  }
  addMatchHighlight(he, ke, ue) {
    for (let me = he; me < ke; me++)
      this.forEachTextContainer((Me) => {
        Array.from(Me.querySelectorAll(toClassSelector(`${this.options.charClass}[${CHAR_INDEX_DATA_ATTR}='${me}']`))).forEach((F) => {
          addClass(this.options.highlightClass, F), F.setAttribute(MATCH_INDEX_DATA_ATTR, ue);
        });
      });
  }
  removeMatchHighlights() {
    this.forEachTextContainer((he) => {
      Array.from(he.querySelectorAll(toClassSelector(this.options.highlightClass))).forEach((ue) => {
        removeClass(this.options.highlightClass, ue), ue.removeAttribute(MATCH_INDEX_DATA_ATTR);
      });
    });
  }
  addActiveMatchMark() {
    !this.state.activeMatchIndex && this.state.activeMatchIndex !== 0 ? this.state.activeMatchIndex = 0 : this.state.activeMatchIndex > this.state.matches.length ? this.state.activeMatchIndex = this.state.matches.length : this.removeActiveMatchMark();
    const he = document.createElement("span");
    he.classList.add(this.options.highlightMarkClass), this.forEachTextContainer((ke) => {
      Array.from(ke.querySelectorAll(toClassSelector(this.options.charClass + "[" + MATCH_INDEX_DATA_ATTR + "='" + this.state.activeMatchIndex + "']"))).forEach((me) => {
        wrapInnerElement(me, he.cloneNode(!0));
      });
    });
  }
  removeActiveMatchMark() {
    this.forEachTextContainer((he) => {
      const ue = Array.from(he.querySelectorAll(toClassSelector(this.options.highlightMarkClass))).flatMap((me) => Array.from(me.childNodes));
      unwrapElements(ue);
    });
  }
  removeIndicators() {
    this.removeActiveMatchMark(), this.removeMatchHighlights();
  }
  markNextMatch() {
    this.markNextMatchIndex(), this.addActiveMatchMark();
  }
  markPreviousMatch() {
    this.markPreviousMatchIndex(), this.addActiveMatchMark();
  }
  markNextMatchIndex() {
    this.moveActiveMatchIndex(1);
  }
  markPreviousMatchIndex() {
    this.moveActiveMatchIndex(-1);
  }
  moveActiveMatchIndex(he) {
    this.state.activeMatchIndex += he, this.state.activeMatchIndex < 0 ? this.state.activeMatchIndex = Math.max(this.state.matches.length - 1, 0) : this.state.activeMatchIndex > this.state.matches.length - 1 && (this.state.activeMatchIndex = 0);
  }
  getActiveMatchElement() {
    let he;
    return this.forEachTextContainer((ke) => {
      const ue = ke.querySelector(toClassSelector(this.options.highlightMarkClass));
      if (ue) {
        he = ue;
        return;
      }
    }), he;
  }
}
function commonjsRequire(Se) {
  throw new Error('Could not dynamically require "' + Se + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var pdf = { exports: {} };
const __viteBrowserExternal = {}, __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" })), require$$5 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
(function(module, exports) {
  (function(he, ke) {
    module.exports = ke();
  })(globalThis, () => (
    /******/
    (() => {
      var __webpack_modules__ = [
        ,
        /* 1 */
        /***/
        (Se, he) => {
          var Fe;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.VerbosityLevel = he.Util = he.UnknownErrorException = he.UnexpectedResponseException = he.TextRenderingMode = he.RenderingIntentFlag = he.PromiseCapability = he.PermissionFlag = he.PasswordResponses = he.PasswordException = he.PageActionEventType = he.OPS = he.MissingPDFException = he.MAX_IMAGE_SIZE_TO_CACHE = he.LINE_FACTOR = he.LINE_DESCENT_FACTOR = he.InvalidPDFException = he.ImageKind = he.IDENTITY_MATRIX = he.FormatError = he.FeatureTest = he.FONT_IDENTITY_MATRIX = he.DocumentActionEventType = he.CMapCompressionType = he.BaseException = he.BASELINE_FACTOR = he.AnnotationType = he.AnnotationStateModelType = he.AnnotationReviewState = he.AnnotationReplyType = he.AnnotationMode = he.AnnotationMarkedState = he.AnnotationFlag = he.AnnotationFieldFlag = he.AnnotationEditorType = he.AnnotationEditorPrefix = he.AnnotationEditorParamsType = he.AnnotationBorderStyleType = he.AnnotationActionEventType = he.AbortException = void 0, he.assert = N, he.bytesToString = V, he.createValidAbsoluteUrl = H, he.getModificationDate = se, he.getVerbosityLevel = P, he.info = c, he.isArrayBuffer = te, he.isArrayEqual = oe, he.normalizeUnicode = Ie, he.objectFromMap = R, he.objectSize = X, he.setVerbosityLevel = y, he.shadow = $, he.string32 = Q, he.stringToBytes = U, he.stringToPDFString = ne, he.stringToUTF8String = re, he.unreachable = A, he.utf8StringToString = ee, he.warn = d;
          const ke = [1, 0, 0, 1, 0, 0];
          he.IDENTITY_MATRIX = ke;
          const ue = [1e-3, 0, 0, 1e-3, 0, 0];
          he.FONT_IDENTITY_MATRIX = ue;
          const me = 1e7;
          he.MAX_IMAGE_SIZE_TO_CACHE = me;
          const Me = 1.35;
          he.LINE_FACTOR = Me;
          const xe = 0.35;
          he.LINE_DESCENT_FACTOR = xe;
          const F = xe / Me;
          he.BASELINE_FACTOR = F;
          const ae = {
            ANY: 1,
            DISPLAY: 2,
            PRINT: 4,
            SAVE: 8,
            ANNOTATIONS_FORMS: 16,
            ANNOTATIONS_STORAGE: 32,
            ANNOTATIONS_DISABLE: 64,
            OPLIST: 256
          };
          he.RenderingIntentFlag = ae;
          const n = {
            DISABLE: 0,
            ENABLE: 1,
            ENABLE_FORMS: 2,
            ENABLE_STORAGE: 3
          };
          he.AnnotationMode = n;
          const u = "pdfjs_internal_editor_";
          he.AnnotationEditorPrefix = u;
          const q = {
            DISABLE: -1,
            NONE: 0,
            FREETEXT: 3,
            INK: 15
          };
          he.AnnotationEditorType = q;
          const e = {
            FREETEXT_SIZE: 1,
            FREETEXT_COLOR: 2,
            FREETEXT_OPACITY: 3,
            INK_COLOR: 11,
            INK_THICKNESS: 12,
            INK_OPACITY: 13
          };
          he.AnnotationEditorParamsType = e;
          const t = {
            PRINT: 4,
            MODIFY_CONTENTS: 8,
            COPY: 16,
            MODIFY_ANNOTATIONS: 32,
            FILL_INTERACTIVE_FORMS: 256,
            COPY_FOR_ACCESSIBILITY: 512,
            ASSEMBLE: 1024,
            PRINT_HIGH_QUALITY: 2048
          };
          he.PermissionFlag = t;
          const B = {
            FILL: 0,
            STROKE: 1,
            FILL_STROKE: 2,
            INVISIBLE: 3,
            FILL_ADD_TO_PATH: 4,
            STROKE_ADD_TO_PATH: 5,
            FILL_STROKE_ADD_TO_PATH: 6,
            ADD_TO_PATH: 7,
            FILL_STROKE_MASK: 3,
            ADD_TO_PATH_FLAG: 4
          };
          he.TextRenderingMode = B;
          const j = {
            GRAYSCALE_1BPP: 1,
            RGB_24BPP: 2,
            RGBA_32BPP: 3
          };
          he.ImageKind = j;
          const M = {
            TEXT: 1,
            LINK: 2,
            FREETEXT: 3,
            LINE: 4,
            SQUARE: 5,
            CIRCLE: 6,
            POLYGON: 7,
            POLYLINE: 8,
            HIGHLIGHT: 9,
            UNDERLINE: 10,
            SQUIGGLY: 11,
            STRIKEOUT: 12,
            STAMP: 13,
            CARET: 14,
            INK: 15,
            POPUP: 16,
            FILEATTACHMENT: 17,
            SOUND: 18,
            MOVIE: 19,
            WIDGET: 20,
            SCREEN: 21,
            PRINTERMARK: 22,
            TRAPNET: 23,
            WATERMARK: 24,
            THREED: 25,
            REDACT: 26
          };
          he.AnnotationType = M;
          const O = {
            MARKED: "Marked",
            REVIEW: "Review"
          };
          he.AnnotationStateModelType = O;
          const w = {
            MARKED: "Marked",
            UNMARKED: "Unmarked"
          };
          he.AnnotationMarkedState = w;
          const C = {
            ACCEPTED: "Accepted",
            REJECTED: "Rejected",
            CANCELLED: "Cancelled",
            COMPLETED: "Completed",
            NONE: "None"
          };
          he.AnnotationReviewState = C;
          const i = {
            GROUP: "Group",
            REPLY: "R"
          };
          he.AnnotationReplyType = i;
          const o = {
            INVISIBLE: 1,
            HIDDEN: 2,
            PRINT: 4,
            NOZOOM: 8,
            NOROTATE: 16,
            NOVIEW: 32,
            READONLY: 64,
            LOCKED: 128,
            TOGGLENOVIEW: 256,
            LOCKEDCONTENTS: 512
          };
          he.AnnotationFlag = o;
          const k = {
            READONLY: 1,
            REQUIRED: 2,
            NOEXPORT: 4,
            MULTILINE: 4096,
            PASSWORD: 8192,
            NOTOGGLETOOFF: 16384,
            RADIO: 32768,
            PUSHBUTTON: 65536,
            COMBO: 131072,
            EDIT: 262144,
            SORT: 524288,
            FILESELECT: 1048576,
            MULTISELECT: 2097152,
            DONOTSPELLCHECK: 4194304,
            DONOTSCROLL: 8388608,
            COMB: 16777216,
            RICHTEXT: 33554432,
            RADIOSINUNISON: 33554432,
            COMMITONSELCHANGE: 67108864
          };
          he.AnnotationFieldFlag = k;
          const s = {
            SOLID: 1,
            DASHED: 2,
            BEVELED: 3,
            INSET: 4,
            UNDERLINE: 5
          };
          he.AnnotationBorderStyleType = s;
          const l = {
            E: "Mouse Enter",
            X: "Mouse Exit",
            D: "Mouse Down",
            U: "Mouse Up",
            Fo: "Focus",
            Bl: "Blur",
            PO: "PageOpen",
            PC: "PageClose",
            PV: "PageVisible",
            PI: "PageInvisible",
            K: "Keystroke",
            F: "Format",
            V: "Validate",
            C: "Calculate"
          };
          he.AnnotationActionEventType = l;
          const g = {
            WC: "WillClose",
            WS: "WillSave",
            DS: "DidSave",
            WP: "WillPrint",
            DP: "DidPrint"
          };
          he.DocumentActionEventType = g;
          const v = {
            O: "PageOpen",
            C: "PageClose"
          };
          he.PageActionEventType = v;
          const r = {
            ERRORS: 0,
            WARNINGS: 1,
            INFOS: 5
          };
          he.VerbosityLevel = r;
          const x = {
            NONE: 0,
            BINARY: 1
          };
          he.CMapCompressionType = x;
          const b = {
            dependency: 1,
            setLineWidth: 2,
            setLineCap: 3,
            setLineJoin: 4,
            setMiterLimit: 5,
            setDash: 6,
            setRenderingIntent: 7,
            setFlatness: 8,
            setGState: 9,
            save: 10,
            restore: 11,
            transform: 12,
            moveTo: 13,
            lineTo: 14,
            curveTo: 15,
            curveTo2: 16,
            curveTo3: 17,
            closePath: 18,
            rectangle: 19,
            stroke: 20,
            closeStroke: 21,
            fill: 22,
            eoFill: 23,
            fillStroke: 24,
            eoFillStroke: 25,
            closeFillStroke: 26,
            closeEOFillStroke: 27,
            endPath: 28,
            clip: 29,
            eoClip: 30,
            beginText: 31,
            endText: 32,
            setCharSpacing: 33,
            setWordSpacing: 34,
            setHScale: 35,
            setLeading: 36,
            setFont: 37,
            setTextRenderingMode: 38,
            setTextRise: 39,
            moveText: 40,
            setLeadingMoveText: 41,
            setTextMatrix: 42,
            nextLine: 43,
            showText: 44,
            showSpacedText: 45,
            nextLineShowText: 46,
            nextLineSetSpacingShowText: 47,
            setCharWidth: 48,
            setCharWidthAndBounds: 49,
            setStrokeColorSpace: 50,
            setFillColorSpace: 51,
            setStrokeColor: 52,
            setStrokeColorN: 53,
            setFillColor: 54,
            setFillColorN: 55,
            setStrokeGray: 56,
            setFillGray: 57,
            setStrokeRGBColor: 58,
            setFillRGBColor: 59,
            setStrokeCMYKColor: 60,
            setFillCMYKColor: 61,
            shadingFill: 62,
            beginInlineImage: 63,
            beginImageData: 64,
            endInlineImage: 65,
            paintXObject: 66,
            markPoint: 67,
            markPointProps: 68,
            beginMarkedContent: 69,
            beginMarkedContentProps: 70,
            endMarkedContent: 71,
            beginCompat: 72,
            endCompat: 73,
            paintFormXObjectBegin: 74,
            paintFormXObjectEnd: 75,
            beginGroup: 76,
            endGroup: 77,
            beginAnnotation: 80,
            endAnnotation: 81,
            paintImageMaskXObject: 83,
            paintImageMaskXObjectGroup: 84,
            paintImageXObject: 85,
            paintInlineImageXObject: 86,
            paintInlineImageXObjectGroup: 87,
            paintImageXObjectRepeat: 88,
            paintImageMaskXObjectRepeat: 89,
            paintSolidColorImageMask: 90,
            constructPath: 91
          };
          he.OPS = b;
          const I = {
            NEED_PASSWORD: 1,
            INCORRECT_PASSWORD: 2
          };
          he.PasswordResponses = I;
          let h = r.WARNINGS;
          function y(we) {
            Number.isInteger(we) && (h = we);
          }
          function P() {
            return h;
          }
          function c(we) {
            h >= r.INFOS && console.log(`Info: ${we}`);
          }
          function d(we) {
            h >= r.WARNINGS && console.log(`Warning: ${we}`);
          }
          function A(we) {
            throw new Error(we);
          }
          function N(we, pe) {
            we || A(pe);
          }
          function E(we) {
            switch (we == null ? void 0 : we.protocol) {
              case "http:":
              case "https:":
              case "ftp:":
              case "mailto:":
              case "tel:":
                return !0;
              default:
                return !1;
            }
          }
          function H(we, pe = null, fe = null) {
            if (!we)
              return null;
            try {
              if (fe && typeof we == "string") {
                if (fe.addDefaultProtocol && we.startsWith("www.")) {
                  const Pe = we.match(/\./g);
                  (Pe == null ? void 0 : Pe.length) >= 2 && (we = `http://${we}`);
                }
                if (fe.tryConvertEncoding)
                  try {
                    we = re(we);
                  } catch {
                  }
              }
              const Ae = pe ? new URL(we, pe) : new URL(we);
              if (E(Ae))
                return Ae;
            } catch {
            }
            return null;
          }
          function $(we, pe, fe, Ae = !1) {
            return Object.defineProperty(we, pe, {
              value: fe,
              enumerable: !Ae,
              configurable: !0,
              writable: !1
            }), fe;
          }
          const m = function() {
            function pe(fe, Ae) {
              this.constructor === pe && A("Cannot initialize BaseException."), this.message = fe, this.name = Ae;
            }
            return pe.prototype = new Error(), pe.constructor = pe, pe;
          }();
          he.BaseException = m;
          class p extends m {
            constructor(pe, fe) {
              super(pe, "PasswordException"), this.code = fe;
            }
          }
          he.PasswordException = p;
          class T extends m {
            constructor(pe, fe) {
              super(pe, "UnknownErrorException"), this.details = fe;
            }
          }
          he.UnknownErrorException = T;
          class L extends m {
            constructor(pe) {
              super(pe, "InvalidPDFException");
            }
          }
          he.InvalidPDFException = L;
          class _ extends m {
            constructor(pe) {
              super(pe, "MissingPDFException");
            }
          }
          he.MissingPDFException = _;
          class G extends m {
            constructor(pe, fe) {
              super(pe, "UnexpectedResponseException"), this.status = fe;
            }
          }
          he.UnexpectedResponseException = G;
          class J extends m {
            constructor(pe) {
              super(pe, "FormatError");
            }
          }
          he.FormatError = J;
          class K extends m {
            constructor(pe) {
              super(pe, "AbortException");
            }
          }
          he.AbortException = K;
          function V(we) {
            (typeof we != "object" || (we == null ? void 0 : we.length) === void 0) && A("Invalid argument for bytesToString");
            const pe = we.length, fe = 8192;
            if (pe < fe)
              return String.fromCharCode.apply(null, we);
            const Ae = [];
            for (let Pe = 0; Pe < pe; Pe += fe) {
              const Re = Math.min(Pe + fe, pe), Ee = we.subarray(Pe, Re);
              Ae.push(String.fromCharCode.apply(null, Ee));
            }
            return Ae.join("");
          }
          function U(we) {
            typeof we != "string" && A("Invalid argument for stringToBytes");
            const pe = we.length, fe = new Uint8Array(pe);
            for (let Ae = 0; Ae < pe; ++Ae)
              fe[Ae] = we.charCodeAt(Ae) & 255;
            return fe;
          }
          function Q(we) {
            return String.fromCharCode(we >> 24 & 255, we >> 16 & 255, we >> 8 & 255, we & 255);
          }
          function X(we) {
            return Object.keys(we).length;
          }
          function R(we) {
            const pe = /* @__PURE__ */ Object.create(null);
            for (const [fe, Ae] of we)
              pe[fe] = Ae;
            return pe;
          }
          function f() {
            const we = new Uint8Array(4);
            return we[0] = 1, new Uint32Array(we.buffer, 0, 1)[0] === 1;
          }
          function D() {
            try {
              return new Function(""), !0;
            } catch {
              return !1;
            }
          }
          class z {
            static get isLittleEndian() {
              return $(this, "isLittleEndian", f());
            }
            static get isEvalSupported() {
              return $(this, "isEvalSupported", D());
            }
            static get isOffscreenCanvasSupported() {
              return $(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas < "u");
            }
            static get platform() {
              return typeof navigator > "u" ? $(this, "platform", {
                isWin: !1,
                isMac: !1
              }) : $(this, "platform", {
                isWin: navigator.platform.includes("Win"),
                isMac: navigator.platform.includes("Mac")
              });
            }
          }
          he.FeatureTest = z;
          const Y = [...Array(256).keys()].map((we) => we.toString(16).padStart(2, "0"));
          class W {
            static makeHexColor(pe, fe, Ae) {
              return `#${Y[pe]}${Y[fe]}${Y[Ae]}`;
            }
            static scaleMinMax(pe, fe) {
              let Ae;
              pe[0] ? (pe[0] < 0 && (Ae = fe[0], fe[0] = fe[1], fe[1] = Ae), fe[0] *= pe[0], fe[1] *= pe[0], pe[3] < 0 && (Ae = fe[2], fe[2] = fe[3], fe[3] = Ae), fe[2] *= pe[3], fe[3] *= pe[3]) : (Ae = fe[0], fe[0] = fe[2], fe[2] = Ae, Ae = fe[1], fe[1] = fe[3], fe[3] = Ae, pe[1] < 0 && (Ae = fe[2], fe[2] = fe[3], fe[3] = Ae), fe[2] *= pe[1], fe[3] *= pe[1], pe[2] < 0 && (Ae = fe[0], fe[0] = fe[1], fe[1] = Ae), fe[0] *= pe[2], fe[1] *= pe[2]), fe[0] += pe[4], fe[1] += pe[4], fe[2] += pe[5], fe[3] += pe[5];
            }
            static transform(pe, fe) {
              return [pe[0] * fe[0] + pe[2] * fe[1], pe[1] * fe[0] + pe[3] * fe[1], pe[0] * fe[2] + pe[2] * fe[3], pe[1] * fe[2] + pe[3] * fe[3], pe[0] * fe[4] + pe[2] * fe[5] + pe[4], pe[1] * fe[4] + pe[3] * fe[5] + pe[5]];
            }
            static applyTransform(pe, fe) {
              const Ae = pe[0] * fe[0] + pe[1] * fe[2] + fe[4], Pe = pe[0] * fe[1] + pe[1] * fe[3] + fe[5];
              return [Ae, Pe];
            }
            static applyInverseTransform(pe, fe) {
              const Ae = fe[0] * fe[3] - fe[1] * fe[2], Pe = (pe[0] * fe[3] - pe[1] * fe[2] + fe[2] * fe[5] - fe[4] * fe[3]) / Ae, Re = (-pe[0] * fe[1] + pe[1] * fe[0] + fe[4] * fe[1] - fe[5] * fe[0]) / Ae;
              return [Pe, Re];
            }
            static getAxialAlignedBoundingBox(pe, fe) {
              const Ae = W.applyTransform(pe, fe), Pe = W.applyTransform(pe.slice(2, 4), fe), Re = W.applyTransform([pe[0], pe[3]], fe), Ee = W.applyTransform([pe[2], pe[1]], fe);
              return [Math.min(Ae[0], Pe[0], Re[0], Ee[0]), Math.min(Ae[1], Pe[1], Re[1], Ee[1]), Math.max(Ae[0], Pe[0], Re[0], Ee[0]), Math.max(Ae[1], Pe[1], Re[1], Ee[1])];
            }
            static inverseTransform(pe) {
              const fe = pe[0] * pe[3] - pe[1] * pe[2];
              return [pe[3] / fe, -pe[1] / fe, -pe[2] / fe, pe[0] / fe, (pe[2] * pe[5] - pe[4] * pe[3]) / fe, (pe[4] * pe[1] - pe[5] * pe[0]) / fe];
            }
            static singularValueDecompose2dScale(pe) {
              const fe = [pe[0], pe[2], pe[1], pe[3]], Ae = pe[0] * fe[0] + pe[1] * fe[2], Pe = pe[0] * fe[1] + pe[1] * fe[3], Re = pe[2] * fe[0] + pe[3] * fe[2], Ee = pe[2] * fe[1] + pe[3] * fe[3], ye = (Ae + Ee) / 2, Te = Math.sqrt((Ae + Ee) ** 2 - 4 * (Ae * Ee - Re * Pe)) / 2, je = ye + Te || 1, ve = ye - Te || 1;
              return [Math.sqrt(je), Math.sqrt(ve)];
            }
            static normalizeRect(pe) {
              const fe = pe.slice(0);
              return pe[0] > pe[2] && (fe[0] = pe[2], fe[2] = pe[0]), pe[1] > pe[3] && (fe[1] = pe[3], fe[3] = pe[1]), fe;
            }
            static intersect(pe, fe) {
              const Ae = Math.max(Math.min(pe[0], pe[2]), Math.min(fe[0], fe[2])), Pe = Math.min(Math.max(pe[0], pe[2]), Math.max(fe[0], fe[2]));
              if (Ae > Pe)
                return null;
              const Re = Math.max(Math.min(pe[1], pe[3]), Math.min(fe[1], fe[3])), Ee = Math.min(Math.max(pe[1], pe[3]), Math.max(fe[1], fe[3]));
              return Re > Ee ? null : [Ae, Re, Pe, Ee];
            }
            static bezierBoundingBox(pe, fe, Ae, Pe, Re, Ee, ye, Te) {
              const je = [], ve = [[], []];
              let Ce, Ne, Ge, Oe, tt, Ke, et, Xe;
              for (let gt = 0; gt < 2; ++gt) {
                if (gt === 0 ? (Ne = 6 * pe - 12 * Ae + 6 * Re, Ce = -3 * pe + 9 * Ae - 9 * Re + 3 * ye, Ge = 3 * Ae - 3 * pe) : (Ne = 6 * fe - 12 * Pe + 6 * Ee, Ce = -3 * fe + 9 * Pe - 9 * Ee + 3 * Te, Ge = 3 * Pe - 3 * fe), Math.abs(Ce) < 1e-12) {
                  if (Math.abs(Ne) < 1e-12)
                    continue;
                  Oe = -Ge / Ne, 0 < Oe && Oe < 1 && je.push(Oe);
                  continue;
                }
                et = Ne * Ne - 4 * Ge * Ce, Xe = Math.sqrt(et), !(et < 0) && (tt = (-Ne + Xe) / (2 * Ce), 0 < tt && tt < 1 && je.push(tt), Ke = (-Ne - Xe) / (2 * Ce), 0 < Ke && Ke < 1 && je.push(Ke));
              }
              let Qe = je.length, it;
              const We = Qe;
              for (; Qe--; )
                Oe = je[Qe], it = 1 - Oe, ve[0][Qe] = it * it * it * pe + 3 * it * it * Oe * Ae + 3 * it * Oe * Oe * Re + Oe * Oe * Oe * ye, ve[1][Qe] = it * it * it * fe + 3 * it * it * Oe * Pe + 3 * it * Oe * Oe * Ee + Oe * Oe * Oe * Te;
              return ve[0][We] = pe, ve[1][We] = fe, ve[0][We + 1] = ye, ve[1][We + 1] = Te, ve[0].length = ve[1].length = We + 2, [Math.min(...ve[0]), Math.min(...ve[1]), Math.max(...ve[0]), Math.max(...ve[1])];
            }
          }
          he.Util = W;
          const ie = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 728, 711, 710, 729, 733, 731, 730, 732, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 8226, 8224, 8225, 8230, 8212, 8211, 402, 8260, 8249, 8250, 8722, 8240, 8222, 8220, 8221, 8216, 8217, 8218, 8482, 64257, 64258, 321, 338, 352, 376, 381, 305, 322, 339, 353, 382, 0, 8364];
          function ne(we) {
            if (we[0] >= "ï") {
              let fe;
              if (we[0] === "þ" && we[1] === "ÿ" ? fe = "utf-16be" : we[0] === "ÿ" && we[1] === "þ" ? fe = "utf-16le" : we[0] === "ï" && we[1] === "»" && we[2] === "¿" && (fe = "utf-8"), fe)
                try {
                  const Ae = new TextDecoder(fe, {
                    fatal: !0
                  }), Pe = U(we);
                  return Ae.decode(Pe);
                } catch (Ae) {
                  d(`stringToPDFString: "${Ae}".`);
                }
            }
            const pe = [];
            for (let fe = 0, Ae = we.length; fe < Ae; fe++) {
              const Pe = ie[we.charCodeAt(fe)];
              pe.push(Pe ? String.fromCharCode(Pe) : we.charAt(fe));
            }
            return pe.join("");
          }
          function re(we) {
            return decodeURIComponent(escape(we));
          }
          function ee(we) {
            return unescape(encodeURIComponent(we));
          }
          function te(we) {
            return typeof we == "object" && (we == null ? void 0 : we.byteLength) !== void 0;
          }
          function oe(we, pe) {
            if (we.length !== pe.length)
              return !1;
            for (let fe = 0, Ae = we.length; fe < Ae; fe++)
              if (we[fe] !== pe[fe])
                return !1;
            return !0;
          }
          function se(we = /* @__PURE__ */ new Date()) {
            return [we.getUTCFullYear().toString(), (we.getUTCMonth() + 1).toString().padStart(2, "0"), we.getUTCDate().toString().padStart(2, "0"), we.getUTCHours().toString().padStart(2, "0"), we.getUTCMinutes().toString().padStart(2, "0"), we.getUTCSeconds().toString().padStart(2, "0")].join("");
          }
          class ce {
            constructor() {
              Be(this, Fe, !1);
              this.promise = new Promise((pe, fe) => {
                this.resolve = (Ae) => {
                  rt(this, Fe, !0), pe(Ae);
                }, this.reject = (Ae) => {
                  rt(this, Fe, !0), fe(Ae);
                };
              });
            }
            get settled() {
              return ge(this, Fe);
            }
          }
          Fe = new WeakMap(), he.PromiseCapability = ce;
          let le = null, de = null;
          function Ie(we) {
            return le || (le = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu, de = /* @__PURE__ */ new Map([["ﬅ", "ſt"]])), we.replaceAll(le, (pe, fe, Ae) => fe ? fe.normalize("NFKC") : de.get(Ae));
          }
        },
        /* 2 */
        /***/
        (__unused_webpack_module, exports, __w_pdfjs_require__) => {
          var Se, ke, ue, me, un, xe, Tn, ae, n, u, q, e, t, B, j, Vn, O, w, Yn, i, o;
          Object.defineProperty(exports, "__esModule", {
            value: !0
          }), exports.build = exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0, exports.getDocument = getDocument, exports.version = void 0;
          var _util = __w_pdfjs_require__(1), _annotation_storage = __w_pdfjs_require__(3), _display_utils = __w_pdfjs_require__(6), _font_loader = __w_pdfjs_require__(9), _canvas = __w_pdfjs_require__(11), _worker_options = __w_pdfjs_require__(14), _is_node = __w_pdfjs_require__(10), _message_handler = __w_pdfjs_require__(15), _metadata = __w_pdfjs_require__(16), _optional_content_config = __w_pdfjs_require__(17), _transport_stream = __w_pdfjs_require__(18), _xfa_text = __w_pdfjs_require__(19);
          const DEFAULT_RANGE_CHUNK_SIZE = 65536, RENDERING_CANCELLED_TIMEOUT = 100, DELAYED_CLEANUP_TIMEOUT = 5e3;
          let DefaultCanvasFactory = _display_utils.DOMCanvasFactory;
          exports.DefaultCanvasFactory = DefaultCanvasFactory;
          let DefaultCMapReaderFactory = _display_utils.DOMCMapReaderFactory;
          exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
          let DefaultFilterFactory = _display_utils.DOMFilterFactory;
          exports.DefaultFilterFactory = DefaultFilterFactory;
          let DefaultStandardFontDataFactory = _display_utils.DOMStandardFontDataFactory;
          if (exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory, _is_node.isNodeJS) {
            const {
              NodeCanvasFactory: s,
              NodeCMapReaderFactory: l,
              NodeFilterFactory: g,
              NodeStandardFontDataFactory: v
            } = __w_pdfjs_require__(20);
            exports.DefaultCanvasFactory = DefaultCanvasFactory = s, exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory = l, exports.DefaultFilterFactory = DefaultFilterFactory = g, exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory = v;
          }
          let createPDFNetworkStream;
          if (_is_node.isNodeJS) {
            const {
              PDFNodeStream: s
            } = __w_pdfjs_require__(21);
            createPDFNetworkStream = (l) => new s(l);
          } else {
            const {
              PDFNetworkStream: s
            } = __w_pdfjs_require__(24), {
              PDFFetchStream: l
            } = __w_pdfjs_require__(25);
            createPDFNetworkStream = (g) => (0, _display_utils.isValidFetchUrl)(g.url) ? new l(g) : new s(g);
          }
          function getDocument(s) {
            if (typeof s == "string" || s instanceof URL ? s = {
              url: s
            } : (0, _util.isArrayBuffer)(s) && (s = {
              data: s
            }), typeof s != "object")
              throw new Error("Invalid parameter in getDocument, need parameter object.");
            if (!s.url && !s.data && !s.range)
              throw new Error("Invalid parameter object: need either .data, .range or .url");
            const l = new PDFDocumentLoadingTask(), {
              docId: g
            } = l, v = s.url ? getUrlProp(s.url) : null, r = s.data ? getDataProp(s.data) : null, x = s.httpHeaders || null, b = s.withCredentials === !0, I = s.password ?? null, h = s.range instanceof PDFDataRangeTransport ? s.range : null, y = Number.isInteger(s.rangeChunkSize) && s.rangeChunkSize > 0 ? s.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
            let P = s.worker instanceof PDFWorker ? s.worker : null;
            const c = s.verbosity, d = typeof s.docBaseUrl == "string" && !(0, _display_utils.isDataScheme)(s.docBaseUrl) ? s.docBaseUrl : null, A = typeof s.cMapUrl == "string" ? s.cMapUrl : null, N = s.cMapPacked !== !1, E = s.CMapReaderFactory || DefaultCMapReaderFactory, H = typeof s.standardFontDataUrl == "string" ? s.standardFontDataUrl : null, $ = s.StandardFontDataFactory || DefaultStandardFontDataFactory, m = s.stopAtErrors !== !0, p = Number.isInteger(s.maxImageSize) && s.maxImageSize > -1 ? s.maxImageSize : -1, T = s.isEvalSupported !== !1, L = typeof s.isOffscreenCanvasSupported == "boolean" ? s.isOffscreenCanvasSupported : !_is_node.isNodeJS, _ = Number.isInteger(s.canvasMaxAreaInBytes) ? s.canvasMaxAreaInBytes : -1, G = typeof s.disableFontFace == "boolean" ? s.disableFontFace : _is_node.isNodeJS, J = s.fontExtraProperties === !0, K = s.enableXfa === !0, V = s.ownerDocument || globalThis.document, U = s.disableRange === !0, Q = s.disableStream === !0, X = s.disableAutoFetch === !0, R = s.pdfBug === !0, f = h ? h.length : s.length ?? NaN, D = typeof s.useSystemFonts == "boolean" ? s.useSystemFonts : !_is_node.isNodeJS && !G, z = typeof s.useWorkerFetch == "boolean" ? s.useWorkerFetch : E === _display_utils.DOMCMapReaderFactory && $ === _display_utils.DOMStandardFontDataFactory && (0, _display_utils.isValidFetchUrl)(A, document.baseURI) && (0, _display_utils.isValidFetchUrl)(H, document.baseURI), Y = s.canvasFactory || new DefaultCanvasFactory({
              ownerDocument: V
            }), W = s.filterFactory || new DefaultFilterFactory({
              docId: g,
              ownerDocument: V
            }), ie = null;
            (0, _util.setVerbosityLevel)(c);
            const ne = {
              canvasFactory: Y,
              filterFactory: W
            };
            if (z || (ne.cMapReaderFactory = new E({
              baseUrl: A,
              isCompressed: N
            }), ne.standardFontDataFactory = new $({
              baseUrl: H
            })), !P) {
              const te = {
                verbosity: c,
                port: _worker_options.GlobalWorkerOptions.workerPort
              };
              P = te.port ? PDFWorker.fromPort(te) : new PDFWorker(te), l._worker = P;
            }
            const re = {
              docId: g,
              apiVersion: "3.7.107",
              data: r,
              password: I,
              disableAutoFetch: X,
              rangeChunkSize: y,
              length: f,
              docBaseUrl: d,
              enableXfa: K,
              evaluatorOptions: {
                maxImageSize: p,
                disableFontFace: G,
                ignoreErrors: m,
                isEvalSupported: T,
                isOffscreenCanvasSupported: L,
                canvasMaxAreaInBytes: _,
                fontExtraProperties: J,
                useSystemFonts: D,
                cMapUrl: z ? A : null,
                standardFontDataUrl: z ? H : null
              }
            }, ee = {
              ignoreErrors: m,
              isEvalSupported: T,
              disableFontFace: G,
              fontExtraProperties: J,
              enableXfa: K,
              ownerDocument: V,
              disableAutoFetch: X,
              pdfBug: R,
              styleElement: ie
            };
            return P.promise.then(function() {
              if (l.destroyed)
                throw new Error("Loading aborted");
              const te = _fetchDocument(P, re), oe = new Promise(function(se) {
                let ce;
                h ? ce = new _transport_stream.PDFDataTransportStream({
                  length: f,
                  initialData: h.initialData,
                  progressiveDone: h.progressiveDone,
                  contentDispositionFilename: h.contentDispositionFilename,
                  disableRange: U,
                  disableStream: Q
                }, h) : r || (ce = createPDFNetworkStream({
                  url: v,
                  length: f,
                  httpHeaders: x,
                  withCredentials: b,
                  rangeChunkSize: y,
                  disableRange: U,
                  disableStream: Q
                })), se(ce);
              });
              return Promise.all([te, oe]).then(function([se, ce]) {
                if (l.destroyed)
                  throw new Error("Loading aborted");
                const le = new _message_handler.MessageHandler(g, se, P.port), de = new WorkerTransport(le, l, ce, ee, ne);
                l._transport = de, le.send("Ready", null);
              });
            }).catch(l._capability.reject), l;
          }
          async function _fetchDocument(s, l) {
            if (s.destroyed)
              throw new Error("Worker was destroyed");
            const g = await s.messageHandler.sendWithPromise("GetDocRequest", l, l.data ? [l.data.buffer] : null);
            if (s.destroyed)
              throw new Error("Worker was destroyed");
            return g;
          }
          function getUrlProp(s) {
            if (s instanceof URL)
              return s.href;
            try {
              return new URL(s, window.location).href;
            } catch {
              if (_is_node.isNodeJS && typeof s == "string")
                return s;
            }
            throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
          }
          function getDataProp(s) {
            if (_is_node.isNodeJS && typeof Buffer < "u" && s instanceof Buffer)
              return (0, _display_utils.deprecated)("Please provide binary data as `Uint8Array`, rather than `Buffer`."), new Uint8Array(s);
            if (s instanceof Uint8Array && s.byteLength === s.buffer.byteLength)
              return s;
            if (typeof s == "string")
              return (0, _util.stringToBytes)(s);
            if (typeof s == "object" && !isNaN(s == null ? void 0 : s.length) || (0, _util.isArrayBuffer)(s))
              return new Uint8Array(s);
            throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
          }
          const he = class he {
            constructor() {
              this._capability = new _util.PromiseCapability(), this._transport = null, this._worker = null, this.docId = `d${kn(he, Se)._++}`, this.destroyed = !1, this.onPassword = null, this.onProgress = null;
            }
            get promise() {
              return this._capability.promise;
            }
            async destroy() {
              var l;
              this.destroyed = !0, await ((l = this._transport) == null ? void 0 : l.destroy()), this._transport = null, this._worker && (this._worker.destroy(), this._worker = null);
            }
          };
          Se = new WeakMap(), Be(he, Se, 0);
          let PDFDocumentLoadingTask = he;
          exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
          class PDFDataRangeTransport {
            constructor(l, g, v = !1, r = null) {
              this.length = l, this.initialData = g, this.progressiveDone = v, this.contentDispositionFilename = r, this._rangeListeners = [], this._progressListeners = [], this._progressiveReadListeners = [], this._progressiveDoneListeners = [], this._readyCapability = new _util.PromiseCapability();
            }
            addRangeListener(l) {
              this._rangeListeners.push(l);
            }
            addProgressListener(l) {
              this._progressListeners.push(l);
            }
            addProgressiveReadListener(l) {
              this._progressiveReadListeners.push(l);
            }
            addProgressiveDoneListener(l) {
              this._progressiveDoneListeners.push(l);
            }
            onDataRange(l, g) {
              for (const v of this._rangeListeners)
                v(l, g);
            }
            onDataProgress(l, g) {
              this._readyCapability.promise.then(() => {
                for (const v of this._progressListeners)
                  v(l, g);
              });
            }
            onDataProgressiveRead(l) {
              this._readyCapability.promise.then(() => {
                for (const g of this._progressiveReadListeners)
                  g(l);
              });
            }
            onDataProgressiveDone() {
              this._readyCapability.promise.then(() => {
                for (const l of this._progressiveDoneListeners)
                  l();
              });
            }
            transportReady() {
              this._readyCapability.resolve();
            }
            requestDataRange(l, g) {
              (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
            }
            abort() {
            }
          }
          exports.PDFDataRangeTransport = PDFDataRangeTransport;
          class PDFDocumentProxy {
            constructor(l, g) {
              this._pdfInfo = l, this._transport = g;
            }
            get annotationStorage() {
              return this._transport.annotationStorage;
            }
            get filterFactory() {
              return this._transport.filterFactory;
            }
            get numPages() {
              return this._pdfInfo.numPages;
            }
            get fingerprints() {
              return this._pdfInfo.fingerprints;
            }
            get isPureXfa() {
              return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
            }
            get allXfaHtml() {
              return this._transport._htmlForXfa;
            }
            getPage(l) {
              return this._transport.getPage(l);
            }
            getPageIndex(l) {
              return this._transport.getPageIndex(l);
            }
            getDestinations() {
              return this._transport.getDestinations();
            }
            getDestination(l) {
              return this._transport.getDestination(l);
            }
            getPageLabels() {
              return this._transport.getPageLabels();
            }
            getPageLayout() {
              return this._transport.getPageLayout();
            }
            getPageMode() {
              return this._transport.getPageMode();
            }
            getViewerPreferences() {
              return this._transport.getViewerPreferences();
            }
            getOpenAction() {
              return this._transport.getOpenAction();
            }
            getAttachments() {
              return this._transport.getAttachments();
            }
            getJavaScript() {
              return this._transport.getJavaScript();
            }
            getJSActions() {
              return this._transport.getDocJSActions();
            }
            getOutline() {
              return this._transport.getOutline();
            }
            getOptionalContentConfig() {
              return this._transport.getOptionalContentConfig();
            }
            getPermissions() {
              return this._transport.getPermissions();
            }
            getMetadata() {
              return this._transport.getMetadata();
            }
            getMarkInfo() {
              return this._transport.getMarkInfo();
            }
            getData() {
              return this._transport.getData();
            }
            saveDocument() {
              return this._transport.saveDocument();
            }
            getDownloadInfo() {
              return this._transport.downloadInfoCapability.promise;
            }
            cleanup(l = !1) {
              return this._transport.startCleanup(l || this.isPureXfa);
            }
            destroy() {
              return this.loadingTask.destroy();
            }
            get loadingParams() {
              return this._transport.loadingParams;
            }
            get loadingTask() {
              return this._transport.loadingTask;
            }
            getFieldObjects() {
              return this._transport.getFieldObjects();
            }
            hasJSActions() {
              return this._transport.hasJSActions();
            }
            getCalculationOrderIds() {
              return this._transport.getCalculationOrderIds();
            }
          }
          exports.PDFDocumentProxy = PDFDocumentProxy;
          class PDFPageProxy {
            constructor(l, g, v, r = !1) {
              Be(this, me);
              Be(this, xe);
              Be(this, ke, null);
              Be(this, ue, !1);
              this._pageIndex = l, this._pageInfo = g, this._transport = v, this._stats = r ? new _display_utils.StatTimer() : null, this._pdfBug = r, this.commonObjs = v.commonObjs, this.objs = new PDFObjects(), this._maybeCleanupAfterRender = !1, this._intentStates = /* @__PURE__ */ new Map(), this.destroyed = !1;
            }
            get pageNumber() {
              return this._pageIndex + 1;
            }
            get rotate() {
              return this._pageInfo.rotate;
            }
            get ref() {
              return this._pageInfo.ref;
            }
            get userUnit() {
              return this._pageInfo.userUnit;
            }
            get view() {
              return this._pageInfo.view;
            }
            getViewport({
              scale: l,
              rotation: g = this.rotate,
              offsetX: v = 0,
              offsetY: r = 0,
              dontFlip: x = !1
            } = {}) {
              return new _display_utils.PageViewport({
                viewBox: this.view,
                scale: l,
                rotation: g,
                offsetX: v,
                offsetY: r,
                dontFlip: x
              });
            }
            getAnnotations({
              intent: l = "display"
            } = {}) {
              const g = this._transport.getRenderingIntent(l);
              return this._transport.getAnnotations(this._pageIndex, g.renderingIntent);
            }
            getJSActions() {
              return this._transport.getPageJSActions(this._pageIndex);
            }
            get isPureXfa() {
              return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
            }
            async getXfa() {
              var l;
              return ((l = this._transport._htmlForXfa) == null ? void 0 : l.children[this._pageIndex]) || null;
            }
            render({
              canvasContext: l,
              viewport: g,
              intent: v = "display",
              annotationMode: r = _util.AnnotationMode.ENABLE,
              transform: x = null,
              background: b = null,
              optionalContentConfigPromise: I = null,
              annotationCanvasMap: h = null,
              pageColors: y = null,
              printAnnotationStorage: P = null
            }) {
              var $, m, p;
              if (($ = arguments[0]) != null && $.canvasFactory)
                throw new Error("render no longer accepts the `canvasFactory`-option, please pass it to the `getDocument`-function instead.");
              (m = this._stats) == null || m.time("Overall");
              const c = this._transport.getRenderingIntent(v, r, P);
              rt(this, ue, !1), ze(this, xe, Tn).call(this), I || (I = this._transport.getOptionalContentConfig());
              let d = this._intentStates.get(c.cacheKey);
              d || (d = /* @__PURE__ */ Object.create(null), this._intentStates.set(c.cacheKey, d)), d.streamReaderCancelTimeout && (clearTimeout(d.streamReaderCancelTimeout), d.streamReaderCancelTimeout = null);
              const A = !!(c.renderingIntent & _util.RenderingIntentFlag.PRINT);
              d.displayReadyCapability || (d.displayReadyCapability = new _util.PromiseCapability(), d.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1,
                separateAnnots: null
              }, (p = this._stats) == null || p.time("Page Request"), this._pumpOperatorList(c));
              const N = (T) => {
                var L, _;
                d.renderTasks.delete(E), (this._maybeCleanupAfterRender || A) && rt(this, ue, !0), ze(this, me, un).call(this, !A), T ? (E.capability.reject(T), this._abortOperatorList({
                  intentState: d,
                  reason: T instanceof Error ? T : new Error(T)
                })) : E.capability.resolve(), (L = this._stats) == null || L.timeEnd("Rendering"), (_ = this._stats) == null || _.timeEnd("Overall");
              }, E = new InternalRenderTask({
                callback: N,
                params: {
                  canvasContext: l,
                  viewport: g,
                  transform: x,
                  background: b
                },
                objs: this.objs,
                commonObjs: this.commonObjs,
                annotationCanvasMap: h,
                operatorList: d.operatorList,
                pageIndex: this._pageIndex,
                canvasFactory: this._transport.canvasFactory,
                filterFactory: this._transport.filterFactory,
                useRequestAnimationFrame: !A,
                pdfBug: this._pdfBug,
                pageColors: y
              });
              (d.renderTasks || (d.renderTasks = /* @__PURE__ */ new Set())).add(E);
              const H = E.task;
              return Promise.all([d.displayReadyCapability.promise, I]).then(([T, L]) => {
                var _;
                if (ge(this, ue)) {
                  N();
                  return;
                }
                (_ = this._stats) == null || _.time("Rendering"), E.initializeGraphics({
                  transparency: T,
                  optionalContentConfig: L
                }), E.operatorListChanged();
              }).catch(N), H;
            }
            getOperatorList({
              intent: l = "display",
              annotationMode: g = _util.AnnotationMode.ENABLE,
              printAnnotationStorage: v = null
            } = {}) {
              var h;
              function r() {
                b.operatorList.lastChunk && (b.opListReadCapability.resolve(b.operatorList), b.renderTasks.delete(I));
              }
              const x = this._transport.getRenderingIntent(l, g, v, !0);
              let b = this._intentStates.get(x.cacheKey);
              b || (b = /* @__PURE__ */ Object.create(null), this._intentStates.set(x.cacheKey, b));
              let I;
              return b.opListReadCapability || (I = /* @__PURE__ */ Object.create(null), I.operatorListChanged = r, b.opListReadCapability = new _util.PromiseCapability(), (b.renderTasks || (b.renderTasks = /* @__PURE__ */ new Set())).add(I), b.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: !1,
                separateAnnots: null
              }, (h = this._stats) == null || h.time("Page Request"), this._pumpOperatorList(x)), b.opListReadCapability.promise;
            }
            streamTextContent({
              includeMarkedContent: l = !1,
              disableNormalization: g = !1
            } = {}) {
              return this._transport.messageHandler.sendWithStream("GetTextContent", {
                pageIndex: this._pageIndex,
                includeMarkedContent: l === !0,
                disableNormalization: g === !0
              }, {
                highWaterMark: 100,
                size(r) {
                  return r.items.length;
                }
              });
            }
            getTextContent(l = {}) {
              if (this._transport._htmlForXfa)
                return this.getXfa().then((v) => _xfa_text.XfaText.textContent(v));
              const g = this.streamTextContent(l);
              return new Promise(function(v, r) {
                function x() {
                  b.read().then(function({
                    value: h,
                    done: y
                  }) {
                    if (y) {
                      v(I);
                      return;
                    }
                    Object.assign(I.styles, h.styles), I.items.push(...h.items), x();
                  }, r);
                }
                const b = g.getReader(), I = {
                  items: [],
                  styles: /* @__PURE__ */ Object.create(null)
                };
                x();
              });
            }
            getStructTree() {
              return this._transport.getStructTree(this._pageIndex);
            }
            _destroy() {
              this.destroyed = !0;
              const l = [];
              for (const g of this._intentStates.values())
                if (this._abortOperatorList({
                  intentState: g,
                  reason: new Error("Page was destroyed."),
                  force: !0
                }), !g.opListReadCapability)
                  for (const v of g.renderTasks)
                    l.push(v.completed), v.cancel();
              return this.objs.clear(), rt(this, ue, !1), ze(this, xe, Tn).call(this), Promise.all(l);
            }
            cleanup(l = !1) {
              rt(this, ue, !0);
              const g = ze(this, me, un).call(this, !1);
              return l && g && this._stats && (this._stats = new _display_utils.StatTimer()), g;
            }
            _startRenderPage(l, g) {
              var r, x;
              const v = this._intentStates.get(g);
              v && ((r = this._stats) == null || r.timeEnd("Page Request"), (x = v.displayReadyCapability) == null || x.resolve(l));
            }
            _renderPageChunk(l, g) {
              for (let v = 0, r = l.length; v < r; v++)
                g.operatorList.fnArray.push(l.fnArray[v]), g.operatorList.argsArray.push(l.argsArray[v]);
              g.operatorList.lastChunk = l.lastChunk, g.operatorList.separateAnnots = l.separateAnnots;
              for (const v of g.renderTasks)
                v.operatorListChanged();
              l.lastChunk && ze(this, me, un).call(this, !0);
            }
            _pumpOperatorList({
              renderingIntent: l,
              cacheKey: g,
              annotationStorageMap: v
            }) {
              const x = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                pageIndex: this._pageIndex,
                intent: l,
                cacheKey: g,
                annotationStorage: v
              }).getReader(), b = this._intentStates.get(g);
              b.streamReader = x;
              const I = () => {
                x.read().then(({
                  value: h,
                  done: y
                }) => {
                  if (y) {
                    b.streamReader = null;
                    return;
                  }
                  this._transport.destroyed || (this._renderPageChunk(h, b), I());
                }, (h) => {
                  if (b.streamReader = null, !this._transport.destroyed) {
                    if (b.operatorList) {
                      b.operatorList.lastChunk = !0;
                      for (const y of b.renderTasks)
                        y.operatorListChanged();
                      ze(this, me, un).call(this, !0);
                    }
                    if (b.displayReadyCapability)
                      b.displayReadyCapability.reject(h);
                    else if (b.opListReadCapability)
                      b.opListReadCapability.reject(h);
                    else
                      throw h;
                  }
                });
              };
              I();
            }
            _abortOperatorList({
              intentState: l,
              reason: g,
              force: v = !1
            }) {
              if (l.streamReader) {
                if (l.streamReaderCancelTimeout && (clearTimeout(l.streamReaderCancelTimeout), l.streamReaderCancelTimeout = null), !v) {
                  if (l.renderTasks.size > 0)
                    return;
                  if (g instanceof _display_utils.RenderingCancelledException) {
                    let r = RENDERING_CANCELLED_TIMEOUT;
                    g.extraDelay > 0 && g.extraDelay < 1e3 && (r += g.extraDelay), l.streamReaderCancelTimeout = setTimeout(() => {
                      l.streamReaderCancelTimeout = null, this._abortOperatorList({
                        intentState: l,
                        reason: g,
                        force: !0
                      });
                    }, r);
                    return;
                  }
                }
                if (l.streamReader.cancel(new _util.AbortException(g.message)).catch(() => {
                }), l.streamReader = null, !this._transport.destroyed) {
                  for (const [r, x] of this._intentStates)
                    if (x === l) {
                      this._intentStates.delete(r);
                      break;
                    }
                  this.cleanup();
                }
              }
            }
            get stats() {
              return this._stats;
            }
          }
          ke = new WeakMap(), ue = new WeakMap(), me = new WeakSet(), un = function(l = !1) {
            if (ze(this, xe, Tn).call(this), !ge(this, ue))
              return !1;
            if (l)
              return rt(this, ke, setTimeout(() => {
                rt(this, ke, null), ze(this, me, un).call(this, !1);
              }, DELAYED_CLEANUP_TIMEOUT)), !1;
            for (const {
              renderTasks: g,
              operatorList: v
            } of this._intentStates.values())
              if (g.size > 0 || !v.lastChunk)
                return !1;
            return this._intentStates.clear(), this.objs.clear(), rt(this, ue, !1), !0;
          }, xe = new WeakSet(), Tn = function() {
            ge(this, ke) && (clearTimeout(ge(this, ke)), rt(this, ke, null));
          }, exports.PDFPageProxy = PDFPageProxy;
          class LoopbackPort {
            constructor() {
              Be(this, ae, /* @__PURE__ */ new Set());
              Be(this, n, Promise.resolve());
            }
            postMessage(l, g) {
              const v = {
                data: structuredClone(l, g ? {
                  transfer: g
                } : null)
              };
              ge(this, n).then(() => {
                for (const r of ge(this, ae))
                  r.call(this, v);
              });
            }
            addEventListener(l, g) {
              ge(this, ae).add(g);
            }
            removeEventListener(l, g) {
              ge(this, ae).delete(g);
            }
            terminate() {
              ge(this, ae).clear();
            }
          }
          ae = new WeakMap(), n = new WeakMap(), exports.LoopbackPort = LoopbackPort;
          const PDFWorkerUtil = {
            isWorkerDisabled: !1,
            fallbackWorkerSrc: null,
            fakeWorkerId: 0
          };
          exports.PDFWorkerUtil = PDFWorkerUtil;
          {
            if (_is_node.isNodeJS && typeof commonjsRequire == "function")
              PDFWorkerUtil.isWorkerDisabled = !0, PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
            else if (typeof document == "object") {
              const s = (u = document == null ? void 0 : document.currentScript) == null ? void 0 : u.src;
              s && (PDFWorkerUtil.fallbackWorkerSrc = s.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2"));
            }
            PDFWorkerUtil.isSameOrigin = function(s, l) {
              let g;
              try {
                if (g = new URL(s), !g.origin || g.origin === "null")
                  return !1;
              } catch {
                return !1;
              }
              const v = new URL(l, g);
              return g.origin === v.origin;
            }, PDFWorkerUtil.createCDNWrapper = function(s) {
              const l = `importScripts("${s}");`;
              return URL.createObjectURL(new Blob([l]));
            };
          }
          const _PDFWorker = class _PDFWorker {
            constructor({
              name: s = null,
              port: l = null,
              verbosity: g = (0, _util.getVerbosityLevel)()
            } = {}) {
              if (l && ge(_PDFWorker, q).has(l))
                throw new Error("Cannot use more than one PDFWorker per port.");
              if (this.name = s, this.destroyed = !1, this.verbosity = g, this._readyCapability = new _util.PromiseCapability(), this._port = null, this._webWorker = null, this._messageHandler = null, l) {
                ge(_PDFWorker, q).set(l, this), this._initializeFromPort(l);
                return;
              }
              this._initialize();
            }
            get promise() {
              return this._readyCapability.promise;
            }
            get port() {
              return this._port;
            }
            get messageHandler() {
              return this._messageHandler;
            }
            _initializeFromPort(s) {
              this._port = s, this._messageHandler = new _message_handler.MessageHandler("main", "worker", s), this._messageHandler.on("ready", function() {
              }), this._readyCapability.resolve(), this._messageHandler.send("configure", {
                verbosity: this.verbosity
              });
            }
            _initialize() {
              if (!PDFWorkerUtil.isWorkerDisabled && !_PDFWorker._mainThreadWorkerMessageHandler) {
                let {
                  workerSrc: s
                } = _PDFWorker;
                try {
                  PDFWorkerUtil.isSameOrigin(window.location.href, s) || (s = PDFWorkerUtil.createCDNWrapper(new URL(s, window.location).href));
                  const l = new Worker(s), g = new _message_handler.MessageHandler("main", "worker", l), v = () => {
                    l.removeEventListener("error", r), g.destroy(), l.terminate(), this.destroyed ? this._readyCapability.reject(new Error("Worker was destroyed")) : this._setupFakeWorker();
                  }, r = () => {
                    this._webWorker || v();
                  };
                  l.addEventListener("error", r), g.on("test", (b) => {
                    if (l.removeEventListener("error", r), this.destroyed) {
                      v();
                      return;
                    }
                    b ? (this._messageHandler = g, this._port = l, this._webWorker = l, this._readyCapability.resolve(), g.send("configure", {
                      verbosity: this.verbosity
                    })) : (this._setupFakeWorker(), g.destroy(), l.terminate());
                  }), g.on("ready", (b) => {
                    if (l.removeEventListener("error", r), this.destroyed) {
                      v();
                      return;
                    }
                    try {
                      x();
                    } catch {
                      this._setupFakeWorker();
                    }
                  });
                  const x = () => {
                    const b = new Uint8Array();
                    g.send("test", b, [b.buffer]);
                  };
                  x();
                  return;
                } catch {
                  (0, _util.info)("The worker has been disabled.");
                }
              }
              this._setupFakeWorker();
            }
            _setupFakeWorker() {
              PDFWorkerUtil.isWorkerDisabled || ((0, _util.warn)("Setting up fake worker."), PDFWorkerUtil.isWorkerDisabled = !0), _PDFWorker._setupFakeWorkerGlobal.then((s) => {
                if (this.destroyed) {
                  this._readyCapability.reject(new Error("Worker was destroyed"));
                  return;
                }
                const l = new LoopbackPort();
                this._port = l;
                const g = `fake${PDFWorkerUtil.fakeWorkerId++}`, v = new _message_handler.MessageHandler(g + "_worker", g, l);
                s.setup(v, l);
                const r = new _message_handler.MessageHandler(g, g + "_worker", l);
                this._messageHandler = r, this._readyCapability.resolve(), r.send("configure", {
                  verbosity: this.verbosity
                });
              }).catch((s) => {
                this._readyCapability.reject(new Error(`Setting up fake worker failed: "${s.message}".`));
              });
            }
            destroy() {
              this.destroyed = !0, this._webWorker && (this._webWorker.terminate(), this._webWorker = null), ge(_PDFWorker, q).delete(this._port), this._port = null, this._messageHandler && (this._messageHandler.destroy(), this._messageHandler = null);
            }
            static fromPort(s) {
              if (!(s != null && s.port))
                throw new Error("PDFWorker.fromPort - invalid method signature.");
              return ge(this, q).has(s.port) ? ge(this, q).get(s.port) : new _PDFWorker(s);
            }
            static get workerSrc() {
              if (_worker_options.GlobalWorkerOptions.workerSrc)
                return _worker_options.GlobalWorkerOptions.workerSrc;
              if (PDFWorkerUtil.fallbackWorkerSrc !== null)
                return _is_node.isNodeJS || (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.'), PDFWorkerUtil.fallbackWorkerSrc;
              throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
            }
            static get _mainThreadWorkerMessageHandler() {
              var s;
              try {
                return ((s = globalThis.pdfjsWorker) == null ? void 0 : s.WorkerMessageHandler) || null;
              } catch {
                return null;
              }
            }
            static get _setupFakeWorkerGlobal() {
              const loader = async () => {
                const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                if (mainWorkerMessageHandler)
                  return mainWorkerMessageHandler;
                if (_is_node.isNodeJS && typeof commonjsRequire == "function") {
                  const worker = eval("require")(this.workerSrc);
                  return worker.WorkerMessageHandler;
                }
                return await (0, _display_utils.loadScript)(this.workerSrc), window.pdfjsWorker.WorkerMessageHandler;
              };
              return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
            }
          };
          q = new WeakMap(), Be(_PDFWorker, q, /* @__PURE__ */ new WeakMap());
          let PDFWorker = _PDFWorker;
          exports.PDFWorker = PDFWorker;
          class WorkerTransport {
            constructor(l, g, v, r, x) {
              Be(this, j);
              Be(this, e, /* @__PURE__ */ new Map());
              Be(this, t, /* @__PURE__ */ new Map());
              Be(this, B, /* @__PURE__ */ new Map());
              this.messageHandler = l, this.loadingTask = g, this.commonObjs = new PDFObjects(), this.fontLoader = new _font_loader.FontLoader({
                ownerDocument: r.ownerDocument,
                styleElement: r.styleElement
              }), this._params = r, this.canvasFactory = x.canvasFactory, this.filterFactory = x.filterFactory, this.cMapReaderFactory = x.cMapReaderFactory, this.standardFontDataFactory = x.standardFontDataFactory, this.destroyed = !1, this.destroyCapability = null, this._passwordCapability = null, this._networkStream = v, this._fullReader = null, this._lastProgress = null, this.downloadInfoCapability = new _util.PromiseCapability(), this.setupMessageHandler();
            }
            get annotationStorage() {
              return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
            }
            getRenderingIntent(l, g = _util.AnnotationMode.ENABLE, v = null, r = !1) {
              let x = _util.RenderingIntentFlag.DISPLAY, b = null;
              switch (l) {
                case "any":
                  x = _util.RenderingIntentFlag.ANY;
                  break;
                case "display":
                  break;
                case "print":
                  x = _util.RenderingIntentFlag.PRINT;
                  break;
                default:
                  (0, _util.warn)(`getRenderingIntent - invalid intent: ${l}`);
              }
              switch (g) {
                case _util.AnnotationMode.DISABLE:
                  x += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                  break;
                case _util.AnnotationMode.ENABLE:
                  break;
                case _util.AnnotationMode.ENABLE_FORMS:
                  x += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                  break;
                case _util.AnnotationMode.ENABLE_STORAGE:
                  x += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE, b = (x & _util.RenderingIntentFlag.PRINT && v instanceof _annotation_storage.PrintAnnotationStorage ? v : this.annotationStorage).serializable;
                  break;
                default:
                  (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${g}`);
              }
              return r && (x += _util.RenderingIntentFlag.OPLIST), {
                renderingIntent: x,
                cacheKey: `${x}_${_annotation_storage.AnnotationStorage.getHash(b)}`,
                annotationStorageMap: b
              };
            }
            destroy() {
              if (this.destroyCapability)
                return this.destroyCapability.promise;
              this.destroyed = !0, this.destroyCapability = new _util.PromiseCapability(), this._passwordCapability && this._passwordCapability.reject(new Error("Worker was destroyed during onPassword callback"));
              const l = [];
              for (const v of ge(this, t).values())
                l.push(v._destroy());
              ge(this, t).clear(), ge(this, B).clear(), this.hasOwnProperty("annotationStorage") && this.annotationStorage.resetModified();
              const g = this.messageHandler.sendWithPromise("Terminate", null);
              return l.push(g), Promise.all(l).then(() => {
                this.commonObjs.clear(), this.fontLoader.clear(), ge(this, e).clear(), this.filterFactory.destroy(), this._networkStream && this._networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated.")), this.messageHandler && (this.messageHandler.destroy(), this.messageHandler = null), this.destroyCapability.resolve();
              }, this.destroyCapability.reject), this.destroyCapability.promise;
            }
            setupMessageHandler() {
              const {
                messageHandler: l,
                loadingTask: g
              } = this;
              l.on("GetReader", (v, r) => {
                (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available."), this._fullReader = this._networkStream.getFullReader(), this._fullReader.onProgress = (x) => {
                  this._lastProgress = {
                    loaded: x.loaded,
                    total: x.total
                  };
                }, r.onPull = () => {
                  this._fullReader.read().then(function({
                    value: x,
                    done: b
                  }) {
                    if (b) {
                      r.close();
                      return;
                    }
                    (0, _util.assert)(x instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer."), r.enqueue(new Uint8Array(x), 1, [x]);
                  }).catch((x) => {
                    r.error(x);
                  });
                }, r.onCancel = (x) => {
                  this._fullReader.cancel(x), r.ready.catch((b) => {
                    if (!this.destroyed)
                      throw b;
                  });
                };
              }), l.on("ReaderHeadersReady", (v) => {
                const r = new _util.PromiseCapability(), x = this._fullReader;
                return x.headersReady.then(() => {
                  var b;
                  (!x.isStreamingSupported || !x.isRangeSupported) && (this._lastProgress && ((b = g.onProgress) == null || b.call(g, this._lastProgress)), x.onProgress = (I) => {
                    var h;
                    (h = g.onProgress) == null || h.call(g, {
                      loaded: I.loaded,
                      total: I.total
                    });
                  }), r.resolve({
                    isStreamingSupported: x.isStreamingSupported,
                    isRangeSupported: x.isRangeSupported,
                    contentLength: x.contentLength
                  });
                }, r.reject), r.promise;
              }), l.on("GetRangeReader", (v, r) => {
                (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                const x = this._networkStream.getRangeReader(v.begin, v.end);
                if (!x) {
                  r.close();
                  return;
                }
                r.onPull = () => {
                  x.read().then(function({
                    value: b,
                    done: I
                  }) {
                    if (I) {
                      r.close();
                      return;
                    }
                    (0, _util.assert)(b instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer."), r.enqueue(new Uint8Array(b), 1, [b]);
                  }).catch((b) => {
                    r.error(b);
                  });
                }, r.onCancel = (b) => {
                  x.cancel(b), r.ready.catch((I) => {
                    if (!this.destroyed)
                      throw I;
                  });
                };
              }), l.on("GetDoc", ({
                pdfInfo: v
              }) => {
                this._numPages = v.numPages, this._htmlForXfa = v.htmlForXfa, delete v.htmlForXfa, g._capability.resolve(new PDFDocumentProxy(v, this));
              }), l.on("DocException", function(v) {
                let r;
                switch (v.name) {
                  case "PasswordException":
                    r = new _util.PasswordException(v.message, v.code);
                    break;
                  case "InvalidPDFException":
                    r = new _util.InvalidPDFException(v.message);
                    break;
                  case "MissingPDFException":
                    r = new _util.MissingPDFException(v.message);
                    break;
                  case "UnexpectedResponseException":
                    r = new _util.UnexpectedResponseException(v.message, v.status);
                    break;
                  case "UnknownErrorException":
                    r = new _util.UnknownErrorException(v.message, v.details);
                    break;
                  default:
                    (0, _util.unreachable)("DocException - expected a valid Error.");
                }
                g._capability.reject(r);
              }), l.on("PasswordRequest", (v) => {
                if (this._passwordCapability = new _util.PromiseCapability(), g.onPassword) {
                  const r = (x) => {
                    x instanceof Error ? this._passwordCapability.reject(x) : this._passwordCapability.resolve({
                      password: x
                    });
                  };
                  try {
                    g.onPassword(r, v.code);
                  } catch (x) {
                    this._passwordCapability.reject(x);
                  }
                } else
                  this._passwordCapability.reject(new _util.PasswordException(v.message, v.code));
                return this._passwordCapability.promise;
              }), l.on("DataLoaded", (v) => {
                var r;
                (r = g.onProgress) == null || r.call(g, {
                  loaded: v.length,
                  total: v.length
                }), this.downloadInfoCapability.resolve(v);
              }), l.on("StartRenderPage", (v) => {
                if (this.destroyed)
                  return;
                ge(this, t).get(v.pageIndex)._startRenderPage(v.transparency, v.cacheKey);
              }), l.on("commonobj", ([v, r, x]) => {
                var b;
                if (!this.destroyed && !this.commonObjs.has(v))
                  switch (r) {
                    case "Font":
                      const I = this._params;
                      if ("error" in x) {
                        const P = x.error;
                        (0, _util.warn)(`Error during font loading: ${P}`), this.commonObjs.resolve(v, P);
                        break;
                      }
                      const h = I.pdfBug && ((b = globalThis.FontInspector) != null && b.enabled) ? (P, c) => globalThis.FontInspector.fontAdded(P, c) : null, y = new _font_loader.FontFaceObject(x, {
                        isEvalSupported: I.isEvalSupported,
                        disableFontFace: I.disableFontFace,
                        ignoreErrors: I.ignoreErrors,
                        inspectFont: h
                      });
                      this.fontLoader.bind(y).catch((P) => l.sendWithPromise("FontFallback", {
                        id: v
                      })).finally(() => {
                        !I.fontExtraProperties && y.data && (y.data = null), this.commonObjs.resolve(v, y);
                      });
                      break;
                    case "FontPath":
                    case "Image":
                    case "Pattern":
                      this.commonObjs.resolve(v, x);
                      break;
                    default:
                      throw new Error(`Got unknown common object type ${r}`);
                  }
              }), l.on("obj", ([v, r, x, b]) => {
                var h;
                if (this.destroyed)
                  return;
                const I = ge(this, t).get(r);
                if (!I.objs.has(v))
                  switch (x) {
                    case "Image":
                      if (I.objs.resolve(v, b), b) {
                        let y;
                        if (b.bitmap) {
                          const {
                            width: P,
                            height: c
                          } = b;
                          y = P * c * 4;
                        } else
                          y = ((h = b.data) == null ? void 0 : h.length) || 0;
                        y > _util.MAX_IMAGE_SIZE_TO_CACHE && (I._maybeCleanupAfterRender = !0);
                      }
                      break;
                    case "Pattern":
                      I.objs.resolve(v, b);
                      break;
                    default:
                      throw new Error(`Got unknown object type ${x}`);
                  }
              }), l.on("DocProgress", (v) => {
                var r;
                this.destroyed || (r = g.onProgress) == null || r.call(g, {
                  loaded: v.loaded,
                  total: v.total
                });
              }), l.on("FetchBuiltInCMap", (v) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.cMapReaderFactory ? this.cMapReaderFactory.fetch(v) : Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."))), l.on("FetchStandardFontData", (v) => this.destroyed ? Promise.reject(new Error("Worker was destroyed.")) : this.standardFontDataFactory ? this.standardFontDataFactory.fetch(v) : Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter.")));
            }
            getData() {
              return this.messageHandler.sendWithPromise("GetData", null);
            }
            saveDocument() {
              var l;
              return this.annotationStorage.size <= 0 && (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead."), this.messageHandler.sendWithPromise("SaveDocument", {
                isPureXfa: !!this._htmlForXfa,
                numPages: this._numPages,
                annotationStorage: this.annotationStorage.serializable,
                filename: ((l = this._fullReader) == null ? void 0 : l.filename) ?? null
              }).finally(() => {
                this.annotationStorage.resetModified();
              });
            }
            getPage(l) {
              if (!Number.isInteger(l) || l <= 0 || l > this._numPages)
                return Promise.reject(new Error("Invalid page request."));
              const g = l - 1, v = ge(this, B).get(g);
              if (v)
                return v;
              const r = this.messageHandler.sendWithPromise("GetPage", {
                pageIndex: g
              }).then((x) => {
                if (this.destroyed)
                  throw new Error("Transport destroyed");
                const b = new PDFPageProxy(g, x, this, this._params.pdfBug);
                return ge(this, t).set(g, b), b;
              });
              return ge(this, B).set(g, r), r;
            }
            getPageIndex(l) {
              return typeof l != "object" || l === null || !Number.isInteger(l.num) || l.num < 0 || !Number.isInteger(l.gen) || l.gen < 0 ? Promise.reject(new Error("Invalid pageIndex request.")) : this.messageHandler.sendWithPromise("GetPageIndex", {
                num: l.num,
                gen: l.gen
              });
            }
            getAnnotations(l, g) {
              return this.messageHandler.sendWithPromise("GetAnnotations", {
                pageIndex: l,
                intent: g
              });
            }
            getFieldObjects() {
              return ze(this, j, Vn).call(this, "GetFieldObjects");
            }
            hasJSActions() {
              return ze(this, j, Vn).call(this, "HasJSActions");
            }
            getCalculationOrderIds() {
              return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
            }
            getDestinations() {
              return this.messageHandler.sendWithPromise("GetDestinations", null);
            }
            getDestination(l) {
              return typeof l != "string" ? Promise.reject(new Error("Invalid destination request.")) : this.messageHandler.sendWithPromise("GetDestination", {
                id: l
              });
            }
            getPageLabels() {
              return this.messageHandler.sendWithPromise("GetPageLabels", null);
            }
            getPageLayout() {
              return this.messageHandler.sendWithPromise("GetPageLayout", null);
            }
            getPageMode() {
              return this.messageHandler.sendWithPromise("GetPageMode", null);
            }
            getViewerPreferences() {
              return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
            }
            getOpenAction() {
              return this.messageHandler.sendWithPromise("GetOpenAction", null);
            }
            getAttachments() {
              return this.messageHandler.sendWithPromise("GetAttachments", null);
            }
            getJavaScript() {
              return this.messageHandler.sendWithPromise("GetJavaScript", null);
            }
            getDocJSActions() {
              return this.messageHandler.sendWithPromise("GetDocJSActions", null);
            }
            getPageJSActions(l) {
              return this.messageHandler.sendWithPromise("GetPageJSActions", {
                pageIndex: l
              });
            }
            getStructTree(l) {
              return this.messageHandler.sendWithPromise("GetStructTree", {
                pageIndex: l
              });
            }
            getOutline() {
              return this.messageHandler.sendWithPromise("GetOutline", null);
            }
            getOptionalContentConfig() {
              return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((l) => new _optional_content_config.OptionalContentConfig(l));
            }
            getPermissions() {
              return this.messageHandler.sendWithPromise("GetPermissions", null);
            }
            getMetadata() {
              const l = "GetMetadata", g = ge(this, e).get(l);
              if (g)
                return g;
              const v = this.messageHandler.sendWithPromise(l, null).then((r) => {
                var x, b;
                return {
                  info: r[0],
                  metadata: r[1] ? new _metadata.Metadata(r[1]) : null,
                  contentDispositionFilename: ((x = this._fullReader) == null ? void 0 : x.filename) ?? null,
                  contentLength: ((b = this._fullReader) == null ? void 0 : b.contentLength) ?? null
                };
              });
              return ge(this, e).set(l, v), v;
            }
            getMarkInfo() {
              return this.messageHandler.sendWithPromise("GetMarkInfo", null);
            }
            async startCleanup(l = !1) {
              if (!this.destroyed) {
                await this.messageHandler.sendWithPromise("Cleanup", null);
                for (const g of ge(this, t).values())
                  if (!g.cleanup())
                    throw new Error(`startCleanup: Page ${g.pageNumber} is currently rendering.`);
                this.commonObjs.clear(), l || this.fontLoader.clear(), ge(this, e).clear(), this.filterFactory.destroy(!0);
              }
            }
            get loadingParams() {
              const {
                disableAutoFetch: l,
                enableXfa: g
              } = this._params;
              return (0, _util.shadow)(this, "loadingParams", {
                disableAutoFetch: l,
                enableXfa: g
              });
            }
          }
          e = new WeakMap(), t = new WeakMap(), B = new WeakMap(), j = new WeakSet(), Vn = function(l, g = null) {
            const v = ge(this, e).get(l);
            if (v)
              return v;
            const r = this.messageHandler.sendWithPromise(l, g);
            return ge(this, e).set(l, r), r;
          };
          class PDFObjects {
            constructor() {
              Be(this, w);
              Be(this, O, /* @__PURE__ */ Object.create(null));
            }
            get(l, g = null) {
              if (g) {
                const r = ze(this, w, Yn).call(this, l);
                return r.capability.promise.then(() => g(r.data)), null;
              }
              const v = ge(this, O)[l];
              if (!(v != null && v.capability.settled))
                throw new Error(`Requesting object that isn't resolved yet ${l}.`);
              return v.data;
            }
            has(l) {
              const g = ge(this, O)[l];
              return (g == null ? void 0 : g.capability.settled) || !1;
            }
            resolve(l, g = null) {
              const v = ze(this, w, Yn).call(this, l);
              v.data = g, v.capability.resolve();
            }
            clear() {
              var l;
              for (const g in ge(this, O)) {
                const {
                  data: v
                } = ge(this, O)[g];
                (l = v == null ? void 0 : v.bitmap) == null || l.close();
              }
              rt(this, O, /* @__PURE__ */ Object.create(null));
            }
          }
          O = new WeakMap(), w = new WeakSet(), Yn = function(l) {
            const g = ge(this, O)[l];
            return g || (ge(this, O)[l] = {
              capability: new _util.PromiseCapability(),
              data: null
            });
          };
          class RenderTask {
            constructor(l) {
              Be(this, i, null);
              rt(this, i, l), this.onContinue = null;
            }
            get promise() {
              return ge(this, i).capability.promise;
            }
            cancel(l = 0) {
              ge(this, i).cancel(null, l);
            }
            get separateAnnots() {
              const {
                separateAnnots: l
              } = ge(this, i).operatorList;
              if (!l)
                return !1;
              const {
                annotationCanvasMap: g
              } = ge(this, i);
              return l.form || l.canvas && (g == null ? void 0 : g.size) > 0;
            }
          }
          i = new WeakMap(), exports.RenderTask = RenderTask;
          const k = class k {
            constructor({
              callback: l,
              params: g,
              objs: v,
              commonObjs: r,
              annotationCanvasMap: x,
              operatorList: b,
              pageIndex: I,
              canvasFactory: h,
              filterFactory: y,
              useRequestAnimationFrame: P = !1,
              pdfBug: c = !1,
              pageColors: d = null
            }) {
              this.callback = l, this.params = g, this.objs = v, this.commonObjs = r, this.annotationCanvasMap = x, this.operatorListIdx = null, this.operatorList = b, this._pageIndex = I, this.canvasFactory = h, this.filterFactory = y, this._pdfBug = c, this.pageColors = d, this.running = !1, this.graphicsReadyCallback = null, this.graphicsReady = !1, this._useRequestAnimationFrame = P === !0 && typeof window < "u", this.cancelled = !1, this.capability = new _util.PromiseCapability(), this.task = new RenderTask(this), this._cancelBound = this.cancel.bind(this), this._continueBound = this._continue.bind(this), this._scheduleNextBound = this._scheduleNext.bind(this), this._nextBound = this._next.bind(this), this._canvas = g.canvasContext.canvas;
            }
            get completed() {
              return this.capability.promise.catch(function() {
              });
            }
            initializeGraphics({
              transparency: l = !1,
              optionalContentConfig: g
            }) {
              var I, h;
              if (this.cancelled)
                return;
              if (this._canvas) {
                if (ge(k, o).has(this._canvas))
                  throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                ge(k, o).add(this._canvas);
              }
              this._pdfBug && ((I = globalThis.StepperManager) != null && I.enabled) && (this.stepper = globalThis.StepperManager.create(this._pageIndex), this.stepper.init(this.operatorList), this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint());
              const {
                canvasContext: v,
                viewport: r,
                transform: x,
                background: b
              } = this.params;
              this.gfx = new _canvas.CanvasGraphics(v, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                optionalContentConfig: g
              }, this.annotationCanvasMap, this.pageColors), this.gfx.beginDrawing({
                transform: x,
                viewport: r,
                transparency: l,
                background: b
              }), this.operatorListIdx = 0, this.graphicsReady = !0, (h = this.graphicsReadyCallback) == null || h.call(this);
            }
            cancel(l = null, g = 0) {
              var v;
              this.running = !1, this.cancelled = !0, (v = this.gfx) == null || v.endDrawing(), this._canvas && ge(k, o).delete(this._canvas), this.callback(l || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, "canvas", g));
            }
            operatorListChanged() {
              var l;
              if (!this.graphicsReady) {
                this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                return;
              }
              (l = this.stepper) == null || l.updateOperatorList(this.operatorList), !this.running && this._continue();
            }
            _continue() {
              this.running = !0, !this.cancelled && (this.task.onContinue ? this.task.onContinue(this._scheduleNextBound) : this._scheduleNext());
            }
            _scheduleNext() {
              this._useRequestAnimationFrame ? window.requestAnimationFrame(() => {
                this._nextBound().catch(this._cancelBound);
              }) : Promise.resolve().then(this._nextBound).catch(this._cancelBound);
            }
            async _next() {
              this.cancelled || (this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper), this.operatorListIdx === this.operatorList.argsArray.length && (this.running = !1, this.operatorList.lastChunk && (this.gfx.endDrawing(this.pageColors), this._canvas && ge(k, o).delete(this._canvas), this.callback())));
            }
          };
          o = new WeakMap(), Be(k, o, /* @__PURE__ */ new WeakSet());
          let InternalRenderTask = k;
          const version = "3.7.107";
          exports.version = version;
          const build = "036f855dc";
          exports.build = build;
        },
        /* 3 */
        /***/
        (Se, he, ke) => {
          var ae, n, u, mi, e;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.PrintAnnotationStorage = he.AnnotationStorage = void 0;
          var ue = ke(1), me = ke(4), Me = ke(8);
          class xe {
            constructor() {
              Be(this, u);
              Be(this, ae, !1);
              Be(this, n, /* @__PURE__ */ new Map());
              this.onSetModified = null, this.onResetModified = null, this.onAnnotationEditor = null;
            }
            getValue(B, j) {
              const M = ge(this, n).get(B);
              return M === void 0 ? j : Object.assign(j, M);
            }
            getRawValue(B) {
              return ge(this, n).get(B);
            }
            remove(B) {
              if (ge(this, n).delete(B), ge(this, n).size === 0 && this.resetModified(), typeof this.onAnnotationEditor == "function") {
                for (const j of ge(this, n).values())
                  if (j instanceof me.AnnotationEditor)
                    return;
                this.onAnnotationEditor(null);
              }
            }
            setValue(B, j) {
              const M = ge(this, n).get(B);
              let O = !1;
              if (M !== void 0)
                for (const [w, C] of Object.entries(j))
                  M[w] !== C && (O = !0, M[w] = C);
              else
                O = !0, ge(this, n).set(B, j);
              O && ze(this, u, mi).call(this), j instanceof me.AnnotationEditor && typeof this.onAnnotationEditor == "function" && this.onAnnotationEditor(j.constructor._type);
            }
            has(B) {
              return ge(this, n).has(B);
            }
            getAll() {
              return ge(this, n).size > 0 ? (0, ue.objectFromMap)(ge(this, n)) : null;
            }
            setAll(B) {
              for (const [j, M] of Object.entries(B))
                this.setValue(j, M);
            }
            get size() {
              return ge(this, n).size;
            }
            resetModified() {
              ge(this, ae) && (rt(this, ae, !1), typeof this.onResetModified == "function" && this.onResetModified());
            }
            get print() {
              return new F(this);
            }
            get serializable() {
              if (ge(this, n).size === 0)
                return null;
              const B = /* @__PURE__ */ new Map();
              for (const [j, M] of ge(this, n)) {
                const O = M instanceof me.AnnotationEditor ? M.serialize() : M;
                O && B.set(j, O);
              }
              return B;
            }
            static getHash(B) {
              if (!B)
                return "";
              const j = new Me.MurmurHash3_64();
              for (const [M, O] of B)
                j.update(`${M}:${JSON.stringify(O)}`);
              return j.hexdigest();
            }
          }
          ae = new WeakMap(), n = new WeakMap(), u = new WeakSet(), mi = function() {
            ge(this, ae) || (rt(this, ae, !0), typeof this.onSetModified == "function" && this.onSetModified());
          }, he.AnnotationStorage = xe;
          class F extends xe {
            constructor(j) {
              super();
              Be(this, e, null);
              rt(this, e, structuredClone(j.serializable));
            }
            get print() {
              (0, ue.unreachable)("Should not call PrintAnnotationStorage.print");
            }
            get serializable() {
              return ge(this, e);
            }
          }
          e = new WeakMap(), he.PrintAnnotationStorage = F;
        },
        /* 4 */
        /***/
        (Se, he, ke) => {
          var xe, F, ae, n, u, q;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.AnnotationEditor = void 0;
          var ue = ke(5), me = ke(1);
          const e = class e {
            constructor(B) {
              Be(this, xe, this.focusin.bind(this));
              Be(this, F, this.focusout.bind(this));
              Be(this, ae, !1);
              Be(this, n, !1);
              Be(this, u, !1);
              Dt(this, "_uiManager", null);
              Be(this, q, e._zIndex++);
              this.constructor === e && (0, me.unreachable)("Cannot initialize AnnotationEditor."), this.parent = B.parent, this.id = B.id, this.width = this.height = null, this.pageIndex = B.parent.pageIndex, this.name = B.name, this.div = null, this._uiManager = B.uiManager;
              const {
                rotation: j,
                rawDims: {
                  pageWidth: M,
                  pageHeight: O,
                  pageX: w,
                  pageY: C
                }
              } = this.parent.viewport;
              this.rotation = j, this.pageRotation = (360 + j - this._uiManager.viewParameters.rotation) % 360, this.pageDimensions = [M, O], this.pageTranslation = [w, C];
              const [i, o] = this.parentDimensions;
              this.x = B.x / i, this.y = B.y / o, this.isAttachedToDOM = !1;
            }
            static get _defaultLineColor() {
              return (0, me.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
            }
            addCommands(B) {
              this._uiManager.addCommands(B);
            }
            get currentLayer() {
              return this._uiManager.currentLayer;
            }
            setInBackground() {
              this.div.style.zIndex = 0;
            }
            setInForeground() {
              this.div.style.zIndex = ge(this, q);
            }
            setParent(B) {
              B !== null && (this.pageIndex = B.pageIndex, this.pageDimensions = B.pageDimensions), this.parent = B;
            }
            focusin(B) {
              ge(this, ae) ? rt(this, ae, !1) : this.parent.setSelected(this);
            }
            focusout(B) {
              var M;
              if (!this.isAttachedToDOM)
                return;
              const j = B.relatedTarget;
              j != null && j.closest(`#${this.id}`) || (B.preventDefault(), (M = this.parent) != null && M.isMultipleSelection || this.commitOrRemove());
            }
            commitOrRemove() {
              this.isEmpty() ? this.remove() : this.commit();
            }
            commit() {
              this.addToAnnotationStorage();
            }
            addToAnnotationStorage() {
              this._uiManager.addToAnnotationStorage(this);
            }
            dragstart(B) {
              const j = this.parent.div.getBoundingClientRect();
              this.startX = B.clientX - j.x, this.startY = B.clientY - j.y, B.dataTransfer.setData("text/plain", this.id), B.dataTransfer.effectAllowed = "move";
            }
            setAt(B, j, M, O) {
              const [w, C] = this.parentDimensions;
              [M, O] = this.screenToPageTranslation(M, O), this.x = (B + M) / w, this.y = (j + O) / C, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
            }
            translate(B, j) {
              const [M, O] = this.parentDimensions;
              [B, j] = this.screenToPageTranslation(B, j), this.x += B / M, this.y += j / O, this.div.style.left = `${100 * this.x}%`, this.div.style.top = `${100 * this.y}%`;
            }
            screenToPageTranslation(B, j) {
              switch (this.parentRotation) {
                case 90:
                  return [j, -B];
                case 180:
                  return [-B, -j];
                case 270:
                  return [-j, B];
                default:
                  return [B, j];
              }
            }
            get parentScale() {
              return this._uiManager.viewParameters.realScale;
            }
            get parentRotation() {
              return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
            }
            get parentDimensions() {
              const {
                realScale: B
              } = this._uiManager.viewParameters, [j, M] = this.pageDimensions;
              return [j * B, M * B];
            }
            setDims(B, j) {
              const [M, O] = this.parentDimensions;
              this.div.style.width = `${100 * B / M}%`, this.div.style.height = `${100 * j / O}%`;
            }
            fixDims() {
              const {
                style: B
              } = this.div, {
                height: j,
                width: M
              } = B, O = M.endsWith("%"), w = j.endsWith("%");
              if (O && w)
                return;
              const [C, i] = this.parentDimensions;
              O || (B.width = `${100 * parseFloat(M) / C}%`), w || (B.height = `${100 * parseFloat(j) / i}%`);
            }
            getInitialTranslation() {
              return [0, 0];
            }
            render() {
              this.div = document.createElement("div"), this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360), this.div.className = this.name, this.div.setAttribute("id", this.id), this.div.setAttribute("tabIndex", 0), this.setInForeground(), this.div.addEventListener("focusin", ge(this, xe)), this.div.addEventListener("focusout", ge(this, F));
              const [B, j] = this.getInitialTranslation();
              return this.translate(B, j), (0, ue.bindEvents)(this, this.div, ["dragstart", "pointerdown"]), this.div;
            }
            pointerdown(B) {
              const {
                isMac: j
              } = me.FeatureTest.platform;
              if (B.button !== 0 || B.ctrlKey && j) {
                B.preventDefault();
                return;
              }
              B.ctrlKey && !j || B.shiftKey || B.metaKey && j ? this.parent.toggleSelected(this) : this.parent.setSelected(this), rt(this, ae, !0);
            }
            getRect(B, j) {
              const M = this.parentScale, [O, w] = this.pageDimensions, [C, i] = this.pageTranslation, o = B / M, k = j / M, s = this.x * O, l = this.y * w, g = this.width * O, v = this.height * w;
              switch (this.rotation) {
                case 0:
                  return [s + o + C, w - l - k - v + i, s + o + g + C, w - l - k + i];
                case 90:
                  return [s + k + C, w - l + o + i, s + k + v + C, w - l + o + g + i];
                case 180:
                  return [s - o - g + C, w - l + k + i, s - o + C, w - l + k + v + i];
                case 270:
                  return [s - k - v + C, w - l - o - g + i, s - k + C, w - l - o + i];
                default:
                  throw new Error("Invalid rotation");
              }
            }
            getRectInCurrentCoords(B, j) {
              const [M, O, w, C] = B, i = w - M, o = C - O;
              switch (this.rotation) {
                case 0:
                  return [M, j - C, i, o];
                case 90:
                  return [M, j - O, o, i];
                case 180:
                  return [w, j - O, i, o];
                case 270:
                  return [w, j - C, o, i];
                default:
                  throw new Error("Invalid rotation");
              }
            }
            onceAdded() {
            }
            isEmpty() {
              return !1;
            }
            enableEditMode() {
              rt(this, u, !0);
            }
            disableEditMode() {
              rt(this, u, !1);
            }
            isInEditMode() {
              return ge(this, u);
            }
            shouldGetKeyboardEvents() {
              return !1;
            }
            needsToBeRebuilt() {
              return this.div && !this.isAttachedToDOM;
            }
            rebuild() {
              var B;
              (B = this.div) == null || B.addEventListener("focusin", ge(this, xe));
            }
            serialize() {
              (0, me.unreachable)("An editor must be serializable");
            }
            static deserialize(B, j, M) {
              const O = new this.prototype.constructor({
                parent: j,
                id: j.getNextId(),
                uiManager: M
              });
              O.rotation = B.rotation;
              const [w, C] = O.pageDimensions, [i, o, k, s] = O.getRectInCurrentCoords(B.rect, C);
              return O.x = i / w, O.y = o / C, O.width = k / w, O.height = s / C, O;
            }
            remove() {
              this.div.removeEventListener("focusin", ge(this, xe)), this.div.removeEventListener("focusout", ge(this, F)), this.isEmpty() || this.commit(), this.parent.remove(this);
            }
            select() {
              var B;
              (B = this.div) == null || B.classList.add("selectedEditor");
            }
            unselect() {
              var B;
              (B = this.div) == null || B.classList.remove("selectedEditor");
            }
            updateParams(B, j) {
            }
            disableEditing() {
            }
            enableEditing() {
            }
            get propertiesToUpdate() {
              return {};
            }
            get contentDiv() {
              return this.div;
            }
            get isEditing() {
              return ge(this, n);
            }
            set isEditing(B) {
              rt(this, n, B), B ? (this.parent.setSelected(this), this.parent.setActiveEditor(this)) : this.parent.setActiveEditor(null);
            }
          };
          xe = new WeakMap(), F = new WeakMap(), ae = new WeakMap(), n = new WeakMap(), u = new WeakMap(), q = new WeakMap(), Dt(e, "_colorManager", new ue.ColorManager()), Dt(e, "_zIndex", 1);
          let Me = e;
          he.AnnotationEditor = Me;
        },
        /* 5 */
        /***/
        (Se, he, ke) => {
          var e, t, B, j, M, O, xi, i, o, k, s, l, g, v, r, x, b, I, h, y, P, c, d, A, N, E, H, $, m, p, T, bi, _, Kn, J, yi, V, wi, Q, Zt, R, yn, D, Ai, Y, Si, ie, Jn, re, wn, te, Zn;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.KeyboardManager = he.CommandManager = he.ColorManager = he.AnnotationEditorUIManager = void 0, he.bindEvents = Me, he.opacityToHex = xe;
          var ue = ke(1), me = ke(6);
          function Me(ce, le, de) {
            for (const Ie of de)
              le.addEventListener(Ie, ce[Ie].bind(ce));
          }
          function xe(ce) {
            return Math.round(Math.min(255, Math.max(1, 255 * ce))).toString(16).padStart(2, "0");
          }
          class F {
            constructor() {
              Be(this, e, 0);
            }
            getId() {
              return `${ue.AnnotationEditorPrefix}${kn(this, e)._++}`;
            }
          }
          e = new WeakMap();
          class ae {
            constructor(le = 128) {
              Be(this, t, []);
              Be(this, B, !1);
              Be(this, j, void 0);
              Be(this, M, -1);
              rt(this, j, le);
            }
            add({
              cmd: le,
              undo: de,
              mustExec: Ie,
              type: Fe = NaN,
              overwriteIfSameType: we = !1,
              keepUndo: pe = !1
            }) {
              if (Ie && le(), ge(this, B))
                return;
              const fe = {
                cmd: le,
                undo: de,
                type: Fe
              };
              if (ge(this, M) === -1) {
                ge(this, t).length > 0 && (ge(this, t).length = 0), rt(this, M, 0), ge(this, t).push(fe);
                return;
              }
              if (we && ge(this, t)[ge(this, M)].type === Fe) {
                pe && (fe.undo = ge(this, t)[ge(this, M)].undo), ge(this, t)[ge(this, M)] = fe;
                return;
              }
              const Ae = ge(this, M) + 1;
              Ae === ge(this, j) ? ge(this, t).splice(0, 1) : (rt(this, M, Ae), Ae < ge(this, t).length && ge(this, t).splice(Ae)), ge(this, t).push(fe);
            }
            undo() {
              ge(this, M) !== -1 && (rt(this, B, !0), ge(this, t)[ge(this, M)].undo(), rt(this, B, !1), rt(this, M, ge(this, M) - 1));
            }
            redo() {
              ge(this, M) < ge(this, t).length - 1 && (rt(this, M, ge(this, M) + 1), rt(this, B, !0), ge(this, t)[ge(this, M)].cmd(), rt(this, B, !1));
            }
            hasSomethingToUndo() {
              return ge(this, M) !== -1;
            }
            hasSomethingToRedo() {
              return ge(this, M) < ge(this, t).length - 1;
            }
            destroy() {
              rt(this, t, null);
            }
          }
          t = new WeakMap(), B = new WeakMap(), j = new WeakMap(), M = new WeakMap(), he.CommandManager = ae;
          class n {
            constructor(le) {
              Be(this, O);
              this.buffer = [], this.callbacks = /* @__PURE__ */ new Map(), this.allKeys = /* @__PURE__ */ new Set();
              const {
                isMac: de
              } = ue.FeatureTest.platform;
              for (const [Ie, Fe] of le)
                for (const we of Ie) {
                  const pe = we.startsWith("mac+");
                  de && pe ? (this.callbacks.set(we.slice(4), Fe), this.allKeys.add(we.split("+").at(-1))) : !de && !pe && (this.callbacks.set(we, Fe), this.allKeys.add(we.split("+").at(-1)));
                }
            }
            exec(le, de) {
              if (!this.allKeys.has(de.key))
                return;
              const Ie = this.callbacks.get(ze(this, O, xi).call(this, de));
              Ie && (Ie.bind(le)(), de.stopPropagation(), de.preventDefault());
            }
          }
          O = new WeakSet(), xi = function(le) {
            le.altKey && this.buffer.push("alt"), le.ctrlKey && this.buffer.push("ctrl"), le.metaKey && this.buffer.push("meta"), le.shiftKey && this.buffer.push("shift"), this.buffer.push(le.key);
            const de = this.buffer.join("+");
            return this.buffer.length = 0, de;
          }, he.KeyboardManager = n;
          const C = class C {
            get _colors() {
              const le = /* @__PURE__ */ new Map([["CanvasText", null], ["Canvas", null]]);
              return (0, me.getColorValues)(le), (0, ue.shadow)(this, "_colors", le);
            }
            convert(le) {
              const de = (0, me.getRGB)(le);
              if (!window.matchMedia("(forced-colors: active)").matches)
                return de;
              for (const [Ie, Fe] of this._colors)
                if (Fe.every((we, pe) => we === de[pe]))
                  return C._colorsMapping.get(Ie);
              return de;
            }
            getHexCode(le) {
              const de = this._colors.get(le);
              return de ? ue.Util.makeHexColor(...de) : le;
            }
          };
          Dt(C, "_colorsMapping", /* @__PURE__ */ new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]));
          let u = C;
          he.ColorManager = u;
          const se = class se {
            constructor(le, de, Ie) {
              Be(this, T);
              Be(this, _);
              Be(this, J);
              Be(this, V);
              Be(this, Q);
              Be(this, R);
              Be(this, D);
              Be(this, Y);
              Be(this, ie);
              Be(this, re);
              Be(this, te);
              Be(this, i, null);
              Be(this, o, /* @__PURE__ */ new Map());
              Be(this, k, /* @__PURE__ */ new Map());
              Be(this, s, null);
              Be(this, l, new ae());
              Be(this, g, 0);
              Be(this, v, null);
              Be(this, r, /* @__PURE__ */ new Set());
              Be(this, x, null);
              Be(this, b, new F());
              Be(this, I, !1);
              Be(this, h, ue.AnnotationEditorType.NONE);
              Be(this, y, /* @__PURE__ */ new Set());
              Be(this, P, this.copy.bind(this));
              Be(this, c, this.cut.bind(this));
              Be(this, d, this.paste.bind(this));
              Be(this, A, this.keydown.bind(this));
              Be(this, N, this.onEditingAction.bind(this));
              Be(this, E, this.onPageChanging.bind(this));
              Be(this, H, this.onScaleChanging.bind(this));
              Be(this, $, this.onRotationChanging.bind(this));
              Be(this, m, {
                isEditing: !1,
                isEmpty: !0,
                hasSomethingToUndo: !1,
                hasSomethingToRedo: !1,
                hasSelectedEditor: !1
              });
              Be(this, p, null);
              rt(this, p, le), rt(this, x, de), ge(this, x)._on("editingaction", ge(this, N)), ge(this, x)._on("pagechanging", ge(this, E)), ge(this, x)._on("scalechanging", ge(this, H)), ge(this, x)._on("rotationchanging", ge(this, $)), rt(this, s, Ie), this.viewParameters = {
                realScale: me.PixelsPerInch.PDF_TO_CSS_UNITS,
                rotation: 0
              };
            }
            destroy() {
              ze(this, _, Kn).call(this), ge(this, x)._off("editingaction", ge(this, N)), ge(this, x)._off("pagechanging", ge(this, E)), ge(this, x)._off("scalechanging", ge(this, H)), ge(this, x)._off("rotationchanging", ge(this, $));
              for (const le of ge(this, k).values())
                le.destroy();
              ge(this, k).clear(), ge(this, o).clear(), ge(this, r).clear(), rt(this, i, null), ge(this, y).clear(), ge(this, l).destroy();
            }
            onPageChanging({
              pageNumber: le
            }) {
              rt(this, g, le - 1);
            }
            focusMainContainer() {
              ge(this, p).focus();
            }
            addShouldRescale(le) {
              ge(this, r).add(le);
            }
            removeShouldRescale(le) {
              ge(this, r).delete(le);
            }
            onScaleChanging({
              scale: le
            }) {
              this.commitOrRemove(), this.viewParameters.realScale = le * me.PixelsPerInch.PDF_TO_CSS_UNITS;
              for (const de of ge(this, r))
                de.onScaleChanging();
            }
            onRotationChanging({
              pagesRotation: le
            }) {
              this.commitOrRemove(), this.viewParameters.rotation = le;
            }
            addToAnnotationStorage(le) {
              !le.isEmpty() && ge(this, s) && !ge(this, s).has(le.id) && ge(this, s).setValue(le.id, le);
            }
            copy(le) {
              if (le.preventDefault(), ge(this, i) && ge(this, i).commitOrRemove(), !this.hasSelection)
                return;
              const de = [];
              for (const Ie of ge(this, y))
                Ie.isEmpty() || de.push(Ie.serialize());
              de.length !== 0 && le.clipboardData.setData("application/pdfjs", JSON.stringify(de));
            }
            cut(le) {
              this.copy(le), this.delete();
            }
            paste(le) {
              le.preventDefault();
              let de = le.clipboardData.getData("application/pdfjs");
              if (!de)
                return;
              try {
                de = JSON.parse(de);
              } catch (Fe) {
                (0, ue.warn)(`paste: "${Fe.message}".`);
                return;
              }
              if (!Array.isArray(de))
                return;
              this.unselectAll();
              const Ie = ge(this, k).get(ge(this, g));
              try {
                const Fe = [];
                for (const fe of de) {
                  const Ae = Ie.deserialize(fe);
                  if (!Ae)
                    return;
                  Fe.push(Ae);
                }
                const we = () => {
                  for (const fe of Fe)
                    ze(this, ie, Jn).call(this, fe);
                  ze(this, te, Zn).call(this, Fe);
                }, pe = () => {
                  for (const fe of Fe)
                    fe.remove();
                };
                this.addCommands({
                  cmd: we,
                  undo: pe,
                  mustExec: !0
                });
              } catch (Fe) {
                (0, ue.warn)(`paste: "${Fe.message}".`);
              }
            }
            keydown(le) {
              var de;
              (de = this.getActive()) != null && de.shouldGetKeyboardEvents() || se._keyboardManager.exec(this, le);
            }
            onEditingAction(le) {
              ["undo", "redo", "delete", "selectAll"].includes(le.name) && this[le.name]();
            }
            setEditingState(le) {
              le ? (ze(this, T, bi).call(this), ze(this, J, yi).call(this), ze(this, Q, Zt).call(this, {
                isEditing: ge(this, h) !== ue.AnnotationEditorType.NONE,
                isEmpty: ze(this, re, wn).call(this),
                hasSomethingToUndo: ge(this, l).hasSomethingToUndo(),
                hasSomethingToRedo: ge(this, l).hasSomethingToRedo(),
                hasSelectedEditor: !1
              })) : (ze(this, _, Kn).call(this), ze(this, V, wi).call(this), ze(this, Q, Zt).call(this, {
                isEditing: !1
              }));
            }
            registerEditorTypes(le) {
              if (!ge(this, v)) {
                rt(this, v, le);
                for (const de of ge(this, v))
                  ze(this, R, yn).call(this, de.defaultPropertiesToUpdate);
              }
            }
            getId() {
              return ge(this, b).getId();
            }
            get currentLayer() {
              return ge(this, k).get(ge(this, g));
            }
            get currentPageIndex() {
              return ge(this, g);
            }
            addLayer(le) {
              ge(this, k).set(le.pageIndex, le), ge(this, I) ? le.enable() : le.disable();
            }
            removeLayer(le) {
              ge(this, k).delete(le.pageIndex);
            }
            updateMode(le) {
              if (rt(this, h, le), le === ue.AnnotationEditorType.NONE)
                this.setEditingState(!1), ze(this, Y, Si).call(this);
              else {
                this.setEditingState(!0), ze(this, D, Ai).call(this);
                for (const de of ge(this, k).values())
                  de.updateMode(le);
              }
            }
            updateToolbar(le) {
              le !== ge(this, h) && ge(this, x).dispatch("switchannotationeditormode", {
                source: this,
                mode: le
              });
            }
            updateParams(le, de) {
              if (ge(this, v)) {
                for (const Ie of ge(this, y))
                  Ie.updateParams(le, de);
                for (const Ie of ge(this, v))
                  Ie.updateDefaultParams(le, de);
              }
            }
            getEditors(le) {
              const de = [];
              for (const Ie of ge(this, o).values())
                Ie.pageIndex === le && de.push(Ie);
              return de;
            }
            getEditor(le) {
              return ge(this, o).get(le);
            }
            addEditor(le) {
              ge(this, o).set(le.id, le);
            }
            removeEditor(le) {
              var de;
              ge(this, o).delete(le.id), this.unselect(le), (de = ge(this, s)) == null || de.remove(le.id);
            }
            setActiveEditor(le) {
              ge(this, i) !== le && (rt(this, i, le), le && ze(this, R, yn).call(this, le.propertiesToUpdate));
            }
            toggleSelected(le) {
              if (ge(this, y).has(le)) {
                ge(this, y).delete(le), le.unselect(), ze(this, Q, Zt).call(this, {
                  hasSelectedEditor: this.hasSelection
                });
                return;
              }
              ge(this, y).add(le), le.select(), ze(this, R, yn).call(this, le.propertiesToUpdate), ze(this, Q, Zt).call(this, {
                hasSelectedEditor: !0
              });
            }
            setSelected(le) {
              for (const de of ge(this, y))
                de !== le && de.unselect();
              ge(this, y).clear(), ge(this, y).add(le), le.select(), ze(this, R, yn).call(this, le.propertiesToUpdate), ze(this, Q, Zt).call(this, {
                hasSelectedEditor: !0
              });
            }
            isSelected(le) {
              return ge(this, y).has(le);
            }
            unselect(le) {
              le.unselect(), ge(this, y).delete(le), ze(this, Q, Zt).call(this, {
                hasSelectedEditor: this.hasSelection
              });
            }
            get hasSelection() {
              return ge(this, y).size !== 0;
            }
            undo() {
              ge(this, l).undo(), ze(this, Q, Zt).call(this, {
                hasSomethingToUndo: ge(this, l).hasSomethingToUndo(),
                hasSomethingToRedo: !0,
                isEmpty: ze(this, re, wn).call(this)
              });
            }
            redo() {
              ge(this, l).redo(), ze(this, Q, Zt).call(this, {
                hasSomethingToUndo: !0,
                hasSomethingToRedo: ge(this, l).hasSomethingToRedo(),
                isEmpty: ze(this, re, wn).call(this)
              });
            }
            addCommands(le) {
              ge(this, l).add(le), ze(this, Q, Zt).call(this, {
                hasSomethingToUndo: !0,
                hasSomethingToRedo: !1,
                isEmpty: ze(this, re, wn).call(this)
              });
            }
            delete() {
              if (this.commitOrRemove(), !this.hasSelection)
                return;
              const le = [...ge(this, y)], de = () => {
                for (const Fe of le)
                  Fe.remove();
              }, Ie = () => {
                for (const Fe of le)
                  ze(this, ie, Jn).call(this, Fe);
              };
              this.addCommands({
                cmd: de,
                undo: Ie,
                mustExec: !0
              });
            }
            commitOrRemove() {
              var le;
              (le = ge(this, i)) == null || le.commitOrRemove();
            }
            selectAll() {
              for (const le of ge(this, y))
                le.commit();
              ze(this, te, Zn).call(this, ge(this, o).values());
            }
            unselectAll() {
              if (ge(this, i)) {
                ge(this, i).commitOrRemove();
                return;
              }
              if (ge(this, y).size !== 0) {
                for (const le of ge(this, y))
                  le.unselect();
                ge(this, y).clear(), ze(this, Q, Zt).call(this, {
                  hasSelectedEditor: !1
                });
              }
            }
            isActive(le) {
              return ge(this, i) === le;
            }
            getActive() {
              return ge(this, i);
            }
            getMode() {
              return ge(this, h);
            }
          };
          i = new WeakMap(), o = new WeakMap(), k = new WeakMap(), s = new WeakMap(), l = new WeakMap(), g = new WeakMap(), v = new WeakMap(), r = new WeakMap(), x = new WeakMap(), b = new WeakMap(), I = new WeakMap(), h = new WeakMap(), y = new WeakMap(), P = new WeakMap(), c = new WeakMap(), d = new WeakMap(), A = new WeakMap(), N = new WeakMap(), E = new WeakMap(), H = new WeakMap(), $ = new WeakMap(), m = new WeakMap(), p = new WeakMap(), T = new WeakSet(), bi = function() {
            ge(this, p).addEventListener("keydown", ge(this, A));
          }, _ = new WeakSet(), Kn = function() {
            ge(this, p).removeEventListener("keydown", ge(this, A));
          }, J = new WeakSet(), yi = function() {
            document.addEventListener("copy", ge(this, P)), document.addEventListener("cut", ge(this, c)), document.addEventListener("paste", ge(this, d));
          }, V = new WeakSet(), wi = function() {
            document.removeEventListener("copy", ge(this, P)), document.removeEventListener("cut", ge(this, c)), document.removeEventListener("paste", ge(this, d));
          }, Q = new WeakSet(), Zt = function(le) {
            Object.entries(le).some(([Ie, Fe]) => ge(this, m)[Ie] !== Fe) && ge(this, x).dispatch("annotationeditorstateschanged", {
              source: this,
              details: Object.assign(ge(this, m), le)
            });
          }, R = new WeakSet(), yn = function(le) {
            ge(this, x).dispatch("annotationeditorparamschanged", {
              source: this,
              details: le
            });
          }, D = new WeakSet(), Ai = function() {
            if (!ge(this, I)) {
              rt(this, I, !0);
              for (const le of ge(this, k).values())
                le.enable();
            }
          }, Y = new WeakSet(), Si = function() {
            if (this.unselectAll(), ge(this, I)) {
              rt(this, I, !1);
              for (const le of ge(this, k).values())
                le.disable();
            }
          }, ie = new WeakSet(), Jn = function(le) {
            const de = ge(this, k).get(le.pageIndex);
            de ? de.addOrRebuild(le) : this.addEditor(le);
          }, re = new WeakSet(), wn = function() {
            if (ge(this, o).size === 0)
              return !0;
            if (ge(this, o).size === 1)
              for (const le of ge(this, o).values())
                return le.isEmpty();
            return !1;
          }, te = new WeakSet(), Zn = function(le) {
            ge(this, y).clear();
            for (const de of le)
              de.isEmpty() || (ge(this, y).add(de), de.select());
            ze(this, Q, Zt).call(this, {
              hasSelectedEditor: !0
            });
          }, Dt(se, "_keyboardManager", new n([[["ctrl+a", "mac+meta+a"], se.prototype.selectAll], [["ctrl+z", "mac+meta+z"], se.prototype.undo], [["ctrl+y", "ctrl+shift+Z", "mac+meta+shift+Z"], se.prototype.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete"], se.prototype.delete], [["Escape", "mac+Escape"], se.prototype.unselectAll]]));
          let q = se;
          he.AnnotationEditorUIManager = q;
        },
        /* 6 */
        /***/
        (Se, he, ke) => {
          var P, c, d, A, N, E, H, $, m, dn, T, sn, _, tn;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.StatTimer = he.RenderingCancelledException = he.PixelsPerInch = he.PageViewport = he.PDFDateString = he.DOMStandardFontDataFactory = he.DOMSVGFactory = he.DOMFilterFactory = he.DOMCanvasFactory = he.DOMCMapReaderFactory = he.AnnotationPrefix = void 0, he.deprecated = s, he.getColorValues = x, he.getCurrentTransform = b, he.getCurrentTransformInverse = I, he.getFilenameFromUrl = w, he.getPdfFilenameFromUrl = C, he.getRGB = r, he.getXfaPageViewport = v, he.isDataScheme = M, he.isPdfFile = O, he.isValidFetchUrl = o, he.loadScript = k, he.setLayerDimensions = h;
          var ue = ke(7), me = ke(1);
          const Me = "http://www.w3.org/2000/svg", xe = "pdfjs_internal_id_";
          he.AnnotationPrefix = xe;
          const y = class y {
          };
          Dt(y, "CSS", 96), Dt(y, "PDF", 72), Dt(y, "PDF_TO_CSS_UNITS", y.CSS / y.PDF);
          let F = y;
          he.PixelsPerInch = F;
          class ae extends ue.BaseFilterFactory {
            constructor({
              docId: V,
              ownerDocument: U = globalThis.document
            } = {}) {
              super();
              Be(this, m);
              Be(this, T);
              Be(this, _);
              Be(this, P, void 0);
              Be(this, c, void 0);
              Be(this, d, void 0);
              Be(this, A, void 0);
              Be(this, N, void 0);
              Be(this, E, void 0);
              Be(this, H, void 0);
              Be(this, $, 0);
              rt(this, d, V), rt(this, A, U);
            }
            addFilter(V) {
              if (!V)
                return "none";
              let U = ge(this, m, dn).get(V);
              if (U)
                return U;
              let Q, X, R, f;
              if (V.length === 1) {
                const ie = V[0], ne = new Array(256);
                for (let re = 0; re < 256; re++)
                  ne[re] = ie[re] / 255;
                f = Q = X = R = ne.join(",");
              } else {
                const [ie, ne, re] = V, ee = new Array(256), te = new Array(256), oe = new Array(256);
                for (let se = 0; se < 256; se++)
                  ee[se] = ie[se] / 255, te[se] = ne[se] / 255, oe[se] = re[se] / 255;
                Q = ee.join(","), X = te.join(","), R = oe.join(","), f = `${Q}${X}${R}`;
              }
              if (U = ge(this, m, dn).get(f), U)
                return ge(this, m, dn).set(V, U), U;
              const D = `g_${ge(this, d)}_transfer_map_${kn(this, $)._++}`, z = `url(#${D})`;
              ge(this, m, dn).set(V, z), ge(this, m, dn).set(f, z);
              const Y = ge(this, A).createElementNS(Me, "filter", Me);
              Y.setAttribute("id", D), Y.setAttribute("color-interpolation-filters", "sRGB");
              const W = ge(this, A).createElementNS(Me, "feComponentTransfer");
              return Y.append(W), ze(this, _, tn).call(this, W, "feFuncR", Q), ze(this, _, tn).call(this, W, "feFuncG", X), ze(this, _, tn).call(this, W, "feFuncB", R), ge(this, T, sn).append(Y), z;
            }
            addHCMFilter(V, U) {
              var re;
              const Q = `${V}-${U}`;
              if (ge(this, E) === Q)
                return ge(this, H);
              if (rt(this, E, Q), rt(this, H, "none"), (re = ge(this, N)) == null || re.remove(), !V || !U)
                return ge(this, H);
              ge(this, T, sn).style.color = V, V = getComputedStyle(ge(this, T, sn)).getPropertyValue("color");
              const X = r(V);
              V = me.Util.makeHexColor(...X), ge(this, T, sn).style.color = U, U = getComputedStyle(ge(this, T, sn)).getPropertyValue("color");
              const R = r(U);
              if (U = me.Util.makeHexColor(...R), ge(this, T, sn).style.color = "", V === "#000000" && U === "#ffffff" || V === U)
                return ge(this, H);
              const f = new Array(256);
              for (let ee = 0; ee <= 255; ee++) {
                const te = ee / 255;
                f[ee] = te <= 0.03928 ? te / 12.92 : ((te + 0.055) / 1.055) ** 2.4;
              }
              const D = f.join(","), z = `g_${ge(this, d)}_hcm_filter`, Y = rt(this, N, ge(this, A).createElementNS(Me, "filter", Me));
              Y.setAttribute("id", z), Y.setAttribute("color-interpolation-filters", "sRGB");
              let W = ge(this, A).createElementNS(Me, "feComponentTransfer");
              Y.append(W), ze(this, _, tn).call(this, W, "feFuncR", D), ze(this, _, tn).call(this, W, "feFuncG", D), ze(this, _, tn).call(this, W, "feFuncB", D);
              const ie = ge(this, A).createElementNS(Me, "feColorMatrix");
              ie.setAttribute("type", "matrix"), ie.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0"), Y.append(ie), W = ge(this, A).createElementNS(Me, "feComponentTransfer"), Y.append(W);
              const ne = (ee, te) => {
                const oe = X[ee] / 255, se = R[ee] / 255, ce = new Array(te + 1);
                for (let le = 0; le <= te; le++)
                  ce[le] = oe + le / te * (se - oe);
                return ce.join(",");
              };
              return ze(this, _, tn).call(this, W, "feFuncR", ne(0, 5)), ze(this, _, tn).call(this, W, "feFuncG", ne(1, 5)), ze(this, _, tn).call(this, W, "feFuncB", ne(2, 5)), ge(this, T, sn).append(Y), rt(this, H, `url(#${z})`), ge(this, H);
            }
            destroy(V = !1) {
              V && ge(this, H) || (ge(this, c) && (ge(this, c).parentNode.parentNode.remove(), rt(this, c, null)), ge(this, P) && (ge(this, P).clear(), rt(this, P, null)), rt(this, $, 0));
            }
          }
          P = new WeakMap(), c = new WeakMap(), d = new WeakMap(), A = new WeakMap(), N = new WeakMap(), E = new WeakMap(), H = new WeakMap(), $ = new WeakMap(), m = new WeakSet(), dn = function() {
            return ge(this, P) || rt(this, P, /* @__PURE__ */ new Map());
          }, T = new WeakSet(), sn = function() {
            if (!ge(this, c)) {
              const V = ge(this, A).createElement("div"), {
                style: U
              } = V;
              U.visibility = "hidden", U.contain = "strict", U.width = U.height = 0, U.position = "absolute", U.top = U.left = 0, U.zIndex = -1;
              const Q = ge(this, A).createElementNS(Me, "svg");
              Q.setAttribute("width", 0), Q.setAttribute("height", 0), rt(this, c, ge(this, A).createElementNS(Me, "defs")), V.append(Q), Q.append(ge(this, c)), ge(this, A).body.append(V);
            }
            return ge(this, c);
          }, _ = new WeakSet(), tn = function(V, U, Q) {
            const X = ge(this, A).createElementNS(Me, U);
            X.setAttribute("type", "discrete"), X.setAttribute("tableValues", Q), V.append(X);
          }, he.DOMFilterFactory = ae;
          class n extends ue.BaseCanvasFactory {
            constructor({
              ownerDocument: K = globalThis.document
            } = {}) {
              super(), this._document = K;
            }
            _createCanvas(K, V) {
              const U = this._document.createElement("canvas");
              return U.width = K, U.height = V, U;
            }
          }
          he.DOMCanvasFactory = n;
          async function u(J, K = !1) {
            if (o(J, document.baseURI)) {
              const V = await fetch(J);
              if (!V.ok)
                throw new Error(V.statusText);
              return K ? new Uint8Array(await V.arrayBuffer()) : (0, me.stringToBytes)(await V.text());
            }
            return new Promise((V, U) => {
              const Q = new XMLHttpRequest();
              Q.open("GET", J, !0), K && (Q.responseType = "arraybuffer"), Q.onreadystatechange = () => {
                if (Q.readyState === XMLHttpRequest.DONE) {
                  if (Q.status === 200 || Q.status === 0) {
                    let X;
                    if (K && Q.response ? X = new Uint8Array(Q.response) : !K && Q.responseText && (X = (0, me.stringToBytes)(Q.responseText)), X) {
                      V(X);
                      return;
                    }
                  }
                  U(new Error(Q.statusText));
                }
              }, Q.send(null);
            });
          }
          class q extends ue.BaseCMapReaderFactory {
            _fetchData(K, V) {
              return u(K, this.isCompressed).then((U) => ({
                cMapData: U,
                compressionType: V
              }));
            }
          }
          he.DOMCMapReaderFactory = q;
          class e extends ue.BaseStandardFontDataFactory {
            _fetchData(K) {
              return u(K, !0);
            }
          }
          he.DOMStandardFontDataFactory = e;
          class t extends ue.BaseSVGFactory {
            _createSVG(K) {
              return document.createElementNS(Me, K);
            }
          }
          he.DOMSVGFactory = t;
          class B {
            constructor({
              viewBox: K,
              scale: V,
              rotation: U,
              offsetX: Q = 0,
              offsetY: X = 0,
              dontFlip: R = !1
            }) {
              this.viewBox = K, this.scale = V, this.rotation = U, this.offsetX = Q, this.offsetY = X;
              const f = (K[2] + K[0]) / 2, D = (K[3] + K[1]) / 2;
              let z, Y, W, ie;
              switch (U %= 360, U < 0 && (U += 360), U) {
                case 180:
                  z = -1, Y = 0, W = 0, ie = 1;
                  break;
                case 90:
                  z = 0, Y = 1, W = 1, ie = 0;
                  break;
                case 270:
                  z = 0, Y = -1, W = -1, ie = 0;
                  break;
                case 0:
                  z = 1, Y = 0, W = 0, ie = -1;
                  break;
                default:
                  throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
              }
              R && (W = -W, ie = -ie);
              let ne, re, ee, te;
              z === 0 ? (ne = Math.abs(D - K[1]) * V + Q, re = Math.abs(f - K[0]) * V + X, ee = (K[3] - K[1]) * V, te = (K[2] - K[0]) * V) : (ne = Math.abs(f - K[0]) * V + Q, re = Math.abs(D - K[1]) * V + X, ee = (K[2] - K[0]) * V, te = (K[3] - K[1]) * V), this.transform = [z * V, Y * V, W * V, ie * V, ne - z * V * f - W * V * D, re - Y * V * f - ie * V * D], this.width = ee, this.height = te;
            }
            get rawDims() {
              const {
                viewBox: K
              } = this;
              return (0, me.shadow)(this, "rawDims", {
                pageWidth: K[2] - K[0],
                pageHeight: K[3] - K[1],
                pageX: K[0],
                pageY: K[1]
              });
            }
            clone({
              scale: K = this.scale,
              rotation: V = this.rotation,
              offsetX: U = this.offsetX,
              offsetY: Q = this.offsetY,
              dontFlip: X = !1
            } = {}) {
              return new B({
                viewBox: this.viewBox.slice(),
                scale: K,
                rotation: V,
                offsetX: U,
                offsetY: Q,
                dontFlip: X
              });
            }
            convertToViewportPoint(K, V) {
              return me.Util.applyTransform([K, V], this.transform);
            }
            convertToViewportRectangle(K) {
              const V = me.Util.applyTransform([K[0], K[1]], this.transform), U = me.Util.applyTransform([K[2], K[3]], this.transform);
              return [V[0], V[1], U[0], U[1]];
            }
            convertToPdfPoint(K, V) {
              return me.Util.applyInverseTransform([K, V], this.transform);
            }
          }
          he.PageViewport = B;
          class j extends me.BaseException {
            constructor(K, V, U = 0) {
              super(K, "RenderingCancelledException"), this.type = V, this.extraDelay = U;
            }
          }
          he.RenderingCancelledException = j;
          function M(J) {
            const K = J.length;
            let V = 0;
            for (; V < K && J[V].trim() === ""; )
              V++;
            return J.substring(V, V + 5).toLowerCase() === "data:";
          }
          function O(J) {
            return typeof J == "string" && /\.pdf$/i.test(J);
          }
          function w(J, K = !1) {
            return K || ([J] = J.split(/[#?]/, 1)), J.substring(J.lastIndexOf("/") + 1);
          }
          function C(J, K = "document.pdf") {
            if (typeof J != "string")
              return K;
            if (M(J))
              return (0, me.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.'), K;
            const V = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/, U = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i, Q = V.exec(J);
            let X = U.exec(Q[1]) || U.exec(Q[2]) || U.exec(Q[3]);
            if (X && (X = X[0], X.includes("%")))
              try {
                X = U.exec(decodeURIComponent(X))[0];
              } catch {
              }
            return X || K;
          }
          class i {
            constructor() {
              Dt(this, "started", /* @__PURE__ */ Object.create(null));
              Dt(this, "times", []);
            }
            time(K) {
              K in this.started && (0, me.warn)(`Timer is already running for ${K}`), this.started[K] = Date.now();
            }
            timeEnd(K) {
              K in this.started || (0, me.warn)(`Timer has not been started for ${K}`), this.times.push({
                name: K,
                start: this.started[K],
                end: Date.now()
              }), delete this.started[K];
            }
            toString() {
              const K = [];
              let V = 0;
              for (const {
                name: U
              } of this.times)
                V = Math.max(U.length, V);
              for (const {
                name: U,
                start: Q,
                end: X
              } of this.times)
                K.push(`${U.padEnd(V)} ${X - Q}ms
`);
              return K.join("");
            }
          }
          he.StatTimer = i;
          function o(J, K) {
            try {
              const {
                protocol: V
              } = K ? new URL(J, K) : new URL(J);
              return V === "http:" || V === "https:";
            } catch {
              return !1;
            }
          }
          function k(J, K = !1) {
            return new Promise((V, U) => {
              const Q = document.createElement("script");
              Q.src = J, Q.onload = function(X) {
                K && Q.remove(), V(X);
              }, Q.onerror = function() {
                U(new Error(`Cannot load script at: ${Q.src}`));
              }, (document.head || document.documentElement).append(Q);
            });
          }
          function s(J) {
            console.log("Deprecated API usage: " + J);
          }
          let l;
          class g {
            static toDateObject(K) {
              if (!K || typeof K != "string")
                return null;
              l || (l = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
              const V = l.exec(K);
              if (!V)
                return null;
              const U = parseInt(V[1], 10);
              let Q = parseInt(V[2], 10);
              Q = Q >= 1 && Q <= 12 ? Q - 1 : 0;
              let X = parseInt(V[3], 10);
              X = X >= 1 && X <= 31 ? X : 1;
              let R = parseInt(V[4], 10);
              R = R >= 0 && R <= 23 ? R : 0;
              let f = parseInt(V[5], 10);
              f = f >= 0 && f <= 59 ? f : 0;
              let D = parseInt(V[6], 10);
              D = D >= 0 && D <= 59 ? D : 0;
              const z = V[7] || "Z";
              let Y = parseInt(V[8], 10);
              Y = Y >= 0 && Y <= 23 ? Y : 0;
              let W = parseInt(V[9], 10) || 0;
              return W = W >= 0 && W <= 59 ? W : 0, z === "-" ? (R += Y, f += W) : z === "+" && (R -= Y, f -= W), new Date(Date.UTC(U, Q, X, R, f, D));
            }
          }
          he.PDFDateString = g;
          function v(J, {
            scale: K = 1,
            rotation: V = 0
          }) {
            const {
              width: U,
              height: Q
            } = J.attributes.style, X = [0, 0, parseInt(U), parseInt(Q)];
            return new B({
              viewBox: X,
              scale: K,
              rotation: V
            });
          }
          function r(J) {
            if (J.startsWith("#")) {
              const K = parseInt(J.slice(1), 16);
              return [(K & 16711680) >> 16, (K & 65280) >> 8, K & 255];
            }
            return J.startsWith("rgb(") ? J.slice(4, -1).split(",").map((K) => parseInt(K)) : J.startsWith("rgba(") ? J.slice(5, -1).split(",").map((K) => parseInt(K)).slice(0, 3) : ((0, me.warn)(`Not a valid color format: "${J}"`), [0, 0, 0]);
          }
          function x(J) {
            const K = document.createElement("span");
            K.style.visibility = "hidden", document.body.append(K);
            for (const V of J.keys()) {
              K.style.color = V;
              const U = window.getComputedStyle(K).color;
              J.set(V, r(U));
            }
            K.remove();
          }
          function b(J) {
            const {
              a: K,
              b: V,
              c: U,
              d: Q,
              e: X,
              f: R
            } = J.getTransform();
            return [K, V, U, Q, X, R];
          }
          function I(J) {
            const {
              a: K,
              b: V,
              c: U,
              d: Q,
              e: X,
              f: R
            } = J.getTransform().invertSelf();
            return [K, V, U, Q, X, R];
          }
          function h(J, K, V = !1, U = !0) {
            if (K instanceof B) {
              const {
                pageWidth: Q,
                pageHeight: X
              } = K.rawDims, {
                style: R
              } = J, f = `calc(var(--scale-factor) * ${Q}px)`, D = `calc(var(--scale-factor) * ${X}px)`;
              !V || K.rotation % 180 === 0 ? (R.width = f, R.height = D) : (R.width = D, R.height = f);
            }
            U && J.setAttribute("data-main-rotation", K.rotation);
          }
        },
        /* 7 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.BaseStandardFontDataFactory = he.BaseSVGFactory = he.BaseFilterFactory = he.BaseCanvasFactory = he.BaseCMapReaderFactory = void 0;
          var ue = ke(1);
          class me {
            constructor() {
              this.constructor === me && (0, ue.unreachable)("Cannot initialize BaseFilterFactory.");
            }
            addFilter(u) {
              return "none";
            }
            addHCMFilter(u, q) {
              return "none";
            }
            destroy(u = !1) {
            }
          }
          he.BaseFilterFactory = me;
          class Me {
            constructor() {
              this.constructor === Me && (0, ue.unreachable)("Cannot initialize BaseCanvasFactory.");
            }
            create(u, q) {
              if (u <= 0 || q <= 0)
                throw new Error("Invalid canvas size");
              const e = this._createCanvas(u, q);
              return {
                canvas: e,
                context: e.getContext("2d")
              };
            }
            reset(u, q, e) {
              if (!u.canvas)
                throw new Error("Canvas is not specified");
              if (q <= 0 || e <= 0)
                throw new Error("Invalid canvas size");
              u.canvas.width = q, u.canvas.height = e;
            }
            destroy(u) {
              if (!u.canvas)
                throw new Error("Canvas is not specified");
              u.canvas.width = 0, u.canvas.height = 0, u.canvas = null, u.context = null;
            }
            _createCanvas(u, q) {
              (0, ue.unreachable)("Abstract method `_createCanvas` called.");
            }
          }
          he.BaseCanvasFactory = Me;
          class xe {
            constructor({
              baseUrl: u = null,
              isCompressed: q = !0
            }) {
              this.constructor === xe && (0, ue.unreachable)("Cannot initialize BaseCMapReaderFactory."), this.baseUrl = u, this.isCompressed = q;
            }
            async fetch({
              name: u
            }) {
              if (!this.baseUrl)
                throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
              if (!u)
                throw new Error("CMap name must be specified.");
              const q = this.baseUrl + u + (this.isCompressed ? ".bcmap" : ""), e = this.isCompressed ? ue.CMapCompressionType.BINARY : ue.CMapCompressionType.NONE;
              return this._fetchData(q, e).catch((t) => {
                throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${q}`);
              });
            }
            _fetchData(u, q) {
              (0, ue.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          he.BaseCMapReaderFactory = xe;
          class F {
            constructor({
              baseUrl: u = null
            }) {
              this.constructor === F && (0, ue.unreachable)("Cannot initialize BaseStandardFontDataFactory."), this.baseUrl = u;
            }
            async fetch({
              filename: u
            }) {
              if (!this.baseUrl)
                throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
              if (!u)
                throw new Error("Font filename must be specified.");
              const q = `${this.baseUrl}${u}`;
              return this._fetchData(q).catch((e) => {
                throw new Error(`Unable to load font data at: ${q}`);
              });
            }
            _fetchData(u) {
              (0, ue.unreachable)("Abstract method `_fetchData` called.");
            }
          }
          he.BaseStandardFontDataFactory = F;
          class ae {
            constructor() {
              this.constructor === ae && (0, ue.unreachable)("Cannot initialize BaseSVGFactory.");
            }
            create(u, q, e = !1) {
              if (u <= 0 || q <= 0)
                throw new Error("Invalid SVG dimensions");
              const t = this._createSVG("svg:svg");
              return t.setAttribute("version", "1.1"), e || (t.setAttribute("width", `${u}px`), t.setAttribute("height", `${q}px`)), t.setAttribute("preserveAspectRatio", "none"), t.setAttribute("viewBox", `0 0 ${u} ${q}`), t;
            }
            createElement(u) {
              if (typeof u != "string")
                throw new Error("Invalid SVG element type");
              return this._createSVG(u);
            }
            _createSVG(u) {
              (0, ue.unreachable)("Abstract method `_createSVG` called.");
            }
          }
          he.BaseSVGFactory = ae;
        },
        /* 8 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.MurmurHash3_64 = void 0;
          var ue = ke(1);
          const me = 3285377520, Me = 4294901760, xe = 65535;
          class F {
            constructor(n) {
              this.h1 = n ? n & 4294967295 : me, this.h2 = n ? n & 4294967295 : me;
            }
            update(n) {
              let u, q;
              if (typeof n == "string") {
                u = new Uint8Array(n.length * 2), q = 0;
                for (let s = 0, l = n.length; s < l; s++) {
                  const g = n.charCodeAt(s);
                  g <= 255 ? u[q++] = g : (u[q++] = g >>> 8, u[q++] = g & 255);
                }
              } else if ((0, ue.isArrayBuffer)(n))
                u = n.slice(), q = u.byteLength;
              else
                throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
              const e = q >> 2, t = q - e * 4, B = new Uint32Array(u.buffer, 0, e);
              let j = 0, M = 0, O = this.h1, w = this.h2;
              const C = 3432918353, i = 461845907, o = C & xe, k = i & xe;
              for (let s = 0; s < e; s++)
                s & 1 ? (j = B[s], j = j * C & Me | j * o & xe, j = j << 15 | j >>> 17, j = j * i & Me | j * k & xe, O ^= j, O = O << 13 | O >>> 19, O = O * 5 + 3864292196) : (M = B[s], M = M * C & Me | M * o & xe, M = M << 15 | M >>> 17, M = M * i & Me | M * k & xe, w ^= M, w = w << 13 | w >>> 19, w = w * 5 + 3864292196);
              switch (j = 0, t) {
                case 3:
                  j ^= u[e * 4 + 2] << 16;
                case 2:
                  j ^= u[e * 4 + 1] << 8;
                case 1:
                  j ^= u[e * 4], j = j * C & Me | j * o & xe, j = j << 15 | j >>> 17, j = j * i & Me | j * k & xe, e & 1 ? O ^= j : w ^= j;
              }
              this.h1 = O, this.h2 = w;
            }
            hexdigest() {
              let n = this.h1, u = this.h2;
              return n ^= u >>> 1, n = n * 3981806797 & Me | n * 36045 & xe, u = u * 4283543511 & Me | ((u << 16 | n >>> 16) * 2950163797 & Me) >>> 16, n ^= u >>> 1, n = n * 444984403 & Me | n * 60499 & xe, u = u * 3301882366 & Me | ((u << 16 | n >>> 16) * 3120437893 & Me) >>> 16, n ^= u >>> 1, (n >>> 0).toString(16).padStart(8, "0") + (u >>> 0).toString(16).padStart(8, "0");
            }
          }
          he.MurmurHash3_64 = F;
        },
        /* 9 */
        /***/
        (Se, he, ke) => {
          var F;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.FontLoader = he.FontFaceObject = void 0;
          var ue = ke(1), me = ke(10);
          class Me {
            constructor({
              ownerDocument: n = globalThis.document,
              styleElement: u = null
            }) {
              Be(this, F, /* @__PURE__ */ new Set());
              this._document = n, this.nativeFontFaces = /* @__PURE__ */ new Set(), this.styleElement = null, this.loadingRequests = [], this.loadTestFontId = 0;
            }
            addNativeFontFace(n) {
              this.nativeFontFaces.add(n), this._document.fonts.add(n);
            }
            removeNativeFontFace(n) {
              this.nativeFontFaces.delete(n), this._document.fonts.delete(n);
            }
            insertRule(n) {
              this.styleElement || (this.styleElement = this._document.createElement("style"), this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement));
              const u = this.styleElement.sheet;
              u.insertRule(n, u.cssRules.length);
            }
            clear() {
              for (const n of this.nativeFontFaces)
                this._document.fonts.delete(n);
              this.nativeFontFaces.clear(), ge(this, F).clear(), this.styleElement && (this.styleElement.remove(), this.styleElement = null);
            }
            async loadSystemFont(n) {
              if (!(!n || ge(this, F).has(n.loadedName))) {
                if ((0, ue.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set."), this.isFontLoadingAPISupported) {
                  const {
                    loadedName: u,
                    src: q,
                    style: e
                  } = n, t = new FontFace(u, q, e);
                  this.addNativeFontFace(t);
                  try {
                    await t.load(), ge(this, F).add(u);
                  } catch {
                    (0, ue.warn)(`Cannot load system font: ${n.baseFontName}, installing it could help to improve PDF rendering.`), this.removeNativeFontFace(t);
                  }
                  return;
                }
                (0, ue.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
              }
            }
            async bind(n) {
              if (n.attached || n.missingFile && !n.systemFontInfo)
                return;
              if (n.attached = !0, n.systemFontInfo) {
                await this.loadSystemFont(n.systemFontInfo);
                return;
              }
              if (this.isFontLoadingAPISupported) {
                const q = n.createNativeFontFace();
                if (q) {
                  this.addNativeFontFace(q);
                  try {
                    await q.loaded;
                  } catch (e) {
                    throw (0, ue.warn)(`Failed to load font '${q.family}': '${e}'.`), n.disableFontFace = !0, e;
                  }
                }
                return;
              }
              const u = n.createFontFaceRule();
              if (u) {
                if (this.insertRule(u), this.isSyncFontLoadingSupported)
                  return;
                await new Promise((q) => {
                  const e = this._queueLoadingCallback(q);
                  this._prepareFontLoadEvent(n, e);
                });
              }
            }
            get isFontLoadingAPISupported() {
              var u;
              const n = !!((u = this._document) != null && u.fonts);
              return (0, ue.shadow)(this, "isFontLoadingAPISupported", n);
            }
            get isSyncFontLoadingSupported() {
              let n = !1;
              return (me.isNodeJS || typeof navigator < "u" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) && (n = !0), (0, ue.shadow)(this, "isSyncFontLoadingSupported", n);
            }
            _queueLoadingCallback(n) {
              function u() {
                for ((0, ue.assert)(!e.done, "completeRequest() cannot be called twice."), e.done = !0; q.length > 0 && q[0].done; ) {
                  const t = q.shift();
                  setTimeout(t.callback, 0);
                }
              }
              const {
                loadingRequests: q
              } = this, e = {
                done: !1,
                complete: u,
                callback: n
              };
              return q.push(e), e;
            }
            get _loadTestFont() {
              const n = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
              return (0, ue.shadow)(this, "_loadTestFont", n);
            }
            _prepareFontLoadEvent(n, u) {
              function q(x, b) {
                return x.charCodeAt(b) << 24 | x.charCodeAt(b + 1) << 16 | x.charCodeAt(b + 2) << 8 | x.charCodeAt(b + 3) & 255;
              }
              function e(x, b, I, h) {
                const y = x.substring(0, b), P = x.substring(b + I);
                return y + h + P;
              }
              let t, B;
              const j = this._document.createElement("canvas");
              j.width = 1, j.height = 1;
              const M = j.getContext("2d");
              let O = 0;
              function w(x, b) {
                if (++O > 30) {
                  (0, ue.warn)("Load test font never loaded."), b();
                  return;
                }
                if (M.font = "30px " + x, M.fillText(".", 0, 20), M.getImageData(0, 0, 1, 1).data[3] > 0) {
                  b();
                  return;
                }
                setTimeout(w.bind(null, x, b));
              }
              const C = `lt${Date.now()}${this.loadTestFontId++}`;
              let i = this._loadTestFont;
              i = e(i, 976, C.length, C);
              const k = 16, s = 1482184792;
              let l = q(i, k);
              for (t = 0, B = C.length - 3; t < B; t += 4)
                l = l - s + q(C, t) | 0;
              t < C.length && (l = l - s + q(C + "XXX", t) | 0), i = e(i, k, 4, (0, ue.string32)(l));
              const g = `url(data:font/opentype;base64,${btoa(i)});`, v = `@font-face {font-family:"${C}";src:${g}}`;
              this.insertRule(v);
              const r = this._document.createElement("div");
              r.style.visibility = "hidden", r.style.width = r.style.height = "10px", r.style.position = "absolute", r.style.top = r.style.left = "0px";
              for (const x of [n.loadedName, C]) {
                const b = this._document.createElement("span");
                b.textContent = "Hi", b.style.fontFamily = x, r.append(b);
              }
              this._document.body.append(r), w(C, () => {
                r.remove(), u.complete();
              });
            }
          }
          F = new WeakMap(), he.FontLoader = Me;
          class xe {
            constructor(n, {
              isEvalSupported: u = !0,
              disableFontFace: q = !1,
              ignoreErrors: e = !1,
              inspectFont: t = null
            }) {
              this.compiledGlyphs = /* @__PURE__ */ Object.create(null);
              for (const B in n)
                this[B] = n[B];
              this.isEvalSupported = u !== !1, this.disableFontFace = q === !0, this.ignoreErrors = e === !0, this._inspectFont = t;
            }
            createNativeFontFace() {
              var u;
              if (!this.data || this.disableFontFace)
                return null;
              let n;
              if (!this.cssFontInfo)
                n = new FontFace(this.loadedName, this.data, {});
              else {
                const q = {
                  weight: this.cssFontInfo.fontWeight
                };
                this.cssFontInfo.italicAngle && (q.style = `oblique ${this.cssFontInfo.italicAngle}deg`), n = new FontFace(this.cssFontInfo.fontFamily, this.data, q);
              }
              return (u = this._inspectFont) == null || u.call(this, this), n;
            }
            createFontFaceRule() {
              var e;
              if (!this.data || this.disableFontFace)
                return null;
              const n = (0, ue.bytesToString)(this.data), u = `url(data:${this.mimetype};base64,${btoa(n)});`;
              let q;
              if (!this.cssFontInfo)
                q = `@font-face {font-family:"${this.loadedName}";src:${u}}`;
              else {
                let t = `font-weight: ${this.cssFontInfo.fontWeight};`;
                this.cssFontInfo.italicAngle && (t += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`), q = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${t}src:${u}}`;
              }
              return (e = this._inspectFont) == null || e.call(this, this, u), q;
            }
            getPathGenerator(n, u) {
              if (this.compiledGlyphs[u] !== void 0)
                return this.compiledGlyphs[u];
              let q;
              try {
                q = n.get(this.loadedName + "_path_" + u);
              } catch (e) {
                if (!this.ignoreErrors)
                  throw e;
                return (0, ue.warn)(`getPathGenerator - ignoring character: "${e}".`), this.compiledGlyphs[u] = function(t, B) {
                };
              }
              if (this.isEvalSupported && ue.FeatureTest.isEvalSupported) {
                const e = [];
                for (const t of q) {
                  const B = t.args !== void 0 ? t.args.join(",") : "";
                  e.push("c.", t.cmd, "(", B, `);
`);
                }
                return this.compiledGlyphs[u] = new Function("c", "size", e.join(""));
              }
              return this.compiledGlyphs[u] = function(e, t) {
                for (const B of q)
                  B.cmd === "scale" && (B.args = [t, -t]), e[B.cmd].apply(e, B.args);
              };
            }
          }
          he.FontFaceObject = xe;
        },
        /* 10 */
        /***/
        (Se, he) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.isNodeJS = void 0;
          const ke = typeof process == "object" && process + "" == "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
          he.isNodeJS = ke;
        },
        /* 11 */
        /***/
        (Se, he, ke) => {
          var d, Qn, N, ei;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.CanvasGraphics = void 0;
          var ue = ke(1), me = ke(6), Me = ke(12), xe = ke(13), F = ke(10);
          const ae = 16, n = 100, u = 4096, q = 15, e = 10, t = 1e3, B = 16;
          function j($, m) {
            if ($._removeMirroring)
              throw new Error("Context is already forwarding operations.");
            $.__originalSave = $.save, $.__originalRestore = $.restore, $.__originalRotate = $.rotate, $.__originalScale = $.scale, $.__originalTranslate = $.translate, $.__originalTransform = $.transform, $.__originalSetTransform = $.setTransform, $.__originalResetTransform = $.resetTransform, $.__originalClip = $.clip, $.__originalMoveTo = $.moveTo, $.__originalLineTo = $.lineTo, $.__originalBezierCurveTo = $.bezierCurveTo, $.__originalRect = $.rect, $.__originalClosePath = $.closePath, $.__originalBeginPath = $.beginPath, $._removeMirroring = () => {
              $.save = $.__originalSave, $.restore = $.__originalRestore, $.rotate = $.__originalRotate, $.scale = $.__originalScale, $.translate = $.__originalTranslate, $.transform = $.__originalTransform, $.setTransform = $.__originalSetTransform, $.resetTransform = $.__originalResetTransform, $.clip = $.__originalClip, $.moveTo = $.__originalMoveTo, $.lineTo = $.__originalLineTo, $.bezierCurveTo = $.__originalBezierCurveTo, $.rect = $.__originalRect, $.closePath = $.__originalClosePath, $.beginPath = $.__originalBeginPath, delete $._removeMirroring;
            }, $.save = function() {
              m.save(), this.__originalSave();
            }, $.restore = function() {
              m.restore(), this.__originalRestore();
            }, $.translate = function(T, L) {
              m.translate(T, L), this.__originalTranslate(T, L);
            }, $.scale = function(T, L) {
              m.scale(T, L), this.__originalScale(T, L);
            }, $.transform = function(T, L, _, G, J, K) {
              m.transform(T, L, _, G, J, K), this.__originalTransform(T, L, _, G, J, K);
            }, $.setTransform = function(T, L, _, G, J, K) {
              m.setTransform(T, L, _, G, J, K), this.__originalSetTransform(T, L, _, G, J, K);
            }, $.resetTransform = function() {
              m.resetTransform(), this.__originalResetTransform();
            }, $.rotate = function(T) {
              m.rotate(T), this.__originalRotate(T);
            }, $.clip = function(T) {
              m.clip(T), this.__originalClip(T);
            }, $.moveTo = function(p, T) {
              m.moveTo(p, T), this.__originalMoveTo(p, T);
            }, $.lineTo = function(p, T) {
              m.lineTo(p, T), this.__originalLineTo(p, T);
            }, $.bezierCurveTo = function(p, T, L, _, G, J) {
              m.bezierCurveTo(p, T, L, _, G, J), this.__originalBezierCurveTo(p, T, L, _, G, J);
            }, $.rect = function(p, T, L, _) {
              m.rect(p, T, L, _), this.__originalRect(p, T, L, _);
            }, $.closePath = function() {
              m.closePath(), this.__originalClosePath();
            }, $.beginPath = function() {
              m.beginPath(), this.__originalBeginPath();
            };
          }
          class M {
            constructor(m) {
              this.canvasFactory = m, this.cache = /* @__PURE__ */ Object.create(null);
            }
            getCanvas(m, p, T) {
              let L;
              return this.cache[m] !== void 0 ? (L = this.cache[m], this.canvasFactory.reset(L, p, T)) : (L = this.canvasFactory.create(p, T), this.cache[m] = L), L;
            }
            delete(m) {
              delete this.cache[m];
            }
            clear() {
              for (const m in this.cache) {
                const p = this.cache[m];
                this.canvasFactory.destroy(p), delete this.cache[m];
              }
            }
          }
          function O($, m, p, T, L, _, G, J, K, V) {
            const [U, Q, X, R, f, D] = (0, me.getCurrentTransform)($);
            if (Q === 0 && X === 0) {
              const W = G * U + f, ie = Math.round(W), ne = J * R + D, re = Math.round(ne), ee = (G + K) * U + f, te = Math.abs(Math.round(ee) - ie) || 1, oe = (J + V) * R + D, se = Math.abs(Math.round(oe) - re) || 1;
              return $.setTransform(Math.sign(U), 0, 0, Math.sign(R), ie, re), $.drawImage(m, p, T, L, _, 0, 0, te, se), $.setTransform(U, Q, X, R, f, D), [te, se];
            }
            if (U === 0 && R === 0) {
              const W = J * X + f, ie = Math.round(W), ne = G * Q + D, re = Math.round(ne), ee = (J + V) * X + f, te = Math.abs(Math.round(ee) - ie) || 1, oe = (G + K) * Q + D, se = Math.abs(Math.round(oe) - re) || 1;
              return $.setTransform(0, Math.sign(Q), Math.sign(X), 0, ie, re), $.drawImage(m, p, T, L, _, 0, 0, se, te), $.setTransform(U, Q, X, R, f, D), [se, te];
            }
            $.drawImage(m, p, T, L, _, G, J, K, V);
            const z = Math.hypot(U, Q), Y = Math.hypot(X, R);
            return [z * K, Y * V];
          }
          function w($) {
            const {
              width: m,
              height: p
            } = $;
            if (m > t || p > t)
              return null;
            const T = 1e3, L = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]), _ = m + 1;
            let G = new Uint8Array(_ * (p + 1)), J, K, V;
            const U = m + 7 & -8;
            let Q = new Uint8Array(U * p), X = 0;
            for (const Y of $.data) {
              let W = 128;
              for (; W > 0; )
                Q[X++] = Y & W ? 0 : 255, W >>= 1;
            }
            let R = 0;
            for (X = 0, Q[X] !== 0 && (G[0] = 1, ++R), K = 1; K < m; K++)
              Q[X] !== Q[X + 1] && (G[K] = Q[X] ? 2 : 1, ++R), X++;
            for (Q[X] !== 0 && (G[K] = 2, ++R), J = 1; J < p; J++) {
              X = J * U, V = J * _, Q[X - U] !== Q[X] && (G[V] = Q[X] ? 1 : 8, ++R);
              let Y = (Q[X] ? 4 : 0) + (Q[X - U] ? 8 : 0);
              for (K = 1; K < m; K++)
                Y = (Y >> 2) + (Q[X + 1] ? 4 : 0) + (Q[X - U + 1] ? 8 : 0), L[Y] && (G[V + K] = L[Y], ++R), X++;
              if (Q[X - U] !== Q[X] && (G[V + K] = Q[X] ? 2 : 4, ++R), R > T)
                return null;
            }
            for (X = U * (p - 1), V = J * _, Q[X] !== 0 && (G[V] = 8, ++R), K = 1; K < m; K++)
              Q[X] !== Q[X + 1] && (G[V + K] = Q[X] ? 4 : 8, ++R), X++;
            if (Q[X] !== 0 && (G[V + K] = 4, ++R), R > T)
              return null;
            const f = new Int32Array([0, _, -1, 0, -_, 0, 0, 0, 1]), D = new Path2D();
            for (J = 0; R && J <= p; J++) {
              let Y = J * _;
              const W = Y + m;
              for (; Y < W && !G[Y]; )
                Y++;
              if (Y === W)
                continue;
              D.moveTo(Y % _, J);
              const ie = Y;
              let ne = G[Y];
              do {
                const re = f[ne];
                do
                  Y += re;
                while (!G[Y]);
                const ee = G[Y];
                ee !== 5 && ee !== 10 ? (ne = ee, G[Y] = 0) : (ne = ee & 51 * ne >> 4, G[Y] &= ne >> 2 | ne << 2), D.lineTo(Y % _, Y / _ | 0), G[Y] || --R;
              } while (ie !== Y);
              --J;
            }
            return Q = null, G = null, function(Y) {
              Y.save(), Y.scale(1 / m, -1 / p), Y.translate(0, -p), Y.fill(D), Y.beginPath(), Y.restore();
            };
          }
          class C {
            constructor(m, p) {
              this.alphaIsShape = !1, this.fontSize = 0, this.fontSizeScale = 1, this.textMatrix = ue.IDENTITY_MATRIX, this.textMatrixScale = 1, this.fontMatrix = ue.FONT_IDENTITY_MATRIX, this.leading = 0, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRenderingMode = ue.TextRenderingMode.FILL, this.textRise = 0, this.fillColor = "#000000", this.strokeColor = "#000000", this.patternFill = !1, this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.activeSMask = null, this.transferMaps = "none", this.startNewPathAndClipBox([0, 0, m, p]);
            }
            clone() {
              const m = Object.create(this);
              return m.clipBox = this.clipBox.slice(), m;
            }
            setCurrentPoint(m, p) {
              this.x = m, this.y = p;
            }
            updatePathMinMax(m, p, T) {
              [p, T] = ue.Util.applyTransform([p, T], m), this.minX = Math.min(this.minX, p), this.minY = Math.min(this.minY, T), this.maxX = Math.max(this.maxX, p), this.maxY = Math.max(this.maxY, T);
            }
            updateRectMinMax(m, p) {
              const T = ue.Util.applyTransform(p, m), L = ue.Util.applyTransform(p.slice(2), m);
              this.minX = Math.min(this.minX, T[0], L[0]), this.minY = Math.min(this.minY, T[1], L[1]), this.maxX = Math.max(this.maxX, T[0], L[0]), this.maxY = Math.max(this.maxY, T[1], L[1]);
            }
            updateScalingPathMinMax(m, p) {
              ue.Util.scaleMinMax(m, p), this.minX = Math.min(this.minX, p[0]), this.maxX = Math.max(this.maxX, p[1]), this.minY = Math.min(this.minY, p[2]), this.maxY = Math.max(this.maxY, p[3]);
            }
            updateCurvePathMinMax(m, p, T, L, _, G, J, K, V, U) {
              const Q = ue.Util.bezierBoundingBox(p, T, L, _, G, J, K, V);
              if (U) {
                U[0] = Math.min(U[0], Q[0], Q[2]), U[1] = Math.max(U[1], Q[0], Q[2]), U[2] = Math.min(U[2], Q[1], Q[3]), U[3] = Math.max(U[3], Q[1], Q[3]);
                return;
              }
              this.updateRectMinMax(m, Q);
            }
            getPathBoundingBox(m = Me.PathType.FILL, p = null) {
              const T = [this.minX, this.minY, this.maxX, this.maxY];
              if (m === Me.PathType.STROKE) {
                p || (0, ue.unreachable)("Stroke bounding box must include transform.");
                const L = ue.Util.singularValueDecompose2dScale(p), _ = L[0] * this.lineWidth / 2, G = L[1] * this.lineWidth / 2;
                T[0] -= _, T[1] -= G, T[2] += _, T[3] += G;
              }
              return T;
            }
            updateClipFromPath() {
              const m = ue.Util.intersect(this.clipBox, this.getPathBoundingBox());
              this.startNewPathAndClipBox(m || [0, 0, 0, 0]);
            }
            isEmptyClip() {
              return this.minX === 1 / 0;
            }
            startNewPathAndClipBox(m) {
              this.clipBox = m, this.minX = 1 / 0, this.minY = 1 / 0, this.maxX = 0, this.maxY = 0;
            }
            getClippedPathBoundingBox(m = Me.PathType.FILL, p = null) {
              return ue.Util.intersect(this.clipBox, this.getPathBoundingBox(m, p));
            }
          }
          function i($, m) {
            if (typeof ImageData < "u" && m instanceof ImageData) {
              $.putImageData(m, 0, 0);
              return;
            }
            const p = m.height, T = m.width, L = p % B, _ = (p - L) / B, G = L === 0 ? _ : _ + 1, J = $.createImageData(T, B);
            let K = 0, V;
            const U = m.data, Q = J.data;
            let X, R, f, D;
            if (m.kind === ue.ImageKind.GRAYSCALE_1BPP) {
              const z = U.byteLength, Y = new Uint32Array(Q.buffer, 0, Q.byteLength >> 2), W = Y.length, ie = T + 7 >> 3, ne = 4294967295, re = ue.FeatureTest.isLittleEndian ? 4278190080 : 255;
              for (X = 0; X < G; X++) {
                for (f = X < _ ? B : L, V = 0, R = 0; R < f; R++) {
                  const ee = z - K;
                  let te = 0;
                  const oe = ee > ie ? T : ee * 8 - 7, se = oe & -8;
                  let ce = 0, le = 0;
                  for (; te < se; te += 8)
                    le = U[K++], Y[V++] = le & 128 ? ne : re, Y[V++] = le & 64 ? ne : re, Y[V++] = le & 32 ? ne : re, Y[V++] = le & 16 ? ne : re, Y[V++] = le & 8 ? ne : re, Y[V++] = le & 4 ? ne : re, Y[V++] = le & 2 ? ne : re, Y[V++] = le & 1 ? ne : re;
                  for (; te < oe; te++)
                    ce === 0 && (le = U[K++], ce = 128), Y[V++] = le & ce ? ne : re, ce >>= 1;
                }
                for (; V < W; )
                  Y[V++] = 0;
                $.putImageData(J, 0, X * B);
              }
            } else if (m.kind === ue.ImageKind.RGBA_32BPP) {
              for (R = 0, D = T * B * 4, X = 0; X < _; X++)
                Q.set(U.subarray(K, K + D)), K += D, $.putImageData(J, 0, R), R += B;
              X < G && (D = T * L * 4, Q.set(U.subarray(K, K + D)), $.putImageData(J, 0, R));
            } else if (m.kind === ue.ImageKind.RGB_24BPP)
              for (f = B, D = T * f, X = 0; X < G; X++) {
                for (X >= _ && (f = L, D = T * f), V = 0, R = D; R--; )
                  Q[V++] = U[K++], Q[V++] = U[K++], Q[V++] = U[K++], Q[V++] = 255;
                $.putImageData(J, 0, X * B);
              }
            else
              throw new Error(`bad image kind: ${m.kind}`);
          }
          function o($, m) {
            if (m.bitmap) {
              $.drawImage(m.bitmap, 0, 0);
              return;
            }
            const p = m.height, T = m.width, L = p % B, _ = (p - L) / B, G = L === 0 ? _ : _ + 1, J = $.createImageData(T, B);
            let K = 0;
            const V = m.data, U = J.data;
            for (let Q = 0; Q < G; Q++) {
              const X = Q < _ ? B : L;
              ({
                srcPos: K
              } = (0, xe.convertBlackAndWhiteToRGBA)({
                src: V,
                srcPos: K,
                dest: U,
                width: T,
                height: X,
                nonBlackColor: 0
              })), $.putImageData(J, 0, Q * B);
            }
          }
          function k($, m) {
            const p = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
            for (const T of p)
              $[T] !== void 0 && (m[T] = $[T]);
            $.setLineDash !== void 0 && (m.setLineDash($.getLineDash()), m.lineDashOffset = $.lineDashOffset);
          }
          function s($) {
            $.strokeStyle = $.fillStyle = "#000000", $.fillRule = "nonzero", $.globalAlpha = 1, $.lineWidth = 1, $.lineCap = "butt", $.lineJoin = "miter", $.miterLimit = 10, $.globalCompositeOperation = "source-over", $.font = "10px sans-serif", $.setLineDash !== void 0 && ($.setLineDash([]), $.lineDashOffset = 0), F.isNodeJS || ($.filter = "none");
          }
          function l($, m, p, T) {
            const L = $.length;
            for (let _ = 3; _ < L; _ += 4) {
              const G = $[_];
              if (G === 0)
                $[_ - 3] = m, $[_ - 2] = p, $[_ - 1] = T;
              else if (G < 255) {
                const J = 255 - G;
                $[_ - 3] = $[_ - 3] * G + m * J >> 8, $[_ - 2] = $[_ - 2] * G + p * J >> 8, $[_ - 1] = $[_ - 1] * G + T * J >> 8;
              }
            }
          }
          function g($, m, p) {
            const T = $.length, L = 1 / 255;
            for (let _ = 3; _ < T; _ += 4) {
              const G = p ? p[$[_]] : $[_];
              m[_] = m[_] * G * L | 0;
            }
          }
          function v($, m, p) {
            const T = $.length;
            for (let L = 3; L < T; L += 4) {
              const _ = $[L - 3] * 77 + $[L - 2] * 152 + $[L - 1] * 28;
              m[L] = p ? m[L] * p[_ >> 8] >> 8 : m[L] * _ >> 16;
            }
          }
          function r($, m, p, T, L, _, G, J, K, V, U) {
            const Q = !!_, X = Q ? _[0] : 0, R = Q ? _[1] : 0, f = Q ? _[2] : 0;
            let D;
            L === "Luminosity" ? D = v : D = g;
            const Y = Math.min(T, Math.ceil(1048576 / p));
            for (let W = 0; W < T; W += Y) {
              const ie = Math.min(Y, T - W), ne = $.getImageData(J - V, W + (K - U), p, ie), re = m.getImageData(J, W + K, p, ie);
              Q && l(ne.data, X, R, f), D(ne.data, re.data, G), m.putImageData(re, J, W + K);
            }
          }
          function x($, m, p, T) {
            const L = T[0], _ = T[1], G = T[2] - L, J = T[3] - _;
            G === 0 || J === 0 || (r(m.context, p, G, J, m.subtype, m.backdrop, m.transferMap, L, _, m.offsetX, m.offsetY), $.save(), $.globalAlpha = 1, $.globalCompositeOperation = "source-over", $.setTransform(1, 0, 0, 1, 0, 0), $.drawImage(p.canvas, 0, 0), $.restore());
          }
          function b($, m) {
            const p = ue.Util.singularValueDecompose2dScale($);
            p[0] = Math.fround(p[0]), p[1] = Math.fround(p[1]);
            const T = Math.fround((globalThis.devicePixelRatio || 1) * me.PixelsPerInch.PDF_TO_CSS_UNITS);
            return m !== void 0 ? m : p[0] <= T || p[1] <= T;
          }
          const I = ["butt", "round", "square"], h = ["miter", "round", "bevel"], y = {}, P = {}, H = class H {
            constructor(m, p, T, L, _, {
              optionalContentConfig: G,
              markedContentStack: J = null
            }, K, V) {
              Be(this, d);
              Be(this, N);
              this.ctx = m, this.current = new C(this.ctx.canvas.width, this.ctx.canvas.height), this.stateStack = [], this.pendingClip = null, this.pendingEOFill = !1, this.res = null, this.xobjs = null, this.commonObjs = p, this.objs = T, this.canvasFactory = L, this.filterFactory = _, this.groupStack = [], this.processingType3 = null, this.baseTransform = null, this.baseTransformStack = [], this.groupLevel = 0, this.smaskStack = [], this.smaskCounter = 0, this.tempSMask = null, this.suspendedCtx = null, this.contentVisible = !0, this.markedContentStack = J || [], this.optionalContentConfig = G, this.cachedCanvases = new M(this.canvasFactory), this.cachedPatterns = /* @__PURE__ */ new Map(), this.annotationCanvasMap = K, this.viewportScale = 1, this.outputScaleX = 1, this.outputScaleY = 1, this.pageColors = V, this._cachedScaleForStroking = [-1, 0], this._cachedGetSinglePixelWidth = null, this._cachedBitmapsMap = /* @__PURE__ */ new Map();
            }
            getObject(m, p = null) {
              return typeof m == "string" ? m.startsWith("g_") ? this.commonObjs.get(m) : this.objs.get(m) : p;
            }
            beginDrawing({
              transform: m,
              viewport: p,
              transparency: T = !1,
              background: L = null
            }) {
              const _ = this.ctx.canvas.width, G = this.ctx.canvas.height, J = this.ctx.fillStyle;
              if (this.ctx.fillStyle = L || "#ffffff", this.ctx.fillRect(0, 0, _, G), this.ctx.fillStyle = J, T) {
                const K = this.cachedCanvases.getCanvas("transparent", _, G);
                this.compositeCtx = this.ctx, this.transparentCanvas = K.canvas, this.ctx = K.context, this.ctx.save(), this.ctx.transform(...(0, me.getCurrentTransform)(this.compositeCtx));
              }
              this.ctx.save(), s(this.ctx), m && (this.ctx.transform(...m), this.outputScaleX = m[0], this.outputScaleY = m[0]), this.ctx.transform(...p.transform), this.viewportScale = p.scale, this.baseTransform = (0, me.getCurrentTransform)(this.ctx);
            }
            executeOperatorList(m, p, T, L) {
              const _ = m.argsArray, G = m.fnArray;
              let J = p || 0;
              const K = _.length;
              if (K === J)
                return J;
              const V = K - J > e && typeof T == "function", U = V ? Date.now() + q : 0;
              let Q = 0;
              const X = this.commonObjs, R = this.objs;
              let f;
              for (; ; ) {
                if (L !== void 0 && J === L.nextBreakPoint)
                  return L.breakIt(J, T), J;
                if (f = G[J], f !== ue.OPS.dependency)
                  this[f].apply(this, _[J]);
                else
                  for (const D of _[J]) {
                    const z = D.startsWith("g_") ? X : R;
                    if (!z.has(D))
                      return z.get(D, T), J;
                  }
                if (J++, J === K)
                  return J;
                if (V && ++Q > e) {
                  if (Date.now() > U)
                    return T(), J;
                  Q = 0;
                }
              }
            }
            endDrawing() {
              ze(this, d, Qn).call(this), this.cachedCanvases.clear(), this.cachedPatterns.clear();
              for (const m of this._cachedBitmapsMap.values()) {
                for (const p of m.values())
                  typeof HTMLCanvasElement < "u" && p instanceof HTMLCanvasElement && (p.width = p.height = 0);
                m.clear();
              }
              this._cachedBitmapsMap.clear(), ze(this, N, ei).call(this);
            }
            _scaleImage(m, p) {
              const T = m.width, L = m.height;
              let _ = Math.max(Math.hypot(p[0], p[1]), 1), G = Math.max(Math.hypot(p[2], p[3]), 1), J = T, K = L, V = "prescale1", U, Q;
              for (; _ > 2 && J > 1 || G > 2 && K > 1; ) {
                let X = J, R = K;
                _ > 2 && J > 1 && (X = J >= 16384 ? Math.floor(J / 2) - 1 || 1 : Math.ceil(J / 2), _ /= J / X), G > 2 && K > 1 && (R = K >= 16384 ? Math.floor(K / 2) - 1 || 1 : Math.ceil(K) / 2, G /= K / R), U = this.cachedCanvases.getCanvas(V, X, R), Q = U.context, Q.clearRect(0, 0, X, R), Q.drawImage(m, 0, 0, J, K, 0, 0, X, R), m = U.canvas, J = X, K = R, V = V === "prescale1" ? "prescale2" : "prescale1";
              }
              return {
                img: m,
                paintWidth: J,
                paintHeight: K
              };
            }
            _createMaskCanvas(m) {
              const p = this.ctx, {
                width: T,
                height: L
              } = m, _ = this.current.fillColor, G = this.current.patternFill, J = (0, me.getCurrentTransform)(p);
              let K, V, U, Q;
              if ((m.bitmap || m.data) && m.count > 1) {
                const te = m.bitmap || m.data.buffer;
                V = JSON.stringify(G ? J : [J.slice(0, 4), _]), K = this._cachedBitmapsMap.get(te), K || (K = /* @__PURE__ */ new Map(), this._cachedBitmapsMap.set(te, K));
                const oe = K.get(V);
                if (oe && !G) {
                  const se = Math.round(Math.min(J[0], J[2]) + J[4]), ce = Math.round(Math.min(J[1], J[3]) + J[5]);
                  return {
                    canvas: oe,
                    offsetX: se,
                    offsetY: ce
                  };
                }
                U = oe;
              }
              U || (Q = this.cachedCanvases.getCanvas("maskCanvas", T, L), o(Q.context, m));
              let X = ue.Util.transform(J, [1 / T, 0, 0, -1 / L, 0, 0]);
              X = ue.Util.transform(X, [1, 0, 0, 1, 0, -L]);
              const R = ue.Util.applyTransform([0, 0], X), f = ue.Util.applyTransform([T, L], X), D = ue.Util.normalizeRect([R[0], R[1], f[0], f[1]]), z = Math.round(D[2] - D[0]) || 1, Y = Math.round(D[3] - D[1]) || 1, W = this.cachedCanvases.getCanvas("fillCanvas", z, Y), ie = W.context, ne = Math.min(R[0], f[0]), re = Math.min(R[1], f[1]);
              ie.translate(-ne, -re), ie.transform(...X), U || (U = this._scaleImage(Q.canvas, (0, me.getCurrentTransformInverse)(ie)), U = U.img, K && G && K.set(V, U)), ie.imageSmoothingEnabled = b((0, me.getCurrentTransform)(ie), m.interpolate), O(ie, U, 0, 0, U.width, U.height, 0, 0, T, L), ie.globalCompositeOperation = "source-in";
              const ee = ue.Util.transform((0, me.getCurrentTransformInverse)(ie), [1, 0, 0, 1, -ne, -re]);
              return ie.fillStyle = G ? _.getPattern(p, this, ee, Me.PathType.FILL) : _, ie.fillRect(0, 0, T, L), K && !G && (this.cachedCanvases.delete("fillCanvas"), K.set(V, W.canvas)), {
                canvas: W.canvas,
                offsetX: Math.round(ne),
                offsetY: Math.round(re)
              };
            }
            setLineWidth(m) {
              m !== this.current.lineWidth && (this._cachedScaleForStroking[0] = -1), this.current.lineWidth = m, this.ctx.lineWidth = m;
            }
            setLineCap(m) {
              this.ctx.lineCap = I[m];
            }
            setLineJoin(m) {
              this.ctx.lineJoin = h[m];
            }
            setMiterLimit(m) {
              this.ctx.miterLimit = m;
            }
            setDash(m, p) {
              const T = this.ctx;
              T.setLineDash !== void 0 && (T.setLineDash(m), T.lineDashOffset = p);
            }
            setRenderingIntent(m) {
            }
            setFlatness(m) {
            }
            setGState(m) {
              for (const [p, T] of m)
                switch (p) {
                  case "LW":
                    this.setLineWidth(T);
                    break;
                  case "LC":
                    this.setLineCap(T);
                    break;
                  case "LJ":
                    this.setLineJoin(T);
                    break;
                  case "ML":
                    this.setMiterLimit(T);
                    break;
                  case "D":
                    this.setDash(T[0], T[1]);
                    break;
                  case "RI":
                    this.setRenderingIntent(T);
                    break;
                  case "FL":
                    this.setFlatness(T);
                    break;
                  case "Font":
                    this.setFont(T[0], T[1]);
                    break;
                  case "CA":
                    this.current.strokeAlpha = T;
                    break;
                  case "ca":
                    this.current.fillAlpha = T, this.ctx.globalAlpha = T;
                    break;
                  case "BM":
                    this.ctx.globalCompositeOperation = T;
                    break;
                  case "SMask":
                    this.current.activeSMask = T ? this.tempSMask : null, this.tempSMask = null, this.checkSMaskState();
                    break;
                  case "TR":
                    this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(T);
                    break;
                }
            }
            get inSMaskMode() {
              return !!this.suspendedCtx;
            }
            checkSMaskState() {
              const m = this.inSMaskMode;
              this.current.activeSMask && !m ? this.beginSMaskMode() : !this.current.activeSMask && m && this.endSMaskMode();
            }
            beginSMaskMode() {
              if (this.inSMaskMode)
                throw new Error("beginSMaskMode called while already in smask mode");
              const m = this.ctx.canvas.width, p = this.ctx.canvas.height, T = "smaskGroupAt" + this.groupLevel, L = this.cachedCanvases.getCanvas(T, m, p);
              this.suspendedCtx = this.ctx, this.ctx = L.context;
              const _ = this.ctx;
              _.setTransform(...(0, me.getCurrentTransform)(this.suspendedCtx)), k(this.suspendedCtx, _), j(_, this.suspendedCtx), this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
            }
            endSMaskMode() {
              if (!this.inSMaskMode)
                throw new Error("endSMaskMode called while not in smask mode");
              this.ctx._removeMirroring(), k(this.ctx, this.suspendedCtx), this.ctx = this.suspendedCtx, this.suspendedCtx = null;
            }
            compose(m) {
              if (!this.current.activeSMask)
                return;
              m ? (m[0] = Math.floor(m[0]), m[1] = Math.floor(m[1]), m[2] = Math.ceil(m[2]), m[3] = Math.ceil(m[3])) : m = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
              const p = this.current.activeSMask, T = this.suspendedCtx;
              x(T, p, this.ctx, m), this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height), this.ctx.restore();
            }
            save() {
              this.inSMaskMode ? (k(this.ctx, this.suspendedCtx), this.suspendedCtx.save()) : this.ctx.save();
              const m = this.current;
              this.stateStack.push(m), this.current = m.clone();
            }
            restore() {
              this.stateStack.length === 0 && this.inSMaskMode && this.endSMaskMode(), this.stateStack.length !== 0 && (this.current = this.stateStack.pop(), this.inSMaskMode ? (this.suspendedCtx.restore(), k(this.suspendedCtx, this.ctx)) : this.ctx.restore(), this.checkSMaskState(), this.pendingClip = null, this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null);
            }
            transform(m, p, T, L, _, G) {
              this.ctx.transform(m, p, T, L, _, G), this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null;
            }
            constructPath(m, p, T) {
              const L = this.ctx, _ = this.current;
              let G = _.x, J = _.y, K, V;
              const U = (0, me.getCurrentTransform)(L), Q = U[0] === 0 && U[3] === 0 || U[1] === 0 && U[2] === 0, X = Q ? T.slice(0) : null;
              for (let R = 0, f = 0, D = m.length; R < D; R++)
                switch (m[R] | 0) {
                  case ue.OPS.rectangle:
                    G = p[f++], J = p[f++];
                    const z = p[f++], Y = p[f++], W = G + z, ie = J + Y;
                    L.moveTo(G, J), z === 0 || Y === 0 ? L.lineTo(W, ie) : (L.lineTo(W, J), L.lineTo(W, ie), L.lineTo(G, ie)), Q || _.updateRectMinMax(U, [G, J, W, ie]), L.closePath();
                    break;
                  case ue.OPS.moveTo:
                    G = p[f++], J = p[f++], L.moveTo(G, J), Q || _.updatePathMinMax(U, G, J);
                    break;
                  case ue.OPS.lineTo:
                    G = p[f++], J = p[f++], L.lineTo(G, J), Q || _.updatePathMinMax(U, G, J);
                    break;
                  case ue.OPS.curveTo:
                    K = G, V = J, G = p[f + 4], J = p[f + 5], L.bezierCurveTo(p[f], p[f + 1], p[f + 2], p[f + 3], G, J), _.updateCurvePathMinMax(U, K, V, p[f], p[f + 1], p[f + 2], p[f + 3], G, J, X), f += 6;
                    break;
                  case ue.OPS.curveTo2:
                    K = G, V = J, L.bezierCurveTo(G, J, p[f], p[f + 1], p[f + 2], p[f + 3]), _.updateCurvePathMinMax(U, K, V, G, J, p[f], p[f + 1], p[f + 2], p[f + 3], X), G = p[f + 2], J = p[f + 3], f += 4;
                    break;
                  case ue.OPS.curveTo3:
                    K = G, V = J, G = p[f + 2], J = p[f + 3], L.bezierCurveTo(p[f], p[f + 1], G, J, G, J), _.updateCurvePathMinMax(U, K, V, p[f], p[f + 1], G, J, G, J, X), f += 4;
                    break;
                  case ue.OPS.closePath:
                    L.closePath();
                    break;
                }
              Q && _.updateScalingPathMinMax(U, X), _.setCurrentPoint(G, J);
            }
            closePath() {
              this.ctx.closePath();
            }
            stroke(m = !0) {
              const p = this.ctx, T = this.current.strokeColor;
              p.globalAlpha = this.current.strokeAlpha, this.contentVisible && (typeof T == "object" && (T != null && T.getPattern) ? (p.save(), p.strokeStyle = T.getPattern(p, this, (0, me.getCurrentTransformInverse)(p), Me.PathType.STROKE), this.rescaleAndStroke(!1), p.restore()) : this.rescaleAndStroke(!0)), m && this.consumePath(this.current.getClippedPathBoundingBox()), p.globalAlpha = this.current.fillAlpha;
            }
            closeStroke() {
              this.closePath(), this.stroke();
            }
            fill(m = !0) {
              const p = this.ctx, T = this.current.fillColor, L = this.current.patternFill;
              let _ = !1;
              L && (p.save(), p.fillStyle = T.getPattern(p, this, (0, me.getCurrentTransformInverse)(p), Me.PathType.FILL), _ = !0);
              const G = this.current.getClippedPathBoundingBox();
              this.contentVisible && G !== null && (this.pendingEOFill ? (p.fill("evenodd"), this.pendingEOFill = !1) : p.fill()), _ && p.restore(), m && this.consumePath(G);
            }
            eoFill() {
              this.pendingEOFill = !0, this.fill();
            }
            fillStroke() {
              this.fill(!1), this.stroke(!1), this.consumePath();
            }
            eoFillStroke() {
              this.pendingEOFill = !0, this.fillStroke();
            }
            closeFillStroke() {
              this.closePath(), this.fillStroke();
            }
            closeEOFillStroke() {
              this.pendingEOFill = !0, this.closePath(), this.fillStroke();
            }
            endPath() {
              this.consumePath();
            }
            clip() {
              this.pendingClip = y;
            }
            eoClip() {
              this.pendingClip = P;
            }
            beginText() {
              this.current.textMatrix = ue.IDENTITY_MATRIX, this.current.textMatrixScale = 1, this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
            }
            endText() {
              const m = this.pendingTextPaths, p = this.ctx;
              if (m === void 0) {
                p.beginPath();
                return;
              }
              p.save(), p.beginPath();
              for (const T of m)
                p.setTransform(...T.transform), p.translate(T.x, T.y), T.addToPath(p, T.fontSize);
              p.restore(), p.clip(), p.beginPath(), delete this.pendingTextPaths;
            }
            setCharSpacing(m) {
              this.current.charSpacing = m;
            }
            setWordSpacing(m) {
              this.current.wordSpacing = m;
            }
            setHScale(m) {
              this.current.textHScale = m / 100;
            }
            setLeading(m) {
              this.current.leading = -m;
            }
            setFont(m, p) {
              var U;
              const T = this.commonObjs.get(m), L = this.current;
              if (!T)
                throw new Error(`Can't find font for ${m}`);
              if (L.fontMatrix = T.fontMatrix || ue.FONT_IDENTITY_MATRIX, (L.fontMatrix[0] === 0 || L.fontMatrix[3] === 0) && (0, ue.warn)("Invalid font matrix for font " + m), p < 0 ? (p = -p, L.fontDirection = -1) : L.fontDirection = 1, this.current.font = T, this.current.fontSize = p, T.isType3Font)
                return;
              const _ = T.loadedName || "sans-serif", G = ((U = T.systemFontInfo) == null ? void 0 : U.css) || `"${_}", ${T.fallbackName}`;
              let J = "normal";
              T.black ? J = "900" : T.bold && (J = "bold");
              const K = T.italic ? "italic" : "normal";
              let V = p;
              p < ae ? V = ae : p > n && (V = n), this.current.fontSizeScale = p / V, this.ctx.font = `${K} ${J} ${V}px ${G}`;
            }
            setTextRenderingMode(m) {
              this.current.textRenderingMode = m;
            }
            setTextRise(m) {
              this.current.textRise = m;
            }
            moveText(m, p) {
              this.current.x = this.current.lineX += m, this.current.y = this.current.lineY += p;
            }
            setLeadingMoveText(m, p) {
              this.setLeading(-p), this.moveText(m, p);
            }
            setTextMatrix(m, p, T, L, _, G) {
              this.current.textMatrix = [m, p, T, L, _, G], this.current.textMatrixScale = Math.hypot(m, p), this.current.x = this.current.lineX = 0, this.current.y = this.current.lineY = 0;
            }
            nextLine() {
              this.moveText(0, this.current.leading);
            }
            paintChar(m, p, T, L) {
              const _ = this.ctx, G = this.current, J = G.font, K = G.textRenderingMode, V = G.fontSize / G.fontSizeScale, U = K & ue.TextRenderingMode.FILL_STROKE_MASK, Q = !!(K & ue.TextRenderingMode.ADD_TO_PATH_FLAG), X = G.patternFill && !J.missingFile;
              let R;
              (J.disableFontFace || Q || X) && (R = J.getPathGenerator(this.commonObjs, m)), J.disableFontFace || X ? (_.save(), _.translate(p, T), _.beginPath(), R(_, V), L && _.setTransform(...L), (U === ue.TextRenderingMode.FILL || U === ue.TextRenderingMode.FILL_STROKE) && _.fill(), (U === ue.TextRenderingMode.STROKE || U === ue.TextRenderingMode.FILL_STROKE) && _.stroke(), _.restore()) : ((U === ue.TextRenderingMode.FILL || U === ue.TextRenderingMode.FILL_STROKE) && _.fillText(m, p, T), (U === ue.TextRenderingMode.STROKE || U === ue.TextRenderingMode.FILL_STROKE) && _.strokeText(m, p, T)), Q && (this.pendingTextPaths || (this.pendingTextPaths = [])).push({
                transform: (0, me.getCurrentTransform)(_),
                x: p,
                y: T,
                fontSize: V,
                addToPath: R
              });
            }
            get isFontSubpixelAAEnabled() {
              const {
                context: m
              } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
              m.scale(1.5, 1), m.fillText("I", 0, 10);
              const p = m.getImageData(0, 0, 10, 10).data;
              let T = !1;
              for (let L = 3; L < p.length; L += 4)
                if (p[L] > 0 && p[L] < 255) {
                  T = !0;
                  break;
                }
              return (0, ue.shadow)(this, "isFontSubpixelAAEnabled", T);
            }
            showText(m) {
              const p = this.current, T = p.font;
              if (T.isType3Font)
                return this.showType3Text(m);
              const L = p.fontSize;
              if (L === 0)
                return;
              const _ = this.ctx, G = p.fontSizeScale, J = p.charSpacing, K = p.wordSpacing, V = p.fontDirection, U = p.textHScale * V, Q = m.length, X = T.vertical, R = X ? 1 : -1, f = T.defaultVMetrics, D = L * p.fontMatrix[0], z = p.textRenderingMode === ue.TextRenderingMode.FILL && !T.disableFontFace && !p.patternFill;
              _.save(), _.transform(...p.textMatrix), _.translate(p.x, p.y + p.textRise), V > 0 ? _.scale(U, -1) : _.scale(U, 1);
              let Y;
              if (p.patternFill) {
                _.save();
                const ee = p.fillColor.getPattern(_, this, (0, me.getCurrentTransformInverse)(_), Me.PathType.FILL);
                Y = (0, me.getCurrentTransform)(_), _.restore(), _.fillStyle = ee;
              }
              let W = p.lineWidth;
              const ie = p.textMatrixScale;
              if (ie === 0 || W === 0) {
                const ee = p.textRenderingMode & ue.TextRenderingMode.FILL_STROKE_MASK;
                (ee === ue.TextRenderingMode.STROKE || ee === ue.TextRenderingMode.FILL_STROKE) && (W = this.getSinglePixelWidth());
              } else
                W /= ie;
              if (G !== 1 && (_.scale(G, G), W /= G), _.lineWidth = W, T.isInvalidPDFjsFont) {
                const ee = [];
                let te = 0;
                for (const oe of m)
                  ee.push(oe.unicode), te += oe.width;
                _.fillText(ee.join(""), 0, 0), p.x += te * D * U, _.restore(), this.compose();
                return;
              }
              let ne = 0, re;
              for (re = 0; re < Q; ++re) {
                const ee = m[re];
                if (typeof ee == "number") {
                  ne += R * ee * L / 1e3;
                  continue;
                }
                let te = !1;
                const oe = (ee.isSpace ? K : 0) + J, se = ee.fontChar, ce = ee.accent;
                let le, de, Ie = ee.width;
                if (X) {
                  const we = ee.vmetric || f, pe = -(ee.vmetric ? we[1] : Ie * 0.5) * D, fe = we[2] * D;
                  Ie = we ? -we[0] : Ie, le = pe / G, de = (ne + fe) / G;
                } else
                  le = ne / G, de = 0;
                if (T.remeasure && Ie > 0) {
                  const we = _.measureText(se).width * 1e3 / L * G;
                  if (Ie < we && this.isFontSubpixelAAEnabled) {
                    const pe = Ie / we;
                    te = !0, _.save(), _.scale(pe, 1), le /= pe;
                  } else
                    Ie !== we && (le += (Ie - we) / 2e3 * L / G);
                }
                if (this.contentVisible && (ee.isInFont || T.missingFile)) {
                  if (z && !ce)
                    _.fillText(se, le, de);
                  else if (this.paintChar(se, le, de, Y), ce) {
                    const we = le + L * ce.offset.x / G, pe = de - L * ce.offset.y / G;
                    this.paintChar(ce.fontChar, we, pe, Y);
                  }
                }
                let Fe;
                X ? Fe = Ie * D - oe * V : Fe = Ie * D + oe * V, ne += Fe, te && _.restore();
              }
              X ? p.y -= ne : p.x += ne * U, _.restore(), this.compose();
            }
            showType3Text(m) {
              const p = this.ctx, T = this.current, L = T.font, _ = T.fontSize, G = T.fontDirection, J = L.vertical ? 1 : -1, K = T.charSpacing, V = T.wordSpacing, U = T.textHScale * G, Q = T.fontMatrix || ue.FONT_IDENTITY_MATRIX, X = m.length, R = T.textRenderingMode === ue.TextRenderingMode.INVISIBLE;
              let f, D, z, Y;
              if (!(R || _ === 0)) {
                for (this._cachedScaleForStroking[0] = -1, this._cachedGetSinglePixelWidth = null, p.save(), p.transform(...T.textMatrix), p.translate(T.x, T.y), p.scale(U, G), f = 0; f < X; ++f) {
                  if (D = m[f], typeof D == "number") {
                    Y = J * D * _ / 1e3, this.ctx.translate(Y, 0), T.x += Y * U;
                    continue;
                  }
                  const W = (D.isSpace ? V : 0) + K, ie = L.charProcOperatorList[D.operatorListId];
                  if (!ie) {
                    (0, ue.warn)(`Type3 character "${D.operatorListId}" is not available.`);
                    continue;
                  }
                  this.contentVisible && (this.processingType3 = D, this.save(), p.scale(_, _), p.transform(...Q), this.executeOperatorList(ie), this.restore()), z = ue.Util.applyTransform([D.width, 0], Q)[0] * _ + W, p.translate(z, 0), T.x += z * U;
                }
                p.restore(), this.processingType3 = null;
              }
            }
            setCharWidth(m, p) {
            }
            setCharWidthAndBounds(m, p, T, L, _, G) {
              this.ctx.rect(T, L, _ - T, G - L), this.ctx.clip(), this.endPath();
            }
            getColorN_Pattern(m) {
              let p;
              if (m[0] === "TilingPattern") {
                const T = m[1], L = this.baseTransform || (0, me.getCurrentTransform)(this.ctx), _ = {
                  createCanvasGraphics: (G) => new H(G, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                    optionalContentConfig: this.optionalContentConfig,
                    markedContentStack: this.markedContentStack
                  })
                };
                p = new Me.TilingPattern(m, T, this.ctx, _, L);
              } else
                p = this._getPattern(m[1], m[2]);
              return p;
            }
            setStrokeColorN() {
              this.current.strokeColor = this.getColorN_Pattern(arguments);
            }
            setFillColorN() {
              this.current.fillColor = this.getColorN_Pattern(arguments), this.current.patternFill = !0;
            }
            setStrokeRGBColor(m, p, T) {
              const L = ue.Util.makeHexColor(m, p, T);
              this.ctx.strokeStyle = L, this.current.strokeColor = L;
            }
            setFillRGBColor(m, p, T) {
              const L = ue.Util.makeHexColor(m, p, T);
              this.ctx.fillStyle = L, this.current.fillColor = L, this.current.patternFill = !1;
            }
            _getPattern(m, p = null) {
              let T;
              return this.cachedPatterns.has(m) ? T = this.cachedPatterns.get(m) : (T = (0, Me.getShadingPattern)(this.getObject(m)), this.cachedPatterns.set(m, T)), p && (T.matrix = p), T;
            }
            shadingFill(m) {
              if (!this.contentVisible)
                return;
              const p = this.ctx;
              this.save();
              const T = this._getPattern(m);
              p.fillStyle = T.getPattern(p, this, (0, me.getCurrentTransformInverse)(p), Me.PathType.SHADING);
              const L = (0, me.getCurrentTransformInverse)(p);
              if (L) {
                const _ = p.canvas, G = _.width, J = _.height, K = ue.Util.applyTransform([0, 0], L), V = ue.Util.applyTransform([0, J], L), U = ue.Util.applyTransform([G, 0], L), Q = ue.Util.applyTransform([G, J], L), X = Math.min(K[0], V[0], U[0], Q[0]), R = Math.min(K[1], V[1], U[1], Q[1]), f = Math.max(K[0], V[0], U[0], Q[0]), D = Math.max(K[1], V[1], U[1], Q[1]);
                this.ctx.fillRect(X, R, f - X, D - R);
              } else
                this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
              this.compose(this.current.getClippedPathBoundingBox()), this.restore();
            }
            beginInlineImage() {
              (0, ue.unreachable)("Should not call beginInlineImage");
            }
            beginImageData() {
              (0, ue.unreachable)("Should not call beginImageData");
            }
            paintFormXObjectBegin(m, p) {
              if (this.contentVisible && (this.save(), this.baseTransformStack.push(this.baseTransform), Array.isArray(m) && m.length === 6 && this.transform(...m), this.baseTransform = (0, me.getCurrentTransform)(this.ctx), p)) {
                const T = p[2] - p[0], L = p[3] - p[1];
                this.ctx.rect(p[0], p[1], T, L), this.current.updateRectMinMax((0, me.getCurrentTransform)(this.ctx), p), this.clip(), this.endPath();
              }
            }
            paintFormXObjectEnd() {
              this.contentVisible && (this.restore(), this.baseTransform = this.baseTransformStack.pop());
            }
            beginGroup(m) {
              if (!this.contentVisible)
                return;
              this.save(), this.inSMaskMode && (this.endSMaskMode(), this.current.activeSMask = null);
              const p = this.ctx;
              m.isolated || (0, ue.info)("TODO: Support non-isolated groups."), m.knockout && (0, ue.warn)("Knockout groups not supported.");
              const T = (0, me.getCurrentTransform)(p);
              if (m.matrix && p.transform(...m.matrix), !m.bbox)
                throw new Error("Bounding box is required.");
              let L = ue.Util.getAxialAlignedBoundingBox(m.bbox, (0, me.getCurrentTransform)(p));
              const _ = [0, 0, p.canvas.width, p.canvas.height];
              L = ue.Util.intersect(L, _) || [0, 0, 0, 0];
              const G = Math.floor(L[0]), J = Math.floor(L[1]);
              let K = Math.max(Math.ceil(L[2]) - G, 1), V = Math.max(Math.ceil(L[3]) - J, 1), U = 1, Q = 1;
              K > u && (U = K / u, K = u), V > u && (Q = V / u, V = u), this.current.startNewPathAndClipBox([0, 0, K, V]);
              let X = "groupAt" + this.groupLevel;
              m.smask && (X += "_smask_" + this.smaskCounter++ % 2);
              const R = this.cachedCanvases.getCanvas(X, K, V), f = R.context;
              f.scale(1 / U, 1 / Q), f.translate(-G, -J), f.transform(...T), m.smask ? this.smaskStack.push({
                canvas: R.canvas,
                context: f,
                offsetX: G,
                offsetY: J,
                scaleX: U,
                scaleY: Q,
                subtype: m.smask.subtype,
                backdrop: m.smask.backdrop,
                transferMap: m.smask.transferMap || null,
                startTransformInverse: null
              }) : (p.setTransform(1, 0, 0, 1, 0, 0), p.translate(G, J), p.scale(U, Q), p.save()), k(p, f), this.ctx = f, this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]), this.groupStack.push(p), this.groupLevel++;
            }
            endGroup(m) {
              if (!this.contentVisible)
                return;
              this.groupLevel--;
              const p = this.ctx, T = this.groupStack.pop();
              if (this.ctx = T, this.ctx.imageSmoothingEnabled = !1, m.smask)
                this.tempSMask = this.smaskStack.pop(), this.restore();
              else {
                this.ctx.restore();
                const L = (0, me.getCurrentTransform)(this.ctx);
                this.restore(), this.ctx.save(), this.ctx.setTransform(...L);
                const _ = ue.Util.getAxialAlignedBoundingBox([0, 0, p.canvas.width, p.canvas.height], L);
                this.ctx.drawImage(p.canvas, 0, 0), this.ctx.restore(), this.compose(_);
              }
            }
            beginAnnotation(m, p, T, L, _) {
              if (ze(this, d, Qn).call(this), s(this.ctx), this.ctx.save(), this.save(), this.baseTransform && this.ctx.setTransform(...this.baseTransform), Array.isArray(p) && p.length === 4) {
                const G = p[2] - p[0], J = p[3] - p[1];
                if (_ && this.annotationCanvasMap) {
                  T = T.slice(), T[4] -= p[0], T[5] -= p[1], p = p.slice(), p[0] = p[1] = 0, p[2] = G, p[3] = J;
                  const [K, V] = ue.Util.singularValueDecompose2dScale((0, me.getCurrentTransform)(this.ctx)), {
                    viewportScale: U
                  } = this, Q = Math.ceil(G * this.outputScaleX * U), X = Math.ceil(J * this.outputScaleY * U);
                  this.annotationCanvas = this.canvasFactory.create(Q, X);
                  const {
                    canvas: R,
                    context: f
                  } = this.annotationCanvas;
                  this.annotationCanvasMap.set(m, R), this.annotationCanvas.savedCtx = this.ctx, this.ctx = f, this.ctx.save(), this.ctx.setTransform(K, 0, 0, -V, 0, J * V), s(this.ctx);
                } else
                  s(this.ctx), this.ctx.rect(p[0], p[1], G, J), this.ctx.clip(), this.endPath();
              }
              this.current = new C(this.ctx.canvas.width, this.ctx.canvas.height), this.transform(...T), this.transform(...L);
            }
            endAnnotation() {
              this.annotationCanvas && (this.ctx.restore(), ze(this, N, ei).call(this), this.ctx = this.annotationCanvas.savedCtx, delete this.annotationCanvas.savedCtx, delete this.annotationCanvas);
            }
            paintImageMaskXObject(m) {
              if (!this.contentVisible)
                return;
              const p = m.count;
              m = this.getObject(m.data, m), m.count = p;
              const T = this.ctx, L = this.processingType3;
              if (L && (L.compiled === void 0 && (L.compiled = w(m)), L.compiled)) {
                L.compiled(T);
                return;
              }
              const _ = this._createMaskCanvas(m), G = _.canvas;
              T.save(), T.setTransform(1, 0, 0, 1, 0, 0), T.drawImage(G, _.offsetX, _.offsetY), T.restore(), this.compose();
            }
            paintImageMaskXObjectRepeat(m, p, T = 0, L = 0, _, G) {
              if (!this.contentVisible)
                return;
              m = this.getObject(m.data, m);
              const J = this.ctx;
              J.save();
              const K = (0, me.getCurrentTransform)(J);
              J.transform(p, T, L, _, 0, 0);
              const V = this._createMaskCanvas(m);
              J.setTransform(1, 0, 0, 1, V.offsetX - K[4], V.offsetY - K[5]);
              for (let U = 0, Q = G.length; U < Q; U += 2) {
                const X = ue.Util.transform(K, [p, T, L, _, G[U], G[U + 1]]), [R, f] = ue.Util.applyTransform([0, 0], X);
                J.drawImage(V.canvas, R, f);
              }
              J.restore(), this.compose();
            }
            paintImageMaskXObjectGroup(m) {
              if (!this.contentVisible)
                return;
              const p = this.ctx, T = this.current.fillColor, L = this.current.patternFill;
              for (const _ of m) {
                const {
                  data: G,
                  width: J,
                  height: K,
                  transform: V
                } = _, U = this.cachedCanvases.getCanvas("maskCanvas", J, K), Q = U.context;
                Q.save();
                const X = this.getObject(G, _);
                o(Q, X), Q.globalCompositeOperation = "source-in", Q.fillStyle = L ? T.getPattern(Q, this, (0, me.getCurrentTransformInverse)(p), Me.PathType.FILL) : T, Q.fillRect(0, 0, J, K), Q.restore(), p.save(), p.transform(...V), p.scale(1, -1), O(p, U.canvas, 0, 0, J, K, 0, -1, 1, 1), p.restore();
              }
              this.compose();
            }
            paintImageXObject(m) {
              if (!this.contentVisible)
                return;
              const p = this.getObject(m);
              if (!p) {
                (0, ue.warn)("Dependent image isn't ready yet");
                return;
              }
              this.paintInlineImageXObject(p);
            }
            paintImageXObjectRepeat(m, p, T, L) {
              if (!this.contentVisible)
                return;
              const _ = this.getObject(m);
              if (!_) {
                (0, ue.warn)("Dependent image isn't ready yet");
                return;
              }
              const G = _.width, J = _.height, K = [];
              for (let V = 0, U = L.length; V < U; V += 2)
                K.push({
                  transform: [p, 0, 0, T, L[V], L[V + 1]],
                  x: 0,
                  y: 0,
                  w: G,
                  h: J
                });
              this.paintInlineImageXObjectGroup(_, K);
            }
            applyTransferMapsToCanvas(m) {
              return this.current.transferMaps !== "none" && (m.filter = this.current.transferMaps, m.drawImage(m.canvas, 0, 0), m.filter = "none"), m.canvas;
            }
            applyTransferMapsToBitmap(m) {
              if (this.current.transferMaps === "none")
                return m.bitmap;
              const {
                bitmap: p,
                width: T,
                height: L
              } = m, _ = this.cachedCanvases.getCanvas("inlineImage", T, L), G = _.context;
              return G.filter = this.current.transferMaps, G.drawImage(p, 0, 0), G.filter = "none", _.canvas;
            }
            paintInlineImageXObject(m) {
              if (!this.contentVisible)
                return;
              const p = m.width, T = m.height, L = this.ctx;
              this.save(), F.isNodeJS || (L.filter = "none"), L.scale(1 / p, -1 / T);
              let _;
              if (m.bitmap)
                _ = this.applyTransferMapsToBitmap(m);
              else if (typeof HTMLElement == "function" && m instanceof HTMLElement || !m.data)
                _ = m;
              else {
                const K = this.cachedCanvases.getCanvas("inlineImage", p, T).context;
                i(K, m), _ = this.applyTransferMapsToCanvas(K);
              }
              const G = this._scaleImage(_, (0, me.getCurrentTransformInverse)(L));
              L.imageSmoothingEnabled = b((0, me.getCurrentTransform)(L), m.interpolate), O(L, G.img, 0, 0, G.paintWidth, G.paintHeight, 0, -T, p, T), this.compose(), this.restore();
            }
            paintInlineImageXObjectGroup(m, p) {
              if (!this.contentVisible)
                return;
              const T = this.ctx;
              let L;
              if (m.bitmap)
                L = m.bitmap;
              else {
                const _ = m.width, G = m.height, K = this.cachedCanvases.getCanvas("inlineImage", _, G).context;
                i(K, m), L = this.applyTransferMapsToCanvas(K);
              }
              for (const _ of p)
                T.save(), T.transform(..._.transform), T.scale(1, -1), O(T, L, _.x, _.y, _.w, _.h, 0, -1, 1, 1), T.restore();
              this.compose();
            }
            paintSolidColorImageMask() {
              this.contentVisible && (this.ctx.fillRect(0, 0, 1, 1), this.compose());
            }
            markPoint(m) {
            }
            markPointProps(m, p) {
            }
            beginMarkedContent(m) {
              this.markedContentStack.push({
                visible: !0
              });
            }
            beginMarkedContentProps(m, p) {
              m === "OC" ? this.markedContentStack.push({
                visible: this.optionalContentConfig.isVisible(p)
              }) : this.markedContentStack.push({
                visible: !0
              }), this.contentVisible = this.isContentVisible();
            }
            endMarkedContent() {
              this.markedContentStack.pop(), this.contentVisible = this.isContentVisible();
            }
            beginCompat() {
            }
            endCompat() {
            }
            consumePath(m) {
              const p = this.current.isEmptyClip();
              this.pendingClip && this.current.updateClipFromPath(), this.pendingClip || this.compose(m);
              const T = this.ctx;
              this.pendingClip && (p || (this.pendingClip === P ? T.clip("evenodd") : T.clip()), this.pendingClip = null), this.current.startNewPathAndClipBox(this.current.clipBox), T.beginPath();
            }
            getSinglePixelWidth() {
              if (!this._cachedGetSinglePixelWidth) {
                const m = (0, me.getCurrentTransform)(this.ctx);
                if (m[1] === 0 && m[2] === 0)
                  this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                else {
                  const p = Math.abs(m[0] * m[3] - m[2] * m[1]), T = Math.hypot(m[0], m[2]), L = Math.hypot(m[1], m[3]);
                  this._cachedGetSinglePixelWidth = Math.max(T, L) / p;
                }
              }
              return this._cachedGetSinglePixelWidth;
            }
            getScaleForStroking() {
              if (this._cachedScaleForStroking[0] === -1) {
                const {
                  lineWidth: m
                } = this.current, {
                  a: p,
                  b: T,
                  c: L,
                  d: _
                } = this.ctx.getTransform();
                let G, J;
                if (T === 0 && L === 0) {
                  const K = Math.abs(p), V = Math.abs(_);
                  if (K === V)
                    if (m === 0)
                      G = J = 1 / K;
                    else {
                      const U = K * m;
                      G = J = U < 1 ? 1 / U : 1;
                    }
                  else if (m === 0)
                    G = 1 / K, J = 1 / V;
                  else {
                    const U = K * m, Q = V * m;
                    G = U < 1 ? 1 / U : 1, J = Q < 1 ? 1 / Q : 1;
                  }
                } else {
                  const K = Math.abs(p * _ - T * L), V = Math.hypot(p, T), U = Math.hypot(L, _);
                  if (m === 0)
                    G = U / K, J = V / K;
                  else {
                    const Q = m * K;
                    G = U > Q ? U / Q : 1, J = V > Q ? V / Q : 1;
                  }
                }
                this._cachedScaleForStroking[0] = G, this._cachedScaleForStroking[1] = J;
              }
              return this._cachedScaleForStroking;
            }
            rescaleAndStroke(m) {
              const {
                ctx: p
              } = this, {
                lineWidth: T
              } = this.current, [L, _] = this.getScaleForStroking();
              if (p.lineWidth = T || 1, L === 1 && _ === 1) {
                p.stroke();
                return;
              }
              const G = p.getLineDash();
              if (m && p.save(), p.scale(L, _), G.length > 0) {
                const J = Math.max(L, _);
                p.setLineDash(G.map((K) => K / J)), p.lineDashOffset /= J;
              }
              p.stroke(), m && p.restore();
            }
            isContentVisible() {
              for (let m = this.markedContentStack.length - 1; m >= 0; m--)
                if (!this.markedContentStack[m].visible)
                  return !1;
              return !0;
            }
          };
          d = new WeakSet(), Qn = function() {
            for (; this.stateStack.length || this.inSMaskMode; )
              this.restore();
            this.ctx.restore(), this.transparentCanvas && (this.ctx = this.compositeCtx, this.ctx.save(), this.ctx.setTransform(1, 0, 0, 1, 0, 0), this.ctx.drawImage(this.transparentCanvas, 0, 0), this.ctx.restore(), this.transparentCanvas = null);
          }, N = new WeakSet(), ei = function() {
            if (this.pageColors) {
              const m = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
              if (m !== "none") {
                const p = this.ctx.filter;
                this.ctx.filter = m, this.ctx.drawImage(this.ctx.canvas, 0, 0), this.ctx.filter = p;
              }
            }
          };
          let c = H;
          he.CanvasGraphics = c;
          for (const $ in ue.OPS)
            c.prototype[$] !== void 0 && (c.prototype[ue.OPS[$]] = c.prototype[$]);
        },
        /* 12 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.TilingPattern = he.PathType = void 0, he.getShadingPattern = t;
          var ue = ke(1), me = ke(6);
          const Me = {
            FILL: "Fill",
            STROKE: "Stroke",
            SHADING: "Shading"
          };
          he.PathType = Me;
          function xe(O, w) {
            if (!w)
              return;
            const C = w[2] - w[0], i = w[3] - w[1], o = new Path2D();
            o.rect(w[0], w[1], C, i), O.clip(o);
          }
          class F {
            constructor() {
              this.constructor === F && (0, ue.unreachable)("Cannot initialize BaseShadingPattern.");
            }
            getPattern() {
              (0, ue.unreachable)("Abstract method `getPattern` called.");
            }
          }
          class ae extends F {
            constructor(w) {
              super(), this._type = w[1], this._bbox = w[2], this._colorStops = w[3], this._p0 = w[4], this._p1 = w[5], this._r0 = w[6], this._r1 = w[7], this.matrix = null;
            }
            _createGradient(w) {
              let C;
              this._type === "axial" ? C = w.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]) : this._type === "radial" && (C = w.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1));
              for (const i of this._colorStops)
                C.addColorStop(i[0], i[1]);
              return C;
            }
            getPattern(w, C, i, o) {
              let k;
              if (o === Me.STROKE || o === Me.FILL) {
                const s = C.current.getClippedPathBoundingBox(o, (0, me.getCurrentTransform)(w)) || [0, 0, 0, 0], l = Math.ceil(s[2] - s[0]) || 1, g = Math.ceil(s[3] - s[1]) || 1, v = C.cachedCanvases.getCanvas("pattern", l, g, !0), r = v.context;
                r.clearRect(0, 0, r.canvas.width, r.canvas.height), r.beginPath(), r.rect(0, 0, r.canvas.width, r.canvas.height), r.translate(-s[0], -s[1]), i = ue.Util.transform(i, [1, 0, 0, 1, s[0], s[1]]), r.transform(...C.baseTransform), this.matrix && r.transform(...this.matrix), xe(r, this._bbox), r.fillStyle = this._createGradient(r), r.fill(), k = w.createPattern(v.canvas, "no-repeat");
                const x = new DOMMatrix(i);
                k.setTransform(x);
              } else
                xe(w, this._bbox), k = this._createGradient(w);
              return k;
            }
          }
          function n(O, w, C, i, o, k, s, l) {
            const g = w.coords, v = w.colors, r = O.data, x = O.width * 4;
            let b;
            g[C + 1] > g[i + 1] && (b = C, C = i, i = b, b = k, k = s, s = b), g[i + 1] > g[o + 1] && (b = i, i = o, o = b, b = s, s = l, l = b), g[C + 1] > g[i + 1] && (b = C, C = i, i = b, b = k, k = s, s = b);
            const I = (g[C] + w.offsetX) * w.scaleX, h = (g[C + 1] + w.offsetY) * w.scaleY, y = (g[i] + w.offsetX) * w.scaleX, P = (g[i + 1] + w.offsetY) * w.scaleY, c = (g[o] + w.offsetX) * w.scaleX, d = (g[o + 1] + w.offsetY) * w.scaleY;
            if (h >= d)
              return;
            const A = v[k], N = v[k + 1], E = v[k + 2], H = v[s], $ = v[s + 1], m = v[s + 2], p = v[l], T = v[l + 1], L = v[l + 2], _ = Math.round(h), G = Math.round(d);
            let J, K, V, U, Q, X, R, f;
            for (let D = _; D <= G; D++) {
              if (D < P) {
                let ne;
                D < h ? ne = 0 : ne = (h - D) / (h - P), J = I - (I - y) * ne, K = A - (A - H) * ne, V = N - (N - $) * ne, U = E - (E - m) * ne;
              } else {
                let ne;
                D > d ? ne = 1 : P === d ? ne = 0 : ne = (P - D) / (P - d), J = y - (y - c) * ne, K = H - (H - p) * ne, V = $ - ($ - T) * ne, U = m - (m - L) * ne;
              }
              let z;
              D < h ? z = 0 : D > d ? z = 1 : z = (h - D) / (h - d), Q = I - (I - c) * z, X = A - (A - p) * z, R = N - (N - T) * z, f = E - (E - L) * z;
              const Y = Math.round(Math.min(J, Q)), W = Math.round(Math.max(J, Q));
              let ie = x * D + Y * 4;
              for (let ne = Y; ne <= W; ne++)
                z = (J - ne) / (J - Q), z < 0 ? z = 0 : z > 1 && (z = 1), r[ie++] = K - (K - X) * z | 0, r[ie++] = V - (V - R) * z | 0, r[ie++] = U - (U - f) * z | 0, r[ie++] = 255;
            }
          }
          function u(O, w, C) {
            const i = w.coords, o = w.colors;
            let k, s;
            switch (w.type) {
              case "lattice":
                const l = w.verticesPerRow, g = Math.floor(i.length / l) - 1, v = l - 1;
                for (k = 0; k < g; k++) {
                  let r = k * l;
                  for (let x = 0; x < v; x++, r++)
                    n(O, C, i[r], i[r + 1], i[r + l], o[r], o[r + 1], o[r + l]), n(O, C, i[r + l + 1], i[r + 1], i[r + l], o[r + l + 1], o[r + 1], o[r + l]);
                }
                break;
              case "triangles":
                for (k = 0, s = i.length; k < s; k += 3)
                  n(O, C, i[k], i[k + 1], i[k + 2], o[k], o[k + 1], o[k + 2]);
                break;
              default:
                throw new Error("illegal figure");
            }
          }
          class q extends F {
            constructor(w) {
              super(), this._coords = w[2], this._colors = w[3], this._figures = w[4], this._bounds = w[5], this._bbox = w[7], this._background = w[8], this.matrix = null;
            }
            _createMeshCanvas(w, C, i) {
              const l = Math.floor(this._bounds[0]), g = Math.floor(this._bounds[1]), v = Math.ceil(this._bounds[2]) - l, r = Math.ceil(this._bounds[3]) - g, x = Math.min(Math.ceil(Math.abs(v * w[0] * 1.1)), 3e3), b = Math.min(Math.ceil(Math.abs(r * w[1] * 1.1)), 3e3), I = v / x, h = r / b, y = {
                coords: this._coords,
                colors: this._colors,
                offsetX: -l,
                offsetY: -g,
                scaleX: 1 / I,
                scaleY: 1 / h
              }, P = x + 2 * 2, c = b + 2 * 2, d = i.getCanvas("mesh", P, c, !1), A = d.context, N = A.createImageData(x, b);
              if (C) {
                const H = N.data;
                for (let $ = 0, m = H.length; $ < m; $ += 4)
                  H[$] = C[0], H[$ + 1] = C[1], H[$ + 2] = C[2], H[$ + 3] = 255;
              }
              for (const H of this._figures)
                u(N, H, y);
              return A.putImageData(N, 2, 2), {
                canvas: d.canvas,
                offsetX: l - 2 * I,
                offsetY: g - 2 * h,
                scaleX: I,
                scaleY: h
              };
            }
            getPattern(w, C, i, o) {
              xe(w, this._bbox);
              let k;
              if (o === Me.SHADING)
                k = ue.Util.singularValueDecompose2dScale((0, me.getCurrentTransform)(w));
              else if (k = ue.Util.singularValueDecompose2dScale(C.baseTransform), this.matrix) {
                const l = ue.Util.singularValueDecompose2dScale(this.matrix);
                k = [k[0] * l[0], k[1] * l[1]];
              }
              const s = this._createMeshCanvas(k, o === Me.SHADING ? null : this._background, C.cachedCanvases);
              return o !== Me.SHADING && (w.setTransform(...C.baseTransform), this.matrix && w.transform(...this.matrix)), w.translate(s.offsetX, s.offsetY), w.scale(s.scaleX, s.scaleY), w.createPattern(s.canvas, "no-repeat");
            }
          }
          class e extends F {
            getPattern() {
              return "hotpink";
            }
          }
          function t(O) {
            switch (O[0]) {
              case "RadialAxial":
                return new ae(O);
              case "Mesh":
                return new q(O);
              case "Dummy":
                return new e();
            }
            throw new Error(`Unknown IR type: ${O[0]}`);
          }
          const B = {
            COLORED: 1,
            UNCOLORED: 2
          }, M = class M {
            constructor(w, C, i, o, k) {
              this.operatorList = w[2], this.matrix = w[3] || [1, 0, 0, 1, 0, 0], this.bbox = w[4], this.xstep = w[5], this.ystep = w[6], this.paintType = w[7], this.tilingType = w[8], this.color = C, this.ctx = i, this.canvasGraphicsFactory = o, this.baseTransform = k;
            }
            createPatternCanvas(w) {
              const C = this.operatorList, i = this.bbox, o = this.xstep, k = this.ystep, s = this.paintType, l = this.tilingType, g = this.color, v = this.canvasGraphicsFactory;
              (0, ue.info)("TilingType: " + l);
              const r = i[0], x = i[1], b = i[2], I = i[3], h = ue.Util.singularValueDecompose2dScale(this.matrix), y = ue.Util.singularValueDecompose2dScale(this.baseTransform), P = [h[0] * y[0], h[1] * y[1]], c = this.getSizeAndScale(o, this.ctx.canvas.width, P[0]), d = this.getSizeAndScale(k, this.ctx.canvas.height, P[1]), A = w.cachedCanvases.getCanvas("pattern", c.size, d.size, !0), N = A.context, E = v.createCanvasGraphics(N);
              E.groupLevel = w.groupLevel, this.setFillAndStrokeStyleToContext(E, s, g);
              let H = r, $ = x, m = b, p = I;
              return r < 0 && (H = 0, m += Math.abs(r)), x < 0 && ($ = 0, p += Math.abs(x)), N.translate(-(c.scale * H), -(d.scale * $)), E.transform(c.scale, 0, 0, d.scale, 0, 0), N.save(), this.clipBbox(E, H, $, m, p), E.baseTransform = (0, me.getCurrentTransform)(E.ctx), E.executeOperatorList(C), E.endDrawing(), {
                canvas: A.canvas,
                scaleX: c.scale,
                scaleY: d.scale,
                offsetX: H,
                offsetY: $
              };
            }
            getSizeAndScale(w, C, i) {
              w = Math.abs(w);
              const o = Math.max(M.MAX_PATTERN_SIZE, C);
              let k = Math.ceil(w * i);
              return k >= o ? k = o : i = k / w, {
                scale: i,
                size: k
              };
            }
            clipBbox(w, C, i, o, k) {
              const s = o - C, l = k - i;
              w.ctx.rect(C, i, s, l), w.current.updateRectMinMax((0, me.getCurrentTransform)(w.ctx), [C, i, o, k]), w.clip(), w.endPath();
            }
            setFillAndStrokeStyleToContext(w, C, i) {
              const o = w.ctx, k = w.current;
              switch (C) {
                case B.COLORED:
                  const s = this.ctx;
                  o.fillStyle = s.fillStyle, o.strokeStyle = s.strokeStyle, k.fillColor = s.fillStyle, k.strokeColor = s.strokeStyle;
                  break;
                case B.UNCOLORED:
                  const l = ue.Util.makeHexColor(i[0], i[1], i[2]);
                  o.fillStyle = l, o.strokeStyle = l, k.fillColor = l, k.strokeColor = l;
                  break;
                default:
                  throw new ue.FormatError(`Unsupported paint type: ${C}`);
              }
            }
            getPattern(w, C, i, o) {
              let k = i;
              o !== Me.SHADING && (k = ue.Util.transform(k, C.baseTransform), this.matrix && (k = ue.Util.transform(k, this.matrix)));
              const s = this.createPatternCanvas(C);
              let l = new DOMMatrix(k);
              l = l.translate(s.offsetX, s.offsetY), l = l.scale(1 / s.scaleX, 1 / s.scaleY);
              const g = w.createPattern(s.canvas, "repeat");
              return g.setTransform(l), g;
            }
          };
          Dt(M, "MAX_PATTERN_SIZE", 3e3);
          let j = M;
          he.TilingPattern = j;
        },
        /* 13 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.convertBlackAndWhiteToRGBA = Me, he.convertToRGBA = me, he.grayToRGBA = F;
          var ue = ke(1);
          function me(ae) {
            switch (ae.kind) {
              case ue.ImageKind.GRAYSCALE_1BPP:
                return Me(ae);
              case ue.ImageKind.RGB_24BPP:
                return xe(ae);
            }
            return null;
          }
          function Me({
            src: ae,
            srcPos: n = 0,
            dest: u,
            width: q,
            height: e,
            nonBlackColor: t = 4294967295,
            inverseDecode: B = !1
          }) {
            const j = ue.FeatureTest.isLittleEndian ? 4278190080 : 255, [M, O] = B ? [t, j] : [j, t], w = q >> 3, C = q & 7, i = ae.length;
            u = new Uint32Array(u.buffer);
            let o = 0;
            for (let k = 0; k < e; k++) {
              for (const l = n + w; n < l; n++) {
                const g = n < i ? ae[n] : 255;
                u[o++] = g & 128 ? O : M, u[o++] = g & 64 ? O : M, u[o++] = g & 32 ? O : M, u[o++] = g & 16 ? O : M, u[o++] = g & 8 ? O : M, u[o++] = g & 4 ? O : M, u[o++] = g & 2 ? O : M, u[o++] = g & 1 ? O : M;
              }
              if (C === 0)
                continue;
              const s = n < i ? ae[n++] : 255;
              for (let l = 0; l < C; l++)
                u[o++] = s & 1 << 7 - l ? O : M;
            }
            return {
              srcPos: n,
              destPos: o
            };
          }
          function xe({
            src: ae,
            srcPos: n = 0,
            dest: u,
            destPos: q = 0,
            width: e,
            height: t
          }) {
            let B = 0;
            const j = ae.length >> 2, M = new Uint32Array(ae.buffer, n, j);
            if (ue.FeatureTest.isLittleEndian) {
              for (; B < j - 2; B += 3, q += 4) {
                const O = M[B], w = M[B + 1], C = M[B + 2];
                u[q] = O | 4278190080, u[q + 1] = O >>> 24 | w << 8 | 4278190080, u[q + 2] = w >>> 16 | C << 16 | 4278190080, u[q + 3] = C >>> 8 | 4278190080;
              }
              for (let O = B * 4, w = ae.length; O < w; O += 3)
                u[q++] = ae[O] | ae[O + 1] << 8 | ae[O + 2] << 16 | 4278190080;
            } else {
              for (; B < j - 2; B += 3, q += 4) {
                const O = M[B], w = M[B + 1], C = M[B + 2];
                u[q] = O | 255, u[q + 1] = O << 24 | w >>> 8 | 255, u[q + 2] = w << 16 | C >>> 16 | 255, u[q + 3] = C << 8 | 255;
              }
              for (let O = B * 4, w = ae.length; O < w; O += 3)
                u[q++] = ae[O] << 24 | ae[O + 1] << 16 | ae[O + 2] << 8 | 255;
            }
            return {
              srcPos: n,
              destPos: q
            };
          }
          function F(ae, n) {
            if (ue.FeatureTest.isLittleEndian)
              for (let u = 0, q = ae.length; u < q; u++)
                n[u] = ae[u] * 65793 | 4278190080;
            else
              for (let u = 0, q = ae.length; u < q; u++)
                n[u] = ae[u] * 16843008 | 255;
          }
        },
        /* 14 */
        /***/
        (Se, he) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.GlobalWorkerOptions = void 0;
          const ke = /* @__PURE__ */ Object.create(null);
          he.GlobalWorkerOptions = ke, ke.workerPort = null, ke.workerSrc = "";
        },
        /* 15 */
        /***/
        (Se, he, ke) => {
          var ae, vi, u, Ci, e, En;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.MessageHandler = void 0;
          var ue = ke(1);
          const me = {
            UNKNOWN: 0,
            DATA: 1,
            ERROR: 2
          }, Me = {
            UNKNOWN: 0,
            CANCEL: 1,
            CANCEL_COMPLETE: 2,
            CLOSE: 3,
            ENQUEUE: 4,
            ERROR: 5,
            PULL: 6,
            PULL_COMPLETE: 7,
            START_COMPLETE: 8
          };
          function xe(B) {
            switch (B instanceof Error || typeof B == "object" && B !== null || (0, ue.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.'), B.name) {
              case "AbortException":
                return new ue.AbortException(B.message);
              case "MissingPDFException":
                return new ue.MissingPDFException(B.message);
              case "PasswordException":
                return new ue.PasswordException(B.message, B.code);
              case "UnexpectedResponseException":
                return new ue.UnexpectedResponseException(B.message, B.status);
              case "UnknownErrorException":
                return new ue.UnknownErrorException(B.message, B.details);
              default:
                return new ue.UnknownErrorException(B.message, B.toString());
            }
          }
          class F {
            constructor(j, M, O) {
              Be(this, ae);
              Be(this, u);
              Be(this, e);
              this.sourceName = j, this.targetName = M, this.comObj = O, this.callbackId = 1, this.streamId = 1, this.streamSinks = /* @__PURE__ */ Object.create(null), this.streamControllers = /* @__PURE__ */ Object.create(null), this.callbackCapabilities = /* @__PURE__ */ Object.create(null), this.actionHandler = /* @__PURE__ */ Object.create(null), this._onComObjOnMessage = (w) => {
                const C = w.data;
                if (C.targetName !== this.sourceName)
                  return;
                if (C.stream) {
                  ze(this, u, Ci).call(this, C);
                  return;
                }
                if (C.callback) {
                  const o = C.callbackId, k = this.callbackCapabilities[o];
                  if (!k)
                    throw new Error(`Cannot resolve callback ${o}`);
                  if (delete this.callbackCapabilities[o], C.callback === me.DATA)
                    k.resolve(C.data);
                  else if (C.callback === me.ERROR)
                    k.reject(xe(C.reason));
                  else
                    throw new Error("Unexpected callback case");
                  return;
                }
                const i = this.actionHandler[C.action];
                if (!i)
                  throw new Error(`Unknown action from worker: ${C.action}`);
                if (C.callbackId) {
                  const o = this.sourceName, k = C.sourceName;
                  new Promise(function(s) {
                    s(i(C.data));
                  }).then(function(s) {
                    O.postMessage({
                      sourceName: o,
                      targetName: k,
                      callback: me.DATA,
                      callbackId: C.callbackId,
                      data: s
                    });
                  }, function(s) {
                    O.postMessage({
                      sourceName: o,
                      targetName: k,
                      callback: me.ERROR,
                      callbackId: C.callbackId,
                      reason: xe(s)
                    });
                  });
                  return;
                }
                if (C.streamId) {
                  ze(this, ae, vi).call(this, C);
                  return;
                }
                i(C.data);
              }, O.addEventListener("message", this._onComObjOnMessage);
            }
            on(j, M) {
              const O = this.actionHandler;
              if (O[j])
                throw new Error(`There is already an actionName called "${j}"`);
              O[j] = M;
            }
            send(j, M, O) {
              this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: j,
                data: M
              }, O);
            }
            sendWithPromise(j, M, O) {
              const w = this.callbackId++, C = new ue.PromiseCapability();
              this.callbackCapabilities[w] = C;
              try {
                this.comObj.postMessage({
                  sourceName: this.sourceName,
                  targetName: this.targetName,
                  action: j,
                  callbackId: w,
                  data: M
                }, O);
              } catch (i) {
                C.reject(i);
              }
              return C.promise;
            }
            sendWithStream(j, M, O, w) {
              const C = this.streamId++, i = this.sourceName, o = this.targetName, k = this.comObj;
              return new ReadableStream({
                start: (s) => {
                  const l = new ue.PromiseCapability();
                  return this.streamControllers[C] = {
                    controller: s,
                    startCall: l,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: !1
                  }, k.postMessage({
                    sourceName: i,
                    targetName: o,
                    action: j,
                    streamId: C,
                    data: M,
                    desiredSize: s.desiredSize
                  }, w), l.promise;
                },
                pull: (s) => {
                  const l = new ue.PromiseCapability();
                  return this.streamControllers[C].pullCall = l, k.postMessage({
                    sourceName: i,
                    targetName: o,
                    stream: Me.PULL,
                    streamId: C,
                    desiredSize: s.desiredSize
                  }), l.promise;
                },
                cancel: (s) => {
                  (0, ue.assert)(s instanceof Error, "cancel must have a valid reason");
                  const l = new ue.PromiseCapability();
                  return this.streamControllers[C].cancelCall = l, this.streamControllers[C].isClosed = !0, k.postMessage({
                    sourceName: i,
                    targetName: o,
                    stream: Me.CANCEL,
                    streamId: C,
                    reason: xe(s)
                  }), l.promise;
                }
              }, O);
            }
            destroy() {
              this.comObj.removeEventListener("message", this._onComObjOnMessage);
            }
          }
          ae = new WeakSet(), vi = function(j) {
            const M = j.streamId, O = this.sourceName, w = j.sourceName, C = this.comObj, i = this, o = this.actionHandler[j.action], k = {
              enqueue(s, l = 1, g) {
                if (this.isCancelled)
                  return;
                const v = this.desiredSize;
                this.desiredSize -= l, v > 0 && this.desiredSize <= 0 && (this.sinkCapability = new ue.PromiseCapability(), this.ready = this.sinkCapability.promise), C.postMessage({
                  sourceName: O,
                  targetName: w,
                  stream: Me.ENQUEUE,
                  streamId: M,
                  chunk: s
                }, g);
              },
              close() {
                this.isCancelled || (this.isCancelled = !0, C.postMessage({
                  sourceName: O,
                  targetName: w,
                  stream: Me.CLOSE,
                  streamId: M
                }), delete i.streamSinks[M]);
              },
              error(s) {
                (0, ue.assert)(s instanceof Error, "error must have a valid reason"), !this.isCancelled && (this.isCancelled = !0, C.postMessage({
                  sourceName: O,
                  targetName: w,
                  stream: Me.ERROR,
                  streamId: M,
                  reason: xe(s)
                }));
              },
              sinkCapability: new ue.PromiseCapability(),
              onPull: null,
              onCancel: null,
              isCancelled: !1,
              desiredSize: j.desiredSize,
              ready: null
            };
            k.sinkCapability.resolve(), k.ready = k.sinkCapability.promise, this.streamSinks[M] = k, new Promise(function(s) {
              s(o(j.data, k));
            }).then(function() {
              C.postMessage({
                sourceName: O,
                targetName: w,
                stream: Me.START_COMPLETE,
                streamId: M,
                success: !0
              });
            }, function(s) {
              C.postMessage({
                sourceName: O,
                targetName: w,
                stream: Me.START_COMPLETE,
                streamId: M,
                reason: xe(s)
              });
            });
          }, u = new WeakSet(), Ci = function(j) {
            const M = j.streamId, O = this.sourceName, w = j.sourceName, C = this.comObj, i = this.streamControllers[M], o = this.streamSinks[M];
            switch (j.stream) {
              case Me.START_COMPLETE:
                j.success ? i.startCall.resolve() : i.startCall.reject(xe(j.reason));
                break;
              case Me.PULL_COMPLETE:
                j.success ? i.pullCall.resolve() : i.pullCall.reject(xe(j.reason));
                break;
              case Me.PULL:
                if (!o) {
                  C.postMessage({
                    sourceName: O,
                    targetName: w,
                    stream: Me.PULL_COMPLETE,
                    streamId: M,
                    success: !0
                  });
                  break;
                }
                o.desiredSize <= 0 && j.desiredSize > 0 && o.sinkCapability.resolve(), o.desiredSize = j.desiredSize, new Promise(function(k) {
                  var s;
                  k((s = o.onPull) == null ? void 0 : s.call(o));
                }).then(function() {
                  C.postMessage({
                    sourceName: O,
                    targetName: w,
                    stream: Me.PULL_COMPLETE,
                    streamId: M,
                    success: !0
                  });
                }, function(k) {
                  C.postMessage({
                    sourceName: O,
                    targetName: w,
                    stream: Me.PULL_COMPLETE,
                    streamId: M,
                    reason: xe(k)
                  });
                });
                break;
              case Me.ENQUEUE:
                if ((0, ue.assert)(i, "enqueue should have stream controller"), i.isClosed)
                  break;
                i.controller.enqueue(j.chunk);
                break;
              case Me.CLOSE:
                if ((0, ue.assert)(i, "close should have stream controller"), i.isClosed)
                  break;
                i.isClosed = !0, i.controller.close(), ze(this, e, En).call(this, i, M);
                break;
              case Me.ERROR:
                (0, ue.assert)(i, "error should have stream controller"), i.controller.error(xe(j.reason)), ze(this, e, En).call(this, i, M);
                break;
              case Me.CANCEL_COMPLETE:
                j.success ? i.cancelCall.resolve() : i.cancelCall.reject(xe(j.reason)), ze(this, e, En).call(this, i, M);
                break;
              case Me.CANCEL:
                if (!o)
                  break;
                new Promise(function(k) {
                  var s;
                  k((s = o.onCancel) == null ? void 0 : s.call(o, xe(j.reason)));
                }).then(function() {
                  C.postMessage({
                    sourceName: O,
                    targetName: w,
                    stream: Me.CANCEL_COMPLETE,
                    streamId: M,
                    success: !0
                  });
                }, function(k) {
                  C.postMessage({
                    sourceName: O,
                    targetName: w,
                    stream: Me.CANCEL_COMPLETE,
                    streamId: M,
                    reason: xe(k)
                  });
                }), o.sinkCapability.reject(xe(j.reason)), o.isCancelled = !0, delete this.streamSinks[M];
                break;
              default:
                throw new Error("Unexpected stream case");
            }
          }, e = new WeakSet(), En = async function(j, M) {
            var O, w, C;
            await Promise.allSettled([(O = j.startCall) == null ? void 0 : O.promise, (w = j.pullCall) == null ? void 0 : w.promise, (C = j.cancelCall) == null ? void 0 : C.promise]), delete this.streamControllers[M];
          }, he.MessageHandler = F;
        },
        /* 16 */
        /***/
        (Se, he, ke) => {
          var Me, xe;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.Metadata = void 0;
          var ue = ke(1);
          class me {
            constructor({
              parsedData: ae,
              rawData: n
            }) {
              Be(this, Me, void 0);
              Be(this, xe, void 0);
              rt(this, Me, ae), rt(this, xe, n);
            }
            getRaw() {
              return ge(this, xe);
            }
            get(ae) {
              return ge(this, Me).get(ae) ?? null;
            }
            getAll() {
              return (0, ue.objectFromMap)(ge(this, Me));
            }
            has(ae) {
              return ge(this, Me).has(ae);
            }
          }
          Me = new WeakMap(), xe = new WeakMap(), he.Metadata = me;
        },
        /* 17 */
        /***/
        (Se, he, ke) => {
          var ae, n, u, q, e, t, ti;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.OptionalContentConfig = void 0;
          var ue = ke(1), me = ke(8);
          const Me = Symbol("INTERNAL");
          class xe {
            constructor(M, O) {
              Be(this, ae, !0);
              this.name = M, this.intent = O;
            }
            get visible() {
              return ge(this, ae);
            }
            _setVisible(M, O) {
              M !== Me && (0, ue.unreachable)("Internal method `_setVisible` called."), rt(this, ae, O);
            }
          }
          ae = new WeakMap();
          class F {
            constructor(M) {
              Be(this, t);
              Be(this, n, null);
              Be(this, u, /* @__PURE__ */ new Map());
              Be(this, q, null);
              Be(this, e, null);
              if (this.name = null, this.creator = null, M !== null) {
                this.name = M.name, this.creator = M.creator, rt(this, e, M.order);
                for (const O of M.groups)
                  ge(this, u).set(O.id, new xe(O.name, O.intent));
                if (M.baseState === "OFF")
                  for (const O of ge(this, u).values())
                    O._setVisible(Me, !1);
                for (const O of M.on)
                  ge(this, u).get(O)._setVisible(Me, !0);
                for (const O of M.off)
                  ge(this, u).get(O)._setVisible(Me, !1);
                rt(this, q, this.getHash());
              }
            }
            isVisible(M) {
              if (ge(this, u).size === 0)
                return !0;
              if (!M)
                return (0, ue.warn)("Optional content group not defined."), !0;
              if (M.type === "OCG")
                return ge(this, u).has(M.id) ? ge(this, u).get(M.id).visible : ((0, ue.warn)(`Optional content group not found: ${M.id}`), !0);
              if (M.type === "OCMD") {
                if (M.expression)
                  return ze(this, t, ti).call(this, M.expression);
                if (!M.policy || M.policy === "AnyOn") {
                  for (const O of M.ids) {
                    if (!ge(this, u).has(O))
                      return (0, ue.warn)(`Optional content group not found: ${O}`), !0;
                    if (ge(this, u).get(O).visible)
                      return !0;
                  }
                  return !1;
                } else if (M.policy === "AllOn") {
                  for (const O of M.ids) {
                    if (!ge(this, u).has(O))
                      return (0, ue.warn)(`Optional content group not found: ${O}`), !0;
                    if (!ge(this, u).get(O).visible)
                      return !1;
                  }
                  return !0;
                } else if (M.policy === "AnyOff") {
                  for (const O of M.ids) {
                    if (!ge(this, u).has(O))
                      return (0, ue.warn)(`Optional content group not found: ${O}`), !0;
                    if (!ge(this, u).get(O).visible)
                      return !0;
                  }
                  return !1;
                } else if (M.policy === "AllOff") {
                  for (const O of M.ids) {
                    if (!ge(this, u).has(O))
                      return (0, ue.warn)(`Optional content group not found: ${O}`), !0;
                    if (ge(this, u).get(O).visible)
                      return !1;
                  }
                  return !0;
                }
                return (0, ue.warn)(`Unknown optional content policy ${M.policy}.`), !0;
              }
              return (0, ue.warn)(`Unknown group type ${M.type}.`), !0;
            }
            setVisibility(M, O = !0) {
              if (!ge(this, u).has(M)) {
                (0, ue.warn)(`Optional content group not found: ${M}`);
                return;
              }
              ge(this, u).get(M)._setVisible(Me, !!O), rt(this, n, null);
            }
            get hasInitialVisibility() {
              return this.getHash() === ge(this, q);
            }
            getOrder() {
              return ge(this, u).size ? ge(this, e) ? ge(this, e).slice() : [...ge(this, u).keys()] : null;
            }
            getGroups() {
              return ge(this, u).size > 0 ? (0, ue.objectFromMap)(ge(this, u)) : null;
            }
            getGroup(M) {
              return ge(this, u).get(M) || null;
            }
            getHash() {
              if (ge(this, n) !== null)
                return ge(this, n);
              const M = new me.MurmurHash3_64();
              for (const [O, w] of ge(this, u))
                M.update(`${O}:${w.visible}`);
              return rt(this, n, M.hexdigest());
            }
          }
          n = new WeakMap(), u = new WeakMap(), q = new WeakMap(), e = new WeakMap(), t = new WeakSet(), ti = function(M) {
            const O = M.length;
            if (O < 2)
              return !0;
            const w = M[0];
            for (let C = 1; C < O; C++) {
              const i = M[C];
              let o;
              if (Array.isArray(i))
                o = ze(this, t, ti).call(this, i);
              else if (ge(this, u).has(i))
                o = ge(this, u).get(i).visible;
              else
                return (0, ue.warn)(`Optional content group not found: ${i}`), !0;
              switch (w) {
                case "And":
                  if (!o)
                    return !1;
                  break;
                case "Or":
                  if (o)
                    return !0;
                  break;
                case "Not":
                  return !o;
                default:
                  return !0;
              }
            }
            return w === "And";
          }, he.OptionalContentConfig = F;
        },
        /* 18 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.PDFDataTransportStream = void 0;
          var ue = ke(1), me = ke(6);
          class Me {
            constructor({
              length: n,
              initialData: u,
              progressiveDone: q = !1,
              contentDispositionFilename: e = null,
              disableRange: t = !1,
              disableStream: B = !1
            }, j) {
              if ((0, ue.assert)(j, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.'), this._queuedChunks = [], this._progressiveDone = q, this._contentDispositionFilename = e, (u == null ? void 0 : u.length) > 0) {
                const M = u instanceof Uint8Array && u.byteLength === u.buffer.byteLength ? u.buffer : new Uint8Array(u).buffer;
                this._queuedChunks.push(M);
              }
              this._pdfDataRangeTransport = j, this._isStreamingSupported = !B, this._isRangeSupported = !t, this._contentLength = n, this._fullRequestReader = null, this._rangeReaders = [], this._pdfDataRangeTransport.addRangeListener((M, O) => {
                this._onReceiveData({
                  begin: M,
                  chunk: O
                });
              }), this._pdfDataRangeTransport.addProgressListener((M, O) => {
                this._onProgress({
                  loaded: M,
                  total: O
                });
              }), this._pdfDataRangeTransport.addProgressiveReadListener((M) => {
                this._onReceiveData({
                  chunk: M
                });
              }), this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
                this._onProgressiveDone();
              }), this._pdfDataRangeTransport.transportReady();
            }
            _onReceiveData({
              begin: n,
              chunk: u
            }) {
              const q = u instanceof Uint8Array && u.byteLength === u.buffer.byteLength ? u.buffer : new Uint8Array(u).buffer;
              if (n === void 0)
                this._fullRequestReader ? this._fullRequestReader._enqueue(q) : this._queuedChunks.push(q);
              else {
                const e = this._rangeReaders.some(function(t) {
                  return t._begin !== n ? !1 : (t._enqueue(q), !0);
                });
                (0, ue.assert)(e, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
              }
            }
            get _progressiveDataLength() {
              var n;
              return ((n = this._fullRequestReader) == null ? void 0 : n._loaded) ?? 0;
            }
            _onProgress(n) {
              var u, q, e, t;
              n.total === void 0 ? (q = (u = this._rangeReaders[0]) == null ? void 0 : u.onProgress) == null || q.call(u, {
                loaded: n.loaded
              }) : (t = (e = this._fullRequestReader) == null ? void 0 : e.onProgress) == null || t.call(e, {
                loaded: n.loaded,
                total: n.total
              });
            }
            _onProgressiveDone() {
              var n;
              (n = this._fullRequestReader) == null || n.progressiveDone(), this._progressiveDone = !0;
            }
            _removeRangeReader(n) {
              const u = this._rangeReaders.indexOf(n);
              u >= 0 && this._rangeReaders.splice(u, 1);
            }
            getFullReader() {
              (0, ue.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
              const n = this._queuedChunks;
              return this._queuedChunks = null, new xe(this, n, this._progressiveDone, this._contentDispositionFilename);
            }
            getRangeReader(n, u) {
              if (u <= this._progressiveDataLength)
                return null;
              const q = new F(this, n, u);
              return this._pdfDataRangeTransport.requestDataRange(n, u), this._rangeReaders.push(q), q;
            }
            cancelAllRequests(n) {
              var u;
              (u = this._fullRequestReader) == null || u.cancel(n);
              for (const q of this._rangeReaders.slice(0))
                q.cancel(n);
              this._pdfDataRangeTransport.abort();
            }
          }
          he.PDFDataTransportStream = Me;
          class xe {
            constructor(n, u, q = !1, e = null) {
              this._stream = n, this._done = q || !1, this._filename = (0, me.isPdfFile)(e) ? e : null, this._queuedChunks = u || [], this._loaded = 0;
              for (const t of this._queuedChunks)
                this._loaded += t.byteLength;
              this._requests = [], this._headersReady = Promise.resolve(), n._fullRequestReader = this, this.onProgress = null;
            }
            _enqueue(n) {
              this._done || (this._requests.length > 0 ? this._requests.shift().resolve({
                value: n,
                done: !1
              }) : this._queuedChunks.push(n), this._loaded += n.byteLength);
            }
            get headersReady() {
              return this._headersReady;
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._stream._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._stream._isStreamingSupported;
            }
            get contentLength() {
              return this._stream._contentLength;
            }
            async read() {
              if (this._queuedChunks.length > 0)
                return {
                  value: this._queuedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const n = new ue.PromiseCapability();
              return this._requests.push(n), n.promise;
            }
            cancel(n) {
              this._done = !0;
              for (const u of this._requests)
                u.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0;
            }
            progressiveDone() {
              this._done || (this._done = !0);
            }
          }
          class F {
            constructor(n, u, q) {
              this._stream = n, this._begin = u, this._end = q, this._queuedChunk = null, this._requests = [], this._done = !1, this.onProgress = null;
            }
            _enqueue(n) {
              if (!this._done) {
                if (this._requests.length === 0)
                  this._queuedChunk = n;
                else {
                  this._requests.shift().resolve({
                    value: n,
                    done: !1
                  });
                  for (const q of this._requests)
                    q.resolve({
                      value: void 0,
                      done: !0
                    });
                  this._requests.length = 0;
                }
                this._done = !0, this._stream._removeRangeReader(this);
              }
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._queuedChunk) {
                const u = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: u,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const n = new ue.PromiseCapability();
              return this._requests.push(n), n.promise;
            }
            cancel(n) {
              this._done = !0;
              for (const u of this._requests)
                u.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._stream._removeRangeReader(this);
            }
          }
        },
        /* 19 */
        /***/
        (Se, he) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.XfaText = void 0;
          class ke {
            static textContent(me) {
              const Me = [], xe = {
                items: Me,
                styles: /* @__PURE__ */ Object.create(null)
              };
              function F(ae) {
                var q;
                if (!ae)
                  return;
                let n = null;
                const u = ae.name;
                if (u === "#text")
                  n = ae.value;
                else if (ke.shouldBuildText(u))
                  (q = ae == null ? void 0 : ae.attributes) != null && q.textContent ? n = ae.attributes.textContent : ae.value && (n = ae.value);
                else
                  return;
                if (n !== null && Me.push({
                  str: n
                }), !!ae.children)
                  for (const e of ae.children)
                    F(e);
              }
              return F(me), xe;
            }
            static shouldBuildText(me) {
              return !(me === "textarea" || me === "input" || me === "option" || me === "select");
            }
          }
          he.XfaText = ke;
        },
        /* 20 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.NodeStandardFontDataFactory = he.NodeFilterFactory = he.NodeCanvasFactory = he.NodeCMapReaderFactory = void 0;
          var ue = ke(7);
          const me = function(n) {
            return new Promise((u, q) => {
              require$$5.readFile(n, (t, B) => {
                if (t || !B) {
                  q(new Error(t));
                  return;
                }
                u(new Uint8Array(B));
              });
            });
          };
          class Me extends ue.BaseFilterFactory {
          }
          he.NodeFilterFactory = Me;
          class xe extends ue.BaseCanvasFactory {
            _createCanvas(u, q) {
              return require$$5.createCanvas(u, q);
            }
          }
          he.NodeCanvasFactory = xe;
          class F extends ue.BaseCMapReaderFactory {
            _fetchData(u, q) {
              return me(u).then((e) => ({
                cMapData: e,
                compressionType: q
              }));
            }
          }
          he.NodeCMapReaderFactory = F;
          class ae extends ue.BaseStandardFontDataFactory {
            _fetchData(u) {
              return me(u);
            }
          }
          he.NodeStandardFontDataFactory = ae;
        },
        /* 21 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.PDFNodeStream = void 0;
          var ue = ke(1), me = ke(22);
          const Me = require$$5, xe = require$$5, F = require$$5, ae = require$$5, n = /^file:\/\/\/[a-zA-Z]:\//;
          function u(C) {
            const i = ae.parse(C);
            return i.protocol === "file:" || i.host ? i : /^[a-z]:[/\\]/i.test(C) ? ae.parse(`file:///${C}`) : (i.host || (i.protocol = "file:"), i);
          }
          class q {
            constructor(i) {
              this.source = i, this.url = u(i.url), this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:", this.isFsUrl = this.url.protocol === "file:", this.httpHeaders = this.isHttp && i.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var i;
              return ((i = this._fullRequestReader) == null ? void 0 : i._loaded) ?? 0;
            }
            getFullReader() {
              return (0, ue.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once."), this._fullRequestReader = this.isFsUrl ? new O(this) : new j(this), this._fullRequestReader;
            }
            getRangeReader(i, o) {
              if (o <= this._progressiveDataLength)
                return null;
              const k = this.isFsUrl ? new w(this, i, o) : new M(this, i, o);
              return this._rangeRequestReaders.push(k), k;
            }
            cancelAllRequests(i) {
              var o;
              (o = this._fullRequestReader) == null || o.cancel(i);
              for (const k of this._rangeRequestReaders.slice(0))
                k.cancel(i);
            }
          }
          he.PDFNodeStream = q;
          class e {
            constructor(i) {
              this._url = i.url, this._done = !1, this._storedError = null, this.onProgress = null;
              const o = i.source;
              this._contentLength = o.length, this._loaded = 0, this._filename = null, this._disableRange = o.disableRange || !1, this._rangeChunkSize = o.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !o.disableStream, this._isRangeSupported = !o.disableRange, this._readableStream = null, this._readCapability = new ue.PromiseCapability(), this._headersCapability = new ue.PromiseCapability();
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var k;
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const i = this._readableStream.read();
              return i === null ? (this._readCapability = new ue.PromiseCapability(), this.read()) : (this._loaded += i.length, (k = this.onProgress) == null || k.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: new Uint8Array(i).buffer,
                done: !1
              });
            }
            cancel(i) {
              if (!this._readableStream) {
                this._error(i);
                return;
              }
              this._readableStream.destroy(i);
            }
            _error(i) {
              this._storedError = i, this._readCapability.resolve();
            }
            _setReadableStream(i) {
              this._readableStream = i, i.on("readable", () => {
                this._readCapability.resolve();
              }), i.on("end", () => {
                i.destroy(), this._done = !0, this._readCapability.resolve();
              }), i.on("error", (o) => {
                this._error(o);
              }), !this._isStreamingSupported && this._isRangeSupported && this._error(new ue.AbortException("streaming is disabled")), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          class t {
            constructor(i) {
              this._url = i.url, this._done = !1, this._storedError = null, this.onProgress = null, this._loaded = 0, this._readableStream = null, this._readCapability = new ue.PromiseCapability();
              const o = i.source;
              this._isStreamingSupported = !o.disableStream;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var k;
              if (await this._readCapability.promise, this._done)
                return {
                  value: void 0,
                  done: !0
                };
              if (this._storedError)
                throw this._storedError;
              const i = this._readableStream.read();
              return i === null ? (this._readCapability = new ue.PromiseCapability(), this.read()) : (this._loaded += i.length, (k = this.onProgress) == null || k.call(this, {
                loaded: this._loaded
              }), {
                value: new Uint8Array(i).buffer,
                done: !1
              });
            }
            cancel(i) {
              if (!this._readableStream) {
                this._error(i);
                return;
              }
              this._readableStream.destroy(i);
            }
            _error(i) {
              this._storedError = i, this._readCapability.resolve();
            }
            _setReadableStream(i) {
              this._readableStream = i, i.on("readable", () => {
                this._readCapability.resolve();
              }), i.on("end", () => {
                i.destroy(), this._done = !0, this._readCapability.resolve();
              }), i.on("error", (o) => {
                this._error(o);
              }), this._storedError && this._readableStream.destroy(this._storedError);
            }
          }
          function B(C, i) {
            return {
              protocol: C.protocol,
              auth: C.auth,
              host: C.hostname,
              port: C.port,
              path: C.path,
              method: "GET",
              headers: i
            };
          }
          class j extends e {
            constructor(i) {
              super(i);
              const o = (k) => {
                if (k.statusCode === 404) {
                  const v = new ue.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = v, this._headersCapability.reject(v);
                  return;
                }
                this._headersCapability.resolve(), this._setReadableStream(k);
                const s = (v) => this._readableStream.headers[v.toLowerCase()], {
                  allowRangeRequests: l,
                  suggestedLength: g
                } = (0, me.validateRangeRequestCapabilities)({
                  getResponseHeader: s,
                  isHttp: i.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = l, this._contentLength = g || this._contentLength, this._filename = (0, me.extractFilenameFromHeader)(s);
              };
              this._request = null, this._url.protocol === "http:" ? this._request = xe.request(B(this._url, i.httpHeaders), o) : this._request = F.request(B(this._url, i.httpHeaders), o), this._request.on("error", (k) => {
                this._storedError = k, this._headersCapability.reject(k);
              }), this._request.end();
            }
          }
          class M extends t {
            constructor(i, o, k) {
              super(i), this._httpHeaders = {};
              for (const l in i.httpHeaders) {
                const g = i.httpHeaders[l];
                g !== void 0 && (this._httpHeaders[l] = g);
              }
              this._httpHeaders.Range = `bytes=${o}-${k - 1}`;
              const s = (l) => {
                if (l.statusCode === 404) {
                  const g = new ue.MissingPDFException(`Missing PDF "${this._url}".`);
                  this._storedError = g;
                  return;
                }
                this._setReadableStream(l);
              };
              this._request = null, this._url.protocol === "http:" ? this._request = xe.request(B(this._url, this._httpHeaders), s) : this._request = F.request(B(this._url, this._httpHeaders), s), this._request.on("error", (l) => {
                this._storedError = l;
              }), this._request.end();
            }
          }
          class O extends e {
            constructor(i) {
              super(i);
              let o = decodeURIComponent(this._url.path);
              n.test(this._url.href) && (o = o.replace(/^\//, "")), Me.lstat(o, (k, s) => {
                if (k) {
                  k.code === "ENOENT" && (k = new ue.MissingPDFException(`Missing PDF "${o}".`)), this._storedError = k, this._headersCapability.reject(k);
                  return;
                }
                this._contentLength = s.size, this._setReadableStream(Me.createReadStream(o)), this._headersCapability.resolve();
              });
            }
          }
          class w extends t {
            constructor(i, o, k) {
              super(i);
              let s = decodeURIComponent(this._url.path);
              n.test(this._url.href) && (s = s.replace(/^\//, "")), this._setReadableStream(Me.createReadStream(s, {
                start: o,
                end: k - 1
              }));
            }
          }
        },
        /* 22 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.createResponseStatusError = ae, he.extractFilenameFromHeader = F, he.validateRangeRequestCapabilities = xe, he.validateResponseStatus = n;
          var ue = ke(1), me = ke(23), Me = ke(6);
          function xe({
            getResponseHeader: u,
            isHttp: q,
            rangeChunkSize: e,
            disableRange: t
          }) {
            const B = {
              allowRangeRequests: !1,
              suggestedLength: void 0
            }, j = parseInt(u("Content-Length"), 10);
            return !Number.isInteger(j) || (B.suggestedLength = j, j <= 2 * e) || t || !q || u("Accept-Ranges") !== "bytes" || (u("Content-Encoding") || "identity") !== "identity" || (B.allowRangeRequests = !0), B;
          }
          function F(u) {
            const q = u("Content-Disposition");
            if (q) {
              let e = (0, me.getFilenameFromContentDispositionHeader)(q);
              if (e.includes("%"))
                try {
                  e = decodeURIComponent(e);
                } catch {
                }
              if ((0, Me.isPdfFile)(e))
                return e;
            }
            return null;
          }
          function ae(u, q) {
            return u === 404 || u === 0 && q.startsWith("file:") ? new ue.MissingPDFException('Missing PDF "' + q + '".') : new ue.UnexpectedResponseException(`Unexpected server response (${u}) while retrieving PDF "${q}".`, u);
          }
          function n(u) {
            return u === 200 || u === 206;
          }
        },
        /* 23 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.getFilenameFromContentDispositionHeader = me;
          var ue = ke(1);
          function me(Me) {
            let xe = !0, F = ae("filename\\*", "i").exec(Me);
            if (F) {
              F = F[1];
              let j = e(F);
              return j = unescape(j), j = t(j), j = B(j), u(j);
            }
            if (F = q(Me), F) {
              const j = B(F);
              return u(j);
            }
            if (F = ae("filename", "i").exec(Me), F) {
              F = F[1];
              let j = e(F);
              return j = B(j), u(j);
            }
            function ae(j, M) {
              return new RegExp("(?:^|;)\\s*" + j + '\\s*=\\s*([^";\\s][^;\\s]*|"(?:[^"\\\\]|\\\\"?)+"?)', M);
            }
            function n(j, M) {
              if (j) {
                if (!/^[\x00-\xFF]+$/.test(M))
                  return M;
                try {
                  const O = new TextDecoder(j, {
                    fatal: !0
                  }), w = (0, ue.stringToBytes)(M);
                  M = O.decode(w), xe = !1;
                } catch {
                }
              }
              return M;
            }
            function u(j) {
              return xe && /[\x80-\xff]/.test(j) && (j = n("utf-8", j), xe && (j = n("iso-8859-1", j))), j;
            }
            function q(j) {
              const M = [];
              let O;
              const w = ae("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
              for (; (O = w.exec(j)) !== null; ) {
                let [, i, o, k] = O;
                if (i = parseInt(i, 10), i in M) {
                  if (i === 0)
                    break;
                  continue;
                }
                M[i] = [o, k];
              }
              const C = [];
              for (let i = 0; i < M.length && i in M; ++i) {
                let [o, k] = M[i];
                k = e(k), o && (k = unescape(k), i === 0 && (k = t(k))), C.push(k);
              }
              return C.join("");
            }
            function e(j) {
              if (j.startsWith('"')) {
                const M = j.slice(1).split('\\"');
                for (let O = 0; O < M.length; ++O) {
                  const w = M[O].indexOf('"');
                  w !== -1 && (M[O] = M[O].slice(0, w), M.length = O + 1), M[O] = M[O].replaceAll(/\\(.)/g, "$1");
                }
                j = M.join('"');
              }
              return j;
            }
            function t(j) {
              const M = j.indexOf("'");
              if (M === -1)
                return j;
              const O = j.slice(0, M), C = j.slice(M + 1).replace(/^[^']*'/, "");
              return n(O, C);
            }
            function B(j) {
              return !j.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(j) ? j : j.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(M, O, w, C) {
                if (w === "q" || w === "Q")
                  return C = C.replaceAll("_", " "), C = C.replaceAll(/=([0-9a-fA-F]{2})/g, function(i, o) {
                    return String.fromCharCode(parseInt(o, 16));
                  }), n(O, C);
                try {
                  C = atob(C);
                } catch {
                }
                return n(O, C);
              });
            }
            return "";
          }
        },
        /* 24 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.PDFNetworkStream = void 0;
          var ue = ke(1), me = ke(22);
          const Me = 200, xe = 206;
          function F(e) {
            const t = e.response;
            return typeof t != "string" ? t : (0, ue.stringToBytes)(t).buffer;
          }
          class ae {
            constructor(t, B = {}) {
              this.url = t, this.isHttp = /^https?:/i.test(t), this.httpHeaders = this.isHttp && B.httpHeaders || /* @__PURE__ */ Object.create(null), this.withCredentials = B.withCredentials || !1, this.currXhrId = 0, this.pendingRequests = /* @__PURE__ */ Object.create(null);
            }
            requestRange(t, B, j) {
              const M = {
                begin: t,
                end: B
              };
              for (const O in j)
                M[O] = j[O];
              return this.request(M);
            }
            requestFull(t) {
              return this.request(t);
            }
            request(t) {
              const B = new XMLHttpRequest(), j = this.currXhrId++, M = this.pendingRequests[j] = {
                xhr: B
              };
              B.open("GET", this.url), B.withCredentials = this.withCredentials;
              for (const O in this.httpHeaders) {
                const w = this.httpHeaders[O];
                w !== void 0 && B.setRequestHeader(O, w);
              }
              return this.isHttp && "begin" in t && "end" in t ? (B.setRequestHeader("Range", `bytes=${t.begin}-${t.end - 1}`), M.expectedStatus = xe) : M.expectedStatus = Me, B.responseType = "arraybuffer", t.onError && (B.onerror = function(O) {
                t.onError(B.status);
              }), B.onreadystatechange = this.onStateChange.bind(this, j), B.onprogress = this.onProgress.bind(this, j), M.onHeadersReceived = t.onHeadersReceived, M.onDone = t.onDone, M.onError = t.onError, M.onProgress = t.onProgress, B.send(null), j;
            }
            onProgress(t, B) {
              var M;
              const j = this.pendingRequests[t];
              j && ((M = j.onProgress) == null || M.call(j, B));
            }
            onStateChange(t, B) {
              var i, o, k;
              const j = this.pendingRequests[t];
              if (!j)
                return;
              const M = j.xhr;
              if (M.readyState >= 2 && j.onHeadersReceived && (j.onHeadersReceived(), delete j.onHeadersReceived), M.readyState !== 4 || !(t in this.pendingRequests))
                return;
              if (delete this.pendingRequests[t], M.status === 0 && this.isHttp) {
                (i = j.onError) == null || i.call(j, M.status);
                return;
              }
              const O = M.status || Me;
              if (!(O === Me && j.expectedStatus === xe) && O !== j.expectedStatus) {
                (o = j.onError) == null || o.call(j, M.status);
                return;
              }
              const C = F(M);
              if (O === xe) {
                const s = M.getResponseHeader("Content-Range"), l = /bytes (\d+)-(\d+)\/(\d+)/.exec(s);
                j.onDone({
                  begin: parseInt(l[1], 10),
                  chunk: C
                });
              } else
                C ? j.onDone({
                  begin: 0,
                  chunk: C
                }) : (k = j.onError) == null || k.call(j, M.status);
            }
            getRequestXhr(t) {
              return this.pendingRequests[t].xhr;
            }
            isPendingRequest(t) {
              return t in this.pendingRequests;
            }
            abortRequest(t) {
              const B = this.pendingRequests[t].xhr;
              delete this.pendingRequests[t], B.abort();
            }
          }
          class n {
            constructor(t) {
              this._source = t, this._manager = new ae(t.url, {
                httpHeaders: t.httpHeaders,
                withCredentials: t.withCredentials
              }), this._rangeChunkSize = t.rangeChunkSize, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            _onRangeRequestReaderClosed(t) {
              const B = this._rangeRequestReaders.indexOf(t);
              B >= 0 && this._rangeRequestReaders.splice(B, 1);
            }
            getFullReader() {
              return (0, ue.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once."), this._fullRequestReader = new u(this._manager, this._source), this._fullRequestReader;
            }
            getRangeReader(t, B) {
              const j = new q(this._manager, t, B);
              return j.onClosed = this._onRangeRequestReaderClosed.bind(this), this._rangeRequestReaders.push(j), j;
            }
            cancelAllRequests(t) {
              var B;
              (B = this._fullRequestReader) == null || B.cancel(t);
              for (const j of this._rangeRequestReaders.slice(0))
                j.cancel(t);
            }
          }
          he.PDFNetworkStream = n;
          class u {
            constructor(t, B) {
              this._manager = t;
              const j = {
                onHeadersReceived: this._onHeadersReceived.bind(this),
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = B.url, this._fullRequestId = t.requestFull(j), this._headersReceivedCapability = new ue.PromiseCapability(), this._disableRange = B.disableRange || !1, this._contentLength = B.length, this._rangeChunkSize = B.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._isStreamingSupported = !1, this._isRangeSupported = !1, this._cachedChunks = [], this._requests = [], this._done = !1, this._storedError = void 0, this._filename = null, this.onProgress = null;
            }
            _onHeadersReceived() {
              const t = this._fullRequestId, B = this._manager.getRequestXhr(t), j = (w) => B.getResponseHeader(w), {
                allowRangeRequests: M,
                suggestedLength: O
              } = (0, me.validateRangeRequestCapabilities)({
                getResponseHeader: j,
                isHttp: this._manager.isHttp,
                rangeChunkSize: this._rangeChunkSize,
                disableRange: this._disableRange
              });
              M && (this._isRangeSupported = !0), this._contentLength = O || this._contentLength, this._filename = (0, me.extractFilenameFromHeader)(j), this._isRangeSupported && this._manager.abortRequest(t), this._headersReceivedCapability.resolve();
            }
            _onDone(t) {
              if (t && (this._requests.length > 0 ? this._requests.shift().resolve({
                value: t.chunk,
                done: !1
              }) : this._cachedChunks.push(t.chunk)), this._done = !0, !(this._cachedChunks.length > 0)) {
                for (const B of this._requests)
                  B.resolve({
                    value: void 0,
                    done: !0
                  });
                this._requests.length = 0;
              }
            }
            _onError(t) {
              this._storedError = (0, me.createResponseStatusError)(t, this._url), this._headersReceivedCapability.reject(this._storedError);
              for (const B of this._requests)
                B.reject(this._storedError);
              this._requests.length = 0, this._cachedChunks.length = 0;
            }
            _onProgress(t) {
              var B;
              (B = this.onProgress) == null || B.call(this, {
                loaded: t.loaded,
                total: t.lengthComputable ? t.total : this._contentLength
              });
            }
            get filename() {
              return this._filename;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            get contentLength() {
              return this._contentLength;
            }
            get headersReady() {
              return this._headersReceivedCapability.promise;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._cachedChunks.length > 0)
                return {
                  value: this._cachedChunks.shift(),
                  done: !1
                };
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const t = new ue.PromiseCapability();
              return this._requests.push(t), t.promise;
            }
            cancel(t) {
              this._done = !0, this._headersReceivedCapability.reject(t);
              for (const B of this._requests)
                B.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._manager.isPendingRequest(this._fullRequestId) && this._manager.abortRequest(this._fullRequestId), this._fullRequestReader = null;
            }
          }
          class q {
            constructor(t, B, j) {
              this._manager = t;
              const M = {
                onDone: this._onDone.bind(this),
                onError: this._onError.bind(this),
                onProgress: this._onProgress.bind(this)
              };
              this._url = t.url, this._requestId = t.requestRange(B, j, M), this._requests = [], this._queuedChunk = null, this._done = !1, this._storedError = void 0, this.onProgress = null, this.onClosed = null;
            }
            _close() {
              var t;
              (t = this.onClosed) == null || t.call(this, this);
            }
            _onDone(t) {
              const B = t.chunk;
              this._requests.length > 0 ? this._requests.shift().resolve({
                value: B,
                done: !1
              }) : this._queuedChunk = B, this._done = !0;
              for (const j of this._requests)
                j.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._close();
            }
            _onError(t) {
              this._storedError = (0, me.createResponseStatusError)(t, this._url);
              for (const B of this._requests)
                B.reject(this._storedError);
              this._requests.length = 0, this._queuedChunk = null;
            }
            _onProgress(t) {
              var B;
              this.isStreamingSupported || (B = this.onProgress) == null || B.call(this, {
                loaded: t.loaded
              });
            }
            get isStreamingSupported() {
              return !1;
            }
            async read() {
              if (this._storedError)
                throw this._storedError;
              if (this._queuedChunk !== null) {
                const B = this._queuedChunk;
                return this._queuedChunk = null, {
                  value: B,
                  done: !1
                };
              }
              if (this._done)
                return {
                  value: void 0,
                  done: !0
                };
              const t = new ue.PromiseCapability();
              return this._requests.push(t), t.promise;
            }
            cancel(t) {
              this._done = !0;
              for (const B of this._requests)
                B.resolve({
                  value: void 0,
                  done: !0
                });
              this._requests.length = 0, this._manager.isPendingRequest(this._requestId) && this._manager.abortRequest(this._requestId), this._close();
            }
          }
        },
        /* 25 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.PDFFetchStream = void 0;
          var ue = ke(1), me = ke(22);
          function Me(q, e, t) {
            return {
              method: "GET",
              headers: q,
              signal: t.signal,
              mode: "cors",
              credentials: e ? "include" : "same-origin",
              redirect: "follow"
            };
          }
          function xe(q) {
            const e = new Headers();
            for (const t in q) {
              const B = q[t];
              B !== void 0 && e.append(t, B);
            }
            return e;
          }
          function F(q) {
            return q instanceof Uint8Array ? q.buffer : q instanceof ArrayBuffer ? q : ((0, ue.warn)(`getArrayBuffer - unexpected data format: ${q}`), new Uint8Array(q).buffer);
          }
          class ae {
            constructor(e) {
              this.source = e, this.isHttp = /^https?:/i.test(e.url), this.httpHeaders = this.isHttp && e.httpHeaders || {}, this._fullRequestReader = null, this._rangeRequestReaders = [];
            }
            get _progressiveDataLength() {
              var e;
              return ((e = this._fullRequestReader) == null ? void 0 : e._loaded) ?? 0;
            }
            getFullReader() {
              return (0, ue.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once."), this._fullRequestReader = new n(this), this._fullRequestReader;
            }
            getRangeReader(e, t) {
              if (t <= this._progressiveDataLength)
                return null;
              const B = new u(this, e, t);
              return this._rangeRequestReaders.push(B), B;
            }
            cancelAllRequests(e) {
              var t;
              (t = this._fullRequestReader) == null || t.cancel(e);
              for (const B of this._rangeRequestReaders.slice(0))
                B.cancel(e);
            }
          }
          he.PDFFetchStream = ae;
          class n {
            constructor(e) {
              this._stream = e, this._reader = null, this._loaded = 0, this._filename = null;
              const t = e.source;
              this._withCredentials = t.withCredentials || !1, this._contentLength = t.length, this._headersCapability = new ue.PromiseCapability(), this._disableRange = t.disableRange || !1, this._rangeChunkSize = t.rangeChunkSize, !this._rangeChunkSize && !this._disableRange && (this._disableRange = !0), this._abortController = new AbortController(), this._isStreamingSupported = !t.disableStream, this._isRangeSupported = !t.disableRange, this._headers = xe(this._stream.httpHeaders);
              const B = t.url;
              fetch(B, Me(this._headers, this._withCredentials, this._abortController)).then((j) => {
                if (!(0, me.validateResponseStatus)(j.status))
                  throw (0, me.createResponseStatusError)(j.status, B);
                this._reader = j.body.getReader(), this._headersCapability.resolve();
                const M = (C) => j.headers.get(C), {
                  allowRangeRequests: O,
                  suggestedLength: w
                } = (0, me.validateRangeRequestCapabilities)({
                  getResponseHeader: M,
                  isHttp: this._stream.isHttp,
                  rangeChunkSize: this._rangeChunkSize,
                  disableRange: this._disableRange
                });
                this._isRangeSupported = O, this._contentLength = w || this._contentLength, this._filename = (0, me.extractFilenameFromHeader)(M), !this._isStreamingSupported && this._isRangeSupported && this.cancel(new ue.AbortException("Streaming is disabled."));
              }).catch(this._headersCapability.reject), this.onProgress = null;
            }
            get headersReady() {
              return this._headersCapability.promise;
            }
            get filename() {
              return this._filename;
            }
            get contentLength() {
              return this._contentLength;
            }
            get isRangeSupported() {
              return this._isRangeSupported;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var B;
              await this._headersCapability.promise;
              const {
                value: e,
                done: t
              } = await this._reader.read();
              return t ? {
                value: e,
                done: t
              } : (this._loaded += e.byteLength, (B = this.onProgress) == null || B.call(this, {
                loaded: this._loaded,
                total: this._contentLength
              }), {
                value: F(e),
                done: !1
              });
            }
            cancel(e) {
              var t;
              (t = this._reader) == null || t.cancel(e), this._abortController.abort();
            }
          }
          class u {
            constructor(e, t, B) {
              this._stream = e, this._reader = null, this._loaded = 0;
              const j = e.source;
              this._withCredentials = j.withCredentials || !1, this._readCapability = new ue.PromiseCapability(), this._isStreamingSupported = !j.disableStream, this._abortController = new AbortController(), this._headers = xe(this._stream.httpHeaders), this._headers.append("Range", `bytes=${t}-${B - 1}`);
              const M = j.url;
              fetch(M, Me(this._headers, this._withCredentials, this._abortController)).then((O) => {
                if (!(0, me.validateResponseStatus)(O.status))
                  throw (0, me.createResponseStatusError)(O.status, M);
                this._readCapability.resolve(), this._reader = O.body.getReader();
              }).catch(this._readCapability.reject), this.onProgress = null;
            }
            get isStreamingSupported() {
              return this._isStreamingSupported;
            }
            async read() {
              var B;
              await this._readCapability.promise;
              const {
                value: e,
                done: t
              } = await this._reader.read();
              return t ? {
                value: e,
                done: t
              } : (this._loaded += e.byteLength, (B = this.onProgress) == null || B.call(this, {
                loaded: this._loaded
              }), {
                value: F(e),
                done: !1
              });
            }
            cancel(e) {
              var t;
              (t = this._reader) == null || t.cancel(e), this._abortController.abort();
            }
          }
        },
        /* 26 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.TextLayerRenderTask = void 0, he.renderTextLayer = j, he.updateTextLayer = M;
          var ue = ke(1), me = ke(6);
          const Me = 1e5, xe = 30, F = 0.8, ae = /* @__PURE__ */ new Map();
          function n(O, w) {
            let C;
            if (w && ue.FeatureTest.isOffscreenCanvasSupported)
              C = new OffscreenCanvas(O, O).getContext("2d", {
                alpha: !1
              });
            else {
              const i = document.createElement("canvas");
              i.width = i.height = O, C = i.getContext("2d", {
                alpha: !1
              });
            }
            return C;
          }
          function u(O, w) {
            const C = ae.get(O);
            if (C)
              return C;
            const i = n(xe, w);
            i.font = `${xe}px ${O}`;
            const o = i.measureText("");
            let k = o.fontBoundingBoxAscent, s = Math.abs(o.fontBoundingBoxDescent);
            if (k) {
              const g = k / (k + s);
              return ae.set(O, g), i.canvas.width = i.canvas.height = 0, g;
            }
            i.strokeStyle = "red", i.clearRect(0, 0, xe, xe), i.strokeText("g", 0, 0);
            let l = i.getImageData(0, 0, xe, xe).data;
            s = 0;
            for (let g = l.length - 1 - 3; g >= 0; g -= 4)
              if (l[g] > 0) {
                s = Math.ceil(g / 4 / xe);
                break;
              }
            i.clearRect(0, 0, xe, xe), i.strokeText("A", 0, xe), l = i.getImageData(0, 0, xe, xe).data, k = 0;
            for (let g = 0, v = l.length; g < v; g += 4)
              if (l[g] > 0) {
                k = xe - Math.floor(g / 4 / xe);
                break;
              }
            if (i.canvas.width = i.canvas.height = 0, k) {
              const g = k / (k + s);
              return ae.set(O, g), g;
            }
            return ae.set(O, F), F;
          }
          function q(O, w, C) {
            const i = document.createElement("span"), o = {
              angle: 0,
              canvasWidth: 0,
              hasText: w.str !== "",
              hasEOL: w.hasEOL,
              fontSize: 0
            };
            O._textDivs.push(i);
            const k = ue.Util.transform(O._transform, w.transform);
            let s = Math.atan2(k[1], k[0]);
            const l = C[w.fontName];
            l.vertical && (s += Math.PI / 2);
            const g = Math.hypot(k[2], k[3]), v = g * u(l.fontFamily, O._isOffscreenCanvasSupported);
            let r, x;
            s === 0 ? (r = k[4], x = k[5] - v) : (r = k[4] + v * Math.sin(s), x = k[5] - v * Math.cos(s));
            const b = "calc(var(--scale-factor)*", I = i.style;
            O._container === O._rootContainer ? (I.left = `${(100 * r / O._pageWidth).toFixed(2)}%`, I.top = `${(100 * x / O._pageHeight).toFixed(2)}%`) : (I.left = `${b}${r.toFixed(2)}px)`, I.top = `${b}${x.toFixed(2)}px)`), I.fontSize = `${b}${g.toFixed(2)}px)`, I.fontFamily = l.fontFamily, o.fontSize = g, i.setAttribute("role", "presentation"), i.textContent = w.str, i.dir = w.dir, O._fontInspectorEnabled && (i.dataset.fontName = w.fontName), s !== 0 && (o.angle = s * (180 / Math.PI));
            let h = !1;
            if (w.str.length > 1)
              h = !0;
            else if (w.str !== " " && w.transform[0] !== w.transform[3]) {
              const y = Math.abs(w.transform[0]), P = Math.abs(w.transform[3]);
              y !== P && Math.max(y, P) / Math.min(y, P) > 1.5 && (h = !0);
            }
            h && (o.canvasWidth = l.vertical ? w.height : w.width), O._textDivProperties.set(i, o), O._isReadableStream && O._layoutText(i);
          }
          function e(O) {
            const {
              div: w,
              scale: C,
              properties: i,
              ctx: o,
              prevFontSize: k,
              prevFontFamily: s
            } = O, {
              style: l
            } = w;
            let g = "";
            if (i.canvasWidth !== 0 && i.hasText) {
              const {
                fontFamily: v
              } = l, {
                canvasWidth: r,
                fontSize: x
              } = i;
              (k !== x || s !== v) && (o.font = `${x * C}px ${v}`, O.prevFontSize = x, O.prevFontFamily = v);
              const {
                width: b
              } = o.measureText(w.textContent);
              b > 0 && (g = `scaleX(${r * C / b})`);
            }
            i.angle !== 0 && (g = `rotate(${i.angle}deg) ${g}`), g.length > 0 && (l.transform = g);
          }
          function t(O) {
            if (O._canceled)
              return;
            const w = O._textDivs, C = O._capability;
            if (w.length > Me) {
              C.resolve();
              return;
            }
            if (!O._isReadableStream)
              for (const o of w)
                O._layoutText(o);
            C.resolve();
          }
          class B {
            constructor({
              textContentSource: w,
              container: C,
              viewport: i,
              textDivs: o,
              textDivProperties: k,
              textContentItemsStr: s,
              isOffscreenCanvasSupported: l
            }) {
              var b;
              this._textContentSource = w, this._isReadableStream = w instanceof ReadableStream, this._container = this._rootContainer = C, this._textDivs = o || [], this._textContentItemsStr = s || [], this._isOffscreenCanvasSupported = l, this._fontInspectorEnabled = !!((b = globalThis.FontInspector) != null && b.enabled), this._reader = null, this._textDivProperties = k || /* @__PURE__ */ new WeakMap(), this._canceled = !1, this._capability = new ue.PromiseCapability(), this._layoutTextParams = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                scale: i.scale * (globalThis.devicePixelRatio || 1),
                properties: null,
                ctx: n(0, l)
              };
              const {
                pageWidth: g,
                pageHeight: v,
                pageX: r,
                pageY: x
              } = i.rawDims;
              this._transform = [1, 0, 0, -1, -r, x + v], this._pageWidth = g, this._pageHeight = v, (0, me.setLayerDimensions)(C, i), this._capability.promise.finally(() => {
                this._layoutTextParams = null;
              }).catch(() => {
              });
            }
            get promise() {
              return this._capability.promise;
            }
            cancel() {
              this._canceled = !0, this._reader && (this._reader.cancel(new ue.AbortException("TextLayer task cancelled.")).catch(() => {
              }), this._reader = null), this._capability.reject(new ue.AbortException("TextLayer task cancelled."));
            }
            _processItems(w, C) {
              for (const i of w) {
                if (i.str === void 0) {
                  if (i.type === "beginMarkedContentProps" || i.type === "beginMarkedContent") {
                    const o = this._container;
                    this._container = document.createElement("span"), this._container.classList.add("markedContent"), i.id !== null && this._container.setAttribute("id", `${i.id}`), o.append(this._container);
                  } else
                    i.type === "endMarkedContent" && (this._container = this._container.parentNode);
                  continue;
                }
                this._textContentItemsStr.push(i.str), q(this, i, C);
              }
            }
            _layoutText(w) {
              const C = this._layoutTextParams.properties = this._textDivProperties.get(w);
              if (this._layoutTextParams.div = w, e(this._layoutTextParams), C.hasText && this._container.append(w), C.hasEOL) {
                const i = document.createElement("br");
                i.setAttribute("role", "presentation"), this._container.append(i);
              }
            }
            _render() {
              const w = new ue.PromiseCapability();
              let C = /* @__PURE__ */ Object.create(null);
              if (this._isReadableStream) {
                const i = () => {
                  this._reader.read().then(({
                    value: o,
                    done: k
                  }) => {
                    if (k) {
                      w.resolve();
                      return;
                    }
                    Object.assign(C, o.styles), this._processItems(o.items, C), i();
                  }, w.reject);
                };
                this._reader = this._textContentSource.getReader(), i();
              } else if (this._textContentSource) {
                const {
                  items: i,
                  styles: o
                } = this._textContentSource;
                this._processItems(i, o), w.resolve();
              } else
                throw new Error('No "textContentSource" parameter specified.');
              w.promise.then(() => {
                C = null, t(this);
              }, this._capability.reject);
            }
          }
          he.TextLayerRenderTask = B;
          function j(O) {
            !O.textContentSource && (O.textContent || O.textContentStream) && ((0, me.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead."), O.textContentSource = O.textContent || O.textContentStream);
            const {
              container: w,
              viewport: C
            } = O, i = getComputedStyle(w), o = i.getPropertyValue("visibility"), k = parseFloat(i.getPropertyValue("--scale-factor"));
            o === "visible" && (!k || Math.abs(k - C.scale) > 1e-5) && console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
            const s = new B(O);
            return s._render(), s;
          }
          function M({
            container: O,
            viewport: w,
            textDivs: C,
            textDivProperties: i,
            isOffscreenCanvasSupported: o,
            mustRotate: k = !0,
            mustRescale: s = !0
          }) {
            if (k && (0, me.setLayerDimensions)(O, {
              rotation: w.rotation
            }), s) {
              const l = n(0, o), v = {
                prevFontSize: null,
                prevFontFamily: null,
                div: null,
                scale: w.scale * (globalThis.devicePixelRatio || 1),
                properties: null,
                ctx: l
              };
              for (const r of C)
                v.properties = i.get(r), v.div = r, e(v);
            }
          }
        },
        /* 27 */
        /***/
        (Se, he, ke) => {
          var n, u, q, e, t, B, j, M, O, ni, C, ki, o, ii, s, ai;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.AnnotationEditorLayer = void 0;
          var ue = ke(1), me = ke(5), Me = ke(28), xe = ke(29), F = ke(6);
          const g = class g {
            constructor(r) {
              Be(this, O);
              Be(this, C);
              Be(this, o);
              Be(this, s);
              Be(this, n, void 0);
              Be(this, u, !1);
              Be(this, q, this.pointerup.bind(this));
              Be(this, e, this.pointerdown.bind(this));
              Be(this, t, /* @__PURE__ */ new Map());
              Be(this, B, !1);
              Be(this, j, !1);
              Be(this, M, void 0);
              g._initialized || (g._initialized = !0, Me.FreeTextEditor.initialize(r.l10n), xe.InkEditor.initialize(r.l10n)), r.uiManager.registerEditorTypes([Me.FreeTextEditor, xe.InkEditor]), rt(this, M, r.uiManager), this.pageIndex = r.pageIndex, this.div = r.div, rt(this, n, r.accessibilityManager), ge(this, M).addLayer(this);
            }
            get isEmpty() {
              return ge(this, t).size === 0;
            }
            updateToolbar(r) {
              ge(this, M).updateToolbar(r);
            }
            updateMode(r = ge(this, M).getMode()) {
              ze(this, s, ai).call(this), r === ue.AnnotationEditorType.INK ? (this.addInkEditorIfNeeded(!1), this.disableClick()) : this.enableClick(), ge(this, M).unselectAll(), r !== ue.AnnotationEditorType.NONE && (this.div.classList.toggle("freeTextEditing", r === ue.AnnotationEditorType.FREETEXT), this.div.classList.toggle("inkEditing", r === ue.AnnotationEditorType.INK), this.div.hidden = !1);
            }
            addInkEditorIfNeeded(r) {
              if (!r && ge(this, M).getMode() !== ue.AnnotationEditorType.INK)
                return;
              if (!r) {
                for (const b of ge(this, t).values())
                  if (b.isEmpty()) {
                    b.setInBackground();
                    return;
                  }
              }
              ze(this, o, ii).call(this, {
                offsetX: 0,
                offsetY: 0
              }).setInBackground();
            }
            setEditingState(r) {
              ge(this, M).setEditingState(r);
            }
            addCommands(r) {
              ge(this, M).addCommands(r);
            }
            enable() {
              this.div.style.pointerEvents = "auto";
              for (const r of ge(this, t).values())
                r.enableEditing();
            }
            disable() {
              this.div.style.pointerEvents = "none";
              for (const r of ge(this, t).values())
                r.disableEditing();
              ze(this, s, ai).call(this), this.isEmpty && (this.div.hidden = !0);
            }
            setActiveEditor(r) {
              ge(this, M).getActive() !== r && ge(this, M).setActiveEditor(r);
            }
            enableClick() {
              this.div.addEventListener("pointerdown", ge(this, e)), this.div.addEventListener("pointerup", ge(this, q));
            }
            disableClick() {
              this.div.removeEventListener("pointerdown", ge(this, e)), this.div.removeEventListener("pointerup", ge(this, q));
            }
            attach(r) {
              ge(this, t).set(r.id, r);
            }
            detach(r) {
              var x;
              ge(this, t).delete(r.id), (x = ge(this, n)) == null || x.removePointerInTextLayer(r.contentDiv);
            }
            remove(r) {
              ge(this, M).removeEditor(r), this.detach(r), r.div.style.display = "none", setTimeout(() => {
                r.div.style.display = "", r.div.remove(), r.isAttachedToDOM = !1, document.activeElement === document.body && ge(this, M).focusMainContainer();
              }, 0), ge(this, j) || this.addInkEditorIfNeeded(!1);
            }
            add(r) {
              if (ze(this, O, ni).call(this, r), ge(this, M).addEditor(r), this.attach(r), !r.isAttachedToDOM) {
                const x = r.render();
                this.div.append(x), r.isAttachedToDOM = !0;
              }
              this.moveEditorInDOM(r), r.onceAdded(), ge(this, M).addToAnnotationStorage(r);
            }
            moveEditorInDOM(r) {
              var x;
              (x = ge(this, n)) == null || x.moveElementInDOM(this.div, r.div, r.contentDiv, !0);
            }
            addOrRebuild(r) {
              r.needsToBeRebuilt() ? r.rebuild() : this.add(r);
            }
            addANewEditor(r) {
              const x = () => {
                this.addOrRebuild(r);
              }, b = () => {
                r.remove();
              };
              this.addCommands({
                cmd: x,
                undo: b,
                mustExec: !0
              });
            }
            addUndoableEditor(r) {
              const x = () => {
                this.addOrRebuild(r);
              }, b = () => {
                r.remove();
              };
              this.addCommands({
                cmd: x,
                undo: b,
                mustExec: !1
              });
            }
            getNextId() {
              return ge(this, M).getId();
            }
            deserialize(r) {
              switch (r.annotationType) {
                case ue.AnnotationEditorType.FREETEXT:
                  return Me.FreeTextEditor.deserialize(r, this, ge(this, M));
                case ue.AnnotationEditorType.INK:
                  return xe.InkEditor.deserialize(r, this, ge(this, M));
              }
              return null;
            }
            setSelected(r) {
              ge(this, M).setSelected(r);
            }
            toggleSelected(r) {
              ge(this, M).toggleSelected(r);
            }
            isSelected(r) {
              return ge(this, M).isSelected(r);
            }
            unselect(r) {
              ge(this, M).unselect(r);
            }
            pointerup(r) {
              const {
                isMac: x
              } = ue.FeatureTest.platform;
              if (!(r.button !== 0 || r.ctrlKey && x) && r.target === this.div && ge(this, B)) {
                if (rt(this, B, !1), !ge(this, u)) {
                  rt(this, u, !0);
                  return;
                }
                ze(this, o, ii).call(this, r);
              }
            }
            pointerdown(r) {
              const {
                isMac: x
              } = ue.FeatureTest.platform;
              if (r.button !== 0 || r.ctrlKey && x || r.target !== this.div)
                return;
              rt(this, B, !0);
              const b = ge(this, M).getActive();
              rt(this, u, !b || b.isEmpty());
            }
            drop(r) {
              const x = r.dataTransfer.getData("text/plain"), b = ge(this, M).getEditor(x);
              if (!b)
                return;
              r.preventDefault(), r.dataTransfer.dropEffect = "move", ze(this, O, ni).call(this, b);
              const I = this.div.getBoundingClientRect(), h = r.clientX - I.x, y = r.clientY - I.y;
              b.translate(h - b.startX, y - b.startY), this.moveEditorInDOM(b), b.div.focus();
            }
            dragover(r) {
              r.preventDefault();
            }
            destroy() {
              var r, x;
              ((r = ge(this, M).getActive()) == null ? void 0 : r.parent) === this && ge(this, M).setActiveEditor(null);
              for (const b of ge(this, t).values())
                (x = ge(this, n)) == null || x.removePointerInTextLayer(b.contentDiv), b.setParent(null), b.isAttachedToDOM = !1, b.div.remove();
              this.div = null, ge(this, t).clear(), ge(this, M).removeLayer(this);
            }
            render({
              viewport: r
            }) {
              this.viewport = r, (0, F.setLayerDimensions)(this.div, r), (0, me.bindEvents)(this, this.div, ["dragover", "drop"]);
              for (const x of ge(this, M).getEditors(this.pageIndex))
                this.add(x);
              this.updateMode();
            }
            update({
              viewport: r
            }) {
              ge(this, M).commitOrRemove(), this.viewport = r, (0, F.setLayerDimensions)(this.div, {
                rotation: r.rotation
              }), this.updateMode();
            }
            get pageDimensions() {
              const {
                pageWidth: r,
                pageHeight: x
              } = this.viewport.rawDims;
              return [r, x];
            }
          };
          n = new WeakMap(), u = new WeakMap(), q = new WeakMap(), e = new WeakMap(), t = new WeakMap(), B = new WeakMap(), j = new WeakMap(), M = new WeakMap(), O = new WeakSet(), ni = function(r) {
            var x;
            r.parent !== this && (this.attach(r), (x = r.parent) == null || x.detach(r), r.setParent(this), r.div && r.isAttachedToDOM && (r.div.remove(), this.div.append(r.div)));
          }, C = new WeakSet(), ki = function(r) {
            switch (ge(this, M).getMode()) {
              case ue.AnnotationEditorType.FREETEXT:
                return new Me.FreeTextEditor(r);
              case ue.AnnotationEditorType.INK:
                return new xe.InkEditor(r);
            }
            return null;
          }, o = new WeakSet(), ii = function(r) {
            const x = this.getNextId(), b = ze(this, C, ki).call(this, {
              parent: this,
              id: x,
              x: r.offsetX,
              y: r.offsetY,
              uiManager: ge(this, M)
            });
            return b && this.add(b), b;
          }, s = new WeakSet(), ai = function() {
            rt(this, j, !0);
            for (const r of ge(this, t).values())
              r.isEmpty() && r.remove();
            rt(this, j, !1);
          }, Dt(g, "_initialized", !1);
          let ae = g;
          he.AnnotationEditorLayer = ae;
        },
        /* 28 */
        /***/
        (Se, he, ke) => {
          var F, ae, n, u, q, e, t, B, j, M, Fi, w, Ti, i, Ei, k, si;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.FreeTextEditor = void 0;
          var ue = ke(1), me = ke(5), Me = ke(4);
          const l = class l extends Me.AnnotationEditor {
            constructor(r) {
              super({
                ...r,
                name: "freeTextEditor"
              });
              Be(this, M);
              Be(this, w);
              Be(this, i);
              Be(this, k);
              Be(this, F, this.editorDivBlur.bind(this));
              Be(this, ae, this.editorDivFocus.bind(this));
              Be(this, n, this.editorDivInput.bind(this));
              Be(this, u, this.editorDivKeydown.bind(this));
              Be(this, q, void 0);
              Be(this, e, "");
              Be(this, t, `${this.id}-editor`);
              Be(this, B, !1);
              Be(this, j, void 0);
              rt(this, q, r.color || l._defaultColor || Me.AnnotationEditor._defaultLineColor), rt(this, j, r.fontSize || l._defaultFontSize);
            }
            static initialize(r) {
              this._l10nPromise = new Map(["free_text2_default_content", "editor_free_text2_aria_label"].map((b) => [b, r.get(b)]));
              const x = getComputedStyle(document.documentElement);
              this._internalPadding = parseFloat(x.getPropertyValue("--freetext-padding"));
            }
            static updateDefaultParams(r, x) {
              switch (r) {
                case ue.AnnotationEditorParamsType.FREETEXT_SIZE:
                  l._defaultFontSize = x;
                  break;
                case ue.AnnotationEditorParamsType.FREETEXT_COLOR:
                  l._defaultColor = x;
                  break;
              }
            }
            updateParams(r, x) {
              switch (r) {
                case ue.AnnotationEditorParamsType.FREETEXT_SIZE:
                  ze(this, M, Fi).call(this, x);
                  break;
                case ue.AnnotationEditorParamsType.FREETEXT_COLOR:
                  ze(this, w, Ti).call(this, x);
                  break;
              }
            }
            static get defaultPropertiesToUpdate() {
              return [[ue.AnnotationEditorParamsType.FREETEXT_SIZE, l._defaultFontSize], [ue.AnnotationEditorParamsType.FREETEXT_COLOR, l._defaultColor || Me.AnnotationEditor._defaultLineColor]];
            }
            get propertiesToUpdate() {
              return [[ue.AnnotationEditorParamsType.FREETEXT_SIZE, ge(this, j)], [ue.AnnotationEditorParamsType.FREETEXT_COLOR, ge(this, q)]];
            }
            getInitialTranslation() {
              const r = this.parentScale;
              return [-l._internalPadding * r, -(l._internalPadding + ge(this, j)) * r];
            }
            rebuild() {
              super.rebuild(), this.div !== null && (this.isAttachedToDOM || this.parent.add(this));
            }
            enableEditMode() {
              this.isInEditMode() || (this.parent.setEditingState(!1), this.parent.updateToolbar(ue.AnnotationEditorType.FREETEXT), super.enableEditMode(), this.overlayDiv.classList.remove("enabled"), this.editorDiv.contentEditable = !0, this.div.draggable = !1, this.div.removeAttribute("aria-activedescendant"), this.editorDiv.addEventListener("keydown", ge(this, u)), this.editorDiv.addEventListener("focus", ge(this, ae)), this.editorDiv.addEventListener("blur", ge(this, F)), this.editorDiv.addEventListener("input", ge(this, n)));
            }
            disableEditMode() {
              this.isInEditMode() && (this.parent.setEditingState(!0), super.disableEditMode(), this.overlayDiv.classList.add("enabled"), this.editorDiv.contentEditable = !1, this.div.setAttribute("aria-activedescendant", ge(this, t)), this.div.draggable = !0, this.editorDiv.removeEventListener("keydown", ge(this, u)), this.editorDiv.removeEventListener("focus", ge(this, ae)), this.editorDiv.removeEventListener("blur", ge(this, F)), this.editorDiv.removeEventListener("input", ge(this, n)), this.div.focus({
                preventScroll: !0
              }), this.isEditing = !1, this.parent.div.classList.add("freeTextEditing"));
            }
            focusin(r) {
              super.focusin(r), r.target !== this.editorDiv && this.editorDiv.focus();
            }
            onceAdded() {
              this.width || (this.enableEditMode(), this.editorDiv.focus());
            }
            isEmpty() {
              return !this.editorDiv || this.editorDiv.innerText.trim() === "";
            }
            remove() {
              this.isEditing = !1, this.parent.setEditingState(!0), this.parent.div.classList.add("freeTextEditing"), super.remove();
            }
            commit() {
              this.isInEditMode() && (super.commit(), ge(this, B) || (rt(this, B, !0), this.parent.addUndoableEditor(this)), this.disableEditMode(), rt(this, e, ze(this, i, Ei).call(this).trimEnd()), ze(this, k, si).call(this));
            }
            shouldGetKeyboardEvents() {
              return this.isInEditMode();
            }
            dblclick(r) {
              this.enableEditMode(), this.editorDiv.focus();
            }
            keydown(r) {
              r.target === this.div && r.key === "Enter" && (this.enableEditMode(), this.editorDiv.focus());
            }
            editorDivKeydown(r) {
              l._keyboardManager.exec(this, r);
            }
            editorDivFocus(r) {
              this.isEditing = !0;
            }
            editorDivBlur(r) {
              this.isEditing = !1;
            }
            editorDivInput(r) {
              this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
            }
            disableEditing() {
              this.editorDiv.setAttribute("role", "comment"), this.editorDiv.removeAttribute("aria-multiline");
            }
            enableEditing() {
              this.editorDiv.setAttribute("role", "textbox"), this.editorDiv.setAttribute("aria-multiline", !0);
            }
            render() {
              if (this.div)
                return this.div;
              let r, x;
              this.width && (r = this.x, x = this.y), super.render(), this.editorDiv = document.createElement("div"), this.editorDiv.className = "internal", this.editorDiv.setAttribute("id", ge(this, t)), this.enableEditing(), l._l10nPromise.get("editor_free_text2_aria_label").then((I) => {
                var h;
                return (h = this.editorDiv) == null ? void 0 : h.setAttribute("aria-label", I);
              }), l._l10nPromise.get("free_text2_default_content").then((I) => {
                var h;
                return (h = this.editorDiv) == null ? void 0 : h.setAttribute("default-content", I);
              }), this.editorDiv.contentEditable = !0;
              const {
                style: b
              } = this.editorDiv;
              if (b.fontSize = `calc(${ge(this, j)}px * var(--scale-factor))`, b.color = ge(this, q), this.div.append(this.editorDiv), this.overlayDiv = document.createElement("div"), this.overlayDiv.classList.add("overlay", "enabled"), this.div.append(this.overlayDiv), (0, me.bindEvents)(this, this.div, ["dblclick", "keydown"]), this.width) {
                const [I, h] = this.parentDimensions;
                this.setAt(r * I, x * h, this.width * I, this.height * h);
                for (const y of ge(this, e).split(`
`)) {
                  const P = document.createElement("div");
                  P.append(y ? document.createTextNode(y) : document.createElement("br")), this.editorDiv.append(P);
                }
                this.div.draggable = !0, this.editorDiv.contentEditable = !1;
              } else
                this.div.draggable = !1, this.editorDiv.contentEditable = !0;
              return this.div;
            }
            get contentDiv() {
              return this.editorDiv;
            }
            static deserialize(r, x, b) {
              const I = super.deserialize(r, x, b);
              return rt(I, j, r.fontSize), rt(I, q, ue.Util.makeHexColor(...r.color)), rt(I, e, r.value), I;
            }
            serialize() {
              if (this.isEmpty())
                return null;
              const r = l._internalPadding * this.parentScale, x = this.getRect(r, r), b = Me.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : ge(this, q));
              return {
                annotationType: ue.AnnotationEditorType.FREETEXT,
                color: b,
                fontSize: ge(this, j),
                value: ge(this, e),
                pageIndex: this.pageIndex,
                rect: x,
                rotation: this.rotation
              };
            }
          };
          F = new WeakMap(), ae = new WeakMap(), n = new WeakMap(), u = new WeakMap(), q = new WeakMap(), e = new WeakMap(), t = new WeakMap(), B = new WeakMap(), j = new WeakMap(), M = new WeakSet(), Fi = function(r) {
            const x = (I) => {
              this.editorDiv.style.fontSize = `calc(${I}px * var(--scale-factor))`, this.translate(0, -(I - ge(this, j)) * this.parentScale), rt(this, j, I), ze(this, k, si).call(this);
            }, b = ge(this, j);
            this.addCommands({
              cmd: () => {
                x(r);
              },
              undo: () => {
                x(b);
              },
              mustExec: !0,
              type: ue.AnnotationEditorParamsType.FREETEXT_SIZE,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, w = new WeakSet(), Ti = function(r) {
            const x = ge(this, q);
            this.addCommands({
              cmd: () => {
                rt(this, q, this.editorDiv.style.color = r);
              },
              undo: () => {
                rt(this, q, this.editorDiv.style.color = x);
              },
              mustExec: !0,
              type: ue.AnnotationEditorParamsType.FREETEXT_COLOR,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, i = new WeakSet(), Ei = function() {
            const r = this.editorDiv.getElementsByTagName("div");
            if (r.length === 0)
              return this.editorDiv.innerText;
            const x = [];
            for (const b of r)
              x.push(b.innerText.replace(/\r\n?|\n/, ""));
            return x.join(`
`);
          }, k = new WeakSet(), si = function() {
            const [r, x] = this.parentDimensions;
            let b;
            if (this.isAttachedToDOM)
              b = this.div.getBoundingClientRect();
            else {
              const {
                currentLayer: I,
                div: h
              } = this, y = h.style.display;
              h.style.display = "hidden", I.div.append(this.div), b = h.getBoundingClientRect(), h.remove(), h.style.display = y;
            }
            this.width = b.width / r, this.height = b.height / x;
          }, Dt(l, "_freeTextDefaultContent", ""), Dt(l, "_l10nPromise"), Dt(l, "_internalPadding", 0), Dt(l, "_defaultColor", null), Dt(l, "_defaultFontSize", 10), Dt(l, "_keyboardManager", new me.KeyboardManager([[["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], l.prototype.commitOrRemove]])), Dt(l, "_type", "freetext");
          let xe = l;
          he.FreeTextEditor = xe;
        },
        /* 29 */
        /***/
        (Se, he, ke) => {
          var ae, n, u, q, e, t, B, j, M, O, w, C, i, o, k, s, l, Oi, v, Ii, x, Pi, I, Mi, y, ri, c, Ri, A, oi, E, Di, $, _i, p, Li, L, Ni, G, Bi, K, nn, U, ci, X, On, f, In, z, fn, W, li, ne, Pn, ee, ji, oe, $i, ce, Ui, de, Hi, Fe, hi, pe, Mn, Ae, gn, Re, ui;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.InkEditor = void 0;
          var ue = ke(1), me = ke(4), Me = ke(5);
          const xe = 16, ye = class ye extends me.AnnotationEditor {
            constructor(ve) {
              super({
                ...ve,
                name: "inkEditor"
              });
              Be(this, l);
              Be(this, v);
              Be(this, x);
              Be(this, I);
              Be(this, y);
              Be(this, c);
              Be(this, A);
              Be(this, E);
              Be(this, $);
              Be(this, p);
              Be(this, L);
              Be(this, G);
              Be(this, K);
              Be(this, U);
              Be(this, X);
              Be(this, f);
              Be(this, z);
              Be(this, W);
              Be(this, ne);
              Be(this, oe);
              Be(this, ce);
              Be(this, de);
              Be(this, Fe);
              Be(this, pe);
              Be(this, Ae);
              Be(this, Re);
              Be(this, ae, 0);
              Be(this, n, 0);
              Be(this, u, 0);
              Be(this, q, this.canvasContextMenu.bind(this));
              Be(this, e, this.canvasPointermove.bind(this));
              Be(this, t, this.canvasPointerleave.bind(this));
              Be(this, B, this.canvasPointerup.bind(this));
              Be(this, j, this.canvasPointerdown.bind(this));
              Be(this, M, new Path2D());
              Be(this, O, !1);
              Be(this, w, !1);
              Be(this, C, !1);
              Be(this, i, null);
              Be(this, o, 0);
              Be(this, k, 0);
              Be(this, s, null);
              this.color = ve.color || null, this.thickness = ve.thickness || null, this.opacity = ve.opacity || null, this.paths = [], this.bezierPath2D = [], this.allRawPaths = [], this.currentPath = [], this.scaleFactor = 1, this.translationX = this.translationY = 0, this.x = 0, this.y = 0;
            }
            static initialize(ve) {
              this._l10nPromise = new Map(["editor_ink_canvas_aria_label", "editor_ink2_aria_label"].map((Ce) => [Ce, ve.get(Ce)]));
            }
            static updateDefaultParams(ve, Ce) {
              switch (ve) {
                case ue.AnnotationEditorParamsType.INK_THICKNESS:
                  ye._defaultThickness = Ce;
                  break;
                case ue.AnnotationEditorParamsType.INK_COLOR:
                  ye._defaultColor = Ce;
                  break;
                case ue.AnnotationEditorParamsType.INK_OPACITY:
                  ye._defaultOpacity = Ce / 100;
                  break;
              }
            }
            updateParams(ve, Ce) {
              switch (ve) {
                case ue.AnnotationEditorParamsType.INK_THICKNESS:
                  ze(this, l, Oi).call(this, Ce);
                  break;
                case ue.AnnotationEditorParamsType.INK_COLOR:
                  ze(this, v, Ii).call(this, Ce);
                  break;
                case ue.AnnotationEditorParamsType.INK_OPACITY:
                  ze(this, x, Pi).call(this, Ce);
                  break;
              }
            }
            static get defaultPropertiesToUpdate() {
              return [[ue.AnnotationEditorParamsType.INK_THICKNESS, ye._defaultThickness], [ue.AnnotationEditorParamsType.INK_COLOR, ye._defaultColor || me.AnnotationEditor._defaultLineColor], [ue.AnnotationEditorParamsType.INK_OPACITY, Math.round(ye._defaultOpacity * 100)]];
            }
            get propertiesToUpdate() {
              return [[ue.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || ye._defaultThickness], [ue.AnnotationEditorParamsType.INK_COLOR, this.color || ye._defaultColor || me.AnnotationEditor._defaultLineColor], [ue.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? ye._defaultOpacity))]];
            }
            rebuild() {
              super.rebuild(), this.div !== null && (this.canvas || (ze(this, X, On).call(this), ze(this, f, In).call(this)), this.isAttachedToDOM || (this.parent.add(this), ze(this, z, fn).call(this)), ze(this, Ae, gn).call(this));
            }
            remove() {
              this.canvas !== null && (this.isEmpty() || this.commit(), this.canvas.width = this.canvas.height = 0, this.canvas.remove(), this.canvas = null, ge(this, i).disconnect(), rt(this, i, null), super.remove());
            }
            setParent(ve) {
              !this.parent && ve ? this._uiManager.removeShouldRescale(this) : this.parent && ve === null && this._uiManager.addShouldRescale(this), super.setParent(ve);
            }
            onScaleChanging() {
              const [ve, Ce] = this.parentDimensions, Ne = this.width * ve, Ge = this.height * Ce;
              this.setDimensions(Ne, Ge);
            }
            enableEditMode() {
              ge(this, O) || this.canvas === null || (super.enableEditMode(), this.div.draggable = !1, this.canvas.addEventListener("pointerdown", ge(this, j)));
            }
            disableEditMode() {
              !this.isInEditMode() || this.canvas === null || (super.disableEditMode(), this.div.draggable = !this.isEmpty(), this.div.classList.remove("editing"), this.canvas.removeEventListener("pointerdown", ge(this, j)));
            }
            onceAdded() {
              this.div.draggable = !this.isEmpty();
            }
            isEmpty() {
              return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
            }
            commit() {
              ge(this, O) || (super.commit(), this.isEditing = !1, this.disableEditMode(), this.setInForeground(), rt(this, O, !0), this.div.classList.add("disabled"), ze(this, Ae, gn).call(this, !0), this.parent.addInkEditorIfNeeded(!0), this.parent.moveEditorInDOM(this), this.div.focus({
                preventScroll: !0
              }));
            }
            focusin(ve) {
              super.focusin(ve), this.enableEditMode();
            }
            canvasPointerdown(ve) {
              ve.button !== 0 || !this.isInEditMode() || ge(this, O) || (this.setInForeground(), ve.preventDefault(), ve.type !== "mouse" && this.div.focus(), ze(this, c, Ri).call(this, ve.offsetX, ve.offsetY));
            }
            canvasContextMenu(ve) {
              ve.preventDefault();
            }
            canvasPointermove(ve) {
              ve.preventDefault(), ze(this, A, oi).call(this, ve.offsetX, ve.offsetY);
            }
            canvasPointerup(ve) {
              ve.preventDefault(), ze(this, U, ci).call(this, ve);
            }
            canvasPointerleave(ve) {
              ze(this, U, ci).call(this, ve);
            }
            render() {
              if (this.div)
                return this.div;
              let ve, Ce;
              this.width && (ve = this.x, Ce = this.y), super.render(), ye._l10nPromise.get("editor_ink2_aria_label").then((Ke) => {
                var et;
                return (et = this.div) == null ? void 0 : et.setAttribute("aria-label", Ke);
              });
              const [Ne, Ge, Oe, tt] = ze(this, I, Mi).call(this);
              if (this.setAt(Ne, Ge, 0, 0), this.setDims(Oe, tt), ze(this, X, On).call(this), this.width) {
                const [Ke, et] = this.parentDimensions;
                this.setAt(ve * Ke, Ce * et, this.width * Ke, this.height * et), rt(this, C, !0), ze(this, z, fn).call(this), this.setDims(this.width * Ke, this.height * et), ze(this, K, nn).call(this), ze(this, Re, ui).call(this), this.div.classList.add("disabled");
              } else
                this.div.classList.add("editing"), this.enableEditMode();
              return ze(this, f, In).call(this), this.div;
            }
            setDimensions(ve, Ce) {
              const Ne = Math.round(ve), Ge = Math.round(Ce);
              if (ge(this, o) === Ne && ge(this, k) === Ge)
                return;
              rt(this, o, Ne), rt(this, k, Ge), this.canvas.style.visibility = "hidden", ge(this, ae) && Math.abs(ge(this, ae) - ve / Ce) > 0.01 && (Ce = Math.ceil(ve / ge(this, ae)), this.setDims(ve, Ce));
              const [Oe, tt] = this.parentDimensions;
              this.width = ve / Oe, this.height = Ce / tt, ge(this, O) && ze(this, W, li).call(this, ve, Ce), ze(this, z, fn).call(this), ze(this, K, nn).call(this), this.canvas.style.visibility = "visible", this.fixDims();
            }
            static deserialize(ve, Ce, Ne) {
              var We, gt;
              const Ge = super.deserialize(ve, Ce, Ne);
              Ge.thickness = ve.thickness, Ge.color = ue.Util.makeHexColor(...ve.color), Ge.opacity = ve.opacity;
              const [Oe, tt] = Ge.pageDimensions, Ke = Ge.width * Oe, et = Ge.height * tt, Xe = Ge.parentScale, Qe = ve.thickness / 2;
              rt(Ge, ae, Ke / et), rt(Ge, O, !0), rt(Ge, o, Math.round(Ke)), rt(Ge, k, Math.round(et));
              for (const {
                bezier: mt
              } of ve.paths) {
                const Ct = [];
                Ge.paths.push(Ct);
                let Pt = Xe * (mt[0] - Qe), at = Xe * (et - mt[1] - Qe);
                for (let ot = 2, Mt = mt.length; ot < Mt; ot += 6) {
                  const Rt = Xe * (mt[ot] - Qe), Et = Xe * (et - mt[ot + 1] - Qe), At = Xe * (mt[ot + 2] - Qe), Nt = Xe * (et - mt[ot + 3] - Qe), qe = Xe * (mt[ot + 4] - Qe), Ue = Xe * (et - mt[ot + 5] - Qe);
                  Ct.push([[Pt, at], [Rt, Et], [At, Nt], [qe, Ue]]), Pt = qe, at = Ue;
                }
                const dt = ze(this, ee, ji).call(this, Ct);
                Ge.bezierPath2D.push(dt);
              }
              const it = ze(We = Ge, Fe, hi).call(We);
              return rt(Ge, u, Math.max(xe, it[2] - it[0])), rt(Ge, n, Math.max(xe, it[3] - it[1])), ze(gt = Ge, W, li).call(gt, Ke, et), Ge;
            }
            serialize() {
              if (this.isEmpty())
                return null;
              const ve = this.getRect(0, 0), Ce = this.rotation % 180 === 0 ? ve[3] - ve[1] : ve[2] - ve[0], Ne = me.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
              return {
                annotationType: ue.AnnotationEditorType.INK,
                color: Ne,
                thickness: this.thickness,
                opacity: this.opacity,
                paths: ze(this, oe, $i).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, Ce),
                pageIndex: this.pageIndex,
                rect: ve,
                rotation: this.rotation
              };
            }
          };
          ae = new WeakMap(), n = new WeakMap(), u = new WeakMap(), q = new WeakMap(), e = new WeakMap(), t = new WeakMap(), B = new WeakMap(), j = new WeakMap(), M = new WeakMap(), O = new WeakMap(), w = new WeakMap(), C = new WeakMap(), i = new WeakMap(), o = new WeakMap(), k = new WeakMap(), s = new WeakMap(), l = new WeakSet(), Oi = function(ve) {
            const Ce = this.thickness;
            this.addCommands({
              cmd: () => {
                this.thickness = ve, ze(this, Ae, gn).call(this);
              },
              undo: () => {
                this.thickness = Ce, ze(this, Ae, gn).call(this);
              },
              mustExec: !0,
              type: ue.AnnotationEditorParamsType.INK_THICKNESS,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, v = new WeakSet(), Ii = function(ve) {
            const Ce = this.color;
            this.addCommands({
              cmd: () => {
                this.color = ve, ze(this, K, nn).call(this);
              },
              undo: () => {
                this.color = Ce, ze(this, K, nn).call(this);
              },
              mustExec: !0,
              type: ue.AnnotationEditorParamsType.INK_COLOR,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, x = new WeakSet(), Pi = function(ve) {
            ve /= 100;
            const Ce = this.opacity;
            this.addCommands({
              cmd: () => {
                this.opacity = ve, ze(this, K, nn).call(this);
              },
              undo: () => {
                this.opacity = Ce, ze(this, K, nn).call(this);
              },
              mustExec: !0,
              type: ue.AnnotationEditorParamsType.INK_OPACITY,
              overwriteIfSameType: !0,
              keepUndo: !0
            });
          }, I = new WeakSet(), Mi = function() {
            const {
              parentRotation: ve,
              parentDimensions: [Ce, Ne]
            } = this;
            switch (ve) {
              case 90:
                return [0, Ne, Ne, Ce];
              case 180:
                return [Ce, Ne, Ce, Ne];
              case 270:
                return [Ce, 0, Ne, Ce];
              default:
                return [0, 0, Ce, Ne];
            }
          }, y = new WeakSet(), ri = function() {
            const {
              ctx: ve,
              color: Ce,
              opacity: Ne,
              thickness: Ge,
              parentScale: Oe,
              scaleFactor: tt
            } = this;
            ve.lineWidth = Ge * Oe / tt, ve.lineCap = "round", ve.lineJoin = "round", ve.miterLimit = 10, ve.strokeStyle = `${Ce}${(0, Me.opacityToHex)(Ne)}`;
          }, c = new WeakSet(), Ri = function(ve, Ce) {
            this.canvas.addEventListener("contextmenu", ge(this, q)), this.canvas.addEventListener("pointerleave", ge(this, t)), this.canvas.addEventListener("pointermove", ge(this, e)), this.canvas.addEventListener("pointerup", ge(this, B)), this.canvas.removeEventListener("pointerdown", ge(this, j)), this.isEditing = !0, ge(this, C) || (rt(this, C, !0), ze(this, z, fn).call(this), this.thickness || (this.thickness = ye._defaultThickness), this.color || (this.color = ye._defaultColor || me.AnnotationEditor._defaultLineColor), this.opacity ?? (this.opacity = ye._defaultOpacity)), this.currentPath.push([ve, Ce]), rt(this, w, !1), ze(this, y, ri).call(this), rt(this, s, () => {
              ze(this, p, Li).call(this), ge(this, s) && window.requestAnimationFrame(ge(this, s));
            }), window.requestAnimationFrame(ge(this, s));
          }, A = new WeakSet(), oi = function(ve, Ce) {
            const [Ne, Ge] = this.currentPath.at(-1);
            if (this.currentPath.length > 1 && ve === Ne && Ce === Ge)
              return;
            const Oe = this.currentPath;
            let tt = ge(this, M);
            if (Oe.push([ve, Ce]), rt(this, w, !0), Oe.length <= 2) {
              tt.moveTo(...Oe[0]), tt.lineTo(ve, Ce);
              return;
            }
            Oe.length === 3 && (rt(this, M, tt = new Path2D()), tt.moveTo(...Oe[0])), ze(this, L, Ni).call(this, tt, ...Oe.at(-3), ...Oe.at(-2), ve, Ce);
          }, E = new WeakSet(), Di = function() {
            if (this.currentPath.length === 0)
              return;
            const ve = this.currentPath.at(-1);
            ge(this, M).lineTo(...ve);
          }, $ = new WeakSet(), _i = function(ve, Ce) {
            rt(this, s, null), ve = Math.min(Math.max(ve, 0), this.canvas.width), Ce = Math.min(Math.max(Ce, 0), this.canvas.height), ze(this, A, oi).call(this, ve, Ce), ze(this, E, Di).call(this);
            let Ne;
            if (this.currentPath.length !== 1)
              Ne = ze(this, G, Bi).call(this);
            else {
              const et = [ve, Ce];
              Ne = [[et, et.slice(), et.slice(), et]];
            }
            const Ge = ge(this, M), Oe = this.currentPath;
            this.currentPath = [], rt(this, M, new Path2D());
            const tt = () => {
              this.allRawPaths.push(Oe), this.paths.push(Ne), this.bezierPath2D.push(Ge), this.rebuild();
            }, Ke = () => {
              this.allRawPaths.pop(), this.paths.pop(), this.bezierPath2D.pop(), this.paths.length === 0 ? this.remove() : (this.canvas || (ze(this, X, On).call(this), ze(this, f, In).call(this)), ze(this, Ae, gn).call(this));
            };
            this.addCommands({
              cmd: tt,
              undo: Ke,
              mustExec: !0
            });
          }, p = new WeakSet(), Li = function() {
            if (!ge(this, w))
              return;
            rt(this, w, !1);
            const ve = Math.ceil(this.thickness * this.parentScale), Ce = this.currentPath.slice(-3), Ne = Ce.map((tt) => tt[0]), Ge = Ce.map((tt) => tt[1]);
            Math.min(...Ne) - ve, Math.max(...Ne) + ve, Math.min(...Ge) - ve, Math.max(...Ge) + ve;
            const {
              ctx: Oe
            } = this;
            Oe.save(), Oe.clearRect(0, 0, this.canvas.width, this.canvas.height);
            for (const tt of this.bezierPath2D)
              Oe.stroke(tt);
            Oe.stroke(ge(this, M)), Oe.restore();
          }, L = new WeakSet(), Ni = function(ve, Ce, Ne, Ge, Oe, tt, Ke) {
            const et = (Ce + Ge) / 2, Xe = (Ne + Oe) / 2, Qe = (Ge + tt) / 2, it = (Oe + Ke) / 2;
            ve.bezierCurveTo(et + 2 * (Ge - et) / 3, Xe + 2 * (Oe - Xe) / 3, Qe + 2 * (Ge - Qe) / 3, it + 2 * (Oe - it) / 3, Qe, it);
          }, G = new WeakSet(), Bi = function() {
            const ve = this.currentPath;
            if (ve.length <= 2)
              return [[ve[0], ve[0], ve.at(-1), ve.at(-1)]];
            const Ce = [];
            let Ne, [Ge, Oe] = ve[0];
            for (Ne = 1; Ne < ve.length - 2; Ne++) {
              const [We, gt] = ve[Ne], [mt, Ct] = ve[Ne + 1], Pt = (We + mt) / 2, at = (gt + Ct) / 2, dt = [Ge + 2 * (We - Ge) / 3, Oe + 2 * (gt - Oe) / 3], ot = [Pt + 2 * (We - Pt) / 3, at + 2 * (gt - at) / 3];
              Ce.push([[Ge, Oe], dt, ot, [Pt, at]]), [Ge, Oe] = [Pt, at];
            }
            const [tt, Ke] = ve[Ne], [et, Xe] = ve[Ne + 1], Qe = [Ge + 2 * (tt - Ge) / 3, Oe + 2 * (Ke - Oe) / 3], it = [et + 2 * (tt - et) / 3, Xe + 2 * (Ke - Xe) / 3];
            return Ce.push([[Ge, Oe], Qe, it, [et, Xe]]), Ce;
          }, K = new WeakSet(), nn = function() {
            if (this.isEmpty()) {
              ze(this, ne, Pn).call(this);
              return;
            }
            ze(this, y, ri).call(this);
            const {
              canvas: ve,
              ctx: Ce
            } = this;
            Ce.setTransform(1, 0, 0, 1, 0, 0), Ce.clearRect(0, 0, ve.width, ve.height), ze(this, ne, Pn).call(this);
            for (const Ne of this.bezierPath2D)
              Ce.stroke(Ne);
          }, U = new WeakSet(), ci = function(ve) {
            this.canvas.removeEventListener("pointerleave", ge(this, t)), this.canvas.removeEventListener("pointermove", ge(this, e)), this.canvas.removeEventListener("pointerup", ge(this, B)), this.canvas.addEventListener("pointerdown", ge(this, j)), setTimeout(() => {
              this.canvas.removeEventListener("contextmenu", ge(this, q));
            }, 10), ze(this, $, _i).call(this, ve.offsetX, ve.offsetY), this.addToAnnotationStorage(), this.setInBackground();
          }, X = new WeakSet(), On = function() {
            this.canvas = document.createElement("canvas"), this.canvas.width = this.canvas.height = 0, this.canvas.className = "inkEditorCanvas", ye._l10nPromise.get("editor_ink_canvas_aria_label").then((ve) => {
              var Ce;
              return (Ce = this.canvas) == null ? void 0 : Ce.setAttribute("aria-label", ve);
            }), this.div.append(this.canvas), this.ctx = this.canvas.getContext("2d");
          }, f = new WeakSet(), In = function() {
            rt(this, i, new ResizeObserver((ve) => {
              const Ce = ve[0].contentRect;
              Ce.width && Ce.height && this.setDimensions(Ce.width, Ce.height);
            })), ge(this, i).observe(this.div);
          }, z = new WeakSet(), fn = function() {
            if (!ge(this, C))
              return;
            const [ve, Ce] = this.parentDimensions;
            this.canvas.width = Math.ceil(this.width * ve), this.canvas.height = Math.ceil(this.height * Ce), ze(this, ne, Pn).call(this);
          }, W = new WeakSet(), li = function(ve, Ce) {
            const Ne = ze(this, pe, Mn).call(this), Ge = (ve - Ne) / ge(this, u), Oe = (Ce - Ne) / ge(this, n);
            this.scaleFactor = Math.min(Ge, Oe);
          }, ne = new WeakSet(), Pn = function() {
            const ve = ze(this, pe, Mn).call(this) / 2;
            this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + ve, this.translationY * this.scaleFactor + ve);
          }, ee = new WeakSet(), ji = function(ve) {
            const Ce = new Path2D();
            for (let Ne = 0, Ge = ve.length; Ne < Ge; Ne++) {
              const [Oe, tt, Ke, et] = ve[Ne];
              Ne === 0 && Ce.moveTo(...Oe), Ce.bezierCurveTo(tt[0], tt[1], Ke[0], Ke[1], et[0], et[1]);
            }
            return Ce;
          }, oe = new WeakSet(), $i = function(ve, Ce, Ne, Ge) {
            const tt = [], Ke = this.thickness / 2;
            let et, Xe;
            for (const Qe of this.paths) {
              et = [], Xe = [];
              for (let it = 0, We = Qe.length; it < We; it++) {
                const [gt, mt, Ct, Pt] = Qe[it], at = ve * (gt[0] + Ce) + Ke, dt = Ge - ve * (gt[1] + Ne) - Ke, ot = ve * (mt[0] + Ce) + Ke, Mt = Ge - ve * (mt[1] + Ne) - Ke, Rt = ve * (Ct[0] + Ce) + Ke, Et = Ge - ve * (Ct[1] + Ne) - Ke, At = ve * (Pt[0] + Ce) + Ke, Nt = Ge - ve * (Pt[1] + Ne) - Ke;
                it === 0 && (et.push(at, dt), Xe.push(at, dt)), et.push(ot, Mt, Rt, Et, At, Nt), ze(this, ce, Ui).call(this, at, dt, ot, Mt, Rt, Et, At, Nt, 4, Xe);
              }
              tt.push({
                bezier: et,
                points: Xe
              });
            }
            return tt;
          }, ce = new WeakSet(), Ui = function(ve, Ce, Ne, Ge, Oe, tt, Ke, et, Xe, Qe) {
            if (ze(this, de, Hi).call(this, ve, Ce, Ne, Ge, Oe, tt, Ke, et)) {
              Qe.push(Ke, et);
              return;
            }
            for (let it = 1; it < Xe - 1; it++) {
              const We = it / Xe, gt = 1 - We;
              let mt = We * ve + gt * Ne, Ct = We * Ce + gt * Ge, Pt = We * Ne + gt * Oe, at = We * Ge + gt * tt;
              const dt = We * Oe + gt * Ke, ot = We * tt + gt * et;
              mt = We * mt + gt * Pt, Ct = We * Ct + gt * at, Pt = We * Pt + gt * dt, at = We * at + gt * ot, mt = We * mt + gt * Pt, Ct = We * Ct + gt * at, Qe.push(mt, Ct);
            }
            Qe.push(Ke, et);
          }, de = new WeakSet(), Hi = function(ve, Ce, Ne, Ge, Oe, tt, Ke, et) {
            const Qe = (3 * Ne - 2 * ve - Ke) ** 2, it = (3 * Ge - 2 * Ce - et) ** 2, We = (3 * Oe - ve - 2 * Ke) ** 2, gt = (3 * tt - Ce - 2 * et) ** 2;
            return Math.max(Qe, We) + Math.max(it, gt) <= 10;
          }, Fe = new WeakSet(), hi = function() {
            let ve = 1 / 0, Ce = -1 / 0, Ne = 1 / 0, Ge = -1 / 0;
            for (const Oe of this.paths)
              for (const [tt, Ke, et, Xe] of Oe) {
                const Qe = ue.Util.bezierBoundingBox(...tt, ...Ke, ...et, ...Xe);
                ve = Math.min(ve, Qe[0]), Ne = Math.min(Ne, Qe[1]), Ce = Math.max(Ce, Qe[2]), Ge = Math.max(Ge, Qe[3]);
              }
            return [ve, Ne, Ce, Ge];
          }, pe = new WeakSet(), Mn = function() {
            return ge(this, O) ? Math.ceil(this.thickness * this.parentScale) : 0;
          }, Ae = new WeakSet(), gn = function(ve = !1) {
            if (this.isEmpty())
              return;
            if (!ge(this, O)) {
              ze(this, K, nn).call(this);
              return;
            }
            const Ce = ze(this, Fe, hi).call(this), Ne = ze(this, pe, Mn).call(this);
            rt(this, u, Math.max(xe, Ce[2] - Ce[0])), rt(this, n, Math.max(xe, Ce[3] - Ce[1]));
            const Ge = Math.ceil(Ne + ge(this, u) * this.scaleFactor), Oe = Math.ceil(Ne + ge(this, n) * this.scaleFactor), [tt, Ke] = this.parentDimensions;
            this.width = Ge / tt, this.height = Oe / Ke, rt(this, ae, Ge / Oe), ze(this, Re, ui).call(this);
            const et = this.translationX, Xe = this.translationY;
            this.translationX = -Ce[0], this.translationY = -Ce[1], ze(this, z, fn).call(this), ze(this, K, nn).call(this), rt(this, o, Ge), rt(this, k, Oe), this.setDims(Ge, Oe);
            const Qe = ve ? Ne / this.scaleFactor / 2 : 0;
            this.translate(et - this.translationX - Qe, Xe - this.translationY - Qe);
          }, Re = new WeakSet(), ui = function() {
            const {
              style: ve
            } = this.div;
            ge(this, ae) >= 1 ? (ve.minHeight = `${xe}px`, ve.minWidth = `${Math.round(ge(this, ae) * xe)}px`) : (ve.minWidth = `${xe}px`, ve.minHeight = `${Math.round(xe / ge(this, ae))}px`);
          }, Be(ye, ee), Dt(ye, "_defaultColor", null), Dt(ye, "_defaultOpacity", 1), Dt(ye, "_defaultThickness", 1), Dt(ye, "_l10nPromise"), Dt(ye, "_type", "ink");
          let F = ye;
          he.InkEditor = F;
        },
        /* 30 */
        /***/
        (Se, he, ke) => {
          var H, on, m, Xi, L, di, G, fi;
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.AnnotationLayer = void 0;
          var ue = ke(1), me = ke(6), Me = ke(3), xe = ke(31), F = ke(32);
          const ae = 1e3, n = 9, u = /* @__PURE__ */ new WeakSet();
          function q(V) {
            return {
              width: V[2] - V[0],
              height: V[3] - V[1]
            };
          }
          class e {
            static create(U) {
              switch (U.data.annotationType) {
                case ue.AnnotationType.LINK:
                  return new B(U);
                case ue.AnnotationType.TEXT:
                  return new j(U);
                case ue.AnnotationType.WIDGET:
                  switch (U.data.fieldType) {
                    case "Tx":
                      return new O(U);
                    case "Btn":
                      return U.data.radioButton ? new C(U) : U.data.checkBox ? new w(U) : new i(U);
                    case "Ch":
                      return new o(U);
                  }
                  return new M(U);
                case ue.AnnotationType.POPUP:
                  return new k(U);
                case ue.AnnotationType.FREETEXT:
                  return new l(U);
                case ue.AnnotationType.LINE:
                  return new g(U);
                case ue.AnnotationType.SQUARE:
                  return new v(U);
                case ue.AnnotationType.CIRCLE:
                  return new r(U);
                case ue.AnnotationType.POLYLINE:
                  return new x(U);
                case ue.AnnotationType.CARET:
                  return new I(U);
                case ue.AnnotationType.INK:
                  return new h(U);
                case ue.AnnotationType.POLYGON:
                  return new b(U);
                case ue.AnnotationType.HIGHLIGHT:
                  return new y(U);
                case ue.AnnotationType.UNDERLINE:
                  return new P(U);
                case ue.AnnotationType.SQUIGGLY:
                  return new c(U);
                case ue.AnnotationType.STRIKEOUT:
                  return new d(U);
                case ue.AnnotationType.STAMP:
                  return new A(U);
                case ue.AnnotationType.FILEATTACHMENT:
                  return new N(U);
                default:
                  return new t(U);
              }
            }
          }
          class t {
            constructor(U, {
              isRenderable: Q = !1,
              ignoreBorder: X = !1,
              createQuadrilaterals: R = !1
            } = {}) {
              this.isRenderable = Q, this.data = U.data, this.layer = U.layer, this.page = U.page, this.viewport = U.viewport, this.linkService = U.linkService, this.downloadManager = U.downloadManager, this.imageResourcesPath = U.imageResourcesPath, this.renderForms = U.renderForms, this.svgFactory = U.svgFactory, this.annotationStorage = U.annotationStorage, this.enableScripting = U.enableScripting, this.hasJSActions = U.hasJSActions, this._fieldObjects = U.fieldObjects, Q && (this.container = this._createContainer(X)), R && (this.quadrilaterals = this._createQuadrilaterals(X));
            }
            _createContainer(U = !1) {
              const {
                data: Q,
                page: X,
                viewport: R
              } = this, f = document.createElement("section");
              f.setAttribute("data-annotation-id", Q.id), Q.noRotate && f.classList.add("norotate");
              const {
                pageWidth: D,
                pageHeight: z,
                pageX: Y,
                pageY: W
              } = R.rawDims, {
                width: ie,
                height: ne
              } = q(Q.rect), re = ue.Util.normalizeRect([Q.rect[0], X.view[3] - Q.rect[1] + X.view[1], Q.rect[2], X.view[3] - Q.rect[3] + X.view[1]]);
              if (!U && Q.borderStyle.width > 0) {
                f.style.borderWidth = `${Q.borderStyle.width}px`;
                const te = Q.borderStyle.horizontalCornerRadius, oe = Q.borderStyle.verticalCornerRadius;
                if (te > 0 || oe > 0) {
                  const ce = `calc(${te}px * var(--scale-factor)) / calc(${oe}px * var(--scale-factor))`;
                  f.style.borderRadius = ce;
                } else if (this instanceof C) {
                  const ce = `calc(${ie}px * var(--scale-factor)) / calc(${ne}px * var(--scale-factor))`;
                  f.style.borderRadius = ce;
                }
                switch (Q.borderStyle.style) {
                  case ue.AnnotationBorderStyleType.SOLID:
                    f.style.borderStyle = "solid";
                    break;
                  case ue.AnnotationBorderStyleType.DASHED:
                    f.style.borderStyle = "dashed";
                    break;
                  case ue.AnnotationBorderStyleType.BEVELED:
                    (0, ue.warn)("Unimplemented border style: beveled");
                    break;
                  case ue.AnnotationBorderStyleType.INSET:
                    (0, ue.warn)("Unimplemented border style: inset");
                    break;
                  case ue.AnnotationBorderStyleType.UNDERLINE:
                    f.style.borderBottomStyle = "solid";
                    break;
                }
                const se = Q.borderColor || null;
                se ? f.style.borderColor = ue.Util.makeHexColor(se[0] | 0, se[1] | 0, se[2] | 0) : f.style.borderWidth = 0;
              }
              f.style.left = `${100 * (re[0] - Y) / D}%`, f.style.top = `${100 * (re[1] - W) / z}%`;
              const {
                rotation: ee
              } = Q;
              return Q.hasOwnCanvas || ee === 0 ? (f.style.width = `${100 * ie / D}%`, f.style.height = `${100 * ne / z}%`) : this.setRotation(ee, f), f;
            }
            setRotation(U, Q = this.container) {
              const {
                pageWidth: X,
                pageHeight: R
              } = this.viewport.rawDims, {
                width: f,
                height: D
              } = q(this.data.rect);
              let z, Y;
              U % 180 === 0 ? (z = 100 * f / X, Y = 100 * D / R) : (z = 100 * D / X, Y = 100 * f / R), Q.style.width = `${z}%`, Q.style.height = `${Y}%`, Q.setAttribute("data-main-rotation", (360 - U) % 360);
            }
            get _commonActions() {
              const U = (Q, X, R) => {
                const f = R.detail[Q];
                R.target.style[X] = xe.ColorConverters[`${f[0]}_HTML`](f.slice(1));
              };
              return (0, ue.shadow)(this, "_commonActions", {
                display: (Q) => {
                  const X = Q.detail.display % 2 === 1;
                  this.container.style.visibility = X ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                    hidden: X,
                    print: Q.detail.display === 0 || Q.detail.display === 3
                  });
                },
                print: (Q) => {
                  this.annotationStorage.setValue(this.data.id, {
                    print: Q.detail.print
                  });
                },
                hidden: (Q) => {
                  this.container.style.visibility = Q.detail.hidden ? "hidden" : "visible", this.annotationStorage.setValue(this.data.id, {
                    hidden: Q.detail.hidden
                  });
                },
                focus: (Q) => {
                  setTimeout(() => Q.target.focus({
                    preventScroll: !1
                  }), 0);
                },
                userName: (Q) => {
                  Q.target.title = Q.detail.userName;
                },
                readonly: (Q) => {
                  Q.detail.readonly ? Q.target.setAttribute("readonly", "") : Q.target.removeAttribute("readonly");
                },
                required: (Q) => {
                  this._setRequired(Q.target, Q.detail.required);
                },
                bgColor: (Q) => {
                  U("bgColor", "backgroundColor", Q);
                },
                fillColor: (Q) => {
                  U("fillColor", "backgroundColor", Q);
                },
                fgColor: (Q) => {
                  U("fgColor", "color", Q);
                },
                textColor: (Q) => {
                  U("textColor", "color", Q);
                },
                borderColor: (Q) => {
                  U("borderColor", "borderColor", Q);
                },
                strokeColor: (Q) => {
                  U("strokeColor", "borderColor", Q);
                },
                rotation: (Q) => {
                  const X = Q.detail.rotation;
                  this.setRotation(X), this.annotationStorage.setValue(this.data.id, {
                    rotation: X
                  });
                }
              });
            }
            _dispatchEventFromSandbox(U, Q) {
              const X = this._commonActions;
              for (const R of Object.keys(Q.detail)) {
                const f = U[R] || X[R];
                f == null || f(Q);
              }
            }
            _setDefaultPropertiesFromJS(U) {
              if (!this.enableScripting)
                return;
              const Q = this.annotationStorage.getRawValue(this.data.id);
              if (!Q)
                return;
              const X = this._commonActions;
              for (const [R, f] of Object.entries(Q)) {
                const D = X[R];
                if (D) {
                  const z = {
                    detail: {
                      [R]: f
                    },
                    target: U
                  };
                  D(z), delete Q[R];
                }
              }
            }
            _createQuadrilaterals(U = !1) {
              if (!this.data.quadPoints)
                return null;
              const Q = [], X = this.data.rect;
              for (const R of this.data.quadPoints)
                this.data.rect = [R[2].x, R[2].y, R[1].x, R[1].y], Q.push(this._createContainer(U));
              return this.data.rect = X, Q;
            }
            _createPopup(U, Q) {
              let X = this.container;
              this.quadrilaterals && (U || (U = this.quadrilaterals), X = this.quadrilaterals[0]), U || (U = document.createElement("div"), U.classList.add("popupTriggerArea"), X.append(U));
              const f = new s({
                container: X,
                trigger: U,
                color: Q.color,
                titleObj: Q.titleObj,
                modificationDate: Q.modificationDate,
                contentsObj: Q.contentsObj,
                richText: Q.richText,
                hideWrapper: !0
              }).render();
              f.style.left = "100%", X.append(f);
            }
            _renderQuadrilaterals(U) {
              for (const Q of this.quadrilaterals)
                Q.classList.add(U);
              return this.quadrilaterals;
            }
            render() {
              (0, ue.unreachable)("Abstract method `AnnotationElement.render` called");
            }
            _getElementsByName(U, Q = null) {
              const X = [];
              if (this._fieldObjects) {
                const R = this._fieldObjects[U];
                if (R)
                  for (const {
                    page: f,
                    id: D,
                    exportValues: z
                  } of R) {
                    if (f === -1 || D === Q)
                      continue;
                    const Y = typeof z == "string" ? z : null, W = document.querySelector(`[data-element-id="${D}"]`);
                    if (W && !u.has(W)) {
                      (0, ue.warn)(`_getElementsByName - element not allowed: ${D}`);
                      continue;
                    }
                    X.push({
                      id: D,
                      exportValue: Y,
                      domElement: W
                    });
                  }
                return X;
              }
              for (const R of document.getElementsByName(U)) {
                const {
                  exportValue: f
                } = R, D = R.getAttribute("data-element-id");
                D !== Q && u.has(R) && X.push({
                  id: D,
                  exportValue: f,
                  domElement: R
                });
              }
              return X;
            }
          }
          class B extends t {
            constructor(Q, X = null) {
              super(Q, {
                isRenderable: !0,
                ignoreBorder: !!(X != null && X.ignoreBorder),
                createQuadrilaterals: !0
              });
              Be(this, H);
              Be(this, m);
              this.isTooltipOnly = Q.data.isTooltipOnly;
            }
            render() {
              const {
                data: Q,
                linkService: X
              } = this, R = document.createElement("a");
              R.setAttribute("data-element-id", Q.id);
              let f = !1;
              return Q.url ? (X.addLinkAttributes(R, Q.url, Q.newWindow), f = !0) : Q.action ? (this._bindNamedAction(R, Q.action), f = !0) : Q.attachment ? (this._bindAttachment(R, Q.attachment), f = !0) : Q.setOCGState ? (ze(this, m, Xi).call(this, R, Q.setOCGState), f = !0) : Q.dest ? (this._bindLink(R, Q.dest), f = !0) : (Q.actions && (Q.actions.Action || Q.actions["Mouse Up"] || Q.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions && (this._bindJSAction(R, Q), f = !0), Q.resetForm ? (this._bindResetFormAction(R, Q.resetForm), f = !0) : this.isTooltipOnly && !f && (this._bindLink(R, ""), f = !0)), this.quadrilaterals ? this._renderQuadrilaterals("linkAnnotation").map((D, z) => {
                const Y = z === 0 ? R : R.cloneNode();
                return D.append(Y), D;
              }) : (this.container.classList.add("linkAnnotation"), f && this.container.append(R), this.container);
            }
            _bindLink(Q, X) {
              Q.href = this.linkService.getDestinationHash(X), Q.onclick = () => (X && this.linkService.goToDestination(X), !1), (X || X === "") && ze(this, H, on).call(this);
            }
            _bindNamedAction(Q, X) {
              Q.href = this.linkService.getAnchorUrl(""), Q.onclick = () => (this.linkService.executeNamedAction(X), !1), ze(this, H, on).call(this);
            }
            _bindAttachment(Q, X) {
              Q.href = this.linkService.getAnchorUrl(""), Q.onclick = () => {
                var R;
                return (R = this.downloadManager) == null || R.openOrDownloadData(this.container, X.content, X.filename), !1;
              }, ze(this, H, on).call(this);
            }
            _bindJSAction(Q, X) {
              Q.href = this.linkService.getAnchorUrl("");
              const R = /* @__PURE__ */ new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
              for (const f of Object.keys(X.actions)) {
                const D = R.get(f);
                D && (Q[D] = () => {
                  var z;
                  return (z = this.linkService.eventBus) == null || z.dispatch("dispatcheventinsandbox", {
                    source: this,
                    detail: {
                      id: X.id,
                      name: f
                    }
                  }), !1;
                });
              }
              Q.onclick || (Q.onclick = () => !1), ze(this, H, on).call(this);
            }
            _bindResetFormAction(Q, X) {
              const R = Q.onclick;
              if (R || (Q.href = this.linkService.getAnchorUrl("")), ze(this, H, on).call(this), !this._fieldObjects) {
                (0, ue.warn)('_bindResetFormAction - "resetForm" action not supported, ensure that the `fieldObjects` parameter is provided.'), R || (Q.onclick = () => !1);
                return;
              }
              Q.onclick = () => {
                var ne;
                R == null || R();
                const {
                  fields: f,
                  refs: D,
                  include: z
                } = X, Y = [];
                if (f.length !== 0 || D.length !== 0) {
                  const re = new Set(D);
                  for (const ee of f) {
                    const te = this._fieldObjects[ee] || [];
                    for (const {
                      id: oe
                    } of te)
                      re.add(oe);
                  }
                  for (const ee of Object.values(this._fieldObjects))
                    for (const te of ee)
                      re.has(te.id) === z && Y.push(te);
                } else
                  for (const re of Object.values(this._fieldObjects))
                    Y.push(...re);
                const W = this.annotationStorage, ie = [];
                for (const re of Y) {
                  const {
                    id: ee
                  } = re;
                  switch (ie.push(ee), re.type) {
                    case "text": {
                      const oe = re.defaultValue || "";
                      W.setValue(ee, {
                        value: oe
                      });
                      break;
                    }
                    case "checkbox":
                    case "radiobutton": {
                      const oe = re.defaultValue === re.exportValues;
                      W.setValue(ee, {
                        value: oe
                      });
                      break;
                    }
                    case "combobox":
                    case "listbox": {
                      const oe = re.defaultValue || "";
                      W.setValue(ee, {
                        value: oe
                      });
                      break;
                    }
                    default:
                      continue;
                  }
                  const te = document.querySelector(`[data-element-id="${ee}"]`);
                  if (te) {
                    if (!u.has(te)) {
                      (0, ue.warn)(`_bindResetFormAction - element not allowed: ${ee}`);
                      continue;
                    }
                  } else
                    continue;
                  te.dispatchEvent(new Event("resetform"));
                }
                return this.enableScripting && ((ne = this.linkService.eventBus) == null || ne.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: "app",
                    ids: ie,
                    name: "ResetForm"
                  }
                })), !1;
              };
            }
          }
          H = new WeakSet(), on = function() {
            this.container.setAttribute("data-internal-link", "");
          }, m = new WeakSet(), Xi = function(Q, X) {
            Q.href = this.linkService.getAnchorUrl(""), Q.onclick = () => (this.linkService.executeSetOCGState(X), !1), ze(this, H, on).call(this);
          };
          class j extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q
              });
            }
            render() {
              this.container.classList.add("textAnnotation");
              const U = document.createElement("img");
              return U.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg", U.alt = "[{{type}} Annotation]", U.dataset.l10nId = "text_annotation_type", U.dataset.l10nArgs = JSON.stringify({
                type: this.data.name
              }), this.data.hasPopup || this._createPopup(U, this.data), this.container.append(U), this.container;
            }
          }
          class M extends t {
            render() {
              return this.data.alternativeText && (this.container.title = this.data.alternativeText), this.container;
            }
            showElementAndHideCanvas(U) {
              var Q;
              this.data.hasOwnCanvas && (((Q = U.previousSibling) == null ? void 0 : Q.nodeName) === "CANVAS" && (U.previousSibling.hidden = !0), U.hidden = !1);
            }
            _getKeyModifier(U) {
              const {
                isWin: Q,
                isMac: X
              } = ue.FeatureTest.platform;
              return Q && U.ctrlKey || X && U.metaKey;
            }
            _setEventListener(U, Q, X, R) {
              Q.includes("mouse") ? U.addEventListener(Q, (f) => {
                var D;
                (D = this.linkService.eventBus) == null || D.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: this.data.id,
                    name: X,
                    value: R(f),
                    shift: f.shiftKey,
                    modifier: this._getKeyModifier(f)
                  }
                });
              }) : U.addEventListener(Q, (f) => {
                var D;
                (D = this.linkService.eventBus) == null || D.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: this.data.id,
                    name: X,
                    value: R(f)
                  }
                });
              });
            }
            _setEventListeners(U, Q, X) {
              var R;
              for (const [f, D] of Q)
                (D === "Action" || (R = this.data.actions) != null && R[D]) && this._setEventListener(U, f, D, X);
            }
            _setBackgroundColor(U) {
              const Q = this.data.backgroundColor || null;
              U.style.backgroundColor = Q === null ? "transparent" : ue.Util.makeHexColor(Q[0], Q[1], Q[2]);
            }
            _setTextStyle(U) {
              const Q = ["left", "center", "right"], {
                fontColor: X
              } = this.data.defaultAppearanceData, R = this.data.defaultAppearanceData.fontSize || n, f = U.style;
              let D;
              const z = 2, Y = (W) => Math.round(10 * W) / 10;
              if (this.data.multiLine) {
                const W = Math.abs(this.data.rect[3] - this.data.rect[1] - z), ie = Math.round(W / (ue.LINE_FACTOR * R)) || 1, ne = W / ie;
                D = Math.min(R, Y(ne / ue.LINE_FACTOR));
              } else {
                const W = Math.abs(this.data.rect[3] - this.data.rect[1] - z);
                D = Math.min(R, Y(W / ue.LINE_FACTOR));
              }
              f.fontSize = `calc(${D}px * var(--scale-factor))`, f.color = ue.Util.makeHexColor(X[0], X[1], X[2]), this.data.textAlignment !== null && (f.textAlign = Q[this.data.textAlignment]);
            }
            _setRequired(U, Q) {
              Q ? U.setAttribute("required", !0) : U.removeAttribute("required"), U.setAttribute("aria-required", Q);
            }
          }
          class O extends M {
            constructor(U) {
              const Q = U.renderForms || !U.data.hasAppearance && !!U.data.fieldValue;
              super(U, {
                isRenderable: Q
              });
            }
            setPropertyOnSiblings(U, Q, X, R) {
              const f = this.annotationStorage;
              for (const D of this._getElementsByName(U.name, U.id))
                D.domElement && (D.domElement[Q] = X), f.setValue(D.id, {
                  [R]: X
                });
            }
            render() {
              var R, f;
              const U = this.annotationStorage, Q = this.data.id;
              this.container.classList.add("textWidgetAnnotation");
              let X = null;
              if (this.renderForms) {
                const D = U.getValue(Q, {
                  value: this.data.fieldValue
                });
                let z = D.value || "";
                const Y = U.getValue(Q, {
                  charLimit: this.data.maxLen
                }).charLimit;
                Y && z.length > Y && (z = z.slice(0, Y));
                let W = D.formattedValue || ((R = this.data.textContent) == null ? void 0 : R.join(`
`)) || null;
                W && this.data.comb && (W = W.replaceAll(/\s+/g, ""));
                const ie = {
                  userValue: z,
                  formattedValue: W,
                  lastCommittedValue: null,
                  commitKey: 1
                };
                this.data.multiLine ? (X = document.createElement("textarea"), X.textContent = W ?? z, this.data.doNotScroll && (X.style.overflowY = "hidden")) : (X = document.createElement("input"), X.type = "text", X.setAttribute("value", W ?? z), this.data.doNotScroll && (X.style.overflowX = "hidden")), this.data.hasOwnCanvas && (X.hidden = !0), u.add(X), X.setAttribute("data-element-id", Q), X.disabled = this.data.readOnly, X.name = this.data.fieldName, X.tabIndex = ae, this._setRequired(X, this.data.required), Y && (X.maxLength = Y), X.addEventListener("input", (re) => {
                  U.setValue(Q, {
                    value: re.target.value
                  }), this.setPropertyOnSiblings(X, "value", re.target.value, "value"), ie.formattedValue = null;
                }), X.addEventListener("resetform", (re) => {
                  const ee = this.data.defaultFieldValue ?? "";
                  X.value = ie.userValue = ee, ie.formattedValue = null;
                });
                let ne = (re) => {
                  const {
                    formattedValue: ee
                  } = ie;
                  ee != null && (re.target.value = ee), re.target.scrollLeft = 0;
                };
                if (this.enableScripting && this.hasJSActions) {
                  X.addEventListener("focus", (ee) => {
                    const {
                      target: te
                    } = ee;
                    ie.userValue && (te.value = ie.userValue), ie.lastCommittedValue = te.value, ie.commitKey = 1;
                  }), X.addEventListener("updatefromsandbox", (ee) => {
                    this.showElementAndHideCanvas(ee.target);
                    const te = {
                      value(oe) {
                        ie.userValue = oe.detail.value ?? "", U.setValue(Q, {
                          value: ie.userValue.toString()
                        }), oe.target.value = ie.userValue;
                      },
                      formattedValue(oe) {
                        const {
                          formattedValue: se
                        } = oe.detail;
                        ie.formattedValue = se, se != null && oe.target !== document.activeElement && (oe.target.value = se), U.setValue(Q, {
                          formattedValue: se
                        });
                      },
                      selRange(oe) {
                        oe.target.setSelectionRange(...oe.detail.selRange);
                      },
                      charLimit: (oe) => {
                        var de;
                        const {
                          charLimit: se
                        } = oe.detail, {
                          target: ce
                        } = oe;
                        if (se === 0) {
                          ce.removeAttribute("maxLength");
                          return;
                        }
                        ce.setAttribute("maxLength", se);
                        let le = ie.userValue;
                        !le || le.length <= se || (le = le.slice(0, se), ce.value = ie.userValue = le, U.setValue(Q, {
                          value: le
                        }), (de = this.linkService.eventBus) == null || de.dispatch("dispatcheventinsandbox", {
                          source: this,
                          detail: {
                            id: Q,
                            name: "Keystroke",
                            value: le,
                            willCommit: !0,
                            commitKey: 1,
                            selStart: ce.selectionStart,
                            selEnd: ce.selectionEnd
                          }
                        }));
                      }
                    };
                    this._dispatchEventFromSandbox(te, ee);
                  }), X.addEventListener("keydown", (ee) => {
                    var se;
                    ie.commitKey = 1;
                    let te = -1;
                    if (ee.key === "Escape" ? te = 0 : ee.key === "Enter" && !this.data.multiLine ? te = 2 : ee.key === "Tab" && (ie.commitKey = 3), te === -1)
                      return;
                    const {
                      value: oe
                    } = ee.target;
                    ie.lastCommittedValue !== oe && (ie.lastCommittedValue = oe, ie.userValue = oe, (se = this.linkService.eventBus) == null || se.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: Q,
                        name: "Keystroke",
                        value: oe,
                        willCommit: !0,
                        commitKey: te,
                        selStart: ee.target.selectionStart,
                        selEnd: ee.target.selectionEnd
                      }
                    }));
                  });
                  const re = ne;
                  ne = null, X.addEventListener("blur", (ee) => {
                    var oe;
                    if (!ee.relatedTarget)
                      return;
                    const {
                      value: te
                    } = ee.target;
                    ie.userValue = te, ie.lastCommittedValue !== te && ((oe = this.linkService.eventBus) == null || oe.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: Q,
                        name: "Keystroke",
                        value: te,
                        willCommit: !0,
                        commitKey: ie.commitKey,
                        selStart: ee.target.selectionStart,
                        selEnd: ee.target.selectionEnd
                      }
                    })), re(ee);
                  }), (f = this.data.actions) != null && f.Keystroke && X.addEventListener("beforeinput", (ee) => {
                    var Fe;
                    ie.lastCommittedValue = null;
                    const {
                      data: te,
                      target: oe
                    } = ee, {
                      value: se,
                      selectionStart: ce,
                      selectionEnd: le
                    } = oe;
                    let de = ce, Ie = le;
                    switch (ee.inputType) {
                      case "deleteWordBackward": {
                        const we = se.substring(0, ce).match(/\w*[^\w]*$/);
                        we && (de -= we[0].length);
                        break;
                      }
                      case "deleteWordForward": {
                        const we = se.substring(ce).match(/^[^\w]*\w*/);
                        we && (Ie += we[0].length);
                        break;
                      }
                      case "deleteContentBackward":
                        ce === le && (de -= 1);
                        break;
                      case "deleteContentForward":
                        ce === le && (Ie += 1);
                        break;
                    }
                    ee.preventDefault(), (Fe = this.linkService.eventBus) == null || Fe.dispatch("dispatcheventinsandbox", {
                      source: this,
                      detail: {
                        id: Q,
                        name: "Keystroke",
                        value: se,
                        change: te || "",
                        willCommit: !1,
                        selStart: de,
                        selEnd: Ie
                      }
                    });
                  }), this._setEventListeners(X, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (ee) => ee.target.value);
                }
                if (ne && X.addEventListener("blur", ne), this.data.comb) {
                  const ee = (this.data.rect[2] - this.data.rect[0]) / Y;
                  X.classList.add("comb"), X.style.letterSpacing = `calc(${ee}px * var(--scale-factor) - 1ch)`;
                }
              } else
                X = document.createElement("div"), X.textContent = this.data.fieldValue, X.style.verticalAlign = "middle", X.style.display = "table-cell";
              return this._setTextStyle(X), this._setBackgroundColor(X), this._setDefaultPropertiesFromJS(X), this.container.append(X), this.container;
            }
          }
          class w extends M {
            constructor(U) {
              super(U, {
                isRenderable: U.renderForms
              });
            }
            render() {
              const U = this.annotationStorage, Q = this.data, X = Q.id;
              let R = U.getValue(X, {
                value: Q.exportValue === Q.fieldValue
              }).value;
              typeof R == "string" && (R = R !== "Off", U.setValue(X, {
                value: R
              })), this.container.classList.add("buttonWidgetAnnotation", "checkBox");
              const f = document.createElement("input");
              return u.add(f), f.setAttribute("data-element-id", X), f.disabled = Q.readOnly, this._setRequired(f, this.data.required), f.type = "checkbox", f.name = Q.fieldName, R && f.setAttribute("checked", !0), f.setAttribute("exportValue", Q.exportValue), f.tabIndex = ae, f.addEventListener("change", (D) => {
                const {
                  name: z,
                  checked: Y
                } = D.target;
                for (const W of this._getElementsByName(z, X)) {
                  const ie = Y && W.exportValue === Q.exportValue;
                  W.domElement && (W.domElement.checked = ie), U.setValue(W.id, {
                    value: ie
                  });
                }
                U.setValue(X, {
                  value: Y
                });
              }), f.addEventListener("resetform", (D) => {
                const z = Q.defaultFieldValue || "Off";
                D.target.checked = z === Q.exportValue;
              }), this.enableScripting && this.hasJSActions && (f.addEventListener("updatefromsandbox", (D) => {
                const z = {
                  value(Y) {
                    Y.target.checked = Y.detail.value !== "Off", U.setValue(X, {
                      value: Y.target.checked
                    });
                  }
                };
                this._dispatchEventFromSandbox(z, D);
              }), this._setEventListeners(f, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (D) => D.target.checked)), this._setBackgroundColor(f), this._setDefaultPropertiesFromJS(f), this.container.append(f), this.container;
            }
          }
          class C extends M {
            constructor(U) {
              super(U, {
                isRenderable: U.renderForms
              });
            }
            render() {
              this.container.classList.add("buttonWidgetAnnotation", "radioButton");
              const U = this.annotationStorage, Q = this.data, X = Q.id;
              let R = U.getValue(X, {
                value: Q.fieldValue === Q.buttonValue
              }).value;
              typeof R == "string" && (R = R !== Q.buttonValue, U.setValue(X, {
                value: R
              }));
              const f = document.createElement("input");
              if (u.add(f), f.setAttribute("data-element-id", X), f.disabled = Q.readOnly, this._setRequired(f, this.data.required), f.type = "radio", f.name = Q.fieldName, R && f.setAttribute("checked", !0), f.tabIndex = ae, f.addEventListener("change", (D) => {
                const {
                  name: z,
                  checked: Y
                } = D.target;
                for (const W of this._getElementsByName(z, X))
                  U.setValue(W.id, {
                    value: !1
                  });
                U.setValue(X, {
                  value: Y
                });
              }), f.addEventListener("resetform", (D) => {
                const z = Q.defaultFieldValue;
                D.target.checked = z != null && z === Q.buttonValue;
              }), this.enableScripting && this.hasJSActions) {
                const D = Q.buttonValue;
                f.addEventListener("updatefromsandbox", (z) => {
                  const Y = {
                    value: (W) => {
                      const ie = D === W.detail.value;
                      for (const ne of this._getElementsByName(W.target.name)) {
                        const re = ie && ne.id === X;
                        ne.domElement && (ne.domElement.checked = re), U.setValue(ne.id, {
                          value: re
                        });
                      }
                    }
                  };
                  this._dispatchEventFromSandbox(Y, z);
                }), this._setEventListeners(f, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], (z) => z.target.checked);
              }
              return this._setBackgroundColor(f), this._setDefaultPropertiesFromJS(f), this.container.append(f), this.container;
            }
          }
          class i extends B {
            constructor(U) {
              super(U, {
                ignoreBorder: U.data.hasAppearance
              });
            }
            render() {
              const U = super.render();
              U.classList.add("buttonWidgetAnnotation", "pushButton"), this.data.alternativeText && (U.title = this.data.alternativeText);
              const Q = U.lastChild;
              return this.enableScripting && this.hasJSActions && Q && (this._setDefaultPropertiesFromJS(Q), Q.addEventListener("updatefromsandbox", (X) => {
                this._dispatchEventFromSandbox({}, X);
              })), U;
            }
          }
          class o extends M {
            constructor(U) {
              super(U, {
                isRenderable: U.renderForms
              });
            }
            render() {
              this.container.classList.add("choiceWidgetAnnotation");
              const U = this.annotationStorage, Q = this.data.id, X = U.getValue(Q, {
                value: this.data.fieldValue
              }), R = document.createElement("select");
              u.add(R), R.setAttribute("data-element-id", Q), R.disabled = this.data.readOnly, this._setRequired(R, this.data.required), R.name = this.data.fieldName, R.tabIndex = ae;
              let f = this.data.combo && this.data.options.length > 0;
              this.data.combo || (R.size = this.data.options.length, this.data.multiSelect && (R.multiple = !0)), R.addEventListener("resetform", (ie) => {
                const ne = this.data.defaultFieldValue;
                for (const re of R.options)
                  re.selected = re.value === ne;
              });
              for (const ie of this.data.options) {
                const ne = document.createElement("option");
                ne.textContent = ie.displayValue, ne.value = ie.exportValue, X.value.includes(ie.exportValue) && (ne.setAttribute("selected", !0), f = !1), R.append(ne);
              }
              let D = null;
              if (f) {
                const ie = document.createElement("option");
                ie.value = " ", ie.setAttribute("hidden", !0), ie.setAttribute("selected", !0), R.prepend(ie), D = () => {
                  ie.remove(), R.removeEventListener("input", D), D = null;
                }, R.addEventListener("input", D);
              }
              const z = (ie) => {
                const ne = ie ? "value" : "textContent", {
                  options: re,
                  multiple: ee
                } = R;
                return ee ? Array.prototype.filter.call(re, (te) => te.selected).map((te) => te[ne]) : re.selectedIndex === -1 ? null : re[re.selectedIndex][ne];
              };
              let Y = z(!1);
              const W = (ie) => {
                const ne = ie.target.options;
                return Array.prototype.map.call(ne, (re) => ({
                  displayValue: re.textContent,
                  exportValue: re.value
                }));
              };
              return this.enableScripting && this.hasJSActions ? (R.addEventListener("updatefromsandbox", (ie) => {
                const ne = {
                  value(re) {
                    D == null || D();
                    const ee = re.detail.value, te = new Set(Array.isArray(ee) ? ee : [ee]);
                    for (const oe of R.options)
                      oe.selected = te.has(oe.value);
                    U.setValue(Q, {
                      value: z(!0)
                    }), Y = z(!1);
                  },
                  multipleSelection(re) {
                    R.multiple = !0;
                  },
                  remove(re) {
                    const ee = R.options, te = re.detail.remove;
                    ee[te].selected = !1, R.remove(te), ee.length > 0 && Array.prototype.findIndex.call(ee, (se) => se.selected) === -1 && (ee[0].selected = !0), U.setValue(Q, {
                      value: z(!0),
                      items: W(re)
                    }), Y = z(!1);
                  },
                  clear(re) {
                    for (; R.length !== 0; )
                      R.remove(0);
                    U.setValue(Q, {
                      value: null,
                      items: []
                    }), Y = z(!1);
                  },
                  insert(re) {
                    const {
                      index: ee,
                      displayValue: te,
                      exportValue: oe
                    } = re.detail.insert, se = R.children[ee], ce = document.createElement("option");
                    ce.textContent = te, ce.value = oe, se ? se.before(ce) : R.append(ce), U.setValue(Q, {
                      value: z(!0),
                      items: W(re)
                    }), Y = z(!1);
                  },
                  items(re) {
                    const {
                      items: ee
                    } = re.detail;
                    for (; R.length !== 0; )
                      R.remove(0);
                    for (const te of ee) {
                      const {
                        displayValue: oe,
                        exportValue: se
                      } = te, ce = document.createElement("option");
                      ce.textContent = oe, ce.value = se, R.append(ce);
                    }
                    R.options.length > 0 && (R.options[0].selected = !0), U.setValue(Q, {
                      value: z(!0),
                      items: W(re)
                    }), Y = z(!1);
                  },
                  indices(re) {
                    const ee = new Set(re.detail.indices);
                    for (const te of re.target.options)
                      te.selected = ee.has(te.index);
                    U.setValue(Q, {
                      value: z(!0)
                    }), Y = z(!1);
                  },
                  editable(re) {
                    re.target.disabled = !re.detail.editable;
                  }
                };
                this._dispatchEventFromSandbox(ne, ie);
              }), R.addEventListener("input", (ie) => {
                var re;
                const ne = z(!0);
                U.setValue(Q, {
                  value: ne
                }), ie.preventDefault(), (re = this.linkService.eventBus) == null || re.dispatch("dispatcheventinsandbox", {
                  source: this,
                  detail: {
                    id: Q,
                    name: "Keystroke",
                    value: Y,
                    changeEx: ne,
                    willCommit: !1,
                    commitKey: 1,
                    keyDown: !1
                  }
                });
              }), this._setEventListeners(R, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], (ie) => ie.target.value)) : R.addEventListener("input", function(ie) {
                U.setValue(Q, {
                  value: z(!0)
                });
              }), this.data.combo && this._setTextStyle(R), this._setBackgroundColor(R), this._setDefaultPropertiesFromJS(R), this.container.append(R), this.container;
            }
          }
          const T = class T extends t {
            constructor(U) {
              var R, f, D;
              const {
                data: Q
              } = U, X = !T.IGNORE_TYPES.has(Q.parentType) && !!((R = Q.titleObj) != null && R.str || (f = Q.contentsObj) != null && f.str || (D = Q.richText) != null && D.str);
              super(U, {
                isRenderable: X
              });
            }
            render() {
              this.container.classList.add("popupAnnotation");
              const U = this.layer.querySelectorAll(`[data-annotation-id="${this.data.parentId}"]`);
              if (U.length === 0)
                return this.container;
              const Q = new s({
                container: this.container,
                trigger: Array.from(U),
                color: this.data.color,
                titleObj: this.data.titleObj,
                modificationDate: this.data.modificationDate,
                contentsObj: this.data.contentsObj,
                richText: this.data.richText
              }), X = this.page, R = ue.Util.normalizeRect([this.data.parentRect[0], X.view[3] - this.data.parentRect[1] + X.view[1], this.data.parentRect[2], X.view[3] - this.data.parentRect[3] + X.view[1]]), f = R[0] + this.data.parentRect[2] - this.data.parentRect[0], D = R[1], {
                pageWidth: z,
                pageHeight: Y,
                pageX: W,
                pageY: ie
              } = this.viewport.rawDims;
              return this.container.style.left = `${100 * (f - W) / z}%`, this.container.style.top = `${100 * (D - ie) / Y}%`, this.container.append(Q.render()), this.container;
            }
          };
          Dt(T, "IGNORE_TYPES", /* @__PURE__ */ new Set(["Line", "Square", "Circle", "PolyLine", "Polygon", "Ink"]));
          let k = T;
          class s {
            constructor(U) {
              this.container = U.container, this.trigger = U.trigger, this.color = U.color, this.titleObj = U.titleObj, this.modificationDate = U.modificationDate, this.contentsObj = U.contentsObj, this.richText = U.richText, this.hideWrapper = U.hideWrapper || !1, this.pinned = !1;
            }
            render() {
              var z, Y;
              const Q = document.createElement("div");
              Q.classList.add("popupWrapper"), this.hideElement = this.hideWrapper ? Q : this.container, this.hideElement.hidden = !0;
              const X = document.createElement("div");
              X.classList.add("popup");
              const R = this.color;
              if (R) {
                const W = 0.7 * (255 - R[0]) + R[0], ie = 0.7 * (255 - R[1]) + R[1], ne = 0.7 * (255 - R[2]) + R[2];
                X.style.backgroundColor = ue.Util.makeHexColor(W | 0, ie | 0, ne | 0);
              }
              const f = document.createElement("h1");
              f.dir = this.titleObj.dir, f.textContent = this.titleObj.str, X.append(f);
              const D = me.PDFDateString.toDateObject(this.modificationDate);
              if (D) {
                const W = document.createElement("span");
                W.classList.add("popupDate"), W.textContent = "{{date}}, {{time}}", W.dataset.l10nId = "annotation_date_string", W.dataset.l10nArgs = JSON.stringify({
                  date: D.toLocaleDateString(),
                  time: D.toLocaleTimeString()
                }), X.append(W);
              }
              if ((z = this.richText) != null && z.str && (!((Y = this.contentsObj) != null && Y.str) || this.contentsObj.str === this.richText.str))
                F.XfaLayer.render({
                  xfaHtml: this.richText.html,
                  intent: "richText",
                  div: X
                }), X.lastChild.classList.add("richText", "popupContent");
              else {
                const W = this._formatContents(this.contentsObj);
                X.append(W);
              }
              Array.isArray(this.trigger) || (this.trigger = [this.trigger]);
              for (const W of this.trigger)
                W.addEventListener("click", this._toggle.bind(this)), W.addEventListener("mouseover", this._show.bind(this, !1)), W.addEventListener("mouseout", this._hide.bind(this, !1));
              return X.addEventListener("click", this._hide.bind(this, !0)), Q.append(X), Q;
            }
            _formatContents({
              str: U,
              dir: Q
            }) {
              const X = document.createElement("p");
              X.classList.add("popupContent"), X.dir = Q;
              const R = U.split(/(?:\r\n?|\n)/);
              for (let f = 0, D = R.length; f < D; ++f) {
                const z = R[f];
                X.append(document.createTextNode(z)), f < D - 1 && X.append(document.createElement("br"));
              }
              return X;
            }
            _toggle() {
              this.pinned ? this._hide(!0) : this._show(!0);
            }
            _show(U = !1) {
              U && (this.pinned = !0), this.hideElement.hidden && (this.hideElement.hidden = !1, this.container.style.zIndex = parseInt(this.container.style.zIndex) + 1e3);
            }
            _hide(U = !0) {
              U && (this.pinned = !1), !this.hideElement.hidden && !this.pinned && (this.hideElement.hidden = !0, this.container.style.zIndex = parseInt(this.container.style.zIndex) - 1e3);
            }
          }
          class l extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              }), this.textContent = U.data.textContent;
            }
            render() {
              if (this.container.classList.add("freeTextAnnotation"), this.textContent) {
                const U = document.createElement("div");
                U.classList.add("annotationTextContent"), U.setAttribute("role", "comment");
                for (const Q of this.textContent) {
                  const X = document.createElement("span");
                  X.textContent = Q, U.append(X);
                }
                this.container.append(U);
              }
              return this.data.hasPopup || this._createPopup(null, this.data), this.container;
            }
          }
          class g extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              });
            }
            render() {
              this.container.classList.add("lineAnnotation");
              const U = this.data, {
                width: Q,
                height: X
              } = q(U.rect), R = this.svgFactory.create(Q, X, !0), f = this.svgFactory.createElement("svg:line");
              return f.setAttribute("x1", U.rect[2] - U.lineCoordinates[0]), f.setAttribute("y1", U.rect[3] - U.lineCoordinates[1]), f.setAttribute("x2", U.rect[2] - U.lineCoordinates[2]), f.setAttribute("y2", U.rect[3] - U.lineCoordinates[3]), f.setAttribute("stroke-width", U.borderStyle.width || 1), f.setAttribute("stroke", "transparent"), f.setAttribute("fill", "transparent"), R.append(f), this.container.append(R), this._createPopup(f, U), this.container;
            }
          }
          class v extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              });
            }
            render() {
              this.container.classList.add("squareAnnotation");
              const U = this.data, {
                width: Q,
                height: X
              } = q(U.rect), R = this.svgFactory.create(Q, X, !0), f = U.borderStyle.width, D = this.svgFactory.createElement("svg:rect");
              return D.setAttribute("x", f / 2), D.setAttribute("y", f / 2), D.setAttribute("width", Q - f), D.setAttribute("height", X - f), D.setAttribute("stroke-width", f || 1), D.setAttribute("stroke", "transparent"), D.setAttribute("fill", "transparent"), R.append(D), this.container.append(R), this._createPopup(D, U), this.container;
            }
          }
          class r extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              });
            }
            render() {
              this.container.classList.add("circleAnnotation");
              const U = this.data, {
                width: Q,
                height: X
              } = q(U.rect), R = this.svgFactory.create(Q, X, !0), f = U.borderStyle.width, D = this.svgFactory.createElement("svg:ellipse");
              return D.setAttribute("cx", Q / 2), D.setAttribute("cy", X / 2), D.setAttribute("rx", Q / 2 - f / 2), D.setAttribute("ry", X / 2 - f / 2), D.setAttribute("stroke-width", f || 1), D.setAttribute("stroke", "transparent"), D.setAttribute("fill", "transparent"), R.append(D), this.container.append(R), this._createPopup(D, U), this.container;
            }
          }
          class x extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              }), this.containerClassName = "polylineAnnotation", this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.classList.add(this.containerClassName);
              const U = this.data, {
                width: Q,
                height: X
              } = q(U.rect), R = this.svgFactory.create(Q, X, !0);
              let f = [];
              for (const z of U.vertices) {
                const Y = z.x - U.rect[0], W = U.rect[3] - z.y;
                f.push(Y + "," + W);
              }
              f = f.join(" ");
              const D = this.svgFactory.createElement(this.svgElementName);
              return D.setAttribute("points", f), D.setAttribute("stroke-width", U.borderStyle.width || 1), D.setAttribute("stroke", "transparent"), D.setAttribute("fill", "transparent"), R.append(D), this.container.append(R), this._createPopup(D, U), this.container;
            }
          }
          class b extends x {
            constructor(U) {
              super(U), this.containerClassName = "polygonAnnotation", this.svgElementName = "svg:polygon";
            }
          }
          class I extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              });
            }
            render() {
              return this.container.classList.add("caretAnnotation"), this.data.hasPopup || this._createPopup(null, this.data), this.container;
            }
          }
          class h extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              }), this.containerClassName = "inkAnnotation", this.svgElementName = "svg:polyline";
            }
            render() {
              this.container.classList.add(this.containerClassName);
              const U = this.data, {
                width: Q,
                height: X
              } = q(U.rect), R = this.svgFactory.create(Q, X, !0);
              for (const f of U.inkLists) {
                let D = [];
                for (const Y of f) {
                  const W = Y.x - U.rect[0], ie = U.rect[3] - Y.y;
                  D.push(`${W},${ie}`);
                }
                D = D.join(" ");
                const z = this.svgFactory.createElement(this.svgElementName);
                z.setAttribute("points", D), z.setAttribute("stroke-width", U.borderStyle.width || 1), z.setAttribute("stroke", "transparent"), z.setAttribute("fill", "transparent"), this._createPopup(z, U), R.append(z);
              }
              return this.container.append(R), this.container;
            }
          }
          class y extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("highlightAnnotation") : (this.container.classList.add("highlightAnnotation"), this.container);
            }
          }
          class P extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("underlineAnnotation") : (this.container.classList.add("underlineAnnotation"), this.container);
            }
          }
          class c extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("squigglyAnnotation") : (this.container.classList.add("squigglyAnnotation"), this.container);
            }
          }
          class d extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0,
                createQuadrilaterals: !0
              });
            }
            render() {
              return this.data.hasPopup || this._createPopup(null, this.data), this.quadrilaterals ? this._renderQuadrilaterals("strikeoutAnnotation") : (this.container.classList.add("strikeoutAnnotation"), this.container);
            }
          }
          class A extends t {
            constructor(U) {
              var X, R, f;
              const Q = !!(U.data.hasPopup || (X = U.data.titleObj) != null && X.str || (R = U.data.contentsObj) != null && R.str || (f = U.data.richText) != null && f.str);
              super(U, {
                isRenderable: Q,
                ignoreBorder: !0
              });
            }
            render() {
              return this.container.classList.add("stampAnnotation"), this.data.hasPopup || this._createPopup(null, this.data), this.container;
            }
          }
          class N extends t {
            constructor(U) {
              var R;
              super(U, {
                isRenderable: !0
              });
              const {
                filename: Q,
                content: X
              } = this.data.file;
              this.filename = (0, me.getFilenameFromUrl)(Q, !0), this.content = X, (R = this.linkService.eventBus) == null || R.dispatch("fileattachmentannotation", {
                source: this,
                filename: Q,
                content: X
              });
            }
            render() {
              var Q, X;
              this.container.classList.add("fileAttachmentAnnotation");
              let U;
              return this.data.hasAppearance ? U = document.createElement("div") : (U = document.createElement("img"), U.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(this.data.name) ? "paperclip" : "pushpin"}.svg`), U.classList.add("popupTriggerArea"), U.addEventListener("dblclick", this._download.bind(this)), !this.data.hasPopup && ((Q = this.data.titleObj) != null && Q.str || (X = this.data.contentsObj) != null && X.str || this.data.richText) && this._createPopup(U, this.data), this.container.append(U), this.container;
            }
            _download() {
              var U;
              (U = this.downloadManager) == null || U.openOrDownloadData(this.container, this.content, this.filename);
            }
          }
          const K = class K {
            static render(U) {
              var Y, W;
              const {
                annotations: Q,
                div: X,
                viewport: R,
                accessibilityManager: f
              } = U;
              (0, me.setLayerDimensions)(X, R);
              const D = {
                data: null,
                layer: X,
                page: U.page,
                viewport: R,
                linkService: U.linkService,
                downloadManager: U.downloadManager,
                imageResourcesPath: U.imageResourcesPath || "",
                renderForms: U.renderForms !== !1,
                svgFactory: new me.DOMSVGFactory(),
                annotationStorage: U.annotationStorage || new Me.AnnotationStorage(),
                enableScripting: U.enableScripting === !0,
                hasJSActions: U.hasJSActions,
                fieldObjects: U.fieldObjects
              };
              let z = 0;
              for (const ie of Q) {
                if (ie.noHTML)
                  continue;
                if (ie.annotationType !== ue.AnnotationType.POPUP) {
                  const {
                    width: ee,
                    height: te
                  } = q(ie.rect);
                  if (ee <= 0 || te <= 0)
                    continue;
                }
                D.data = ie;
                const ne = e.create(D);
                if (!ne.isRenderable)
                  continue;
                const re = ne.render();
                if (ie.hidden && (re.style.visibility = "hidden"), Array.isArray(re))
                  for (const ee of re)
                    ee.style.zIndex = z++, ze(Y = K, L, di).call(Y, ee, ie.id, X, f);
                else
                  re.style.zIndex = z++, ne instanceof k ? X.prepend(re) : ze(W = K, L, di).call(W, re, ie.id, X, f);
              }
              ze(this, G, fi).call(this, X, U.annotationCanvasMap);
            }
            static update(U) {
              const {
                annotationCanvasMap: Q,
                div: X,
                viewport: R
              } = U;
              (0, me.setLayerDimensions)(X, {
                rotation: R.rotation
              }), ze(this, G, fi).call(this, X, Q), X.hidden = !1;
            }
          };
          L = new WeakSet(), di = function(U, Q, X, R) {
            const f = U.firstChild || U;
            f.id = `${me.AnnotationPrefix}${Q}`, X.append(U), R == null || R.moveElementInDOM(X, U, f, !1);
          }, G = new WeakSet(), fi = function(U, Q) {
            if (Q) {
              for (const [X, R] of Q) {
                const f = U.querySelector(`[data-annotation-id="${X}"]`);
                if (!f)
                  continue;
                const {
                  firstChild: D
                } = f;
                D ? D.nodeName === "CANVAS" ? D.replaceWith(R) : D.before(R) : f.append(R);
              }
              Q.clear();
            }
          }, Be(K, L), Be(K, G);
          let E = K;
          he.AnnotationLayer = E;
        },
        /* 31 */
        /***/
        (Se, he) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.ColorConverters = void 0;
          function ke(me) {
            return Math.floor(Math.max(0, Math.min(1, me)) * 255).toString(16).padStart(2, "0");
          }
          class ue {
            static CMYK_G([Me, xe, F, ae]) {
              return ["G", 1 - Math.min(1, 0.3 * Me + 0.59 * F + 0.11 * xe + ae)];
            }
            static G_CMYK([Me]) {
              return ["CMYK", 0, 0, 0, 1 - Me];
            }
            static G_RGB([Me]) {
              return ["RGB", Me, Me, Me];
            }
            static G_HTML([Me]) {
              const xe = ke(Me);
              return `#${xe}${xe}${xe}`;
            }
            static RGB_G([Me, xe, F]) {
              return ["G", 0.3 * Me + 0.59 * xe + 0.11 * F];
            }
            static RGB_HTML([Me, xe, F]) {
              const ae = ke(Me), n = ke(xe), u = ke(F);
              return `#${ae}${n}${u}`;
            }
            static T_HTML() {
              return "#00000000";
            }
            static CMYK_RGB([Me, xe, F, ae]) {
              return ["RGB", 1 - Math.min(1, Me + ae), 1 - Math.min(1, F + ae), 1 - Math.min(1, xe + ae)];
            }
            static CMYK_HTML(Me) {
              const xe = this.CMYK_RGB(Me).slice(1);
              return this.RGB_HTML(xe);
            }
            static RGB_CMYK([Me, xe, F]) {
              const ae = 1 - Me, n = 1 - xe, u = 1 - F, q = Math.min(ae, n, u);
              return ["CMYK", ae, n, u, q];
            }
          }
          he.ColorConverters = ue;
        },
        /* 32 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.XfaLayer = void 0;
          var ue = ke(19);
          class me {
            static setupStorage(xe, F, ae, n, u) {
              const q = n.getValue(F, {
                value: null
              });
              switch (ae.name) {
                case "textarea":
                  if (q.value !== null && (xe.textContent = q.value), u === "print")
                    break;
                  xe.addEventListener("input", (e) => {
                    n.setValue(F, {
                      value: e.target.value
                    });
                  });
                  break;
                case "input":
                  if (ae.attributes.type === "radio" || ae.attributes.type === "checkbox") {
                    if (q.value === ae.attributes.xfaOn ? xe.setAttribute("checked", !0) : q.value === ae.attributes.xfaOff && xe.removeAttribute("checked"), u === "print")
                      break;
                    xe.addEventListener("change", (e) => {
                      n.setValue(F, {
                        value: e.target.checked ? e.target.getAttribute("xfaOn") : e.target.getAttribute("xfaOff")
                      });
                    });
                  } else {
                    if (q.value !== null && xe.setAttribute("value", q.value), u === "print")
                      break;
                    xe.addEventListener("input", (e) => {
                      n.setValue(F, {
                        value: e.target.value
                      });
                    });
                  }
                  break;
                case "select":
                  if (q.value !== null)
                    for (const e of ae.children)
                      e.attributes.value === q.value && (e.attributes.selected = !0);
                  xe.addEventListener("input", (e) => {
                    const t = e.target.options, B = t.selectedIndex === -1 ? "" : t[t.selectedIndex].value;
                    n.setValue(F, {
                      value: B
                    });
                  });
                  break;
              }
            }
            static setAttributes({
              html: xe,
              element: F,
              storage: ae = null,
              intent: n,
              linkService: u
            }) {
              const {
                attributes: q
              } = F, e = xe instanceof HTMLAnchorElement;
              q.type === "radio" && (q.name = `${q.name}-${n}`);
              for (const [t, B] of Object.entries(q))
                if (B != null)
                  switch (t) {
                    case "class":
                      B.length && xe.setAttribute(t, B.join(" "));
                      break;
                    case "dataId":
                      break;
                    case "id":
                      xe.setAttribute("data-element-id", B);
                      break;
                    case "style":
                      Object.assign(xe.style, B);
                      break;
                    case "textContent":
                      xe.textContent = B;
                      break;
                    default:
                      (!e || t !== "href" && t !== "newWindow") && xe.setAttribute(t, B);
                  }
              e && u.addLinkAttributes(xe, q.href, q.newWindow), ae && q.dataId && this.setupStorage(xe, q.dataId, F, ae);
            }
            static render(xe) {
              var j;
              const F = xe.annotationStorage, ae = xe.linkService, n = xe.xfaHtml, u = xe.intent || "display", q = document.createElement(n.name);
              n.attributes && this.setAttributes({
                html: q,
                element: n,
                intent: u,
                linkService: ae
              });
              const e = [[n, -1, q]], t = xe.div;
              if (t.append(q), xe.viewport) {
                const M = `matrix(${xe.viewport.transform.join(",")})`;
                t.style.transform = M;
              }
              u !== "richText" && t.setAttribute("class", "xfaLayer xfaFont");
              const B = [];
              for (; e.length > 0; ) {
                const [M, O, w] = e.at(-1);
                if (O + 1 === M.children.length) {
                  e.pop();
                  continue;
                }
                const C = M.children[++e.at(-1)[1]];
                if (C === null)
                  continue;
                const {
                  name: i
                } = C;
                if (i === "#text") {
                  const k = document.createTextNode(C.value);
                  B.push(k), w.append(k);
                  continue;
                }
                let o;
                if ((j = C == null ? void 0 : C.attributes) != null && j.xmlns ? o = document.createElementNS(C.attributes.xmlns, i) : o = document.createElement(i), w.append(o), C.attributes && this.setAttributes({
                  html: o,
                  element: C,
                  storage: F,
                  intent: u,
                  linkService: ae
                }), C.children && C.children.length > 0)
                  e.push([C, -1, o]);
                else if (C.value) {
                  const k = document.createTextNode(C.value);
                  ue.XfaText.shouldBuildText(i) && B.push(k), o.append(k);
                }
              }
              for (const M of t.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))
                M.setAttribute("readOnly", !0);
              return {
                textDivs: B
              };
            }
            static update(xe) {
              const F = `matrix(${xe.viewport.transform.join(",")})`;
              xe.div.style.transform = F, xe.div.hidden = !1;
            }
          }
          he.XfaLayer = me;
        },
        /* 33 */
        /***/
        (Se, he, ke) => {
          Object.defineProperty(he, "__esModule", {
            value: !0
          }), he.SVGGraphics = void 0;
          var ue = ke(6), me = ke(1), Me = ke(10);
          let xe = class {
            constructor() {
              (0, me.unreachable)("Not implemented: SVGGraphics");
            }
          };
          he.SVGGraphics = xe;
          {
            let j = function(o) {
              let k = [];
              const s = [];
              for (const l of o) {
                if (l.fn === "save") {
                  k.push({
                    fnId: 92,
                    fn: "group",
                    items: []
                  }), s.push(k), k = k.at(-1).items;
                  continue;
                }
                l.fn === "restore" ? k = s.pop() : k.push(l);
              }
              return k;
            }, M = function(o) {
              if (Number.isInteger(o))
                return o.toString();
              const k = o.toFixed(10);
              let s = k.length - 1;
              if (k[s] !== "0")
                return k;
              do
                s--;
              while (k[s] === "0");
              return k.substring(0, k[s] === "." ? s : s + 1);
            }, O = function(o) {
              if (o[4] === 0 && o[5] === 0) {
                if (o[1] === 0 && o[2] === 0)
                  return o[0] === 1 && o[3] === 1 ? "" : `scale(${M(o[0])} ${M(o[3])})`;
                if (o[0] === o[3] && o[1] === -o[2]) {
                  const k = Math.acos(o[0]) * 180 / Math.PI;
                  return `rotate(${M(k)})`;
                }
              } else if (o[0] === 1 && o[1] === 0 && o[2] === 0 && o[3] === 1)
                return `translate(${M(o[4])} ${M(o[5])})`;
              return `matrix(${M(o[0])} ${M(o[1])} ${M(o[2])} ${M(o[3])} ${M(o[4])} ${M(o[5])})`;
            };
            const F = {
              fontStyle: "normal",
              fontWeight: "normal",
              fillColor: "#000000"
            }, ae = "http://www.w3.org/XML/1998/namespace", n = "http://www.w3.org/1999/xlink", u = ["butt", "round", "square"], q = ["miter", "round", "bevel"], e = function(o, k = "", s = !1) {
              if (URL.createObjectURL && typeof Blob < "u" && !s)
                return URL.createObjectURL(new Blob([o], {
                  type: k
                }));
              const l = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
              let g = `data:${k};base64,`;
              for (let v = 0, r = o.length; v < r; v += 3) {
                const x = o[v] & 255, b = o[v + 1] & 255, I = o[v + 2] & 255, h = x >> 2, y = (x & 3) << 4 | b >> 4, P = v + 1 < r ? (b & 15) << 2 | I >> 6 : 64, c = v + 2 < r ? I & 63 : 64;
                g += l[h] + l[y] + l[P] + l[c];
              }
              return g;
            }, t = function() {
              const o = new Uint8Array([137, 80, 78, 71, 13, 10, 26, 10]), k = 12, s = new Int32Array(256);
              for (let I = 0; I < 256; I++) {
                let h = I;
                for (let y = 0; y < 8; y++)
                  h & 1 ? h = 3988292384 ^ h >> 1 & 2147483647 : h = h >> 1 & 2147483647;
                s[I] = h;
              }
              function l(I, h, y) {
                let P = -1;
                for (let c = h; c < y; c++) {
                  const d = (P ^ I[c]) & 255, A = s[d];
                  P = P >>> 8 ^ A;
                }
                return P ^ -1;
              }
              function g(I, h, y, P) {
                let c = P;
                const d = h.length;
                y[c] = d >> 24 & 255, y[c + 1] = d >> 16 & 255, y[c + 2] = d >> 8 & 255, y[c + 3] = d & 255, c += 4, y[c] = I.charCodeAt(0) & 255, y[c + 1] = I.charCodeAt(1) & 255, y[c + 2] = I.charCodeAt(2) & 255, y[c + 3] = I.charCodeAt(3) & 255, c += 4, y.set(h, c), c += h.length;
                const A = l(y, P + 4, c);
                y[c] = A >> 24 & 255, y[c + 1] = A >> 16 & 255, y[c + 2] = A >> 8 & 255, y[c + 3] = A & 255;
              }
              function v(I, h, y) {
                let P = 1, c = 0;
                for (let d = h; d < y; ++d)
                  P = (P + (I[d] & 255)) % 65521, c = (c + P) % 65521;
                return c << 16 | P;
              }
              function r(I) {
                if (!Me.isNodeJS)
                  return x(I);
                try {
                  let h;
                  parseInt(process.versions.node) >= 8 ? h = I : h = Buffer.from(I);
                  const y = require$$5.deflateSync(h, {
                    level: 9
                  });
                  return y instanceof Uint8Array ? y : new Uint8Array(y);
                } catch (h) {
                  (0, me.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + h);
                }
                return x(I);
              }
              function x(I) {
                let h = I.length;
                const y = 65535, P = Math.ceil(h / y), c = new Uint8Array(2 + h + P * 5 + 4);
                let d = 0;
                c[d++] = 120, c[d++] = 156;
                let A = 0;
                for (; h > y; )
                  c[d++] = 0, c[d++] = 255, c[d++] = 255, c[d++] = 0, c[d++] = 0, c.set(I.subarray(A, A + y), d), d += y, A += y, h -= y;
                c[d++] = 1, c[d++] = h & 255, c[d++] = h >> 8 & 255, c[d++] = ~h & 65535 & 255, c[d++] = (~h & 65535) >> 8 & 255, c.set(I.subarray(A), d), d += I.length - A;
                const N = v(I, 0, I.length);
                return c[d++] = N >> 24 & 255, c[d++] = N >> 16 & 255, c[d++] = N >> 8 & 255, c[d++] = N & 255, c;
              }
              function b(I, h, y, P) {
                const c = I.width, d = I.height;
                let A, N, E;
                const H = I.data;
                switch (h) {
                  case me.ImageKind.GRAYSCALE_1BPP:
                    N = 0, A = 1, E = c + 7 >> 3;
                    break;
                  case me.ImageKind.RGB_24BPP:
                    N = 2, A = 8, E = c * 3;
                    break;
                  case me.ImageKind.RGBA_32BPP:
                    N = 6, A = 8, E = c * 4;
                    break;
                  default:
                    throw new Error("invalid format");
                }
                const $ = new Uint8Array((1 + E) * d);
                let m = 0, p = 0;
                for (let K = 0; K < d; ++K)
                  $[m++] = 0, $.set(H.subarray(p, p + E), m), p += E, m += E;
                if (h === me.ImageKind.GRAYSCALE_1BPP && P) {
                  m = 0;
                  for (let K = 0; K < d; K++) {
                    m++;
                    for (let V = 0; V < E; V++)
                      $[m++] ^= 255;
                  }
                }
                const T = new Uint8Array([c >> 24 & 255, c >> 16 & 255, c >> 8 & 255, c & 255, d >> 24 & 255, d >> 16 & 255, d >> 8 & 255, d & 255, A, N, 0, 0, 0]), L = r($), _ = o.length + k * 3 + T.length + L.length, G = new Uint8Array(_);
                let J = 0;
                return G.set(o, J), J += o.length, g("IHDR", T, G, J), J += k + T.length, g("IDATA", L, G, J), J += k + L.length, g("IEND", new Uint8Array(0), G, J), e(G, "image/png", y);
              }
              return function(h, y, P) {
                const c = h.kind === void 0 ? me.ImageKind.GRAYSCALE_1BPP : h.kind;
                return b(h, c, y, P);
              };
            }();
            class B {
              constructor() {
                this.fontSizeScale = 1, this.fontWeight = F.fontWeight, this.fontSize = 0, this.textMatrix = me.IDENTITY_MATRIX, this.fontMatrix = me.FONT_IDENTITY_MATRIX, this.leading = 0, this.textRenderingMode = me.TextRenderingMode.FILL, this.textMatrixScale = 1, this.x = 0, this.y = 0, this.lineX = 0, this.lineY = 0, this.charSpacing = 0, this.wordSpacing = 0, this.textHScale = 1, this.textRise = 0, this.fillColor = F.fillColor, this.strokeColor = "#000000", this.fillAlpha = 1, this.strokeAlpha = 1, this.lineWidth = 1, this.lineJoin = "", this.lineCap = "", this.miterLimit = 0, this.dashArray = [], this.dashPhase = 0, this.dependencies = [], this.activeClipUrl = null, this.clipGroup = null, this.maskId = "";
              }
              clone() {
                return Object.create(this);
              }
              setCurrentPoint(k, s) {
                this.x = k, this.y = s;
              }
            }
            let w = 0, C = 0, i = 0;
            he.SVGGraphics = xe = class {
              constructor(o, k, s = !1) {
                (0, ue.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future."), this.svgFactory = new ue.DOMSVGFactory(), this.current = new B(), this.transformMatrix = me.IDENTITY_MATRIX, this.transformStack = [], this.extraStack = [], this.commonObjs = o, this.objs = k, this.pendingClip = null, this.pendingEOFill = !1, this.embedFonts = !1, this.embeddedFonts = /* @__PURE__ */ Object.create(null), this.cssStyle = null, this.forceDataSchema = !!s, this._operatorIdMapping = [];
                for (const l in me.OPS)
                  this._operatorIdMapping[me.OPS[l]] = l;
              }
              getObject(o, k = null) {
                return typeof o == "string" ? o.startsWith("g_") ? this.commonObjs.get(o) : this.objs.get(o) : k;
              }
              save() {
                this.transformStack.push(this.transformMatrix);
                const o = this.current;
                this.extraStack.push(o), this.current = o.clone();
              }
              restore() {
                this.transformMatrix = this.transformStack.pop(), this.current = this.extraStack.pop(), this.pendingClip = null, this.tgrp = null;
              }
              group(o) {
                this.save(), this.executeOpTree(o), this.restore();
              }
              loadDependencies(o) {
                const k = o.fnArray, s = o.argsArray;
                for (let l = 0, g = k.length; l < g; l++)
                  if (k[l] === me.OPS.dependency)
                    for (const v of s[l]) {
                      const r = v.startsWith("g_") ? this.commonObjs : this.objs, x = new Promise((b) => {
                        r.get(v, b);
                      });
                      this.current.dependencies.push(x);
                    }
                return Promise.all(this.current.dependencies);
              }
              transform(o, k, s, l, g, v) {
                const r = [o, k, s, l, g, v];
                this.transformMatrix = me.Util.transform(this.transformMatrix, r), this.tgrp = null;
              }
              getSVG(o, k) {
                this.viewport = k;
                const s = this._initialize(k);
                return this.loadDependencies(o).then(() => (this.transformMatrix = me.IDENTITY_MATRIX, this.executeOpTree(this.convertOpList(o)), s));
              }
              convertOpList(o) {
                const k = this._operatorIdMapping, s = o.argsArray, l = o.fnArray, g = [];
                for (let v = 0, r = l.length; v < r; v++) {
                  const x = l[v];
                  g.push({
                    fnId: x,
                    fn: k[x],
                    args: s[v]
                  });
                }
                return j(g);
              }
              executeOpTree(o) {
                for (const k of o) {
                  const s = k.fn, l = k.fnId, g = k.args;
                  switch (l | 0) {
                    case me.OPS.beginText:
                      this.beginText();
                      break;
                    case me.OPS.dependency:
                      break;
                    case me.OPS.setLeading:
                      this.setLeading(g);
                      break;
                    case me.OPS.setLeadingMoveText:
                      this.setLeadingMoveText(g[0], g[1]);
                      break;
                    case me.OPS.setFont:
                      this.setFont(g);
                      break;
                    case me.OPS.showText:
                      this.showText(g[0]);
                      break;
                    case me.OPS.showSpacedText:
                      this.showText(g[0]);
                      break;
                    case me.OPS.endText:
                      this.endText();
                      break;
                    case me.OPS.moveText:
                      this.moveText(g[0], g[1]);
                      break;
                    case me.OPS.setCharSpacing:
                      this.setCharSpacing(g[0]);
                      break;
                    case me.OPS.setWordSpacing:
                      this.setWordSpacing(g[0]);
                      break;
                    case me.OPS.setHScale:
                      this.setHScale(g[0]);
                      break;
                    case me.OPS.setTextMatrix:
                      this.setTextMatrix(g[0], g[1], g[2], g[3], g[4], g[5]);
                      break;
                    case me.OPS.setTextRise:
                      this.setTextRise(g[0]);
                      break;
                    case me.OPS.setTextRenderingMode:
                      this.setTextRenderingMode(g[0]);
                      break;
                    case me.OPS.setLineWidth:
                      this.setLineWidth(g[0]);
                      break;
                    case me.OPS.setLineJoin:
                      this.setLineJoin(g[0]);
                      break;
                    case me.OPS.setLineCap:
                      this.setLineCap(g[0]);
                      break;
                    case me.OPS.setMiterLimit:
                      this.setMiterLimit(g[0]);
                      break;
                    case me.OPS.setFillRGBColor:
                      this.setFillRGBColor(g[0], g[1], g[2]);
                      break;
                    case me.OPS.setStrokeRGBColor:
                      this.setStrokeRGBColor(g[0], g[1], g[2]);
                      break;
                    case me.OPS.setStrokeColorN:
                      this.setStrokeColorN(g);
                      break;
                    case me.OPS.setFillColorN:
                      this.setFillColorN(g);
                      break;
                    case me.OPS.shadingFill:
                      this.shadingFill(g[0]);
                      break;
                    case me.OPS.setDash:
                      this.setDash(g[0], g[1]);
                      break;
                    case me.OPS.setRenderingIntent:
                      this.setRenderingIntent(g[0]);
                      break;
                    case me.OPS.setFlatness:
                      this.setFlatness(g[0]);
                      break;
                    case me.OPS.setGState:
                      this.setGState(g[0]);
                      break;
                    case me.OPS.fill:
                      this.fill();
                      break;
                    case me.OPS.eoFill:
                      this.eoFill();
                      break;
                    case me.OPS.stroke:
                      this.stroke();
                      break;
                    case me.OPS.fillStroke:
                      this.fillStroke();
                      break;
                    case me.OPS.eoFillStroke:
                      this.eoFillStroke();
                      break;
                    case me.OPS.clip:
                      this.clip("nonzero");
                      break;
                    case me.OPS.eoClip:
                      this.clip("evenodd");
                      break;
                    case me.OPS.paintSolidColorImageMask:
                      this.paintSolidColorImageMask();
                      break;
                    case me.OPS.paintImageXObject:
                      this.paintImageXObject(g[0]);
                      break;
                    case me.OPS.paintInlineImageXObject:
                      this.paintInlineImageXObject(g[0]);
                      break;
                    case me.OPS.paintImageMaskXObject:
                      this.paintImageMaskXObject(g[0]);
                      break;
                    case me.OPS.paintFormXObjectBegin:
                      this.paintFormXObjectBegin(g[0], g[1]);
                      break;
                    case me.OPS.paintFormXObjectEnd:
                      this.paintFormXObjectEnd();
                      break;
                    case me.OPS.closePath:
                      this.closePath();
                      break;
                    case me.OPS.closeStroke:
                      this.closeStroke();
                      break;
                    case me.OPS.closeFillStroke:
                      this.closeFillStroke();
                      break;
                    case me.OPS.closeEOFillStroke:
                      this.closeEOFillStroke();
                      break;
                    case me.OPS.nextLine:
                      this.nextLine();
                      break;
                    case me.OPS.transform:
                      this.transform(g[0], g[1], g[2], g[3], g[4], g[5]);
                      break;
                    case me.OPS.constructPath:
                      this.constructPath(g[0], g[1]);
                      break;
                    case me.OPS.endPath:
                      this.endPath();
                      break;
                    case 92:
                      this.group(k.items);
                      break;
                    default:
                      (0, me.warn)(`Unimplemented operator ${s}`);
                      break;
                  }
                }
              }
              setWordSpacing(o) {
                this.current.wordSpacing = o;
              }
              setCharSpacing(o) {
                this.current.charSpacing = o;
              }
              nextLine() {
                this.moveText(0, this.current.leading);
              }
              setTextMatrix(o, k, s, l, g, v) {
                const r = this.current;
                r.textMatrix = r.lineMatrix = [o, k, s, l, g, v], r.textMatrixScale = Math.hypot(o, k), r.x = r.lineX = 0, r.y = r.lineY = 0, r.xcoords = [], r.ycoords = [], r.tspan = this.svgFactory.createElement("svg:tspan"), r.tspan.setAttributeNS(null, "font-family", r.fontFamily), r.tspan.setAttributeNS(null, "font-size", `${M(r.fontSize)}px`), r.tspan.setAttributeNS(null, "y", M(-r.y)), r.txtElement = this.svgFactory.createElement("svg:text"), r.txtElement.append(r.tspan);
              }
              beginText() {
                const o = this.current;
                o.x = o.lineX = 0, o.y = o.lineY = 0, o.textMatrix = me.IDENTITY_MATRIX, o.lineMatrix = me.IDENTITY_MATRIX, o.textMatrixScale = 1, o.tspan = this.svgFactory.createElement("svg:tspan"), o.txtElement = this.svgFactory.createElement("svg:text"), o.txtgrp = this.svgFactory.createElement("svg:g"), o.xcoords = [], o.ycoords = [];
              }
              moveText(o, k) {
                const s = this.current;
                s.x = s.lineX += o, s.y = s.lineY += k, s.xcoords = [], s.ycoords = [], s.tspan = this.svgFactory.createElement("svg:tspan"), s.tspan.setAttributeNS(null, "font-family", s.fontFamily), s.tspan.setAttributeNS(null, "font-size", `${M(s.fontSize)}px`), s.tspan.setAttributeNS(null, "y", M(-s.y));
              }
              showText(o) {
                const k = this.current, s = k.font, l = k.fontSize;
                if (l === 0)
                  return;
                const g = k.fontSizeScale, v = k.charSpacing, r = k.wordSpacing, x = k.fontDirection, b = k.textHScale * x, I = s.vertical, h = I ? 1 : -1, y = s.defaultVMetrics, P = l * k.fontMatrix[0];
                let c = 0;
                for (const N of o) {
                  if (N === null) {
                    c += x * r;
                    continue;
                  } else if (typeof N == "number") {
                    c += h * N * l / 1e3;
                    continue;
                  }
                  const E = (N.isSpace ? r : 0) + v, H = N.fontChar;
                  let $, m, p = N.width;
                  if (I) {
                    let L;
                    const _ = N.vmetric || y;
                    L = N.vmetric ? _[1] : p * 0.5, L = -L * P;
                    const G = _[2] * P;
                    p = _ ? -_[0] : p, $ = L / g, m = (c + G) / g;
                  } else
                    $ = c / g, m = 0;
                  (N.isInFont || s.missingFile) && (k.xcoords.push(k.x + $), I && k.ycoords.push(-k.y + m), k.tspan.textContent += H);
                  let T;
                  I ? T = p * P - E * x : T = p * P + E * x, c += T;
                }
                k.tspan.setAttributeNS(null, "x", k.xcoords.map(M).join(" ")), I ? k.tspan.setAttributeNS(null, "y", k.ycoords.map(M).join(" ")) : k.tspan.setAttributeNS(null, "y", M(-k.y)), I ? k.y -= c : k.x += c * b, k.tspan.setAttributeNS(null, "font-family", k.fontFamily), k.tspan.setAttributeNS(null, "font-size", `${M(k.fontSize)}px`), k.fontStyle !== F.fontStyle && k.tspan.setAttributeNS(null, "font-style", k.fontStyle), k.fontWeight !== F.fontWeight && k.tspan.setAttributeNS(null, "font-weight", k.fontWeight);
                const d = k.textRenderingMode & me.TextRenderingMode.FILL_STROKE_MASK;
                if (d === me.TextRenderingMode.FILL || d === me.TextRenderingMode.FILL_STROKE ? (k.fillColor !== F.fillColor && k.tspan.setAttributeNS(null, "fill", k.fillColor), k.fillAlpha < 1 && k.tspan.setAttributeNS(null, "fill-opacity", k.fillAlpha)) : k.textRenderingMode === me.TextRenderingMode.ADD_TO_PATH ? k.tspan.setAttributeNS(null, "fill", "transparent") : k.tspan.setAttributeNS(null, "fill", "none"), d === me.TextRenderingMode.STROKE || d === me.TextRenderingMode.FILL_STROKE) {
                  const N = 1 / (k.textMatrixScale || 1);
                  this._setStrokeAttributes(k.tspan, N);
                }
                let A = k.textMatrix;
                k.textRise !== 0 && (A = A.slice(), A[5] += k.textRise), k.txtElement.setAttributeNS(null, "transform", `${O(A)} scale(${M(b)}, -1)`), k.txtElement.setAttributeNS(ae, "xml:space", "preserve"), k.txtElement.append(k.tspan), k.txtgrp.append(k.txtElement), this._ensureTransformGroup().append(k.txtElement);
              }
              setLeadingMoveText(o, k) {
                this.setLeading(-k), this.moveText(o, k);
              }
              addFontStyle(o) {
                if (!o.data)
                  throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                this.cssStyle || (this.cssStyle = this.svgFactory.createElement("svg:style"), this.cssStyle.setAttributeNS(null, "type", "text/css"), this.defs.append(this.cssStyle));
                const k = e(o.data, o.mimetype, this.forceDataSchema);
                this.cssStyle.textContent += `@font-face { font-family: "${o.loadedName}"; src: url(${k}); }
`;
              }
              setFont(o) {
                const k = this.current, s = this.commonObjs.get(o[0]);
                let l = o[1];
                k.font = s, this.embedFonts && !s.missingFile && !this.embeddedFonts[s.loadedName] && (this.addFontStyle(s), this.embeddedFonts[s.loadedName] = s), k.fontMatrix = s.fontMatrix || me.FONT_IDENTITY_MATRIX;
                let g = "normal";
                s.black ? g = "900" : s.bold && (g = "bold");
                const v = s.italic ? "italic" : "normal";
                l < 0 ? (l = -l, k.fontDirection = -1) : k.fontDirection = 1, k.fontSize = l, k.fontFamily = s.loadedName, k.fontWeight = g, k.fontStyle = v, k.tspan = this.svgFactory.createElement("svg:tspan"), k.tspan.setAttributeNS(null, "y", M(-k.y)), k.xcoords = [], k.ycoords = [];
              }
              endText() {
                var k;
                const o = this.current;
                o.textRenderingMode & me.TextRenderingMode.ADD_TO_PATH_FLAG && ((k = o.txtElement) != null && k.hasChildNodes()) && (o.element = o.txtElement, this.clip("nonzero"), this.endPath());
              }
              setLineWidth(o) {
                o > 0 && (this.current.lineWidth = o);
              }
              setLineCap(o) {
                this.current.lineCap = u[o];
              }
              setLineJoin(o) {
                this.current.lineJoin = q[o];
              }
              setMiterLimit(o) {
                this.current.miterLimit = o;
              }
              setStrokeAlpha(o) {
                this.current.strokeAlpha = o;
              }
              setStrokeRGBColor(o, k, s) {
                this.current.strokeColor = me.Util.makeHexColor(o, k, s);
              }
              setFillAlpha(o) {
                this.current.fillAlpha = o;
              }
              setFillRGBColor(o, k, s) {
                this.current.fillColor = me.Util.makeHexColor(o, k, s), this.current.tspan = this.svgFactory.createElement("svg:tspan"), this.current.xcoords = [], this.current.ycoords = [];
              }
              setStrokeColorN(o) {
                this.current.strokeColor = this._makeColorN_Pattern(o);
              }
              setFillColorN(o) {
                this.current.fillColor = this._makeColorN_Pattern(o);
              }
              shadingFill(o) {
                const k = this.viewport.width, s = this.viewport.height, l = me.Util.inverseTransform(this.transformMatrix), g = me.Util.applyTransform([0, 0], l), v = me.Util.applyTransform([0, s], l), r = me.Util.applyTransform([k, 0], l), x = me.Util.applyTransform([k, s], l), b = Math.min(g[0], v[0], r[0], x[0]), I = Math.min(g[1], v[1], r[1], x[1]), h = Math.max(g[0], v[0], r[0], x[0]), y = Math.max(g[1], v[1], r[1], x[1]), P = this.svgFactory.createElement("svg:rect");
                P.setAttributeNS(null, "x", b), P.setAttributeNS(null, "y", I), P.setAttributeNS(null, "width", h - b), P.setAttributeNS(null, "height", y - I), P.setAttributeNS(null, "fill", this._makeShadingPattern(o)), this.current.fillAlpha < 1 && P.setAttributeNS(null, "fill-opacity", this.current.fillAlpha), this._ensureTransformGroup().append(P);
              }
              _makeColorN_Pattern(o) {
                return o[0] === "TilingPattern" ? this._makeTilingPattern(o) : this._makeShadingPattern(o);
              }
              _makeTilingPattern(o) {
                const k = o[1], s = o[2], l = o[3] || me.IDENTITY_MATRIX, [g, v, r, x] = o[4], b = o[5], I = o[6], h = o[7], y = `shading${i++}`, [P, c, d, A] = me.Util.normalizeRect([...me.Util.applyTransform([g, v], l), ...me.Util.applyTransform([r, x], l)]), [N, E] = me.Util.singularValueDecompose2dScale(l), H = b * N, $ = I * E, m = this.svgFactory.createElement("svg:pattern");
                m.setAttributeNS(null, "id", y), m.setAttributeNS(null, "patternUnits", "userSpaceOnUse"), m.setAttributeNS(null, "width", H), m.setAttributeNS(null, "height", $), m.setAttributeNS(null, "x", `${P}`), m.setAttributeNS(null, "y", `${c}`);
                const p = this.svg, T = this.transformMatrix, L = this.current.fillColor, _ = this.current.strokeColor, G = this.svgFactory.create(d - P, A - c);
                if (this.svg = G, this.transformMatrix = l, h === 2) {
                  const J = me.Util.makeHexColor(...k);
                  this.current.fillColor = J, this.current.strokeColor = J;
                }
                return this.executeOpTree(this.convertOpList(s)), this.svg = p, this.transformMatrix = T, this.current.fillColor = L, this.current.strokeColor = _, m.append(G.childNodes[0]), this.defs.append(m), `url(#${y})`;
              }
              _makeShadingPattern(o) {
                switch (typeof o == "string" && (o = this.objs.get(o)), o[0]) {
                  case "RadialAxial":
                    const k = `shading${i++}`, s = o[3];
                    let l;
                    switch (o[1]) {
                      case "axial":
                        const g = o[4], v = o[5];
                        l = this.svgFactory.createElement("svg:linearGradient"), l.setAttributeNS(null, "id", k), l.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), l.setAttributeNS(null, "x1", g[0]), l.setAttributeNS(null, "y1", g[1]), l.setAttributeNS(null, "x2", v[0]), l.setAttributeNS(null, "y2", v[1]);
                        break;
                      case "radial":
                        const r = o[4], x = o[5], b = o[6], I = o[7];
                        l = this.svgFactory.createElement("svg:radialGradient"), l.setAttributeNS(null, "id", k), l.setAttributeNS(null, "gradientUnits", "userSpaceOnUse"), l.setAttributeNS(null, "cx", x[0]), l.setAttributeNS(null, "cy", x[1]), l.setAttributeNS(null, "r", I), l.setAttributeNS(null, "fx", r[0]), l.setAttributeNS(null, "fy", r[1]), l.setAttributeNS(null, "fr", b);
                        break;
                      default:
                        throw new Error(`Unknown RadialAxial type: ${o[1]}`);
                    }
                    for (const g of s) {
                      const v = this.svgFactory.createElement("svg:stop");
                      v.setAttributeNS(null, "offset", g[0]), v.setAttributeNS(null, "stop-color", g[1]), l.append(v);
                    }
                    return this.defs.append(l), `url(#${k})`;
                  case "Mesh":
                    return (0, me.warn)("Unimplemented pattern Mesh"), null;
                  case "Dummy":
                    return "hotpink";
                  default:
                    throw new Error(`Unknown IR type: ${o[0]}`);
                }
              }
              setDash(o, k) {
                this.current.dashArray = o, this.current.dashPhase = k;
              }
              constructPath(o, k) {
                const s = this.current;
                let l = s.x, g = s.y, v = [], r = 0;
                for (const x of o)
                  switch (x | 0) {
                    case me.OPS.rectangle:
                      l = k[r++], g = k[r++];
                      const b = k[r++], I = k[r++], h = l + b, y = g + I;
                      v.push("M", M(l), M(g), "L", M(h), M(g), "L", M(h), M(y), "L", M(l), M(y), "Z");
                      break;
                    case me.OPS.moveTo:
                      l = k[r++], g = k[r++], v.push("M", M(l), M(g));
                      break;
                    case me.OPS.lineTo:
                      l = k[r++], g = k[r++], v.push("L", M(l), M(g));
                      break;
                    case me.OPS.curveTo:
                      l = k[r + 4], g = k[r + 5], v.push("C", M(k[r]), M(k[r + 1]), M(k[r + 2]), M(k[r + 3]), M(l), M(g)), r += 6;
                      break;
                    case me.OPS.curveTo2:
                      v.push("C", M(l), M(g), M(k[r]), M(k[r + 1]), M(k[r + 2]), M(k[r + 3])), l = k[r + 2], g = k[r + 3], r += 4;
                      break;
                    case me.OPS.curveTo3:
                      l = k[r + 2], g = k[r + 3], v.push("C", M(k[r]), M(k[r + 1]), M(l), M(g), M(l), M(g)), r += 4;
                      break;
                    case me.OPS.closePath:
                      v.push("Z");
                      break;
                  }
                v = v.join(" "), s.path && o.length > 0 && o[0] !== me.OPS.rectangle && o[0] !== me.OPS.moveTo ? v = s.path.getAttributeNS(null, "d") + v : (s.path = this.svgFactory.createElement("svg:path"), this._ensureTransformGroup().append(s.path)), s.path.setAttributeNS(null, "d", v), s.path.setAttributeNS(null, "fill", "none"), s.element = s.path, s.setCurrentPoint(l, g);
              }
              endPath() {
                const o = this.current;
                if (o.path = null, !this.pendingClip)
                  return;
                if (!o.element) {
                  this.pendingClip = null;
                  return;
                }
                const k = `clippath${w++}`, s = this.svgFactory.createElement("svg:clipPath");
                s.setAttributeNS(null, "id", k), s.setAttributeNS(null, "transform", O(this.transformMatrix));
                const l = o.element.cloneNode(!0);
                if (this.pendingClip === "evenodd" ? l.setAttributeNS(null, "clip-rule", "evenodd") : l.setAttributeNS(null, "clip-rule", "nonzero"), this.pendingClip = null, s.append(l), this.defs.append(s), o.activeClipUrl) {
                  o.clipGroup = null;
                  for (const g of this.extraStack)
                    g.clipGroup = null;
                  s.setAttributeNS(null, "clip-path", o.activeClipUrl);
                }
                o.activeClipUrl = `url(#${k})`, this.tgrp = null;
              }
              clip(o) {
                this.pendingClip = o;
              }
              closePath() {
                const o = this.current;
                if (o.path) {
                  const k = `${o.path.getAttributeNS(null, "d")}Z`;
                  o.path.setAttributeNS(null, "d", k);
                }
              }
              setLeading(o) {
                this.current.leading = -o;
              }
              setTextRise(o) {
                this.current.textRise = o;
              }
              setTextRenderingMode(o) {
                this.current.textRenderingMode = o;
              }
              setHScale(o) {
                this.current.textHScale = o / 100;
              }
              setRenderingIntent(o) {
              }
              setFlatness(o) {
              }
              setGState(o) {
                for (const [k, s] of o)
                  switch (k) {
                    case "LW":
                      this.setLineWidth(s);
                      break;
                    case "LC":
                      this.setLineCap(s);
                      break;
                    case "LJ":
                      this.setLineJoin(s);
                      break;
                    case "ML":
                      this.setMiterLimit(s);
                      break;
                    case "D":
                      this.setDash(s[0], s[1]);
                      break;
                    case "RI":
                      this.setRenderingIntent(s);
                      break;
                    case "FL":
                      this.setFlatness(s);
                      break;
                    case "Font":
                      this.setFont(s);
                      break;
                    case "CA":
                      this.setStrokeAlpha(s);
                      break;
                    case "ca":
                      this.setFillAlpha(s);
                      break;
                    default:
                      (0, me.warn)(`Unimplemented graphic state operator ${k}`);
                      break;
                  }
              }
              fill() {
                const o = this.current;
                o.element && (o.element.setAttributeNS(null, "fill", o.fillColor), o.element.setAttributeNS(null, "fill-opacity", o.fillAlpha), this.endPath());
              }
              stroke() {
                const o = this.current;
                o.element && (this._setStrokeAttributes(o.element), o.element.setAttributeNS(null, "fill", "none"), this.endPath());
              }
              _setStrokeAttributes(o, k = 1) {
                const s = this.current;
                let l = s.dashArray;
                k !== 1 && l.length > 0 && (l = l.map(function(g) {
                  return k * g;
                })), o.setAttributeNS(null, "stroke", s.strokeColor), o.setAttributeNS(null, "stroke-opacity", s.strokeAlpha), o.setAttributeNS(null, "stroke-miterlimit", M(s.miterLimit)), o.setAttributeNS(null, "stroke-linecap", s.lineCap), o.setAttributeNS(null, "stroke-linejoin", s.lineJoin), o.setAttributeNS(null, "stroke-width", M(k * s.lineWidth) + "px"), o.setAttributeNS(null, "stroke-dasharray", l.map(M).join(" ")), o.setAttributeNS(null, "stroke-dashoffset", M(k * s.dashPhase) + "px");
              }
              eoFill() {
                var o;
                (o = this.current.element) == null || o.setAttributeNS(null, "fill-rule", "evenodd"), this.fill();
              }
              fillStroke() {
                this.stroke(), this.fill();
              }
              eoFillStroke() {
                var o;
                (o = this.current.element) == null || o.setAttributeNS(null, "fill-rule", "evenodd"), this.fillStroke();
              }
              closeStroke() {
                this.closePath(), this.stroke();
              }
              closeFillStroke() {
                this.closePath(), this.fillStroke();
              }
              closeEOFillStroke() {
                this.closePath(), this.eoFillStroke();
              }
              paintSolidColorImageMask() {
                const o = this.svgFactory.createElement("svg:rect");
                o.setAttributeNS(null, "x", "0"), o.setAttributeNS(null, "y", "0"), o.setAttributeNS(null, "width", "1px"), o.setAttributeNS(null, "height", "1px"), o.setAttributeNS(null, "fill", this.current.fillColor), this._ensureTransformGroup().append(o);
              }
              paintImageXObject(o) {
                const k = this.getObject(o);
                if (!k) {
                  (0, me.warn)(`Dependent image with object ID ${o} is not ready yet`);
                  return;
                }
                this.paintInlineImageXObject(k);
              }
              paintInlineImageXObject(o, k) {
                const s = o.width, l = o.height, g = t(o, this.forceDataSchema, !!k), v = this.svgFactory.createElement("svg:rect");
                v.setAttributeNS(null, "x", "0"), v.setAttributeNS(null, "y", "0"), v.setAttributeNS(null, "width", M(s)), v.setAttributeNS(null, "height", M(l)), this.current.element = v, this.clip("nonzero");
                const r = this.svgFactory.createElement("svg:image");
                r.setAttributeNS(n, "xlink:href", g), r.setAttributeNS(null, "x", "0"), r.setAttributeNS(null, "y", M(-l)), r.setAttributeNS(null, "width", M(s) + "px"), r.setAttributeNS(null, "height", M(l) + "px"), r.setAttributeNS(null, "transform", `scale(${M(1 / s)} ${M(-1 / l)})`), k ? k.append(r) : this._ensureTransformGroup().append(r);
              }
              paintImageMaskXObject(o) {
                const k = this.getObject(o.data, o);
                if (k.bitmap) {
                  (0, me.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                  return;
                }
                const s = this.current, l = k.width, g = k.height, v = s.fillColor;
                s.maskId = `mask${C++}`;
                const r = this.svgFactory.createElement("svg:mask");
                r.setAttributeNS(null, "id", s.maskId);
                const x = this.svgFactory.createElement("svg:rect");
                x.setAttributeNS(null, "x", "0"), x.setAttributeNS(null, "y", "0"), x.setAttributeNS(null, "width", M(l)), x.setAttributeNS(null, "height", M(g)), x.setAttributeNS(null, "fill", v), x.setAttributeNS(null, "mask", `url(#${s.maskId})`), this.defs.append(r), this._ensureTransformGroup().append(x), this.paintInlineImageXObject(k, r);
              }
              paintFormXObjectBegin(o, k) {
                if (Array.isArray(o) && o.length === 6 && this.transform(o[0], o[1], o[2], o[3], o[4], o[5]), k) {
                  const s = k[2] - k[0], l = k[3] - k[1], g = this.svgFactory.createElement("svg:rect");
                  g.setAttributeNS(null, "x", k[0]), g.setAttributeNS(null, "y", k[1]), g.setAttributeNS(null, "width", M(s)), g.setAttributeNS(null, "height", M(l)), this.current.element = g, this.clip("nonzero"), this.endPath();
                }
              }
              paintFormXObjectEnd() {
              }
              _initialize(o) {
                const k = this.svgFactory.create(o.width, o.height), s = this.svgFactory.createElement("svg:defs");
                k.append(s), this.defs = s;
                const l = this.svgFactory.createElement("svg:g");
                return l.setAttributeNS(null, "transform", O(o.transform)), k.append(l), this.svg = l, k;
              }
              _ensureClipGroup() {
                if (!this.current.clipGroup) {
                  const o = this.svgFactory.createElement("svg:g");
                  o.setAttributeNS(null, "clip-path", this.current.activeClipUrl), this.svg.append(o), this.current.clipGroup = o;
                }
                return this.current.clipGroup;
              }
              _ensureTransformGroup() {
                return this.tgrp || (this.tgrp = this.svgFactory.createElement("svg:g"), this.tgrp.setAttributeNS(null, "transform", O(this.transformMatrix)), this.current.activeClipUrl ? this._ensureClipGroup().append(this.tgrp) : this.svg.append(this.tgrp)), this.tgrp;
              }
            };
          }
        }
        /******/
      ], __webpack_module_cache__ = {};
      function __w_pdfjs_require__(Se) {
        var he = __webpack_module_cache__[Se];
        if (he !== void 0)
          return he.exports;
        var ke = __webpack_module_cache__[Se] = {
          /******/
          // no module.id needed
          /******/
          // no module.loaded needed
          /******/
          exports: {}
          /******/
        };
        return __webpack_modules__[Se](ke, ke.exports, __w_pdfjs_require__), ke.exports;
      }
      var __webpack_exports__ = {};
      return (() => {
        var Se = __webpack_exports__;
        Object.defineProperty(Se, "__esModule", {
          value: !0
        }), Object.defineProperty(Se, "AbortException", {
          enumerable: !0,
          get: function() {
            return he.AbortException;
          }
        }), Object.defineProperty(Se, "AnnotationEditorLayer", {
          enumerable: !0,
          get: function() {
            return Me.AnnotationEditorLayer;
          }
        }), Object.defineProperty(Se, "AnnotationEditorParamsType", {
          enumerable: !0,
          get: function() {
            return he.AnnotationEditorParamsType;
          }
        }), Object.defineProperty(Se, "AnnotationEditorType", {
          enumerable: !0,
          get: function() {
            return he.AnnotationEditorType;
          }
        }), Object.defineProperty(Se, "AnnotationEditorUIManager", {
          enumerable: !0,
          get: function() {
            return xe.AnnotationEditorUIManager;
          }
        }), Object.defineProperty(Se, "AnnotationLayer", {
          enumerable: !0,
          get: function() {
            return F.AnnotationLayer;
          }
        }), Object.defineProperty(Se, "AnnotationMode", {
          enumerable: !0,
          get: function() {
            return he.AnnotationMode;
          }
        }), Object.defineProperty(Se, "CMapCompressionType", {
          enumerable: !0,
          get: function() {
            return he.CMapCompressionType;
          }
        }), Object.defineProperty(Se, "FeatureTest", {
          enumerable: !0,
          get: function() {
            return he.FeatureTest;
          }
        }), Object.defineProperty(Se, "GlobalWorkerOptions", {
          enumerable: !0,
          get: function() {
            return ae.GlobalWorkerOptions;
          }
        }), Object.defineProperty(Se, "InvalidPDFException", {
          enumerable: !0,
          get: function() {
            return he.InvalidPDFException;
          }
        }), Object.defineProperty(Se, "MissingPDFException", {
          enumerable: !0,
          get: function() {
            return he.MissingPDFException;
          }
        }), Object.defineProperty(Se, "OPS", {
          enumerable: !0,
          get: function() {
            return he.OPS;
          }
        }), Object.defineProperty(Se, "PDFDataRangeTransport", {
          enumerable: !0,
          get: function() {
            return ke.PDFDataRangeTransport;
          }
        }), Object.defineProperty(Se, "PDFDateString", {
          enumerable: !0,
          get: function() {
            return ue.PDFDateString;
          }
        }), Object.defineProperty(Se, "PDFWorker", {
          enumerable: !0,
          get: function() {
            return ke.PDFWorker;
          }
        }), Object.defineProperty(Se, "PasswordResponses", {
          enumerable: !0,
          get: function() {
            return he.PasswordResponses;
          }
        }), Object.defineProperty(Se, "PermissionFlag", {
          enumerable: !0,
          get: function() {
            return he.PermissionFlag;
          }
        }), Object.defineProperty(Se, "PixelsPerInch", {
          enumerable: !0,
          get: function() {
            return ue.PixelsPerInch;
          }
        }), Object.defineProperty(Se, "PromiseCapability", {
          enumerable: !0,
          get: function() {
            return he.PromiseCapability;
          }
        }), Object.defineProperty(Se, "RenderingCancelledException", {
          enumerable: !0,
          get: function() {
            return ue.RenderingCancelledException;
          }
        }), Object.defineProperty(Se, "SVGGraphics", {
          enumerable: !0,
          get: function() {
            return n.SVGGraphics;
          }
        }), Object.defineProperty(Se, "UnexpectedResponseException", {
          enumerable: !0,
          get: function() {
            return he.UnexpectedResponseException;
          }
        }), Object.defineProperty(Se, "Util", {
          enumerable: !0,
          get: function() {
            return he.Util;
          }
        }), Object.defineProperty(Se, "VerbosityLevel", {
          enumerable: !0,
          get: function() {
            return he.VerbosityLevel;
          }
        }), Object.defineProperty(Se, "XfaLayer", {
          enumerable: !0,
          get: function() {
            return u.XfaLayer;
          }
        }), Object.defineProperty(Se, "build", {
          enumerable: !0,
          get: function() {
            return ke.build;
          }
        }), Object.defineProperty(Se, "createValidAbsoluteUrl", {
          enumerable: !0,
          get: function() {
            return he.createValidAbsoluteUrl;
          }
        }), Object.defineProperty(Se, "getDocument", {
          enumerable: !0,
          get: function() {
            return ke.getDocument;
          }
        }), Object.defineProperty(Se, "getFilenameFromUrl", {
          enumerable: !0,
          get: function() {
            return ue.getFilenameFromUrl;
          }
        }), Object.defineProperty(Se, "getPdfFilenameFromUrl", {
          enumerable: !0,
          get: function() {
            return ue.getPdfFilenameFromUrl;
          }
        }), Object.defineProperty(Se, "getXfaPageViewport", {
          enumerable: !0,
          get: function() {
            return ue.getXfaPageViewport;
          }
        }), Object.defineProperty(Se, "isDataScheme", {
          enumerable: !0,
          get: function() {
            return ue.isDataScheme;
          }
        }), Object.defineProperty(Se, "isPdfFile", {
          enumerable: !0,
          get: function() {
            return ue.isPdfFile;
          }
        }), Object.defineProperty(Se, "loadScript", {
          enumerable: !0,
          get: function() {
            return ue.loadScript;
          }
        }), Object.defineProperty(Se, "normalizeUnicode", {
          enumerable: !0,
          get: function() {
            return he.normalizeUnicode;
          }
        }), Object.defineProperty(Se, "renderTextLayer", {
          enumerable: !0,
          get: function() {
            return me.renderTextLayer;
          }
        }), Object.defineProperty(Se, "setLayerDimensions", {
          enumerable: !0,
          get: function() {
            return ue.setLayerDimensions;
          }
        }), Object.defineProperty(Se, "shadow", {
          enumerable: !0,
          get: function() {
            return he.shadow;
          }
        }), Object.defineProperty(Se, "updateTextLayer", {
          enumerable: !0,
          get: function() {
            return me.updateTextLayer;
          }
        }), Object.defineProperty(Se, "version", {
          enumerable: !0,
          get: function() {
            return ke.version;
          }
        });
        var he = __w_pdfjs_require__(1), ke = __w_pdfjs_require__(2), ue = __w_pdfjs_require__(6), me = __w_pdfjs_require__(26), Me = __w_pdfjs_require__(27), xe = __w_pdfjs_require__(5), F = __w_pdfjs_require__(30), ae = __w_pdfjs_require__(14), n = __w_pdfjs_require__(33), u = __w_pdfjs_require__(32);
      })(), __webpack_exports__;
    })()
  ));
})(pdf);
var pdfExports = pdf.exports;
const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /Macintosh/i.test(navigator.userAgent), DEFAULT_ZOOM_LEVEL = 1.25, scale = () => isIOS() ? devicePixelRatio : devicePixelRatio * 3, parsePdfFromBase64String = (Se) => atob(Se.replace(/^(data:application\/pdf;base64,)/gi, "")), getDocumentParameters = (Se) => {
  let he = {
    verbosity: 0
  };
  return typeof Se.data == "string" ? he.data = parsePdfFromBase64String(Se.data) : typeof Se.url == "string" ? he.url = Se.url : Se.arrayBuffer instanceof ArrayBuffer ? he = Se.arrayBuffer : Se.typedArray && (he = Se.typedArray), he;
}, removeChildren = (Se) => {
  for (; Se.firstChild; )
    Se.removeChild(Se.firstChild);
}, appendPage = (Se, he, ke) => {
  ke === 0 && removeChildren(Se), Se.appendChild(he);
}, download$1 = (Se, he = "Document", ke = {}, ue) => {
  Se.pdf && Se.pdf.getData().then((me) => new Blob([me], { type: "application/pdf" })).then((me) => {
    ue(me, he, ke) || saveAs(me, he, ke);
  }).catch((me) => {
    Se.error.call(void 0, me);
  });
}, loadPDF = (Se) => {
  const he = getDocumentParameters(Se), { dom: ke, zoom: ue, done: me, error: Me } = Se;
  pdfExports.getDocument(he).promise.then((xe) => {
    const F = [];
    for (let ae = 1; ae <= xe.numPages; ae++)
      F.push(xe.getPage(ae));
    return { pages: F, pdfDoc: xe };
  }).then(({ pages: xe, pdfDoc: F }) => {
    Promise.all(xe).then((ae) => ae.map((n, u) => (appendPage(ke, renderPage(n, ue, Me), u), n))).then((ae) => {
      me({ pdfPages: ae, pdfDoc: F, zoom: ue });
    }).catch((ae) => {
      Se.error(ae);
    });
  }).catch((xe) => {
    Se.error(xe);
  });
}, reloadDocument = (Se) => {
  const { pdfDoc: he, zoom: ke, dom: ue, done: me, error: Me } = Se, xe = [];
  for (let F = 1; F <= he.numPages; F++)
    xe.push(he.getPage(F));
  Promise.all(xe).then((F) => F.map((ae, n) => (appendPage(ue, renderPage(ae, ke, Me), n), ae))).then(me).catch(Me);
}, print$1 = (Se, he, ke) => {
  const ue = document.createElement("div"), me = Se.map(() => !1), Me = scale();
  Se.forEach((xe, F) => {
    const ae = renderCanvas(xe, (n) => {
      ue.appendChild(n), me[F] = !0, me.every(Boolean) && openPrintDialog(ue, Math.floor(ae.width / Me), Math.floor(ae.height / Me), he, ke);
    }, ke);
  });
}, openPrintDialog = (Se, he, ke, ue, me) => {
  const Me = window.open("", "", "innerWidth=" + he + ",innerHeight=" + ke + "location=no,titlebar=no,toolbar=no");
  if (!Me || !Me.document) {
    me();
    return;
  }
  if (Me) {
    Me.document.body.style.margin = "0", Me.document.body.appendChild(Se), Me.focus(), setTimeout(() => {
      Me.print(), ue();
    });
    const xe = () => {
      Me.removeEventListener("afterprint", xe), Me.close();
    };
    Me.addEventListener("afterprint", xe);
  }
}, renderCanvas = (Se, he, ke) => {
  const ue = scale(), me = Se.getViewport({ scale: ue }), Me = {
    width: Math.floor(me.width / ue) + "pt",
    height: Math.floor(me.height / ue) + "pt"
  }, xe = createElement("div", "", Me), F = createElement("canvas", "", {
    width: "100%",
    height: "100%"
  });
  F.height = me.height, F.width = me.width;
  const ae = F.getContext("2d");
  return xe.appendChild(F), Se.render({ canvasContext: ae, viewport: me }).promise.then(() => {
    const n = new Image(Math.floor(me.width / ue), Math.floor(me.height / ue));
    n.src = F.toDataURL(), xe.removeChild(F), xe.appendChild(n);
    const u = () => {
      n.removeEventListener("load", u), he(xe);
    };
    n.addEventListener("load", u);
  }).catch(ke), me;
}, createElement = function(Se, he, ke) {
  const ue = document.createElement(Se);
  return he && (ue.className = he), Object.keys(ke).forEach((me) => ue.style[me] = ke[me]), ue;
}, renderPage = (Se, he, ke) => {
  const ue = scale(), me = Se.getViewport({ scale: ue }), Me = {
    width: Math.floor(me.width / ue) * he + "pt",
    height: Math.floor(me.height / ue) * he + "pt"
  }, xe = createElement("div", "k-page", Me), F = createElement("canvas", "", {
    width: "100%",
    height: "100%"
  });
  F.height = me.height, F.width = me.width;
  const ae = F.getContext("2d");
  return xe.appendChild(F), Se.render({ canvasContext: ae, viewport: me }).promise.then(() => {
    Se.getTextContent().then((n) => {
      const u = createElement("div", "k-text-layer", Me);
      pdfExports.renderTextLayer({
        textContentSource: n,
        container: u,
        viewport: me,
        textDivs: []
      }).promise.then(() => {
        u.style.width = u.style.width.replace(/px/g, "pt"), u.style.height = u.style.height.replace(/px/g, "pt"), u.querySelectorAll("span").forEach((q) => {
          q.style.fontSize && (q.style.fontSize = q.style.fontSize.replace(/px/g, "pt"));
        }), xe.appendChild(u);
      }).catch(ke);
    });
  }).catch(ke), xe;
}, searchMatchScrollLeftOffset = 0, searchMatchScrollTopOffset = -64, scrollToSearchMatch = (Se, he) => {
  if (!Se)
    return;
  const ke = Se.closest(".k-text-char"), ue = ke ? ke.closest('span[role="presentation"]') : null;
  if (!ue)
    return;
  const me = ue.closest(".k-page");
  if (!me)
    return;
  const Me = me.offsetLeft + -1 * he.scroller.element.offsetLeft + ue.offsetLeft + searchMatchScrollLeftOffset, xe = me.offsetTop + -1 * he.scroller.element.offsetTop + ue.offsetTop + searchMatchScrollTopOffset;
  he.scroller.scrollTo(Me, xe, { trackScrollEvent: !1 });
}, goToNextSearchMatch = (Se) => {
  Se.search.markNextMatch();
  const he = Se.search.getActiveMatchElement();
  scrollToSearchMatch(he, Se);
}, goToPreviousSearchMatch = (Se) => {
  Se.search.markPreviousMatch();
  const he = Se.search.getActiveMatchElement();
  scrollToSearchMatch(he, Se);
}, calculateZoomLevel = (Se, he, ke, ue) => {
  const me = ue.closest(".k-pdf-viewer-canvas"), Me = ue.querySelector(".k-page"), xe = { width: Me.offsetWidth, height: Me.offsetHeight };
  let F = Se;
  return he === "ActualWidth" ? F = 1 : he === "FitToWidth" ? F = me.offsetWidth / (xe.width / ke) : he === "FitToPage" && (F = me.offsetHeight / (xe.height / ke)), F;
}, scrollToPage = (Se, he) => {
  const ke = Se.querySelectorAll(".k-page"), ue = ke[0];
  if (ue instanceof HTMLDivElement) {
    const me = (ue.offsetHeight + ue.offsetTop) * Math.max(0, Math.min(he, ke.length - 1)), Me = ue.closest(".k-pdf-viewer-canvas");
    Me && Me.scrollTo({ top: me, behavior: "auto" });
  }
}, currentPage = (Se) => {
  const he = Se.querySelector(".k-pdf-viewer-canvas"), ke = Se.querySelector(".k-page");
  return he && ke ? Math.floor(Math.round(he.scrollTop) / (ke.offsetHeight + ke.offsetTop) + 0.01) : 0;
}, zoomIn = "pdfviewer.zoomIn", zoomOut = "pdfviewer.zoomOut", enableSelection = "pdfviewer.enableSelection", enablePanning = "pdfviewer.enablePanning", search = "pdfviewer.search", open = "pdfviewer.open", download = "pdfviewer.download", print = "pdfviewer.print", close = "pdfviewer.close", matchCase = "pdfviewer.matchCase", prevMatch = "pdfviewer.prevMatch", nextMatch = "pdfviewer.nextMatch", actualWidth = "pdfviewer.actualWidth", fitToWidth = "pdfviewer.fitToWidth", fitToPage = "pdfviewer.fitToPage", popupBlocked = "pdfviewer.popupBlocked", messages = {
  [zoomIn]: "Zoom in",
  [zoomOut]: "Zoom out",
  [enableSelection]: "Enable selection",
  [enablePanning]: "Enable panning",
  [search]: "Search",
  [open]: "Open",
  [download]: "Download",
  [print]: "Print",
  [close]: "Close",
  [matchCase]: "Match case",
  [prevMatch]: "Previous match",
  [nextMatch]: "Next match",
  [actualWidth]: "Actual width",
  [fitToWidth]: "Fit to width",
  [fitToPage]: "Fit to page",
  [popupBlocked]: "Popup is blocked."
}, toolNames = [
  "pager",
  "spacer",
  "zoomInOut",
  "zoom",
  "selection",
  "spacer",
  "search",
  "open",
  "download",
  "print"
], defaultProps = {
  minZoom: 0.5,
  maxZoom: 4,
  tools: [...toolNames],
  zoomRate: 0.25,
  zoomLevels: [
    { id: 1, priority: 1, value: 1, text: "Actual width", type: "ActualWidth", locationString: actualWidth },
    { id: 2, priority: 2, value: 1, text: "Fit to width", type: "FitToWidth", locationString: fitToWidth },
    { id: 3, priority: 3, value: 1, text: "Fit to page", type: "FitToPage", locationString: fitToPage },
    { id: 4, priority: 4, value: 0.5, text: "50%", type: "" },
    { id: 5, priority: 5, value: 0.75, text: "75%", type: "" },
    { id: 6, priority: 100, value: 1, text: "100%", type: "" },
    { id: 7, priority: 7, value: 1.25, text: "125%", type: "" },
    { id: 8, priority: 8, value: 1.5, text: "150%", type: "" },
    { id: 9, priority: 9, value: 2, text: "200%", type: "" },
    { id: 10, priority: 10, value: 3, text: "300%", type: "" },
    { id: 11, priority: 11, value: 4, text: "400%", type: "" }
  ],
  defaultZoom: DEFAULT_ZOOM_LEVEL
}, navigation = [
  ".k-toolbar > button",
  ".k-toolbar .k-combobox > input",
  ".k-toolbar .k-button-group > button",
  ".k-toolbar .k-pager > a",
  ".k-toolbar .k-pager input"
], sortByPriority = (Se, he) => Se.priority > he.priority ? -1 : Se.priority < he.priority ? 1 : 0, PDFViewer$1 = React.forwardRef((Se, he) => {
  validatePackage(packageMetadata);
  const ke = shouldShowValidationUI(packageMetadata), { zoom: ue, zoomLevels: me = defaultProps.zoomLevels, defaultZoom: Me = defaultProps.defaultZoom, minZoom: xe = defaultProps.minZoom, maxZoom: F = defaultProps.maxZoom, zoomRate: ae = defaultProps.zoomRate } = Se, n = S(), u = React.useRef(null), [q, e] = React.useState(Me), t = ue !== void 0 ? ue : q, B = me.slice().sort(sortByPriority).find((Ae) => Ae.value === t) || { text: t * 100 + "%", value: t, id: t, locationString: "" };
  B.locationString && (B.text = n.toLanguageString(B.locationString, messages[B.locationString]));
  const [j, M] = React.useState(!1), [O, w] = React.useState(!0), [C, i] = React.useState(0), [o, k] = React.useState(!1), [s, l] = React.useState(!1), [g, v] = React.useState(0), [r, x] = React.useState(0), [b, I] = React.useState(!1), [h, y] = React.useState(""), P = React.useMemo(() => ({}), []);
  P.currentZoom = t, P.props = Se;
  const c = React.useCallback((Ae) => {
    u.current && u.current.style.setProperty("--scale-factor", String(Ae));
  }, []), d = React.useRef(null), A = React.useRef(null);
  React.useImperativeHandle(d, () => ({
    element: A.current,
    props: Se,
    pages: P.pages,
    document: P.document
  }), []), React.useImperativeHandle(he, () => d.current);
  const N = React.useCallback(() => {
    if (P.props.onLoad) {
      const Ae = { target: d.current };
      P.props.onLoad.call(void 0, Ae);
    }
  }, []), E = React.useCallback((Ae, Pe, Re) => {
    if (Se.onDownload) {
      const Ee = {
        target: d.current,
        blob: Ae,
        fileName: Pe,
        saveOptions: Re
      };
      return Se.onDownload.call(void 0, Ee) === !1;
    }
    return !1;
  }, [Se.onDownload]), H = React.useCallback(() => {
    var Ae;
    P.scroller && P.scroller.destroy(), P.scroller = new Scroller((Ae = u.current) === null || Ae === void 0 ? void 0 : Ae.parentNode, {
      filter: ".k-page",
      events: {}
    }), P.scroller.enablePanEventsTracking();
  }, []), $ = React.useCallback((Ae) => {
    const Pe = Array.from(Ae.querySelectorAll(".k-text-layer"));
    P.search = new SearchService({
      textContainers: Pe || [],
      highlightClass: "k-search-highlight",
      highlightMarkClass: "k-search-highlight-mark",
      charClass: "k-text-char"
    });
  }, []);
  P.done = React.useCallback(({ pdfPages: Ae, pdfDoc: Pe, zoom: Re }) => {
    P.document = Pe, P.pages = Ae, P.zoom = Re, H(), w(!1), M(!0), N(), u.current && scrollToPage(u.current, 0);
  }, []), P.error = React.useCallback((Ae) => {
    if (P.document = null, P.pages = [], w(!1), M(!1), Se.onError) {
      const Pe = {
        error: typeof Ae == "string" ? { message: Ae } : Ae,
        target: d.current
      };
      Se.onError.call(void 0, Pe);
    }
  }, [Se.onError]), React.useEffect(() => {
    u.current && (Se.url || Se.data || Se.arrayBuffer ? (w(!0), removeChildren(u.current), loadPDF({
      url: Se.url,
      data: Se.data,
      arrayBuffer: Se.arrayBuffer,
      dom: u.current,
      zoom: P.currentZoom,
      done: P.done,
      error: P.error
    }), c(P.currentZoom)) : (P.document = null, P.pages = [], M(!1), w(!1), removeChildren(u.current)));
  }, [Se.url, Se.data, Se.arrayBuffer]);
  const m = React.useCallback((Ae, Pe) => {
    u.current && (w(!0), removeChildren(u.current), reloadDocument({
      pdfDoc: Ae,
      zoom: Pe,
      dom: u.current,
      done: (Re) => {
        P.pages = Re, P.zoom = Pe, w(!1);
      },
      error: P.error
    }));
  }, []);
  React.useEffect(() => {
    c(t), u.current && P.document && t !== P.zoom && m(P.document, t);
  }, [t, m]), React.useEffect(() => () => {
    P.scroller && P.scroller.destroy(), P.search && P.search.destroy(), P.document = null, P.pages = [];
  }, []);
  const p = React.useCallback(() => {
    l(!0), $(u.current);
  }, []), T = React.useCallback((Ae) => {
    const Pe = Ae.value, Re = P.search.search({ text: Pe, matchCase: b });
    x(Re.length ? 1 : 0), v(Re.length), y(Pe);
  }, [b]), L = React.useCallback(() => {
    const Ae = P.search.search({ text: h, matchCase: !b });
    x(Ae.length ? 1 : 0), v(Ae.length), I(!b);
  }, [b, h]), _ = React.useCallback(() => {
    goToNextSearchMatch(P), x(r + 1 > g ? 1 : r + 1);
  }, [r, g]), G = React.useCallback(() => {
    goToPreviousSearchMatch(P), x(r - 1 < 1 ? g : r - 1);
  }, [r, g]), J = React.useCallback(() => {
    P.search.destroy(), x(0), v(0), I(!1), y(""), l(!1);
  }, []), K = React.useCallback((Ae) => {
    Ae.key === "Enter" ? (Ae.preventDefault(), goToNextSearchMatch(P), x(r + 1 > g ? 1 : r + 1)) : Ae.key === "Escape" && J();
  }, [r, g]), V = React.useCallback((Ae) => {
    if (u.current) {
      const Pe = Ae.skip;
      scrollToPage(u.current, Pe);
      const Re = {
        page: Pe + 1,
        target: d.current,
        syntheticEvent: Ae.syntheticEvent
      };
      Se.onPageChange && Se.onPageChange.call(void 0, Re);
    }
    i(Ae.skip);
  }, [C, Se.onPageChange]), U = React.useCallback((Ae) => {
    if (A.current) {
      const Pe = currentPage(A.current);
      if (Pe !== C) {
        i(Pe);
        const Re = {
          page: Pe + 1,
          target: d.current,
          syntheticEvent: Ae
        };
        Se.onPageChange && Se.onPageChange.call(void 0, Re);
      }
    }
  }, [C, Se.onPageChange]), Q = React.useCallback((Ae) => {
    const Pe = Math.min(P.currentZoom + ae, F);
    if (Pe !== P.currentZoom && P.document && (e(Pe), Se.onZoom)) {
      const Re = {
        zoom: Pe,
        target: d.current,
        syntheticEvent: Ae
      };
      Se.onZoom.call(void 0, Re);
    }
  }, [ae, F, Se.onZoom]), X = React.useCallback((Ae) => {
    const Pe = Math.max(P.currentZoom - ae, xe);
    if (Pe !== P.currentZoom && P.document && (e(Pe), Se.onZoom)) {
      const Re = {
        zoom: Pe,
        target: d.current,
        syntheticEvent: Ae
      };
      Se.onZoom.call(void 0, Re);
    }
  }, [ae, xe, Se.onZoom]), R = React.useCallback((Ae) => {
    const Pe = Ae.value === null ? { text: "100%", value: 1, id: 100 } : Object.assign({}, Ae.value);
    if (Pe.value === void 0) {
      const Ee = parseFloat(Pe.text);
      typeof Ee == "number" && !Number.isNaN(Ee) ? Pe.value = Ee / 100 : Pe.value = 1;
    }
    let Re = Pe ? calculateZoomLevel(Pe.value, Pe.type, P.currentZoom, u.current) : 1;
    if (Re = Math.round(Re * 100) / 100, P.currentZoom !== Re && P.document && (e(Re), Se.onZoom)) {
      const Ee = {
        zoom: Re,
        target: d.current,
        syntheticEvent: Ae.syntheticEvent
      };
      Se.onZoom.call(void 0, Ee);
    }
  }, [Se.onZoom]), f = React.useCallback(() => {
    P.scroller.disablePanEventsTracking(), k(!0);
  }, []), D = React.useCallback(() => {
    P.scroller.enablePanEventsTracking(), k(!1);
  }, []), z = React.useCallback(() => {
    download$1({
      pdf: P.document,
      error: P.error
    }, Se.saveFileName, Se.saveOptions, E);
  }, [Se.url, Se.data, Se.arrayBuffer, Se.saveFileName, Se.saveOptions, E]), Y = React.useCallback(() => {
    w(!0);
    const Ae = (Re) => {
      P.error(typeof (Re ? Re.message || Re : null) == "string" ? Re.message || Re : n.toLanguageString(popupBlocked, messages[popupBlocked]));
    }, Pe = () => {
      w(!1);
    };
    print$1(P.pages, Pe, Ae);
  }, []), W = React.useCallback((Ae) => {
    const Pe = Ae.newState;
    Pe[0] && Pe[0].getRawFile && Pe[0].getRawFile().arrayBuffer().then((Ee) => {
      if (u.current) {
        w(!0), removeChildren(u.current);
        const ye = P.props.zoom === void 0 ? Me : P.props.zoom;
        loadPDF({
          arrayBuffer: Ee,
          dom: u.current,
          zoom: ye,
          done: P.done,
          error: P.error
        }), e(ye);
      }
    });
  }, [Me]), ie = React.useCallback((Ae) => {
    const Pe = Ae.target;
    if (Pe instanceof Element && Pe.parentNode) {
      const Re = Pe.closest(".k-toolbar"), Ee = Re && Re.querySelector(".k-upload input");
      Ee && Ee.click();
    }
  }, []), ne = O && React.createElement(
    "div",
    { className: "k-loader-container k-loader-container-md k-loader-top" },
    React.createElement("div", { className: "k-loader-container-overlay k-overlay-light" }),
    React.createElement(
      "div",
      { className: "k-loader-container-inner " },
      React.createElement(Loader, { size: "large" })
    )
  ), re = React.createElement(
    ButtonGroup,
    null,
    React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(zoomOut, messages[zoomOut]), disabled: t <= xe || !j, onClick: X, icon: "zoom-out", svgIcon: zoomOutIcon }),
    React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(zoomIn, messages[zoomIn]), disabled: t >= F || !j, onClick: Q, icon: "zoom-in", svgIcon: zoomInIcon })
  ), ee = React.createElement(ys, { disabled: !j, data: me.map((Ae) => Object.assign(Object.assign({}, Ae), { text: Ae.locationString ? n.toLanguageString(Ae.locationString, messages[Ae.locationString]) : Ae.text })), dataItemKey: "id", textField: "text", value: j ? B : null, allowCustom: !0, onChange: R }), te = React.createElement(Pager, { previousNext: !0, type: "input", skip: C, take: 1, total: P.pages ? P.pages.length : 0, info: !1, onPageChange: V }), oe = React.createElement(ToolbarSpacer, null), se = React.createElement(
    ButtonGroup,
    null,
    React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(enableSelection, messages[enableSelection]), icon: "pointer", svgIcon: pointerIcon, disabled: !j, togglable: !0, selected: o && j, onClick: f }),
    React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(enablePanning, messages[enablePanning]), icon: "hand", svgIcon: handIcon, disabled: !j, togglable: !0, selected: !o && j, onClick: D })
  ), ce = React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(search, messages[search]), icon: "search", svgIcon: searchIcon, disabled: !j, onClick: p }), le = React.createElement(
    React.Fragment,
    null,
    React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(open, messages[open]), icon: "folder-open", svgIcon: folderOpenIcon, onClick: ie }),
    React.createElement(
      "div",
      { style: { display: "none" } },
      React.createElement(Upload, { restrictions: { allowedExtensions: [".pdf"] }, onAdd: W, autoUpload: !1, defaultFiles: [], multiple: !1, accept: ".pdf,.PDF", withCredentials: !1 })
    )
  ), de = React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(download, messages[download]), icon: "download", svgIcon: downloadIcon, disabled: !j, onClick: z }), Ie = React.createElement(Button$1, { className: "k-toolbar-button", title: n.toLanguageString(print, messages[print]), icon: "print", svgIcon: printIcon, disabled: !j, onClick: Y }), Fe = {
    pager: te,
    spacer: oe,
    zoomInOut: re,
    zoom: ee,
    selection: se,
    search: ce,
    open: le,
    download: de,
    print: Ie
  }, we = (Se.tools || defaultProps.tools).map((Ae) => Fe[Ae]), pe = React.createElement(Toolbar, { buttons: navigation }, ...we), fe = React.createElement(
    "div",
    { className: classNames("k-canvas k-pdf-viewer-canvas k-pos-relative k-overflow-auto", {
      "k-enable-text-select": o,
      "k-enable-panning": !o
    }), onScroll: U },
    s && React.createElement(
      "div",
      { className: "k-search-panel k-pos-sticky k-top-center" },
      React.createElement(xa, { value: h, onChange: T, placeholder: n.toLanguageString(search, messages[search]), autoFocus: !0, onKeyDown: K, suffix: () => React.createElement(
        gr,
        null,
        React.createElement(Button$1, { icon: "convert-lowercase", svgIcon: convertLowercaseIcon, title: n.toLanguageString(matchCase, messages[matchCase]), fillMode: "flat", togglable: !0, selected: b, onClick: L })
      ) }),
      React.createElement(
        "span",
        { className: "k-search-matches" },
        React.createElement("span", null, r),
        " of ",
        React.createElement("span", null, g)
      ),
      React.createElement(Button$1, { title: n.toLanguageString(prevMatch, messages[prevMatch]), fillMode: "flat", icon: "arrow-up", svgIcon: arrowUpIcon, disabled: g === 0, onClick: G }),
      React.createElement(Button$1, { title: n.toLanguageString(nextMatch, messages[nextMatch]), fillMode: "flat", icon: "arrow-down", svgIcon: arrowDownIcon, disabled: g === 0, onClick: _ }),
      React.createElement(Button$1, { title: n.toLanguageString(close, messages[close]), fillMode: "flat", icon: "x", svgIcon: xIcon, onClick: J })
    ),
    React.createElement("div", { ref: u, className: "k-pdf-viewer-pages" })
  );
  return React.createElement(
    "div",
    { className: "k-pdf-viewer", style: Se.style, ref: A },
    Se.onRenderLoader ? Se.onRenderLoader.call(void 0, ne || null) : ne,
    Se.onRenderToolbar ? Se.onRenderToolbar.call(void 0, pe) : pe,
    Se.onRenderContent ? Se.onRenderContent.call(void 0, fe) : fe,
    ke && React.createElement(WatermarkOverlay, null)
  );
});
PDFViewer$1.displayName = "KendoReactPDFViewer";
PDFViewer$1.propTypes = {
  url: propTypesExports.string,
  data: propTypesExports.string,
  arrayBuffer: propTypesExports.any,
  typedArray: propTypesExports.any,
  style: propTypesExports.object,
  saveFileName: propTypesExports.string,
  saveOptions: propTypesExports.object,
  tools: propTypesExports.arrayOf(propTypesExports.oneOf(toolNames).isRequired),
  zoomLevels: propTypesExports.arrayOf(propTypesExports.any),
  zoom: propTypesExports.number,
  defaultZoom: propTypesExports.number,
  minZoom: propTypesExports.number,
  maxZoom: propTypesExports.number,
  zoomRate: propTypesExports.number,
  onError: propTypesExports.func,
  onLoad: propTypesExports.func,
  onDownload: propTypesExports.func,
  onRenderToolbar: propTypesExports.func,
  onRenderContent: propTypesExports.func,
  onRenderLoader: propTypesExports.func,
  onZoom: propTypesExports.func
};
PDFViewer$1.defaultProps = defaultProps;
const PDFViewer = PDFViewer$1;
export {
  PDFViewer
};
